
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1229Z", function(module, exports) {

$parcel$export(module.exports, "main", () => $0c07a74dd7e350c8$export$f22da7240b7add18);
// Generated by purs version 0.15.16

var $32mKU = parcelRequire("32mKU");

var $e6cRy = parcelRequire("e6cRy");

var $bjiNg = parcelRequire("bjiNg");

var $gUTA8 = parcelRequire("gUTA8");

var $9Grh5 = parcelRequire("9Grh5");

var $7T8P4 = parcelRequire("7T8P4");

var $frF73 = parcelRequire("frF73");

var $kQAxW = parcelRequire("kQAxW");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");

var $6VVZC = parcelRequire("6VVZC");

var $ykHdR = parcelRequire("ykHdR");

var $d0PPW = parcelRequire("d0PPW");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");

var $kqxtr = parcelRequire("kqxtr");

var $kQlZ1 = parcelRequire("kQlZ1");

var $khWlH = parcelRequire("khWlH");

var $dstJY = parcelRequire("dstJY");

var $jHZNn = parcelRequire("jHZNn");

var $j8EJb = parcelRequire("j8EJb");

var $kugLX = parcelRequire("kugLX");

var $d8Pe6 = parcelRequire("d8Pe6");

var $hhMAk = parcelRequire("hhMAk");

var $jIMHU = parcelRequire("jIMHU");

var $1qNv1 = parcelRequire("1qNv1");

var $cLQJF = parcelRequire("cLQJF");

var $bllhK = parcelRequire("bllhK");

var $b3Gyo = parcelRequire("b3Gyo");

var $gaeJx = parcelRequire("gaeJx");

var $7yevh = parcelRequire("7yevh");

var $h3hu6 = parcelRequire("h3hu6");
var $0c07a74dd7e350c8$var$map = /* #__PURE__ */ $l0wDR.map($l0wDR.functorArray);
var $0c07a74dd7e350c8$var$bind = /* #__PURE__ */ $9Grh5.bind($bllhK.bindHalogenM);
var $0c07a74dd7e350c8$var$generator = /* #__PURE__ */ $jHZNn.generator($gaeJx.monadRecGen)($gaeJx.monadGenGen);
var $0c07a74dd7e350c8$var$pure = /* #__PURE__ */ $gUTA8.pure($bllhK.applicativeHalogenM);
var $0c07a74dd7e350c8$var$extract = /* #__PURE__ */ $frF73.extract($6VVZC.comonadIdentity);
var $0c07a74dd7e350c8$var$prop = /* #__PURE__ */ $cLQJF.prop($hhMAk.isPropString);
var $0c07a74dd7e350c8$var$identity = /* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn);
var $0c07a74dd7e350c8$var$map1 = /* #__PURE__ */ $l0wDR.map($bllhK.functorHalogenM);
var $0c07a74dd7e350c8$var$join = /* #__PURE__ */ $9Grh5.join($ykHdR.bindMaybe);
var $0c07a74dd7e350c8$var$query = /* #__PURE__ */ $bllhK.query();
var $0c07a74dd7e350c8$var$tokenizerIsSymbol = {
    reflectSymbol: function() {
        return "tokenizer";
    }
};
var $0c07a74dd7e350c8$var$query1 = /* #__PURE__ */ $0c07a74dd7e350c8$var$query($0c07a74dd7e350c8$var$tokenizerIsSymbol)($d0PPW.ordUnit);
var $0c07a74dd7e350c8$var$discard = /* #__PURE__ */ $9Grh5.discard($9Grh5.discardUnit);
var $0c07a74dd7e350c8$var$discard1 = /* #__PURE__ */ $0c07a74dd7e350c8$var$discard($bllhK.bindHalogenM);
var $0c07a74dd7e350c8$var$parserIsSymbol = {
    reflectSymbol: function() {
        return "parser";
    }
};
var $0c07a74dd7e350c8$var$query2 = /* #__PURE__ */ $0c07a74dd7e350c8$var$query($0c07a74dd7e350c8$var$parserIsSymbol)($d0PPW.ordUnit);
var $0c07a74dd7e350c8$var$cekMachineIsSymbol = {
    reflectSymbol: function() {
        return "cekMachine";
    }
};
var $0c07a74dd7e350c8$var$query3 = /* #__PURE__ */ $0c07a74dd7e350c8$var$query($0c07a74dd7e350c8$var$cekMachineIsSymbol)($d0PPW.ordUnit);
var $0c07a74dd7e350c8$var$boundsCheckerIsSymbol = {
    reflectSymbol: function() {
        return "boundsChecker";
    }
};
var $0c07a74dd7e350c8$var$query4 = /* #__PURE__ */ $0c07a74dd7e350c8$var$query($0c07a74dd7e350c8$var$boundsCheckerIsSymbol)($d0PPW.ordUnit);
var $0c07a74dd7e350c8$var$closed = /* #__PURE__ */ $32mKU.closed($e6cRy.traversableBExpr);
var $0c07a74dd7e350c8$var$$$void = /* #__PURE__ */ $l0wDR.void($bllhK.functorHalogenM);
var $0c07a74dd7e350c8$var$stepperIsSymbol = {
    reflectSymbol: function() {
        return "stepper";
    }
};
var $0c07a74dd7e350c8$var$query5 = /* #__PURE__ */ $0c07a74dd7e350c8$var$query($0c07a74dd7e350c8$var$stepperIsSymbol)($d0PPW.ordUnit);
var $0c07a74dd7e350c8$var$put = /* #__PURE__ */ $kQAxW.put($bllhK.monadStateHalogenM);
var $0c07a74dd7e350c8$var$slot = /* #__PURE__ */ $d8Pe6.slot()({
    reflectSymbol: function() {
        return "randomExpr";
    }
})($d0PPW.ordUnit);
var $0c07a74dd7e350c8$var$slot_ = /* #__PURE__ */ $d8Pe6.slot_();
var $0c07a74dd7e350c8$var$slot_1 = /* #__PURE__ */ $0c07a74dd7e350c8$var$slot_($0c07a74dd7e350c8$var$tokenizerIsSymbol)($d0PPW.ordUnit);
var $0c07a74dd7e350c8$var$slot_2 = /* #__PURE__ */ $0c07a74dd7e350c8$var$slot_($0c07a74dd7e350c8$var$parserIsSymbol)($d0PPW.ordUnit);
var $0c07a74dd7e350c8$var$slot_3 = /* #__PURE__ */ $0c07a74dd7e350c8$var$slot_($0c07a74dd7e350c8$var$cekMachineIsSymbol)($d0PPW.ordUnit);
var $0c07a74dd7e350c8$var$slot_4 = /* #__PURE__ */ $0c07a74dd7e350c8$var$slot_($0c07a74dd7e350c8$var$boundsCheckerIsSymbol)($d0PPW.ordUnit);
var $0c07a74dd7e350c8$var$slot_5 = /* #__PURE__ */ $0c07a74dd7e350c8$var$slot_($0c07a74dd7e350c8$var$stepperIsSymbol)($d0PPW.ordUnit);
var $0c07a74dd7e350c8$var$discard2 = /* #__PURE__ */ $0c07a74dd7e350c8$var$discard($kqxtr.bindAff);
var $0c07a74dd7e350c8$var$log = /* #__PURE__ */ $khWlH.log($kqxtr.monadEffectAff);
var $0c07a74dd7e350c8$var$MkStandardTerm = function(x) {
    return x;
};
var $0c07a74dd7e350c8$var$standardTerms = /* #__PURE__ */ $0c07a74dd7e350c8$var$map($0c07a74dd7e350c8$var$MkStandardTerm)([
    {
        name: "I",
        value: "\\x.x"
    },
    {
        name: "S",
        value: "\\x.\\y.\\z.x z (y z)"
    },
    {
        name: "K",
        value: "\\x.\\y.x"
    },
    {
        name: "B",
        value: "\\x.\\y.\\z.x (y z)"
    },
    {
        name: "C",
        value: "\\x.\\y.\\z.x z y"
    },
    {
        name: "W",
        value: "\\x.\\y.x y y"
    },
    {
        name: "omega",
        value: "\\x.x x"
    },
    {
        name: "Omega",
        value: "(\\x.x x)\\x.x x"
    },
    {
        name: "T",
        value: "\\x.\\y.x"
    },
    {
        name: "F",
        value: "\\x.\\y.y"
    }
]);
var $0c07a74dd7e350c8$var$randomExprComponent = function(dictMonadEffect) {
    var liftEffect = $kQlZ1.liftEffect($bllhK.monadEffectHalogenM(dictMonadEffect));
    var render = function(_unit) {
        return $jIMHU.button([
            $1qNv1.onClick($l4M7e.const($r2HHk.unit))
        ])([
            $hhMAk.text("Random Expression")
        ]);
    };
    var handleAction = function(_unit) {
        return $0c07a74dd7e350c8$var$bind(liftEffect($gaeJx.randomSampleOne($0c07a74dd7e350c8$var$generator)))(function(expr) {
            return $bllhK.raise(expr);
        });
    };
    return $kugLX.mkComponent({
        initialState: $l4M7e.const($r2HHk.unit),
        render: render,
        "eval": $kugLX.mkEval({
            initialize: $ykHdR.Nothing.value,
            receive: $l4M7e.const($ykHdR.Nothing.value),
            handleAction: handleAction,
            handleQuery: function($66) {
                return $0c07a74dd7e350c8$var$pure($ykHdR.Just.create($0c07a74dd7e350c8$var$extract($66)));
            },
            finalize: $ykHdR.Nothing.value
        })
    });
};
var $0c07a74dd7e350c8$var$inputTA = function(val) {
    return $jIMHU.textarea([
        $0c07a74dd7e350c8$var$prop("value")(val),
        $1qNv1.onValueInput($0c07a74dd7e350c8$var$identity)
    ]);
};
var $0c07a74dd7e350c8$var$buttonStandardTerm = function(v) {
    return $jIMHU.button([
        $1qNv1.onClick($l4M7e.const(v.value))
    ])([
        $hhMAk.text(v.name)
    ]);
};
var $0c07a74dd7e350c8$var$aslTokenizer = /* #__PURE__ */ function() {
    return $h3hu6.Proxy.value;
}();
var $0c07a74dd7e350c8$var$aslStepper = /* #__PURE__ */ function() {
    return $h3hu6.Proxy.value;
}();
var $0c07a74dd7e350c8$var$aslRandomExpr = /* #__PURE__ */ function() {
    return $h3hu6.Proxy.value;
}();
var $0c07a74dd7e350c8$var$aslParser = /* #__PURE__ */ function() {
    return $h3hu6.Proxy.value;
}();
var $0c07a74dd7e350c8$var$aslCekMachine = /* #__PURE__ */ function() {
    return $h3hu6.Proxy.value;
}();
var $0c07a74dd7e350c8$var$aslBoundsChecker = /* #__PURE__ */ function() {
    return $h3hu6.Proxy.value;
}();
var $0c07a74dd7e350c8$var$evalApp = /* #__PURE__ */ function() {
    var handleAction = function(str) {
        return $0c07a74dd7e350c8$var$bind($0c07a74dd7e350c8$var$map1($0c07a74dd7e350c8$var$join)($0c07a74dd7e350c8$var$query1($0c07a74dd7e350c8$var$aslTokenizer)($r2HHk.unit)(new $7yevh.Tokenize(str, $ykHdR.Just.create, $l4M7e.const($ykHdR.Nothing.value)))))(function(mToks) {
            return $0c07a74dd7e350c8$var$discard1(function() {
                if (mToks instanceof $ykHdR.Nothing) return $0c07a74dd7e350c8$var$pure($r2HHk.unit);
                if (mToks instanceof $ykHdR.Just) return $0c07a74dd7e350c8$var$bind($0c07a74dd7e350c8$var$query2($0c07a74dd7e350c8$var$aslParser)($r2HHk.unit)(new $jHZNn.Parse(mToks.value0, $0c07a74dd7e350c8$var$identity)))(function(mExpr) {
                    if (mExpr instanceof $ykHdR.Nothing) return $0c07a74dd7e350c8$var$pure($r2HHk.unit);
                    if (mExpr instanceof $ykHdR.Just) return $0c07a74dd7e350c8$var$bind($0c07a74dd7e350c8$var$query3($0c07a74dd7e350c8$var$aslCekMachine)($r2HHk.unit)(mExpr.value0))(function() {
                        return $0c07a74dd7e350c8$var$bind($0c07a74dd7e350c8$var$map1($0c07a74dd7e350c8$var$join)($0c07a74dd7e350c8$var$query4($0c07a74dd7e350c8$var$aslBoundsChecker)($r2HHk.unit)(new $e6cRy.BoundsCheck(mExpr.value0, $0c07a74dd7e350c8$var$closed))))(function(bexpr) {
                            if (bexpr instanceof $ykHdR.Nothing) return $0c07a74dd7e350c8$var$pure($r2HHk.unit);
                            if (bexpr instanceof $ykHdR.Just) return $0c07a74dd7e350c8$var$$$void($0c07a74dd7e350c8$var$query5($0c07a74dd7e350c8$var$aslStepper)($r2HHk.unit)(bexpr.value0));
                            throw new Error("Failed pattern match at Main (line 201, column 13 - line 203, column 72): " + [
                                bexpr.constructor.name
                            ]);
                        });
                    });
                    throw new Error("Failed pattern match at Main (line 196, column 9 - line 203, column 72): " + [
                        mExpr.constructor.name
                    ]);
                });
                throw new Error("Failed pattern match at Main (line 192, column 5 - line 203, column 72): " + [
                    mToks.constructor.name
                ]);
            }())(function() {
                return $0c07a74dd7e350c8$var$put(str);
            });
        });
    };
    return $kugLX.mkEval({
        finalize: $ykHdR.Nothing.value,
        receive: $l4M7e.const($ykHdR.Nothing.value),
        handleAction: handleAction,
        handleQuery: $l4M7e.const($0c07a74dd7e350c8$var$pure($ykHdR.Nothing.value)),
        initialize: $ykHdR.Nothing.value
    });
}();
var $0c07a74dd7e350c8$var$renderApp = function(dictMonadEffect) {
    var randomExprComponent1 = $0c07a74dd7e350c8$var$randomExprComponent(dictMonadEffect);
    return function(val) {
        return $jIMHU.div([
            $cLQJF.id("app")
        ])([
            $jIMHU.h2_([
                $hhMAk.text("Input Program / Source Text")
            ]),
            $jIMHU.p_([
                $hhMAk.text("Enter lambda expression directly")
            ]),
            $jIMHU.div_([
                $0c07a74dd7e350c8$var$inputTA(val)
            ]),
            $jIMHU.p_([
                $hhMAk.text("Or, select from some "),
                $jIMHU.a([
                    $cLQJF.href("https://en.wikipedia.org/wiki/Lambda_calculus#Standard_terms")
                ])([
                    $hhMAk.text("standard terms")
                ]),
                $hhMAk.text(".")
            ]),
            $jIMHU.div_($0c07a74dd7e350c8$var$map($0c07a74dd7e350c8$var$buttonStandardTerm)($0c07a74dd7e350c8$var$standardTerms)),
            $jIMHU.div_([
                $0c07a74dd7e350c8$var$slot($0c07a74dd7e350c8$var$aslRandomExpr)($r2HHk.unit)(randomExprComponent1)($r2HHk.unit)($jHZNn.print)
            ]),
            $jIMHU.h2_([
                $hhMAk.text("Static Analysis / Compilation")
            ]),
            $jIMHU.h3_([
                $hhMAk.text("Tokenization")
            ]),
            $jIMHU.p_([
                $hhMAk.text("Fundamentally, tokenization takes an external input stream (usually bytes / octets)"),
                $hhMAk.text(" and converts to a stream with elements (\"tokens\") suitable for input to the parser."),
                $hhMAk.text("  Tokenization is reset anytime the input changes.")
            ]),
            $0c07a74dd7e350c8$var$slot_1($0c07a74dd7e350c8$var$aslTokenizer)($r2HHk.unit)($7yevh.tokenizer)($r2HHk.unit),
            $jIMHU.h3_([
                $hhMAk.text("Parsing")
            ]),
            $jIMHU.p_([
                $hhMAk.text("Parsing takes a stream and discovers / applies a tree struture to generate an abstract syntax tree (AST)."),
                $hhMAk.text("  Parsing is reset on successful tokenization.")
            ]),
            $0c07a74dd7e350c8$var$slot_2($0c07a74dd7e350c8$var$aslParser)($r2HHk.unit)($jHZNn.parserComponent)($r2HHk.unit),
            $jIMHU.h3_([
                $hhMAk.text("CEK Machine evaluation")
            ]),
            $0c07a74dd7e350c8$var$slot_3($0c07a74dd7e350c8$var$aslCekMachine)($r2HHk.unit)($bjiNg.component)($r2HHk.unit),
            $jIMHU.h3_([
                $hhMAk.text("Scope Checking / Nameless Represenation")
            ]),
            $jIMHU.p_([
                $hhMAk.text("In this implementation we convert references to a nameless representation using"),
                $hhMAk.text(" (generalized) DeBruijn indexes.  Out-of-scope varible references are highlighted."),
                $hhMAk.text("  If the are any, scope checking has failed.")
            ]),
            $0c07a74dd7e350c8$var$slot_4($0c07a74dd7e350c8$var$aslBoundsChecker)($r2HHk.unit)($e6cRy.boundsChecker)($r2HHk.unit),
            $jIMHU.h2_([
                $hhMAk.text("Evaluation")
            ]),
            $jIMHU.p_([
                $hhMAk.text("Evaluation is reset when the static analysis successfully changes."),
                $hhMAk.text("  The next small step in evaluation is named, clicking that step name will advance.")
            ]),
            $0c07a74dd7e350c8$var$slot_5($0c07a74dd7e350c8$var$aslStepper)($r2HHk.unit)($dstJY.stepper)($r2HHk.unit)
        ]);
    };
};
var $0c07a74dd7e350c8$var$app = function(dictMonadEffect) {
    return $kugLX.mkComponent({
        initialState: $l4M7e.const(""),
        render: $0c07a74dd7e350c8$var$renderApp(dictMonadEffect),
        "eval": $0c07a74dd7e350c8$var$evalApp
    });
};
var $0c07a74dd7e350c8$var$app1 = /* #__PURE__ */ $0c07a74dd7e350c8$var$app($kqxtr.monadEffectAff);
var $0c07a74dd7e350c8$export$f22da7240b7add18 = /* #__PURE__ */ $j8EJb.runHalogenAff(/* #__PURE__ */ $9Grh5.bind($kqxtr.bindAff)($j8EJb.awaitBody)(function(body) {
    return $0c07a74dd7e350c8$var$discard2($0c07a74dd7e350c8$var$log("Ready to runUI"))(function() {
        return $b3Gyo.runUI($0c07a74dd7e350c8$var$app1)($r2HHk.unit)(body);
    });
}));

});
parcelRegister("32mKU", function(module, exports) {

$parcel$export(module.exports, "B", () => $236335cc09a39a0b$export$ef35774e6d314e91);
$parcel$export(module.exports, "F", () => $236335cc09a39a0b$export$d66501df72047452);
$parcel$export(module.exports, "unScope", () => $236335cc09a39a0b$export$79838ac3ee52e73a);
$parcel$export(module.exports, "subst", () => $236335cc09a39a0b$export$a6965a26994a67a3);
$parcel$export(module.exports, "instantiate1", () => $236335cc09a39a0b$export$436c44e3f6ffc5f2);
$parcel$export(module.exports, "showVar", () => $236335cc09a39a0b$export$898eaccac8eb7d82);
$parcel$export(module.exports, "showScope", () => $236335cc09a39a0b$export$8aecc9908139b3b7);
$parcel$export(module.exports, "foldableScope", () => $236335cc09a39a0b$export$ad5aaad389ca4f6b);
$parcel$export(module.exports, "eqVar", () => $236335cc09a39a0b$export$ed8e6d1c7a9597f6);
$parcel$export(module.exports, "eqScope", () => $236335cc09a39a0b$export$e0afc2bb272fa6ff);
$parcel$export(module.exports, "closed", () => $236335cc09a39a0b$export$15ff61f90f7efc74);
$parcel$export(module.exports, "functorScope", () => $236335cc09a39a0b$export$d156fbb2b0cf46e2);
$parcel$export(module.exports, "hoistScope", () => $236335cc09a39a0b$export$365097e23ff56be3);
$parcel$export(module.exports, "traversableScope", () => $236335cc09a39a0b$export$7e34b044aab76dcf);
$parcel$export(module.exports, "boundScope", () => $236335cc09a39a0b$export$3a790c048919f257);
$parcel$export(module.exports, "abstract1", () => $236335cc09a39a0b$export$926e1ed63c65ede2);
// Generated by purs version 0.15.16

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $9Grh5 = parcelRequire("9Grh5");

var $7T8P4 = parcelRequire("7T8P4");

var $ibtPS = parcelRequire("ibtPS");

var $lGPnP = parcelRequire("lGPnP");

var $i2F6a = parcelRequire("i2F6a");

var $i7s3U = parcelRequire("i7s3U");

var $9DlYk = parcelRequire("9DlYk");

var $9Iord = parcelRequire("9Iord");

var $bnrVm = parcelRequire("bnrVm");

var $k4cbH = parcelRequire("k4cbH");

var $4PFx6 = parcelRequire("4PFx6");

var $iI3r9 = parcelRequire("iI3r9");

var $8rZxf = parcelRequire("8rZxf");

var $2Mmje = parcelRequire("2Mmje");

var $kzMnk = parcelRequire("kzMnk");

var $4MBcA = parcelRequire("4MBcA");

var $6RkEA = parcelRequire("6RkEA");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");

var $cw1rg = parcelRequire("cw1rg");

var $ykHdR = parcelRequire("ykHdR");

var $aknDF = parcelRequire("aknDF");

var $d0PPW = parcelRequire("d0PPW");

var $6SDUu = parcelRequire("6SDUu");

var $iwqgS = parcelRequire("iwqgS");

var $7eHfd = parcelRequire("7eHfd");

var $1wR1l = parcelRequire("1wR1l");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");
var $236335cc09a39a0b$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $236335cc09a39a0b$var$BIsSymbol = {
    reflectSymbol: function() {
        return "B";
    }
};
var $236335cc09a39a0b$var$FIsSymbol = {
    reflectSymbol: function() {
        return "F";
    }
};
var $236335cc09a39a0b$var$ScopeIsSymbol = {
    reflectSymbol: function() {
        return "Scope";
    }
};
var $236335cc09a39a0b$var$identity = /* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn);
var $236335cc09a39a0b$export$ef35774e6d314e91 = /* #__PURE__ */ function() {
    function B(value0) {
        this.value0 = value0;
    }
    B.create = function(value0) {
        return new B(value0);
    };
    return B;
}();
var $236335cc09a39a0b$export$d66501df72047452 = /* #__PURE__ */ function() {
    function F(value0) {
        this.value0 = value0;
    }
    F.create = function(value0) {
        return new F(value0);
    };
    return F;
}();
var $236335cc09a39a0b$export$775b6bb06e53a214 = function(x) {
    return x;
};
var $236335cc09a39a0b$var$AM = function(x) {
    return x;
};
var $236335cc09a39a0b$export$79838ac3ee52e73a = function(v) {
    return v;
};
var $236335cc09a39a0b$export$dc985a0043bce069 = function(dictFunctor) {
    var map1 = $l0wDR.map(dictFunctor);
    return function(dictEq) {
        var eq = $4MBcA.eq(dictEq);
        return function(v) {
            return function(s) {
                return map1(function(x) {
                    var $343 = eq(x)(v);
                    if ($343) return s;
                    return x;
                });
            };
        };
    };
};
var $236335cc09a39a0b$export$d865ce2836f5927f = function(dictMonad) {
    var bind = $9Grh5.bind(dictMonad.Bind1());
    var pure1 = $gUTA8.pure(dictMonad.Applicative0());
    return function(dictEq) {
        var eq = $4MBcA.eq(dictEq);
        return function(v) {
            return function(s) {
                return function(t) {
                    return bind(t)(function(x) {
                        var $344 = eq(x)(v);
                        if ($344) return s;
                        return pure1(x);
                    });
                };
            };
        };
    };
};
var $236335cc09a39a0b$export$42210578eb5caf58 = function(dictMonadTrans) {
    var lift = $4PFx6.lift(dictMonadTrans);
    return function(dictMonad) {
        var lift1 = lift(dictMonad);
        return function(dictMonad1) {
            var bind = $9Grh5.bind(dictMonad1.Bind1());
            return function(f) {
                return function(m) {
                    return bind(m)(function($421) {
                        return lift1(f($421));
                    });
                };
            };
        };
    };
};
var $236335cc09a39a0b$var$substDefault1 = /* #__PURE__ */ $236335cc09a39a0b$export$42210578eb5caf58($k4cbH.monadTransStateT);
var $236335cc09a39a0b$var$substDefault2 = /* #__PURE__ */ $236335cc09a39a0b$export$42210578eb5caf58($bnrVm.monadTransReaderT);
var $236335cc09a39a0b$var$substDefault3 = /* #__PURE__ */ $236335cc09a39a0b$export$42210578eb5caf58($9DlYk.monadTransMaybeT);
var $236335cc09a39a0b$var$substDefault4 = /* #__PURE__ */ $236335cc09a39a0b$export$42210578eb5caf58($i7s3U.monadTransListT);
var $236335cc09a39a0b$var$substDefault5 = /* #__PURE__ */ $236335cc09a39a0b$export$42210578eb5caf58($i2F6a.monadTransExceptT);
var $236335cc09a39a0b$var$substDefault6 = /* #__PURE__ */ $236335cc09a39a0b$export$42210578eb5caf58($lGPnP.monadTransContT);
var $236335cc09a39a0b$export$a6965a26994a67a3 = function(dict) {
    return dict.subst;
};
var $236335cc09a39a0b$export$c8f2e574698899d6 = function(dictMonad) {
    var bind = $9Grh5.bind(dictMonad.Bind1());
    return function(f) {
        return function(g) {
            return function(s) {
                return bind($236335cc09a39a0b$export$79838ac3ee52e73a(s))(function($$var) {
                    if ($$var instanceof $236335cc09a39a0b$export$ef35774e6d314e91) return g($$var.value0);
                    if ($$var instanceof $236335cc09a39a0b$export$d66501df72047452) return bind($$var.value0)(f);
                    throw new Error("Failed pattern match at Bound (line 199, column 5 - line 201, column 29): " + [
                        $$var.constructor.name
                    ]);
                });
            };
        };
    };
};
var $236335cc09a39a0b$var$semigroupAM = function(dictSemigroup) {
    var append = $iwqgS.append(dictSemigroup);
    return function(dictApply) {
        var lift2 = $a5g3C.lift2(dictApply);
        return {
            append: function(v) {
                return function(v1) {
                    return lift2(append)(v)(v1);
                };
            }
        };
    };
};
var $236335cc09a39a0b$var$monoidAM = function(dictMonoid) {
    var mempty = $aknDF.mempty(dictMonoid);
    var semigroupAM1 = $236335cc09a39a0b$var$semigroupAM(dictMonoid.Semigroup0());
    return function(dictApplicative) {
        var semigroupAM2 = semigroupAM1(dictApplicative.Apply0());
        return {
            mempty: $gUTA8.pure(dictApplicative)(mempty),
            Semigroup0: function() {
                return semigroupAM2;
            }
        };
    };
};
var $236335cc09a39a0b$var$monoidAM1 = /* #__PURE__ */ $236335cc09a39a0b$var$monoidAM($aknDF.monoidUnit);
var $236335cc09a39a0b$export$37e856e004dca055 = {
    lift: function(dictMonad) {
        var pure1 = $gUTA8.pure(dictMonad.Applicative0());
        return function(m) {
            return pure1(new $236335cc09a39a0b$export$d66501df72047452(m));
        };
    }
};
var $236335cc09a39a0b$var$substDefault7 = /* #__PURE__ */ $236335cc09a39a0b$export$42210578eb5caf58($236335cc09a39a0b$export$37e856e004dca055);
var $236335cc09a39a0b$export$f9bb8d20ccc7477a = function(dictMonad) {
    var bind = $9Grh5.bind(dictMonad.Bind1());
    return function(f) {
        return function(scope) {
            return bind($236335cc09a39a0b$export$79838ac3ee52e73a(scope))(function($$var) {
                if ($$var instanceof $236335cc09a39a0b$export$ef35774e6d314e91) return f($$var.value0);
                if ($$var instanceof $236335cc09a39a0b$export$d66501df72047452) return $$var.value0;
                throw new Error("Failed pattern match at Bound (line 190, column 5 - line 192, column 17): " + [
                    $$var.constructor.name
                ]);
            });
        };
    };
};
var $236335cc09a39a0b$export$436c44e3f6ffc5f2 = function(dictMonad) {
    var instantiate2 = $236335cc09a39a0b$export$f9bb8d20ccc7477a(dictMonad);
    return function(expr) {
        return instantiate2($l4M7e.const(expr));
    };
};
var $236335cc09a39a0b$var$getAM = function(v) {
    return v;
};
var $236335cc09a39a0b$export$b1b2ce097b6bf117 = {
    to: function(x) {
        if (x instanceof $cw1rg.Inl) return new $236335cc09a39a0b$export$ef35774e6d314e91(x.value0);
        if (x instanceof $cw1rg.Inr) return new $236335cc09a39a0b$export$d66501df72047452(x.value0);
        throw new Error("Failed pattern match at Bound (line 89, column 1 - line 89, column 50): " + [
            x.constructor.name
        ]);
    },
    from: function(x) {
        if (x instanceof $236335cc09a39a0b$export$ef35774e6d314e91) return new $cw1rg.Inl(x.value0);
        if (x instanceof $236335cc09a39a0b$export$d66501df72047452) return new $cw1rg.Inr(x.value0);
        throw new Error("Failed pattern match at Bound (line 89, column 1 - line 89, column 50): " + [
            x.constructor.name
        ]);
    }
};
var $236335cc09a39a0b$var$genericShow = /* #__PURE__ */ $7eHfd.genericShow($236335cc09a39a0b$export$b1b2ce097b6bf117);
var $236335cc09a39a0b$export$898eaccac8eb7d82 = function(dictShow) {
    var genericShowSum = $7eHfd.genericShowSum($7eHfd.genericShowConstructor($7eHfd.genericShowArgsArgument(dictShow))($236335cc09a39a0b$var$BIsSymbol));
    return function(dictShow1) {
        return {
            show: $236335cc09a39a0b$var$genericShow(genericShowSum($7eHfd.genericShowConstructor($7eHfd.genericShowArgsArgument(dictShow1))($236335cc09a39a0b$var$FIsSymbol)))
        };
    };
};
var $236335cc09a39a0b$export$4600d21000c01468 = {
    to: function(x) {
        return x;
    },
    from: function(x) {
        return x;
    }
};
var $236335cc09a39a0b$var$genericShow1 = /* #__PURE__ */ $7eHfd.genericShow($236335cc09a39a0b$export$4600d21000c01468);
var $236335cc09a39a0b$export$8aecc9908139b3b7 = function(dictShow) {
    return function(dictShow1) {
        var genericShow2 = $236335cc09a39a0b$var$genericShow1($7eHfd.genericShowConstructor($7eHfd.genericShowArgsArgument(dictShow1))($236335cc09a39a0b$var$ScopeIsSymbol));
        return function(dictShow2) {
            return {
                show: genericShow2
            };
        };
    };
};
var $236335cc09a39a0b$export$d6f6432270b6148c = function(dictMonad) {
    var Bind1 = dictMonad.Bind1();
    var bind = $9Grh5.bind(Bind1);
    var map1 = $l0wDR.map(Bind1.Apply0().Functor0());
    var pure1 = $gUTA8.pure(dictMonad.Applicative0());
    return function(scope) {
        return bind($236335cc09a39a0b$export$79838ac3ee52e73a(scope))(function($$var) {
            if ($$var instanceof $236335cc09a39a0b$export$d66501df72047452) return map1($236335cc09a39a0b$export$d66501df72047452.create)($$var.value0);
            if ($$var instanceof $236335cc09a39a0b$export$ef35774e6d314e91) return pure1(new $236335cc09a39a0b$export$ef35774e6d314e91($$var.value0));
            throw new Error("Failed pattern match at Bound (line 137, column 5 - line 139, column 26): " + [
                $$var.constructor.name
            ]);
        });
    };
};
var $236335cc09a39a0b$export$6d69283ccadd5e65 = {
    foldMap: function(dictMonoid) {
        var mempty = $aknDF.mempty(dictMonoid);
        return function(v) {
            return function(v1) {
                if (v1 instanceof $236335cc09a39a0b$export$ef35774e6d314e91) return mempty;
                if (v1 instanceof $236335cc09a39a0b$export$d66501df72047452) return v(v1.value0);
                throw new Error("Failed pattern match at Bound (line 106, column 1 - line 110, column 29): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    },
    foldr: function(f) {
        return $6RkEA.foldrDefault($236335cc09a39a0b$export$6d69283ccadd5e65)(f);
    },
    foldl: function(f) {
        return $6RkEA.foldlDefault($236335cc09a39a0b$export$6d69283ccadd5e65)(f);
    }
};
var $236335cc09a39a0b$var$foldMap = /* #__PURE__ */ $6RkEA.foldMap($236335cc09a39a0b$export$6d69283ccadd5e65);
var $236335cc09a39a0b$export$ad5aaad389ca4f6b = function(dictFoldable) {
    var foldMap1 = $6RkEA.foldMap(dictFoldable);
    return {
        foldMap: function(dictMonoid) {
            var foldMap2 = foldMap1(dictMonoid);
            var foldMap3 = $236335cc09a39a0b$var$foldMap(dictMonoid);
            return function(f) {
                var $422 = foldMap2(foldMap3(foldMap2(f)));
                return function($423) {
                    return $422($236335cc09a39a0b$export$79838ac3ee52e73a($423));
                };
            };
        },
        foldr: function(f) {
            return $6RkEA.foldrDefault($236335cc09a39a0b$export$ad5aaad389ca4f6b(dictFoldable))(f);
        },
        foldl: function(f) {
            return $6RkEA.foldlDefault($236335cc09a39a0b$export$ad5aaad389ca4f6b(dictFoldable))(f);
        }
    };
};
var $236335cc09a39a0b$export$a62e490ddf4c4bd6 = function(dictBound) {
    var subst1 = $236335cc09a39a0b$export$a6965a26994a67a3(dictBound);
    return function(dictMonad) {
        return $l4M7e.flip(subst1(dictMonad));
    };
};
var $236335cc09a39a0b$export$ed8e6d1c7a9597f6 = function(dictEq) {
    var eq = $4MBcA.eq(dictEq);
    return function(dictEq1) {
        var eq1 = $4MBcA.eq(dictEq1);
        return {
            eq: function(x) {
                return function(y) {
                    if (x instanceof $236335cc09a39a0b$export$ef35774e6d314e91 && y instanceof $236335cc09a39a0b$export$ef35774e6d314e91) return eq(x.value0)(y.value0);
                    if (x instanceof $236335cc09a39a0b$export$d66501df72047452 && y instanceof $236335cc09a39a0b$export$d66501df72047452) return eq1(x.value0)(y.value0);
                    return false;
                };
            }
        };
    };
};
var $236335cc09a39a0b$export$4934ed3e5e63353a = function(dictOrd) {
    var compare = $d0PPW.compare(dictOrd);
    var eqVar1 = $236335cc09a39a0b$export$ed8e6d1c7a9597f6(dictOrd.Eq0());
    return function(dictOrd1) {
        var compare1 = $d0PPW.compare(dictOrd1);
        var eqVar2 = eqVar1(dictOrd1.Eq0());
        return {
            compare: function(x) {
                return function(y) {
                    if (x instanceof $236335cc09a39a0b$export$ef35774e6d314e91 && y instanceof $236335cc09a39a0b$export$ef35774e6d314e91) return compare(x.value0)(y.value0);
                    if (x instanceof $236335cc09a39a0b$export$ef35774e6d314e91) return $6SDUu.LT.value;
                    if (y instanceof $236335cc09a39a0b$export$ef35774e6d314e91) return $6SDUu.GT.value;
                    if (x instanceof $236335cc09a39a0b$export$d66501df72047452 && y instanceof $236335cc09a39a0b$export$d66501df72047452) return compare1(x.value0)(y.value0);
                    throw new Error("Failed pattern match at Bound (line 0, column 0 - line 0, column 0): " + [
                        x.constructor.name,
                        y.constructor.name
                    ]);
                };
            },
            Eq0: function() {
                return eqVar2;
            }
        };
    };
};
var $236335cc09a39a0b$export$e0afc2bb272fa6ff = function(dictEq) {
    var eqVar1 = $236335cc09a39a0b$export$ed8e6d1c7a9597f6(dictEq);
    return function(dictEq1) {
        var eq1 = $4MBcA.eq1(dictEq1);
        return function(dictEq2) {
            var eq11 = eq1(eqVar1(dictEq2));
            return function(dictEq3) {
                return function(dictEq4) {
                    return {
                        eq: function(x) {
                            return function(y) {
                                return eq11(x)(y);
                            };
                        }
                    };
                };
            };
        };
    };
};
var $236335cc09a39a0b$export$c9cd9c25654e1f67 = function(dictOrd) {
    var ordVar1 = $236335cc09a39a0b$export$4934ed3e5e63353a(dictOrd);
    var eqScope1 = $236335cc09a39a0b$export$e0afc2bb272fa6ff(dictOrd.Eq0());
    return function(dictOrd1) {
        var compare1 = $d0PPW.compare1(dictOrd1);
        var eqScope2 = eqScope1(dictOrd1.Eq10());
        return function(dictOrd2) {
            var compare11 = compare1(ordVar1(dictOrd2));
            var eqScope3 = eqScope2(dictOrd2.Eq0());
            return function(dictOrd3) {
                var eqScope4 = eqScope3(dictOrd3.Eq0());
                return function(dictOrd4) {
                    var eqScope5 = eqScope4(dictOrd4.Eq0());
                    return {
                        compare: function(x) {
                            return function(y) {
                                return compare11(x)(y);
                            };
                        },
                        Eq0: function() {
                            return eqScope5;
                        }
                    };
                };
            };
        };
    };
};
var $236335cc09a39a0b$export$15ff61f90f7efc74 = function(dictTraversable) {
    return $1wR1l.traverse(dictTraversable)($ykHdR.applicativeMaybe)($l4M7e.const($ykHdR.Nothing.value));
};
var $236335cc09a39a0b$export$2ac051b0a03ce153 = function(dictMonoid) {
    var substDefault8 = $236335cc09a39a0b$export$42210578eb5caf58($iI3r9.monadTransWriterT(dictMonoid));
    var monadWriterT = $iI3r9.monadWriterT(dictMonoid);
    return {
        subst: function(dictMonad) {
            return substDefault8(dictMonad)(monadWriterT(dictMonad));
        }
    };
};
var $236335cc09a39a0b$export$73b07953fcee654 = {
    subst: function(dictMonad) {
        return $236335cc09a39a0b$var$substDefault1(dictMonad)($k4cbH.monadStateT(dictMonad));
    }
};
var $236335cc09a39a0b$export$54910acd4dd2a8ce = {
    subst: function(dictMonad) {
        return $236335cc09a39a0b$var$substDefault2(dictMonad)($bnrVm.monadReaderT(dictMonad));
    }
};
var $236335cc09a39a0b$export$ca960533b727fc8f = function(dictMonoid) {
    var substDefault8 = $236335cc09a39a0b$export$42210578eb5caf58($9Iord.monadTransRWST(dictMonoid));
    return {
        subst: function(dictMonad) {
            return substDefault8(dictMonad)($9Iord.monadRWST(dictMonad)(dictMonoid));
        }
    };
};
var $236335cc09a39a0b$export$e6340a0d3d0b4b8f = {
    subst: function(dictMonad) {
        return $236335cc09a39a0b$var$substDefault3(dictMonad)($9DlYk.monadMaybeT(dictMonad));
    }
};
var $236335cc09a39a0b$export$868ea02aff252c4a = {
    subst: function(dictMonad) {
        return $236335cc09a39a0b$var$substDefault4(dictMonad)($i7s3U.monadListT(dictMonad));
    }
};
var $236335cc09a39a0b$export$9524d3e7d9735dd1 = {
    subst: function(dictMonad) {
        return $236335cc09a39a0b$var$substDefault5(dictMonad)($i2F6a.monadExceptT(dictMonad));
    }
};
var $236335cc09a39a0b$export$43bdc3dad5ec51b3 = {
    subst: function(dictMonad) {
        return $236335cc09a39a0b$var$substDefault6(dictMonad)($lGPnP.monadContT(dictMonad));
    }
};
var $236335cc09a39a0b$export$97a1a3e6f39778d2 = function(dictFoldable) {
    var f = function(v) {
        if (v instanceof $236335cc09a39a0b$export$ef35774e6d314e91) return [
            v.value0
        ];
        return [];
    };
    var $424 = $6RkEA.foldMap(dictFoldable)($aknDF.monoidArray)(f);
    return function($425) {
        return $424($236335cc09a39a0b$export$79838ac3ee52e73a($425));
    };
};
var $236335cc09a39a0b$export$752861e1652b4d11 = {
    bimap: function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $236335cc09a39a0b$export$ef35774e6d314e91) return new $236335cc09a39a0b$export$ef35774e6d314e91(v(v2.value0));
                if (v2 instanceof $236335cc09a39a0b$export$d66501df72047452) return new $236335cc09a39a0b$export$d66501df72047452(v1(v2.value0));
                throw new Error("Failed pattern match at Bound (line 116, column 1 - line 118, column 31): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    }
};
var $236335cc09a39a0b$var$bimap = /* #__PURE__ */ $2Mmje.bimap($236335cc09a39a0b$export$752861e1652b4d11);
var $236335cc09a39a0b$export$b3713e8d8599b14e = function(dictFunctor) {
    var map1 = $l0wDR.map(dictFunctor);
    return function(f) {
        return function(g) {
            var $426 = map1($236335cc09a39a0b$var$bimap(f)(map1(g)));
            return function($427) {
                return $236335cc09a39a0b$export$775b6bb06e53a214($426($236335cc09a39a0b$export$79838ac3ee52e73a($427)));
            };
        };
    };
};
var $236335cc09a39a0b$export$714cecffaf1f4e8a = function(dictFunctor) {
    var mapScope1 = $236335cc09a39a0b$export$b3713e8d8599b14e(dictFunctor);
    return function(f) {
        return mapScope1(f)($236335cc09a39a0b$var$identity);
    };
};
var $236335cc09a39a0b$export$74de2e138bc38def = {
    bifoldMap: function(dictMonoid) {
        return function(v) {
            return function(v1) {
                return function(v2) {
                    if (v2 instanceof $236335cc09a39a0b$export$ef35774e6d314e91) return v(v2.value0);
                    if (v2 instanceof $236335cc09a39a0b$export$d66501df72047452) return v1(v2.value0);
                    throw new Error("Failed pattern match at Bound (line 119, column 1 - line 123, column 33): " + [
                        v.constructor.name,
                        v1.constructor.name,
                        v2.constructor.name
                    ]);
                };
            };
        };
    },
    bifoldr: function(f) {
        return $8rZxf.bifoldrDefault($236335cc09a39a0b$export$74de2e138bc38def)(f);
    },
    bifoldl: function(f) {
        return $8rZxf.bifoldlDefault($236335cc09a39a0b$export$74de2e138bc38def)(f);
    }
};
var $236335cc09a39a0b$var$bifoldMap = /* #__PURE__ */ $8rZxf.bifoldMap($236335cc09a39a0b$export$74de2e138bc38def);
var $236335cc09a39a0b$export$8619627c6b7bcd4d = {
    bitraverse: function(dictApplicative) {
        var map1 = $l0wDR.map(dictApplicative.Apply0().Functor0());
        return function(v) {
            return function(v1) {
                return function(v2) {
                    if (v2 instanceof $236335cc09a39a0b$export$ef35774e6d314e91) return map1($236335cc09a39a0b$export$ef35774e6d314e91.create)(v(v2.value0));
                    if (v2 instanceof $236335cc09a39a0b$export$d66501df72047452) return map1($236335cc09a39a0b$export$d66501df72047452.create)(v1(v2.value0));
                    throw new Error("Failed pattern match at Bound (line 124, column 1 - line 127, column 39): " + [
                        v.constructor.name,
                        v1.constructor.name,
                        v2.constructor.name
                    ]);
                };
            };
        };
    },
    bisequence: function(dictApplicative) {
        return function(x) {
            return $kzMnk.bisequenceDefault($236335cc09a39a0b$export$8619627c6b7bcd4d)(dictApplicative)(x);
        };
    },
    Bifunctor0: function() {
        return $236335cc09a39a0b$export$752861e1652b4d11;
    },
    Bifoldable1: function() {
        return $236335cc09a39a0b$export$74de2e138bc38def;
    }
};
var $236335cc09a39a0b$var$bitraverse = /* #__PURE__ */ $kzMnk.bitraverse($236335cc09a39a0b$export$8619627c6b7bcd4d);
var $236335cc09a39a0b$export$bc482e30ecbfaf8d = function(dictTraversable) {
    var traverse1 = $1wR1l.traverse(dictTraversable);
    return function(dictApplicative) {
        var map1 = $l0wDR.map(dictApplicative.Apply0().Functor0());
        var traverse2 = traverse1(dictApplicative);
        var bitraverse1 = $236335cc09a39a0b$var$bitraverse(dictApplicative);
        return function(f) {
            return function(g) {
                var $428 = map1($236335cc09a39a0b$export$775b6bb06e53a214);
                var $429 = traverse2(bitraverse1(f)(traverse2(g)));
                return function($430) {
                    return $428($429($236335cc09a39a0b$export$79838ac3ee52e73a($430)));
                };
            };
        };
    };
};
var $236335cc09a39a0b$export$f698510c8841707c = function(dictTraversable) {
    var traverseScope1 = $236335cc09a39a0b$export$bc482e30ecbfaf8d(dictTraversable);
    return function(dictApplicative) {
        var traverseScope2 = traverseScope1(dictApplicative);
        var pure1 = $gUTA8.pure(dictApplicative);
        return function(f) {
            return traverseScope2(f)(pure1);
        };
    };
};
var $236335cc09a39a0b$export$731e8d6b016ef763 = function(dictFoldable) {
    var foldMap1 = $6RkEA.foldMap(dictFoldable);
    return function(dictMonoid) {
        var foldMap2 = foldMap1(dictMonoid);
        var bifoldMap1 = $236335cc09a39a0b$var$bifoldMap(dictMonoid);
        return function(f) {
            return function(g) {
                var $431 = foldMap2(bifoldMap1(f)(foldMap2(g)));
                return function($432) {
                    return $431($236335cc09a39a0b$export$79838ac3ee52e73a($432));
                };
            };
        };
    };
};
var $236335cc09a39a0b$export$eff1cf241fc2c67 = function(dictFoldable) {
    var foldMapScope1 = $236335cc09a39a0b$export$731e8d6b016ef763(dictFoldable);
    return function(dictMonoid) {
        var foldMapScope2 = foldMapScope1(dictMonoid);
        var mempty = $aknDF.mempty(dictMonoid);
        return function(f) {
            return foldMapScope2(f)($l4M7e.const(mempty));
        };
    };
};
var $236335cc09a39a0b$export$8e09345e3e994e3 = function(dictFoldable) {
    var foldMapBound1 = $236335cc09a39a0b$export$eff1cf241fc2c67(dictFoldable);
    return function(dictApplicative) {
        var foldMapBound2 = foldMapBound1($236335cc09a39a0b$var$monoidAM1(dictApplicative));
        var map1 = $l0wDR.map(dictApplicative.Apply0().Functor0());
        return function(f) {
            var $433 = foldMapBound2(function() {
                var $435 = map1($l4M7e.const($r2HHk.unit));
                return function($436) {
                    return $236335cc09a39a0b$var$AM($435(f($436)));
                };
            }());
            return function($434) {
                return $236335cc09a39a0b$var$getAM($433($434));
            };
        };
    };
};
var $236335cc09a39a0b$export$93f6ca736dd182f2 = function(dictFoldable) {
    var foldMapScope1 = $236335cc09a39a0b$export$731e8d6b016ef763(dictFoldable);
    return function(dictApplicative) {
        var foldMapScope2 = foldMapScope1($236335cc09a39a0b$var$monoidAM1(dictApplicative));
        var map1 = $l0wDR.map(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(g) {
                var $437 = foldMapScope2(function() {
                    var $439 = map1($l4M7e.const($r2HHk.unit));
                    return function($440) {
                        return $236335cc09a39a0b$var$AM($439(f($440)));
                    };
                }())(function() {
                    var $441 = map1($l4M7e.const($r2HHk.unit));
                    return function($442) {
                        return $236335cc09a39a0b$var$AM($441(g($442)));
                    };
                }());
                return function($438) {
                    return $236335cc09a39a0b$var$getAM($437($438));
                };
            };
        };
    };
};
var $236335cc09a39a0b$export$9212db2dbd43e780 = {
    Applicative0: function() {
        return $236335cc09a39a0b$export$61981f830dc23992;
    },
    Bind1: function() {
        return $236335cc09a39a0b$export$ea9e672c20f800dc;
    }
};
var $236335cc09a39a0b$export$ea9e672c20f800dc = {
    bind: function(v) {
        return function(v1) {
            if (v instanceof $236335cc09a39a0b$export$ef35774e6d314e91) return new $236335cc09a39a0b$export$ef35774e6d314e91(v.value0);
            if (v instanceof $236335cc09a39a0b$export$d66501df72047452) return v1(v.value0);
            throw new Error("Failed pattern match at Bound (line 101, column 1 - line 103, column 23): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    Apply0: function() {
        return $236335cc09a39a0b$var$$lazy_applyVar(0);
    }
};
var $236335cc09a39a0b$export$61981f830dc23992 = /* #__PURE__ */ function() {
    return {
        pure: $236335cc09a39a0b$export$d66501df72047452.create,
        Apply0: function() {
            return $236335cc09a39a0b$var$$lazy_applyVar(0);
        }
    };
}();
var $236335cc09a39a0b$var$$lazy_functorVar = /* #__PURE__ */ $236335cc09a39a0b$var$$runtime_lazy("functorVar", "Bound", function() {
    return {
        map: $gUTA8.liftA1($236335cc09a39a0b$export$61981f830dc23992)
    };
});
var $236335cc09a39a0b$var$$lazy_applyVar = /* #__PURE__ */ $236335cc09a39a0b$var$$runtime_lazy("applyVar", "Bound", function() {
    return {
        apply: $ibtPS.ap($236335cc09a39a0b$export$9212db2dbd43e780),
        Functor0: function() {
            return $236335cc09a39a0b$var$$lazy_functorVar(0);
        }
    };
});
var $236335cc09a39a0b$export$4f41f02e7077ce01 = /* #__PURE__ */ $236335cc09a39a0b$var$$lazy_functorVar(95);
var $236335cc09a39a0b$export$73de7bb8f46f7dce = /* #__PURE__ */ $236335cc09a39a0b$var$$lazy_applyVar(97);
var $236335cc09a39a0b$var$map = /* #__PURE__ */ $l0wDR.map($236335cc09a39a0b$export$4f41f02e7077ce01);
var $236335cc09a39a0b$var$pure = /* #__PURE__ */ $gUTA8.pure($236335cc09a39a0b$export$61981f830dc23992);
var $236335cc09a39a0b$export$d156fbb2b0cf46e2 = function(dictFunctor) {
    var map1 = $l0wDR.map(dictFunctor);
    return {
        map: function(f) {
            var $443 = map1($236335cc09a39a0b$var$map(map1(f)));
            return function($444) {
                return $236335cc09a39a0b$export$775b6bb06e53a214($443($236335cc09a39a0b$export$79838ac3ee52e73a($444)));
            };
        }
    };
};
var $236335cc09a39a0b$export$365097e23ff56be3 = function(dictFunctor) {
    var map1 = $l0wDR.map(dictFunctor);
    return function(eta) {
        var $445 = map1($236335cc09a39a0b$var$map(eta));
        return function($446) {
            return $236335cc09a39a0b$export$775b6bb06e53a214(eta($445($236335cc09a39a0b$export$79838ac3ee52e73a($446))));
        };
    };
};
var $236335cc09a39a0b$export$192ecaf52b2dcd94 = function(dictMonad) {
    var $447 = $l0wDR.map(dictMonad.Bind1().Apply0().Functor0())($236335cc09a39a0b$var$map($gUTA8.pure(dictMonad.Applicative0())));
    return function($448) {
        return $236335cc09a39a0b$export$775b6bb06e53a214($447($448));
    };
};
var $236335cc09a39a0b$export$3a0e3ed8abfbd305 = {
    traverse: function(dictApplicative) {
        var pure1 = $gUTA8.pure(dictApplicative);
        var map1 = $l0wDR.map(dictApplicative.Apply0().Functor0());
        return function(v) {
            return function(v1) {
                if (v1 instanceof $236335cc09a39a0b$export$ef35774e6d314e91) return pure1(new $236335cc09a39a0b$export$ef35774e6d314e91(v1.value0));
                if (v1 instanceof $236335cc09a39a0b$export$d66501df72047452) return map1($236335cc09a39a0b$export$d66501df72047452.create)(v(v1.value0));
                throw new Error("Failed pattern match at Bound (line 111, column 1 - line 114, column 35): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    },
    sequence: function(dictApplicative) {
        return function(x) {
            return $1wR1l.sequenceDefault($236335cc09a39a0b$export$3a0e3ed8abfbd305)(dictApplicative)(x);
        };
    },
    Functor0: function() {
        return $236335cc09a39a0b$export$4f41f02e7077ce01;
    },
    Foldable1: function() {
        return $236335cc09a39a0b$export$6d69283ccadd5e65;
    }
};
var $236335cc09a39a0b$var$traverse = /* #__PURE__ */ $1wR1l.traverse($236335cc09a39a0b$export$3a0e3ed8abfbd305);
var $236335cc09a39a0b$export$7e34b044aab76dcf = function(dictTraversable) {
    var traverse1 = $1wR1l.traverse(dictTraversable);
    var functorScope1 = $236335cc09a39a0b$export$d156fbb2b0cf46e2(dictTraversable.Functor0());
    var foldableScope1 = $236335cc09a39a0b$export$ad5aaad389ca4f6b(dictTraversable.Foldable1());
    return {
        traverse: function(dictApplicative) {
            var map1 = $l0wDR.map(dictApplicative.Apply0().Functor0());
            var traverse2 = traverse1(dictApplicative);
            var traverse3 = $236335cc09a39a0b$var$traverse(dictApplicative);
            return function(f) {
                var $449 = map1($236335cc09a39a0b$export$775b6bb06e53a214);
                var $450 = traverse2(traverse3(traverse2(f)));
                return function($451) {
                    return $449($450($236335cc09a39a0b$export$79838ac3ee52e73a($451)));
                };
            };
        },
        sequence: function(dictApplicative) {
            return function(s) {
                return $1wR1l.sequenceDefault($236335cc09a39a0b$export$7e34b044aab76dcf(dictTraversable))(dictApplicative)(s);
            };
        },
        Functor0: function() {
            return functorScope1;
        },
        Foldable1: function() {
            return foldableScope1;
        }
    };
};
var $236335cc09a39a0b$export$26f970323cefb7d5 = function(dictMonad) {
    return {
        Applicative0: function() {
            return $236335cc09a39a0b$export$6ccfd650ec5dd5cb(dictMonad);
        },
        Bind1: function() {
            return $236335cc09a39a0b$export$709883085da0cba3(dictMonad);
        }
    };
};
var $236335cc09a39a0b$export$709883085da0cba3 = function(dictMonad) {
    var bind = $9Grh5.bind(dictMonad.Bind1());
    var pure1 = $gUTA8.pure(dictMonad.Applicative0());
    return {
        bind: function(v) {
            return function(f) {
                return bind(v)(function($$var) {
                    if ($$var instanceof $236335cc09a39a0b$export$ef35774e6d314e91) return pure1(new $236335cc09a39a0b$export$ef35774e6d314e91($$var.value0));
                    if ($$var instanceof $236335cc09a39a0b$export$d66501df72047452) return bind($$var.value0)(function($452) {
                        return $236335cc09a39a0b$export$79838ac3ee52e73a(f($452));
                    });
                    throw new Error("Failed pattern match at Bound (line 159, column 9 - line 161, column 44): " + [
                        $$var.constructor.name
                    ]);
                });
            };
        },
        Apply0: function() {
            return $236335cc09a39a0b$export$a705a1745020d212(dictMonad);
        }
    };
};
var $236335cc09a39a0b$export$a705a1745020d212 = function(dictMonad) {
    var functorScope1 = $236335cc09a39a0b$export$d156fbb2b0cf46e2(dictMonad.Bind1().Apply0().Functor0());
    return {
        apply: $ibtPS.ap($236335cc09a39a0b$export$26f970323cefb7d5(dictMonad)),
        Functor0: function() {
            return functorScope1;
        }
    };
};
var $236335cc09a39a0b$export$6ccfd650ec5dd5cb = function(dictMonad) {
    var pure1 = $gUTA8.pure(dictMonad.Applicative0());
    return {
        pure: function($453) {
            return $236335cc09a39a0b$export$775b6bb06e53a214(pure1($236335cc09a39a0b$var$pure(pure1($453))));
        },
        Apply0: function() {
            return $236335cc09a39a0b$export$a705a1745020d212(dictMonad);
        }
    };
};
var $236335cc09a39a0b$export$3a790c048919f257 = {
    subst: function(dictMonad) {
        return $236335cc09a39a0b$var$substDefault7(dictMonad)($236335cc09a39a0b$export$26f970323cefb7d5(dictMonad));
    }
};
var $236335cc09a39a0b$export$817eb92a8194bab0 = function(dictMonad) {
    var pure1 = $gUTA8.pure(dictMonad.Applicative0());
    var map1 = $l0wDR.map(dictMonad.Bind1().Apply0().Functor0());
    return function(f) {
        var g = function($$var) {
            var v = f($$var);
            if (v instanceof $ykHdR.Nothing) return new $236335cc09a39a0b$export$d66501df72047452(pure1($$var));
            if (v instanceof $ykHdR.Just) return new $236335cc09a39a0b$export$ef35774e6d314e91(v.value0);
            throw new Error("Failed pattern match at Bound (line 180, column 19 - line 182, column 26): " + [
                v.constructor.name
            ]);
        };
        var $454 = map1(g);
        return function($455) {
            return $236335cc09a39a0b$export$775b6bb06e53a214($454($455));
        };
    };
};
var $236335cc09a39a0b$export$926e1ed63c65ede2 = function(dictEq) {
    var eq = $4MBcA.eq(dictEq);
    return function(dictMonad) {
        var abstract2 = $236335cc09a39a0b$export$817eb92a8194bab0(dictMonad);
        return function(x) {
            return abstract2(function(y) {
                var $420 = eq(x)(y);
                if ($420) return new $ykHdR.Just($r2HHk.unit);
                return $ykHdR.Nothing.value;
            });
        };
    };
};

});
parcelRegister("gUTA8", function(module, exports) {

$parcel$export(module.exports, "pure", () => $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557);
$parcel$export(module.exports, "unless", () => $c50cfdb0b9e8fa31$export$6f0673371501d6b6);
$parcel$export(module.exports, "when", () => $c50cfdb0b9e8fa31$export$a55877ca9db47377);
$parcel$export(module.exports, "liftA1", () => $c50cfdb0b9e8fa31$export$53544bd8de5a7427);
$parcel$export(module.exports, "applicativeProxy", () => $c50cfdb0b9e8fa31$export$598532d07e20ffc2);
$parcel$export(module.exports, "applicativeFn", () => $c50cfdb0b9e8fa31$export$e68c32b2a06f106c);
$parcel$export(module.exports, "applicativeArray", () => $c50cfdb0b9e8fa31$export$8f0ac76856b1d87e);
// Generated by purs version 0.15.16

var $a5g3C = parcelRequire("a5g3C");

var $l0wDR = parcelRequire("l0wDR");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");

var $h3hu6 = parcelRequire("h3hu6");
var $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557 = function(dict) {
    return dict.pure;
};
var $c50cfdb0b9e8fa31$export$6f0673371501d6b6 = function(dictApplicative) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    return function(v) {
        return function(v1) {
            if (!v) return v1;
            if (v) return pure1($r2HHk.unit);
            throw new Error("Failed pattern match at Control.Applicative (line 68, column 1 - line 68, column 65): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    };
};
var $c50cfdb0b9e8fa31$export$a55877ca9db47377 = function(dictApplicative) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    return function(v) {
        return function(v1) {
            if (v) return v1;
            if (!v) return pure1($r2HHk.unit);
            throw new Error("Failed pattern match at Control.Applicative (line 63, column 1 - line 63, column 63): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    };
};
var $c50cfdb0b9e8fa31$export$53544bd8de5a7427 = function(dictApplicative) {
    var apply = $a5g3C.apply(dictApplicative.Apply0());
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    return function(f) {
        return function(a) {
            return apply(pure1(f))(a);
        };
    };
};
var $c50cfdb0b9e8fa31$export$598532d07e20ffc2 = {
    pure: function(v) {
        return $h3hu6.Proxy.value;
    },
    Apply0: function() {
        return $a5g3C.applyProxy;
    }
};
var $c50cfdb0b9e8fa31$export$e68c32b2a06f106c = {
    pure: function(x) {
        return function(v) {
            return x;
        };
    },
    Apply0: function() {
        return $a5g3C.applyFn;
    }
};
var $c50cfdb0b9e8fa31$export$8f0ac76856b1d87e = {
    pure: function(x) {
        return [
            x
        ];
    },
    Apply0: function() {
        return $a5g3C.applyArray;
    }
};

});
parcelRegister("a5g3C", function(module, exports) {

$parcel$export(module.exports, "applyProxy", () => $7576d3a958d66ab0$export$e24166bf2f1a6c73);
$parcel$export(module.exports, "applyFn", () => $7576d3a958d66ab0$export$2f68caa5c730775d);
$parcel$export(module.exports, "applyArray", () => $7576d3a958d66ab0$export$60d7bd9d686a5521);
$parcel$export(module.exports, "apply", () => $7576d3a958d66ab0$export$5635d7ef4b8fee1c);
$parcel$export(module.exports, "applyFirst", () => $7576d3a958d66ab0$export$e48e2da4536c2eea);
$parcel$export(module.exports, "applySecond", () => $7576d3a958d66ab0$export$3d5d566a030a20fc);
$parcel$export(module.exports, "lift2", () => $7576d3a958d66ab0$export$f016650e64b51e7d);
// Generated by purs version 0.15.16

var $18LbZ = parcelRequire("18LbZ");

var $7T8P4 = parcelRequire("7T8P4");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");

var $h3hu6 = parcelRequire("h3hu6");
var $7576d3a958d66ab0$var$identity = /* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn);
var $7576d3a958d66ab0$export$e24166bf2f1a6c73 = {
    apply: function(v) {
        return function(v1) {
            return $h3hu6.Proxy.value;
        };
    },
    Functor0: function() {
        return $l0wDR.functorProxy;
    }
};
var $7576d3a958d66ab0$export$2f68caa5c730775d = {
    apply: function(f) {
        return function(g) {
            return function(x) {
                return f(x)(g(x));
            };
        };
    },
    Functor0: function() {
        return $l0wDR.functorFn;
    }
};
var $7576d3a958d66ab0$export$60d7bd9d686a5521 = {
    apply: $18LbZ.arrayApply,
    Functor0: function() {
        return $l0wDR.functorArray;
    }
};
var $7576d3a958d66ab0$export$5635d7ef4b8fee1c = function(dict) {
    return dict.apply;
};
var $7576d3a958d66ab0$export$e48e2da4536c2eea = function(dictApply) {
    var apply1 = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
    var map = $l0wDR.map(dictApply.Functor0());
    return function(a) {
        return function(b) {
            return apply1(map($l4M7e.const)(a))(b);
        };
    };
};
var $7576d3a958d66ab0$export$3d5d566a030a20fc = function(dictApply) {
    var apply1 = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
    var map = $l0wDR.map(dictApply.Functor0());
    return function(a) {
        return function(b) {
            return apply1(map($l4M7e.const($7576d3a958d66ab0$var$identity))(a))(b);
        };
    };
};
var $7576d3a958d66ab0$export$f016650e64b51e7d = function(dictApply) {
    var apply1 = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
    var map = $l0wDR.map(dictApply.Functor0());
    return function(f) {
        return function(a) {
            return function(b) {
                return apply1(map(f)(a))(b);
            };
        };
    };
};
var $7576d3a958d66ab0$export$30190e46300cc996 = function(dictApply) {
    var apply1 = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
    var map = $l0wDR.map(dictApply.Functor0());
    return function(f) {
        return function(a) {
            return function(b) {
                return function(c) {
                    return apply1(apply1(map(f)(a))(b))(c);
                };
            };
        };
    };
};
var $7576d3a958d66ab0$export$6659660f0e855aea = function(dictApply) {
    var apply1 = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
    var map = $l0wDR.map(dictApply.Functor0());
    return function(f) {
        return function(a) {
            return function(b) {
                return function(c) {
                    return function(d) {
                        return apply1(apply1(apply1(map(f)(a))(b))(c))(d);
                    };
                };
            };
        };
    };
};
var $7576d3a958d66ab0$export$6c80f2f7f1ad8105 = function(dictApply) {
    var apply1 = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
    var map = $l0wDR.map(dictApply.Functor0());
    return function(f) {
        return function(a) {
            return function(b) {
                return function(c) {
                    return function(d) {
                        return function(e) {
                            return apply1(apply1(apply1(apply1(map(f)(a))(b))(c))(d))(e);
                        };
                    };
                };
            };
        };
    };
};

});
parcelRegister("18LbZ", function(module, exports) {

$parcel$export(module.exports, "arrayApply", () => $0d4b25392f45f74c$export$4add775dfee37121);
const $0d4b25392f45f74c$export$4add775dfee37121 = function(fs) {
    return function(xs) {
        var l = fs.length;
        var k = xs.length;
        var result = new Array(l * k);
        var n = 0;
        for(var i = 0; i < l; i++){
            var f = fs[i];
            for(var j = 0; j < k; j++)result[n++] = f(xs[j]);
        }
        return result;
    };
};

});

parcelRegister("7T8P4", function(module, exports) {

$parcel$export(module.exports, "identity", () => $5be483788e0e6f04$export$f0954fd7d5368655);
$parcel$export(module.exports, "categoryFn", () => $5be483788e0e6f04$export$7037e3b2ba3bd7aa);
// Generated by purs version 0.15.16

var $7yzxp = parcelRequire("7yzxp");
var $5be483788e0e6f04$export$f0954fd7d5368655 = function(dict) {
    return dict.identity;
};
var $5be483788e0e6f04$export$7037e3b2ba3bd7aa = {
    identity: function(x) {
        return x;
    },
    Semigroupoid0: function() {
        return $7yzxp.semigroupoidFn;
    }
};

});
parcelRegister("7yzxp", function(module, exports) {

$parcel$export(module.exports, "semigroupoidFn", () => $5807467a73465f3c$export$3af17640bddf7212);
$parcel$export(module.exports, "compose", () => $5807467a73465f3c$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "composeFlipped", () => $5807467a73465f3c$export$b5a9558a7176e41b);
// Generated by purs version 0.15.16
var $5807467a73465f3c$export$3af17640bddf7212 = {
    compose: function(f) {
        return function(g) {
            return function(x) {
                return f(g(x));
            };
        };
    }
};
var $5807467a73465f3c$export$f672e0b6f7222cd7 = function(dict) {
    return dict.compose;
};
var $5807467a73465f3c$export$b5a9558a7176e41b = function(dictSemigroupoid) {
    var compose1 = $5807467a73465f3c$export$f672e0b6f7222cd7(dictSemigroupoid);
    return function(f) {
        return function(g) {
            return compose1(g)(f);
        };
    };
};

});


parcelRegister("l4M7e", function(module, exports) {

$parcel$export(module.exports, "on", () => $f57f4b701aa7b66e$export$af631764ddc44097);
$parcel$export(module.exports, "flip", () => $f57f4b701aa7b66e$export$8a83211c878a3f1f);
$parcel$export(module.exports, "const", () => $f57f4b701aa7b66e$export$5b38a098e5a9e7ca);
$parcel$export(module.exports, "applyFlipped", () => $f57f4b701aa7b66e$export$5f9c390da86b6e49);
// Generated by purs version 0.15.16

var $7T8P4 = parcelRequire("7T8P4");

var $6UHO6 = parcelRequire("6UHO6");
var $f57f4b701aa7b66e$export$af631764ddc44097 = function(f) {
    return function(g) {
        return function(x) {
            return function(y) {
                return f(g(x))(g(y));
            };
        };
    };
};
var $f57f4b701aa7b66e$export$8a83211c878a3f1f = function(f) {
    return function(b) {
        return function(a) {
            return f(a)(b);
        };
    };
};
var $f57f4b701aa7b66e$export$5b38a098e5a9e7ca = function(a) {
    return function(v) {
        return a;
    };
};
var $f57f4b701aa7b66e$export$32c25ff0a0410173 = function(f) {
    var go = function($copy_n) {
        return function($copy_acc) {
            var $tco_var_n = $copy_n;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(n, acc) {
                if (n <= 0) {
                    $tco_done = true;
                    return acc;
                }
                if ($6UHO6.otherwise) {
                    $tco_var_n = n - 1 | 0;
                    $copy_acc = f(acc);
                    return;
                }
                throw new Error("Failed pattern match at Data.Function (line 107, column 3 - line 109, column 37): " + [
                    n.constructor.name,
                    acc.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_n, $copy_acc);
            return $tco_result;
        };
    };
    return go;
};
var $f57f4b701aa7b66e$export$5f9c390da86b6e49 = function(x) {
    return function(f) {
        return f(x);
    };
};
var $f57f4b701aa7b66e$export$5635d7ef4b8fee1c = function(f) {
    return function(x) {
        return f(x);
    };
};

});
parcelRegister("6UHO6", function(module, exports) {

$parcel$export(module.exports, "otherwise", () => $5089f43af3d55e5d$export$4bed41887d8c5096);
// Generated by purs version 0.15.16
var $5089f43af3d55e5d$export$4bed41887d8c5096 = true;

});


parcelRegister("l0wDR", function(module, exports) {

$parcel$export(module.exports, "map", () => $f4b2eb11fc32ed34$export$871de8747c9eaa88);
$parcel$export(module.exports, "mapFlipped", () => $f4b2eb11fc32ed34$export$5c8c64e4bc0bcb7a);
$parcel$export(module.exports, "void", () => $f4b2eb11fc32ed34$export$490e536ee7389aeb);
$parcel$export(module.exports, "voidLeft", () => $f4b2eb11fc32ed34$export$6775eb02dd4c5e2a);
$parcel$export(module.exports, "voidRight", () => $f4b2eb11fc32ed34$export$b818c54ed8d3e90a);
$parcel$export(module.exports, "functorProxy", () => $f4b2eb11fc32ed34$export$816e5e05deb8955e);
$parcel$export(module.exports, "functorFn", () => $f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
$parcel$export(module.exports, "functorArray", () => $f4b2eb11fc32ed34$export$2330f868b62ed546);
// Generated by purs version 0.15.16

var $bJ8AE = parcelRequire("bJ8AE");

var $7yzxp = parcelRequire("7yzxp");

var $l4M7e = parcelRequire("l4M7e");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");

var $h3hu6 = parcelRequire("h3hu6");
var $f4b2eb11fc32ed34$export$871de8747c9eaa88 = function(dict) {
    return dict.map;
};
var $f4b2eb11fc32ed34$export$5c8c64e4bc0bcb7a = function(dictFunctor) {
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(fa) {
        return function(f) {
            return map1(f)(fa);
        };
    };
};
var $f4b2eb11fc32ed34$export$490e536ee7389aeb = function(dictFunctor) {
    return $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor)($l4M7e.const($r2HHk.unit));
};
var $f4b2eb11fc32ed34$export$6775eb02dd4c5e2a = function(dictFunctor) {
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(f) {
        return function(x) {
            return map1($l4M7e.const(x))(f);
        };
    };
};
var $f4b2eb11fc32ed34$export$b818c54ed8d3e90a = function(dictFunctor) {
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(x) {
        return map1($l4M7e.const(x));
    };
};
var $f4b2eb11fc32ed34$export$816e5e05deb8955e = {
    map: function(v) {
        return function(v1) {
            return $h3hu6.Proxy.value;
        };
    }
};
var $f4b2eb11fc32ed34$export$11c8d16a3c15d11b = {
    map: /* #__PURE__ */ $7yzxp.compose($7yzxp.semigroupoidFn)
};
var $f4b2eb11fc32ed34$export$2330f868b62ed546 = {
    map: $bJ8AE.arrayMap
};
var $f4b2eb11fc32ed34$export$18c957606d8bdf09 = function(dictFunctor) {
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(ff) {
        return function(x) {
            return map1(function(f) {
                return f(x);
            })(ff);
        };
    };
};

});
parcelRegister("bJ8AE", function(module, exports) {

$parcel$export(module.exports, "arrayMap", () => $889a8f7c70c4a41c$export$dc30017ac4432edc);
const $889a8f7c70c4a41c$export$dc30017ac4432edc = function(f) {
    return function(arr) {
        var l = arr.length;
        var result = new Array(l);
        for(var i = 0; i < l; i++)result[i] = f(arr[i]);
        return result;
    };
};

});

parcelRegister("csvvy", function(module, exports) {

$parcel$export(module.exports, "unit", () => (parcelRequire("r2HHk")).unit);
// Generated by purs version 0.15.16

var $r2HHk = parcelRequire("r2HHk");

});
parcelRegister("r2HHk", function(module, exports) {

$parcel$export(module.exports, "unit", () => $05149ea687d6b460$export$523c0b569236b342);
const $05149ea687d6b460$export$523c0b569236b342 = undefined;

});


parcelRegister("h3hu6", function(module, exports) {

$parcel$export(module.exports, "Proxy", () => $c6a0478cbb9b5a21$export$accffb5fb4579e0d);
// Generated by purs version 0.15.16
var $c6a0478cbb9b5a21$export$accffb5fb4579e0d = /* #__PURE__ */ function() {
    function $$Proxy() {}
    $$Proxy.value = new $$Proxy();
    return $$Proxy;
}();

});




parcelRegister("9Grh5", function(module, exports) {

$parcel$export(module.exports, "discard", () => $70cd3177464e7915$export$584af591d945b55a);
$parcel$export(module.exports, "bindProxy", () => $70cd3177464e7915$export$6dbdf4766af04452);
$parcel$export(module.exports, "bindFn", () => $70cd3177464e7915$export$2c348afe2becdb4f);
$parcel$export(module.exports, "bindArray", () => $70cd3177464e7915$export$794f9574ca20b986);
$parcel$export(module.exports, "bind", () => $70cd3177464e7915$export$2385a24977818dd0);
$parcel$export(module.exports, "bindFlipped", () => $70cd3177464e7915$export$f2077a1c19a006d9);
$parcel$export(module.exports, "composeKleisliFlipped", () => $70cd3177464e7915$export$ea9fbbe247ef8e50);
$parcel$export(module.exports, "composeKleisli", () => $70cd3177464e7915$export$61a2047e1b1e0d3e);
$parcel$export(module.exports, "discardUnit", () => $70cd3177464e7915$export$f73711e565ded7e);
$parcel$export(module.exports, "join", () => $70cd3177464e7915$export$f7e2c8231c57a8bd);
// Generated by purs version 0.15.16

var $jenDx = parcelRequire("jenDx");

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $7T8P4 = parcelRequire("7T8P4");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");

var $h3hu6 = parcelRequire("h3hu6");
var $70cd3177464e7915$var$identity = /* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn);
var $70cd3177464e7915$export$584af591d945b55a = function(dict) {
    return dict.discard;
};
var $70cd3177464e7915$export$6dbdf4766af04452 = {
    bind: function(v) {
        return function(v1) {
            return $h3hu6.Proxy.value;
        };
    },
    Apply0: function() {
        return $a5g3C.applyProxy;
    }
};
var $70cd3177464e7915$export$2c348afe2becdb4f = {
    bind: function(m) {
        return function(f) {
            return function(x) {
                return f(m(x))(x);
            };
        };
    },
    Apply0: function() {
        return $a5g3C.applyFn;
    }
};
var $70cd3177464e7915$export$794f9574ca20b986 = {
    bind: $jenDx.arrayBind,
    Apply0: function() {
        return $a5g3C.applyArray;
    }
};
var $70cd3177464e7915$export$2385a24977818dd0 = function(dict) {
    return dict.bind;
};
var $70cd3177464e7915$export$f2077a1c19a006d9 = function(dictBind) {
    return $l4M7e.flip($70cd3177464e7915$export$2385a24977818dd0(dictBind));
};
var $70cd3177464e7915$export$ea9fbbe247ef8e50 = function(dictBind) {
    var bindFlipped1 = $70cd3177464e7915$export$f2077a1c19a006d9(dictBind);
    return function(f) {
        return function(g) {
            return function(a) {
                return bindFlipped1(f)(g(a));
            };
        };
    };
};
var $70cd3177464e7915$export$61a2047e1b1e0d3e = function(dictBind) {
    var bind1 = $70cd3177464e7915$export$2385a24977818dd0(dictBind);
    return function(f) {
        return function(g) {
            return function(a) {
                return bind1(f(a))(g);
            };
        };
    };
};
var $70cd3177464e7915$export$9a012077684d4c76 = {
    discard: function(dictBind) {
        return $70cd3177464e7915$export$2385a24977818dd0(dictBind);
    }
};
var $70cd3177464e7915$export$f73711e565ded7e = {
    discard: function(dictBind) {
        return $70cd3177464e7915$export$2385a24977818dd0(dictBind);
    }
};
var $70cd3177464e7915$export$2937bb6ffdfdda28 = function(dictBind) {
    var bind1 = $70cd3177464e7915$export$2385a24977818dd0(dictBind);
    return function(cond) {
        return function(t) {
            return function(f) {
                return bind1(cond)(function(cond$prime) {
                    if (cond$prime) return t;
                    return f;
                });
            };
        };
    };
};
var $70cd3177464e7915$export$f7e2c8231c57a8bd = function(dictBind) {
    var bind1 = $70cd3177464e7915$export$2385a24977818dd0(dictBind);
    return function(m) {
        return bind1(m)($70cd3177464e7915$var$identity);
    };
};

});
parcelRegister("jenDx", function(module, exports) {

$parcel$export(module.exports, "arrayBind", () => $e001a8e6e4264547$export$4d853d3353098e5a);
const $e001a8e6e4264547$export$4d853d3353098e5a = typeof Array.prototype.flatMap === "function" ? function(arr) {
    return function(f) {
        return arr.flatMap(f);
    };
} : function(arr) {
    return function(f) {
        var result = [];
        var l = arr.length;
        for(var i = 0; i < l; i++){
            var xs = f(arr[i]);
            var k = xs.length;
            for(var j = 0; j < k; j++)result.push(xs[j]);
        }
        return result;
    };
};

});


parcelRegister("ibtPS", function(module, exports) {

$parcel$export(module.exports, "unlessM", () => $d3d065da31679be1$export$551dd5524146e426);
$parcel$export(module.exports, "monadFn", () => $d3d065da31679be1$export$513f938006a06509);
$parcel$export(module.exports, "monadArray", () => $d3d065da31679be1$export$68aea3a98a23c265);
$parcel$export(module.exports, "liftM1", () => $d3d065da31679be1$export$167848c32e61a4d4);
$parcel$export(module.exports, "ap", () => $d3d065da31679be1$export$2f6ca3d3b1f80bf5);
// Generated by purs version 0.15.16

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $9Grh5 = parcelRequire("9Grh5");

var $l0wDR = parcelRequire("l0wDR");
var $d3d065da31679be1$export$7e7b1df9f5185791 = function(dictMonad) {
    var bind = $9Grh5.bind(dictMonad.Bind1());
    var when = $gUTA8.when(dictMonad.Applicative0());
    return function(mb) {
        return function(m) {
            return bind(mb)(function(b) {
                return when(b)(m);
            });
        };
    };
};
var $d3d065da31679be1$export$551dd5524146e426 = function(dictMonad) {
    var bind = $9Grh5.bind(dictMonad.Bind1());
    var unless = $gUTA8.unless(dictMonad.Applicative0());
    return function(mb) {
        return function(m) {
            return bind(mb)(function(b) {
                return unless(b)(m);
            });
        };
    };
};
var $d3d065da31679be1$export$d34b9ad93b1f095a = {
    Applicative0: function() {
        return $gUTA8.applicativeProxy;
    },
    Bind1: function() {
        return $9Grh5.bindProxy;
    }
};
var $d3d065da31679be1$export$513f938006a06509 = {
    Applicative0: function() {
        return $gUTA8.applicativeFn;
    },
    Bind1: function() {
        return $9Grh5.bindFn;
    }
};
var $d3d065da31679be1$export$68aea3a98a23c265 = {
    Applicative0: function() {
        return $gUTA8.applicativeArray;
    },
    Bind1: function() {
        return $9Grh5.bindArray;
    }
};
var $d3d065da31679be1$export$167848c32e61a4d4 = function(dictMonad) {
    var bind = $9Grh5.bind(dictMonad.Bind1());
    var pure = $gUTA8.pure(dictMonad.Applicative0());
    return function(f) {
        return function(a) {
            return bind(a)(function(a$prime) {
                return pure(f(a$prime));
            });
        };
    };
};
var $d3d065da31679be1$export$2f6ca3d3b1f80bf5 = function(dictMonad) {
    var bind = $9Grh5.bind(dictMonad.Bind1());
    var pure = $gUTA8.pure(dictMonad.Applicative0());
    return function(f) {
        return function(a) {
            return bind(f)(function(f$prime) {
                return bind(a)(function(a$prime) {
                    return pure(f$prime(a$prime));
                });
            });
        };
    };
};

});

parcelRegister("lGPnP", function(module, exports) {

$parcel$export(module.exports, "runContT", () => $fca560e14229da4e$export$358211fab263c66b);
$parcel$export(module.exports, "monadTransContT", () => $fca560e14229da4e$export$6a2bb59a0c53ce17);
$parcel$export(module.exports, "functorContT", () => $fca560e14229da4e$export$232156ef715cfc9b);
$parcel$export(module.exports, "applyContT", () => $fca560e14229da4e$export$6b05a2ec606a3559);
$parcel$export(module.exports, "applicativeContT", () => $fca560e14229da4e$export$d73f0595e894296c);
$parcel$export(module.exports, "monadContT", () => $fca560e14229da4e$export$735f43b0215ad39);
$parcel$export(module.exports, "monadEffectContT", () => $fca560e14229da4e$export$35d988300b9091c9);
// Generated by purs version 0.15.16

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $9Grh5 = parcelRequire("9Grh5");

var $8UXl5 = parcelRequire("8UXl5");

var $9ZRMq = parcelRequire("9ZRMq");

var $iYXib = parcelRequire("iYXib");

var $kQAxW = parcelRequire("kQAxW");

var $4PFx6 = parcelRequire("4PFx6");

var $l4M7e = parcelRequire("l4M7e");

var $aknDF = parcelRequire("aknDF");

var $iwqgS = parcelRequire("iwqgS");

var $kQlZ1 = parcelRequire("kQlZ1");
var $fca560e14229da4e$export$14010cd19909b6b = function(x) {
    return x;
};
var $fca560e14229da4e$export$2a106bc5b2e64dce = function(f) {
    return function(v) {
        return function(k) {
            return v(f(k));
        };
    };
};
var $fca560e14229da4e$export$358211fab263c66b = function(v) {
    return function(k) {
        return v(k);
    };
};
var $fca560e14229da4e$export$5419b7e78c76e565 = {
    Coercible0: function() {
        return undefined;
    }
};
var $fca560e14229da4e$export$6a2bb59a0c53ce17 = {
    lift: function(dictMonad) {
        var bind = $9Grh5.bind(dictMonad.Bind1());
        return function(m) {
            return function(k) {
                return bind(m)(k);
            };
        };
    }
};
var $fca560e14229da4e$var$lift = /* #__PURE__ */ $4PFx6.lift($fca560e14229da4e$export$6a2bb59a0c53ce17);
var $fca560e14229da4e$export$604f139dbf56bccf = function(f) {
    return function(v) {
        return function(k) {
            return f(v(k));
        };
    };
};
var $fca560e14229da4e$export$232156ef715cfc9b = function(dictFunctor) {
    return {
        map: function(f) {
            return function(v) {
                return function(k) {
                    return v(function(a) {
                        return k(f(a));
                    });
                };
            };
        }
    };
};
var $fca560e14229da4e$export$6b05a2ec606a3559 = function(dictApply) {
    var functorContT1 = $fca560e14229da4e$export$232156ef715cfc9b(dictApply.Functor0());
    return {
        apply: function(v) {
            return function(v1) {
                return function(k) {
                    return v(function(g) {
                        return v1(function(a) {
                            return k(g(a));
                        });
                    });
                };
            };
        },
        Functor0: function() {
            return functorContT1;
        }
    };
};
var $fca560e14229da4e$export$91905d227b995e9d = function(dictBind) {
    var applyContT1 = $fca560e14229da4e$export$6b05a2ec606a3559(dictBind.Apply0());
    return {
        bind: function(v) {
            return function(k) {
                return function(k$prime) {
                    return v(function(a) {
                        var v1 = k(a);
                        return v1(k$prime);
                    });
                };
            };
        },
        Apply0: function() {
            return applyContT1;
        }
    };
};
var $fca560e14229da4e$export$ebd715a8b64afb39 = function(dictApply) {
    var lift2 = $a5g3C.lift2($fca560e14229da4e$export$6b05a2ec606a3559(dictApply));
    return function(dictSemigroup) {
        return {
            append: lift2($iwqgS.append(dictSemigroup))
        };
    };
};
var $fca560e14229da4e$export$d73f0595e894296c = function(dictApplicative) {
    var applyContT1 = $fca560e14229da4e$export$6b05a2ec606a3559(dictApplicative.Apply0());
    return {
        pure: function(a) {
            return function(k) {
                return k(a);
            };
        },
        Apply0: function() {
            return applyContT1;
        }
    };
};
var $fca560e14229da4e$export$735f43b0215ad39 = function(dictMonad) {
    var applicativeContT1 = $fca560e14229da4e$export$d73f0595e894296c(dictMonad.Applicative0());
    var bindContT1 = $fca560e14229da4e$export$91905d227b995e9d(dictMonad.Bind1());
    return {
        Applicative0: function() {
            return applicativeContT1;
        },
        Bind1: function() {
            return bindContT1;
        }
    };
};
var $fca560e14229da4e$export$6062b41302ddcd80 = function(dictMonadAsk) {
    var Monad0 = dictMonadAsk.Monad0();
    var monadContT1 = $fca560e14229da4e$export$735f43b0215ad39(Monad0);
    return {
        ask: $fca560e14229da4e$var$lift(Monad0)($9ZRMq.ask(dictMonadAsk)),
        Monad0: function() {
            return monadContT1;
        }
    };
};
var $fca560e14229da4e$export$dbf903f187194ce5 = function(dictMonadReader) {
    var MonadAsk0 = dictMonadReader.MonadAsk0();
    var bind = $9Grh5.bind(MonadAsk0.Monad0().Bind1());
    var ask = $9ZRMq.ask(MonadAsk0);
    var local = $9ZRMq.local(dictMonadReader);
    var monadAskContT1 = $fca560e14229da4e$export$6062b41302ddcd80(MonadAsk0);
    return {
        local: function(f) {
            return function(v) {
                return function(k) {
                    return bind(ask)(function(r) {
                        return local(f)(v(function() {
                            var $94 = local($l4M7e.const(r));
                            return function($95) {
                                return $94(k($95));
                            };
                        }()));
                    });
                };
            };
        },
        MonadAsk0: function() {
            return monadAskContT1;
        }
    };
};
var $fca560e14229da4e$export$fd982f3f83dedfc9 = function(dictMonad) {
    var monadContT1 = $fca560e14229da4e$export$735f43b0215ad39(dictMonad);
    return {
        callCC: function(f) {
            return function(k) {
                var v = f(function(a) {
                    return function(v1) {
                        return k(a);
                    };
                });
                return v(k);
            };
        },
        Monad0: function() {
            return monadContT1;
        }
    };
};
var $fca560e14229da4e$export$35d988300b9091c9 = function(dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var monadContT1 = $fca560e14229da4e$export$735f43b0215ad39(Monad0);
    return {
        liftEffect: function() {
            var $96 = $fca560e14229da4e$var$lift(Monad0);
            var $97 = $kQlZ1.liftEffect(dictMonadEffect);
            return function($98) {
                return $96($97($98));
            };
        }(),
        Monad0: function() {
            return monadContT1;
        }
    };
};
var $fca560e14229da4e$export$1aa60909d07c5b2d = function(dictMonadState) {
    var Monad0 = dictMonadState.Monad0();
    var monadContT1 = $fca560e14229da4e$export$735f43b0215ad39(Monad0);
    return {
        state: function() {
            var $99 = $fca560e14229da4e$var$lift(Monad0);
            var $100 = $kQAxW.state(dictMonadState);
            return function($101) {
                return $99($100($101));
            };
        }(),
        Monad0: function() {
            return monadContT1;
        }
    };
};
var $fca560e14229da4e$export$845d7a4c5796dca2 = function(dictMonadST) {
    var Monad0 = dictMonadST.Monad0();
    var monadContT1 = $fca560e14229da4e$export$735f43b0215ad39(Monad0);
    return {
        liftST: function() {
            var $102 = $fca560e14229da4e$var$lift(Monad0);
            var $103 = $iYXib.liftST(dictMonadST);
            return function($104) {
                return $102($103($104));
            };
        }(),
        Monad0: function() {
            return monadContT1;
        }
    };
};
var $fca560e14229da4e$export$e824ef6fc9053d43 = function(dictApplicative) {
    var pure = $gUTA8.pure($fca560e14229da4e$export$d73f0595e894296c(dictApplicative));
    var semigroupContT1 = $fca560e14229da4e$export$ebd715a8b64afb39(dictApplicative.Apply0());
    return function(dictMonoid) {
        var semigroupContT2 = semigroupContT1(dictMonoid.Semigroup0());
        return {
            mempty: pure($aknDF.mempty(dictMonoid)),
            Semigroup0: function() {
                return semigroupContT2;
            }
        };
    };
};

});
parcelRegister("8UXl5", function(module, exports) {

$parcel$export(module.exports, "callCC", () => $67e1952ff57566f7$export$bb801a161a3121f0);
// Generated by purs version 0.15.16
var $67e1952ff57566f7$export$bb801a161a3121f0 = function(dict) {
    return dict.callCC;
};

});

parcelRegister("9ZRMq", function(module, exports) {

$parcel$export(module.exports, "local", () => $74738728c27df511$export$3bf5078b16209b91);
$parcel$export(module.exports, "ask", () => $74738728c27df511$export$1b4aee0b51c3def8);
// Generated by purs version 0.15.16

var $7T8P4 = parcelRequire("7T8P4");

var $ibtPS = parcelRequire("ibtPS");

var $7yzxp = parcelRequire("7yzxp");

var $l0wDR = parcelRequire("l0wDR");
var $74738728c27df511$export$97f42efbb325fef6 = {
    ask: /* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn),
    Monad0: function() {
        return $ibtPS.monadFn;
    }
};
var $74738728c27df511$export$487d42cd354774ee = {
    local: /* #__PURE__ */ $7yzxp.composeFlipped($7yzxp.semigroupoidFn),
    MonadAsk0: function() {
        return $74738728c27df511$export$97f42efbb325fef6;
    }
};
var $74738728c27df511$export$3bf5078b16209b91 = function(dict) {
    return dict.local;
};
var $74738728c27df511$export$1b4aee0b51c3def8 = function(dict) {
    return dict.ask;
};
var $74738728c27df511$export$5551e829c4b2a916 = function(dictMonadAsk) {
    var map = $l0wDR.map(dictMonadAsk.Monad0().Bind1().Apply0().Functor0());
    var ask1 = $74738728c27df511$export$1b4aee0b51c3def8(dictMonadAsk);
    return function(f) {
        return map(f)(ask1);
    };
};

});

parcelRegister("iYXib", function(module, exports) {

$parcel$export(module.exports, "monadSTEffect", () => $dd1bd2cc217b6a6d$export$d1b56b21630310a5);
$parcel$export(module.exports, "liftST", () => $dd1bd2cc217b6a6d$export$90556654c9c47d5f);
// Generated by purs version 0.15.16

var $7T8P4 = parcelRequire("7T8P4");

var $3JF9h = parcelRequire("3JF9h");

var $JFoio = parcelRequire("JFoio");

var $9hRVP = parcelRequire("9hRVP");
var $dd1bd2cc217b6a6d$export$162690b6fa074d8b = {
    liftST: /* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn),
    Monad0: function() {
        return $JFoio.monadST;
    }
};
var $dd1bd2cc217b6a6d$export$d1b56b21630310a5 = {
    liftST: $3JF9h.toEffect,
    Monad0: function() {
        return $9hRVP.monadEffect;
    }
};
var $dd1bd2cc217b6a6d$export$90556654c9c47d5f = function(dict) {
    return dict.liftST;
};

});
parcelRegister("3JF9h", function(module, exports) {

$parcel$export(module.exports, "toEffect", () => $2b857e558a2a0921$export$2bf63e57346d9602);
// Generated by purs version 0.15.16
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");
var $2b857e558a2a0921$export$2bf63e57346d9602 = $eOrGk.unsafeCoerce;

});
parcelRegister("gukrE", function(module, exports) {

$parcel$export(module.exports, "unsafeCoerce", () => (parcelRequire("eOrGk")).unsafeCoerce);
// Generated by purs version 0.15.16

var $eOrGk = parcelRequire("eOrGk");

});
parcelRegister("eOrGk", function(module, exports) {

$parcel$export(module.exports, "unsafeCoerce", () => $ac8b3532514ac019$export$401372c57776dc);
// module Unsafe.Coerce
const $ac8b3532514ac019$export$401372c57776dc = function(x) {
    return x;
};

});



parcelRegister("JFoio", function(module, exports) {

$parcel$export(module.exports, "modify", () => $08944f7287e2704c$export$3ff57735a52b8713);
$parcel$export(module.exports, "functorST", () => $08944f7287e2704c$export$a47991927f51461e);
$parcel$export(module.exports, "monadST", () => $08944f7287e2704c$export$962073314682c2c);
$parcel$export(module.exports, "applicativeST", () => $08944f7287e2704c$export$603d84e49041d7b2);
$parcel$export(module.exports, "bindST", () => $08944f7287e2704c$export$14049c9ff5b55fb3);
$parcel$export(module.exports, "for", () => (parcelRequire("kHt3z")).for);
$parcel$export(module.exports, "foreach", () => (parcelRequire("kHt3z")).foreach);
$parcel$export(module.exports, "new", () => (parcelRequire("kHt3z")).new);
$parcel$export(module.exports, "read", () => (parcelRequire("kHt3z")).read);
$parcel$export(module.exports, "write", () => (parcelRequire("kHt3z")).write);
// Generated by purs version 0.15.16

var $kHt3z = parcelRequire("kHt3z");

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $9Grh5 = parcelRequire("9Grh5");

var $ibtPS = parcelRequire("ibtPS");

var $lowBm = parcelRequire("lowBm");

var $l0wDR = parcelRequire("l0wDR");

var $aknDF = parcelRequire("aknDF");

var $iwqgS = parcelRequire("iwqgS");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");
var $08944f7287e2704c$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $08944f7287e2704c$export$4d5401161a900ce1 = $kHt3z.modifyImpl;
var $08944f7287e2704c$export$3ff57735a52b8713 = function(f) {
    return $08944f7287e2704c$export$4d5401161a900ce1(function(s) {
        var s$prime = f(s);
        return {
            state: s$prime,
            value: s$prime
        };
    });
};
var $08944f7287e2704c$export$a47991927f51461e = {
    map: $kHt3z.map_
};
var $08944f7287e2704c$var$map = /* #__PURE__ */ $l0wDR.map($08944f7287e2704c$export$a47991927f51461e);
var $08944f7287e2704c$var$$$void = /* #__PURE__ */ $l0wDR.void($08944f7287e2704c$export$a47991927f51461e);
var $08944f7287e2704c$export$962073314682c2c = {
    Applicative0: function() {
        return $08944f7287e2704c$export$603d84e49041d7b2;
    },
    Bind1: function() {
        return $08944f7287e2704c$export$14049c9ff5b55fb3;
    }
};
var $08944f7287e2704c$export$14049c9ff5b55fb3 = {
    bind: $kHt3z.bind_,
    Apply0: function() {
        return $08944f7287e2704c$var$$lazy_applyST(0);
    }
};
var $08944f7287e2704c$export$603d84e49041d7b2 = {
    pure: $kHt3z.pure_,
    Apply0: function() {
        return $08944f7287e2704c$var$$lazy_applyST(0);
    }
};
var $08944f7287e2704c$var$$lazy_applyST = /* #__PURE__ */ $08944f7287e2704c$var$$runtime_lazy("applyST", "Control.Monad.ST.Internal", function() {
    return {
        apply: $ibtPS.ap($08944f7287e2704c$export$962073314682c2c),
        Functor0: function() {
            return $08944f7287e2704c$export$a47991927f51461e;
        }
    };
});
var $08944f7287e2704c$export$65915895b3a8faeb = /* #__PURE__ */ $08944f7287e2704c$var$$lazy_applyST(47);
var $08944f7287e2704c$var$lift2 = /* #__PURE__ */ $a5g3C.lift2($08944f7287e2704c$export$65915895b3a8faeb);
var $08944f7287e2704c$var$bind = /* #__PURE__ */ $9Grh5.bind($08944f7287e2704c$export$14049c9ff5b55fb3);
var $08944f7287e2704c$var$bindFlipped = /* #__PURE__ */ $9Grh5.bindFlipped($08944f7287e2704c$export$14049c9ff5b55fb3);
var $08944f7287e2704c$var$discard = /* #__PURE__ */ $9Grh5.discard($9Grh5.discardUnit)($08944f7287e2704c$export$14049c9ff5b55fb3);
var $08944f7287e2704c$var$pure = /* #__PURE__ */ $gUTA8.pure($08944f7287e2704c$export$603d84e49041d7b2);
var $08944f7287e2704c$export$56941e1c622ade00 = function(dictSemigroup) {
    return {
        append: $08944f7287e2704c$var$lift2($iwqgS.append(dictSemigroup))
    };
};
var $08944f7287e2704c$export$24025a1415d0847d = {
    tailRecM: function(f) {
        return function(a) {
            var isLooping = function(v) {
                if (v instanceof $lowBm.Loop) return true;
                return false;
            };
            var fromDone = function(v) {
                if (v instanceof $lowBm.Done) return v.value0;
                throw new Error("Failed pattern match at Control.Monad.ST.Internal (line 70, column 32 - line 70, column 46): " + [
                    v.constructor.name
                ]);
            };
            return $08944f7287e2704c$var$bind($08944f7287e2704c$var$bindFlipped($kHt3z.new)(f(a)))(function(r) {
                return $08944f7287e2704c$var$discard($kHt3z.while($08944f7287e2704c$var$map(isLooping)($kHt3z.read(r)))($08944f7287e2704c$var$bind($kHt3z.read(r))(function(v) {
                    if (v instanceof $lowBm.Loop) return $08944f7287e2704c$var$bind(f(v.value0))(function(e) {
                        return $08944f7287e2704c$var$$$void($kHt3z.write(e)(r));
                    });
                    if (v instanceof $lowBm.Done) return $08944f7287e2704c$var$pure($r2HHk.unit);
                    throw new Error("Failed pattern match at Control.Monad.ST.Internal (line 62, column 18 - line 66, column 28): " + [
                        v.constructor.name
                    ]);
                })))(function() {
                    return $08944f7287e2704c$var$map(fromDone)($kHt3z.read(r));
                });
            });
        };
    },
    Monad0: function() {
        return $08944f7287e2704c$export$962073314682c2c;
    }
};
var $08944f7287e2704c$export$85c55a7e282bbb67 = function(dictMonoid) {
    var semigroupST1 = $08944f7287e2704c$export$56941e1c622ade00(dictMonoid.Semigroup0());
    return {
        mempty: $08944f7287e2704c$var$pure($aknDF.mempty(dictMonoid)),
        Semigroup0: function() {
            return semigroupST1;
        }
    };
};

});
parcelRegister("kHt3z", function(module, exports) {

$parcel$export(module.exports, "map_", () => $f11e5cd39add8df2$export$aca8cce159e578de);
$parcel$export(module.exports, "pure_", () => $f11e5cd39add8df2$export$3bbfc465dcacc7f4);
$parcel$export(module.exports, "bind_", () => $f11e5cd39add8df2$export$b25ab69b10c0d17b);
$parcel$export(module.exports, "while", () => $f11e5cd39add8df2$export$f021a974ad8da35c);
$parcel$export(module.exports, "for", () => $f11e5cd39add8df2$export$f89de2e5bf57e5e6);
$parcel$export(module.exports, "foreach", () => $f11e5cd39add8df2$export$8802485f9deae94f);
$parcel$export(module.exports, "new", () => $f11e5cd39add8df2$export$b8cb59497041ffe4);
$parcel$export(module.exports, "read", () => $f11e5cd39add8df2$export$aafa59e2e03f2942);
$parcel$export(module.exports, "modifyImpl", () => $f11e5cd39add8df2$export$cc2488c59b3f757);
$parcel$export(module.exports, "write", () => $f11e5cd39add8df2$export$68d8715fc104d294);
const $f11e5cd39add8df2$export$aca8cce159e578de = function(f) {
    return function(a) {
        return function() {
            return f(a());
        };
    };
};
const $f11e5cd39add8df2$export$3bbfc465dcacc7f4 = function(a) {
    return function() {
        return a;
    };
};
const $f11e5cd39add8df2$export$b25ab69b10c0d17b = function(a) {
    return function(f) {
        return function() {
            return f(a())();
        };
    };
};
const $f11e5cd39add8df2$export$889ea624f2cb2c57 = function(f) {
    return f();
};
function $f11e5cd39add8df2$export$f021a974ad8da35c(f) {
    return function(a) {
        return function() {
            while(f())a();
        };
    };
}
function $f11e5cd39add8df2$export$f89de2e5bf57e5e6(lo) {
    return function(hi) {
        return function(f) {
            return function() {
                for(var i = lo; i < hi; i++)f(i)();
            };
        };
    };
}
const $f11e5cd39add8df2$export$8802485f9deae94f = function(as) {
    return function(f) {
        return function() {
            for(var i = 0, l = as.length; i < l; i++)f(as[i])();
        };
    };
};
function $f11e5cd39add8df2$export$b8cb59497041ffe4(val) {
    return function() {
        return {
            value: val
        };
    };
}
const $f11e5cd39add8df2$export$aafa59e2e03f2942 = function(ref) {
    return function() {
        return ref.value;
    };
};
const $f11e5cd39add8df2$export$cc2488c59b3f757 = function(f) {
    return function(ref) {
        return function() {
            var t = f(ref.value);
            ref.value = t.state;
            return t.value;
        };
    };
};
const $f11e5cd39add8df2$export$68d8715fc104d294 = function(a) {
    return function(ref) {
        return function() {
            return ref.value = a; // eslint-disable-line no-return-assign
        };
    };
};

});

parcelRegister("lowBm", function(module, exports) {

$parcel$export(module.exports, "Loop", () => $f93520de2fa37b44$export$550acbd06a1f5a6a);
$parcel$export(module.exports, "Done", () => $f93520de2fa37b44$export$7fe28cb29e71bf10);
$parcel$export(module.exports, "tailRecM", () => $f93520de2fa37b44$export$c025cfd4cc93300b);
$parcel$export(module.exports, "tailRecM2", () => $f93520de2fa37b44$export$9056a6bb308e8c79);
$parcel$export(module.exports, "monadRecMaybe", () => $f93520de2fa37b44$export$6a06149683d26749);
$parcel$export(module.exports, "monadRecIdentity", () => $f93520de2fa37b44$export$ef692454cdd8c2ba);
$parcel$export(module.exports, "monadRecEffect", () => $f93520de2fa37b44$export$c2472dc015e90d28);
$parcel$export(module.exports, "bifunctorStep", () => $f93520de2fa37b44$export$61e43214bca7f031);
// Generated by purs version 0.15.16

var $9Grh5 = parcelRequire("9Grh5");

var $ibtPS = parcelRequire("ibtPS");

var $aKY4H = parcelRequire("aKY4H");

var $l0wDR = parcelRequire("l0wDR");

var $6VVZC = parcelRequire("6VVZC");

var $ykHdR = parcelRequire("ykHdR");

var $aknDF = parcelRequire("aknDF");

var $iwqgS = parcelRequire("iwqgS");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");

var $9hRVP = parcelRequire("9hRVP");

var $cnyA5 = parcelRequire("cnyA5");
var $jFEU8 = parcelRequire("jFEU8");
var $f93520de2fa37b44$var$bindFlipped = /* #__PURE__ */ $9Grh5.bindFlipped($9hRVP.bindEffect);
var $f93520de2fa37b44$var$map = /* #__PURE__ */ $l0wDR.map($9hRVP.functorEffect);
var $f93520de2fa37b44$export$550acbd06a1f5a6a = /* #__PURE__ */ function() {
    function Loop(value0) {
        this.value0 = value0;
    }
    Loop.create = function(value0) {
        return new Loop(value0);
    };
    return Loop;
}();
var $f93520de2fa37b44$export$7fe28cb29e71bf10 = /* #__PURE__ */ function() {
    function Done(value0) {
        this.value0 = value0;
    }
    Done.create = function(value0) {
        return new Done(value0);
    };
    return Done;
}();
var $f93520de2fa37b44$export$c025cfd4cc93300b = function(dict) {
    return dict.tailRecM;
};
var $f93520de2fa37b44$export$9056a6bb308e8c79 = function(dictMonadRec) {
    var tailRecM1 = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
    return function(f) {
        return function(a) {
            return function(b) {
                return tailRecM1(function(o) {
                    return f(o.a)(o.b);
                })({
                    a: a,
                    b: b
                });
            };
        };
    };
};
var $f93520de2fa37b44$export$db5fda1cbdfd94f2 = function(dictMonadRec) {
    var tailRecM1 = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
    return function(f) {
        return function(a) {
            return function(b) {
                return function(c) {
                    return tailRecM1(function(o) {
                        return f(o.a)(o.b)(o.c);
                    })({
                        a: a,
                        b: b,
                        c: c
                    });
                };
            };
        };
    };
};
var $f93520de2fa37b44$export$f216db41e265325c = function(dictMonadRec) {
    var tailRecM1 = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
    var mapFlipped = $l0wDR.mapFlipped(dictMonadRec.Monad0().Bind1().Apply0().Functor0());
    return function(m) {
        return tailRecM1(function(v) {
            return mapFlipped(m)(function(v1) {
                if (v1 instanceof $ykHdR.Nothing) return new $f93520de2fa37b44$export$550acbd06a1f5a6a($r2HHk.unit);
                if (v1 instanceof $ykHdR.Just) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(v1.value0);
                throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 179, column 43 - line 181, column 19): " + [
                    v1.constructor.name
                ]);
            });
        })($r2HHk.unit);
    };
};
var $f93520de2fa37b44$export$4f7c5e075dda46f7 = function(dictMonoid) {
    var append = $iwqgS.append(dictMonoid.Semigroup0());
    var mempty = $aknDF.mempty(dictMonoid);
    return function(dictMonadRec) {
        var tailRecM1 = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
        var mapFlipped = $l0wDR.mapFlipped(dictMonadRec.Monad0().Bind1().Apply0().Functor0());
        return function(m) {
            return tailRecM1(function(v) {
                return mapFlipped(m)(function(v1) {
                    if (v1 instanceof $ykHdR.Nothing) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(v);
                    if (v1 instanceof $ykHdR.Just) return new $f93520de2fa37b44$export$550acbd06a1f5a6a(append(v)(v1.value0));
                    throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 172, column 45 - line 174, column 26): " + [
                        v1.constructor.name
                    ]);
                });
            })(mempty);
        };
    };
};
var $f93520de2fa37b44$export$2e586eaa876dd2fd = function(f) {
    var go = function($copy_v) {
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v) {
            if (v instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) {
                $copy_v = f(v.value0);
                return;
            }
            if (v instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) {
                $tco_done = true;
                return v.value0;
            }
            throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 103, column 3 - line 103, column 25): " + [
                v.constructor.name
            ]);
        }
        while(!$tco_done)$tco_result = $tco_loop($copy_v);
        return $tco_result;
    };
    return function($85) {
        return go(f($85));
    };
};
var $f93520de2fa37b44$export$1a33088d59e37d84 = function(f) {
    return function(a) {
        return function(b) {
            return $f93520de2fa37b44$export$2e586eaa876dd2fd(function(o) {
                return f(o.a)(o.b);
            })({
                a: a,
                b: b
            });
        };
    };
};
var $f93520de2fa37b44$export$6866e5a95a71aa68 = function(f) {
    return function(a) {
        return function(b) {
            return function(c) {
                return $f93520de2fa37b44$export$2e586eaa876dd2fd(function(o) {
                    return f(o.a)(o.b)(o.c);
                })({
                    a: a,
                    b: b,
                    c: c
                });
            };
        };
    };
};
var $f93520de2fa37b44$export$6a06149683d26749 = {
    tailRecM: function(f) {
        return function(a0) {
            var g = function(v) {
                if (v instanceof $ykHdR.Nothing) return new $f93520de2fa37b44$export$7fe28cb29e71bf10($ykHdR.Nothing.value);
                if (v instanceof $ykHdR.Just && v.value0 instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) return new $f93520de2fa37b44$export$550acbd06a1f5a6a(f(v.value0.value0));
                if (v instanceof $ykHdR.Just && v.value0 instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(new $ykHdR.Just(v.value0.value0));
                throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 153, column 7 - line 153, column 31): " + [
                    v.constructor.name
                ]);
            };
            return $f93520de2fa37b44$export$2e586eaa876dd2fd(g)(f(a0));
        };
    },
    Monad0: function() {
        return $ykHdR.monadMaybe;
    }
};
var $f93520de2fa37b44$export$ef692454cdd8c2ba = {
    tailRecM: function(f) {
        var runIdentity = function(v) {
            return v;
        };
        var $86 = $f93520de2fa37b44$export$2e586eaa876dd2fd(function($88) {
            return runIdentity(f($88));
        });
        return function($87) {
            return $6VVZC.Identity($86($87));
        };
    },
    Monad0: function() {
        return $6VVZC.monadIdentity;
    }
};
var $f93520de2fa37b44$export$6871d929a8e135b0 = {
    tailRecM: function(f) {
        return function(a0) {
            return function(e) {
                return $f93520de2fa37b44$export$2e586eaa876dd2fd(function(a) {
                    return f(a)(e);
                })(a0);
            };
        };
    },
    Monad0: function() {
        return $ibtPS.monadFn;
    }
};
var $f93520de2fa37b44$export$ddd28c989be5e46c = {
    tailRecM: function(f) {
        return function(a0) {
            var g = function(v) {
                if (v instanceof $aKY4H.Left) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(new $aKY4H.Left(v.value0));
                if (v instanceof $aKY4H.Right && v.value0 instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) return new $f93520de2fa37b44$export$550acbd06a1f5a6a(f(v.value0.value0));
                if (v instanceof $aKY4H.Right && v.value0 instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(new $aKY4H.Right(v.value0.value0));
                throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 145, column 7 - line 145, column 33): " + [
                    v.constructor.name
                ]);
            };
            return $f93520de2fa37b44$export$2e586eaa876dd2fd(g)(f(a0));
        };
    },
    Monad0: function() {
        return $aKY4H.monadEither;
    }
};
var $f93520de2fa37b44$export$c2472dc015e90d28 = {
    tailRecM: function(f) {
        return function(a) {
            var fromDone = function(v) {
                if (v instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return v.value0;
                throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 137, column 30 - line 137, column 44): " + [
                    v.constructor.name
                ]);
            };
            return function __do() {
                var r = $f93520de2fa37b44$var$bindFlipped($cnyA5.new)(f(a))();
                (function() {
                    while(!function __do() {
                        var v = $jFEU8.read(r)();
                        if (v instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) {
                            var e = f(v.value0)();
                            $jFEU8.write(e)(r)();
                            return false;
                        }
                        if (v instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return true;
                        throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 128, column 22 - line 133, column 28): " + [
                            v.constructor.name
                        ]);
                    }());
                    return {};
                })();
                return $f93520de2fa37b44$var$map(fromDone)($jFEU8.read(r))();
            };
        };
    },
    Monad0: function() {
        return $9hRVP.monadEffect;
    }
};
var $f93520de2fa37b44$export$432fdf8e79663288 = function(a) {
    return function(b) {
        return function(c) {
            return new $f93520de2fa37b44$export$550acbd06a1f5a6a({
                a: a,
                b: b,
                c: c
            });
        };
    };
};
var $f93520de2fa37b44$export$e10d15f285e25594 = function(a) {
    return function(b) {
        return new $f93520de2fa37b44$export$550acbd06a1f5a6a({
            a: a,
            b: b
        });
    };
};
var $f93520de2fa37b44$export$ff1ade7cb067ac12 = {
    map: function(f) {
        return function(m) {
            if (m instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) return new $f93520de2fa37b44$export$550acbd06a1f5a6a(m.value0);
            if (m instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(f(m.value0));
            throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 0, column 0 - line 0, column 0): " + [
                m.constructor.name
            ]);
        };
    }
};
var $f93520de2fa37b44$export$116a0f7f2303acd8 = function(dictMonadRec) {
    var tailRecM1 = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
    var voidRight = $l0wDR.voidRight(dictMonadRec.Monad0().Bind1().Apply0().Functor0());
    return function(ma) {
        return tailRecM1(function(u) {
            return voidRight(new $f93520de2fa37b44$export$550acbd06a1f5a6a(u))(ma);
        })($r2HHk.unit);
    };
};
var $f93520de2fa37b44$export$61e43214bca7f031 = {
    bimap: function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) return new $f93520de2fa37b44$export$550acbd06a1f5a6a(v(v2.value0));
                if (v2 instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(v1(v2.value0));
                throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 33, column 1 - line 35, column 34): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    }
};

});
parcelRegister("aKY4H", function(module, exports) {

$parcel$export(module.exports, "Left", () => $7d4cccdf062a2261$export$37c4d04eafdc5515);
$parcel$export(module.exports, "Right", () => $7d4cccdf062a2261$export$19db0165690c701a);
$parcel$export(module.exports, "functorEither", () => $7d4cccdf062a2261$export$f0a413d3d6075601);
$parcel$export(module.exports, "eqEither", () => $7d4cccdf062a2261$export$bde8fea66b0f9f9a);
$parcel$export(module.exports, "ordEither", () => $7d4cccdf062a2261$export$f105364bfbaa033b);
$parcel$export(module.exports, "either", () => $7d4cccdf062a2261$export$5f5be1bb6cd1fded);
$parcel$export(module.exports, "applyEither", () => $7d4cccdf062a2261$export$d5df7cb019d08f04);
$parcel$export(module.exports, "bindEither", () => $7d4cccdf062a2261$export$3806e10d0c441ac5);
$parcel$export(module.exports, "applicativeEither", () => $7d4cccdf062a2261$export$400f1ef3f3ec304d);
$parcel$export(module.exports, "monadEither", () => $7d4cccdf062a2261$export$b3b4ecb28e3a8df3);
// Generated by purs version 0.15.16

var $a7Dxq = parcelRequire("a7Dxq");

var $a5g3C = parcelRequire("a5g3C");

var $95fRU = parcelRequire("95fRU");

var $4MBcA = parcelRequire("4MBcA");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");

var $5hqdn = parcelRequire("5hqdn");

var $cw1rg = parcelRequire("cw1rg");

var $ykHdR = parcelRequire("ykHdR");

var $d0PPW = parcelRequire("d0PPW");

var $6SDUu = parcelRequire("6SDUu");

var $iwqgS = parcelRequire("iwqgS");

var $3Orkn = parcelRequire("3Orkn");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");
var $7d4cccdf062a2261$export$37c4d04eafdc5515 = /* #__PURE__ */ function() {
    function Left(value0) {
        this.value0 = value0;
    }
    Left.create = function(value0) {
        return new Left(value0);
    };
    return Left;
}();
var $7d4cccdf062a2261$export$19db0165690c701a = /* #__PURE__ */ function() {
    function Right(value0) {
        this.value0 = value0;
    }
    Right.create = function(value0) {
        return new Right(value0);
    };
    return Right;
}();
var $7d4cccdf062a2261$export$37ab35e89b41eda = function(dictShow) {
    var show = $3Orkn.show(dictShow);
    return function(dictShow1) {
        var show1 = $3Orkn.show(dictShow1);
        return {
            show: function(v) {
                if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return "(Left " + (show(v.value0) + ")");
                if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return "(Right " + (show1(v.value0) + ")");
                throw new Error("Failed pattern match at Data.Either (line 173, column 1 - line 175, column 46): " + [
                    v.constructor.name
                ]);
            }
        };
    };
};
var $7d4cccdf062a2261$export$e29cdc8bc2cafc59 = function(f) {
    return $ykHdR.maybe$prime(function($138) {
        return $7d4cccdf062a2261$export$37c4d04eafdc5515.create(f($138));
    })($7d4cccdf062a2261$export$19db0165690c701a.create);
};
var $7d4cccdf062a2261$export$a92e4c44d367d0af = function(a) {
    return $ykHdR.maybe(new $7d4cccdf062a2261$export$37c4d04eafdc5515(a))($7d4cccdf062a2261$export$19db0165690c701a.create);
};
var $7d4cccdf062a2261$export$72a1c23d752d2155 = {
    to: function(x) {
        if (x instanceof $cw1rg.Inl) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(x.value0);
        if (x instanceof $cw1rg.Inr) return new $7d4cccdf062a2261$export$19db0165690c701a(x.value0);
        throw new Error("Failed pattern match at Data.Either (line 33, column 1 - line 33, column 56): " + [
            x.constructor.name
        ]);
    },
    from: function(x) {
        if (x instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $cw1rg.Inl(x.value0);
        if (x instanceof $7d4cccdf062a2261$export$19db0165690c701a) return new $cw1rg.Inr(x.value0);
        throw new Error("Failed pattern match at Data.Either (line 33, column 1 - line 33, column 56): " + [
            x.constructor.name
        ]);
    }
};
var $7d4cccdf062a2261$export$f0a413d3d6075601 = {
    map: function(f) {
        return function(m) {
            if (m instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(m.value0);
            if (m instanceof $7d4cccdf062a2261$export$19db0165690c701a) return new $7d4cccdf062a2261$export$19db0165690c701a(f(m.value0));
            throw new Error("Failed pattern match at Data.Either (line 0, column 0 - line 0, column 0): " + [
                m.constructor.name
            ]);
        };
    }
};
var $7d4cccdf062a2261$var$map = /* #__PURE__ */ $l0wDR.map($7d4cccdf062a2261$export$f0a413d3d6075601);
var $7d4cccdf062a2261$export$26473b852950cc9f = {
    imap: /* #__PURE__ */ $5hqdn.imapF($7d4cccdf062a2261$export$f0a413d3d6075601)
};
var $7d4cccdf062a2261$export$f41f6e6ed5e42617 = function(v) {
    return function(v1) {
        if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return v1.value0;
        return v($r2HHk.unit);
    };
};
var $7d4cccdf062a2261$export$27d3ca2b5d864fdd = function(v) {
    return function(v1) {
        if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return v1.value0;
        return v;
    };
};
var $7d4cccdf062a2261$export$a6bf632a63e8a255 = function(v) {
    return function(v1) {
        if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return v1.value0;
        return v($r2HHk.unit);
    };
};
var $7d4cccdf062a2261$export$ed20f362be8f8b52 = function(v) {
    return function(v1) {
        if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return v1.value0;
        return v;
    };
};
var $7d4cccdf062a2261$export$d6a44bcd37031227 = {
    extend: function(v) {
        return function(v1) {
            if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(v1.value0);
            return new $7d4cccdf062a2261$export$19db0165690c701a(v(v1));
        };
    },
    Functor0: function() {
        return $7d4cccdf062a2261$export$f0a413d3d6075601;
    }
};
var $7d4cccdf062a2261$export$bde8fea66b0f9f9a = function(dictEq) {
    var eq = $4MBcA.eq(dictEq);
    return function(dictEq1) {
        var eq1 = $4MBcA.eq(dictEq1);
        return {
            eq: function(x) {
                return function(y) {
                    if (x instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515 && y instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return eq(x.value0)(y.value0);
                    if (x instanceof $7d4cccdf062a2261$export$19db0165690c701a && y instanceof $7d4cccdf062a2261$export$19db0165690c701a) return eq1(x.value0)(y.value0);
                    return false;
                };
            }
        };
    };
};
var $7d4cccdf062a2261$export$f105364bfbaa033b = function(dictOrd) {
    var compare = $d0PPW.compare(dictOrd);
    var eqEither1 = $7d4cccdf062a2261$export$bde8fea66b0f9f9a(dictOrd.Eq0());
    return function(dictOrd1) {
        var compare1 = $d0PPW.compare(dictOrd1);
        var eqEither2 = eqEither1(dictOrd1.Eq0());
        return {
            compare: function(x) {
                return function(y) {
                    if (x instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515 && y instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return compare(x.value0)(y.value0);
                    if (x instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $6SDUu.LT.value;
                    if (y instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $6SDUu.GT.value;
                    if (x instanceof $7d4cccdf062a2261$export$19db0165690c701a && y instanceof $7d4cccdf062a2261$export$19db0165690c701a) return compare1(x.value0)(y.value0);
                    throw new Error("Failed pattern match at Data.Either (line 0, column 0 - line 0, column 0): " + [
                        x.constructor.name,
                        y.constructor.name
                    ]);
                };
            },
            Eq0: function() {
                return eqEither2;
            }
        };
    };
};
var $7d4cccdf062a2261$export$551ea40f4c230981 = function(dictEq) {
    var eqEither1 = $7d4cccdf062a2261$export$bde8fea66b0f9f9a(dictEq);
    return {
        eq1: function(dictEq1) {
            return $4MBcA.eq(eqEither1(dictEq1));
        }
    };
};
var $7d4cccdf062a2261$export$f4a01dc57c45522b = function(dictOrd) {
    var ordEither1 = $7d4cccdf062a2261$export$f105364bfbaa033b(dictOrd);
    var eq1Either1 = $7d4cccdf062a2261$export$551ea40f4c230981(dictOrd.Eq0());
    return {
        compare1: function(dictOrd1) {
            return $d0PPW.compare(ordEither1(dictOrd1));
        },
        Eq10: function() {
            return eq1Either1;
        }
    };
};
var $7d4cccdf062a2261$export$5f5be1bb6cd1fded = function(v) {
    return function(v1) {
        return function(v2) {
            if (v2 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return v(v2.value0);
            if (v2 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return v1(v2.value0);
            throw new Error("Failed pattern match at Data.Either (line 208, column 1 - line 208, column 64): " + [
                v.constructor.name,
                v1.constructor.name,
                v2.constructor.name
            ]);
        };
    };
};
var $7d4cccdf062a2261$export$3a6c138b8d0f3874 = /* #__PURE__ */ function() {
    return $7d4cccdf062a2261$export$5f5be1bb6cd1fded($l4M7e.const($ykHdR.Nothing.value))($ykHdR.Just.create);
}();
var $7d4cccdf062a2261$export$d649b6842e09f2b = /* #__PURE__ */ $7d4cccdf062a2261$export$5f5be1bb6cd1fded(/* #__PURE__ */ $l4M7e.const(true))(/* #__PURE__ */ $l4M7e.const(false));
var $7d4cccdf062a2261$export$a9d71693f0c1a85d = /* #__PURE__ */ $7d4cccdf062a2261$export$5f5be1bb6cd1fded(/* #__PURE__ */ $l4M7e.const(false))(/* #__PURE__ */ $l4M7e.const(true));
var $7d4cccdf062a2261$export$7877a478dd30fd3d = function(dictAlt) {
    var alt = $a7Dxq.alt(dictAlt);
    var map1 = $l0wDR.map(dictAlt.Functor0());
    return function(a) {
        return function(b) {
            return alt(map1($7d4cccdf062a2261$export$37c4d04eafdc5515.create)(a))(map1($7d4cccdf062a2261$export$19db0165690c701a.create)(b));
        };
    };
};
var $7d4cccdf062a2261$export$39ea3c8fac814734 = function(dictBounded) {
    var bottom = $95fRU.bottom(dictBounded);
    var ordEither1 = $7d4cccdf062a2261$export$f105364bfbaa033b(dictBounded.Ord0());
    return function(dictBounded1) {
        var ordEither2 = ordEither1(dictBounded1.Ord0());
        return {
            top: new $7d4cccdf062a2261$export$19db0165690c701a($95fRU.top(dictBounded1)),
            bottom: new $7d4cccdf062a2261$export$37c4d04eafdc5515(bottom),
            Ord0: function() {
                return ordEither2;
            }
        };
    };
};
var $7d4cccdf062a2261$export$521d8864384143c6 = /* #__PURE__ */ function() {
    return $7d4cccdf062a2261$export$5f5be1bb6cd1fded($ykHdR.Just.create)($l4M7e.const($ykHdR.Nothing.value));
}();
var $7d4cccdf062a2261$export$d5df7cb019d08f04 = {
    apply: function(v) {
        return function(v1) {
            if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(v.value0);
            if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $7d4cccdf062a2261$var$map(v.value0)(v1);
            throw new Error("Failed pattern match at Data.Either (line 70, column 1 - line 72, column 30): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    Functor0: function() {
        return $7d4cccdf062a2261$export$f0a413d3d6075601;
    }
};
var $7d4cccdf062a2261$var$apply = /* #__PURE__ */ $a5g3C.apply($7d4cccdf062a2261$export$d5df7cb019d08f04);
var $7d4cccdf062a2261$export$3806e10d0c441ac5 = {
    bind: /* #__PURE__ */ $7d4cccdf062a2261$export$5f5be1bb6cd1fded(function(e) {
        return function(v) {
            return new $7d4cccdf062a2261$export$37c4d04eafdc5515(e);
        };
    })(function(a) {
        return function(f) {
            return f(a);
        };
    }),
    Apply0: function() {
        return $7d4cccdf062a2261$export$d5df7cb019d08f04;
    }
};
var $7d4cccdf062a2261$export$56cf4be43732c31d = function(dictSemigroup) {
    var append1 = $iwqgS.append(dictSemigroup);
    return {
        append: function(x) {
            return function(y) {
                return $7d4cccdf062a2261$var$apply($7d4cccdf062a2261$var$map(append1)(x))(y);
            };
        }
    };
};
var $7d4cccdf062a2261$export$400f1ef3f3ec304d = /* #__PURE__ */ function() {
    return {
        pure: $7d4cccdf062a2261$export$19db0165690c701a.create,
        Apply0: function() {
            return $7d4cccdf062a2261$export$d5df7cb019d08f04;
        }
    };
}();
var $7d4cccdf062a2261$export$b3b4ecb28e3a8df3 = {
    Applicative0: function() {
        return $7d4cccdf062a2261$export$400f1ef3f3ec304d;
    },
    Bind1: function() {
        return $7d4cccdf062a2261$export$3806e10d0c441ac5;
    }
};
var $7d4cccdf062a2261$export$79ac44fe35dcf650 = {
    alt: function(v) {
        return function(v1) {
            if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return v1;
            return v;
        };
    },
    Functor0: function() {
        return $7d4cccdf062a2261$export$f0a413d3d6075601;
    }
};

});
parcelRegister("a7Dxq", function(module, exports) {

$parcel$export(module.exports, "altArray", () => $75e93a4111e80214$export$186d613bb872946c);
$parcel$export(module.exports, "alt", () => $75e93a4111e80214$export$228be17d80722ab);
// Generated by purs version 0.15.16

var $l0wDR = parcelRequire("l0wDR");

var $iwqgS = parcelRequire("iwqgS");
var $75e93a4111e80214$export$186d613bb872946c = {
    alt: /* #__PURE__ */ $iwqgS.append($iwqgS.semigroupArray),
    Functor0: function() {
        return $l0wDR.functorArray;
    }
};
var $75e93a4111e80214$export$228be17d80722ab = function(dict) {
    return dict.alt;
};

});
parcelRegister("iwqgS", function(module, exports) {

$parcel$export(module.exports, "semigroupUnit", () => $d7bf9817a417d4ae$export$824c37c4afd77b1);
$parcel$export(module.exports, "semigroupString", () => $d7bf9817a417d4ae$export$d9b7100b101f2c5b);
$parcel$export(module.exports, "semigroupRecordNil", () => $d7bf9817a417d4ae$export$955753116dc9242c);
$parcel$export(module.exports, "semigroupArray", () => $d7bf9817a417d4ae$export$d082f07d0a8e9909);
$parcel$export(module.exports, "semigroupRecord", () => $d7bf9817a417d4ae$export$dbfe6b321632d7c9);
$parcel$export(module.exports, "append", () => $d7bf9817a417d4ae$export$10d8903dec122b9d);
$parcel$export(module.exports, "semigroupFn", () => $d7bf9817a417d4ae$export$49c9dc4575956c55);
$parcel$export(module.exports, "semigroupRecordCons", () => $d7bf9817a417d4ae$export$74eae24c3d2a7535);
// Generated by purs version 0.15.16

var $fFQtG = parcelRequire("fFQtG");

var $2HEu8 = parcelRequire("2HEu8");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");

var $7DusG = parcelRequire("7DusG");
parcelRequire("2zMBQ");
var $i72yb = parcelRequire("i72yb");

var $h3hu6 = parcelRequire("h3hu6");
var $d7bf9817a417d4ae$export$36aabcd6b6e45f3b = {
    append: function(v) {
        return $7DusG.absurd;
    }
};
var $d7bf9817a417d4ae$export$824c37c4afd77b1 = {
    append: function(v) {
        return function(v1) {
            return $r2HHk.unit;
        };
    }
};
var $d7bf9817a417d4ae$export$d9b7100b101f2c5b = {
    append: $fFQtG.concatString
};
var $d7bf9817a417d4ae$export$955753116dc9242c = {
    appendRecord: function(v) {
        return function(v1) {
            return function(v2) {
                return {};
            };
        };
    }
};
var $d7bf9817a417d4ae$export$af5ddea0c4d23f3c = {
    append: function(v) {
        return function(v1) {
            return $h3hu6.Proxy.value;
        };
    }
};
var $d7bf9817a417d4ae$export$d082f07d0a8e9909 = {
    append: $fFQtG.concatArray
};
var $d7bf9817a417d4ae$export$1e8e5e81637c934d = function(dict) {
    return dict.appendRecord;
};
var $d7bf9817a417d4ae$export$dbfe6b321632d7c9 = function() {
    return function(dictSemigroupRecord) {
        return {
            append: $d7bf9817a417d4ae$export$1e8e5e81637c934d(dictSemigroupRecord)($h3hu6.Proxy.value)
        };
    };
};
var $d7bf9817a417d4ae$export$10d8903dec122b9d = function(dict) {
    return dict.append;
};
var $d7bf9817a417d4ae$export$49c9dc4575956c55 = function(dictSemigroup) {
    var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    return {
        append: function(f) {
            return function(g) {
                return function(x) {
                    return append1(f(x))(g(x));
                };
            };
        }
    };
};
var $d7bf9817a417d4ae$export$74eae24c3d2a7535 = function(dictIsSymbol) {
    var reflectSymbol = $2HEu8.reflectSymbol(dictIsSymbol);
    return function() {
        return function(dictSemigroupRecord) {
            var appendRecord1 = $d7bf9817a417d4ae$export$1e8e5e81637c934d(dictSemigroupRecord);
            return function(dictSemigroup) {
                var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
                return {
                    appendRecord: function(v) {
                        return function(ra) {
                            return function(rb) {
                                var tail = appendRecord1($h3hu6.Proxy.value)(ra)(rb);
                                var key = reflectSymbol($h3hu6.Proxy.value);
                                var insert = $i72yb.unsafeSet(key);
                                var get = $i72yb.unsafeGet(key);
                                return insert(append1(get(ra))(get(rb)))(tail);
                            };
                        };
                    }
                };
            };
        };
    };
};

});
parcelRegister("fFQtG", function(module, exports) {

$parcel$export(module.exports, "concatString", () => $b693645c2c75f222$export$171e7edd26203a84);
$parcel$export(module.exports, "concatArray", () => $b693645c2c75f222$export$4fd8af2c48c43416);
const $b693645c2c75f222$export$171e7edd26203a84 = function(s1) {
    return function(s2) {
        return s1 + s2;
    };
};
const $b693645c2c75f222$export$4fd8af2c48c43416 = function(xs) {
    return function(ys) {
        if (xs.length === 0) return ys;
        if (ys.length === 0) return xs;
        return xs.concat(ys);
    };
};

});

parcelRegister("2HEu8", function(module, exports) {

$parcel$export(module.exports, "reflectSymbol", () => $1f7f00687c3959c5$export$e5ed8a20a1c4d576);
// Generated by purs version 0.15.16

var $g3Abr = parcelRequire("g3Abr");

var $h3hu6 = parcelRequire("h3hu6");
var $1f7f00687c3959c5$export$340e995c37375b7a = function(s) {
    return function(f) {
        return $g3Abr.unsafeCoerce(function(dictIsSymbol) {
            return f(dictIsSymbol);
        })({
            reflectSymbol: function(v) {
                return s;
            }
        })($h3hu6.Proxy.value);
    };
};
var $1f7f00687c3959c5$export$e5ed8a20a1c4d576 = function(dict) {
    return dict.reflectSymbol;
};

});
parcelRegister("g3Abr", function(module, exports) {

$parcel$export(module.exports, "unsafeCoerce", () => $bb08fe6cef393d6b$export$401372c57776dc);
// module Data.Symbol
const $bb08fe6cef393d6b$export$401372c57776dc = function(arg) {
    return arg;
};

});


parcelRegister("7DusG", function(module, exports) {

$parcel$export(module.exports, "absurd", () => $58f3cdfbfe212d20$export$f172309911142386);
// Generated by purs version 0.15.16
var $58f3cdfbfe212d20$var$Void = function(x) {
    return x;
};
var $58f3cdfbfe212d20$export$f172309911142386 = function(a) {
    var spin = function($copy_v) {
        var $tco_result;
        function $tco_loop(v) {
            $copy_v = v;
            return;
        }
        while(true)$tco_result = $tco_loop($copy_v);
        return $tco_result;
    };
    return spin(a);
};

});

parcelRegister("2zMBQ", function(module, exports) {

$parcel$export(module.exports, "unsafeGet", () => (parcelRequire("i72yb")).unsafeGet);
$parcel$export(module.exports, "unsafeSet", () => (parcelRequire("i72yb")).unsafeSet);
// Generated by purs version 0.15.16

var $i72yb = parcelRequire("i72yb");

});
parcelRegister("i72yb", function(module, exports) {

$parcel$export(module.exports, "unsafeGet", () => $d2fadbdf02925823$export$1d94535d2cda4eda);
$parcel$export(module.exports, "unsafeSet", () => $d2fadbdf02925823$export$444262986932b766);
const $d2fadbdf02925823$export$12c1b2b255bc527d = function(label) {
    return function(rec) {
        return ({}).hasOwnProperty.call(rec, label);
    };
};
const $d2fadbdf02925823$export$1d94535d2cda4eda = function(label) {
    return function(rec) {
        return rec[label];
    };
};
const $d2fadbdf02925823$export$444262986932b766 = function(label) {
    return function(value) {
        return function(rec) {
            var copy = {};
            for(var key in rec)if (({}).hasOwnProperty.call(rec, key)) copy[key] = rec[key];
            copy[label] = value;
            return copy;
        };
    };
};
const $d2fadbdf02925823$export$14b6a75b3eb38458 = function(label) {
    return function(rec) {
        var copy = {};
        for(var key in rec)if (key !== label && ({}).hasOwnProperty.call(rec, key)) copy[key] = rec[key];
        return copy;
    };
};

});




parcelRegister("95fRU", function(module, exports) {

$parcel$export(module.exports, "top", () => $69d0e3dbb12088d2$export$1e95b668f3b82d);
$parcel$export(module.exports, "boundedUnit", () => $69d0e3dbb12088d2$export$48259b86288d7b58);
$parcel$export(module.exports, "boundedOrdering", () => $69d0e3dbb12088d2$export$2e0fd44408d4861);
$parcel$export(module.exports, "boundedInt", () => $69d0e3dbb12088d2$export$c84fa7e5ca2385dd);
$parcel$export(module.exports, "boundedChar", () => $69d0e3dbb12088d2$export$7cd7c97ac7ec5b79);
$parcel$export(module.exports, "boundedBoolean", () => $69d0e3dbb12088d2$export$b6c012947af8ebbc);
$parcel$export(module.exports, "bottom", () => $69d0e3dbb12088d2$export$40e543e69a8b3fbb);
// Generated by purs version 0.15.16

var $hBO1V = parcelRequire("hBO1V");

var $d0PPW = parcelRequire("d0PPW");

var $6SDUu = parcelRequire("6SDUu");

var $2HEu8 = parcelRequire("2HEu8");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");
parcelRequire("2zMBQ");
var $i72yb = parcelRequire("i72yb");

var $h3hu6 = parcelRequire("h3hu6");
var $69d0e3dbb12088d2$var$ordRecord = /* #__PURE__ */ $d0PPW.ordRecord();
var $69d0e3dbb12088d2$export$407dd25a598bb432 = function(dict) {
    return dict.topRecord;
};
var $69d0e3dbb12088d2$export$1e95b668f3b82d = function(dict) {
    return dict.top;
};
var $69d0e3dbb12088d2$export$48259b86288d7b58 = {
    top: $r2HHk.unit,
    bottom: $r2HHk.unit,
    Ord0: function() {
        return $d0PPW.ordUnit;
    }
};
var $69d0e3dbb12088d2$export$8978fddf7d98bede = {
    topRecord: function(v) {
        return function(v1) {
            return {};
        };
    },
    bottomRecord: function(v) {
        return function(v1) {
            return {};
        };
    },
    OrdRecord0: function() {
        return $d0PPW.ordRecordNil;
    }
};
var $69d0e3dbb12088d2$export$6001ef8e188ae2f5 = /* #__PURE__ */ function() {
    return {
        bottom: $h3hu6.Proxy.value,
        top: $h3hu6.Proxy.value,
        Ord0: function() {
            return $d0PPW.ordProxy;
        }
    };
}();
var $69d0e3dbb12088d2$export$2e0fd44408d4861 = /* #__PURE__ */ function() {
    return {
        top: $6SDUu.GT.value,
        bottom: $6SDUu.LT.value,
        Ord0: function() {
            return $d0PPW.ordOrdering;
        }
    };
}();
var $69d0e3dbb12088d2$export$5acaecf0b0cd5fa9 = {
    top: $hBO1V.topNumber,
    bottom: $hBO1V.bottomNumber,
    Ord0: function() {
        return $d0PPW.ordNumber;
    }
};
var $69d0e3dbb12088d2$export$c84fa7e5ca2385dd = {
    top: $hBO1V.topInt,
    bottom: $hBO1V.bottomInt,
    Ord0: function() {
        return $d0PPW.ordInt;
    }
};
var $69d0e3dbb12088d2$export$7cd7c97ac7ec5b79 = {
    top: $hBO1V.topChar,
    bottom: $hBO1V.bottomChar,
    Ord0: function() {
        return $d0PPW.ordChar;
    }
};
var $69d0e3dbb12088d2$export$b6c012947af8ebbc = {
    top: true,
    bottom: false,
    Ord0: function() {
        return $d0PPW.ordBoolean;
    }
};
var $69d0e3dbb12088d2$export$72232990c70f5e82 = function(dict) {
    return dict.bottomRecord;
};
var $69d0e3dbb12088d2$export$8d7db335b27db939 = function() {
    return function(dictBoundedRecord) {
        var ordRecord1 = $69d0e3dbb12088d2$var$ordRecord(dictBoundedRecord.OrdRecord0());
        return {
            top: $69d0e3dbb12088d2$export$407dd25a598bb432(dictBoundedRecord)($h3hu6.Proxy.value)($h3hu6.Proxy.value),
            bottom: $69d0e3dbb12088d2$export$72232990c70f5e82(dictBoundedRecord)($h3hu6.Proxy.value)($h3hu6.Proxy.value),
            Ord0: function() {
                return ordRecord1;
            }
        };
    };
};
var $69d0e3dbb12088d2$export$40e543e69a8b3fbb = function(dict) {
    return dict.bottom;
};
var $69d0e3dbb12088d2$export$53fc630a84ecc59b = function(dictIsSymbol) {
    var reflectSymbol = $2HEu8.reflectSymbol(dictIsSymbol);
    return function(dictBounded) {
        var top1 = $69d0e3dbb12088d2$export$1e95b668f3b82d(dictBounded);
        var bottom1 = $69d0e3dbb12088d2$export$40e543e69a8b3fbb(dictBounded);
        var Ord0 = dictBounded.Ord0();
        return function() {
            return function() {
                return function(dictBoundedRecord) {
                    var topRecord1 = $69d0e3dbb12088d2$export$407dd25a598bb432(dictBoundedRecord);
                    var bottomRecord1 = $69d0e3dbb12088d2$export$72232990c70f5e82(dictBoundedRecord);
                    var ordRecordCons = $d0PPW.ordRecordCons(dictBoundedRecord.OrdRecord0())()(dictIsSymbol)(Ord0);
                    return {
                        topRecord: function(v) {
                            return function(rowProxy) {
                                var tail = topRecord1($h3hu6.Proxy.value)(rowProxy);
                                var key = reflectSymbol($h3hu6.Proxy.value);
                                var insert = $i72yb.unsafeSet(key);
                                return insert(top1)(tail);
                            };
                        },
                        bottomRecord: function(v) {
                            return function(rowProxy) {
                                var tail = bottomRecord1($h3hu6.Proxy.value)(rowProxy);
                                var key = reflectSymbol($h3hu6.Proxy.value);
                                var insert = $i72yb.unsafeSet(key);
                                return insert(bottom1)(tail);
                            };
                        },
                        OrdRecord0: function() {
                            return ordRecordCons;
                        }
                    };
                };
            };
        };
    };
};

});
parcelRegister("hBO1V", function(module, exports) {

$parcel$export(module.exports, "topInt", () => $cd1cb347a48b7ff0$export$afdd678689eb299);
$parcel$export(module.exports, "bottomInt", () => $cd1cb347a48b7ff0$export$4a17ba08fd82d88b);
$parcel$export(module.exports, "topChar", () => $cd1cb347a48b7ff0$export$4ffd3705721c8b5b);
$parcel$export(module.exports, "bottomChar", () => $cd1cb347a48b7ff0$export$d6be889e229abd84);
$parcel$export(module.exports, "topNumber", () => $cd1cb347a48b7ff0$export$ef55dfccfe3a15b);
$parcel$export(module.exports, "bottomNumber", () => $cd1cb347a48b7ff0$export$d1edf35dfee544b5);
const $cd1cb347a48b7ff0$export$afdd678689eb299 = 2147483647;
const $cd1cb347a48b7ff0$export$4a17ba08fd82d88b = -2147483648;
const $cd1cb347a48b7ff0$export$4ffd3705721c8b5b = String.fromCharCode(65535);
const $cd1cb347a48b7ff0$export$d6be889e229abd84 = String.fromCharCode(0);
const $cd1cb347a48b7ff0$export$ef55dfccfe3a15b = Number.POSITIVE_INFINITY;
const $cd1cb347a48b7ff0$export$d1edf35dfee544b5 = Number.NEGATIVE_INFINITY;

});

parcelRegister("d0PPW", function(module, exports) {

$parcel$export(module.exports, "ordUnit", () => $97937c29f879e68e$export$f6b429625e3530b0);
$parcel$export(module.exports, "ordString", () => $97937c29f879e68e$export$c5f2758e49b2b86a);
$parcel$export(module.exports, "ordRecordNil", () => $97937c29f879e68e$export$927f7db8ecc0069f);
$parcel$export(module.exports, "ordProxy", () => $97937c29f879e68e$export$55c25d215527e8e8);
$parcel$export(module.exports, "ordOrdering", () => $97937c29f879e68e$export$dcb5533042a37f3c);
$parcel$export(module.exports, "ordNumber", () => $97937c29f879e68e$export$5ed021ff2336715c);
$parcel$export(module.exports, "ordInt", () => $97937c29f879e68e$export$ff461bf68e7dd332);
$parcel$export(module.exports, "ordChar", () => $97937c29f879e68e$export$3abd12c96be3b09b);
$parcel$export(module.exports, "ordBoolean", () => $97937c29f879e68e$export$ef759d57a4e44836);
$parcel$export(module.exports, "ordRecord", () => $97937c29f879e68e$export$ebb7a7956d139174);
$parcel$export(module.exports, "compare1", () => $97937c29f879e68e$export$693feb0c3c484b70);
$parcel$export(module.exports, "compare", () => $97937c29f879e68e$export$398604a469f7de9a);
$parcel$export(module.exports, "comparing", () => $97937c29f879e68e$export$e9509a298f6befc2);
$parcel$export(module.exports, "greaterThan", () => $97937c29f879e68e$export$f517ea36c68d4644);
$parcel$export(module.exports, "greaterThanOrEq", () => $97937c29f879e68e$export$4be320a4fd1ac499);
$parcel$export(module.exports, "lessThan", () => $97937c29f879e68e$export$9b050841a3a1b328);
$parcel$export(module.exports, "lessThanOrEq", () => $97937c29f879e68e$export$f0c1dc893917aeba);
$parcel$export(module.exports, "max", () => $97937c29f879e68e$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $97937c29f879e68e$export$96ec731ed4dcb222);
$parcel$export(module.exports, "ordArray", () => $97937c29f879e68e$export$6ace7ea8ac01a75e);
$parcel$export(module.exports, "ord1Array", () => $97937c29f879e68e$export$8e34cc59438cf1bf);
$parcel$export(module.exports, "ordRecordCons", () => $97937c29f879e68e$export$a9b387b18fb85611);
$parcel$export(module.exports, "abs", () => $97937c29f879e68e$export$2335f513bbd82c6d);
// Generated by purs version 0.15.16

var $jgZMl = parcelRequire("jgZMl");

var $4MBcA = parcelRequire("4MBcA");

var $6SDUu = parcelRequire("6SDUu");

var $hTcAb = parcelRequire("hTcAb");

var $gyPYh = parcelRequire("gyPYh");

var $2HEu8 = parcelRequire("2HEu8");
parcelRequire("2zMBQ");
var $i72yb = parcelRequire("i72yb");

var $h3hu6 = parcelRequire("h3hu6");
var $97937c29f879e68e$var$eqRec = /* #__PURE__ */ $4MBcA.eqRec();
var $97937c29f879e68e$var$notEq = /* #__PURE__ */ $4MBcA.notEq($6SDUu.eqOrdering);
var $97937c29f879e68e$export$752cdd067643c910 = {
    compare: function(v) {
        return function(v1) {
            return $6SDUu.EQ.value;
        };
    },
    Eq0: function() {
        return $4MBcA.eqVoid;
    }
};
var $97937c29f879e68e$export$f6b429625e3530b0 = {
    compare: function(v) {
        return function(v1) {
            return $6SDUu.EQ.value;
        };
    },
    Eq0: function() {
        return $4MBcA.eqUnit;
    }
};
var $97937c29f879e68e$export$c5f2758e49b2b86a = /* #__PURE__ */ function() {
    return {
        compare: $jgZMl.ordStringImpl($6SDUu.LT.value)($6SDUu.EQ.value)($6SDUu.GT.value),
        Eq0: function() {
            return $4MBcA.eqString;
        }
    };
}();
var $97937c29f879e68e$export$927f7db8ecc0069f = {
    compareRecord: function(v) {
        return function(v1) {
            return function(v2) {
                return $6SDUu.EQ.value;
            };
        };
    },
    EqRecord0: function() {
        return $4MBcA.eqRowNil;
    }
};
var $97937c29f879e68e$export$55c25d215527e8e8 = {
    compare: function(v) {
        return function(v1) {
            return $6SDUu.EQ.value;
        };
    },
    Eq0: function() {
        return $4MBcA.eqProxy;
    }
};
var $97937c29f879e68e$export$dcb5533042a37f3c = {
    compare: function(v) {
        return function(v1) {
            if (v instanceof $6SDUu.LT && v1 instanceof $6SDUu.LT) return $6SDUu.EQ.value;
            if (v instanceof $6SDUu.EQ && v1 instanceof $6SDUu.EQ) return $6SDUu.EQ.value;
            if (v instanceof $6SDUu.GT && v1 instanceof $6SDUu.GT) return $6SDUu.EQ.value;
            if (v instanceof $6SDUu.LT) return $6SDUu.LT.value;
            if (v instanceof $6SDUu.EQ && v1 instanceof $6SDUu.LT) return $6SDUu.GT.value;
            if (v instanceof $6SDUu.EQ && v1 instanceof $6SDUu.GT) return $6SDUu.LT.value;
            if (v instanceof $6SDUu.GT) return $6SDUu.GT.value;
            throw new Error("Failed pattern match at Data.Ord (line 126, column 1 - line 133, column 20): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $6SDUu.eqOrdering;
    }
};
var $97937c29f879e68e$export$5ed021ff2336715c = /* #__PURE__ */ function() {
    return {
        compare: $jgZMl.ordNumberImpl($6SDUu.LT.value)($6SDUu.EQ.value)($6SDUu.GT.value),
        Eq0: function() {
            return $4MBcA.eqNumber;
        }
    };
}();
var $97937c29f879e68e$export$ff461bf68e7dd332 = /* #__PURE__ */ function() {
    return {
        compare: $jgZMl.ordIntImpl($6SDUu.LT.value)($6SDUu.EQ.value)($6SDUu.GT.value),
        Eq0: function() {
            return $4MBcA.eqInt;
        }
    };
}();
var $97937c29f879e68e$export$3abd12c96be3b09b = /* #__PURE__ */ function() {
    return {
        compare: $jgZMl.ordCharImpl($6SDUu.LT.value)($6SDUu.EQ.value)($6SDUu.GT.value),
        Eq0: function() {
            return $4MBcA.eqChar;
        }
    };
}();
var $97937c29f879e68e$export$ef759d57a4e44836 = /* #__PURE__ */ function() {
    return {
        compare: $jgZMl.ordBooleanImpl($6SDUu.LT.value)($6SDUu.EQ.value)($6SDUu.GT.value),
        Eq0: function() {
            return $4MBcA.eqBoolean;
        }
    };
}();
var $97937c29f879e68e$export$f595b73424c1647a = function(dict) {
    return dict.compareRecord;
};
var $97937c29f879e68e$export$ebb7a7956d139174 = function() {
    return function(dictOrdRecord) {
        var eqRec1 = $97937c29f879e68e$var$eqRec(dictOrdRecord.EqRecord0());
        return {
            compare: $97937c29f879e68e$export$f595b73424c1647a(dictOrdRecord)($h3hu6.Proxy.value),
            Eq0: function() {
                return eqRec1;
            }
        };
    };
};
var $97937c29f879e68e$export$693feb0c3c484b70 = function(dict) {
    return dict.compare1;
};
var $97937c29f879e68e$export$398604a469f7de9a = function(dict) {
    return dict.compare;
};
var $97937c29f879e68e$var$compare2 = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$ff461bf68e7dd332);
var $97937c29f879e68e$export$e9509a298f6befc2 = function(dictOrd) {
    var compare3 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(f) {
        return function(x) {
            return function(y) {
                return compare3(f(x))(f(y));
            };
        };
    };
};
var $97937c29f879e68e$export$f517ea36c68d4644 = function(dictOrd) {
    var compare3 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(a1) {
        return function(a2) {
            var v = compare3(a1)(a2);
            if (v instanceof $6SDUu.GT) return true;
            return false;
        };
    };
};
var $97937c29f879e68e$export$4be320a4fd1ac499 = function(dictOrd) {
    var compare3 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(a1) {
        return function(a2) {
            var v = compare3(a1)(a2);
            if (v instanceof $6SDUu.LT) return false;
            return true;
        };
    };
};
var $97937c29f879e68e$export$9b050841a3a1b328 = function(dictOrd) {
    var compare3 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(a1) {
        return function(a2) {
            var v = compare3(a1)(a2);
            if (v instanceof $6SDUu.LT) return true;
            return false;
        };
    };
};
var $97937c29f879e68e$export$23e3e2011c250f0f = function(dictOrd) {
    var lessThan1 = $97937c29f879e68e$export$9b050841a3a1b328(dictOrd);
    var greaterThan1 = $97937c29f879e68e$export$f517ea36c68d4644(dictOrd);
    return function(dictRing) {
        var Semiring0 = dictRing.Semiring0();
        var zero = $gyPYh.zero(Semiring0);
        var negate1 = $hTcAb.negate(dictRing);
        var one = $gyPYh.one(Semiring0);
        return function(x) {
            var $89 = lessThan1(x)(zero);
            if ($89) return negate1(one);
            var $90 = greaterThan1(x)(zero);
            if ($90) return one;
            return x;
        };
    };
};
var $97937c29f879e68e$export$f0c1dc893917aeba = function(dictOrd) {
    var compare3 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(a1) {
        return function(a2) {
            var v = compare3(a1)(a2);
            if (v instanceof $6SDUu.GT) return false;
            return true;
        };
    };
};
var $97937c29f879e68e$export$8960430cfd85939f = function(dictOrd) {
    var compare3 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(x) {
        return function(y) {
            var v = compare3(x)(y);
            if (v instanceof $6SDUu.LT) return y;
            if (v instanceof $6SDUu.EQ) return x;
            if (v instanceof $6SDUu.GT) return x;
            throw new Error("Failed pattern match at Data.Ord (line 181, column 3 - line 184, column 12): " + [
                v.constructor.name
            ]);
        };
    };
};
var $97937c29f879e68e$export$96ec731ed4dcb222 = function(dictOrd) {
    var compare3 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(x) {
        return function(y) {
            var v = compare3(x)(y);
            if (v instanceof $6SDUu.LT) return x;
            if (v instanceof $6SDUu.EQ) return x;
            if (v instanceof $6SDUu.GT) return y;
            throw new Error("Failed pattern match at Data.Ord (line 172, column 3 - line 175, column 12): " + [
                v.constructor.name
            ]);
        };
    };
};
var $97937c29f879e68e$export$6ace7ea8ac01a75e = function(dictOrd) {
    var compare3 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    var eqArray = $4MBcA.eqArray(dictOrd.Eq0());
    return {
        compare: function() {
            var toDelta = function(x) {
                return function(y) {
                    var v = compare3(x)(y);
                    if (v instanceof $6SDUu.EQ) return 0;
                    if (v instanceof $6SDUu.LT) return 1;
                    if (v instanceof $6SDUu.GT) return -1;
                    throw new Error("Failed pattern match at Data.Ord (line 79, column 7 - line 82, column 17): " + [
                        v.constructor.name
                    ]);
                };
            };
            return function(xs) {
                return function(ys) {
                    return $97937c29f879e68e$var$compare2(0)($jgZMl.ordArrayImpl(toDelta)(xs)(ys));
                };
            };
        }(),
        Eq0: function() {
            return eqArray;
        }
    };
};
var $97937c29f879e68e$export$8e34cc59438cf1bf = {
    compare1: function(dictOrd) {
        return $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$6ace7ea8ac01a75e(dictOrd));
    },
    Eq10: function() {
        return $4MBcA.eq1Array;
    }
};
var $97937c29f879e68e$export$a9b387b18fb85611 = function(dictOrdRecord) {
    var compareRecord1 = $97937c29f879e68e$export$f595b73424c1647a(dictOrdRecord);
    var eqRowCons = $4MBcA.eqRowCons(dictOrdRecord.EqRecord0())();
    return function() {
        return function(dictIsSymbol) {
            var reflectSymbol = $2HEu8.reflectSymbol(dictIsSymbol);
            var eqRowCons1 = eqRowCons(dictIsSymbol);
            return function(dictOrd) {
                var compare3 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
                var eqRowCons2 = eqRowCons1(dictOrd.Eq0());
                return {
                    compareRecord: function(v) {
                        return function(ra) {
                            return function(rb) {
                                var key = reflectSymbol($h3hu6.Proxy.value);
                                var left = compare3($i72yb.unsafeGet(key)(ra))($i72yb.unsafeGet(key)(rb));
                                var $95 = $97937c29f879e68e$var$notEq(left)($6SDUu.EQ.value);
                                if ($95) return left;
                                return compareRecord1($h3hu6.Proxy.value)(ra)(rb);
                            };
                        };
                    },
                    EqRecord0: function() {
                        return eqRowCons2;
                    }
                };
            };
        };
    };
};
var $97937c29f879e68e$export$7d15b64cf5a3a4c4 = function(dictOrd) {
    var min1 = $97937c29f879e68e$export$96ec731ed4dcb222(dictOrd);
    var max1 = $97937c29f879e68e$export$8960430cfd85939f(dictOrd);
    return function(low) {
        return function(hi) {
            return function(x) {
                return min1(hi)(max1(low)(x));
            };
        };
    };
};
var $97937c29f879e68e$export$cf95c51b03f10bae = function(dictOrd) {
    var lessThan1 = $97937c29f879e68e$export$9b050841a3a1b328(dictOrd);
    var greaterThan1 = $97937c29f879e68e$export$f517ea36c68d4644(dictOrd);
    return function(low) {
        return function(hi) {
            return function(x) {
                if (lessThan1(x)(low)) return false;
                if (greaterThan1(x)(hi)) return false;
                return true;
            };
        };
    };
};
var $97937c29f879e68e$export$2335f513bbd82c6d = function(dictOrd) {
    var greaterThanOrEq1 = $97937c29f879e68e$export$4be320a4fd1ac499(dictOrd);
    return function(dictRing) {
        var zero = $gyPYh.zero(dictRing.Semiring0());
        var negate1 = $hTcAb.negate(dictRing);
        return function(x) {
            var $99 = greaterThanOrEq1(x)(zero);
            if ($99) return x;
            return negate1(x);
        };
    };
};

});
parcelRegister("jgZMl", function(module, exports) {

$parcel$export(module.exports, "ordBooleanImpl", () => $e07f6ef164bf0728$export$fcb09e9654c4896a);
$parcel$export(module.exports, "ordIntImpl", () => $e07f6ef164bf0728$export$654933317498633e);
$parcel$export(module.exports, "ordNumberImpl", () => $e07f6ef164bf0728$export$a509696eaf723ed7);
$parcel$export(module.exports, "ordStringImpl", () => $e07f6ef164bf0728$export$bfcbb0304ffa620f);
$parcel$export(module.exports, "ordCharImpl", () => $e07f6ef164bf0728$export$5a20025607cdef3f);
$parcel$export(module.exports, "ordArrayImpl", () => $e07f6ef164bf0728$export$6d083685ddc7682f);
var $e07f6ef164bf0728$var$unsafeCompareImpl = function(lt) {
    return function(eq) {
        return function(gt) {
            return function(x) {
                return function(y) {
                    return x < y ? lt : x === y ? eq : gt;
                };
            };
        };
    };
};
const $e07f6ef164bf0728$export$fcb09e9654c4896a = $e07f6ef164bf0728$var$unsafeCompareImpl;
const $e07f6ef164bf0728$export$654933317498633e = $e07f6ef164bf0728$var$unsafeCompareImpl;
const $e07f6ef164bf0728$export$a509696eaf723ed7 = $e07f6ef164bf0728$var$unsafeCompareImpl;
const $e07f6ef164bf0728$export$bfcbb0304ffa620f = $e07f6ef164bf0728$var$unsafeCompareImpl;
const $e07f6ef164bf0728$export$5a20025607cdef3f = $e07f6ef164bf0728$var$unsafeCompareImpl;
const $e07f6ef164bf0728$export$6d083685ddc7682f = function(f) {
    return function(xs) {
        return function(ys) {
            var i = 0;
            var xlen = xs.length;
            var ylen = ys.length;
            while(i < xlen && i < ylen){
                var x = xs[i];
                var y = ys[i];
                var o = f(x)(y);
                if (o !== 0) return o;
                i++;
            }
            if (xlen === ylen) return 0;
            else if (xlen > ylen) return -1;
            else return 1;
        };
    };
};

});

parcelRegister("4MBcA", function(module, exports) {

$parcel$export(module.exports, "eqVoid", () => $37b880af5f4991bd$export$2965418ef5ae9704);
$parcel$export(module.exports, "eqUnit", () => $37b880af5f4991bd$export$671c8820f3b36bad);
$parcel$export(module.exports, "eqString", () => $37b880af5f4991bd$export$fa624555ca2acbc8);
$parcel$export(module.exports, "eqRowNil", () => $37b880af5f4991bd$export$d12253326f924cb1);
$parcel$export(module.exports, "eqRec", () => $37b880af5f4991bd$export$691c0e424728509e);
$parcel$export(module.exports, "eqProxy", () => $37b880af5f4991bd$export$db5a78c472a81a32);
$parcel$export(module.exports, "eqNumber", () => $37b880af5f4991bd$export$e24978670be1e4f3);
$parcel$export(module.exports, "eqInt", () => $37b880af5f4991bd$export$e65788c6d4494539);
$parcel$export(module.exports, "eqChar", () => $37b880af5f4991bd$export$bcd79f9321394c38);
$parcel$export(module.exports, "eqBoolean", () => $37b880af5f4991bd$export$d7927e8ffc1afb48);
$parcel$export(module.exports, "eq1", () => $37b880af5f4991bd$export$96fd6c73d03c9dd2);
$parcel$export(module.exports, "eq", () => $37b880af5f4991bd$export$9663ddc1cf085b32);
$parcel$export(module.exports, "eqArray", () => $37b880af5f4991bd$export$159e06dc5ec60b00);
$parcel$export(module.exports, "eq1Array", () => $37b880af5f4991bd$export$861eb926e0b8ea5b);
$parcel$export(module.exports, "eqRowCons", () => $37b880af5f4991bd$export$730b16b2c839caa0);
$parcel$export(module.exports, "notEq", () => $37b880af5f4991bd$export$5475dfc31a65c2cd);
// Generated by purs version 0.15.16

var $l1LO9 = parcelRequire("l1LO9");

var $2HEu8 = parcelRequire("2HEu8");
parcelRequire("2zMBQ");
var $i72yb = parcelRequire("i72yb");

var $h3hu6 = parcelRequire("h3hu6");
var $37b880af5f4991bd$export$2965418ef5ae9704 = {
    eq: function(v) {
        return function(v1) {
            return true;
        };
    }
};
var $37b880af5f4991bd$export$671c8820f3b36bad = {
    eq: function(v) {
        return function(v1) {
            return true;
        };
    }
};
var $37b880af5f4991bd$export$fa624555ca2acbc8 = {
    eq: $l1LO9.eqStringImpl
};
var $37b880af5f4991bd$export$d12253326f924cb1 = {
    eqRecord: function(v) {
        return function(v1) {
            return function(v2) {
                return true;
            };
        };
    }
};
var $37b880af5f4991bd$export$14e60b8fdd01f41c = function(dict) {
    return dict.eqRecord;
};
var $37b880af5f4991bd$export$691c0e424728509e = function() {
    return function(dictEqRecord) {
        return {
            eq: $37b880af5f4991bd$export$14e60b8fdd01f41c(dictEqRecord)($h3hu6.Proxy.value)
        };
    };
};
var $37b880af5f4991bd$export$db5a78c472a81a32 = {
    eq: function(v) {
        return function(v1) {
            return true;
        };
    }
};
var $37b880af5f4991bd$export$e24978670be1e4f3 = {
    eq: $l1LO9.eqNumberImpl
};
var $37b880af5f4991bd$export$e65788c6d4494539 = {
    eq: $l1LO9.eqIntImpl
};
var $37b880af5f4991bd$export$bcd79f9321394c38 = {
    eq: $l1LO9.eqCharImpl
};
var $37b880af5f4991bd$export$d7927e8ffc1afb48 = {
    eq: $l1LO9.eqBooleanImpl
};
var $37b880af5f4991bd$export$96fd6c73d03c9dd2 = function(dict) {
    return dict.eq1;
};
var $37b880af5f4991bd$export$9663ddc1cf085b32 = function(dict) {
    return dict.eq;
};
var $37b880af5f4991bd$var$eq2 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($37b880af5f4991bd$export$d7927e8ffc1afb48);
var $37b880af5f4991bd$export$159e06dc5ec60b00 = function(dictEq) {
    return {
        eq: $l1LO9.eqArrayImpl($37b880af5f4991bd$export$9663ddc1cf085b32(dictEq))
    };
};
var $37b880af5f4991bd$export$861eb926e0b8ea5b = {
    eq1: function(dictEq) {
        return $37b880af5f4991bd$export$9663ddc1cf085b32($37b880af5f4991bd$export$159e06dc5ec60b00(dictEq));
    }
};
var $37b880af5f4991bd$export$730b16b2c839caa0 = function(dictEqRecord) {
    var eqRecord1 = $37b880af5f4991bd$export$14e60b8fdd01f41c(dictEqRecord);
    return function() {
        return function(dictIsSymbol) {
            var reflectSymbol = $2HEu8.reflectSymbol(dictIsSymbol);
            return function(dictEq) {
                var eq3 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
                return {
                    eqRecord: function(v) {
                        return function(ra) {
                            return function(rb) {
                                var tail = eqRecord1($h3hu6.Proxy.value)(ra)(rb);
                                var key = reflectSymbol($h3hu6.Proxy.value);
                                var get = $i72yb.unsafeGet(key);
                                return eq3(get(ra))(get(rb)) && tail;
                            };
                        };
                    }
                };
            };
        };
    };
};
var $37b880af5f4991bd$export$5475dfc31a65c2cd = function(dictEq) {
    var eq3 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(x) {
        return function(y) {
            return $37b880af5f4991bd$var$eq2(eq3(x)(y))(false);
        };
    };
};
var $37b880af5f4991bd$export$d0aa07ff560ecb = function(dictEq1) {
    var eq11 = $37b880af5f4991bd$export$96fd6c73d03c9dd2(dictEq1);
    return function(dictEq) {
        var eq12 = eq11(dictEq);
        return function(x) {
            return function(y) {
                return $37b880af5f4991bd$var$eq2(eq12(x)(y))(false);
            };
        };
    };
};

});
parcelRegister("l1LO9", function(module, exports) {

$parcel$export(module.exports, "eqBooleanImpl", () => $f4eec6a416d226bf$export$373f9c52154d3177);
$parcel$export(module.exports, "eqIntImpl", () => $f4eec6a416d226bf$export$123e3cb4a5e139f4);
$parcel$export(module.exports, "eqNumberImpl", () => $f4eec6a416d226bf$export$9fc9964c874ac58);
$parcel$export(module.exports, "eqCharImpl", () => $f4eec6a416d226bf$export$b056fd0da0447ba9);
$parcel$export(module.exports, "eqStringImpl", () => $f4eec6a416d226bf$export$bb9bce33bd088a97);
$parcel$export(module.exports, "eqArrayImpl", () => $f4eec6a416d226bf$export$e89e5efeb0be06bc);
var $f4eec6a416d226bf$var$refEq = function(r1) {
    return function(r2) {
        return r1 === r2;
    };
};
const $f4eec6a416d226bf$export$373f9c52154d3177 = $f4eec6a416d226bf$var$refEq;
const $f4eec6a416d226bf$export$123e3cb4a5e139f4 = $f4eec6a416d226bf$var$refEq;
const $f4eec6a416d226bf$export$9fc9964c874ac58 = $f4eec6a416d226bf$var$refEq;
const $f4eec6a416d226bf$export$b056fd0da0447ba9 = $f4eec6a416d226bf$var$refEq;
const $f4eec6a416d226bf$export$bb9bce33bd088a97 = $f4eec6a416d226bf$var$refEq;
const $f4eec6a416d226bf$export$e89e5efeb0be06bc = function(f) {
    return function(xs) {
        return function(ys) {
            if (xs.length !== ys.length) return false;
            for(var i = 0; i < xs.length; i++){
                if (!f(xs[i])(ys[i])) return false;
            }
            return true;
        };
    };
};

});


parcelRegister("6SDUu", function(module, exports) {

$parcel$export(module.exports, "LT", () => $5026be88823ef1f4$export$7158f0ceb70f54c7);
$parcel$export(module.exports, "GT", () => $5026be88823ef1f4$export$b023c82b48e70453);
$parcel$export(module.exports, "EQ", () => $5026be88823ef1f4$export$1c0a5d05eb3f6e18);
$parcel$export(module.exports, "semigroupOrdering", () => $5026be88823ef1f4$export$d04ea36c3e51a408);
$parcel$export(module.exports, "eqOrdering", () => $5026be88823ef1f4$export$82d306ead3b703cd);
// Generated by purs version 0.15.16
var $5026be88823ef1f4$export$7158f0ceb70f54c7 = /* #__PURE__ */ function() {
    function LT() {}
    LT.value = new LT();
    return LT;
}();
var $5026be88823ef1f4$export$b023c82b48e70453 = /* #__PURE__ */ function() {
    function GT() {}
    GT.value = new GT();
    return GT;
}();
var $5026be88823ef1f4$export$1c0a5d05eb3f6e18 = /* #__PURE__ */ function() {
    function EQ() {}
    EQ.value = new EQ();
    return EQ;
}();
var $5026be88823ef1f4$export$c1dd7b0030d4618e = {
    show: function(v) {
        if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return "LT";
        if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return "GT";
        if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return "EQ";
        throw new Error("Failed pattern match at Data.Ordering (line 26, column 1 - line 29, column 17): " + [
            v.constructor.name
        ]);
    }
};
var $5026be88823ef1f4$export$d04ea36c3e51a408 = {
    append: function(v) {
        return function(v1) {
            if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return v1;
            throw new Error("Failed pattern match at Data.Ordering (line 21, column 1 - line 24, column 18): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    }
};
var $5026be88823ef1f4$export$6897c284b6f9f4dc = function(v) {
    if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
    if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
    if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$b023c82b48e70453.value;
    throw new Error("Failed pattern match at Data.Ordering (line 33, column 1 - line 33, column 31): " + [
        v.constructor.name
    ]);
};
var $5026be88823ef1f4$export$82d306ead3b703cd = {
    eq: function(v) {
        return function(v1) {
            if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7 && v1 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return true;
            if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453 && v1 instanceof $5026be88823ef1f4$export$b023c82b48e70453) return true;
            if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18 && v1 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return true;
            return false;
        };
    }
};

});

parcelRegister("hTcAb", function(module, exports) {

$parcel$export(module.exports, "sub", () => $d061555d3b2c84b2$export$f93b5905241a7cca);
$parcel$export(module.exports, "ringUnit", () => $d061555d3b2c84b2$export$e2da189c845067f9);
$parcel$export(module.exports, "ringRecordNil", () => $d061555d3b2c84b2$export$38dc985ea1e564cd);
$parcel$export(module.exports, "ringRecordCons", () => $d061555d3b2c84b2$export$857cf13a2f74264d);
$parcel$export(module.exports, "ringRecord", () => $d061555d3b2c84b2$export$492fe4fa507ea6ad);
$parcel$export(module.exports, "ringProxy", () => $d061555d3b2c84b2$export$948aff48831eff14);
$parcel$export(module.exports, "ringNumber", () => $d061555d3b2c84b2$export$194f4464e73e7816);
$parcel$export(module.exports, "ringInt", () => $d061555d3b2c84b2$export$d40e27c88e22a303);
$parcel$export(module.exports, "ringFn", () => $d061555d3b2c84b2$export$9f43d8c61dde305d);
$parcel$export(module.exports, "negate", () => $d061555d3b2c84b2$export$aef51622e549b8b0);
// Generated by purs version 0.15.16

var $944mO = parcelRequire("944mO");

var $gyPYh = parcelRequire("gyPYh");

var $2HEu8 = parcelRequire("2HEu8");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");
parcelRequire("2zMBQ");
var $i72yb = parcelRequire("i72yb");

var $h3hu6 = parcelRequire("h3hu6");
var $d061555d3b2c84b2$var$semiringRecord = /* #__PURE__ */ $gyPYh.semiringRecord();
var $d061555d3b2c84b2$export$11a6fe76b07a0 = function(dict) {
    return dict.subRecord;
};
var $d061555d3b2c84b2$export$f93b5905241a7cca = function(dict) {
    return dict.sub;
};
var $d061555d3b2c84b2$export$e2da189c845067f9 = {
    sub: function(v) {
        return function(v1) {
            return $r2HHk.unit;
        };
    },
    Semiring0: function() {
        return $gyPYh.semiringUnit;
    }
};
var $d061555d3b2c84b2$export$38dc985ea1e564cd = {
    subRecord: function(v) {
        return function(v1) {
            return function(v2) {
                return {};
            };
        };
    },
    SemiringRecord0: function() {
        return $gyPYh.semiringRecordNil;
    }
};
var $d061555d3b2c84b2$export$857cf13a2f74264d = function(dictIsSymbol) {
    var reflectSymbol = $2HEu8.reflectSymbol(dictIsSymbol);
    var semiringRecordCons = $gyPYh.semiringRecordCons(dictIsSymbol)();
    return function() {
        return function(dictRingRecord) {
            var subRecord1 = $d061555d3b2c84b2$export$11a6fe76b07a0(dictRingRecord);
            var semiringRecordCons1 = semiringRecordCons(dictRingRecord.SemiringRecord0());
            return function(dictRing) {
                var sub1 = $d061555d3b2c84b2$export$f93b5905241a7cca(dictRing);
                var semiringRecordCons2 = semiringRecordCons1(dictRing.Semiring0());
                return {
                    subRecord: function(v) {
                        return function(ra) {
                            return function(rb) {
                                var tail = subRecord1($h3hu6.Proxy.value)(ra)(rb);
                                var key = reflectSymbol($h3hu6.Proxy.value);
                                var insert = $i72yb.unsafeSet(key);
                                var get = $i72yb.unsafeGet(key);
                                return insert(sub1(get(ra))(get(rb)))(tail);
                            };
                        };
                    },
                    SemiringRecord0: function() {
                        return semiringRecordCons2;
                    }
                };
            };
        };
    };
};
var $d061555d3b2c84b2$export$492fe4fa507ea6ad = function() {
    return function(dictRingRecord) {
        var semiringRecord1 = $d061555d3b2c84b2$var$semiringRecord(dictRingRecord.SemiringRecord0());
        return {
            sub: $d061555d3b2c84b2$export$11a6fe76b07a0(dictRingRecord)($h3hu6.Proxy.value),
            Semiring0: function() {
                return semiringRecord1;
            }
        };
    };
};
var $d061555d3b2c84b2$export$948aff48831eff14 = {
    sub: function(v) {
        return function(v1) {
            return $h3hu6.Proxy.value;
        };
    },
    Semiring0: function() {
        return $gyPYh.semiringProxy;
    }
};
var $d061555d3b2c84b2$export$194f4464e73e7816 = {
    sub: $944mO.numSub,
    Semiring0: function() {
        return $gyPYh.semiringNumber;
    }
};
var $d061555d3b2c84b2$export$d40e27c88e22a303 = {
    sub: $944mO.intSub,
    Semiring0: function() {
        return $gyPYh.semiringInt;
    }
};
var $d061555d3b2c84b2$export$9f43d8c61dde305d = function(dictRing) {
    var sub1 = $d061555d3b2c84b2$export$f93b5905241a7cca(dictRing);
    var semiringFn = $gyPYh.semiringFn(dictRing.Semiring0());
    return {
        sub: function(f) {
            return function(g) {
                return function(x) {
                    return sub1(f(x))(g(x));
                };
            };
        },
        Semiring0: function() {
            return semiringFn;
        }
    };
};
var $d061555d3b2c84b2$export$aef51622e549b8b0 = function(dictRing) {
    var sub1 = $d061555d3b2c84b2$export$f93b5905241a7cca(dictRing);
    var zero = $gyPYh.zero(dictRing.Semiring0());
    return function(a) {
        return sub1(zero)(a);
    };
};

});
parcelRegister("944mO", function(module, exports) {

$parcel$export(module.exports, "intSub", () => $6997dff57b67dccd$export$8964faf538cd4472);
$parcel$export(module.exports, "numSub", () => $6997dff57b67dccd$export$592dc8db1291fc5e);
const $6997dff57b67dccd$export$8964faf538cd4472 = function(x) {
    return function(y) {
        /* jshint bitwise: false */ return x - y | 0;
    };
};
const $6997dff57b67dccd$export$592dc8db1291fc5e = function(n1) {
    return function(n2) {
        return n1 - n2;
    };
};

});

parcelRegister("gyPYh", function(module, exports) {

$parcel$export(module.exports, "zero", () => $c0e822be92afc4df$export$7f9972325ebfd559);
$parcel$export(module.exports, "semiringUnit", () => $c0e822be92afc4df$export$348dab40c63d4f3e);
$parcel$export(module.exports, "semiringRecordNil", () => $c0e822be92afc4df$export$5f825cdfc30c8d7a);
$parcel$export(module.exports, "semiringProxy", () => $c0e822be92afc4df$export$28b7adff71d7e2f2);
$parcel$export(module.exports, "semiringNumber", () => $c0e822be92afc4df$export$f48694d6539477b9);
$parcel$export(module.exports, "semiringInt", () => $c0e822be92afc4df$export$7e80d6910c05bd77);
$parcel$export(module.exports, "one", () => $c0e822be92afc4df$export$80bf7733f1207381);
$parcel$export(module.exports, "mul", () => $c0e822be92afc4df$export$6e3a27864ab166fe);
$parcel$export(module.exports, "semiringRecord", () => $c0e822be92afc4df$export$93af3fe715165fc8);
$parcel$export(module.exports, "add", () => $c0e822be92afc4df$export$e16d8520af44a096);
$parcel$export(module.exports, "semiringFn", () => $c0e822be92afc4df$export$4946f164d066bdc5);
$parcel$export(module.exports, "semiringRecordCons", () => $c0e822be92afc4df$export$8d7f5ae13d42a4f9);
// Generated by purs version 0.15.16

var $hXB7N = parcelRequire("hXB7N");

var $2HEu8 = parcelRequire("2HEu8");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");
parcelRequire("2zMBQ");
var $i72yb = parcelRequire("i72yb");

var $h3hu6 = parcelRequire("h3hu6");
var $c0e822be92afc4df$export$2fbd183cf91e4d96 = function(dict) {
    return dict.zeroRecord;
};
var $c0e822be92afc4df$export$7f9972325ebfd559 = function(dict) {
    return dict.zero;
};
var $c0e822be92afc4df$export$348dab40c63d4f3e = {
    add: function(v) {
        return function(v1) {
            return $r2HHk.unit;
        };
    },
    zero: $r2HHk.unit,
    mul: function(v) {
        return function(v1) {
            return $r2HHk.unit;
        };
    },
    one: $r2HHk.unit
};
var $c0e822be92afc4df$export$5f825cdfc30c8d7a = {
    addRecord: function(v) {
        return function(v1) {
            return function(v2) {
                return {};
            };
        };
    },
    mulRecord: function(v) {
        return function(v1) {
            return function(v2) {
                return {};
            };
        };
    },
    oneRecord: function(v) {
        return function(v1) {
            return {};
        };
    },
    zeroRecord: function(v) {
        return function(v1) {
            return {};
        };
    }
};
var $c0e822be92afc4df$export$28b7adff71d7e2f2 = /* #__PURE__ */ function() {
    return {
        add: function(v) {
            return function(v1) {
                return $h3hu6.Proxy.value;
            };
        },
        mul: function(v) {
            return function(v1) {
                return $h3hu6.Proxy.value;
            };
        },
        one: $h3hu6.Proxy.value,
        zero: $h3hu6.Proxy.value
    };
}();
var $c0e822be92afc4df$export$f48694d6539477b9 = {
    add: $hXB7N.numAdd,
    zero: 0.0,
    mul: $hXB7N.numMul,
    one: 1.0
};
var $c0e822be92afc4df$export$7e80d6910c05bd77 = {
    add: $hXB7N.intAdd,
    zero: 0,
    mul: $hXB7N.intMul,
    one: 1
};
var $c0e822be92afc4df$export$e9e5a13b3096dd62 = function(dict) {
    return dict.oneRecord;
};
var $c0e822be92afc4df$export$80bf7733f1207381 = function(dict) {
    return dict.one;
};
var $c0e822be92afc4df$export$ff4422e298afd4cc = function(dict) {
    return dict.mulRecord;
};
var $c0e822be92afc4df$export$6e3a27864ab166fe = function(dict) {
    return dict.mul;
};
var $c0e822be92afc4df$export$ab0ab92b3cb31c66 = function(dict) {
    return dict.addRecord;
};
var $c0e822be92afc4df$export$93af3fe715165fc8 = function() {
    return function(dictSemiringRecord) {
        return {
            add: $c0e822be92afc4df$export$ab0ab92b3cb31c66(dictSemiringRecord)($h3hu6.Proxy.value),
            mul: $c0e822be92afc4df$export$ff4422e298afd4cc(dictSemiringRecord)($h3hu6.Proxy.value),
            one: $c0e822be92afc4df$export$e9e5a13b3096dd62(dictSemiringRecord)($h3hu6.Proxy.value)($h3hu6.Proxy.value),
            zero: $c0e822be92afc4df$export$2fbd183cf91e4d96(dictSemiringRecord)($h3hu6.Proxy.value)($h3hu6.Proxy.value)
        };
    };
};
var $c0e822be92afc4df$export$e16d8520af44a096 = function(dict) {
    return dict.add;
};
var $c0e822be92afc4df$export$4946f164d066bdc5 = function(dictSemiring) {
    var add1 = $c0e822be92afc4df$export$e16d8520af44a096(dictSemiring);
    var zero1 = $c0e822be92afc4df$export$7f9972325ebfd559(dictSemiring);
    var mul1 = $c0e822be92afc4df$export$6e3a27864ab166fe(dictSemiring);
    var one1 = $c0e822be92afc4df$export$80bf7733f1207381(dictSemiring);
    return {
        add: function(f) {
            return function(g) {
                return function(x) {
                    return add1(f(x))(g(x));
                };
            };
        },
        zero: function(v) {
            return zero1;
        },
        mul: function(f) {
            return function(g) {
                return function(x) {
                    return mul1(f(x))(g(x));
                };
            };
        },
        one: function(v) {
            return one1;
        }
    };
};
var $c0e822be92afc4df$export$8d7f5ae13d42a4f9 = function(dictIsSymbol) {
    var reflectSymbol = $2HEu8.reflectSymbol(dictIsSymbol);
    return function() {
        return function(dictSemiringRecord) {
            var addRecord1 = $c0e822be92afc4df$export$ab0ab92b3cb31c66(dictSemiringRecord);
            var mulRecord1 = $c0e822be92afc4df$export$ff4422e298afd4cc(dictSemiringRecord);
            var oneRecord1 = $c0e822be92afc4df$export$e9e5a13b3096dd62(dictSemiringRecord);
            var zeroRecord1 = $c0e822be92afc4df$export$2fbd183cf91e4d96(dictSemiringRecord);
            return function(dictSemiring) {
                var add1 = $c0e822be92afc4df$export$e16d8520af44a096(dictSemiring);
                var mul1 = $c0e822be92afc4df$export$6e3a27864ab166fe(dictSemiring);
                var one1 = $c0e822be92afc4df$export$80bf7733f1207381(dictSemiring);
                var zero1 = $c0e822be92afc4df$export$7f9972325ebfd559(dictSemiring);
                return {
                    addRecord: function(v) {
                        return function(ra) {
                            return function(rb) {
                                var tail = addRecord1($h3hu6.Proxy.value)(ra)(rb);
                                var key = reflectSymbol($h3hu6.Proxy.value);
                                var insert = $i72yb.unsafeSet(key);
                                var get = $i72yb.unsafeGet(key);
                                return insert(add1(get(ra))(get(rb)))(tail);
                            };
                        };
                    },
                    mulRecord: function(v) {
                        return function(ra) {
                            return function(rb) {
                                var tail = mulRecord1($h3hu6.Proxy.value)(ra)(rb);
                                var key = reflectSymbol($h3hu6.Proxy.value);
                                var insert = $i72yb.unsafeSet(key);
                                var get = $i72yb.unsafeGet(key);
                                return insert(mul1(get(ra))(get(rb)))(tail);
                            };
                        };
                    },
                    oneRecord: function(v) {
                        return function(v1) {
                            var tail = oneRecord1($h3hu6.Proxy.value)($h3hu6.Proxy.value);
                            var key = reflectSymbol($h3hu6.Proxy.value);
                            var insert = $i72yb.unsafeSet(key);
                            return insert(one1)(tail);
                        };
                    },
                    zeroRecord: function(v) {
                        return function(v1) {
                            var tail = zeroRecord1($h3hu6.Proxy.value)($h3hu6.Proxy.value);
                            var key = reflectSymbol($h3hu6.Proxy.value);
                            var insert = $i72yb.unsafeSet(key);
                            return insert(zero1)(tail);
                        };
                    }
                };
            };
        };
    };
};

});
parcelRegister("hXB7N", function(module, exports) {

$parcel$export(module.exports, "intAdd", () => $d134be8d1f9fbf5c$export$3493e4651621d0b);
$parcel$export(module.exports, "intMul", () => $d134be8d1f9fbf5c$export$9961c9313a91a4c2);
$parcel$export(module.exports, "numAdd", () => $d134be8d1f9fbf5c$export$7851ca78a7fd68e5);
$parcel$export(module.exports, "numMul", () => $d134be8d1f9fbf5c$export$3c84e2814d77f9f0);
const $d134be8d1f9fbf5c$export$3493e4651621d0b = function(x) {
    return function(y) {
        /* jshint bitwise: false */ return x + y | 0;
    };
};
const $d134be8d1f9fbf5c$export$9961c9313a91a4c2 = function(x) {
    return function(y) {
        /* jshint bitwise: false */ return x * y | 0;
    };
};
const $d134be8d1f9fbf5c$export$7851ca78a7fd68e5 = function(n1) {
    return function(n2) {
        return n1 + n2;
    };
};
const $d134be8d1f9fbf5c$export$3c84e2814d77f9f0 = function(n1) {
    return function(n2) {
        return n1 * n2;
    };
};

});





parcelRegister("5hqdn", function(module, exports) {

$parcel$export(module.exports, "imapF", () => $3d82dffba933b011$export$eb38b1c8c5f72ca8);
$parcel$export(module.exports, "imap", () => $3d82dffba933b011$export$b2517b0ab3a58435);
// Generated by purs version 0.15.16

var $l0wDR = parcelRequire("l0wDR");
var $3d82dffba933b011$export$e8c9127d2f50172d = {
    imap: function(f) {
        return function(v) {
            return function(v1) {
                return f(v1);
            };
        };
    }
};
var $3d82dffba933b011$export$8824a2bea4c1012c = {
    imap: function(ab) {
        return function(ba) {
            return function(v) {
                return function($42) {
                    return ab(v(ba($42)));
                };
            };
        };
    }
};
var $3d82dffba933b011$export$1c6d49d5878078c3 = {
    imap: function(f) {
        return function(v) {
            return function(v1) {
                return f(v1);
            };
        };
    }
};
var $3d82dffba933b011$export$ef56ebe0e8112a3f = {
    imap: function(f) {
        return function(v) {
            return function(v1) {
                return f(v1);
            };
        };
    }
};
var $3d82dffba933b011$export$562bca5a8a46bf61 = {
    imap: function(f) {
        return function(v) {
            return function(v1) {
                return f(v1);
            };
        };
    }
};
var $3d82dffba933b011$export$bf44d3d4196f3d53 = {
    imap: function(f) {
        return function(v) {
            return function(v1) {
                return f(v1);
            };
        };
    }
};
var $3d82dffba933b011$export$eb38b1c8c5f72ca8 = function(dictFunctor) {
    var map = $l0wDR.map(dictFunctor);
    return function(f) {
        return function(v) {
            return map(f);
        };
    };
};
var $3d82dffba933b011$export$c469d4e9c6f65eae = {
    imap: /* #__PURE__ */ $3d82dffba933b011$export$eb38b1c8c5f72ca8($l0wDR.functorArray)
};
var $3d82dffba933b011$export$993789ec90a91854 = {
    imap: /* #__PURE__ */ $3d82dffba933b011$export$eb38b1c8c5f72ca8($l0wDR.functorFn)
};
var $3d82dffba933b011$export$b2517b0ab3a58435 = function(dict) {
    return dict.imap;
};
var $3d82dffba933b011$export$6e542772b026aecb = function(dictInvariant) {
    var imap1 = $3d82dffba933b011$export$b2517b0ab3a58435(dictInvariant);
    return {
        imap: function(f) {
            return function(g) {
                return function(v) {
                    return imap1(f)(g)(v);
                };
            };
        }
    };
};

});

parcelRegister("cw1rg", function(module, exports) {

$parcel$export(module.exports, "Inl", () => $91c996e9c07e3b3f$export$dd5fad028b7772cd);
$parcel$export(module.exports, "Inr", () => $91c996e9c07e3b3f$export$df71ca4577dbdff6);
$parcel$export(module.exports, "Product", () => $91c996e9c07e3b3f$export$264ad599d7cef668);
$parcel$export(module.exports, "NoArguments", () => $91c996e9c07e3b3f$export$928c7f2d618c070b);
$parcel$export(module.exports, "from", () => $91c996e9c07e3b3f$export$6788812c4e6611e6);
// Generated by purs version 0.15.16

var $3Orkn = parcelRequire("3Orkn");

var $2HEu8 = parcelRequire("2HEu8");

var $h3hu6 = parcelRequire("h3hu6");
var $91c996e9c07e3b3f$var$show = /* #__PURE__ */ $3Orkn.show($3Orkn.showString);
var $91c996e9c07e3b3f$export$dd5fad028b7772cd = /* #__PURE__ */ function() {
    function Inl(value0) {
        this.value0 = value0;
    }
    Inl.create = function(value0) {
        return new Inl(value0);
    };
    return Inl;
}();
var $91c996e9c07e3b3f$export$df71ca4577dbdff6 = /* #__PURE__ */ function() {
    function Inr(value0) {
        this.value0 = value0;
    }
    Inr.create = function(value0) {
        return new Inr(value0);
    };
    return Inr;
}();
var $91c996e9c07e3b3f$export$264ad599d7cef668 = /* #__PURE__ */ function() {
    function Product(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Product.create = function(value0) {
        return function(value1) {
            return new Product(value0, value1);
        };
    };
    return Product;
}();
var $91c996e9c07e3b3f$var$NoConstructors = function(x) {
    return x;
};
var $91c996e9c07e3b3f$export$928c7f2d618c070b = /* #__PURE__ */ function() {
    function NoArguments() {}
    NoArguments.value = new NoArguments();
    return NoArguments;
}();
var $91c996e9c07e3b3f$export$8bfc33963ccbb2a = function(x) {
    return x;
};
var $91c996e9c07e3b3f$export$84637ea037d2e218 = function(x) {
    return x;
};
var $91c996e9c07e3b3f$export$2c618a4308a30424 = function(dict) {
    return dict.to;
};
var $91c996e9c07e3b3f$export$a76fa7ac9b018069 = function(dictShow) {
    var show1 = $3Orkn.show(dictShow);
    return function(dictShow1) {
        var show2 = $3Orkn.show(dictShow1);
        return {
            show: function(v) {
                if (v instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return "(Inl " + (show1(v.value0) + ")");
                if (v instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6) return "(Inr " + (show2(v.value0) + ")");
                throw new Error("Failed pattern match at Data.Generic.Rep (line 32, column 1 - line 34, column 42): " + [
                    v.constructor.name
                ]);
            }
        };
    };
};
var $91c996e9c07e3b3f$export$821c121fea76e4f5 = function(dictShow) {
    var show1 = $3Orkn.show(dictShow);
    return function(dictShow1) {
        var show2 = $3Orkn.show(dictShow1);
        return {
            show: function(v) {
                return "(Product " + (show1(v.value0) + (" " + (show2(v.value1) + ")")));
            }
        };
    };
};
var $91c996e9c07e3b3f$export$1275f813f7f7622c = {
    show: function(v) {
        return "NoArguments";
    }
};
var $91c996e9c07e3b3f$export$4133b31869b937df = function(dictIsSymbol) {
    var reflectSymbol = $2HEu8.reflectSymbol(dictIsSymbol);
    return function(dictShow) {
        var show1 = $3Orkn.show(dictShow);
        return {
            show: function(v) {
                return "(Constructor @" + ($91c996e9c07e3b3f$var$show(reflectSymbol($h3hu6.Proxy.value)) + (" " + (show1(v) + ")")));
            }
        };
    };
};
var $91c996e9c07e3b3f$export$b1716375e6f06e2d = function(dictShow) {
    var show1 = $3Orkn.show(dictShow);
    return {
        show: function(v) {
            return "(Argument " + (show1(v) + ")");
        }
    };
};
var $91c996e9c07e3b3f$export$3d0c2c94453de4b8 = function(dictGeneric) {
    return function(v) {
        return $h3hu6.Proxy.value;
    };
};
var $91c996e9c07e3b3f$export$6788812c4e6611e6 = function(dict) {
    return dict.from;
};

});
parcelRegister("3Orkn", function(module, exports) {

$parcel$export(module.exports, "showUnit", () => $2c6b3d51d10471a7$export$5a8c7efb782a6055);
$parcel$export(module.exports, "showString", () => $2c6b3d51d10471a7$export$e4b6cd05df3043f6);
$parcel$export(module.exports, "showRecord", () => $2c6b3d51d10471a7$export$28b0be767d2bc2c2);
$parcel$export(module.exports, "showNumber", () => $2c6b3d51d10471a7$export$e5aa470f8f97c3fe);
$parcel$export(module.exports, "showInt", () => $2c6b3d51d10471a7$export$3d7cf516d27998a0);
$parcel$export(module.exports, "showChar", () => $2c6b3d51d10471a7$export$def6059c21714f2a);
$parcel$export(module.exports, "show", () => $2c6b3d51d10471a7$export$57bf213be019eeb0);
$parcel$export(module.exports, "showArray", () => $2c6b3d51d10471a7$export$5bda33a3389a7225);
$parcel$export(module.exports, "showRecordFieldsCons", () => $2c6b3d51d10471a7$export$70f8f8693d114c9d);
$parcel$export(module.exports, "showRecordFieldsConsNil", () => $2c6b3d51d10471a7$export$d57593979a3bd7f3);
// Generated by purs version 0.15.16

var $5EAUk = parcelRequire("5EAUk");

var $2HEu8 = parcelRequire("2HEu8");

var $7DusG = parcelRequire("7DusG");
parcelRequire("2zMBQ");
var $i72yb = parcelRequire("i72yb");

var $h3hu6 = parcelRequire("h3hu6");
var $2c6b3d51d10471a7$export$2052789f27d4993d = {
    show: $7DusG.absurd
};
var $2c6b3d51d10471a7$export$5a8c7efb782a6055 = {
    show: function(v) {
        return "unit";
    }
};
var $2c6b3d51d10471a7$export$e4b6cd05df3043f6 = {
    show: $5EAUk.showStringImpl
};
var $2c6b3d51d10471a7$export$a673323aec880979 = {
    showRecordFields: function(v) {
        return function(v1) {
            return "";
        };
    }
};
var $2c6b3d51d10471a7$export$2633f2b0f857f544 = function(dict) {
    return dict.showRecordFields;
};
var $2c6b3d51d10471a7$export$28b0be767d2bc2c2 = function() {
    return function() {
        return function(dictShowRecordFields) {
            var showRecordFields1 = $2c6b3d51d10471a7$export$2633f2b0f857f544(dictShowRecordFields);
            return {
                show: function(record) {
                    return "{" + (showRecordFields1($h3hu6.Proxy.value)(record) + "}");
                }
            };
        };
    };
};
var $2c6b3d51d10471a7$export$3805d09d172f9aca = {
    show: function(v) {
        return "Proxy";
    }
};
var $2c6b3d51d10471a7$export$e5aa470f8f97c3fe = {
    show: $5EAUk.showNumberImpl
};
var $2c6b3d51d10471a7$export$3d7cf516d27998a0 = {
    show: $5EAUk.showIntImpl
};
var $2c6b3d51d10471a7$export$def6059c21714f2a = {
    show: $5EAUk.showCharImpl
};
var $2c6b3d51d10471a7$export$ad55f318773e3cd5 = {
    show: function(v) {
        if (v) return "true";
        if (!v) return "false";
        throw new Error("Failed pattern match at Data.Show (line 29, column 1 - line 31, column 23): " + [
            v.constructor.name
        ]);
    }
};
var $2c6b3d51d10471a7$export$57bf213be019eeb0 = function(dict) {
    return dict.show;
};
var $2c6b3d51d10471a7$export$5bda33a3389a7225 = function(dictShow) {
    return {
        show: $5EAUk.showArrayImpl($2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow))
    };
};
var $2c6b3d51d10471a7$export$70f8f8693d114c9d = function(dictIsSymbol) {
    var reflectSymbol = $2HEu8.reflectSymbol(dictIsSymbol);
    return function(dictShowRecordFields) {
        var showRecordFields1 = $2c6b3d51d10471a7$export$2633f2b0f857f544(dictShowRecordFields);
        return function(dictShow) {
            var show1 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
            return {
                showRecordFields: function(v) {
                    return function(record) {
                        var tail = showRecordFields1($h3hu6.Proxy.value)(record);
                        var key = reflectSymbol($h3hu6.Proxy.value);
                        var focus = $i72yb.unsafeGet(key)(record);
                        return " " + (key + (": " + (show1(focus) + ("," + tail))));
                    };
                }
            };
        };
    };
};
var $2c6b3d51d10471a7$export$d57593979a3bd7f3 = function(dictIsSymbol) {
    var reflectSymbol = $2HEu8.reflectSymbol(dictIsSymbol);
    return function(dictShow) {
        var show1 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
        return {
            showRecordFields: function(v) {
                return function(record) {
                    var key = reflectSymbol($h3hu6.Proxy.value);
                    var focus = $i72yb.unsafeGet(key)(record);
                    return " " + (key + (": " + (show1(focus) + " ")));
                };
            }
        };
    };
};

});
parcelRegister("5EAUk", function(module, exports) {

$parcel$export(module.exports, "showIntImpl", () => $41dd51408824a8aa$export$c7cd64a71178c531);
$parcel$export(module.exports, "showNumberImpl", () => $41dd51408824a8aa$export$e43176eac712254a);
$parcel$export(module.exports, "showCharImpl", () => $41dd51408824a8aa$export$91f9c7a21f1f86c8);
$parcel$export(module.exports, "showStringImpl", () => $41dd51408824a8aa$export$336c8e5b2153cec7);
$parcel$export(module.exports, "showArrayImpl", () => $41dd51408824a8aa$export$a23154580f12ac67);
const $41dd51408824a8aa$export$c7cd64a71178c531 = function(n) {
    return n.toString();
};
const $41dd51408824a8aa$export$e43176eac712254a = function(n) {
    var str = n.toString();
    return isNaN(str + ".0") ? str : str + ".0";
};
const $41dd51408824a8aa$export$91f9c7a21f1f86c8 = function(c) {
    var code = c.charCodeAt(0);
    if (code < 0x20 || code === 0x7F) {
        switch(c){
            case "\x07":
                return "'\\a'";
            case "\b":
                return "'\\b'";
            case "\f":
                return "'\\f'";
            case "\n":
                return "'\\n'";
            case "\r":
                return "'\\r'";
            case "\t":
                return "'\\t'";
            case "\v":
                return "'\\v'";
        }
        return "'\\" + code.toString(10) + "'";
    }
    return c === "'" || c === "\\" ? "'\\" + c + "'" : "'" + c + "'";
};
const $41dd51408824a8aa$export$336c8e5b2153cec7 = function(s) {
    var l = s.length;
    return "\"" + s.replace(/[\0-\x1F\x7F"\\]/g, function(c, i) {
        switch(c){
            case "\"":
            case "\\":
                return "\\" + c;
            case "\x07":
                return "\\a";
            case "\b":
                return "\\b";
            case "\f":
                return "\\f";
            case "\n":
                return "\\n";
            case "\r":
                return "\\r";
            case "\t":
                return "\\t";
            case "\v":
                return "\\v";
        }
        var k = i + 1;
        var empty = k < l && s[k] >= "0" && s[k] <= "9" ? "\\&" : "";
        return "\\" + c.charCodeAt(0).toString(10) + empty;
    }) + "\"";
};
const $41dd51408824a8aa$export$a23154580f12ac67 = function(f) {
    return function(xs) {
        var ss = [];
        for(var i = 0, l = xs.length; i < l; i++)ss[i] = f(xs[i]);
        return "[" + ss.join(",") + "]";
    };
};

});



parcelRegister("ykHdR", function(module, exports) {

$parcel$export(module.exports, "Nothing", () => $06733ae99ed4f534$export$bebe9059409a0d04);
$parcel$export(module.exports, "Just", () => $06733ae99ed4f534$export$8a67b48435b5d073);
$parcel$export(module.exports, "showMaybe", () => $06733ae99ed4f534$export$9b814e760fdd264a);
$parcel$export(module.exports, "maybe$prime", () => $06733ae99ed4f534$export$76f250758a65e763);
$parcel$export(module.exports, "maybe", () => $06733ae99ed4f534$export$f8b8b9ce72e9ccbf);
$parcel$export(module.exports, "isNothing", () => $06733ae99ed4f534$export$4967676db1b89293);
$parcel$export(module.exports, "isJust", () => $06733ae99ed4f534$export$c15bd07a493e1236);
$parcel$export(module.exports, "functorMaybe", () => $06733ae99ed4f534$export$fdd2427f0e60fd66);
$parcel$export(module.exports, "invariantMaybe", () => $06733ae99ed4f534$export$62eda6ff839a0571);
$parcel$export(module.exports, "fromMaybe", () => $06733ae99ed4f534$export$43db023a260c5e9f);
$parcel$export(module.exports, "fromJust", () => $06733ae99ed4f534$export$2506262575dd10a7);
$parcel$export(module.exports, "extendMaybe", () => $06733ae99ed4f534$export$cb6d304dbd10aa95);
$parcel$export(module.exports, "eqMaybe", () => $06733ae99ed4f534$export$8f45bb76abf9699e);
$parcel$export(module.exports, "ordMaybe", () => $06733ae99ed4f534$export$e35c29f98d259c46);
$parcel$export(module.exports, "eq1Maybe", () => $06733ae99ed4f534$export$b59095d05faa8cf6);
$parcel$export(module.exports, "ord1Maybe", () => $06733ae99ed4f534$export$c82772423d5de0b);
$parcel$export(module.exports, "boundedMaybe", () => $06733ae99ed4f534$export$158982e65b249847);
$parcel$export(module.exports, "applyMaybe", () => $06733ae99ed4f534$export$22d9917da16590e7);
$parcel$export(module.exports, "bindMaybe", () => $06733ae99ed4f534$export$e5fea5661dee377);
$parcel$export(module.exports, "applicativeMaybe", () => $06733ae99ed4f534$export$b203ef4465f15037);
$parcel$export(module.exports, "monadMaybe", () => $06733ae99ed4f534$export$f78a1c2d38efcc13);
$parcel$export(module.exports, "alternativeMaybe", () => $06733ae99ed4f534$export$92d23d3d8fa78a80);
// Generated by purs version 0.15.16

var $a7Dxq = parcelRequire("a7Dxq");

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $7T8P4 = parcelRequire("7T8P4");

var $95fRU = parcelRequire("95fRU");

var $4MBcA = parcelRequire("4MBcA");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");

var $5hqdn = parcelRequire("5hqdn");

var $cw1rg = parcelRequire("cw1rg");

var $d0PPW = parcelRequire("d0PPW");

var $6SDUu = parcelRequire("6SDUu");

var $iwqgS = parcelRequire("iwqgS");

var $gyPYh = parcelRequire("gyPYh");

var $3Orkn = parcelRequire("3Orkn");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");
var $06733ae99ed4f534$var$identity = /* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn);
var $06733ae99ed4f534$export$bebe9059409a0d04 = /* #__PURE__ */ function() {
    function Nothing() {}
    Nothing.value = new Nothing();
    return Nothing;
}();
var $06733ae99ed4f534$export$8a67b48435b5d073 = /* #__PURE__ */ function() {
    function Just(value0) {
        this.value0 = value0;
    }
    Just.create = function(value0) {
        return new Just(value0);
    };
    return Just;
}();
var $06733ae99ed4f534$export$9b814e760fdd264a = function(dictShow) {
    var show = $3Orkn.show(dictShow);
    return {
        show: function(v) {
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return "(Just " + (show(v.value0) + ")");
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return "Nothing";
            throw new Error("Failed pattern match at Data.Maybe (line 223, column 1 - line 225, column 28): " + [
                v.constructor.name
            ]);
        }
    };
};
var $06733ae99ed4f534$export$fb85b8a3a6158141 = function(dictSemigroup) {
    var append1 = $iwqgS.append(dictSemigroup);
    return {
        append: function(v) {
            return function(v1) {
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v1;
                if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v;
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073(append1(v.value0)(v1.value0));
                throw new Error("Failed pattern match at Data.Maybe (line 182, column 1 - line 185, column 43): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        }
    };
};
var $06733ae99ed4f534$export$516e28dec6a4b6d4 = function(dictAlt) {
    var alt = $a7Dxq.alt(dictAlt);
    var map1 = $l0wDR.map(dictAlt.Functor0());
    return function(dictApplicative) {
        var pure = $gUTA8.pure(dictApplicative);
        return function(a) {
            return alt(map1($06733ae99ed4f534$export$8a67b48435b5d073.create)(a))(pure($06733ae99ed4f534$export$bebe9059409a0d04.value));
        };
    };
};
var $06733ae99ed4f534$export$89fc9eb1adf8ed28 = function(dictSemigroup) {
    var semigroupMaybe1 = $06733ae99ed4f534$export$fb85b8a3a6158141(dictSemigroup);
    return {
        mempty: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        Semigroup0: function() {
            return semigroupMaybe1;
        }
    };
};
var $06733ae99ed4f534$export$76f250758a65e763 = function(v) {
    return function(v1) {
        return function(v2) {
            if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v($r2HHk.unit);
            if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return v1(v2.value0);
            throw new Error("Failed pattern match at Data.Maybe (line 250, column 1 - line 250, column 62): " + [
                v.constructor.name,
                v1.constructor.name,
                v2.constructor.name
            ]);
        };
    };
};
var $06733ae99ed4f534$export$f8b8b9ce72e9ccbf = function(v) {
    return function(v1) {
        return function(v2) {
            if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v;
            if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return v1(v2.value0);
            throw new Error("Failed pattern match at Data.Maybe (line 237, column 1 - line 237, column 51): " + [
                v.constructor.name,
                v1.constructor.name,
                v2.constructor.name
            ]);
        };
    };
};
var $06733ae99ed4f534$export$4967676db1b89293 = /* #__PURE__ */ $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(true)(/* #__PURE__ */ $l4M7e.const(false));
var $06733ae99ed4f534$export$c15bd07a493e1236 = /* #__PURE__ */ $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(false)(/* #__PURE__ */ $l4M7e.const(true));
var $06733ae99ed4f534$export$a1265319b56c5090 = {
    to: function(x) {
        if (x instanceof $cw1rg.Inl) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        if (x instanceof $cw1rg.Inr) return new $06733ae99ed4f534$export$8a67b48435b5d073(x.value0);
        throw new Error("Failed pattern match at Data.Maybe (line 227, column 1 - line 227, column 52): " + [
            x.constructor.name
        ]);
    },
    from: function(x) {
        if (x instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $cw1rg.Inl($cw1rg.NoArguments.value);
        if (x instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $cw1rg.Inr(x.value0);
        throw new Error("Failed pattern match at Data.Maybe (line 227, column 1 - line 227, column 52): " + [
            x.constructor.name
        ]);
    }
};
var $06733ae99ed4f534$export$fdd2427f0e60fd66 = {
    map: function(v) {
        return function(v1) {
            if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073(v(v1.value0));
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        };
    }
};
var $06733ae99ed4f534$var$map = /* #__PURE__ */ $l0wDR.map($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $06733ae99ed4f534$export$62eda6ff839a0571 = {
    imap: /* #__PURE__ */ $5hqdn.imapF($06733ae99ed4f534$export$fdd2427f0e60fd66)
};
var $06733ae99ed4f534$export$770f48d991b0f2a2 = function(a) {
    return $06733ae99ed4f534$export$76f250758a65e763(a)($06733ae99ed4f534$var$identity);
};
var $06733ae99ed4f534$export$43db023a260c5e9f = function(a) {
    return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(a)($06733ae99ed4f534$var$identity);
};
var $06733ae99ed4f534$export$2506262575dd10a7 = function() {
    return function(v) {
        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return v.value0;
        throw new Error("Failed pattern match at Data.Maybe (line 288, column 1 - line 288, column 46): " + [
            v.constructor.name
        ]);
    };
};
var $06733ae99ed4f534$export$cb6d304dbd10aa95 = {
    extend: function(v) {
        return function(v1) {
            if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            return new $06733ae99ed4f534$export$8a67b48435b5d073(v(v1));
        };
    },
    Functor0: function() {
        return $06733ae99ed4f534$export$fdd2427f0e60fd66;
    }
};
var $06733ae99ed4f534$export$8f45bb76abf9699e = function(dictEq) {
    var eq = $4MBcA.eq(dictEq);
    return {
        eq: function(x) {
            return function(y) {
                if (x instanceof $06733ae99ed4f534$export$bebe9059409a0d04 && y instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return true;
                if (x instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && y instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return eq(x.value0)(y.value0);
                return false;
            };
        }
    };
};
var $06733ae99ed4f534$export$e35c29f98d259c46 = function(dictOrd) {
    var compare = $d0PPW.compare(dictOrd);
    var eqMaybe1 = $06733ae99ed4f534$export$8f45bb76abf9699e(dictOrd.Eq0());
    return {
        compare: function(x) {
            return function(y) {
                if (x instanceof $06733ae99ed4f534$export$bebe9059409a0d04 && y instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $6SDUu.EQ.value;
                if (x instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $6SDUu.LT.value;
                if (y instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $6SDUu.GT.value;
                if (x instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && y instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return compare(x.value0)(y.value0);
                throw new Error("Failed pattern match at Data.Maybe (line 0, column 0 - line 0, column 0): " + [
                    x.constructor.name,
                    y.constructor.name
                ]);
            };
        },
        Eq0: function() {
            return eqMaybe1;
        }
    };
};
var $06733ae99ed4f534$export$b59095d05faa8cf6 = {
    eq1: function(dictEq) {
        return $4MBcA.eq($06733ae99ed4f534$export$8f45bb76abf9699e(dictEq));
    }
};
var $06733ae99ed4f534$export$c82772423d5de0b = {
    compare1: function(dictOrd) {
        return $d0PPW.compare($06733ae99ed4f534$export$e35c29f98d259c46(dictOrd));
    },
    Eq10: function() {
        return $06733ae99ed4f534$export$b59095d05faa8cf6;
    }
};
var $06733ae99ed4f534$export$158982e65b249847 = function(dictBounded) {
    var ordMaybe1 = $06733ae99ed4f534$export$e35c29f98d259c46(dictBounded.Ord0());
    return {
        top: new $06733ae99ed4f534$export$8a67b48435b5d073($95fRU.top(dictBounded)),
        bottom: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        Ord0: function() {
            return ordMaybe1;
        }
    };
};
var $06733ae99ed4f534$export$22d9917da16590e7 = {
    apply: function(v) {
        return function(v1) {
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $06733ae99ed4f534$var$map(v.value0)(v1);
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            throw new Error("Failed pattern match at Data.Maybe (line 67, column 1 - line 69, column 30): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    Functor0: function() {
        return $06733ae99ed4f534$export$fdd2427f0e60fd66;
    }
};
var $06733ae99ed4f534$var$apply = /* #__PURE__ */ $a5g3C.apply($06733ae99ed4f534$export$22d9917da16590e7);
var $06733ae99ed4f534$export$e5fea5661dee377 = {
    bind: function(v) {
        return function(v1) {
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return v1(v.value0);
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            throw new Error("Failed pattern match at Data.Maybe (line 125, column 1 - line 127, column 28): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    Apply0: function() {
        return $06733ae99ed4f534$export$22d9917da16590e7;
    }
};
var $06733ae99ed4f534$export$9e0396ae96a86801 = function(dictSemiring) {
    var add = $gyPYh.add(dictSemiring);
    var mul = $gyPYh.mul(dictSemiring);
    return {
        zero: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        one: new $06733ae99ed4f534$export$8a67b48435b5d073($gyPYh.one(dictSemiring)),
        add: function(v) {
            return function(v1) {
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v1;
                if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v;
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073(add(v.value0)(v1.value0));
                throw new Error("Failed pattern match at Data.Maybe (line 190, column 1 - line 198, column 28): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        },
        mul: function(x) {
            return function(y) {
                return $06733ae99ed4f534$var$apply($06733ae99ed4f534$var$map(mul)(x))(y);
            };
        }
    };
};
var $06733ae99ed4f534$export$b203ef4465f15037 = /* #__PURE__ */ function() {
    return {
        pure: $06733ae99ed4f534$export$8a67b48435b5d073.create,
        Apply0: function() {
            return $06733ae99ed4f534$export$22d9917da16590e7;
        }
    };
}();
var $06733ae99ed4f534$export$f78a1c2d38efcc13 = {
    Applicative0: function() {
        return $06733ae99ed4f534$export$b203ef4465f15037;
    },
    Bind1: function() {
        return $06733ae99ed4f534$export$e5fea5661dee377;
    }
};
var $06733ae99ed4f534$export$a22c94fdeac581ff = {
    alt: function(v) {
        return function(v1) {
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v1;
            return v;
        };
    },
    Functor0: function() {
        return $06733ae99ed4f534$export$fdd2427f0e60fd66;
    }
};
var $06733ae99ed4f534$export$164e6bcbae9cfdd0 = /* #__PURE__ */ function() {
    return {
        empty: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        Alt0: function() {
            return $06733ae99ed4f534$export$a22c94fdeac581ff;
        }
    };
}();
var $06733ae99ed4f534$export$92d23d3d8fa78a80 = {
    Applicative0: function() {
        return $06733ae99ed4f534$export$b203ef4465f15037;
    },
    Plus1: function() {
        return $06733ae99ed4f534$export$164e6bcbae9cfdd0;
    }
};

});


parcelRegister("6VVZC", function(module, exports) {

$parcel$export(module.exports, "Identity", () => $50c50d1f444e5fa4$export$544bf02140fa9a77);
$parcel$export(module.exports, "functorIdentity", () => $50c50d1f444e5fa4$export$dc85e8383eafbd81);
$parcel$export(module.exports, "comonadIdentity", () => $50c50d1f444e5fa4$export$aac6efd7b2eac4c4);
$parcel$export(module.exports, "applicativeIdentity", () => $50c50d1f444e5fa4$export$fd3b2458e55fc503);
$parcel$export(module.exports, "monadIdentity", () => $50c50d1f444e5fa4$export$9a2f2fd6148bc6d0);
$parcel$export(module.exports, "altIdentity", () => $50c50d1f444e5fa4$export$1cd7ff14f6a7fcef);
// Generated by purs version 0.15.16

var $4MBcA = parcelRequire("4MBcA");

var $5hqdn = parcelRequire("5hqdn");

var $d0PPW = parcelRequire("d0PPW");

var $3Orkn = parcelRequire("3Orkn");
var $50c50d1f444e5fa4$export$544bf02140fa9a77 = function(x) {
    return x;
};
var $50c50d1f444e5fa4$export$7af8a265c45f06a6 = function(dictShow) {
    var show = $3Orkn.show(dictShow);
    return {
        show: function(v) {
            return "(Identity " + (show(v) + ")");
        }
    };
};
var $50c50d1f444e5fa4$export$de6e130f3067e173 = function(dictSemiring) {
    return dictSemiring;
};
var $50c50d1f444e5fa4$export$fbd9f08ec652d5d9 = function(dictSemigroup) {
    return dictSemigroup;
};
var $50c50d1f444e5fa4$export$7f1a4089c064b339 = function(dictRing) {
    return dictRing;
};
var $50c50d1f444e5fa4$export$af307155aba4d997 = function(dictOrd) {
    return dictOrd;
};
var $50c50d1f444e5fa4$export$4e4e6c89b10840f9 = {
    Coercible0: function() {
        return undefined;
    }
};
var $50c50d1f444e5fa4$export$2f07791950174d24 = function(dictMonoid) {
    return dictMonoid;
};
var $50c50d1f444e5fa4$export$c7656c1a42d43140 = function(dictLazy) {
    return dictLazy;
};
var $50c50d1f444e5fa4$export$7e3f9626786077f7 = function(dictHeytingAlgebra) {
    return dictHeytingAlgebra;
};
var $50c50d1f444e5fa4$export$dc85e8383eafbd81 = {
    map: function(f) {
        return function(m) {
            return f(m);
        };
    }
};
var $50c50d1f444e5fa4$export$ace4d1c3770c9591 = {
    imap: /* #__PURE__ */ $5hqdn.imapF($50c50d1f444e5fa4$export$dc85e8383eafbd81)
};
var $50c50d1f444e5fa4$export$a04fa6f5a41919d9 = {
    extend: function(f) {
        return function(m) {
            return f(m);
        };
    },
    Functor0: function() {
        return $50c50d1f444e5fa4$export$dc85e8383eafbd81;
    }
};
var $50c50d1f444e5fa4$export$4d1b13d40da4cff7 = function(dictEuclideanRing) {
    return dictEuclideanRing;
};
var $50c50d1f444e5fa4$export$b3449ff235884fd4 = function(dictEq) {
    return dictEq;
};
var $50c50d1f444e5fa4$export$43b3c8db16b4e7b8 = {
    eq1: function(dictEq) {
        return $4MBcA.eq($50c50d1f444e5fa4$export$b3449ff235884fd4(dictEq));
    }
};
var $50c50d1f444e5fa4$export$982c033a83dfd7d3 = {
    compare1: function(dictOrd) {
        return $d0PPW.compare($50c50d1f444e5fa4$export$af307155aba4d997(dictOrd));
    },
    Eq10: function() {
        return $50c50d1f444e5fa4$export$43b3c8db16b4e7b8;
    }
};
var $50c50d1f444e5fa4$export$aac6efd7b2eac4c4 = {
    extract: function(v) {
        return v;
    },
    Extend0: function() {
        return $50c50d1f444e5fa4$export$a04fa6f5a41919d9;
    }
};
var $50c50d1f444e5fa4$export$133f9093a008dc4d = function(dictCommutativeRing) {
    return dictCommutativeRing;
};
var $50c50d1f444e5fa4$export$5be407eed81cb759 = function(dictBounded) {
    return dictBounded;
};
var $50c50d1f444e5fa4$export$c3b024d9c40a32df = function(dictBooleanAlgebra) {
    return dictBooleanAlgebra;
};
var $50c50d1f444e5fa4$export$c7d2c62721e92954 = {
    apply: function(v) {
        return function(v1) {
            return v(v1);
        };
    },
    Functor0: function() {
        return $50c50d1f444e5fa4$export$dc85e8383eafbd81;
    }
};
var $50c50d1f444e5fa4$export$91e759983456b85e = {
    bind: function(v) {
        return function(f) {
            return f(v);
        };
    },
    Apply0: function() {
        return $50c50d1f444e5fa4$export$c7d2c62721e92954;
    }
};
var $50c50d1f444e5fa4$export$fd3b2458e55fc503 = {
    pure: $50c50d1f444e5fa4$export$544bf02140fa9a77,
    Apply0: function() {
        return $50c50d1f444e5fa4$export$c7d2c62721e92954;
    }
};
var $50c50d1f444e5fa4$export$9a2f2fd6148bc6d0 = {
    Applicative0: function() {
        return $50c50d1f444e5fa4$export$fd3b2458e55fc503;
    },
    Bind1: function() {
        return $50c50d1f444e5fa4$export$91e759983456b85e;
    }
};
var $50c50d1f444e5fa4$export$1cd7ff14f6a7fcef = {
    alt: function(x) {
        return function(v) {
            return x;
        };
    },
    Functor0: function() {
        return $50c50d1f444e5fa4$export$dc85e8383eafbd81;
    }
};

});

parcelRegister("aknDF", function(module, exports) {

$parcel$export(module.exports, "monoidUnit", () => $784e1bd3d26d71da$export$852b4040eee6c6ba);
$parcel$export(module.exports, "monoidString", () => $784e1bd3d26d71da$export$fc39f3d77fa2e58a);
$parcel$export(module.exports, "monoidArray", () => $784e1bd3d26d71da$export$db307f59121ffcc4);
$parcel$export(module.exports, "mempty", () => $784e1bd3d26d71da$export$9a7d64bc1d75357);
$parcel$export(module.exports, "monoidFn", () => $784e1bd3d26d71da$export$192e81b9fe7e4abe);
// Generated by purs version 0.15.16

var $6UHO6 = parcelRequire("6UHO6");

var $fb7aO = parcelRequire("fb7aO");

var $6SDUu = parcelRequire("6SDUu");

var $iwqgS = parcelRequire("iwqgS");

var $2HEu8 = parcelRequire("2HEu8");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");
parcelRequire("2zMBQ");
var $i72yb = parcelRequire("i72yb");

var $h3hu6 = parcelRequire("h3hu6");
var $784e1bd3d26d71da$var$semigroupRecord = /* #__PURE__ */ $iwqgS.semigroupRecord();
var $784e1bd3d26d71da$var$mod = /* #__PURE__ */ $fb7aO.mod($fb7aO.euclideanRingInt);
var $784e1bd3d26d71da$var$div = /* #__PURE__ */ $fb7aO.div($fb7aO.euclideanRingInt);
var $784e1bd3d26d71da$export$852b4040eee6c6ba = {
    mempty: $r2HHk.unit,
    Semigroup0: function() {
        return $iwqgS.semigroupUnit;
    }
};
var $784e1bd3d26d71da$export$fc39f3d77fa2e58a = {
    mempty: "",
    Semigroup0: function() {
        return $iwqgS.semigroupString;
    }
};
var $784e1bd3d26d71da$export$254fca207e30c208 = {
    memptyRecord: function(v) {
        return {};
    },
    SemigroupRecord0: function() {
        return $iwqgS.semigroupRecordNil;
    }
};
var $784e1bd3d26d71da$export$84dd8432d2bb1dc3 = /* #__PURE__ */ function() {
    return {
        mempty: $6SDUu.EQ.value,
        Semigroup0: function() {
            return $6SDUu.semigroupOrdering;
        }
    };
}();
var $784e1bd3d26d71da$export$db307f59121ffcc4 = {
    mempty: [],
    Semigroup0: function() {
        return $iwqgS.semigroupArray;
    }
};
var $784e1bd3d26d71da$export$ae16212c99887b7f = function(dict) {
    return dict.memptyRecord;
};
var $784e1bd3d26d71da$export$b6526a2ab5064058 = function() {
    return function(dictMonoidRecord) {
        var semigroupRecord1 = $784e1bd3d26d71da$var$semigroupRecord(dictMonoidRecord.SemigroupRecord0());
        return {
            mempty: $784e1bd3d26d71da$export$ae16212c99887b7f(dictMonoidRecord)($h3hu6.Proxy.value),
            Semigroup0: function() {
                return semigroupRecord1;
            }
        };
    };
};
var $784e1bd3d26d71da$export$9a7d64bc1d75357 = function(dict) {
    return dict.mempty;
};
var $784e1bd3d26d71da$export$192e81b9fe7e4abe = function(dictMonoid) {
    var mempty1 = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    var semigroupFn = $iwqgS.semigroupFn(dictMonoid.Semigroup0());
    return {
        mempty: function(v) {
            return mempty1;
        },
        Semigroup0: function() {
            return semigroupFn;
        }
    };
};
var $784e1bd3d26d71da$export$d672019c76a5af4a = function(dictIsSymbol) {
    var reflectSymbol = $2HEu8.reflectSymbol(dictIsSymbol);
    var semigroupRecordCons = $iwqgS.semigroupRecordCons(dictIsSymbol)();
    return function(dictMonoid) {
        var mempty1 = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        var Semigroup0 = dictMonoid.Semigroup0();
        return function() {
            return function(dictMonoidRecord) {
                var memptyRecord1 = $784e1bd3d26d71da$export$ae16212c99887b7f(dictMonoidRecord);
                var semigroupRecordCons1 = semigroupRecordCons(dictMonoidRecord.SemigroupRecord0())(Semigroup0);
                return {
                    memptyRecord: function(v) {
                        var tail = memptyRecord1($h3hu6.Proxy.value);
                        var key = reflectSymbol($h3hu6.Proxy.value);
                        var insert = $i72yb.unsafeSet(key);
                        return insert(mempty1)(tail);
                    },
                    SemigroupRecord0: function() {
                        return semigroupRecordCons1;
                    }
                };
            };
        };
    };
};
var $784e1bd3d26d71da$export$836601bcef5ff40 = function(dictMonoid) {
    var mempty1 = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    var append = $iwqgS.append(dictMonoid.Semigroup0());
    return function(x) {
        var go = function(p) {
            if (p <= 0) return mempty1;
            if (p === 1) return x;
            if ($784e1bd3d26d71da$var$mod(p)(2) === 0) {
                var x$prime = go($784e1bd3d26d71da$var$div(p)(2));
                return append(x$prime)(x$prime);
            }
            if ($6UHO6.otherwise) {
                var x$prime = go($784e1bd3d26d71da$var$div(p)(2));
                return append(x$prime)(append(x$prime)(x));
            }
            throw new Error("Failed pattern match at Data.Monoid (line 88, column 3 - line 88, column 17): " + [
                p.constructor.name
            ]);
        };
        return go;
    };
};
var $784e1bd3d26d71da$export$864d727b48066337 = function(dictMonoid) {
    var mempty1 = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    return function(v) {
        return function(v1) {
            if (v) return v1;
            if (!v) return mempty1;
            throw new Error("Failed pattern match at Data.Monoid (line 96, column 1 - line 96, column 49): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    };
};

});
parcelRegister("fb7aO", function(module, exports) {

$parcel$export(module.exports, "mod", () => $b0cd729514c2504e$export$842a2cf37af977e1);
$parcel$export(module.exports, "euclideanRingInt", () => $b0cd729514c2504e$export$437776face1858ae);
$parcel$export(module.exports, "div", () => $b0cd729514c2504e$export$159d9494db57879b);
$parcel$export(module.exports, "degree", () => $b0cd729514c2504e$export$a23b7da4bc008930);
// Generated by purs version 0.15.16

var $dFAcP = parcelRequire("dFAcP");

var $ehfXI = parcelRequire("ehfXI");

var $4MBcA = parcelRequire("4MBcA");

var $hTcAb = parcelRequire("hTcAb");

var $gyPYh = parcelRequire("gyPYh");
var $b0cd729514c2504e$export$842a2cf37af977e1 = function(dict) {
    return dict.mod;
};
var $b0cd729514c2504e$export$f81847884871263e = function(dictEq) {
    var eq = $4MBcA.eq(dictEq);
    return function(dictEuclideanRing) {
        var zero = $gyPYh.zero(dictEuclideanRing.CommutativeRing0().Ring0().Semiring0());
        var mod1 = $b0cd729514c2504e$export$842a2cf37af977e1(dictEuclideanRing);
        return function(a) {
            return function(b) {
                var $24 = eq(b)(zero);
                if ($24) return a;
                return $b0cd729514c2504e$export$f81847884871263e(dictEq)(dictEuclideanRing)(b)(mod1(a)(b));
            };
        };
    };
};
var $b0cd729514c2504e$export$ea62662521882766 = {
    degree: function(v) {
        return 1;
    },
    div: $dFAcP.numDiv,
    mod: function(v) {
        return function(v1) {
            return 0.0;
        };
    },
    CommutativeRing0: function() {
        return $ehfXI.commutativeRingNumber;
    }
};
var $b0cd729514c2504e$export$437776face1858ae = {
    degree: $dFAcP.intDegree,
    div: $dFAcP.intDiv,
    mod: $dFAcP.intMod,
    CommutativeRing0: function() {
        return $ehfXI.commutativeRingInt;
    }
};
var $b0cd729514c2504e$export$159d9494db57879b = function(dict) {
    return dict.div;
};
var $b0cd729514c2504e$export$f686d97e407ec4ef = function(dictEq) {
    var eq = $4MBcA.eq(dictEq);
    var gcd1 = $b0cd729514c2504e$export$f81847884871263e(dictEq);
    return function(dictEuclideanRing) {
        var Semiring0 = dictEuclideanRing.CommutativeRing0().Ring0().Semiring0();
        var zero = $gyPYh.zero(Semiring0);
        var div1 = $b0cd729514c2504e$export$159d9494db57879b(dictEuclideanRing);
        var mul = $gyPYh.mul(Semiring0);
        var gcd2 = gcd1(dictEuclideanRing);
        return function(a) {
            return function(b) {
                var $26 = eq(a)(zero) || eq(b)(zero);
                if ($26) return zero;
                return div1(mul(a)(b))(gcd2(a)(b));
            };
        };
    };
};
var $b0cd729514c2504e$export$a23b7da4bc008930 = function(dict) {
    return dict.degree;
};

});
parcelRegister("dFAcP", function(module, exports) {

$parcel$export(module.exports, "intDegree", () => $9f3b30719c815f93$export$748d824f642f540d);
$parcel$export(module.exports, "intDiv", () => $9f3b30719c815f93$export$baf7824ae32165f5);
$parcel$export(module.exports, "intMod", () => $9f3b30719c815f93$export$faa51fbcd7b05d8f);
$parcel$export(module.exports, "numDiv", () => $9f3b30719c815f93$export$6db30f2997f70499);
const $9f3b30719c815f93$export$748d824f642f540d = function(x) {
    return Math.min(Math.abs(x), 2147483647);
};
const $9f3b30719c815f93$export$baf7824ae32165f5 = function(x) {
    return function(y) {
        if (y === 0) return 0;
        return y > 0 ? Math.floor(x / y) : -Math.floor(x / -y);
    };
};
const $9f3b30719c815f93$export$faa51fbcd7b05d8f = function(x) {
    return function(y) {
        if (y === 0) return 0;
        var yy = Math.abs(y);
        return (x % yy + yy) % yy;
    };
};
const $9f3b30719c815f93$export$6db30f2997f70499 = function(n1) {
    return function(n2) {
        return n1 / n2;
    };
};

});

parcelRegister("ehfXI", function(module, exports) {

$parcel$export(module.exports, "commutativeRingNumber", () => $a64f08f726dec5e9$export$ed11bb9ee1d36807);
$parcel$export(module.exports, "commutativeRingInt", () => $a64f08f726dec5e9$export$5745e05f6b169cee);
// Generated by purs version 0.15.16

var $hTcAb = parcelRequire("hTcAb");

var $gyPYh = parcelRequire("gyPYh");
var $a64f08f726dec5e9$var$ringRecord = /* #__PURE__ */ $hTcAb.ringRecord();
var $a64f08f726dec5e9$export$4fcc4024c8011653 = {
    Ring0: function() {
        return $hTcAb.ringUnit;
    }
};
var $a64f08f726dec5e9$export$a2ce2b4503316dcc = {
    RingRecord0: function() {
        return $hTcAb.ringRecordNil;
    }
};
var $a64f08f726dec5e9$export$dc394faf01ed3f4e = function(dictIsSymbol) {
    var ringRecordCons = $hTcAb.ringRecordCons(dictIsSymbol)();
    return function() {
        return function(dictCommutativeRingRecord) {
            var ringRecordCons1 = ringRecordCons(dictCommutativeRingRecord.RingRecord0());
            return function(dictCommutativeRing) {
                var ringRecordCons2 = ringRecordCons1(dictCommutativeRing.Ring0());
                return {
                    RingRecord0: function() {
                        return ringRecordCons2;
                    }
                };
            };
        };
    };
};
var $a64f08f726dec5e9$export$d4bbb7afedb09bfd = function() {
    return function(dictCommutativeRingRecord) {
        var ringRecord1 = $a64f08f726dec5e9$var$ringRecord(dictCommutativeRingRecord.RingRecord0());
        return {
            Ring0: function() {
                return ringRecord1;
            }
        };
    };
};
var $a64f08f726dec5e9$export$7f39ee449b822938 = {
    Ring0: function() {
        return $hTcAb.ringProxy;
    }
};
var $a64f08f726dec5e9$export$ed11bb9ee1d36807 = {
    Ring0: function() {
        return $hTcAb.ringNumber;
    }
};
var $a64f08f726dec5e9$export$5745e05f6b169cee = {
    Ring0: function() {
        return $hTcAb.ringInt;
    }
};
var $a64f08f726dec5e9$export$bdad616b79aca10 = function(dictCommutativeRing) {
    var ringFn = $hTcAb.ringFn(dictCommutativeRing.Ring0());
    return {
        Ring0: function() {
            return ringFn;
        }
    };
};

});



parcelRegister("9hRVP", function(module, exports) {

$parcel$export(module.exports, "monadEffect", () => $6c2f8951ecf9531e$export$7e900d895707a1af);
$parcel$export(module.exports, "applicativeEffect", () => $6c2f8951ecf9531e$export$89bf999217d3022a);
$parcel$export(module.exports, "bindEffect", () => $6c2f8951ecf9531e$export$855330f8a2a9f2e8);
$parcel$export(module.exports, "functorEffect", () => $6c2f8951ecf9531e$export$91fce01ecf0438e1);
$parcel$export(module.exports, "applyEffect", () => $6c2f8951ecf9531e$export$59a7b217c53300d2);
$parcel$export(module.exports, "semigroupEffect", () => $6c2f8951ecf9531e$export$58139e981c60cf43);
$parcel$export(module.exports, "monoidEffect", () => $6c2f8951ecf9531e$export$2d8226ee4b2722f7);
// Generated by purs version 0.15.16

var $aAild = parcelRequire("aAild");

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $ibtPS = parcelRequire("ibtPS");

var $aknDF = parcelRequire("aknDF");

var $iwqgS = parcelRequire("iwqgS");
var $6c2f8951ecf9531e$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $6c2f8951ecf9531e$export$7e900d895707a1af = {
    Applicative0: function() {
        return $6c2f8951ecf9531e$export$89bf999217d3022a;
    },
    Bind1: function() {
        return $6c2f8951ecf9531e$export$855330f8a2a9f2e8;
    }
};
var $6c2f8951ecf9531e$export$855330f8a2a9f2e8 = {
    bind: $aAild.bindE,
    Apply0: function() {
        return $6c2f8951ecf9531e$var$$lazy_applyEffect(0);
    }
};
var $6c2f8951ecf9531e$export$89bf999217d3022a = {
    pure: $aAild.pureE,
    Apply0: function() {
        return $6c2f8951ecf9531e$var$$lazy_applyEffect(0);
    }
};
var $6c2f8951ecf9531e$var$$lazy_functorEffect = /* #__PURE__ */ $6c2f8951ecf9531e$var$$runtime_lazy("functorEffect", "Effect", function() {
    return {
        map: $gUTA8.liftA1($6c2f8951ecf9531e$export$89bf999217d3022a)
    };
});
var $6c2f8951ecf9531e$var$$lazy_applyEffect = /* #__PURE__ */ $6c2f8951ecf9531e$var$$runtime_lazy("applyEffect", "Effect", function() {
    return {
        apply: $ibtPS.ap($6c2f8951ecf9531e$export$7e900d895707a1af),
        Functor0: function() {
            return $6c2f8951ecf9531e$var$$lazy_functorEffect(0);
        }
    };
});
var $6c2f8951ecf9531e$export$91fce01ecf0438e1 = /* #__PURE__ */ $6c2f8951ecf9531e$var$$lazy_functorEffect(20);
var $6c2f8951ecf9531e$export$59a7b217c53300d2 = /* #__PURE__ */ $6c2f8951ecf9531e$var$$lazy_applyEffect(23);
var $6c2f8951ecf9531e$var$lift2 = /* #__PURE__ */ $a5g3C.lift2($6c2f8951ecf9531e$export$59a7b217c53300d2);
var $6c2f8951ecf9531e$export$58139e981c60cf43 = function(dictSemigroup) {
    return {
        append: $6c2f8951ecf9531e$var$lift2($iwqgS.append(dictSemigroup))
    };
};
var $6c2f8951ecf9531e$export$2d8226ee4b2722f7 = function(dictMonoid) {
    var semigroupEffect1 = $6c2f8951ecf9531e$export$58139e981c60cf43(dictMonoid.Semigroup0());
    return {
        mempty: $aAild.pureE($aknDF.mempty(dictMonoid)),
        Semigroup0: function() {
            return semigroupEffect1;
        }
    };
};

});
parcelRegister("aAild", function(module, exports) {

$parcel$export(module.exports, "pureE", () => $01fd16aefb19fd56$export$f6d4f01ca39c2fe);
$parcel$export(module.exports, "bindE", () => $01fd16aefb19fd56$export$b771a24b80e4c766);
const $01fd16aefb19fd56$export$f6d4f01ca39c2fe = function(a) {
    return function() {
        return a;
    };
};
const $01fd16aefb19fd56$export$b771a24b80e4c766 = function(a) {
    return function(f) {
        return function() {
            return f(a())();
        };
    };
};
const $01fd16aefb19fd56$export$161ebd47ed3ced60 = function(f) {
    return function() {
        while(!f());
    };
};
const $01fd16aefb19fd56$export$27334490557f84d2 = function(f) {
    return function(a) {
        return function() {
            while(f())a();
        };
    };
};
const $01fd16aefb19fd56$export$3dfbdd78bf0090db = function(lo) {
    return function(hi) {
        return function(f) {
            return function() {
                for(var i = lo; i < hi; i++)f(i)();
            };
        };
    };
};
const $01fd16aefb19fd56$export$eff012ca4e6ded0b = function(as) {
    return function(f) {
        return function() {
            for(var i = 0, l = as.length; i < l; i++)f(as[i])();
        };
    };
};

});


parcelRegister("cnyA5", function(module, exports) {

$parcel$export(module.exports, "new", () => $90327512d8280b8d$export$b8cb59497041ffe4);
$parcel$export(module.exports, "modify$prime", () => $90327512d8280b8d$export$4d5401161a900ce1);
$parcel$export(module.exports, "modify", () => $90327512d8280b8d$export$3ff57735a52b8713);
$parcel$export(module.exports, "modify_", () => $90327512d8280b8d$export$45b91115a89d6020);
$parcel$export(module.exports, "read", () => (parcelRequire("jFEU8")).read);
$parcel$export(module.exports, "write", () => (parcelRequire("jFEU8")).write);
// Generated by purs version 0.15.16

var $jFEU8 = parcelRequire("jFEU8");

var $l0wDR = parcelRequire("l0wDR");

var $9hRVP = parcelRequire("9hRVP");
var $90327512d8280b8d$var$$$void = /* #__PURE__ */ $l0wDR.void($9hRVP.functorEffect);
var $90327512d8280b8d$export$b8cb59497041ffe4 = $jFEU8._new;
var $90327512d8280b8d$export$4d5401161a900ce1 = $jFEU8.modifyImpl;
var $90327512d8280b8d$export$3ff57735a52b8713 = function(f) {
    return $90327512d8280b8d$export$4d5401161a900ce1(function(s) {
        var s$prime = f(s);
        return {
            state: s$prime,
            value: s$prime
        };
    });
};
var $90327512d8280b8d$export$45b91115a89d6020 = function(f) {
    return function(s) {
        return $90327512d8280b8d$var$$$void($90327512d8280b8d$export$3ff57735a52b8713(f)(s));
    };
};

});
parcelRegister("jFEU8", function(module, exports) {

$parcel$export(module.exports, "_new", () => $e521936ea118867a$export$339fb7f00efd6941);
$parcel$export(module.exports, "read", () => $e521936ea118867a$export$aafa59e2e03f2942);
$parcel$export(module.exports, "modifyImpl", () => $e521936ea118867a$export$cc2488c59b3f757);
$parcel$export(module.exports, "write", () => $e521936ea118867a$export$68d8715fc104d294);
const $e521936ea118867a$export$339fb7f00efd6941 = function(val) {
    return function() {
        return {
            value: val
        };
    };
};
const $e521936ea118867a$export$d23276e97b1411ef = function(f) {
    return function() {
        var ref = {
            value: null
        };
        ref.value = f(ref);
        return ref;
    };
};
const $e521936ea118867a$export$aafa59e2e03f2942 = function(ref) {
    return function() {
        return ref.value;
    };
};
const $e521936ea118867a$export$cc2488c59b3f757 = function(f) {
    return function(ref) {
        return function() {
            var t = f(ref.value);
            ref.value = t.state;
            return t.value;
        };
    };
};
const $e521936ea118867a$export$68d8715fc104d294 = function(val) {
    return function(ref) {
        return function() {
            ref.value = val;
        };
    };
};

});





parcelRegister("kQAxW", function(module, exports) {

$parcel$export(module.exports, "state", () => $f2d5035ce6148af6$export$ca000e230c0caa3e);
$parcel$export(module.exports, "put", () => $f2d5035ce6148af6$export$327f7b26ebf455db);
$parcel$export(module.exports, "modify_", () => $f2d5035ce6148af6$export$45b91115a89d6020);
$parcel$export(module.exports, "modify", () => $f2d5035ce6148af6$export$3ff57735a52b8713);
$parcel$export(module.exports, "get", () => $f2d5035ce6148af6$export$3988ae62b71be9a3);
// Generated by purs version 0.15.16

var $9MxTl = parcelRequire("9MxTl");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");
var $f2d5035ce6148af6$export$ca000e230c0caa3e = function(dict) {
    return dict.state;
};
var $f2d5035ce6148af6$export$327f7b26ebf455db = function(dictMonadState) {
    var state1 = $f2d5035ce6148af6$export$ca000e230c0caa3e(dictMonadState);
    return function(s) {
        return state1(function(v) {
            return new $9MxTl.Tuple($r2HHk.unit, s);
        });
    };
};
var $f2d5035ce6148af6$export$45b91115a89d6020 = function(dictMonadState) {
    var state1 = $f2d5035ce6148af6$export$ca000e230c0caa3e(dictMonadState);
    return function(f) {
        return state1(function(s) {
            return new $9MxTl.Tuple($r2HHk.unit, f(s));
        });
    };
};
var $f2d5035ce6148af6$export$3ff57735a52b8713 = function(dictMonadState) {
    var state1 = $f2d5035ce6148af6$export$ca000e230c0caa3e(dictMonadState);
    return function(f) {
        return state1(function(s) {
            var s$prime = f(s);
            return new $9MxTl.Tuple(s$prime, s$prime);
        });
    };
};
var $f2d5035ce6148af6$export$49487f6cbb79019d = function(dictMonadState) {
    var state1 = $f2d5035ce6148af6$export$ca000e230c0caa3e(dictMonadState);
    return function(f) {
        return state1(function(s) {
            return new $9MxTl.Tuple(f(s), s);
        });
    };
};
var $f2d5035ce6148af6$export$3988ae62b71be9a3 = function(dictMonadState) {
    return $f2d5035ce6148af6$export$ca000e230c0caa3e(dictMonadState)(function(s) {
        return new $9MxTl.Tuple(s, s);
    });
};

});
parcelRegister("9MxTl", function(module, exports) {

$parcel$export(module.exports, "Tuple", () => $71f2e2e9476163f8$export$1908877435b1d5e9);
$parcel$export(module.exports, "uncurry", () => $71f2e2e9476163f8$export$7864d59d01b6d6bf);
$parcel$export(module.exports, "swap", () => $71f2e2e9476163f8$export$b0e76d9850c64156);
$parcel$export(module.exports, "snd", () => $71f2e2e9476163f8$export$6f71268a1666ab58);
$parcel$export(module.exports, "showTuple", () => $71f2e2e9476163f8$export$c29279d1dfdefb95);
$parcel$export(module.exports, "functorTuple", () => $71f2e2e9476163f8$export$19ab04734dcb0ff0);
$parcel$export(module.exports, "fst", () => $71f2e2e9476163f8$export$9e770fa6ce19a9d6);
$parcel$export(module.exports, "eqTuple", () => $71f2e2e9476163f8$export$d625e8a97ba36bd6);
$parcel$export(module.exports, "ordTuple", () => $71f2e2e9476163f8$export$8f11eb03746a66e2);
$parcel$export(module.exports, "curry", () => $71f2e2e9476163f8$export$c3095a23b368d1f2);
$parcel$export(module.exports, "comonadTuple", () => $71f2e2e9476163f8$export$8e995acc5599767e);
// Generated by purs version 0.15.16

var $dTFzl = parcelRequire("dTFzl");

var $95fRU = parcelRequire("95fRU");

var $4MBcA = parcelRequire("4MBcA");

var $5hqdn = parcelRequire("5hqdn");

var $cw1rg = parcelRequire("cw1rg");

var $lnl7Y = parcelRequire("lnl7Y");

var $aknDF = parcelRequire("aknDF");

var $d0PPW = parcelRequire("d0PPW");

var $6SDUu = parcelRequire("6SDUu");

var $hTcAb = parcelRequire("hTcAb");

var $iwqgS = parcelRequire("iwqgS");

var $gyPYh = parcelRequire("gyPYh");

var $3Orkn = parcelRequire("3Orkn");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");
var $71f2e2e9476163f8$export$1908877435b1d5e9 = /* #__PURE__ */ function() {
    function Tuple(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Tuple.create = function(value0) {
        return function(value1) {
            return new Tuple(value0, value1);
        };
    };
    return Tuple;
}();
var $71f2e2e9476163f8$export$7864d59d01b6d6bf = function(f) {
    return function(v) {
        return f(v.value0)(v.value1);
    };
};
var $71f2e2e9476163f8$export$b0e76d9850c64156 = function(v) {
    return new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value1, v.value0);
};
var $71f2e2e9476163f8$export$6f71268a1666ab58 = function(v) {
    return v.value1;
};
var $71f2e2e9476163f8$export$c29279d1dfdefb95 = function(dictShow) {
    var show = $3Orkn.show(dictShow);
    return function(dictShow1) {
        var show1 = $3Orkn.show(dictShow1);
        return {
            show: function(v) {
                return "(Tuple " + (show(v.value0) + (" " + (show1(v.value1) + ")")));
            }
        };
    };
};
var $71f2e2e9476163f8$export$a55548456e48767 = function(dictSemiring) {
    var add = $gyPYh.add(dictSemiring);
    var one = $gyPYh.one(dictSemiring);
    var mul = $gyPYh.mul(dictSemiring);
    var zero = $gyPYh.zero(dictSemiring);
    return function(dictSemiring1) {
        var add1 = $gyPYh.add(dictSemiring1);
        var mul1 = $gyPYh.mul(dictSemiring1);
        return {
            add: function(v) {
                return function(v1) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(add(v.value0)(v1.value0), add1(v.value1)(v1.value1));
                };
            },
            one: new $71f2e2e9476163f8$export$1908877435b1d5e9(one, $gyPYh.one(dictSemiring1)),
            mul: function(v) {
                return function(v1) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(mul(v.value0)(v1.value0), mul1(v.value1)(v1.value1));
                };
            },
            zero: new $71f2e2e9476163f8$export$1908877435b1d5e9(zero, $gyPYh.zero(dictSemiring1))
        };
    };
};
var $71f2e2e9476163f8$export$ab2b4b200e457b99 = {
    compose: function(v) {
        return function(v1) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9(v1.value0, v.value1);
        };
    }
};
var $71f2e2e9476163f8$export$1f8404c41aab4117 = function(dictSemigroup) {
    var append1 = $iwqgS.append(dictSemigroup);
    return function(dictSemigroup1) {
        var append2 = $iwqgS.append(dictSemigroup1);
        return {
            append: function(v) {
                return function(v1) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(append1(v.value0)(v1.value0), append2(v.value1)(v1.value1));
                };
            }
        };
    };
};
var $71f2e2e9476163f8$export$9ba4b2debe474100 = function(dictRing) {
    var sub = $hTcAb.sub(dictRing);
    var semiringTuple1 = $71f2e2e9476163f8$export$a55548456e48767(dictRing.Semiring0());
    return function(dictRing1) {
        var sub1 = $hTcAb.sub(dictRing1);
        var semiringTuple2 = semiringTuple1(dictRing1.Semiring0());
        return {
            sub: function(v) {
                return function(v1) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(sub(v.value0)(v1.value0), sub1(v.value1)(v1.value1));
                };
            },
            Semiring0: function() {
                return semiringTuple2;
            }
        };
    };
};
var $71f2e2e9476163f8$export$a9eaa17b3ab5a78d = function(dictMonoid) {
    var mempty = $aknDF.mempty(dictMonoid);
    var semigroupTuple1 = $71f2e2e9476163f8$export$1f8404c41aab4117(dictMonoid.Semigroup0());
    return function(dictMonoid1) {
        var semigroupTuple2 = semigroupTuple1(dictMonoid1.Semigroup0());
        return {
            mempty: new $71f2e2e9476163f8$export$1908877435b1d5e9(mempty, $aknDF.mempty(dictMonoid1)),
            Semigroup0: function() {
                return semigroupTuple2;
            }
        };
    };
};
var $71f2e2e9476163f8$export$47e10f15d8f6e8d8 = function(dictHeytingAlgebra) {
    var tt = $lnl7Y.tt(dictHeytingAlgebra);
    var ff = $lnl7Y.ff(dictHeytingAlgebra);
    var implies = $lnl7Y.implies(dictHeytingAlgebra);
    var conj1 = $lnl7Y.conj(dictHeytingAlgebra);
    var disj = $lnl7Y.disj(dictHeytingAlgebra);
    var not = $lnl7Y.not(dictHeytingAlgebra);
    return function(dictHeytingAlgebra1) {
        var implies1 = $lnl7Y.implies(dictHeytingAlgebra1);
        var conj2 = $lnl7Y.conj(dictHeytingAlgebra1);
        var disj1 = $lnl7Y.disj(dictHeytingAlgebra1);
        var not1 = $lnl7Y.not(dictHeytingAlgebra1);
        return {
            tt: new $71f2e2e9476163f8$export$1908877435b1d5e9(tt, $lnl7Y.tt(dictHeytingAlgebra1)),
            ff: new $71f2e2e9476163f8$export$1908877435b1d5e9(ff, $lnl7Y.ff(dictHeytingAlgebra1)),
            implies: function(v) {
                return function(v1) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(implies(v.value0)(v1.value0), implies1(v.value1)(v1.value1));
                };
            },
            conj: function(v) {
                return function(v1) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(conj1(v.value0)(v1.value0), conj2(v.value1)(v1.value1));
                };
            },
            disj: function(v) {
                return function(v1) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(disj(v.value0)(v1.value0), disj1(v.value1)(v1.value1));
                };
            },
            not: function(v) {
                return new $71f2e2e9476163f8$export$1908877435b1d5e9(not(v.value0), not1(v.value1));
            }
        };
    };
};
var $71f2e2e9476163f8$export$8b71b9e63ea20f7b = {
    to: function(x) {
        return new $71f2e2e9476163f8$export$1908877435b1d5e9(x.value0, x.value1);
    },
    from: function(x) {
        return new $cw1rg.Product(x.value0, x.value1);
    }
};
var $71f2e2e9476163f8$export$19ab04734dcb0ff0 = {
    map: function(f) {
        return function(m) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9(m.value0, f(m.value1));
        };
    }
};
var $71f2e2e9476163f8$export$9801206bd382aee0 = {
    imap: /* #__PURE__ */ $5hqdn.imapF($71f2e2e9476163f8$export$19ab04734dcb0ff0)
};
var $71f2e2e9476163f8$export$9e770fa6ce19a9d6 = function(v) {
    return v.value0;
};
var $71f2e2e9476163f8$export$28de2725b8db0d42 = function(dictLazy) {
    var defer = $dTFzl.defer(dictLazy);
    return function(dictLazy1) {
        var defer1 = $dTFzl.defer(dictLazy1);
        return {
            defer: function(f) {
                return new $71f2e2e9476163f8$export$1908877435b1d5e9(defer(function(v) {
                    return $71f2e2e9476163f8$export$9e770fa6ce19a9d6(f($r2HHk.unit));
                }), defer1(function(v) {
                    return $71f2e2e9476163f8$export$6f71268a1666ab58(f($r2HHk.unit));
                }));
            }
        };
    };
};
var $71f2e2e9476163f8$export$1d78bbb1aca8569c = {
    extend: function(f) {
        return function(v) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value0, f(v));
        };
    },
    Functor0: function() {
        return $71f2e2e9476163f8$export$19ab04734dcb0ff0;
    }
};
var $71f2e2e9476163f8$export$d625e8a97ba36bd6 = function(dictEq) {
    var eq = $4MBcA.eq(dictEq);
    return function(dictEq1) {
        var eq1 = $4MBcA.eq(dictEq1);
        return {
            eq: function(x) {
                return function(y) {
                    return eq(x.value0)(y.value0) && eq1(x.value1)(y.value1);
                };
            }
        };
    };
};
var $71f2e2e9476163f8$export$8f11eb03746a66e2 = function(dictOrd) {
    var compare = $d0PPW.compare(dictOrd);
    var eqTuple1 = $71f2e2e9476163f8$export$d625e8a97ba36bd6(dictOrd.Eq0());
    return function(dictOrd1) {
        var compare1 = $d0PPW.compare(dictOrd1);
        var eqTuple2 = eqTuple1(dictOrd1.Eq0());
        return {
            compare: function(x) {
                return function(y) {
                    var v = compare(x.value0)(y.value0);
                    if (v instanceof $6SDUu.LT) return $6SDUu.LT.value;
                    if (v instanceof $6SDUu.GT) return $6SDUu.GT.value;
                    return compare1(x.value1)(y.value1);
                };
            },
            Eq0: function() {
                return eqTuple2;
            }
        };
    };
};
var $71f2e2e9476163f8$export$11462014c11c050e = function(dictEq) {
    var eqTuple1 = $71f2e2e9476163f8$export$d625e8a97ba36bd6(dictEq);
    return {
        eq1: function(dictEq1) {
            return $4MBcA.eq(eqTuple1(dictEq1));
        }
    };
};
var $71f2e2e9476163f8$export$2c05c340f808b07c = function(dictOrd) {
    var ordTuple1 = $71f2e2e9476163f8$export$8f11eb03746a66e2(dictOrd);
    var eq1Tuple1 = $71f2e2e9476163f8$export$11462014c11c050e(dictOrd.Eq0());
    return {
        compare1: function(dictOrd1) {
            return $d0PPW.compare(ordTuple1(dictOrd1));
        },
        Eq10: function() {
            return eq1Tuple1;
        }
    };
};
var $71f2e2e9476163f8$export$c3095a23b368d1f2 = function(f) {
    return function(a) {
        return function(b) {
            return f(new $71f2e2e9476163f8$export$1908877435b1d5e9(a, b));
        };
    };
};
var $71f2e2e9476163f8$export$8e995acc5599767e = {
    extract: $71f2e2e9476163f8$export$6f71268a1666ab58,
    Extend0: function() {
        return $71f2e2e9476163f8$export$1d78bbb1aca8569c;
    }
};
var $71f2e2e9476163f8$export$4b53a8a87c01bf43 = function(dictCommutativeRing) {
    var ringTuple1 = $71f2e2e9476163f8$export$9ba4b2debe474100(dictCommutativeRing.Ring0());
    return function(dictCommutativeRing1) {
        var ringTuple2 = ringTuple1(dictCommutativeRing1.Ring0());
        return {
            Ring0: function() {
                return ringTuple2;
            }
        };
    };
};
var $71f2e2e9476163f8$export$f1ad4da5028a9f5f = function(dictBounded) {
    var top = $95fRU.top(dictBounded);
    var bottom = $95fRU.bottom(dictBounded);
    var ordTuple1 = $71f2e2e9476163f8$export$8f11eb03746a66e2(dictBounded.Ord0());
    return function(dictBounded1) {
        var ordTuple2 = ordTuple1(dictBounded1.Ord0());
        return {
            top: new $71f2e2e9476163f8$export$1908877435b1d5e9(top, $95fRU.top(dictBounded1)),
            bottom: new $71f2e2e9476163f8$export$1908877435b1d5e9(bottom, $95fRU.bottom(dictBounded1)),
            Ord0: function() {
                return ordTuple2;
            }
        };
    };
};
var $71f2e2e9476163f8$export$cc556dd69d46ad4 = function(dictBooleanAlgebra) {
    var heytingAlgebraTuple1 = $71f2e2e9476163f8$export$47e10f15d8f6e8d8(dictBooleanAlgebra.HeytingAlgebra0());
    return function(dictBooleanAlgebra1) {
        var heytingAlgebraTuple2 = heytingAlgebraTuple1(dictBooleanAlgebra1.HeytingAlgebra0());
        return {
            HeytingAlgebra0: function() {
                return heytingAlgebraTuple2;
            }
        };
    };
};
var $71f2e2e9476163f8$export$c87751c00e30fc9e = function(dictSemigroup) {
    var append1 = $iwqgS.append(dictSemigroup);
    return {
        apply: function(v) {
            return function(v1) {
                return new $71f2e2e9476163f8$export$1908877435b1d5e9(append1(v.value0)(v1.value0), v.value1(v1.value1));
            };
        },
        Functor0: function() {
            return $71f2e2e9476163f8$export$19ab04734dcb0ff0;
        }
    };
};
var $71f2e2e9476163f8$export$5266c91ec2409601 = function(dictSemigroup) {
    var append1 = $iwqgS.append(dictSemigroup);
    var applyTuple1 = $71f2e2e9476163f8$export$c87751c00e30fc9e(dictSemigroup);
    return {
        bind: function(v) {
            return function(f) {
                var v1 = f(v.value1);
                return new $71f2e2e9476163f8$export$1908877435b1d5e9(append1(v.value0)(v1.value0), v1.value1);
            };
        },
        Apply0: function() {
            return applyTuple1;
        }
    };
};
var $71f2e2e9476163f8$export$2f2c2cdaef7b685e = function(dictMonoid) {
    var applyTuple1 = $71f2e2e9476163f8$export$c87751c00e30fc9e(dictMonoid.Semigroup0());
    return {
        pure: $71f2e2e9476163f8$export$1908877435b1d5e9.create($aknDF.mempty(dictMonoid)),
        Apply0: function() {
            return applyTuple1;
        }
    };
};
var $71f2e2e9476163f8$export$d5a06b0f6aa5b11a = function(dictMonoid) {
    var applicativeTuple1 = $71f2e2e9476163f8$export$2f2c2cdaef7b685e(dictMonoid);
    var bindTuple1 = $71f2e2e9476163f8$export$5266c91ec2409601(dictMonoid.Semigroup0());
    return {
        Applicative0: function() {
            return applicativeTuple1;
        },
        Bind1: function() {
            return bindTuple1;
        }
    };
};

});
parcelRegister("dTFzl", function(module, exports) {

$parcel$export(module.exports, "defer", () => $a1e0a82f0b162743$export$260e5c0943f31606);
$parcel$export(module.exports, "fix", () => $a1e0a82f0b162743$export$d838837eb5b184e3);
// Generated by purs version 0.15.16
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");
var $a1e0a82f0b162743$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $a1e0a82f0b162743$export$15718d19459d1753 = {
    defer: function(v) {
        return $r2HHk.unit;
    }
};
var $a1e0a82f0b162743$export$5dc1db391e531241 = {
    defer: function(f) {
        return function(x) {
            return f($r2HHk.unit)(x);
        };
    }
};
var $a1e0a82f0b162743$export$260e5c0943f31606 = function(dict) {
    return dict.defer;
};
var $a1e0a82f0b162743$export$d838837eb5b184e3 = function(dictLazy) {
    var defer1 = $a1e0a82f0b162743$export$260e5c0943f31606(dictLazy);
    return function(f) {
        var $lazy_go = $a1e0a82f0b162743$var$$runtime_lazy("go", "Control.Lazy", function() {
            return defer1(function(v) {
                return f($lazy_go(25));
            });
        });
        var go = $lazy_go(25);
        return go;
    };
};

});

parcelRegister("lnl7Y", function(module, exports) {

$parcel$export(module.exports, "tt", () => $f8fc227945eb179e$export$80bf595f9d9a1157);
$parcel$export(module.exports, "not", () => $f8fc227945eb179e$export$6003a5f097c73977);
$parcel$export(module.exports, "implies", () => $f8fc227945eb179e$export$6c53455e54f455ef);
$parcel$export(module.exports, "ff", () => $f8fc227945eb179e$export$f59495b1b7502b33);
$parcel$export(module.exports, "disj", () => $f8fc227945eb179e$export$9bd7ee00e37438db);
$parcel$export(module.exports, "heytingAlgebraBoolean", () => $f8fc227945eb179e$export$d7d9283ee84f4c3f);
$parcel$export(module.exports, "conj", () => $f8fc227945eb179e$export$fb254c661fe9c0db);
$parcel$export(module.exports, "heytingAlgebraFunction", () => $f8fc227945eb179e$export$e9ae480d80dfc592);
// Generated by purs version 0.15.16

var $HPrAU = parcelRequire("HPrAU");

var $2HEu8 = parcelRequire("2HEu8");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");
parcelRequire("2zMBQ");
var $i72yb = parcelRequire("i72yb");

var $h3hu6 = parcelRequire("h3hu6");
var $f8fc227945eb179e$export$4c5e47bb71c07b6a = function(dict) {
    return dict.ttRecord;
};
var $f8fc227945eb179e$export$80bf595f9d9a1157 = function(dict) {
    return dict.tt;
};
var $f8fc227945eb179e$export$242da53d3ad27a73 = function(dict) {
    return dict.notRecord;
};
var $f8fc227945eb179e$export$6003a5f097c73977 = function(dict) {
    return dict.not;
};
var $f8fc227945eb179e$export$30918bdfe7eba090 = function(dict) {
    return dict.impliesRecord;
};
var $f8fc227945eb179e$export$6c53455e54f455ef = function(dict) {
    return dict.implies;
};
var $f8fc227945eb179e$export$960158ea2ad21b8d = {
    ff: $r2HHk.unit,
    tt: $r2HHk.unit,
    implies: function(v) {
        return function(v1) {
            return $r2HHk.unit;
        };
    },
    conj: function(v) {
        return function(v1) {
            return $r2HHk.unit;
        };
    },
    disj: function(v) {
        return function(v1) {
            return $r2HHk.unit;
        };
    },
    not: function(v) {
        return $r2HHk.unit;
    }
};
var $f8fc227945eb179e$export$456c60aba1aeaaa = {
    conjRecord: function(v) {
        return function(v1) {
            return function(v2) {
                return {};
            };
        };
    },
    disjRecord: function(v) {
        return function(v1) {
            return function(v2) {
                return {};
            };
        };
    },
    ffRecord: function(v) {
        return function(v1) {
            return {};
        };
    },
    impliesRecord: function(v) {
        return function(v1) {
            return function(v2) {
                return {};
            };
        };
    },
    notRecord: function(v) {
        return function(v1) {
            return {};
        };
    },
    ttRecord: function(v) {
        return function(v1) {
            return {};
        };
    }
};
var $f8fc227945eb179e$export$7347fefc6a9ef6b6 = /* #__PURE__ */ function() {
    return {
        conj: function(v) {
            return function(v1) {
                return $h3hu6.Proxy.value;
            };
        },
        disj: function(v) {
            return function(v1) {
                return $h3hu6.Proxy.value;
            };
        },
        implies: function(v) {
            return function(v1) {
                return $h3hu6.Proxy.value;
            };
        },
        ff: $h3hu6.Proxy.value,
        not: function(v) {
            return $h3hu6.Proxy.value;
        },
        tt: $h3hu6.Proxy.value
    };
}();
var $f8fc227945eb179e$export$1b03126bff237ceb = function(dict) {
    return dict.ffRecord;
};
var $f8fc227945eb179e$export$f59495b1b7502b33 = function(dict) {
    return dict.ff;
};
var $f8fc227945eb179e$export$84e5fab3d833d7a2 = function(dict) {
    return dict.disjRecord;
};
var $f8fc227945eb179e$export$9bd7ee00e37438db = function(dict) {
    return dict.disj;
};
var $f8fc227945eb179e$export$d7d9283ee84f4c3f = {
    ff: false,
    tt: true,
    implies: function(a) {
        return function(b) {
            return $f8fc227945eb179e$export$9bd7ee00e37438db($f8fc227945eb179e$export$d7d9283ee84f4c3f)($f8fc227945eb179e$export$6003a5f097c73977($f8fc227945eb179e$export$d7d9283ee84f4c3f)(a))(b);
        };
    },
    conj: $HPrAU.boolConj,
    disj: $HPrAU.boolDisj,
    not: $HPrAU.boolNot
};
var $f8fc227945eb179e$export$49ae8d06200d7fce = function(dict) {
    return dict.conjRecord;
};
var $f8fc227945eb179e$export$7f2b975cf624805f = function() {
    return function(dictHeytingAlgebraRecord) {
        return {
            ff: $f8fc227945eb179e$export$1b03126bff237ceb(dictHeytingAlgebraRecord)($h3hu6.Proxy.value)($h3hu6.Proxy.value),
            tt: $f8fc227945eb179e$export$4c5e47bb71c07b6a(dictHeytingAlgebraRecord)($h3hu6.Proxy.value)($h3hu6.Proxy.value),
            conj: $f8fc227945eb179e$export$49ae8d06200d7fce(dictHeytingAlgebraRecord)($h3hu6.Proxy.value),
            disj: $f8fc227945eb179e$export$84e5fab3d833d7a2(dictHeytingAlgebraRecord)($h3hu6.Proxy.value),
            implies: $f8fc227945eb179e$export$30918bdfe7eba090(dictHeytingAlgebraRecord)($h3hu6.Proxy.value),
            not: $f8fc227945eb179e$export$242da53d3ad27a73(dictHeytingAlgebraRecord)($h3hu6.Proxy.value)
        };
    };
};
var $f8fc227945eb179e$export$fb254c661fe9c0db = function(dict) {
    return dict.conj;
};
var $f8fc227945eb179e$export$e9ae480d80dfc592 = function(dictHeytingAlgebra) {
    var ff1 = $f8fc227945eb179e$export$f59495b1b7502b33(dictHeytingAlgebra);
    var tt1 = $f8fc227945eb179e$export$80bf595f9d9a1157(dictHeytingAlgebra);
    var implies1 = $f8fc227945eb179e$export$6c53455e54f455ef(dictHeytingAlgebra);
    var conj1 = $f8fc227945eb179e$export$fb254c661fe9c0db(dictHeytingAlgebra);
    var disj1 = $f8fc227945eb179e$export$9bd7ee00e37438db(dictHeytingAlgebra);
    var not1 = $f8fc227945eb179e$export$6003a5f097c73977(dictHeytingAlgebra);
    return {
        ff: function(v) {
            return ff1;
        },
        tt: function(v) {
            return tt1;
        },
        implies: function(f) {
            return function(g) {
                return function(a) {
                    return implies1(f(a))(g(a));
                };
            };
        },
        conj: function(f) {
            return function(g) {
                return function(a) {
                    return conj1(f(a))(g(a));
                };
            };
        },
        disj: function(f) {
            return function(g) {
                return function(a) {
                    return disj1(f(a))(g(a));
                };
            };
        },
        not: function(f) {
            return function(a) {
                return not1(f(a));
            };
        }
    };
};
var $f8fc227945eb179e$export$8b20a52b1d1213a4 = function(dictIsSymbol) {
    var reflectSymbol = $2HEu8.reflectSymbol(dictIsSymbol);
    return function() {
        return function(dictHeytingAlgebraRecord) {
            var conjRecord1 = $f8fc227945eb179e$export$49ae8d06200d7fce(dictHeytingAlgebraRecord);
            var disjRecord1 = $f8fc227945eb179e$export$84e5fab3d833d7a2(dictHeytingAlgebraRecord);
            var impliesRecord1 = $f8fc227945eb179e$export$30918bdfe7eba090(dictHeytingAlgebraRecord);
            var ffRecord1 = $f8fc227945eb179e$export$1b03126bff237ceb(dictHeytingAlgebraRecord);
            var notRecord1 = $f8fc227945eb179e$export$242da53d3ad27a73(dictHeytingAlgebraRecord);
            var ttRecord1 = $f8fc227945eb179e$export$4c5e47bb71c07b6a(dictHeytingAlgebraRecord);
            return function(dictHeytingAlgebra) {
                var conj1 = $f8fc227945eb179e$export$fb254c661fe9c0db(dictHeytingAlgebra);
                var disj1 = $f8fc227945eb179e$export$9bd7ee00e37438db(dictHeytingAlgebra);
                var implies1 = $f8fc227945eb179e$export$6c53455e54f455ef(dictHeytingAlgebra);
                var ff1 = $f8fc227945eb179e$export$f59495b1b7502b33(dictHeytingAlgebra);
                var not1 = $f8fc227945eb179e$export$6003a5f097c73977(dictHeytingAlgebra);
                var tt1 = $f8fc227945eb179e$export$80bf595f9d9a1157(dictHeytingAlgebra);
                return {
                    conjRecord: function(v) {
                        return function(ra) {
                            return function(rb) {
                                var tail = conjRecord1($h3hu6.Proxy.value)(ra)(rb);
                                var key = reflectSymbol($h3hu6.Proxy.value);
                                var insert = $i72yb.unsafeSet(key);
                                var get = $i72yb.unsafeGet(key);
                                return insert(conj1(get(ra))(get(rb)))(tail);
                            };
                        };
                    },
                    disjRecord: function(v) {
                        return function(ra) {
                            return function(rb) {
                                var tail = disjRecord1($h3hu6.Proxy.value)(ra)(rb);
                                var key = reflectSymbol($h3hu6.Proxy.value);
                                var insert = $i72yb.unsafeSet(key);
                                var get = $i72yb.unsafeGet(key);
                                return insert(disj1(get(ra))(get(rb)))(tail);
                            };
                        };
                    },
                    impliesRecord: function(v) {
                        return function(ra) {
                            return function(rb) {
                                var tail = impliesRecord1($h3hu6.Proxy.value)(ra)(rb);
                                var key = reflectSymbol($h3hu6.Proxy.value);
                                var insert = $i72yb.unsafeSet(key);
                                var get = $i72yb.unsafeGet(key);
                                return insert(implies1(get(ra))(get(rb)))(tail);
                            };
                        };
                    },
                    ffRecord: function(v) {
                        return function(row) {
                            var tail = ffRecord1($h3hu6.Proxy.value)(row);
                            var key = reflectSymbol($h3hu6.Proxy.value);
                            var insert = $i72yb.unsafeSet(key);
                            return insert(ff1)(tail);
                        };
                    },
                    notRecord: function(v) {
                        return function(row) {
                            var tail = notRecord1($h3hu6.Proxy.value)(row);
                            var key = reflectSymbol($h3hu6.Proxy.value);
                            var insert = $i72yb.unsafeSet(key);
                            var get = $i72yb.unsafeGet(key);
                            return insert(not1(get(row)))(tail);
                        };
                    },
                    ttRecord: function(v) {
                        return function(row) {
                            var tail = ttRecord1($h3hu6.Proxy.value)(row);
                            var key = reflectSymbol($h3hu6.Proxy.value);
                            var insert = $i72yb.unsafeSet(key);
                            return insert(tt1)(tail);
                        };
                    }
                };
            };
        };
    };
};

});
parcelRegister("HPrAU", function(module, exports) {

$parcel$export(module.exports, "boolConj", () => $083bebfcbf303ad1$export$e5682d87e23bb875);
$parcel$export(module.exports, "boolDisj", () => $083bebfcbf303ad1$export$4edd36328926db3d);
$parcel$export(module.exports, "boolNot", () => $083bebfcbf303ad1$export$856531720ce57da6);
const $083bebfcbf303ad1$export$e5682d87e23bb875 = function(b1) {
    return function(b2) {
        return b1 && b2;
    };
};
const $083bebfcbf303ad1$export$4edd36328926db3d = function(b1) {
    return function(b2) {
        return b1 || b2;
    };
};
const $083bebfcbf303ad1$export$856531720ce57da6 = function(b) {
    return !b;
};

});




parcelRegister("4PFx6", function(module, exports) {

$parcel$export(module.exports, "lift", () => $384c24655e07f36c$export$590e8b2c435046d9);
// Generated by purs version 0.15.16
var $384c24655e07f36c$export$590e8b2c435046d9 = function(dict) {
    return dict.lift;
};

});

parcelRegister("kQlZ1", function(module, exports) {

$parcel$export(module.exports, "monadEffectEffect", () => $f2c9b767d25cfbb9$export$86a2e24932ca2aa0);
$parcel$export(module.exports, "liftEffect", () => $f2c9b767d25cfbb9$export$34255e15eb56d2b3);
// Generated by purs version 0.15.16

var $7T8P4 = parcelRequire("7T8P4");

var $9hRVP = parcelRequire("9hRVP");
var $f2c9b767d25cfbb9$export$86a2e24932ca2aa0 = {
    liftEffect: /* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn),
    Monad0: function() {
        return $9hRVP.monadEffect;
    }
};
var $f2c9b767d25cfbb9$export$34255e15eb56d2b3 = function(dict) {
    return dict.liftEffect;
};

});


parcelRegister("i2F6a", function(module, exports) {

$parcel$export(module.exports, "ExceptT", () => $d2284b2d3e1b6f87$export$2e7afd25df37516b);
$parcel$export(module.exports, "withExceptT", () => $d2284b2d3e1b6f87$export$998a9a780731dd5b);
$parcel$export(module.exports, "runExceptT", () => $d2284b2d3e1b6f87$export$8291c2122093ac93);
$parcel$export(module.exports, "monadTransExceptT", () => $d2284b2d3e1b6f87$export$fa93accd6d6dc1d2);
$parcel$export(module.exports, "mapExceptT", () => $d2284b2d3e1b6f87$export$34cbd9fbda5c1fb2);
$parcel$export(module.exports, "monadExceptT", () => $d2284b2d3e1b6f87$export$5a198347e9244c74);
$parcel$export(module.exports, "applicativeExceptT", () => $d2284b2d3e1b6f87$export$963960a96c103d2f);
$parcel$export(module.exports, "bindExceptT", () => $d2284b2d3e1b6f87$export$a8cbc0f84e8b069b);
$parcel$export(module.exports, "applyExceptT", () => $d2284b2d3e1b6f87$export$581feac922061bf0);
$parcel$export(module.exports, "monadEffectExceptT", () => $d2284b2d3e1b6f87$export$14ff7e4e497a86b1);
$parcel$export(module.exports, "monadThrowExceptT", () => $d2284b2d3e1b6f87$export$75f89ba5e7a712b0);
// Generated by purs version 0.15.16

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $9Grh5 = parcelRequire("9Grh5");

var $7T8P4 = parcelRequire("7T8P4");

var $ibtPS = parcelRequire("ibtPS");

var $8UXl5 = parcelRequire("8UXl5");

var $84kZf = parcelRequire("84kZf");

var $9ZRMq = parcelRequire("9ZRMq");

var $lowBm = parcelRequire("lowBm");

var $iYXib = parcelRequire("iYXib");

var $kQAxW = parcelRequire("kQAxW");

var $4PFx6 = parcelRequire("4PFx6");

var $3NKEZ = parcelRequire("3NKEZ");

var $aKY4H = parcelRequire("aKY4H");

var $l0wDR = parcelRequire("l0wDR");

var $aknDF = parcelRequire("aknDF");

var $iwqgS = parcelRequire("iwqgS");

var $9MxTl = parcelRequire("9MxTl");

var $kQlZ1 = parcelRequire("kQlZ1");
var $d2284b2d3e1b6f87$var$map = /* #__PURE__ */ $l0wDR.map($aKY4H.functorEither);
var $d2284b2d3e1b6f87$var$identity = /* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn);
var $d2284b2d3e1b6f87$export$2e7afd25df37516b = function(x) {
    return x;
};
var $d2284b2d3e1b6f87$export$998a9a780731dd5b = function(dictFunctor) {
    var map1 = $l0wDR.map(dictFunctor);
    return function(f) {
        return function(v) {
            var mapLeft = function(v1) {
                return function(v2) {
                    if (v2 instanceof $aKY4H.Right) return new $aKY4H.Right(v2.value0);
                    if (v2 instanceof $aKY4H.Left) return new $aKY4H.Left(v1(v2.value0));
                    throw new Error("Failed pattern match at Control.Monad.Except.Trans (line 43, column 3 - line 43, column 32): " + [
                        v1.constructor.name,
                        v2.constructor.name
                    ]);
                };
            };
            return map1(mapLeft(f))(v);
        };
    };
};
var $d2284b2d3e1b6f87$export$8291c2122093ac93 = function(v) {
    return v;
};
var $d2284b2d3e1b6f87$export$779e60e46c1e0f8b = {
    Coercible0: function() {
        return undefined;
    }
};
var $d2284b2d3e1b6f87$export$fa93accd6d6dc1d2 = {
    lift: function(dictMonad) {
        var bind = $9Grh5.bind(dictMonad.Bind1());
        var pure = $gUTA8.pure(dictMonad.Applicative0());
        return function(m) {
            return bind(m)(function(a) {
                return pure(new $aKY4H.Right(a));
            });
        };
    }
};
var $d2284b2d3e1b6f87$var$lift = /* #__PURE__ */ $4PFx6.lift($d2284b2d3e1b6f87$export$fa93accd6d6dc1d2);
var $d2284b2d3e1b6f87$export$34cbd9fbda5c1fb2 = function(f) {
    return function(v) {
        return f(v);
    };
};
var $d2284b2d3e1b6f87$export$d684c62fe584fcfa = function(dictFunctor) {
    var map1 = $l0wDR.map(dictFunctor);
    return {
        map: function(f) {
            return $d2284b2d3e1b6f87$export$34cbd9fbda5c1fb2(map1($d2284b2d3e1b6f87$var$map(f)));
        }
    };
};
var $d2284b2d3e1b6f87$export$67aba9fb222c5e1d = function(dictApplicative) {
    var $191 = $gUTA8.pure(dictApplicative);
    return function($192) {
        return $d2284b2d3e1b6f87$export$2e7afd25df37516b($191($192));
    };
};
var $d2284b2d3e1b6f87$export$5a198347e9244c74 = function(dictMonad) {
    return {
        Applicative0: function() {
            return $d2284b2d3e1b6f87$export$963960a96c103d2f(dictMonad);
        },
        Bind1: function() {
            return $d2284b2d3e1b6f87$export$a8cbc0f84e8b069b(dictMonad);
        }
    };
};
var $d2284b2d3e1b6f87$export$a8cbc0f84e8b069b = function(dictMonad) {
    var bind = $9Grh5.bind(dictMonad.Bind1());
    var pure = $gUTA8.pure(dictMonad.Applicative0());
    return {
        bind: function(v) {
            return function(k) {
                return bind(v)($aKY4H.either(function($193) {
                    return pure($aKY4H.Left.create($193));
                })(function(a) {
                    var v1 = k(a);
                    return v1;
                }));
            };
        },
        Apply0: function() {
            return $d2284b2d3e1b6f87$export$581feac922061bf0(dictMonad);
        }
    };
};
var $d2284b2d3e1b6f87$export$581feac922061bf0 = function(dictMonad) {
    var functorExceptT1 = $d2284b2d3e1b6f87$export$d684c62fe584fcfa(dictMonad.Bind1().Apply0().Functor0());
    return {
        apply: $ibtPS.ap($d2284b2d3e1b6f87$export$5a198347e9244c74(dictMonad)),
        Functor0: function() {
            return functorExceptT1;
        }
    };
};
var $d2284b2d3e1b6f87$export$963960a96c103d2f = function(dictMonad) {
    return {
        pure: function() {
            var $194 = $gUTA8.pure(dictMonad.Applicative0());
            return function($195) {
                return $d2284b2d3e1b6f87$export$2e7afd25df37516b($194($aKY4H.Right.create($195)));
            };
        }(),
        Apply0: function() {
            return $d2284b2d3e1b6f87$export$581feac922061bf0(dictMonad);
        }
    };
};
var $d2284b2d3e1b6f87$export$3539db811b3307bc = function(dictMonad) {
    var lift2 = $a5g3C.lift2($d2284b2d3e1b6f87$export$581feac922061bf0(dictMonad));
    return function(dictSemigroup) {
        return {
            append: lift2($iwqgS.append(dictSemigroup))
        };
    };
};
var $d2284b2d3e1b6f87$export$90c373eb83297b8e = function(dictMonadAsk) {
    var Monad0 = dictMonadAsk.Monad0();
    var monadExceptT1 = $d2284b2d3e1b6f87$export$5a198347e9244c74(Monad0);
    return {
        ask: $d2284b2d3e1b6f87$var$lift(Monad0)($9ZRMq.ask(dictMonadAsk)),
        Monad0: function() {
            return monadExceptT1;
        }
    };
};
var $d2284b2d3e1b6f87$export$fb6edd8453289893 = function(dictMonadReader) {
    var local = $9ZRMq.local(dictMonadReader);
    var monadAskExceptT1 = $d2284b2d3e1b6f87$export$90c373eb83297b8e(dictMonadReader.MonadAsk0());
    return {
        local: function(f) {
            return $d2284b2d3e1b6f87$export$34cbd9fbda5c1fb2(local(f));
        },
        MonadAsk0: function() {
            return monadAskExceptT1;
        }
    };
};
var $d2284b2d3e1b6f87$export$aed911633663c3d8 = function(dictMonadCont) {
    var callCC = $8UXl5.callCC(dictMonadCont);
    var monadExceptT1 = $d2284b2d3e1b6f87$export$5a198347e9244c74(dictMonadCont.Monad0());
    return {
        callCC: function(f) {
            return callCC(function(c) {
                var v = f(function(a) {
                    return c(new $aKY4H.Right(a));
                });
                return v;
            });
        },
        Monad0: function() {
            return monadExceptT1;
        }
    };
};
var $d2284b2d3e1b6f87$export$14ff7e4e497a86b1 = function(dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var monadExceptT1 = $d2284b2d3e1b6f87$export$5a198347e9244c74(Monad0);
    return {
        liftEffect: function() {
            var $196 = $d2284b2d3e1b6f87$var$lift(Monad0);
            var $197 = $kQlZ1.liftEffect(dictMonadEffect);
            return function($198) {
                return $196($197($198));
            };
        }(),
        Monad0: function() {
            return monadExceptT1;
        }
    };
};
var $d2284b2d3e1b6f87$export$fed8f4223a283613 = function(dictMonadRec) {
    var tailRecM = $lowBm.tailRecM(dictMonadRec);
    var Monad0 = dictMonadRec.Monad0();
    var bind = $9Grh5.bind(Monad0.Bind1());
    var pure = $gUTA8.pure(Monad0.Applicative0());
    var monadExceptT1 = $d2284b2d3e1b6f87$export$5a198347e9244c74(Monad0);
    return {
        tailRecM: function(f) {
            var $199 = tailRecM(function(a) {
                var v = f(a);
                return bind(v)(function(m$prime) {
                    return pure(function() {
                        if (m$prime instanceof $aKY4H.Left) return new $lowBm.Done(new $aKY4H.Left(m$prime.value0));
                        if (m$prime instanceof $aKY4H.Right && m$prime.value0 instanceof $lowBm.Loop) return new $lowBm.Loop(m$prime.value0.value0);
                        if (m$prime instanceof $aKY4H.Right && m$prime.value0 instanceof $lowBm.Done) return new $lowBm.Done(new $aKY4H.Right(m$prime.value0.value0));
                        throw new Error("Failed pattern match at Control.Monad.Except.Trans (line 75, column 14 - line 78, column 43): " + [
                            m$prime.constructor.name
                        ]);
                    }());
                });
            });
            return function($200) {
                return $d2284b2d3e1b6f87$export$2e7afd25df37516b($199($200));
            };
        },
        Monad0: function() {
            return monadExceptT1;
        }
    };
};
var $d2284b2d3e1b6f87$export$e8228b6b505171fd = function(dictMonadState) {
    var Monad0 = dictMonadState.Monad0();
    var lift1 = $d2284b2d3e1b6f87$var$lift(Monad0);
    var state = $kQAxW.state(dictMonadState);
    var monadExceptT1 = $d2284b2d3e1b6f87$export$5a198347e9244c74(Monad0);
    return {
        state: function(f) {
            return lift1(state(f));
        },
        Monad0: function() {
            return monadExceptT1;
        }
    };
};
var $d2284b2d3e1b6f87$export$7a7c2ab3eaa0a3e9 = function(dictMonadTell) {
    var Monad1 = dictMonadTell.Monad1();
    var Semigroup0 = dictMonadTell.Semigroup0();
    var monadExceptT1 = $d2284b2d3e1b6f87$export$5a198347e9244c74(Monad1);
    return {
        tell: function() {
            var $201 = $d2284b2d3e1b6f87$var$lift(Monad1);
            var $202 = $3NKEZ.tell(dictMonadTell);
            return function($203) {
                return $201($202($203));
            };
        }(),
        Semigroup0: function() {
            return Semigroup0;
        },
        Monad1: function() {
            return monadExceptT1;
        }
    };
};
var $d2284b2d3e1b6f87$export$a9c9aad9aca5566b = function(dictMonadWriter) {
    var MonadTell1 = dictMonadWriter.MonadTell1();
    var Monad1 = MonadTell1.Monad1();
    var bind = $9Grh5.bind(Monad1.Bind1());
    var listen = $3NKEZ.listen(dictMonadWriter);
    var pure = $gUTA8.pure(Monad1.Applicative0());
    var pass = $3NKEZ.pass(dictMonadWriter);
    var Monoid0 = dictMonadWriter.Monoid0();
    var monadTellExceptT1 = $d2284b2d3e1b6f87$export$7a7c2ab3eaa0a3e9(MonadTell1);
    return {
        listen: $d2284b2d3e1b6f87$export$34cbd9fbda5c1fb2(function(m) {
            return bind(listen(m))(function(v) {
                return pure($d2284b2d3e1b6f87$var$map(function(r) {
                    return new $9MxTl.Tuple(r, v.value1);
                })(v.value0));
            });
        }),
        pass: $d2284b2d3e1b6f87$export$34cbd9fbda5c1fb2(function(m) {
            return pass(bind(m)(function(a) {
                return pure(function() {
                    if (a instanceof $aKY4H.Left) return new $9MxTl.Tuple(new $aKY4H.Left(a.value0), $d2284b2d3e1b6f87$var$identity);
                    if (a instanceof $aKY4H.Right) return new $9MxTl.Tuple(new $aKY4H.Right(a.value0.value0), a.value0.value1);
                    throw new Error("Failed pattern match at Control.Monad.Except.Trans (line 135, column 10 - line 137, column 45): " + [
                        a.constructor.name
                    ]);
                }());
            }));
        }),
        Monoid0: function() {
            return Monoid0;
        },
        MonadTell1: function() {
            return monadTellExceptT1;
        }
    };
};
var $d2284b2d3e1b6f87$export$75f89ba5e7a712b0 = function(dictMonad) {
    var monadExceptT1 = $d2284b2d3e1b6f87$export$5a198347e9244c74(dictMonad);
    return {
        throwError: function() {
            var $204 = $gUTA8.pure(dictMonad.Applicative0());
            return function($205) {
                return $d2284b2d3e1b6f87$export$2e7afd25df37516b($204($aKY4H.Left.create($205)));
            };
        }(),
        Monad0: function() {
            return monadExceptT1;
        }
    };
};
var $d2284b2d3e1b6f87$export$78c1353d784c47dd = function(dictMonad) {
    var bind = $9Grh5.bind(dictMonad.Bind1());
    var pure = $gUTA8.pure(dictMonad.Applicative0());
    var monadThrowExceptT1 = $d2284b2d3e1b6f87$export$75f89ba5e7a712b0(dictMonad);
    return {
        catchError: function(v) {
            return function(k) {
                return bind(v)($aKY4H.either(function(a) {
                    var v1 = k(a);
                    return v1;
                })(function($206) {
                    return pure($aKY4H.Right.create($206));
                }));
            };
        },
        MonadThrow0: function() {
            return monadThrowExceptT1;
        }
    };
};
var $d2284b2d3e1b6f87$export$5b1239aace2566fd = function(dictMonadST) {
    var Monad0 = dictMonadST.Monad0();
    var monadExceptT1 = $d2284b2d3e1b6f87$export$5a198347e9244c74(Monad0);
    return {
        liftST: function() {
            var $207 = $d2284b2d3e1b6f87$var$lift(Monad0);
            var $208 = $iYXib.liftST(dictMonadST);
            return function($209) {
                return $207($208($209));
            };
        }(),
        Monad0: function() {
            return monadExceptT1;
        }
    };
};
var $d2284b2d3e1b6f87$export$9a16ccee20eb55ce = function(dictMonad) {
    var pure = $gUTA8.pure($d2284b2d3e1b6f87$export$963960a96c103d2f(dictMonad));
    var semigroupExceptT1 = $d2284b2d3e1b6f87$export$3539db811b3307bc(dictMonad);
    return function(dictMonoid) {
        var semigroupExceptT2 = semigroupExceptT1(dictMonoid.Semigroup0());
        return {
            mempty: pure($aknDF.mempty(dictMonoid)),
            Semigroup0: function() {
                return semigroupExceptT2;
            }
        };
    };
};
var $d2284b2d3e1b6f87$export$4cca4d0f6dfbd781 = function(dictSemigroup) {
    var append = $iwqgS.append(dictSemigroup);
    return function(dictMonad) {
        var Bind1 = dictMonad.Bind1();
        var bind = $9Grh5.bind(Bind1);
        var pure = $gUTA8.pure(dictMonad.Applicative0());
        var functorExceptT1 = $d2284b2d3e1b6f87$export$d684c62fe584fcfa(Bind1.Apply0().Functor0());
        return {
            alt: function(v) {
                return function(v1) {
                    return bind(v)(function(rm) {
                        if (rm instanceof $aKY4H.Right) return pure(new $aKY4H.Right(rm.value0));
                        if (rm instanceof $aKY4H.Left) return bind(v1)(function(rn) {
                            if (rn instanceof $aKY4H.Right) return pure(new $aKY4H.Right(rn.value0));
                            if (rn instanceof $aKY4H.Left) return pure(new $aKY4H.Left(append(rm.value0)(rn.value0)));
                            throw new Error("Failed pattern match at Control.Monad.Except.Trans (line 87, column 9 - line 89, column 49): " + [
                                rn.constructor.name
                            ]);
                        });
                        throw new Error("Failed pattern match at Control.Monad.Except.Trans (line 83, column 5 - line 89, column 49): " + [
                            rm.constructor.name
                        ]);
                    });
                };
            },
            Functor0: function() {
                return functorExceptT1;
            }
        };
    };
};
var $d2284b2d3e1b6f87$export$c5d1f65b4da4d62f = function(dictMonoid) {
    var mempty = $aknDF.mempty(dictMonoid);
    var altExceptT1 = $d2284b2d3e1b6f87$export$4cca4d0f6dfbd781(dictMonoid.Semigroup0());
    return function(dictMonad) {
        var altExceptT2 = altExceptT1(dictMonad);
        return {
            empty: $84kZf.throwError($d2284b2d3e1b6f87$export$75f89ba5e7a712b0(dictMonad))(mempty),
            Alt0: function() {
                return altExceptT2;
            }
        };
    };
};
var $d2284b2d3e1b6f87$export$bfd291e36e6170e5 = function(dictMonoid) {
    var plusExceptT1 = $d2284b2d3e1b6f87$export$c5d1f65b4da4d62f(dictMonoid);
    return function(dictMonad) {
        var applicativeExceptT1 = $d2284b2d3e1b6f87$export$963960a96c103d2f(dictMonad);
        var plusExceptT2 = plusExceptT1(dictMonad);
        return {
            Applicative0: function() {
                return applicativeExceptT1;
            },
            Plus1: function() {
                return plusExceptT2;
            }
        };
    };
};
var $d2284b2d3e1b6f87$export$2b1e74d8588fcb7c = function(dictMonoid) {
    var alternativeExceptT1 = $d2284b2d3e1b6f87$export$bfd291e36e6170e5(dictMonoid);
    return function(dictMonad) {
        var monadExceptT1 = $d2284b2d3e1b6f87$export$5a198347e9244c74(dictMonad);
        var alternativeExceptT2 = alternativeExceptT1(dictMonad);
        return {
            Monad0: function() {
                return monadExceptT1;
            },
            Alternative1: function() {
                return alternativeExceptT2;
            }
        };
    };
};

});
parcelRegister("84kZf", function(module, exports) {

$parcel$export(module.exports, "throwError", () => $5dfefa023749ded0$export$8bf7aba4a9e09055);
$parcel$export(module.exports, "monadThrowEither", () => $5dfefa023749ded0$export$390154ec55cffb04);
$parcel$export(module.exports, "catchError", () => $5dfefa023749ded0$export$3dede90624df3ba9);
$parcel$export(module.exports, "try", () => $5dfefa023749ded0$export$410a452afcd48948);
// Generated by purs version 0.15.16

var $gUTA8 = parcelRequire("gUTA8");

var $9Grh5 = parcelRequire("9Grh5");

var $aKY4H = parcelRequire("aKY4H");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");

var $ykHdR = parcelRequire("ykHdR");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");

var $9hRVP = parcelRequire("9hRVP");
parcelRequire("6ITWO");
var $eROd4 = parcelRequire("eROd4");
var $5dfefa023749ded0$var$discard = /* #__PURE__ */ $9Grh5.discard($9Grh5.discardUnit);
var $5dfefa023749ded0$export$8bf7aba4a9e09055 = function(dict) {
    return dict.throwError;
};
var $5dfefa023749ded0$export$fff877a725e9aba1 = /* #__PURE__ */ function() {
    return {
        throwError: $l4M7e.const($ykHdR.Nothing.value),
        Monad0: function() {
            return $ykHdR.monadMaybe;
        }
    };
}();
var $5dfefa023749ded0$export$390154ec55cffb04 = /* #__PURE__ */ function() {
    return {
        throwError: $aKY4H.Left.create,
        Monad0: function() {
            return $aKY4H.monadEither;
        }
    };
}();
var $5dfefa023749ded0$export$e4992fc673e7b027 = {
    throwError: $eROd4.throwException,
    Monad0: function() {
        return $9hRVP.monadEffect;
    }
};
var $5dfefa023749ded0$export$438e6a8af9a8a22d = {
    catchError: function(v) {
        return function(v1) {
            if (v instanceof $ykHdR.Nothing) return v1($r2HHk.unit);
            if (v instanceof $ykHdR.Just) return new $ykHdR.Just(v.value0);
            throw new Error("Failed pattern match at Control.Monad.Error.Class (line 79, column 1 - line 81, column 33): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    MonadThrow0: function() {
        return $5dfefa023749ded0$export$fff877a725e9aba1;
    }
};
var $5dfefa023749ded0$export$abb16404f142771a = {
    catchError: function(v) {
        return function(v1) {
            if (v instanceof $aKY4H.Left) return v1(v.value0);
            if (v instanceof $aKY4H.Right) return new $aKY4H.Right(v.value0);
            throw new Error("Failed pattern match at Control.Monad.Error.Class (line 72, column 1 - line 74, column 35): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    MonadThrow0: function() {
        return $5dfefa023749ded0$export$390154ec55cffb04;
    }
};
var $5dfefa023749ded0$export$434b8bb3cd954f77 = {
    catchError: /* #__PURE__ */ $l4M7e.flip($eROd4.catchException),
    MonadThrow0: function() {
        return $5dfefa023749ded0$export$e4992fc673e7b027;
    }
};
var $5dfefa023749ded0$export$1cf01ae67112be7b = function(dictMonadThrow) {
    var throwError1 = $5dfefa023749ded0$export$8bf7aba4a9e09055(dictMonadThrow);
    var pure = $gUTA8.pure(dictMonadThrow.Monad0().Applicative0());
    return function(error) {
        return $ykHdR.maybe(throwError1(error))(pure);
    };
};
var $5dfefa023749ded0$export$bd6bd7bb5418f998 = function(dictMonadThrow) {
    return $aKY4H.either($5dfefa023749ded0$export$8bf7aba4a9e09055(dictMonadThrow))($gUTA8.pure(dictMonadThrow.Monad0().Applicative0()));
};
var $5dfefa023749ded0$export$3dede90624df3ba9 = function(dict) {
    return dict.catchError;
};
var $5dfefa023749ded0$export$b726b0cdf642257a = function(dictMonadError) {
    var throwError1 = $5dfefa023749ded0$export$8bf7aba4a9e09055(dictMonadError.MonadThrow0());
    var catchError1 = $5dfefa023749ded0$export$3dede90624df3ba9(dictMonadError);
    return function(p) {
        return function(act) {
            return function(handler) {
                var handle = function(e) {
                    var v = p(e);
                    if (v instanceof $ykHdR.Nothing) return throwError1(e);
                    if (v instanceof $ykHdR.Just) return handler(v.value0);
                    throw new Error("Failed pattern match at Control.Monad.Error.Class (line 57, column 5 - line 59, column 26): " + [
                        v.constructor.name
                    ]);
                };
                return catchError1(act)(handle);
            };
        };
    };
};
var $5dfefa023749ded0$export$410a452afcd48948 = function(dictMonadError) {
    var catchError1 = $5dfefa023749ded0$export$3dede90624df3ba9(dictMonadError);
    var Monad0 = dictMonadError.MonadThrow0().Monad0();
    var map = $l0wDR.map(Monad0.Bind1().Apply0().Functor0());
    var pure = $gUTA8.pure(Monad0.Applicative0());
    return function(a) {
        return catchError1(map($aKY4H.Right.create)(a))(function($52) {
            return pure($aKY4H.Left.create($52));
        });
    };
};
var $5dfefa023749ded0$export$8f240c41514f3a3e = function(dictMonadError) {
    var MonadThrow0 = dictMonadError.MonadThrow0();
    var Monad0 = MonadThrow0.Monad0();
    var Bind1 = Monad0.Bind1();
    var bind = $9Grh5.bind(Bind1);
    var try1 = $5dfefa023749ded0$export$410a452afcd48948(dictMonadError);
    var discard1 = $5dfefa023749ded0$var$discard(Bind1);
    var throwError1 = $5dfefa023749ded0$export$8bf7aba4a9e09055(MonadThrow0);
    var pure = $gUTA8.pure(Monad0.Applicative0());
    return function(acquire) {
        return function(release) {
            return function(kleisli) {
                return bind(acquire)(function(resource) {
                    return bind(try1(kleisli(resource)))(function(result) {
                        return discard1(release(resource))(function() {
                            return $aKY4H.either(throwError1)(pure)(result);
                        });
                    });
                });
            };
        };
    };
};

});
parcelRegister("6ITWO", function(module, exports) {

$parcel$export(module.exports, "throw", () => $4e52402d7134c8bb$export$7b1a37e4f0fe815);
$parcel$export(module.exports, "catchException", () => (parcelRequire("eROd4")).catchException);
$parcel$export(module.exports, "error", () => (parcelRequire("eROd4")).error);
$parcel$export(module.exports, "throwException", () => (parcelRequire("eROd4")).throwException);
// Generated by purs version 0.15.16

var $eROd4 = parcelRequire("eROd4");

var $gUTA8 = parcelRequire("gUTA8");

var $aKY4H = parcelRequire("aKY4H");

var $l0wDR = parcelRequire("l0wDR");

var $ykHdR = parcelRequire("ykHdR");

var $9hRVP = parcelRequire("9hRVP");
var $4e52402d7134c8bb$var$pure = /* #__PURE__ */ $gUTA8.pure($9hRVP.applicativeEffect);
var $4e52402d7134c8bb$var$map = /* #__PURE__ */ $l0wDR.map($9hRVP.functorEffect);
var $4e52402d7134c8bb$export$410a452afcd48948 = function(action) {
    return $eROd4.catchException(function($3) {
        return $4e52402d7134c8bb$var$pure($aKY4H.Left.create($3));
    })($4e52402d7134c8bb$var$map($aKY4H.Right.create)(action));
};
var $4e52402d7134c8bb$export$7b1a37e4f0fe815 = function($4) {
    return $eROd4.throwException($eROd4.error($4));
};
var $4e52402d7134c8bb$export$a57ab32f40f83ea9 = /* #__PURE__ */ function() {
    return $eROd4.stackImpl($ykHdR.Just.create)($ykHdR.Nothing.value);
}();
var $4e52402d7134c8bb$export$3879b24e8245693d = {
    show: $eROd4.showErrorImpl
};

});
parcelRegister("eROd4", function(module, exports) {

$parcel$export(module.exports, "showErrorImpl", () => $ad2cf6904bca3ba1$export$e49cfe3e3ab3c67c);
$parcel$export(module.exports, "error", () => $ad2cf6904bca3ba1$export$a3bc9b8ed74fc);
$parcel$export(module.exports, "stackImpl", () => $ad2cf6904bca3ba1$export$c159e25936a96837);
$parcel$export(module.exports, "throwException", () => $ad2cf6904bca3ba1$export$de0c4a986b439e52);
$parcel$export(module.exports, "catchException", () => $ad2cf6904bca3ba1$export$d49c1c6bf2cedce5);
function $ad2cf6904bca3ba1$export$e49cfe3e3ab3c67c(err) {
    return err.stack || err.toString();
}
function $ad2cf6904bca3ba1$export$a3bc9b8ed74fc(msg) {
    return new Error(msg);
}
function $ad2cf6904bca3ba1$export$d010f7d0d0793465(msg) {
    return function(cause) {
        return new Error(msg, {
            cause: cause
        });
    };
}
function $ad2cf6904bca3ba1$export$afd88dc4d34c0903(msg) {
    return function(name) {
        const e = new Error(msg);
        e.name = name;
        return e;
    };
}
function $ad2cf6904bca3ba1$export$a8ecead220dd38a6(e) {
    return e.message;
}
function $ad2cf6904bca3ba1$export$a8ff84c12d48cfa6(e) {
    return e.name || "Error";
}
function $ad2cf6904bca3ba1$export$c159e25936a96837(just) {
    return function(nothing) {
        return function(e) {
            return e.stack ? just(e.stack) : nothing;
        };
    };
}
function $ad2cf6904bca3ba1$export$de0c4a986b439e52(e) {
    return function() {
        throw e;
    };
}
function $ad2cf6904bca3ba1$export$d49c1c6bf2cedce5(c) {
    return function(t) {
        return function() {
            try {
                return t();
            } catch (e) {
                if (e instanceof Error || Object.prototype.toString.call(e) === "[object Error]") return c(e)();
                else return c(new Error(e.toString()))();
            }
        };
    };
}

});



parcelRegister("3NKEZ", function(module, exports) {

$parcel$export(module.exports, "tell", () => $2c4a247071255d7e$export$de3113ed932c61ab);
$parcel$export(module.exports, "pass", () => $2c4a247071255d7e$export$167b0ad523238611);
$parcel$export(module.exports, "listen", () => $2c4a247071255d7e$export$63174c828edd6ff8);
// Generated by purs version 0.15.16

var $gUTA8 = parcelRequire("gUTA8");

var $9Grh5 = parcelRequire("9Grh5");

var $9MxTl = parcelRequire("9MxTl");
var $2c4a247071255d7e$export$de3113ed932c61ab = function(dict) {
    return dict.tell;
};
var $2c4a247071255d7e$export$167b0ad523238611 = function(dict) {
    return dict.pass;
};
var $2c4a247071255d7e$export$63174c828edd6ff8 = function(dict) {
    return dict.listen;
};
var $2c4a247071255d7e$export$e63807bfd37abcc0 = function(dictMonadWriter) {
    var Monad1 = dictMonadWriter.MonadTell1().Monad1();
    var bind = $9Grh5.bind(Monad1.Bind1());
    var listen1 = $2c4a247071255d7e$export$63174c828edd6ff8(dictMonadWriter);
    var pure = $gUTA8.pure(Monad1.Applicative0());
    return function(f) {
        return function(m) {
            return bind(listen1(m))(function(v) {
                return pure(new $9MxTl.Tuple(v.value0, f(v.value1)));
            });
        };
    };
};
var $2c4a247071255d7e$export$b0a417369eddf9f2 = function(dictMonadWriter) {
    var pass1 = $2c4a247071255d7e$export$167b0ad523238611(dictMonadWriter);
    var Monad1 = dictMonadWriter.MonadTell1().Monad1();
    var bind = $9Grh5.bind(Monad1.Bind1());
    var pure = $gUTA8.pure(Monad1.Applicative0());
    return function(f) {
        return function(m) {
            return pass1(bind(m)(function(a) {
                return pure(new $9MxTl.Tuple(a, f));
            }));
        };
    };
};

});


parcelRegister("i7s3U", function(module, exports) {

$parcel$export(module.exports, "monadTransListT", () => $d30ea600cb89759b$export$619131e858bec5bb);
$parcel$export(module.exports, "monadListT", () => $d30ea600cb89759b$export$204d5ba0706a4088);
$parcel$export(module.exports, "monadEffectListT", () => $d30ea600cb89759b$export$f00d8368ae31463f);
// Generated by purs version 0.15.16

var $gUTA8 = parcelRequire("gUTA8");

var $9Grh5 = parcelRequire("9Grh5");

var $7T8P4 = parcelRequire("7T8P4");

var $ibtPS = parcelRequire("ibtPS");

var $lowBm = parcelRequire("lowBm");

var $iYXib = parcelRequire("iYXib");

var $4PFx6 = parcelRequire("4PFx6");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");

var $9VGs1 = parcelRequire("9VGs1");
var $dc43y = parcelRequire("dc43y");

var $ykHdR = parcelRequire("ykHdR");

var $iwqgS = parcelRequire("iwqgS");

var $9MxTl = parcelRequire("9MxTl");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");

var $kQlZ1 = parcelRequire("kQlZ1");
var $d30ea600cb89759b$var$map = /* #__PURE__ */ $l0wDR.map($ykHdR.functorMaybe);
var $d30ea600cb89759b$var$map1 = /* #__PURE__ */ $l0wDR.map($9VGs1.functorLazy);
var $d30ea600cb89759b$var$identity = /* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn);
var $d30ea600cb89759b$var$pure = /* #__PURE__ */ $gUTA8.pure($9VGs1.applicativeLazy);
var $d30ea600cb89759b$export$1bffd077443cd981 = /* #__PURE__ */ function() {
    function Yield(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Yield.create = function(value0) {
        return function(value1) {
            return new Yield(value0, value1);
        };
    };
    return Yield;
}();
var $d30ea600cb89759b$export$38d24f5c1eb0e4c0 = /* #__PURE__ */ function() {
    function Skip(value0) {
        this.value0 = value0;
    }
    Skip.create = function(value0) {
        return new Skip(value0);
    };
    return Skip;
}();
var $d30ea600cb89759b$export$7fe28cb29e71bf10 = /* #__PURE__ */ function() {
    function Done() {}
    Done.value = new Done();
    return Done;
}();
var $d30ea600cb89759b$export$4ae3cbbaa857dd72 = function(x) {
    return x;
};
var $d30ea600cb89759b$export$72a5dac3748973f0 = function(dictApplicative) {
    var pure1 = $gUTA8.pure(dictApplicative);
    return function(v) {
        return pure1(new $d30ea600cb89759b$export$38d24f5c1eb0e4c0(v));
    };
};
var $d30ea600cb89759b$export$860beaf0e87f1a9f = function(dictFunctor) {
    var map2 = $l0wDR.map(dictFunctor);
    return function(v) {
        return map2(function($338) {
            return $d30ea600cb89759b$export$38d24f5c1eb0e4c0.create($dc43y.defer($l4M7e.const($338)));
        })(v);
    };
};
var $d30ea600cb89759b$export$c48e357c1a89b78d = function(dictMonad) {
    var map2 = $l0wDR.map(dictMonad.Bind1().Apply0().Functor0());
    return function(f) {
        return function(z) {
            var g = function(v) {
                if (v instanceof $ykHdR.Just) return new $d30ea600cb89759b$export$1bffd077443cd981(v.value0.value1, $dc43y.defer(function(v1) {
                    return $d30ea600cb89759b$export$c48e357c1a89b78d(dictMonad)(f)(v.value0.value0);
                }));
                if (v instanceof $ykHdR.Nothing) return $d30ea600cb89759b$export$7fe28cb29e71bf10.value;
                throw new Error("Failed pattern match at Control.Monad.List.Trans (line 130, column 3 - line 130, column 60): " + [
                    v.constructor.name
                ]);
            };
            return map2(g)(f(z));
        };
    };
};
var $d30ea600cb89759b$export$b446f6baa3bb1430 = function(dictMonad) {
    var pure1 = $gUTA8.pure(dictMonad.Applicative0());
    var bind = $9Grh5.bind(dictMonad.Bind1());
    return function(v) {
        var g = function(v1) {
            if (v1 instanceof $d30ea600cb89759b$export$1bffd077443cd981) return pure1(new $ykHdR.Just(new $9MxTl.Tuple(v1.value0, $dc43y.force(v1.value1))));
            if (v1 instanceof $d30ea600cb89759b$export$38d24f5c1eb0e4c0) return $d30ea600cb89759b$export$b446f6baa3bb1430(dictMonad)($dc43y.force(v1.value0));
            if (v1 instanceof $d30ea600cb89759b$export$7fe28cb29e71bf10) return pure1($ykHdR.Nothing.value);
            throw new Error("Failed pattern match at Control.Monad.List.Trans (line 195, column 3 - line 195, column 50): " + [
                v1.constructor.name
            ]);
        };
        return bind(v)(g);
    };
};
var $d30ea600cb89759b$export$c01875f616615628 = function(dictMonad) {
    var map2 = $l0wDR.map(dictMonad.Bind1().Apply0().Functor0());
    var uncons1 = $d30ea600cb89759b$export$b446f6baa3bb1430(dictMonad);
    return function(l) {
        return map2($d30ea600cb89759b$var$map($9MxTl.snd))(uncons1(l));
    };
};
var $d30ea600cb89759b$var$stepMap = function(dictFunctor) {
    var map2 = $l0wDR.map(dictFunctor);
    return function(f) {
        return function(v) {
            return map2(f)(v);
        };
    };
};
var $d30ea600cb89759b$export$9384c7afe4015e42 = function(dictApplicative) {
    var stepMap1 = $d30ea600cb89759b$var$stepMap(dictApplicative.Apply0().Functor0());
    return function(f) {
        var g = function(v) {
            if (v instanceof $d30ea600cb89759b$export$1bffd077443cd981) {
                var $255 = f(v.value0);
                if ($255) return new $d30ea600cb89759b$export$1bffd077443cd981(v.value0, $d30ea600cb89759b$var$map1($d30ea600cb89759b$export$9384c7afe4015e42(dictApplicative)(f))(v.value1));
                return $d30ea600cb89759b$export$7fe28cb29e71bf10.value;
            }
            if (v instanceof $d30ea600cb89759b$export$38d24f5c1eb0e4c0) return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0($d30ea600cb89759b$var$map1($d30ea600cb89759b$export$9384c7afe4015e42(dictApplicative)(f))(v.value0));
            if (v instanceof $d30ea600cb89759b$export$7fe28cb29e71bf10) return $d30ea600cb89759b$export$7fe28cb29e71bf10.value;
            throw new Error("Failed pattern match at Control.Monad.List.Trans (line 154, column 3 - line 154, column 68): " + [
                v.constructor.name
            ]);
        };
        return stepMap1(g);
    };
};
var $d30ea600cb89759b$export$65f513eaf3c582b8 = function(dictMonad) {
    var map2 = $l0wDR.map(dictMonad.Bind1().Apply0().Functor0());
    var unfold1 = $d30ea600cb89759b$export$c48e357c1a89b78d(dictMonad);
    return function(f) {
        return function(b) {
            return function(l) {
                var g = function(v) {
                    var h = function(v1) {
                        if (v1 instanceof $d30ea600cb89759b$export$1bffd077443cd981) {
                            var b$prime$prime = f(v.value0)(v1.value0);
                            return new $ykHdR.Just(new $9MxTl.Tuple(new $9MxTl.Tuple(b$prime$prime, $dc43y.force(v1.value1)), v.value0));
                        }
                        if (v1 instanceof $d30ea600cb89759b$export$38d24f5c1eb0e4c0) return new $ykHdR.Just(new $9MxTl.Tuple(new $9MxTl.Tuple(v.value0, $dc43y.force(v1.value0)), v.value0));
                        if (v1 instanceof $d30ea600cb89759b$export$7fe28cb29e71bf10) return $ykHdR.Nothing.value;
                        throw new Error("Failed pattern match at Control.Monad.List.Trans (line 248, column 5 - line 248, column 78): " + [
                            v1.constructor.name
                        ]);
                    };
                    return map2(h)(v.value1);
                };
                return unfold1(g)(new $9MxTl.Tuple(b, l));
            };
        };
    };
};
var $d30ea600cb89759b$export$3466dae21163a3ee = function(dictApplicative) {
    var pure1 = $gUTA8.pure(dictApplicative);
    return function(h) {
        return function(t) {
            return pure1(new $d30ea600cb89759b$export$1bffd077443cd981(h, t));
        };
    };
};
var $d30ea600cb89759b$export$68159836694e22c1 = function(dictApplicative) {
    var prepend$prime1 = $d30ea600cb89759b$export$3466dae21163a3ee(dictApplicative);
    return function(h) {
        return function(t) {
            return prepend$prime1(h)($dc43y.defer($l4M7e.const(t)));
        };
    };
};
var $d30ea600cb89759b$export$f2c4f74e8fe88e34 = function(dictApplicative) {
    return $gUTA8.pure(dictApplicative)($d30ea600cb89759b$export$7fe28cb29e71bf10.value);
};
var $d30ea600cb89759b$export$439306a4dcaafbb9 = function(dictApplicative) {
    var prepend1 = $d30ea600cb89759b$export$68159836694e22c1(dictApplicative);
    var nil1 = $d30ea600cb89759b$export$f2c4f74e8fe88e34(dictApplicative);
    return function(a) {
        return prepend1(a)(nil1);
    };
};
var $d30ea600cb89759b$export$b7df5d561049483a = function(dictApplicative) {
    var nil1 = $d30ea600cb89759b$export$f2c4f74e8fe88e34(dictApplicative);
    var stepMap1 = $d30ea600cb89759b$var$stepMap(dictApplicative.Apply0().Functor0());
    return function(v) {
        return function(v1) {
            if (v === 0) return nil1;
            var f = function(v2) {
                if (v2 instanceof $d30ea600cb89759b$export$1bffd077443cd981) return new $d30ea600cb89759b$export$1bffd077443cd981(v2.value0, $d30ea600cb89759b$var$map1($d30ea600cb89759b$export$b7df5d561049483a(dictApplicative)(v - 1 | 0))(v2.value1));
                if (v2 instanceof $d30ea600cb89759b$export$38d24f5c1eb0e4c0) return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0($d30ea600cb89759b$var$map1($d30ea600cb89759b$export$b7df5d561049483a(dictApplicative)(v))(v2.value0));
                if (v2 instanceof $d30ea600cb89759b$export$7fe28cb29e71bf10) return $d30ea600cb89759b$export$7fe28cb29e71bf10.value;
                throw new Error("Failed pattern match at Control.Monad.List.Trans (line 147, column 3 - line 147, column 47): " + [
                    v2.constructor.name
                ]);
            };
            return stepMap1(f)(v1);
        };
    };
};
var $d30ea600cb89759b$export$e3b52f6f0a4bd72e = function(dictMonad) {
    var Applicative0 = dictMonad.Applicative0();
    var pure1 = $gUTA8.pure(Applicative0);
    var nil1 = $d30ea600cb89759b$export$f2c4f74e8fe88e34(Applicative0);
    var Bind1 = dictMonad.Bind1();
    var Functor0 = Bind1.Apply0().Functor0();
    var map2 = $l0wDR.map(Functor0);
    var prepend$prime1 = $d30ea600cb89759b$export$3466dae21163a3ee(Applicative0);
    var wrapEffect1 = $d30ea600cb89759b$export$860beaf0e87f1a9f(Functor0);
    var bind = $9Grh5.bind(Bind1);
    var uncons1 = $d30ea600cb89759b$export$b446f6baa3bb1430(dictMonad);
    return function(f) {
        var g = function(v) {
            return function(v1) {
                if (v1 instanceof $ykHdR.Nothing) return pure1(nil1);
                if (v instanceof $ykHdR.Nothing) return pure1(nil1);
                if (v instanceof $ykHdR.Just && v1 instanceof $ykHdR.Just) return map2($l4M7e.flip(prepend$prime1)($dc43y.defer(function(v2) {
                    return $d30ea600cb89759b$export$e3b52f6f0a4bd72e(dictMonad)(f)(v.value0.value1)(v1.value0.value1);
                })))(f(v.value0.value0)(v1.value0.value0));
                throw new Error("Failed pattern match at Control.Monad.List.Trans (line 260, column 3 - line 260, column 25): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
        var loop = function(fa) {
            return function(fb) {
                return wrapEffect1(bind(uncons1(fa))(function(ua) {
                    return bind(uncons1(fb))(function(ub) {
                        return g(ua)(ub);
                    });
                }));
            };
        };
        return loop;
    };
};
var $d30ea600cb89759b$export$b634740ce272acb5 = function(dictMonad) {
    var pure1 = $gUTA8.pure(dictMonad.Applicative0());
    var zipWith$prime1 = $d30ea600cb89759b$export$e3b52f6f0a4bd72e(dictMonad);
    return function(f) {
        var g = function(a) {
            return function(b) {
                return pure1(f(a)(b));
            };
        };
        return zipWith$prime1(g);
    };
};
var $d30ea600cb89759b$export$acf0795b499e2d1a = {
    Coercible0: function() {
        return undefined;
    }
};
var $d30ea600cb89759b$export$e70771d2e7e590a = function(dictFunctor) {
    var stepMap1 = $d30ea600cb89759b$var$stepMap(dictFunctor);
    return function(f) {
        var g = function(v) {
            if (v instanceof $d30ea600cb89759b$export$1bffd077443cd981) return $ykHdR.fromMaybe($d30ea600cb89759b$export$38d24f5c1eb0e4c0.create)($d30ea600cb89759b$var$map($d30ea600cb89759b$export$1bffd077443cd981.create)(f(v.value0)))($d30ea600cb89759b$var$map1($d30ea600cb89759b$export$e70771d2e7e590a(dictFunctor)(f))(v.value1));
            if (v instanceof $d30ea600cb89759b$export$38d24f5c1eb0e4c0) return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0($d30ea600cb89759b$var$map1($d30ea600cb89759b$export$e70771d2e7e590a(dictFunctor)(f))(v.value0));
            if (v instanceof $d30ea600cb89759b$export$7fe28cb29e71bf10) return $d30ea600cb89759b$export$7fe28cb29e71bf10.value;
            throw new Error("Failed pattern match at Control.Monad.List.Trans (line 183, column 3 - line 183, column 72): " + [
                v.constructor.name
            ]);
        };
        return stepMap1(g);
    };
};
var $d30ea600cb89759b$export$c1a059043cc9c119 = function(dictMonad) {
    var pure1 = $gUTA8.pure(dictMonad.Applicative0());
    var unfold1 = $d30ea600cb89759b$export$c48e357c1a89b78d(dictMonad);
    return function(f) {
        return function(a) {
            var g = function(x) {
                return pure1(new $ykHdR.Just(new $9MxTl.Tuple(f(x), x)));
            };
            return unfold1(g)(a);
        };
    };
};
var $d30ea600cb89759b$export$76d90c956114f2c2 = function(dictMonad) {
    return $d30ea600cb89759b$export$c1a059043cc9c119(dictMonad)($d30ea600cb89759b$var$identity);
};
var $d30ea600cb89759b$export$5fd5031fecdacec3 = function(dictMonad) {
    var map2 = $l0wDR.map(dictMonad.Bind1().Apply0().Functor0());
    var uncons1 = $d30ea600cb89759b$export$b446f6baa3bb1430(dictMonad);
    return function(l) {
        return map2($d30ea600cb89759b$var$map($9MxTl.fst))(uncons1(l));
    };
};
var $d30ea600cb89759b$export$5af6b427ff316359 = function(dictFunctor) {
    var stepMap1 = $d30ea600cb89759b$var$stepMap(dictFunctor);
    return {
        map: function(f) {
            var g = function(v) {
                if (v instanceof $d30ea600cb89759b$export$1bffd077443cd981) return new $d30ea600cb89759b$export$1bffd077443cd981(f(v.value0), $d30ea600cb89759b$var$map1($l0wDR.map($d30ea600cb89759b$export$5af6b427ff316359(dictFunctor))(f))(v.value1));
                if (v instanceof $d30ea600cb89759b$export$38d24f5c1eb0e4c0) return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0($d30ea600cb89759b$var$map1($l0wDR.map($d30ea600cb89759b$export$5af6b427ff316359(dictFunctor))(f))(v.value0));
                if (v instanceof $d30ea600cb89759b$export$7fe28cb29e71bf10) return $d30ea600cb89759b$export$7fe28cb29e71bf10.value;
                throw new Error("Failed pattern match at Control.Monad.List.Trans (line 280, column 5 - line 280, column 48): " + [
                    v.constructor.name
                ]);
            };
            return stepMap1(g);
        }
    };
};
var $d30ea600cb89759b$export$df62323340295157 = function(dictApplicative) {
    var map2 = $l0wDR.map(dictApplicative.Apply0().Functor0());
    var nil1 = $d30ea600cb89759b$export$f2c4f74e8fe88e34(dictApplicative);
    return function(fa) {
        return map2($l4M7e.flip($d30ea600cb89759b$export$1bffd077443cd981.create)($dc43y.defer(function(v) {
            return nil1;
        })))(fa);
    };
};
var $d30ea600cb89759b$export$619131e858bec5bb = {
    lift: function(dictMonad) {
        return $d30ea600cb89759b$export$df62323340295157(dictMonad.Applicative0());
    }
};
var $d30ea600cb89759b$var$lift = /* #__PURE__ */ $4PFx6.lift($d30ea600cb89759b$export$619131e858bec5bb);
var $d30ea600cb89759b$export$5f62080e6ea5ad16 = function(dictMonadRec) {
    var Monad0 = dictMonadRec.Monad0();
    var pure1 = $gUTA8.pure(Monad0.Applicative0());
    var bind = $9Grh5.bind(Monad0.Bind1());
    var uncons1 = $d30ea600cb89759b$export$b446f6baa3bb1430(Monad0);
    var tailRecM2 = $lowBm.tailRecM2(dictMonadRec);
    return function(f) {
        var loop = function(b) {
            return function(l) {
                var g = function(v) {
                    if (v instanceof $ykHdR.Nothing) return pure1(new $lowBm.Done(b));
                    if (v instanceof $ykHdR.Just) return bind(f(b)(v.value0.value0))(function(b$prime) {
                        return pure1(new $lowBm.Loop({
                            a: b$prime,
                            b: v.value0.value1
                        }));
                    });
                    throw new Error("Failed pattern match at Control.Monad.List.Trans (line 221, column 5 - line 221, column 45): " + [
                        v.constructor.name
                    ]);
                };
                return bind(uncons1(l))(g);
            };
        };
        return tailRecM2(loop);
    };
};
var $d30ea600cb89759b$export$3120598051129cb3 = function(dictMonadRec) {
    var pure1 = $gUTA8.pure(dictMonadRec.Monad0().Applicative0());
    return $d30ea600cb89759b$export$5f62080e6ea5ad16(dictMonadRec)(function(v) {
        return function(v1) {
            return pure1($r2HHk.unit);
        };
    })($r2HHk.unit);
};
var $d30ea600cb89759b$export$48b115eebb7f3c53 = function(dictMonadRec) {
    var Monad0 = dictMonadRec.Monad0();
    var pure1 = $gUTA8.pure(Monad0.Applicative0());
    var bind = $9Grh5.bind(Monad0.Bind1());
    var uncons1 = $d30ea600cb89759b$export$b446f6baa3bb1430(Monad0);
    var tailRecM2 = $lowBm.tailRecM2(dictMonadRec);
    return function(f) {
        var loop = function(b) {
            return function(l) {
                var g = function(v) {
                    if (v instanceof $ykHdR.Nothing) return pure1(new $lowBm.Done(b));
                    if (v instanceof $ykHdR.Just) return pure1(new $lowBm.Loop({
                        a: f(b)(v.value0.value0),
                        b: v.value0.value1
                    }));
                    throw new Error("Failed pattern match at Control.Monad.List.Trans (line 239, column 7 - line 239, column 47): " + [
                        v.constructor.name
                    ]);
                };
                return bind(uncons1(l))(g);
            };
        };
        return tailRecM2(loop);
    };
};
var $d30ea600cb89759b$export$fa87a49fad651048 = function(dictMonad) {
    var pure1 = $gUTA8.pure(dictMonad.Applicative0());
    var bind = $9Grh5.bind(dictMonad.Bind1());
    var uncons1 = $d30ea600cb89759b$export$b446f6baa3bb1430(dictMonad);
    return function(f) {
        var loop = function(b) {
            return function(l) {
                var g = function(v) {
                    if (v instanceof $ykHdR.Nothing) return pure1(b);
                    if (v instanceof $ykHdR.Just) return bind(f(b)(v.value0.value0))($l4M7e.flip(loop)(v.value0.value1));
                    throw new Error("Failed pattern match at Control.Monad.List.Trans (line 212, column 5 - line 212, column 35): " + [
                        v.constructor.name
                    ]);
                };
                return bind(uncons1(l))(g);
            };
        };
        return loop;
    };
};
var $d30ea600cb89759b$export$99ac321f734efd9b = function(dictMonad) {
    var pure1 = $gUTA8.pure(dictMonad.Applicative0());
    return $d30ea600cb89759b$export$fa87a49fad651048(dictMonad)(function(v) {
        return function(v1) {
            return pure1($r2HHk.unit);
        };
    })($r2HHk.unit);
};
var $d30ea600cb89759b$export$50ae948ca12cdcbc = function(dictMonad) {
    var pure1 = $gUTA8.pure(dictMonad.Applicative0());
    var bind = $9Grh5.bind(dictMonad.Bind1());
    var uncons1 = $d30ea600cb89759b$export$b446f6baa3bb1430(dictMonad);
    return function(f) {
        var loop = function(b) {
            return function(l) {
                var g = function(v) {
                    if (v instanceof $ykHdR.Nothing) return pure1(b);
                    if (v instanceof $ykHdR.Just) return loop(f(b)(v.value0.value0))(v.value0.value1);
                    throw new Error("Failed pattern match at Control.Monad.List.Trans (line 229, column 5 - line 229, column 35): " + [
                        v.constructor.name
                    ]);
                };
                return bind(uncons1(l))(g);
            };
        };
        return loop;
    };
};
var $d30ea600cb89759b$export$3dea766d36a8935f = function(dictFunctor) {
    var stepMap1 = $d30ea600cb89759b$var$stepMap(dictFunctor);
    return function(f) {
        var g = function(v) {
            if (v instanceof $d30ea600cb89759b$export$1bffd077443cd981) {
                var s$prime = $d30ea600cb89759b$var$map1($d30ea600cb89759b$export$3dea766d36a8935f(dictFunctor)(f))(v.value1);
                var $305 = f(v.value0);
                if ($305) return new $d30ea600cb89759b$export$1bffd077443cd981(v.value0, s$prime);
                return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0(s$prime);
            }
            if (v instanceof $d30ea600cb89759b$export$38d24f5c1eb0e4c0) {
                var s$prime = $d30ea600cb89759b$var$map1($d30ea600cb89759b$export$3dea766d36a8935f(dictFunctor)(f))(v.value0);
                return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0(s$prime);
            }
            if (v instanceof $d30ea600cb89759b$export$7fe28cb29e71bf10) return $d30ea600cb89759b$export$7fe28cb29e71bf10.value;
            throw new Error("Failed pattern match at Control.Monad.List.Trans (line 176, column 3 - line 176, column 80): " + [
                v.constructor.name
            ]);
        };
        return stepMap1(g);
    };
};
var $d30ea600cb89759b$export$533af5c8cd6afa16 = function(dictApplicative) {
    var stepMap1 = $d30ea600cb89759b$var$stepMap(dictApplicative.Apply0().Functor0());
    return function(f) {
        var g = function(v) {
            if (v instanceof $d30ea600cb89759b$export$1bffd077443cd981) {
                var $310 = f(v.value0);
                if ($310) return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0($d30ea600cb89759b$var$map1($d30ea600cb89759b$export$533af5c8cd6afa16(dictApplicative)(f))(v.value1));
                return new $d30ea600cb89759b$export$1bffd077443cd981(v.value0, v.value1);
            }
            if (v instanceof $d30ea600cb89759b$export$38d24f5c1eb0e4c0) return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0($d30ea600cb89759b$var$map1($d30ea600cb89759b$export$533af5c8cd6afa16(dictApplicative)(f))(v.value0));
            if (v instanceof $d30ea600cb89759b$export$7fe28cb29e71bf10) return $d30ea600cb89759b$export$7fe28cb29e71bf10.value;
            throw new Error("Failed pattern match at Control.Monad.List.Trans (line 169, column 3 - line 169, column 70): " + [
                v.constructor.name
            ]);
        };
        return stepMap1(g);
    };
};
var $d30ea600cb89759b$export$663103110d94aac9 = function(dictApplicative) {
    var stepMap1 = $d30ea600cb89759b$var$stepMap(dictApplicative.Apply0().Functor0());
    return function(v) {
        return function(v1) {
            if (v === 0) return v1;
            var f = function(v2) {
                if (v2 instanceof $d30ea600cb89759b$export$1bffd077443cd981) return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0($d30ea600cb89759b$var$map1($d30ea600cb89759b$export$663103110d94aac9(dictApplicative)(v - 1 | 0))(v2.value1));
                if (v2 instanceof $d30ea600cb89759b$export$38d24f5c1eb0e4c0) return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0($d30ea600cb89759b$var$map1($d30ea600cb89759b$export$663103110d94aac9(dictApplicative)(v))(v2.value0));
                if (v2 instanceof $d30ea600cb89759b$export$7fe28cb29e71bf10) return $d30ea600cb89759b$export$7fe28cb29e71bf10.value;
                throw new Error("Failed pattern match at Control.Monad.List.Trans (line 162, column 3 - line 162, column 44): " + [
                    v2.constructor.name
                ]);
            };
            return stepMap1(f)(v1);
        };
    };
};
var $d30ea600cb89759b$export$8327ebbef2a0ba76 = function(dictApplicative) {
    var pure1 = $gUTA8.pure(dictApplicative);
    return function(lh) {
        return function(t) {
            return pure1(new $d30ea600cb89759b$export$1bffd077443cd981($dc43y.force(lh), t));
        };
    };
};
var $d30ea600cb89759b$export$e5d91f6921d97963 = function(dictMonad) {
    var Applicative0 = dictMonad.Applicative0();
    var singleton1 = $d30ea600cb89759b$export$439306a4dcaafbb9(Applicative0);
    var cons1 = $d30ea600cb89759b$export$8327ebbef2a0ba76(Applicative0);
    return {
        unfoldr1: function(f) {
            return function(b) {
                var go = function(v) {
                    if (v.value1 instanceof $ykHdR.Nothing) return singleton1(v.value0);
                    if (v.value1 instanceof $ykHdR.Just) return cons1($d30ea600cb89759b$var$pure(v.value0))($dc43y.defer(function(v1) {
                        return go(f(v.value1.value0));
                    }));
                    throw new Error("Failed pattern match at Control.Monad.List.Trans (line 294, column 12 - line 296, column 67): " + [
                        v.constructor.name
                    ]);
                };
                return go(f(b));
            };
        }
    };
};
var $d30ea600cb89759b$export$bbfbcefbf94b996f = function(dictMonad) {
    var Applicative0 = dictMonad.Applicative0();
    var nil1 = $d30ea600cb89759b$export$f2c4f74e8fe88e34(Applicative0);
    var cons1 = $d30ea600cb89759b$export$8327ebbef2a0ba76(Applicative0);
    var unfoldable1ListT1 = $d30ea600cb89759b$export$e5d91f6921d97963(dictMonad);
    return {
        unfoldr: function(f) {
            return function(b) {
                var go = function(v) {
                    if (v instanceof $ykHdR.Nothing) return nil1;
                    if (v instanceof $ykHdR.Just) return cons1($d30ea600cb89759b$var$pure(v.value0.value0))($dc43y.defer(function(v1) {
                        return go(f(v.value0.value1));
                    }));
                    throw new Error("Failed pattern match at Control.Monad.List.Trans (line 287, column 12 - line 289, column 67): " + [
                        v.constructor.name
                    ]);
                };
                return go(f(b));
            };
        },
        Unfoldable10: function() {
            return unfoldable1ListT1;
        }
    };
};
var $d30ea600cb89759b$export$e65aba2be8e37f8a = function(dictApplicative) {
    return {
        append: $d30ea600cb89759b$var$concat(dictApplicative)
    };
};
var $d30ea600cb89759b$var$concat = function(dictApplicative) {
    var stepMap1 = $d30ea600cb89759b$var$stepMap(dictApplicative.Apply0().Functor0());
    return function(x) {
        return function(y) {
            var f = function(v) {
                if (v instanceof $d30ea600cb89759b$export$1bffd077443cd981) return new $d30ea600cb89759b$export$1bffd077443cd981(v.value0, $d30ea600cb89759b$var$map1(function(v1) {
                    return $iwqgS.append($d30ea600cb89759b$export$e65aba2be8e37f8a(dictApplicative))(v1)(y);
                })(v.value1));
                if (v instanceof $d30ea600cb89759b$export$38d24f5c1eb0e4c0) return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0($d30ea600cb89759b$var$map1(function(v1) {
                    return $iwqgS.append($d30ea600cb89759b$export$e65aba2be8e37f8a(dictApplicative))(v1)(y);
                })(v.value0));
                if (v instanceof $d30ea600cb89759b$export$7fe28cb29e71bf10) return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0($dc43y.defer($l4M7e.const(y)));
                throw new Error("Failed pattern match at Control.Monad.List.Trans (line 106, column 3 - line 106, column 43): " + [
                    v.constructor.name
                ]);
            };
            return stepMap1(f)(x);
        };
    };
};
var $d30ea600cb89759b$export$6b8d2264760710b = function(dictApplicative) {
    var semigroupListT1 = $d30ea600cb89759b$export$e65aba2be8e37f8a(dictApplicative);
    return {
        mempty: $d30ea600cb89759b$export$f2c4f74e8fe88e34(dictApplicative),
        Semigroup0: function() {
            return semigroupListT1;
        }
    };
};
var $d30ea600cb89759b$export$986c2bbe7a34be0b = function(dictFunctor) {
    return $d30ea600cb89759b$export$e70771d2e7e590a(dictFunctor)($d30ea600cb89759b$var$identity);
};
var $d30ea600cb89759b$export$204d5ba0706a4088 = function(dictMonad) {
    return {
        Applicative0: function() {
            return $d30ea600cb89759b$export$cf70c952df59e46e(dictMonad);
        },
        Bind1: function() {
            return $d30ea600cb89759b$export$871b02513702e0(dictMonad);
        }
    };
};
var $d30ea600cb89759b$export$871b02513702e0 = function(dictMonad) {
    var append = $iwqgS.append($d30ea600cb89759b$export$e65aba2be8e37f8a(dictMonad.Applicative0()));
    var stepMap1 = $d30ea600cb89759b$var$stepMap(dictMonad.Bind1().Apply0().Functor0());
    return {
        bind: function(fa) {
            return function(f) {
                var g = function(v) {
                    if (v instanceof $d30ea600cb89759b$export$1bffd077443cd981) {
                        var h = function(s$prime) {
                            return append(f(v.value0))($9Grh5.bind($d30ea600cb89759b$export$871b02513702e0(dictMonad))(s$prime)(f));
                        };
                        return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0($d30ea600cb89759b$var$map1(h)(v.value1));
                    }
                    if (v instanceof $d30ea600cb89759b$export$38d24f5c1eb0e4c0) return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0($d30ea600cb89759b$var$map1(function(v1) {
                        return $9Grh5.bind($d30ea600cb89759b$export$871b02513702e0(dictMonad))(v1)(f);
                    })(v.value0));
                    if (v instanceof $d30ea600cb89759b$export$7fe28cb29e71bf10) return $d30ea600cb89759b$export$7fe28cb29e71bf10.value;
                    throw new Error("Failed pattern match at Control.Monad.List.Trans (line 306, column 5 - line 308, column 31): " + [
                        v.constructor.name
                    ]);
                };
                return stepMap1(g)(fa);
            };
        },
        Apply0: function() {
            return $d30ea600cb89759b$export$fd7d3bacedac3347(dictMonad);
        }
    };
};
var $d30ea600cb89759b$export$fd7d3bacedac3347 = function(dictMonad) {
    var functorListT1 = $d30ea600cb89759b$export$5af6b427ff316359(dictMonad.Bind1().Apply0().Functor0());
    return {
        apply: $ibtPS.ap($d30ea600cb89759b$export$204d5ba0706a4088(dictMonad)),
        Functor0: function() {
            return functorListT1;
        }
    };
};
var $d30ea600cb89759b$export$cf70c952df59e46e = function(dictMonad) {
    return {
        pure: $d30ea600cb89759b$export$439306a4dcaafbb9(dictMonad.Applicative0()),
        Apply0: function() {
            return $d30ea600cb89759b$export$fd7d3bacedac3347(dictMonad);
        }
    };
};
var $d30ea600cb89759b$export$f00d8368ae31463f = function(dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var monadListT1 = $d30ea600cb89759b$export$204d5ba0706a4088(Monad0);
    return {
        liftEffect: function() {
            var $339 = $d30ea600cb89759b$var$lift(Monad0);
            var $340 = $kQlZ1.liftEffect(dictMonadEffect);
            return function($341) {
                return $339($340($341));
            };
        }(),
        Monad0: function() {
            return monadListT1;
        }
    };
};
var $d30ea600cb89759b$export$24d9325f26d68bae = function(dictMonadST) {
    var Monad0 = dictMonadST.Monad0();
    var monadListT1 = $d30ea600cb89759b$export$204d5ba0706a4088(Monad0);
    return {
        liftST: function() {
            var $342 = $d30ea600cb89759b$var$lift(Monad0);
            var $343 = $iYXib.liftST(dictMonadST);
            return function($344) {
                return $342($343($344));
            };
        }(),
        Monad0: function() {
            return monadListT1;
        }
    };
};
var $d30ea600cb89759b$export$bf13ffdc6b7113ca = function(dictApplicative) {
    var functorListT1 = $d30ea600cb89759b$export$5af6b427ff316359(dictApplicative.Apply0().Functor0());
    return {
        alt: $d30ea600cb89759b$var$concat(dictApplicative),
        Functor0: function() {
            return functorListT1;
        }
    };
};
var $d30ea600cb89759b$export$82f742a0347e990a = function(dictMonad) {
    var Applicative0 = dictMonad.Applicative0();
    var altListT1 = $d30ea600cb89759b$export$bf13ffdc6b7113ca(Applicative0);
    return {
        empty: $d30ea600cb89759b$export$f2c4f74e8fe88e34(Applicative0),
        Alt0: function() {
            return altListT1;
        }
    };
};
var $d30ea600cb89759b$export$183e8a1c18c60fd3 = function(dictMonad) {
    var applicativeListT1 = $d30ea600cb89759b$export$cf70c952df59e46e(dictMonad);
    var plusListT1 = $d30ea600cb89759b$export$82f742a0347e990a(dictMonad);
    return {
        Applicative0: function() {
            return applicativeListT1;
        },
        Plus1: function() {
            return plusListT1;
        }
    };
};
var $d30ea600cb89759b$export$bb0af79e56ac53fe = function(dictMonad) {
    var monadListT1 = $d30ea600cb89759b$export$204d5ba0706a4088(dictMonad);
    var alternativeListT1 = $d30ea600cb89759b$export$183e8a1c18c60fd3(dictMonad);
    return {
        Monad0: function() {
            return monadListT1;
        },
        Alternative1: function() {
            return alternativeListT1;
        }
    };
};

});
parcelRegister("9VGs1", function(module, exports) {

$parcel$export(module.exports, "showLazy", () => $73aa5dd1904ebcb7$export$bb0ce398898c1c48);
$parcel$export(module.exports, "functorLazy", () => $73aa5dd1904ebcb7$export$3780b8670d5f24f8);
$parcel$export(module.exports, "eqLazy", () => $73aa5dd1904ebcb7$export$1c9d1a32b20e91d5);
$parcel$export(module.exports, "ordLazy", () => $73aa5dd1904ebcb7$export$cbabaf21b7e8b5db);
$parcel$export(module.exports, "eq1Lazy", () => $73aa5dd1904ebcb7$export$4fb3dc255b34fa12);
$parcel$export(module.exports, "ord1Lazy", () => $73aa5dd1904ebcb7$export$d65b504a31b57308);
$parcel$export(module.exports, "applyLazy", () => $73aa5dd1904ebcb7$export$c3ec2aebe6109e81);
$parcel$export(module.exports, "applicativeLazy", () => $73aa5dd1904ebcb7$export$28587442a46d4141);
$parcel$export(module.exports, "defer", () => (parcelRequire("dc43y")).defer);
$parcel$export(module.exports, "force", () => (parcelRequire("dc43y")).force);
// Generated by purs version 0.15.16

var $dc43y = parcelRequire("dc43y");

var $a5g3C = parcelRequire("a5g3C");

var $95fRU = parcelRequire("95fRU");

var $4MBcA = parcelRequire("4MBcA");

var $fb7aO = parcelRequire("fb7aO");

var $6RkEA = parcelRequire("6RkEA");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");

var $5hqdn = parcelRequire("5hqdn");

var $lnl7Y = parcelRequire("lnl7Y");

var $aknDF = parcelRequire("aknDF");

var $d0PPW = parcelRequire("d0PPW");

var $hTcAb = parcelRequire("hTcAb");

var $iwqgS = parcelRequire("iwqgS");

var $gyPYh = parcelRequire("gyPYh");

var $3Orkn = parcelRequire("3Orkn");

var $1wR1l = parcelRequire("1wR1l");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");
var $73aa5dd1904ebcb7$export$bb0ce398898c1c48 = function(dictShow) {
    var show = $3Orkn.show(dictShow);
    return {
        show: function(x) {
            return "(defer \\_ -> " + (show($dc43y.force(x)) + ")");
        }
    };
};
var $73aa5dd1904ebcb7$export$a23c81c7931f53a = function(dictSemiring) {
    var add = $gyPYh.add(dictSemiring);
    var zero = $gyPYh.zero(dictSemiring);
    var mul = $gyPYh.mul(dictSemiring);
    var one = $gyPYh.one(dictSemiring);
    return {
        add: function(a) {
            return function(b) {
                return $dc43y.defer(function(v) {
                    return add($dc43y.force(a))($dc43y.force(b));
                });
            };
        },
        zero: $dc43y.defer(function(v) {
            return zero;
        }),
        mul: function(a) {
            return function(b) {
                return $dc43y.defer(function(v) {
                    return mul($dc43y.force(a))($dc43y.force(b));
                });
            };
        },
        one: $dc43y.defer(function(v) {
            return one;
        })
    };
};
var $73aa5dd1904ebcb7$export$8400f884b0cf16b1 = function(dictSemigroup) {
    var append1 = $iwqgS.append(dictSemigroup);
    return {
        append: function(a) {
            return function(b) {
                return $dc43y.defer(function(v) {
                    return append1($dc43y.force(a))($dc43y.force(b));
                });
            };
        }
    };
};
var $73aa5dd1904ebcb7$export$6dfc43186b725e5c = function(dictRing) {
    var sub = $hTcAb.sub(dictRing);
    var semiringLazy1 = $73aa5dd1904ebcb7$export$a23c81c7931f53a(dictRing.Semiring0());
    return {
        sub: function(a) {
            return function(b) {
                return $dc43y.defer(function(v) {
                    return sub($dc43y.force(a))($dc43y.force(b));
                });
            };
        },
        Semiring0: function() {
            return semiringLazy1;
        }
    };
};
var $73aa5dd1904ebcb7$export$fe3e07ed2de45f8f = function(dictMonoid) {
    var mempty = $aknDF.mempty(dictMonoid);
    var semigroupLazy1 = $73aa5dd1904ebcb7$export$8400f884b0cf16b1(dictMonoid.Semigroup0());
    return {
        mempty: $dc43y.defer(function(v) {
            return mempty;
        }),
        Semigroup0: function() {
            return semigroupLazy1;
        }
    };
};
var $73aa5dd1904ebcb7$export$56fd27feb83d90f5 = {
    defer: function(f) {
        return $dc43y.defer(function(v) {
            return $dc43y.force(f($r2HHk.unit));
        });
    }
};
var $73aa5dd1904ebcb7$export$3780b8670d5f24f8 = {
    map: function(f) {
        return function(l) {
            return $dc43y.defer(function(v) {
                return f($dc43y.force(l));
            });
        };
    }
};
var $73aa5dd1904ebcb7$var$map = /* #__PURE__ */ $l0wDR.map($73aa5dd1904ebcb7$export$3780b8670d5f24f8);
var $73aa5dd1904ebcb7$export$8f588843775274ce = {
    mapWithIndex: function(f) {
        return $73aa5dd1904ebcb7$var$map(f($r2HHk.unit));
    },
    Functor0: function() {
        return $73aa5dd1904ebcb7$export$3780b8670d5f24f8;
    }
};
var $73aa5dd1904ebcb7$export$3bd0a60cfec06f1a = {
    imap: /* #__PURE__ */ $5hqdn.imapF($73aa5dd1904ebcb7$export$3780b8670d5f24f8)
};
var $73aa5dd1904ebcb7$export$6ad686e404b9cd02 = {
    foldr: function(f) {
        return function(z) {
            return function(l) {
                return f($dc43y.force(l))(z);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(l) {
                return f(z)($dc43y.force(l));
            };
        };
    },
    foldMap: function(dictMonoid) {
        return function(f) {
            return function(l) {
                return f($dc43y.force(l));
            };
        };
    }
};
var $73aa5dd1904ebcb7$var$foldr = /* #__PURE__ */ $6RkEA.foldr($73aa5dd1904ebcb7$export$6ad686e404b9cd02);
var $73aa5dd1904ebcb7$var$foldl = /* #__PURE__ */ $6RkEA.foldl($73aa5dd1904ebcb7$export$6ad686e404b9cd02);
var $73aa5dd1904ebcb7$var$foldMap = /* #__PURE__ */ $6RkEA.foldMap($73aa5dd1904ebcb7$export$6ad686e404b9cd02);
var $73aa5dd1904ebcb7$export$c99a011ac0d986c7 = {
    foldrWithIndex: function(f) {
        return $73aa5dd1904ebcb7$var$foldr(f($r2HHk.unit));
    },
    foldlWithIndex: function(f) {
        return $73aa5dd1904ebcb7$var$foldl(f($r2HHk.unit));
    },
    foldMapWithIndex: function(dictMonoid) {
        var foldMap1 = $73aa5dd1904ebcb7$var$foldMap(dictMonoid);
        return function(f) {
            return foldMap1(f($r2HHk.unit));
        };
    },
    Foldable0: function() {
        return $73aa5dd1904ebcb7$export$6ad686e404b9cd02;
    }
};
var $73aa5dd1904ebcb7$export$d75b77350c4c9111 = {
    traverse: function(dictApplicative) {
        var map1 = $l0wDR.map(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(l) {
                return map1(function($103) {
                    return $dc43y.defer($l4M7e.const($103));
                })(f($dc43y.force(l)));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map1 = $l0wDR.map(dictApplicative.Apply0().Functor0());
        return function(l) {
            return map1(function($104) {
                return $dc43y.defer($l4M7e.const($104));
            })($dc43y.force(l));
        };
    },
    Functor0: function() {
        return $73aa5dd1904ebcb7$export$3780b8670d5f24f8;
    },
    Foldable1: function() {
        return $73aa5dd1904ebcb7$export$6ad686e404b9cd02;
    }
};
var $73aa5dd1904ebcb7$var$traverse = /* #__PURE__ */ $1wR1l.traverse($73aa5dd1904ebcb7$export$d75b77350c4c9111);
var $73aa5dd1904ebcb7$export$1c9f73288a97bff6 = {
    traverseWithIndex: function(dictApplicative) {
        var traverse1 = $73aa5dd1904ebcb7$var$traverse(dictApplicative);
        return function(f) {
            return traverse1(f($r2HHk.unit));
        };
    },
    FunctorWithIndex0: function() {
        return $73aa5dd1904ebcb7$export$8f588843775274ce;
    },
    FoldableWithIndex1: function() {
        return $73aa5dd1904ebcb7$export$c99a011ac0d986c7;
    },
    Traversable2: function() {
        return $73aa5dd1904ebcb7$export$d75b77350c4c9111;
    }
};
var $73aa5dd1904ebcb7$export$8d84e581926eaeba = {
    foldMap1: function(dictSemigroup) {
        return function(f) {
            return function(l) {
                return f($dc43y.force(l));
            };
        };
    },
    foldr1: function(v) {
        return function(l) {
            return $dc43y.force(l);
        };
    },
    foldl1: function(v) {
        return function(l) {
            return $dc43y.force(l);
        };
    },
    Foldable0: function() {
        return $73aa5dd1904ebcb7$export$6ad686e404b9cd02;
    }
};
var $73aa5dd1904ebcb7$export$316fa2792966d831 = {
    traverse1: function(dictApply) {
        var map1 = $l0wDR.map(dictApply.Functor0());
        return function(f) {
            return function(l) {
                return map1(function($105) {
                    return $dc43y.defer($l4M7e.const($105));
                })(f($dc43y.force(l)));
            };
        };
    },
    sequence1: function(dictApply) {
        var map1 = $l0wDR.map(dictApply.Functor0());
        return function(l) {
            return map1(function($106) {
                return $dc43y.defer($l4M7e.const($106));
            })($dc43y.force(l));
        };
    },
    Foldable10: function() {
        return $73aa5dd1904ebcb7$export$8d84e581926eaeba;
    },
    Traversable1: function() {
        return $73aa5dd1904ebcb7$export$d75b77350c4c9111;
    }
};
var $73aa5dd1904ebcb7$export$5db1a0137683eb80 = {
    extend: function(f) {
        return function(x) {
            return $dc43y.defer(function(v) {
                return f(x);
            });
        };
    },
    Functor0: function() {
        return $73aa5dd1904ebcb7$export$3780b8670d5f24f8;
    }
};
var $73aa5dd1904ebcb7$export$1c9d1a32b20e91d5 = function(dictEq) {
    var eq = $4MBcA.eq(dictEq);
    return {
        eq: function(x) {
            return function(y) {
                return eq($dc43y.force(x))($dc43y.force(y));
            };
        }
    };
};
var $73aa5dd1904ebcb7$export$cbabaf21b7e8b5db = function(dictOrd) {
    var compare = $d0PPW.compare(dictOrd);
    var eqLazy1 = $73aa5dd1904ebcb7$export$1c9d1a32b20e91d5(dictOrd.Eq0());
    return {
        compare: function(x) {
            return function(y) {
                return compare($dc43y.force(x))($dc43y.force(y));
            };
        },
        Eq0: function() {
            return eqLazy1;
        }
    };
};
var $73aa5dd1904ebcb7$export$4fb3dc255b34fa12 = {
    eq1: function(dictEq) {
        return $4MBcA.eq($73aa5dd1904ebcb7$export$1c9d1a32b20e91d5(dictEq));
    }
};
var $73aa5dd1904ebcb7$export$d65b504a31b57308 = {
    compare1: function(dictOrd) {
        return $d0PPW.compare($73aa5dd1904ebcb7$export$cbabaf21b7e8b5db(dictOrd));
    },
    Eq10: function() {
        return $73aa5dd1904ebcb7$export$4fb3dc255b34fa12;
    }
};
var $73aa5dd1904ebcb7$export$544fccaec3eca1d4 = {
    extract: $dc43y.force,
    Extend0: function() {
        return $73aa5dd1904ebcb7$export$5db1a0137683eb80;
    }
};
var $73aa5dd1904ebcb7$export$b0aa908a8262dbd4 = function(dictCommutativeRing) {
    var ringLazy1 = $73aa5dd1904ebcb7$export$6dfc43186b725e5c(dictCommutativeRing.Ring0());
    return {
        Ring0: function() {
            return ringLazy1;
        }
    };
};
var $73aa5dd1904ebcb7$export$d150da49d30e2076 = function(dictEuclideanRing) {
    var div = $fb7aO.div(dictEuclideanRing);
    var mod = $fb7aO.mod(dictEuclideanRing);
    var commutativeRingLazy1 = $73aa5dd1904ebcb7$export$b0aa908a8262dbd4(dictEuclideanRing.CommutativeRing0());
    return {
        degree: function() {
            var $107 = $fb7aO.degree(dictEuclideanRing);
            return function($108) {
                return $107($dc43y.force($108));
            };
        }(),
        div: function(a) {
            return function(b) {
                return $dc43y.defer(function(v) {
                    return div($dc43y.force(a))($dc43y.force(b));
                });
            };
        },
        mod: function(a) {
            return function(b) {
                return $dc43y.defer(function(v) {
                    return mod($dc43y.force(a))($dc43y.force(b));
                });
            };
        },
        CommutativeRing0: function() {
            return commutativeRingLazy1;
        }
    };
};
var $73aa5dd1904ebcb7$export$aabc837ad904b190 = function(dictBounded) {
    var top = $95fRU.top(dictBounded);
    var bottom = $95fRU.bottom(dictBounded);
    var ordLazy1 = $73aa5dd1904ebcb7$export$cbabaf21b7e8b5db(dictBounded.Ord0());
    return {
        top: $dc43y.defer(function(v) {
            return top;
        }),
        bottom: $dc43y.defer(function(v) {
            return bottom;
        }),
        Ord0: function() {
            return ordLazy1;
        }
    };
};
var $73aa5dd1904ebcb7$export$c3ec2aebe6109e81 = {
    apply: function(f) {
        return function(x) {
            return $dc43y.defer(function(v) {
                return $dc43y.force(f)($dc43y.force(x));
            });
        };
    },
    Functor0: function() {
        return $73aa5dd1904ebcb7$export$3780b8670d5f24f8;
    }
};
var $73aa5dd1904ebcb7$var$apply = /* #__PURE__ */ $a5g3C.apply($73aa5dd1904ebcb7$export$c3ec2aebe6109e81);
var $73aa5dd1904ebcb7$export$e1a4485e8a67faf2 = {
    bind: function(l) {
        return function(f) {
            return $dc43y.defer(function(v) {
                return $dc43y.force(f($dc43y.force(l)));
            });
        };
    },
    Apply0: function() {
        return $73aa5dd1904ebcb7$export$c3ec2aebe6109e81;
    }
};
var $73aa5dd1904ebcb7$export$89956d4f263e939b = function(dictHeytingAlgebra) {
    var ff = $lnl7Y.ff(dictHeytingAlgebra);
    var tt = $lnl7Y.tt(dictHeytingAlgebra);
    var implies = $lnl7Y.implies(dictHeytingAlgebra);
    var conj = $lnl7Y.conj(dictHeytingAlgebra);
    var disj = $lnl7Y.disj(dictHeytingAlgebra);
    var not = $lnl7Y.not(dictHeytingAlgebra);
    return {
        ff: $dc43y.defer(function(v) {
            return ff;
        }),
        tt: $dc43y.defer(function(v) {
            return tt;
        }),
        implies: function(a) {
            return function(b) {
                return $73aa5dd1904ebcb7$var$apply($73aa5dd1904ebcb7$var$map(implies)(a))(b);
            };
        },
        conj: function(a) {
            return function(b) {
                return $73aa5dd1904ebcb7$var$apply($73aa5dd1904ebcb7$var$map(conj)(a))(b);
            };
        },
        disj: function(a) {
            return function(b) {
                return $73aa5dd1904ebcb7$var$apply($73aa5dd1904ebcb7$var$map(disj)(a))(b);
            };
        },
        not: function(a) {
            return $73aa5dd1904ebcb7$var$map(not)(a);
        }
    };
};
var $73aa5dd1904ebcb7$export$27ff7cba27a505be = function(dictBooleanAlgebra) {
    var heytingAlgebraLazy1 = $73aa5dd1904ebcb7$export$89956d4f263e939b(dictBooleanAlgebra.HeytingAlgebra0());
    return {
        HeytingAlgebra0: function() {
            return heytingAlgebraLazy1;
        }
    };
};
var $73aa5dd1904ebcb7$export$28587442a46d4141 = {
    pure: function(a) {
        return $dc43y.defer(function(v) {
            return a;
        });
    },
    Apply0: function() {
        return $73aa5dd1904ebcb7$export$c3ec2aebe6109e81;
    }
};
var $73aa5dd1904ebcb7$export$cfa2e2b570f2d5d3 = {
    Applicative0: function() {
        return $73aa5dd1904ebcb7$export$28587442a46d4141;
    },
    Bind1: function() {
        return $73aa5dd1904ebcb7$export$e1a4485e8a67faf2;
    }
};

});
parcelRegister("dc43y", function(module, exports) {

$parcel$export(module.exports, "defer", () => $99af8ad7682e39c7$export$260e5c0943f31606);
$parcel$export(module.exports, "force", () => $99af8ad7682e39c7$export$4d82290515cd0ddb);
const $99af8ad7682e39c7$export$260e5c0943f31606 = function(thunk) {
    var v = null;
    return function() {
        if (thunk === undefined) return v;
        v = thunk();
        thunk = undefined; // eslint-disable-line no-param-reassign
        return v;
    };
};
const $99af8ad7682e39c7$export$4d82290515cd0ddb = function(l) {
    return l();
};

});

parcelRegister("6RkEA", function(module, exports) {

$parcel$export(module.exports, "foldr", () => $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf);
$parcel$export(module.exports, "oneOf", () => $4fe7b6acfba7f29f$export$a9a18ae5ba42aeab);
$parcel$export(module.exports, "oneOfMap", () => $4fe7b6acfba7f29f$export$79f3cac53daaaae6);
$parcel$export(module.exports, "traverse_", () => $4fe7b6acfba7f29f$export$33f63ccdb08d8723);
$parcel$export(module.exports, "for_", () => $4fe7b6acfba7f29f$export$9747ee7caa0b40b1);
$parcel$export(module.exports, "foldl", () => $4fe7b6acfba7f29f$export$50ae948ca12cdcbc);
$parcel$export(module.exports, "intercalate", () => $4fe7b6acfba7f29f$export$739ec22334c44788);
$parcel$export(module.exports, "length", () => $4fe7b6acfba7f29f$export$f24224f1c91d8156);
$parcel$export(module.exports, "foldableTuple", () => $4fe7b6acfba7f29f$export$ffb07d5442a5d6a6);
$parcel$export(module.exports, "foldableMultiplicative", () => $4fe7b6acfba7f29f$export$9519b6731ae6781c);
$parcel$export(module.exports, "foldableMaybe", () => $4fe7b6acfba7f29f$export$ff97dbee91e727b6);
$parcel$export(module.exports, "foldableIdentity", () => $4fe7b6acfba7f29f$export$3c076fb5bbc5428f);
$parcel$export(module.exports, "foldableEither", () => $4fe7b6acfba7f29f$export$6a194eaac00c1ff4);
$parcel$export(module.exports, "foldableDual", () => $4fe7b6acfba7f29f$export$1f8d30ddb0a4c229);
$parcel$export(module.exports, "foldableDisj", () => $4fe7b6acfba7f29f$export$fbf8f11f9a917de3);
$parcel$export(module.exports, "foldableConst", () => $4fe7b6acfba7f29f$export$6857d056e9f0762d);
$parcel$export(module.exports, "foldableConj", () => $4fe7b6acfba7f29f$export$b0c90191a04a5815);
$parcel$export(module.exports, "foldableAdditive", () => $4fe7b6acfba7f29f$export$a3b6f6613d3d5767);
$parcel$export(module.exports, "foldableArray", () => $4fe7b6acfba7f29f$export$e97014618a7eb593);
$parcel$export(module.exports, "foldMapDefaultL", () => $4fe7b6acfba7f29f$export$1131b47d09454899);
$parcel$export(module.exports, "foldMap", () => $4fe7b6acfba7f29f$export$b66cdc0497d8a99a);
$parcel$export(module.exports, "foldableApp", () => $4fe7b6acfba7f29f$export$1e1b0f55a49f1dc6);
$parcel$export(module.exports, "foldableCompose", () => $4fe7b6acfba7f29f$export$5677464b2ea4179d);
$parcel$export(module.exports, "foldableCoproduct", () => $4fe7b6acfba7f29f$export$5c9c2b827ab84341);
$parcel$export(module.exports, "foldableFirst", () => $4fe7b6acfba7f29f$export$f52a7d3e80f7fd5e);
$parcel$export(module.exports, "foldableLast", () => $4fe7b6acfba7f29f$export$d127e049f7f9d81c);
$parcel$export(module.exports, "foldableProduct", () => $4fe7b6acfba7f29f$export$a013322ac1f6d3aa);
$parcel$export(module.exports, "foldlDefault", () => $4fe7b6acfba7f29f$export$e623e8bf74059b22);
$parcel$export(module.exports, "foldrDefault", () => $4fe7b6acfba7f29f$export$9b986141719153e);
$parcel$export(module.exports, "fold", () => $4fe7b6acfba7f29f$export$93e2b83da34ff82a);
$parcel$export(module.exports, "any", () => $4fe7b6acfba7f29f$export$4154a199d7d90455);
// Generated by purs version 0.15.16

var $5U4oI = parcelRequire("5U4oI");

var $a7Dxq = parcelRequire("a7Dxq");

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $9Grh5 = parcelRequire("9Grh5");

var $7T8P4 = parcelRequire("7T8P4");

var $axmEP = parcelRequire("axmEP");

var $aKY4H = parcelRequire("aKY4H");

var $4MBcA = parcelRequire("4MBcA");

var $l4M7e = parcelRequire("l4M7e");

var $6gSOm = parcelRequire("6gSOm");

var $lnl7Y = parcelRequire("lnl7Y");

var $ykHdR = parcelRequire("ykHdR");

var $cxbq2 = parcelRequire("cxbq2");

var $aknDF = parcelRequire("aknDF");

var $8JeQl = parcelRequire("8JeQl");

var $1zczT = parcelRequire("1zczT");

var $bbOAS = parcelRequire("bbOAS");

var $7wVLo = parcelRequire("7wVLo");

var $6PW1p = parcelRequire("6PW1p");

var $d0PPW = parcelRequire("d0PPW");

var $6SDUu = parcelRequire("6SDUu");

var $iwqgS = parcelRequire("iwqgS");

var $gyPYh = parcelRequire("gyPYh");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");
var $4fe7b6acfba7f29f$var$identity = /* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn);
var $4fe7b6acfba7f29f$var$eq1 = /* #__PURE__ */ $4MBcA.eq($6SDUu.eqOrdering);
var $4fe7b6acfba7f29f$var$unwrap = /* #__PURE__ */ $6PW1p.unwrap();
var $4fe7b6acfba7f29f$var$monoidEndo = /* #__PURE__ */ $7wVLo.monoidEndo($7T8P4.categoryFn);
var $4fe7b6acfba7f29f$var$monoidDual = /* #__PURE__ */ $bbOAS.monoidDual($4fe7b6acfba7f29f$var$monoidEndo);
var $4fe7b6acfba7f29f$var$alaF = /* #__PURE__ */ $6PW1p.alaF()()()();
var $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf = function(dict) {
    return dict.foldr;
};
var $4fe7b6acfba7f29f$export$f14ab6cb4b8e359c = function(dictFoldable) {
    var foldr2 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
    return function(idx) {
        var go = function(a) {
            return function(cursor) {
                if (cursor.elem instanceof $ykHdR.Just) return cursor;
                var $292 = cursor.pos === idx;
                if ($292) return {
                    elem: new $ykHdR.Just(a),
                    pos: cursor.pos
                };
                return {
                    pos: cursor.pos + 1 | 0,
                    elem: cursor.elem
                };
            };
        };
        var $451 = foldr2(go)({
            elem: $ykHdR.Nothing.value,
            pos: 0
        });
        return function($452) {
            return function(v) {
                return v.elem;
            }($451($452));
        };
    };
};
var $4fe7b6acfba7f29f$export$7b1b591b262c240 = function(dictFoldable) {
    return $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable)(function(v) {
        return function(v1) {
            return false;
        };
    })(true);
};
var $4fe7b6acfba7f29f$export$a9a18ae5ba42aeab = function(dictFoldable) {
    var foldr2 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
    return function(dictPlus) {
        return foldr2($a7Dxq.alt(dictPlus.Alt0()))($axmEP.empty(dictPlus));
    };
};
var $4fe7b6acfba7f29f$export$79f3cac53daaaae6 = function(dictFoldable) {
    var foldr2 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
    return function(dictPlus) {
        var alt = $a7Dxq.alt(dictPlus.Alt0());
        var empty = $axmEP.empty(dictPlus);
        return function(f) {
            return foldr2(function($453) {
                return alt(f($453));
            })(empty);
        };
    };
};
var $4fe7b6acfba7f29f$export$33f63ccdb08d8723 = function(dictApplicative) {
    var applySecond = $a5g3C.applySecond(dictApplicative.Apply0());
    var pure = $gUTA8.pure(dictApplicative);
    return function(dictFoldable) {
        var foldr2 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
        return function(f) {
            return foldr2(function($454) {
                return applySecond(f($454));
            })(pure($r2HHk.unit));
        };
    };
};
var $4fe7b6acfba7f29f$export$9747ee7caa0b40b1 = function(dictApplicative) {
    var traverse_1 = $4fe7b6acfba7f29f$export$33f63ccdb08d8723(dictApplicative);
    return function(dictFoldable) {
        return $l4M7e.flip(traverse_1(dictFoldable));
    };
};
var $4fe7b6acfba7f29f$export$4426b9bff8b7b6fb = function(dictApplicative) {
    var traverse_1 = $4fe7b6acfba7f29f$export$33f63ccdb08d8723(dictApplicative);
    return function(dictFoldable) {
        return traverse_1(dictFoldable)($4fe7b6acfba7f29f$var$identity);
    };
};
var $4fe7b6acfba7f29f$export$50ae948ca12cdcbc = function(dict) {
    return dict.foldl;
};
var $4fe7b6acfba7f29f$export$fe35754984712af1 = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(idx) {
        var go = function(cursor) {
            return function(a) {
                if (cursor.elem instanceof $ykHdR.Just) return cursor;
                var $296 = cursor.pos === idx;
                if ($296) return {
                    elem: new $ykHdR.Just(a),
                    pos: cursor.pos
                };
                return {
                    pos: cursor.pos + 1 | 0,
                    elem: cursor.elem
                };
            };
        };
        var $455 = foldl2(go)({
            elem: $ykHdR.Nothing.value,
            pos: 0
        });
        return function($456) {
            return function(v) {
                return v.elem;
            }($455($456));
        };
    };
};
var $4fe7b6acfba7f29f$export$739ec22334c44788 = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(dictMonoid) {
        var append = $iwqgS.append(dictMonoid.Semigroup0());
        var mempty = $aknDF.mempty(dictMonoid);
        return function(sep) {
            return function(xs) {
                var go = function(v) {
                    return function(v1) {
                        if (v.init) return {
                            init: false,
                            acc: v1
                        };
                        return {
                            init: false,
                            acc: append(v.acc)(append(sep)(v1))
                        };
                    };
                };
                return foldl2(go)({
                    init: true,
                    acc: mempty
                })(xs).acc;
            };
        };
    };
};
var $4fe7b6acfba7f29f$export$f24224f1c91d8156 = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(dictSemiring) {
        var add1 = $gyPYh.add(dictSemiring);
        var one = $gyPYh.one(dictSemiring);
        return foldl2(function(c) {
            return function(v) {
                return add1(one)(c);
            };
        })($gyPYh.zero(dictSemiring));
    };
};
var $4fe7b6acfba7f29f$export$c42fa06aba2a552c = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(cmp) {
        var max$prime = function(v) {
            return function(v1) {
                if (v instanceof $ykHdR.Nothing) return new $ykHdR.Just(v1);
                if (v instanceof $ykHdR.Just) return new $ykHdR.Just(function() {
                    var $303 = $4fe7b6acfba7f29f$var$eq1(cmp(v.value0)(v1))($6SDUu.GT.value);
                    if ($303) return v.value0;
                    return v1;
                }());
                throw new Error("Failed pattern match at Data.Foldable (line 441, column 3 - line 441, column 27): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
        return foldl2(max$prime)($ykHdR.Nothing.value);
    };
};
var $4fe7b6acfba7f29f$export$b25e0be55f42c9a = function(dictOrd) {
    var compare = $d0PPW.compare(dictOrd);
    return function(dictFoldable) {
        return $4fe7b6acfba7f29f$export$c42fa06aba2a552c(dictFoldable)(compare);
    };
};
var $4fe7b6acfba7f29f$export$b65392d958998255 = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(cmp) {
        var min$prime = function(v) {
            return function(v1) {
                if (v instanceof $ykHdR.Nothing) return new $ykHdR.Just(v1);
                if (v instanceof $ykHdR.Just) return new $ykHdR.Just(function() {
                    var $307 = $4fe7b6acfba7f29f$var$eq1(cmp(v.value0)(v1))($6SDUu.LT.value);
                    if ($307) return v.value0;
                    return v1;
                }());
                throw new Error("Failed pattern match at Data.Foldable (line 454, column 3 - line 454, column 27): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
        return foldl2(min$prime)($ykHdR.Nothing.value);
    };
};
var $4fe7b6acfba7f29f$export$916782c1f0ddb132 = function(dictOrd) {
    var compare = $d0PPW.compare(dictOrd);
    return function(dictFoldable) {
        return $4fe7b6acfba7f29f$export$b65392d958998255(dictFoldable)(compare);
    };
};
var $4fe7b6acfba7f29f$export$dbd0f18357df1ddd = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(dictSemiring) {
        return foldl2($gyPYh.mul(dictSemiring))($gyPYh.one(dictSemiring));
    };
};
var $4fe7b6acfba7f29f$export$8a63f25cc62965f1 = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(dictSemiring) {
        return foldl2($gyPYh.add(dictSemiring))($gyPYh.zero(dictSemiring));
    };
};
var $4fe7b6acfba7f29f$export$ffb07d5442a5d6a6 = {
    foldr: function(f) {
        return function(z) {
            return function(v) {
                return f(v.value1)(z);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(v) {
                return f(z)(v.value1);
            };
        };
    },
    foldMap: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return f(v.value1);
            };
        };
    }
};
var $4fe7b6acfba7f29f$export$9519b6731ae6781c = {
    foldr: function(f) {
        return function(z) {
            return function(v) {
                return f(v)(z);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(v) {
                return f(z)(v);
            };
        };
    },
    foldMap: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return f(v);
            };
        };
    }
};
var $4fe7b6acfba7f29f$export$ff97dbee91e727b6 = {
    foldr: function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $ykHdR.Nothing) return v1;
                if (v2 instanceof $ykHdR.Just) return v(v2.value0)(v1);
                throw new Error("Failed pattern match at Data.Foldable (line 138, column 1 - line 144, column 27): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    },
    foldl: function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $ykHdR.Nothing) return v1;
                if (v2 instanceof $ykHdR.Just) return v(v1)(v2.value0);
                throw new Error("Failed pattern match at Data.Foldable (line 138, column 1 - line 144, column 27): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    },
    foldMap: function(dictMonoid) {
        var mempty = $aknDF.mempty(dictMonoid);
        return function(v) {
            return function(v1) {
                if (v1 instanceof $ykHdR.Nothing) return mempty;
                if (v1 instanceof $ykHdR.Just) return v(v1.value0);
                throw new Error("Failed pattern match at Data.Foldable (line 138, column 1 - line 144, column 27): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    }
};
var $4fe7b6acfba7f29f$var$foldr1 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($4fe7b6acfba7f29f$export$ff97dbee91e727b6);
var $4fe7b6acfba7f29f$var$foldl1 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($4fe7b6acfba7f29f$export$ff97dbee91e727b6);
var $4fe7b6acfba7f29f$export$3c076fb5bbc5428f = {
    foldr: function(f) {
        return function(z) {
            return function(v) {
                return f(v)(z);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(v) {
                return f(z)(v);
            };
        };
    },
    foldMap: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return f(v);
            };
        };
    }
};
var $4fe7b6acfba7f29f$export$6a194eaac00c1ff4 = {
    foldr: function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $aKY4H.Left) return v1;
                if (v2 instanceof $aKY4H.Right) return v(v2.value0)(v1);
                throw new Error("Failed pattern match at Data.Foldable (line 181, column 1 - line 187, column 28): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    },
    foldl: function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $aKY4H.Left) return v1;
                if (v2 instanceof $aKY4H.Right) return v(v1)(v2.value0);
                throw new Error("Failed pattern match at Data.Foldable (line 181, column 1 - line 187, column 28): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    },
    foldMap: function(dictMonoid) {
        var mempty = $aknDF.mempty(dictMonoid);
        return function(v) {
            return function(v1) {
                if (v1 instanceof $aKY4H.Left) return mempty;
                if (v1 instanceof $aKY4H.Right) return v(v1.value0);
                throw new Error("Failed pattern match at Data.Foldable (line 181, column 1 - line 187, column 28): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    }
};
var $4fe7b6acfba7f29f$export$1f8d30ddb0a4c229 = {
    foldr: function(f) {
        return function(z) {
            return function(v) {
                return f(v)(z);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(v) {
                return f(z)(v);
            };
        };
    },
    foldMap: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return f(v);
            };
        };
    }
};
var $4fe7b6acfba7f29f$export$fbf8f11f9a917de3 = {
    foldr: function(f) {
        return function(z) {
            return function(v) {
                return f(v)(z);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(v) {
                return f(z)(v);
            };
        };
    },
    foldMap: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return f(v);
            };
        };
    }
};
var $4fe7b6acfba7f29f$export$6857d056e9f0762d = {
    foldr: function(v) {
        return function(z) {
            return function(v1) {
                return z;
            };
        };
    },
    foldl: function(v) {
        return function(z) {
            return function(v1) {
                return z;
            };
        };
    },
    foldMap: function(dictMonoid) {
        var mempty = $aknDF.mempty(dictMonoid);
        return function(v) {
            return function(v1) {
                return mempty;
            };
        };
    }
};
var $4fe7b6acfba7f29f$export$b0c90191a04a5815 = {
    foldr: function(f) {
        return function(z) {
            return function(v) {
                return f(v)(z);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(v) {
                return f(z)(v);
            };
        };
    },
    foldMap: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return f(v);
            };
        };
    }
};
var $4fe7b6acfba7f29f$export$a3b6f6613d3d5767 = {
    foldr: function(f) {
        return function(z) {
            return function(v) {
                return f(v)(z);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(v) {
                return f(z)(v);
            };
        };
    },
    foldMap: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return f(v);
            };
        };
    }
};
var $4fe7b6acfba7f29f$export$edac6f86a9ee0bec = function(dictFoldable) {
    var foldr2 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
    return function(dictMonoid) {
        var append = $iwqgS.append(dictMonoid.Semigroup0());
        var mempty = $aknDF.mempty(dictMonoid);
        return function(f) {
            return foldr2(function(x) {
                return function(acc) {
                    return append(f(x))(acc);
                };
            })(mempty);
        };
    };
};
var $4fe7b6acfba7f29f$export$e97014618a7eb593 = {
    foldr: $5U4oI.foldrArray,
    foldl: $5U4oI.foldlArray,
    foldMap: function(dictMonoid) {
        return $4fe7b6acfba7f29f$export$edac6f86a9ee0bec($4fe7b6acfba7f29f$export$e97014618a7eb593)(dictMonoid);
    }
};
var $4fe7b6acfba7f29f$export$1131b47d09454899 = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(dictMonoid) {
        var append = $iwqgS.append(dictMonoid.Semigroup0());
        var mempty = $aknDF.mempty(dictMonoid);
        return function(f) {
            return foldl2(function(acc) {
                return function(x) {
                    return append(acc)(f(x));
                };
            })(mempty);
        };
    };
};
var $4fe7b6acfba7f29f$export$b66cdc0497d8a99a = function(dict) {
    return dict.foldMap;
};
var $4fe7b6acfba7f29f$var$foldMap1 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$b66cdc0497d8a99a($4fe7b6acfba7f29f$export$ff97dbee91e727b6);
var $4fe7b6acfba7f29f$export$1e1b0f55a49f1dc6 = function(dictFoldable) {
    var foldr2 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    var foldMap2 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable);
    return {
        foldr: function(f) {
            return function(i) {
                return function(v) {
                    return foldr2(f)(i)(v);
                };
            };
        },
        foldl: function(f) {
            return function(i) {
                return function(v) {
                    return foldl2(f)(i)(v);
                };
            };
        },
        foldMap: function(dictMonoid) {
            var foldMap3 = foldMap2(dictMonoid);
            return function(f) {
                return function(v) {
                    return foldMap3(f)(v);
                };
            };
        }
    };
};
var $4fe7b6acfba7f29f$export$5677464b2ea4179d = function(dictFoldable) {
    var foldr2 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    var foldMap2 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable);
    return function(dictFoldable1) {
        var foldr3 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable1);
        var foldl3 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable1);
        var foldMap3 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable1);
        return {
            foldr: function(f) {
                return function(i) {
                    return function(v) {
                        return foldr2($l4M7e.flip(foldr3(f)))(i)(v);
                    };
                };
            },
            foldl: function(f) {
                return function(i) {
                    return function(v) {
                        return foldl2(foldl3(f))(i)(v);
                    };
                };
            },
            foldMap: function(dictMonoid) {
                var foldMap4 = foldMap2(dictMonoid);
                var foldMap5 = foldMap3(dictMonoid);
                return function(f) {
                    return function(v) {
                        return foldMap4(foldMap5(f))(v);
                    };
                };
            }
        };
    };
};
var $4fe7b6acfba7f29f$export$5c9c2b827ab84341 = function(dictFoldable) {
    var foldr2 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    var foldMap2 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable);
    return function(dictFoldable1) {
        var foldr3 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable1);
        var foldl3 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable1);
        var foldMap3 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable1);
        return {
            foldr: function(f) {
                return function(z) {
                    return $6gSOm.coproduct(foldr2(f)(z))(foldr3(f)(z));
                };
            },
            foldl: function(f) {
                return function(z) {
                    return $6gSOm.coproduct(foldl2(f)(z))(foldl3(f)(z));
                };
            },
            foldMap: function(dictMonoid) {
                var foldMap4 = foldMap2(dictMonoid);
                var foldMap5 = foldMap3(dictMonoid);
                return function(f) {
                    return $6gSOm.coproduct(foldMap4(f))(foldMap5(f));
                };
            }
        };
    };
};
var $4fe7b6acfba7f29f$export$f52a7d3e80f7fd5e = {
    foldr: function(f) {
        return function(z) {
            return function(v) {
                return $4fe7b6acfba7f29f$var$foldr1(f)(z)(v);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(v) {
                return $4fe7b6acfba7f29f$var$foldl1(f)(z)(v);
            };
        };
    },
    foldMap: function(dictMonoid) {
        var foldMap2 = $4fe7b6acfba7f29f$var$foldMap1(dictMonoid);
        return function(f) {
            return function(v) {
                return foldMap2(f)(v);
            };
        };
    }
};
var $4fe7b6acfba7f29f$export$d127e049f7f9d81c = {
    foldr: function(f) {
        return function(z) {
            return function(v) {
                return $4fe7b6acfba7f29f$var$foldr1(f)(z)(v);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(v) {
                return $4fe7b6acfba7f29f$var$foldl1(f)(z)(v);
            };
        };
    },
    foldMap: function(dictMonoid) {
        var foldMap2 = $4fe7b6acfba7f29f$var$foldMap1(dictMonoid);
        return function(f) {
            return function(v) {
                return foldMap2(f)(v);
            };
        };
    }
};
var $4fe7b6acfba7f29f$export$a013322ac1f6d3aa = function(dictFoldable) {
    var foldr2 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    var foldMap2 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable);
    return function(dictFoldable1) {
        var foldr3 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable1);
        var foldl3 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable1);
        var foldMap3 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable1);
        return {
            foldr: function(f) {
                return function(z) {
                    return function(v) {
                        return foldr2(f)(foldr3(f)(z)(v.value1))(v.value0);
                    };
                };
            },
            foldl: function(f) {
                return function(z) {
                    return function(v) {
                        return foldl3(f)(foldl2(f)(z)(v.value0))(v.value1);
                    };
                };
            },
            foldMap: function(dictMonoid) {
                var append = $iwqgS.append(dictMonoid.Semigroup0());
                var foldMap4 = foldMap2(dictMonoid);
                var foldMap5 = foldMap3(dictMonoid);
                return function(f) {
                    return function(v) {
                        return append(foldMap4(f)(v.value0))(foldMap5(f)(v.value1));
                    };
                };
            }
        };
    };
};
var $4fe7b6acfba7f29f$export$e623e8bf74059b22 = function(dictFoldable) {
    var foldMap2 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable)($4fe7b6acfba7f29f$var$monoidDual);
    return function(c) {
        return function(u) {
            return function(xs) {
                return $4fe7b6acfba7f29f$var$unwrap($4fe7b6acfba7f29f$var$unwrap(foldMap2(function() {
                    var $457 = $l4M7e.flip(c);
                    return function($458) {
                        return $bbOAS.Dual($7wVLo.Endo($457($458)));
                    };
                }())(xs)))(u);
            };
        };
    };
};
var $4fe7b6acfba7f29f$export$9b986141719153e = function(dictFoldable) {
    var foldMap2 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable)($4fe7b6acfba7f29f$var$monoidEndo);
    return function(c) {
        return function(u) {
            return function(xs) {
                return $4fe7b6acfba7f29f$var$unwrap(foldMap2(function($459) {
                    return $7wVLo.Endo(c($459));
                })(xs))(u);
            };
        };
    };
};
var $4fe7b6acfba7f29f$export$dfc7155ac0343b8 = function(dictFoldable) {
    var foldMap2 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable)($cxbq2.monoidFirst);
    return function(dictEq) {
        var eq2 = $4MBcA.eq(dictEq);
        return function(a) {
            var $460 = foldMap2(function(v) {
                var $444 = eq2(a)(v.value0);
                if ($444) return new $ykHdR.Just(v.value1);
                return $ykHdR.Nothing.value;
            });
            return function($461) {
                return $4fe7b6acfba7f29f$var$unwrap($460($461));
            };
        };
    };
};
var $4fe7b6acfba7f29f$export$7606e2cbf4afaea2 = function(dictFoldable) {
    var foldMap2 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable)($4fe7b6acfba7f29f$var$monoidEndo);
    return function(dictSemigroup) {
        var append = $iwqgS.append(dictSemigroup);
        return function(d) {
            return function(t) {
                return function(f) {
                    var joined = function(a) {
                        return function(m) {
                            return append(d)(append(t(a))(m));
                        };
                    };
                    return $4fe7b6acfba7f29f$var$unwrap(foldMap2(joined)(f))(d);
                };
            };
        };
    };
};
var $4fe7b6acfba7f29f$export$5a27709e8737ce25 = function(dictFoldable) {
    var surroundMap1 = $4fe7b6acfba7f29f$export$7606e2cbf4afaea2(dictFoldable);
    return function(dictSemigroup) {
        var surroundMap2 = surroundMap1(dictSemigroup);
        return function(d) {
            return surroundMap2(d)($4fe7b6acfba7f29f$var$identity);
        };
    };
};
var $4fe7b6acfba7f29f$export$7a067f9280ad8af0 = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(dictMonad) {
        var bind = $9Grh5.bind(dictMonad.Bind1());
        var pure = $gUTA8.pure(dictMonad.Applicative0());
        return function(f) {
            return function(b0) {
                return foldl2(function(b) {
                    return function(a) {
                        return bind(b)($l4M7e.flip(f)(a));
                    };
                })(pure(b0));
            };
        };
    };
};
var $4fe7b6acfba7f29f$export$93e2b83da34ff82a = function(dictFoldable) {
    var foldMap2 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable);
    return function(dictMonoid) {
        return foldMap2(dictMonoid)($4fe7b6acfba7f29f$var$identity);
    };
};
var $4fe7b6acfba7f29f$export$23e5dcedfce4509c = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(p) {
        var go = function(v) {
            return function(v1) {
                if (v instanceof $ykHdR.Nothing) return p(v1);
                return v;
            };
        };
        return foldl2(go)($ykHdR.Nothing.value);
    };
};
var $4fe7b6acfba7f29f$export$71aa6c912b956294 = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(p) {
        var go = function(v) {
            return function(v1) {
                if (v instanceof $ykHdR.Nothing && p(v1)) return new $ykHdR.Just(v1);
                return v;
            };
        };
        return foldl2(go)($ykHdR.Nothing.value);
    };
};
var $4fe7b6acfba7f29f$export$4154a199d7d90455 = function(dictFoldable) {
    var foldMap2 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable);
    return function(dictHeytingAlgebra) {
        return $4fe7b6acfba7f29f$var$alaF($1zczT.Disj)(foldMap2($1zczT.monoidDisj(dictHeytingAlgebra)));
    };
};
var $4fe7b6acfba7f29f$export$5bf96401662340b7 = function(dictFoldable) {
    var any1 = $4fe7b6acfba7f29f$export$4154a199d7d90455(dictFoldable)($lnl7Y.heytingAlgebraBoolean);
    return function(dictEq) {
        var $462 = $4MBcA.eq(dictEq);
        return function($463) {
            return any1($462($463));
        };
    };
};
var $4fe7b6acfba7f29f$export$63faa62a0284a4a6 = function(dictFoldable) {
    var elem1 = $4fe7b6acfba7f29f$export$5bf96401662340b7(dictFoldable);
    return function(dictEq) {
        var elem2 = elem1(dictEq);
        return function(x) {
            var $464 = elem2(x);
            return function($465) {
                return !$464($465);
            };
        };
    };
};
var $4fe7b6acfba7f29f$export$252bb8b3bbdf6749 = function(dictFoldable) {
    var any1 = $4fe7b6acfba7f29f$export$4154a199d7d90455(dictFoldable);
    return function(dictHeytingAlgebra) {
        return any1(dictHeytingAlgebra)($4fe7b6acfba7f29f$var$identity);
    };
};
var $4fe7b6acfba7f29f$export$84bf76cd7afc7469 = function(dictFoldable) {
    var foldMap2 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable);
    return function(dictHeytingAlgebra) {
        return $4fe7b6acfba7f29f$var$alaF($8JeQl.Conj)(foldMap2($8JeQl.monoidConj(dictHeytingAlgebra)));
    };
};
var $4fe7b6acfba7f29f$export$21c0ac7fe1cef1b8 = function(dictFoldable) {
    var all1 = $4fe7b6acfba7f29f$export$84bf76cd7afc7469(dictFoldable);
    return function(dictHeytingAlgebra) {
        return all1(dictHeytingAlgebra)($4fe7b6acfba7f29f$var$identity);
    };
};

});
parcelRegister("5U4oI", function(module, exports) {

$parcel$export(module.exports, "foldrArray", () => $44c597fdc38e7b03$export$6332150c6d01d807);
$parcel$export(module.exports, "foldlArray", () => $44c597fdc38e7b03$export$6b86e13802001a00);
const $44c597fdc38e7b03$export$6332150c6d01d807 = function(f) {
    return function(init) {
        return function(xs) {
            var acc = init;
            var len = xs.length;
            for(var i = len - 1; i >= 0; i--)acc = f(xs[i])(acc);
            return acc;
        };
    };
};
const $44c597fdc38e7b03$export$6b86e13802001a00 = function(f) {
    return function(init) {
        return function(xs) {
            var acc = init;
            var len = xs.length;
            for(var i = 0; i < len; i++)acc = f(acc)(xs[i]);
            return acc;
        };
    };
};

});

parcelRegister("axmEP", function(module, exports) {

$parcel$export(module.exports, "plusArray", () => $7abe8fbe97ebda87$export$b7c99dd4fc96d90e);
$parcel$export(module.exports, "empty", () => $7abe8fbe97ebda87$export$6e22c362a0406a2c);
// Generated by purs version 0.15.16

var $a7Dxq = parcelRequire("a7Dxq");

var $l0wDR = parcelRequire("l0wDR");
var $7abe8fbe97ebda87$export$b7c99dd4fc96d90e = {
    empty: [],
    Alt0: function() {
        return $a7Dxq.altArray;
    }
};
var $7abe8fbe97ebda87$export$6e22c362a0406a2c = function(dict) {
    return dict.empty;
};

});

parcelRegister("6gSOm", function(module, exports) {

$parcel$export(module.exports, "Coproduct", () => $490ec114b4138e6d$export$a7f096464cca5f3a);
$parcel$export(module.exports, "functorCoproduct", () => $490ec114b4138e6d$export$e192c0fa89a291cb);
$parcel$export(module.exports, "coproduct", () => $490ec114b4138e6d$export$ab04af7daecb905f);
// Generated by purs version 0.15.16

var $frF73 = parcelRequire("frF73");

var $hfMWE = parcelRequire("hfMWE");

var $2Mmje = parcelRequire("2Mmje");

var $aKY4H = parcelRequire("aKY4H");

var $4MBcA = parcelRequire("4MBcA");

var $l0wDR = parcelRequire("l0wDR");

var $d0PPW = parcelRequire("d0PPW");

var $6SDUu = parcelRequire("6SDUu");

var $3Orkn = parcelRequire("3Orkn");
var $490ec114b4138e6d$var$bimap = /* #__PURE__ */ $2Mmje.bimap($2Mmje.bifunctorEither);
var $490ec114b4138e6d$export$a7f096464cca5f3a = function(x) {
    return x;
};
var $490ec114b4138e6d$export$593e0c14cbf7732e = function(dictShow) {
    var show = $3Orkn.show(dictShow);
    return function(dictShow1) {
        var show1 = $3Orkn.show(dictShow1);
        return {
            show: function(v) {
                if (v instanceof $aKY4H.Left) return "(left " + (show(v.value0) + ")");
                if (v instanceof $aKY4H.Right) return "(right " + (show1(v.value0) + ")");
                throw new Error("Failed pattern match at Data.Functor.Coproduct (line 63, column 1 - line 65, column 60): " + [
                    v.constructor.name
                ]);
            }
        };
    };
};
var $490ec114b4138e6d$export$79ffe56a765070d2 = function(ga) {
    return new $aKY4H.Right(ga);
};
var $490ec114b4138e6d$export$7fc1e26c1ee5b3a4 = {
    Coercible0: function() {
        return undefined;
    }
};
var $490ec114b4138e6d$export$eabcd2c8791e7bf4 = function(fa) {
    return new $aKY4H.Left(fa);
};
var $490ec114b4138e6d$export$e192c0fa89a291cb = function(dictFunctor) {
    var map = $l0wDR.map(dictFunctor);
    return function(dictFunctor1) {
        var map1 = $l0wDR.map(dictFunctor1);
        return {
            map: function(f) {
                return function(v) {
                    return $490ec114b4138e6d$var$bimap(map(f))(map1(f))(v);
                };
            }
        };
    };
};
var $490ec114b4138e6d$export$30aaa5110153edc1 = function(dictEq1) {
    var eq1 = $4MBcA.eq1(dictEq1);
    return function(dictEq11) {
        var eq11 = $4MBcA.eq1(dictEq11);
        return {
            eq1: function(dictEq) {
                var eq12 = eq1(dictEq);
                var eq13 = eq11(dictEq);
                return function(v) {
                    return function(v1) {
                        if (v instanceof $aKY4H.Left && v1 instanceof $aKY4H.Left) return eq12(v.value0)(v1.value0);
                        if (v instanceof $aKY4H.Right && v1 instanceof $aKY4H.Right) return eq13(v.value0)(v1.value0);
                        return false;
                    };
                };
            }
        };
    };
};
var $490ec114b4138e6d$export$4f54a72d7417da7c = function(dictEq1) {
    var eq1Coproduct1 = $490ec114b4138e6d$export$30aaa5110153edc1(dictEq1);
    return function(dictEq11) {
        var eq1 = $4MBcA.eq1(eq1Coproduct1(dictEq11));
        return function(dictEq) {
            return {
                eq: eq1(dictEq)
            };
        };
    };
};
var $490ec114b4138e6d$export$ec3d1f0587fb15ed = function(dictOrd1) {
    var compare1 = $d0PPW.compare1(dictOrd1);
    var eq1Coproduct1 = $490ec114b4138e6d$export$30aaa5110153edc1(dictOrd1.Eq10());
    return function(dictOrd11) {
        var compare11 = $d0PPW.compare1(dictOrd11);
        var eq1Coproduct2 = eq1Coproduct1(dictOrd11.Eq10());
        return {
            compare1: function(dictOrd) {
                var compare12 = compare1(dictOrd);
                var compare13 = compare11(dictOrd);
                return function(v) {
                    return function(v1) {
                        if (v instanceof $aKY4H.Left && v1 instanceof $aKY4H.Left) return compare12(v.value0)(v1.value0);
                        if (v instanceof $aKY4H.Left) return $6SDUu.LT.value;
                        if (v1 instanceof $aKY4H.Left) return $6SDUu.GT.value;
                        if (v instanceof $aKY4H.Right && v1 instanceof $aKY4H.Right) return compare13(v.value0)(v1.value0);
                        throw new Error("Failed pattern match at Data.Functor.Coproduct (line 57, column 5 - line 61, column 43): " + [
                            v.constructor.name,
                            v1.constructor.name
                        ]);
                    };
                };
            },
            Eq10: function() {
                return eq1Coproduct2;
            }
        };
    };
};
var $490ec114b4138e6d$export$f437f5dfb3faee67 = function(dictOrd1) {
    var ord1Coproduct1 = $490ec114b4138e6d$export$ec3d1f0587fb15ed(dictOrd1);
    var eqCoproduct1 = $490ec114b4138e6d$export$4f54a72d7417da7c(dictOrd1.Eq10());
    return function(dictOrd11) {
        var compare1 = $d0PPW.compare1(ord1Coproduct1(dictOrd11));
        var eqCoproduct2 = eqCoproduct1(dictOrd11.Eq10());
        return function(dictOrd) {
            var eqCoproduct3 = eqCoproduct2(dictOrd.Eq0());
            return {
                compare: compare1(dictOrd),
                Eq0: function() {
                    return eqCoproduct3;
                }
            };
        };
    };
};
var $490ec114b4138e6d$export$ab04af7daecb905f = function(v) {
    return function(v1) {
        return function(v2) {
            if (v2 instanceof $aKY4H.Left) return v(v2.value0);
            if (v2 instanceof $aKY4H.Right) return v1(v2.value0);
            throw new Error("Failed pattern match at Data.Functor.Coproduct (line 27, column 1 - line 27, column 78): " + [
                v.constructor.name,
                v1.constructor.name,
                v2.constructor.name
            ]);
        };
    };
};
var $490ec114b4138e6d$export$7ce1af5f45fd6777 = function(dictExtend) {
    var extend = $hfMWE.extend(dictExtend);
    var functorCoproduct1 = $490ec114b4138e6d$export$e192c0fa89a291cb(dictExtend.Functor0());
    return function(dictExtend1) {
        var extend1 = $hfMWE.extend(dictExtend1);
        var functorCoproduct2 = functorCoproduct1(dictExtend1.Functor0());
        return {
            extend: function(f) {
                var $106 = $490ec114b4138e6d$export$ab04af7daecb905f(function() {
                    var $108 = extend(function($110) {
                        return f($490ec114b4138e6d$export$a7f096464cca5f3a($aKY4H.Left.create($110)));
                    });
                    return function($109) {
                        return $aKY4H.Left.create($108($109));
                    };
                }())(function() {
                    var $111 = extend1(function($113) {
                        return f($490ec114b4138e6d$export$a7f096464cca5f3a($aKY4H.Right.create($113)));
                    });
                    return function($112) {
                        return $aKY4H.Right.create($111($112));
                    };
                }());
                return function($107) {
                    return $490ec114b4138e6d$export$a7f096464cca5f3a($106($107));
                };
            },
            Functor0: function() {
                return functorCoproduct2;
            }
        };
    };
};
var $490ec114b4138e6d$export$2f16914668ceb808 = function(dictComonad) {
    var extract = $frF73.extract(dictComonad);
    var extendCoproduct1 = $490ec114b4138e6d$export$7ce1af5f45fd6777(dictComonad.Extend0());
    return function(dictComonad1) {
        var extendCoproduct2 = extendCoproduct1(dictComonad1.Extend0());
        return {
            extract: $490ec114b4138e6d$export$ab04af7daecb905f(extract)($frF73.extract(dictComonad1)),
            Extend0: function() {
                return extendCoproduct2;
            }
        };
    };
};
var $490ec114b4138e6d$export$c1a518500c2ed5de = function(natF) {
    return function(natG) {
        return function(v) {
            return $490ec114b4138e6d$var$bimap(natF)(natG)(v);
        };
    };
};

});
parcelRegister("frF73", function(module, exports) {

$parcel$export(module.exports, "extract", () => $b3e944c79ac8b935$export$f9380c9a627682d3);
// Generated by purs version 0.15.16

var $hfMWE = parcelRequire("hfMWE");

var $l0wDR = parcelRequire("l0wDR");
var $b3e944c79ac8b935$export$f9380c9a627682d3 = function(dict) {
    return dict.extract;
};

});
parcelRegister("hfMWE", function(module, exports) {

$parcel$export(module.exports, "extend", () => $c8f9cdd14046b503$export$8b58be045bf06082);
$parcel$export(module.exports, "duplicate", () => $c8f9cdd14046b503$export$ecd5e8ace626722c);
$parcel$export(module.exports, "composeCoKleisliFlipped", () => $c8f9cdd14046b503$export$fbe89af2ce156300);
// Generated by purs version 0.15.16

var $bFKoO = parcelRequire("bFKoO");

var $7T8P4 = parcelRequire("7T8P4");

var $l0wDR = parcelRequire("l0wDR");

var $iwqgS = parcelRequire("iwqgS");
var $c8f9cdd14046b503$var$identity = /* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn);
var $c8f9cdd14046b503$export$cd01f0fbd2ca8bd6 = function(dictSemigroup) {
    var append = $iwqgS.append(dictSemigroup);
    return {
        extend: function(f) {
            return function(g) {
                return function(w) {
                    return f(function(w$prime) {
                        return g(append(w)(w$prime));
                    });
                };
            };
        },
        Functor0: function() {
            return $l0wDR.functorFn;
        }
    };
};
var $c8f9cdd14046b503$export$a321b0e45770af43 = {
    extend: $bFKoO.arrayExtend,
    Functor0: function() {
        return $l0wDR.functorArray;
    }
};
var $c8f9cdd14046b503$export$8b58be045bf06082 = function(dict) {
    return dict.extend;
};
var $c8f9cdd14046b503$export$285c6f9556cd75fc = function(dictExtend) {
    var extend1 = $c8f9cdd14046b503$export$8b58be045bf06082(dictExtend);
    return function(w) {
        return function(f) {
            return extend1(f)(w);
        };
    };
};
var $c8f9cdd14046b503$export$ecd5e8ace626722c = function(dictExtend) {
    return $c8f9cdd14046b503$export$8b58be045bf06082(dictExtend)($c8f9cdd14046b503$var$identity);
};
var $c8f9cdd14046b503$export$fbe89af2ce156300 = function(dictExtend) {
    var extend1 = $c8f9cdd14046b503$export$8b58be045bf06082(dictExtend);
    return function(f) {
        return function(g) {
            return function(w) {
                return f(extend1(g)(w));
            };
        };
    };
};
var $c8f9cdd14046b503$export$a868f0c7fe15a03f = function(dictExtend) {
    var extend1 = $c8f9cdd14046b503$export$8b58be045bf06082(dictExtend);
    return function(f) {
        return function(g) {
            return function(w) {
                return g(extend1(f)(w));
            };
        };
    };
};

});
parcelRegister("bFKoO", function(module, exports) {

$parcel$export(module.exports, "arrayExtend", () => $87f783ef0843fa28$export$2ed6d41c398ed712);
const $87f783ef0843fa28$export$2ed6d41c398ed712 = function(f) {
    return function(xs) {
        return xs.map(function(_, i, xs) {
            return f(xs.slice(i));
        });
    };
};

});



parcelRegister("2Mmje", function(module, exports) {

$parcel$export(module.exports, "bimap", () => $20615e99b278adf5$export$eb54baf0b342cb1d);
$parcel$export(module.exports, "lmap", () => $20615e99b278adf5$export$2ad466be2e2b0196);
$parcel$export(module.exports, "rmap", () => $20615e99b278adf5$export$6630987c9d273301);
$parcel$export(module.exports, "bifunctorTuple", () => $20615e99b278adf5$export$34a2521cb7920188);
$parcel$export(module.exports, "bifunctorEither", () => $20615e99b278adf5$export$9b66d4861c364eff);
$parcel$export(module.exports, "bifunctorConst", () => $20615e99b278adf5$export$52f77c2cc8ef8f31);
// Generated by purs version 0.15.16

var $7T8P4 = parcelRequire("7T8P4");

var $aKY4H = parcelRequire("aKY4H");

var $l4M7e = parcelRequire("l4M7e");

var $9MxTl = parcelRequire("9MxTl");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");
var $20615e99b278adf5$var$identity = /* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn);
var $20615e99b278adf5$export$eb54baf0b342cb1d = function(dict) {
    return dict.bimap;
};
var $20615e99b278adf5$export$4ec4986d7b23d5a5 = function(dictBifunctor) {
    return $20615e99b278adf5$export$eb54baf0b342cb1d(dictBifunctor)($l4M7e.const($r2HHk.unit))($l4M7e.const($r2HHk.unit));
};
var $20615e99b278adf5$export$2ad466be2e2b0196 = function(dictBifunctor) {
    var bimap1 = $20615e99b278adf5$export$eb54baf0b342cb1d(dictBifunctor);
    return function(f) {
        return bimap1(f)($20615e99b278adf5$var$identity);
    };
};
var $20615e99b278adf5$export$6630987c9d273301 = function(dictBifunctor) {
    return $20615e99b278adf5$export$eb54baf0b342cb1d(dictBifunctor)($20615e99b278adf5$var$identity);
};
var $20615e99b278adf5$export$34a2521cb7920188 = {
    bimap: function(f) {
        return function(g) {
            return function(v) {
                return new $9MxTl.Tuple(f(v.value0), g(v.value1));
            };
        };
    }
};
var $20615e99b278adf5$export$9b66d4861c364eff = {
    bimap: function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $aKY4H.Left) return new $aKY4H.Left(v(v2.value0));
                if (v2 instanceof $aKY4H.Right) return new $aKY4H.Right(v1(v2.value0));
                throw new Error("Failed pattern match at Data.Bifunctor (line 38, column 1 - line 40, column 36): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    }
};
var $20615e99b278adf5$export$52f77c2cc8ef8f31 = {
    bimap: function(f) {
        return function(v) {
            return function(v1) {
                return f(v1);
            };
        };
    }
};

});


parcelRegister("cxbq2", function(module, exports) {

$parcel$export(module.exports, "First", () => $92016ca92c497156$export$b25abba66f7be210);
$parcel$export(module.exports, "monoidFirst", () => $92016ca92c497156$export$db2423f7434b7a30);
$parcel$export(module.exports, "functorFirst", () => $92016ca92c497156$export$98d9d13e8b5bfe4d);
// Generated by purs version 0.15.16

var $ykHdR = parcelRequire("ykHdR");

var $aknDF = parcelRequire("aknDF");

var $iwqgS = parcelRequire("iwqgS");

var $3Orkn = parcelRequire("3Orkn");
var $92016ca92c497156$export$b25abba66f7be210 = function(x) {
    return x;
};
var $92016ca92c497156$export$20f833961f1940c8 = function(dictShow) {
    var show = $3Orkn.show($ykHdR.showMaybe(dictShow));
    return {
        show: function(v) {
            return "First (" + (show(v) + ")");
        }
    };
};
var $92016ca92c497156$export$53ff158b23f5d382 = {
    append: function(v) {
        return function(v1) {
            if (v instanceof $ykHdR.Just) return v;
            return v1;
        };
    }
};
var $92016ca92c497156$export$4d7d8eedf770f0 = function(dictOrd) {
    return $ykHdR.ordMaybe(dictOrd);
};
var $92016ca92c497156$export$f6a5e365037ccf9a = $ykHdR.ord1Maybe;
var $92016ca92c497156$export$130c32806db3fdc8 = {
    Coercible0: function() {
        return undefined;
    }
};
var $92016ca92c497156$export$db2423f7434b7a30 = /* #__PURE__ */ function() {
    return {
        mempty: $ykHdR.Nothing.value,
        Semigroup0: function() {
            return $92016ca92c497156$export$53ff158b23f5d382;
        }
    };
}();
var $92016ca92c497156$export$e17b0506de713d2e = $ykHdR.monadMaybe;
var $92016ca92c497156$export$6f62e1511455cb87 = $ykHdR.invariantMaybe;
var $92016ca92c497156$export$98d9d13e8b5bfe4d = $ykHdR.functorMaybe;
var $92016ca92c497156$export$590ee69b33ca98b4 = $ykHdR.extendMaybe;
var $92016ca92c497156$export$8232f15b0b41395c = function(dictEq) {
    return $ykHdR.eqMaybe(dictEq);
};
var $92016ca92c497156$export$1a969f11cd8a353e = $ykHdR.eq1Maybe;
var $92016ca92c497156$export$315f32b6f78e2785 = function(dictBounded) {
    return $ykHdR.boundedMaybe(dictBounded);
};
var $92016ca92c497156$export$456f8570baa6024f = $ykHdR.bindMaybe;
var $92016ca92c497156$export$e48e2da4536c2eea = $ykHdR.applyMaybe;
var $92016ca92c497156$export$178f5831973b2ff8 = $ykHdR.applicativeMaybe;
var $92016ca92c497156$export$5cfe42f95bdf312b = {
    alt: /* #__PURE__ */ $iwqgS.append($92016ca92c497156$export$53ff158b23f5d382),
    Functor0: function() {
        return $92016ca92c497156$export$98d9d13e8b5bfe4d;
    }
};
var $92016ca92c497156$export$e3c1997b7c0ee480 = {
    empty: /* #__PURE__ */ $aknDF.mempty($92016ca92c497156$export$db2423f7434b7a30),
    Alt0: function() {
        return $92016ca92c497156$export$5cfe42f95bdf312b;
    }
};
var $92016ca92c497156$export$92398121afed1258 = {
    Applicative0: function() {
        return $92016ca92c497156$export$178f5831973b2ff8;
    },
    Plus1: function() {
        return $92016ca92c497156$export$e3c1997b7c0ee480;
    }
};

});

parcelRegister("8JeQl", function(module, exports) {

$parcel$export(module.exports, "Conj", () => $65ae0a43a0950bac$export$c688766eb4789b8c);
$parcel$export(module.exports, "monoidConj", () => $65ae0a43a0950bac$export$4f2b093ea8408d89);
$parcel$export(module.exports, "functorConj", () => $65ae0a43a0950bac$export$48b7cf0194537bca);
// Generated by purs version 0.15.16

var $4MBcA = parcelRequire("4MBcA");

var $lnl7Y = parcelRequire("lnl7Y");

var $d0PPW = parcelRequire("d0PPW");

var $3Orkn = parcelRequire("3Orkn");
var $65ae0a43a0950bac$export$c688766eb4789b8c = function(x) {
    return x;
};
var $65ae0a43a0950bac$export$3e00b8f10f0f4e39 = function(dictShow) {
    var show = $3Orkn.show(dictShow);
    return {
        show: function(v) {
            return "(Conj " + (show(v) + ")");
        }
    };
};
var $65ae0a43a0950bac$export$b71164e0e6b84c70 = function(dictHeytingAlgebra) {
    var conj = $lnl7Y.conj(dictHeytingAlgebra);
    var disj = $lnl7Y.disj(dictHeytingAlgebra);
    return {
        zero: $lnl7Y.tt(dictHeytingAlgebra),
        one: $lnl7Y.ff(dictHeytingAlgebra),
        add: function(v) {
            return function(v1) {
                return conj(v)(v1);
            };
        },
        mul: function(v) {
            return function(v1) {
                return disj(v)(v1);
            };
        }
    };
};
var $65ae0a43a0950bac$export$91e0ef53a9c72523 = function(dictHeytingAlgebra) {
    var conj = $lnl7Y.conj(dictHeytingAlgebra);
    return {
        append: function(v) {
            return function(v1) {
                return conj(v)(v1);
            };
        }
    };
};
var $65ae0a43a0950bac$export$74eade9f2b920d02 = function(dictOrd) {
    return dictOrd;
};
var $65ae0a43a0950bac$export$4f2b093ea8408d89 = function(dictHeytingAlgebra) {
    var semigroupConj1 = $65ae0a43a0950bac$export$91e0ef53a9c72523(dictHeytingAlgebra);
    return {
        mempty: $lnl7Y.tt(dictHeytingAlgebra),
        Semigroup0: function() {
            return semigroupConj1;
        }
    };
};
var $65ae0a43a0950bac$export$48b7cf0194537bca = {
    map: function(f) {
        return function(m) {
            return f(m);
        };
    }
};
var $65ae0a43a0950bac$export$2d4ce045d5165d6f = function(dictEq) {
    return dictEq;
};
var $65ae0a43a0950bac$export$43823c09e8843bf5 = {
    eq1: function(dictEq) {
        return $4MBcA.eq($65ae0a43a0950bac$export$2d4ce045d5165d6f(dictEq));
    }
};
var $65ae0a43a0950bac$export$a6a01ce014de97e1 = {
    compare1: function(dictOrd) {
        return $d0PPW.compare($65ae0a43a0950bac$export$74eade9f2b920d02(dictOrd));
    },
    Eq10: function() {
        return $65ae0a43a0950bac$export$43823c09e8843bf5;
    }
};
var $65ae0a43a0950bac$export$a4102daba18ffc08 = function(dictBounded) {
    return dictBounded;
};
var $65ae0a43a0950bac$export$a163c218e9f2482b = {
    apply: function(v) {
        return function(v1) {
            return v(v1);
        };
    },
    Functor0: function() {
        return $65ae0a43a0950bac$export$48b7cf0194537bca;
    }
};
var $65ae0a43a0950bac$export$b79fdb9ffe29876e = {
    bind: function(v) {
        return function(f) {
            return f(v);
        };
    },
    Apply0: function() {
        return $65ae0a43a0950bac$export$a163c218e9f2482b;
    }
};
var $65ae0a43a0950bac$export$af9c11f53d676ebc = {
    pure: $65ae0a43a0950bac$export$c688766eb4789b8c,
    Apply0: function() {
        return $65ae0a43a0950bac$export$a163c218e9f2482b;
    }
};
var $65ae0a43a0950bac$export$7c7cf1e6ee225e25 = {
    Applicative0: function() {
        return $65ae0a43a0950bac$export$af9c11f53d676ebc;
    },
    Bind1: function() {
        return $65ae0a43a0950bac$export$b79fdb9ffe29876e;
    }
};

});

parcelRegister("1zczT", function(module, exports) {

$parcel$export(module.exports, "Disj", () => $1242d110ab1edcd9$export$286e7113895e33ef);
$parcel$export(module.exports, "monoidDisj", () => $1242d110ab1edcd9$export$e1c73e5b30670500);
$parcel$export(module.exports, "functorDisj", () => $1242d110ab1edcd9$export$410cd7ab647069e5);
// Generated by purs version 0.15.16

var $4MBcA = parcelRequire("4MBcA");

var $lnl7Y = parcelRequire("lnl7Y");

var $d0PPW = parcelRequire("d0PPW");

var $3Orkn = parcelRequire("3Orkn");
var $1242d110ab1edcd9$export$286e7113895e33ef = function(x) {
    return x;
};
var $1242d110ab1edcd9$export$84ed1543fc941c9a = function(dictShow) {
    var show = $3Orkn.show(dictShow);
    return {
        show: function(v) {
            return "(Disj " + (show(v) + ")");
        }
    };
};
var $1242d110ab1edcd9$export$5b0a7c2f35d7a492 = function(dictHeytingAlgebra) {
    var disj = $lnl7Y.disj(dictHeytingAlgebra);
    var conj = $lnl7Y.conj(dictHeytingAlgebra);
    return {
        zero: $lnl7Y.ff(dictHeytingAlgebra),
        one: $lnl7Y.tt(dictHeytingAlgebra),
        add: function(v) {
            return function(v1) {
                return disj(v)(v1);
            };
        },
        mul: function(v) {
            return function(v1) {
                return conj(v)(v1);
            };
        }
    };
};
var $1242d110ab1edcd9$export$f23e3b19aa9e04ea = function(dictHeytingAlgebra) {
    var disj = $lnl7Y.disj(dictHeytingAlgebra);
    return {
        append: function(v) {
            return function(v1) {
                return disj(v)(v1);
            };
        }
    };
};
var $1242d110ab1edcd9$export$5f1629868b2a8f7a = function(dictOrd) {
    return dictOrd;
};
var $1242d110ab1edcd9$export$e1c73e5b30670500 = function(dictHeytingAlgebra) {
    var semigroupDisj1 = $1242d110ab1edcd9$export$f23e3b19aa9e04ea(dictHeytingAlgebra);
    return {
        mempty: $lnl7Y.ff(dictHeytingAlgebra),
        Semigroup0: function() {
            return semigroupDisj1;
        }
    };
};
var $1242d110ab1edcd9$export$410cd7ab647069e5 = {
    map: function(f) {
        return function(m) {
            return f(m);
        };
    }
};
var $1242d110ab1edcd9$export$3f2868cf248cd7c5 = function(dictEq) {
    return dictEq;
};
var $1242d110ab1edcd9$export$8ab894b15d39baff = {
    eq1: function(dictEq) {
        return $4MBcA.eq($1242d110ab1edcd9$export$3f2868cf248cd7c5(dictEq));
    }
};
var $1242d110ab1edcd9$export$b2df6a05be54d5b7 = {
    compare1: function(dictOrd) {
        return $d0PPW.compare($1242d110ab1edcd9$export$5f1629868b2a8f7a(dictOrd));
    },
    Eq10: function() {
        return $1242d110ab1edcd9$export$8ab894b15d39baff;
    }
};
var $1242d110ab1edcd9$export$fcd058ea94ebee31 = function(dictBounded) {
    return dictBounded;
};
var $1242d110ab1edcd9$export$6e64deb0714631e6 = {
    apply: function(v) {
        return function(v1) {
            return v(v1);
        };
    },
    Functor0: function() {
        return $1242d110ab1edcd9$export$410cd7ab647069e5;
    }
};
var $1242d110ab1edcd9$export$997bc439fd07ce0b = {
    bind: function(v) {
        return function(f) {
            return f(v);
        };
    },
    Apply0: function() {
        return $1242d110ab1edcd9$export$6e64deb0714631e6;
    }
};
var $1242d110ab1edcd9$export$a5d698d68d7ba6f5 = {
    pure: $1242d110ab1edcd9$export$286e7113895e33ef,
    Apply0: function() {
        return $1242d110ab1edcd9$export$6e64deb0714631e6;
    }
};
var $1242d110ab1edcd9$export$15ab4d3c125d7ac0 = {
    Applicative0: function() {
        return $1242d110ab1edcd9$export$a5d698d68d7ba6f5;
    },
    Bind1: function() {
        return $1242d110ab1edcd9$export$997bc439fd07ce0b;
    }
};

});

parcelRegister("bbOAS", function(module, exports) {

$parcel$export(module.exports, "Dual", () => $8257f7a36ab9f9cd$export$c26a72e8d91adeec);
$parcel$export(module.exports, "semigroupDual", () => $8257f7a36ab9f9cd$export$dc7d4cd4865fc48);
$parcel$export(module.exports, "monoidDual", () => $8257f7a36ab9f9cd$export$b54c1e48d4afa3cb);
$parcel$export(module.exports, "functorDual", () => $8257f7a36ab9f9cd$export$916a3957c09e9ed5);
// Generated by purs version 0.15.16

var $4MBcA = parcelRequire("4MBcA");

var $aknDF = parcelRequire("aknDF");

var $d0PPW = parcelRequire("d0PPW");

var $iwqgS = parcelRequire("iwqgS");

var $3Orkn = parcelRequire("3Orkn");
var $8257f7a36ab9f9cd$export$c26a72e8d91adeec = function(x) {
    return x;
};
var $8257f7a36ab9f9cd$export$367774d50e2e283e = function(dictShow) {
    var show = $3Orkn.show(dictShow);
    return {
        show: function(v) {
            return "(Dual " + (show(v) + ")");
        }
    };
};
var $8257f7a36ab9f9cd$export$dc7d4cd4865fc48 = function(dictSemigroup) {
    var append1 = $iwqgS.append(dictSemigroup);
    return {
        append: function(v) {
            return function(v1) {
                return append1(v1)(v);
            };
        }
    };
};
var $8257f7a36ab9f9cd$export$baedc2c70a4ae2b1 = function(dictOrd) {
    return dictOrd;
};
var $8257f7a36ab9f9cd$export$b54c1e48d4afa3cb = function(dictMonoid) {
    var semigroupDual1 = $8257f7a36ab9f9cd$export$dc7d4cd4865fc48(dictMonoid.Semigroup0());
    return {
        mempty: $aknDF.mempty(dictMonoid),
        Semigroup0: function() {
            return semigroupDual1;
        }
    };
};
var $8257f7a36ab9f9cd$export$916a3957c09e9ed5 = {
    map: function(f) {
        return function(m) {
            return f(m);
        };
    }
};
var $8257f7a36ab9f9cd$export$2b6bf0b2b79b7623 = function(dictEq) {
    return dictEq;
};
var $8257f7a36ab9f9cd$export$334c9b177d56941 = {
    eq1: function(dictEq) {
        return $4MBcA.eq($8257f7a36ab9f9cd$export$2b6bf0b2b79b7623(dictEq));
    }
};
var $8257f7a36ab9f9cd$export$f00e1ac1e19e7381 = {
    compare1: function(dictOrd) {
        return $d0PPW.compare($8257f7a36ab9f9cd$export$baedc2c70a4ae2b1(dictOrd));
    },
    Eq10: function() {
        return $8257f7a36ab9f9cd$export$334c9b177d56941;
    }
};
var $8257f7a36ab9f9cd$export$5a3916bf05e599b0 = function(dictBounded) {
    return dictBounded;
};
var $8257f7a36ab9f9cd$export$9e642462d19ab815 = {
    apply: function(v) {
        return function(v1) {
            return v(v1);
        };
    },
    Functor0: function() {
        return $8257f7a36ab9f9cd$export$916a3957c09e9ed5;
    }
};
var $8257f7a36ab9f9cd$export$307a1784edb0cbc9 = {
    bind: function(v) {
        return function(f) {
            return f(v);
        };
    },
    Apply0: function() {
        return $8257f7a36ab9f9cd$export$9e642462d19ab815;
    }
};
var $8257f7a36ab9f9cd$export$f853c12137409deb = {
    pure: $8257f7a36ab9f9cd$export$c26a72e8d91adeec,
    Apply0: function() {
        return $8257f7a36ab9f9cd$export$9e642462d19ab815;
    }
};
var $8257f7a36ab9f9cd$export$965738b694a4882b = {
    Applicative0: function() {
        return $8257f7a36ab9f9cd$export$f853c12137409deb;
    },
    Bind1: function() {
        return $8257f7a36ab9f9cd$export$307a1784edb0cbc9;
    }
};

});

parcelRegister("7wVLo", function(module, exports) {

$parcel$export(module.exports, "Endo", () => $57b8542ac3131c5d$export$6aef3ff797629bec);
$parcel$export(module.exports, "monoidEndo", () => $57b8542ac3131c5d$export$947ca1a8eed6111);
// Generated by purs version 0.15.16

var $7T8P4 = parcelRequire("7T8P4");

var $7yzxp = parcelRequire("7yzxp");

var $3Orkn = parcelRequire("3Orkn");
var $57b8542ac3131c5d$export$6aef3ff797629bec = function(x) {
    return x;
};
var $57b8542ac3131c5d$export$e6887fe542fcbae3 = function(dictShow) {
    var show = $3Orkn.show(dictShow);
    return {
        show: function(v) {
            return "(Endo " + (show(v) + ")");
        }
    };
};
var $57b8542ac3131c5d$export$5f7c224ff60452b9 = function(dictSemigroupoid) {
    var compose = $7yzxp.compose(dictSemigroupoid);
    return {
        append: function(v) {
            return function(v1) {
                return compose(v)(v1);
            };
        }
    };
};
var $57b8542ac3131c5d$export$5f95a5e6b940187f = function(dictOrd) {
    return dictOrd;
};
var $57b8542ac3131c5d$export$947ca1a8eed6111 = function(dictCategory) {
    var semigroupEndo1 = $57b8542ac3131c5d$export$5f7c224ff60452b9(dictCategory.Semigroupoid0());
    return {
        mempty: $7T8P4.identity(dictCategory),
        Semigroup0: function() {
            return semigroupEndo1;
        }
    };
};
var $57b8542ac3131c5d$export$ee65626e0479baec = function(dictEq) {
    return dictEq;
};
var $57b8542ac3131c5d$export$35b120d2f621b3e2 = function(dictBounded) {
    return dictBounded;
};

});

parcelRegister("6PW1p", function(module, exports) {

$parcel$export(module.exports, "wrap", () => $4fa4836228a192cc$export$4997ffc0176396a6);
$parcel$export(module.exports, "unwrap", () => $4fa4836228a192cc$export$debb760848ca95a);
$parcel$export(module.exports, "un", () => $4fa4836228a192cc$export$a2a39c9747f0e54a);
$parcel$export(module.exports, "over", () => $4fa4836228a192cc$export$fb4902fd9e525693);
$parcel$export(module.exports, "alaF", () => $4fa4836228a192cc$export$b533eaec53aab18a);
$parcel$export(module.exports, "ala", () => $4fa4836228a192cc$export$7317c19c5df48291);
// Generated by purs version 0.15.16

var $e9Lv5 = parcelRequire("e9Lv5");
var $4fa4836228a192cc$var$coerce = /* #__PURE__ */ $e9Lv5.coerce();
var $4fa4836228a192cc$export$4997ffc0176396a6 = function() {
    return $4fa4836228a192cc$var$coerce;
};
var $4fa4836228a192cc$var$wrap1 = /* #__PURE__ */ $4fa4836228a192cc$export$4997ffc0176396a6();
var $4fa4836228a192cc$export$debb760848ca95a = function() {
    return $4fa4836228a192cc$var$coerce;
};
var $4fa4836228a192cc$var$unwrap1 = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $4fa4836228a192cc$export$5ac000a3404ef088 = function() {
    return function() {
        return function() {
            return function() {
                return function(v) {
                    return $4fa4836228a192cc$var$coerce;
                };
            };
        };
    };
};
var $4fa4836228a192cc$export$18fe6ced65b9d3a7 = function() {
    return function() {
        return function() {
            return function() {
                return function(v) {
                    return $4fa4836228a192cc$var$coerce;
                };
            };
        };
    };
};
var $4fa4836228a192cc$export$9824f93a497ba98e = function() {
    return function() {
        return function(v) {
            return $4fa4836228a192cc$var$coerce;
        };
    };
};
var $4fa4836228a192cc$export$3b98aa7d576b2b80 = function() {
    return function() {
        return function(v) {
            return $4fa4836228a192cc$var$coerce;
        };
    };
};
var $4fa4836228a192cc$export$a2a39c9747f0e54a = function() {
    return function(v) {
        return $4fa4836228a192cc$var$unwrap1;
    };
};
var $4fa4836228a192cc$export$df3f009e3d155b20 = function() {
    return function() {
        return function(v) {
            return $4fa4836228a192cc$var$coerce;
        };
    };
};
var $4fa4836228a192cc$export$f2787354896befb9 = function() {
    return function() {
        return function() {
            return function() {
                return function(v) {
                    return $4fa4836228a192cc$var$coerce;
                };
            };
        };
    };
};
var $4fa4836228a192cc$export$d0d3897f12fa9d17 = function() {
    return function() {
        return function() {
            return function() {
                return function(v) {
                    return $4fa4836228a192cc$var$coerce;
                };
            };
        };
    };
};
var $4fa4836228a192cc$export$e8dd23d7349f1a08 = function() {
    return function() {
        return function(v) {
            return $4fa4836228a192cc$var$coerce;
        };
    };
};
var $4fa4836228a192cc$export$fb4902fd9e525693 = function() {
    return function() {
        return function(v) {
            return $4fa4836228a192cc$var$coerce;
        };
    };
};
var $4fa4836228a192cc$export$cbef643c6d6f42c2 = {
    Coercible0: function() {
        return undefined;
    }
};
var $4fa4836228a192cc$export$ccaccac244187f64 = {
    Coercible0: function() {
        return undefined;
    }
};
var $4fa4836228a192cc$export$130c32806db3fdc8 = {
    Coercible0: function() {
        return undefined;
    }
};
var $4fa4836228a192cc$export$bae63404e9252557 = {
    Coercible0: function() {
        return undefined;
    }
};
var $4fa4836228a192cc$export$940059b52273aa56 = {
    Coercible0: function() {
        return undefined;
    }
};
var $4fa4836228a192cc$export$b77ba17f6321a9fb = {
    Coercible0: function() {
        return undefined;
    }
};
var $4fa4836228a192cc$export$59af3bbd6a00f6a9 = {
    Coercible0: function() {
        return undefined;
    }
};
var $4fa4836228a192cc$export$78c87ff68dcb8da2 = {
    Coercible0: function() {
        return undefined;
    }
};
var $4fa4836228a192cc$export$3ff57735a52b8713 = function() {
    return function(fn) {
        return function(t) {
            return $4fa4836228a192cc$var$wrap1(fn($4fa4836228a192cc$var$unwrap1(t)));
        };
    };
};
var $4fa4836228a192cc$export$bb44f104e3c54dae = function() {
    return function() {
        return function(v) {
            return $4fa4836228a192cc$var$coerce;
        };
    };
};
var $4fa4836228a192cc$export$b533eaec53aab18a = function() {
    return function() {
        return function() {
            return function() {
                return function(v) {
                    return $4fa4836228a192cc$var$coerce;
                };
            };
        };
    };
};
var $4fa4836228a192cc$export$7317c19c5df48291 = function() {
    return function() {
        return function() {
            return function(v) {
                return function(f) {
                    return $4fa4836228a192cc$var$coerce(f($4fa4836228a192cc$var$wrap1));
                };
            };
        };
    };
};

});
parcelRegister("e9Lv5", function(module, exports) {

$parcel$export(module.exports, "coerce", () => $a4e6c090e9e673b6$export$8c14e57e778d3873);
// Generated by purs version 0.15.16
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");
var $a4e6c090e9e673b6$export$8c14e57e778d3873 = function() {
    return $eOrGk.unsafeCoerce;
};

});



parcelRegister("1wR1l", function(module, exports) {

$parcel$export(module.exports, "traverse", () => $11d1e86de605dfc6$export$df3f009e3d155b20);
$parcel$export(module.exports, "traversableTuple", () => $11d1e86de605dfc6$export$d35878ee42638401);
$parcel$export(module.exports, "traversableMultiplicative", () => $11d1e86de605dfc6$export$b86a2d00788e21b6);
$parcel$export(module.exports, "traversableMaybe", () => $11d1e86de605dfc6$export$80f6258c17467741);
$parcel$export(module.exports, "traversableIdentity", () => $11d1e86de605dfc6$export$63e84f34fb558532);
$parcel$export(module.exports, "traversableEither", () => $11d1e86de605dfc6$export$29eea1300519490d);
$parcel$export(module.exports, "traversableDual", () => $11d1e86de605dfc6$export$54df524caf88dbea);
$parcel$export(module.exports, "traversableDisj", () => $11d1e86de605dfc6$export$a73c18000a1a08d7);
$parcel$export(module.exports, "traversableConst", () => $11d1e86de605dfc6$export$e6d8402c3fd7d14d);
$parcel$export(module.exports, "traversableConj", () => $11d1e86de605dfc6$export$ecbf0d941e1ac029);
$parcel$export(module.exports, "traversableCompose", () => $11d1e86de605dfc6$export$8c91a5391205dbe);
$parcel$export(module.exports, "traversableAdditive", () => $11d1e86de605dfc6$export$617ac6e03fd9951c);
$parcel$export(module.exports, "sequenceDefault", () => $11d1e86de605dfc6$export$417d88f64c497aed);
$parcel$export(module.exports, "traversableArray", () => $11d1e86de605dfc6$export$9e4a28683e28e26a);
$parcel$export(module.exports, "sequence", () => $11d1e86de605dfc6$export$49bb65c2ea163039);
$parcel$export(module.exports, "traversableApp", () => $11d1e86de605dfc6$export$744e1c7707f1991f);
$parcel$export(module.exports, "traversableCoproduct", () => $11d1e86de605dfc6$export$78124b32135c203a);
$parcel$export(module.exports, "traversableFirst", () => $11d1e86de605dfc6$export$1cee23aad9b21cdc);
$parcel$export(module.exports, "traversableLast", () => $11d1e86de605dfc6$export$f5923975fb28337f);
$parcel$export(module.exports, "traversableProduct", () => $11d1e86de605dfc6$export$261d8d87b1749d17);
// Generated by purs version 0.15.16

var $jtNss = parcelRequire("jtNss");

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $7T8P4 = parcelRequire("7T8P4");

var $1qMIU = parcelRequire("1qMIU");

var $aKY4H = parcelRequire("aKY4H");

var $6RkEA = parcelRequire("6RkEA");

var $l0wDR = parcelRequire("l0wDR");

var $8jFkD = parcelRequire("8jFkD");

var $8gI0w = parcelRequire("8gI0w");

var $6gSOm = parcelRequire("6gSOm");

var $dUqA2 = parcelRequire("dUqA2");

var $6VVZC = parcelRequire("6VVZC");

var $ykHdR = parcelRequire("ykHdR");

var $cxbq2 = parcelRequire("cxbq2");

var $2liqj = parcelRequire("2liqj");

var $jCCb5 = parcelRequire("jCCb5");

var $8JeQl = parcelRequire("8JeQl");

var $1zczT = parcelRequire("1zczT");

var $bbOAS = parcelRequire("bbOAS");

var $8MGTa = parcelRequire("8MGTa");
parcelRequire("dbQBZ");

var $fAYru = parcelRequire("fAYru");

var $9MxTl = parcelRequire("9MxTl");
var $11d1e86de605dfc6$var$identity = /* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn);
var $11d1e86de605dfc6$export$df3f009e3d155b20 = function(dict) {
    return dict.traverse;
};
var $11d1e86de605dfc6$export$d35878ee42638401 = {
    traverse: function(dictApplicative) {
        var map = $l0wDR.map(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return map($9MxTl.Tuple.create(v.value0))(f(v.value1));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map = $l0wDR.map(dictApplicative.Apply0().Functor0());
        return function(v) {
            return map($9MxTl.Tuple.create(v.value0))(v.value1);
        };
    },
    Functor0: function() {
        return $9MxTl.functorTuple;
    },
    Foldable1: function() {
        return $6RkEA.foldableTuple;
    }
};
var $11d1e86de605dfc6$export$b86a2d00788e21b6 = {
    traverse: function(dictApplicative) {
        var map = $l0wDR.map(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return map($8MGTa.Multiplicative)(f(v));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map = $l0wDR.map(dictApplicative.Apply0().Functor0());
        return function(v) {
            return map($8MGTa.Multiplicative)(v);
        };
    },
    Functor0: function() {
        return $8MGTa.functorMultiplicative;
    },
    Foldable1: function() {
        return $6RkEA.foldableMultiplicative;
    }
};
var $11d1e86de605dfc6$export$80f6258c17467741 = {
    traverse: function(dictApplicative) {
        var pure = $gUTA8.pure(dictApplicative);
        var map = $l0wDR.map(dictApplicative.Apply0().Functor0());
        return function(v) {
            return function(v1) {
                if (v1 instanceof $ykHdR.Nothing) return pure($ykHdR.Nothing.value);
                if (v1 instanceof $ykHdR.Just) return map($ykHdR.Just.create)(v(v1.value0));
                throw new Error("Failed pattern match at Data.Traversable (line 115, column 1 - line 119, column 33): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    },
    sequence: function(dictApplicative) {
        var pure = $gUTA8.pure(dictApplicative);
        var map = $l0wDR.map(dictApplicative.Apply0().Functor0());
        return function(v) {
            if (v instanceof $ykHdR.Nothing) return pure($ykHdR.Nothing.value);
            if (v instanceof $ykHdR.Just) return map($ykHdR.Just.create)(v.value0);
            throw new Error("Failed pattern match at Data.Traversable (line 115, column 1 - line 119, column 33): " + [
                v.constructor.name
            ]);
        };
    },
    Functor0: function() {
        return $ykHdR.functorMaybe;
    },
    Foldable1: function() {
        return $6RkEA.foldableMaybe;
    }
};
var $11d1e86de605dfc6$var$traverse1 = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$80f6258c17467741);
var $11d1e86de605dfc6$export$63e84f34fb558532 = {
    traverse: function(dictApplicative) {
        var map = $l0wDR.map(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return map($6VVZC.Identity)(f(v));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map = $l0wDR.map(dictApplicative.Apply0().Functor0());
        return function(v) {
            return map($6VVZC.Identity)(v);
        };
    },
    Functor0: function() {
        return $6VVZC.functorIdentity;
    },
    Foldable1: function() {
        return $6RkEA.foldableIdentity;
    }
};
var $11d1e86de605dfc6$export$29eea1300519490d = {
    traverse: function(dictApplicative) {
        var pure = $gUTA8.pure(dictApplicative);
        var map = $l0wDR.map(dictApplicative.Apply0().Functor0());
        return function(v) {
            return function(v1) {
                if (v1 instanceof $aKY4H.Left) return pure(new $aKY4H.Left(v1.value0));
                if (v1 instanceof $aKY4H.Right) return map($aKY4H.Right.create)(v(v1.value0));
                throw new Error("Failed pattern match at Data.Traversable (line 149, column 1 - line 153, column 36): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    },
    sequence: function(dictApplicative) {
        var pure = $gUTA8.pure(dictApplicative);
        var map = $l0wDR.map(dictApplicative.Apply0().Functor0());
        return function(v) {
            if (v instanceof $aKY4H.Left) return pure(new $aKY4H.Left(v.value0));
            if (v instanceof $aKY4H.Right) return map($aKY4H.Right.create)(v.value0);
            throw new Error("Failed pattern match at Data.Traversable (line 149, column 1 - line 153, column 36): " + [
                v.constructor.name
            ]);
        };
    },
    Functor0: function() {
        return $aKY4H.functorEither;
    },
    Foldable1: function() {
        return $6RkEA.foldableEither;
    }
};
var $11d1e86de605dfc6$export$54df524caf88dbea = {
    traverse: function(dictApplicative) {
        var map = $l0wDR.map(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return map($bbOAS.Dual)(f(v));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map = $l0wDR.map(dictApplicative.Apply0().Functor0());
        return function(v) {
            return map($bbOAS.Dual)(v);
        };
    },
    Functor0: function() {
        return $bbOAS.functorDual;
    },
    Foldable1: function() {
        return $6RkEA.foldableDual;
    }
};
var $11d1e86de605dfc6$export$a73c18000a1a08d7 = {
    traverse: function(dictApplicative) {
        var map = $l0wDR.map(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return map($1zczT.Disj)(f(v));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map = $l0wDR.map(dictApplicative.Apply0().Functor0());
        return function(v) {
            return map($1zczT.Disj)(v);
        };
    },
    Functor0: function() {
        return $1zczT.functorDisj;
    },
    Foldable1: function() {
        return $6RkEA.foldableDisj;
    }
};
var $11d1e86de605dfc6$export$e6d8402c3fd7d14d = {
    traverse: function(dictApplicative) {
        var pure = $gUTA8.pure(dictApplicative);
        return function(v) {
            return function(v1) {
                return pure(v1);
            };
        };
    },
    sequence: function(dictApplicative) {
        var pure = $gUTA8.pure(dictApplicative);
        return function(v) {
            return pure(v);
        };
    },
    Functor0: function() {
        return $1qMIU.functorConst;
    },
    Foldable1: function() {
        return $6RkEA.foldableConst;
    }
};
var $11d1e86de605dfc6$export$ecbf0d941e1ac029 = {
    traverse: function(dictApplicative) {
        var map = $l0wDR.map(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return map($8JeQl.Conj)(f(v));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map = $l0wDR.map(dictApplicative.Apply0().Functor0());
        return function(v) {
            return map($8JeQl.Conj)(v);
        };
    },
    Functor0: function() {
        return $8JeQl.functorConj;
    },
    Foldable1: function() {
        return $6RkEA.foldableConj;
    }
};
var $11d1e86de605dfc6$export$8c91a5391205dbe = function(dictTraversable) {
    var traverse2 = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable);
    var functorCompose = $8gI0w.functorCompose(dictTraversable.Functor0());
    var foldableCompose = $6RkEA.foldableCompose(dictTraversable.Foldable1());
    return function(dictTraversable1) {
        var traverse3 = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable1);
        var functorCompose1 = functorCompose(dictTraversable1.Functor0());
        var foldableCompose1 = foldableCompose(dictTraversable1.Foldable1());
        return {
            traverse: function(dictApplicative) {
                var map = $l0wDR.map(dictApplicative.Apply0().Functor0());
                var traverse4 = traverse2(dictApplicative);
                var traverse5 = traverse3(dictApplicative);
                return function(f) {
                    return function(v) {
                        return map($8gI0w.Compose)(traverse4(traverse5(f))(v));
                    };
                };
            },
            sequence: function(dictApplicative) {
                return $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$8c91a5391205dbe(dictTraversable)(dictTraversable1))(dictApplicative)($11d1e86de605dfc6$var$identity);
            },
            Functor0: function() {
                return functorCompose1;
            },
            Foldable1: function() {
                return foldableCompose1;
            }
        };
    };
};
var $11d1e86de605dfc6$export$617ac6e03fd9951c = {
    traverse: function(dictApplicative) {
        var map = $l0wDR.map(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return map($jCCb5.Additive)(f(v));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map = $l0wDR.map(dictApplicative.Apply0().Functor0());
        return function(v) {
            return map($jCCb5.Additive)(v);
        };
    },
    Functor0: function() {
        return $jCCb5.functorAdditive;
    },
    Foldable1: function() {
        return $6RkEA.foldableAdditive;
    }
};
var $11d1e86de605dfc6$export$417d88f64c497aed = function(dictTraversable) {
    var traverse2 = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable);
    return function(dictApplicative) {
        return traverse2(dictApplicative)($11d1e86de605dfc6$var$identity);
    };
};
var $11d1e86de605dfc6$export$9e4a28683e28e26a = {
    traverse: function(dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        return $jtNss.traverseArrayImpl($a5g3C.apply(Apply0))($l0wDR.map(Apply0.Functor0()))($gUTA8.pure(dictApplicative));
    },
    sequence: function(dictApplicative) {
        return $11d1e86de605dfc6$export$417d88f64c497aed($11d1e86de605dfc6$export$9e4a28683e28e26a)(dictApplicative);
    },
    Functor0: function() {
        return $l0wDR.functorArray;
    },
    Foldable1: function() {
        return $6RkEA.foldableArray;
    }
};
var $11d1e86de605dfc6$export$49bb65c2ea163039 = function(dict) {
    return dict.sequence;
};
var $11d1e86de605dfc6$var$sequence1 = /* #__PURE__ */ $11d1e86de605dfc6$export$49bb65c2ea163039($11d1e86de605dfc6$export$80f6258c17467741);
var $11d1e86de605dfc6$export$744e1c7707f1991f = function(dictTraversable) {
    var traverse2 = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable);
    var sequence2 = $11d1e86de605dfc6$export$49bb65c2ea163039(dictTraversable);
    var functorApp = $8jFkD.functorApp(dictTraversable.Functor0());
    var foldableApp = $6RkEA.foldableApp(dictTraversable.Foldable1());
    return {
        traverse: function(dictApplicative) {
            var map = $l0wDR.map(dictApplicative.Apply0().Functor0());
            var traverse3 = traverse2(dictApplicative);
            return function(f) {
                return function(v) {
                    return map($8jFkD.App)(traverse3(f)(v));
                };
            };
        },
        sequence: function(dictApplicative) {
            var map = $l0wDR.map(dictApplicative.Apply0().Functor0());
            var sequence3 = sequence2(dictApplicative);
            return function(v) {
                return map($8jFkD.App)(sequence3(v));
            };
        },
        Functor0: function() {
            return functorApp;
        },
        Foldable1: function() {
            return foldableApp;
        }
    };
};
var $11d1e86de605dfc6$export$78124b32135c203a = function(dictTraversable) {
    var traverse2 = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable);
    var sequence2 = $11d1e86de605dfc6$export$49bb65c2ea163039(dictTraversable);
    var functorCoproduct = $6gSOm.functorCoproduct(dictTraversable.Functor0());
    var foldableCoproduct = $6RkEA.foldableCoproduct(dictTraversable.Foldable1());
    return function(dictTraversable1) {
        var traverse3 = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable1);
        var sequence3 = $11d1e86de605dfc6$export$49bb65c2ea163039(dictTraversable1);
        var functorCoproduct1 = functorCoproduct(dictTraversable1.Functor0());
        var foldableCoproduct1 = foldableCoproduct(dictTraversable1.Foldable1());
        return {
            traverse: function(dictApplicative) {
                var map = $l0wDR.map(dictApplicative.Apply0().Functor0());
                var traverse4 = traverse2(dictApplicative);
                var traverse5 = traverse3(dictApplicative);
                return function(f) {
                    return $6gSOm.coproduct(function() {
                        var $313 = map(function($316) {
                            return $6gSOm.Coproduct($aKY4H.Left.create($316));
                        });
                        var $314 = traverse4(f);
                        return function($315) {
                            return $313($314($315));
                        };
                    }())(function() {
                        var $317 = map(function($320) {
                            return $6gSOm.Coproduct($aKY4H.Right.create($320));
                        });
                        var $318 = traverse5(f);
                        return function($319) {
                            return $317($318($319));
                        };
                    }());
                };
            },
            sequence: function(dictApplicative) {
                var map = $l0wDR.map(dictApplicative.Apply0().Functor0());
                return $6gSOm.coproduct(function() {
                    var $321 = map(function($324) {
                        return $6gSOm.Coproduct($aKY4H.Left.create($324));
                    });
                    var $322 = sequence2(dictApplicative);
                    return function($323) {
                        return $321($322($323));
                    };
                }())(function() {
                    var $325 = map(function($328) {
                        return $6gSOm.Coproduct($aKY4H.Right.create($328));
                    });
                    var $326 = sequence3(dictApplicative);
                    return function($327) {
                        return $325($326($327));
                    };
                }());
            },
            Functor0: function() {
                return functorCoproduct1;
            },
            Foldable1: function() {
                return foldableCoproduct1;
            }
        };
    };
};
var $11d1e86de605dfc6$export$1cee23aad9b21cdc = {
    traverse: function(dictApplicative) {
        var map = $l0wDR.map(dictApplicative.Apply0().Functor0());
        var traverse2 = $11d1e86de605dfc6$var$traverse1(dictApplicative);
        return function(f) {
            return function(v) {
                return map($cxbq2.First)(traverse2(f)(v));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map = $l0wDR.map(dictApplicative.Apply0().Functor0());
        var sequence2 = $11d1e86de605dfc6$var$sequence1(dictApplicative);
        return function(v) {
            return map($cxbq2.First)(sequence2(v));
        };
    },
    Functor0: function() {
        return $cxbq2.functorFirst;
    },
    Foldable1: function() {
        return $6RkEA.foldableFirst;
    }
};
var $11d1e86de605dfc6$export$f5923975fb28337f = {
    traverse: function(dictApplicative) {
        var map = $l0wDR.map(dictApplicative.Apply0().Functor0());
        var traverse2 = $11d1e86de605dfc6$var$traverse1(dictApplicative);
        return function(f) {
            return function(v) {
                return map($2liqj.Last)(traverse2(f)(v));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map = $l0wDR.map(dictApplicative.Apply0().Functor0());
        var sequence2 = $11d1e86de605dfc6$var$sequence1(dictApplicative);
        return function(v) {
            return map($2liqj.Last)(sequence2(v));
        };
    },
    Functor0: function() {
        return $2liqj.functorLast;
    },
    Foldable1: function() {
        return $6RkEA.foldableLast;
    }
};
var $11d1e86de605dfc6$export$261d8d87b1749d17 = function(dictTraversable) {
    var traverse2 = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable);
    var sequence2 = $11d1e86de605dfc6$export$49bb65c2ea163039(dictTraversable);
    var functorProduct = $dUqA2.functorProduct(dictTraversable.Functor0());
    var foldableProduct = $6RkEA.foldableProduct(dictTraversable.Foldable1());
    return function(dictTraversable1) {
        var traverse3 = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable1);
        var sequence3 = $11d1e86de605dfc6$export$49bb65c2ea163039(dictTraversable1);
        var functorProduct1 = functorProduct(dictTraversable1.Functor0());
        var foldableProduct1 = foldableProduct(dictTraversable1.Foldable1());
        return {
            traverse: function(dictApplicative) {
                var lift2 = $a5g3C.lift2(dictApplicative.Apply0());
                var traverse4 = traverse2(dictApplicative);
                var traverse5 = traverse3(dictApplicative);
                return function(f) {
                    return function(v) {
                        return lift2($dUqA2.product)(traverse4(f)(v.value0))(traverse5(f)(v.value1));
                    };
                };
            },
            sequence: function(dictApplicative) {
                var lift2 = $a5g3C.lift2(dictApplicative.Apply0());
                var sequence4 = sequence2(dictApplicative);
                var sequence5 = sequence3(dictApplicative);
                return function(v) {
                    return lift2($dUqA2.product)(sequence4(v.value0))(sequence5(v.value1));
                };
            },
            Functor0: function() {
                return functorProduct1;
            },
            Foldable1: function() {
                return foldableProduct1;
            }
        };
    };
};
var $11d1e86de605dfc6$export$d50a9c31d69ee13c = function(dictTraversable) {
    var sequence2 = $11d1e86de605dfc6$export$49bb65c2ea163039(dictTraversable);
    var map = $l0wDR.map(dictTraversable.Functor0());
    return function(dictApplicative) {
        var sequence3 = sequence2(dictApplicative);
        return function(f) {
            return function(ta) {
                return sequence3(map(f)(ta));
            };
        };
    };
};
var $11d1e86de605dfc6$export$d54b12b778292b35 = function(dictTraversable) {
    var traverse2 = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable)($fAYru.applicativeStateR);
    return function(f) {
        return function(s0) {
            return function(xs) {
                return $fAYru.stateR(traverse2(function(a) {
                    return function(s) {
                        return f(s)(a);
                    };
                })(xs))(s0);
            };
        };
    };
};
var $11d1e86de605dfc6$export$64df51ac031d4ad2 = function(dictTraversable) {
    var mapAccumR1 = $11d1e86de605dfc6$export$d54b12b778292b35(dictTraversable);
    return function(f) {
        return function(b0) {
            return function(xs) {
                return mapAccumR1(function(b) {
                    return function(a) {
                        var b$prime = f(a)(b);
                        return {
                            accum: b$prime,
                            value: b$prime
                        };
                    };
                })(b0)(xs).value;
            };
        };
    };
};
var $11d1e86de605dfc6$export$d5f444bb5e0f233 = function(dictTraversable) {
    var traverse2 = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable)($fAYru.applicativeStateL);
    return function(f) {
        return function(s0) {
            return function(xs) {
                return $fAYru.stateL(traverse2(function(a) {
                    return function(s) {
                        return f(s)(a);
                    };
                })(xs))(s0);
            };
        };
    };
};
var $11d1e86de605dfc6$export$65f513eaf3c582b8 = function(dictTraversable) {
    var mapAccumL1 = $11d1e86de605dfc6$export$d5f444bb5e0f233(dictTraversable);
    return function(f) {
        return function(b0) {
            return function(xs) {
                return mapAccumL1(function(b) {
                    return function(a) {
                        var b$prime = f(b)(a);
                        return {
                            accum: b$prime,
                            value: b$prime
                        };
                    };
                })(b0)(xs).value;
            };
        };
    };
};
var $11d1e86de605dfc6$export$f89de2e5bf57e5e6 = function(dictApplicative) {
    return function(dictTraversable) {
        var traverse2 = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable)(dictApplicative);
        return function(x) {
            return function(f) {
                return traverse2(f)(x);
            };
        };
    };
};

});
parcelRegister("jtNss", function(module, exports) {

$parcel$export(module.exports, "traverseArrayImpl", () => $e2e7171b55349aa8$export$778bf95e3da1fa51);
// jshint maxparams: 3
const $e2e7171b55349aa8$export$778bf95e3da1fa51 = function() {
    function array1(a) {
        return [
            a
        ];
    }
    function array2(a) {
        return function(b) {
            return [
                a,
                b
            ];
        };
    }
    function array3(a) {
        return function(b) {
            return function(c) {
                return [
                    a,
                    b,
                    c
                ];
            };
        };
    }
    function concat2(xs) {
        return function(ys) {
            return xs.concat(ys);
        };
    }
    return function(apply) {
        return function(map) {
            return function(pure) {
                return function(f) {
                    return function(array) {
                        function go(bot, top) {
                            switch(top - bot){
                                case 0:
                                    return pure([]);
                                case 1:
                                    return map(array1)(f(array[bot]));
                                case 2:
                                    return apply(map(array2)(f(array[bot])))(f(array[bot + 1]));
                                case 3:
                                    return apply(apply(map(array3)(f(array[bot])))(f(array[bot + 1])))(f(array[bot + 2]));
                                default:
                                    // This slightly tricky pivot selection aims to produce two
                                    // even-length partitions where possible.
                                    var pivot = bot + Math.floor((top - bot) / 4) * 2;
                                    return apply(map(concat2)(go(bot, pivot)))(go(pivot, top));
                            }
                        }
                        return go(0, array.length);
                    };
                };
            };
        };
    };
}();

});

parcelRegister("1qMIU", function(module, exports) {

$parcel$export(module.exports, "Const", () => $10ae0394c8c3139a$export$8ad5d15375e29446);
$parcel$export(module.exports, "functorConst", () => $10ae0394c8c3139a$export$c03820c48bf31fc8);
$parcel$export(module.exports, "applicativeConst", () => $10ae0394c8c3139a$export$38647a91a5af2717);
// Generated by purs version 0.15.16

var $4MBcA = parcelRequire("4MBcA");

var $5hqdn = parcelRequire("5hqdn");

var $aknDF = parcelRequire("aknDF");

var $d0PPW = parcelRequire("d0PPW");

var $iwqgS = parcelRequire("iwqgS");

var $3Orkn = parcelRequire("3Orkn");
var $10ae0394c8c3139a$export$8ad5d15375e29446 = function(x) {
    return x;
};
var $10ae0394c8c3139a$export$698fc26f8c8bb631 = function(dictShow) {
    var show = $3Orkn.show(dictShow);
    return {
        show: function(v) {
            return "(Const " + (show(v) + ")");
        }
    };
};
var $10ae0394c8c3139a$export$8e644eba3b05046b = function(dictSemiring) {
    return dictSemiring;
};
var $10ae0394c8c3139a$export$8f2711bf2f3160c6 = {
    compose: function(v) {
        return function(v1) {
            return v1;
        };
    }
};
var $10ae0394c8c3139a$export$6eaf1848e07ae857 = function(dictSemigroup) {
    return dictSemigroup;
};
var $10ae0394c8c3139a$export$e21edfc60fb6207c = function(dictRing) {
    return dictRing;
};
var $10ae0394c8c3139a$export$2dc639aba34e0026 = function(dictOrd) {
    return dictOrd;
};
var $10ae0394c8c3139a$export$ea93befd55cd9816 = {
    Coercible0: function() {
        return undefined;
    }
};
var $10ae0394c8c3139a$export$d484d0b1dc07b605 = function(dictMonoid) {
    return dictMonoid;
};
var $10ae0394c8c3139a$export$208a79db5ecd5bbf = function(dictHeytingAlgebra) {
    return dictHeytingAlgebra;
};
var $10ae0394c8c3139a$export$c03820c48bf31fc8 = {
    map: function(f) {
        return function(m) {
            return m;
        };
    }
};
var $10ae0394c8c3139a$export$30c2a66ea46ad17b = {
    imap: /* #__PURE__ */ $5hqdn.imapF($10ae0394c8c3139a$export$c03820c48bf31fc8)
};
var $10ae0394c8c3139a$export$aa81c0060845253 = function(dictEuclideanRing) {
    return dictEuclideanRing;
};
var $10ae0394c8c3139a$export$1688a037b5b692da = function(dictEq) {
    return dictEq;
};
var $10ae0394c8c3139a$export$bdb9acf61703c804 = function(dictEq) {
    var eq = $4MBcA.eq($10ae0394c8c3139a$export$1688a037b5b692da(dictEq));
    return {
        eq1: function(dictEq1) {
            return eq;
        }
    };
};
var $10ae0394c8c3139a$export$87702177ef8adff4 = function(dictOrd) {
    var compare = $d0PPW.compare($10ae0394c8c3139a$export$2dc639aba34e0026(dictOrd));
    var eq1Const1 = $10ae0394c8c3139a$export$bdb9acf61703c804(dictOrd.Eq0());
    return {
        compare1: function(dictOrd1) {
            return compare;
        },
        Eq10: function() {
            return eq1Const1;
        }
    };
};
var $10ae0394c8c3139a$export$c708f2c7ab030e40 = function(dictCommutativeRing) {
    return dictCommutativeRing;
};
var $10ae0394c8c3139a$export$9ca7ce64fd99d2e3 = function(dictBounded) {
    return dictBounded;
};
var $10ae0394c8c3139a$export$b7df7e3b07273a9c = function(dictBooleanAlgebra) {
    return dictBooleanAlgebra;
};
var $10ae0394c8c3139a$export$17ba89632b46bf87 = function(dictSemigroup) {
    var append1 = $iwqgS.append(dictSemigroup);
    return {
        apply: function(v) {
            return function(v1) {
                return append1(v)(v1);
            };
        },
        Functor0: function() {
            return $10ae0394c8c3139a$export$c03820c48bf31fc8;
        }
    };
};
var $10ae0394c8c3139a$export$38647a91a5af2717 = function(dictMonoid) {
    var mempty = $aknDF.mempty(dictMonoid);
    var applyConst1 = $10ae0394c8c3139a$export$17ba89632b46bf87(dictMonoid.Semigroup0());
    return {
        pure: function(v) {
            return mempty;
        },
        Apply0: function() {
            return applyConst1;
        }
    };
};

});

parcelRegister("8jFkD", function(module, exports) {

$parcel$export(module.exports, "App", () => $60e028b2ef4ceb5f$export$86fbec116b87613f);
$parcel$export(module.exports, "hoistLiftApp", () => $60e028b2ef4ceb5f$export$d26bca0552b37bb6);
$parcel$export(module.exports, "functorApp", () => $60e028b2ef4ceb5f$export$79ab389dc7ad1e04);
$parcel$export(module.exports, "eqApp", () => $60e028b2ef4ceb5f$export$ca57ebaecdc7d318);
$parcel$export(module.exports, "ordApp", () => $60e028b2ef4ceb5f$export$f5438903fac97fd7);
// Generated by purs version 0.15.16

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $4MBcA = parcelRequire("4MBcA");

var $aknDF = parcelRequire("aknDF");

var $d0PPW = parcelRequire("d0PPW");

var $iwqgS = parcelRequire("iwqgS");

var $3Orkn = parcelRequire("3Orkn");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");
var $60e028b2ef4ceb5f$export$86fbec116b87613f = function(x) {
    return x;
};
var $60e028b2ef4ceb5f$export$993a94e8f319ddca = function(dictShow) {
    var show = $3Orkn.show(dictShow);
    return {
        show: function(v) {
            return "(App " + (show(v) + ")");
        }
    };
};
var $60e028b2ef4ceb5f$export$25412483a1d87cf9 = function(dictApply) {
    var lift2 = $a5g3C.lift2(dictApply);
    return function(dictSemigroup) {
        var append1 = $iwqgS.append(dictSemigroup);
        return {
            append: function(v) {
                return function(v1) {
                    return lift2(append1)(v)(v1);
                };
            }
        };
    };
};
var $60e028b2ef4ceb5f$export$ca15fc0ee645d5ca = function(dictPlus) {
    return dictPlus;
};
var $60e028b2ef4ceb5f$export$d6896dcb1200915c = {
    Coercible0: function() {
        return undefined;
    }
};
var $60e028b2ef4ceb5f$export$4d0b678caa24727 = function(dictApplicative) {
    var pure = $gUTA8.pure(dictApplicative);
    var semigroupApp1 = $60e028b2ef4ceb5f$export$25412483a1d87cf9(dictApplicative.Apply0());
    return function(dictMonoid) {
        var semigroupApp2 = semigroupApp1(dictMonoid.Semigroup0());
        return {
            mempty: pure($aknDF.mempty(dictMonoid)),
            Semigroup0: function() {
                return semigroupApp2;
            }
        };
    };
};
var $60e028b2ef4ceb5f$export$5dee9c05ece04940 = function(dictMonadPlus) {
    return dictMonadPlus;
};
var $60e028b2ef4ceb5f$export$6a01a2292278ad36 = function(dictMonad) {
    return dictMonad;
};
var $60e028b2ef4ceb5f$export$aef3f1b3df1ccc91 = function(dictLazy) {
    return dictLazy;
};
var $60e028b2ef4ceb5f$export$74e988bb94b714ec = $eOrGk.unsafeCoerce;
var $60e028b2ef4ceb5f$export$d26bca0552b37bb6 = $eOrGk.unsafeCoerce;
var $60e028b2ef4ceb5f$export$e5247fd078351cb8 = function(f) {
    return function(v) {
        return f(v);
    };
};
var $60e028b2ef4ceb5f$export$79ab389dc7ad1e04 = function(dictFunctor) {
    return dictFunctor;
};
var $60e028b2ef4ceb5f$export$4392ba23127b7f7e = function(dictExtend) {
    return dictExtend;
};
var $60e028b2ef4ceb5f$export$ca57ebaecdc7d318 = function(dictEq1) {
    var eq1 = $4MBcA.eq1(dictEq1);
    return function(dictEq) {
        var eq11 = eq1(dictEq);
        return {
            eq: function(x) {
                return function(y) {
                    return eq11(x)(y);
                };
            }
        };
    };
};
var $60e028b2ef4ceb5f$export$f5438903fac97fd7 = function(dictOrd1) {
    var compare1 = $d0PPW.compare1(dictOrd1);
    var eqApp1 = $60e028b2ef4ceb5f$export$ca57ebaecdc7d318(dictOrd1.Eq10());
    return function(dictOrd) {
        var compare11 = compare1(dictOrd);
        var eqApp2 = eqApp1(dictOrd.Eq0());
        return {
            compare: function(x) {
                return function(y) {
                    return compare11(x)(y);
                };
            },
            Eq0: function() {
                return eqApp2;
            }
        };
    };
};
var $60e028b2ef4ceb5f$export$878272f7ccf91d14 = function(dictEq1) {
    var eqApp1 = $60e028b2ef4ceb5f$export$ca57ebaecdc7d318(dictEq1);
    return {
        eq1: function(dictEq) {
            return $4MBcA.eq(eqApp1(dictEq));
        }
    };
};
var $60e028b2ef4ceb5f$export$594a740e645fec3d = function(dictOrd1) {
    var ordApp1 = $60e028b2ef4ceb5f$export$f5438903fac97fd7(dictOrd1);
    var eq1App1 = $60e028b2ef4ceb5f$export$878272f7ccf91d14(dictOrd1.Eq10());
    return {
        compare1: function(dictOrd) {
            return $d0PPW.compare(ordApp1(dictOrd));
        },
        Eq10: function() {
            return eq1App1;
        }
    };
};
var $60e028b2ef4ceb5f$export$7470af1a1433fe40 = function(dictComonad) {
    return dictComonad;
};
var $60e028b2ef4ceb5f$export$a9edb76092ee7d6f = function(dictBind) {
    return dictBind;
};
var $60e028b2ef4ceb5f$export$e73125860a07eff3 = function(dictApply) {
    return dictApply;
};
var $60e028b2ef4ceb5f$export$3550db4068efefdd = function(dictApplicative) {
    return dictApplicative;
};
var $60e028b2ef4ceb5f$export$afc0b729746e2971 = function(dictAlternative) {
    return dictAlternative;
};
var $60e028b2ef4ceb5f$export$69ee13496a90cde5 = function(dictAlt) {
    return dictAlt;
};

});

parcelRegister("8gI0w", function(module, exports) {

$parcel$export(module.exports, "Compose", () => $6051f44ece6b7171$export$5a3a146e358e1bcf);
$parcel$export(module.exports, "functorCompose", () => $6051f44ece6b7171$export$4e14cb014c72d19c);
$parcel$export(module.exports, "eqCompose", () => $6051f44ece6b7171$export$861bef6ec455b19c);
$parcel$export(module.exports, "applyCompose", () => $6051f44ece6b7171$export$6b631277dc31d20d);
$parcel$export(module.exports, "altCompose", () => $6051f44ece6b7171$export$b9fb31044795461);
$parcel$export(module.exports, "plusCompose", () => $6051f44ece6b7171$export$2f025d423e425357);
// Generated by purs version 0.15.16

var $a7Dxq = parcelRequire("a7Dxq");

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $axmEP = parcelRequire("axmEP");

var $4MBcA = parcelRequire("4MBcA");

var $l0wDR = parcelRequire("l0wDR");

var $8jFkD = parcelRequire("8jFkD");

var $d0PPW = parcelRequire("d0PPW");

var $3Orkn = parcelRequire("3Orkn");
var $6051f44ece6b7171$export$5a3a146e358e1bcf = function(x) {
    return x;
};
var $6051f44ece6b7171$export$48988665210796c9 = function(dictShow) {
    var show = $3Orkn.show(dictShow);
    return {
        show: function(v) {
            return "(Compose " + (show(v) + ")");
        }
    };
};
var $6051f44ece6b7171$export$db82d32400573da6 = {
    Coercible0: function() {
        return undefined;
    }
};
var $6051f44ece6b7171$export$4e14cb014c72d19c = function(dictFunctor) {
    var map = $l0wDR.map(dictFunctor);
    return function(dictFunctor1) {
        var map1 = $l0wDR.map(dictFunctor1);
        return {
            map: function(f) {
                return function(v) {
                    return map(map1(f))(v);
                };
            }
        };
    };
};
var $6051f44ece6b7171$export$861bef6ec455b19c = function(dictEq1) {
    var eq1 = $4MBcA.eq1(dictEq1);
    return function(dictEq11) {
        var eqApp = $8jFkD.eqApp(dictEq11);
        return function(dictEq) {
            var eq11 = eq1(eqApp(dictEq));
            return {
                eq: function(v) {
                    return function(v1) {
                        return eq11($8jFkD.hoistLiftApp(v))($8jFkD.hoistLiftApp(v1));
                    };
                }
            };
        };
    };
};
var $6051f44ece6b7171$export$71b54a761b111692 = function(dictOrd1) {
    var compare1 = $d0PPW.compare1(dictOrd1);
    var eqCompose1 = $6051f44ece6b7171$export$861bef6ec455b19c(dictOrd1.Eq10());
    return function(dictOrd11) {
        var ordApp = $8jFkD.ordApp(dictOrd11);
        var eqCompose2 = eqCompose1(dictOrd11.Eq10());
        return function(dictOrd) {
            var compare11 = compare1(ordApp(dictOrd));
            var eqCompose3 = eqCompose2(dictOrd.Eq0());
            return {
                compare: function(v) {
                    return function(v1) {
                        return compare11($8jFkD.hoistLiftApp(v))($8jFkD.hoistLiftApp(v1));
                    };
                },
                Eq0: function() {
                    return eqCompose3;
                }
            };
        };
    };
};
var $6051f44ece6b7171$export$cbe2b7f63279884c = function(dictEq1) {
    var eqCompose1 = $6051f44ece6b7171$export$861bef6ec455b19c(dictEq1);
    return function(dictEq11) {
        var eqCompose2 = eqCompose1(dictEq11);
        return {
            eq1: function(dictEq) {
                return $4MBcA.eq(eqCompose2(dictEq));
            }
        };
    };
};
var $6051f44ece6b7171$export$d435219eb92d4b50 = function(dictOrd1) {
    var ordCompose1 = $6051f44ece6b7171$export$71b54a761b111692(dictOrd1);
    var eq1Compose1 = $6051f44ece6b7171$export$cbe2b7f63279884c(dictOrd1.Eq10());
    return function(dictOrd11) {
        var ordCompose2 = ordCompose1(dictOrd11);
        var eq1Compose2 = eq1Compose1(dictOrd11.Eq10());
        return {
            compare1: function(dictOrd) {
                return $d0PPW.compare(ordCompose2(dictOrd));
            },
            Eq10: function() {
                return eq1Compose2;
            }
        };
    };
};
var $6051f44ece6b7171$export$6ac747c53920df53 = function(dictFunctor) {
    var map = $l0wDR.map(dictFunctor);
    return function(natF) {
        return function(natG) {
            return function(v) {
                return natF(map(natG)(v));
            };
        };
    };
};
var $6051f44ece6b7171$export$6b631277dc31d20d = function(dictApply) {
    var apply = $a5g3C.apply(dictApply);
    var Functor0 = dictApply.Functor0();
    var map = $l0wDR.map(Functor0);
    var functorCompose1 = $6051f44ece6b7171$export$4e14cb014c72d19c(Functor0);
    return function(dictApply1) {
        var apply1 = $a5g3C.apply(dictApply1);
        var functorCompose2 = functorCompose1(dictApply1.Functor0());
        return {
            apply: function(v) {
                return function(v1) {
                    return apply(map(apply1)(v))(v1);
                };
            },
            Functor0: function() {
                return functorCompose2;
            }
        };
    };
};
var $6051f44ece6b7171$export$ce6787b8eb4a9f48 = function(dictApplicative) {
    var pure = $gUTA8.pure(dictApplicative);
    var applyCompose1 = $6051f44ece6b7171$export$6b631277dc31d20d(dictApplicative.Apply0());
    return function(dictApplicative1) {
        var applyCompose2 = applyCompose1(dictApplicative1.Apply0());
        return {
            pure: function() {
                var $112 = $gUTA8.pure(dictApplicative1);
                return function($113) {
                    return $6051f44ece6b7171$export$5a3a146e358e1bcf(pure($112($113)));
                };
            }(),
            Apply0: function() {
                return applyCompose2;
            }
        };
    };
};
var $6051f44ece6b7171$export$b9fb31044795461 = function(dictAlt) {
    var alt = $a7Dxq.alt(dictAlt);
    var functorCompose1 = $6051f44ece6b7171$export$4e14cb014c72d19c(dictAlt.Functor0());
    return function(dictFunctor) {
        var functorCompose2 = functorCompose1(dictFunctor);
        return {
            alt: function(v) {
                return function(v1) {
                    return alt(v)(v1);
                };
            },
            Functor0: function() {
                return functorCompose2;
            }
        };
    };
};
var $6051f44ece6b7171$export$2f025d423e425357 = function(dictPlus) {
    var empty = $axmEP.empty(dictPlus);
    var altCompose1 = $6051f44ece6b7171$export$b9fb31044795461(dictPlus.Alt0());
    return function(dictFunctor) {
        var altCompose2 = altCompose1(dictFunctor);
        return {
            empty: empty,
            Alt0: function() {
                return altCompose2;
            }
        };
    };
};
var $6051f44ece6b7171$export$3bf64fe887e680d3 = function(dictAlternative) {
    var applicativeCompose1 = $6051f44ece6b7171$export$ce6787b8eb4a9f48(dictAlternative.Applicative0());
    var plusCompose1 = $6051f44ece6b7171$export$2f025d423e425357(dictAlternative.Plus1());
    return function(dictApplicative) {
        var applicativeCompose2 = applicativeCompose1(dictApplicative);
        var plusCompose2 = plusCompose1(dictApplicative.Apply0().Functor0());
        return {
            Applicative0: function() {
                return applicativeCompose2;
            },
            Plus1: function() {
                return plusCompose2;
            }
        };
    };
};

});

parcelRegister("dUqA2", function(module, exports) {

$parcel$export(module.exports, "product", () => $a2051f9edf3d1db6$export$dbd0f18357df1ddd);
$parcel$export(module.exports, "functorProduct", () => $a2051f9edf3d1db6$export$e5b52224642d1f48);
// Generated by purs version 0.15.16

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $9Grh5 = parcelRequire("9Grh5");

var $2Mmje = parcelRequire("2Mmje");

var $4MBcA = parcelRequire("4MBcA");

var $l0wDR = parcelRequire("l0wDR");

var $6PW1p = parcelRequire("6PW1p");

var $d0PPW = parcelRequire("d0PPW");

var $6SDUu = parcelRequire("6SDUu");

var $3Orkn = parcelRequire("3Orkn");

var $9MxTl = parcelRequire("9MxTl");
var $a2051f9edf3d1db6$var$bimap = /* #__PURE__ */ $2Mmje.bimap($2Mmje.bifunctorTuple);
var $a2051f9edf3d1db6$var$unwrap = /* #__PURE__ */ $6PW1p.unwrap();
var $a2051f9edf3d1db6$export$264ad599d7cef668 = function(x) {
    return x;
};
var $a2051f9edf3d1db6$export$821c121fea76e4f5 = function(dictShow) {
    var show = $3Orkn.show(dictShow);
    return function(dictShow1) {
        var show1 = $3Orkn.show(dictShow1);
        return {
            show: function(v) {
                return "(product " + (show(v.value0) + (" " + (show1(v.value1) + ")")));
            }
        };
    };
};
var $a2051f9edf3d1db6$export$dbd0f18357df1ddd = function(fa) {
    return function(ga) {
        return new $9MxTl.Tuple(fa, ga);
    };
};
var $a2051f9edf3d1db6$export$7ea85e95f1a9febc = {
    Coercible0: function() {
        return undefined;
    }
};
var $a2051f9edf3d1db6$export$e5b52224642d1f48 = function(dictFunctor) {
    var map = $l0wDR.map(dictFunctor);
    return function(dictFunctor1) {
        var map1 = $l0wDR.map(dictFunctor1);
        return {
            map: function(f) {
                return function(v) {
                    return $a2051f9edf3d1db6$var$bimap(map(f))(map1(f))(v);
                };
            }
        };
    };
};
var $a2051f9edf3d1db6$export$df541bd41566d1a7 = function(dictEq1) {
    var eq1 = $4MBcA.eq1(dictEq1);
    return function(dictEq11) {
        var eq11 = $4MBcA.eq1(dictEq11);
        return {
            eq1: function(dictEq) {
                var eq12 = eq1(dictEq);
                var eq13 = eq11(dictEq);
                return function(v) {
                    return function(v1) {
                        return eq12(v.value0)(v1.value0) && eq13(v.value1)(v1.value1);
                    };
                };
            }
        };
    };
};
var $a2051f9edf3d1db6$export$e82658b20fc49a26 = function(dictEq1) {
    var eq1Product1 = $a2051f9edf3d1db6$export$df541bd41566d1a7(dictEq1);
    return function(dictEq11) {
        var eq1 = $4MBcA.eq1(eq1Product1(dictEq11));
        return function(dictEq) {
            return {
                eq: eq1(dictEq)
            };
        };
    };
};
var $a2051f9edf3d1db6$export$b9dd7b4b85c7c1b7 = function(dictOrd1) {
    var compare1 = $d0PPW.compare1(dictOrd1);
    var eq1Product1 = $a2051f9edf3d1db6$export$df541bd41566d1a7(dictOrd1.Eq10());
    return function(dictOrd11) {
        var compare11 = $d0PPW.compare1(dictOrd11);
        var eq1Product2 = eq1Product1(dictOrd11.Eq10());
        return {
            compare1: function(dictOrd) {
                var compare12 = compare1(dictOrd);
                var compare13 = compare11(dictOrd);
                return function(v) {
                    return function(v1) {
                        var v2 = compare12(v.value0)(v1.value0);
                        if (v2 instanceof $6SDUu.EQ) return compare13(v.value1)(v1.value1);
                        return v2;
                    };
                };
            },
            Eq10: function() {
                return eq1Product2;
            }
        };
    };
};
var $a2051f9edf3d1db6$export$96856f3fc4c91454 = function(dictOrd1) {
    var ord1Product1 = $a2051f9edf3d1db6$export$b9dd7b4b85c7c1b7(dictOrd1);
    var eqProduct1 = $a2051f9edf3d1db6$export$e82658b20fc49a26(dictOrd1.Eq10());
    return function(dictOrd11) {
        var compare1 = $d0PPW.compare1(ord1Product1(dictOrd11));
        var eqProduct2 = eqProduct1(dictOrd11.Eq10());
        return function(dictOrd) {
            var eqProduct3 = eqProduct2(dictOrd.Eq0());
            return {
                compare: compare1(dictOrd),
                Eq0: function() {
                    return eqProduct3;
                }
            };
        };
    };
};
var $a2051f9edf3d1db6$export$a3738445608c58d6 = function(natF) {
    return function(natG) {
        return function(v) {
            return $a2051f9edf3d1db6$var$bimap(natF)(natG)(v);
        };
    };
};
var $a2051f9edf3d1db6$export$893d0f454e6dfaee = function(dictApply) {
    var apply = $a5g3C.apply(dictApply);
    var functorProduct1 = $a2051f9edf3d1db6$export$e5b52224642d1f48(dictApply.Functor0());
    return function(dictApply1) {
        var apply1 = $a5g3C.apply(dictApply1);
        var functorProduct2 = functorProduct1(dictApply1.Functor0());
        return {
            apply: function(v) {
                return function(v1) {
                    return $a2051f9edf3d1db6$export$dbd0f18357df1ddd(apply(v.value0)(v1.value0))(apply1(v.value1)(v1.value1));
                };
            },
            Functor0: function() {
                return functorProduct2;
            }
        };
    };
};
var $a2051f9edf3d1db6$export$5990c3ca6a566877 = function(dictBind) {
    var bind = $9Grh5.bind(dictBind);
    var applyProduct1 = $a2051f9edf3d1db6$export$893d0f454e6dfaee(dictBind.Apply0());
    return function(dictBind1) {
        var bind1 = $9Grh5.bind(dictBind1);
        var applyProduct2 = applyProduct1(dictBind1.Apply0());
        return {
            bind: function(v) {
                return function(f) {
                    return $a2051f9edf3d1db6$export$dbd0f18357df1ddd(bind(v.value0)(function($128) {
                        return $9MxTl.fst($a2051f9edf3d1db6$var$unwrap(f($128)));
                    }))(bind1(v.value1)(function($129) {
                        return $9MxTl.snd($a2051f9edf3d1db6$var$unwrap(f($129)));
                    }));
                };
            },
            Apply0: function() {
                return applyProduct2;
            }
        };
    };
};
var $a2051f9edf3d1db6$export$2034ae3acf01a9af = function(dictApplicative) {
    var pure = $gUTA8.pure(dictApplicative);
    var applyProduct1 = $a2051f9edf3d1db6$export$893d0f454e6dfaee(dictApplicative.Apply0());
    return function(dictApplicative1) {
        var pure1 = $gUTA8.pure(dictApplicative1);
        var applyProduct2 = applyProduct1(dictApplicative1.Apply0());
        return {
            pure: function(a) {
                return $a2051f9edf3d1db6$export$dbd0f18357df1ddd(pure(a))(pure1(a));
            },
            Apply0: function() {
                return applyProduct2;
            }
        };
    };
};
var $a2051f9edf3d1db6$export$2dfe129c60aea5cb = function(dictMonad) {
    var applicativeProduct1 = $a2051f9edf3d1db6$export$2034ae3acf01a9af(dictMonad.Applicative0());
    var bindProduct1 = $a2051f9edf3d1db6$export$5990c3ca6a566877(dictMonad.Bind1());
    return function(dictMonad1) {
        var applicativeProduct2 = applicativeProduct1(dictMonad1.Applicative0());
        var bindProduct2 = bindProduct1(dictMonad1.Bind1());
        return {
            Applicative0: function() {
                return applicativeProduct2;
            },
            Bind1: function() {
                return bindProduct2;
            }
        };
    };
};

});

parcelRegister("2liqj", function(module, exports) {

$parcel$export(module.exports, "Last", () => $1b4bd570fcdcddf2$export$bed9238d8933c9a8);
$parcel$export(module.exports, "functorLast", () => $1b4bd570fcdcddf2$export$74aba74241121413);
// Generated by purs version 0.15.16

var $ykHdR = parcelRequire("ykHdR");

var $aknDF = parcelRequire("aknDF");

var $iwqgS = parcelRequire("iwqgS");

var $3Orkn = parcelRequire("3Orkn");
var $1b4bd570fcdcddf2$export$bed9238d8933c9a8 = function(x) {
    return x;
};
var $1b4bd570fcdcddf2$export$1e0d830d3054d46d = function(dictShow) {
    var show = $3Orkn.show($ykHdR.showMaybe(dictShow));
    return {
        show: function(v) {
            return "(Last " + (show(v) + ")");
        }
    };
};
var $1b4bd570fcdcddf2$export$6d3c4648150c5bae = {
    append: function(v) {
        return function(v1) {
            if (v1 instanceof $ykHdR.Just) return v1;
            if (v1 instanceof $ykHdR.Nothing) return v;
            throw new Error("Failed pattern match at Data.Maybe.Last (line 54, column 1 - line 56, column 36): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    }
};
var $1b4bd570fcdcddf2$export$4ded69d4b0c99b7b = function(dictOrd) {
    return $ykHdR.ordMaybe(dictOrd);
};
var $1b4bd570fcdcddf2$export$64bd44ceff2f4638 = $ykHdR.ord1Maybe;
var $1b4bd570fcdcddf2$export$ccaccac244187f64 = {
    Coercible0: function() {
        return undefined;
    }
};
var $1b4bd570fcdcddf2$export$862bb074dbe2690f = /* #__PURE__ */ function() {
    return {
        mempty: $ykHdR.Nothing.value,
        Semigroup0: function() {
            return $1b4bd570fcdcddf2$export$6d3c4648150c5bae;
        }
    };
}();
var $1b4bd570fcdcddf2$export$25d122cd3cbaf721 = $ykHdR.monadMaybe;
var $1b4bd570fcdcddf2$export$21558e167578c47d = $ykHdR.invariantMaybe;
var $1b4bd570fcdcddf2$export$74aba74241121413 = $ykHdR.functorMaybe;
var $1b4bd570fcdcddf2$export$7f096d1e61d1725f = $ykHdR.extendMaybe;
var $1b4bd570fcdcddf2$export$4dd70ef4fbe4d1f3 = function(dictEq) {
    return $ykHdR.eqMaybe(dictEq);
};
var $1b4bd570fcdcddf2$export$634a54207b73ac14 = $ykHdR.eq1Maybe;
var $1b4bd570fcdcddf2$export$835f68c2f339b021 = function(dictBounded) {
    return $ykHdR.boundedMaybe(dictBounded);
};
var $1b4bd570fcdcddf2$export$f2b93d1f1ac78d51 = $ykHdR.bindMaybe;
var $1b4bd570fcdcddf2$export$dcd798c84777f95 = $ykHdR.applyMaybe;
var $1b4bd570fcdcddf2$export$5b4de68c5dd33934 = $ykHdR.applicativeMaybe;
var $1b4bd570fcdcddf2$export$a0374697fe7c8648 = {
    alt: /* #__PURE__ */ $iwqgS.append($1b4bd570fcdcddf2$export$6d3c4648150c5bae),
    Functor0: function() {
        return $1b4bd570fcdcddf2$export$74aba74241121413;
    }
};
var $1b4bd570fcdcddf2$export$1bb9770eb80691dd = {
    empty: /* #__PURE__ */ $aknDF.mempty($1b4bd570fcdcddf2$export$862bb074dbe2690f),
    Alt0: function() {
        return $1b4bd570fcdcddf2$export$a0374697fe7c8648;
    }
};
var $1b4bd570fcdcddf2$export$bc87013f8f3da20e = {
    Applicative0: function() {
        return $1b4bd570fcdcddf2$export$5b4de68c5dd33934;
    },
    Plus1: function() {
        return $1b4bd570fcdcddf2$export$1bb9770eb80691dd;
    }
};

});

parcelRegister("jCCb5", function(module, exports) {

$parcel$export(module.exports, "Additive", () => $e48f2e41a907ae60$export$14f8ce08180a98e1);
$parcel$export(module.exports, "semigroupAdditive", () => $e48f2e41a907ae60$export$8adb2de2291fe34);
$parcel$export(module.exports, "monoidAdditive", () => $e48f2e41a907ae60$export$c38b62d29991685f);
$parcel$export(module.exports, "functorAdditive", () => $e48f2e41a907ae60$export$ba106ed6ee21ba26);
// Generated by purs version 0.15.16

var $4MBcA = parcelRequire("4MBcA");

var $d0PPW = parcelRequire("d0PPW");

var $gyPYh = parcelRequire("gyPYh");

var $3Orkn = parcelRequire("3Orkn");
var $e48f2e41a907ae60$export$14f8ce08180a98e1 = function(x) {
    return x;
};
var $e48f2e41a907ae60$export$d0709814982cbf95 = function(dictShow) {
    var show = $3Orkn.show(dictShow);
    return {
        show: function(v) {
            return "(Additive " + (show(v) + ")");
        }
    };
};
var $e48f2e41a907ae60$export$8adb2de2291fe34 = function(dictSemiring) {
    var add = $gyPYh.add(dictSemiring);
    return {
        append: function(v) {
            return function(v1) {
                return add(v)(v1);
            };
        }
    };
};
var $e48f2e41a907ae60$export$45e15fb7ca2189d8 = function(dictOrd) {
    return dictOrd;
};
var $e48f2e41a907ae60$export$c38b62d29991685f = function(dictSemiring) {
    var semigroupAdditive1 = $e48f2e41a907ae60$export$8adb2de2291fe34(dictSemiring);
    return {
        mempty: $gyPYh.zero(dictSemiring),
        Semigroup0: function() {
            return semigroupAdditive1;
        }
    };
};
var $e48f2e41a907ae60$export$ba106ed6ee21ba26 = {
    map: function(f) {
        return function(m) {
            return f(m);
        };
    }
};
var $e48f2e41a907ae60$export$7e0cae55dbdaa6a6 = function(dictEq) {
    return dictEq;
};
var $e48f2e41a907ae60$export$3bc4d3e676a5f3ba = {
    eq1: function(dictEq) {
        return $4MBcA.eq($e48f2e41a907ae60$export$7e0cae55dbdaa6a6(dictEq));
    }
};
var $e48f2e41a907ae60$export$bf0109c88461ccc9 = {
    compare1: function(dictOrd) {
        return $d0PPW.compare($e48f2e41a907ae60$export$45e15fb7ca2189d8(dictOrd));
    },
    Eq10: function() {
        return $e48f2e41a907ae60$export$3bc4d3e676a5f3ba;
    }
};
var $e48f2e41a907ae60$export$ac1ed4a2f2107898 = function(dictBounded) {
    return dictBounded;
};
var $e48f2e41a907ae60$export$9ed13d4e91f74d66 = {
    apply: function(v) {
        return function(v1) {
            return v(v1);
        };
    },
    Functor0: function() {
        return $e48f2e41a907ae60$export$ba106ed6ee21ba26;
    }
};
var $e48f2e41a907ae60$export$3c0293aa90d839fe = {
    bind: function(v) {
        return function(f) {
            return f(v);
        };
    },
    Apply0: function() {
        return $e48f2e41a907ae60$export$9ed13d4e91f74d66;
    }
};
var $e48f2e41a907ae60$export$3f78fbeb96209a2 = {
    pure: $e48f2e41a907ae60$export$14f8ce08180a98e1,
    Apply0: function() {
        return $e48f2e41a907ae60$export$9ed13d4e91f74d66;
    }
};
var $e48f2e41a907ae60$export$50439d128d692efb = {
    Applicative0: function() {
        return $e48f2e41a907ae60$export$3f78fbeb96209a2;
    },
    Bind1: function() {
        return $e48f2e41a907ae60$export$3c0293aa90d839fe;
    }
};

});

parcelRegister("8MGTa", function(module, exports) {

$parcel$export(module.exports, "Multiplicative", () => $665413393090e9d0$export$d0198c9c86fc2be1);
$parcel$export(module.exports, "functorMultiplicative", () => $665413393090e9d0$export$fb489b392661d391);
// Generated by purs version 0.15.16

var $4MBcA = parcelRequire("4MBcA");

var $d0PPW = parcelRequire("d0PPW");

var $gyPYh = parcelRequire("gyPYh");

var $3Orkn = parcelRequire("3Orkn");
var $665413393090e9d0$export$d0198c9c86fc2be1 = function(x) {
    return x;
};
var $665413393090e9d0$export$27987c20bfe6da1c = function(dictShow) {
    var show = $3Orkn.show(dictShow);
    return {
        show: function(v) {
            return "(Multiplicative " + (show(v) + ")");
        }
    };
};
var $665413393090e9d0$export$879165283e0876da = function(dictSemiring) {
    var mul = $gyPYh.mul(dictSemiring);
    return {
        append: function(v) {
            return function(v1) {
                return mul(v)(v1);
            };
        }
    };
};
var $665413393090e9d0$export$a745aa1873a0c2a6 = function(dictOrd) {
    return dictOrd;
};
var $665413393090e9d0$export$b1fd47ce92821578 = function(dictSemiring) {
    var semigroupMultiplicative1 = $665413393090e9d0$export$879165283e0876da(dictSemiring);
    return {
        mempty: $gyPYh.one(dictSemiring),
        Semigroup0: function() {
            return semigroupMultiplicative1;
        }
    };
};
var $665413393090e9d0$export$fb489b392661d391 = {
    map: function(f) {
        return function(m) {
            return f(m);
        };
    }
};
var $665413393090e9d0$export$d7079d8ae90b8bb4 = function(dictEq) {
    return dictEq;
};
var $665413393090e9d0$export$989c1e5544f0c166 = {
    eq1: function(dictEq) {
        return $4MBcA.eq($665413393090e9d0$export$d7079d8ae90b8bb4(dictEq));
    }
};
var $665413393090e9d0$export$fecaa24314ae6d78 = {
    compare1: function(dictOrd) {
        return $d0PPW.compare($665413393090e9d0$export$a745aa1873a0c2a6(dictOrd));
    },
    Eq10: function() {
        return $665413393090e9d0$export$989c1e5544f0c166;
    }
};
var $665413393090e9d0$export$bbf6fde3198eeb4e = function(dictBounded) {
    return dictBounded;
};
var $665413393090e9d0$export$4270b48d12c8e2c9 = {
    apply: function(v) {
        return function(v1) {
            return v(v1);
        };
    },
    Functor0: function() {
        return $665413393090e9d0$export$fb489b392661d391;
    }
};
var $665413393090e9d0$export$b787e2c352a5d886 = {
    bind: function(v) {
        return function(f) {
            return f(v);
        };
    },
    Apply0: function() {
        return $665413393090e9d0$export$4270b48d12c8e2c9;
    }
};
var $665413393090e9d0$export$98fc700c14e70ff0 = {
    pure: $665413393090e9d0$export$d0198c9c86fc2be1,
    Apply0: function() {
        return $665413393090e9d0$export$4270b48d12c8e2c9;
    }
};
var $665413393090e9d0$export$8980d206f063bc12 = {
    Applicative0: function() {
        return $665413393090e9d0$export$98fc700c14e70ff0;
    },
    Bind1: function() {
        return $665413393090e9d0$export$b787e2c352a5d886;
    }
};

});

parcelRegister("dbQBZ", function(module, exports) {
// Generated by purs version 0.15.16

});

parcelRegister("fAYru", function(module, exports) {

$parcel$export(module.exports, "stateR", () => $b5a91a6cc4fccdbd$export$8c9fed8401f25951);
$parcel$export(module.exports, "stateL", () => $b5a91a6cc4fccdbd$export$25c41c6231a79e25);
$parcel$export(module.exports, "applicativeStateR", () => $b5a91a6cc4fccdbd$export$c4ee441de2fba0d9);
$parcel$export(module.exports, "applicativeStateL", () => $b5a91a6cc4fccdbd$export$9fd2229713491b84);
// Generated by purs version 0.15.16
var $b5a91a6cc4fccdbd$export$e55c55b7b44ad601 = function(x) {
    return x;
};
var $b5a91a6cc4fccdbd$export$28dda4bfb631a565 = function(x) {
    return x;
};
var $b5a91a6cc4fccdbd$export$8c9fed8401f25951 = function(v) {
    return v;
};
var $b5a91a6cc4fccdbd$export$25c41c6231a79e25 = function(v) {
    return v;
};
var $b5a91a6cc4fccdbd$export$c9b79b3c57c3d6cd = {
    map: function(f) {
        return function(k) {
            return function(s) {
                var v = $b5a91a6cc4fccdbd$export$8c9fed8401f25951(k)(s);
                return {
                    accum: v.accum,
                    value: f(v.value)
                };
            };
        };
    }
};
var $b5a91a6cc4fccdbd$export$b9d5be898ea82056 = {
    map: function(f) {
        return function(k) {
            return function(s) {
                var v = $b5a91a6cc4fccdbd$export$25c41c6231a79e25(k)(s);
                return {
                    accum: v.accum,
                    value: f(v.value)
                };
            };
        };
    }
};
var $b5a91a6cc4fccdbd$export$68347817ab3710ea = {
    apply: function(f) {
        return function(x) {
            return function(s) {
                var v = $b5a91a6cc4fccdbd$export$8c9fed8401f25951(x)(s);
                var v1 = $b5a91a6cc4fccdbd$export$8c9fed8401f25951(f)(v.accum);
                return {
                    accum: v1.accum,
                    value: v1.value(v.value)
                };
            };
        };
    },
    Functor0: function() {
        return $b5a91a6cc4fccdbd$export$c9b79b3c57c3d6cd;
    }
};
var $b5a91a6cc4fccdbd$export$d997dc0aadd0b300 = {
    apply: function(f) {
        return function(x) {
            return function(s) {
                var v = $b5a91a6cc4fccdbd$export$25c41c6231a79e25(f)(s);
                var v1 = $b5a91a6cc4fccdbd$export$25c41c6231a79e25(x)(v.accum);
                return {
                    accum: v1.accum,
                    value: v.value(v1.value)
                };
            };
        };
    },
    Functor0: function() {
        return $b5a91a6cc4fccdbd$export$b9d5be898ea82056;
    }
};
var $b5a91a6cc4fccdbd$export$c4ee441de2fba0d9 = {
    pure: function(a) {
        return function(s) {
            return {
                accum: s,
                value: a
            };
        };
    },
    Apply0: function() {
        return $b5a91a6cc4fccdbd$export$68347817ab3710ea;
    }
};
var $b5a91a6cc4fccdbd$export$9fd2229713491b84 = {
    pure: function(a) {
        return function(s) {
            return {
                accum: s,
                value: a
            };
        };
    },
    Apply0: function() {
        return $b5a91a6cc4fccdbd$export$d997dc0aadd0b300;
    }
};

});




parcelRegister("9DlYk", function(module, exports) {

$parcel$export(module.exports, "monadTransMaybeT", () => $7038ccc2f7f5bbce$export$84eda9cb75492c36);
$parcel$export(module.exports, "monadMaybeT", () => $7038ccc2f7f5bbce$export$63cf87c0678a1d2c);
$parcel$export(module.exports, "applyMaybeT", () => $7038ccc2f7f5bbce$export$2fa55c29b4f8d86e);
$parcel$export(module.exports, "monadEffectMaybe", () => $7038ccc2f7f5bbce$export$2f876a9cb1e407d9);
// Generated by purs version 0.15.16

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $9Grh5 = parcelRequire("9Grh5");

var $7T8P4 = parcelRequire("7T8P4");

var $ibtPS = parcelRequire("ibtPS");

var $8UXl5 = parcelRequire("8UXl5");

var $84kZf = parcelRequire("84kZf");

var $9ZRMq = parcelRequire("9ZRMq");

var $lowBm = parcelRequire("lowBm");

var $iYXib = parcelRequire("iYXib");

var $kQAxW = parcelRequire("kQAxW");

var $4PFx6 = parcelRequire("4PFx6");

var $3NKEZ = parcelRequire("3NKEZ");

var $l0wDR = parcelRequire("l0wDR");

var $ykHdR = parcelRequire("ykHdR");

var $aknDF = parcelRequire("aknDF");

var $iwqgS = parcelRequire("iwqgS");

var $9MxTl = parcelRequire("9MxTl");

var $kQlZ1 = parcelRequire("kQlZ1");
var $7038ccc2f7f5bbce$var$map = /* #__PURE__ */ $l0wDR.map($ykHdR.functorMaybe);
var $7038ccc2f7f5bbce$var$identity = /* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn);
var $7038ccc2f7f5bbce$export$ad3c05b40854bc17 = function(x) {
    return x;
};
var $7038ccc2f7f5bbce$export$74b507a1130daad6 = function(v) {
    return v;
};
var $7038ccc2f7f5bbce$export$e423059046893ebc = {
    Coercible0: function() {
        return undefined;
    }
};
var $7038ccc2f7f5bbce$export$84eda9cb75492c36 = {
    lift: function(dictMonad) {
        var $163 = $ibtPS.liftM1(dictMonad)($ykHdR.Just.create);
        return function($164) {
            return $7038ccc2f7f5bbce$export$ad3c05b40854bc17($163($164));
        };
    }
};
var $7038ccc2f7f5bbce$var$lift = /* #__PURE__ */ $4PFx6.lift($7038ccc2f7f5bbce$export$84eda9cb75492c36);
var $7038ccc2f7f5bbce$export$d0ac118ccd5cda07 = function(f) {
    return function(v) {
        return f(v);
    };
};
var $7038ccc2f7f5bbce$export$3bf77092340654e0 = function(dictFunctor) {
    var map1 = $l0wDR.map(dictFunctor);
    return {
        map: function(f) {
            return function(v) {
                return map1($7038ccc2f7f5bbce$var$map(f))(v);
            };
        }
    };
};
var $7038ccc2f7f5bbce$export$63cf87c0678a1d2c = function(dictMonad) {
    return {
        Applicative0: function() {
            return $7038ccc2f7f5bbce$export$4797150488333da1(dictMonad);
        },
        Bind1: function() {
            return $7038ccc2f7f5bbce$export$c4ec8f671a263573(dictMonad);
        }
    };
};
var $7038ccc2f7f5bbce$export$c4ec8f671a263573 = function(dictMonad) {
    var bind = $9Grh5.bind(dictMonad.Bind1());
    var pure = $gUTA8.pure(dictMonad.Applicative0());
    return {
        bind: function(v) {
            return function(f) {
                return bind(v)(function(v1) {
                    if (v1 instanceof $ykHdR.Nothing) return pure($ykHdR.Nothing.value);
                    if (v1 instanceof $ykHdR.Just) {
                        var v2 = f(v1.value0);
                        return v2;
                    }
                    throw new Error("Failed pattern match at Control.Monad.Maybe.Trans (line 55, column 11 - line 57, column 42): " + [
                        v1.constructor.name
                    ]);
                });
            };
        },
        Apply0: function() {
            return $7038ccc2f7f5bbce$export$2fa55c29b4f8d86e(dictMonad);
        }
    };
};
var $7038ccc2f7f5bbce$export$2fa55c29b4f8d86e = function(dictMonad) {
    var functorMaybeT1 = $7038ccc2f7f5bbce$export$3bf77092340654e0(dictMonad.Bind1().Apply0().Functor0());
    return {
        apply: $ibtPS.ap($7038ccc2f7f5bbce$export$63cf87c0678a1d2c(dictMonad)),
        Functor0: function() {
            return functorMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$4797150488333da1 = function(dictMonad) {
    return {
        pure: function() {
            var $165 = $gUTA8.pure(dictMonad.Applicative0());
            return function($166) {
                return $7038ccc2f7f5bbce$export$ad3c05b40854bc17($165($ykHdR.Just.create($166)));
            };
        }(),
        Apply0: function() {
            return $7038ccc2f7f5bbce$export$2fa55c29b4f8d86e(dictMonad);
        }
    };
};
var $7038ccc2f7f5bbce$export$984e03b79d8c6656 = function(dictMonad) {
    var lift2 = $a5g3C.lift2($7038ccc2f7f5bbce$export$2fa55c29b4f8d86e(dictMonad));
    return function(dictSemigroup) {
        return {
            append: lift2($iwqgS.append(dictSemigroup))
        };
    };
};
var $7038ccc2f7f5bbce$export$36c6624b0bef0761 = function(dictMonadAsk) {
    var Monad0 = dictMonadAsk.Monad0();
    var monadMaybeT1 = $7038ccc2f7f5bbce$export$63cf87c0678a1d2c(Monad0);
    return {
        ask: $7038ccc2f7f5bbce$var$lift(Monad0)($9ZRMq.ask(dictMonadAsk)),
        Monad0: function() {
            return monadMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$d73769631c0edb39 = function(dictMonadReader) {
    var local = $9ZRMq.local(dictMonadReader);
    var monadAskMaybeT1 = $7038ccc2f7f5bbce$export$36c6624b0bef0761(dictMonadReader.MonadAsk0());
    return {
        local: function(f) {
            return $7038ccc2f7f5bbce$export$d0ac118ccd5cda07(local(f));
        },
        MonadAsk0: function() {
            return monadAskMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$ec6a88a02083ed25 = function(dictMonadCont) {
    var callCC = $8UXl5.callCC(dictMonadCont);
    var monadMaybeT1 = $7038ccc2f7f5bbce$export$63cf87c0678a1d2c(dictMonadCont.Monad0());
    return {
        callCC: function(f) {
            return callCC(function(c) {
                var v = f(function(a) {
                    return c(new $ykHdR.Just(a));
                });
                return v;
            });
        },
        Monad0: function() {
            return monadMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$2f876a9cb1e407d9 = function(dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var monadMaybeT1 = $7038ccc2f7f5bbce$export$63cf87c0678a1d2c(Monad0);
    return {
        liftEffect: function() {
            var $167 = $7038ccc2f7f5bbce$var$lift(Monad0);
            var $168 = $kQlZ1.liftEffect(dictMonadEffect);
            return function($169) {
                return $167($168($169));
            };
        }(),
        Monad0: function() {
            return monadMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$7b9e3f37a9f7f6b2 = function(dictMonadRec) {
    var tailRecM = $lowBm.tailRecM(dictMonadRec);
    var Monad0 = dictMonadRec.Monad0();
    var bind = $9Grh5.bind(Monad0.Bind1());
    var pure = $gUTA8.pure(Monad0.Applicative0());
    var monadMaybeT1 = $7038ccc2f7f5bbce$export$63cf87c0678a1d2c(Monad0);
    return {
        tailRecM: function(f) {
            var $170 = tailRecM(function(a) {
                var v = f(a);
                return bind(v)(function(m$prime) {
                    return pure(function() {
                        if (m$prime instanceof $ykHdR.Nothing) return new $lowBm.Done($ykHdR.Nothing.value);
                        if (m$prime instanceof $ykHdR.Just && m$prime.value0 instanceof $lowBm.Loop) return new $lowBm.Loop(m$prime.value0.value0);
                        if (m$prime instanceof $ykHdR.Just && m$prime.value0 instanceof $lowBm.Done) return new $lowBm.Done(new $ykHdR.Just(m$prime.value0.value0));
                        throw new Error("Failed pattern match at Control.Monad.Maybe.Trans (line 83, column 16 - line 86, column 43): " + [
                            m$prime.constructor.name
                        ]);
                    }());
                });
            });
            return function($171) {
                return $7038ccc2f7f5bbce$export$ad3c05b40854bc17($170($171));
            };
        },
        Monad0: function() {
            return monadMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$99cfcc8edd025934 = function(dictMonadState) {
    var Monad0 = dictMonadState.Monad0();
    var lift1 = $7038ccc2f7f5bbce$var$lift(Monad0);
    var state = $kQAxW.state(dictMonadState);
    var monadMaybeT1 = $7038ccc2f7f5bbce$export$63cf87c0678a1d2c(Monad0);
    return {
        state: function(f) {
            return lift1(state(f));
        },
        Monad0: function() {
            return monadMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$907950ecc201e8fb = function(dictMonadTell) {
    var Monad1 = dictMonadTell.Monad1();
    var Semigroup0 = dictMonadTell.Semigroup0();
    var monadMaybeT1 = $7038ccc2f7f5bbce$export$63cf87c0678a1d2c(Monad1);
    return {
        tell: function() {
            var $172 = $7038ccc2f7f5bbce$var$lift(Monad1);
            var $173 = $3NKEZ.tell(dictMonadTell);
            return function($174) {
                return $172($173($174));
            };
        }(),
        Semigroup0: function() {
            return Semigroup0;
        },
        Monad1: function() {
            return monadMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$5afebe755b331e96 = function(dictMonadWriter) {
    var MonadTell1 = dictMonadWriter.MonadTell1();
    var Monad1 = MonadTell1.Monad1();
    var bind = $9Grh5.bind(Monad1.Bind1());
    var listen = $3NKEZ.listen(dictMonadWriter);
    var pure = $gUTA8.pure(Monad1.Applicative0());
    var pass = $3NKEZ.pass(dictMonadWriter);
    var Monoid0 = dictMonadWriter.Monoid0();
    var monadTellMaybeT1 = $7038ccc2f7f5bbce$export$907950ecc201e8fb(MonadTell1);
    return {
        listen: $7038ccc2f7f5bbce$export$d0ac118ccd5cda07(function(m) {
            return bind(listen(m))(function(v) {
                return pure($7038ccc2f7f5bbce$var$map(function(r) {
                    return new $9MxTl.Tuple(r, v.value1);
                })(v.value0));
            });
        }),
        pass: $7038ccc2f7f5bbce$export$d0ac118ccd5cda07(function(m) {
            return pass(bind(m)(function(a) {
                return pure(function() {
                    if (a instanceof $ykHdR.Nothing) return new $9MxTl.Tuple($ykHdR.Nothing.value, $7038ccc2f7f5bbce$var$identity);
                    if (a instanceof $ykHdR.Just) return new $9MxTl.Tuple(new $ykHdR.Just(a.value0.value0), a.value0.value1);
                    throw new Error("Failed pattern match at Control.Monad.Maybe.Trans (line 120, column 10 - line 122, column 43): " + [
                        a.constructor.name
                    ]);
                }());
            }));
        }),
        Monoid0: function() {
            return Monoid0;
        },
        MonadTell1: function() {
            return monadTellMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$8908e8a28a021e1c = function(dictMonadThrow) {
    var Monad0 = dictMonadThrow.Monad0();
    var lift1 = $7038ccc2f7f5bbce$var$lift(Monad0);
    var throwError = $84kZf.throwError(dictMonadThrow);
    var monadMaybeT1 = $7038ccc2f7f5bbce$export$63cf87c0678a1d2c(Monad0);
    return {
        throwError: function(e) {
            return lift1(throwError(e));
        },
        Monad0: function() {
            return monadMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$f77b055a7835b1d0 = function(dictMonadError) {
    var catchError = $84kZf.catchError(dictMonadError);
    var monadThrowMaybeT1 = $7038ccc2f7f5bbce$export$8908e8a28a021e1c(dictMonadError.MonadThrow0());
    return {
        catchError: function(v) {
            return function(h) {
                return catchError(v)(function(a) {
                    var v1 = h(a);
                    return v1;
                });
            };
        },
        MonadThrow0: function() {
            return monadThrowMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$4033508ee81d9e59 = function(dictMonadST) {
    var Monad0 = dictMonadST.Monad0();
    var monadMaybeT1 = $7038ccc2f7f5bbce$export$63cf87c0678a1d2c(Monad0);
    return {
        liftST: function() {
            var $175 = $7038ccc2f7f5bbce$var$lift(Monad0);
            var $176 = $iYXib.liftST(dictMonadST);
            return function($177) {
                return $175($176($177));
            };
        }(),
        Monad0: function() {
            return monadMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$20ac3a2d3113d020 = function(dictMonad) {
    var pure = $gUTA8.pure($7038ccc2f7f5bbce$export$4797150488333da1(dictMonad));
    var semigroupMaybeT1 = $7038ccc2f7f5bbce$export$984e03b79d8c6656(dictMonad);
    return function(dictMonoid) {
        var semigroupMaybeT2 = semigroupMaybeT1(dictMonoid.Semigroup0());
        return {
            mempty: pure($aknDF.mempty(dictMonoid)),
            Semigroup0: function() {
                return semigroupMaybeT2;
            }
        };
    };
};
var $7038ccc2f7f5bbce$export$e14125e5a208a0c9 = function(dictMonad) {
    var Bind1 = dictMonad.Bind1();
    var bind = $9Grh5.bind(Bind1);
    var pure = $gUTA8.pure(dictMonad.Applicative0());
    var functorMaybeT1 = $7038ccc2f7f5bbce$export$3bf77092340654e0(Bind1.Apply0().Functor0());
    return {
        alt: function(v) {
            return function(v1) {
                return bind(v)(function(m) {
                    if (m instanceof $ykHdR.Nothing) return v1;
                    return pure(m);
                });
            };
        },
        Functor0: function() {
            return functorMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$140a10b5716e1900 = function(dictMonad) {
    var altMaybeT1 = $7038ccc2f7f5bbce$export$e14125e5a208a0c9(dictMonad);
    return {
        empty: $gUTA8.pure(dictMonad.Applicative0())($ykHdR.Nothing.value),
        Alt0: function() {
            return altMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$68df7d2debd59865 = function(dictMonad) {
    var applicativeMaybeT1 = $7038ccc2f7f5bbce$export$4797150488333da1(dictMonad);
    var plusMaybeT1 = $7038ccc2f7f5bbce$export$140a10b5716e1900(dictMonad);
    return {
        Applicative0: function() {
            return applicativeMaybeT1;
        },
        Plus1: function() {
            return plusMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$d4030eff1969644e = function(dictMonad) {
    var monadMaybeT1 = $7038ccc2f7f5bbce$export$63cf87c0678a1d2c(dictMonad);
    var alternativeMaybeT1 = $7038ccc2f7f5bbce$export$68df7d2debd59865(dictMonad);
    return {
        Monad0: function() {
            return monadMaybeT1;
        },
        Alternative1: function() {
            return alternativeMaybeT1;
        }
    };
};

});

parcelRegister("9Iord", function(module, exports) {

$parcel$export(module.exports, "monadTransRWST", () => $712b2df71ce372f8$export$1d2bc64ff0e647b4);
$parcel$export(module.exports, "monadRWST", () => $712b2df71ce372f8$export$3addf8bc39ac949f);
$parcel$export(module.exports, "monadEffectRWS", () => $712b2df71ce372f8$export$1947b5c08efdf68f);
// Generated by purs version 0.15.16

var $a7Dxq = parcelRequire("a7Dxq");

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $9Grh5 = parcelRequire("9Grh5");

var $84kZf = parcelRequire("84kZf");

var $lowBm = parcelRequire("lowBm");

var $iYXib = parcelRequire("iYXib");

var $4PFx6 = parcelRequire("4PFx6");

var $axmEP = parcelRequire("axmEP");

var $l0wDR = parcelRequire("l0wDR");

var $aknDF = parcelRequire("aknDF");

var $iwqgS = parcelRequire("iwqgS");

var $9MxTl = parcelRequire("9MxTl");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");

var $kQlZ1 = parcelRequire("kQlZ1");
var $712b2df71ce372f8$export$6950f537d8cb5965 = /* #__PURE__ */ function() {
    function RWSResult(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    RWSResult.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new RWSResult(value0, value1, value2);
            };
        };
    };
    return RWSResult;
}();
var $712b2df71ce372f8$export$f3fc26d039f92fdf = function(x) {
    return x;
};
var $712b2df71ce372f8$export$82c3159babd6b403 = function(f) {
    return function(m) {
        return function(r) {
            return function(s) {
                return $9MxTl.uncurry(m)(f(r)(s));
            };
        };
    };
};
var $712b2df71ce372f8$export$4c8676657688a1cd = function(v) {
    return v;
};
var $712b2df71ce372f8$export$7bded133c80fee1b = {
    Coercible0: function() {
        return undefined;
    }
};
var $712b2df71ce372f8$export$1d2bc64ff0e647b4 = function(dictMonoid) {
    var mempty = $aknDF.mempty(dictMonoid);
    return {
        lift: function(dictMonad) {
            var bind = $9Grh5.bind(dictMonad.Bind1());
            var pure = $gUTA8.pure(dictMonad.Applicative0());
            return function(m) {
                return function(v) {
                    return function(s) {
                        return bind(m)(function(a) {
                            return pure(new $712b2df71ce372f8$export$6950f537d8cb5965(s, a, mempty));
                        });
                    };
                };
            };
        }
    };
};
var $712b2df71ce372f8$export$b3b7a52c4baabcad = function(f) {
    return function(v) {
        return function(r) {
            return function(s) {
                return f(v(r)(s));
            };
        };
    };
};
var $712b2df71ce372f8$export$ab4be9af97c7111d = {
    defer: function(f) {
        return function(r) {
            return function(s) {
                var v = f($r2HHk.unit);
                return v(r)(s);
            };
        };
    }
};
var $712b2df71ce372f8$export$799f7a47278c4ab2 = function(dictFunctor) {
    var map = $l0wDR.map(dictFunctor);
    return {
        map: function(f) {
            return function(v) {
                return function(r) {
                    return function(s) {
                        return map(function(v1) {
                            return new $712b2df71ce372f8$export$6950f537d8cb5965(v1.value0, f(v1.value1), v1.value2);
                        })(v(r)(s));
                    };
                };
            };
        }
    };
};
var $712b2df71ce372f8$export$8f895b27f6bea35a = function(dictMonad) {
    var bind = $9Grh5.bind(dictMonad.Bind1());
    var pure = $gUTA8.pure(dictMonad.Applicative0());
    return function(v) {
        return function(r) {
            return function(s) {
                return bind(v(r)(s))(function(v1) {
                    return pure(new $9MxTl.Tuple(v1.value0, v1.value2));
                });
            };
        };
    };
};
var $712b2df71ce372f8$export$9492f7142a7c6dda = function(dictMonad) {
    var bind = $9Grh5.bind(dictMonad.Bind1());
    var pure = $gUTA8.pure(dictMonad.Applicative0());
    return function(v) {
        return function(r) {
            return function(s) {
                return bind(v(r)(s))(function(v1) {
                    return pure(new $9MxTl.Tuple(v1.value1, v1.value2));
                });
            };
        };
    };
};
var $712b2df71ce372f8$export$3f72b7b9b643060e = function(dictBind) {
    var bind = $9Grh5.bind(dictBind);
    var Functor0 = dictBind.Apply0().Functor0();
    var mapFlipped = $l0wDR.mapFlipped(Functor0);
    var functorRWST1 = $712b2df71ce372f8$export$799f7a47278c4ab2(Functor0);
    return function(dictMonoid) {
        var append = $iwqgS.append(dictMonoid.Semigroup0());
        return {
            apply: function(v) {
                return function(v1) {
                    return function(r) {
                        return function(s) {
                            return bind(v(r)(s))(function(v2) {
                                return mapFlipped(v1(r)(v2.value0))(function(v3) {
                                    return new $712b2df71ce372f8$export$6950f537d8cb5965(v3.value0, v2.value1(v3.value1), append(v2.value2)(v3.value2));
                                });
                            });
                        };
                    };
                };
            },
            Functor0: function() {
                return functorRWST1;
            }
        };
    };
};
var $712b2df71ce372f8$export$ecf0616f2cad1379 = function(dictBind) {
    var bind = $9Grh5.bind(dictBind);
    var mapFlipped = $l0wDR.mapFlipped(dictBind.Apply0().Functor0());
    var applyRWST1 = $712b2df71ce372f8$export$3f72b7b9b643060e(dictBind);
    return function(dictMonoid) {
        var append = $iwqgS.append(dictMonoid.Semigroup0());
        var applyRWST2 = applyRWST1(dictMonoid);
        return {
            bind: function(v) {
                return function(f) {
                    return function(r) {
                        return function(s) {
                            return bind(v(r)(s))(function(v1) {
                                var v2 = f(v1.value1);
                                return mapFlipped(v2(r)(v1.value0))(function(v3) {
                                    return new $712b2df71ce372f8$export$6950f537d8cb5965(v3.value0, v3.value1, append(v1.value2)(v3.value2));
                                });
                            });
                        };
                    };
                };
            },
            Apply0: function() {
                return applyRWST2;
            }
        };
    };
};
var $712b2df71ce372f8$export$863b3ca33677d9b2 = function(dictBind) {
    var applyRWST1 = $712b2df71ce372f8$export$3f72b7b9b643060e(dictBind);
    return function(dictMonoid) {
        var lift2 = $a5g3C.lift2(applyRWST1(dictMonoid));
        return function(dictSemigroup) {
            return {
                append: lift2($iwqgS.append(dictSemigroup))
            };
        };
    };
};
var $712b2df71ce372f8$export$b7ffaf6687c91068 = function(dictMonad) {
    var pure = $gUTA8.pure(dictMonad.Applicative0());
    var applyRWST1 = $712b2df71ce372f8$export$3f72b7b9b643060e(dictMonad.Bind1());
    return function(dictMonoid) {
        var mempty = $aknDF.mempty(dictMonoid);
        var applyRWST2 = applyRWST1(dictMonoid);
        return {
            pure: function(a) {
                return function(v) {
                    return function(s) {
                        return pure(new $712b2df71ce372f8$export$6950f537d8cb5965(s, a, mempty));
                    };
                };
            },
            Apply0: function() {
                return applyRWST2;
            }
        };
    };
};
var $712b2df71ce372f8$export$3addf8bc39ac949f = function(dictMonad) {
    var applicativeRWST1 = $712b2df71ce372f8$export$b7ffaf6687c91068(dictMonad);
    var bindRWST1 = $712b2df71ce372f8$export$ecf0616f2cad1379(dictMonad.Bind1());
    return function(dictMonoid) {
        var applicativeRWST2 = applicativeRWST1(dictMonoid);
        var bindRWST2 = bindRWST1(dictMonoid);
        return {
            Applicative0: function() {
                return applicativeRWST2;
            },
            Bind1: function() {
                return bindRWST2;
            }
        };
    };
};
var $712b2df71ce372f8$export$b3a6ad9a80cd89aa = function(dictMonad) {
    var pure = $gUTA8.pure(dictMonad.Applicative0());
    var monadRWST1 = $712b2df71ce372f8$export$3addf8bc39ac949f(dictMonad);
    return function(dictMonoid) {
        var mempty = $aknDF.mempty(dictMonoid);
        var monadRWST2 = monadRWST1(dictMonoid);
        return {
            ask: function(r) {
                return function(s) {
                    return pure(new $712b2df71ce372f8$export$6950f537d8cb5965(s, r, mempty));
                };
            },
            Monad0: function() {
                return monadRWST2;
            }
        };
    };
};
var $712b2df71ce372f8$export$149b7da9e90e1eac = function(dictMonad) {
    var monadAskRWST1 = $712b2df71ce372f8$export$b3a6ad9a80cd89aa(dictMonad);
    return function(dictMonoid) {
        var monadAskRWST2 = monadAskRWST1(dictMonoid);
        return {
            local: function(f) {
                return function(m) {
                    return function(r) {
                        return function(s) {
                            return m(f(r))(s);
                        };
                    };
                };
            },
            MonadAsk0: function() {
                return monadAskRWST2;
            }
        };
    };
};
var $712b2df71ce372f8$export$1947b5c08efdf68f = function(dictMonoid) {
    var lift = $4PFx6.lift($712b2df71ce372f8$export$1d2bc64ff0e647b4(dictMonoid));
    return function(dictMonadEffect) {
        var Monad0 = dictMonadEffect.Monad0();
        var monadRWST1 = $712b2df71ce372f8$export$3addf8bc39ac949f(Monad0)(dictMonoid);
        return {
            liftEffect: function() {
                var $284 = lift(Monad0);
                var $285 = $kQlZ1.liftEffect(dictMonadEffect);
                return function($286) {
                    return $284($285($286));
                };
            }(),
            Monad0: function() {
                return monadRWST1;
            }
        };
    };
};
var $712b2df71ce372f8$export$858b449733703d7f = function(dictMonadRec) {
    var Monad0 = dictMonadRec.Monad0();
    var bind = $9Grh5.bind(Monad0.Bind1());
    var pure = $gUTA8.pure(Monad0.Applicative0());
    var tailRecM = $lowBm.tailRecM(dictMonadRec);
    var monadRWST1 = $712b2df71ce372f8$export$3addf8bc39ac949f(Monad0);
    return function(dictMonoid) {
        var append = $iwqgS.append(dictMonoid.Semigroup0());
        var mempty = $aknDF.mempty(dictMonoid);
        var monadRWST2 = monadRWST1(dictMonoid);
        return {
            tailRecM: function(k) {
                return function(a) {
                    var k$prime = function(r) {
                        return function(v) {
                            var v1 = k(v.value1);
                            return bind(v1(r)(v.value0))(function(v2) {
                                return pure(function() {
                                    if (v2.value1 instanceof $lowBm.Loop) return new $lowBm.Loop(new $712b2df71ce372f8$export$6950f537d8cb5965(v2.value0, v2.value1.value0, append(v.value2)(v2.value2)));
                                    if (v2.value1 instanceof $lowBm.Done) return new $lowBm.Done(new $712b2df71ce372f8$export$6950f537d8cb5965(v2.value0, v2.value1.value0, append(v.value2)(v2.value2)));
                                    throw new Error("Failed pattern match at Control.Monad.RWS.Trans (line 129, column 16 - line 131, column 68): " + [
                                        v2.value1.constructor.name
                                    ]);
                                }());
                            });
                        };
                    };
                    return function(r) {
                        return function(s) {
                            return tailRecM(k$prime(r))(new $712b2df71ce372f8$export$6950f537d8cb5965(s, a, mempty));
                        };
                    };
                };
            },
            Monad0: function() {
                return monadRWST2;
            }
        };
    };
};
var $712b2df71ce372f8$export$c835aca1626da706 = function(dictMonad) {
    var pure = $gUTA8.pure(dictMonad.Applicative0());
    var monadRWST1 = $712b2df71ce372f8$export$3addf8bc39ac949f(dictMonad);
    return function(dictMonoid) {
        var mempty = $aknDF.mempty(dictMonoid);
        var monadRWST2 = monadRWST1(dictMonoid);
        return {
            state: function(f) {
                return function(v) {
                    return function(s) {
                        var v1 = f(s);
                        return pure(new $712b2df71ce372f8$export$6950f537d8cb5965(v1.value1, v1.value0, mempty));
                    };
                };
            },
            Monad0: function() {
                return monadRWST2;
            }
        };
    };
};
var $712b2df71ce372f8$export$5538632dd3cd70cc = function(dictMonad) {
    var pure = $gUTA8.pure(dictMonad.Applicative0());
    var monadRWST1 = $712b2df71ce372f8$export$3addf8bc39ac949f(dictMonad);
    return function(dictMonoid) {
        var Semigroup0 = dictMonoid.Semigroup0();
        var monadRWST2 = monadRWST1(dictMonoid);
        return {
            tell: function(w) {
                return function(v) {
                    return function(s) {
                        return pure(new $712b2df71ce372f8$export$6950f537d8cb5965(s, $r2HHk.unit, w));
                    };
                };
            },
            Semigroup0: function() {
                return Semigroup0;
            },
            Monad1: function() {
                return monadRWST2;
            }
        };
    };
};
var $712b2df71ce372f8$export$d26d81ccbf9cc981 = function(dictMonad) {
    var bind = $9Grh5.bind(dictMonad.Bind1());
    var pure = $gUTA8.pure(dictMonad.Applicative0());
    var monadTellRWST1 = $712b2df71ce372f8$export$5538632dd3cd70cc(dictMonad);
    return function(dictMonoid) {
        var monadTellRWST2 = monadTellRWST1(dictMonoid);
        return {
            listen: function(m) {
                return function(r) {
                    return function(s) {
                        return bind(m(r)(s))(function(v) {
                            return pure(new $712b2df71ce372f8$export$6950f537d8cb5965(v.value0, new $9MxTl.Tuple(v.value1, v.value2), v.value2));
                        });
                    };
                };
            },
            pass: function(m) {
                return function(r) {
                    return function(s) {
                        return bind(m(r)(s))(function(v) {
                            return pure(new $712b2df71ce372f8$export$6950f537d8cb5965(v.value0, v.value1.value0, v.value1.value1(v.value2)));
                        });
                    };
                };
            },
            Monoid0: function() {
                return dictMonoid;
            },
            MonadTell1: function() {
                return monadTellRWST2;
            }
        };
    };
};
var $712b2df71ce372f8$export$9d857fb7268a3f42 = function(dictMonadThrow) {
    var Monad0 = dictMonadThrow.Monad0();
    var throwError = $84kZf.throwError(dictMonadThrow);
    var monadRWST1 = $712b2df71ce372f8$export$3addf8bc39ac949f(Monad0);
    return function(dictMonoid) {
        var lift = $4PFx6.lift($712b2df71ce372f8$export$1d2bc64ff0e647b4(dictMonoid))(Monad0);
        var monadRWST2 = monadRWST1(dictMonoid);
        return {
            throwError: function(e) {
                return lift(throwError(e));
            },
            Monad0: function() {
                return monadRWST2;
            }
        };
    };
};
var $712b2df71ce372f8$export$f1aa4e7ce0e20856 = function(dictMonadError) {
    var catchError = $84kZf.catchError(dictMonadError);
    var monadThrowRWST1 = $712b2df71ce372f8$export$9d857fb7268a3f42(dictMonadError.MonadThrow0());
    return function(dictMonoid) {
        var monadThrowRWST2 = monadThrowRWST1(dictMonoid);
        return {
            catchError: function(m) {
                return function(h) {
                    return function(r) {
                        return function(s) {
                            return catchError(m(r)(s))(function(e) {
                                var v = h(e);
                                return v(r)(s);
                            });
                        };
                    };
                };
            },
            MonadThrow0: function() {
                return monadThrowRWST2;
            }
        };
    };
};
var $712b2df71ce372f8$export$fa98ca5d27201430 = function(dictMonoid) {
    var lift = $4PFx6.lift($712b2df71ce372f8$export$1d2bc64ff0e647b4(dictMonoid));
    return function(dictMonadST) {
        var Monad0 = dictMonadST.Monad0();
        var monadRWST1 = $712b2df71ce372f8$export$3addf8bc39ac949f(Monad0)(dictMonoid);
        return {
            liftST: function() {
                var $287 = lift(Monad0);
                var $288 = $iYXib.liftST(dictMonadST);
                return function($289) {
                    return $287($288($289));
                };
            }(),
            Monad0: function() {
                return monadRWST1;
            }
        };
    };
};
var $712b2df71ce372f8$export$83c8cfee0365f931 = function(dictMonad) {
    var applicativeRWST1 = $712b2df71ce372f8$export$b7ffaf6687c91068(dictMonad);
    var semigroupRWST1 = $712b2df71ce372f8$export$863b3ca33677d9b2(dictMonad.Bind1());
    return function(dictMonoid) {
        var pure = $gUTA8.pure(applicativeRWST1(dictMonoid));
        var semigroupRWST2 = semigroupRWST1(dictMonoid);
        return function(dictMonoid1) {
            var semigroupRWST3 = semigroupRWST2(dictMonoid1.Semigroup0());
            return {
                mempty: pure($aknDF.mempty(dictMonoid1)),
                Semigroup0: function() {
                    return semigroupRWST3;
                }
            };
        };
    };
};
var $712b2df71ce372f8$export$cfb751420c588279 = function(dictAlt) {
    var alt = $a7Dxq.alt(dictAlt);
    var functorRWST1 = $712b2df71ce372f8$export$799f7a47278c4ab2(dictAlt.Functor0());
    return {
        alt: function(v) {
            return function(v1) {
                return function(r) {
                    return function(s) {
                        return alt(v(r)(s))(v1(r)(s));
                    };
                };
            };
        },
        Functor0: function() {
            return functorRWST1;
        }
    };
};
var $712b2df71ce372f8$export$6179beba56f1d9b2 = function(dictPlus) {
    var empty = $axmEP.empty(dictPlus);
    var altRWST1 = $712b2df71ce372f8$export$cfb751420c588279(dictPlus.Alt0());
    return {
        empty: function(v) {
            return function(v1) {
                return empty;
            };
        },
        Alt0: function() {
            return altRWST1;
        }
    };
};
var $712b2df71ce372f8$export$26aad7e9ffabe87b = function(dictMonoid) {
    return function(dictAlternative) {
        var plusRWST1 = $712b2df71ce372f8$export$6179beba56f1d9b2(dictAlternative.Plus1());
        return function(dictMonad) {
            var applicativeRWST1 = $712b2df71ce372f8$export$b7ffaf6687c91068(dictMonad)(dictMonoid);
            return {
                Applicative0: function() {
                    return applicativeRWST1;
                },
                Plus1: function() {
                    return plusRWST1;
                }
            };
        };
    };
};

});

parcelRegister("bnrVm", function(module, exports) {

$parcel$export(module.exports, "runReaderT", () => $848780da1bf26d9d$export$f356de2c51baae29);
$parcel$export(module.exports, "monadTransReaderT", () => $848780da1bf26d9d$export$95510d0cd7e6e7eb);
$parcel$export(module.exports, "mapReaderT", () => $848780da1bf26d9d$export$1b8048a192a96779);
$parcel$export(module.exports, "applyReaderT", () => $848780da1bf26d9d$export$fee188993a7996b7);
$parcel$export(module.exports, "monadReaderT", () => $848780da1bf26d9d$export$6f721f6865c71dd2);
$parcel$export(module.exports, "monadEffectReader", () => $848780da1bf26d9d$export$a554ebf369a3f56d);
$parcel$export(module.exports, "monadThrowReaderT", () => $848780da1bf26d9d$export$1b067e2856bff729);
$parcel$export(module.exports, "monadErrorReaderT", () => $848780da1bf26d9d$export$484cd3c856ffc7);
// Generated by purs version 0.15.16

var $a7Dxq = parcelRequire("a7Dxq");

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $9Grh5 = parcelRequire("9Grh5");

var $8UXl5 = parcelRequire("8UXl5");

var $84kZf = parcelRequire("84kZf");

var $9ZRMq = parcelRequire("9ZRMq");

var $lowBm = parcelRequire("lowBm");

var $iYXib = parcelRequire("iYXib");

var $kQAxW = parcelRequire("kQAxW");

var $4PFx6 = parcelRequire("4PFx6");

var $3NKEZ = parcelRequire("3NKEZ");

var $axmEP = parcelRequire("axmEP");

var $5ecNO = parcelRequire("5ecNO");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");

var $aknDF = parcelRequire("aknDF");

var $iwqgS = parcelRequire("iwqgS");

var $kQlZ1 = parcelRequire("kQlZ1");
var $848780da1bf26d9d$export$ea3c61b219e01d1e = function(x) {
    return x;
};
var $848780da1bf26d9d$export$36ee99cc8d1d67c9 = function(f) {
    return function(v) {
        return function($152) {
            return v(f($152));
        };
    };
};
var $848780da1bf26d9d$export$f356de2c51baae29 = function(v) {
    return v;
};
var $848780da1bf26d9d$export$f52dceb6bbe9cc1f = {
    Coercible0: function() {
        return undefined;
    }
};
var $848780da1bf26d9d$export$95510d0cd7e6e7eb = {
    lift: function(dictMonad) {
        return function($153) {
            return $848780da1bf26d9d$export$ea3c61b219e01d1e($l4M7e.const($153));
        };
    }
};
var $848780da1bf26d9d$var$lift = /* #__PURE__ */ $4PFx6.lift($848780da1bf26d9d$export$95510d0cd7e6e7eb);
var $848780da1bf26d9d$export$1b8048a192a96779 = function(f) {
    return function(v) {
        return function($154) {
            return f(v($154));
        };
    };
};
var $848780da1bf26d9d$export$9ef8da126720992c = function(dictFunctor) {
    return {
        map: function() {
            var $155 = $l0wDR.map(dictFunctor);
            return function($156) {
                return $848780da1bf26d9d$export$1b8048a192a96779($155($156));
            };
        }()
    };
};
var $848780da1bf26d9d$export$4b73f9411376f1b4 = function(dictDistributive) {
    var collect = $5ecNO.collect(dictDistributive);
    var functorReaderT1 = $848780da1bf26d9d$export$9ef8da126720992c(dictDistributive.Functor0());
    return {
        distribute: function(dictFunctor) {
            var collect1 = collect(dictFunctor);
            return function(a) {
                return function(e) {
                    return collect1(function(r) {
                        return r(e);
                    })(a);
                };
            };
        },
        collect: function(dictFunctor) {
            var map = $l0wDR.map(dictFunctor);
            return function(f) {
                var $157 = $5ecNO.distribute($848780da1bf26d9d$export$4b73f9411376f1b4(dictDistributive))(dictFunctor);
                var $158 = map(f);
                return function($159) {
                    return $157($158($159));
                };
            };
        },
        Functor0: function() {
            return functorReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$fee188993a7996b7 = function(dictApply) {
    var apply = $a5g3C.apply(dictApply);
    var functorReaderT1 = $848780da1bf26d9d$export$9ef8da126720992c(dictApply.Functor0());
    return {
        apply: function(v) {
            return function(v1) {
                return function(r) {
                    return apply(v(r))(v1(r));
                };
            };
        },
        Functor0: function() {
            return functorReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$4255fb962d7d3c76 = function(dictBind) {
    var bind = $9Grh5.bind(dictBind);
    var applyReaderT1 = $848780da1bf26d9d$export$fee188993a7996b7(dictBind.Apply0());
    return {
        bind: function(v) {
            return function(k) {
                return function(r) {
                    return bind(v(r))(function(a) {
                        var v1 = k(a);
                        return v1(r);
                    });
                };
            };
        },
        Apply0: function() {
            return applyReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$12572275428491c2 = function(dictApply) {
    var lift2 = $a5g3C.lift2($848780da1bf26d9d$export$fee188993a7996b7(dictApply));
    return function(dictSemigroup) {
        return {
            append: lift2($iwqgS.append(dictSemigroup))
        };
    };
};
var $848780da1bf26d9d$export$aef633589549fee0 = function(dictApplicative) {
    var applyReaderT1 = $848780da1bf26d9d$export$fee188993a7996b7(dictApplicative.Apply0());
    return {
        pure: function() {
            var $160 = $gUTA8.pure(dictApplicative);
            return function($161) {
                return $848780da1bf26d9d$export$ea3c61b219e01d1e($l4M7e.const($160($161)));
            };
        }(),
        Apply0: function() {
            return applyReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$6f721f6865c71dd2 = function(dictMonad) {
    var applicativeReaderT1 = $848780da1bf26d9d$export$aef633589549fee0(dictMonad.Applicative0());
    var bindReaderT1 = $848780da1bf26d9d$export$4255fb962d7d3c76(dictMonad.Bind1());
    return {
        Applicative0: function() {
            return applicativeReaderT1;
        },
        Bind1: function() {
            return bindReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$1fc6951fa9cc0730 = function(dictMonad) {
    var monadReaderT1 = $848780da1bf26d9d$export$6f721f6865c71dd2(dictMonad);
    return {
        ask: $gUTA8.pure(dictMonad.Applicative0()),
        Monad0: function() {
            return monadReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$202df576a32d0b15 = function(dictMonad) {
    var monadAskReaderT1 = $848780da1bf26d9d$export$1fc6951fa9cc0730(dictMonad);
    return {
        local: $848780da1bf26d9d$export$36ee99cc8d1d67c9,
        MonadAsk0: function() {
            return monadAskReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$9f6c922afb6673fe = function(dictMonadCont) {
    var callCC = $8UXl5.callCC(dictMonadCont);
    var monadReaderT1 = $848780da1bf26d9d$export$6f721f6865c71dd2(dictMonadCont.Monad0());
    return {
        callCC: function(f) {
            return function(r) {
                return callCC(function(c) {
                    var v = f(function($162) {
                        return $848780da1bf26d9d$export$ea3c61b219e01d1e($l4M7e.const(c($162)));
                    });
                    return v(r);
                });
            };
        },
        Monad0: function() {
            return monadReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$a554ebf369a3f56d = function(dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var monadReaderT1 = $848780da1bf26d9d$export$6f721f6865c71dd2(Monad0);
    return {
        liftEffect: function() {
            var $163 = $848780da1bf26d9d$var$lift(Monad0);
            var $164 = $kQlZ1.liftEffect(dictMonadEffect);
            return function($165) {
                return $163($164($165));
            };
        }(),
        Monad0: function() {
            return monadReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$b063aaccf75fba13 = function(dictMonadRec) {
    var Monad0 = dictMonadRec.Monad0();
    var bindFlipped = $9Grh5.bindFlipped(Monad0.Bind1());
    var pure = $gUTA8.pure(Monad0.Applicative0());
    var tailRecM = $lowBm.tailRecM(dictMonadRec);
    var monadReaderT1 = $848780da1bf26d9d$export$6f721f6865c71dd2(Monad0);
    return {
        tailRecM: function(k) {
            return function(a) {
                var k$prime = function(r) {
                    return function(a$prime) {
                        var v = k(a$prime);
                        return bindFlipped(pure)(v(r));
                    };
                };
                return function(r) {
                    return tailRecM(k$prime(r))(a);
                };
            };
        },
        Monad0: function() {
            return monadReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$48d7aff14d826a4f = function(dictMonadState) {
    var Monad0 = dictMonadState.Monad0();
    var monadReaderT1 = $848780da1bf26d9d$export$6f721f6865c71dd2(Monad0);
    return {
        state: function() {
            var $166 = $848780da1bf26d9d$var$lift(Monad0);
            var $167 = $kQAxW.state(dictMonadState);
            return function($168) {
                return $166($167($168));
            };
        }(),
        Monad0: function() {
            return monadReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$ab1235cf7f047d07 = function(dictMonadTell) {
    var Monad1 = dictMonadTell.Monad1();
    var Semigroup0 = dictMonadTell.Semigroup0();
    var monadReaderT1 = $848780da1bf26d9d$export$6f721f6865c71dd2(Monad1);
    return {
        tell: function() {
            var $169 = $848780da1bf26d9d$var$lift(Monad1);
            var $170 = $3NKEZ.tell(dictMonadTell);
            return function($171) {
                return $169($170($171));
            };
        }(),
        Semigroup0: function() {
            return Semigroup0;
        },
        Monad1: function() {
            return monadReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$662fa4b34fb6720c = function(dictMonadWriter) {
    var Monoid0 = dictMonadWriter.Monoid0();
    var monadTellReaderT1 = $848780da1bf26d9d$export$ab1235cf7f047d07(dictMonadWriter.MonadTell1());
    return {
        listen: $848780da1bf26d9d$export$1b8048a192a96779($3NKEZ.listen(dictMonadWriter)),
        pass: $848780da1bf26d9d$export$1b8048a192a96779($3NKEZ.pass(dictMonadWriter)),
        Monoid0: function() {
            return Monoid0;
        },
        MonadTell1: function() {
            return monadTellReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$1b067e2856bff729 = function(dictMonadThrow) {
    var Monad0 = dictMonadThrow.Monad0();
    var monadReaderT1 = $848780da1bf26d9d$export$6f721f6865c71dd2(Monad0);
    return {
        throwError: function() {
            var $172 = $848780da1bf26d9d$var$lift(Monad0);
            var $173 = $84kZf.throwError(dictMonadThrow);
            return function($174) {
                return $172($173($174));
            };
        }(),
        Monad0: function() {
            return monadReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$484cd3c856ffc7 = function(dictMonadError) {
    var catchError = $84kZf.catchError(dictMonadError);
    var monadThrowReaderT1 = $848780da1bf26d9d$export$1b067e2856bff729(dictMonadError.MonadThrow0());
    return {
        catchError: function(v) {
            return function(h) {
                return function(r) {
                    return catchError(v(r))(function(e) {
                        var v1 = h(e);
                        return v1(r);
                    });
                };
            };
        },
        MonadThrow0: function() {
            return monadThrowReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$162b6a611607bf69 = function(dictMonadST) {
    var Monad0 = dictMonadST.Monad0();
    var monadReaderT1 = $848780da1bf26d9d$export$6f721f6865c71dd2(Monad0);
    return {
        liftST: function() {
            var $175 = $848780da1bf26d9d$var$lift(Monad0);
            var $176 = $iYXib.liftST(dictMonadST);
            return function($177) {
                return $175($176($177));
            };
        }(),
        Monad0: function() {
            return monadReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$df55f2197442fd9 = function(dictApplicative) {
    var pure = $gUTA8.pure($848780da1bf26d9d$export$aef633589549fee0(dictApplicative));
    var semigroupReaderT1 = $848780da1bf26d9d$export$12572275428491c2(dictApplicative.Apply0());
    return function(dictMonoid) {
        var semigroupReaderT2 = semigroupReaderT1(dictMonoid.Semigroup0());
        return {
            mempty: pure($aknDF.mempty(dictMonoid)),
            Semigroup0: function() {
                return semigroupReaderT2;
            }
        };
    };
};
var $848780da1bf26d9d$export$32cadcb66dd98ef3 = function(dictAlt) {
    var alt = $a7Dxq.alt(dictAlt);
    var functorReaderT1 = $848780da1bf26d9d$export$9ef8da126720992c(dictAlt.Functor0());
    return {
        alt: function(v) {
            return function(v1) {
                return function(r) {
                    return alt(v(r))(v1(r));
                };
            };
        },
        Functor0: function() {
            return functorReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$97f8c30f9c69a13c = function(dictPlus) {
    var altReaderT1 = $848780da1bf26d9d$export$32cadcb66dd98ef3(dictPlus.Alt0());
    return {
        empty: $l4M7e.const($axmEP.empty(dictPlus)),
        Alt0: function() {
            return altReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$8bebb77f5bc043a9 = function(dictAlternative) {
    var applicativeReaderT1 = $848780da1bf26d9d$export$aef633589549fee0(dictAlternative.Applicative0());
    var plusReaderT1 = $848780da1bf26d9d$export$97f8c30f9c69a13c(dictAlternative.Plus1());
    return {
        Applicative0: function() {
            return applicativeReaderT1;
        },
        Plus1: function() {
            return plusReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$3772d6c9d5f8e735 = function(dictMonadPlus) {
    var monadReaderT1 = $848780da1bf26d9d$export$6f721f6865c71dd2(dictMonadPlus.Monad0());
    var alternativeReaderT1 = $848780da1bf26d9d$export$8bebb77f5bc043a9(dictMonadPlus.Alternative1());
    return {
        Monad0: function() {
            return monadReaderT1;
        },
        Alternative1: function() {
            return alternativeReaderT1;
        }
    };
};

});
parcelRegister("5ecNO", function(module, exports) {

$parcel$export(module.exports, "distribute", () => $3ce830dde03d3389$export$f02a9ddbe4480f19);
$parcel$export(module.exports, "collect", () => $3ce830dde03d3389$export$bb44f104e3c54dae);
// Generated by purs version 0.15.16

var $7T8P4 = parcelRequire("7T8P4");

var $l0wDR = parcelRequire("l0wDR");

var $6VVZC = parcelRequire("6VVZC");

var $6PW1p = parcelRequire("6PW1p");

var $9MxTl = parcelRequire("9MxTl");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");

var $eZ0pB = parcelRequire("eZ0pB");
var $3ce830dde03d3389$var$unwrap = /* #__PURE__ */ $6PW1p.unwrap();
var $3ce830dde03d3389$var$identity = /* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn);
var $3ce830dde03d3389$export$c2a69422949c6b5c = {
    distribute: function(dictFunctor) {
        var $34 = $l0wDR.map(dictFunctor)($3ce830dde03d3389$var$unwrap);
        return function($35) {
            return $6VVZC.Identity($34($35));
        };
    },
    collect: function(dictFunctor) {
        var map = $l0wDR.map(dictFunctor);
        return function(f) {
            var $36 = map(function($38) {
                return $3ce830dde03d3389$var$unwrap(f($38));
            });
            return function($37) {
                return $6VVZC.Identity($36($37));
            };
        };
    },
    Functor0: function() {
        return $6VVZC.functorIdentity;
    }
};
var $3ce830dde03d3389$export$f02a9ddbe4480f19 = function(dict) {
    return dict.distribute;
};
var $3ce830dde03d3389$export$31ac6c2237b1bf1b = {
    distribute: function(dictFunctor) {
        var map = $l0wDR.map(dictFunctor);
        return function(a) {
            return function(e) {
                return map(function(v) {
                    return v(e);
                })(a);
            };
        };
    },
    collect: function(dictFunctor) {
        var map = $l0wDR.map(dictFunctor);
        return function(f) {
            var $39 = $3ce830dde03d3389$export$f02a9ddbe4480f19($3ce830dde03d3389$export$31ac6c2237b1bf1b)(dictFunctor);
            var $40 = map(f);
            return function($41) {
                return $39($40($41));
            };
        };
    },
    Functor0: function() {
        return $l0wDR.functorFn;
    }
};
var $3ce830dde03d3389$export$e6005abdfe1aac80 = function(dictDistributive) {
    var map = $l0wDR.map(dictDistributive.Functor0());
    var distribute1 = $3ce830dde03d3389$export$f02a9ddbe4480f19(dictDistributive);
    return function(dictFunctor) {
        var distribute2 = distribute1(dictFunctor);
        return function(f) {
            var $42 = map(f);
            return function($43) {
                return $42(distribute2($43));
            };
        };
    };
};
var $3ce830dde03d3389$export$2d5a930f1676b9b7 = function(dictDistributive) {
    var distribute1 = $3ce830dde03d3389$export$f02a9ddbe4480f19(dictDistributive);
    return function(dictFunctor) {
        var distribute2 = distribute1(dictFunctor);
        var map = $l0wDR.map(dictFunctor);
        return function(f) {
            var $44 = map(f);
            return function($45) {
                return distribute2($44($45));
            };
        };
    };
};
var $3ce830dde03d3389$export$76df48f9f3fb8eb1 = function(dictTypeEquals) {
    var from = $eZ0pB.from(dictTypeEquals);
    return {
        collect: function(dictFunctor) {
            return $3ce830dde03d3389$export$2d5a930f1676b9b7($3ce830dde03d3389$export$76df48f9f3fb8eb1(dictTypeEquals))(dictFunctor);
        },
        distribute: function(dictFunctor) {
            var $46 = $9MxTl.Tuple.create(from($r2HHk.unit));
            var $47 = $l0wDR.map(dictFunctor)($9MxTl.snd);
            return function($48) {
                return $46($47($48));
            };
        },
        Functor0: function() {
            return $9MxTl.functorTuple;
        }
    };
};
var $3ce830dde03d3389$export$bb44f104e3c54dae = function(dict) {
    return dict.collect;
};
var $3ce830dde03d3389$export$f13cbf7f76d41467 = function(dictDistributive) {
    var collect1 = $3ce830dde03d3389$export$bb44f104e3c54dae(dictDistributive);
    return function(dictFunctor) {
        return collect1(dictFunctor)($3ce830dde03d3389$var$identity);
    };
};

});
parcelRegister("eZ0pB", function(module, exports) {

$parcel$export(module.exports, "from", () => $ae8714ffa2598cf8$export$6788812c4e6611e6);
// Generated by purs version 0.15.16
var $ae8714ffa2598cf8$var$To = function(x) {
    return x;
};
var $ae8714ffa2598cf8$var$From = function(x) {
    return x;
};
var $ae8714ffa2598cf8$export$9fc2f52ae8ba6578 = {
    proof: function(a) {
        return a;
    },
    Coercible0: function() {
        return undefined;
    }
};
var $ae8714ffa2598cf8$export$3d466392f5188420 = function(dict) {
    return dict.proof;
};
var $ae8714ffa2598cf8$export$2c618a4308a30424 = function(dictTypeEquals) {
    var v = $ae8714ffa2598cf8$export$3d466392f5188420(dictTypeEquals)(function(a) {
        return a;
    });
    return v;
};
var $ae8714ffa2598cf8$export$6788812c4e6611e6 = function(dictTypeEquals) {
    var v = $ae8714ffa2598cf8$export$3d466392f5188420(dictTypeEquals)(function(a) {
        return a;
    });
    return v;
};

});



parcelRegister("k4cbH", function(module, exports) {

$parcel$export(module.exports, "withStateT", () => $e9bda291f4ec10ec$export$72aea7109e8312dd);
$parcel$export(module.exports, "runStateT", () => $e9bda291f4ec10ec$export$c5ba8a89d9140c32);
$parcel$export(module.exports, "monadTransStateT", () => $e9bda291f4ec10ec$export$5e0a9e9fea50cb88);
$parcel$export(module.exports, "mapStateT", () => $e9bda291f4ec10ec$export$8342df5ddac360cd);
$parcel$export(module.exports, "lazyStateT", () => $e9bda291f4ec10ec$export$dce43013fc3a5fe1);
$parcel$export(module.exports, "functorStateT", () => $e9bda291f4ec10ec$export$d5449d946db19e3a);
$parcel$export(module.exports, "monadStateT", () => $e9bda291f4ec10ec$export$345b4840c14ff10f);
$parcel$export(module.exports, "applicativeStateT", () => $e9bda291f4ec10ec$export$5cbc630d6fbe2e14);
$parcel$export(module.exports, "bindStateT", () => $e9bda291f4ec10ec$export$f28534bdc7259c7);
$parcel$export(module.exports, "applyStateT", () => $e9bda291f4ec10ec$export$2ea3d0ecd25a5eef);
$parcel$export(module.exports, "monadEffectState", () => $e9bda291f4ec10ec$export$cba9856135198781);
$parcel$export(module.exports, "monadRecStateT", () => $e9bda291f4ec10ec$export$ade5de830b656137);
$parcel$export(module.exports, "monadStateStateT", () => $e9bda291f4ec10ec$export$fc3b89a546fa5c5c);
$parcel$export(module.exports, "altStateT", () => $e9bda291f4ec10ec$export$d5bde0fdc0bca75b);
// Generated by purs version 0.15.16

var $a7Dxq = parcelRequire("a7Dxq");

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $9Grh5 = parcelRequire("9Grh5");

var $ibtPS = parcelRequire("ibtPS");

var $8UXl5 = parcelRequire("8UXl5");

var $84kZf = parcelRequire("84kZf");

var $9ZRMq = parcelRequire("9ZRMq");

var $lowBm = parcelRequire("lowBm");

var $iYXib = parcelRequire("iYXib");

var $kQAxW = parcelRequire("kQAxW");

var $4PFx6 = parcelRequire("4PFx6");

var $3NKEZ = parcelRequire("3NKEZ");

var $axmEP = parcelRequire("axmEP");

var $l0wDR = parcelRequire("l0wDR");

var $aknDF = parcelRequire("aknDF");

var $iwqgS = parcelRequire("iwqgS");

var $9MxTl = parcelRequire("9MxTl");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");

var $kQlZ1 = parcelRequire("kQlZ1");
var $e9bda291f4ec10ec$export$73ce73bddfe2800a = function(x) {
    return x;
};
var $e9bda291f4ec10ec$export$72aea7109e8312dd = function(f) {
    return function(v) {
        return function($199) {
            return v(f($199));
        };
    };
};
var $e9bda291f4ec10ec$export$c5ba8a89d9140c32 = function(v) {
    return v;
};
var $e9bda291f4ec10ec$export$dce35699eedd4739 = {
    Coercible0: function() {
        return undefined;
    }
};
var $e9bda291f4ec10ec$export$5e0a9e9fea50cb88 = {
    lift: function(dictMonad) {
        var bind = $9Grh5.bind(dictMonad.Bind1());
        var pure = $gUTA8.pure(dictMonad.Applicative0());
        return function(m) {
            return function(s) {
                return bind(m)(function(x) {
                    return pure(new $9MxTl.Tuple(x, s));
                });
            };
        };
    }
};
var $e9bda291f4ec10ec$var$lift = /* #__PURE__ */ $4PFx6.lift($e9bda291f4ec10ec$export$5e0a9e9fea50cb88);
var $e9bda291f4ec10ec$export$8342df5ddac360cd = function(f) {
    return function(v) {
        return function($200) {
            return f(v($200));
        };
    };
};
var $e9bda291f4ec10ec$export$dce43013fc3a5fe1 = {
    defer: function(f) {
        return function(s) {
            var v = f($r2HHk.unit);
            return v(s);
        };
    }
};
var $e9bda291f4ec10ec$export$d5449d946db19e3a = function(dictFunctor) {
    var map = $l0wDR.map(dictFunctor);
    return {
        map: function(f) {
            return function(v) {
                return function(s) {
                    return map(function(v1) {
                        return new $9MxTl.Tuple(f(v1.value0), v1.value1);
                    })(v(s));
                };
            };
        }
    };
};
var $e9bda291f4ec10ec$export$193956ba360b7728 = function(dictFunctor) {
    var map = $l0wDR.map(dictFunctor);
    return function(v) {
        return function(s) {
            return map($9MxTl.snd)(v(s));
        };
    };
};
var $e9bda291f4ec10ec$export$99aa49a66d7c0535 = function(dictFunctor) {
    var map = $l0wDR.map(dictFunctor);
    return function(v) {
        return function(s) {
            return map($9MxTl.fst)(v(s));
        };
    };
};
var $e9bda291f4ec10ec$export$345b4840c14ff10f = function(dictMonad) {
    return {
        Applicative0: function() {
            return $e9bda291f4ec10ec$export$5cbc630d6fbe2e14(dictMonad);
        },
        Bind1: function() {
            return $e9bda291f4ec10ec$export$f28534bdc7259c7(dictMonad);
        }
    };
};
var $e9bda291f4ec10ec$export$f28534bdc7259c7 = function(dictMonad) {
    var bind = $9Grh5.bind(dictMonad.Bind1());
    return {
        bind: function(v) {
            return function(f) {
                return function(s) {
                    return bind(v(s))(function(v1) {
                        var v3 = f(v1.value0);
                        return v3(v1.value1);
                    });
                };
            };
        },
        Apply0: function() {
            return $e9bda291f4ec10ec$export$2ea3d0ecd25a5eef(dictMonad);
        }
    };
};
var $e9bda291f4ec10ec$export$2ea3d0ecd25a5eef = function(dictMonad) {
    var functorStateT1 = $e9bda291f4ec10ec$export$d5449d946db19e3a(dictMonad.Bind1().Apply0().Functor0());
    return {
        apply: $ibtPS.ap($e9bda291f4ec10ec$export$345b4840c14ff10f(dictMonad)),
        Functor0: function() {
            return functorStateT1;
        }
    };
};
var $e9bda291f4ec10ec$export$5cbc630d6fbe2e14 = function(dictMonad) {
    var pure = $gUTA8.pure(dictMonad.Applicative0());
    return {
        pure: function(a) {
            return function(s) {
                return pure(new $9MxTl.Tuple(a, s));
            };
        },
        Apply0: function() {
            return $e9bda291f4ec10ec$export$2ea3d0ecd25a5eef(dictMonad);
        }
    };
};
var $e9bda291f4ec10ec$export$726f0b075e4f5d8b = function(dictMonad) {
    var lift2 = $a5g3C.lift2($e9bda291f4ec10ec$export$2ea3d0ecd25a5eef(dictMonad));
    return function(dictSemigroup) {
        return {
            append: lift2($iwqgS.append(dictSemigroup))
        };
    };
};
var $e9bda291f4ec10ec$export$45bacc938270e8f5 = function(dictMonadAsk) {
    var Monad0 = dictMonadAsk.Monad0();
    var monadStateT1 = $e9bda291f4ec10ec$export$345b4840c14ff10f(Monad0);
    return {
        ask: $e9bda291f4ec10ec$var$lift(Monad0)($9ZRMq.ask(dictMonadAsk)),
        Monad0: function() {
            return monadStateT1;
        }
    };
};
var $e9bda291f4ec10ec$export$20f71c563c2e6d49 = function(dictMonadReader) {
    var monadAskStateT1 = $e9bda291f4ec10ec$export$45bacc938270e8f5(dictMonadReader.MonadAsk0());
    return {
        local: function() {
            var $201 = $9ZRMq.local(dictMonadReader);
            return function($202) {
                return $e9bda291f4ec10ec$export$8342df5ddac360cd($201($202));
            };
        }(),
        MonadAsk0: function() {
            return monadAskStateT1;
        }
    };
};
var $e9bda291f4ec10ec$export$2e498a385f8c30f1 = function(dictMonadCont) {
    var callCC = $8UXl5.callCC(dictMonadCont);
    var monadStateT1 = $e9bda291f4ec10ec$export$345b4840c14ff10f(dictMonadCont.Monad0());
    return {
        callCC: function(f) {
            return function(s) {
                return callCC(function(c) {
                    var v = f(function(a) {
                        return function(s$prime) {
                            return c(new $9MxTl.Tuple(a, s$prime));
                        };
                    });
                    return v(s);
                });
            };
        },
        Monad0: function() {
            return monadStateT1;
        }
    };
};
var $e9bda291f4ec10ec$export$cba9856135198781 = function(dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var monadStateT1 = $e9bda291f4ec10ec$export$345b4840c14ff10f(Monad0);
    return {
        liftEffect: function() {
            var $203 = $e9bda291f4ec10ec$var$lift(Monad0);
            var $204 = $kQlZ1.liftEffect(dictMonadEffect);
            return function($205) {
                return $203($204($205));
            };
        }(),
        Monad0: function() {
            return monadStateT1;
        }
    };
};
var $e9bda291f4ec10ec$export$ade5de830b656137 = function(dictMonadRec) {
    var Monad0 = dictMonadRec.Monad0();
    var bind = $9Grh5.bind(Monad0.Bind1());
    var pure = $gUTA8.pure(Monad0.Applicative0());
    var tailRecM = $lowBm.tailRecM(dictMonadRec);
    var monadStateT1 = $e9bda291f4ec10ec$export$345b4840c14ff10f(Monad0);
    return {
        tailRecM: function(f) {
            return function(a) {
                var f$prime = function(v) {
                    var v1 = f(v.value0);
                    return bind(v1(v.value1))(function(v2) {
                        return pure(function() {
                            if (v2.value0 instanceof $lowBm.Loop) return new $lowBm.Loop(new $9MxTl.Tuple(v2.value0.value0, v2.value1));
                            if (v2.value0 instanceof $lowBm.Done) return new $lowBm.Done(new $9MxTl.Tuple(v2.value0.value0, v2.value1));
                            throw new Error("Failed pattern match at Control.Monad.State.Trans (line 88, column 16 - line 90, column 40): " + [
                                v2.value0.constructor.name
                            ]);
                        }());
                    });
                };
                return function(s) {
                    return tailRecM(f$prime)(new $9MxTl.Tuple(a, s));
                };
            };
        },
        Monad0: function() {
            return monadStateT1;
        }
    };
};
var $e9bda291f4ec10ec$export$fc3b89a546fa5c5c = function(dictMonad) {
    var pure = $gUTA8.pure(dictMonad.Applicative0());
    var monadStateT1 = $e9bda291f4ec10ec$export$345b4840c14ff10f(dictMonad);
    return {
        state: function(f) {
            return function($206) {
                return pure(f($206));
            };
        },
        Monad0: function() {
            return monadStateT1;
        }
    };
};
var $e9bda291f4ec10ec$export$7fdbbf63ca644aa6 = function(dictMonadTell) {
    var Monad1 = dictMonadTell.Monad1();
    var Semigroup0 = dictMonadTell.Semigroup0();
    var monadStateT1 = $e9bda291f4ec10ec$export$345b4840c14ff10f(Monad1);
    return {
        tell: function() {
            var $207 = $e9bda291f4ec10ec$var$lift(Monad1);
            var $208 = $3NKEZ.tell(dictMonadTell);
            return function($209) {
                return $207($208($209));
            };
        }(),
        Semigroup0: function() {
            return Semigroup0;
        },
        Monad1: function() {
            return monadStateT1;
        }
    };
};
var $e9bda291f4ec10ec$export$f97520cd68688e2d = function(dictMonadWriter) {
    var MonadTell1 = dictMonadWriter.MonadTell1();
    var Monad1 = MonadTell1.Monad1();
    var bind = $9Grh5.bind(Monad1.Bind1());
    var listen = $3NKEZ.listen(dictMonadWriter);
    var pure = $gUTA8.pure(Monad1.Applicative0());
    var pass = $3NKEZ.pass(dictMonadWriter);
    var Monoid0 = dictMonadWriter.Monoid0();
    var monadTellStateT1 = $e9bda291f4ec10ec$export$7fdbbf63ca644aa6(MonadTell1);
    return {
        listen: function(m) {
            return function(s) {
                return bind(listen(m(s)))(function(v) {
                    return pure(new $9MxTl.Tuple(new $9MxTl.Tuple(v.value0.value0, v.value1), v.value0.value1));
                });
            };
        },
        pass: function(m) {
            return function(s) {
                return pass(bind(m(s))(function(v) {
                    return pure(new $9MxTl.Tuple(new $9MxTl.Tuple(v.value0.value0, v.value1), v.value0.value1));
                }));
            };
        },
        Monoid0: function() {
            return Monoid0;
        },
        MonadTell1: function() {
            return monadTellStateT1;
        }
    };
};
var $e9bda291f4ec10ec$export$89cac97299cfdec2 = function(dictMonadThrow) {
    var Monad0 = dictMonadThrow.Monad0();
    var lift1 = $e9bda291f4ec10ec$var$lift(Monad0);
    var throwError = $84kZf.throwError(dictMonadThrow);
    var monadStateT1 = $e9bda291f4ec10ec$export$345b4840c14ff10f(Monad0);
    return {
        throwError: function(e) {
            return lift1(throwError(e));
        },
        Monad0: function() {
            return monadStateT1;
        }
    };
};
var $e9bda291f4ec10ec$export$c2a2ecf63b1e47e2 = function(dictMonadError) {
    var catchError = $84kZf.catchError(dictMonadError);
    var monadThrowStateT1 = $e9bda291f4ec10ec$export$89cac97299cfdec2(dictMonadError.MonadThrow0());
    return {
        catchError: function(v) {
            return function(h) {
                return function(s) {
                    return catchError(v(s))(function(e) {
                        var v1 = h(e);
                        return v1(s);
                    });
                };
            };
        },
        MonadThrow0: function() {
            return monadThrowStateT1;
        }
    };
};
var $e9bda291f4ec10ec$export$e7c6f10a88f3ca17 = function(dictMonadST) {
    var Monad0 = dictMonadST.Monad0();
    var monadStateT1 = $e9bda291f4ec10ec$export$345b4840c14ff10f(Monad0);
    return {
        liftST: function() {
            var $210 = $e9bda291f4ec10ec$var$lift(Monad0);
            var $211 = $iYXib.liftST(dictMonadST);
            return function($212) {
                return $210($211($212));
            };
        }(),
        Monad0: function() {
            return monadStateT1;
        }
    };
};
var $e9bda291f4ec10ec$export$9d9b8c7bcee971bf = function(dictMonad) {
    var pure = $gUTA8.pure($e9bda291f4ec10ec$export$5cbc630d6fbe2e14(dictMonad));
    var semigroupStateT1 = $e9bda291f4ec10ec$export$726f0b075e4f5d8b(dictMonad);
    return function(dictMonoid) {
        var semigroupStateT2 = semigroupStateT1(dictMonoid.Semigroup0());
        return {
            mempty: pure($aknDF.mempty(dictMonoid)),
            Semigroup0: function() {
                return semigroupStateT2;
            }
        };
    };
};
var $e9bda291f4ec10ec$export$d5bde0fdc0bca75b = function(dictMonad) {
    return function(dictAlt) {
        var alt = $a7Dxq.alt(dictAlt);
        var functorStateT1 = $e9bda291f4ec10ec$export$d5449d946db19e3a(dictAlt.Functor0());
        return {
            alt: function(v) {
                return function(v1) {
                    return function(s) {
                        return alt(v(s))(v1(s));
                    };
                };
            },
            Functor0: function() {
                return functorStateT1;
            }
        };
    };
};
var $e9bda291f4ec10ec$export$300a7627bf7b0e65 = function(dictMonad) {
    var altStateT1 = $e9bda291f4ec10ec$export$d5bde0fdc0bca75b(dictMonad);
    return function(dictPlus) {
        var empty = $axmEP.empty(dictPlus);
        var altStateT2 = altStateT1(dictPlus.Alt0());
        return {
            empty: function(v) {
                return empty;
            },
            Alt0: function() {
                return altStateT2;
            }
        };
    };
};
var $e9bda291f4ec10ec$export$d31747194ff6662e = function(dictMonad) {
    var applicativeStateT1 = $e9bda291f4ec10ec$export$5cbc630d6fbe2e14(dictMonad);
    var plusStateT1 = $e9bda291f4ec10ec$export$300a7627bf7b0e65(dictMonad);
    return function(dictAlternative) {
        var plusStateT2 = plusStateT1(dictAlternative.Plus1());
        return {
            Applicative0: function() {
                return applicativeStateT1;
            },
            Plus1: function() {
                return plusStateT2;
            }
        };
    };
};
var $e9bda291f4ec10ec$export$b08eeaf68c7005d9 = function(dictMonadPlus) {
    var Monad0 = dictMonadPlus.Monad0();
    var monadStateT1 = $e9bda291f4ec10ec$export$345b4840c14ff10f(Monad0);
    var alternativeStateT1 = $e9bda291f4ec10ec$export$d31747194ff6662e(Monad0)(dictMonadPlus.Alternative1());
    return {
        Monad0: function() {
            return monadStateT1;
        },
        Alternative1: function() {
            return alternativeStateT1;
        }
    };
};

});

parcelRegister("iI3r9", function(module, exports) {

$parcel$export(module.exports, "monadTransWriterT", () => $d9ef009191ddae40$export$6b749a3db2c2aac6);
$parcel$export(module.exports, "mapWriterT", () => $d9ef009191ddae40$export$c950a71321ef1ffc);
$parcel$export(module.exports, "applyWriterT", () => $d9ef009191ddae40$export$2f46a8de9e2e0acc);
$parcel$export(module.exports, "monadWriterT", () => $d9ef009191ddae40$export$a45df43c41b778a);
$parcel$export(module.exports, "monadEffectWriter", () => $d9ef009191ddae40$export$29fece65832b4369);
// Generated by purs version 0.15.16

var $a7Dxq = parcelRequire("a7Dxq");

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $9Grh5 = parcelRequire("9Grh5");

var $8UXl5 = parcelRequire("8UXl5");

var $84kZf = parcelRequire("84kZf");

var $9ZRMq = parcelRequire("9ZRMq");

var $lowBm = parcelRequire("lowBm");

var $iYXib = parcelRequire("iYXib");

var $kQAxW = parcelRequire("kQAxW");

var $4PFx6 = parcelRequire("4PFx6");

var $3NKEZ = parcelRequire("3NKEZ");

var $axmEP = parcelRequire("axmEP");

var $l0wDR = parcelRequire("l0wDR");

var $aknDF = parcelRequire("aknDF");

var $iwqgS = parcelRequire("iwqgS");

var $9MxTl = parcelRequire("9MxTl");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");

var $kQlZ1 = parcelRequire("kQlZ1");
var $d9ef009191ddae40$export$6bef9d59f22e8880 = function(x) {
    return x;
};
var $d9ef009191ddae40$export$973e92d98e897dbf = function(v) {
    return v;
};
var $d9ef009191ddae40$export$d5b925da5ee69c31 = {
    Coercible0: function() {
        return undefined;
    }
};
var $d9ef009191ddae40$export$6b749a3db2c2aac6 = function(dictMonoid) {
    var mempty = $aknDF.mempty(dictMonoid);
    return {
        lift: function(dictMonad) {
            var bind = $9Grh5.bind(dictMonad.Bind1());
            var pure = $gUTA8.pure(dictMonad.Applicative0());
            return function(m) {
                return bind(m)(function(a) {
                    return pure(new $9MxTl.Tuple(a, mempty));
                });
            };
        }
    };
};
var $d9ef009191ddae40$export$c950a71321ef1ffc = function(f) {
    return function(v) {
        return f(v);
    };
};
var $d9ef009191ddae40$export$502115c714790859 = function(dictFunctor) {
    var map = $l0wDR.map(dictFunctor);
    return {
        map: function(f) {
            return $d9ef009191ddae40$export$c950a71321ef1ffc(map(function(v) {
                return new $9MxTl.Tuple(f(v.value0), v.value1);
            }));
        }
    };
};
var $d9ef009191ddae40$export$730fbe746bee115d = function(dictFunctor) {
    var map = $l0wDR.map(dictFunctor);
    return function(v) {
        return map($9MxTl.snd)(v);
    };
};
var $d9ef009191ddae40$export$2f46a8de9e2e0acc = function(dictSemigroup) {
    var append = $iwqgS.append(dictSemigroup);
    return function(dictApply) {
        var apply = $a5g3C.apply(dictApply);
        var Functor0 = dictApply.Functor0();
        var map = $l0wDR.map(Functor0);
        var functorWriterT1 = $d9ef009191ddae40$export$502115c714790859(Functor0);
        return {
            apply: function(v) {
                return function(v1) {
                    var k = function(v3) {
                        return function(v4) {
                            return new $9MxTl.Tuple(v3.value0(v4.value0), append(v3.value1)(v4.value1));
                        };
                    };
                    return apply(map(k)(v))(v1);
                };
            },
            Functor0: function() {
                return functorWriterT1;
            }
        };
    };
};
var $d9ef009191ddae40$export$4483e5256f36d121 = function(dictSemigroup) {
    var append = $iwqgS.append(dictSemigroup);
    var applyWriterT1 = $d9ef009191ddae40$export$2f46a8de9e2e0acc(dictSemigroup);
    return function(dictBind) {
        var bind = $9Grh5.bind(dictBind);
        var Apply0 = dictBind.Apply0();
        var map = $l0wDR.map(Apply0.Functor0());
        var applyWriterT2 = applyWriterT1(Apply0);
        return {
            bind: function(v) {
                return function(k) {
                    return bind(v)(function(v1) {
                        var v2 = k(v1.value0);
                        return map(function(v3) {
                            return new $9MxTl.Tuple(v3.value0, append(v1.value1)(v3.value1));
                        })(v2);
                    });
                };
            },
            Apply0: function() {
                return applyWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$8c475e05f959fff2 = function(dictApply) {
    return function(dictSemigroup) {
        var lift2 = $a5g3C.lift2($d9ef009191ddae40$export$2f46a8de9e2e0acc(dictSemigroup)(dictApply));
        return function(dictSemigroup1) {
            return {
                append: lift2($iwqgS.append(dictSemigroup1))
            };
        };
    };
};
var $d9ef009191ddae40$export$c3b0a193a5475c40 = function(dictMonoid) {
    var mempty = $aknDF.mempty(dictMonoid);
    var applyWriterT1 = $d9ef009191ddae40$export$2f46a8de9e2e0acc(dictMonoid.Semigroup0());
    return function(dictApplicative) {
        var pure = $gUTA8.pure(dictApplicative);
        var applyWriterT2 = applyWriterT1(dictApplicative.Apply0());
        return {
            pure: function(a) {
                return pure(new $9MxTl.Tuple(a, mempty));
            },
            Apply0: function() {
                return applyWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$a45df43c41b778a = function(dictMonoid) {
    var applicativeWriterT1 = $d9ef009191ddae40$export$c3b0a193a5475c40(dictMonoid);
    var bindWriterT1 = $d9ef009191ddae40$export$4483e5256f36d121(dictMonoid.Semigroup0());
    return function(dictMonad) {
        var applicativeWriterT2 = applicativeWriterT1(dictMonad.Applicative0());
        var bindWriterT2 = bindWriterT1(dictMonad.Bind1());
        return {
            Applicative0: function() {
                return applicativeWriterT2;
            },
            Bind1: function() {
                return bindWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$2b88d21fdbd23b84 = function(dictMonoid) {
    var lift = $4PFx6.lift($d9ef009191ddae40$export$6b749a3db2c2aac6(dictMonoid));
    var monadWriterT1 = $d9ef009191ddae40$export$a45df43c41b778a(dictMonoid);
    return function(dictMonadAsk) {
        var Monad0 = dictMonadAsk.Monad0();
        var monadWriterT2 = monadWriterT1(Monad0);
        return {
            ask: lift(Monad0)($9ZRMq.ask(dictMonadAsk)),
            Monad0: function() {
                return monadWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$1e8e23b27bf4b6eb = function(dictMonoid) {
    var monadAskWriterT1 = $d9ef009191ddae40$export$2b88d21fdbd23b84(dictMonoid);
    return function(dictMonadReader) {
        var local = $9ZRMq.local(dictMonadReader);
        var monadAskWriterT2 = monadAskWriterT1(dictMonadReader.MonadAsk0());
        return {
            local: function(f) {
                return $d9ef009191ddae40$export$c950a71321ef1ffc(local(f));
            },
            MonadAsk0: function() {
                return monadAskWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$7520b5391c6ad7c7 = function(dictMonoid) {
    var mempty = $aknDF.mempty(dictMonoid);
    var monadWriterT1 = $d9ef009191ddae40$export$a45df43c41b778a(dictMonoid);
    return function(dictMonadCont) {
        var callCC = $8UXl5.callCC(dictMonadCont);
        var monadWriterT2 = monadWriterT1(dictMonadCont.Monad0());
        return {
            callCC: function(f) {
                return callCC(function(c) {
                    var v = f(function(a) {
                        return c(new $9MxTl.Tuple(a, mempty));
                    });
                    return v;
                });
            },
            Monad0: function() {
                return monadWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$29fece65832b4369 = function(dictMonoid) {
    var lift = $4PFx6.lift($d9ef009191ddae40$export$6b749a3db2c2aac6(dictMonoid));
    var monadWriterT1 = $d9ef009191ddae40$export$a45df43c41b778a(dictMonoid);
    return function(dictMonadEffect) {
        var Monad0 = dictMonadEffect.Monad0();
        var monadWriterT2 = monadWriterT1(Monad0);
        return {
            liftEffect: function() {
                var $259 = lift(Monad0);
                var $260 = $kQlZ1.liftEffect(dictMonadEffect);
                return function($261) {
                    return $259($260($261));
                };
            }(),
            Monad0: function() {
                return monadWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$36179168852a11d0 = function(dictMonoid) {
    var append = $iwqgS.append(dictMonoid.Semigroup0());
    var mempty = $aknDF.mempty(dictMonoid);
    var monadWriterT1 = $d9ef009191ddae40$export$a45df43c41b778a(dictMonoid);
    return function(dictMonadRec) {
        var Monad0 = dictMonadRec.Monad0();
        var bind = $9Grh5.bind(Monad0.Bind1());
        var pure = $gUTA8.pure(Monad0.Applicative0());
        var tailRecM = $lowBm.tailRecM(dictMonadRec);
        var monadWriterT2 = monadWriterT1(Monad0);
        return {
            tailRecM: function(f) {
                return function(a) {
                    var f$prime = function(v) {
                        var v1 = f(v.value0);
                        return bind(v1)(function(v2) {
                            return pure(function() {
                                if (v2.value0 instanceof $lowBm.Loop) return new $lowBm.Loop(new $9MxTl.Tuple(v2.value0.value0, append(v.value1)(v2.value1)));
                                if (v2.value0 instanceof $lowBm.Done) return new $lowBm.Done(new $9MxTl.Tuple(v2.value0.value0, append(v.value1)(v2.value1)));
                                throw new Error("Failed pattern match at Control.Monad.Writer.Trans (line 84, column 16 - line 86, column 47): " + [
                                    v2.value0.constructor.name
                                ]);
                            }());
                        });
                    };
                    return tailRecM(f$prime)(new $9MxTl.Tuple(a, mempty));
                };
            },
            Monad0: function() {
                return monadWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$6594c621b12bf0b9 = function(dictMonoid) {
    var lift = $4PFx6.lift($d9ef009191ddae40$export$6b749a3db2c2aac6(dictMonoid));
    var monadWriterT1 = $d9ef009191ddae40$export$a45df43c41b778a(dictMonoid);
    return function(dictMonadState) {
        var Monad0 = dictMonadState.Monad0();
        var lift1 = lift(Monad0);
        var state = $kQAxW.state(dictMonadState);
        var monadWriterT2 = monadWriterT1(Monad0);
        return {
            state: function(f) {
                return lift1(state(f));
            },
            Monad0: function() {
                return monadWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$b022f808a9791225 = function(dictMonoid) {
    var Semigroup0 = dictMonoid.Semigroup0();
    var monadWriterT1 = $d9ef009191ddae40$export$a45df43c41b778a(dictMonoid);
    return function(dictMonad) {
        var monadWriterT2 = monadWriterT1(dictMonad);
        return {
            tell: function() {
                var $262 = $gUTA8.pure(dictMonad.Applicative0());
                var $263 = $9MxTl.Tuple.create($r2HHk.unit);
                return function($264) {
                    return $d9ef009191ddae40$export$6bef9d59f22e8880($262($263($264)));
                };
            }(),
            Semigroup0: function() {
                return Semigroup0;
            },
            Monad1: function() {
                return monadWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$f2385bf9afd45c19 = function(dictMonoid) {
    var monadTellWriterT1 = $d9ef009191ddae40$export$b022f808a9791225(dictMonoid);
    return function(dictMonad) {
        var bind = $9Grh5.bind(dictMonad.Bind1());
        var pure = $gUTA8.pure(dictMonad.Applicative0());
        var monadTellWriterT2 = monadTellWriterT1(dictMonad);
        return {
            listen: function(v) {
                return bind(v)(function(v1) {
                    return pure(new $9MxTl.Tuple(new $9MxTl.Tuple(v1.value0, v1.value1), v1.value1));
                });
            },
            pass: function(v) {
                return bind(v)(function(v1) {
                    return pure(new $9MxTl.Tuple(v1.value0.value0, v1.value0.value1(v1.value1)));
                });
            },
            Monoid0: function() {
                return dictMonoid;
            },
            MonadTell1: function() {
                return monadTellWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$8fbe11284b53cf18 = function(dictMonoid) {
    var lift = $4PFx6.lift($d9ef009191ddae40$export$6b749a3db2c2aac6(dictMonoid));
    var monadWriterT1 = $d9ef009191ddae40$export$a45df43c41b778a(dictMonoid);
    return function(dictMonadThrow) {
        var Monad0 = dictMonadThrow.Monad0();
        var lift1 = lift(Monad0);
        var throwError = $84kZf.throwError(dictMonadThrow);
        var monadWriterT2 = monadWriterT1(Monad0);
        return {
            throwError: function(e) {
                return lift1(throwError(e));
            },
            Monad0: function() {
                return monadWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$f7d1d5bacfa0742c = function(dictMonoid) {
    var monadThrowWriterT1 = $d9ef009191ddae40$export$8fbe11284b53cf18(dictMonoid);
    return function(dictMonadError) {
        var catchError = $84kZf.catchError(dictMonadError);
        var monadThrowWriterT2 = monadThrowWriterT1(dictMonadError.MonadThrow0());
        return {
            catchError: function(v) {
                return function(h) {
                    return catchError(v)(function(e) {
                        var v1 = h(e);
                        return v1;
                    });
                };
            },
            MonadThrow0: function() {
                return monadThrowWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$3e5fc362694e79bf = function(dictMonoid) {
    var lift = $4PFx6.lift($d9ef009191ddae40$export$6b749a3db2c2aac6(dictMonoid));
    var monadWriterT1 = $d9ef009191ddae40$export$a45df43c41b778a(dictMonoid);
    return function(dictMonadST) {
        var Monad0 = dictMonadST.Monad0();
        var monadWriterT2 = monadWriterT1(Monad0);
        return {
            liftST: function() {
                var $265 = lift(Monad0);
                var $266 = $iYXib.liftST(dictMonadST);
                return function($267) {
                    return $265($266($267));
                };
            }(),
            Monad0: function() {
                return monadWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$8a353f8c5b798525 = function(dictApplicative) {
    var semigroupWriterT1 = $d9ef009191ddae40$export$8c475e05f959fff2(dictApplicative.Apply0());
    return function(dictMonoid) {
        var pure = $gUTA8.pure($d9ef009191ddae40$export$c3b0a193a5475c40(dictMonoid)(dictApplicative));
        var semigroupWriterT2 = semigroupWriterT1(dictMonoid.Semigroup0());
        return function(dictMonoid1) {
            var semigroupWriterT3 = semigroupWriterT2(dictMonoid1.Semigroup0());
            return {
                mempty: pure($aknDF.mempty(dictMonoid1)),
                Semigroup0: function() {
                    return semigroupWriterT3;
                }
            };
        };
    };
};
var $d9ef009191ddae40$export$6f6793d950011736 = function(dictAlt) {
    var alt = $a7Dxq.alt(dictAlt);
    var functorWriterT1 = $d9ef009191ddae40$export$502115c714790859(dictAlt.Functor0());
    return {
        alt: function(v) {
            return function(v1) {
                return alt(v)(v1);
            };
        },
        Functor0: function() {
            return functorWriterT1;
        }
    };
};
var $d9ef009191ddae40$export$a57a36ca2cee11fb = function(dictPlus) {
    var altWriterT1 = $d9ef009191ddae40$export$6f6793d950011736(dictPlus.Alt0());
    return {
        empty: $axmEP.empty(dictPlus),
        Alt0: function() {
            return altWriterT1;
        }
    };
};
var $d9ef009191ddae40$export$c91ecc30f23c76ec = function(dictMonoid) {
    var applicativeWriterT1 = $d9ef009191ddae40$export$c3b0a193a5475c40(dictMonoid);
    return function(dictAlternative) {
        var applicativeWriterT2 = applicativeWriterT1(dictAlternative.Applicative0());
        var plusWriterT1 = $d9ef009191ddae40$export$a57a36ca2cee11fb(dictAlternative.Plus1());
        return {
            Applicative0: function() {
                return applicativeWriterT2;
            },
            Plus1: function() {
                return plusWriterT1;
            }
        };
    };
};
var $d9ef009191ddae40$export$1c68552a87a434af = function(dictMonoid) {
    var monadWriterT1 = $d9ef009191ddae40$export$a45df43c41b778a(dictMonoid);
    var alternativeWriterT1 = $d9ef009191ddae40$export$c91ecc30f23c76ec(dictMonoid);
    return function(dictMonadPlus) {
        var monadWriterT2 = monadWriterT1(dictMonadPlus.Monad0());
        var alternativeWriterT2 = alternativeWriterT1(dictMonadPlus.Alternative1());
        return {
            Monad0: function() {
                return monadWriterT2;
            },
            Alternative1: function() {
                return alternativeWriterT2;
            }
        };
    };
};

});

parcelRegister("8rZxf", function(module, exports) {

$parcel$export(module.exports, "bifoldableTuple", () => $627093fb1ee74b6b$export$9e57ed04fa06006f);
$parcel$export(module.exports, "bifoldableJoker", () => $627093fb1ee74b6b$export$3ea37b6c505d5921);
$parcel$export(module.exports, "bifoldableEither", () => $627093fb1ee74b6b$export$631c798dd7783874);
$parcel$export(module.exports, "bifoldableConst", () => $627093fb1ee74b6b$export$fac7dcf8414b1558);
$parcel$export(module.exports, "bifoldableClown", () => $627093fb1ee74b6b$export$48d6bd28fb1f7b98);
$parcel$export(module.exports, "bifoldMap", () => $627093fb1ee74b6b$export$7bc3582301cda79f);
$parcel$export(module.exports, "bifoldableFlip", () => $627093fb1ee74b6b$export$83ed5690f1f40b8b);
$parcel$export(module.exports, "bifoldlDefault", () => $627093fb1ee74b6b$export$c7471c021d101489);
$parcel$export(module.exports, "bifoldrDefault", () => $627093fb1ee74b6b$export$43eff0ef7d27584d);
$parcel$export(module.exports, "bifoldableProduct2", () => $627093fb1ee74b6b$export$15009c29dbef42b7);
// Generated by purs version 0.15.16

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $7T8P4 = parcelRequire("7T8P4");

var $aKY4H = parcelRequire("aKY4H");

var $6RkEA = parcelRequire("6RkEA");

var $l4M7e = parcelRequire("l4M7e");

var $aknDF = parcelRequire("aknDF");

var $8JeQl = parcelRequire("8JeQl");

var $1zczT = parcelRequire("1zczT");

var $bbOAS = parcelRequire("bbOAS");

var $7wVLo = parcelRequire("7wVLo");

var $6PW1p = parcelRequire("6PW1p");

var $iwqgS = parcelRequire("iwqgS");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");
var $627093fb1ee74b6b$var$identity = /* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn);
var $627093fb1ee74b6b$var$unwrap = /* #__PURE__ */ $6PW1p.unwrap();
var $627093fb1ee74b6b$var$monoidEndo = /* #__PURE__ */ $7wVLo.monoidEndo($7T8P4.categoryFn);
var $627093fb1ee74b6b$var$monoidDual = /* #__PURE__ */ $bbOAS.monoidDual($627093fb1ee74b6b$var$monoidEndo);
var $627093fb1ee74b6b$export$140b6cacf0caee10 = function(dict) {
    return dict.bifoldr;
};
var $627093fb1ee74b6b$export$2467df3bb4497583 = function(dictBifoldable) {
    var bifoldr1 = $627093fb1ee74b6b$export$140b6cacf0caee10(dictBifoldable);
    return function(dictApplicative) {
        var applySecond = $a5g3C.applySecond(dictApplicative.Apply0());
        var pure = $gUTA8.pure(dictApplicative);
        return function(f) {
            return function(g) {
                return bifoldr1(function($207) {
                    return applySecond(f($207));
                })(function($208) {
                    return applySecond(g($208));
                })(pure($r2HHk.unit));
            };
        };
    };
};
var $627093fb1ee74b6b$export$2018976ee387bf60 = function(dictBifoldable) {
    var bitraverse_1 = $627093fb1ee74b6b$export$2467df3bb4497583(dictBifoldable);
    return function(dictApplicative) {
        var bitraverse_2 = bitraverse_1(dictApplicative);
        return function(t) {
            return function(f) {
                return function(g) {
                    return bitraverse_2(f)(g)(t);
                };
            };
        };
    };
};
var $627093fb1ee74b6b$export$39fe8462a48d4c44 = function(dictBifoldable) {
    var bitraverse_1 = $627093fb1ee74b6b$export$2467df3bb4497583(dictBifoldable);
    return function(dictApplicative) {
        return bitraverse_1(dictApplicative)($627093fb1ee74b6b$var$identity)($627093fb1ee74b6b$var$identity);
    };
};
var $627093fb1ee74b6b$export$fd45dcee229151ae = function(dict) {
    return dict.bifoldl;
};
var $627093fb1ee74b6b$export$9e57ed04fa06006f = {
    bifoldMap: function(dictMonoid) {
        var append = $iwqgS.append(dictMonoid.Semigroup0());
        return function(f) {
            return function(g) {
                return function(v) {
                    return append(f(v.value0))(g(v.value1));
                };
            };
        };
    },
    bifoldr: function(f) {
        return function(g) {
            return function(z) {
                return function(v) {
                    return f(v.value0)(g(v.value1)(z));
                };
            };
        };
    },
    bifoldl: function(f) {
        return function(g) {
            return function(z) {
                return function(v) {
                    return g(f(z)(v.value0))(v.value1);
                };
            };
        };
    }
};
var $627093fb1ee74b6b$export$3ea37b6c505d5921 = function(dictFoldable) {
    var foldr = $6RkEA.foldr(dictFoldable);
    var foldl = $6RkEA.foldl(dictFoldable);
    var foldMap = $6RkEA.foldMap(dictFoldable);
    return {
        bifoldr: function(v) {
            return function(r) {
                return function(u) {
                    return function(v1) {
                        return foldr(r)(u)(v1);
                    };
                };
            };
        },
        bifoldl: function(v) {
            return function(r) {
                return function(u) {
                    return function(v1) {
                        return foldl(r)(u)(v1);
                    };
                };
            };
        },
        bifoldMap: function(dictMonoid) {
            var foldMap1 = foldMap(dictMonoid);
            return function(v) {
                return function(r) {
                    return function(v1) {
                        return foldMap1(r)(v1);
                    };
                };
            };
        }
    };
};
var $627093fb1ee74b6b$export$631c798dd7783874 = {
    bifoldr: function(v) {
        return function(v1) {
            return function(v2) {
                return function(v3) {
                    if (v3 instanceof $aKY4H.Left) return v(v3.value0)(v2);
                    if (v3 instanceof $aKY4H.Right) return v1(v3.value0)(v2);
                    throw new Error("Failed pattern match at Data.Bifoldable (line 62, column 1 - line 68, column 32): " + [
                        v.constructor.name,
                        v1.constructor.name,
                        v2.constructor.name,
                        v3.constructor.name
                    ]);
                };
            };
        };
    },
    bifoldl: function(v) {
        return function(v1) {
            return function(v2) {
                return function(v3) {
                    if (v3 instanceof $aKY4H.Left) return v(v2)(v3.value0);
                    if (v3 instanceof $aKY4H.Right) return v1(v2)(v3.value0);
                    throw new Error("Failed pattern match at Data.Bifoldable (line 62, column 1 - line 68, column 32): " + [
                        v.constructor.name,
                        v1.constructor.name,
                        v2.constructor.name,
                        v3.constructor.name
                    ]);
                };
            };
        };
    },
    bifoldMap: function(dictMonoid) {
        return function(v) {
            return function(v1) {
                return function(v2) {
                    if (v2 instanceof $aKY4H.Left) return v(v2.value0);
                    if (v2 instanceof $aKY4H.Right) return v1(v2.value0);
                    throw new Error("Failed pattern match at Data.Bifoldable (line 62, column 1 - line 68, column 32): " + [
                        v.constructor.name,
                        v1.constructor.name,
                        v2.constructor.name
                    ]);
                };
            };
        };
    }
};
var $627093fb1ee74b6b$export$fac7dcf8414b1558 = {
    bifoldr: function(f) {
        return function(v) {
            return function(z) {
                return function(v1) {
                    return f(v1)(z);
                };
            };
        };
    },
    bifoldl: function(f) {
        return function(v) {
            return function(z) {
                return function(v1) {
                    return f(z)(v1);
                };
            };
        };
    },
    bifoldMap: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return function(v1) {
                    return f(v1);
                };
            };
        };
    }
};
var $627093fb1ee74b6b$export$48d6bd28fb1f7b98 = function(dictFoldable) {
    var foldr = $6RkEA.foldr(dictFoldable);
    var foldl = $6RkEA.foldl(dictFoldable);
    var foldMap = $6RkEA.foldMap(dictFoldable);
    return {
        bifoldr: function(l) {
            return function(v) {
                return function(u) {
                    return function(v1) {
                        return foldr(l)(u)(v1);
                    };
                };
            };
        },
        bifoldl: function(l) {
            return function(v) {
                return function(u) {
                    return function(v1) {
                        return foldl(l)(u)(v1);
                    };
                };
            };
        },
        bifoldMap: function(dictMonoid) {
            var foldMap1 = foldMap(dictMonoid);
            return function(l) {
                return function(v) {
                    return function(v1) {
                        return foldMap1(l)(v1);
                    };
                };
            };
        }
    };
};
var $627093fb1ee74b6b$export$d9dff9894698034d = function(dictBifoldable) {
    var bifoldr1 = $627093fb1ee74b6b$export$140b6cacf0caee10(dictBifoldable);
    return function(dictMonoid) {
        var append = $iwqgS.append(dictMonoid.Semigroup0());
        var mempty = $aknDF.mempty(dictMonoid);
        return function(f) {
            return function(g) {
                return bifoldr1(function($209) {
                    return append(f($209));
                })(function($210) {
                    return append(g($210));
                })(mempty);
            };
        };
    };
};
var $627093fb1ee74b6b$export$d9474c98248f3f9f = function(dictBifoldable) {
    var bifoldl1 = $627093fb1ee74b6b$export$fd45dcee229151ae(dictBifoldable);
    return function(dictMonoid) {
        var append = $iwqgS.append(dictMonoid.Semigroup0());
        var mempty = $aknDF.mempty(dictMonoid);
        return function(f) {
            return function(g) {
                return bifoldl1(function(m) {
                    return function(a) {
                        return append(m)(f(a));
                    };
                })(function(m) {
                    return function(b) {
                        return append(m)(g(b));
                    };
                })(mempty);
            };
        };
    };
};
var $627093fb1ee74b6b$export$7bc3582301cda79f = function(dict) {
    return dict.bifoldMap;
};
var $627093fb1ee74b6b$export$83ed5690f1f40b8b = function(dictBifoldable) {
    var bifoldr1 = $627093fb1ee74b6b$export$140b6cacf0caee10(dictBifoldable);
    var bifoldl1 = $627093fb1ee74b6b$export$fd45dcee229151ae(dictBifoldable);
    var bifoldMap1 = $627093fb1ee74b6b$export$7bc3582301cda79f(dictBifoldable);
    return {
        bifoldr: function(r) {
            return function(l) {
                return function(u) {
                    return function(v) {
                        return bifoldr1(l)(r)(u)(v);
                    };
                };
            };
        },
        bifoldl: function(r) {
            return function(l) {
                return function(u) {
                    return function(v) {
                        return bifoldl1(l)(r)(u)(v);
                    };
                };
            };
        },
        bifoldMap: function(dictMonoid) {
            var bifoldMap2 = bifoldMap1(dictMonoid);
            return function(r) {
                return function(l) {
                    return function(v) {
                        return bifoldMap2(l)(r)(v);
                    };
                };
            };
        }
    };
};
var $627093fb1ee74b6b$export$c7471c021d101489 = function(dictBifoldable) {
    var bifoldMap1 = $627093fb1ee74b6b$export$7bc3582301cda79f(dictBifoldable)($627093fb1ee74b6b$var$monoidDual);
    return function(f) {
        return function(g) {
            return function(z) {
                return function(p) {
                    return $627093fb1ee74b6b$var$unwrap($627093fb1ee74b6b$var$unwrap(bifoldMap1(function() {
                        var $211 = $l4M7e.flip(f);
                        return function($212) {
                            return $bbOAS.Dual($7wVLo.Endo($211($212)));
                        };
                    }())(function() {
                        var $213 = $l4M7e.flip(g);
                        return function($214) {
                            return $bbOAS.Dual($7wVLo.Endo($213($214)));
                        };
                    }())(p)))(z);
                };
            };
        };
    };
};
var $627093fb1ee74b6b$export$43eff0ef7d27584d = function(dictBifoldable) {
    var bifoldMap1 = $627093fb1ee74b6b$export$7bc3582301cda79f(dictBifoldable)($627093fb1ee74b6b$var$monoidEndo);
    return function(f) {
        return function(g) {
            return function(z) {
                return function(p) {
                    return $627093fb1ee74b6b$var$unwrap(bifoldMap1(function($215) {
                        return $7wVLo.Endo(f($215));
                    })(function($216) {
                        return $7wVLo.Endo(g($216));
                    })(p))(z);
                };
            };
        };
    };
};
var $627093fb1ee74b6b$export$15009c29dbef42b7 = function(dictBifoldable) {
    var bifoldMap1 = $627093fb1ee74b6b$export$7bc3582301cda79f(dictBifoldable);
    return function(dictBifoldable1) {
        var bifoldMap2 = $627093fb1ee74b6b$export$7bc3582301cda79f(dictBifoldable1);
        return {
            bifoldr: function(l) {
                return function(r) {
                    return function(u) {
                        return function(m) {
                            return $627093fb1ee74b6b$export$43eff0ef7d27584d($627093fb1ee74b6b$export$15009c29dbef42b7(dictBifoldable)(dictBifoldable1))(l)(r)(u)(m);
                        };
                    };
                };
            },
            bifoldl: function(l) {
                return function(r) {
                    return function(u) {
                        return function(m) {
                            return $627093fb1ee74b6b$export$c7471c021d101489($627093fb1ee74b6b$export$15009c29dbef42b7(dictBifoldable)(dictBifoldable1))(l)(r)(u)(m);
                        };
                    };
                };
            },
            bifoldMap: function(dictMonoid) {
                var append = $iwqgS.append(dictMonoid.Semigroup0());
                var bifoldMap3 = bifoldMap1(dictMonoid);
                var bifoldMap4 = bifoldMap2(dictMonoid);
                return function(l) {
                    return function(r) {
                        return function(v) {
                            return append(bifoldMap3(l)(r)(v.value0))(bifoldMap4(l)(r)(v.value1));
                        };
                    };
                };
            }
        };
    };
};
var $627093fb1ee74b6b$export$16bd399c2eeb79bd = function(dictBifoldable) {
    var bifoldMap1 = $627093fb1ee74b6b$export$7bc3582301cda79f(dictBifoldable);
    return function(dictMonoid) {
        return bifoldMap1(dictMonoid)($627093fb1ee74b6b$var$identity)($627093fb1ee74b6b$var$identity);
    };
};
var $627093fb1ee74b6b$export$b2f5f4f071ae5de6 = function(dictBifoldable) {
    var bifoldMap1 = $627093fb1ee74b6b$export$7bc3582301cda79f(dictBifoldable);
    return function(dictBooleanAlgebra) {
        var bifoldMap2 = bifoldMap1($1zczT.monoidDisj(dictBooleanAlgebra.HeytingAlgebra0()));
        return function(p) {
            return function(q) {
                var $217 = bifoldMap2(function($219) {
                    return $1zczT.Disj(p($219));
                })(function($220) {
                    return $1zczT.Disj(q($220));
                });
                return function($218) {
                    return $627093fb1ee74b6b$var$unwrap($217($218));
                };
            };
        };
    };
};
var $627093fb1ee74b6b$export$75b148bc89d1ac62 = function(dictBifoldable) {
    var bifoldMap1 = $627093fb1ee74b6b$export$7bc3582301cda79f(dictBifoldable);
    return function(dictBooleanAlgebra) {
        var bifoldMap2 = bifoldMap1($8JeQl.monoidConj(dictBooleanAlgebra.HeytingAlgebra0()));
        return function(p) {
            return function(q) {
                var $221 = bifoldMap2(function($223) {
                    return $8JeQl.Conj(p($223));
                })(function($224) {
                    return $8JeQl.Conj(q($224));
                });
                return function($222) {
                    return $627093fb1ee74b6b$var$unwrap($221($222));
                };
            };
        };
    };
};

});

parcelRegister("kzMnk", function(module, exports) {

$parcel$export(module.exports, "bitraverse", () => $efac99db7971f271$export$f664b6bec32af3f2);
$parcel$export(module.exports, "bisequenceDefault", () => $efac99db7971f271$export$b907c0867bacb762);
// Generated by purs version 0.15.16

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $7T8P4 = parcelRequire("7T8P4");

var $8rZxf = parcelRequire("8rZxf");

var $2Mmje = parcelRequire("2Mmje");

var $1qMIU = parcelRequire("1qMIU");

var $aKY4H = parcelRequire("aKY4H");

var $l0wDR = parcelRequire("l0wDR");

var $irt3F = parcelRequire("irt3F");

var $j4tdJ = parcelRequire("j4tdJ");

var $lfKKM = parcelRequire("lfKKM");

var $lHkBx = parcelRequire("lHkBx");

var $1wR1l = parcelRequire("1wR1l");

var $9MxTl = parcelRequire("9MxTl");
var $efac99db7971f271$var$identity = /* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn);
var $efac99db7971f271$export$f664b6bec32af3f2 = function(dict) {
    return dict.bitraverse;
};
var $efac99db7971f271$export$4bdf9ec3e0ef1266 = function(dictBitraversable) {
    var bitraverse1 = $efac99db7971f271$export$f664b6bec32af3f2(dictBitraversable);
    return function(dictApplicative) {
        var bitraverse2 = bitraverse1(dictApplicative);
        var pure = $gUTA8.pure(dictApplicative);
        return function(t) {
            return function(f) {
                return bitraverse2(f)(pure)(t);
            };
        };
    };
};
var $efac99db7971f271$export$4a1651cd8fd555cf = function(dictBitraversable) {
    var bitraverse1 = $efac99db7971f271$export$f664b6bec32af3f2(dictBitraversable);
    return function(dictApplicative) {
        var bitraverse2 = bitraverse1(dictApplicative);
        var pure = $gUTA8.pure(dictApplicative);
        return function(f) {
            return bitraverse2(f)(pure);
        };
    };
};
var $efac99db7971f271$export$e0fb30cfec67a969 = function(dictBitraversable) {
    var bitraverse1 = $efac99db7971f271$export$f664b6bec32af3f2(dictBitraversable);
    return function(dictApplicative) {
        var bitraverse2 = bitraverse1(dictApplicative);
        var pure = $gUTA8.pure(dictApplicative);
        return function(t) {
            return function(f) {
                return bitraverse2(pure)(f)(t);
            };
        };
    };
};
var $efac99db7971f271$export$6f921142225b4cb1 = function(dictBitraversable) {
    var bitraverse1 = $efac99db7971f271$export$f664b6bec32af3f2(dictBitraversable);
    return function(dictApplicative) {
        return bitraverse1(dictApplicative)($gUTA8.pure(dictApplicative));
    };
};
var $efac99db7971f271$export$b0be3b32fab47d0a = {
    bitraverse: function(dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        var apply = $a5g3C.apply(Apply0);
        var map = $l0wDR.map(Apply0.Functor0());
        return function(f) {
            return function(g) {
                return function(v) {
                    return apply(map($9MxTl.Tuple.create)(f(v.value0)))(g(v.value1));
                };
            };
        };
    },
    bisequence: function(dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        var apply = $a5g3C.apply(Apply0);
        var map = $l0wDR.map(Apply0.Functor0());
        return function(v) {
            return apply(map($9MxTl.Tuple.create)(v.value0))(v.value1);
        };
    },
    Bifunctor0: function() {
        return $2Mmje.bifunctorTuple;
    },
    Bifoldable1: function() {
        return $8rZxf.bifoldableTuple;
    }
};
var $efac99db7971f271$export$5c615a3bd82f83ea = function(dictTraversable) {
    var traverse = $1wR1l.traverse(dictTraversable);
    var sequence = $1wR1l.sequence(dictTraversable);
    var bifunctorJoker = $lfKKM.bifunctorJoker(dictTraversable.Functor0());
    var bifoldableJoker = $8rZxf.bifoldableJoker(dictTraversable.Foldable1());
    return {
        bitraverse: function(dictApplicative) {
            var map = $l0wDR.map(dictApplicative.Apply0().Functor0());
            var traverse1 = traverse(dictApplicative);
            return function(v) {
                return function(r) {
                    return function(v1) {
                        return map($lfKKM.Joker)(traverse1(r)(v1));
                    };
                };
            };
        },
        bisequence: function(dictApplicative) {
            var map = $l0wDR.map(dictApplicative.Apply0().Functor0());
            var sequence1 = sequence(dictApplicative);
            return function(v) {
                return map($lfKKM.Joker)(sequence1(v));
            };
        },
        Bifunctor0: function() {
            return bifunctorJoker;
        },
        Bifoldable1: function() {
            return bifoldableJoker;
        }
    };
};
var $efac99db7971f271$export$d5985330978d0d8e = {
    bitraverse: function(dictApplicative) {
        var map = $l0wDR.map(dictApplicative.Apply0().Functor0());
        return function(v) {
            return function(v1) {
                return function(v2) {
                    if (v2 instanceof $aKY4H.Left) return map($aKY4H.Left.create)(v(v2.value0));
                    if (v2 instanceof $aKY4H.Right) return map($aKY4H.Right.create)(v1(v2.value0));
                    throw new Error("Failed pattern match at Data.Bitraversable (line 57, column 1 - line 61, column 37): " + [
                        v.constructor.name,
                        v1.constructor.name,
                        v2.constructor.name
                    ]);
                };
            };
        };
    },
    bisequence: function(dictApplicative) {
        var map = $l0wDR.map(dictApplicative.Apply0().Functor0());
        return function(v) {
            if (v instanceof $aKY4H.Left) return map($aKY4H.Left.create)(v.value0);
            if (v instanceof $aKY4H.Right) return map($aKY4H.Right.create)(v.value0);
            throw new Error("Failed pattern match at Data.Bitraversable (line 57, column 1 - line 61, column 37): " + [
                v.constructor.name
            ]);
        };
    },
    Bifunctor0: function() {
        return $2Mmje.bifunctorEither;
    },
    Bifoldable1: function() {
        return $8rZxf.bifoldableEither;
    }
};
var $efac99db7971f271$export$f03ce3e5a761332f = {
    bitraverse: function(dictApplicative) {
        var map = $l0wDR.map(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return function(v1) {
                    return map($1qMIU.Const)(f(v1));
                };
            };
        };
    },
    bisequence: function(dictApplicative) {
        var map = $l0wDR.map(dictApplicative.Apply0().Functor0());
        return function(v) {
            return map($1qMIU.Const)(v);
        };
    },
    Bifunctor0: function() {
        return $2Mmje.bifunctorConst;
    },
    Bifoldable1: function() {
        return $8rZxf.bifoldableConst;
    }
};
var $efac99db7971f271$export$69b7519c34a78b72 = function(dictTraversable) {
    var traverse = $1wR1l.traverse(dictTraversable);
    var sequence = $1wR1l.sequence(dictTraversable);
    var bifunctorClown = $irt3F.bifunctorClown(dictTraversable.Functor0());
    var bifoldableClown = $8rZxf.bifoldableClown(dictTraversable.Foldable1());
    return {
        bitraverse: function(dictApplicative) {
            var map = $l0wDR.map(dictApplicative.Apply0().Functor0());
            var traverse1 = traverse(dictApplicative);
            return function(l) {
                return function(v) {
                    return function(v1) {
                        return map($irt3F.Clown)(traverse1(l)(v1));
                    };
                };
            };
        },
        bisequence: function(dictApplicative) {
            var map = $l0wDR.map(dictApplicative.Apply0().Functor0());
            var sequence1 = sequence(dictApplicative);
            return function(v) {
                return map($irt3F.Clown)(sequence1(v));
            };
        },
        Bifunctor0: function() {
            return bifunctorClown;
        },
        Bifoldable1: function() {
            return bifoldableClown;
        }
    };
};
var $efac99db7971f271$export$b907c0867bacb762 = function(dictBitraversable) {
    var bitraverse1 = $efac99db7971f271$export$f664b6bec32af3f2(dictBitraversable);
    return function(dictApplicative) {
        return bitraverse1(dictApplicative)($efac99db7971f271$var$identity)($efac99db7971f271$var$identity);
    };
};
var $efac99db7971f271$export$105dc78ebd8ad704 = function(dict) {
    return dict.bisequence;
};
var $efac99db7971f271$export$763d9827b6839c7a = function(dictBitraversable) {
    var bitraverse1 = $efac99db7971f271$export$f664b6bec32af3f2(dictBitraversable);
    var bisequence1 = $efac99db7971f271$export$105dc78ebd8ad704(dictBitraversable);
    var bifunctorFlip = $j4tdJ.bifunctorFlip(dictBitraversable.Bifunctor0());
    var bifoldableFlip = $8rZxf.bifoldableFlip(dictBitraversable.Bifoldable1());
    return {
        bitraverse: function(dictApplicative) {
            var map = $l0wDR.map(dictApplicative.Apply0().Functor0());
            var bitraverse2 = bitraverse1(dictApplicative);
            return function(r) {
                return function(l) {
                    return function(v) {
                        return map($j4tdJ.Flip)(bitraverse2(l)(r)(v));
                    };
                };
            };
        },
        bisequence: function(dictApplicative) {
            var map = $l0wDR.map(dictApplicative.Apply0().Functor0());
            var bisequence2 = bisequence1(dictApplicative);
            return function(v) {
                return map($j4tdJ.Flip)(bisequence2(v));
            };
        },
        Bifunctor0: function() {
            return bifunctorFlip;
        },
        Bifoldable1: function() {
            return bifoldableFlip;
        }
    };
};
var $efac99db7971f271$export$6e4c0387ddae9c26 = function(dictBitraversable) {
    var bitraverse1 = $efac99db7971f271$export$f664b6bec32af3f2(dictBitraversable);
    var bisequence1 = $efac99db7971f271$export$105dc78ebd8ad704(dictBitraversable);
    var bifunctorProduct2 = $lHkBx.bifunctorProduct2(dictBitraversable.Bifunctor0());
    var bifoldableProduct2 = $8rZxf.bifoldableProduct2(dictBitraversable.Bifoldable1());
    return function(dictBitraversable1) {
        var bitraverse2 = $efac99db7971f271$export$f664b6bec32af3f2(dictBitraversable1);
        var bisequence2 = $efac99db7971f271$export$105dc78ebd8ad704(dictBitraversable1);
        var bifunctorProduct21 = bifunctorProduct2(dictBitraversable1.Bifunctor0());
        var bifoldableProduct21 = bifoldableProduct2(dictBitraversable1.Bifoldable1());
        return {
            bitraverse: function(dictApplicative) {
                var Apply0 = dictApplicative.Apply0();
                var apply = $a5g3C.apply(Apply0);
                var map = $l0wDR.map(Apply0.Functor0());
                var bitraverse3 = bitraverse1(dictApplicative);
                var bitraverse4 = bitraverse2(dictApplicative);
                return function(l) {
                    return function(r) {
                        return function(v) {
                            return apply(map($lHkBx.Product2.create)(bitraverse3(l)(r)(v.value0)))(bitraverse4(l)(r)(v.value1));
                        };
                    };
                };
            },
            bisequence: function(dictApplicative) {
                var Apply0 = dictApplicative.Apply0();
                var apply = $a5g3C.apply(Apply0);
                var map = $l0wDR.map(Apply0.Functor0());
                var bisequence3 = bisequence1(dictApplicative);
                var bisequence4 = bisequence2(dictApplicative);
                return function(v) {
                    return apply(map($lHkBx.Product2.create)(bisequence3(v.value0)))(bisequence4(v.value1));
                };
            },
            Bifunctor0: function() {
                return bifunctorProduct21;
            },
            Bifoldable1: function() {
                return bifoldableProduct21;
            }
        };
    };
};
var $efac99db7971f271$export$4fc918b93696de0e = function(dictBitraversable) {
    var bisequence1 = $efac99db7971f271$export$105dc78ebd8ad704(dictBitraversable);
    var bimap = $2Mmje.bimap(dictBitraversable.Bifunctor0());
    return function(dictApplicative) {
        var bisequence2 = bisequence1(dictApplicative);
        return function(f) {
            return function(g) {
                return function(t) {
                    return bisequence2(bimap(f)(g)(t));
                };
            };
        };
    };
};
var $efac99db7971f271$export$864c03cc95ff0e3b = function(dictBitraversable) {
    var bitraverse1 = $efac99db7971f271$export$f664b6bec32af3f2(dictBitraversable);
    return function(dictApplicative) {
        var bitraverse2 = bitraverse1(dictApplicative);
        return function(t) {
            return function(f) {
                return function(g) {
                    return bitraverse2(f)(g)(t);
                };
            };
        };
    };
};

});
parcelRegister("irt3F", function(module, exports) {

$parcel$export(module.exports, "Clown", () => $d6d149fa89f1aabd$export$617c6d3c4831cc55);
$parcel$export(module.exports, "bifunctorClown", () => $d6d149fa89f1aabd$export$49a3b6a3ac05d533);
// Generated by purs version 0.15.16

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $l0wDR = parcelRequire("l0wDR");

var $hVi1M = parcelRequire("hVi1M");

var $3Orkn = parcelRequire("3Orkn");
var $d6d149fa89f1aabd$export$617c6d3c4831cc55 = function(x) {
    return x;
};
var $d6d149fa89f1aabd$export$c320d38647c61759 = function(dictShow) {
    var show = $3Orkn.show(dictShow);
    return {
        show: function(v) {
            return "(Clown " + (show(v) + ")");
        }
    };
};
var $d6d149fa89f1aabd$export$62a719bb29c754ea = function(dictContravariant) {
    var cmap = $hVi1M.cmap(dictContravariant);
    return {
        dimap: function(f) {
            return function(v) {
                return function(v1) {
                    return cmap(f)(v1);
                };
            };
        }
    };
};
var $d6d149fa89f1aabd$export$98046469085cbfc0 = function(dictOrd) {
    return dictOrd;
};
var $d6d149fa89f1aabd$export$4c876fa5e839e472 = {
    Coercible0: function() {
        return undefined;
    }
};
var $d6d149fa89f1aabd$export$968b613baf9bea0a = function(f) {
    return function(v) {
        return f(v);
    };
};
var $d6d149fa89f1aabd$export$a63b78c5190ed148 = {
    map: function(v) {
        return function(v1) {
            return v1;
        };
    }
};
var $d6d149fa89f1aabd$export$e11f6184161f7535 = function(dictEq) {
    return dictEq;
};
var $d6d149fa89f1aabd$export$49a3b6a3ac05d533 = function(dictFunctor) {
    var map = $l0wDR.map(dictFunctor);
    return {
        bimap: function(f) {
            return function(v) {
                return function(v1) {
                    return map(f)(v1);
                };
            };
        }
    };
};
var $d6d149fa89f1aabd$export$2e3be9fb35707fb9 = function(dictApply) {
    var apply = $a5g3C.apply(dictApply);
    var bifunctorClown1 = $d6d149fa89f1aabd$export$49a3b6a3ac05d533(dictApply.Functor0());
    return {
        biapply: function(v) {
            return function(v1) {
                return apply(v)(v1);
            };
        },
        Bifunctor0: function() {
            return bifunctorClown1;
        }
    };
};
var $d6d149fa89f1aabd$export$3bb380ca0409a138 = function(dictApplicative) {
    var pure = $gUTA8.pure(dictApplicative);
    var biapplyClown1 = $d6d149fa89f1aabd$export$2e3be9fb35707fb9(dictApplicative.Apply0());
    return {
        bipure: function(a) {
            return function(v) {
                return pure(a);
            };
        },
        Biapply0: function() {
            return biapplyClown1;
        }
    };
};

});
parcelRegister("hVi1M", function(module, exports) {

$parcel$export(module.exports, "cmap", () => $d0c5be72120caeb7$export$b186cb408b99d7fc);
// Generated by purs version 0.15.16

var $l0wDR = parcelRequire("l0wDR");

var $7DusG = parcelRequire("7DusG");
var $d0c5be72120caeb7$export$578ae18717ba10de = {
    cmap: function(v) {
        return function(v1) {
            return v1;
        };
    }
};
var $d0c5be72120caeb7$export$b186cb408b99d7fc = function(dict) {
    return dict.cmap;
};
var $d0c5be72120caeb7$export$d0a699a1379b7fb5 = function(dictContravariant) {
    var cmap1 = $d0c5be72120caeb7$export$b186cb408b99d7fc(dictContravariant);
    return function(x) {
        return function(f) {
            return cmap1(f)(x);
        };
    };
};
var $d0c5be72120caeb7$export$8c14e57e778d3873 = function(dictContravariant) {
    var cmap1 = $d0c5be72120caeb7$export$b186cb408b99d7fc(dictContravariant);
    return function(dictFunctor) {
        var map = $l0wDR.map(dictFunctor);
        return function(a) {
            return map($7DusG.absurd)(cmap1($7DusG.absurd)(a));
        };
    };
};
var $d0c5be72120caeb7$export$dc224e55acb863f5 = function(dictContravariant) {
    var cmap1 = $d0c5be72120caeb7$export$b186cb408b99d7fc(dictContravariant);
    return function(v) {
        return function(f) {
            return cmap1(f);
        };
    };
};

});


parcelRegister("j4tdJ", function(module, exports) {

$parcel$export(module.exports, "Flip", () => $de250e9a855a8821$export$4d2fae537bd90431);
$parcel$export(module.exports, "bifunctorFlip", () => $de250e9a855a8821$export$3cb4e79429911677);
// Generated by purs version 0.15.16

var $ewum4 = parcelRequire("ewum4");

var $8x2Wd = parcelRequire("8x2Wd");

var $7T8P4 = parcelRequire("7T8P4");

var $7yzxp = parcelRequire("7yzxp");

var $2Mmje = parcelRequire("2Mmje");

var $dnKRS = parcelRequire("dnKRS");

var $3Orkn = parcelRequire("3Orkn");
var $de250e9a855a8821$export$4d2fae537bd90431 = function(x) {
    return x;
};
var $de250e9a855a8821$export$29291423364aa70c = function(dictShow) {
    var show = $3Orkn.show(dictShow);
    return {
        show: function(v) {
            return "(Flip " + (show(v) + ")");
        }
    };
};
var $de250e9a855a8821$export$4ae6be85993247fc = function(dictSemigroupoid) {
    var compose = $7yzxp.compose(dictSemigroupoid);
    return {
        compose: function(v) {
            return function(v1) {
                return compose(v1)(v);
            };
        }
    };
};
var $de250e9a855a8821$export$175d7b12ce1db076 = function(dictOrd) {
    return dictOrd;
};
var $de250e9a855a8821$export$a74ebf4492f31698 = {
    Coercible0: function() {
        return undefined;
    }
};
var $de250e9a855a8821$export$663e27a09bebb78f = function(dictBifunctor) {
    var lmap = $2Mmje.lmap(dictBifunctor);
    return {
        map: function(f) {
            return function(v) {
                return lmap(f)(v);
            };
        }
    };
};
var $de250e9a855a8821$export$ffc04081e45d2595 = function(dictEq) {
    return dictEq;
};
var $de250e9a855a8821$export$621a9013f7700922 = function(dictProfunctor) {
    var lcmap = $dnKRS.lcmap(dictProfunctor);
    return {
        cmap: function(f) {
            return function(v) {
                return lcmap(f)(v);
            };
        }
    };
};
var $de250e9a855a8821$export$8edc16d54231bba5 = function(dictCategory) {
    var semigroupoidFlip1 = $de250e9a855a8821$export$4ae6be85993247fc(dictCategory.Semigroupoid0());
    return {
        identity: $7T8P4.identity(dictCategory),
        Semigroupoid0: function() {
            return semigroupoidFlip1;
        }
    };
};
var $de250e9a855a8821$export$3cb4e79429911677 = function(dictBifunctor) {
    var bimap = $2Mmje.bimap(dictBifunctor);
    return {
        bimap: function(f) {
            return function(g) {
                return function(v) {
                    return bimap(g)(f)(v);
                };
            };
        }
    };
};
var $de250e9a855a8821$export$5ff98b746a3df330 = function(dictBiapply) {
    var biapply = $8x2Wd.biapply(dictBiapply);
    var bifunctorFlip1 = $de250e9a855a8821$export$3cb4e79429911677(dictBiapply.Bifunctor0());
    return {
        biapply: function(v) {
            return function(v1) {
                return biapply(v)(v1);
            };
        },
        Bifunctor0: function() {
            return bifunctorFlip1;
        }
    };
};
var $de250e9a855a8821$export$f4fd609408b6b321 = function(dictBiapplicative) {
    var bipure = $ewum4.bipure(dictBiapplicative);
    var biapplyFlip1 = $de250e9a855a8821$export$5ff98b746a3df330(dictBiapplicative.Biapply0());
    return {
        bipure: function(a) {
            return function(b) {
                return bipure(b)(a);
            };
        },
        Biapply0: function() {
            return biapplyFlip1;
        }
    };
};

});
parcelRegister("ewum4", function(module, exports) {

$parcel$export(module.exports, "bipure", () => $a92b99b22372f0f6$export$2a8f362ea9934c72);
// Generated by purs version 0.15.16

var $8x2Wd = parcelRequire("8x2Wd");

var $9MxTl = parcelRequire("9MxTl");
var $a92b99b22372f0f6$export$2a8f362ea9934c72 = function(dict) {
    return dict.bipure;
};
var $a92b99b22372f0f6$export$9a37246915e03f77 = /* #__PURE__ */ function() {
    return {
        bipure: $9MxTl.Tuple.create,
        Biapply0: function() {
            return $8x2Wd.biapplyTuple;
        }
    };
}();

});
parcelRegister("8x2Wd", function(module, exports) {

$parcel$export(module.exports, "biapplyTuple", () => $6363af3298f653fe$export$10012d3bb776a59b);
$parcel$export(module.exports, "biapply", () => $6363af3298f653fe$export$6ff8eae0be34c22f);
// Generated by purs version 0.15.16

var $7T8P4 = parcelRequire("7T8P4");

var $2Mmje = parcelRequire("2Mmje");

var $l4M7e = parcelRequire("l4M7e");

var $9MxTl = parcelRequire("9MxTl");
var $6363af3298f653fe$var$identity = /* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn);
var $6363af3298f653fe$export$10012d3bb776a59b = {
    biapply: function(v) {
        return function(v1) {
            return new $9MxTl.Tuple(v.value0(v1.value0), v.value1(v1.value1));
        };
    },
    Bifunctor0: function() {
        return $2Mmje.bifunctorTuple;
    }
};
var $6363af3298f653fe$export$6ff8eae0be34c22f = function(dict) {
    return dict.biapply;
};
var $6363af3298f653fe$export$ce80f032d535bf8c = function(dictBiapply) {
    var biapply1 = $6363af3298f653fe$export$6ff8eae0be34c22f(dictBiapply);
    var bimap = $2Mmje.bimap(dictBiapply.Bifunctor0());
    return function(a) {
        return function(b) {
            return biapply1(bimap($l4M7e.const($6363af3298f653fe$var$identity))($l4M7e.const($6363af3298f653fe$var$identity))(a))(b);
        };
    };
};
var $6363af3298f653fe$export$f0109f4e856ff51b = function(dictBiapply) {
    var biapply1 = $6363af3298f653fe$export$6ff8eae0be34c22f(dictBiapply);
    var bimap = $2Mmje.bimap(dictBiapply.Bifunctor0());
    return function(a) {
        return function(b) {
            return biapply1(bimap($l4M7e.const)($l4M7e.const)(a))(b);
        };
    };
};
var $6363af3298f653fe$export$abae8d500b299649 = function(dictBiapply) {
    var biapply1 = $6363af3298f653fe$export$6ff8eae0be34c22f(dictBiapply);
    var bimap = $2Mmje.bimap(dictBiapply.Bifunctor0());
    return function(f) {
        return function(g) {
            return function(a) {
                return function(b) {
                    return biapply1(bimap(f)(g)(a))(b);
                };
            };
        };
    };
};
var $6363af3298f653fe$export$2f99c17ac3b747ef = function(dictBiapply) {
    var biapply1 = $6363af3298f653fe$export$6ff8eae0be34c22f(dictBiapply);
    var bimap = $2Mmje.bimap(dictBiapply.Bifunctor0());
    return function(f) {
        return function(g) {
            return function(a) {
                return function(b) {
                    return function(c) {
                        return biapply1(biapply1(bimap(f)(g)(a))(b))(c);
                    };
                };
            };
        };
    };
};

});


parcelRegister("dnKRS", function(module, exports) {

$parcel$export(module.exports, "profunctorFn", () => $9be1c75e3223ee2e$export$e10497e40cde5fd3);
$parcel$export(module.exports, "dimap", () => $9be1c75e3223ee2e$export$7c344215185fc3ac);
$parcel$export(module.exports, "lcmap", () => $9be1c75e3223ee2e$export$48f54268254cf7d0);
// Generated by purs version 0.15.16

var $7T8P4 = parcelRequire("7T8P4");

var $6PW1p = parcelRequire("6PW1p");
var $9be1c75e3223ee2e$var$identity = /* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn);
var $9be1c75e3223ee2e$var$wrap = /* #__PURE__ */ $6PW1p.wrap();
var $9be1c75e3223ee2e$var$unwrap = /* #__PURE__ */ $6PW1p.unwrap();
var $9be1c75e3223ee2e$export$e10497e40cde5fd3 = {
    dimap: function(a2b) {
        return function(c2d) {
            return function(b2c) {
                return function($18) {
                    return c2d(b2c(a2b($18)));
                };
            };
        };
    }
};
var $9be1c75e3223ee2e$export$7c344215185fc3ac = function(dict) {
    return dict.dimap;
};
var $9be1c75e3223ee2e$export$48f54268254cf7d0 = function(dictProfunctor) {
    var dimap1 = $9be1c75e3223ee2e$export$7c344215185fc3ac(dictProfunctor);
    return function(a2b) {
        return dimap1(a2b)($9be1c75e3223ee2e$var$identity);
    };
};
var $9be1c75e3223ee2e$export$6630987c9d273301 = function(dictProfunctor) {
    var dimap1 = $9be1c75e3223ee2e$export$7c344215185fc3ac(dictProfunctor);
    return function(b2c) {
        return dimap1($9be1c75e3223ee2e$var$identity)(b2c);
    };
};
var $9be1c75e3223ee2e$export$93b4506d26e3367 = function(dictProfunctor) {
    var dimap1 = $9be1c75e3223ee2e$export$7c344215185fc3ac(dictProfunctor);
    return function() {
        return dimap1($9be1c75e3223ee2e$var$wrap)($9be1c75e3223ee2e$var$unwrap);
    };
};
var $9be1c75e3223ee2e$export$d25bf6793fd4dfcb = function(dictProfunctor) {
    var dimap1 = $9be1c75e3223ee2e$export$7c344215185fc3ac(dictProfunctor);
    return function() {
        return function(v) {
            return dimap1($9be1c75e3223ee2e$var$unwrap)($9be1c75e3223ee2e$var$wrap);
        };
    };
};
var $9be1c75e3223ee2e$export$29d5d0b2414dfc5c = function(dictCategory) {
    var identity1 = $7T8P4.identity(dictCategory);
    return function(dictProfunctor) {
        var rmap1 = $9be1c75e3223ee2e$export$6630987c9d273301(dictProfunctor);
        return function(f) {
            return rmap1(f)(identity1);
        };
    };
};

});


parcelRegister("lfKKM", function(module, exports) {

$parcel$export(module.exports, "Joker", () => $f78f43f57784c3b0$export$6aabc6925447f4b0);
$parcel$export(module.exports, "bifunctorJoker", () => $f78f43f57784c3b0$export$fef3ae072f671f73);
// Generated by purs version 0.15.16

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $9Grh5 = parcelRequire("9Grh5");

var $aKY4H = parcelRequire("aKY4H");

var $l0wDR = parcelRequire("l0wDR");

var $6PW1p = parcelRequire("6PW1p");

var $3Orkn = parcelRequire("3Orkn");
var $f78f43f57784c3b0$var$un = /* #__PURE__ */ $6PW1p.un();
var $f78f43f57784c3b0$export$6aabc6925447f4b0 = function(x) {
    return x;
};
var $f78f43f57784c3b0$export$b4ec34c7248171a7 = function(dictShow) {
    var show = $3Orkn.show(dictShow);
    return {
        show: function(v) {
            return "(Joker " + (show(v) + ")");
        }
    };
};
var $f78f43f57784c3b0$export$452aa45645295937 = function(dictFunctor) {
    var map = $l0wDR.map(dictFunctor);
    return {
        dimap: function(v) {
            return function(g) {
                return function(v1) {
                    return map(g)(v1);
                };
            };
        }
    };
};
var $f78f43f57784c3b0$export$ced2a20c0b18b37d = function(dictOrd) {
    return dictOrd;
};
var $f78f43f57784c3b0$export$89da6ea6949743c = {
    Coercible0: function() {
        return undefined;
    }
};
var $f78f43f57784c3b0$export$391d641ca6d60218 = function(f) {
    return function(v) {
        return f(v);
    };
};
var $f78f43f57784c3b0$export$f3932b67dd828010 = function(dictFunctor) {
    var map = $l0wDR.map(dictFunctor);
    return {
        map: function(f) {
            return function(v) {
                return map(f)(v);
            };
        }
    };
};
var $f78f43f57784c3b0$export$c3be8193cff8c2a1 = function(dictEq) {
    return dictEq;
};
var $f78f43f57784c3b0$export$61eb042f0a783df2 = function(dictFunctor) {
    var map = $l0wDR.map(dictFunctor);
    var profunctorJoker1 = $f78f43f57784c3b0$export$452aa45645295937(dictFunctor);
    return {
        left: function(v) {
            return map($aKY4H.Left.create)(v);
        },
        right: function(v) {
            return map($aKY4H.Right.create)(v);
        },
        Profunctor0: function() {
            return profunctorJoker1;
        }
    };
};
var $f78f43f57784c3b0$export$fef3ae072f671f73 = function(dictFunctor) {
    var map = $l0wDR.map(dictFunctor);
    return {
        bimap: function(v) {
            return function(g) {
                return function(v1) {
                    return map(g)(v1);
                };
            };
        }
    };
};
var $f78f43f57784c3b0$export$45bd288b70d866e3 = function(dictApply) {
    var apply = $a5g3C.apply(dictApply);
    var bifunctorJoker1 = $f78f43f57784c3b0$export$fef3ae072f671f73(dictApply.Functor0());
    return {
        biapply: function(v) {
            return function(v1) {
                return apply(v)(v1);
            };
        },
        Bifunctor0: function() {
            return bifunctorJoker1;
        }
    };
};
var $f78f43f57784c3b0$export$9f071db006f4d6df = function(dictApplicative) {
    var pure = $gUTA8.pure(dictApplicative);
    var biapplyJoker1 = $f78f43f57784c3b0$export$45bd288b70d866e3(dictApplicative.Apply0());
    return {
        bipure: function(v) {
            return function(b) {
                return pure(b);
            };
        },
        Biapply0: function() {
            return biapplyJoker1;
        }
    };
};
var $f78f43f57784c3b0$export$ea793751a641ee88 = function(dictApply) {
    var apply = $a5g3C.apply(dictApply);
    var functorJoker1 = $f78f43f57784c3b0$export$f3932b67dd828010(dictApply.Functor0());
    return {
        apply: function(v) {
            return function(v1) {
                return apply(v)(v1);
            };
        },
        Functor0: function() {
            return functorJoker1;
        }
    };
};
var $f78f43f57784c3b0$export$aeee4b79ac977d96 = function(dictBind) {
    var bind = $9Grh5.bind(dictBind);
    var applyJoker1 = $f78f43f57784c3b0$export$ea793751a641ee88(dictBind.Apply0());
    return {
        bind: function(v) {
            return function(amb) {
                return bind(v)(function() {
                    var $76 = $f78f43f57784c3b0$var$un($f78f43f57784c3b0$export$6aabc6925447f4b0);
                    return function($77) {
                        return $76(amb($77));
                    };
                }());
            };
        },
        Apply0: function() {
            return applyJoker1;
        }
    };
};
var $f78f43f57784c3b0$export$eb740e16f1c502d6 = function(dictApplicative) {
    var applyJoker1 = $f78f43f57784c3b0$export$ea793751a641ee88(dictApplicative.Apply0());
    return {
        pure: function() {
            var $78 = $gUTA8.pure(dictApplicative);
            return function($79) {
                return $f78f43f57784c3b0$export$6aabc6925447f4b0($78($79));
            };
        }(),
        Apply0: function() {
            return applyJoker1;
        }
    };
};
var $f78f43f57784c3b0$export$c73a19238155f37d = function(dictMonad) {
    var applicativeJoker1 = $f78f43f57784c3b0$export$eb740e16f1c502d6(dictMonad.Applicative0());
    var bindJoker1 = $f78f43f57784c3b0$export$aeee4b79ac977d96(dictMonad.Bind1());
    return {
        Applicative0: function() {
            return applicativeJoker1;
        },
        Bind1: function() {
            return bindJoker1;
        }
    };
};

});

parcelRegister("lHkBx", function(module, exports) {

$parcel$export(module.exports, "Product2", () => $fcbd98bdf4ceeb9f$export$ad5a88bb6a2c931c);
$parcel$export(module.exports, "bifunctorProduct2", () => $fcbd98bdf4ceeb9f$export$61e154f74ad4267e);
// Generated by purs version 0.15.16

var $ewum4 = parcelRequire("ewum4");

var $8x2Wd = parcelRequire("8x2Wd");

var $2Mmje = parcelRequire("2Mmje");

var $4MBcA = parcelRequire("4MBcA");

var $l0wDR = parcelRequire("l0wDR");

var $d0PPW = parcelRequire("d0PPW");

var $6SDUu = parcelRequire("6SDUu");

var $dnKRS = parcelRequire("dnKRS");

var $3Orkn = parcelRequire("3Orkn");
var $fcbd98bdf4ceeb9f$export$ad5a88bb6a2c931c = /* #__PURE__ */ function() {
    function Product2(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Product2.create = function(value0) {
        return function(value1) {
            return new Product2(value0, value1);
        };
    };
    return Product2;
}();
var $fcbd98bdf4ceeb9f$export$6c093255e90d22dc = function(dictShow) {
    var show = $3Orkn.show(dictShow);
    return function(dictShow1) {
        var show1 = $3Orkn.show(dictShow1);
        return {
            show: function(v) {
                return "(Product2 " + (show(v.value0) + (" " + (show1(v.value1) + ")")));
            }
        };
    };
};
var $fcbd98bdf4ceeb9f$export$5f8c2a3cf153d402 = function(dictProfunctor) {
    var dimap = $dnKRS.dimap(dictProfunctor);
    return function(dictProfunctor1) {
        var dimap1 = $dnKRS.dimap(dictProfunctor1);
        return {
            dimap: function(f) {
                return function(g) {
                    return function(v) {
                        return new $fcbd98bdf4ceeb9f$export$ad5a88bb6a2c931c(dimap(f)(g)(v.value0), dimap1(f)(g)(v.value1));
                    };
                };
            }
        };
    };
};
var $fcbd98bdf4ceeb9f$export$df18121261f4a19e = function(dictFunctor) {
    var map = $l0wDR.map(dictFunctor);
    return function(dictFunctor1) {
        var map1 = $l0wDR.map(dictFunctor1);
        return {
            map: function(f) {
                return function(v) {
                    return new $fcbd98bdf4ceeb9f$export$ad5a88bb6a2c931c(map(f)(v.value0), map1(f)(v.value1));
                };
            }
        };
    };
};
var $fcbd98bdf4ceeb9f$export$a9ce93700a5c7167 = function(dictEq) {
    var eq = $4MBcA.eq(dictEq);
    return function(dictEq1) {
        var eq1 = $4MBcA.eq(dictEq1);
        return {
            eq: function(x) {
                return function(y) {
                    return eq(x.value0)(y.value0) && eq1(x.value1)(y.value1);
                };
            }
        };
    };
};
var $fcbd98bdf4ceeb9f$export$3df4cac97292b80b = function(dictOrd) {
    var compare = $d0PPW.compare(dictOrd);
    var eqProduct21 = $fcbd98bdf4ceeb9f$export$a9ce93700a5c7167(dictOrd.Eq0());
    return function(dictOrd1) {
        var compare1 = $d0PPW.compare(dictOrd1);
        var eqProduct22 = eqProduct21(dictOrd1.Eq0());
        return {
            compare: function(x) {
                return function(y) {
                    var v = compare(x.value0)(y.value0);
                    if (v instanceof $6SDUu.LT) return $6SDUu.LT.value;
                    if (v instanceof $6SDUu.GT) return $6SDUu.GT.value;
                    return compare1(x.value1)(y.value1);
                };
            },
            Eq0: function() {
                return eqProduct22;
            }
        };
    };
};
var $fcbd98bdf4ceeb9f$export$61e154f74ad4267e = function(dictBifunctor) {
    var bimap = $2Mmje.bimap(dictBifunctor);
    return function(dictBifunctor1) {
        var bimap1 = $2Mmje.bimap(dictBifunctor1);
        return {
            bimap: function(f) {
                return function(g) {
                    return function(v) {
                        return new $fcbd98bdf4ceeb9f$export$ad5a88bb6a2c931c(bimap(f)(g)(v.value0), bimap1(f)(g)(v.value1));
                    };
                };
            }
        };
    };
};
var $fcbd98bdf4ceeb9f$export$682ecf1e69af4477 = function(dictBiapply) {
    var biapply = $8x2Wd.biapply(dictBiapply);
    var bifunctorProduct21 = $fcbd98bdf4ceeb9f$export$61e154f74ad4267e(dictBiapply.Bifunctor0());
    return function(dictBiapply1) {
        var biapply1 = $8x2Wd.biapply(dictBiapply1);
        var bifunctorProduct22 = bifunctorProduct21(dictBiapply1.Bifunctor0());
        return {
            biapply: function(v) {
                return function(v1) {
                    return new $fcbd98bdf4ceeb9f$export$ad5a88bb6a2c931c(biapply(v.value0)(v1.value0), biapply1(v.value1)(v1.value1));
                };
            },
            Bifunctor0: function() {
                return bifunctorProduct22;
            }
        };
    };
};
var $fcbd98bdf4ceeb9f$export$439f710a1c8c1d51 = function(dictBiapplicative) {
    var bipure = $ewum4.bipure(dictBiapplicative);
    var biapplyProduct21 = $fcbd98bdf4ceeb9f$export$682ecf1e69af4477(dictBiapplicative.Biapply0());
    return function(dictBiapplicative1) {
        var bipure1 = $ewum4.bipure(dictBiapplicative1);
        var biapplyProduct22 = biapplyProduct21(dictBiapplicative1.Biapply0());
        return {
            bipure: function(a) {
                return function(b) {
                    return new $fcbd98bdf4ceeb9f$export$ad5a88bb6a2c931c(bipure(a)(b), bipure1(a)(b));
                };
            },
            Biapply0: function() {
                return biapplyProduct22;
            }
        };
    };
};

});


parcelRegister("7eHfd", function(module, exports) {

$parcel$export(module.exports, "genericShowArgsNoArguments", () => $544b62a378cc0091$export$f7ad98836d6849e8);
$parcel$export(module.exports, "genericShowArgsArgument", () => $544b62a378cc0091$export$bc1180ef96fcb658);
$parcel$export(module.exports, "genericShowConstructor", () => $544b62a378cc0091$export$186afff91b813845);
$parcel$export(module.exports, "genericShowSum", () => $544b62a378cc0091$export$29d77e0cd7b7a3b8);
$parcel$export(module.exports, "genericShow", () => $544b62a378cc0091$export$dc29b8461849edae);
// Generated by purs version 0.15.16

var $b1cgx = parcelRequire("b1cgx");

var $cw1rg = parcelRequire("cw1rg");

var $iwqgS = parcelRequire("iwqgS");

var $3Orkn = parcelRequire("3Orkn");

var $2HEu8 = parcelRequire("2HEu8");

var $h3hu6 = parcelRequire("h3hu6");
var $544b62a378cc0091$var$append = /* #__PURE__ */ $iwqgS.append($iwqgS.semigroupArray);
var $544b62a378cc0091$export$f7ad98836d6849e8 = {
    genericShowArgs: function(v) {
        return [];
    }
};
var $544b62a378cc0091$export$bc1180ef96fcb658 = function(dictShow) {
    var show = $3Orkn.show(dictShow);
    return {
        genericShowArgs: function(v) {
            return [
                show(v)
            ];
        }
    };
};
var $544b62a378cc0091$export$13bb3b5ea79b5fe6 = function(dict) {
    return dict.genericShowArgs;
};
var $544b62a378cc0091$export$b8b972500eedbc74 = function(dictGenericShowArgs) {
    var genericShowArgs1 = $544b62a378cc0091$export$13bb3b5ea79b5fe6(dictGenericShowArgs);
    return function(dictGenericShowArgs1) {
        var genericShowArgs2 = $544b62a378cc0091$export$13bb3b5ea79b5fe6(dictGenericShowArgs1);
        return {
            genericShowArgs: function(v) {
                return $544b62a378cc0091$var$append(genericShowArgs1(v.value0))(genericShowArgs2(v.value1));
            }
        };
    };
};
var $544b62a378cc0091$export$186afff91b813845 = function(dictGenericShowArgs) {
    var genericShowArgs1 = $544b62a378cc0091$export$13bb3b5ea79b5fe6(dictGenericShowArgs);
    return function(dictIsSymbol) {
        var reflectSymbol = $2HEu8.reflectSymbol(dictIsSymbol);
        return {
            "genericShow'": function(v) {
                var ctor = reflectSymbol($h3hu6.Proxy.value);
                var v1 = genericShowArgs1(v);
                if (v1.length === 0) return ctor;
                return "(" + ($b1cgx.intercalate(" ")($544b62a378cc0091$var$append([
                    ctor
                ])(v1)) + ")");
            }
        };
    };
};
var $544b62a378cc0091$export$c357439213aef314 = function(dict) {
    return dict["genericShow'"];
};
var $544b62a378cc0091$export$385ce500412a77a5 = {
    "genericShow'": function(a) {
        return $544b62a378cc0091$export$c357439213aef314($544b62a378cc0091$export$385ce500412a77a5)(a);
    }
};
var $544b62a378cc0091$export$29d77e0cd7b7a3b8 = function(dictGenericShow) {
    var genericShow$prime1 = $544b62a378cc0091$export$c357439213aef314(dictGenericShow);
    return function(dictGenericShow1) {
        var genericShow$prime2 = $544b62a378cc0091$export$c357439213aef314(dictGenericShow1);
        return {
            "genericShow'": function(v) {
                if (v instanceof $cw1rg.Inl) return genericShow$prime1(v.value0);
                if (v instanceof $cw1rg.Inr) return genericShow$prime2(v.value0);
                throw new Error("Failed pattern match at Data.Show.Generic (line 26, column 1 - line 28, column 40): " + [
                    v.constructor.name
                ]);
            }
        };
    };
};
var $544b62a378cc0091$export$dc29b8461849edae = function(dictGeneric) {
    var from = $cw1rg.from(dictGeneric);
    return function(dictGenericShow) {
        var genericShow$prime1 = $544b62a378cc0091$export$c357439213aef314(dictGenericShow);
        return function(x) {
            return genericShow$prime1(from(x));
        };
    };
};

});
parcelRegister("b1cgx", function(module, exports) {

$parcel$export(module.exports, "intercalate", () => $80594d6a65468c7b$export$739ec22334c44788);
const $80594d6a65468c7b$export$739ec22334c44788 = function(separator) {
    return function(xs) {
        return xs.join(separator);
    };
};

});



parcelRegister("e6cRy", function(module, exports) {

$parcel$export(module.exports, "Application", () => $a43b9a86bb91298f$export$16975c34e60e1e61);
$parcel$export(module.exports, "Abstraction", () => $a43b9a86bb91298f$export$f362e1cb1a1602a0);
$parcel$export(module.exports, "FreeVariable", () => $a43b9a86bb91298f$export$b9a1949c5703f871);
$parcel$export(module.exports, "BoundsCheck", () => $a43b9a86bb91298f$export$5da6a0315ed0e7e);
$parcel$export(module.exports, "traversableBExpr", () => $a43b9a86bb91298f$export$8c16e082f8518134);
$parcel$export(module.exports, "eqBExpr", () => $a43b9a86bb91298f$export$5fb71106c2b26b4);
$parcel$export(module.exports, "monadBExpr", () => $a43b9a86bb91298f$export$f251fbc2d382c317);
$parcel$export(module.exports, "displayBExpr", () => $a43b9a86bb91298f$export$15fd46b486d35725);
$parcel$export(module.exports, "boundsChecker", () => $a43b9a86bb91298f$export$bf7be5ce28447d8a);
// Generated by purs version 0.15.16

var $32mKU = parcelRequire("32mKU");

var $5PtR4 = parcelRequire("5PtR4");

var $a7Dxq = parcelRequire("a7Dxq");

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $9Grh5 = parcelRequire("9Grh5");

var $7T8P4 = parcelRequire("7T8P4");

var $ibtPS = parcelRequire("ibtPS");

var $kQAxW = parcelRequire("kQAxW");

var $axmEP = parcelRequire("axmEP");

var $1qMIU = parcelRequire("1qMIU");

var $cYgrH = parcelRequire("cYgrH");

var $aKY4H = parcelRequire("aKY4H");

var $4MBcA = parcelRequire("4MBcA");

var $fQr0C = parcelRequire("fQr0C");

var $6RkEA = parcelRequire("6RkEA");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");

var $8gI0w = parcelRequire("8gI0w");

var $cw1rg = parcelRequire("cw1rg");

var $6VVZC = parcelRequire("6VVZC");

var $ykHdR = parcelRequire("ykHdR");

var $6PW1p = parcelRequire("6PW1p");

var $dnKRS = parcelRequire("dnKRS");

var $8JwLM = parcelRequire("8JwLM");

var $iwqgS = parcelRequire("iwqgS");

var $3Orkn = parcelRequire("3Orkn");

var $7eHfd = parcelRequire("7eHfd");

var $1wR1l = parcelRequire("1wR1l");

var $9MxTl = parcelRequire("9MxTl");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");

var $7DusG = parcelRequire("7DusG");

var $jHZNn = parcelRequire("jHZNn");

var $hK1Ac = parcelRequire("hK1Ac");

var $kugLX = parcelRequire("kugLX");

var $hhMAk = parcelRequire("hhMAk");

var $jIMHU = parcelRequire("jIMHU");

var $cLQJF = parcelRequire("cLQJF");

var $bllhK = parcelRequire("bllhK");

var $aaxt2 = parcelRequire("aaxt2");

var $eo6zx = parcelRequire("eo6zx");

var $lO7j1 = parcelRequire("lO7j1");

var $8IafO = parcelRequire("8IafO");
var $a43b9a86bb91298f$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $a43b9a86bb91298f$var$unwrap = /* #__PURE__ */ $6PW1p.unwrap();
var $a43b9a86bb91298f$var$hoistScope = /* #__PURE__ */ $32mKU.hoistScope($cYgrH.functorCoyoneda);
var $a43b9a86bb91298f$var$showRecord = /* #__PURE__ */ $3Orkn.showRecord()();
var $a43b9a86bb91298f$var$showRecordFieldsCons = /* #__PURE__ */ $3Orkn.showRecordFieldsCons({
    reflectSymbol: function() {
        return "argument";
    }
});
var $a43b9a86bb91298f$var$showRecordFieldsConsNil = /* #__PURE__ */ $3Orkn.showRecordFieldsConsNil({
    reflectSymbol: function() {
        return "function";
    }
});
var $a43b9a86bb91298f$var$ApplicationIsSymbol = {
    reflectSymbol: function() {
        return "Application";
    }
};
var $a43b9a86bb91298f$var$showRecordFieldsCons1 = /* #__PURE__ */ $3Orkn.showRecordFieldsCons({
    reflectSymbol: function() {
        return "body";
    }
})(/* #__PURE__ */ $3Orkn.showRecordFieldsConsNil({
    reflectSymbol: function() {
        return "variableName";
    }
})($3Orkn.showString));
var $a43b9a86bb91298f$var$showScope = /* #__PURE__ */ $32mKU.showScope($3Orkn.showUnit);
var $a43b9a86bb91298f$var$showVar = /* #__PURE__ */ $32mKU.showVar($3Orkn.showUnit);
var $a43b9a86bb91298f$var$AbstractionIsSymbol = {
    reflectSymbol: function() {
        return "Abstraction";
    }
};
var $a43b9a86bb91298f$var$FreeVariableIsSymbol = {
    reflectSymbol: function() {
        return "FreeVariable";
    }
};
var $a43b9a86bb91298f$var$lcmap = /* #__PURE__ */ $dnKRS.lcmap($dnKRS.profunctorFn);
var $a43b9a86bb91298f$var$map = /* #__PURE__ */ $l0wDR.map(/* #__PURE__ */ $32mKU.functorScope($cYgrH.functorCoyoneda));
var $a43b9a86bb91298f$var$identity = /* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn);
var $a43b9a86bb91298f$var$eqScope = /* #__PURE__ */ $32mKU.eqScope($4MBcA.eqUnit);
var $a43b9a86bb91298f$var$eqVar = /* #__PURE__ */ $32mKU.eqVar($4MBcA.eqUnit);
var $a43b9a86bb91298f$var$subst = /* #__PURE__ */ $32mKU.subst($32mKU.boundScope);
var $a43b9a86bb91298f$var$show = /* #__PURE__ */ $3Orkn.show($3Orkn.showInt);
var $a43b9a86bb91298f$var$map1 = /* #__PURE__ */ $l0wDR.map($aKY4H.functorEither);
var $a43b9a86bb91298f$var$first = /* #__PURE__ */ $8JwLM.first($8JwLM.strongFn);
var $a43b9a86bb91298f$var$discard = /* #__PURE__ */ $9Grh5.discard($9Grh5.discardUnit)($bllhK.bindHalogenM);
var $a43b9a86bb91298f$var$put = /* #__PURE__ */ $kQAxW.put($bllhK.monadStateHalogenM);
var $a43b9a86bb91298f$var$pure = /* #__PURE__ */ $gUTA8.pure($bllhK.applicativeHalogenM);
var $a43b9a86bb91298f$var$pure1 = /* #__PURE__ */ $gUTA8.pure($gUTA8.applicativeArray);
var $a43b9a86bb91298f$var$eq1 = /* #__PURE__ */ $4MBcA.eq($jHZNn.eqExpr);
var $a43b9a86bb91298f$export$e4905c4aa6135813 = function(x) {
    return x;
};
var $a43b9a86bb91298f$export$881ee4b5e3aa35c7 = function(x) {
    return x;
};
var $a43b9a86bb91298f$export$4405c5ce142c5cb7 = function(x) {
    return x;
};
var $a43b9a86bb91298f$export$6e2a67bc79ff1c6b = function(x) {
    return x;
};
var $a43b9a86bb91298f$export$d194bc2b1d244070 = function(x) {
    return x;
};
var $a43b9a86bb91298f$export$cbd14172cb4d89bb = function(x) {
    return x;
};
var $a43b9a86bb91298f$export$16975c34e60e1e61 = /* #__PURE__ */ function() {
    function Application(value0) {
        this.value0 = value0;
    }
    Application.create = function(value0) {
        return new Application(value0);
    };
    return Application;
}();
var $a43b9a86bb91298f$export$f362e1cb1a1602a0 = /* #__PURE__ */ function() {
    function Abstraction(value0) {
        this.value0 = value0;
    }
    Abstraction.create = function(value0) {
        return new Abstraction(value0);
    };
    return Abstraction;
}();
var $a43b9a86bb91298f$export$b9a1949c5703f871 = /* #__PURE__ */ function() {
    function FreeVariable(value0) {
        this.value0 = value0;
    }
    FreeVariable.create = function(value0) {
        return new FreeVariable(value0);
    };
    return FreeVariable;
}();
var $a43b9a86bb91298f$export$5da6a0315ed0e7e = /* #__PURE__ */ function() {
    function BoundsCheck(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    BoundsCheck.create = function(value0) {
        return function(value1) {
            return new BoundsCheck(value0, value1);
        };
    };
    return BoundsCheck;
}();
var $a43b9a86bb91298f$export$722620c86700909e = /* #__PURE__ */ function() {
    function AppF(value0) {
        this.value0 = value0;
    }
    AppF.create = function(value0) {
        return new AppF(value0);
    };
    return AppF;
}();
var $a43b9a86bb91298f$export$2bf0c6b7057c5d19 = /* #__PURE__ */ function() {
    function AbsF(value0) {
        this.value0 = value0;
    }
    AbsF.create = function(value0) {
        return new AbsF(value0);
    };
    return AbsF;
}();
var $a43b9a86bb91298f$export$2f0c881bb9f2c06c = /* #__PURE__ */ function() {
    function VarF(value0) {
        this.value0 = value0;
    }
    VarF.create = function(value0) {
        return new VarF(value0);
    };
    return VarF;
}();
var $a43b9a86bb91298f$export$69c03a87ef47a7cc = {
    Coercible0: function() {
        return undefined;
    }
};
var $a43b9a86bb91298f$export$e2b6a7411b77a239 = function(dictFunctor) {
    var map5 = $l0wDR.map(dictFunctor);
    return {
        hmap: function(nt) {
            var $513 = map5(nt);
            return function($514) {
                return $a43b9a86bb91298f$export$881ee4b5e3aa35c7($8gI0w.Compose($513($a43b9a86bb91298f$var$unwrap($a43b9a86bb91298f$var$unwrap($514)))));
            };
        }
    };
};
var $a43b9a86bb91298f$export$82b07ff5e600f603 = function(dictRecursive) {
    var project = $eo6zx.project(dictRecursive);
    return function(dictCorecursive) {
        var Functor0 = dictCorecursive.Functor0();
        var map5 = $l0wDR.map(Functor0);
        var hFunctorNComp1 = $a43b9a86bb91298f$export$e2b6a7411b77a239(Functor0);
        return {
            hproject: function() {
                var $515 = map5($1qMIU.Const);
                return function($516) {
                    return $a43b9a86bb91298f$export$881ee4b5e3aa35c7($8gI0w.Compose($515(project($a43b9a86bb91298f$var$unwrap($516)))));
                };
            }(),
            hembed: function() {
                var $517 = $aaxt2.embed(dictCorecursive);
                var $518 = map5($a43b9a86bb91298f$var$unwrap);
                return function($519) {
                    return $1qMIU.Const($517($518($a43b9a86bb91298f$var$unwrap($a43b9a86bb91298f$var$unwrap($519)))));
                };
            }(),
            HFunctor0: function() {
                return hFunctorNComp1;
            }
        };
    };
};
var $a43b9a86bb91298f$export$5c164b8d11bf3b37 = {
    hmap: function(f) {
        var h = function(v) {
            if (v instanceof $a43b9a86bb91298f$export$722620c86700909e) return new $a43b9a86bb91298f$export$722620c86700909e({
                "function": f(v["value0"]["function"]),
                argument: f(v.value0.argument)
            });
            if (v instanceof $a43b9a86bb91298f$export$2bf0c6b7057c5d19) return new $a43b9a86bb91298f$export$2bf0c6b7057c5d19({
                variableName: v.value0.variableName,
                body: $a43b9a86bb91298f$var$hoistScope($cYgrH.hoistCoyoneda(f))(v.value0.body)
            });
            if (v instanceof $a43b9a86bb91298f$export$2f0c881bb9f2c06c) return new $a43b9a86bb91298f$export$2f0c881bb9f2c06c(v.value0);
            throw new Error("Failed pattern match at Bounded (line 107, column 5 - line 107, column 73): " + [
                v.constructor.name
            ]);
        };
        return h;
    }
};
var $a43b9a86bb91298f$export$cf5a8950f3dc56d0 = {
    to: function(x) {
        return x;
    },
    from: function(x) {
        return x;
    }
};
var $a43b9a86bb91298f$export$6f30a7eed3d0f415 = {
    to: function(x) {
        if (x instanceof $cw1rg.Inl) return new $a43b9a86bb91298f$export$16975c34e60e1e61(x.value0);
        if (x instanceof $cw1rg.Inr && x.value0 instanceof $cw1rg.Inl) return new $a43b9a86bb91298f$export$f362e1cb1a1602a0(x.value0.value0);
        if (x instanceof $cw1rg.Inr && x.value0 instanceof $cw1rg.Inr) return new $a43b9a86bb91298f$export$b9a1949c5703f871(x.value0.value0);
        throw new Error("Failed pattern match at Bounded (line 63, column 1 - line 63, column 36): " + [
            x.constructor.name
        ]);
    },
    from: function(x) {
        if (x instanceof $a43b9a86bb91298f$export$16975c34e60e1e61) return new $cw1rg.Inl(x.value0);
        if (x instanceof $a43b9a86bb91298f$export$f362e1cb1a1602a0) return new $cw1rg.Inr(new $cw1rg.Inl(x.value0));
        if (x instanceof $a43b9a86bb91298f$export$b9a1949c5703f871) return new $cw1rg.Inr(new $cw1rg.Inr(x.value0));
        throw new Error("Failed pattern match at Bounded (line 63, column 1 - line 63, column 36): " + [
            x.constructor.name
        ]);
    }
};
var $a43b9a86bb91298f$var$genericShow = /* #__PURE__ */ $7eHfd.genericShow($a43b9a86bb91298f$export$6f30a7eed3d0f415);
var $a43b9a86bb91298f$export$3d221a5fefec4bbf = function(dictShow) {
    var genericShowConstructor = $7eHfd.genericShowConstructor($7eHfd.genericShowArgsArgument(dictShow))($a43b9a86bb91298f$var$FreeVariableIsSymbol);
    return {
        show: function(x) {
            return $a43b9a86bb91298f$var$genericShow($7eHfd.genericShowSum($7eHfd.genericShowConstructor($7eHfd.genericShowArgsArgument($a43b9a86bb91298f$var$showRecord($a43b9a86bb91298f$var$showRecordFieldsCons($a43b9a86bb91298f$var$showRecordFieldsConsNil($a43b9a86bb91298f$export$3d221a5fefec4bbf(dictShow)))($a43b9a86bb91298f$export$3d221a5fefec4bbf(dictShow)))))($a43b9a86bb91298f$var$ApplicationIsSymbol))($7eHfd.genericShowSum($7eHfd.genericShowConstructor($7eHfd.genericShowArgsArgument($a43b9a86bb91298f$var$showRecord($a43b9a86bb91298f$var$showRecordFieldsCons1($a43b9a86bb91298f$var$showScope($a43b9a86bb91298f$export$3d221a5fefec4bbf($a43b9a86bb91298f$var$showVar($a43b9a86bb91298f$export$3d221a5fefec4bbf(dictShow))))(dictShow)))))($a43b9a86bb91298f$var$AbstractionIsSymbol))(genericShowConstructor)))(x);
        }
    };
};
var $a43b9a86bb91298f$export$7848955b26b1afbd = {
    to: function(x) {
        if (x instanceof $cw1rg.Inl) return new $a43b9a86bb91298f$export$722620c86700909e(x.value0);
        if (x instanceof $cw1rg.Inr && x.value0 instanceof $cw1rg.Inl) return new $a43b9a86bb91298f$export$2bf0c6b7057c5d19(x.value0.value0);
        if (x instanceof $cw1rg.Inr && x.value0 instanceof $cw1rg.Inr) return new $a43b9a86bb91298f$export$2f0c881bb9f2c06c(x.value0.value0);
        throw new Error("Failed pattern match at Bounded (line 97, column 1 - line 97, column 39): " + [
            x.constructor.name
        ]);
    },
    from: function(x) {
        if (x instanceof $a43b9a86bb91298f$export$722620c86700909e) return new $cw1rg.Inl(x.value0);
        if (x instanceof $a43b9a86bb91298f$export$2bf0c6b7057c5d19) return new $cw1rg.Inr(new $cw1rg.Inl(x.value0));
        if (x instanceof $a43b9a86bb91298f$export$2f0c881bb9f2c06c) return new $cw1rg.Inr(new $cw1rg.Inr(x.value0));
        throw new Error("Failed pattern match at Bounded (line 97, column 1 - line 97, column 39): " + [
            x.constructor.name
        ]);
    }
};
var $a43b9a86bb91298f$export$c3748152a3a12194 = {
    map: function(f) {
        return function(m) {
            return $a43b9a86bb91298f$var$lcmap($a43b9a86bb91298f$var$lcmap(f))(m);
        };
    }
};
var $a43b9a86bb91298f$export$92cc2c0ab767f73 = function(dictFunctor) {
    var functorCompose = $8gI0w.functorCompose(dictFunctor);
    return function(dictFunctor1) {
        var map5 = $l0wDR.map(functorCompose(dictFunctor1));
        return {
            map: function(f) {
                return function(m) {
                    return map5(f)(m);
                };
            }
        };
    };
};
var $a43b9a86bb91298f$export$d8a50fc8675b888e = {
    map: function(f) {
        return function(m) {
            return $a43b9a86bb91298f$var$lcmap($a43b9a86bb91298f$var$lcmap(f))(m);
        };
    }
};
var $a43b9a86bb91298f$var$lowerCoyoneda = /* #__PURE__ */ $cYgrH.lowerCoyoneda($a43b9a86bb91298f$export$d8a50fc8675b888e);
var $a43b9a86bb91298f$export$fefbf52478894c76 = function(dictFunctor) {
    var map5 = $l0wDR.map(dictFunctor);
    return {
        map: function(f) {
            return function(m) {
                if (m instanceof $a43b9a86bb91298f$export$722620c86700909e) return new $a43b9a86bb91298f$export$722620c86700909e({
                    argument: map5(f)(m.value0.argument),
                    "function": map5(f)(m["value0"]["function"])
                });
                if (m instanceof $a43b9a86bb91298f$export$2bf0c6b7057c5d19) return new $a43b9a86bb91298f$export$2bf0c6b7057c5d19({
                    variableName: m.value0.variableName,
                    body: $a43b9a86bb91298f$var$map(f)(m.value0.body)
                });
                if (m instanceof $a43b9a86bb91298f$export$2f0c881bb9f2c06c) return new $a43b9a86bb91298f$export$2f0c881bb9f2c06c(f(m.value0));
                throw new Error("Failed pattern match at Bounded (line 0, column 0 - line 0, column 0): " + [
                    m.constructor.name
                ]);
            };
        }
    };
};
var $a43b9a86bb91298f$export$3c6728313226c414 = {
    map: function(f) {
        return function(m) {
            if (m instanceof $a43b9a86bb91298f$export$16975c34e60e1e61) return new $a43b9a86bb91298f$export$16975c34e60e1e61({
                argument: $l0wDR.map($a43b9a86bb91298f$export$3c6728313226c414)(f)(m.value0.argument),
                "function": $l0wDR.map($a43b9a86bb91298f$export$3c6728313226c414)(f)(m["value0"]["function"])
            });
            if (m instanceof $a43b9a86bb91298f$export$f362e1cb1a1602a0) return new $a43b9a86bb91298f$export$f362e1cb1a1602a0({
                variableName: m.value0.variableName,
                body: $l0wDR.map($32mKU.functorScope($a43b9a86bb91298f$export$3c6728313226c414))(f)(m.value0.body)
            });
            if (m instanceof $a43b9a86bb91298f$export$b9a1949c5703f871) return new $a43b9a86bb91298f$export$b9a1949c5703f871(f(m.value0));
            throw new Error("Failed pattern match at Bounded (line 0, column 0 - line 0, column 0): " + [
                m.constructor.name
            ]);
        };
    }
};
var $a43b9a86bb91298f$var$hoistScope1 = /* #__PURE__ */ $32mKU.hoistScope($a43b9a86bb91298f$export$3c6728313226c414);
var $a43b9a86bb91298f$var$lowerCoyoneda1 = /* #__PURE__ */ $cYgrH.lowerCoyoneda($a43b9a86bb91298f$export$3c6728313226c414);
var $a43b9a86bb91298f$var$map2 = /* #__PURE__ */ $l0wDR.map($a43b9a86bb91298f$export$3c6728313226c414);
var $a43b9a86bb91298f$export$52f698283a1c85e5 = {
    hproject: function(v) {
        if (v instanceof $a43b9a86bb91298f$export$16975c34e60e1e61) return new $a43b9a86bb91298f$export$722620c86700909e(v.value0);
        if (v instanceof $a43b9a86bb91298f$export$f362e1cb1a1602a0) return new $a43b9a86bb91298f$export$2bf0c6b7057c5d19({
            variableName: v.value0.variableName,
            body: $a43b9a86bb91298f$var$hoistScope1($cYgrH.liftCoyoneda)(v.value0.body)
        });
        if (v instanceof $a43b9a86bb91298f$export$b9a1949c5703f871) return new $a43b9a86bb91298f$export$2f0c881bb9f2c06c(v.value0);
        throw new Error("Failed pattern match at Bounded (line 159, column 1 - line 166, column 35): " + [
            v.constructor.name
        ]);
    },
    hembed: function(v) {
        if (v instanceof $a43b9a86bb91298f$export$722620c86700909e) return new $a43b9a86bb91298f$export$16975c34e60e1e61(v.value0);
        if (v instanceof $a43b9a86bb91298f$export$2bf0c6b7057c5d19) return new $a43b9a86bb91298f$export$f362e1cb1a1602a0({
            variableName: v.value0.variableName,
            body: $a43b9a86bb91298f$var$hoistScope($a43b9a86bb91298f$var$lowerCoyoneda1)(v.value0.body)
        });
        if (v instanceof $a43b9a86bb91298f$export$2f0c881bb9f2c06c) return new $a43b9a86bb91298f$export$b9a1949c5703f871(v.value0);
        throw new Error("Failed pattern match at Bounded (line 159, column 1 - line 166, column 35): " + [
            v.constructor.name
        ]);
    },
    HFunctor0: function() {
        return $a43b9a86bb91298f$export$5c164b8d11bf3b37;
    }
};
var $a43b9a86bb91298f$export$f54cf8f3c0bfb17a = {
    foldl: function(f) {
        return function(z) {
            return function(m) {
                if (m instanceof $a43b9a86bb91298f$export$16975c34e60e1e61) return $6RkEA.foldl($a43b9a86bb91298f$export$f54cf8f3c0bfb17a)(f)($6RkEA.foldl($a43b9a86bb91298f$export$f54cf8f3c0bfb17a)(f)(z)(m.value0.argument))(m["value0"]["function"]);
                if (m instanceof $a43b9a86bb91298f$export$f362e1cb1a1602a0) return $6RkEA.foldl($32mKU.foldableScope($a43b9a86bb91298f$export$f54cf8f3c0bfb17a))(f)(z)(m.value0.body);
                if (m instanceof $a43b9a86bb91298f$export$b9a1949c5703f871) return f(z)(m.value0);
                throw new Error("Failed pattern match at Bounded (line 0, column 0 - line 0, column 0): " + [
                    m.constructor.name
                ]);
            };
        };
    },
    foldr: function(f) {
        return function(z) {
            return function(m) {
                if (m instanceof $a43b9a86bb91298f$export$16975c34e60e1e61) return $6RkEA.foldr($a43b9a86bb91298f$export$f54cf8f3c0bfb17a)(f)($6RkEA.foldr($a43b9a86bb91298f$export$f54cf8f3c0bfb17a)(f)(z)(m["value0"]["function"]))(m.value0.argument);
                if (m instanceof $a43b9a86bb91298f$export$f362e1cb1a1602a0) return $6RkEA.foldr($32mKU.foldableScope($a43b9a86bb91298f$export$f54cf8f3c0bfb17a))(f)(z)(m.value0.body);
                if (m instanceof $a43b9a86bb91298f$export$b9a1949c5703f871) return f(m.value0)(z);
                throw new Error("Failed pattern match at Bounded (line 0, column 0 - line 0, column 0): " + [
                    m.constructor.name
                ]);
            };
        };
    },
    foldMap: function(dictMonoid) {
        var append1 = $iwqgS.append(dictMonoid.Semigroup0());
        return function(f) {
            return function(m) {
                if (m instanceof $a43b9a86bb91298f$export$16975c34e60e1e61) return append1($6RkEA.foldMap($a43b9a86bb91298f$export$f54cf8f3c0bfb17a)(dictMonoid)(f)(m.value0.argument))($6RkEA.foldMap($a43b9a86bb91298f$export$f54cf8f3c0bfb17a)(dictMonoid)(f)(m["value0"]["function"]));
                if (m instanceof $a43b9a86bb91298f$export$f362e1cb1a1602a0) return $6RkEA.foldMap($32mKU.foldableScope($a43b9a86bb91298f$export$f54cf8f3c0bfb17a))(dictMonoid)(f)(m.value0.body);
                if (m instanceof $a43b9a86bb91298f$export$b9a1949c5703f871) return f(m.value0);
                throw new Error("Failed pattern match at Bounded (line 0, column 0 - line 0, column 0): " + [
                    m.constructor.name
                ]);
            };
        };
    }
};
var $a43b9a86bb91298f$export$8c16e082f8518134 = {
    traverse: function(dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        var apply = $a5g3C.apply(Apply0);
        var map5 = $l0wDR.map(Apply0.Functor0());
        return function(f) {
            return function(m) {
                if (m instanceof $a43b9a86bb91298f$export$16975c34e60e1e61) return apply(map5(function(v1) {
                    return function(v2) {
                        return new $a43b9a86bb91298f$export$16975c34e60e1e61({
                            argument: v1,
                            "function": v2
                        });
                    };
                })($1wR1l.traverse($a43b9a86bb91298f$export$8c16e082f8518134)(dictApplicative)(f)(m.value0.argument)))($1wR1l.traverse($a43b9a86bb91298f$export$8c16e082f8518134)(dictApplicative)(f)(m["value0"]["function"]));
                if (m instanceof $a43b9a86bb91298f$export$f362e1cb1a1602a0) return map5(function(v1) {
                    return new $a43b9a86bb91298f$export$f362e1cb1a1602a0({
                        variableName: m.value0.variableName,
                        body: v1
                    });
                })($1wR1l.traverse($32mKU.traversableScope($a43b9a86bb91298f$export$8c16e082f8518134))(dictApplicative)(f)(m.value0.body));
                if (m instanceof $a43b9a86bb91298f$export$b9a1949c5703f871) return map5(function(v1) {
                    return new $a43b9a86bb91298f$export$b9a1949c5703f871(v1);
                })(f(m.value0));
                throw new Error("Failed pattern match at Bounded (line 0, column 0 - line 0, column 0): " + [
                    m.constructor.name
                ]);
            };
        };
    },
    sequence: function(dictApplicative) {
        return function(v) {
            return $1wR1l.traverse($a43b9a86bb91298f$export$8c16e082f8518134)(dictApplicative)($a43b9a86bb91298f$var$identity)(v);
        };
    },
    Functor0: function() {
        return $a43b9a86bb91298f$export$3c6728313226c414;
    },
    Foldable1: function() {
        return $a43b9a86bb91298f$export$f54cf8f3c0bfb17a;
    }
};
var $a43b9a86bb91298f$export$1d617deb41905f90 = {
    fmap: function(dictFunctor) {
        var map5 = $l0wDR.map(dictFunctor);
        return function(f) {
            var x = function(v) {
                if (v instanceof $a43b9a86bb91298f$export$722620c86700909e) return new $a43b9a86bb91298f$export$722620c86700909e({
                    "function": map5(f)(v["value0"]["function"]),
                    argument: map5(f)(v.value0.argument)
                });
                if (v instanceof $a43b9a86bb91298f$export$2bf0c6b7057c5d19) return new $a43b9a86bb91298f$export$2bf0c6b7057c5d19({
                    variableName: v.value0.variableName,
                    body: $a43b9a86bb91298f$var$map(f)(v.value0.body)
                });
                if (v instanceof $a43b9a86bb91298f$export$2f0c881bb9f2c06c) return new $a43b9a86bb91298f$export$2f0c881bb9f2c06c(f(v.value0));
                throw new Error("Failed pattern match at Bounded (line 330, column 5 - line 330, column 81): " + [
                    v.constructor.name
                ]);
            };
            return x;
        };
    }
};
var $a43b9a86bb91298f$export$bd94f479ba720033 = function(dictEq1) {
    var eqCompose = $8gI0w.eqCompose(dictEq1);
    return function(dictEq11) {
        var eqCompose1 = eqCompose(dictEq11);
        return function(dictEq) {
            var eq2 = $4MBcA.eq(eqCompose1(dictEq));
            return {
                eq: function(x) {
                    return function(y) {
                        return eq2(x)(y);
                    };
                }
            };
        };
    };
};
var $a43b9a86bb91298f$export$f18f1a410726dd8f = function(dictEq1) {
    var eq11 = $4MBcA.eq1(dictEq1);
    return function(dictFunctor) {
        var eqScope1 = $a43b9a86bb91298f$var$eqScope($cYgrH.eq1Coyoneda(dictFunctor)(dictEq1));
        var eqCoyoneda = $cYgrH.eqCoyoneda(dictFunctor)(dictEq1);
        return function(dictEq) {
            var eq12 = eq11(dictEq);
            var eqCoyoneda1 = eqCoyoneda(dictEq);
            var eq2 = $4MBcA.eq(eqScope1(eqCoyoneda1)(eqCoyoneda($a43b9a86bb91298f$var$eqVar(eqCoyoneda1)))(dictEq));
            var eq3 = $4MBcA.eq(dictEq);
            return {
                eq: function(x) {
                    return function(y) {
                        if (x instanceof $a43b9a86bb91298f$export$722620c86700909e && y instanceof $a43b9a86bb91298f$export$722620c86700909e) return eq12(x.value0.argument)(y.value0.argument) && eq12(x["value0"]["function"])(y["value0"]["function"]);
                        if (x instanceof $a43b9a86bb91298f$export$2bf0c6b7057c5d19 && y instanceof $a43b9a86bb91298f$export$2bf0c6b7057c5d19) return eq2(x.value0.body)(y.value0.body) && x.value0.variableName === y.value0.variableName;
                        if (x instanceof $a43b9a86bb91298f$export$2f0c881bb9f2c06c && y instanceof $a43b9a86bb91298f$export$2f0c881bb9f2c06c) return eq3(x.value0)(y.value0);
                        return false;
                    };
                }
            };
        };
    };
};
var $a43b9a86bb91298f$export$957d53dd529e0572 = function(dictEq1) {
    var eqNComp1 = $a43b9a86bb91298f$export$bd94f479ba720033(dictEq1);
    return function(dictEq11) {
        var eqNComp2 = eqNComp1(dictEq11);
        return {
            eq1: function(dictEq) {
                return $4MBcA.eq(eqNComp2(dictEq));
            }
        };
    };
};
var $a43b9a86bb91298f$export$8f76bfd6b090c674 = function(dictEq1) {
    var eqBExprF1 = $a43b9a86bb91298f$export$f18f1a410726dd8f(dictEq1);
    return function(dictFunctor) {
        var eqBExprF2 = eqBExprF1(dictFunctor);
        return {
            eq1: function(dictEq) {
                return $4MBcA.eq(eqBExprF2(dictEq));
            }
        };
    };
};
var $a43b9a86bb91298f$export$5fb71106c2b26b4 = function(dictEq) {
    var eq2 = $4MBcA.eq(dictEq);
    return {
        eq: function(x) {
            return function(y) {
                if (x instanceof $a43b9a86bb91298f$export$16975c34e60e1e61 && y instanceof $a43b9a86bb91298f$export$16975c34e60e1e61) return $4MBcA.eq($a43b9a86bb91298f$export$5fb71106c2b26b4(dictEq))(x.value0.argument)(y.value0.argument) && $4MBcA.eq($a43b9a86bb91298f$export$5fb71106c2b26b4(dictEq))(x["value0"]["function"])(y["value0"]["function"]);
                if (x instanceof $a43b9a86bb91298f$export$f362e1cb1a1602a0 && y instanceof $a43b9a86bb91298f$export$f362e1cb1a1602a0) return $4MBcA.eq($a43b9a86bb91298f$var$eqScope($a43b9a86bb91298f$export$2eb031be6cacdfb)($a43b9a86bb91298f$export$5fb71106c2b26b4(dictEq))($a43b9a86bb91298f$export$5fb71106c2b26b4($a43b9a86bb91298f$var$eqVar($a43b9a86bb91298f$export$5fb71106c2b26b4(dictEq))))(dictEq))(x.value0.body)(y.value0.body) && x.value0.variableName === y.value0.variableName;
                if (x instanceof $a43b9a86bb91298f$export$b9a1949c5703f871 && y instanceof $a43b9a86bb91298f$export$b9a1949c5703f871) return eq2(x.value0)(y.value0);
                return false;
            };
        }
    };
};
var $a43b9a86bb91298f$export$2eb031be6cacdfb = {
    eq1: function(dictEq) {
        return $4MBcA.eq($a43b9a86bb91298f$export$5fb71106c2b26b4(dictEq));
    }
};
var $a43b9a86bb91298f$export$478c93ad4999c060 = function(dictApply) {
    var applyCompose = $8gI0w.applyCompose(dictApply);
    var functorNComp1 = $a43b9a86bb91298f$export$92cc2c0ab767f73(dictApply.Functor0());
    return function(dictApply1) {
        var apply = $a5g3C.apply(applyCompose(dictApply1));
        var functorNComp2 = functorNComp1(dictApply1.Functor0());
        return {
            apply: function(f) {
                return function(x) {
                    return apply($a43b9a86bb91298f$var$unwrap(f))($a43b9a86bb91298f$var$unwrap(x));
                };
            },
            Functor0: function() {
                return functorNComp2;
            }
        };
    };
};
var $a43b9a86bb91298f$export$3ffeb23eded0715c = function(dictApplicative) {
    var pure3 = $gUTA8.pure(dictApplicative);
    var applyNComp1 = $a43b9a86bb91298f$export$478c93ad4999c060(dictApplicative.Apply0());
    return function(dictApplicative1) {
        var applyNComp2 = applyNComp1(dictApplicative1.Apply0());
        return {
            pure: function() {
                var $520 = $gUTA8.pure(dictApplicative1);
                return function($521) {
                    return $a43b9a86bb91298f$export$881ee4b5e3aa35c7($8gI0w.Compose(pure3($520($521))));
                };
            }(),
            Apply0: function() {
                return applyNComp2;
            }
        };
    };
};
var $a43b9a86bb91298f$export$f251fbc2d382c317 = {
    Applicative0: function() {
        return $a43b9a86bb91298f$export$2484f832dd5c53cf;
    },
    Bind1: function() {
        return $a43b9a86bb91298f$export$c9bc5bb0f94c07d;
    }
};
var $a43b9a86bb91298f$export$c9bc5bb0f94c07d = {
    bind: function(v) {
        return function(v1) {
            if (v instanceof $a43b9a86bb91298f$export$16975c34e60e1e61) return new $a43b9a86bb91298f$export$16975c34e60e1e61({
                "function": $9Grh5.bind($a43b9a86bb91298f$export$c9bc5bb0f94c07d)(v["value0"]["function"])(v1),
                argument: $9Grh5.bind($a43b9a86bb91298f$export$c9bc5bb0f94c07d)(v.value0.argument)(v1)
            });
            if (v instanceof $a43b9a86bb91298f$export$f362e1cb1a1602a0) return new $a43b9a86bb91298f$export$f362e1cb1a1602a0({
                variableName: v.value0.variableName,
                body: $a43b9a86bb91298f$var$subst($a43b9a86bb91298f$export$f251fbc2d382c317)(v1)(v.value0.body)
            });
            if (v instanceof $a43b9a86bb91298f$export$b9a1949c5703f871) return v1(v.value0);
            throw new Error("Failed pattern match at Bounded (line 79, column 1 - line 84, column 32): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    Apply0: function() {
        return $a43b9a86bb91298f$var$$lazy_applyBExpr(0);
    }
};
var $a43b9a86bb91298f$export$2484f832dd5c53cf = /* #__PURE__ */ function() {
    return {
        pure: $a43b9a86bb91298f$export$b9a1949c5703f871.create,
        Apply0: function() {
            return $a43b9a86bb91298f$var$$lazy_applyBExpr(0);
        }
    };
}();
var $a43b9a86bb91298f$var$$lazy_applyBExpr = /* #__PURE__ */ $a43b9a86bb91298f$var$$runtime_lazy("applyBExpr", "Bounded", function() {
    return {
        apply: $ibtPS.ap($a43b9a86bb91298f$export$f251fbc2d382c317),
        Functor0: function() {
            return $a43b9a86bb91298f$export$3c6728313226c414;
        }
    };
});
var $a43b9a86bb91298f$export$137c55c80ecd8064 = /* #__PURE__ */ $a43b9a86bb91298f$var$$lazy_applyBExpr(73);
var $a43b9a86bb91298f$var$abstract1 = /* #__PURE__ */ $32mKU.abstract1($4MBcA.eqString)($a43b9a86bb91298f$export$f251fbc2d382c317);
var $a43b9a86bb91298f$export$44a4c2df84fb9c62 = function(dictAlt) {
    var altCompose = $8gI0w.altCompose(dictAlt);
    var functorNComp1 = $a43b9a86bb91298f$export$92cc2c0ab767f73(dictAlt.Functor0());
    return function(dictFunctor) {
        var alt = $a7Dxq.alt(altCompose(dictFunctor));
        var functorNComp2 = functorNComp1(dictFunctor);
        return {
            alt: function(preferred) {
                return function(fallback) {
                    return alt($a43b9a86bb91298f$var$unwrap(preferred))($a43b9a86bb91298f$var$unwrap(fallback));
                };
            },
            Functor0: function() {
                return functorNComp2;
            }
        };
    };
};
var $a43b9a86bb91298f$export$463cad02c03f1d82 = function(dictPlus) {
    var plusCompose = $8gI0w.plusCompose(dictPlus);
    var altNComp1 = $a43b9a86bb91298f$export$44a4c2df84fb9c62(dictPlus.Alt0());
    return function(dictFunctor) {
        var altNComp2 = altNComp1(dictFunctor);
        return {
            empty: $axmEP.empty(plusCompose(dictFunctor)),
            Alt0: function() {
                return altNComp2;
            }
        };
    };
};
var $a43b9a86bb91298f$export$3569aca3d82a1465 = function(dictAlternative) {
    var applicativeNComp1 = $a43b9a86bb91298f$export$3ffeb23eded0715c(dictAlternative.Applicative0());
    var plusNComp1 = $a43b9a86bb91298f$export$463cad02c03f1d82(dictAlternative.Plus1());
    return function(dictApplicative) {
        var applicativeNComp2 = applicativeNComp1(dictApplicative);
        var plusNComp2 = plusNComp1(dictApplicative.Apply0().Functor0());
        return {
            Applicative0: function() {
                return applicativeNComp2;
            },
            Plus1: function() {
                return plusNComp2;
            }
        };
    };
};
var $a43b9a86bb91298f$export$e307a58525dd7d1b = function(v) {
    return v;
};
var $a43b9a86bb91298f$export$1b71bd99f0bc5c3d = function(v) {
    return v;
};
var $a43b9a86bb91298f$export$d4cc899d1fd25439 = function(v) {
    return v;
};
var $a43b9a86bb91298f$export$70345241af6ece6c = function(pt) {
    return function(v) {
        return v.extract(pt(v.seed));
    };
};
var $a43b9a86bb91298f$export$a4d2f2cf7f703661 = function(nt) {
    return function(v) {
        return $fQr0C.runExists($a43b9a86bb91298f$export$70345241af6ece6c(nt))(v);
    };
};
var $a43b9a86bb91298f$export$c134caa93799f689 = function($522) {
    return $a43b9a86bb91298f$export$e4905c4aa6135813($a43b9a86bb91298f$export$d4cc899d1fd25439($522));
};
var $a43b9a86bb91298f$export$2688daada1dcfbb9 = {
    lift: function(dictMonad) {
        var $523 = $9Grh5.bind(dictMonad.Bind1());
        return function($524) {
            return $a43b9a86bb91298f$export$cbd14172cb4d89bb($523($524));
        };
    }
};
var $a43b9a86bb91298f$export$2a5ecbe91d428473 = function(seed) {
    return function(extract) {
        return {
            extract: extract,
            seed: seed
        };
    };
};
var $a43b9a86bb91298f$export$f54069faa77a2177 = function(dictApplicative) {
    var $525 = $a43b9a86bb91298f$export$2a5ecbe91d428473($gUTA8.pure(dictApplicative)($r2HHk.unit));
    return function($526) {
        return $525($l4M7e.const($526));
    };
};
var $a43b9a86bb91298f$export$2e151e725af1b8ea = function(seed) {
    var $527 = $a43b9a86bb91298f$export$2a5ecbe91d428473(seed);
    return function($528) {
        return $a43b9a86bb91298f$export$6e2a67bc79ff1c6b($fQr0C.mkExists($527($528)));
    };
};
var $a43b9a86bb91298f$export$6fb29dcd41117f3 = function(fun) {
    return function(v) {
        return $a43b9a86bb91298f$export$2a5ecbe91d428473(v.seed)(function($529) {
            return fun(v.extract($529));
        });
    };
};
var $a43b9a86bb91298f$export$7d361e6a62be8e34 = function(dictApplicative) {
    var $530 = $8IafO.lower$prime(dictApplicative);
    return function($531) {
        return $530($a43b9a86bb91298f$export$e307a58525dd7d1b($531));
    };
};
var $a43b9a86bb91298f$var$lowerRan1 = /* #__PURE__ */ $a43b9a86bb91298f$export$7d361e6a62be8e34($6VVZC.applicativeIdentity);
var $a43b9a86bb91298f$export$d571fa4e6b308e5f = function(dict) {
    return dict.hproject;
};
var $a43b9a86bb91298f$export$245f8eacd56e821c = function(dictHFunctor) {
    var hmap = $hK1Ac.hmap(dictHFunctor);
    return function(c) {
        return function(a) {
            var r = function(x) {
                return a(hmap(r)(c(x)));
            };
            return r;
        };
    };
};
var $a43b9a86bb91298f$export$f8ac77d699371162 = function(dictNested) {
    var hmap = $hK1Ac.hmap(dictNested.HFunctor0());
    var hproject1 = $a43b9a86bb91298f$export$d571fa4e6b308e5f(dictNested);
    return function(a) {
        var f = function(x) {
            return a(hmap(f)(hproject1(x)));
        };
        return f;
    };
};
var $a43b9a86bb91298f$export$c6445ea4a1a56930 = function(dict) {
    return dict.hembed;
};
var $a43b9a86bb91298f$export$8efb9627b02e531b = function(dictNested) {
    var hembed1 = $a43b9a86bb91298f$export$c6445ea4a1a56930(dictNested);
    var hmap = $hK1Ac.hmap(dictNested.HFunctor0());
    return function(c) {
        var u = function(x) {
            return hembed1(hmap(u)(c(x)));
        };
        return u;
    };
};
var $a43b9a86bb91298f$export$7d89e99ed62494c5 = function(dictNested) {
    var hproject1 = $a43b9a86bb91298f$export$d571fa4e6b308e5f(dictNested);
    return function(u) {
        return u(hproject1);
    };
};
var $a43b9a86bb91298f$export$a931cbdd4b92ce61 = function(dictNested) {
    var hembed1 = $a43b9a86bb91298f$export$c6445ea4a1a56930(dictNested);
    return function(f) {
        return f(hembed1);
    };
};
var $a43b9a86bb91298f$export$acb0554df34e6fff = function(dictNested) {
    var hunfold1 = $a43b9a86bb91298f$export$8efb9627b02e531b(dictNested);
    return function(ca) {
        return function(seed) {
            var $532 = hunfold1(ca);
            var $533 = $a43b9a86bb91298f$export$2e151e725af1b8ea(seed);
            return function($534) {
                return $532($533($534));
            };
        };
    };
};
var $a43b9a86bb91298f$export$3fd0a3d2e5d4ddb4 = function(dictNested) {
    var hfold1 = $a43b9a86bb91298f$export$f8ac77d699371162(dictNested);
    return function(a) {
        var $535 = hfold1(a);
        return function($536) {
            return $a43b9a86bb91298f$export$e307a58525dd7d1b($535($536));
        };
    };
};
var $a43b9a86bb91298f$export$99fa7d046fe1b31e = function(dictNested) {
    var gunfold1 = $a43b9a86bb91298f$export$acb0554df34e6fff(dictNested);
    var hmap = $hK1Ac.hmap(dictNested.HFunctor0());
    return function(ca) {
        return function(s) {
            return gunfold1(function() {
                var $537 = hmap($a43b9a86bb91298f$export$1b71bd99f0bc5c3d);
                return function($538) {
                    return $537(ca($a43b9a86bb91298f$export$d194bc2b1d244070($538)));
                };
            }())(s)($a43b9a86bb91298f$var$unwrap);
        };
    };
};
var $a43b9a86bb91298f$export$bdec7a9c693f38bb = {
    map: function(fun) {
        return function(v) {
            return $fQr0C.runExists(function() {
                var $539 = $a43b9a86bb91298f$export$6fb29dcd41117f3(fun);
                return function($540) {
                    return $fQr0C.mkExists($539($540));
                };
            }())(v);
        };
    }
};
var $a43b9a86bb91298f$var$map3 = /* #__PURE__ */ $l0wDR.map($a43b9a86bb91298f$export$bdec7a9c693f38bb);
var $a43b9a86bb91298f$export$724b41f50809ff40 = {
    map: function(f) {
        return function(m) {
            return $a43b9a86bb91298f$var$map3(f)(m);
        };
    }
};
var $a43b9a86bb91298f$var$map4 = /* #__PURE__ */ $l0wDR.map($a43b9a86bb91298f$export$724b41f50809ff40);
var $a43b9a86bb91298f$export$25d367e02170840 = function(dict) {
    return dict.fmap;
};
var $a43b9a86bb91298f$export$a3a9b8a6ee74a36 = function(dictNested) {
    var hembed1 = $a43b9a86bb91298f$export$c6445ea4a1a56930(dictNested);
    var hmap = $hK1Ac.hmap(dictNested.HFunctor0());
    var gfold1 = $a43b9a86bb91298f$export$3fd0a3d2e5d4ddb4(dictNested);
    return function(dictFFunctor) {
        var fmap1 = $a43b9a86bb91298f$export$25d367e02170840(dictFFunctor)($a43b9a86bb91298f$export$c3748152a3a12194);
        return function(f) {
            return function(x) {
                var mapAlg = function(t) {
                    return function(e) {
                        return hembed1(hmap($a43b9a86bb91298f$var$lowerRan1)(fmap1(function($541) {
                            return $a43b9a86bb91298f$var$unwrap(e($541));
                        })(t)));
                    };
                };
                return gfold1(mapAlg)(x)(function($542) {
                    return $6VVZC.Identity(f($542));
                });
            };
        };
    };
};
var $a43b9a86bb91298f$export$e0ce401d0b82e29 = function(dictNested) {
    var hfold1 = $a43b9a86bb91298f$export$f8ac77d699371162(dictNested);
    return function(a) {
        return function(t) {
            return $a43b9a86bb91298f$var$unwrap($a43b9a86bb91298f$export$d4cc899d1fd25439(hfold1(a)(t))($1qMIU.Const));
        };
    };
};
var $a43b9a86bb91298f$var$ffold1 = /* #__PURE__ */ $a43b9a86bb91298f$export$e0ce401d0b82e29($a43b9a86bb91298f$export$52f698283a1c85e5);
var $a43b9a86bb91298f$export$d8330949698cd282 = function(dx) {
    var mkDensity = function(extract) {
        return function(seed) {
            return $fQr0C.mkExists({
                extract: extract,
                seed: seed
            });
        };
    };
    var v = $a43b9a86bb91298f$export$1b71bd99f0bc5c3d(dx);
    return $fQr0C.runExists(function(v1) {
        return mkDensity(mkDensity(v1.extract))(v1.seed);
    })(v);
};
var $a43b9a86bb91298f$export$43162eee96c2f3a = {
    extend: function(fd) {
        var $543 = $a43b9a86bb91298f$var$map4(fd);
        return function($544) {
            return $543($a43b9a86bb91298f$export$d8330949698cd282($544));
        };
    },
    Functor0: function() {
        return $a43b9a86bb91298f$export$724b41f50809ff40;
    }
};
var $a43b9a86bb91298f$export$15fd46b486d35725 = function(displayFree) {
    var d = function(f) {
        var df = function(v) {
            if (v instanceof $a43b9a86bb91298f$export$b9a1949c5703f871) {
                var dfv = function(v2) {
                    if (v2 instanceof $aKY4H.Left) return v2.value0;
                    if (v2 instanceof $aKY4H.Right) return $jIMHU.span([
                        $cLQJF.class_("bounded-variable")
                    ])([
                        $hhMAk.text($a43b9a86bb91298f$var$show(v2.value0.value0) + (" (" + (v2.value0.value1 + ")")))
                    ]);
                    throw new Error("Failed pattern match at Bounded (line 422, column 7 - line 422, column 29): " + [
                        v2.constructor.name
                    ]);
                };
                return dfv(f(v.value0));
            }
            if (v instanceof $a43b9a86bb91298f$export$f362e1cb1a1602a0) {
                var displayVar = function(v1) {
                    if (v1 instanceof $32mKU.B) return new $aKY4H.Right(new $9MxTl.Tuple(0, v.value0.variableName));
                    if (v1 instanceof $32mKU.F) return new $aKY4H.Left(d(function() {
                        var $545 = $a43b9a86bb91298f$var$map1($a43b9a86bb91298f$var$first(function(v2) {
                            return v2 + 1 | 0;
                        }));
                        return function($546) {
                            return $545(f($546));
                        };
                    }())(v1.value0));
                    throw new Error("Failed pattern match at Bounded (line 435, column 7 - line 435, column 60): " + [
                        v1.constructor.name
                    ]);
                };
                return $jIMHU.div([
                    $cLQJF.class_("bounded-abstraction")
                ])([
                    $jIMHU.span([
                        $cLQJF.class_("bounded-scope-label")
                    ])([
                        $hhMAk.text("Scope of " + v.value0.variableName)
                    ]),
                    $jIMHU.div([
                        $cLQJF.class_("bounded-scope")
                    ])([
                        d(displayVar)($32mKU.unScope(v.value0.body))
                    ])
                ]);
            }
            if (v instanceof $a43b9a86bb91298f$export$16975c34e60e1e61) return $jIMHU.div([
                $cLQJF.class_("bounded-application")
            ])([
                $jIMHU.div([
                    $cLQJF.class_("bounded-function")
                ])([
                    df(v["value0"]["function"])
                ]),
                $jIMHU.div([
                    $cLQJF.class_("bounded-argument")
                ])([
                    df(v.value0.argument)
                ])
            ]);
            throw new Error("Failed pattern match at Bounded (line 419, column 5 - line 419, column 40): " + [
                v.constructor.name
            ]);
        };
        return df;
    };
    return d(function($547) {
        return $aKY4H.Left.create(displayFree($547));
    });
};
var $a43b9a86bb91298f$export$a702ab8f45539d96 = {
    extract: /* #__PURE__ */ function() {
        var $548 = $a43b9a86bb91298f$export$a4d2f2cf7f703661($a43b9a86bb91298f$var$identity);
        return function($549) {
            return $548($a43b9a86bb91298f$export$1b71bd99f0bc5c3d($549));
        };
    }(),
    Extend0: function() {
        return $a43b9a86bb91298f$export$43162eee96c2f3a;
    }
};
var $a43b9a86bb91298f$export$ac84b1acd9f34335 = function($550) {
    return $a43b9a86bb91298f$export$cbd14172cb4d89bb($a43b9a86bb91298f$export$e307a58525dd7d1b($550));
};
var $a43b9a86bb91298f$export$f713306c9c7e962f = /* #__PURE__ */ function() {
    var alg = function(v) {
        if (v instanceof $jHZNn.ApplyF) return new $a43b9a86bb91298f$export$16975c34e60e1e61(v.value0);
        if (v instanceof $jHZNn.LambdaF) return new $a43b9a86bb91298f$export$f362e1cb1a1602a0({
            variableName: v.value0.binder,
            body: $a43b9a86bb91298f$var$abstract1(v.value0.binder)(v.value0.body)
        });
        if (v instanceof $jHZNn.VariableF) return new $a43b9a86bb91298f$export$b9a1949c5703f871(v.value0);
        throw new Error("Failed pattern match at Bounded (line 344, column 9 - line 348, column 39): " + [
            v.constructor.name
        ]);
    };
    return $lO7j1.cata($jHZNn.recursiveExprExprF)(alg);
}();
var $a43b9a86bb91298f$export$bf7be5ce28447d8a = /* #__PURE__ */ function() {
    var handleQuery = function(v) {
        var bound = $a43b9a86bb91298f$export$f713306c9c7e962f(v.value0);
        return $a43b9a86bb91298f$var$discard($a43b9a86bb91298f$var$put(new $ykHdR.Just(bound)))(function() {
            return $a43b9a86bb91298f$var$pure($ykHdR.Just.create(v.value1(bound)));
        });
    };
    return $kugLX.mkComponent({
        initialState: $l4M7e.const($ykHdR.Nothing.value),
        render: function(mExpr) {
            return $jIMHU.div([
                $cLQJF.class_("bounds-checker")
            ])($ykHdR.maybe([])(function() {
                var $551 = $a43b9a86bb91298f$export$15fd46b486d35725(function(unbound) {
                    return $jIMHU.span([
                        $cLQJF.class_("unbound-variable")
                    ])([
                        $hhMAk.text(unbound)
                    ]);
                });
                return function($552) {
                    return $a43b9a86bb91298f$var$pure1($551($552));
                };
            }())(mExpr));
        },
        "eval": $kugLX.mkEval({
            initialize: $ykHdR.Nothing.value,
            receive: $l4M7e.const($ykHdR.Nothing.value),
            handleAction: $l4M7e.const($a43b9a86bb91298f$var$pure($r2HHk.unit)),
            handleQuery: handleQuery,
            finalize: $ykHdR.Nothing.value
        })
    });
}();
var $a43b9a86bb91298f$export$93307db3d2cb317 = function(dictFunctor) {
    var map5 = $l0wDR.map(dictFunctor);
    return function(dictApply) {
        var apply = $a5g3C.apply(dictApply);
        var map6 = $l0wDR.map(dictApply.Functor0());
        return function(v) {
            return function(v1) {
                return $a43b9a86bb91298f$export$2a5ecbe91d428473(apply(map6($9MxTl.Tuple.create)(v.seed))(v1.seed))(function(ft) {
                    return v.extract(map5($9MxTl.fst)(ft))(v1.extract(map5($9MxTl.snd)(ft)));
                });
            };
        };
    };
};
var $a43b9a86bb91298f$export$302afa4d104b7c6a = function(dictFunctor) {
    var applyLanF1 = $a43b9a86bb91298f$export$93307db3d2cb317(dictFunctor);
    return function(dictApply) {
        var applyLanF2 = applyLanF1(dictApply);
        return {
            apply: function(v) {
                return function(v1) {
                    return $fQr0C.runExists(function(lff) {
                        return $fQr0C.runExists(function() {
                            var $553 = applyLanF2(lff);
                            return function($554) {
                                return $fQr0C.mkExists($553($554));
                            };
                        }())(v1);
                    })(v);
                };
            },
            Functor0: function() {
                return $a43b9a86bb91298f$export$bdec7a9c693f38bb;
            }
        };
    };
};
var $a43b9a86bb91298f$export$558e0856d6d3e7e9 = function(dictApply) {
    var apply = $a5g3C.apply($a43b9a86bb91298f$export$302afa4d104b7c6a(dictApply.Functor0())(dictApply));
    return {
        apply: function(df) {
            var $555 = apply($a43b9a86bb91298f$export$1b71bd99f0bc5c3d(df));
            return function($556) {
                return $a43b9a86bb91298f$export$d194bc2b1d244070($555($a43b9a86bb91298f$export$1b71bd99f0bc5c3d($556)));
            };
        },
        Functor0: function() {
            return $a43b9a86bb91298f$export$724b41f50809ff40;
        }
    };
};
var $a43b9a86bb91298f$export$a187ee10cf27b991 = {
    apply: function(f) {
        return function(x) {
            return $5PtR4.apply($a43b9a86bb91298f$export$d4cc899d1fd25439(f))($a43b9a86bb91298f$export$d4cc899d1fd25439(x));
        };
    },
    Functor0: function() {
        return $a43b9a86bb91298f$export$d8a50fc8675b888e;
    }
};
var $a43b9a86bb91298f$export$9b81aff41b14f24a = {
    bind: function(x) {
        return function(f) {
            return $5PtR4.bind($a43b9a86bb91298f$export$d4cc899d1fd25439(x))(function(y) {
                return $a43b9a86bb91298f$export$d4cc899d1fd25439(f(y));
            });
        };
    },
    Apply0: function() {
        return $a43b9a86bb91298f$export$a187ee10cf27b991;
    }
};
var $a43b9a86bb91298f$export$d10929a680069021 = function(dictFunctor) {
    var applyLan1 = $a43b9a86bb91298f$export$302afa4d104b7c6a(dictFunctor);
    return function(dictApplicative) {
        var applyLan2 = applyLan1(dictApplicative.Apply0());
        return {
            pure: function() {
                var $557 = $a43b9a86bb91298f$export$f54069faa77a2177(dictApplicative);
                return function($558) {
                    return $a43b9a86bb91298f$export$6e2a67bc79ff1c6b($fQr0C.mkExists($557($558)));
                };
            }(),
            Apply0: function() {
                return applyLan2;
            }
        };
    };
};
var $a43b9a86bb91298f$export$69d2ccfe63b02a4b = function(dictApplicative) {
    var Apply0 = dictApplicative.Apply0();
    var applyDensity1 = $a43b9a86bb91298f$export$558e0856d6d3e7e9(Apply0);
    return {
        pure: function() {
            var $559 = $gUTA8.pure($a43b9a86bb91298f$export$d10929a680069021(Apply0.Functor0())(dictApplicative));
            return function($560) {
                return $a43b9a86bb91298f$export$d194bc2b1d244070($559($560));
            };
        }(),
        Apply0: function() {
            return applyDensity1;
        }
    };
};
var $a43b9a86bb91298f$export$33fd2e16139aac9 = {
    pure: function($561) {
        return $a43b9a86bb91298f$export$cbd14172cb4d89bb($5PtR4.pure($561));
    },
    Apply0: function() {
        return $a43b9a86bb91298f$export$a187ee10cf27b991;
    }
};
var $a43b9a86bb91298f$var$pure2 = /* #__PURE__ */ $gUTA8.pure($a43b9a86bb91298f$export$33fd2e16139aac9);
var $a43b9a86bb91298f$export$afb17a33e08a3c75 = {
    Applicative0: function() {
        return $a43b9a86bb91298f$export$33fd2e16139aac9;
    },
    Bind1: function() {
        return $a43b9a86bb91298f$export$9b81aff41b14f24a;
    }
};
var $a43b9a86bb91298f$var$instantiate1 = /* #__PURE__ */ $32mKU.instantiate1($a43b9a86bb91298f$export$afb17a33e08a3c75);
var $a43b9a86bb91298f$export$9d38e17d5c5e37fe = function(i) {
    return function(b) {
        var runCodensityConst = function(cod) {
            var $562 = $a43b9a86bb91298f$export$d4cc899d1fd25439(cod);
            return function($563) {
                return $a43b9a86bb91298f$var$unwrap($562($563));
            };
        };
        var alg = function(v) {
            if (v instanceof $a43b9a86bb91298f$export$722620c86700909e) {
                var codensity = function(f) {
                    var runExpr = function(cca) {
                        return runCodensityConst(cca)(f);
                    };
                    return new $jHZNn.Application({
                        "function": runExpr(v["value0"]["function"]),
                        argument: runExpr(v.value0.argument)
                    });
                };
                return codensity;
            }
            if (v instanceof $a43b9a86bb91298f$export$2bf0c6b7057c5d19) {
                var codensity = function(f) {
                    var var0 = $l4M7e.const(new $jHZNn.Variable(v.value0.variableName));
                    var body = runCodensityConst($a43b9a86bb91298f$var$instantiate1(var0)($a43b9a86bb91298f$var$hoistScope($a43b9a86bb91298f$var$lowerCoyoneda)(v.value0.body)))(f);
                    return new $jHZNn.Abstraction({
                        binder: v.value0.variableName,
                        body: body
                    });
                };
                return codensity;
            }
            if (v instanceof $a43b9a86bb91298f$export$2f0c881bb9f2c06c) return $a43b9a86bb91298f$var$pure2(v.value0);
            throw new Error("Failed pattern match at Bounded (line 361, column 9 - line 384, column 21): " + [
                v.constructor.name
            ]);
        };
        return $a43b9a86bb91298f$var$ffold1(alg)($a43b9a86bb91298f$var$map2(function($564) {
            return $jHZNn.Variable.create(i($564));
        })(b));
    };
};
var $a43b9a86bb91298f$export$89f43dcdf25a1c55 = /* #__PURE__ */ $a43b9a86bb91298f$export$9d38e17d5c5e37fe($7DusG.absurd);
var $a43b9a86bb91298f$export$4cd77f3f2fbf3d39 = /* #__PURE__ */ $a43b9a86bb91298f$export$9d38e17d5c5e37fe($a43b9a86bb91298f$var$identity);
var $a43b9a86bb91298f$export$715057d388d09c58 = function(x) {
    return $a43b9a86bb91298f$var$eq1(x)($a43b9a86bb91298f$export$4cd77f3f2fbf3d39($a43b9a86bb91298f$export$f713306c9c7e962f(x)));
};
var $a43b9a86bb91298f$export$c2d084dc44961371 = function(printIdent) {
    var $565 = $a43b9a86bb91298f$export$9d38e17d5c5e37fe(printIdent);
    return function($566) {
        return $jHZNn.print($565($566));
    };
};

});
parcelRegister("5PtR4", function(module, exports) {

$parcel$export(module.exports, "pure", () => $43e8dfbe2a172945$export$48ec4a2b1cfc6557);
$parcel$export(module.exports, "bind", () => $43e8dfbe2a172945$export$2385a24977818dd0);
$parcel$export(module.exports, "apply", () => $43e8dfbe2a172945$export$5635d7ef4b8fee1c);
// Generated by purs version 0.15.16

var $8IafO = parcelRequire("8IafO");
var $43e8dfbe2a172945$export$48ec4a2b1cfc6557 = /* #__PURE__ */ $8IafO.pure(function(x) {
    return x;
});
var $43e8dfbe2a172945$export$871de8747c9eaa88 = $8IafO.map;
var $43e8dfbe2a172945$export$396fca1b21f4e538 = function(dictApplicative) {
    return $8IafO.lower$prime(dictApplicative);
};
var $43e8dfbe2a172945$export$abae053c7acf36bb = $8IafO.lower;
var $43e8dfbe2a172945$export$34255e15eb56d2b3 = function(dictMonadEffect) {
    return $8IafO.liftEffect(dictMonadEffect)(function(x) {
        return x;
    });
};
var $43e8dfbe2a172945$export$37f61af225938e0f = function(dictMonadAff) {
    return $8IafO.liftAff(dictMonadAff)(function(x) {
        return x;
    });
};
var $43e8dfbe2a172945$export$ac013eb8ca5dcfe0 = function(dictComonad) {
    return $8IafO.lift$prime(dictComonad)(dictComonad.Extend0().Functor0());
};
var $43e8dfbe2a172945$export$590e8b2c435046d9 = function(dictFunctor) {
    return $8IafO.lift(dictFunctor);
};
var $43e8dfbe2a172945$export$2385a24977818dd0 = /* #__PURE__ */ $8IafO.bind(function(x) {
    return x;
});
var $43e8dfbe2a172945$export$5635d7ef4b8fee1c = /* #__PURE__ */ $8IafO.apply(function(x) {
    return x;
});

});
parcelRegister("8IafO", function(module, exports) {

$parcel$export(module.exports, "pure", () => $657a6308ad799ba7$export$48ec4a2b1cfc6557);
$parcel$export(module.exports, "map", () => $657a6308ad799ba7$export$871de8747c9eaa88);
$parcel$export(module.exports, "lower$prime", () => $657a6308ad799ba7$export$396fca1b21f4e538);
$parcel$export(module.exports, "lower", () => $657a6308ad799ba7$export$abae053c7acf36bb);
$parcel$export(module.exports, "liftEffect", () => $657a6308ad799ba7$export$34255e15eb56d2b3);
$parcel$export(module.exports, "liftAff", () => $657a6308ad799ba7$export$37f61af225938e0f);
$parcel$export(module.exports, "lift", () => $657a6308ad799ba7$export$590e8b2c435046d9);
$parcel$export(module.exports, "lift$prime", () => $657a6308ad799ba7$export$ac013eb8ca5dcfe0);
$parcel$export(module.exports, "bind", () => $657a6308ad799ba7$export$2385a24977818dd0);
$parcel$export(module.exports, "apply", () => $657a6308ad799ba7$export$5635d7ef4b8fee1c);
// Generated by purs version 0.15.16

var $gUTA8 = parcelRequire("gUTA8");

var $9Grh5 = parcelRequire("9Grh5");

var $frF73 = parcelRequire("frF73");

var $l0wDR = parcelRequire("l0wDR");

var $fHfnu = parcelRequire("fHfnu");

var $kQlZ1 = parcelRequire("kQlZ1");
var $657a6308ad799ba7$export$48ec4a2b1cfc6557 = function(hoist) {
    return function(x) {
        return function(f) {
            return hoist(f(x));
        };
    };
};
var $657a6308ad799ba7$export$871de8747c9eaa88 = function(f) {
    return function(v) {
        return function(h) {
            return v(function(x) {
                return h(f(x));
            });
        };
    };
};
var $657a6308ad799ba7$export$396fca1b21f4e538 = function(dictApplicative) {
    var pure1 = $gUTA8.pure(dictApplicative);
    return function(v) {
        return v(pure1);
    };
};
var $657a6308ad799ba7$export$abae053c7acf36bb = function(f) {
    return function(x) {
        return f(x)(function(y) {
            return y;
        });
    };
};
var $657a6308ad799ba7$export$34255e15eb56d2b3 = function(dictMonadEffect) {
    var bind1 = $9Grh5.bind(dictMonadEffect.Monad0().Bind1());
    var liftEffect1 = $kQlZ1.liftEffect(dictMonadEffect);
    return function(hoist) {
        return function(x) {
            var $33 = bind1(liftEffect1(x));
            return function($34) {
                return hoist($33($34));
            };
        };
    };
};
var $657a6308ad799ba7$export$37f61af225938e0f = function(dictMonadAff) {
    var bind1 = $9Grh5.bind(dictMonadAff.MonadEffect0().Monad0().Bind1());
    var liftAff1 = $fHfnu.liftAff(dictMonadAff);
    return function(hoist) {
        return function(x) {
            var $35 = bind1(liftAff1(x));
            return function($36) {
                return hoist($35($36));
            };
        };
    };
};
var $657a6308ad799ba7$export$590e8b2c435046d9 = function(dictFunctor) {
    var map1 = $l0wDR.map(dictFunctor);
    return function(f) {
        return function(x) {
            return function(g) {
                return f(map1(g)(x));
            };
        };
    };
};
var $657a6308ad799ba7$export$ac013eb8ca5dcfe0 = function(dictComonad) {
    var extract = $frF73.extract(dictComonad);
    return function(dictFunctor) {
        return $657a6308ad799ba7$export$590e8b2c435046d9(dictFunctor)($l0wDR.map(dictFunctor)(extract));
    };
};
var $657a6308ad799ba7$export$2385a24977818dd0 = function(hoist) {
    return function(v) {
        return function(v1) {
            return function(g) {
                return v(function(x) {
                    return hoist(v1(x)(g));
                });
            };
        };
    };
};
var $657a6308ad799ba7$export$5635d7ef4b8fee1c = function(hoist) {
    return function(v) {
        return function(v1) {
            return function(g) {
                return v(function(f) {
                    return hoist(v1(function($37) {
                        return g(f($37));
                    }));
                });
            };
        };
    };
};

});
parcelRegister("fHfnu", function(module, exports) {

$parcel$export(module.exports, "liftAff", () => $b6d6cce78665f23d$export$37f61af225938e0f);
// Generated by purs version 0.15.16

var $7T8P4 = parcelRequire("7T8P4");

var $lGPnP = parcelRequire("lGPnP");

var $i2F6a = parcelRequire("i2F6a");

var $i7s3U = parcelRequire("i7s3U");

var $9DlYk = parcelRequire("9DlYk");

var $9Iord = parcelRequire("9Iord");

var $bnrVm = parcelRequire("bnrVm");

var $k4cbH = parcelRequire("k4cbH");

var $4PFx6 = parcelRequire("4PFx6");

var $iI3r9 = parcelRequire("iI3r9");

var $kqxtr = parcelRequire("kqxtr");
var $b6d6cce78665f23d$var$lift = /* #__PURE__ */ $4PFx6.lift($lGPnP.monadTransContT);
var $b6d6cce78665f23d$var$lift1 = /* #__PURE__ */ $4PFx6.lift($i2F6a.monadTransExceptT);
var $b6d6cce78665f23d$var$lift2 = /* #__PURE__ */ $4PFx6.lift($i7s3U.monadTransListT);
var $b6d6cce78665f23d$var$lift3 = /* #__PURE__ */ $4PFx6.lift($9DlYk.monadTransMaybeT);
var $b6d6cce78665f23d$var$lift4 = /* #__PURE__ */ $4PFx6.lift($bnrVm.monadTransReaderT);
var $b6d6cce78665f23d$var$lift5 = /* #__PURE__ */ $4PFx6.lift($k4cbH.monadTransStateT);
var $b6d6cce78665f23d$export$bd75e69808ef8e57 = {
    liftAff: /* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn),
    MonadEffect0: function() {
        return $kqxtr.monadEffectAff;
    }
};
var $b6d6cce78665f23d$export$37f61af225938e0f = function(dict) {
    return dict.liftAff;
};
var $b6d6cce78665f23d$export$53acd6df2cbe3344 = function(dictMonadAff) {
    var MonadEffect0 = dictMonadAff.MonadEffect0();
    var monadEffectContT = $lGPnP.monadEffectContT(MonadEffect0);
    return {
        liftAff: function() {
            var $65 = $b6d6cce78665f23d$var$lift(MonadEffect0.Monad0());
            var $66 = $b6d6cce78665f23d$export$37f61af225938e0f(dictMonadAff);
            return function($67) {
                return $65($66($67));
            };
        }(),
        MonadEffect0: function() {
            return monadEffectContT;
        }
    };
};
var $b6d6cce78665f23d$export$87a4e9dc50af0c41 = function(dictMonadAff) {
    var MonadEffect0 = dictMonadAff.MonadEffect0();
    var monadEffectExceptT = $i2F6a.monadEffectExceptT(MonadEffect0);
    return {
        liftAff: function() {
            var $68 = $b6d6cce78665f23d$var$lift1(MonadEffect0.Monad0());
            var $69 = $b6d6cce78665f23d$export$37f61af225938e0f(dictMonadAff);
            return function($70) {
                return $68($69($70));
            };
        }(),
        MonadEffect0: function() {
            return monadEffectExceptT;
        }
    };
};
var $b6d6cce78665f23d$export$72b48760d563ad73 = function(dictMonadAff) {
    var MonadEffect0 = dictMonadAff.MonadEffect0();
    var monadEffectListT = $i7s3U.monadEffectListT(MonadEffect0);
    return {
        liftAff: function() {
            var $71 = $b6d6cce78665f23d$var$lift2(MonadEffect0.Monad0());
            var $72 = $b6d6cce78665f23d$export$37f61af225938e0f(dictMonadAff);
            return function($73) {
                return $71($72($73));
            };
        }(),
        MonadEffect0: function() {
            return monadEffectListT;
        }
    };
};
var $b6d6cce78665f23d$export$7091efe953cca892 = function(dictMonadAff) {
    var MonadEffect0 = dictMonadAff.MonadEffect0();
    var monadEffectMaybe = $9DlYk.monadEffectMaybe(MonadEffect0);
    return {
        liftAff: function() {
            var $74 = $b6d6cce78665f23d$var$lift3(MonadEffect0.Monad0());
            var $75 = $b6d6cce78665f23d$export$37f61af225938e0f(dictMonadAff);
            return function($76) {
                return $74($75($76));
            };
        }(),
        MonadEffect0: function() {
            return monadEffectMaybe;
        }
    };
};
var $b6d6cce78665f23d$export$5fd9f999a5266faf = function(dictMonadAff) {
    var MonadEffect0 = dictMonadAff.MonadEffect0();
    var Monad0 = MonadEffect0.Monad0();
    var liftAff1 = $b6d6cce78665f23d$export$37f61af225938e0f(dictMonadAff);
    return function(dictMonoid) {
        var monadEffectRWS = $9Iord.monadEffectRWS(dictMonoid)(MonadEffect0);
        return {
            liftAff: function() {
                var $77 = $4PFx6.lift($9Iord.monadTransRWST(dictMonoid))(Monad0);
                return function($78) {
                    return $77(liftAff1($78));
                };
            }(),
            MonadEffect0: function() {
                return monadEffectRWS;
            }
        };
    };
};
var $b6d6cce78665f23d$export$fa61c33f24d5bab = function(dictMonadAff) {
    var MonadEffect0 = dictMonadAff.MonadEffect0();
    var monadEffectReader = $bnrVm.monadEffectReader(MonadEffect0);
    return {
        liftAff: function() {
            var $79 = $b6d6cce78665f23d$var$lift4(MonadEffect0.Monad0());
            var $80 = $b6d6cce78665f23d$export$37f61af225938e0f(dictMonadAff);
            return function($81) {
                return $79($80($81));
            };
        }(),
        MonadEffect0: function() {
            return monadEffectReader;
        }
    };
};
var $b6d6cce78665f23d$export$1c14dadc45d4bfb9 = function(dictMonadAff) {
    var MonadEffect0 = dictMonadAff.MonadEffect0();
    var monadEffectState = $k4cbH.monadEffectState(MonadEffect0);
    return {
        liftAff: function() {
            var $82 = $b6d6cce78665f23d$var$lift5(MonadEffect0.Monad0());
            var $83 = $b6d6cce78665f23d$export$37f61af225938e0f(dictMonadAff);
            return function($84) {
                return $82($83($84));
            };
        }(),
        MonadEffect0: function() {
            return monadEffectState;
        }
    };
};
var $b6d6cce78665f23d$export$7ad7619eecdb33a9 = function(dictMonadAff) {
    var MonadEffect0 = dictMonadAff.MonadEffect0();
    var Monad0 = MonadEffect0.Monad0();
    var liftAff1 = $b6d6cce78665f23d$export$37f61af225938e0f(dictMonadAff);
    return function(dictMonoid) {
        var monadEffectWriter = $iI3r9.monadEffectWriter(dictMonoid)(MonadEffect0);
        return {
            liftAff: function() {
                var $85 = $4PFx6.lift($iI3r9.monadTransWriterT(dictMonoid))(Monad0);
                return function($86) {
                    return $85(liftAff1($86));
                };
            }(),
            MonadEffect0: function() {
                return monadEffectWriter;
            }
        };
    };
};

});
parcelRegister("kqxtr", function(module, exports) {

$parcel$export(module.exports, "suspendAff", () => $edf0339512807bee$export$4de6f17bc3dfa03);
$parcel$export(module.exports, "functorAff", () => $edf0339512807bee$export$e8a7d9b8d7dc616a);
$parcel$export(module.exports, "forkAff", () => $edf0339512807bee$export$469c8a16c186651e);
$parcel$export(module.exports, "monadAff", () => $edf0339512807bee$export$b147a380fa8fdc0e);
$parcel$export(module.exports, "applicativeAff", () => $edf0339512807bee$export$9dc0454a98607988);
$parcel$export(module.exports, "bindAff", () => $edf0339512807bee$export$f885f489dcf38a2d);
$parcel$export(module.exports, "finally", () => $edf0339512807bee$export$7f8bd3bb7f01e042);
$parcel$export(module.exports, "invincible", () => $edf0339512807bee$export$859f4dae848ac0ae);
$parcel$export(module.exports, "parallelAff", () => $edf0339512807bee$export$cb4623454f96d5e0);
$parcel$export(module.exports, "applicativeParAff", () => $edf0339512807bee$export$389e6cb252ce112f);
$parcel$export(module.exports, "monadEffectAff", () => $edf0339512807bee$export$666a030cecdf96c);
$parcel$export(module.exports, "effectCanceler", () => $edf0339512807bee$export$952106a975f35ae2);
$parcel$export(module.exports, "joinFiber", () => $edf0339512807bee$export$f3d782c2b95165ad);
$parcel$export(module.exports, "functorFiber", () => $edf0339512807bee$export$29466a041ff3b3e0);
$parcel$export(module.exports, "killFiber", () => $edf0339512807bee$export$c65b2010df1810d);
$parcel$export(module.exports, "monadThrowAff", () => $edf0339512807bee$export$37a9b80154c7d256);
$parcel$export(module.exports, "monadErrorAff", () => $edf0339512807bee$export$9efce1646e93cba4);
$parcel$export(module.exports, "runAff_", () => $edf0339512807bee$export$ef62257e6f8a5f8c);
$parcel$export(module.exports, "monadRecAff", () => $edf0339512807bee$export$974f8db4a62dd716);
$parcel$export(module.exports, "nonCanceler", () => $edf0339512807bee$export$8deb6e154ce67af6);
$parcel$export(module.exports, "never", () => $edf0339512807bee$export$b3e22bcfd64c1022);
$parcel$export(module.exports, "makeAff", () => (parcelRequire("fkeSt")).makeAff);
$parcel$export(module.exports, "generalBracket", () => (parcelRequire("fkeSt")).generalBracket);
// Generated by purs version 0.15.16

var $fkeSt = parcelRequire("fkeSt");

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $9Grh5 = parcelRequire("9Grh5");

var $ibtPS = parcelRequire("ibtPS");

var $84kZf = parcelRequire("84kZf");

var $lowBm = parcelRequire("lowBm");

var $iYXib = parcelRequire("iYXib");

var $4A3Wv = parcelRequire("4A3Wv");

var $bvHbv = parcelRequire("bvHbv");

var $axmEP = parcelRequire("axmEP");

var $aKY4H = parcelRequire("aKY4H");

var $6RkEA = parcelRequire("6RkEA");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");

var $aknDF = parcelRequire("aknDF");

var $iwqgS = parcelRequire("iwqgS");

var $5b8Gl = parcelRequire("5b8Gl");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");

var $9hRVP = parcelRequire("9hRVP");

var $kQlZ1 = parcelRequire("kQlZ1");
parcelRequire("6ITWO");
var $eROd4 = parcelRequire("eROd4");
parcelRequire("k5Trf");
var $guZlc = parcelRequire("guZlc");

var $c0aRt = parcelRequire("c0aRt");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");
var $edf0339512807bee$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $edf0339512807bee$var$pure = /* #__PURE__ */ $gUTA8.pure($9hRVP.applicativeEffect);
var $edf0339512807bee$var$$$void = /* #__PURE__ */ $l0wDR.void($9hRVP.functorEffect);
var $edf0339512807bee$var$map = /* #__PURE__ */ $l0wDR.map($9hRVP.functorEffect);
var $edf0339512807bee$var$pure1 = /* #__PURE__ */ $gUTA8.pure($aKY4H.applicativeEither);
var $edf0339512807bee$var$Fiber = function(x) {
    return x;
};
var $edf0339512807bee$var$FFIUtil = function(x) {
    return x;
};
var $edf0339512807bee$export$22f79b48f44c15eb = function(x) {
    return x;
};
var $edf0339512807bee$export$4de6f17bc3dfa03 = /* #__PURE__ */ $fkeSt._fork(false);
var $edf0339512807bee$export$608d3e3a27b14320 = {
    Coercible0: function() {
        return undefined;
    }
};
var $edf0339512807bee$export$d7f9012ed771d686 = {
    map: $fkeSt._parAffMap
};
var $edf0339512807bee$export$e8a7d9b8d7dc616a = {
    map: $fkeSt._map
};
var $edf0339512807bee$var$map1 = /* #__PURE__ */ $l0wDR.map($edf0339512807bee$export$e8a7d9b8d7dc616a);
var $edf0339512807bee$export$469c8a16c186651e = /* #__PURE__ */ $fkeSt._fork(true);
var $edf0339512807bee$var$ffiUtil = /* #__PURE__ */ function() {
    var unsafeFromRight = function(v) {
        if (v instanceof $aKY4H.Right) return v.value0;
        if (v instanceof $aKY4H.Left) return $c0aRt.unsafeCrashWith("unsafeFromRight: Left");
        throw new Error("Failed pattern match at Effect.Aff (line 412, column 21 - line 414, column 54): " + [
            v.constructor.name
        ]);
    };
    var unsafeFromLeft = function(v) {
        if (v instanceof $aKY4H.Left) return v.value0;
        if (v instanceof $aKY4H.Right) return $c0aRt.unsafeCrashWith("unsafeFromLeft: Right");
        throw new Error("Failed pattern match at Effect.Aff (line 407, column 20 - line 409, column 55): " + [
            v.constructor.name
        ]);
    };
    var isLeft = function(v) {
        if (v instanceof $aKY4H.Left) return true;
        if (v instanceof $aKY4H.Right) return false;
        throw new Error("Failed pattern match at Effect.Aff (line 402, column 12 - line 404, column 21): " + [
            v.constructor.name
        ]);
    };
    return {
        isLeft: isLeft,
        fromLeft: unsafeFromLeft,
        fromRight: unsafeFromRight,
        left: $aKY4H.Left.create,
        right: $aKY4H.Right.create
    };
}();
var $edf0339512807bee$var$makeFiber = function(aff) {
    return $fkeSt._makeFiber($edf0339512807bee$var$ffiUtil, aff);
};
var $edf0339512807bee$export$30b347ca11a80af4 = function(aff) {
    return function __do() {
        var fiber = $edf0339512807bee$var$makeFiber(aff)();
        fiber.run();
        return fiber;
    };
};
var $edf0339512807bee$export$c8704a1045ed544d = function($75) {
    return $edf0339512807bee$var$$$void($edf0339512807bee$export$30b347ca11a80af4($75));
};
var $edf0339512807bee$export$d133944c527f2403 = $edf0339512807bee$var$makeFiber;
var $edf0339512807bee$export$1391212d75b2ee65 = function(v) {
    return $fkeSt._delay($aKY4H.Right.create, v);
};
var $edf0339512807bee$export$df5598cc12b9c8c = function(acquire) {
    return function(completed) {
        return $fkeSt.generalBracket(acquire)({
            killed: $l4M7e.const(completed),
            failed: $l4M7e.const(completed),
            completed: $l4M7e.const(completed)
        });
    };
};
var $edf0339512807bee$export$83901714774e2edc = {
    apply: $fkeSt._parAffApply,
    Functor0: function() {
        return $edf0339512807bee$export$d7f9012ed771d686;
    }
};
var $edf0339512807bee$var$lift2 = /* #__PURE__ */ $a5g3C.lift2($edf0339512807bee$export$83901714774e2edc);
var $edf0339512807bee$export$fc7e409bd1eae683 = function(dictSemigroup) {
    return {
        append: $edf0339512807bee$var$lift2($iwqgS.append(dictSemigroup))
    };
};
var $edf0339512807bee$export$b147a380fa8fdc0e = {
    Applicative0: function() {
        return $edf0339512807bee$export$9dc0454a98607988;
    },
    Bind1: function() {
        return $edf0339512807bee$export$f885f489dcf38a2d;
    }
};
var $edf0339512807bee$export$f885f489dcf38a2d = {
    bind: $fkeSt._bind,
    Apply0: function() {
        return $edf0339512807bee$var$$lazy_applyAff(0);
    }
};
var $edf0339512807bee$export$9dc0454a98607988 = {
    pure: $fkeSt._pure,
    Apply0: function() {
        return $edf0339512807bee$var$$lazy_applyAff(0);
    }
};
var $edf0339512807bee$var$$lazy_applyAff = /* #__PURE__ */ $edf0339512807bee$var$$runtime_lazy("applyAff", "Effect.Aff", function() {
    return {
        apply: $ibtPS.ap($edf0339512807bee$export$b147a380fa8fdc0e),
        Functor0: function() {
            return $edf0339512807bee$export$e8a7d9b8d7dc616a;
        }
    };
});
var $edf0339512807bee$export$114a07f1fb466c63 = /* #__PURE__ */ $edf0339512807bee$var$$lazy_applyAff(73);
var $edf0339512807bee$var$pure2 = /* #__PURE__ */ $gUTA8.pure($edf0339512807bee$export$9dc0454a98607988);
var $edf0339512807bee$var$bind1 = /* #__PURE__ */ $9Grh5.bind($edf0339512807bee$export$f885f489dcf38a2d);
var $edf0339512807bee$var$lift21 = /* #__PURE__ */ $a5g3C.lift2($edf0339512807bee$export$114a07f1fb466c63);
var $edf0339512807bee$var$apply = /* #__PURE__ */ $a5g3C.apply($edf0339512807bee$export$114a07f1fb466c63);
var $edf0339512807bee$var$bindFlipped = /* #__PURE__ */ $9Grh5.bindFlipped($edf0339512807bee$export$f885f489dcf38a2d);
var $edf0339512807bee$export$d0776e69f204de29 = function(aff) {
    return function(v) {
        return $fkeSt.generalBracket($edf0339512807bee$var$pure2($r2HHk.unit))({
            killed: function(e) {
                return function(v1) {
                    return v(e);
                };
            },
            failed: $l4M7e.const($edf0339512807bee$var$pure2),
            completed: $l4M7e.const($edf0339512807bee$var$pure2)
        })($l4M7e.const(aff));
    };
};
var $edf0339512807bee$export$7f8bd3bb7f01e042 = function(fin) {
    return function(a) {
        return $edf0339512807bee$export$df5598cc12b9c8c($edf0339512807bee$var$pure2($r2HHk.unit))($l4M7e.const(fin))($l4M7e.const(a));
    };
};
var $edf0339512807bee$export$859f4dae848ac0ae = function(a) {
    return $edf0339512807bee$export$df5598cc12b9c8c(a)($l4M7e.const($edf0339512807bee$var$pure2($r2HHk.unit)))($edf0339512807bee$var$pure2);
};
var $edf0339512807bee$export$6c7682db87129472 = {
    defer: function(f) {
        return $edf0339512807bee$var$bind1($edf0339512807bee$var$pure2($r2HHk.unit))(f);
    }
};
var $edf0339512807bee$export$cb4623454f96d5e0 = {
    parallel: $eOrGk.unsafeCoerce,
    sequential: $fkeSt._sequential,
    Apply0: function() {
        return $edf0339512807bee$export$114a07f1fb466c63;
    },
    Apply1: function() {
        return $edf0339512807bee$export$83901714774e2edc;
    }
};
var $edf0339512807bee$var$parallel = /* #__PURE__ */ $bvHbv.parallel($edf0339512807bee$export$cb4623454f96d5e0);
var $edf0339512807bee$export$389e6cb252ce112f = {
    pure: function($76) {
        return $edf0339512807bee$var$parallel($edf0339512807bee$var$pure2($76));
    },
    Apply0: function() {
        return $edf0339512807bee$export$83901714774e2edc;
    }
};
var $edf0339512807bee$var$pure3 = /* #__PURE__ */ $gUTA8.pure($edf0339512807bee$export$389e6cb252ce112f);
var $edf0339512807bee$var$parSequence_ = /* #__PURE__ */ $4A3Wv.parSequence_($edf0339512807bee$export$cb4623454f96d5e0)($edf0339512807bee$export$389e6cb252ce112f)($6RkEA.foldableArray);
var $edf0339512807bee$export$aa5306b4d3514fa0 = function(dictMonoid) {
    var semigroupParAff1 = $edf0339512807bee$export$fc7e409bd1eae683(dictMonoid.Semigroup0());
    return {
        mempty: $edf0339512807bee$var$pure3($aknDF.mempty(dictMonoid)),
        Semigroup0: function() {
            return semigroupParAff1;
        }
    };
};
var $edf0339512807bee$export$1cab8188db0c4c1f = {
    append: function(v) {
        return function(v1) {
            return function(err) {
                return $edf0339512807bee$var$parSequence_([
                    v(err),
                    v1(err)
                ]);
            };
        };
    }
};
var $edf0339512807bee$export$1dbf838572c25e01 = function(dictSemigroup) {
    return {
        append: $edf0339512807bee$var$lift21($iwqgS.append(dictSemigroup))
    };
};
var $edf0339512807bee$export$666a030cecdf96c = {
    liftEffect: $fkeSt._liftEffect,
    Monad0: function() {
        return $edf0339512807bee$export$b147a380fa8fdc0e;
    }
};
var $edf0339512807bee$var$liftEffect = /* #__PURE__ */ $kQlZ1.liftEffect($edf0339512807bee$export$666a030cecdf96c);
var $edf0339512807bee$export$952106a975f35ae2 = function($77) {
    return $edf0339512807bee$export$22f79b48f44c15eb($l4M7e.const($edf0339512807bee$var$liftEffect($77)));
};
var $edf0339512807bee$export$f3d782c2b95165ad = function(v) {
    return $fkeSt.makeAff(function(k) {
        return $edf0339512807bee$var$map($edf0339512807bee$export$952106a975f35ae2)(v.join(k));
    });
};
var $edf0339512807bee$export$29466a041ff3b3e0 = {
    map: function(f) {
        return function(t) {
            return $guZlc.unsafePerformEffect($edf0339512807bee$var$makeFiber($edf0339512807bee$var$map1(f)($edf0339512807bee$export$f3d782c2b95165ad(t))));
        };
    }
};
var $edf0339512807bee$export$4d705d914d07c7a7 = {
    apply: function(t1) {
        return function(t2) {
            return $guZlc.unsafePerformEffect($edf0339512807bee$var$makeFiber($edf0339512807bee$var$apply($edf0339512807bee$export$f3d782c2b95165ad(t1))($edf0339512807bee$export$f3d782c2b95165ad(t2))));
        };
    },
    Functor0: function() {
        return $edf0339512807bee$export$29466a041ff3b3e0;
    }
};
var $edf0339512807bee$export$6db27cd2d1558d76 = {
    pure: function(a) {
        return $guZlc.unsafePerformEffect($edf0339512807bee$var$makeFiber($edf0339512807bee$var$pure2(a)));
    },
    Apply0: function() {
        return $edf0339512807bee$export$4d705d914d07c7a7;
    }
};
var $edf0339512807bee$export$c65b2010df1810d = function(e) {
    return function(v) {
        return $edf0339512807bee$var$bind1($edf0339512807bee$var$liftEffect(v.isSuspended))(function(suspended) {
            if (suspended) return $edf0339512807bee$var$liftEffect($edf0339512807bee$var$$$void(v.kill(e, $l4M7e.const($edf0339512807bee$var$pure($r2HHk.unit)))));
            return $fkeSt.makeAff(function(k) {
                return $edf0339512807bee$var$map($edf0339512807bee$export$952106a975f35ae2)(v.kill(e, k));
            });
        });
    };
};
var $edf0339512807bee$export$12fb9217a4d25158 = /* #__PURE__ */ function() {
    var $78 = $l4M7e.flip($edf0339512807bee$export$c65b2010df1810d);
    return function($79) {
        return $edf0339512807bee$export$22f79b48f44c15eb($78($79));
    };
}();
var $edf0339512807bee$export$54b8dc42dcff4ab1 = function(aff) {
    var killError = $eROd4.error("[Aff] Child fiber outlived parent");
    var killAll = function(err) {
        return function(sup) {
            return $fkeSt.makeAff(function(k) {
                return $fkeSt._killAll(err, sup.supervisor, k($edf0339512807bee$var$pure1($r2HHk.unit)));
            });
        };
    };
    var acquire = function __do() {
        var sup = $fkeSt._makeSupervisedFiber($edf0339512807bee$var$ffiUtil, aff)();
        sup.fiber.run();
        return sup;
    };
    return $fkeSt.generalBracket($edf0339512807bee$var$liftEffect(acquire))({
        killed: function(err) {
            return function(sup) {
                return $edf0339512807bee$var$parSequence_([
                    $edf0339512807bee$export$c65b2010df1810d(err)(sup.fiber),
                    killAll(err)(sup)
                ]);
            };
        },
        failed: $l4M7e.const(killAll(killError)),
        completed: $l4M7e.const(killAll(killError))
    })(function($80) {
        return $edf0339512807bee$export$f3d782c2b95165ad(function(v) {
            return v.fiber;
        }($80));
    });
};
var $edf0339512807bee$export$d9b2f32f45e29810 = {
    liftST: /* #__PURE__ */ function() {
        var $81 = $iYXib.liftST($iYXib.monadSTEffect);
        return function($82) {
            return $edf0339512807bee$var$liftEffect($81($82));
        };
    }(),
    Monad0: function() {
        return $edf0339512807bee$export$b147a380fa8fdc0e;
    }
};
var $edf0339512807bee$export$37a9b80154c7d256 = {
    throwError: $fkeSt._throwError,
    Monad0: function() {
        return $edf0339512807bee$export$b147a380fa8fdc0e;
    }
};
var $edf0339512807bee$export$9efce1646e93cba4 = {
    catchError: $fkeSt._catchError,
    MonadThrow0: function() {
        return $edf0339512807bee$export$37a9b80154c7d256;
    }
};
var $edf0339512807bee$var$$$try = /* #__PURE__ */ $84kZf.try($edf0339512807bee$export$9efce1646e93cba4);
var $edf0339512807bee$var$catchError = /* #__PURE__ */ $84kZf.catchError($edf0339512807bee$export$9efce1646e93cba4);
var $edf0339512807bee$export$77f9e426014f6edd = $edf0339512807bee$var$$$try;
var $edf0339512807bee$export$60f50bfed4143f9d = function(k) {
    return function(aff) {
        return $edf0339512807bee$export$30b347ca11a80af4($edf0339512807bee$var$bindFlipped(function($83) {
            return $edf0339512807bee$var$liftEffect(k($83));
        })($edf0339512807bee$var$$$try(aff)));
    };
};
var $edf0339512807bee$export$ef62257e6f8a5f8c = function(k) {
    return function(aff) {
        return $edf0339512807bee$var$$$void($edf0339512807bee$export$60f50bfed4143f9d(k)(aff));
    };
};
var $edf0339512807bee$export$52011fb9f1f7b7e2 = function(k) {
    return function(aff) {
        return $edf0339512807bee$export$d133944c527f2403($edf0339512807bee$var$bindFlipped(function($84) {
            return $edf0339512807bee$var$liftEffect(k($84));
        })($edf0339512807bee$var$$$try(aff)));
    };
};
var $edf0339512807bee$export$974f8db4a62dd716 = {
    tailRecM: function(k) {
        var go = function(a) {
            return $edf0339512807bee$var$bind1(k(a))(function(res) {
                if (res instanceof $lowBm.Done) return $edf0339512807bee$var$pure2(res.value0);
                if (res instanceof $lowBm.Loop) return go(res.value0);
                throw new Error("Failed pattern match at Effect.Aff (line 104, column 7 - line 106, column 23): " + [
                    res.constructor.name
                ]);
            });
        };
        return go;
    },
    Monad0: function() {
        return $edf0339512807bee$export$b147a380fa8fdc0e;
    }
};
var $edf0339512807bee$export$b59d1737970253ab = function(dictMonoid) {
    var semigroupAff1 = $edf0339512807bee$export$1dbf838572c25e01(dictMonoid.Semigroup0());
    return {
        mempty: $edf0339512807bee$var$pure2($aknDF.mempty(dictMonoid)),
        Semigroup0: function() {
            return semigroupAff1;
        }
    };
};
var $edf0339512807bee$export$8deb6e154ce67af6 = /* #__PURE__ */ $l4M7e.const(/* #__PURE__ */ $edf0339512807bee$var$pure2($r2HHk.unit));
var $edf0339512807bee$export$800a937b75981c0e = {
    mempty: $edf0339512807bee$export$8deb6e154ce67af6,
    Semigroup0: function() {
        return $edf0339512807bee$export$1cab8188db0c4c1f;
    }
};
var $edf0339512807bee$var$mempty = /* #__PURE__ */ $aknDF.mempty($edf0339512807bee$export$800a937b75981c0e);
var $edf0339512807bee$export$b3e22bcfd64c1022 = /* #__PURE__ */ $fkeSt.makeAff(function(v) {
    return $edf0339512807bee$var$pure($edf0339512807bee$var$mempty);
});
var $edf0339512807bee$export$a19cb95a0294477 = /* #__PURE__ */ function() {
    var $85 = $edf0339512807bee$var$map1($l4M7e.const($r2HHk.unit));
    return function($86) {
        return $85($edf0339512807bee$export$77f9e426014f6edd($86));
    };
}();
var $edf0339512807bee$export$371c34bc9954b4c6 = {
    alt: $fkeSt._parAffAlt,
    Functor0: function() {
        return $edf0339512807bee$export$d7f9012ed771d686;
    }
};
var $edf0339512807bee$export$75f84a0612e9fcac = {
    alt: function(a1) {
        return function(a2) {
            return $edf0339512807bee$var$catchError(a1)($l4M7e.const(a2));
        };
    },
    Functor0: function() {
        return $edf0339512807bee$export$e8a7d9b8d7dc616a;
    }
};
var $edf0339512807bee$export$982abcb51ccf01ce = {
    empty: /* #__PURE__ */ $84kZf.throwError($edf0339512807bee$export$37a9b80154c7d256)(/* #__PURE__ */ $eROd4.error("Always fails")),
    Alt0: function() {
        return $edf0339512807bee$export$75f84a0612e9fcac;
    }
};
var $edf0339512807bee$export$a77596dfa1aa0c51 = {
    empty: /* #__PURE__ */ $edf0339512807bee$var$parallel(/* #__PURE__ */ $axmEP.empty($edf0339512807bee$export$982abcb51ccf01ce)),
    Alt0: function() {
        return $edf0339512807bee$export$371c34bc9954b4c6;
    }
};
var $edf0339512807bee$export$96ad65bdc35fd68a = {
    Applicative0: function() {
        return $edf0339512807bee$export$389e6cb252ce112f;
    },
    Plus1: function() {
        return $edf0339512807bee$export$a77596dfa1aa0c51;
    }
};

});
parcelRegister("fkeSt", function(module, exports) {

$parcel$export(module.exports, "_pure", () => $b28443a27438717a$export$68c6660df485915b);
$parcel$export(module.exports, "_throwError", () => $b28443a27438717a$export$520252a01094c36e);
$parcel$export(module.exports, "_catchError", () => $b28443a27438717a$export$eb5e86cd5464556e);
$parcel$export(module.exports, "_map", () => $b28443a27438717a$export$a0135aecf4a782ab);
$parcel$export(module.exports, "_bind", () => $b28443a27438717a$export$8fe95d71d8c6b6f3);
$parcel$export(module.exports, "_fork", () => $b28443a27438717a$export$f97e7884af471963);
$parcel$export(module.exports, "_liftEffect", () => $b28443a27438717a$export$3c6532f01a0290eb);
$parcel$export(module.exports, "_parAffMap", () => $b28443a27438717a$export$68695d37eb163711);
$parcel$export(module.exports, "_parAffApply", () => $b28443a27438717a$export$bce00526579b3344);
$parcel$export(module.exports, "_parAffAlt", () => $b28443a27438717a$export$6a44b66c7edadaa);
$parcel$export(module.exports, "makeAff", () => $b28443a27438717a$export$49d5975414e0a979);
$parcel$export(module.exports, "generalBracket", () => $b28443a27438717a$export$9ad792f02752f447);
$parcel$export(module.exports, "_makeFiber", () => $b28443a27438717a$export$f24188c8fd3f1234);
$parcel$export(module.exports, "_makeSupervisedFiber", () => $b28443a27438717a$export$7a3baea9562462c7);
$parcel$export(module.exports, "_killAll", () => $b28443a27438717a$export$a494cc11bfc0c750);
$parcel$export(module.exports, "_delay", () => $b28443a27438717a$export$389c1406f5ae6ae7);
$parcel$export(module.exports, "_sequential", () => $b28443a27438717a$export$139486a45824a247);
/* globals setImmediate, clearImmediate, setTimeout, clearTimeout */ /* eslint-disable no-unused-vars, no-prototype-builtins, no-use-before-define, no-unused-labels, no-param-reassign */ var $b28443a27438717a$var$Aff = function() {
    // A unique value for empty.
    var EMPTY = {};
    /*

  An awkward approximation. We elide evidence we would otherwise need in PS for
  efficiency sake.

  data Aff eff a
    = Pure a
    | Throw Error
    | Catch (Aff eff a) (Error -> Aff eff a)
    | Sync (Eff eff a)
    | Async ((Either Error a -> Eff eff Unit) -> Eff eff (Canceler eff))
    | forall b. Bind (Aff eff b) (b -> Aff eff a)
    | forall b. Bracket (Aff eff b) (BracketConditions eff b) (b -> Aff eff a)
    | forall b. Fork Boolean (Aff eff b) ?(Fiber eff b -> a)
    | Sequential (ParAff aff a)

  */ var PURE = "Pure";
    var THROW = "Throw";
    var CATCH = "Catch";
    var SYNC = "Sync";
    var ASYNC = "Async";
    var BIND = "Bind";
    var BRACKET = "Bracket";
    var FORK = "Fork";
    var SEQ = "Sequential";
    /*

  data ParAff eff a
    = forall b. Map (b -> a) (ParAff eff b)
    | forall b. Apply (ParAff eff (b -> a)) (ParAff eff b)
    | Alt (ParAff eff a) (ParAff eff a)
    | ?Par (Aff eff a)

  */ var MAP = "Map";
    var APPLY = "Apply";
    var ALT = "Alt";
    // Various constructors used in interpretation
    var CONS = "Cons"; // Cons-list, for stacks
    var RESUME = "Resume"; // Continue indiscriminately
    var RELEASE = "Release"; // Continue with bracket finalizers
    var FINALIZER = "Finalizer"; // A non-interruptible effect
    var FINALIZED = "Finalized"; // Marker for finalization
    var FORKED = "Forked"; // Reference to a forked fiber, with resumption stack
    var FIBER = "Fiber"; // Actual fiber reference
    var THUNK = "Thunk"; // Primed effect, ready to invoke
    function Aff(tag, _1, _2, _3) {
        this.tag = tag;
        this._1 = _1;
        this._2 = _2;
        this._3 = _3;
    }
    function AffCtr(tag) {
        var fn = function(_1, _2, _3) {
            return new Aff(tag, _1, _2, _3);
        };
        fn.tag = tag;
        return fn;
    }
    function nonCanceler(error) {
        return new Aff(PURE, void 0);
    }
    function runEff(eff) {
        try {
            eff();
        } catch (error) {
            setTimeout(function() {
                throw error;
            }, 0);
        }
    }
    function runSync(left, right, eff) {
        try {
            return right(eff());
        } catch (error) {
            return left(error);
        }
    }
    function runAsync(left, eff, k) {
        try {
            return eff(k)();
        } catch (error) {
            k(left(error))();
            return nonCanceler;
        }
    }
    var Scheduler = function() {
        var limit = 1024;
        var size = 0;
        var ix = 0;
        var queue = new Array(limit);
        var draining = false;
        function drain() {
            var thunk;
            draining = true;
            while(size !== 0){
                size--;
                thunk = queue[ix];
                queue[ix] = void 0;
                ix = (ix + 1) % limit;
                thunk();
            }
            draining = false;
        }
        return {
            isDraining: function() {
                return draining;
            },
            enqueue: function(cb) {
                var i, tmp;
                if (size === limit) {
                    tmp = draining;
                    drain();
                    draining = tmp;
                }
                queue[(ix + size) % limit] = cb;
                size++;
                if (!draining) drain();
            }
        };
    }();
    function Supervisor(util) {
        var fibers = {};
        var fiberId = 0;
        var count = 0;
        return {
            register: function(fiber) {
                var fid = fiberId++;
                fiber.onComplete({
                    rethrow: true,
                    handler: function(result) {
                        return function() {
                            count--;
                            delete fibers[fid];
                        };
                    }
                })();
                fibers[fid] = fiber;
                count++;
            },
            isEmpty: function() {
                return count === 0;
            },
            killAll: function(killError, cb) {
                return function() {
                    if (count === 0) return cb();
                    var killCount = 0;
                    var kills = {};
                    function kill(fid) {
                        kills[fid] = fibers[fid].kill(killError, function(result) {
                            return function() {
                                delete kills[fid];
                                killCount--;
                                if (util.isLeft(result) && util.fromLeft(result)) setTimeout(function() {
                                    throw util.fromLeft(result);
                                }, 0);
                                if (killCount === 0) cb();
                            };
                        })();
                    }
                    for(var k in fibers)if (fibers.hasOwnProperty(k)) {
                        killCount++;
                        kill(k);
                    }
                    fibers = {};
                    fiberId = 0;
                    count = 0;
                    return function(error) {
                        return new Aff(SYNC, function() {
                            for(var k in kills)if (kills.hasOwnProperty(k)) kills[k]();
                        });
                    };
                };
            }
        };
    }
    // Fiber state machine
    var SUSPENDED = 0; // Suspended, pending a join.
    var CONTINUE = 1; // Interpret the next instruction.
    var STEP_BIND = 2; // Apply the next bind.
    var STEP_RESULT = 3; // Handle potential failure from a result.
    var PENDING = 4; // An async effect is running.
    var RETURN = 5; // The current stack has returned.
    var COMPLETED = 6; // The entire fiber has completed.
    function Fiber(util, supervisor, aff) {
        // Monotonically increasing tick, increased on each asynchronous turn.
        var runTick = 0;
        // The current branch of the state machine.
        var status = SUSPENDED;
        // The current point of interest for the state machine branch.
        var step = aff; // Successful step
        var fail = null; // Failure step
        var interrupt = null; // Asynchronous interrupt
        // Stack of continuations for the current fiber.
        var bhead = null;
        var btail = null;
        // Stack of attempts and finalizers for error recovery. Every `Cons` is also
        // tagged with current `interrupt` state. We use this to track which items
        // should be ignored or evaluated as a result of a kill.
        var attempts = null;
        // A special state is needed for Bracket, because it cannot be killed. When
        // we enter a bracket acquisition or finalizer, we increment the counter,
        // and then decrement once complete.
        var bracketCount = 0;
        // Each join gets a new id so they can be revoked.
        var joinId = 0;
        var joins = null;
        var rethrow = true;
        // Each invocation of `run` requires a tick. When an asynchronous effect is
        // resolved, we must check that the local tick coincides with the fiber
        // tick before resuming. This prevents multiple async continuations from
        // accidentally resuming the same fiber. A common example may be invoking
        // the provided callback in `makeAff` more than once, but it may also be an
        // async effect resuming after the fiber was already cancelled.
        function run(localRunTick) {
            var tmp, result, attempt;
            while(true){
                tmp = null;
                result = null;
                attempt = null;
                switch(status){
                    case STEP_BIND:
                        status = CONTINUE;
                        try {
                            step = bhead(step);
                            if (btail === null) bhead = null;
                            else {
                                bhead = btail._1;
                                btail = btail._2;
                            }
                        } catch (e) {
                            status = RETURN;
                            fail = util.left(e);
                            step = null;
                        }
                        break;
                    case STEP_RESULT:
                        if (util.isLeft(step)) {
                            status = RETURN;
                            fail = step;
                            step = null;
                        } else if (bhead === null) status = RETURN;
                        else {
                            status = STEP_BIND;
                            step = util.fromRight(step);
                        }
                        break;
                    case CONTINUE:
                        switch(step.tag){
                            case BIND:
                                if (bhead) btail = new Aff(CONS, bhead, btail);
                                bhead = step._2;
                                status = CONTINUE;
                                step = step._1;
                                break;
                            case PURE:
                                if (bhead === null) {
                                    status = RETURN;
                                    step = util.right(step._1);
                                } else {
                                    status = STEP_BIND;
                                    step = step._1;
                                }
                                break;
                            case SYNC:
                                status = STEP_RESULT;
                                step = runSync(util.left, util.right, step._1);
                                break;
                            case ASYNC:
                                status = PENDING;
                                step = runAsync(util.left, step._1, function(result) {
                                    return function() {
                                        if (runTick !== localRunTick) return;
                                        runTick++;
                                        Scheduler.enqueue(function() {
                                            // It's possible to interrupt the fiber between enqueuing and
                                            // resuming, so we need to check that the runTick is still
                                            // valid.
                                            if (runTick !== localRunTick + 1) return;
                                            status = STEP_RESULT;
                                            step = result;
                                            run(runTick);
                                        });
                                    };
                                });
                                return;
                            case THROW:
                                status = RETURN;
                                fail = util.left(step._1);
                                step = null;
                                break;
                            // Enqueue the Catch so that we can call the error handler later on
                            // in case of an exception.
                            case CATCH:
                                if (bhead === null) attempts = new Aff(CONS, step, attempts, interrupt);
                                else attempts = new Aff(CONS, step, new Aff(CONS, new Aff(RESUME, bhead, btail), attempts, interrupt), interrupt);
                                bhead = null;
                                btail = null;
                                status = CONTINUE;
                                step = step._1;
                                break;
                            // Enqueue the Bracket so that we can call the appropriate handlers
                            // after resource acquisition.
                            case BRACKET:
                                bracketCount++;
                                if (bhead === null) attempts = new Aff(CONS, step, attempts, interrupt);
                                else attempts = new Aff(CONS, step, new Aff(CONS, new Aff(RESUME, bhead, btail), attempts, interrupt), interrupt);
                                bhead = null;
                                btail = null;
                                status = CONTINUE;
                                step = step._1;
                                break;
                            case FORK:
                                status = STEP_RESULT;
                                tmp = Fiber(util, supervisor, step._2);
                                if (supervisor) supervisor.register(tmp);
                                if (step._1) tmp.run();
                                step = util.right(tmp);
                                break;
                            case SEQ:
                                status = CONTINUE;
                                step = sequential(util, supervisor, step._1);
                                break;
                        }
                        break;
                    case RETURN:
                        bhead = null;
                        btail = null;
                        // If the current stack has returned, and we have no other stacks to
                        // resume or finalizers to run, the fiber has halted and we can
                        // invoke all join callbacks. Otherwise we need to resume.
                        if (attempts === null) {
                            status = COMPLETED;
                            step = interrupt || fail || step;
                        } else {
                            // The interrupt status for the enqueued item.
                            tmp = attempts._3;
                            attempt = attempts._1;
                            attempts = attempts._2;
                            switch(attempt.tag){
                                // We cannot recover from an unmasked interrupt. Otherwise we should
                                // continue stepping, or run the exception handler if an exception
                                // was raised.
                                case CATCH:
                                    // We should compare the interrupt status as well because we
                                    // only want it to apply if there has been an interrupt since
                                    // enqueuing the catch.
                                    if (interrupt && interrupt !== tmp && bracketCount === 0) status = RETURN;
                                    else if (fail) {
                                        status = CONTINUE;
                                        step = attempt._2(util.fromLeft(fail));
                                        fail = null;
                                    }
                                    break;
                                // We cannot resume from an unmasked interrupt or exception.
                                case RESUME:
                                    // As with Catch, we only want to ignore in the case of an
                                    // interrupt since enqueing the item.
                                    if (interrupt && interrupt !== tmp && bracketCount === 0 || fail) status = RETURN;
                                    else {
                                        bhead = attempt._1;
                                        btail = attempt._2;
                                        status = STEP_BIND;
                                        step = util.fromRight(step);
                                    }
                                    break;
                                // If we have a bracket, we should enqueue the handlers,
                                // and continue with the success branch only if the fiber has
                                // not been interrupted. If the bracket acquisition failed, we
                                // should not run either.
                                case BRACKET:
                                    bracketCount--;
                                    if (fail === null) {
                                        result = util.fromRight(step);
                                        // We need to enqueue the Release with the same interrupt
                                        // status as the Bracket that is initiating it.
                                        attempts = new Aff(CONS, new Aff(RELEASE, attempt._2, result), attempts, tmp);
                                        // We should only coninue as long as the interrupt status has not changed or
                                        // we are currently within a non-interruptable finalizer.
                                        if (interrupt === tmp || bracketCount > 0) {
                                            status = CONTINUE;
                                            step = attempt._3(result);
                                        }
                                    }
                                    break;
                                // Enqueue the appropriate handler. We increase the bracket count
                                // because it should not be cancelled.
                                case RELEASE:
                                    attempts = new Aff(CONS, new Aff(FINALIZED, step, fail), attempts, interrupt);
                                    status = CONTINUE;
                                    // It has only been killed if the interrupt status has changed
                                    // since we enqueued the item, and the bracket count is 0. If the
                                    // bracket count is non-zero then we are in a masked state so it's
                                    // impossible to be killed.
                                    if (interrupt && interrupt !== tmp && bracketCount === 0) step = attempt._1.killed(util.fromLeft(interrupt))(attempt._2);
                                    else if (fail) step = attempt._1.failed(util.fromLeft(fail))(attempt._2);
                                    else step = attempt._1.completed(util.fromRight(step))(attempt._2);
                                    fail = null;
                                    bracketCount++;
                                    break;
                                case FINALIZER:
                                    bracketCount++;
                                    attempts = new Aff(CONS, new Aff(FINALIZED, step, fail), attempts, interrupt);
                                    status = CONTINUE;
                                    step = attempt._1;
                                    break;
                                case FINALIZED:
                                    bracketCount--;
                                    status = RETURN;
                                    step = attempt._1;
                                    fail = attempt._2;
                                    break;
                            }
                        }
                        break;
                    case COMPLETED:
                        for(var k in joins)if (joins.hasOwnProperty(k)) {
                            rethrow = rethrow && joins[k].rethrow;
                            runEff(joins[k].handler(step));
                        }
                        joins = null;
                        // If we have an interrupt and a fail, then the thread threw while
                        // running finalizers. This should always rethrow in a fresh stack.
                        if (interrupt && fail) setTimeout(function() {
                            throw util.fromLeft(fail);
                        }, 0);
                        else if (util.isLeft(step) && rethrow) setTimeout(function() {
                            // Guard on reathrow because a completely synchronous fiber can
                            // still have an observer which was added after-the-fact.
                            if (rethrow) throw util.fromLeft(step);
                        }, 0);
                        return;
                    case SUSPENDED:
                        status = CONTINUE;
                        break;
                    case PENDING:
                        return;
                }
            }
        }
        function onComplete(join) {
            return function() {
                if (status === COMPLETED) {
                    rethrow = rethrow && join.rethrow;
                    join.handler(step)();
                    return function() {};
                }
                var jid = joinId++;
                joins = joins || {};
                joins[jid] = join;
                return function() {
                    if (joins !== null) delete joins[jid];
                };
            };
        }
        function kill(error, cb) {
            return function() {
                if (status === COMPLETED) {
                    cb(util.right(void 0))();
                    return function() {};
                }
                var canceler = onComplete({
                    rethrow: false,
                    handler: function() {
                        return cb(util.right(void 0));
                    }
                })();
                switch(status){
                    case SUSPENDED:
                        interrupt = util.left(error);
                        status = COMPLETED;
                        step = interrupt;
                        run(runTick);
                        break;
                    case PENDING:
                        if (interrupt === null) interrupt = util.left(error);
                        if (bracketCount === 0) {
                            if (status === PENDING) attempts = new Aff(CONS, new Aff(FINALIZER, step(error)), attempts, interrupt);
                            status = RETURN;
                            step = null;
                            fail = null;
                            run(++runTick);
                        }
                        break;
                    default:
                        if (interrupt === null) interrupt = util.left(error);
                        if (bracketCount === 0) {
                            status = RETURN;
                            step = null;
                            fail = null;
                        }
                }
                return canceler;
            };
        }
        function join(cb) {
            return function() {
                var canceler = onComplete({
                    rethrow: false,
                    handler: cb
                })();
                if (status === SUSPENDED) run(runTick);
                return canceler;
            };
        }
        return {
            kill: kill,
            join: join,
            onComplete: onComplete,
            isSuspended: function() {
                return status === SUSPENDED;
            },
            run: function() {
                if (status === SUSPENDED) {
                    if (!Scheduler.isDraining()) Scheduler.enqueue(function() {
                        run(runTick);
                    });
                    else run(runTick);
                }
            }
        };
    }
    function runPar(util, supervisor, par, cb) {
        // Table of all forked fibers.
        var fiberId = 0;
        var fibers = {};
        // Table of currently running cancelers, as a product of `Alt` behavior.
        var killId = 0;
        var kills = {};
        // Error used for early cancelation on Alt branches.
        var early = new Error("[ParAff] Early exit");
        // Error used to kill the entire tree.
        var interrupt = null;
        // The root pointer of the tree.
        var root = EMPTY;
        // Walks a tree, invoking all the cancelers. Returns the table of pending
        // cancellation fibers.
        function kill(error, par, cb) {
            var step = par;
            var head = null;
            var tail = null;
            var count = 0;
            var kills = {};
            var tmp, kid;
            loop: while(true){
                tmp = null;
                switch(step.tag){
                    case FORKED:
                        if (step._3 === EMPTY) {
                            tmp = fibers[step._1];
                            kills[count++] = tmp.kill(error, function(result) {
                                return function() {
                                    count--;
                                    if (count === 0) cb(result)();
                                };
                            });
                        }
                        // Terminal case.
                        if (head === null) break loop;
                        // Go down the right side of the tree.
                        step = head._2;
                        if (tail === null) head = null;
                        else {
                            head = tail._1;
                            tail = tail._2;
                        }
                        break;
                    case MAP:
                        step = step._2;
                        break;
                    case APPLY:
                    case ALT:
                        if (head) tail = new Aff(CONS, head, tail);
                        head = step;
                        step = step._1;
                        break;
                }
            }
            if (count === 0) cb(util.right(void 0))();
            else {
                // Run the cancelation effects. We alias `count` because it's mutable.
                kid = 0;
                tmp = count;
                for(; kid < tmp; kid++)kills[kid] = kills[kid]();
            }
            return kills;
        }
        // When a fiber resolves, we need to bubble back up the tree with the
        // result, computing the applicative nodes.
        function join(result, head, tail) {
            var fail, step, lhs, rhs, tmp, kid;
            if (util.isLeft(result)) {
                fail = result;
                step = null;
            } else {
                step = result;
                fail = null;
            }
            loop: while(true){
                lhs = null;
                rhs = null;
                tmp = null;
                kid = null;
                // We should never continue if the entire tree has been interrupted.
                if (interrupt !== null) return;
                // We've made it all the way to the root of the tree, which means
                // the tree has fully evaluated.
                if (head === null) {
                    cb(fail || step)();
                    return;
                }
                // The tree has already been computed, so we shouldn't try to do it
                // again. This should never happen.
                // TODO: Remove this?
                if (head._3 !== EMPTY) return;
                switch(head.tag){
                    case MAP:
                        if (fail === null) {
                            head._3 = util.right(head._1(util.fromRight(step)));
                            step = head._3;
                        } else head._3 = fail;
                        break;
                    case APPLY:
                        lhs = head._1._3;
                        rhs = head._2._3;
                        // If we have a failure we should kill the other side because we
                        // can't possible yield a result anymore.
                        if (fail) {
                            head._3 = fail;
                            tmp = true;
                            kid = killId++;
                            kills[kid] = kill(early, fail === lhs ? head._2 : head._1, function() {
                                return function() {
                                    delete kills[kid];
                                    if (tmp) tmp = false;
                                    else if (tail === null) join(fail, null, null);
                                    else join(fail, tail._1, tail._2);
                                };
                            });
                            if (tmp) {
                                tmp = false;
                                return;
                            }
                        } else if (lhs === EMPTY || rhs === EMPTY) // We can only proceed if both sides have resolved.
                        return;
                        else {
                            step = util.right(util.fromRight(lhs)(util.fromRight(rhs)));
                            head._3 = step;
                        }
                        break;
                    case ALT:
                        lhs = head._1._3;
                        rhs = head._2._3;
                        // We can only proceed if both have resolved or we have a success
                        if (lhs === EMPTY && util.isLeft(rhs) || rhs === EMPTY && util.isLeft(lhs)) return;
                        // If both sides resolve with an error, we should continue with the
                        // first error
                        if (lhs !== EMPTY && util.isLeft(lhs) && rhs !== EMPTY && util.isLeft(rhs)) {
                            fail = step === lhs ? rhs : lhs;
                            step = null;
                            head._3 = fail;
                        } else {
                            head._3 = step;
                            tmp = true;
                            kid = killId++;
                            // Once a side has resolved, we need to cancel the side that is still
                            // pending before we can continue.
                            kills[kid] = kill(early, step === lhs ? head._2 : head._1, function() {
                                return function() {
                                    delete kills[kid];
                                    if (tmp) tmp = false;
                                    else if (tail === null) join(step, null, null);
                                    else join(step, tail._1, tail._2);
                                };
                            });
                            if (tmp) {
                                tmp = false;
                                return;
                            }
                        }
                        break;
                }
                if (tail === null) head = null;
                else {
                    head = tail._1;
                    tail = tail._2;
                }
            }
        }
        function resolve(fiber) {
            return function(result) {
                return function() {
                    delete fibers[fiber._1];
                    fiber._3 = result;
                    join(result, fiber._2._1, fiber._2._2);
                };
            };
        }
        // Walks the applicative tree, substituting non-applicative nodes with
        // `FORKED` nodes. In this tree, all applicative nodes use the `_3` slot
        // as a mutable slot for memoization. In an unresolved state, the `_3`
        // slot is `EMPTY`. In the cases of `ALT` and `APPLY`, we always walk
        // the left side first, because both operations are left-associative. As
        // we `RETURN` from those branches, we then walk the right side.
        function run() {
            var status = CONTINUE;
            var step = par;
            var head = null;
            var tail = null;
            var tmp, fid;
            loop: while(true){
                tmp = null;
                fid = null;
                switch(status){
                    case CONTINUE:
                        switch(step.tag){
                            case MAP:
                                if (head) tail = new Aff(CONS, head, tail);
                                head = new Aff(MAP, step._1, EMPTY, EMPTY);
                                step = step._2;
                                break;
                            case APPLY:
                                if (head) tail = new Aff(CONS, head, tail);
                                head = new Aff(APPLY, EMPTY, step._2, EMPTY);
                                step = step._1;
                                break;
                            case ALT:
                                if (head) tail = new Aff(CONS, head, tail);
                                head = new Aff(ALT, EMPTY, step._2, EMPTY);
                                step = step._1;
                                break;
                            default:
                                // When we hit a leaf value, we suspend the stack in the `FORKED`.
                                // When the fiber resolves, it can bubble back up the tree.
                                fid = fiberId++;
                                status = RETURN;
                                tmp = step;
                                step = new Aff(FORKED, fid, new Aff(CONS, head, tail), EMPTY);
                                tmp = Fiber(util, supervisor, tmp);
                                tmp.onComplete({
                                    rethrow: false,
                                    handler: resolve(step)
                                })();
                                fibers[fid] = tmp;
                                if (supervisor) supervisor.register(tmp);
                        }
                        break;
                    case RETURN:
                        // Terminal case, we are back at the root.
                        if (head === null) break loop;
                        // If we are done with the right side, we need to continue down the
                        // left. Otherwise we should continue up the stack.
                        if (head._1 === EMPTY) {
                            head._1 = step;
                            status = CONTINUE;
                            step = head._2;
                            head._2 = EMPTY;
                        } else {
                            head._2 = step;
                            step = head;
                            if (tail === null) head = null;
                            else {
                                head = tail._1;
                                tail = tail._2;
                            }
                        }
                }
            }
            // Keep a reference to the tree root so it can be cancelled.
            root = step;
            for(fid = 0; fid < fiberId; fid++)fibers[fid].run();
        }
        // Cancels the entire tree. If there are already subtrees being canceled,
        // we need to first cancel those joins. We will then add fresh joins for
        // all pending branches including those that were in the process of being
        // canceled.
        function cancel(error, cb) {
            interrupt = util.left(error);
            var innerKills;
            for(var kid in kills)if (kills.hasOwnProperty(kid)) {
                innerKills = kills[kid];
                for(kid in innerKills)if (innerKills.hasOwnProperty(kid)) innerKills[kid]();
            }
            kills = null;
            var newKills = kill(error, root, cb);
            return function(killError) {
                return new Aff(ASYNC, function(killCb) {
                    return function() {
                        for(var kid in newKills)if (newKills.hasOwnProperty(kid)) newKills[kid]();
                        return nonCanceler;
                    };
                });
            };
        }
        run();
        return function(killError) {
            return new Aff(ASYNC, function(killCb) {
                return function() {
                    return cancel(killError, killCb);
                };
            });
        };
    }
    function sequential(util, supervisor, par) {
        return new Aff(ASYNC, function(cb) {
            return function() {
                return runPar(util, supervisor, par, cb);
            };
        });
    }
    Aff.EMPTY = EMPTY;
    Aff.Pure = AffCtr(PURE);
    Aff.Throw = AffCtr(THROW);
    Aff.Catch = AffCtr(CATCH);
    Aff.Sync = AffCtr(SYNC);
    Aff.Async = AffCtr(ASYNC);
    Aff.Bind = AffCtr(BIND);
    Aff.Bracket = AffCtr(BRACKET);
    Aff.Fork = AffCtr(FORK);
    Aff.Seq = AffCtr(SEQ);
    Aff.ParMap = AffCtr(MAP);
    Aff.ParApply = AffCtr(APPLY);
    Aff.ParAlt = AffCtr(ALT);
    Aff.Fiber = Fiber;
    Aff.Supervisor = Supervisor;
    Aff.Scheduler = Scheduler;
    Aff.nonCanceler = nonCanceler;
    return Aff;
}();
const $b28443a27438717a$export$68c6660df485915b = $b28443a27438717a$var$Aff.Pure;
const $b28443a27438717a$export$520252a01094c36e = $b28443a27438717a$var$Aff.Throw;
function $b28443a27438717a$export$eb5e86cd5464556e(aff) {
    return function(k) {
        return $b28443a27438717a$var$Aff.Catch(aff, k);
    };
}
function $b28443a27438717a$export$a0135aecf4a782ab(f) {
    return function(aff) {
        if (aff.tag === $b28443a27438717a$var$Aff.Pure.tag) return $b28443a27438717a$var$Aff.Pure(f(aff._1));
        else return $b28443a27438717a$var$Aff.Bind(aff, function(value) {
            return $b28443a27438717a$var$Aff.Pure(f(value));
        });
    };
}
function $b28443a27438717a$export$8fe95d71d8c6b6f3(aff) {
    return function(k) {
        return $b28443a27438717a$var$Aff.Bind(aff, k);
    };
}
function $b28443a27438717a$export$f97e7884af471963(immediate) {
    return function(aff) {
        return $b28443a27438717a$var$Aff.Fork(immediate, aff);
    };
}
const $b28443a27438717a$export$3c6532f01a0290eb = $b28443a27438717a$var$Aff.Sync;
function $b28443a27438717a$export$68695d37eb163711(f) {
    return function(aff) {
        return $b28443a27438717a$var$Aff.ParMap(f, aff);
    };
}
function $b28443a27438717a$export$bce00526579b3344(aff1) {
    return function(aff2) {
        return $b28443a27438717a$var$Aff.ParApply(aff1, aff2);
    };
}
function $b28443a27438717a$export$6a44b66c7edadaa(aff1) {
    return function(aff2) {
        return $b28443a27438717a$var$Aff.ParAlt(aff1, aff2);
    };
}
const $b28443a27438717a$export$49d5975414e0a979 = $b28443a27438717a$var$Aff.Async;
function $b28443a27438717a$export$9ad792f02752f447(acquire) {
    return function(options) {
        return function(k) {
            return $b28443a27438717a$var$Aff.Bracket(acquire, options, k);
        };
    };
}
function $b28443a27438717a$export$f24188c8fd3f1234(util, aff) {
    return function() {
        return $b28443a27438717a$var$Aff.Fiber(util, null, aff);
    };
}
function $b28443a27438717a$export$7a3baea9562462c7(util, aff) {
    return function() {
        var supervisor = $b28443a27438717a$var$Aff.Supervisor(util);
        return {
            fiber: $b28443a27438717a$var$Aff.Fiber(util, supervisor, aff),
            supervisor: supervisor
        };
    };
}
function $b28443a27438717a$export$a494cc11bfc0c750(error, supervisor, cb) {
    return supervisor.killAll(error, cb);
}
const $b28443a27438717a$export$389c1406f5ae6ae7 = function() {
    function setDelay(n, k) {
        if (n === 0 && typeof setImmediate !== "undefined") return setImmediate(k);
        else return setTimeout(k, n);
    }
    function clearDelay(n, t) {
        if (n === 0 && typeof clearImmediate !== "undefined") return clearImmediate(t);
        else return clearTimeout(t);
    }
    return function(right, ms) {
        return $b28443a27438717a$var$Aff.Async(function(cb) {
            return function() {
                var timer = setDelay(ms, cb(right()));
                return function() {
                    return $b28443a27438717a$var$Aff.Sync(function() {
                        return right(clearDelay(ms, timer));
                    });
                };
            };
        });
    };
}();
const $b28443a27438717a$export$139486a45824a247 = $b28443a27438717a$var$Aff.Seq;

});

parcelRegister("4A3Wv", function(module, exports) {

$parcel$export(module.exports, "parSequence_", () => $355d9520a1199e68$export$a907a2b4fd85b16b);
// Generated by purs version 0.15.16

var $a5g3C = parcelRequire("a5g3C");

var $7T8P4 = parcelRequire("7T8P4");

var $bvHbv = parcelRequire("bvHbv");

var $6RkEA = parcelRequire("6RkEA");

var $1wR1l = parcelRequire("1wR1l");
var $355d9520a1199e68$var$identity = /* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn);
var $355d9520a1199e68$export$3b8cfe43eb195e1d = function(dictParallel) {
    var sequential = $bvHbv.sequential(dictParallel);
    var parallel = $bvHbv.parallel(dictParallel);
    return function(dictApplicative) {
        var traverse_ = $6RkEA.traverse_(dictApplicative);
        return function(dictFoldable) {
            var traverse_1 = traverse_(dictFoldable);
            return function(f) {
                var $51 = traverse_1(function($53) {
                    return parallel(f($53));
                });
                return function($52) {
                    return sequential($51($52));
                };
            };
        };
    };
};
var $355d9520a1199e68$export$bb703a54931a70b6 = function(dictParallel) {
    var sequential = $bvHbv.sequential(dictParallel);
    var parallel = $bvHbv.parallel(dictParallel);
    return function(dictApplicative) {
        return function(dictTraversable) {
            var traverse = $1wR1l.traverse(dictTraversable)(dictApplicative);
            return function(f) {
                var $54 = traverse(function($56) {
                    return parallel(f($56));
                });
                return function($55) {
                    return sequential($54($55));
                };
            };
        };
    };
};
var $355d9520a1199e68$export$a907a2b4fd85b16b = function(dictParallel) {
    var parTraverse_1 = $355d9520a1199e68$export$3b8cfe43eb195e1d(dictParallel);
    return function(dictApplicative) {
        var parTraverse_2 = parTraverse_1(dictApplicative);
        return function(dictFoldable) {
            return parTraverse_2(dictFoldable)($355d9520a1199e68$var$identity);
        };
    };
};
var $355d9520a1199e68$export$b9becc45c388432c = function(dictParallel) {
    var parTraverse1 = $355d9520a1199e68$export$bb703a54931a70b6(dictParallel);
    return function(dictApplicative) {
        var parTraverse2 = parTraverse1(dictApplicative);
        return function(dictTraversable) {
            return parTraverse2(dictTraversable)($355d9520a1199e68$var$identity);
        };
    };
};
var $355d9520a1199e68$export$a82aaa9906cdb569 = function(dictParallel) {
    var sequential = $bvHbv.sequential(dictParallel);
    var parallel = $bvHbv.parallel(dictParallel);
    return function(dictAlternative) {
        var Plus1 = dictAlternative.Plus1();
        return function(dictFoldable) {
            var oneOfMap = $6RkEA.oneOfMap(dictFoldable)(Plus1);
            return function(dictFunctor) {
                return function(f) {
                    var $57 = oneOfMap(function($59) {
                        return parallel(f($59));
                    });
                    return function($58) {
                        return sequential($57($58));
                    };
                };
            };
        };
    };
};
var $355d9520a1199e68$export$70e1ad49970879b5 = function(dictParallel) {
    var sequential = $bvHbv.sequential(dictParallel);
    var parallel = $bvHbv.parallel(dictParallel);
    return function(dictAlternative) {
        var Plus1 = dictAlternative.Plus1();
        return function(dictFoldable) {
            var oneOfMap = $6RkEA.oneOfMap(dictFoldable)(Plus1);
            return function(dictFunctor) {
                var $60 = oneOfMap(parallel);
                return function($61) {
                    return sequential($60($61));
                };
            };
        };
    };
};
var $355d9520a1199e68$export$3d88e33b68f7b8a5 = function(dictParallel) {
    var sequential = $bvHbv.sequential(dictParallel);
    var apply = $a5g3C.apply(dictParallel.Apply1());
    var parallel = $bvHbv.parallel(dictParallel);
    return function(mf) {
        return function(ma) {
            return sequential(apply(parallel(mf))(parallel(ma)));
        };
    };
};

});
parcelRegister("bvHbv", function(module, exports) {

$parcel$export(module.exports, "sequential", () => $86141680556a7436$export$3c7b24ce1c81e349);
$parcel$export(module.exports, "parallel", () => $86141680556a7436$export$451942af9381149c);
// Generated by purs version 0.15.16

var $gUTA8 = parcelRequire("gUTA8");

var $9Grh5 = parcelRequire("9Grh5");

var $lGPnP = parcelRequire("lGPnP");

var $i2F6a = parcelRequire("i2F6a");

var $9DlYk = parcelRequire("9DlYk");

var $bnrVm = parcelRequire("bnrVm");

var $iI3r9 = parcelRequire("iI3r9");

var $aKY4H = parcelRequire("aKY4H");

var $l0wDR = parcelRequire("l0wDR");

var $8gI0w = parcelRequire("8gI0w");

var $fCGwn = parcelRequire("fCGwn");

var $ykHdR = parcelRequire("ykHdR");

var $9zd3I = parcelRequire("9zd3I");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");

var $kQlZ1 = parcelRequire("kQlZ1");

var $cnyA5 = parcelRequire("cnyA5");
var $jFEU8 = parcelRequire("jFEU8");
var $86141680556a7436$var$discard = /* #__PURE__ */ $9Grh5.discard($9Grh5.discardUnit);
var $86141680556a7436$export$e97768dcd3ffe6df = function(x) {
    return x;
};
var $86141680556a7436$export$3c7b24ce1c81e349 = function(dict) {
    return dict.sequential;
};
var $86141680556a7436$export$451942af9381149c = function(dict) {
    return dict.parallel;
};
var $86141680556a7436$export$ddc88912bc863338 = {
    Coercible0: function() {
        return undefined;
    }
};
var $86141680556a7436$export$76ad2e05fec13cc8 = function(dictMonoid) {
    var applyWriterT = $iI3r9.applyWriterT(dictMonoid.Semigroup0());
    return function(dictParallel) {
        var applyWriterT1 = applyWriterT(dictParallel.Apply0());
        var applyWriterT2 = applyWriterT(dictParallel.Apply1());
        return {
            parallel: $iI3r9.mapWriterT($86141680556a7436$export$451942af9381149c(dictParallel)),
            sequential: $iI3r9.mapWriterT($86141680556a7436$export$3c7b24ce1c81e349(dictParallel)),
            Apply0: function() {
                return applyWriterT1;
            },
            Apply1: function() {
                return applyWriterT2;
            }
        };
    };
};
var $86141680556a7436$export$48c6c5bbf7c98dc9 = function(dictParallel) {
    var parallel1 = $86141680556a7436$export$451942af9381149c(dictParallel);
    var sequential1 = $86141680556a7436$export$3c7b24ce1c81e349(dictParallel);
    var applyStar = $9zd3I.applyStar(dictParallel.Apply0());
    var applyStar1 = $9zd3I.applyStar(dictParallel.Apply1());
    return {
        parallel: function(v) {
            return function($124) {
                return parallel1(v($124));
            };
        },
        sequential: function(v) {
            return function($125) {
                return sequential1(v($125));
            };
        },
        Apply0: function() {
            return applyStar;
        },
        Apply1: function() {
            return applyStar1;
        }
    };
};
var $86141680556a7436$export$cfbddc4e0911f419 = function(dictParallel) {
    var applyReaderT = $bnrVm.applyReaderT(dictParallel.Apply0());
    var applyReaderT1 = $bnrVm.applyReaderT(dictParallel.Apply1());
    return {
        parallel: $bnrVm.mapReaderT($86141680556a7436$export$451942af9381149c(dictParallel)),
        sequential: $bnrVm.mapReaderT($86141680556a7436$export$3c7b24ce1c81e349(dictParallel)),
        Apply0: function() {
            return applyReaderT;
        },
        Apply1: function() {
            return applyReaderT1;
        }
    };
};
var $86141680556a7436$export$31d7210ae04b04da = function(dictParallel) {
    var parallel1 = $86141680556a7436$export$451942af9381149c(dictParallel);
    var sequential1 = $86141680556a7436$export$3c7b24ce1c81e349(dictParallel);
    var applyCompose = $8gI0w.applyCompose(dictParallel.Apply1())($ykHdR.applyMaybe);
    return function(dictMonad) {
        var applyMaybeT = $9DlYk.applyMaybeT(dictMonad);
        return {
            parallel: function(v) {
                return parallel1(v);
            },
            sequential: function(v) {
                return sequential1(v);
            },
            Apply0: function() {
                return applyMaybeT;
            },
            Apply1: function() {
                return applyCompose;
            }
        };
    };
};
var $86141680556a7436$export$29ed81e6361e826b = function(dictParallel) {
    var parallel1 = $86141680556a7436$export$451942af9381149c(dictParallel);
    var sequential1 = $86141680556a7436$export$3c7b24ce1c81e349(dictParallel);
    var applyCompose = $8gI0w.applyCompose(dictParallel.Apply1())($aKY4H.applyEither);
    return function(dictMonad) {
        var applyExceptT = $i2F6a.applyExceptT(dictMonad);
        return {
            parallel: function(v) {
                return parallel1(v);
            },
            sequential: function(v) {
                return sequential1(v);
            },
            Apply0: function() {
                return applyExceptT;
            },
            Apply1: function() {
                return applyCompose;
            }
        };
    };
};
var $86141680556a7436$export$36431f0cd2fca0df = function(dictParallel) {
    var sequential1 = $86141680556a7436$export$3c7b24ce1c81e349(dictParallel);
    var parallel1 = $86141680556a7436$export$451942af9381149c(dictParallel);
    return {
        parallel: function(v) {
            return function($126) {
                return v(sequential1($126));
            };
        },
        sequential: function(v) {
            return function($127) {
                return v(parallel1($127));
            };
        },
        Apply0: function() {
            return $fCGwn.applyCostar;
        },
        Apply1: function() {
            return $fCGwn.applyCostar;
        }
    };
};
var $86141680556a7436$export$aecfbd788a6caa47 = function(dictMonadEffect) {
    var applyContT = $lGPnP.applyContT(dictMonadEffect.Monad0().Bind1().Apply0());
    return {
        parallel: $86141680556a7436$export$e97768dcd3ffe6df,
        sequential: function(v) {
            return v;
        },
        Apply0: function() {
            return applyContT;
        },
        Apply1: function() {
            return $86141680556a7436$export$803a06b7a7e59726(dictMonadEffect);
        }
    };
};
var $86141680556a7436$export$bf3675a1b3711367 = function(dictMonadEffect) {
    var map = $l0wDR.map($lGPnP.functorContT(dictMonadEffect.Monad0().Bind1().Apply0().Functor0()));
    return {
        map: function(f) {
            var $128 = $86141680556a7436$export$451942af9381149c($86141680556a7436$export$aecfbd788a6caa47(dictMonadEffect));
            var $129 = map(f);
            var $130 = $86141680556a7436$export$3c7b24ce1c81e349($86141680556a7436$export$aecfbd788a6caa47(dictMonadEffect));
            return function($131) {
                return $128($129($130($131)));
            };
        }
    };
};
var $86141680556a7436$export$803a06b7a7e59726 = function(dictMonadEffect) {
    var Bind1 = dictMonadEffect.Monad0().Bind1();
    var bind = $9Grh5.bind(Bind1);
    var liftEffect = $kQlZ1.liftEffect(dictMonadEffect);
    var discard1 = $86141680556a7436$var$discard(Bind1);
    return {
        apply: function(v) {
            return function(v1) {
                return function(k) {
                    return bind(liftEffect($cnyA5.new($ykHdR.Nothing.value)))(function(ra) {
                        return bind(liftEffect($cnyA5.new($ykHdR.Nothing.value)))(function(rb) {
                            return discard1($lGPnP.runContT(v)(function(a) {
                                return bind(liftEffect($jFEU8.read(rb)))(function(mb) {
                                    if (mb instanceof $ykHdR.Nothing) return liftEffect($jFEU8.write(new $ykHdR.Just(a))(ra));
                                    if (mb instanceof $ykHdR.Just) return k(a(mb.value0));
                                    throw new Error("Failed pattern match at Control.Parallel.Class (line 83, column 7 - line 85, column 26): " + [
                                        mb.constructor.name
                                    ]);
                                });
                            }))(function() {
                                return $lGPnP.runContT(v1)(function(b) {
                                    return bind(liftEffect($jFEU8.read(ra)))(function(ma) {
                                        if (ma instanceof $ykHdR.Nothing) return liftEffect($jFEU8.write(new $ykHdR.Just(b))(rb));
                                        if (ma instanceof $ykHdR.Just) return k(ma.value0(b));
                                        throw new Error("Failed pattern match at Control.Parallel.Class (line 89, column 7 - line 91, column 26): " + [
                                            ma.constructor.name
                                        ]);
                                    });
                                });
                            });
                        });
                    });
                };
            };
        },
        Functor0: function() {
            return $86141680556a7436$export$bf3675a1b3711367(dictMonadEffect);
        }
    };
};
var $86141680556a7436$export$5823fd8d45c99450 = function(dictMonadEffect) {
    var applyParCont1 = $86141680556a7436$export$803a06b7a7e59726(dictMonadEffect);
    return {
        pure: function() {
            var $132 = $86141680556a7436$export$451942af9381149c($86141680556a7436$export$aecfbd788a6caa47(dictMonadEffect));
            var $133 = $gUTA8.pure($lGPnP.applicativeContT(dictMonadEffect.Monad0().Applicative0()));
            return function($134) {
                return $132($133($134));
            };
        }(),
        Apply0: function() {
            return applyParCont1;
        }
    };
};
var $86141680556a7436$export$e02ea57753bb8483 = function(dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var Bind1 = Monad0.Bind1();
    var bind = $9Grh5.bind(Bind1);
    var liftEffect = $kQlZ1.liftEffect(dictMonadEffect);
    var discard1 = $86141680556a7436$var$discard(Bind1);
    var pure = $gUTA8.pure(Monad0.Applicative0());
    var functorParCont1 = $86141680556a7436$export$bf3675a1b3711367(dictMonadEffect);
    return {
        alt: function(v) {
            return function(v1) {
                return function(k) {
                    return bind(liftEffect($cnyA5.new(false)))(function(done) {
                        return discard1($lGPnP.runContT(v)(function(a) {
                            return bind(liftEffect($jFEU8.read(done)))(function(b) {
                                if (b) return pure($r2HHk.unit);
                                return discard1(liftEffect($jFEU8.write(true)(done)))(function() {
                                    return k(a);
                                });
                            });
                        }))(function() {
                            return $lGPnP.runContT(v1)(function(a) {
                                return bind(liftEffect($jFEU8.read(done)))(function(b) {
                                    if (b) return pure($r2HHk.unit);
                                    return discard1(liftEffect($jFEU8.write(true)(done)))(function() {
                                        return k(a);
                                    });
                                });
                            });
                        });
                    });
                };
            };
        },
        Functor0: function() {
            return functorParCont1;
        }
    };
};
var $86141680556a7436$export$eed929a02bcaa239 = function(dictMonadEffect) {
    var pure = $gUTA8.pure(dictMonadEffect.Monad0().Applicative0());
    var altParCont1 = $86141680556a7436$export$e02ea57753bb8483(dictMonadEffect);
    return {
        empty: function(v) {
            return pure($r2HHk.unit);
        },
        Alt0: function() {
            return altParCont1;
        }
    };
};
var $86141680556a7436$export$2e55be12f6c16793 = function(dictMonadEffect) {
    var applicativeParCont1 = $86141680556a7436$export$5823fd8d45c99450(dictMonadEffect);
    var plusParCont1 = $86141680556a7436$export$eed929a02bcaa239(dictMonadEffect);
    return {
        Applicative0: function() {
            return applicativeParCont1;
        },
        Plus1: function() {
            return plusParCont1;
        }
    };
};

});
parcelRegister("fCGwn", function(module, exports) {

$parcel$export(module.exports, "applyCostar", () => $b5fb63758051b147$export$bee433edbc7aed34);
// Generated by purs version 0.15.16

var $frF73 = parcelRequire("frF73");

var $hfMWE = parcelRequire("hfMWE");

var $5ecNO = parcelRequire("5ecNO");

var $l0wDR = parcelRequire("l0wDR");

var $hVi1M = parcelRequire("hVi1M");

var $5hqdn = parcelRequire("5hqdn");

var $dnKRS = parcelRequire("dnKRS");

var $9MxTl = parcelRequire("9MxTl");
var $b5fb63758051b147$var$lcmap = /* #__PURE__ */ $dnKRS.lcmap($dnKRS.profunctorFn);
var $b5fb63758051b147$export$c8d61c7aefcd2eb9 = function(x) {
    return x;
};
var $b5fb63758051b147$export$4b8724da343f8670 = function(dictExtend) {
    var composeCoKleisliFlipped = $hfMWE.composeCoKleisliFlipped(dictExtend);
    return {
        compose: function(v) {
            return function(v1) {
                return composeCoKleisliFlipped(v)(v1);
            };
        }
    };
};
var $b5fb63758051b147$export$7c2608c347081d34 = function(dictFunctor) {
    var map = $l0wDR.map(dictFunctor);
    return {
        dimap: function(f) {
            return function(g) {
                return function(v) {
                    var $65 = map(f);
                    return function($66) {
                        return g(v($65($66)));
                    };
                };
            };
        }
    };
};
var $b5fb63758051b147$export$1b28cf6e14cef765 = function(dictComonad) {
    var Functor0 = dictComonad.Extend0().Functor0();
    var map = $l0wDR.map(Functor0);
    var extract = $frF73.extract(dictComonad);
    var profunctorCostar1 = $b5fb63758051b147$export$7c2608c347081d34(Functor0);
    return {
        first: function(v) {
            return function(x) {
                return new $9MxTl.Tuple(v(map($9MxTl.fst)(x)), $9MxTl.snd(extract(x)));
            };
        },
        second: function(v) {
            return function(x) {
                return new $9MxTl.Tuple($9MxTl.fst(extract(x)), v(map($9MxTl.snd)(x)));
            };
        },
        Profunctor0: function() {
            return profunctorCostar1;
        }
    };
};
var $b5fb63758051b147$export$95b15c3b108c70f1 = {
    Coercible0: function() {
        return undefined;
    }
};
var $b5fb63758051b147$export$538b19297a2c28a0 = function(f) {
    return function(v) {
        return $b5fb63758051b147$var$lcmap(f)(v);
    };
};
var $b5fb63758051b147$export$85082d7f68510c56 = {
    map: function(f) {
        return function(v) {
            return function($67) {
                return f(v($67));
            };
        };
    }
};
var $b5fb63758051b147$export$c2eec9047e1c22f6 = {
    imap: /* #__PURE__ */ $5hqdn.imapF($b5fb63758051b147$export$85082d7f68510c56)
};
var $b5fb63758051b147$export$6ca61216e8ebd2dc = {
    distribute: function(dictFunctor) {
        var map = $l0wDR.map(dictFunctor);
        return function(f) {
            return function(a) {
                return map(function(v) {
                    return v(a);
                })(f);
            };
        };
    },
    collect: function(dictFunctor) {
        var map = $l0wDR.map(dictFunctor);
        return function(f) {
            var $68 = $5ecNO.distribute($b5fb63758051b147$export$6ca61216e8ebd2dc)(dictFunctor);
            var $69 = map(f);
            return function($70) {
                return $68($69($70));
            };
        };
    },
    Functor0: function() {
        return $b5fb63758051b147$export$85082d7f68510c56;
    }
};
var $b5fb63758051b147$export$45296f90ce78a5aa = function(dictFunctor) {
    var map = $l0wDR.map(dictFunctor);
    var profunctorCostar1 = $b5fb63758051b147$export$7c2608c347081d34(dictFunctor);
    return {
        closed: function(v) {
            return function(g) {
                return function(x) {
                    return v(map(function(v1) {
                        return v1(x);
                    })(g));
                };
            };
        },
        Profunctor0: function() {
            return profunctorCostar1;
        }
    };
};
var $b5fb63758051b147$export$1b18a904dcda2b6c = function(dictComonad) {
    var semigroupoidCostar1 = $b5fb63758051b147$export$4b8724da343f8670(dictComonad.Extend0());
    return {
        identity: $frF73.extract(dictComonad),
        Semigroupoid0: function() {
            return semigroupoidCostar1;
        }
    };
};
var $b5fb63758051b147$export$12684125bae58283 = function(dictContravariant) {
    var cmap = $hVi1M.cmap(dictContravariant);
    return {
        bimap: function(f) {
            return function(g) {
                return function(v) {
                    var $71 = cmap(f);
                    return function($72) {
                        return g(v($71($72)));
                    };
                };
            };
        }
    };
};
var $b5fb63758051b147$export$bee433edbc7aed34 = {
    apply: function(v) {
        return function(v1) {
            return function(a) {
                return v(a)(v1(a));
            };
        };
    },
    Functor0: function() {
        return $b5fb63758051b147$export$85082d7f68510c56;
    }
};
var $b5fb63758051b147$export$9af761d291db49ef = {
    bind: function(v) {
        return function(f) {
            return function(x) {
                var v1 = f(v(x));
                return v1(x);
            };
        };
    },
    Apply0: function() {
        return $b5fb63758051b147$export$bee433edbc7aed34;
    }
};
var $b5fb63758051b147$export$ddef3771953a3c3c = {
    pure: function(a) {
        return function(v) {
            return a;
        };
    },
    Apply0: function() {
        return $b5fb63758051b147$export$bee433edbc7aed34;
    }
};
var $b5fb63758051b147$export$88fc0f5d12a9e446 = {
    Applicative0: function() {
        return $b5fb63758051b147$export$ddef3771953a3c3c;
    },
    Bind1: function() {
        return $b5fb63758051b147$export$9af761d291db49ef;
    }
};

});

parcelRegister("9zd3I", function(module, exports) {

$parcel$export(module.exports, "applyStar", () => $6f71832c0f0d3a5b$export$3a827cf342dc199f);
// Generated by purs version 0.15.16

var $a7Dxq = parcelRequire("a7Dxq");

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $9Grh5 = parcelRequire("9Grh5");

var $axmEP = parcelRequire("axmEP");

var $5ecNO = parcelRequire("5ecNO");

var $aKY4H = parcelRequire("aKY4H");

var $l0wDR = parcelRequire("l0wDR");

var $5hqdn = parcelRequire("5hqdn");

var $9MxTl = parcelRequire("9MxTl");
var $6f71832c0f0d3a5b$export$1644ba17714857f1 = function(x) {
    return x;
};
var $6f71832c0f0d3a5b$export$5c32215407d0c561 = function(dictBind) {
    var bind = $9Grh5.bind(dictBind);
    return {
        compose: function(v) {
            return function(v1) {
                return function(x) {
                    return bind(v1(x))(v);
                };
            };
        }
    };
};
var $6f71832c0f0d3a5b$export$a1c7b121a12f67f7 = function(dictFunctor) {
    var map = $l0wDR.map(dictFunctor);
    return {
        dimap: function(f) {
            return function(g) {
                return function(v) {
                    var $127 = map(g);
                    return function($128) {
                        return $127(v(f($128)));
                    };
                };
            };
        }
    };
};
var $6f71832c0f0d3a5b$export$1bd208d997e69566 = function(dictFunctor) {
    var map = $l0wDR.map(dictFunctor);
    var profunctorStar1 = $6f71832c0f0d3a5b$export$a1c7b121a12f67f7(dictFunctor);
    return {
        first: function(v) {
            return function(v1) {
                return map(function(v2) {
                    return new $9MxTl.Tuple(v2, v1.value1);
                })(v(v1.value0));
            };
        },
        second: function(v) {
            return function(v1) {
                return map($9MxTl.Tuple.create(v1.value0))(v(v1.value1));
            };
        },
        Profunctor0: function() {
            return profunctorStar1;
        }
    };
};
var $6f71832c0f0d3a5b$export$5646bceeba0ed2e7 = {
    Coercible0: function() {
        return undefined;
    }
};
var $6f71832c0f0d3a5b$export$8ba4b27aef989a18 = function(dictInvariant) {
    var imap = $5hqdn.imap(dictInvariant);
    return {
        imap: function(f) {
            return function(g) {
                return function(v) {
                    var $129 = imap(f)(g);
                    return function($130) {
                        return $129(v($130));
                    };
                };
            };
        }
    };
};
var $6f71832c0f0d3a5b$export$e7b43b239cd8e22a = function(f) {
    return function(v) {
        return function($131) {
            return f(v($131));
        };
    };
};
var $6f71832c0f0d3a5b$export$a72d0b1c26a6fe63 = function(dictFunctor) {
    var map = $l0wDR.map(dictFunctor);
    return {
        map: function(f) {
            return function(v) {
                var $132 = map(f);
                return function($133) {
                    return $132(v($133));
                };
            };
        }
    };
};
var $6f71832c0f0d3a5b$export$8e00b62431cd4eb7 = function(dictDistributive) {
    var collect = $5ecNO.collect(dictDistributive);
    var functorStar1 = $6f71832c0f0d3a5b$export$a72d0b1c26a6fe63(dictDistributive.Functor0());
    return {
        distribute: function(dictFunctor) {
            var collect1 = collect(dictFunctor);
            return function(f) {
                return function(a) {
                    return collect1(function(v) {
                        return v(a);
                    })(f);
                };
            };
        },
        collect: function(dictFunctor) {
            var map = $l0wDR.map(dictFunctor);
            return function(f) {
                var $134 = $5ecNO.distribute($6f71832c0f0d3a5b$export$8e00b62431cd4eb7(dictDistributive))(dictFunctor);
                var $135 = map(f);
                return function($136) {
                    return $134($135($136));
                };
            };
        },
        Functor0: function() {
            return functorStar1;
        }
    };
};
var $6f71832c0f0d3a5b$export$ee38dceaf1b0a7c1 = function(dictDistributive) {
    var distribute = $5ecNO.distribute(dictDistributive)($l0wDR.functorFn);
    var profunctorStar1 = $6f71832c0f0d3a5b$export$a1c7b121a12f67f7(dictDistributive.Functor0());
    return {
        closed: function(v) {
            return function(g) {
                return distribute(function($137) {
                    return v(g($137));
                });
            };
        },
        Profunctor0: function() {
            return profunctorStar1;
        }
    };
};
var $6f71832c0f0d3a5b$export$9b633f3f90080760 = function(dictApplicative) {
    var Functor0 = dictApplicative.Apply0().Functor0();
    var map = $l0wDR.map(Functor0);
    var pure = $gUTA8.pure(dictApplicative);
    var profunctorStar1 = $6f71832c0f0d3a5b$export$a1c7b121a12f67f7(Functor0);
    return {
        left: function(v) {
            return $aKY4H.either(function() {
                var $138 = map($aKY4H.Left.create);
                return function($139) {
                    return $138(v($139));
                };
            }())(function($140) {
                return pure($aKY4H.Right.create($140));
            });
        },
        right: function(v) {
            return $aKY4H.either(function($141) {
                return pure($aKY4H.Left.create($141));
            })(function() {
                var $142 = map($aKY4H.Right.create);
                return function($143) {
                    return $142(v($143));
                };
            }());
        },
        Profunctor0: function() {
            return profunctorStar1;
        }
    };
};
var $6f71832c0f0d3a5b$export$2315b5444b191e9f = function(dictMonad) {
    var semigroupoidStar1 = $6f71832c0f0d3a5b$export$5c32215407d0c561(dictMonad.Bind1());
    return {
        identity: $gUTA8.pure(dictMonad.Applicative0()),
        Semigroupoid0: function() {
            return semigroupoidStar1;
        }
    };
};
var $6f71832c0f0d3a5b$export$3a827cf342dc199f = function(dictApply) {
    var apply = $a5g3C.apply(dictApply);
    var functorStar1 = $6f71832c0f0d3a5b$export$a72d0b1c26a6fe63(dictApply.Functor0());
    return {
        apply: function(v) {
            return function(v1) {
                return function(a) {
                    return apply(v(a))(v1(a));
                };
            };
        },
        Functor0: function() {
            return functorStar1;
        }
    };
};
var $6f71832c0f0d3a5b$export$a9fd453e55672cc4 = function(dictBind) {
    var bind = $9Grh5.bind(dictBind);
    var applyStar1 = $6f71832c0f0d3a5b$export$3a827cf342dc199f(dictBind.Apply0());
    return {
        bind: function(v) {
            return function(f) {
                return function(x) {
                    return bind(v(x))(function(a) {
                        var v1 = f(a);
                        return v1(x);
                    });
                };
            };
        },
        Apply0: function() {
            return applyStar1;
        }
    };
};
var $6f71832c0f0d3a5b$export$7a1642fc72453036 = function(dictApplicative) {
    var pure = $gUTA8.pure(dictApplicative);
    var applyStar1 = $6f71832c0f0d3a5b$export$3a827cf342dc199f(dictApplicative.Apply0());
    return {
        pure: function(a) {
            return function(v) {
                return pure(a);
            };
        },
        Apply0: function() {
            return applyStar1;
        }
    };
};
var $6f71832c0f0d3a5b$export$be30334ea1d81019 = function(dictMonad) {
    var applicativeStar1 = $6f71832c0f0d3a5b$export$7a1642fc72453036(dictMonad.Applicative0());
    var bindStar1 = $6f71832c0f0d3a5b$export$a9fd453e55672cc4(dictMonad.Bind1());
    return {
        Applicative0: function() {
            return applicativeStar1;
        },
        Bind1: function() {
            return bindStar1;
        }
    };
};
var $6f71832c0f0d3a5b$export$35f44c8ce889b889 = function(dictAlt) {
    var alt = $a7Dxq.alt(dictAlt);
    var functorStar1 = $6f71832c0f0d3a5b$export$a72d0b1c26a6fe63(dictAlt.Functor0());
    return {
        alt: function(v) {
            return function(v1) {
                return function(a) {
                    return alt(v(a))(v1(a));
                };
            };
        },
        Functor0: function() {
            return functorStar1;
        }
    };
};
var $6f71832c0f0d3a5b$export$a37a0eff981675fc = function(dictPlus) {
    var empty = $axmEP.empty(dictPlus);
    var altStar1 = $6f71832c0f0d3a5b$export$35f44c8ce889b889(dictPlus.Alt0());
    return {
        empty: function(v) {
            return empty;
        },
        Alt0: function() {
            return altStar1;
        }
    };
};
var $6f71832c0f0d3a5b$export$b508333aabf9ba3d = function(dictAlternative) {
    var applicativeStar1 = $6f71832c0f0d3a5b$export$7a1642fc72453036(dictAlternative.Applicative0());
    var plusStar1 = $6f71832c0f0d3a5b$export$a37a0eff981675fc(dictAlternative.Plus1());
    return {
        Applicative0: function() {
            return applicativeStar1;
        },
        Plus1: function() {
            return plusStar1;
        }
    };
};
var $6f71832c0f0d3a5b$export$7fe0d763dfe145d = function(dictMonadPlus) {
    var monadStar1 = $6f71832c0f0d3a5b$export$be30334ea1d81019(dictMonadPlus.Monad0());
    var alternativeStar1 = $6f71832c0f0d3a5b$export$b508333aabf9ba3d(dictMonadPlus.Alternative1());
    return {
        Monad0: function() {
            return monadStar1;
        },
        Alternative1: function() {
            return alternativeStar1;
        }
    };
};

});



parcelRegister("5b8Gl", function(module, exports) {
// Generated by purs version 0.15.16

var $7T8P4 = parcelRequire("7T8P4");

var $4MBcA = parcelRequire("4MBcA");

var $6PW1p = parcelRequire("6PW1p");

var $d0PPW = parcelRequire("d0PPW");

var $hTcAb = parcelRequire("hTcAb");

var $3Orkn = parcelRequire("3Orkn");
var $3c54b6e6d30cc3be$var$show = /* #__PURE__ */ $3Orkn.show($3Orkn.showNumber);
var $3c54b6e6d30cc3be$var$over = /* #__PURE__ */ $6PW1p.over()();
var $3c54b6e6d30cc3be$var$negate = /* #__PURE__ */ $hTcAb.negate($hTcAb.ringNumber);
var $3c54b6e6d30cc3be$var$identity = /* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn);
var $3c54b6e6d30cc3be$export$f2a120b78af04023 = function(x) {
    return x;
};
var $3c54b6e6d30cc3be$export$760297a502ec68f7 = function(x) {
    return x;
};
var $3c54b6e6d30cc3be$export$e4eccef8f937a949 = function(x) {
    return x;
};
var $3c54b6e6d30cc3be$export$8c68c012e85c37f4 = function(x) {
    return x;
};
var $3c54b6e6d30cc3be$export$d3134eff2123aadb = function(x) {
    return x;
};
var $3c54b6e6d30cc3be$export$9eabacebe6624782 = function(dict) {
    return dict.toDuration;
};
var $3c54b6e6d30cc3be$export$358ac052a84a2abd = {
    show: function(v) {
        return "(Seconds " + ($3c54b6e6d30cc3be$var$show(v) + ")");
    }
};
var $3c54b6e6d30cc3be$export$f5f4de8badcbd545 = {
    show: function(v) {
        return "(Minutes " + ($3c54b6e6d30cc3be$var$show(v) + ")");
    }
};
var $3c54b6e6d30cc3be$export$1d3b9b5391a72ae7 = {
    show: function(v) {
        return "(Milliseconds " + ($3c54b6e6d30cc3be$var$show(v) + ")");
    }
};
var $3c54b6e6d30cc3be$export$c5d3ca6fc3468bcf = {
    show: function(v) {
        return "(Hours " + ($3c54b6e6d30cc3be$var$show(v) + ")");
    }
};
var $3c54b6e6d30cc3be$export$de46f7d16350d367 = {
    show: function(v) {
        return "(Days " + ($3c54b6e6d30cc3be$var$show(v) + ")");
    }
};
var $3c54b6e6d30cc3be$export$bccfb43682e4a5e4 = {
    append: function(v) {
        return function(v1) {
            return v + v1;
        };
    }
};
var $3c54b6e6d30cc3be$export$d9bc7c6e66ddf272 = {
    append: function(v) {
        return function(v1) {
            return v + v1;
        };
    }
};
var $3c54b6e6d30cc3be$export$def67087bd72fdb7 = {
    append: function(v) {
        return function(v1) {
            return v + v1;
        };
    }
};
var $3c54b6e6d30cc3be$export$5f6754e19ae8b602 = {
    append: function(v) {
        return function(v1) {
            return v + v1;
        };
    }
};
var $3c54b6e6d30cc3be$export$e8bb798e27d1673b = {
    append: function(v) {
        return function(v1) {
            return v + v1;
        };
    }
};
var $3c54b6e6d30cc3be$export$34e2a018de95f3d = $d0PPW.ordNumber;
var $3c54b6e6d30cc3be$export$d6d247637e7494c9 = $d0PPW.ordNumber;
var $3c54b6e6d30cc3be$export$e0a5c04af6395341 = $d0PPW.ordNumber;
var $3c54b6e6d30cc3be$export$4ccf8d6c1ebfa128 = $d0PPW.ordNumber;
var $3c54b6e6d30cc3be$export$3ab38ab5accb6ec2 = $d0PPW.ordNumber;
var $3c54b6e6d30cc3be$export$321d65ffd9e957ce = {
    Coercible0: function() {
        return undefined;
    }
};
var $3c54b6e6d30cc3be$export$f5994f75b457cdcc = {
    Coercible0: function() {
        return undefined;
    }
};
var $3c54b6e6d30cc3be$export$961a021281e4c248 = {
    Coercible0: function() {
        return undefined;
    }
};
var $3c54b6e6d30cc3be$export$5ca80b70b64299ae = {
    Coercible0: function() {
        return undefined;
    }
};
var $3c54b6e6d30cc3be$export$a5ba0a6cacc34910 = {
    Coercible0: function() {
        return undefined;
    }
};
var $3c54b6e6d30cc3be$export$5b5983dc8ed41daa = {
    mempty: 0.0,
    Semigroup0: function() {
        return $3c54b6e6d30cc3be$export$bccfb43682e4a5e4;
    }
};
var $3c54b6e6d30cc3be$export$1857fd2af0af50be = {
    mempty: 0.0,
    Semigroup0: function() {
        return $3c54b6e6d30cc3be$export$d9bc7c6e66ddf272;
    }
};
var $3c54b6e6d30cc3be$export$70200b12758a7a61 = {
    mempty: 0.0,
    Semigroup0: function() {
        return $3c54b6e6d30cc3be$export$def67087bd72fdb7;
    }
};
var $3c54b6e6d30cc3be$export$22829380fb9f2b93 = {
    mempty: 0.0,
    Semigroup0: function() {
        return $3c54b6e6d30cc3be$export$5f6754e19ae8b602;
    }
};
var $3c54b6e6d30cc3be$export$9bd04d01a6c9ebc2 = {
    mempty: 0.0,
    Semigroup0: function() {
        return $3c54b6e6d30cc3be$export$e8bb798e27d1673b;
    }
};
var $3c54b6e6d30cc3be$export$1a0a2c8fdf902748 = function(dict) {
    return dict.fromDuration;
};
var $3c54b6e6d30cc3be$export$28743521ea1cb8f9 = function(dictDuration) {
    var $57 = $3c54b6e6d30cc3be$export$9eabacebe6624782(dictDuration);
    var $58 = $3c54b6e6d30cc3be$var$over($3c54b6e6d30cc3be$export$e4eccef8f937a949)($3c54b6e6d30cc3be$var$negate);
    var $59 = $3c54b6e6d30cc3be$export$1a0a2c8fdf902748(dictDuration);
    return function($60) {
        return $57($58($59($60)));
    };
};
var $3c54b6e6d30cc3be$export$980dbec50a957fc7 = $4MBcA.eqNumber;
var $3c54b6e6d30cc3be$export$4771a2ee9f50caac = $4MBcA.eqNumber;
var $3c54b6e6d30cc3be$export$699cb56941ecf990 = $4MBcA.eqNumber;
var $3c54b6e6d30cc3be$export$fd6d5f49667130a4 = $4MBcA.eqNumber;
var $3c54b6e6d30cc3be$export$c66ee96f983a5e21 = $4MBcA.eqNumber;
var $3c54b6e6d30cc3be$export$1791f02d01a6ae8 = {
    fromDuration: /* #__PURE__ */ $3c54b6e6d30cc3be$var$over($3c54b6e6d30cc3be$export$f2a120b78af04023)(function(v) {
        return v * 1000.0;
    }),
    toDuration: /* #__PURE__ */ $3c54b6e6d30cc3be$var$over($3c54b6e6d30cc3be$export$e4eccef8f937a949)(function(v) {
        return v / 1000.0;
    })
};
var $3c54b6e6d30cc3be$export$563c2be46809b74f = {
    fromDuration: /* #__PURE__ */ $3c54b6e6d30cc3be$var$over($3c54b6e6d30cc3be$export$760297a502ec68f7)(function(v) {
        return v * 60000.0;
    }),
    toDuration: /* #__PURE__ */ $3c54b6e6d30cc3be$var$over($3c54b6e6d30cc3be$export$e4eccef8f937a949)(function(v) {
        return v / 60000.0;
    })
};
var $3c54b6e6d30cc3be$export$44304cbc75c995e8 = {
    fromDuration: $3c54b6e6d30cc3be$var$identity,
    toDuration: $3c54b6e6d30cc3be$var$identity
};
var $3c54b6e6d30cc3be$export$117f08340b9f6c14 = {
    fromDuration: /* #__PURE__ */ $3c54b6e6d30cc3be$var$over($3c54b6e6d30cc3be$export$8c68c012e85c37f4)(function(v) {
        return v * 3600000.0;
    }),
    toDuration: /* #__PURE__ */ $3c54b6e6d30cc3be$var$over($3c54b6e6d30cc3be$export$e4eccef8f937a949)(function(v) {
        return v / 3600000.0;
    })
};
var $3c54b6e6d30cc3be$export$93ad8ffd4576e464 = {
    fromDuration: /* #__PURE__ */ $3c54b6e6d30cc3be$var$over($3c54b6e6d30cc3be$export$d3134eff2123aadb)(function(v) {
        return v * 8.64e7;
    }),
    toDuration: /* #__PURE__ */ $3c54b6e6d30cc3be$var$over($3c54b6e6d30cc3be$export$e4eccef8f937a949)(function(v) {
        return v / 8.64e7;
    })
};
var $3c54b6e6d30cc3be$export$3082151037402ab5 = function(dictDuration) {
    var fromDuration1 = $3c54b6e6d30cc3be$export$1a0a2c8fdf902748(dictDuration);
    return function(dictDuration1) {
        var $61 = $3c54b6e6d30cc3be$export$9eabacebe6624782(dictDuration1);
        return function($62) {
            return $61(fromDuration1($62));
        };
    };
};

});

parcelRegister("k5Trf", function(module, exports) {

$parcel$export(module.exports, "unsafePerformEffect", () => (parcelRequire("guZlc")).unsafePerformEffect);
// Generated by purs version 0.15.16

var $guZlc = parcelRequire("guZlc");

});
parcelRegister("guZlc", function(module, exports) {

$parcel$export(module.exports, "unsafePerformEffect", () => $c02f07bc0f38e9e9$export$c62839628b30a695);
const $c02f07bc0f38e9e9$export$c62839628b30a695 = function(f) {
    return f();
};

});


parcelRegister("c0aRt", function(module, exports) {

$parcel$export(module.exports, "unsafeCrashWith", () => $8bcde8f642a64c7d$export$51b220bae4359b72);
// Generated by purs version 0.15.16

var $2D8k8 = parcelRequire("2D8k8");

var $iXsCb = parcelRequire("iXsCb");
var $8bcde8f642a64c7d$var$crashWith = /* #__PURE__ */ $iXsCb.crashWith();
var $8bcde8f642a64c7d$export$cb50937af21de128 = $2D8k8._unsafePartial;
var $8bcde8f642a64c7d$export$51b220bae4359b72 = function(msg) {
    return $8bcde8f642a64c7d$export$cb50937af21de128(function() {
        return $8bcde8f642a64c7d$var$crashWith(msg);
    });
};

});
parcelRegister("2D8k8", function(module, exports) {

$parcel$export(module.exports, "_unsafePartial", () => $1ea5ae3d66e02fe1$export$3e8f060a4c73ba81);
// module Partial.Unsafe
const $1ea5ae3d66e02fe1$export$3e8f060a4c73ba81 = function(f) {
    return f();
};

});

parcelRegister("iXsCb", function(module, exports) {

$parcel$export(module.exports, "crashWith", () => $dcd3eefef707675c$export$ddf616d7646fcc8e);
// Generated by purs version 0.15.16

var $iCXmZ = parcelRequire("iCXmZ");
var $dcd3eefef707675c$export$ddf616d7646fcc8e = function() {
    return $iCXmZ._crashWith;
};
var $dcd3eefef707675c$var$crashWith1 = /* #__PURE__ */ $dcd3eefef707675c$export$ddf616d7646fcc8e();
var $dcd3eefef707675c$export$dcc9d38dbc7992eb = function() {
    return $dcd3eefef707675c$var$crashWith1("Partial.crash: partial function");
};

});
parcelRegister("iCXmZ", function(module, exports) {

$parcel$export(module.exports, "_crashWith", () => $d8f9d43a2c2b18d5$export$b479f9f69f916b6a);
// module Partial
const $d8f9d43a2c2b18d5$export$b479f9f69f916b6a = function(msg) {
    throw new Error(msg);
};

});







parcelRegister("cYgrH", function(module, exports) {

$parcel$export(module.exports, "unCoyoneda", () => $026fde5446dd624a$export$1088317934ed5679);
$parcel$export(module.exports, "lowerCoyoneda", () => $026fde5446dd624a$export$36cf4525d9d7ca3c);
$parcel$export(module.exports, "eqCoyoneda", () => $026fde5446dd624a$export$4c17598ac057c221);
$parcel$export(module.exports, "eq1Coyoneda", () => $026fde5446dd624a$export$8fee22dc2f6f5e8);
$parcel$export(module.exports, "functorCoyoneda", () => $026fde5446dd624a$export$bd40aba71422b460);
$parcel$export(module.exports, "hoistCoyoneda", () => $026fde5446dd624a$export$782bd81bf3515665);
$parcel$export(module.exports, "liftCoyoneda", () => $026fde5446dd624a$export$6320c031d6b6270f);
// Generated by purs version 0.15.16

var $a7Dxq = parcelRequire("a7Dxq");

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $9Grh5 = parcelRequire("9Grh5");

var $7T8P4 = parcelRequire("7T8P4");

var $frF73 = parcelRequire("frF73");

var $hfMWE = parcelRequire("hfMWE");

var $axmEP = parcelRequire("axmEP");

var $5ecNO = parcelRequire("5ecNO");

var $4MBcA = parcelRequire("4MBcA");

var $fQr0C = parcelRequire("fQr0C");

var $6RkEA = parcelRequire("6RkEA");

var $l0wDR = parcelRequire("l0wDR");

var $5hqdn = parcelRequire("5hqdn");

var $d0PPW = parcelRequire("d0PPW");

var $IFMV2 = parcelRequire("IFMV2");

var $jERGJ = parcelRequire("jERGJ");

var $1wR1l = parcelRequire("1wR1l");
var $026fde5446dd624a$var$CoyonedaF = /* #__PURE__ */ function() {
    function CoyonedaF(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    CoyonedaF.create = function(value0) {
        return function(value1) {
            return new CoyonedaF(value0, value1);
        };
    };
    return CoyonedaF;
}();
var $026fde5446dd624a$export$518a6adb5ee0288f = function(x) {
    return x;
};
var $026fde5446dd624a$export$1088317934ed5679 = function(f) {
    return function(v) {
        return $fQr0C.runExists(function(v1) {
            return f(v1.value0)(v1.value1);
        })(v);
    };
};
var $026fde5446dd624a$export$36cf4525d9d7ca3c = function(dictFunctor) {
    return $026fde5446dd624a$export$1088317934ed5679($l0wDR.map(dictFunctor));
};
var $026fde5446dd624a$export$e10932df6e0657f1 = function(dictFoldable) {
    var foldr = $6RkEA.foldr(dictFoldable);
    var foldl = $6RkEA.foldl(dictFoldable);
    var foldMap = $6RkEA.foldMap(dictFoldable);
    return {
        foldr: function(f) {
            return function(z) {
                return $026fde5446dd624a$export$1088317934ed5679(function(k) {
                    return foldr(function($175) {
                        return f(k($175));
                    })(z);
                });
            };
        },
        foldl: function(f) {
            return function(z) {
                return $026fde5446dd624a$export$1088317934ed5679(function(k) {
                    return foldl(function(x) {
                        var $176 = f(x);
                        return function($177) {
                            return $176(k($177));
                        };
                    })(z);
                });
            };
        },
        foldMap: function(dictMonoid) {
            var foldMap1 = foldMap(dictMonoid);
            return function(f) {
                return $026fde5446dd624a$export$1088317934ed5679(function(k) {
                    return foldMap1(function($178) {
                        return f(k($178));
                    });
                });
            };
        }
    };
};
var $026fde5446dd624a$export$bd381ac72ce00e4e = function(dictFoldable1) {
    var foldMap1 = $IFMV2.foldMap1(dictFoldable1);
    var foldableCoyoneda1 = $026fde5446dd624a$export$e10932df6e0657f1(dictFoldable1.Foldable0());
    return {
        foldMap1: function(dictSemigroup) {
            var foldMap11 = foldMap1(dictSemigroup);
            return function(f) {
                return $026fde5446dd624a$export$1088317934ed5679(function(k) {
                    return foldMap11(function($179) {
                        return f(k($179));
                    });
                });
            };
        },
        foldr1: $IFMV2.foldr1Default($026fde5446dd624a$export$bd381ac72ce00e4e(dictFoldable1)),
        foldl1: $IFMV2.foldl1Default($026fde5446dd624a$export$bd381ac72ce00e4e(dictFoldable1)),
        Foldable0: function() {
            return foldableCoyoneda1;
        }
    };
};
var $026fde5446dd624a$export$4c17598ac057c221 = function(dictFunctor) {
    var lowerCoyoneda1 = $026fde5446dd624a$export$36cf4525d9d7ca3c(dictFunctor);
    return function(dictEq1) {
        var eq1 = $4MBcA.eq1(dictEq1);
        return function(dictEq) {
            var eq11 = eq1(dictEq);
            return {
                eq: function(x) {
                    return function(y) {
                        return eq11(lowerCoyoneda1(x))(lowerCoyoneda1(y));
                    };
                }
            };
        };
    };
};
var $026fde5446dd624a$export$e3d23e83f1d891bb = function(dictFunctor) {
    var lowerCoyoneda1 = $026fde5446dd624a$export$36cf4525d9d7ca3c(dictFunctor);
    var eqCoyoneda1 = $026fde5446dd624a$export$4c17598ac057c221(dictFunctor);
    return function(dictOrd1) {
        var compare1 = $d0PPW.compare1(dictOrd1);
        var eqCoyoneda2 = eqCoyoneda1(dictOrd1.Eq10());
        return function(dictOrd) {
            var compare11 = compare1(dictOrd);
            var eqCoyoneda3 = eqCoyoneda2(dictOrd.Eq0());
            return {
                compare: function(x) {
                    return function(y) {
                        return compare11(lowerCoyoneda1(x))(lowerCoyoneda1(y));
                    };
                },
                Eq0: function() {
                    return eqCoyoneda3;
                }
            };
        };
    };
};
var $026fde5446dd624a$export$8fee22dc2f6f5e8 = function(dictFunctor) {
    var eqCoyoneda1 = $026fde5446dd624a$export$4c17598ac057c221(dictFunctor);
    return function(dictEq1) {
        var eqCoyoneda2 = eqCoyoneda1(dictEq1);
        return {
            eq1: function(dictEq) {
                return $4MBcA.eq(eqCoyoneda2(dictEq));
            }
        };
    };
};
var $026fde5446dd624a$export$72164df904554716 = function(dictFunctor) {
    var ordCoyoneda1 = $026fde5446dd624a$export$e3d23e83f1d891bb(dictFunctor);
    var eq1Coyoneda1 = $026fde5446dd624a$export$8fee22dc2f6f5e8(dictFunctor);
    return function(dictOrd1) {
        var ordCoyoneda2 = ordCoyoneda1(dictOrd1);
        var eq1Coyoneda2 = eq1Coyoneda1(dictOrd1.Eq10());
        return {
            compare1: function(dictOrd) {
                return $d0PPW.compare(ordCoyoneda2(dictOrd));
            },
            Eq10: function() {
                return eq1Coyoneda2;
            }
        };
    };
};
var $026fde5446dd624a$export$cc61df270d10d232 = function(k) {
    return function(fi) {
        return $fQr0C.mkExists(new $026fde5446dd624a$var$CoyonedaF(k, fi));
    };
};
var $026fde5446dd624a$export$bd40aba71422b460 = {
    map: function(f) {
        return function(v) {
            return $fQr0C.runExists(function(v1) {
                return $026fde5446dd624a$export$cc61df270d10d232(function($180) {
                    return f(v1.value0($180));
                })(v1.value1);
            })(v);
        };
    }
};
var $026fde5446dd624a$export$4b21c9b3969f8a88 = {
    imap: /* #__PURE__ */ $5hqdn.imapF($026fde5446dd624a$export$bd40aba71422b460)
};
var $026fde5446dd624a$export$782bd81bf3515665 = function(nat) {
    return function(v) {
        return $fQr0C.runExists(function(v1) {
            return $026fde5446dd624a$export$cc61df270d10d232(v1.value0)(nat(v1.value1));
        })(v);
    };
};
var $026fde5446dd624a$export$6320c031d6b6270f = /* #__PURE__ */ $026fde5446dd624a$export$cc61df270d10d232(/* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn));
var $026fde5446dd624a$export$215969f5aee12fc3 = function(dictDistributive) {
    var collect = $5ecNO.collect(dictDistributive);
    var lowerCoyoneda1 = $026fde5446dd624a$export$36cf4525d9d7ca3c(dictDistributive.Functor0());
    return {
        collect: function(dictFunctor) {
            var collect1 = collect(dictFunctor);
            return function(f) {
                var $181 = collect1(function($183) {
                    return lowerCoyoneda1(f($183));
                });
                return function($182) {
                    return $026fde5446dd624a$export$6320c031d6b6270f($181($182));
                };
            };
        },
        distribute: function(dictFunctor) {
            var $184 = collect(dictFunctor)(lowerCoyoneda1);
            return function($185) {
                return $026fde5446dd624a$export$6320c031d6b6270f($184($185));
            };
        },
        Functor0: function() {
            return $026fde5446dd624a$export$bd40aba71422b460;
        }
    };
};
var $026fde5446dd624a$export$946e5a80c258b6f7 = function(dictExtend) {
    var extend = $hfMWE.extend(dictExtend);
    return {
        extend: function(f) {
            return function(v) {
                return $fQr0C.runExists(function(v1) {
                    return $026fde5446dd624a$export$6320c031d6b6270f(extend(function() {
                        var $186 = $026fde5446dd624a$export$cc61df270d10d232(v1.value0);
                        return function($187) {
                            return f($186($187));
                        };
                    }())(v1.value1));
                })(v);
            };
        },
        Functor0: function() {
            return $026fde5446dd624a$export$bd40aba71422b460;
        }
    };
};
var $026fde5446dd624a$export$1a78c49d463144db = {
    lift: function(dictMonad) {
        return $026fde5446dd624a$export$6320c031d6b6270f;
    }
};
var $026fde5446dd624a$export$d249e493735a3666 = function(dictTraversable) {
    var traverse = $1wR1l.traverse(dictTraversable);
    var foldableCoyoneda1 = $026fde5446dd624a$export$e10932df6e0657f1(dictTraversable.Foldable1());
    return {
        traverse: function(dictApplicative) {
            var map = $l0wDR.map(dictApplicative.Apply0().Functor0());
            var traverse1 = traverse(dictApplicative);
            return function(f) {
                return $026fde5446dd624a$export$1088317934ed5679(function(k) {
                    var $188 = map($026fde5446dd624a$export$6320c031d6b6270f);
                    var $189 = traverse1(function($191) {
                        return f(k($191));
                    });
                    return function($190) {
                        return $188($189($190));
                    };
                });
            };
        },
        sequence: function(dictApplicative) {
            var map = $l0wDR.map(dictApplicative.Apply0().Functor0());
            var traverse1 = traverse(dictApplicative);
            return $026fde5446dd624a$export$1088317934ed5679(function(k) {
                var $192 = map($026fde5446dd624a$export$6320c031d6b6270f);
                var $193 = traverse1(k);
                return function($194) {
                    return $192($193($194));
                };
            });
        },
        Functor0: function() {
            return $026fde5446dd624a$export$bd40aba71422b460;
        },
        Foldable1: function() {
            return foldableCoyoneda1;
        }
    };
};
var $026fde5446dd624a$export$592beb634cc81a68 = function(dictTraversable1) {
    var traverse1 = $jERGJ.traverse1(dictTraversable1);
    var sequence1 = $jERGJ.sequence1(dictTraversable1);
    var Traversable1 = dictTraversable1.Traversable1();
    var map = $l0wDR.map(Traversable1.Functor0());
    var foldable1Coyoneda1 = $026fde5446dd624a$export$bd381ac72ce00e4e(dictTraversable1.Foldable10());
    var traversableCoyoneda1 = $026fde5446dd624a$export$d249e493735a3666(Traversable1);
    return {
        traverse1: function(dictApply) {
            var map1 = $l0wDR.map(dictApply.Functor0());
            var traverse11 = traverse1(dictApply);
            return function(f) {
                return $026fde5446dd624a$export$1088317934ed5679(function(k) {
                    var $195 = map1($026fde5446dd624a$export$6320c031d6b6270f);
                    var $196 = traverse11(function($198) {
                        return f(k($198));
                    });
                    return function($197) {
                        return $195($196($197));
                    };
                });
            };
        },
        sequence1: function(dictApply) {
            var map1 = $l0wDR.map(dictApply.Functor0());
            var sequence11 = sequence1(dictApply);
            return $026fde5446dd624a$export$1088317934ed5679(function(k) {
                var $199 = map1($026fde5446dd624a$export$6320c031d6b6270f);
                var $200 = map(k);
                return function($201) {
                    return $199(sequence11($200($201)));
                };
            });
        },
        Foldable10: function() {
            return foldable1Coyoneda1;
        },
        Traversable1: function() {
            return traversableCoyoneda1;
        }
    };
};
var $026fde5446dd624a$export$3a5b6268908c7242 = function(dictComonad) {
    var extract = $frF73.extract(dictComonad);
    var extendCoyoneda1 = $026fde5446dd624a$export$946e5a80c258b6f7(dictComonad.Extend0());
    return {
        extract: function(v) {
            return $fQr0C.runExists(function(v1) {
                return v1.value0(extract(v1.value1));
            })(v);
        },
        Extend0: function() {
            return extendCoyoneda1;
        }
    };
};
var $026fde5446dd624a$export$96fda80da8742a6b = function(dictApply) {
    var apply = $a5g3C.apply(dictApply);
    var lowerCoyoneda1 = $026fde5446dd624a$export$36cf4525d9d7ca3c(dictApply.Functor0());
    return {
        apply: function(f) {
            return function(g) {
                return $026fde5446dd624a$export$6320c031d6b6270f(apply(lowerCoyoneda1(f))(lowerCoyoneda1(g)));
            };
        },
        Functor0: function() {
            return $026fde5446dd624a$export$bd40aba71422b460;
        }
    };
};
var $026fde5446dd624a$export$ef5b465291a6417e = function(dictBind) {
    var bindFlipped = $9Grh5.bindFlipped(dictBind);
    var Apply0 = dictBind.Apply0();
    var lowerCoyoneda1 = $026fde5446dd624a$export$36cf4525d9d7ca3c(Apply0.Functor0());
    var applyCoyoneda1 = $026fde5446dd624a$export$96fda80da8742a6b(Apply0);
    return {
        bind: function(v) {
            return function(f) {
                return $026fde5446dd624a$export$6320c031d6b6270f($fQr0C.runExists(function(v1) {
                    return bindFlipped(function($202) {
                        return lowerCoyoneda1(f(v1.value0($202)));
                    })(v1.value1);
                })(v));
            };
        },
        Apply0: function() {
            return applyCoyoneda1;
        }
    };
};
var $026fde5446dd624a$export$d337c8e043437698 = function(dictApplicative) {
    var applyCoyoneda1 = $026fde5446dd624a$export$96fda80da8742a6b(dictApplicative.Apply0());
    return {
        pure: function() {
            var $203 = $gUTA8.pure(dictApplicative);
            return function($204) {
                return $026fde5446dd624a$export$6320c031d6b6270f($203($204));
            };
        }(),
        Apply0: function() {
            return applyCoyoneda1;
        }
    };
};
var $026fde5446dd624a$export$dfa10a61f5e8217c = function(dictMonad) {
    var applicativeCoyoneda1 = $026fde5446dd624a$export$d337c8e043437698(dictMonad.Applicative0());
    var bindCoyoneda1 = $026fde5446dd624a$export$ef5b465291a6417e(dictMonad.Bind1());
    return {
        Applicative0: function() {
            return applicativeCoyoneda1;
        },
        Bind1: function() {
            return bindCoyoneda1;
        }
    };
};
var $026fde5446dd624a$export$daa4182a46d81e3 = function(dictAlt) {
    var alt = $a7Dxq.alt(dictAlt);
    var lowerCoyoneda1 = $026fde5446dd624a$export$36cf4525d9d7ca3c(dictAlt.Functor0());
    return {
        alt: function(x) {
            return function(y) {
                return $026fde5446dd624a$export$6320c031d6b6270f(alt(lowerCoyoneda1(x))(lowerCoyoneda1(y)));
            };
        },
        Functor0: function() {
            return $026fde5446dd624a$export$bd40aba71422b460;
        }
    };
};
var $026fde5446dd624a$export$f434c65db07c2e04 = function(dictPlus) {
    var altCoyoneda1 = $026fde5446dd624a$export$daa4182a46d81e3(dictPlus.Alt0());
    return {
        empty: $026fde5446dd624a$export$6320c031d6b6270f($axmEP.empty(dictPlus)),
        Alt0: function() {
            return altCoyoneda1;
        }
    };
};
var $026fde5446dd624a$export$15bae6aadce01350 = function(dictAlternative) {
    var applicativeCoyoneda1 = $026fde5446dd624a$export$d337c8e043437698(dictAlternative.Applicative0());
    var plusCoyoneda1 = $026fde5446dd624a$export$f434c65db07c2e04(dictAlternative.Plus1());
    return {
        Applicative0: function() {
            return applicativeCoyoneda1;
        },
        Plus1: function() {
            return plusCoyoneda1;
        }
    };
};
var $026fde5446dd624a$export$e819965db94a810a = function(dictMonadPlus) {
    var monadCoyoneda1 = $026fde5446dd624a$export$dfa10a61f5e8217c(dictMonadPlus.Monad0());
    var alternativeCoyoneda1 = $026fde5446dd624a$export$15bae6aadce01350(dictMonadPlus.Alternative1());
    return {
        Monad0: function() {
            return monadCoyoneda1;
        },
        Alternative1: function() {
            return alternativeCoyoneda1;
        }
    };
};

});
parcelRegister("fQr0C", function(module, exports) {

$parcel$export(module.exports, "runExists", () => $b890a9c9ccf92ae9$export$49a1dce2f81a97d6);
$parcel$export(module.exports, "mkExists", () => $b890a9c9ccf92ae9$export$7488c940d035302c);
// Generated by purs version 0.15.16
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");
var $b890a9c9ccf92ae9$export$49a1dce2f81a97d6 = $eOrGk.unsafeCoerce;
var $b890a9c9ccf92ae9$export$7488c940d035302c = $eOrGk.unsafeCoerce;

});

parcelRegister("IFMV2", function(module, exports) {

$parcel$export(module.exports, "foldr1", () => $086486679aa806fa$export$c8b99533c112636f);
$parcel$export(module.exports, "foldl1", () => $086486679aa806fa$export$eb5e1ef4ea2eca3d);
$parcel$export(module.exports, "foldableTuple", () => $086486679aa806fa$export$ffb07d5442a5d6a6);
$parcel$export(module.exports, "foldableMultiplicative", () => $086486679aa806fa$export$9519b6731ae6781c);
$parcel$export(module.exports, "foldableIdentity", () => $086486679aa806fa$export$3c076fb5bbc5428f);
$parcel$export(module.exports, "foldableDual", () => $086486679aa806fa$export$1f8d30ddb0a4c229);
$parcel$export(module.exports, "foldMap1DefaultL", () => $086486679aa806fa$export$3341743d361f5644);
$parcel$export(module.exports, "foldMap1", () => $086486679aa806fa$export$b50c31bb8aebd2a7);
$parcel$export(module.exports, "foldl1Default", () => $086486679aa806fa$export$8dd52a2a23ae4dc4);
$parcel$export(module.exports, "foldr1Default", () => $086486679aa806fa$export$8af34898c082e678);
$parcel$export(module.exports, "intercalate", () => $086486679aa806fa$export$739ec22334c44788);
$parcel$export(module.exports, "fold1", () => $086486679aa806fa$export$2e430a6d03f6ee23);
// Generated by purs version 0.15.16

var $a5g3C = parcelRequire("a5g3C");

var $7T8P4 = parcelRequire("7T8P4");

var $4MBcA = parcelRequire("4MBcA");

var $6RkEA = parcelRequire("6RkEA");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");

var $bbOAS = parcelRequire("bbOAS");

var $6PW1p = parcelRequire("6PW1p");

var $g327P = parcelRequire("g327P");

var $anDQI = parcelRequire("anDQI");

var $6SDUu = parcelRequire("6SDUu");

var $iwqgS = parcelRequire("iwqgS");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");
var $086486679aa806fa$var$eq = /* #__PURE__ */ $4MBcA.eq($6SDUu.eqOrdering);
var $086486679aa806fa$var$alaF = /* #__PURE__ */ $6PW1p.alaF()()()();
var $086486679aa806fa$var$identity = /* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn);
var $086486679aa806fa$var$ala = /* #__PURE__ */ $6PW1p.ala()()();
var $086486679aa806fa$var$JoinWith = function(x) {
    return x;
};
var $086486679aa806fa$var$FoldRight1 = /* #__PURE__ */ function() {
    function FoldRight1(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    FoldRight1.create = function(value0) {
        return function(value1) {
            return new FoldRight1(value0, value1);
        };
    };
    return FoldRight1;
}();
var $086486679aa806fa$var$Act = function(x) {
    return x;
};
var $086486679aa806fa$var$semigroupJoinWith = function(dictSemigroup) {
    var append = $iwqgS.append(dictSemigroup);
    return {
        append: function(v) {
            return function(v1) {
                return function(j) {
                    return append(v(j))(append(j)(v1(j)));
                };
            };
        }
    };
};
var $086486679aa806fa$var$semigroupAct = function(dictApply) {
    var applySecond = $a5g3C.applySecond(dictApply);
    return {
        append: function(v) {
            return function(v1) {
                return applySecond(v)(v1);
            };
        }
    };
};
var $086486679aa806fa$var$runFoldRight1 = function(v) {
    return v.value0(v.value1);
};
var $086486679aa806fa$var$mkFoldRight1 = /* #__PURE__ */ function() {
    return $086486679aa806fa$var$FoldRight1.create($l4M7e.const);
}();
var $086486679aa806fa$var$joinee = function(v) {
    return v;
};
var $086486679aa806fa$var$getAct = function(v) {
    return v;
};
var $086486679aa806fa$export$c8b99533c112636f = function(dict) {
    return dict.foldr1;
};
var $086486679aa806fa$export$eb5e1ef4ea2eca3d = function(dict) {
    return dict.foldl1;
};
var $086486679aa806fa$export$c42fa06aba2a552c = function(dictFoldable1) {
    var foldl11 = $086486679aa806fa$export$eb5e1ef4ea2eca3d(dictFoldable1);
    return function(cmp) {
        return foldl11(function(x) {
            return function(y) {
                var $120 = $086486679aa806fa$var$eq(cmp(x)(y))($6SDUu.GT.value);
                if ($120) return x;
                return y;
            };
        });
    };
};
var $086486679aa806fa$export$b65392d958998255 = function(dictFoldable1) {
    var foldl11 = $086486679aa806fa$export$eb5e1ef4ea2eca3d(dictFoldable1);
    return function(cmp) {
        return foldl11(function(x) {
            return function(y) {
                var $121 = $086486679aa806fa$var$eq(cmp(x)(y))($6SDUu.LT.value);
                if ($121) return x;
                return y;
            };
        });
    };
};
var $086486679aa806fa$export$ffb07d5442a5d6a6 = {
    foldMap1: function(dictSemigroup) {
        return function(f) {
            return function(v) {
                return f(v.value1);
            };
        };
    },
    foldr1: function(v) {
        return function(v1) {
            return v1.value1;
        };
    },
    foldl1: function(v) {
        return function(v1) {
            return v1.value1;
        };
    },
    Foldable0: function() {
        return $6RkEA.foldableTuple;
    }
};
var $086486679aa806fa$export$9519b6731ae6781c = {
    foldr1: function(v) {
        return function(v1) {
            return v1;
        };
    },
    foldl1: function(v) {
        return function(v1) {
            return v1;
        };
    },
    foldMap1: function(dictSemigroup) {
        return function(f) {
            return function(v) {
                return f(v);
            };
        };
    },
    Foldable0: function() {
        return $6RkEA.foldableMultiplicative;
    }
};
var $086486679aa806fa$export$3c076fb5bbc5428f = {
    foldMap1: function(dictSemigroup) {
        return function(f) {
            return function(v) {
                return f(v);
            };
        };
    },
    foldl1: function(v) {
        return function(v1) {
            return v1;
        };
    },
    foldr1: function(v) {
        return function(v1) {
            return v1;
        };
    },
    Foldable0: function() {
        return $6RkEA.foldableIdentity;
    }
};
var $086486679aa806fa$export$1f8d30ddb0a4c229 = {
    foldr1: function(v) {
        return function(v1) {
            return v1;
        };
    },
    foldl1: function(v) {
        return function(v1) {
            return v1;
        };
    },
    foldMap1: function(dictSemigroup) {
        return function(f) {
            return function(v) {
                return f(v);
            };
        };
    },
    Foldable0: function() {
        return $6RkEA.foldableDual;
    }
};
var $086486679aa806fa$var$foldRight1Semigroup = {
    append: function(v) {
        return function(v1) {
            return new $086486679aa806fa$var$FoldRight1(function(a) {
                return function(f) {
                    return v.value0(f(v.value1)(v1.value0(a)(f)))(f);
                };
            }, v1.value1);
        };
    }
};
var $086486679aa806fa$var$semigroupDual = /* #__PURE__ */ $bbOAS.semigroupDual($086486679aa806fa$var$foldRight1Semigroup);
var $086486679aa806fa$export$4a5b2f24b03cc38b = function(dictFoldable1) {
    var foldr11 = $086486679aa806fa$export$c8b99533c112636f(dictFoldable1);
    return function(dictFunctor) {
        var map = $l0wDR.map(dictFunctor);
        return function(dictSemigroup) {
            var append = $iwqgS.append(dictSemigroup);
            return function(f) {
                var $159 = foldr11(append);
                var $160 = map(f);
                return function($161) {
                    return $159($160($161));
                };
            };
        };
    };
};
var $086486679aa806fa$export$3341743d361f5644 = function(dictFoldable1) {
    var foldl11 = $086486679aa806fa$export$eb5e1ef4ea2eca3d(dictFoldable1);
    return function(dictFunctor) {
        var map = $l0wDR.map(dictFunctor);
        return function(dictSemigroup) {
            var append = $iwqgS.append(dictSemigroup);
            return function(f) {
                var $162 = foldl11(append);
                var $163 = map(f);
                return function($164) {
                    return $162($163($164));
                };
            };
        };
    };
};
var $086486679aa806fa$export$b50c31bb8aebd2a7 = function(dict) {
    return dict.foldMap1;
};
var $086486679aa806fa$export$8dd52a2a23ae4dc4 = function(dictFoldable1) {
    var $165 = $l4M7e.flip(function() {
        var $167 = $086486679aa806fa$var$alaF($bbOAS.Dual)($086486679aa806fa$export$b50c31bb8aebd2a7(dictFoldable1)($086486679aa806fa$var$semigroupDual))($086486679aa806fa$var$mkFoldRight1);
        return function($168) {
            return $086486679aa806fa$var$runFoldRight1($167($168));
        };
    }());
    return function($166) {
        return $165($l4M7e.flip($166));
    };
};
var $086486679aa806fa$export$8af34898c082e678 = function(dictFoldable1) {
    return $l4M7e.flip(function() {
        var $169 = $086486679aa806fa$export$b50c31bb8aebd2a7(dictFoldable1)($086486679aa806fa$var$foldRight1Semigroup)($086486679aa806fa$var$mkFoldRight1);
        return function($170) {
            return $086486679aa806fa$var$runFoldRight1($169($170));
        };
    }());
};
var $086486679aa806fa$export$a91e4d9c87e70eae = function(dictFoldable1) {
    var foldMap11 = $086486679aa806fa$export$b50c31bb8aebd2a7(dictFoldable1);
    return function(dictSemigroup) {
        var foldMap12 = foldMap11($086486679aa806fa$var$semigroupJoinWith(dictSemigroup));
        return function(j) {
            return function(f) {
                return function(foldable) {
                    return $086486679aa806fa$var$joinee(foldMap12(function($171) {
                        return $086486679aa806fa$var$JoinWith($l4M7e.const(f($171)));
                    })(foldable))(j);
                };
            };
        };
    };
};
var $086486679aa806fa$export$739ec22334c44788 = function(dictFoldable1) {
    var intercalateMap1 = $086486679aa806fa$export$a91e4d9c87e70eae(dictFoldable1);
    return function(dictSemigroup) {
        return $l4M7e.flip(intercalateMap1(dictSemigroup))($086486679aa806fa$var$identity);
    };
};
var $086486679aa806fa$export$b25e0be55f42c9a = function(dictOrd) {
    var semigroupMax = $g327P.semigroupMax(dictOrd);
    return function(dictFoldable1) {
        return $086486679aa806fa$var$ala($g327P.Max)($086486679aa806fa$export$b50c31bb8aebd2a7(dictFoldable1)(semigroupMax));
    };
};
var $086486679aa806fa$export$916782c1f0ddb132 = function(dictOrd) {
    var semigroupMin = $anDQI.semigroupMin(dictOrd);
    return function(dictFoldable1) {
        return $086486679aa806fa$var$ala($anDQI.Min)($086486679aa806fa$export$b50c31bb8aebd2a7(dictFoldable1)(semigroupMin));
    };
};
var $086486679aa806fa$export$4d892265b7b103bf = function(dictFoldable1) {
    var foldMap11 = $086486679aa806fa$export$b50c31bb8aebd2a7(dictFoldable1);
    return function(dictApply) {
        var voidRight = $l0wDR.voidRight(dictApply.Functor0());
        var foldMap12 = foldMap11($086486679aa806fa$var$semigroupAct(dictApply));
        return function(f) {
            return function(t) {
                return voidRight($r2HHk.unit)($086486679aa806fa$var$getAct(foldMap12(function($172) {
                    return $086486679aa806fa$var$Act(f($172));
                })(t)));
            };
        };
    };
};
var $086486679aa806fa$export$f339179a581d1957 = function(dictFoldable1) {
    var traverse1_1 = $086486679aa806fa$export$4d892265b7b103bf(dictFoldable1);
    return function(dictApply) {
        return $l4M7e.flip(traverse1_1(dictApply));
    };
};
var $086486679aa806fa$export$1e2962bbf3c67125 = function(dictFoldable1) {
    var traverse1_1 = $086486679aa806fa$export$4d892265b7b103bf(dictFoldable1);
    return function(dictApply) {
        return traverse1_1(dictApply)($086486679aa806fa$var$identity);
    };
};
var $086486679aa806fa$export$2e430a6d03f6ee23 = function(dictFoldable1) {
    var foldMap11 = $086486679aa806fa$export$b50c31bb8aebd2a7(dictFoldable1);
    return function(dictSemigroup) {
        return foldMap11(dictSemigroup)($086486679aa806fa$var$identity);
    };
};

});
parcelRegister("g327P", function(module, exports) {

$parcel$export(module.exports, "Max", () => $baee932cbcb11133$export$d36c09e5d02927e7);
$parcel$export(module.exports, "semigroupMax", () => $baee932cbcb11133$export$a132d56c46b55689);
// Generated by purs version 0.15.16

var $95fRU = parcelRequire("95fRU");

var $d0PPW = parcelRequire("d0PPW");

var $3Orkn = parcelRequire("3Orkn");
var $baee932cbcb11133$export$d36c09e5d02927e7 = function(x) {
    return x;
};
var $baee932cbcb11133$export$cbb92fe0a8d77a01 = function(dictShow) {
    var show = $3Orkn.show(dictShow);
    return {
        show: function(v) {
            return "(Max " + (show(v) + ")");
        }
    };
};
var $baee932cbcb11133$export$a132d56c46b55689 = function(dictOrd) {
    var max = $d0PPW.max(dictOrd);
    return {
        append: function(v) {
            return function(v1) {
                return max(v)(v1);
            };
        }
    };
};
var $baee932cbcb11133$export$1c8bde74ed3994f3 = {
    Coercible0: function() {
        return undefined;
    }
};
var $baee932cbcb11133$export$1f74115b8967ed30 = function(dictBounded) {
    var semigroupMax1 = $baee932cbcb11133$export$a132d56c46b55689(dictBounded.Ord0());
    return {
        mempty: $95fRU.bottom(dictBounded),
        Semigroup0: function() {
            return semigroupMax1;
        }
    };
};
var $baee932cbcb11133$export$2d291ba9538dc344 = function(dictEq) {
    return dictEq;
};
var $baee932cbcb11133$export$9193f18dc6b98d96 = function(dictOrd) {
    var compare = $d0PPW.compare(dictOrd);
    var eqMax1 = $baee932cbcb11133$export$2d291ba9538dc344(dictOrd.Eq0());
    return {
        compare: function(v) {
            return function(v1) {
                return compare(v)(v1);
            };
        },
        Eq0: function() {
            return eqMax1;
        }
    };
};

});

parcelRegister("anDQI", function(module, exports) {

$parcel$export(module.exports, "Min", () => $78eaf69ebdcfa03a$export$dfed19fabc75a31d);
$parcel$export(module.exports, "semigroupMin", () => $78eaf69ebdcfa03a$export$7a307765ab1cd61e);
// Generated by purs version 0.15.16

var $95fRU = parcelRequire("95fRU");

var $d0PPW = parcelRequire("d0PPW");

var $3Orkn = parcelRequire("3Orkn");
var $78eaf69ebdcfa03a$export$dfed19fabc75a31d = function(x) {
    return x;
};
var $78eaf69ebdcfa03a$export$7b461170c443f592 = function(dictShow) {
    var show = $3Orkn.show(dictShow);
    return {
        show: function(v) {
            return "(Min " + (show(v) + ")");
        }
    };
};
var $78eaf69ebdcfa03a$export$7a307765ab1cd61e = function(dictOrd) {
    var min = $d0PPW.min(dictOrd);
    return {
        append: function(v) {
            return function(v1) {
                return min(v)(v1);
            };
        }
    };
};
var $78eaf69ebdcfa03a$export$1aba8bd40545d1a0 = {
    Coercible0: function() {
        return undefined;
    }
};
var $78eaf69ebdcfa03a$export$6c7bc156e3eb9786 = function(dictBounded) {
    var semigroupMin1 = $78eaf69ebdcfa03a$export$7a307765ab1cd61e(dictBounded.Ord0());
    return {
        mempty: $95fRU.top(dictBounded),
        Semigroup0: function() {
            return semigroupMin1;
        }
    };
};
var $78eaf69ebdcfa03a$export$aa006854d430a332 = function(dictEq) {
    return dictEq;
};
var $78eaf69ebdcfa03a$export$ea9a45890a65660 = function(dictOrd) {
    var compare = $d0PPW.compare(dictOrd);
    var eqMin1 = $78eaf69ebdcfa03a$export$aa006854d430a332(dictOrd.Eq0());
    return {
        compare: function(v) {
            return function(v1) {
                return compare(v)(v1);
            };
        },
        Eq0: function() {
            return eqMin1;
        }
    };
};

});


parcelRegister("jERGJ", function(module, exports) {

$parcel$export(module.exports, "traverse1", () => $e4fb66202bb8a4f4$export$d2990bb35e0a3e00);
$parcel$export(module.exports, "sequence1Default", () => $e4fb66202bb8a4f4$export$c8ca5446ba1698);
$parcel$export(module.exports, "sequence1", () => $e4fb66202bb8a4f4$export$6deffb29affc84c6);
// Generated by purs version 0.15.16

var $7T8P4 = parcelRequire("7T8P4");

var $l0wDR = parcelRequire("l0wDR");

var $6VVZC = parcelRequire("6VVZC");

var $bbOAS = parcelRequire("bbOAS");

var $8MGTa = parcelRequire("8MGTa");

var $IFMV2 = parcelRequire("IFMV2");

var $1wR1l = parcelRequire("1wR1l");

var $9MxTl = parcelRequire("9MxTl");
var $e4fb66202bb8a4f4$var$identity = /* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn);
var $e4fb66202bb8a4f4$export$d2990bb35e0a3e00 = function(dict) {
    return dict.traverse1;
};
var $e4fb66202bb8a4f4$export$d35878ee42638401 = {
    traverse1: function(dictApply) {
        var map = $l0wDR.map(dictApply.Functor0());
        return function(f) {
            return function(v) {
                return map($9MxTl.Tuple.create(v.value0))(f(v.value1));
            };
        };
    },
    sequence1: function(dictApply) {
        var map = $l0wDR.map(dictApply.Functor0());
        return function(v) {
            return map($9MxTl.Tuple.create(v.value0))(v.value1);
        };
    },
    Foldable10: function() {
        return $IFMV2.foldableTuple;
    },
    Traversable1: function() {
        return $1wR1l.traversableTuple;
    }
};
var $e4fb66202bb8a4f4$export$63e84f34fb558532 = {
    traverse1: function(dictApply) {
        var map = $l0wDR.map(dictApply.Functor0());
        return function(f) {
            return function(v) {
                return map($6VVZC.Identity)(f(v));
            };
        };
    },
    sequence1: function(dictApply) {
        var map = $l0wDR.map(dictApply.Functor0());
        return function(v) {
            return map($6VVZC.Identity)(v);
        };
    },
    Foldable10: function() {
        return $IFMV2.foldableIdentity;
    },
    Traversable1: function() {
        return $1wR1l.traversableIdentity;
    }
};
var $e4fb66202bb8a4f4$export$c8ca5446ba1698 = function(dictTraversable1) {
    var traverse11 = $e4fb66202bb8a4f4$export$d2990bb35e0a3e00(dictTraversable1);
    return function(dictApply) {
        return traverse11(dictApply)($e4fb66202bb8a4f4$var$identity);
    };
};
var $e4fb66202bb8a4f4$export$54df524caf88dbea = {
    traverse1: function(dictApply) {
        var map = $l0wDR.map(dictApply.Functor0());
        return function(f) {
            return function(v) {
                return map($bbOAS.Dual)(f(v));
            };
        };
    },
    sequence1: function(dictApply) {
        return $e4fb66202bb8a4f4$export$c8ca5446ba1698($e4fb66202bb8a4f4$export$54df524caf88dbea)(dictApply);
    },
    Foldable10: function() {
        return $IFMV2.foldableDual;
    },
    Traversable1: function() {
        return $1wR1l.traversableDual;
    }
};
var $e4fb66202bb8a4f4$export$b86a2d00788e21b6 = {
    traverse1: function(dictApply) {
        var map = $l0wDR.map(dictApply.Functor0());
        return function(f) {
            return function(v) {
                return map($8MGTa.Multiplicative)(f(v));
            };
        };
    },
    sequence1: function(dictApply) {
        return $e4fb66202bb8a4f4$export$c8ca5446ba1698($e4fb66202bb8a4f4$export$b86a2d00788e21b6)(dictApply);
    },
    Foldable10: function() {
        return $IFMV2.foldableMultiplicative;
    },
    Traversable1: function() {
        return $1wR1l.traversableMultiplicative;
    }
};
var $e4fb66202bb8a4f4$export$6deffb29affc84c6 = function(dict) {
    return dict.sequence1;
};
var $e4fb66202bb8a4f4$export$61888596d46ec879 = function(dictTraversable1) {
    var sequence11 = $e4fb66202bb8a4f4$export$6deffb29affc84c6(dictTraversable1);
    var map = $l0wDR.map(dictTraversable1.Traversable1().Functor0());
    return function(dictApply) {
        var sequence12 = sequence11(dictApply);
        return function(f) {
            return function(ta) {
                return sequence12(map(f)(ta));
            };
        };
    };
};

});


parcelRegister("8JwLM", function(module, exports) {

$parcel$export(module.exports, "strongFn", () => $65bbf210574f301e$export$311dde6ade8133c7);
$parcel$export(module.exports, "first", () => $65bbf210574f301e$export$43128fadae87b74a);
$parcel$export(module.exports, "fanout", () => $65bbf210574f301e$export$296bafc6ffe8d435);
// Generated by purs version 0.15.16

var $7yzxp = parcelRequire("7yzxp");

var $l0wDR = parcelRequire("l0wDR");

var $dnKRS = parcelRequire("dnKRS");

var $9MxTl = parcelRequire("9MxTl");
var $65bbf210574f301e$export$311dde6ade8133c7 = {
    first: function(a2b) {
        return function(v) {
            return new $9MxTl.Tuple(a2b(v.value0), v.value1);
        };
    },
    second: /* #__PURE__ */ $l0wDR.map($9MxTl.functorTuple),
    Profunctor0: function() {
        return $dnKRS.profunctorFn;
    }
};
var $65bbf210574f301e$export$3d3c77ce7df7d30d = function(dict) {
    return dict.second;
};
var $65bbf210574f301e$export$43128fadae87b74a = function(dict) {
    return dict.first;
};
var $65bbf210574f301e$export$a66b5a8932fce7e1 = function(dictSemigroupoid) {
    var composeFlipped = $7yzxp.composeFlipped(dictSemigroupoid);
    return function(dictStrong) {
        var first1 = $65bbf210574f301e$export$43128fadae87b74a(dictStrong);
        var second1 = $65bbf210574f301e$export$3d3c77ce7df7d30d(dictStrong);
        return function(l) {
            return function(r) {
                return composeFlipped(first1(l))(second1(r));
            };
        };
    };
};
var $65bbf210574f301e$export$296bafc6ffe8d435 = function(dictSemigroupoid) {
    var splitStrong1 = $65bbf210574f301e$export$a66b5a8932fce7e1(dictSemigroupoid);
    return function(dictStrong) {
        var lcmap = $dnKRS.lcmap(dictStrong.Profunctor0());
        var splitStrong2 = splitStrong1(dictStrong);
        return function(l) {
            return function(r) {
                return lcmap(function(a) {
                    return new $9MxTl.Tuple(a, a);
                })(splitStrong2(l)(r));
            };
        };
    };
};

});

parcelRegister("jHZNn", function(module, exports) {

$parcel$export(module.exports, "ApplyF", () => $03b3e717ae197bde$export$768edaeb4b9bb9fc);
$parcel$export(module.exports, "LambdaF", () => $03b3e717ae197bde$export$f3c7d3817e87cd1c);
$parcel$export(module.exports, "VariableF", () => $03b3e717ae197bde$export$c6adf0fd0438e6e2);
$parcel$export(module.exports, "Application", () => $03b3e717ae197bde$export$16975c34e60e1e61);
$parcel$export(module.exports, "Abstraction", () => $03b3e717ae197bde$export$f362e1cb1a1602a0);
$parcel$export(module.exports, "Variable", () => $03b3e717ae197bde$export$c867a5c9595a1350);
$parcel$export(module.exports, "Parse", () => $03b3e717ae197bde$export$29abf071d92c5cc2);
$parcel$export(module.exports, "showExpr", () => $03b3e717ae197bde$export$815507a0da5050dc);
$parcel$export(module.exports, "recursiveExprExprF", () => $03b3e717ae197bde$export$842aded1e9f461fb);
$parcel$export(module.exports, "eqExpr", () => $03b3e717ae197bde$export$15567fdd932099c8);
$parcel$export(module.exports, "render", () => $03b3e717ae197bde$export$b3890eb0ae9dca99);
$parcel$export(module.exports, "print", () => $03b3e717ae197bde$export$c2d084dc44961371);
$parcel$export(module.exports, "generator", () => $03b3e717ae197bde$export$2b513308e642d699);
$parcel$export(module.exports, "parserComponent", () => $03b3e717ae197bde$export$b1b56d7cac5b0820);
// Generated by purs version 0.15.16

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $9Grh5 = parcelRequire("9Grh5");

var $7T8P4 = parcelRequire("7T8P4");

var $dTFzl = parcelRequire("dTFzl");

var $8D18I = parcelRequire("8D18I");

var $kUmUH = parcelRequire("kUmUH");

var $kQAxW = parcelRequire("kQAxW");

var $3Dhkl = parcelRequire("3Dhkl");

var $4VF0K = parcelRequire("4VF0K");

var $jxBf5 = parcelRequire("jxBf5");

var $cwMDv = parcelRequire("cwMDv");

var $aKY4H = parcelRequire("aKY4H");

var $4MBcA = parcelRequire("4MBcA");

var $6RkEA = parcelRequire("6RkEA");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");

var $cw1rg = parcelRequire("cw1rg");

var $6VVZC = parcelRequire("6VVZC");
parcelRequire("c8kPS");
var $6pI6x = parcelRequire("6pI6x");

var $ykHdR = parcelRequire("ykHdR");

var $aknDF = parcelRequire("aknDF");

var $6PW1p = parcelRequire("6PW1p");

var $d0PPW = parcelRequire("d0PPW");

var $iwqgS = parcelRequire("iwqgS");

var $3Orkn = parcelRequire("3Orkn");

var $7eHfd = parcelRequire("7eHfd");

var $79GDW = parcelRequire("79GDW");

var $1wR1l = parcelRequire("1wR1l");

var $9MxTl = parcelRequire("9MxTl");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");

var $kugLX = parcelRequire("kugLX");

var $hhMAk = parcelRequire("hhMAk");

var $jIMHU = parcelRequire("jIMHU");

var $cLQJF = parcelRequire("cLQJF");

var $bllhK = parcelRequire("bllhK");

var $5tIT8 = parcelRequire("5tIT8");

var $lO7j1 = parcelRequire("lO7j1");

var $6rKEG = parcelRequire("6rKEG");

var $3J9zV = parcelRequire("3J9zV");

var $1woEV = parcelRequire("1woEV");

var $27rSX = parcelRequire("27rSX");

var $7yevh = parcelRequire("7yevh");
var $03b3e717ae197bde$var$showRecord = /* #__PURE__ */ $3Orkn.showRecord()();
var $03b3e717ae197bde$var$showRecordFieldsCons = /* #__PURE__ */ $3Orkn.showRecordFieldsCons({
    reflectSymbol: function() {
        return "argument";
    }
});
var $03b3e717ae197bde$var$showRecordFieldsConsNil = /* #__PURE__ */ $3Orkn.showRecordFieldsConsNil({
    reflectSymbol: function() {
        return "function";
    }
});
var $03b3e717ae197bde$var$ApplicationIsSymbol = {
    reflectSymbol: function() {
        return "Application";
    }
};
var $03b3e717ae197bde$var$showRecordFieldsCons1 = /* #__PURE__ */ $3Orkn.showRecordFieldsCons({
    reflectSymbol: function() {
        return "binder";
    }
});
var $03b3e717ae197bde$var$showRecordFieldsConsNil1 = /* #__PURE__ */ $3Orkn.showRecordFieldsConsNil({
    reflectSymbol: function() {
        return "body";
    }
});
var $03b3e717ae197bde$var$AbstractionIsSymbol = {
    reflectSymbol: function() {
        return "Abstraction";
    }
};
var $03b3e717ae197bde$var$genericShowConstructor = /* #__PURE__ */ $7eHfd.genericShowConstructor(/* #__PURE__ */ $7eHfd.genericShowArgsArgument($3Orkn.showString));
var $03b3e717ae197bde$var$genericShowConstructor1 = /* #__PURE__ */ $03b3e717ae197bde$var$genericShowConstructor({
    reflectSymbol: function() {
        return "Variable";
    }
});
var $03b3e717ae197bde$var$ApplyFIsSymbol = {
    reflectSymbol: function() {
        return "ApplyF";
    }
};
var $03b3e717ae197bde$var$LambdaFIsSymbol = {
    reflectSymbol: function() {
        return "LambdaF";
    }
};
var $03b3e717ae197bde$var$genericShowConstructor2 = /* #__PURE__ */ $03b3e717ae197bde$var$genericShowConstructor({
    reflectSymbol: function() {
        return "VariableF";
    }
});
var $03b3e717ae197bde$var$identity = /* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn);
var $03b3e717ae197bde$var$append = /* #__PURE__ */ $iwqgS.append($cwMDv.semigroupNonEmptyArray);
var $03b3e717ae197bde$var$map = /* #__PURE__ */ $l0wDR.map($l0wDR.functorArray);
var $03b3e717ae197bde$var$max = /* #__PURE__ */ $d0PPW.max($d0PPW.ordInt);
var $03b3e717ae197bde$var$bind = /* #__PURE__ */ $9Grh5.bind($3J9zV.bindParserT);
var $03b3e717ae197bde$var$when = /* #__PURE__ */ $gUTA8.when($3J9zV.applicativeParserT);
var $03b3e717ae197bde$var$notEq = /* #__PURE__ */ $4MBcA.notEq($5tIT8.eqLexeme);
var $03b3e717ae197bde$var$show = /* #__PURE__ */ $3Orkn.show($5tIT8.showLexeme);
var $03b3e717ae197bde$var$pure = /* #__PURE__ */ $gUTA8.pure($3J9zV.applicativeParserT);
var $03b3e717ae197bde$var$oneOf = /* #__PURE__ */ $6RkEA.oneOf($6RkEA.foldableArray)($3J9zV.plusParserT);
var $03b3e717ae197bde$var$map1 = /* #__PURE__ */ $l0wDR.map($3J9zV.functorParserT);
var $03b3e717ae197bde$var$some = /* #__PURE__ */ $jxBf5.some($3J9zV.alternativeParserT)($3J9zV.lazyParserT);
var $03b3e717ae197bde$var$apply = /* #__PURE__ */ $a5g3C.apply($3J9zV.applyParserT);
var $03b3e717ae197bde$var$applyFirst = /* #__PURE__ */ $a5g3C.applyFirst($3J9zV.applyParserT);
var $03b3e717ae197bde$var$discard = /* #__PURE__ */ $9Grh5.discard($9Grh5.discardUnit)($bllhK.bindHalogenM);
var $03b3e717ae197bde$var$modify_ = /* #__PURE__ */ $kQAxW.modify_($bllhK.monadStateHalogenM);
var $03b3e717ae197bde$var$over = /* #__PURE__ */ $6PW1p.over()();
var $03b3e717ae197bde$var$pure1 = /* #__PURE__ */ $gUTA8.pure($bllhK.applicativeHalogenM);
var $03b3e717ae197bde$var$put = /* #__PURE__ */ $kQAxW.put($bllhK.monadStateHalogenM);
var $03b3e717ae197bde$var$append2 = /* #__PURE__ */ $iwqgS.append($iwqgS.semigroupArray);
var $03b3e717ae197bde$var$pure2 = /* #__PURE__ */ $gUTA8.pure($gUTA8.applicativeArray);
var $03b3e717ae197bde$var$show1 = /* #__PURE__ */ $3Orkn.show($3J9zV.showParseError);
var $03b3e717ae197bde$var$bind1 = /* #__PURE__ */ $9Grh5.bind($aKY4H.bindEither);
var $03b3e717ae197bde$var$tokens = /* #__PURE__ */ $7yevh.tokens($6VVZC.monadIdentity);
var $03b3e717ae197bde$var$pure3 = /* #__PURE__ */ $gUTA8.pure($aKY4H.applicativeEither);
var $03b3e717ae197bde$export$768edaeb4b9bb9fc = /* #__PURE__ */ function() {
    function ApplyF(value0) {
        this.value0 = value0;
    }
    ApplyF.create = function(value0) {
        return new ApplyF(value0);
    };
    return ApplyF;
}();
var $03b3e717ae197bde$export$f3c7d3817e87cd1c = /* #__PURE__ */ function() {
    function LambdaF(value0) {
        this.value0 = value0;
    }
    LambdaF.create = function(value0) {
        return new LambdaF(value0);
    };
    return LambdaF;
}();
var $03b3e717ae197bde$export$c6adf0fd0438e6e2 = /* #__PURE__ */ function() {
    function VariableF(value0) {
        this.value0 = value0;
    }
    VariableF.create = function(value0) {
        return new VariableF(value0);
    };
    return VariableF;
}();
var $03b3e717ae197bde$export$16975c34e60e1e61 = /* #__PURE__ */ function() {
    function Application(value0) {
        this.value0 = value0;
    }
    Application.create = function(value0) {
        return new Application(value0);
    };
    return Application;
}();
var $03b3e717ae197bde$export$f362e1cb1a1602a0 = /* #__PURE__ */ function() {
    function Abstraction(value0) {
        this.value0 = value0;
    }
    Abstraction.create = function(value0) {
        return new Abstraction(value0);
    };
    return Abstraction;
}();
var $03b3e717ae197bde$export$c867a5c9595a1350 = /* #__PURE__ */ function() {
    function Variable(value0) {
        this.value0 = value0;
    }
    Variable.create = function(value0) {
        return new Variable(value0);
    };
    return Variable;
}();
var $03b3e717ae197bde$var$ParserComponentState = function(x) {
    return x;
};
var $03b3e717ae197bde$export$29abf071d92c5cc2 = /* #__PURE__ */ function() {
    function Parse(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Parse.create = function(value0) {
        return function(value1) {
            return new Parse(value0, value1);
        };
    };
    return Parse;
}();
var $03b3e717ae197bde$export$984065e3fb6b69ee = {
    to: function(x) {
        return new $03b3e717ae197bde$export$29abf071d92c5cc2(x.value0, x.value1);
    },
    from: function(x) {
        return new $cw1rg.Product(x.value0, x.value1);
    }
};
var $03b3e717ae197bde$export$9ff2c4d75dad0582 = {
    to: function(x) {
        if (x instanceof $cw1rg.Inl) return new $03b3e717ae197bde$export$16975c34e60e1e61(x.value0);
        if (x instanceof $cw1rg.Inr && x.value0 instanceof $cw1rg.Inl) return new $03b3e717ae197bde$export$f362e1cb1a1602a0(x.value0.value0);
        if (x instanceof $cw1rg.Inr && x.value0 instanceof $cw1rg.Inr) return new $03b3e717ae197bde$export$c867a5c9595a1350(x.value0.value0);
        throw new Error("Failed pattern match at Expr (line 78, column 1 - line 78, column 31): " + [
            x.constructor.name
        ]);
    },
    from: function(x) {
        if (x instanceof $03b3e717ae197bde$export$16975c34e60e1e61) return new $cw1rg.Inl(x.value0);
        if (x instanceof $03b3e717ae197bde$export$f362e1cb1a1602a0) return new $cw1rg.Inr(new $cw1rg.Inl(x.value0));
        if (x instanceof $03b3e717ae197bde$export$c867a5c9595a1350) return new $cw1rg.Inr(new $cw1rg.Inr(x.value0));
        throw new Error("Failed pattern match at Expr (line 78, column 1 - line 78, column 31): " + [
            x.constructor.name
        ]);
    }
};
var $03b3e717ae197bde$var$genericShow = /* #__PURE__ */ $7eHfd.genericShow($03b3e717ae197bde$export$9ff2c4d75dad0582);
var $03b3e717ae197bde$export$815507a0da5050dc = {
    show: function(e) {
        return $03b3e717ae197bde$var$genericShow($7eHfd.genericShowSum($7eHfd.genericShowConstructor($7eHfd.genericShowArgsArgument($03b3e717ae197bde$var$showRecord($03b3e717ae197bde$var$showRecordFieldsCons($03b3e717ae197bde$var$showRecordFieldsConsNil($03b3e717ae197bde$export$815507a0da5050dc))($03b3e717ae197bde$export$815507a0da5050dc))))($03b3e717ae197bde$var$ApplicationIsSymbol))($7eHfd.genericShowSum($7eHfd.genericShowConstructor($7eHfd.genericShowArgsArgument($03b3e717ae197bde$var$showRecord($03b3e717ae197bde$var$showRecordFieldsCons1($03b3e717ae197bde$var$showRecordFieldsConsNil1($03b3e717ae197bde$export$815507a0da5050dc))($3Orkn.showString))))($03b3e717ae197bde$var$AbstractionIsSymbol))($03b3e717ae197bde$var$genericShowConstructor1)))(e);
    }
};
var $03b3e717ae197bde$export$63270713d95b11c5 = {
    to: function(x) {
        if (x instanceof $cw1rg.Inl) return new $03b3e717ae197bde$export$768edaeb4b9bb9fc(x.value0);
        if (x instanceof $cw1rg.Inr && x.value0 instanceof $cw1rg.Inl) return new $03b3e717ae197bde$export$f3c7d3817e87cd1c(x.value0.value0);
        if (x instanceof $cw1rg.Inr && x.value0 instanceof $cw1rg.Inr) return new $03b3e717ae197bde$export$c6adf0fd0438e6e2(x.value0.value0);
        throw new Error("Failed pattern match at Expr (line 60, column 1 - line 60, column 36): " + [
            x.constructor.name
        ]);
    },
    from: function(x) {
        if (x instanceof $03b3e717ae197bde$export$768edaeb4b9bb9fc) return new $cw1rg.Inl(x.value0);
        if (x instanceof $03b3e717ae197bde$export$f3c7d3817e87cd1c) return new $cw1rg.Inr(new $cw1rg.Inl(x.value0));
        if (x instanceof $03b3e717ae197bde$export$c6adf0fd0438e6e2) return new $cw1rg.Inr(new $cw1rg.Inr(x.value0));
        throw new Error("Failed pattern match at Expr (line 60, column 1 - line 60, column 36): " + [
            x.constructor.name
        ]);
    }
};
var $03b3e717ae197bde$var$genericShow1 = /* #__PURE__ */ $7eHfd.genericShow($03b3e717ae197bde$export$63270713d95b11c5);
var $03b3e717ae197bde$export$e2a96a9c55414d39 = function(dictShow) {
    var genericShow2 = $03b3e717ae197bde$var$genericShow1($7eHfd.genericShowSum($7eHfd.genericShowConstructor($7eHfd.genericShowArgsArgument($03b3e717ae197bde$var$showRecord($03b3e717ae197bde$var$showRecordFieldsCons($03b3e717ae197bde$var$showRecordFieldsConsNil(dictShow))(dictShow))))($03b3e717ae197bde$var$ApplyFIsSymbol))($7eHfd.genericShowSum($7eHfd.genericShowConstructor($7eHfd.genericShowArgsArgument($03b3e717ae197bde$var$showRecord($03b3e717ae197bde$var$showRecordFieldsCons1($03b3e717ae197bde$var$showRecordFieldsConsNil1(dictShow))($3Orkn.showString))))($03b3e717ae197bde$var$LambdaFIsSymbol))($03b3e717ae197bde$var$genericShowConstructor2)));
    return {
        show: function(e) {
            return genericShow2(e);
        }
    };
};
var $03b3e717ae197bde$export$3e00d67c6d5da768 = {
    map: function(f) {
        return function(m) {
            if (m instanceof $03b3e717ae197bde$export$768edaeb4b9bb9fc) return new $03b3e717ae197bde$export$768edaeb4b9bb9fc({
                argument: f(m.value0.argument),
                "function": f(m["value0"]["function"])
            });
            if (m instanceof $03b3e717ae197bde$export$f3c7d3817e87cd1c) return new $03b3e717ae197bde$export$f3c7d3817e87cd1c({
                binder: m.value0.binder,
                body: f(m.value0.body)
            });
            if (m instanceof $03b3e717ae197bde$export$c6adf0fd0438e6e2) return new $03b3e717ae197bde$export$c6adf0fd0438e6e2(m.value0);
            throw new Error("Failed pattern match at Expr (line 0, column 0 - line 0, column 0): " + [
                m.constructor.name
            ]);
        };
    }
};
var $03b3e717ae197bde$export$842aded1e9f461fb = {
    project: function(v) {
        if (v instanceof $03b3e717ae197bde$export$16975c34e60e1e61) return new $03b3e717ae197bde$export$768edaeb4b9bb9fc(v.value0);
        if (v instanceof $03b3e717ae197bde$export$f362e1cb1a1602a0) return new $03b3e717ae197bde$export$f3c7d3817e87cd1c(v.value0);
        if (v instanceof $03b3e717ae197bde$export$c867a5c9595a1350) return new $03b3e717ae197bde$export$c6adf0fd0438e6e2(v.value0);
        throw new Error("Failed pattern match at Expr (line 85, column 13 - line 88, column 30): " + [
            v.constructor.name
        ]);
    },
    Functor0: function() {
        return $03b3e717ae197bde$export$3e00d67c6d5da768;
    }
};
var $03b3e717ae197bde$var$cata = /* #__PURE__ */ $lO7j1.cata($03b3e717ae197bde$export$842aded1e9f461fb);
var $03b3e717ae197bde$export$c13ed9096d953ad3 = {
    foldl: function(f) {
        return function(z) {
            return function(m) {
                if (m instanceof $03b3e717ae197bde$export$768edaeb4b9bb9fc) return f(f(z)(m.value0.argument))(m["value0"]["function"]);
                if (m instanceof $03b3e717ae197bde$export$f3c7d3817e87cd1c) return f(z)(m.value0.body);
                if (m instanceof $03b3e717ae197bde$export$c6adf0fd0438e6e2) return z;
                throw new Error("Failed pattern match at Expr (line 0, column 0 - line 0, column 0): " + [
                    m.constructor.name
                ]);
            };
        };
    },
    foldr: function(f) {
        return function(z) {
            return function(m) {
                if (m instanceof $03b3e717ae197bde$export$768edaeb4b9bb9fc) return f(m.value0.argument)(f(m["value0"]["function"])(z));
                if (m instanceof $03b3e717ae197bde$export$f3c7d3817e87cd1c) return f(m.value0.body)(z);
                if (m instanceof $03b3e717ae197bde$export$c6adf0fd0438e6e2) return z;
                throw new Error("Failed pattern match at Expr (line 0, column 0 - line 0, column 0): " + [
                    m.constructor.name
                ]);
            };
        };
    },
    foldMap: function(dictMonoid) {
        var append3 = $iwqgS.append(dictMonoid.Semigroup0());
        var mempty = $aknDF.mempty(dictMonoid);
        return function(f) {
            return function(m) {
                if (m instanceof $03b3e717ae197bde$export$768edaeb4b9bb9fc) return append3(f(m.value0.argument))(f(m["value0"]["function"]));
                if (m instanceof $03b3e717ae197bde$export$f3c7d3817e87cd1c) return f(m.value0.body);
                if (m instanceof $03b3e717ae197bde$export$c6adf0fd0438e6e2) return mempty;
                throw new Error("Failed pattern match at Expr (line 0, column 0 - line 0, column 0): " + [
                    m.constructor.name
                ]);
            };
        };
    }
};
var $03b3e717ae197bde$export$945ea170d2e3ce2e = {
    traverse: function(dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        var apply1 = $a5g3C.apply(Apply0);
        var map2 = $l0wDR.map(Apply0.Functor0());
        var pure4 = $gUTA8.pure(dictApplicative);
        return function(f) {
            return function(m) {
                if (m instanceof $03b3e717ae197bde$export$768edaeb4b9bb9fc) return apply1(map2(function(v1) {
                    return function(v2) {
                        return new $03b3e717ae197bde$export$768edaeb4b9bb9fc({
                            argument: v1,
                            "function": v2
                        });
                    };
                })(f(m.value0.argument)))(f(m["value0"]["function"]));
                if (m instanceof $03b3e717ae197bde$export$f3c7d3817e87cd1c) return map2(function(v1) {
                    return new $03b3e717ae197bde$export$f3c7d3817e87cd1c({
                        binder: m.value0.binder,
                        body: v1
                    });
                })(f(m.value0.body));
                if (m instanceof $03b3e717ae197bde$export$c6adf0fd0438e6e2) return pure4(new $03b3e717ae197bde$export$c6adf0fd0438e6e2(m.value0));
                throw new Error("Failed pattern match at Expr (line 0, column 0 - line 0, column 0): " + [
                    m.constructor.name
                ]);
            };
        };
    },
    sequence: function(dictApplicative) {
        return function(v) {
            return $1wR1l.traverse($03b3e717ae197bde$export$945ea170d2e3ce2e)(dictApplicative)($03b3e717ae197bde$var$identity)(v);
        };
    },
    Functor0: function() {
        return $03b3e717ae197bde$export$3e00d67c6d5da768;
    },
    Foldable1: function() {
        return $03b3e717ae197bde$export$c13ed9096d953ad3;
    }
};
var $03b3e717ae197bde$export$6632562b7fd9998b = function(dictEq) {
    var eq2 = $4MBcA.eq(dictEq);
    return {
        eq: function(x) {
            return function(y) {
                if (x instanceof $03b3e717ae197bde$export$768edaeb4b9bb9fc && y instanceof $03b3e717ae197bde$export$768edaeb4b9bb9fc) return eq2(x.value0.argument)(y.value0.argument) && eq2(x["value0"]["function"])(y["value0"]["function"]);
                if (x instanceof $03b3e717ae197bde$export$f3c7d3817e87cd1c && y instanceof $03b3e717ae197bde$export$f3c7d3817e87cd1c) return x.value0.binder === y.value0.binder && eq2(x.value0.body)(y.value0.body);
                if (x instanceof $03b3e717ae197bde$export$c6adf0fd0438e6e2 && y instanceof $03b3e717ae197bde$export$c6adf0fd0438e6e2) return x.value0 === y.value0;
                return false;
            };
        }
    };
};
var $03b3e717ae197bde$export$15567fdd932099c8 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $03b3e717ae197bde$export$16975c34e60e1e61 && y instanceof $03b3e717ae197bde$export$16975c34e60e1e61) return $4MBcA.eq($03b3e717ae197bde$export$15567fdd932099c8)(x.value0.argument)(y.value0.argument) && $4MBcA.eq($03b3e717ae197bde$export$15567fdd932099c8)(x["value0"]["function"])(y["value0"]["function"]);
            if (x instanceof $03b3e717ae197bde$export$f362e1cb1a1602a0 && y instanceof $03b3e717ae197bde$export$f362e1cb1a1602a0) return x.value0.binder === y.value0.binder && $4MBcA.eq($03b3e717ae197bde$export$15567fdd932099c8)(x.value0.body)(y.value0.body);
            if (x instanceof $03b3e717ae197bde$export$c867a5c9595a1350 && y instanceof $03b3e717ae197bde$export$c867a5c9595a1350) return x.value0 === y.value0;
            return false;
        };
    }
};
var $03b3e717ae197bde$var$eq1 = /* #__PURE__ */ $4MBcA.eq($03b3e717ae197bde$export$15567fdd932099c8);
var $03b3e717ae197bde$export$3c9cf7ab5d47add7 = {
    eq1: function(dictEq) {
        return $4MBcA.eq($03b3e717ae197bde$export$6632562b7fd9998b(dictEq));
    }
};
var $03b3e717ae197bde$export$8eaf5dc8e6a1f81a = {
    embed: function(v) {
        if (v instanceof $03b3e717ae197bde$export$768edaeb4b9bb9fc) return new $03b3e717ae197bde$export$16975c34e60e1e61(v.value0);
        if (v instanceof $03b3e717ae197bde$export$f3c7d3817e87cd1c) return new $03b3e717ae197bde$export$f362e1cb1a1602a0(v.value0);
        if (v instanceof $03b3e717ae197bde$export$c6adf0fd0438e6e2) return new $03b3e717ae197bde$export$c867a5c9595a1350(v.value0);
        throw new Error("Failed pattern match at Expr (line 91, column 11 - line 94, column 30): " + [
            v.constructor.name
        ]);
    },
    Functor0: function() {
        return $03b3e717ae197bde$export$3e00d67c6d5da768;
    }
};
var $03b3e717ae197bde$var$anaM = /* #__PURE__ */ $6rKEG.anaM($03b3e717ae197bde$export$8eaf5dc8e6a1f81a);
var $03b3e717ae197bde$export$3c5e7d1ad072e141 = function(e) {
    var p = function(arr) {
        return $jxBf5.cons($5tIT8.OpenParen.value)($jxBf5.snoc(arr)($5tIT8.CloseParen.value));
    };
    var lambda = function(l) {
        var arr = $jxBf5.cons($5tIT8.Lambda.value)($jxBf5.cons(new $5tIT8.Identifier(l.binder))($jxBf5.cons($5tIT8.Dot.value)(l.body(new $9MxTl.Tuple(true, true)))));
        return $l4M7e.const(function(v) {
            if (v) return arr;
            return p(arr);
        });
    };
    var apply1 = function(a) {
        return function(leading) {
            return function(trailing) {
                var f = a["function"](new $9MxTl.Tuple(true, false));
                if (leading) return $03b3e717ae197bde$var$append(f)(a.argument(new $9MxTl.Tuple(false, trailing)));
                return p($03b3e717ae197bde$var$append(f)(a.argument(new $9MxTl.Tuple(false, true))));
            };
        };
    };
    var coalg = function(v) {
        if (v instanceof $03b3e717ae197bde$export$768edaeb4b9bb9fc) return $9MxTl.uncurry(apply1(v.value0));
        if (v instanceof $03b3e717ae197bde$export$f3c7d3817e87cd1c) return $9MxTl.uncurry(lambda(v.value0));
        if (v instanceof $03b3e717ae197bde$export$c6adf0fd0438e6e2) return $l4M7e.const($jxBf5.cons$prime(new $5tIT8.Identifier(v.value0))([]));
        throw new Error("Failed pattern match at Expr (line 173, column 11 - line 176, column 51): " + [
            v.constructor.name
        ]);
    };
    return $03b3e717ae197bde$var$cata(coalg)(e)(new $9MxTl.Tuple(true, true));
};
var $03b3e717ae197bde$export$b3890eb0ae9dca99 = /* #__PURE__ */ function() {
    var multiApp = function(v) {
        if (v instanceof $03b3e717ae197bde$export$16975c34e60e1e61) {
            var $309 = multiApp(v["value0"]["function"]);
            return function($310) {
                return $309(function(v1) {
                    return $4VF0K.cons(v.value0.argument)(v1);
                }($310));
            };
        }
        return function(v1) {
            return $4VF0K.cons(v)(v1);
        };
    };
    var coalg = function(v) {
        if (v instanceof $03b3e717ae197bde$export$16975c34e60e1e61) return $jIMHU.div([
            $cLQJF.class_("expr_application")
        ])([
            $jIMHU.span([
                $cLQJF.class_("expr_application_root")
            ])([
                $hhMAk.text("@")
            ]),
            $jIMHU.div([
                $cLQJF.class_("expr_application_leaves")
            ])($03b3e717ae197bde$var$map(function($311) {
                return $hhMAk.widget($aKY4H.Left.create($311));
            })(multiApp(v["value0"]["function"])([
                v.value0.argument
            ])))
        ]);
        if (v instanceof $03b3e717ae197bde$export$f362e1cb1a1602a0) return $jIMHU.div([
            $cLQJF.class_("expr_abstraction")
        ])([
            $jIMHU.span([
                $cLQJF.class_("expr_abstraction_root")
            ])([
                $hhMAk.text("\u03bb "),
                $hhMAk.text(v.value0.binder)
            ]),
            $jIMHU.div([
                $cLQJF.class_("expr_abstraction_leaves")
            ])($03b3e717ae197bde$var$map(function($312) {
                return $hhMAk.widget($aKY4H.Left.create($312));
            })(multiApp(v.value0.body)([])))
        ]);
        if (v instanceof $03b3e717ae197bde$export$c867a5c9595a1350) return $jIMHU.div([
            $cLQJF.class_("expr_variable")
        ])([
            $hhMAk.text(v.value0)
        ]);
        throw new Error("Failed pattern match at Expr (line 242, column 11 - line 263, column 72): " + [
            v.constructor.name
        ]);
    };
    return $3Dhkl.unfoldHTML(coalg);
}();
var $03b3e717ae197bde$export$c2d084dc44961371 = /* #__PURE__ */ function() {
    var $313 = $5tIT8.printMany($cwMDv.foldableNonEmptyArray);
    return function($314) {
        return $313($03b3e717ae197bde$export$3c5e7d1ad072e141($314));
    };
}();
var $03b3e717ae197bde$var$ntParserComponentState = {
    Coercible0: function() {
        return undefined;
    }
};
var $03b3e717ae197bde$var$nextToken = /* #__PURE__ */ $27rSX.token(function(v) {
    return v.end;
});
var $03b3e717ae197bde$export$2b513308e642d699 = function(dictMonadRec) {
    var genAlphaString = $79GDW.genAlphaString(dictMonadRec);
    return function(dictMonadGen) {
        var Monad0 = dictMonadGen.Monad0();
        var map2 = $l0wDR.map(Monad0.Bind1().Apply0().Functor0());
        var genAlphaString1 = genAlphaString(dictMonadGen);
        var pure4 = $gUTA8.pure(Monad0.Applicative0());
        var oneOf1 = $8D18I.oneOf(dictMonadGen)($cwMDv.foldable1NonEmptyArray);
        var variable = map2($03b3e717ae197bde$export$c6adf0fd0438e6e2.create)(genAlphaString1);
        var coalg = function(sz) {
            var half = $6pI6x.quot(sz)(2);
            var abstraction = map2(function(v) {
                return new $03b3e717ae197bde$export$f3c7d3817e87cd1c({
                    binder: v,
                    body: $03b3e717ae197bde$var$max(0)(sz - 1 | 0)
                });
            })(genAlphaString1);
            var small = $jxBf5.cons$prime(abstraction)([
                variable
            ]);
            var large = $jxBf5.cons(pure4(new $03b3e717ae197bde$export$768edaeb4b9bb9fc({
                "function": half,
                argument: half
            })))(small);
            var $289 = sz <= 0;
            if ($289) return variable;
            return oneOf1(function() {
                var $290 = sz <= 1;
                if ($290) return small;
                return large;
            }());
        };
        return $kUmUH.sized(dictMonadGen)($03b3e717ae197bde$var$anaM(Monad0)($03b3e717ae197bde$export$945ea170d2e3ce2e)(coalg));
    };
};
var $03b3e717ae197bde$var$expr = function(e) {
    var lexeme = function(l) {
        return $1woEV.try($03b3e717ae197bde$var$bind($03b3e717ae197bde$var$nextToken)(function(v) {
            return $03b3e717ae197bde$var$when($03b3e717ae197bde$var$notEq(v.lexeme)(l))($3J9zV.fail("Expected " + $03b3e717ae197bde$var$show(l)));
        }));
    };
    var openParen = lexeme($5tIT8.OpenParen.value);
    var lambda = lexeme($5tIT8.Lambda.value);
    var identifier = $1woEV.try($03b3e717ae197bde$var$bind($03b3e717ae197bde$var$nextToken)(function(v) {
        if (v.lexeme instanceof $5tIT8.Identifier) return $03b3e717ae197bde$var$pure(v.lexeme.value0);
        return $3J9zV.fail("Expected an identifier");
    }));
    var dot = lexeme($5tIT8.Dot.value);
    var closeParen = lexeme($5tIT8.CloseParen.value);
    var atom = $03b3e717ae197bde$var$oneOf([
        $03b3e717ae197bde$var$map1($03b3e717ae197bde$export$c867a5c9595a1350.create)(identifier),
        $1woEV.between(openParen)(closeParen)(e),
        $3J9zV.fail("Expected an atom (identifier or parenthesized expression)")
    ]);
    var app = $03b3e717ae197bde$var$bind($03b3e717ae197bde$var$some($1woEV.try(atom)))(function(fs) {
        var i = $jxBf5.foldl1(function($$function) {
            return function(argument) {
                return new $03b3e717ae197bde$export$16975c34e60e1e61({
                    "function": $$function,
                    argument: argument
                });
            };
        })(fs);
        return $03b3e717ae197bde$var$bind($1woEV.optionMaybe($1woEV.try(e)))(function(t) {
            return $03b3e717ae197bde$var$pure(function() {
                if (t instanceof $ykHdR.Nothing) return i;
                if (t instanceof $ykHdR.Just) return new $03b3e717ae197bde$export$16975c34e60e1e61({
                    "function": i,
                    argument: t.value0
                });
                throw new Error("Failed pattern match at Expr (line 133, column 12 - line 135, column 57): " + [
                    t.constructor.name
                ]);
            }());
        });
    });
    var abs = $03b3e717ae197bde$var$apply($03b3e717ae197bde$var$apply($03b3e717ae197bde$var$apply($03b3e717ae197bde$var$map1(function(v) {
        return function(v1) {
            return function(v2) {
                return function(v3) {
                    return new $03b3e717ae197bde$export$f362e1cb1a1602a0({
                        binder: v1,
                        body: v3
                    });
                };
            };
        };
    })(lambda))(identifier))(dot))(e);
    return $03b3e717ae197bde$var$oneOf([
        abs,
        app,
        $3J9zV.fail("Expected lambda, application, or identifier")
    ]);
};
var $03b3e717ae197bde$export$743d82c2fd345b72 = /* #__PURE__ */ $dTFzl.fix($3J9zV.lazyParserT)($03b3e717ae197bde$var$expr);
var $03b3e717ae197bde$var$parseQuery = function(v) {
    var v1 = $3J9zV.runParser(v.value0)($03b3e717ae197bde$var$applyFirst($03b3e717ae197bde$export$743d82c2fd345b72)($1woEV.notFollowedBy($03b3e717ae197bde$var$nextToken)));
    if (v1 instanceof $aKY4H.Left) return $03b3e717ae197bde$var$discard($03b3e717ae197bde$var$modify_($03b3e717ae197bde$var$over($03b3e717ae197bde$var$ParserComponentState)(function(v2) {
        return {
            lastExpression: v2.lastExpression,
            parseError: new $ykHdR.Just(v1.value0)
        };
    })))(function() {
        return $03b3e717ae197bde$var$pure1($ykHdR.Nothing.value);
    });
    if (v1 instanceof $aKY4H.Right) return $03b3e717ae197bde$var$discard($03b3e717ae197bde$var$put({
        parseError: $ykHdR.Nothing.value,
        lastExpression: new $ykHdR.Just(v1.value0)
    }))(function() {
        return $03b3e717ae197bde$var$pure1(new $ykHdR.Just(v.value1(v1.value0)));
    });
    throw new Error("Failed pattern match at Expr (line 205, column 3 - line 211, column 31): " + [
        v1.constructor.name
    ]);
};
var $03b3e717ae197bde$export$b1b56d7cac5b0820 = /* #__PURE__ */ function() {
    var renderComponent = function(v) {
        return $jIMHU.div([
            $cLQJF.class_("parser")
        ])($03b3e717ae197bde$var$append2($ykHdR.maybe([])(function(pe) {
            return $03b3e717ae197bde$var$pure2($3Dhkl.overlay([
                "parser_error"
            ])([
                $hhMAk.text($03b3e717ae197bde$var$show1(pe))
            ]));
        })(v.parseError))($ykHdR.maybe([])(function(ex) {
            return $03b3e717ae197bde$var$pure2($03b3e717ae197bde$export$b3890eb0ae9dca99(ex));
        })(v.lastExpression)));
    };
    return $kugLX.mkComponent({
        initialState: $l4M7e.const({
            parseError: $ykHdR.Nothing.value,
            lastExpression: $ykHdR.Nothing.value
        }),
        render: renderComponent,
        "eval": $kugLX.mkEval({
            initialize: $ykHdR.Nothing.value,
            receive: $l4M7e.const($ykHdR.Nothing.value),
            handleAction: $l4M7e.const($03b3e717ae197bde$var$pure1($r2HHk.unit)),
            handleQuery: $03b3e717ae197bde$var$parseQuery,
            finalize: $ykHdR.Nothing.value
        })
    });
}();
var $03b3e717ae197bde$export$ac1935695b51734d = function(x) {
    var rt = $03b3e717ae197bde$var$bind1($3J9zV.runParser($03b3e717ae197bde$export$c2d084dc44961371(x))($03b3e717ae197bde$var$tokens($5tIT8.parser)))(function(toks) {
        return $03b3e717ae197bde$var$bind1($3J9zV.runParser(toks)($03b3e717ae197bde$export$743d82c2fd345b72))(function(y) {
            return $03b3e717ae197bde$var$pure3($03b3e717ae197bde$var$eq1(x)(y));
        });
    });
    if (rt instanceof $aKY4H.Left) return false;
    if (rt instanceof $aKY4H.Right) return rt.value0;
    throw new Error("Failed pattern match at Expr (line 182, column 21 - line 184, column 15): " + [
        rt.constructor.name
    ]);
};

});
parcelRegister("8D18I", function(module, exports) {

$parcel$export(module.exports, "unfoldable", () => $6482d98559452a87$export$62262501c20ccc48);
$parcel$export(module.exports, "oneOf", () => $6482d98559452a87$export$a9a18ae5ba42aeab);
// Generated by purs version 0.15.16

var $gUTA8 = parcelRequire("gUTA8");

var $9Grh5 = parcelRequire("9Grh5");

var $kUmUH = parcelRequire("kUmUH");

var $lowBm = parcelRequire("lowBm");

var $6UHO6 = parcelRequire("6UHO6");

var $6RkEA = parcelRequire("6RkEA");

var $l0wDR = parcelRequire("l0wDR");

var $ykHdR = parcelRequire("ykHdR");

var $jCCb5 = parcelRequire("jCCb5");

var $6PW1p = parcelRequire("6PW1p");

var $IFMV2 = parcelRequire("IFMV2");

var $2aTu9 = parcelRequire("2aTu9");

var $gyPYh = parcelRequire("gyPYh");

var $9MxTl = parcelRequire("9MxTl");

var $hsyEi = parcelRequire("hsyEi");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");
var $6482d98559452a87$var$un = /* #__PURE__ */ $6PW1p.un();
var $6482d98559452a87$var$alaF = /* #__PURE__ */ $6PW1p.alaF()()()();
var $6482d98559452a87$var$monoidAdditive = /* #__PURE__ */ $jCCb5.monoidAdditive($gyPYh.semiringNumber);
var $6482d98559452a87$var$Cons = /* #__PURE__ */ function() {
    function Cons(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Cons.create = function(value0) {
        return function(value1) {
            return new Cons(value0, value1);
        };
    };
    return Cons;
}();
var $6482d98559452a87$var$Nil = /* #__PURE__ */ function() {
    function Nil() {}
    Nil.value = new Nil();
    return Nil;
}();
var $6482d98559452a87$var$FreqSemigroup = function(x) {
    return x;
};
var $6482d98559452a87$export$62262501c20ccc48 = function(dictMonadRec) {
    var tailRecM = $lowBm.tailRecM(dictMonadRec);
    return function(dictMonadGen) {
        var Monad0 = dictMonadGen.Monad0();
        var pure = $gUTA8.pure(Monad0.Applicative0());
        var Bind1 = Monad0.Bind1();
        var bind = $9Grh5.bind(Bind1);
        var map = $l0wDR.map(Bind1.Apply0().Functor0());
        var sized = $kUmUH.sized(dictMonadGen);
        return function(dictUnfoldable) {
            var unfoldr = $hsyEi.unfoldr(dictUnfoldable);
            return function(gen) {
                var unfold = function(v) {
                    if (v instanceof $6482d98559452a87$var$Nil) return $ykHdR.Nothing.value;
                    if (v instanceof $6482d98559452a87$var$Cons) return new $ykHdR.Just(new $9MxTl.Tuple(v.value0, v.value1));
                    throw new Error("Failed pattern match at Control.Monad.Gen (line 102, column 12 - line 104, column 35): " + [
                        v.constructor.name
                    ]);
                };
                var loopGen = function(v) {
                    if (v.value1 <= 0) return pure(new $lowBm.Done(v.value0));
                    if ($6UHO6.otherwise) return bind(gen)(function(x) {
                        return pure(new $lowBm.Loop(new $9MxTl.Tuple(new $6482d98559452a87$var$Cons(x, v.value0), v.value1 - 1 | 0)));
                    });
                    throw new Error("Failed pattern match at Control.Monad.Gen (line 94, column 3 - line 94, column 68): " + [
                        v.constructor.name
                    ]);
                };
                return map(unfoldr(unfold))(sized(function() {
                    var $126 = tailRecM(loopGen);
                    var $127 = $9MxTl.Tuple.create($6482d98559452a87$var$Nil.value);
                    return function($128) {
                        return $126($127($128));
                    };
                }()));
            };
        };
    };
};
var $6482d98559452a87$var$semigroupFreqSemigroup = {
    append: function(v) {
        return function(v1) {
            return function(pos) {
                var v2 = v(pos);
                if (v2.value0 instanceof $ykHdR.Just) return v1(v2.value0.value0);
                return v2;
            };
        };
    }
};
var $6482d98559452a87$var$getFreqVal = function(v) {
    return function($129) {
        return $9MxTl.snd(v($129));
    };
};
var $6482d98559452a87$var$fromIndex = function(dictFoldable1) {
    var foldMap1 = $IFMV2.foldMap1(dictFoldable1)($2aTu9.semigroupLast);
    var foldr = $6RkEA.foldr(dictFoldable1.Foldable0());
    return function(i) {
        return function(xs) {
            var go = function($copy_v) {
                return function($copy_v1) {
                    var $tco_var_v = $copy_v;
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(v, v1) {
                        if (v1 instanceof $6482d98559452a87$var$Cons && v1.value1 instanceof $6482d98559452a87$var$Nil) {
                            $tco_done = true;
                            return v1.value0;
                        }
                        if (v1 instanceof $6482d98559452a87$var$Cons && v <= 0) {
                            $tco_done = true;
                            return v1.value0;
                        }
                        if (v1 instanceof $6482d98559452a87$var$Cons) {
                            $tco_var_v = v - 1 | 0;
                            $copy_v1 = v1.value1;
                            return;
                        }
                        if (v1 instanceof $6482d98559452a87$var$Nil) {
                            $tco_done = true;
                            return $6482d98559452a87$var$un($2aTu9.Last)(foldMap1($2aTu9.Last)(xs));
                        }
                        throw new Error("Failed pattern match at Control.Monad.Gen (line 128, column 5 - line 128, column 26): " + [
                            v.constructor.name,
                            v1.constructor.name
                        ]);
                    }
                    while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
                    return $tco_result;
                };
            };
            return go(i)(foldr($6482d98559452a87$var$Cons.create)($6482d98559452a87$var$Nil.value)(xs));
        };
    };
};
var $6482d98559452a87$export$a9a18ae5ba42aeab = function(dictMonadGen) {
    var bind = $9Grh5.bind(dictMonadGen.Monad0().Bind1());
    var chooseInt = $kUmUH.chooseInt(dictMonadGen);
    return function(dictFoldable1) {
        var length = $6RkEA.length(dictFoldable1.Foldable0())($gyPYh.semiringInt);
        var fromIndex1 = $6482d98559452a87$var$fromIndex(dictFoldable1);
        return function(xs) {
            return bind(chooseInt(0)(length(xs) - 1 | 0))(function(n) {
                return fromIndex1(n)(xs);
            });
        };
    };
};
var $6482d98559452a87$var$freqSemigroup = function(v) {
    return function(pos) {
        var $119 = pos >= v.value0;
        if ($119) return new $9MxTl.Tuple(new $ykHdR.Just(pos - v.value0), v.value1);
        return new $9MxTl.Tuple($ykHdR.Nothing.value, v.value1);
    };
};
var $6482d98559452a87$export$7ca27958f28e2974 = function(dictMonadGen) {
    var bind = $9Grh5.bind(dictMonadGen.Monad0().Bind1());
    var chooseFloat = $kUmUH.chooseFloat(dictMonadGen);
    return function(dictFoldable1) {
        var foldMap = $6RkEA.foldMap(dictFoldable1.Foldable0())($6482d98559452a87$var$monoidAdditive);
        var foldMap1 = $IFMV2.foldMap1(dictFoldable1)($6482d98559452a87$var$semigroupFreqSemigroup);
        return function(xs) {
            var total = $6482d98559452a87$var$alaF($jCCb5.Additive)(foldMap)($9MxTl.fst)(xs);
            return bind(chooseFloat(0.0)(total))($6482d98559452a87$var$getFreqVal(foldMap1($6482d98559452a87$var$freqSemigroup)(xs)));
        };
    };
};
var $6482d98559452a87$export$8082fa36f85e6b63 = function(dictMonadRec) {
    var tailRecM = $lowBm.tailRecM(dictMonadRec);
    return function(dictMonadGen) {
        var mapFlipped = $l0wDR.mapFlipped(dictMonadGen.Monad0().Bind1().Apply0().Functor0());
        return function(gen) {
            var go = function(v) {
                return mapFlipped(gen)(function(a) {
                    if (a instanceof $ykHdR.Nothing) return new $lowBm.Loop($r2HHk.unit);
                    if (a instanceof $ykHdR.Just) return new $lowBm.Done(a.value0);
                    throw new Error("Failed pattern match at Control.Monad.Gen (line 118, column 24 - line 120, column 23): " + [
                        a.constructor.name
                    ]);
                });
            };
            return tailRecM(go)($r2HHk.unit);
        };
    };
};
var $6482d98559452a87$export$a7e2a49ace6c34c5 = function(dictMonadRec) {
    var filtered1 = $6482d98559452a87$export$8082fa36f85e6b63(dictMonadRec);
    return function(dictMonadGen) {
        var filtered2 = filtered1(dictMonadGen);
        var mapFlipped = $l0wDR.mapFlipped(dictMonadGen.Monad0().Bind1().Apply0().Functor0());
        return function(gen) {
            return function(pred) {
                return filtered2(mapFlipped(gen)(function(a) {
                    var $124 = pred(a);
                    if ($124) return new $ykHdR.Just(a);
                    return $ykHdR.Nothing.value;
                }));
            };
        };
    };
};
var $6482d98559452a87$export$7a5d735b2ab6389d = function(dictMonadGen) {
    var Monad0 = dictMonadGen.Monad0();
    var bind = $9Grh5.bind(Monad0.Bind1());
    var chooseInt = $kUmUH.chooseInt(dictMonadGen);
    var pure = $gUTA8.pure(Monad0.Applicative0());
    return function(dictFoldable1) {
        var length = $6RkEA.length(dictFoldable1.Foldable0())($gyPYh.semiringInt);
        var fromIndex1 = $6482d98559452a87$var$fromIndex(dictFoldable1);
        return function(xs) {
            return bind(chooseInt(0)(length(xs) - 1 | 0))(function(n) {
                return pure(fromIndex1(n)(xs));
            });
        };
    };
};
var $6482d98559452a87$export$7877a478dd30fd3d = function(dictMonadGen) {
    var bind = $9Grh5.bind(dictMonadGen.Monad0().Bind1());
    var chooseBool = $kUmUH.chooseBool(dictMonadGen);
    return function(genA) {
        return function(genB) {
            return bind(chooseBool)(function(v) {
                if (v) return genA;
                return genB;
            });
        };
    };
};

});
parcelRegister("kUmUH", function(module, exports) {

$parcel$export(module.exports, "sized", () => $f38acfbf15955b73$export$c1c8be52b85daeca);
$parcel$export(module.exports, "resize", () => $f38acfbf15955b73$export$4380c87abf28fdf);
$parcel$export(module.exports, "chooseInt", () => $f38acfbf15955b73$export$24b3f9c3c8227daa);
$parcel$export(module.exports, "chooseFloat", () => $f38acfbf15955b73$export$73d56bd430e66c0c);
$parcel$export(module.exports, "chooseBool", () => $f38acfbf15955b73$export$ed1be54c7ccedf5b);
// Generated by purs version 0.15.16
var $f38acfbf15955b73$export$c1c8be52b85daeca = function(dict) {
    return dict.sized;
};
var $f38acfbf15955b73$export$4380c87abf28fdf = function(dict) {
    return dict.resize;
};
var $f38acfbf15955b73$export$24b3f9c3c8227daa = function(dict) {
    return dict.chooseInt;
};
var $f38acfbf15955b73$export$73d56bd430e66c0c = function(dict) {
    return dict.chooseFloat;
};
var $f38acfbf15955b73$export$ed1be54c7ccedf5b = function(dict) {
    return dict.chooseBool;
};

});

parcelRegister("2aTu9", function(module, exports) {

$parcel$export(module.exports, "Last", () => $19578e25953179c0$export$bed9238d8933c9a8);
$parcel$export(module.exports, "semigroupLast", () => $19578e25953179c0$export$6d3c4648150c5bae);
// Generated by purs version 0.15.16

var $4MBcA = parcelRequire("4MBcA");

var $d0PPW = parcelRequire("d0PPW");

var $3Orkn = parcelRequire("3Orkn");
var $19578e25953179c0$export$bed9238d8933c9a8 = function(x) {
    return x;
};
var $19578e25953179c0$export$1e0d830d3054d46d = function(dictShow) {
    var show = $3Orkn.show(dictShow);
    return {
        show: function(v) {
            return "(Last " + (show(v) + ")");
        }
    };
};
var $19578e25953179c0$export$6d3c4648150c5bae = {
    append: function(v) {
        return function(x) {
            return x;
        };
    }
};
var $19578e25953179c0$export$4ded69d4b0c99b7b = function(dictOrd) {
    return dictOrd;
};
var $19578e25953179c0$export$74aba74241121413 = {
    map: function(f) {
        return function(m) {
            return f(m);
        };
    }
};
var $19578e25953179c0$export$4dd70ef4fbe4d1f3 = function(dictEq) {
    return dictEq;
};
var $19578e25953179c0$export$634a54207b73ac14 = {
    eq1: function(dictEq) {
        return $4MBcA.eq($19578e25953179c0$export$4dd70ef4fbe4d1f3(dictEq));
    }
};
var $19578e25953179c0$export$64bd44ceff2f4638 = {
    compare1: function(dictOrd) {
        return $d0PPW.compare($19578e25953179c0$export$4ded69d4b0c99b7b(dictOrd));
    },
    Eq10: function() {
        return $19578e25953179c0$export$634a54207b73ac14;
    }
};
var $19578e25953179c0$export$835f68c2f339b021 = function(dictBounded) {
    return dictBounded;
};
var $19578e25953179c0$export$dcd798c84777f95 = {
    apply: function(v) {
        return function(v1) {
            return v(v1);
        };
    },
    Functor0: function() {
        return $19578e25953179c0$export$74aba74241121413;
    }
};
var $19578e25953179c0$export$f2b93d1f1ac78d51 = {
    bind: function(v) {
        return function(f) {
            return f(v);
        };
    },
    Apply0: function() {
        return $19578e25953179c0$export$dcd798c84777f95;
    }
};
var $19578e25953179c0$export$5b4de68c5dd33934 = {
    pure: $19578e25953179c0$export$bed9238d8933c9a8,
    Apply0: function() {
        return $19578e25953179c0$export$dcd798c84777f95;
    }
};
var $19578e25953179c0$export$25d122cd3cbaf721 = {
    Applicative0: function() {
        return $19578e25953179c0$export$5b4de68c5dd33934;
    },
    Bind1: function() {
        return $19578e25953179c0$export$f2b93d1f1ac78d51;
    }
};

});

parcelRegister("hsyEi", function(module, exports) {

$parcel$export(module.exports, "unfoldr", () => $cb5fedc2c4837e1c$export$df2b8ee1690308ae);
$parcel$export(module.exports, "unfoldableArray", () => $cb5fedc2c4837e1c$export$2b90ca20b4b58da5);
$parcel$export(module.exports, "none", () => $cb5fedc2c4837e1c$export$f883a24d5edde77c);
// Generated by purs version 0.15.16

var $9hXpT = parcelRequire("9hXpT");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");

var $ykHdR = parcelRequire("ykHdR");

var $1wR1l = parcelRequire("1wR1l");

var $9MxTl = parcelRequire("9MxTl");

var $hNKjN = parcelRequire("hNKjN");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");
var $cb5fedc2c4837e1c$var$map = /* #__PURE__ */ $l0wDR.map($ykHdR.functorMaybe);
var $cb5fedc2c4837e1c$var$fromJust = /* #__PURE__ */ $ykHdR.fromJust();
var $cb5fedc2c4837e1c$export$df2b8ee1690308ae = function(dict) {
    return dict.unfoldr;
};
var $cb5fedc2c4837e1c$export$b5169c61b27df85a = {
    unfoldr: function(f) {
        return function(b) {
            return $cb5fedc2c4837e1c$var$map($9MxTl.fst)(f(b));
        };
    },
    Unfoldable10: function() {
        return $hNKjN.unfoldable1Maybe;
    }
};
var $cb5fedc2c4837e1c$export$2b90ca20b4b58da5 = {
    unfoldr: /* #__PURE__ */ $9hXpT.unfoldrArrayImpl($ykHdR.isNothing)($cb5fedc2c4837e1c$var$fromJust)($9MxTl.fst)($9MxTl.snd),
    Unfoldable10: function() {
        return $hNKjN.unfoldable1Array;
    }
};
var $cb5fedc2c4837e1c$export$606959e7ccb797f0 = function(dictUnfoldable) {
    var unfoldr1 = $cb5fedc2c4837e1c$export$df2b8ee1690308ae(dictUnfoldable);
    return function(n) {
        return function(v) {
            var step = function(i) {
                var $17 = i <= 0;
                if ($17) return $ykHdR.Nothing.value;
                return new $ykHdR.Just(new $9MxTl.Tuple(v, i - 1 | 0));
            };
            return unfoldr1(step)(n);
        };
    };
};
var $cb5fedc2c4837e1c$export$1e1bbcb33c108a24 = function(dictApplicative) {
    return function(dictUnfoldable) {
        var replicate1 = $cb5fedc2c4837e1c$export$606959e7ccb797f0(dictUnfoldable);
        return function(dictTraversable) {
            var sequence = $1wR1l.sequence(dictTraversable)(dictApplicative);
            return function(n) {
                return function(m) {
                    return sequence(replicate1(n)(m));
                };
            };
        };
    };
};
var $cb5fedc2c4837e1c$export$f883a24d5edde77c = function(dictUnfoldable) {
    return $cb5fedc2c4837e1c$export$df2b8ee1690308ae(dictUnfoldable)($l4M7e.const($ykHdR.Nothing.value))($r2HHk.unit);
};
var $cb5fedc2c4837e1c$export$43db023a260c5e9f = function(dictUnfoldable) {
    return $cb5fedc2c4837e1c$export$df2b8ee1690308ae(dictUnfoldable)(function(b) {
        return $cb5fedc2c4837e1c$var$map($l4M7e.flip($9MxTl.Tuple.create)($ykHdR.Nothing.value))(b);
    });
};

});
parcelRegister("9hXpT", function(module, exports) {

$parcel$export(module.exports, "unfoldrArrayImpl", () => $6c33ca7d98a534e5$export$6368c6d238d348f0);
const $6c33ca7d98a534e5$export$6368c6d238d348f0 = function(isNothing) {
    return function(fromJust) {
        return function(fst) {
            return function(snd) {
                return function(f) {
                    return function(b) {
                        var result = [];
                        var value = b;
                        while(true){
                            var maybe = f(value);
                            if (isNothing(maybe)) return result;
                            var tuple = fromJust(maybe);
                            result.push(fst(tuple));
                            value = snd(tuple);
                        }
                    };
                };
            };
        };
    };
};

});

parcelRegister("hNKjN", function(module, exports) {

$parcel$export(module.exports, "unfoldr1", () => $cf5af1199a495394$export$158c052536266a97);
$parcel$export(module.exports, "unfoldable1Maybe", () => $cf5af1199a495394$export$b5ac0a9881e433c3);
$parcel$export(module.exports, "unfoldable1Array", () => $cf5af1199a495394$export$587ba9a9bf3cf8b4);
$parcel$export(module.exports, "singleton", () => $cf5af1199a495394$export$439306a4dcaafbb9);
// Generated by purs version 0.15.16

var $fcZ1U = parcelRequire("fcZ1U");

var $6UHO6 = parcelRequire("6UHO6");

var $ykHdR = parcelRequire("ykHdR");

var $jERGJ = parcelRequire("jERGJ");

var $9MxTl = parcelRequire("9MxTl");
var $cf5af1199a495394$var$fromJust = /* #__PURE__ */ $ykHdR.fromJust();
var $cf5af1199a495394$export$158c052536266a97 = function(dict) {
    return dict.unfoldr1;
};
var $cf5af1199a495394$export$b5ac0a9881e433c3 = {
    unfoldr1: function(f) {
        return function(b) {
            return new $ykHdR.Just($9MxTl.fst(f(b)));
        };
    }
};
var $cf5af1199a495394$export$587ba9a9bf3cf8b4 = {
    unfoldr1: /* #__PURE__ */ $fcZ1U.unfoldr1ArrayImpl($ykHdR.isNothing)($cf5af1199a495394$var$fromJust)($9MxTl.fst)($9MxTl.snd)
};
var $cf5af1199a495394$export$dcb5d70039e504cd = function(dictUnfoldable1) {
    var unfoldr11 = $cf5af1199a495394$export$158c052536266a97(dictUnfoldable1);
    return function(n) {
        return function(v) {
            var step = function(i) {
                if (i <= 0) return new $9MxTl.Tuple(v, $ykHdR.Nothing.value);
                if ($6UHO6.otherwise) return new $9MxTl.Tuple(v, new $ykHdR.Just(i - 1 | 0));
                throw new Error("Failed pattern match at Data.Unfoldable1 (line 68, column 5 - line 68, column 39): " + [
                    i.constructor.name
                ]);
            };
            return unfoldr11(step)(n - 1 | 0);
        };
    };
};
var $cf5af1199a495394$export$d2a13fab7d8f2b56 = function(dictApply) {
    return function(dictUnfoldable1) {
        var replicate11 = $cf5af1199a495394$export$dcb5d70039e504cd(dictUnfoldable1);
        return function(dictTraversable1) {
            var sequence1 = $jERGJ.sequence1(dictTraversable1)(dictApply);
            return function(n) {
                return function(m) {
                    return sequence1(replicate11(n)(m));
                };
            };
        };
    };
};
var $cf5af1199a495394$export$439306a4dcaafbb9 = function(dictUnfoldable1) {
    return $cf5af1199a495394$export$dcb5d70039e504cd(dictUnfoldable1)(1);
};
var $cf5af1199a495394$export$d02631cccf789723 = function(dictUnfoldable1) {
    var unfoldr11 = $cf5af1199a495394$export$158c052536266a97(dictUnfoldable1);
    return function(start) {
        return function(end) {
            var go = function(delta) {
                return function(i) {
                    var i$prime = i + delta | 0;
                    return new $9MxTl.Tuple(i, function() {
                        var $25 = i === end;
                        if ($25) return $ykHdR.Nothing.value;
                        return new $ykHdR.Just(i$prime);
                    }());
                };
            };
            var delta = function() {
                var $26 = end >= start;
                if ($26) return 1;
                return -1;
            }();
            return unfoldr11(go(delta))(start);
        };
    };
};
var $cf5af1199a495394$export$f1977d76a1a6e399 = function(dictUnfoldable1) {
    var unfoldr11 = $cf5af1199a495394$export$158c052536266a97(dictUnfoldable1);
    return function(n) {
        return function(f) {
            return function(s) {
                var go = function(v) {
                    return new $9MxTl.Tuple(v.value0, function() {
                        var $28 = v.value1 > 0;
                        if ($28) return new $ykHdR.Just(new $9MxTl.Tuple(f(v.value0), v.value1 - 1 | 0));
                        return $ykHdR.Nothing.value;
                    }());
                };
                return unfoldr11(go)(new $9MxTl.Tuple(s, n - 1 | 0));
            };
        };
    };
};

});
parcelRegister("fcZ1U", function(module, exports) {

$parcel$export(module.exports, "unfoldr1ArrayImpl", () => $b1275140774187c9$export$e3753a19e82ccedc);
const $b1275140774187c9$export$e3753a19e82ccedc = function(isNothing) {
    return function(fromJust) {
        return function(fst) {
            return function(snd) {
                return function(f) {
                    return function(b) {
                        var result = [];
                        var value = b;
                        while(true){
                            var tuple = f(value);
                            result.push(fst(tuple));
                            var maybe = snd(tuple);
                            if (isNothing(maybe)) return result;
                            value = fromJust(maybe);
                        }
                    };
                };
            };
        };
    };
};

});




parcelRegister("3Dhkl", function(module, exports) {

$parcel$export(module.exports, "unfoldHTML", () => $2a52746d99c3c6d7$export$9c6beb914fa11a42);
$parcel$export(module.exports, "overlay", () => $2a52746d99c3c6d7$export$29dd17c7f3c81c36);
// Generated by purs version 0.15.16

var $7T8P4 = parcelRequire("7T8P4");

var $4VF0K = parcelRequire("4VF0K");
var $lGiKR = parcelRequire("lGiKR");

var $2Mmje = parcelRequire("2Mmje");

var $aKY4H = parcelRequire("aKY4H");

var $4MBcA = parcelRequire("4MBcA");

var $ykHdR = parcelRequire("ykHdR");

var $hhMAk = parcelRequire("hhMAk");

var $jIMHU = parcelRequire("jIMHU");

var $cLQJF = parcelRequire("cLQJF");

var $gorft = parcelRequire("gorft");
var $2a52746d99c3c6d7$var$identity = /* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn);
var $2a52746d99c3c6d7$var$lmap = /* #__PURE__ */ $2Mmje.lmap($hhMAk.bifunctorHTML);
var $2a52746d99c3c6d7$var$eq1 = /* #__PURE__ */ $4MBcA.eq($4MBcA.eqString);
var $2a52746d99c3c6d7$var$eq2 = /* #__PURE__ */ $4MBcA.eq(/* #__PURE__ */ $ykHdR.eqMaybe($gorft.eqNamespace));
var $2a52746d99c3c6d7$var$eq3 = /* #__PURE__ */ $4MBcA.eq($gorft.eqElemName);
var $2a52746d99c3c6d7$export$9c6beb914fa11a42 = function(c) {
    var u = function(x) {
        return $hhMAk.renderWidget($2a52746d99c3c6d7$var$identity)($aKY4H.either(u)($hhMAk.widget))(c(x));
    };
    return u;
};
var $2a52746d99c3c6d7$export$76777a5c08c1dbda = function(c) {
    return $2a52746d99c3c6d7$export$9c6beb914fa11a42(function() {
        var $60 = $2a52746d99c3c6d7$var$lmap($aKY4H.Left.create);
        return function($61) {
            return $60(c($61));
        };
    }());
};
var $2a52746d99c3c6d7$export$29dd17c7f3c81c36 = function(panel_classes) {
    return function(contents) {
        return $jIMHU.div([
            $cLQJF.class_("overlay")
        ])([
            $jIMHU.div([
                $cLQJF.classes(panel_classes)
            ])([
                $jIMHU.div([
                    $cLQJF.class_("overlay_content")
                ])(contents)
            ])
        ]);
    };
};
var $2a52746d99c3c6d7$var$eqTuple = function(eqX) {
    return function(eqY) {
        return function(v) {
            return function(v1) {
                return eqX(v.value0)(v1.value0) && eqY(v.value1)(v1.value1);
            };
        };
    };
};
var $2a52746d99c3c6d7$var$eqArray = function(eqElem) {
    return function(l) {
        return function(r) {
            var eqIndexed = function(v) {
                return function(v1) {
                    if (v instanceof $ykHdR.Just && v1 instanceof $ykHdR.Just) return eqElem(v.value0)(v1.value0);
                    return false;
                };
            };
            var loop = function(ll) {
                var lloop = function(i) {
                    var $31 = ll <= i;
                    if ($31) return true;
                    return eqIndexed($4VF0K.index(l)(i))($4VF0K.index(r)(i)) && lloop(1 + i | 0);
                };
                return lloop;
            };
            return $lGiKR.length(l) === $lGiKR.length(r) && loop($lGiKR.length(l))(0);
        };
    };
};
var $2a52746d99c3c6d7$export$ee748ddedd836b87 = function(eqAttr) {
    return function(eqWidget) {
        var eqNoGraft = function(v) {
            return function(v1) {
                if (v instanceof $gorft.Text && v1 instanceof $gorft.Text) return v.value0 === v1.value0;
                if (v instanceof $gorft.Elem && v1 instanceof $gorft.Elem) return $2a52746d99c3c6d7$var$eq2(v.value0)(v1.value0) && $2a52746d99c3c6d7$var$eq3(v.value1)(v1.value1) && eqAttr(v.value2)(v1.value2) && $2a52746d99c3c6d7$var$eqArray(deGraft)(v.value3)(v1.value3);
                if (v instanceof $gorft.Keyed && v1 instanceof $gorft.Keyed) return $2a52746d99c3c6d7$var$eq2(v.value0)(v1.value0) && $2a52746d99c3c6d7$var$eq3(v.value1)(v1.value1) && eqAttr(v.value2)(v1.value2) && $2a52746d99c3c6d7$var$eqArray($2a52746d99c3c6d7$var$eqTuple($2a52746d99c3c6d7$var$eq1)(deGraft))(v.value3)(v1.value3);
                if (v instanceof $gorft.Widget && v1 instanceof $gorft.Widget) return eqWidget(v.value0)(v1.value0);
                return false;
            };
        };
        var deGraft = function($copy_v) {
            return function($copy_v1) {
                var $tco_var_v = $copy_v;
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(v, v1) {
                    if (v instanceof $gorft.Grafted && v1 instanceof $gorft.Grafted) {
                        $tco_var_v = $gorft.runGraft(v.value0);
                        $copy_v1 = $gorft.runGraft(v1.value0);
                        return;
                    }
                    if (v instanceof $gorft.Grafted) {
                        $tco_var_v = $gorft.runGraft(v.value0);
                        $copy_v1 = v1;
                        return;
                    }
                    if (v1 instanceof $gorft.Grafted) {
                        $tco_var_v = v;
                        $copy_v1 = $gorft.runGraft(v1.value0);
                        return;
                    }
                    $tco_done = true;
                    return eqNoGraft(v)(v1);
                }
                while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
                return $tco_result;
            };
        };
        return deGraft;
    };
};

});
parcelRegister("4VF0K", function(module, exports) {

$parcel$export(module.exports, "zipWith", () => $396c4c3d9e7fae3c$export$b634740ce272acb5);
$parcel$export(module.exports, "zipWithA", () => $396c4c3d9e7fae3c$export$e00c1e5c5a2b1ad7);
$parcel$export(module.exports, "zip", () => $396c4c3d9e7fae3c$export$8901015135f2fb22);
$parcel$export(module.exports, "updateAtIndices", () => $396c4c3d9e7fae3c$export$f2a09b3ef2c0e257);
$parcel$export(module.exports, "updateAt", () => $396c4c3d9e7fae3c$export$b6d8713d53419d4c);
$parcel$export(module.exports, "unsafeIndex", () => $396c4c3d9e7fae3c$export$90bcd20c17ae578e);
$parcel$export(module.exports, "uncons", () => $396c4c3d9e7fae3c$export$b446f6baa3bb1430);
$parcel$export(module.exports, "toUnfoldable", () => $396c4c3d9e7fae3c$export$823be24f8766da23);
$parcel$export(module.exports, "tail", () => $396c4c3d9e7fae3c$export$c01875f616615628);
$parcel$export(module.exports, "sortBy", () => $396c4c3d9e7fae3c$export$b035e44d7bb4278f);
$parcel$export(module.exports, "sortWith", () => $396c4c3d9e7fae3c$export$a9e7d1a6fdcfefde);
$parcel$export(module.exports, "sort", () => $396c4c3d9e7fae3c$export$97db5808d8f88186);
$parcel$export(module.exports, "snoc", () => $396c4c3d9e7fae3c$export$c40cf5aab899f397);
$parcel$export(module.exports, "slice", () => $396c4c3d9e7fae3c$export$58adb3bec8346d0f);
$parcel$export(module.exports, "splitAt", () => $396c4c3d9e7fae3c$export$b0d75975ac0be0e1);
$parcel$export(module.exports, "take", () => $396c4c3d9e7fae3c$export$b7df5d561049483a);
$parcel$export(module.exports, "singleton", () => $396c4c3d9e7fae3c$export$439306a4dcaafbb9);
$parcel$export(module.exports, "scanr", () => $396c4c3d9e7fae3c$export$64df51ac031d4ad2);
$parcel$export(module.exports, "scanl", () => $396c4c3d9e7fae3c$export$65f513eaf3c582b8);
$parcel$export(module.exports, "replicate", () => $396c4c3d9e7fae3c$export$606959e7ccb797f0);
$parcel$export(module.exports, "range", () => $396c4c3d9e7fae3c$export$d02631cccf789723);
$parcel$export(module.exports, "partition", () => $396c4c3d9e7fae3c$export$b29f828819edca8d);
$parcel$export(module.exports, "null", () => $396c4c3d9e7fae3c$export$7b1b591b262c240);
$parcel$export(module.exports, "modifyAtIndices", () => $396c4c3d9e7fae3c$export$7fd3d81fba5daa58);
$parcel$export(module.exports, "mapWithIndex", () => $396c4c3d9e7fae3c$export$8f07ddce13659f50);
$parcel$export(module.exports, "intersperse", () => $396c4c3d9e7fae3c$export$af200dcf8b7cb5de);
$parcel$export(module.exports, "insertAt", () => $396c4c3d9e7fae3c$export$9f200c4466975173);
$parcel$export(module.exports, "init", () => $396c4c3d9e7fae3c$export$2cd8252107eb640b);
$parcel$export(module.exports, "index", () => $396c4c3d9e7fae3c$export$b610b8812bbcded9);
$parcel$export(module.exports, "last", () => $396c4c3d9e7fae3c$export$4c7897fafd92b108);
$parcel$export(module.exports, "unsnoc", () => $396c4c3d9e7fae3c$export$712962e076096ed4);
$parcel$export(module.exports, "modifyAt", () => $396c4c3d9e7fae3c$export$cba09f9e3d3e58eb);
$parcel$export(module.exports, "span", () => $396c4c3d9e7fae3c$export$afc1bfabebaf28a2);
$parcel$export(module.exports, "takeWhile", () => $396c4c3d9e7fae3c$export$9384c7afe4015e42);
$parcel$export(module.exports, "unzip", () => $396c4c3d9e7fae3c$export$23c8d3f8757cab88);
$parcel$export(module.exports, "head", () => $396c4c3d9e7fae3c$export$5fd5031fecdacec3);
$parcel$export(module.exports, "nubBy", () => $396c4c3d9e7fae3c$export$18f77a3bafa759b9);
$parcel$export(module.exports, "nub", () => $396c4c3d9e7fae3c$export$94f4066a75b10404);
$parcel$export(module.exports, "groupBy", () => $396c4c3d9e7fae3c$export$3f063810d7bf01bd);
$parcel$export(module.exports, "groupAllBy", () => $396c4c3d9e7fae3c$export$1f7a5bf12caafbd);
$parcel$export(module.exports, "group", () => $396c4c3d9e7fae3c$export$e5e25fbcc1f7affe);
$parcel$export(module.exports, "fromFoldable", () => $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072);
$parcel$export(module.exports, "transpose", () => $396c4c3d9e7fae3c$export$9cb09a71b7d66923);
$parcel$export(module.exports, "foldRecM", () => $396c4c3d9e7fae3c$export$61b0588efceffce4);
$parcel$export(module.exports, "foldM", () => $396c4c3d9e7fae3c$export$7a067f9280ad8af0);
$parcel$export(module.exports, "findMap", () => $396c4c3d9e7fae3c$export$23e5dcedfce4509c);
$parcel$export(module.exports, "findLastIndex", () => $396c4c3d9e7fae3c$export$8855a8be7bd3e9f8);
$parcel$export(module.exports, "insertBy", () => $396c4c3d9e7fae3c$export$b8bc901090d2b1d4);
$parcel$export(module.exports, "insert", () => $396c4c3d9e7fae3c$export$21a5ca8aa77d35ff);
$parcel$export(module.exports, "findIndex", () => $396c4c3d9e7fae3c$export$de3a4d4a0d731119);
$parcel$export(module.exports, "find", () => $396c4c3d9e7fae3c$export$71aa6c912b956294);
$parcel$export(module.exports, "filter", () => $396c4c3d9e7fae3c$export$3dea766d36a8935f);
$parcel$export(module.exports, "intersectBy", () => $396c4c3d9e7fae3c$export$f161f39e9c06ab2d);
$parcel$export(module.exports, "elemLastIndex", () => $396c4c3d9e7fae3c$export$c19d79386f4ed99a);
$parcel$export(module.exports, "elemIndex", () => $396c4c3d9e7fae3c$export$f444781b0adb7e4d);
$parcel$export(module.exports, "notElem", () => $396c4c3d9e7fae3c$export$63faa62a0284a4a6);
$parcel$export(module.exports, "elem", () => $396c4c3d9e7fae3c$export$5bf96401662340b7);
$parcel$export(module.exports, "dropWhile", () => $396c4c3d9e7fae3c$export$533af5c8cd6afa16);
$parcel$export(module.exports, "dropEnd", () => $396c4c3d9e7fae3c$export$2b3b686e33c80c56);
$parcel$export(module.exports, "drop", () => $396c4c3d9e7fae3c$export$663103110d94aac9);
$parcel$export(module.exports, "takeEnd", () => $396c4c3d9e7fae3c$export$9100289823a975b0);
$parcel$export(module.exports, "deleteAt", () => $396c4c3d9e7fae3c$export$90f9093465da3136);
$parcel$export(module.exports, "deleteBy", () => $396c4c3d9e7fae3c$export$9ea2b6c3fae093d8);
$parcel$export(module.exports, "delete", () => $396c4c3d9e7fae3c$export$1822828d790e23ee);
$parcel$export(module.exports, "difference", () => $396c4c3d9e7fae3c$export$acaf96a27438246b);
$parcel$export(module.exports, "cons", () => $396c4c3d9e7fae3c$export$8327ebbef2a0ba76);
$parcel$export(module.exports, "some", () => $396c4c3d9e7fae3c$export$ad14ef4001db2bcd);
$parcel$export(module.exports, "many", () => $396c4c3d9e7fae3c$export$14badfee79ea396f);
$parcel$export(module.exports, "mapMaybe", () => $396c4c3d9e7fae3c$export$e70771d2e7e590a);
$parcel$export(module.exports, "filterA", () => $396c4c3d9e7fae3c$export$e6e803076c284bc5);
$parcel$export(module.exports, "catMaybes", () => $396c4c3d9e7fae3c$export$986c2bbe7a34be0b);
$parcel$export(module.exports, "any", () => $396c4c3d9e7fae3c$export$4154a199d7d90455);
$parcel$export(module.exports, "nubByEq", () => $396c4c3d9e7fae3c$export$45273896c792ff3b);
$parcel$export(module.exports, "nubEq", () => $396c4c3d9e7fae3c$export$edce5881c815871);
$parcel$export(module.exports, "unionBy", () => $396c4c3d9e7fae3c$export$ef1d06dc4d91d507);
$parcel$export(module.exports, "alterAt", () => $396c4c3d9e7fae3c$export$2dd9d44f93be5e22);
$parcel$export(module.exports, "all", () => $396c4c3d9e7fae3c$export$84bf76cd7afc7469);
$parcel$export(module.exports, "length", () => (parcelRequire("lGiKR")).length);
$parcel$export(module.exports, "reverse", () => (parcelRequire("lGiKR")).reverse);
$parcel$export(module.exports, "concat", () => (parcelRequire("lGiKR")).concat);
// Generated by purs version 0.15.16

var $lGiKR = parcelRequire("lGiKR");

var $a7Dxq = parcelRequire("a7Dxq");

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $9Grh5 = parcelRequire("9Grh5");

var $7T8P4 = parcelRequire("7T8P4");

var $dTFzl = parcelRequire("dTFzl");

var $lowBm = parcelRequire("lowBm");

var $JFoio = parcelRequire("JFoio");
var $kHt3z = parcelRequire("kHt3z");

var $aknBk = parcelRequire("aknBk");
var $1b9jX = parcelRequire("1b9jX");

var $caTtn = parcelRequire("caTtn");

var $6UHO6 = parcelRequire("6UHO6");

var $4MBcA = parcelRequire("4MBcA");

var $6RkEA = parcelRequire("6RkEA");

var $l4M7e = parcelRequire("l4M7e");
parcelRequire("ikChJ");
var $chZgc = parcelRequire("chZgc");

var $l0wDR = parcelRequire("l0wDR");

var $4oUwX = parcelRequire("4oUwX");

var $ykHdR = parcelRequire("ykHdR");

var $d0PPW = parcelRequire("d0PPW");

var $6SDUu = parcelRequire("6SDUu");

var $iwqgS = parcelRequire("iwqgS");

var $1wR1l = parcelRequire("1wR1l");

var $9MxTl = parcelRequire("9MxTl");

var $hsyEi = parcelRequire("hsyEi");
var $396c4c3d9e7fae3c$var$sequence = /* #__PURE__ */ $1wR1l.sequence($1wR1l.traversableArray);
var $396c4c3d9e7fae3c$var$traverse_ = /* #__PURE__ */ $6RkEA.traverse_($JFoio.applicativeST);
var $396c4c3d9e7fae3c$var$$$void = /* #__PURE__ */ $l0wDR.void($JFoio.functorST);
var $396c4c3d9e7fae3c$var$intercalate1 = /* #__PURE__ */ $6RkEA.intercalate($6RkEA.foldableArray);
var $396c4c3d9e7fae3c$var$apply = /* #__PURE__ */ $a5g3C.apply($ykHdR.applyMaybe);
var $396c4c3d9e7fae3c$var$map = /* #__PURE__ */ $l0wDR.map($ykHdR.functorMaybe);
var $396c4c3d9e7fae3c$var$map1 = /* #__PURE__ */ $l0wDR.map($l0wDR.functorArray);
var $396c4c3d9e7fae3c$var$map2 = /* #__PURE__ */ $l0wDR.map($JFoio.functorST);
var $396c4c3d9e7fae3c$var$fromJust = /* #__PURE__ */ $ykHdR.fromJust();
var $396c4c3d9e7fae3c$var$when = /* #__PURE__ */ $gUTA8.when($JFoio.applicativeST);
var $396c4c3d9e7fae3c$var$notEq = /* #__PURE__ */ $4MBcA.notEq($6SDUu.eqOrdering);
var $396c4c3d9e7fae3c$var$eq1 = /* #__PURE__ */ $4MBcA.eq($6SDUu.eqOrdering);
var $396c4c3d9e7fae3c$var$foldMap1 = /* #__PURE__ */ $6RkEA.foldMap($6RkEA.foldableArray);
var $396c4c3d9e7fae3c$var$fold1 = /* #__PURE__ */ $6RkEA.fold($6RkEA.foldableArray);
var $396c4c3d9e7fae3c$var$append = /* #__PURE__ */ $iwqgS.append($iwqgS.semigroupArray);
var $396c4c3d9e7fae3c$var$traverse = /* #__PURE__ */ $1wR1l.traverse($1wR1l.traversableArray);
var $396c4c3d9e7fae3c$export$b634740ce272acb5 = /* #__PURE__ */ $chZgc.runFn3($lGiKR.zipWithImpl);
var $396c4c3d9e7fae3c$export$e00c1e5c5a2b1ad7 = function(dictApplicative) {
    var sequence1 = $396c4c3d9e7fae3c$var$sequence(dictApplicative);
    return function(f) {
        return function(xs) {
            return function(ys) {
                return sequence1($396c4c3d9e7fae3c$export$b634740ce272acb5(f)(xs)(ys));
            };
        };
    };
};
var $396c4c3d9e7fae3c$export$8901015135f2fb22 = /* #__PURE__ */ function() {
    return $396c4c3d9e7fae3c$export$b634740ce272acb5($9MxTl.Tuple.create);
}();
var $396c4c3d9e7fae3c$export$f2a09b3ef2c0e257 = function(dictFoldable) {
    var traverse_1 = $396c4c3d9e7fae3c$var$traverse_(dictFoldable);
    return function(us) {
        return function(xs) {
            return $aknBk.withArray(function(res) {
                return traverse_1(function(v) {
                    return $aknBk.poke(v.value0)(v.value1)(res);
                })(us);
            })(xs)();
        };
    };
};
var $396c4c3d9e7fae3c$export$b6d8713d53419d4c = /* #__PURE__ */ function() {
    return $chZgc.runFn5($lGiKR._updateAt)($ykHdR.Just.create)($ykHdR.Nothing.value);
}();
var $396c4c3d9e7fae3c$export$90bcd20c17ae578e = function() {
    return $chZgc.runFn2($lGiKR.unsafeIndexImpl);
};
var $396c4c3d9e7fae3c$var$unsafeIndex1 = /* #__PURE__ */ $396c4c3d9e7fae3c$export$90bcd20c17ae578e();
var $396c4c3d9e7fae3c$export$b446f6baa3bb1430 = /* #__PURE__ */ function() {
    return $chZgc.runFn3($lGiKR.unconsImpl)($l4M7e.const($ykHdR.Nothing.value))(function(x) {
        return function(xs) {
            return new $ykHdR.Just({
                head: x,
                tail: xs
            });
        };
    });
}();
var $396c4c3d9e7fae3c$export$823be24f8766da23 = function(dictUnfoldable) {
    var unfoldr = $hsyEi.unfoldr(dictUnfoldable);
    return function(xs) {
        var len = $lGiKR.length(xs);
        var f = function(i) {
            if (i < len) return new $ykHdR.Just(new $9MxTl.Tuple($396c4c3d9e7fae3c$var$unsafeIndex1(xs)(i), i + 1 | 0));
            if ($6UHO6.otherwise) return $ykHdR.Nothing.value;
            throw new Error("Failed pattern match at Data.Array (line 163, column 3 - line 165, column 26): " + [
                i.constructor.name
            ]);
        };
        return unfoldr(f)(0);
    };
};
var $396c4c3d9e7fae3c$export$c01875f616615628 = /* #__PURE__ */ function() {
    return $chZgc.runFn3($lGiKR.unconsImpl)($l4M7e.const($ykHdR.Nothing.value))(function(v) {
        return function(xs) {
            return new $ykHdR.Just(xs);
        };
    });
}();
var $396c4c3d9e7fae3c$export$b035e44d7bb4278f = function(comp) {
    return $chZgc.runFn3($lGiKR.sortByImpl)(comp)(function(v) {
        if (v instanceof $6SDUu.GT) return 1;
        if (v instanceof $6SDUu.EQ) return 0;
        if (v instanceof $6SDUu.LT) return -1;
        throw new Error("Failed pattern match at Data.Array (line 897, column 38 - line 900, column 11): " + [
            v.constructor.name
        ]);
    });
};
var $396c4c3d9e7fae3c$export$a9e7d1a6fdcfefde = function(dictOrd) {
    var comparing = $d0PPW.comparing(dictOrd);
    return function(f) {
        return $396c4c3d9e7fae3c$export$b035e44d7bb4278f(comparing(f));
    };
};
var $396c4c3d9e7fae3c$var$sortWith1 = /* #__PURE__ */ $396c4c3d9e7fae3c$export$a9e7d1a6fdcfefde($d0PPW.ordInt);
var $396c4c3d9e7fae3c$export$97db5808d8f88186 = function(dictOrd) {
    var compare = $d0PPW.compare(dictOrd);
    return function(xs) {
        return $396c4c3d9e7fae3c$export$b035e44d7bb4278f(compare)(xs);
    };
};
var $396c4c3d9e7fae3c$export$c40cf5aab899f397 = function(xs) {
    return function(x) {
        return $aknBk.withArray($aknBk.push(x))(xs)();
    };
};
var $396c4c3d9e7fae3c$export$58adb3bec8346d0f = /* #__PURE__ */ $chZgc.runFn3($lGiKR.sliceImpl);
var $396c4c3d9e7fae3c$export$b0d75975ac0be0e1 = function(v) {
    return function(v1) {
        if (v <= 0) return {
            before: [],
            after: v1
        };
        return {
            before: $396c4c3d9e7fae3c$export$58adb3bec8346d0f(0)(v)(v1),
            after: $396c4c3d9e7fae3c$export$58adb3bec8346d0f(v)($lGiKR.length(v1))(v1)
        };
    };
};
var $396c4c3d9e7fae3c$export$b7df5d561049483a = function(n) {
    return function(xs) {
        var $152 = n < 1;
        if ($152) return [];
        return $396c4c3d9e7fae3c$export$58adb3bec8346d0f(0)(n)(xs);
    };
};
var $396c4c3d9e7fae3c$export$439306a4dcaafbb9 = function(a) {
    return [
        a
    ];
};
var $396c4c3d9e7fae3c$export$64df51ac031d4ad2 = /* #__PURE__ */ $chZgc.runFn3($lGiKR.scanrImpl);
var $396c4c3d9e7fae3c$export$65f513eaf3c582b8 = /* #__PURE__ */ $chZgc.runFn3($lGiKR.scanlImpl);
var $396c4c3d9e7fae3c$export$606959e7ccb797f0 = /* #__PURE__ */ $chZgc.runFn2($lGiKR.replicateImpl);
var $396c4c3d9e7fae3c$export$d02631cccf789723 = /* #__PURE__ */ $chZgc.runFn2($lGiKR.rangeImpl);
var $396c4c3d9e7fae3c$export$b29f828819edca8d = /* #__PURE__ */ $chZgc.runFn2($lGiKR.partitionImpl);
var $396c4c3d9e7fae3c$export$7b1b591b262c240 = function(xs) {
    return $lGiKR.length(xs) === 0;
};
var $396c4c3d9e7fae3c$export$7fd3d81fba5daa58 = function(dictFoldable) {
    var traverse_1 = $396c4c3d9e7fae3c$var$traverse_(dictFoldable);
    return function(is) {
        return function(f) {
            return function(xs) {
                return $aknBk.withArray(function(res) {
                    return traverse_1(function(i) {
                        return $aknBk.modify(i)(f)(res);
                    })(is);
                })(xs)();
            };
        };
    };
};
var $396c4c3d9e7fae3c$export$8f07ddce13659f50 = /* #__PURE__ */ $4oUwX.mapWithIndex($4oUwX.functorWithIndexArray);
var $396c4c3d9e7fae3c$export$af200dcf8b7cb5de = function(a) {
    return function(arr) {
        var v = $lGiKR.length(arr);
        if (v < 2) return arr;
        if ($6UHO6.otherwise) return $aknBk.run(function() {
            var unsafeGetElem = function(idx) {
                return $396c4c3d9e7fae3c$var$unsafeIndex1(arr)(idx);
            };
            return function __do() {
                var out = $1b9jX.new();
                $aknBk.push(unsafeGetElem(0))(out)();
                $kHt3z.for(1)(v)(function(idx) {
                    return function __do() {
                        $aknBk.push(a)(out)();
                        return $396c4c3d9e7fae3c$var$$$void($aknBk.push(unsafeGetElem(idx))(out))();
                    };
                })();
                return out;
            };
        }());
        throw new Error("Failed pattern match at Data.Array (line 623, column 21 - line 633, column 17): " + [
            v.constructor.name
        ]);
    };
};
var $396c4c3d9e7fae3c$export$739ec22334c44788 = function(dictMonoid) {
    return $396c4c3d9e7fae3c$var$intercalate1(dictMonoid);
};
var $396c4c3d9e7fae3c$export$9f200c4466975173 = /* #__PURE__ */ function() {
    return $chZgc.runFn5($lGiKR._insertAt)($ykHdR.Just.create)($ykHdR.Nothing.value);
}();
var $396c4c3d9e7fae3c$export$2cd8252107eb640b = function(xs) {
    if ($396c4c3d9e7fae3c$export$7b1b591b262c240(xs)) return $ykHdR.Nothing.value;
    if ($6UHO6.otherwise) return new $ykHdR.Just($396c4c3d9e7fae3c$export$58adb3bec8346d0f(0)($lGiKR.length(xs) - 1 | 0)(xs));
    throw new Error("Failed pattern match at Data.Array (line 351, column 1 - line 351, column 45): " + [
        xs.constructor.name
    ]);
};
var $396c4c3d9e7fae3c$export$b610b8812bbcded9 = /* #__PURE__ */ function() {
    return $chZgc.runFn4($lGiKR.indexImpl)($ykHdR.Just.create)($ykHdR.Nothing.value);
}();
var $396c4c3d9e7fae3c$export$4c7897fafd92b108 = function(xs) {
    return $396c4c3d9e7fae3c$export$b610b8812bbcded9(xs)($lGiKR.length(xs) - 1 | 0);
};
var $396c4c3d9e7fae3c$export$712962e076096ed4 = function(xs) {
    return $396c4c3d9e7fae3c$var$apply($396c4c3d9e7fae3c$var$map(function(v) {
        return function(v1) {
            return {
                init: v,
                last: v1
            };
        };
    })($396c4c3d9e7fae3c$export$2cd8252107eb640b(xs)))($396c4c3d9e7fae3c$export$4c7897fafd92b108(xs));
};
var $396c4c3d9e7fae3c$export$cba09f9e3d3e58eb = function(i) {
    return function(f) {
        return function(xs) {
            var go = function(x) {
                return $396c4c3d9e7fae3c$export$b6d8713d53419d4c(i)(f(x))(xs);
            };
            return $ykHdR.maybe($ykHdR.Nothing.value)(go)($396c4c3d9e7fae3c$export$b610b8812bbcded9(xs)(i));
        };
    };
};
var $396c4c3d9e7fae3c$export$afc1bfabebaf28a2 = function(p) {
    return function(arr) {
        var go = function($copy_i) {
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(i) {
                var v = $396c4c3d9e7fae3c$export$b610b8812bbcded9(arr)(i);
                if (v instanceof $ykHdR.Just) {
                    var $156 = p(v.value0);
                    if ($156) {
                        $copy_i = i + 1 | 0;
                        return;
                    }
                    $tco_done = true;
                    return new $ykHdR.Just(i);
                }
                if (v instanceof $ykHdR.Nothing) {
                    $tco_done = true;
                    return $ykHdR.Nothing.value;
                }
                throw new Error("Failed pattern match at Data.Array (line 1035, column 5 - line 1037, column 25): " + [
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($copy_i);
            return $tco_result;
        };
        var breakIndex = go(0);
        if (breakIndex instanceof $ykHdR.Just && breakIndex.value0 === 0) return {
            init: [],
            rest: arr
        };
        if (breakIndex instanceof $ykHdR.Just) return {
            init: $396c4c3d9e7fae3c$export$58adb3bec8346d0f(0)(breakIndex.value0)(arr),
            rest: $396c4c3d9e7fae3c$export$58adb3bec8346d0f(breakIndex.value0)($lGiKR.length(arr))(arr)
        };
        if (breakIndex instanceof $ykHdR.Nothing) return {
            init: arr,
            rest: []
        };
        throw new Error("Failed pattern match at Data.Array (line 1022, column 3 - line 1028, column 30): " + [
            breakIndex.constructor.name
        ]);
    };
};
var $396c4c3d9e7fae3c$export$9384c7afe4015e42 = function(p) {
    return function(xs) {
        return $396c4c3d9e7fae3c$export$afc1bfabebaf28a2(p)(xs).init;
    };
};
var $396c4c3d9e7fae3c$export$23c8d3f8757cab88 = function(xs) {
    return function __do() {
        var fsts = $1b9jX.new();
        var snds = $1b9jX.new();
        var iter = $caTtn.iterator(function(v) {
            return $396c4c3d9e7fae3c$export$b610b8812bbcded9(xs)(v);
        })();
        $caTtn.iterate(iter)(function(v) {
            return function __do() {
                $396c4c3d9e7fae3c$var$$$void($aknBk.push(v.value0)(fsts))();
                return $396c4c3d9e7fae3c$var$$$void($aknBk.push(v.value1)(snds))();
            };
        })();
        var fsts$prime = $aknBk.unsafeFreeze(fsts)();
        var snds$prime = $aknBk.unsafeFreeze(snds)();
        return new $9MxTl.Tuple(fsts$prime, snds$prime);
    }();
};
var $396c4c3d9e7fae3c$export$5fd5031fecdacec3 = function(xs) {
    return $396c4c3d9e7fae3c$export$b610b8812bbcded9(xs)(0);
};
var $396c4c3d9e7fae3c$export$18f77a3bafa759b9 = function(comp) {
    return function(xs) {
        var indexedAndSorted = $396c4c3d9e7fae3c$export$b035e44d7bb4278f(function(x) {
            return function(y) {
                return comp($9MxTl.snd(x))($9MxTl.snd(y));
            };
        })($396c4c3d9e7fae3c$export$8f07ddce13659f50($9MxTl.Tuple.create)(xs));
        var v = $396c4c3d9e7fae3c$export$5fd5031fecdacec3(indexedAndSorted);
        if (v instanceof $ykHdR.Nothing) return [];
        if (v instanceof $ykHdR.Just) return $396c4c3d9e7fae3c$var$map1($9MxTl.snd)($396c4c3d9e7fae3c$var$sortWith1($9MxTl.fst)(function __do() {
            var result = $aknBk.unsafeThaw($396c4c3d9e7fae3c$export$439306a4dcaafbb9(v.value0))();
            $kHt3z.foreach(indexedAndSorted)(function(v1) {
                return function __do() {
                    var lst = $396c4c3d9e7fae3c$var$map2(function() {
                        var $183 = function($185) {
                            return $396c4c3d9e7fae3c$var$fromJust($396c4c3d9e7fae3c$export$4c7897fafd92b108($185));
                        };
                        return function($184) {
                            return $9MxTl.snd($183($184));
                        };
                    }())($aknBk.unsafeFreeze(result))();
                    return $396c4c3d9e7fae3c$var$when($396c4c3d9e7fae3c$var$notEq(comp(lst)(v1.value1))($6SDUu.EQ.value))($396c4c3d9e7fae3c$var$$$void($aknBk.push(v1)(result)))();
                };
            })();
            return $aknBk.unsafeFreeze(result)();
        }()));
        throw new Error("Failed pattern match at Data.Array (line 1115, column 17 - line 1123, column 28): " + [
            v.constructor.name
        ]);
    };
};
var $396c4c3d9e7fae3c$export$94f4066a75b10404 = function(dictOrd) {
    return $396c4c3d9e7fae3c$export$18f77a3bafa759b9($d0PPW.compare(dictOrd));
};
var $396c4c3d9e7fae3c$export$3f063810d7bf01bd = function(op) {
    return function(xs) {
        return function __do() {
            var result = $1b9jX.new();
            var iter = $caTtn.iterator(function(v) {
                return $396c4c3d9e7fae3c$export$b610b8812bbcded9(xs)(v);
            })();
            $caTtn.iterate(iter)(function(x) {
                return $396c4c3d9e7fae3c$var$$$void(function __do() {
                    var sub1 = $1b9jX.new();
                    $aknBk.push(x)(sub1)();
                    $caTtn.pushWhile(op(x))(iter)(sub1)();
                    var grp = $aknBk.unsafeFreeze(sub1)();
                    return $aknBk.push(grp)(result)();
                });
            })();
            return $aknBk.unsafeFreeze(result)();
        }();
    };
};
var $396c4c3d9e7fae3c$export$1f7a5bf12caafbd = function(cmp) {
    var $186 = $396c4c3d9e7fae3c$export$3f063810d7bf01bd(function(x) {
        return function(y) {
            return $396c4c3d9e7fae3c$var$eq1(cmp(x)(y))($6SDUu.EQ.value);
        };
    });
    var $187 = $396c4c3d9e7fae3c$export$b035e44d7bb4278f(cmp);
    return function($188) {
        return $186($187($188));
    };
};
var $396c4c3d9e7fae3c$export$361434b95a7d965 = function(dictOrd) {
    return $396c4c3d9e7fae3c$export$1f7a5bf12caafbd($d0PPW.compare(dictOrd));
};
var $396c4c3d9e7fae3c$export$e5e25fbcc1f7affe = function(dictEq) {
    var eq2 = $4MBcA.eq(dictEq);
    return function(xs) {
        return $396c4c3d9e7fae3c$export$3f063810d7bf01bd(eq2)(xs);
    };
};
var $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072 = function(dictFoldable) {
    return $chZgc.runFn2($lGiKR.fromFoldableImpl)($6RkEA.foldr(dictFoldable));
};
var $396c4c3d9e7fae3c$export$a11cb61c36c4a4cf = /* #__PURE__ */ $6RkEA.foldr($6RkEA.foldableArray);
var $396c4c3d9e7fae3c$export$50ae948ca12cdcbc = /* #__PURE__ */ $6RkEA.foldl($6RkEA.foldableArray);
var $396c4c3d9e7fae3c$export$9cb09a71b7d66923 = function(xs) {
    var buildNext = function(idx) {
        return $l4M7e.flip($396c4c3d9e7fae3c$export$50ae948ca12cdcbc)($ykHdR.Nothing.value)(function(acc) {
            return function(nextArr) {
                return $ykHdR.maybe(acc)(function(el) {
                    return new $ykHdR.Just($ykHdR.maybe([
                        el
                    ])($l4M7e.flip($396c4c3d9e7fae3c$export$c40cf5aab899f397)(el))(acc));
                })($396c4c3d9e7fae3c$export$b610b8812bbcded9(nextArr)(idx));
            };
        })(xs);
    };
    var go = function($copy_idx) {
        return function($copy_allArrays) {
            var $tco_var_idx = $copy_idx;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(idx, allArrays) {
                var v = buildNext(idx);
                if (v instanceof $ykHdR.Nothing) {
                    $tco_done = true;
                    return allArrays;
                }
                if (v instanceof $ykHdR.Just) {
                    $tco_var_idx = idx + 1 | 0;
                    $copy_allArrays = $396c4c3d9e7fae3c$export$c40cf5aab899f397(allArrays)(v.value0);
                    return;
                }
                throw new Error("Failed pattern match at Data.Array (line 837, column 22 - line 839, column 52): " + [
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_idx, $copy_allArrays);
            return $tco_result;
        };
    };
    return go(0)([]);
};
var $396c4c3d9e7fae3c$export$61b0588efceffce4 = function(dictMonadRec) {
    var Monad0 = dictMonadRec.Monad0();
    var pure1 = $gUTA8.pure(Monad0.Applicative0());
    var bind1 = $9Grh5.bind(Monad0.Bind1());
    var tailRecM2 = $lowBm.tailRecM2(dictMonadRec);
    return function(f) {
        return function(b) {
            return function(array) {
                var go = function(res) {
                    return function(i) {
                        if (i >= $lGiKR.length(array)) return pure1(new $lowBm.Done(res));
                        if ($6UHO6.otherwise) return bind1(f(res)($396c4c3d9e7fae3c$var$unsafeIndex1(array)(i)))(function(res$prime) {
                            return pure1(new $lowBm.Loop({
                                a: res$prime,
                                b: i + 1 | 0
                            }));
                        });
                        throw new Error("Failed pattern match at Data.Array (line 1349, column 3 - line 1353, column 42): " + [
                            res.constructor.name,
                            i.constructor.name
                        ]);
                    };
                };
                return tailRecM2(go)(b)(0);
            };
        };
    };
};
var $396c4c3d9e7fae3c$export$b66cdc0497d8a99a = function(dictMonoid) {
    return $396c4c3d9e7fae3c$var$foldMap1(dictMonoid);
};
var $396c4c3d9e7fae3c$export$7a067f9280ad8af0 = function(dictMonad) {
    var pure1 = $gUTA8.pure(dictMonad.Applicative0());
    var bind1 = $9Grh5.bind(dictMonad.Bind1());
    return function(f) {
        return function(b) {
            return $chZgc.runFn3($lGiKR.unconsImpl)(function(v) {
                return pure1(b);
            })(function(a) {
                return function(as) {
                    return bind1(f(b)(a))(function(b$prime) {
                        return $396c4c3d9e7fae3c$export$7a067f9280ad8af0(dictMonad)(f)(b$prime)(as);
                    });
                };
            });
        };
    };
};
var $396c4c3d9e7fae3c$export$93e2b83da34ff82a = function(dictMonoid) {
    return $396c4c3d9e7fae3c$var$fold1(dictMonoid);
};
var $396c4c3d9e7fae3c$export$23e5dcedfce4509c = /* #__PURE__ */ function() {
    return $chZgc.runFn4($lGiKR.findMapImpl)($ykHdR.Nothing.value)($ykHdR.isJust);
}();
var $396c4c3d9e7fae3c$export$8855a8be7bd3e9f8 = /* #__PURE__ */ function() {
    return $chZgc.runFn4($lGiKR.findLastIndexImpl)($ykHdR.Just.create)($ykHdR.Nothing.value);
}();
var $396c4c3d9e7fae3c$export$b8bc901090d2b1d4 = function(cmp) {
    return function(x) {
        return function(ys) {
            var i = $ykHdR.maybe(0)(function(v) {
                return v + 1 | 0;
            })($396c4c3d9e7fae3c$export$8855a8be7bd3e9f8(function(y) {
                return $396c4c3d9e7fae3c$var$eq1(cmp(x)(y))($6SDUu.GT.value);
            })(ys));
            return $396c4c3d9e7fae3c$var$fromJust($396c4c3d9e7fae3c$export$9f200c4466975173(i)(x)(ys));
        };
    };
};
var $396c4c3d9e7fae3c$export$21a5ca8aa77d35ff = function(dictOrd) {
    return $396c4c3d9e7fae3c$export$b8bc901090d2b1d4($d0PPW.compare(dictOrd));
};
var $396c4c3d9e7fae3c$export$de3a4d4a0d731119 = /* #__PURE__ */ function() {
    return $chZgc.runFn4($lGiKR.findIndexImpl)($ykHdR.Just.create)($ykHdR.Nothing.value);
}();
var $396c4c3d9e7fae3c$export$71aa6c912b956294 = function(f) {
    return function(xs) {
        return $396c4c3d9e7fae3c$var$map($396c4c3d9e7fae3c$var$unsafeIndex1(xs))($396c4c3d9e7fae3c$export$de3a4d4a0d731119(f)(xs));
    };
};
var $396c4c3d9e7fae3c$export$3dea766d36a8935f = /* #__PURE__ */ $chZgc.runFn2($lGiKR.filterImpl);
var $396c4c3d9e7fae3c$export$f161f39e9c06ab2d = function(eq2) {
    return function(xs) {
        return function(ys) {
            return $396c4c3d9e7fae3c$export$3dea766d36a8935f(function(x) {
                return $ykHdR.isJust($396c4c3d9e7fae3c$export$de3a4d4a0d731119(eq2(x))(ys));
            })(xs);
        };
    };
};
var $396c4c3d9e7fae3c$export$1f4807a235930d45 = function(dictEq) {
    return $396c4c3d9e7fae3c$export$f161f39e9c06ab2d($4MBcA.eq(dictEq));
};
var $396c4c3d9e7fae3c$export$c19d79386f4ed99a = function(dictEq) {
    var eq2 = $4MBcA.eq(dictEq);
    return function(x) {
        return $396c4c3d9e7fae3c$export$8855a8be7bd3e9f8(function(v) {
            return eq2(v)(x);
        });
    };
};
var $396c4c3d9e7fae3c$export$f444781b0adb7e4d = function(dictEq) {
    var eq2 = $4MBcA.eq(dictEq);
    return function(x) {
        return $396c4c3d9e7fae3c$export$de3a4d4a0d731119(function(v) {
            return eq2(v)(x);
        });
    };
};
var $396c4c3d9e7fae3c$export$63faa62a0284a4a6 = function(dictEq) {
    var elemIndex1 = $396c4c3d9e7fae3c$export$f444781b0adb7e4d(dictEq);
    return function(a) {
        return function(arr) {
            return $ykHdR.isNothing(elemIndex1(a)(arr));
        };
    };
};
var $396c4c3d9e7fae3c$export$5bf96401662340b7 = function(dictEq) {
    var elemIndex1 = $396c4c3d9e7fae3c$export$f444781b0adb7e4d(dictEq);
    return function(a) {
        return function(arr) {
            return $ykHdR.isJust(elemIndex1(a)(arr));
        };
    };
};
var $396c4c3d9e7fae3c$export$533af5c8cd6afa16 = function(p) {
    return function(xs) {
        return $396c4c3d9e7fae3c$export$afc1bfabebaf28a2(p)(xs).rest;
    };
};
var $396c4c3d9e7fae3c$export$2b3b686e33c80c56 = function(n) {
    return function(xs) {
        return $396c4c3d9e7fae3c$export$b7df5d561049483a($lGiKR.length(xs) - n | 0)(xs);
    };
};
var $396c4c3d9e7fae3c$export$663103110d94aac9 = function(n) {
    return function(xs) {
        var $173 = n < 1;
        if ($173) return xs;
        return $396c4c3d9e7fae3c$export$58adb3bec8346d0f(n)($lGiKR.length(xs))(xs);
    };
};
var $396c4c3d9e7fae3c$export$9100289823a975b0 = function(n) {
    return function(xs) {
        return $396c4c3d9e7fae3c$export$663103110d94aac9($lGiKR.length(xs) - n | 0)(xs);
    };
};
var $396c4c3d9e7fae3c$export$90f9093465da3136 = /* #__PURE__ */ function() {
    return $chZgc.runFn4($lGiKR._deleteAt)($ykHdR.Just.create)($ykHdR.Nothing.value);
}();
var $396c4c3d9e7fae3c$export$9ea2b6c3fae093d8 = function(v) {
    return function(v1) {
        return function(v2) {
            if (v2.length === 0) return [];
            return $ykHdR.maybe(v2)(function(i) {
                return $396c4c3d9e7fae3c$var$fromJust($396c4c3d9e7fae3c$export$90f9093465da3136(i)(v2));
            })($396c4c3d9e7fae3c$export$de3a4d4a0d731119(v(v1))(v2));
        };
    };
};
var $396c4c3d9e7fae3c$export$1822828d790e23ee = function(dictEq) {
    return $396c4c3d9e7fae3c$export$9ea2b6c3fae093d8($4MBcA.eq(dictEq));
};
var $396c4c3d9e7fae3c$export$acaf96a27438246b = function(dictEq) {
    return $396c4c3d9e7fae3c$export$a11cb61c36c4a4cf($396c4c3d9e7fae3c$export$1822828d790e23ee(dictEq));
};
var $396c4c3d9e7fae3c$export$8327ebbef2a0ba76 = function(x) {
    return function(xs) {
        return $396c4c3d9e7fae3c$var$append([
            x
        ])(xs);
    };
};
var $396c4c3d9e7fae3c$export$ad14ef4001db2bcd = function(dictAlternative) {
    var apply1 = $a5g3C.apply(dictAlternative.Applicative0().Apply0());
    var map3 = $l0wDR.map(dictAlternative.Plus1().Alt0().Functor0());
    return function(dictLazy) {
        var defer = $dTFzl.defer(dictLazy);
        return function(v) {
            return apply1(map3($396c4c3d9e7fae3c$export$8327ebbef2a0ba76)(v))(defer(function(v1) {
                return $396c4c3d9e7fae3c$export$14badfee79ea396f(dictAlternative)(dictLazy)(v);
            }));
        };
    };
};
var $396c4c3d9e7fae3c$export$14badfee79ea396f = function(dictAlternative) {
    var alt = $a7Dxq.alt(dictAlternative.Plus1().Alt0());
    var pure1 = $gUTA8.pure(dictAlternative.Applicative0());
    return function(dictLazy) {
        return function(v) {
            return alt($396c4c3d9e7fae3c$export$ad14ef4001db2bcd(dictAlternative)(dictLazy)(v))(pure1([]));
        };
    };
};
var $396c4c3d9e7fae3c$export$c28c8388be0ab31a = /* #__PURE__ */ $l4M7e.flip(/* #__PURE__ */ $9Grh5.bind($9Grh5.bindArray));
var $396c4c3d9e7fae3c$export$e70771d2e7e590a = function(f) {
    return $396c4c3d9e7fae3c$export$c28c8388be0ab31a(function() {
        var $189 = $ykHdR.maybe([])($396c4c3d9e7fae3c$export$439306a4dcaafbb9);
        return function($190) {
            return $189(f($190));
        };
    }());
};
var $396c4c3d9e7fae3c$export$e6e803076c284bc5 = function(dictApplicative) {
    var traverse1 = $396c4c3d9e7fae3c$var$traverse(dictApplicative);
    var map3 = $l0wDR.map(dictApplicative.Apply0().Functor0());
    return function(p) {
        var $191 = map3($396c4c3d9e7fae3c$export$e70771d2e7e590a(function(v) {
            if (v.value1) return new $ykHdR.Just(v.value0);
            return $ykHdR.Nothing.value;
        }));
        var $192 = traverse1(function(x) {
            return map3($9MxTl.Tuple.create(x))(p(x));
        });
        return function($193) {
            return $191($192($193));
        };
    };
};
var $396c4c3d9e7fae3c$export$986c2bbe7a34be0b = /* #__PURE__ */ $396c4c3d9e7fae3c$export$e70771d2e7e590a(/* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn));
var $396c4c3d9e7fae3c$export$4154a199d7d90455 = /* #__PURE__ */ $chZgc.runFn2($lGiKR.anyImpl);
var $396c4c3d9e7fae3c$export$45273896c792ff3b = function(eq2) {
    return function(xs) {
        return function __do() {
            var arr = $1b9jX.new();
            $kHt3z.foreach(xs)(function(x) {
                return function __do() {
                    var e = $396c4c3d9e7fae3c$var$map2(function() {
                        var $194 = $396c4c3d9e7fae3c$export$4154a199d7d90455(function(v) {
                            return eq2(v)(x);
                        });
                        return function($195) {
                            return !$194($195);
                        };
                    }())($aknBk.unsafeFreeze(arr))();
                    return $396c4c3d9e7fae3c$var$when(e)($396c4c3d9e7fae3c$var$$$void($aknBk.push(x)(arr)))();
                };
            })();
            return $aknBk.unsafeFreeze(arr)();
        }();
    };
};
var $396c4c3d9e7fae3c$export$edce5881c815871 = function(dictEq) {
    return $396c4c3d9e7fae3c$export$45273896c792ff3b($4MBcA.eq(dictEq));
};
var $396c4c3d9e7fae3c$export$ef1d06dc4d91d507 = function(eq2) {
    return function(xs) {
        return function(ys) {
            return $396c4c3d9e7fae3c$var$append(xs)($396c4c3d9e7fae3c$export$50ae948ca12cdcbc($l4M7e.flip($396c4c3d9e7fae3c$export$9ea2b6c3fae093d8(eq2)))($396c4c3d9e7fae3c$export$45273896c792ff3b(eq2)(ys))(xs));
        };
    };
};
var $396c4c3d9e7fae3c$export$971dd5b0dfd021b6 = function(dictEq) {
    return $396c4c3d9e7fae3c$export$ef1d06dc4d91d507($4MBcA.eq(dictEq));
};
var $396c4c3d9e7fae3c$export$2dd9d44f93be5e22 = function(i) {
    return function(f) {
        return function(xs) {
            var go = function(x) {
                var v = f(x);
                if (v instanceof $ykHdR.Nothing) return $396c4c3d9e7fae3c$export$90f9093465da3136(i)(xs);
                if (v instanceof $ykHdR.Just) return $396c4c3d9e7fae3c$export$b6d8713d53419d4c(i)(v.value0)(xs);
                throw new Error("Failed pattern match at Data.Array (line 601, column 10 - line 603, column 32): " + [
                    v.constructor.name
                ]);
            };
            return $ykHdR.maybe($ykHdR.Nothing.value)(go)($396c4c3d9e7fae3c$export$b610b8812bbcded9(xs)(i));
        };
    };
};
var $396c4c3d9e7fae3c$export$84bf76cd7afc7469 = /* #__PURE__ */ $chZgc.runFn2($lGiKR.allImpl);

});
parcelRegister("lGiKR", function(module, exports) {

$parcel$export(module.exports, "rangeImpl", () => $fc8c1182ec2aefec$export$3561205b7dff20bf);
$parcel$export(module.exports, "replicateImpl", () => $fc8c1182ec2aefec$export$86a7d437bed76c03);
$parcel$export(module.exports, "fromFoldableImpl", () => $fc8c1182ec2aefec$export$7de5ece11b723a44);
$parcel$export(module.exports, "length", () => $fc8c1182ec2aefec$export$f24224f1c91d8156);
$parcel$export(module.exports, "unconsImpl", () => $fc8c1182ec2aefec$export$99063656965a82f5);
$parcel$export(module.exports, "indexImpl", () => $fc8c1182ec2aefec$export$fe8606c16d7ceed6);
$parcel$export(module.exports, "findMapImpl", () => $fc8c1182ec2aefec$export$7ad327e9a65b0147);
$parcel$export(module.exports, "findIndexImpl", () => $fc8c1182ec2aefec$export$885b84ba169666c7);
$parcel$export(module.exports, "findLastIndexImpl", () => $fc8c1182ec2aefec$export$32bcb9f71841245e);
$parcel$export(module.exports, "_insertAt", () => $fc8c1182ec2aefec$export$d553b0efc2008003);
$parcel$export(module.exports, "_deleteAt", () => $fc8c1182ec2aefec$export$e83371a4d1b4407c);
$parcel$export(module.exports, "_updateAt", () => $fc8c1182ec2aefec$export$4bc13c05b5f586d5);
$parcel$export(module.exports, "reverse", () => $fc8c1182ec2aefec$export$66c1ae025e96b4bc);
$parcel$export(module.exports, "concat", () => $fc8c1182ec2aefec$export$ee1b3e54f0441b22);
$parcel$export(module.exports, "filterImpl", () => $fc8c1182ec2aefec$export$e85b5b674fbfff84);
$parcel$export(module.exports, "partitionImpl", () => $fc8c1182ec2aefec$export$25718970d830661a);
$parcel$export(module.exports, "scanlImpl", () => $fc8c1182ec2aefec$export$53974fb866918d71);
$parcel$export(module.exports, "scanrImpl", () => $fc8c1182ec2aefec$export$771bbc3bb9be46c2);
$parcel$export(module.exports, "sortByImpl", () => $fc8c1182ec2aefec$export$ea0922e78a1b008a);
$parcel$export(module.exports, "sliceImpl", () => $fc8c1182ec2aefec$export$4bdf1ac3fa5d3d6a);
$parcel$export(module.exports, "zipWithImpl", () => $fc8c1182ec2aefec$export$67fd4cff6f1e6bc);
$parcel$export(module.exports, "anyImpl", () => $fc8c1182ec2aefec$export$b98f41a67d1483f3);
$parcel$export(module.exports, "allImpl", () => $fc8c1182ec2aefec$export$739e1ef870df7d82);
$parcel$export(module.exports, "unsafeIndexImpl", () => $fc8c1182ec2aefec$export$4459d383cf3fd31d);
//------------------------------------------------------------------------------
// Array creation --------------------------------------------------------------
//------------------------------------------------------------------------------
const $fc8c1182ec2aefec$export$3561205b7dff20bf = function(start, end) {
    var step = start > end ? -1 : 1;
    var result = new Array(step * (end - start) + 1);
    var i = start, n = 0;
    while(i !== end){
        result[n++] = i;
        i += step;
    }
    result[n] = i;
    return result;
};
var $fc8c1182ec2aefec$var$replicateFill = function(count, value) {
    if (count < 1) return [];
    var result = new Array(count);
    return result.fill(value);
};
var $fc8c1182ec2aefec$var$replicatePolyfill = function(count, value) {
    var result = [];
    var n = 0;
    for(var i = 0; i < count; i++)result[n++] = value;
    return result;
};
const $fc8c1182ec2aefec$export$86a7d437bed76c03 = typeof Array.prototype.fill === "function" ? $fc8c1182ec2aefec$var$replicateFill : $fc8c1182ec2aefec$var$replicatePolyfill;
const $fc8c1182ec2aefec$export$7de5ece11b723a44 = function() {
    function Cons(head, tail) {
        this.head = head;
        this.tail = tail;
    }
    var emptyList = {};
    function curryCons(head) {
        return function(tail) {
            return new Cons(head, tail);
        };
    }
    function listToArray(list) {
        var result = [];
        var count = 0;
        var xs = list;
        while(xs !== emptyList){
            result[count++] = xs.head;
            xs = xs.tail;
        }
        return result;
    }
    return function(foldr, xs) {
        return listToArray(foldr(curryCons)(emptyList)(xs));
    };
}();
const $fc8c1182ec2aefec$export$f24224f1c91d8156 = function(xs) {
    return xs.length;
};
const $fc8c1182ec2aefec$export$99063656965a82f5 = function(empty, next, xs) {
    return xs.length === 0 ? empty({}) : next(xs[0])(xs.slice(1));
};
const $fc8c1182ec2aefec$export$fe8606c16d7ceed6 = function(just, nothing, xs, i) {
    return i < 0 || i >= xs.length ? nothing : just(xs[i]);
};
const $fc8c1182ec2aefec$export$7ad327e9a65b0147 = function(nothing, isJust, f, xs) {
    for(var i = 0; i < xs.length; i++){
        var result = f(xs[i]);
        if (isJust(result)) return result;
    }
    return nothing;
};
const $fc8c1182ec2aefec$export$885b84ba169666c7 = function(just, nothing, f, xs) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (f(xs[i])) return just(i);
    }
    return nothing;
};
const $fc8c1182ec2aefec$export$32bcb9f71841245e = function(just, nothing, f, xs) {
    for(var i = xs.length - 1; i >= 0; i--){
        if (f(xs[i])) return just(i);
    }
    return nothing;
};
const $fc8c1182ec2aefec$export$d553b0efc2008003 = function(just, nothing, i, a, l) {
    if (i < 0 || i > l.length) return nothing;
    var l1 = l.slice();
    l1.splice(i, 0, a);
    return just(l1);
};
const $fc8c1182ec2aefec$export$e83371a4d1b4407c = function(just, nothing, i, l) {
    if (i < 0 || i >= l.length) return nothing;
    var l1 = l.slice();
    l1.splice(i, 1);
    return just(l1);
};
const $fc8c1182ec2aefec$export$4bc13c05b5f586d5 = function(just, nothing, i, a, l) {
    if (i < 0 || i >= l.length) return nothing;
    var l1 = l.slice();
    l1[i] = a;
    return just(l1);
};
const $fc8c1182ec2aefec$export$66c1ae025e96b4bc = function(l) {
    return l.slice().reverse();
};
const $fc8c1182ec2aefec$export$ee1b3e54f0441b22 = function(xss) {
    if (xss.length <= 10000) // This method is faster, but it crashes on big arrays.
    // So we use it when can and fallback to simple variant otherwise.
    return Array.prototype.concat.apply([], xss);
    var result = [];
    for(var i = 0, l = xss.length; i < l; i++){
        var xs = xss[i];
        for(var j = 0, m = xs.length; j < m; j++)result.push(xs[j]);
    }
    return result;
};
const $fc8c1182ec2aefec$export$e85b5b674fbfff84 = function(f, xs) {
    return xs.filter(f);
};
const $fc8c1182ec2aefec$export$25718970d830661a = function(f, xs) {
    var yes = [];
    var no = [];
    for(var i = 0; i < xs.length; i++){
        var x = xs[i];
        if (f(x)) yes.push(x);
        else no.push(x);
    }
    return {
        yes: yes,
        no: no
    };
};
const $fc8c1182ec2aefec$export$53974fb866918d71 = function(f, b, xs) {
    var len = xs.length;
    var acc = b;
    var out = new Array(len);
    for(var i = 0; i < len; i++){
        acc = f(acc)(xs[i]);
        out[i] = acc;
    }
    return out;
};
const $fc8c1182ec2aefec$export$771bbc3bb9be46c2 = function(f, b, xs) {
    var len = xs.length;
    var acc = b;
    var out = new Array(len);
    for(var i = len - 1; i >= 0; i--){
        acc = f(xs[i])(acc);
        out[i] = acc;
    }
    return out;
};
const $fc8c1182ec2aefec$export$ea0922e78a1b008a = function() {
    function mergeFromTo(compare, fromOrdering, xs1, xs2, from, to) {
        var mid;
        var i;
        var j;
        var k;
        var x;
        var y;
        var c;
        mid = from + (to - from >> 1);
        if (mid - from > 1) mergeFromTo(compare, fromOrdering, xs2, xs1, from, mid);
        if (to - mid > 1) mergeFromTo(compare, fromOrdering, xs2, xs1, mid, to);
        i = from;
        j = mid;
        k = from;
        while(i < mid && j < to){
            x = xs2[i];
            y = xs2[j];
            c = fromOrdering(compare(x)(y));
            if (c > 0) {
                xs1[k++] = y;
                ++j;
            } else {
                xs1[k++] = x;
                ++i;
            }
        }
        while(i < mid)xs1[k++] = xs2[i++];
        while(j < to)xs1[k++] = xs2[j++];
    }
    return function(compare, fromOrdering, xs) {
        var out;
        if (xs.length < 2) return xs;
        out = xs.slice(0);
        mergeFromTo(compare, fromOrdering, out, xs.slice(0), 0, xs.length);
        return out;
    };
}();
const $fc8c1182ec2aefec$export$4bdf1ac3fa5d3d6a = function(s, e, l) {
    return l.slice(s, e);
};
const $fc8c1182ec2aefec$export$67fd4cff6f1e6bc = function(f, xs, ys) {
    var l = xs.length < ys.length ? xs.length : ys.length;
    var result = new Array(l);
    for(var i = 0; i < l; i++)result[i] = f(xs[i])(ys[i]);
    return result;
};
const $fc8c1182ec2aefec$export$b98f41a67d1483f3 = function(p, xs) {
    var len = xs.length;
    for(var i = 0; i < len; i++){
        if (p(xs[i])) return true;
    }
    return false;
};
const $fc8c1182ec2aefec$export$739e1ef870df7d82 = function(p, xs) {
    var len = xs.length;
    for(var i = 0; i < len; i++){
        if (!p(xs[i])) return false;
    }
    return true;
};
const $fc8c1182ec2aefec$export$4459d383cf3fd31d = function(xs, n) {
    return xs[n];
};

});

parcelRegister("aknBk", function(module, exports) {

$parcel$export(module.exports, "unsafeThaw", () => $784e144d56146b5c$export$cc9b8725eef9c137);
$parcel$export(module.exports, "unsafeFreeze", () => $784e144d56146b5c$export$7c850c5af9b9983e);
$parcel$export(module.exports, "withArray", () => $784e144d56146b5c$export$fd51609fe570ea92);
$parcel$export(module.exports, "run", () => $784e144d56146b5c$export$889ea624f2cb2c57);
$parcel$export(module.exports, "push", () => $784e144d56146b5c$export$4cbf152802aa238);
$parcel$export(module.exports, "poke", () => $784e144d56146b5c$export$dc13bdd74c909d26);
$parcel$export(module.exports, "modify", () => $784e144d56146b5c$export$3ff57735a52b8713);
$parcel$export(module.exports, "new", () => (parcelRequire("1b9jX")).new);
// Generated by purs version 0.15.16

var $1b9jX = parcelRequire("1b9jX");

var $9Grh5 = parcelRequire("9Grh5");

var $JFoio = parcelRequire("JFoio");
parcelRequire("88eaw");
var $hwyx6 = parcelRequire("hwyx6");

var $ykHdR = parcelRequire("ykHdR");

var $d0PPW = parcelRequire("d0PPW");

var $6SDUu = parcelRequire("6SDUu");
var $784e144d56146b5c$var$bind = /* #__PURE__ */ $9Grh5.bind($JFoio.bindST);
var $784e144d56146b5c$export$8ff712f7409e81c7 = /* #__PURE__ */ $hwyx6.runSTFn2($1b9jX.unshiftAllImpl);
var $784e144d56146b5c$export$37cdb546b806ae87 = function(a) {
    return $hwyx6.runSTFn2($1b9jX.unshiftAllImpl)([
        a
    ]);
};
var $784e144d56146b5c$export$cc9b8725eef9c137 = /* #__PURE__ */ $hwyx6.runSTFn1($1b9jX.unsafeThawImpl);
var $784e144d56146b5c$export$7c850c5af9b9983e = /* #__PURE__ */ $hwyx6.runSTFn1($1b9jX.unsafeFreezeImpl);
var $784e144d56146b5c$export$a8793e37025aca3d = /* #__PURE__ */ $hwyx6.runSTFn1($1b9jX.toAssocArrayImpl);
var $784e144d56146b5c$export$80340c06f76ce783 = /* #__PURE__ */ $hwyx6.runSTFn1($1b9jX.thawImpl);
var $784e144d56146b5c$export$fd51609fe570ea92 = function(f) {
    return function(xs) {
        return function __do() {
            var result = $784e144d56146b5c$export$80340c06f76ce783(xs)();
            f(result)();
            return $784e144d56146b5c$export$7c850c5af9b9983e(result)();
        };
    };
};
var $784e144d56146b5c$export$869882364835d202 = /* #__PURE__ */ $hwyx6.runSTFn4($1b9jX.spliceImpl);
var $784e144d56146b5c$export$b035e44d7bb4278f = function(comp) {
    return $hwyx6.runSTFn3($1b9jX.sortByImpl)(comp)(function(v) {
        if (v instanceof $6SDUu.GT) return 1;
        if (v instanceof $6SDUu.EQ) return 0;
        if (v instanceof $6SDUu.LT) return -1;
        throw new Error("Failed pattern match at Data.Array.ST (line 129, column 40 - line 132, column 11): " + [
            v.constructor.name
        ]);
    });
};
var $784e144d56146b5c$export$a9e7d1a6fdcfefde = function(dictOrd) {
    var comparing = $d0PPW.comparing(dictOrd);
    return function(f) {
        return $784e144d56146b5c$export$b035e44d7bb4278f(comparing(f));
    };
};
var $784e144d56146b5c$export$97db5808d8f88186 = function(dictOrd) {
    return $784e144d56146b5c$export$b035e44d7bb4278f($d0PPW.compare(dictOrd));
};
var $784e144d56146b5c$export$fba63a578e423eb = /* #__PURE__ */ function() {
    return $hwyx6.runSTFn3($1b9jX.shiftImpl)($ykHdR.Just.create)($ykHdR.Nothing.value);
}();
var $784e144d56146b5c$export$889ea624f2cb2c57 = function(st) {
    return $784e144d56146b5c$var$bind(st)($784e144d56146b5c$export$7c850c5af9b9983e)();
};
var $784e144d56146b5c$export$907644183e99da16 = /* #__PURE__ */ $hwyx6.runSTFn2($1b9jX.pushAllImpl);
var $784e144d56146b5c$export$4cbf152802aa238 = /* #__PURE__ */ $hwyx6.runSTFn2($1b9jX.pushImpl);
var $784e144d56146b5c$export$3e41007ebfff0e64 = /* #__PURE__ */ function() {
    return $hwyx6.runSTFn3($1b9jX.popImpl)($ykHdR.Just.create)($ykHdR.Nothing.value);
}();
var $784e144d56146b5c$export$dc13bdd74c909d26 = /* #__PURE__ */ $hwyx6.runSTFn3($1b9jX.pokeImpl);
var $784e144d56146b5c$export$4d3fb11e950abb9e = /* #__PURE__ */ function() {
    return $hwyx6.runSTFn4($1b9jX.peekImpl)($ykHdR.Just.create)($ykHdR.Nothing.value);
}();
var $784e144d56146b5c$export$3ff57735a52b8713 = function(i) {
    return function(f) {
        return function(xs) {
            return function __do() {
                var entry = $784e144d56146b5c$export$4d3fb11e950abb9e(i)(xs)();
                if (entry instanceof $ykHdR.Just) return $784e144d56146b5c$export$dc13bdd74c909d26(i)(f(entry.value0))(xs)();
                if (entry instanceof $ykHdR.Nothing) return false;
                throw new Error("Failed pattern match at Data.Array.ST (line 234, column 3 - line 236, column 26): " + [
                    entry.constructor.name
                ]);
            };
        };
    };
};
var $784e144d56146b5c$export$f24224f1c91d8156 = /* #__PURE__ */ $hwyx6.runSTFn1($1b9jX.lengthImpl);
var $784e144d56146b5c$export$792f3d81ea979f55 = /* #__PURE__ */ $hwyx6.runSTFn1($1b9jX.freezeImpl);
var $784e144d56146b5c$export$9cd59f9826255e47 = /* #__PURE__ */ $hwyx6.runSTFn1($1b9jX.cloneImpl);

});
parcelRegister("1b9jX", function(module, exports) {

$parcel$export(module.exports, "new", () => $0dbe0c7353bd68b1$export$b8cb59497041ffe4);
$parcel$export(module.exports, "peekImpl", () => $0dbe0c7353bd68b1$export$6dc5f95d8548a16a);
$parcel$export(module.exports, "pokeImpl", () => $0dbe0c7353bd68b1$export$284bbde9874b0917);
$parcel$export(module.exports, "lengthImpl", () => $0dbe0c7353bd68b1$export$b0d1de20d482ef7d);
$parcel$export(module.exports, "popImpl", () => $0dbe0c7353bd68b1$export$636ddc1660dd1285);
$parcel$export(module.exports, "pushAllImpl", () => $0dbe0c7353bd68b1$export$f8b776ba78ff4419);
$parcel$export(module.exports, "shiftImpl", () => $0dbe0c7353bd68b1$export$8a1b3b221575bba8);
$parcel$export(module.exports, "unshiftAllImpl", () => $0dbe0c7353bd68b1$export$23e87bb70af50c39);
$parcel$export(module.exports, "spliceImpl", () => $0dbe0c7353bd68b1$export$b05cd45ffb08c41e);
$parcel$export(module.exports, "unsafeFreezeImpl", () => $0dbe0c7353bd68b1$export$f2963aff015afecf);
$parcel$export(module.exports, "unsafeThawImpl", () => $0dbe0c7353bd68b1$export$601e856cb1838137);
$parcel$export(module.exports, "freezeImpl", () => $0dbe0c7353bd68b1$export$2109af1090f5f6b7);
$parcel$export(module.exports, "thawImpl", () => $0dbe0c7353bd68b1$export$cd8ba9f9707c2718);
$parcel$export(module.exports, "cloneImpl", () => $0dbe0c7353bd68b1$export$57a1a2542c1220dc);
$parcel$export(module.exports, "sortByImpl", () => $0dbe0c7353bd68b1$export$ea0922e78a1b008a);
$parcel$export(module.exports, "toAssocArrayImpl", () => $0dbe0c7353bd68b1$export$66323db02f2496b6);
$parcel$export(module.exports, "pushImpl", () => $0dbe0c7353bd68b1$export$80f4edbb06ec8379);
function $0dbe0c7353bd68b1$export$b8cb59497041ffe4() {
    return [];
}
const $0dbe0c7353bd68b1$export$6dc5f95d8548a16a = function(just, nothing, i, xs) {
    return i >= 0 && i < xs.length ? just(xs[i]) : nothing;
};
const $0dbe0c7353bd68b1$export$284bbde9874b0917 = function(i, a, xs) {
    var ret = i >= 0 && i < xs.length;
    if (ret) xs[i] = a;
    return ret;
};
const $0dbe0c7353bd68b1$export$b0d1de20d482ef7d = function(xs) {
    return xs.length;
};
const $0dbe0c7353bd68b1$export$636ddc1660dd1285 = function(just, nothing, xs) {
    return xs.length > 0 ? just(xs.pop()) : nothing;
};
const $0dbe0c7353bd68b1$export$f8b776ba78ff4419 = function(as, xs) {
    return xs.push.apply(xs, as);
};
const $0dbe0c7353bd68b1$export$8a1b3b221575bba8 = function(just, nothing, xs) {
    return xs.length > 0 ? just(xs.shift()) : nothing;
};
const $0dbe0c7353bd68b1$export$23e87bb70af50c39 = function(as, xs) {
    return xs.unshift.apply(xs, as);
};
const $0dbe0c7353bd68b1$export$b05cd45ffb08c41e = function(i, howMany, bs, xs) {
    return xs.splice.apply(xs, [
        i,
        howMany
    ].concat(bs));
};
function $0dbe0c7353bd68b1$var$unsafeFreezeThawImpl(xs) {
    return xs;
}
const $0dbe0c7353bd68b1$export$f2963aff015afecf = $0dbe0c7353bd68b1$var$unsafeFreezeThawImpl;
const $0dbe0c7353bd68b1$export$601e856cb1838137 = $0dbe0c7353bd68b1$var$unsafeFreezeThawImpl;
function $0dbe0c7353bd68b1$var$copyImpl(xs) {
    return xs.slice();
}
const $0dbe0c7353bd68b1$export$2109af1090f5f6b7 = $0dbe0c7353bd68b1$var$copyImpl;
const $0dbe0c7353bd68b1$export$cd8ba9f9707c2718 = $0dbe0c7353bd68b1$var$copyImpl;
const $0dbe0c7353bd68b1$export$57a1a2542c1220dc = $0dbe0c7353bd68b1$var$copyImpl;
const $0dbe0c7353bd68b1$export$ea0922e78a1b008a = function() {
    function mergeFromTo(compare, fromOrdering, xs1, xs2, from, to) {
        var mid;
        var i;
        var j;
        var k;
        var x;
        var y;
        var c;
        mid = from + (to - from >> 1);
        if (mid - from > 1) mergeFromTo(compare, fromOrdering, xs2, xs1, from, mid);
        if (to - mid > 1) mergeFromTo(compare, fromOrdering, xs2, xs1, mid, to);
        i = from;
        j = mid;
        k = from;
        while(i < mid && j < to){
            x = xs2[i];
            y = xs2[j];
            c = fromOrdering(compare(x)(y));
            if (c > 0) {
                xs1[k++] = y;
                ++j;
            } else {
                xs1[k++] = x;
                ++i;
            }
        }
        while(i < mid)xs1[k++] = xs2[i++];
        while(j < to)xs1[k++] = xs2[j++];
    }
    return function(compare, fromOrdering, xs) {
        if (xs.length < 2) return xs;
        mergeFromTo(compare, fromOrdering, xs, xs.slice(0), 0, xs.length);
        return xs;
    };
}();
const $0dbe0c7353bd68b1$export$66323db02f2496b6 = function(xs) {
    var n = xs.length;
    var as = new Array(n);
    for(var i = 0; i < n; i++)as[i] = {
        value: xs[i],
        index: i
    };
    return as;
};
const $0dbe0c7353bd68b1$export$80f4edbb06ec8379 = function(a, xs) {
    return xs.push(a);
};

});

parcelRegister("88eaw", function(module, exports) {

$parcel$export(module.exports, "runSTFn1", () => (parcelRequire("hwyx6")).runSTFn1);
$parcel$export(module.exports, "runSTFn2", () => (parcelRequire("hwyx6")).runSTFn2);
$parcel$export(module.exports, "runSTFn3", () => (parcelRequire("hwyx6")).runSTFn3);
$parcel$export(module.exports, "runSTFn4", () => (parcelRequire("hwyx6")).runSTFn4);
// Generated by purs version 0.15.16

var $hwyx6 = parcelRequire("hwyx6");

});
parcelRegister("hwyx6", function(module, exports) {

$parcel$export(module.exports, "runSTFn1", () => $cc20365e325869f4$export$16973cca6f004709);
$parcel$export(module.exports, "runSTFn2", () => $cc20365e325869f4$export$67ab494f009454e2);
$parcel$export(module.exports, "runSTFn3", () => $cc20365e325869f4$export$d02c4697b083e08e);
$parcel$export(module.exports, "runSTFn4", () => $cc20365e325869f4$export$38a1b097838c69d7);
const $cc20365e325869f4$export$d092af9ac17843bc = function mkSTFn1(fn) {
    return function(x) {
        return fn(x)();
    };
};
const $cc20365e325869f4$export$6a3a9c423c2be31e = function mkSTFn2(fn) {
    return function(a, b) {
        return fn(a)(b)();
    };
};
const $cc20365e325869f4$export$20b99d064a00c9ee = function mkSTFn3(fn) {
    return function(a, b, c) {
        return fn(a)(b)(c)();
    };
};
const $cc20365e325869f4$export$88b7720b4d616633 = function mkSTFn4(fn) {
    return function(a, b, c, d) {
        return fn(a)(b)(c)(d)();
    };
};
const $cc20365e325869f4$export$ff210326ba56123c = function mkSTFn5(fn) {
    return function(a, b, c, d, e) {
        return fn(a)(b)(c)(d)(e)();
    };
};
const $cc20365e325869f4$export$1df8279312f4490c = function mkSTFn6(fn) {
    return function(a, b, c, d, e, f) {
        return fn(a)(b)(c)(d)(e)(f)();
    };
};
const $cc20365e325869f4$export$c438f7da82a827de = function mkSTFn7(fn) {
    return function(a, b, c, d, e, f, g) {
        return fn(a)(b)(c)(d)(e)(f)(g)();
    };
};
const $cc20365e325869f4$export$8016275d609fc2cf = function mkSTFn8(fn) {
    return function(a, b, c, d, e, f, g, h) {
        return fn(a)(b)(c)(d)(e)(f)(g)(h)();
    };
};
const $cc20365e325869f4$export$85672cd282a38b9f = function mkSTFn9(fn) {
    return function(a, b, c, d, e, f, g, h, i) {
        return fn(a)(b)(c)(d)(e)(f)(g)(h)(i)();
    };
};
const $cc20365e325869f4$export$1e8732a765f7f6a9 = function mkSTFn10(fn) {
    return function(a, b, c, d, e, f, g, h, i, j) {
        return fn(a)(b)(c)(d)(e)(f)(g)(h)(i)(j)();
    };
};
const $cc20365e325869f4$export$16973cca6f004709 = function runSTFn1(fn) {
    return function(a) {
        return function() {
            return fn(a);
        };
    };
};
const $cc20365e325869f4$export$67ab494f009454e2 = function runSTFn2(fn) {
    return function(a) {
        return function(b) {
            return function() {
                return fn(a, b);
            };
        };
    };
};
const $cc20365e325869f4$export$d02c4697b083e08e = function runSTFn3(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function() {
                    return fn(a, b, c);
                };
            };
        };
    };
};
const $cc20365e325869f4$export$38a1b097838c69d7 = function runSTFn4(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function() {
                        return fn(a, b, c, d);
                    };
                };
            };
        };
    };
};
const $cc20365e325869f4$export$df815fcba9ace1f4 = function runSTFn5(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function() {
                            return fn(a, b, c, d, e);
                        };
                    };
                };
            };
        };
    };
};
const $cc20365e325869f4$export$18e87184adad44fe = function runSTFn6(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function() {
                                return fn(a, b, c, d, e, f);
                            };
                        };
                    };
                };
            };
        };
    };
};
const $cc20365e325869f4$export$e282c4050f6499d3 = function runSTFn7(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function() {
                                    return fn(a, b, c, d, e, f, g);
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
const $cc20365e325869f4$export$1d03302402d80b8a = function runSTFn8(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function(h) {
                                    return function() {
                                        return fn(a, b, c, d, e, f, g, h);
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
const $cc20365e325869f4$export$9671bb34351fe15d = function runSTFn9(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function(h) {
                                    return function(i) {
                                        return function() {
                                            return fn(a, b, c, d, e, f, g, h, i);
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
const $cc20365e325869f4$export$54118f4544b4eca2 = function runSTFn10(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function(h) {
                                    return function(i) {
                                        return function(j) {
                                            return function() {
                                                return fn(a, b, c, d, e, f, g, h, i, j);
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};

});



parcelRegister("caTtn", function(module, exports) {

$parcel$export(module.exports, "pushWhile", () => $8dd172f1ebfb42af$export$f458d78453dee163);
$parcel$export(module.exports, "iterator", () => $8dd172f1ebfb42af$export$6f58e2338da23f4d);
$parcel$export(module.exports, "iterate", () => $8dd172f1ebfb42af$export$c1a059043cc9c119);
// Generated by purs version 0.15.16

var $JFoio = parcelRequire("JFoio");
var $kHt3z = parcelRequire("kHt3z");

var $aknBk = parcelRequire("aknBk");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");

var $lnl7Y = parcelRequire("lnl7Y");

var $ykHdR = parcelRequire("ykHdR");
var $8dd172f1ebfb42af$var$map = /* #__PURE__ */ $l0wDR.map($JFoio.functorST);
var $8dd172f1ebfb42af$var$not = /* #__PURE__ */ $lnl7Y.not($lnl7Y.heytingAlgebraBoolean);
var $8dd172f1ebfb42af$var$$$void = /* #__PURE__ */ $l0wDR.void($JFoio.functorST);
var $8dd172f1ebfb42af$var$Iterator = /* #__PURE__ */ function() {
    function Iterator(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Iterator.create = function(value0) {
        return function(value1) {
            return new Iterator(value0, value1);
        };
    };
    return Iterator;
}();
var $8dd172f1ebfb42af$export$4d3fb11e950abb9e = function(v) {
    return function __do() {
        var i = $kHt3z.read(v.value1)();
        return v.value0(i);
    };
};
var $8dd172f1ebfb42af$export$48cfd1e771a65c4f = function(v) {
    return function __do() {
        var i = $kHt3z.read(v.value1)();
        $JFoio.modify(function(v1) {
            return v1 + 1 | 0;
        })(v.value1)();
        return v.value0(i);
    };
};
var $8dd172f1ebfb42af$export$f458d78453dee163 = function(p) {
    return function(iter) {
        return function(array) {
            return function __do() {
                var $$break = $kHt3z.new(false)();
                while($8dd172f1ebfb42af$var$map($8dd172f1ebfb42af$var$not)($kHt3z.read($$break))())(function __do() {
                    var mx = $8dd172f1ebfb42af$export$4d3fb11e950abb9e(iter)();
                    if (mx instanceof $ykHdR.Just && p(mx.value0)) {
                        $aknBk.push(mx.value0)(array)();
                        return $8dd172f1ebfb42af$var$$$void($8dd172f1ebfb42af$export$48cfd1e771a65c4f(iter))();
                    }
                    return $8dd172f1ebfb42af$var$$$void($kHt3z.write(true)($$break))();
                })();
                return {};
            };
        };
    };
};
var $8dd172f1ebfb42af$export$907644183e99da16 = /* #__PURE__ */ $8dd172f1ebfb42af$export$f458d78453dee163(/* #__PURE__ */ $l4M7e.const(true));
var $8dd172f1ebfb42af$export$6f58e2338da23f4d = function(f) {
    return $8dd172f1ebfb42af$var$map($8dd172f1ebfb42af$var$Iterator.create(f))($kHt3z.new(0));
};
var $8dd172f1ebfb42af$export$c1a059043cc9c119 = function(iter) {
    return function(f) {
        return function __do() {
            var $$break = $kHt3z.new(false)();
            while($8dd172f1ebfb42af$var$map($8dd172f1ebfb42af$var$not)($kHt3z.read($$break))())(function __do() {
                var mx = $8dd172f1ebfb42af$export$48cfd1e771a65c4f(iter)();
                if (mx instanceof $ykHdR.Just) return f(mx.value0)();
                if (mx instanceof $ykHdR.Nothing) return $8dd172f1ebfb42af$var$$$void($kHt3z.write(true)($$break))();
                throw new Error("Failed pattern match at Data.Array.ST.Iterator (line 42, column 5 - line 44, column 47): " + [
                    mx.constructor.name
                ]);
            })();
            return {};
        };
    };
};
var $8dd172f1ebfb42af$export$dc4133c4d1844d49 = /* #__PURE__ */ function() {
    var $20 = $8dd172f1ebfb42af$var$map($ykHdR.isNothing);
    return function($21) {
        return $20($8dd172f1ebfb42af$export$4d3fb11e950abb9e($21));
    };
}();

});

parcelRegister("ikChJ", function(module, exports) {

$parcel$export(module.exports, "mkFn2", () => (parcelRequire("chZgc")).mkFn2);
$parcel$export(module.exports, "mkFn5", () => (parcelRequire("chZgc")).mkFn5);
$parcel$export(module.exports, "runFn2", () => (parcelRequire("chZgc")).runFn2);
$parcel$export(module.exports, "runFn3", () => (parcelRequire("chZgc")).runFn3);
$parcel$export(module.exports, "runFn4", () => (parcelRequire("chZgc")).runFn4);
$parcel$export(module.exports, "runFn5", () => (parcelRequire("chZgc")).runFn5);
// Generated by purs version 0.15.16

var $chZgc = parcelRequire("chZgc");
var $d587cad88c02b1d0$export$44d12d4204be2f8c = function(f) {
    return f;
};
var $d587cad88c02b1d0$export$31aab8bc8543af98 = function(f) {
    return f;
};

});
parcelRegister("chZgc", function(module, exports) {

$parcel$export(module.exports, "mkFn2", () => $8f2697950ee155e1$export$b12d5f1f5e196716);
$parcel$export(module.exports, "mkFn5", () => $8f2697950ee155e1$export$253781be9f84fbc);
$parcel$export(module.exports, "runFn2", () => $8f2697950ee155e1$export$b3f66664347b6e8d);
$parcel$export(module.exports, "runFn3", () => $8f2697950ee155e1$export$dd8987cb9f63b77e);
$parcel$export(module.exports, "runFn4", () => $8f2697950ee155e1$export$c4d34fab9eba1901);
$parcel$export(module.exports, "runFn5", () => $8f2697950ee155e1$export$ce6386a175247406);
// module Data.Function.Uncurried
const $8f2697950ee155e1$export$c12d67bac152a4ed = function(fn) {
    return function() {
        return fn();
    };
};
const $8f2697950ee155e1$export$b12d5f1f5e196716 = function(fn) {
    /* jshint maxparams: 2 */ return function(a, b) {
        return fn(a)(b);
    };
};
const $8f2697950ee155e1$export$7c6645ed044f896a = function(fn) {
    /* jshint maxparams: 3 */ return function(a, b, c) {
        return fn(a)(b)(c);
    };
};
const $8f2697950ee155e1$export$f9fcbfb8cc9a5d08 = function(fn) {
    /* jshint maxparams: 4 */ return function(a, b, c, d) {
        return fn(a)(b)(c)(d);
    };
};
const $8f2697950ee155e1$export$253781be9f84fbc = function(fn) {
    /* jshint maxparams: 5 */ return function(a, b, c, d, e) {
        return fn(a)(b)(c)(d)(e);
    };
};
const $8f2697950ee155e1$export$5a7e13c76f011743 = function(fn) {
    /* jshint maxparams: 6 */ return function(a, b, c, d, e, f) {
        return fn(a)(b)(c)(d)(e)(f);
    };
};
const $8f2697950ee155e1$export$72dc4a47844c2067 = function(fn) {
    /* jshint maxparams: 7 */ return function(a, b, c, d, e, f, g) {
        return fn(a)(b)(c)(d)(e)(f)(g);
    };
};
const $8f2697950ee155e1$export$f3e23d6db0ceb902 = function(fn) {
    /* jshint maxparams: 8 */ return function(a, b, c, d, e, f, g, h) {
        return fn(a)(b)(c)(d)(e)(f)(g)(h);
    };
};
const $8f2697950ee155e1$export$d6fc3733d257ba4b = function(fn) {
    /* jshint maxparams: 9 */ return function(a, b, c, d, e, f, g, h, i) {
        return fn(a)(b)(c)(d)(e)(f)(g)(h)(i);
    };
};
const $8f2697950ee155e1$export$55270393dfa2c83f = function(fn) {
    /* jshint maxparams: 10 */ return function(a, b, c, d, e, f, g, h, i, j) {
        return fn(a)(b)(c)(d)(e)(f)(g)(h)(i)(j);
    };
};
const $8f2697950ee155e1$export$6114565cacc4a539 = function(fn) {
    return fn();
};
const $8f2697950ee155e1$export$b3f66664347b6e8d = function(fn) {
    return function(a) {
        return function(b) {
            return fn(a, b);
        };
    };
};
const $8f2697950ee155e1$export$dd8987cb9f63b77e = function(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return fn(a, b, c);
            };
        };
    };
};
const $8f2697950ee155e1$export$c4d34fab9eba1901 = function(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return fn(a, b, c, d);
                };
            };
        };
    };
};
const $8f2697950ee155e1$export$ce6386a175247406 = function(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return fn(a, b, c, d, e);
                    };
                };
            };
        };
    };
};
const $8f2697950ee155e1$export$6764cfc4c1bcc63e = function(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return fn(a, b, c, d, e, f);
                        };
                    };
                };
            };
        };
    };
};
const $8f2697950ee155e1$export$27ec8d6a229d5fae = function(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return fn(a, b, c, d, e, f, g);
                            };
                        };
                    };
                };
            };
        };
    };
};
const $8f2697950ee155e1$export$8a7620e07ee87dd2 = function(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function(h) {
                                    return fn(a, b, c, d, e, f, g, h);
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
const $8f2697950ee155e1$export$a68eb29a6e51700a = function(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function(h) {
                                    return function(i) {
                                        return fn(a, b, c, d, e, f, g, h, i);
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
const $8f2697950ee155e1$export$182286db78b54e73 = function(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function(h) {
                                    return function(i) {
                                        return function(j) {
                                            return fn(a, b, c, d, e, f, g, h, i, j);
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};

});


parcelRegister("4oUwX", function(module, exports) {

$parcel$export(module.exports, "mapWithIndex", () => $334541180b4ef18c$export$8f07ddce13659f50);
$parcel$export(module.exports, "functorWithIndexTuple", () => $334541180b4ef18c$export$98b99a3e5a5c2768);
$parcel$export(module.exports, "functorWithIndexProduct", () => $334541180b4ef18c$export$341bcd9812b20e54);
$parcel$export(module.exports, "functorWithIndexMultiplicative", () => $334541180b4ef18c$export$3f7256b7802d7d35);
$parcel$export(module.exports, "functorWithIndexMaybe", () => $334541180b4ef18c$export$ff6e9b408c0f1d0a);
$parcel$export(module.exports, "functorWithIndexLast", () => $334541180b4ef18c$export$67874b1834c6566b);
$parcel$export(module.exports, "functorWithIndexIdentity", () => $334541180b4ef18c$export$26258e29c904633d);
$parcel$export(module.exports, "functorWithIndexFirst", () => $334541180b4ef18c$export$707dfb58df7f6e4f);
$parcel$export(module.exports, "functorWithIndexEither", () => $334541180b4ef18c$export$381e44b6c18f93d6);
$parcel$export(module.exports, "functorWithIndexDual", () => $334541180b4ef18c$export$50b3765d14980fc);
$parcel$export(module.exports, "functorWithIndexDisj", () => $334541180b4ef18c$export$b6070cf53db1d339);
$parcel$export(module.exports, "functorWithIndexCoproduct", () => $334541180b4ef18c$export$6f7aa172554aa552);
$parcel$export(module.exports, "functorWithIndexConst", () => $334541180b4ef18c$export$dba6a24121753c2b);
$parcel$export(module.exports, "functorWithIndexConj", () => $334541180b4ef18c$export$8ba1941ba7d99c6);
$parcel$export(module.exports, "functorWithIndexCompose", () => $334541180b4ef18c$export$7935f2d7643e66ce);
$parcel$export(module.exports, "functorWithIndexArray", () => $334541180b4ef18c$export$f10d51ea0aa3da42);
$parcel$export(module.exports, "functorWithIndexApp", () => $334541180b4ef18c$export$ffe1008ccae78edc);
$parcel$export(module.exports, "functorWithIndexAdditive", () => $334541180b4ef18c$export$eee3f4036a1ebada);
// Generated by purs version 0.15.16

var $8zSAk = parcelRequire("8zSAk");

var $2Mmje = parcelRequire("2Mmje");

var $1qMIU = parcelRequire("1qMIU");

var $aKY4H = parcelRequire("aKY4H");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");

var $8jFkD = parcelRequire("8jFkD");

var $8gI0w = parcelRequire("8gI0w");

var $6gSOm = parcelRequire("6gSOm");

var $dUqA2 = parcelRequire("dUqA2");

var $6VVZC = parcelRequire("6VVZC");

var $ykHdR = parcelRequire("ykHdR");

var $cxbq2 = parcelRequire("cxbq2");

var $2liqj = parcelRequire("2liqj");

var $jCCb5 = parcelRequire("jCCb5");

var $8JeQl = parcelRequire("8JeQl");

var $1zczT = parcelRequire("1zczT");

var $bbOAS = parcelRequire("bbOAS");

var $8MGTa = parcelRequire("8MGTa");

var $9MxTl = parcelRequire("9MxTl");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");
var $334541180b4ef18c$var$map = /* #__PURE__ */ $l0wDR.map($9MxTl.functorTuple);
var $334541180b4ef18c$var$bimap = /* #__PURE__ */ $2Mmje.bimap($2Mmje.bifunctorTuple);
var $334541180b4ef18c$var$map1 = /* #__PURE__ */ $l0wDR.map($8MGTa.functorMultiplicative);
var $334541180b4ef18c$var$map2 = /* #__PURE__ */ $l0wDR.map($ykHdR.functorMaybe);
var $334541180b4ef18c$var$map3 = /* #__PURE__ */ $l0wDR.map($2liqj.functorLast);
var $334541180b4ef18c$var$map4 = /* #__PURE__ */ $l0wDR.map($cxbq2.functorFirst);
var $334541180b4ef18c$var$map5 = /* #__PURE__ */ $l0wDR.map($aKY4H.functorEither);
var $334541180b4ef18c$var$map6 = /* #__PURE__ */ $l0wDR.map($bbOAS.functorDual);
var $334541180b4ef18c$var$map7 = /* #__PURE__ */ $l0wDR.map($1zczT.functorDisj);
var $334541180b4ef18c$var$bimap1 = /* #__PURE__ */ $2Mmje.bimap($2Mmje.bifunctorEither);
var $334541180b4ef18c$var$map8 = /* #__PURE__ */ $l0wDR.map($8JeQl.functorConj);
var $334541180b4ef18c$var$map9 = /* #__PURE__ */ $l0wDR.map($jCCb5.functorAdditive);
var $334541180b4ef18c$export$8f07ddce13659f50 = function(dict) {
    return dict.mapWithIndex;
};
var $334541180b4ef18c$export$6942612de3ba9e09 = function(dictFunctorWithIndex) {
    var mapWithIndex1 = $334541180b4ef18c$export$8f07ddce13659f50(dictFunctorWithIndex);
    return function(f) {
        return mapWithIndex1($l4M7e.const(f));
    };
};
var $334541180b4ef18c$export$98b99a3e5a5c2768 = {
    mapWithIndex: function(f) {
        return $334541180b4ef18c$var$map(f($r2HHk.unit));
    },
    Functor0: function() {
        return $9MxTl.functorTuple;
    }
};
var $334541180b4ef18c$export$341bcd9812b20e54 = function(dictFunctorWithIndex) {
    var mapWithIndex1 = $334541180b4ef18c$export$8f07ddce13659f50(dictFunctorWithIndex);
    var functorProduct = $dUqA2.functorProduct(dictFunctorWithIndex.Functor0());
    return function(dictFunctorWithIndex1) {
        var mapWithIndex2 = $334541180b4ef18c$export$8f07ddce13659f50(dictFunctorWithIndex1);
        var functorProduct1 = functorProduct(dictFunctorWithIndex1.Functor0());
        return {
            mapWithIndex: function(f) {
                return function(v) {
                    return $334541180b4ef18c$var$bimap(mapWithIndex1(function($63) {
                        return f($aKY4H.Left.create($63));
                    }))(mapWithIndex2(function($64) {
                        return f($aKY4H.Right.create($64));
                    }))(v);
                };
            },
            Functor0: function() {
                return functorProduct1;
            }
        };
    };
};
var $334541180b4ef18c$export$3f7256b7802d7d35 = {
    mapWithIndex: function(f) {
        return $334541180b4ef18c$var$map1(f($r2HHk.unit));
    },
    Functor0: function() {
        return $8MGTa.functorMultiplicative;
    }
};
var $334541180b4ef18c$export$ff6e9b408c0f1d0a = {
    mapWithIndex: function(f) {
        return $334541180b4ef18c$var$map2(f($r2HHk.unit));
    },
    Functor0: function() {
        return $ykHdR.functorMaybe;
    }
};
var $334541180b4ef18c$export$67874b1834c6566b = {
    mapWithIndex: function(f) {
        return $334541180b4ef18c$var$map3(f($r2HHk.unit));
    },
    Functor0: function() {
        return $2liqj.functorLast;
    }
};
var $334541180b4ef18c$export$26258e29c904633d = {
    mapWithIndex: function(f) {
        return function(v) {
            return f($r2HHk.unit)(v);
        };
    },
    Functor0: function() {
        return $6VVZC.functorIdentity;
    }
};
var $334541180b4ef18c$export$707dfb58df7f6e4f = {
    mapWithIndex: function(f) {
        return $334541180b4ef18c$var$map4(f($r2HHk.unit));
    },
    Functor0: function() {
        return $cxbq2.functorFirst;
    }
};
var $334541180b4ef18c$export$381e44b6c18f93d6 = {
    mapWithIndex: function(f) {
        return $334541180b4ef18c$var$map5(f($r2HHk.unit));
    },
    Functor0: function() {
        return $aKY4H.functorEither;
    }
};
var $334541180b4ef18c$export$50b3765d14980fc = {
    mapWithIndex: function(f) {
        return $334541180b4ef18c$var$map6(f($r2HHk.unit));
    },
    Functor0: function() {
        return $bbOAS.functorDual;
    }
};
var $334541180b4ef18c$export$b6070cf53db1d339 = {
    mapWithIndex: function(f) {
        return $334541180b4ef18c$var$map7(f($r2HHk.unit));
    },
    Functor0: function() {
        return $1zczT.functorDisj;
    }
};
var $334541180b4ef18c$export$6f7aa172554aa552 = function(dictFunctorWithIndex) {
    var mapWithIndex1 = $334541180b4ef18c$export$8f07ddce13659f50(dictFunctorWithIndex);
    var functorCoproduct = $6gSOm.functorCoproduct(dictFunctorWithIndex.Functor0());
    return function(dictFunctorWithIndex1) {
        var mapWithIndex2 = $334541180b4ef18c$export$8f07ddce13659f50(dictFunctorWithIndex1);
        var functorCoproduct1 = functorCoproduct(dictFunctorWithIndex1.Functor0());
        return {
            mapWithIndex: function(f) {
                return function(v) {
                    return $334541180b4ef18c$var$bimap1(mapWithIndex1(function($65) {
                        return f($aKY4H.Left.create($65));
                    }))(mapWithIndex2(function($66) {
                        return f($aKY4H.Right.create($66));
                    }))(v);
                };
            },
            Functor0: function() {
                return functorCoproduct1;
            }
        };
    };
};
var $334541180b4ef18c$export$dba6a24121753c2b = {
    mapWithIndex: function(v) {
        return function(v1) {
            return v1;
        };
    },
    Functor0: function() {
        return $1qMIU.functorConst;
    }
};
var $334541180b4ef18c$export$8ba1941ba7d99c6 = {
    mapWithIndex: function(f) {
        return $334541180b4ef18c$var$map8(f($r2HHk.unit));
    },
    Functor0: function() {
        return $8JeQl.functorConj;
    }
};
var $334541180b4ef18c$export$7935f2d7643e66ce = function(dictFunctorWithIndex) {
    var mapWithIndex1 = $334541180b4ef18c$export$8f07ddce13659f50(dictFunctorWithIndex);
    var functorCompose = $8gI0w.functorCompose(dictFunctorWithIndex.Functor0());
    return function(dictFunctorWithIndex1) {
        var mapWithIndex2 = $334541180b4ef18c$export$8f07ddce13659f50(dictFunctorWithIndex1);
        var functorCompose1 = functorCompose(dictFunctorWithIndex1.Functor0());
        return {
            mapWithIndex: function(f) {
                return function(v) {
                    return mapWithIndex1(function() {
                        var $67 = $9MxTl.curry(f);
                        return function($68) {
                            return mapWithIndex2($67($68));
                        };
                    }())(v);
                };
            },
            Functor0: function() {
                return functorCompose1;
            }
        };
    };
};
var $334541180b4ef18c$export$f10d51ea0aa3da42 = {
    mapWithIndex: $8zSAk.mapWithIndexArray,
    Functor0: function() {
        return $l0wDR.functorArray;
    }
};
var $334541180b4ef18c$export$ffe1008ccae78edc = function(dictFunctorWithIndex) {
    var mapWithIndex1 = $334541180b4ef18c$export$8f07ddce13659f50(dictFunctorWithIndex);
    var functorApp = $8jFkD.functorApp(dictFunctorWithIndex.Functor0());
    return {
        mapWithIndex: function(f) {
            return function(v) {
                return mapWithIndex1(f)(v);
            };
        },
        Functor0: function() {
            return functorApp;
        }
    };
};
var $334541180b4ef18c$export$eee3f4036a1ebada = {
    mapWithIndex: function(f) {
        return $334541180b4ef18c$var$map9(f($r2HHk.unit));
    },
    Functor0: function() {
        return $jCCb5.functorAdditive;
    }
};

});
parcelRegister("8zSAk", function(module, exports) {

$parcel$export(module.exports, "mapWithIndexArray", () => $63ebef0b12494a84$export$e1e714991b6c2aba);
const $63ebef0b12494a84$export$e1e714991b6c2aba = function(f) {
    return function(xs) {
        var l = xs.length;
        var result = Array(l);
        for(var i = 0; i < l; i++)result[i] = f(i)(xs[i]);
        return result;
    };
};

});



parcelRegister("hhMAk", function(module, exports) {

$parcel$export(module.exports, "widget", () => $c959b62ce0c19dfe$export$f0c5cfb390964b78);
$parcel$export(module.exports, "text", () => $c959b62ce0c19dfe$export$6f093cfa640b7166);
$parcel$export(module.exports, "ref", () => $c959b62ce0c19dfe$export$eff4d24c3ff7876e);
$parcel$export(module.exports, "prop", () => $c959b62ce0c19dfe$export$977f3f6a9323c0f6);
$parcel$export(module.exports, "renderWidget", () => $c959b62ce0c19dfe$export$8b4d9aa5702dece6);
$parcel$export(module.exports, "keyed", () => $c959b62ce0c19dfe$export$8dbf9c790527241e);
$parcel$export(module.exports, "isPropString", () => $c959b62ce0c19dfe$export$32e0d8bef35d3088);
$parcel$export(module.exports, "isPropStepValue", () => $c959b62ce0c19dfe$export$a77e3c7f90d13c3c);
$parcel$export(module.exports, "isPropScopeValue", () => $c959b62ce0c19dfe$export$cf79af8281015ccd);
$parcel$export(module.exports, "isPropPreloadValue", () => $c959b62ce0c19dfe$export$1cf8b1fb41618835);
$parcel$export(module.exports, "isPropNumber", () => $c959b62ce0c19dfe$export$6b61652c1897c1a);
$parcel$export(module.exports, "isPropMediaType", () => $c959b62ce0c19dfe$export$7bd1d02eb87275db);
$parcel$export(module.exports, "isPropInt", () => $c959b62ce0c19dfe$export$4c390c75bcc39428);
$parcel$export(module.exports, "isPropInputAcceptType", () => $c959b62ce0c19dfe$export$27dc712f9cde9a29);
$parcel$export(module.exports, "isPropFormMethod", () => $c959b62ce0c19dfe$export$efe5d718899194d9);
$parcel$export(module.exports, "isPropBoolean", () => $c959b62ce0c19dfe$export$4e3e21220a22c900);
$parcel$export(module.exports, "isPropAutocompleteType", () => $c959b62ce0c19dfe$export$a538daf4c6392dcf);
$parcel$export(module.exports, "handler", () => $c959b62ce0c19dfe$export$c3c52e219617878);
$parcel$export(module.exports, "element", () => $c959b62ce0c19dfe$export$8454457683f90105);
$parcel$export(module.exports, "bifunctorHTML", () => $c959b62ce0c19dfe$export$a671de4661736606);
$parcel$export(module.exports, "attr", () => $c959b62ce0c19dfe$export$7aabe8b3a840d2fd);
// Generated by purs version 0.15.16

var $6DdrA = parcelRequire("6DdrA");

var $h2vLF = parcelRequire("h2vLF");

var $kOhUj = parcelRequire("kOhUj");

var $1fwLN = parcelRequire("1fwLN");

var $ibAKj = parcelRequire("ibAKj");

var $ebWzy = parcelRequire("ebWzy");

var $hKGK1 = parcelRequire("hKGK1");

var $19t60 = parcelRequire("19t60");

var $7odkg = parcelRequire("7odkg");

var $1UfuE = parcelRequire("1UfuE");

var $8cBb2 = parcelRequire("8cBb2");

var $7ZKwO = parcelRequire("7ZKwO");

var $3rLU8 = parcelRequire("3rLU8");

var $dqDZn = parcelRequire("dqDZn");

var $7f5Dk = parcelRequire("7f5Dk");

var $2Mmje = parcelRequire("2Mmje");

var $l0wDR = parcelRequire("l0wDR");

var $ykHdR = parcelRequire("ykHdR");

var $6PW1p = parcelRequire("6PW1p");

var $cVGsR = parcelRequire("cVGsR");
parcelRequire("lnVhq");
var $gorft = parcelRequire("gorft");

var $lrGyk = parcelRequire("lrGyk");

var $gorft = parcelRequire("gorft");

var $iBWyn = parcelRequire("iBWyn");
var $c959b62ce0c19dfe$var$map = /* #__PURE__ */ $l0wDR.map($l0wDR.functorArray);
var $c959b62ce0c19dfe$var$map1 = /* #__PURE__ */ $l0wDR.map($lrGyk.functorProp);
var $c959b62ce0c19dfe$var$map2 = /* #__PURE__ */ $l0wDR.map($cVGsR.functorInput);
var $c959b62ce0c19dfe$var$un = /* #__PURE__ */ $6PW1p.un();
var $c959b62ce0c19dfe$var$bimap = /* #__PURE__ */ $2Mmje.bimap($gorft.bifunctorVDom);
var $c959b62ce0c19dfe$export$9dcd2b1ca4768128 = function(x) {
    return x;
};
var $c959b62ce0c19dfe$export$f0c5cfb390964b78 = function($28) {
    return $c959b62ce0c19dfe$export$9dcd2b1ca4768128($gorft.Widget.create($28));
};
var $c959b62ce0c19dfe$export$ccd8a7ec14afc6c9 = function(dict) {
    return dict.toPropValue;
};
var $c959b62ce0c19dfe$export$6f093cfa640b7166 = function($29) {
    return $c959b62ce0c19dfe$export$9dcd2b1ca4768128($gorft.Text.create($29));
};
var $c959b62ce0c19dfe$export$eff4d24c3ff7876e = function(f) {
    return new $lrGyk.Ref(function($30) {
        return f(function(v) {
            if (v instanceof $lrGyk.Created) return new $ykHdR.Just(v.value0);
            if (v instanceof $lrGyk.Removed) return $ykHdR.Nothing.value;
            throw new Error("Failed pattern match at Halogen.HTML.Core (line 109, column 21 - line 111, column 23): " + [
                v.constructor.name
            ]);
        }($30));
    });
};
var $c959b62ce0c19dfe$export$977f3f6a9323c0f6 = function(dictIsProp) {
    var toPropValue1 = $c959b62ce0c19dfe$export$ccd8a7ec14afc6c9(dictIsProp);
    return function(v) {
        var $31 = $lrGyk.Property.create(v);
        return function($32) {
            return $31(toPropValue1($32));
        };
    };
};
var $c959b62ce0c19dfe$export$3313fed09a42a979 = {
    Coercible0: function() {
        return undefined;
    }
};
var $c959b62ce0c19dfe$export$8b4d9aa5702dece6 = function(f) {
    return function(g) {
        return function(v) {
            return $gorft.renderWidget($c959b62ce0c19dfe$var$map($c959b62ce0c19dfe$var$map1($c959b62ce0c19dfe$var$map2(f))))(function() {
                var $33 = $c959b62ce0c19dfe$var$un($c959b62ce0c19dfe$export$9dcd2b1ca4768128);
                return function($34) {
                    return $33(g($34));
                };
            }())(v);
        };
    };
};
var $c959b62ce0c19dfe$export$8dbf9c790527241e = function(ns) {
    return function(name) {
        return function(props) {
            return function(children) {
                return new $gorft.Keyed(ns, name, props, children);
            };
        };
    };
};
var $c959b62ce0c19dfe$export$78da172345adb805 = {
    toPropValue: function($35) {
        return $lrGyk.propFromString($7f5Dk.renderWrapValue($35));
    }
};
var $c959b62ce0c19dfe$export$32e0d8bef35d3088 = {
    toPropValue: $lrGyk.propFromString
};
var $c959b62ce0c19dfe$export$a77e3c7f90d13c3c = {
    toPropValue: function($36) {
        return $lrGyk.propFromString($dqDZn.renderStepValue($36));
    }
};
var $c959b62ce0c19dfe$export$cf79af8281015ccd = {
    toPropValue: function($37) {
        return $lrGyk.propFromString($3rLU8.renderScopeValue($37));
    }
};
var $c959b62ce0c19dfe$export$1cf8b1fb41618835 = {
    toPropValue: function($38) {
        return $lrGyk.propFromString($7ZKwO.renderPreloadValue($38));
    }
};
var $c959b62ce0c19dfe$export$93423863175829d3 = {
    toPropValue: function($39) {
        return $lrGyk.propFromString($8cBb2.renderOrderedListType($39));
    }
};
var $c959b62ce0c19dfe$export$6b61652c1897c1a = {
    toPropValue: $lrGyk.propFromNumber
};
var $c959b62ce0c19dfe$export$4a37bd3810743b12 = {
    toPropValue: function($40) {
        return $lrGyk.propFromString($1UfuE.renderMenuitemType($40));
    }
};
var $c959b62ce0c19dfe$export$4111c2fa23eef626 = {
    toPropValue: function($41) {
        return $lrGyk.propFromString($7odkg.renderMenuType($41));
    }
};
var $c959b62ce0c19dfe$export$7bd1d02eb87275db = {
    toPropValue: /* #__PURE__ */ function() {
        var $42 = $6PW1p.unwrap();
        return function($43) {
            return $lrGyk.propFromString($42($43));
        };
    }()
};
var $c959b62ce0c19dfe$export$f017ebe0bff0b5df = {
    toPropValue: function($44) {
        return $lrGyk.propFromString($19t60.renderKindValue($44));
    }
};
var $c959b62ce0c19dfe$export$4c390c75bcc39428 = {
    toPropValue: $lrGyk.propFromInt
};
var $c959b62ce0c19dfe$export$7333503111bf9adf = {
    toPropValue: function($45) {
        return $lrGyk.propFromString($hKGK1.renderInputType($45));
    }
};
var $c959b62ce0c19dfe$export$27dc712f9cde9a29 = {
    toPropValue: function($46) {
        return $lrGyk.propFromString($ebWzy.renderInputAcceptType($46));
    }
};
var $c959b62ce0c19dfe$export$efe5d718899194d9 = {
    toPropValue: function($47) {
        return $lrGyk.propFromString($ibAKj.renderFormMethod($47));
    }
};
var $c959b62ce0c19dfe$export$60997a3274b6da18 = {
    toPropValue: function($48) {
        return $lrGyk.propFromString($1fwLN.renderDirValue($48));
    }
};
var $c959b62ce0c19dfe$export$56ccba9272e74ac2 = {
    toPropValue: function($49) {
        return $lrGyk.propFromString($kOhUj.renderCrossOriginValue($49));
    }
};
var $c959b62ce0c19dfe$export$d48eb3d89026ef9 = {
    toPropValue: function($50) {
        return $lrGyk.propFromString($h2vLF.renderButtonType($50));
    }
};
var $c959b62ce0c19dfe$export$4e3e21220a22c900 = {
    toPropValue: $lrGyk.propFromBoolean
};
var $c959b62ce0c19dfe$export$a538daf4c6392dcf = {
    toPropValue: function($51) {
        return $lrGyk.propFromString($6DdrA.renderAutocompleteType($51));
    }
};
var $c959b62ce0c19dfe$export$c3c52e219617878 = /* #__PURE__ */ function() {
    return $lrGyk.Handler.create;
}();
var $c959b62ce0c19dfe$export$8454457683f90105 = function(ns) {
    return function(name) {
        return function(props) {
            return function(children) {
                return new $gorft.Elem(ns, name, props, children);
            };
        };
    };
};
var $c959b62ce0c19dfe$export$a671de4661736606 = {
    bimap: function(f) {
        return function(g) {
            return function(v) {
                return $c959b62ce0c19dfe$var$bimap($c959b62ce0c19dfe$var$map($c959b62ce0c19dfe$var$map1($c959b62ce0c19dfe$var$map2(g))))(f)(v);
            };
        };
    }
};
var $c959b62ce0c19dfe$export$a02e13c6b9f001c6 = {
    map: /* #__PURE__ */ $2Mmje.rmap($c959b62ce0c19dfe$export$a671de4661736606)
};
var $c959b62ce0c19dfe$export$7aabe8b3a840d2fd = function(ns) {
    return function(v) {
        return $lrGyk.Attribute.create(ns)(v);
    };
};

});
parcelRegister("6DdrA", function(module, exports) {

$parcel$export(module.exports, "renderAutocompleteType", () => $4d40d048175dacfe$export$9b8eae2964bb4cd5);
// Generated by purs version 0.15.16

var $6SDUu = parcelRequire("6SDUu");
var $4d40d048175dacfe$export$7ba2b3d677b0db1c = /* #__PURE__ */ function() {
    function AutocompleteOff() {}
    AutocompleteOff.value = new AutocompleteOff();
    return AutocompleteOff;
}();
var $4d40d048175dacfe$export$1ef0df3f3e6a4dab = /* #__PURE__ */ function() {
    function AutocompleteOn() {}
    AutocompleteOn.value = new AutocompleteOn();
    return AutocompleteOn;
}();
var $4d40d048175dacfe$export$4da01cb598a0d97e = /* #__PURE__ */ function() {
    function AutocompleteName() {}
    AutocompleteName.value = new AutocompleteName();
    return AutocompleteName;
}();
var $4d40d048175dacfe$export$ccb63fd7a749a381 = /* #__PURE__ */ function() {
    function AutocompleteHonorificPrefix() {}
    AutocompleteHonorificPrefix.value = new AutocompleteHonorificPrefix();
    return AutocompleteHonorificPrefix;
}();
var $4d40d048175dacfe$export$a2e3a2bb787472eb = /* #__PURE__ */ function() {
    function AutocompleteGivenName() {}
    AutocompleteGivenName.value = new AutocompleteGivenName();
    return AutocompleteGivenName;
}();
var $4d40d048175dacfe$export$c2899da73c95f826 = /* #__PURE__ */ function() {
    function AutocompleteAdditionalName() {}
    AutocompleteAdditionalName.value = new AutocompleteAdditionalName();
    return AutocompleteAdditionalName;
}();
var $4d40d048175dacfe$export$b189863462ae27fe = /* #__PURE__ */ function() {
    function AutocompleteFamilyName() {}
    AutocompleteFamilyName.value = new AutocompleteFamilyName();
    return AutocompleteFamilyName;
}();
var $4d40d048175dacfe$export$5481c9b080fac1ad = /* #__PURE__ */ function() {
    function AutocompleteHonorificSuffix() {}
    AutocompleteHonorificSuffix.value = new AutocompleteHonorificSuffix();
    return AutocompleteHonorificSuffix;
}();
var $4d40d048175dacfe$export$ed6c67e3f00c02f7 = /* #__PURE__ */ function() {
    function AutocompleteNickname() {}
    AutocompleteNickname.value = new AutocompleteNickname();
    return AutocompleteNickname;
}();
var $4d40d048175dacfe$export$3f2abff6b2574d28 = /* #__PURE__ */ function() {
    function AutocompleteEmail() {}
    AutocompleteEmail.value = new AutocompleteEmail();
    return AutocompleteEmail;
}();
var $4d40d048175dacfe$export$8ef7db4a55783560 = /* #__PURE__ */ function() {
    function AutocompleteUsername() {}
    AutocompleteUsername.value = new AutocompleteUsername();
    return AutocompleteUsername;
}();
var $4d40d048175dacfe$export$2aec4081bfc982fb = /* #__PURE__ */ function() {
    function AutocompleteNewPassword() {}
    AutocompleteNewPassword.value = new AutocompleteNewPassword();
    return AutocompleteNewPassword;
}();
var $4d40d048175dacfe$export$8ee6fb6ac028afda = /* #__PURE__ */ function() {
    function AutocompleteCurrentPassword() {}
    AutocompleteCurrentPassword.value = new AutocompleteCurrentPassword();
    return AutocompleteCurrentPassword;
}();
var $4d40d048175dacfe$export$6f27218568808639 = /* #__PURE__ */ function() {
    function AutocompleteOneTimeCode() {}
    AutocompleteOneTimeCode.value = new AutocompleteOneTimeCode();
    return AutocompleteOneTimeCode;
}();
var $4d40d048175dacfe$export$9748581da6bbbe4e = /* #__PURE__ */ function() {
    function AutocompleteOrganizationTitle() {}
    AutocompleteOrganizationTitle.value = new AutocompleteOrganizationTitle();
    return AutocompleteOrganizationTitle;
}();
var $4d40d048175dacfe$export$5fd9f780846e028b = /* #__PURE__ */ function() {
    function AutocompleteOrganization() {}
    AutocompleteOrganization.value = new AutocompleteOrganization();
    return AutocompleteOrganization;
}();
var $4d40d048175dacfe$export$499720fb85152dfe = /* #__PURE__ */ function() {
    function AutocompleteStreetAddress() {}
    AutocompleteStreetAddress.value = new AutocompleteStreetAddress();
    return AutocompleteStreetAddress;
}();
var $4d40d048175dacfe$export$6b6488e90da63d6 = /* #__PURE__ */ function() {
    function AutocompleteAddressLine1() {}
    AutocompleteAddressLine1.value = new AutocompleteAddressLine1();
    return AutocompleteAddressLine1;
}();
var $4d40d048175dacfe$export$92dfe98bc9dbafde = /* #__PURE__ */ function() {
    function AutocompleteAddressLine2() {}
    AutocompleteAddressLine2.value = new AutocompleteAddressLine2();
    return AutocompleteAddressLine2;
}();
var $4d40d048175dacfe$export$ea74132c1bd19261 = /* #__PURE__ */ function() {
    function AutocompleteAddressLine3() {}
    AutocompleteAddressLine3.value = new AutocompleteAddressLine3();
    return AutocompleteAddressLine3;
}();
var $4d40d048175dacfe$export$e5454c7695ddbd5c = /* #__PURE__ */ function() {
    function AutocompleteAddressLevel1() {}
    AutocompleteAddressLevel1.value = new AutocompleteAddressLevel1();
    return AutocompleteAddressLevel1;
}();
var $4d40d048175dacfe$export$af0e2cc0795570d9 = /* #__PURE__ */ function() {
    function AutocompleteAddressLevel2() {}
    AutocompleteAddressLevel2.value = new AutocompleteAddressLevel2();
    return AutocompleteAddressLevel2;
}();
var $4d40d048175dacfe$export$f76ce82784afe674 = /* #__PURE__ */ function() {
    function AutocompleteAddressLevel3() {}
    AutocompleteAddressLevel3.value = new AutocompleteAddressLevel3();
    return AutocompleteAddressLevel3;
}();
var $4d40d048175dacfe$export$5f9c079ff6708773 = /* #__PURE__ */ function() {
    function AutocompleteAddressLevel4() {}
    AutocompleteAddressLevel4.value = new AutocompleteAddressLevel4();
    return AutocompleteAddressLevel4;
}();
var $4d40d048175dacfe$export$44c5bb026cbe6e37 = /* #__PURE__ */ function() {
    function AutocompleteCountry() {}
    AutocompleteCountry.value = new AutocompleteCountry();
    return AutocompleteCountry;
}();
var $4d40d048175dacfe$export$e259ef3995a99fd4 = /* #__PURE__ */ function() {
    function AutocompleteCountryName() {}
    AutocompleteCountryName.value = new AutocompleteCountryName();
    return AutocompleteCountryName;
}();
var $4d40d048175dacfe$export$f95f909e01aa4cb3 = /* #__PURE__ */ function() {
    function AutocompletePostalCode() {}
    AutocompletePostalCode.value = new AutocompletePostalCode();
    return AutocompletePostalCode;
}();
var $4d40d048175dacfe$export$67ade628725afe90 = /* #__PURE__ */ function() {
    function AutocompleteCreditCardName() {}
    AutocompleteCreditCardName.value = new AutocompleteCreditCardName();
    return AutocompleteCreditCardName;
}();
var $4d40d048175dacfe$export$f03ef3c27a8e4a4b = /* #__PURE__ */ function() {
    function AutocompleteCreditCardGivenName() {}
    AutocompleteCreditCardGivenName.value = new AutocompleteCreditCardGivenName();
    return AutocompleteCreditCardGivenName;
}();
var $4d40d048175dacfe$export$1b45801580e5182f = /* #__PURE__ */ function() {
    function AutocompleteCreditCardAdditionalName() {}
    AutocompleteCreditCardAdditionalName.value = new AutocompleteCreditCardAdditionalName();
    return AutocompleteCreditCardAdditionalName;
}();
var $4d40d048175dacfe$export$d906c17550f3b6f1 = /* #__PURE__ */ function() {
    function AutocompleteCreditCardFamilyName() {}
    AutocompleteCreditCardFamilyName.value = new AutocompleteCreditCardFamilyName();
    return AutocompleteCreditCardFamilyName;
}();
var $4d40d048175dacfe$export$267a9616c09f33fa = /* #__PURE__ */ function() {
    function AutocompleteCreditCardNumber() {}
    AutocompleteCreditCardNumber.value = new AutocompleteCreditCardNumber();
    return AutocompleteCreditCardNumber;
}();
var $4d40d048175dacfe$export$4ac537c498251bbf = /* #__PURE__ */ function() {
    function AutocompleteCreditCardExpiration() {}
    AutocompleteCreditCardExpiration.value = new AutocompleteCreditCardExpiration();
    return AutocompleteCreditCardExpiration;
}();
var $4d40d048175dacfe$export$2e15cf96bd811454 = /* #__PURE__ */ function() {
    function AutocompleteCreditCardExpirationMonth() {}
    AutocompleteCreditCardExpirationMonth.value = new AutocompleteCreditCardExpirationMonth();
    return AutocompleteCreditCardExpirationMonth;
}();
var $4d40d048175dacfe$export$7c4efb1d2d0a7d5d = /* #__PURE__ */ function() {
    function AutocompleteCreditCardExpirationYear() {}
    AutocompleteCreditCardExpirationYear.value = new AutocompleteCreditCardExpirationYear();
    return AutocompleteCreditCardExpirationYear;
}();
var $4d40d048175dacfe$export$42f27b71e570e84c = /* #__PURE__ */ function() {
    function AutocompleteCreditCardSecurityCode() {}
    AutocompleteCreditCardSecurityCode.value = new AutocompleteCreditCardSecurityCode();
    return AutocompleteCreditCardSecurityCode;
}();
var $4d40d048175dacfe$export$7dd055ac3e2d902c = /* #__PURE__ */ function() {
    function AutocompleteCreditCardType() {}
    AutocompleteCreditCardType.value = new AutocompleteCreditCardType();
    return AutocompleteCreditCardType;
}();
var $4d40d048175dacfe$export$918eb55efc9f2e5c = /* #__PURE__ */ function() {
    function AutocompleteTransactionCurrency() {}
    AutocompleteTransactionCurrency.value = new AutocompleteTransactionCurrency();
    return AutocompleteTransactionCurrency;
}();
var $4d40d048175dacfe$export$9d4a96b43ef247de = /* #__PURE__ */ function() {
    function AutocompleteTransactionAmount() {}
    AutocompleteTransactionAmount.value = new AutocompleteTransactionAmount();
    return AutocompleteTransactionAmount;
}();
var $4d40d048175dacfe$export$f69bc69473d6d1fa = /* #__PURE__ */ function() {
    function AutocompleteLanguage() {}
    AutocompleteLanguage.value = new AutocompleteLanguage();
    return AutocompleteLanguage;
}();
var $4d40d048175dacfe$export$db103677e4262f74 = /* #__PURE__ */ function() {
    function AutocompleteBirthday() {}
    AutocompleteBirthday.value = new AutocompleteBirthday();
    return AutocompleteBirthday;
}();
var $4d40d048175dacfe$export$976267f1375fd072 = /* #__PURE__ */ function() {
    function AutocompleteBirthdayDay() {}
    AutocompleteBirthdayDay.value = new AutocompleteBirthdayDay();
    return AutocompleteBirthdayDay;
}();
var $4d40d048175dacfe$export$345017daa9311763 = /* #__PURE__ */ function() {
    function AutocompleteBirthdayMonth() {}
    AutocompleteBirthdayMonth.value = new AutocompleteBirthdayMonth();
    return AutocompleteBirthdayMonth;
}();
var $4d40d048175dacfe$export$a58218c48fdc359f = /* #__PURE__ */ function() {
    function AutocompleteBirthdayYear() {}
    AutocompleteBirthdayYear.value = new AutocompleteBirthdayYear();
    return AutocompleteBirthdayYear;
}();
var $4d40d048175dacfe$export$41a3d5735ecfd56f = /* #__PURE__ */ function() {
    function AutocompleteSex() {}
    AutocompleteSex.value = new AutocompleteSex();
    return AutocompleteSex;
}();
var $4d40d048175dacfe$export$dc25bbd279bd7147 = /* #__PURE__ */ function() {
    function AutocompleteTelephone() {}
    AutocompleteTelephone.value = new AutocompleteTelephone();
    return AutocompleteTelephone;
}();
var $4d40d048175dacfe$export$f37489576ac4e3f5 = /* #__PURE__ */ function() {
    function AutocompleteTelephoneCountryCode() {}
    AutocompleteTelephoneCountryCode.value = new AutocompleteTelephoneCountryCode();
    return AutocompleteTelephoneCountryCode;
}();
var $4d40d048175dacfe$export$85265d7dd09c0246 = /* #__PURE__ */ function() {
    function AutocompleteTelephoneNational() {}
    AutocompleteTelephoneNational.value = new AutocompleteTelephoneNational();
    return AutocompleteTelephoneNational;
}();
var $4d40d048175dacfe$export$fb4e6d66ca842722 = /* #__PURE__ */ function() {
    function AutocompleteTelephoneAreaCode() {}
    AutocompleteTelephoneAreaCode.value = new AutocompleteTelephoneAreaCode();
    return AutocompleteTelephoneAreaCode;
}();
var $4d40d048175dacfe$export$149dc202c94ba771 = /* #__PURE__ */ function() {
    function AutocompleteTelephoneLocal() {}
    AutocompleteTelephoneLocal.value = new AutocompleteTelephoneLocal();
    return AutocompleteTelephoneLocal;
}();
var $4d40d048175dacfe$export$c3fb770456fc7a2e = /* #__PURE__ */ function() {
    function AutocompleteTelephoneLocalPrefix() {}
    AutocompleteTelephoneLocalPrefix.value = new AutocompleteTelephoneLocalPrefix();
    return AutocompleteTelephoneLocalPrefix;
}();
var $4d40d048175dacfe$export$97df2b5615a1b054 = /* #__PURE__ */ function() {
    function AutocompleteTelephoneLocalSuffix() {}
    AutocompleteTelephoneLocalSuffix.value = new AutocompleteTelephoneLocalSuffix();
    return AutocompleteTelephoneLocalSuffix;
}();
var $4d40d048175dacfe$export$7aa0294a80b301d4 = /* #__PURE__ */ function() {
    function AutocompleteTelephoneExtension() {}
    AutocompleteTelephoneExtension.value = new AutocompleteTelephoneExtension();
    return AutocompleteTelephoneExtension;
}();
var $4d40d048175dacfe$export$1294e96da410451d = /* #__PURE__ */ function() {
    function AutocompleteIMPP() {}
    AutocompleteIMPP.value = new AutocompleteIMPP();
    return AutocompleteIMPP;
}();
var $4d40d048175dacfe$export$acf71e1d98edce93 = /* #__PURE__ */ function() {
    function AutocompleteURL() {}
    AutocompleteURL.value = new AutocompleteURL();
    return AutocompleteURL;
}();
var $4d40d048175dacfe$export$7a4045fb80d6a5eb = /* #__PURE__ */ function() {
    function AutocompletePhoto() {}
    AutocompletePhoto.value = new AutocompletePhoto();
    return AutocompletePhoto;
}();
var $4d40d048175dacfe$export$9b8eae2964bb4cd5 = function(v) {
    if (v instanceof $4d40d048175dacfe$export$7ba2b3d677b0db1c) return "off";
    if (v instanceof $4d40d048175dacfe$export$1ef0df3f3e6a4dab) return "on";
    if (v instanceof $4d40d048175dacfe$export$4da01cb598a0d97e) return "name";
    if (v instanceof $4d40d048175dacfe$export$ccb63fd7a749a381) return "honorific-prefix";
    if (v instanceof $4d40d048175dacfe$export$a2e3a2bb787472eb) return "given-name";
    if (v instanceof $4d40d048175dacfe$export$c2899da73c95f826) return "additional-name";
    if (v instanceof $4d40d048175dacfe$export$b189863462ae27fe) return "family-name";
    if (v instanceof $4d40d048175dacfe$export$5481c9b080fac1ad) return "honorific-suffix";
    if (v instanceof $4d40d048175dacfe$export$ed6c67e3f00c02f7) return "nickname";
    if (v instanceof $4d40d048175dacfe$export$3f2abff6b2574d28) return "email";
    if (v instanceof $4d40d048175dacfe$export$8ef7db4a55783560) return "username";
    if (v instanceof $4d40d048175dacfe$export$2aec4081bfc982fb) return "new-password";
    if (v instanceof $4d40d048175dacfe$export$8ee6fb6ac028afda) return "current-password";
    if (v instanceof $4d40d048175dacfe$export$6f27218568808639) return "one-time-code";
    if (v instanceof $4d40d048175dacfe$export$9748581da6bbbe4e) return "organization-title";
    if (v instanceof $4d40d048175dacfe$export$5fd9f780846e028b) return "organization";
    if (v instanceof $4d40d048175dacfe$export$499720fb85152dfe) return "street-address";
    if (v instanceof $4d40d048175dacfe$export$6b6488e90da63d6) return "address-line1";
    if (v instanceof $4d40d048175dacfe$export$92dfe98bc9dbafde) return "address-line2";
    if (v instanceof $4d40d048175dacfe$export$ea74132c1bd19261) return "address-line3";
    if (v instanceof $4d40d048175dacfe$export$e5454c7695ddbd5c) return "address-level1";
    if (v instanceof $4d40d048175dacfe$export$af0e2cc0795570d9) return "address-level2";
    if (v instanceof $4d40d048175dacfe$export$f76ce82784afe674) return "address-level3";
    if (v instanceof $4d40d048175dacfe$export$5f9c079ff6708773) return "address-level4";
    if (v instanceof $4d40d048175dacfe$export$44c5bb026cbe6e37) return "country";
    if (v instanceof $4d40d048175dacfe$export$e259ef3995a99fd4) return "country-name";
    if (v instanceof $4d40d048175dacfe$export$f95f909e01aa4cb3) return "postal-code";
    if (v instanceof $4d40d048175dacfe$export$67ade628725afe90) return "cc-name";
    if (v instanceof $4d40d048175dacfe$export$f03ef3c27a8e4a4b) return "cc-given-name";
    if (v instanceof $4d40d048175dacfe$export$1b45801580e5182f) return "cc-additional-name";
    if (v instanceof $4d40d048175dacfe$export$d906c17550f3b6f1) return "cc-family-name";
    if (v instanceof $4d40d048175dacfe$export$267a9616c09f33fa) return "cc-number";
    if (v instanceof $4d40d048175dacfe$export$4ac537c498251bbf) return "cc-exp";
    if (v instanceof $4d40d048175dacfe$export$2e15cf96bd811454) return "cc-exp-month";
    if (v instanceof $4d40d048175dacfe$export$7c4efb1d2d0a7d5d) return "cc-exp-year";
    if (v instanceof $4d40d048175dacfe$export$42f27b71e570e84c) return "cc-csc";
    if (v instanceof $4d40d048175dacfe$export$7dd055ac3e2d902c) return "cc-type";
    if (v instanceof $4d40d048175dacfe$export$918eb55efc9f2e5c) return "transaction-currency";
    if (v instanceof $4d40d048175dacfe$export$9d4a96b43ef247de) return "transaction-amount";
    if (v instanceof $4d40d048175dacfe$export$f69bc69473d6d1fa) return "language";
    if (v instanceof $4d40d048175dacfe$export$db103677e4262f74) return "bday";
    if (v instanceof $4d40d048175dacfe$export$976267f1375fd072) return "bday-day";
    if (v instanceof $4d40d048175dacfe$export$345017daa9311763) return "bday-month";
    if (v instanceof $4d40d048175dacfe$export$a58218c48fdc359f) return "bday-year";
    if (v instanceof $4d40d048175dacfe$export$41a3d5735ecfd56f) return "sex";
    if (v instanceof $4d40d048175dacfe$export$dc25bbd279bd7147) return "tel";
    if (v instanceof $4d40d048175dacfe$export$f37489576ac4e3f5) return "tel-country-code";
    if (v instanceof $4d40d048175dacfe$export$85265d7dd09c0246) return "tel-national";
    if (v instanceof $4d40d048175dacfe$export$fb4e6d66ca842722) return "telarea-code";
    if (v instanceof $4d40d048175dacfe$export$149dc202c94ba771) return "tel-local";
    if (v instanceof $4d40d048175dacfe$export$c3fb770456fc7a2e) return "tel-local-prefix";
    if (v instanceof $4d40d048175dacfe$export$97df2b5615a1b054) return "tel-local-suffix";
    if (v instanceof $4d40d048175dacfe$export$7aa0294a80b301d4) return "tel-extension";
    if (v instanceof $4d40d048175dacfe$export$1294e96da410451d) return "impp";
    if (v instanceof $4d40d048175dacfe$export$acf71e1d98edce93) return "url";
    if (v instanceof $4d40d048175dacfe$export$7a4045fb80d6a5eb) return "photo";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.AutocompleteType (line 67, column 26 - line 123, column 31): " + [
        v.constructor.name
    ]);
};
var $4d40d048175dacfe$export$51a22934b9cdbac4 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $4d40d048175dacfe$export$7ba2b3d677b0db1c && y instanceof $4d40d048175dacfe$export$7ba2b3d677b0db1c) return true;
            if (x instanceof $4d40d048175dacfe$export$1ef0df3f3e6a4dab && y instanceof $4d40d048175dacfe$export$1ef0df3f3e6a4dab) return true;
            if (x instanceof $4d40d048175dacfe$export$4da01cb598a0d97e && y instanceof $4d40d048175dacfe$export$4da01cb598a0d97e) return true;
            if (x instanceof $4d40d048175dacfe$export$ccb63fd7a749a381 && y instanceof $4d40d048175dacfe$export$ccb63fd7a749a381) return true;
            if (x instanceof $4d40d048175dacfe$export$a2e3a2bb787472eb && y instanceof $4d40d048175dacfe$export$a2e3a2bb787472eb) return true;
            if (x instanceof $4d40d048175dacfe$export$c2899da73c95f826 && y instanceof $4d40d048175dacfe$export$c2899da73c95f826) return true;
            if (x instanceof $4d40d048175dacfe$export$b189863462ae27fe && y instanceof $4d40d048175dacfe$export$b189863462ae27fe) return true;
            if (x instanceof $4d40d048175dacfe$export$5481c9b080fac1ad && y instanceof $4d40d048175dacfe$export$5481c9b080fac1ad) return true;
            if (x instanceof $4d40d048175dacfe$export$ed6c67e3f00c02f7 && y instanceof $4d40d048175dacfe$export$ed6c67e3f00c02f7) return true;
            if (x instanceof $4d40d048175dacfe$export$3f2abff6b2574d28 && y instanceof $4d40d048175dacfe$export$3f2abff6b2574d28) return true;
            if (x instanceof $4d40d048175dacfe$export$8ef7db4a55783560 && y instanceof $4d40d048175dacfe$export$8ef7db4a55783560) return true;
            if (x instanceof $4d40d048175dacfe$export$2aec4081bfc982fb && y instanceof $4d40d048175dacfe$export$2aec4081bfc982fb) return true;
            if (x instanceof $4d40d048175dacfe$export$8ee6fb6ac028afda && y instanceof $4d40d048175dacfe$export$8ee6fb6ac028afda) return true;
            if (x instanceof $4d40d048175dacfe$export$6f27218568808639 && y instanceof $4d40d048175dacfe$export$6f27218568808639) return true;
            if (x instanceof $4d40d048175dacfe$export$9748581da6bbbe4e && y instanceof $4d40d048175dacfe$export$9748581da6bbbe4e) return true;
            if (x instanceof $4d40d048175dacfe$export$5fd9f780846e028b && y instanceof $4d40d048175dacfe$export$5fd9f780846e028b) return true;
            if (x instanceof $4d40d048175dacfe$export$499720fb85152dfe && y instanceof $4d40d048175dacfe$export$499720fb85152dfe) return true;
            if (x instanceof $4d40d048175dacfe$export$6b6488e90da63d6 && y instanceof $4d40d048175dacfe$export$6b6488e90da63d6) return true;
            if (x instanceof $4d40d048175dacfe$export$92dfe98bc9dbafde && y instanceof $4d40d048175dacfe$export$92dfe98bc9dbafde) return true;
            if (x instanceof $4d40d048175dacfe$export$ea74132c1bd19261 && y instanceof $4d40d048175dacfe$export$ea74132c1bd19261) return true;
            if (x instanceof $4d40d048175dacfe$export$e5454c7695ddbd5c && y instanceof $4d40d048175dacfe$export$e5454c7695ddbd5c) return true;
            if (x instanceof $4d40d048175dacfe$export$af0e2cc0795570d9 && y instanceof $4d40d048175dacfe$export$af0e2cc0795570d9) return true;
            if (x instanceof $4d40d048175dacfe$export$f76ce82784afe674 && y instanceof $4d40d048175dacfe$export$f76ce82784afe674) return true;
            if (x instanceof $4d40d048175dacfe$export$5f9c079ff6708773 && y instanceof $4d40d048175dacfe$export$5f9c079ff6708773) return true;
            if (x instanceof $4d40d048175dacfe$export$44c5bb026cbe6e37 && y instanceof $4d40d048175dacfe$export$44c5bb026cbe6e37) return true;
            if (x instanceof $4d40d048175dacfe$export$e259ef3995a99fd4 && y instanceof $4d40d048175dacfe$export$e259ef3995a99fd4) return true;
            if (x instanceof $4d40d048175dacfe$export$f95f909e01aa4cb3 && y instanceof $4d40d048175dacfe$export$f95f909e01aa4cb3) return true;
            if (x instanceof $4d40d048175dacfe$export$67ade628725afe90 && y instanceof $4d40d048175dacfe$export$67ade628725afe90) return true;
            if (x instanceof $4d40d048175dacfe$export$f03ef3c27a8e4a4b && y instanceof $4d40d048175dacfe$export$f03ef3c27a8e4a4b) return true;
            if (x instanceof $4d40d048175dacfe$export$1b45801580e5182f && y instanceof $4d40d048175dacfe$export$1b45801580e5182f) return true;
            if (x instanceof $4d40d048175dacfe$export$d906c17550f3b6f1 && y instanceof $4d40d048175dacfe$export$d906c17550f3b6f1) return true;
            if (x instanceof $4d40d048175dacfe$export$267a9616c09f33fa && y instanceof $4d40d048175dacfe$export$267a9616c09f33fa) return true;
            if (x instanceof $4d40d048175dacfe$export$4ac537c498251bbf && y instanceof $4d40d048175dacfe$export$4ac537c498251bbf) return true;
            if (x instanceof $4d40d048175dacfe$export$2e15cf96bd811454 && y instanceof $4d40d048175dacfe$export$2e15cf96bd811454) return true;
            if (x instanceof $4d40d048175dacfe$export$7c4efb1d2d0a7d5d && y instanceof $4d40d048175dacfe$export$7c4efb1d2d0a7d5d) return true;
            if (x instanceof $4d40d048175dacfe$export$42f27b71e570e84c && y instanceof $4d40d048175dacfe$export$42f27b71e570e84c) return true;
            if (x instanceof $4d40d048175dacfe$export$7dd055ac3e2d902c && y instanceof $4d40d048175dacfe$export$7dd055ac3e2d902c) return true;
            if (x instanceof $4d40d048175dacfe$export$918eb55efc9f2e5c && y instanceof $4d40d048175dacfe$export$918eb55efc9f2e5c) return true;
            if (x instanceof $4d40d048175dacfe$export$9d4a96b43ef247de && y instanceof $4d40d048175dacfe$export$9d4a96b43ef247de) return true;
            if (x instanceof $4d40d048175dacfe$export$f69bc69473d6d1fa && y instanceof $4d40d048175dacfe$export$f69bc69473d6d1fa) return true;
            if (x instanceof $4d40d048175dacfe$export$db103677e4262f74 && y instanceof $4d40d048175dacfe$export$db103677e4262f74) return true;
            if (x instanceof $4d40d048175dacfe$export$976267f1375fd072 && y instanceof $4d40d048175dacfe$export$976267f1375fd072) return true;
            if (x instanceof $4d40d048175dacfe$export$345017daa9311763 && y instanceof $4d40d048175dacfe$export$345017daa9311763) return true;
            if (x instanceof $4d40d048175dacfe$export$a58218c48fdc359f && y instanceof $4d40d048175dacfe$export$a58218c48fdc359f) return true;
            if (x instanceof $4d40d048175dacfe$export$41a3d5735ecfd56f && y instanceof $4d40d048175dacfe$export$41a3d5735ecfd56f) return true;
            if (x instanceof $4d40d048175dacfe$export$dc25bbd279bd7147 && y instanceof $4d40d048175dacfe$export$dc25bbd279bd7147) return true;
            if (x instanceof $4d40d048175dacfe$export$f37489576ac4e3f5 && y instanceof $4d40d048175dacfe$export$f37489576ac4e3f5) return true;
            if (x instanceof $4d40d048175dacfe$export$85265d7dd09c0246 && y instanceof $4d40d048175dacfe$export$85265d7dd09c0246) return true;
            if (x instanceof $4d40d048175dacfe$export$fb4e6d66ca842722 && y instanceof $4d40d048175dacfe$export$fb4e6d66ca842722) return true;
            if (x instanceof $4d40d048175dacfe$export$149dc202c94ba771 && y instanceof $4d40d048175dacfe$export$149dc202c94ba771) return true;
            if (x instanceof $4d40d048175dacfe$export$c3fb770456fc7a2e && y instanceof $4d40d048175dacfe$export$c3fb770456fc7a2e) return true;
            if (x instanceof $4d40d048175dacfe$export$97df2b5615a1b054 && y instanceof $4d40d048175dacfe$export$97df2b5615a1b054) return true;
            if (x instanceof $4d40d048175dacfe$export$7aa0294a80b301d4 && y instanceof $4d40d048175dacfe$export$7aa0294a80b301d4) return true;
            if (x instanceof $4d40d048175dacfe$export$1294e96da410451d && y instanceof $4d40d048175dacfe$export$1294e96da410451d) return true;
            if (x instanceof $4d40d048175dacfe$export$acf71e1d98edce93 && y instanceof $4d40d048175dacfe$export$acf71e1d98edce93) return true;
            if (x instanceof $4d40d048175dacfe$export$7a4045fb80d6a5eb && y instanceof $4d40d048175dacfe$export$7a4045fb80d6a5eb) return true;
            return false;
        };
    }
};
var $4d40d048175dacfe$export$72232ffdb2635391 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $4d40d048175dacfe$export$7ba2b3d677b0db1c && y instanceof $4d40d048175dacfe$export$7ba2b3d677b0db1c) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$7ba2b3d677b0db1c) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$7ba2b3d677b0db1c) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$1ef0df3f3e6a4dab && y instanceof $4d40d048175dacfe$export$1ef0df3f3e6a4dab) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$1ef0df3f3e6a4dab) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$1ef0df3f3e6a4dab) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$4da01cb598a0d97e && y instanceof $4d40d048175dacfe$export$4da01cb598a0d97e) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$4da01cb598a0d97e) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$4da01cb598a0d97e) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$ccb63fd7a749a381 && y instanceof $4d40d048175dacfe$export$ccb63fd7a749a381) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$ccb63fd7a749a381) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$ccb63fd7a749a381) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$a2e3a2bb787472eb && y instanceof $4d40d048175dacfe$export$a2e3a2bb787472eb) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$a2e3a2bb787472eb) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$a2e3a2bb787472eb) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$c2899da73c95f826 && y instanceof $4d40d048175dacfe$export$c2899da73c95f826) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$c2899da73c95f826) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$c2899da73c95f826) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$b189863462ae27fe && y instanceof $4d40d048175dacfe$export$b189863462ae27fe) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$b189863462ae27fe) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$b189863462ae27fe) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$5481c9b080fac1ad && y instanceof $4d40d048175dacfe$export$5481c9b080fac1ad) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$5481c9b080fac1ad) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$5481c9b080fac1ad) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$ed6c67e3f00c02f7 && y instanceof $4d40d048175dacfe$export$ed6c67e3f00c02f7) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$ed6c67e3f00c02f7) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$ed6c67e3f00c02f7) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$3f2abff6b2574d28 && y instanceof $4d40d048175dacfe$export$3f2abff6b2574d28) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$3f2abff6b2574d28) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$3f2abff6b2574d28) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$8ef7db4a55783560 && y instanceof $4d40d048175dacfe$export$8ef7db4a55783560) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$8ef7db4a55783560) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$8ef7db4a55783560) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$2aec4081bfc982fb && y instanceof $4d40d048175dacfe$export$2aec4081bfc982fb) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$2aec4081bfc982fb) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$2aec4081bfc982fb) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$8ee6fb6ac028afda && y instanceof $4d40d048175dacfe$export$8ee6fb6ac028afda) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$8ee6fb6ac028afda) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$8ee6fb6ac028afda) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$6f27218568808639 && y instanceof $4d40d048175dacfe$export$6f27218568808639) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$6f27218568808639) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$6f27218568808639) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$9748581da6bbbe4e && y instanceof $4d40d048175dacfe$export$9748581da6bbbe4e) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$9748581da6bbbe4e) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$9748581da6bbbe4e) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$5fd9f780846e028b && y instanceof $4d40d048175dacfe$export$5fd9f780846e028b) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$5fd9f780846e028b) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$5fd9f780846e028b) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$499720fb85152dfe && y instanceof $4d40d048175dacfe$export$499720fb85152dfe) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$499720fb85152dfe) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$499720fb85152dfe) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$6b6488e90da63d6 && y instanceof $4d40d048175dacfe$export$6b6488e90da63d6) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$6b6488e90da63d6) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$6b6488e90da63d6) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$92dfe98bc9dbafde && y instanceof $4d40d048175dacfe$export$92dfe98bc9dbafde) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$92dfe98bc9dbafde) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$92dfe98bc9dbafde) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$ea74132c1bd19261 && y instanceof $4d40d048175dacfe$export$ea74132c1bd19261) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$ea74132c1bd19261) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$ea74132c1bd19261) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$e5454c7695ddbd5c && y instanceof $4d40d048175dacfe$export$e5454c7695ddbd5c) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$e5454c7695ddbd5c) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$e5454c7695ddbd5c) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$af0e2cc0795570d9 && y instanceof $4d40d048175dacfe$export$af0e2cc0795570d9) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$af0e2cc0795570d9) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$af0e2cc0795570d9) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$f76ce82784afe674 && y instanceof $4d40d048175dacfe$export$f76ce82784afe674) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$f76ce82784afe674) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$f76ce82784afe674) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$5f9c079ff6708773 && y instanceof $4d40d048175dacfe$export$5f9c079ff6708773) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$5f9c079ff6708773) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$5f9c079ff6708773) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$44c5bb026cbe6e37 && y instanceof $4d40d048175dacfe$export$44c5bb026cbe6e37) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$44c5bb026cbe6e37) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$44c5bb026cbe6e37) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$e259ef3995a99fd4 && y instanceof $4d40d048175dacfe$export$e259ef3995a99fd4) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$e259ef3995a99fd4) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$e259ef3995a99fd4) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$f95f909e01aa4cb3 && y instanceof $4d40d048175dacfe$export$f95f909e01aa4cb3) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$f95f909e01aa4cb3) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$f95f909e01aa4cb3) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$67ade628725afe90 && y instanceof $4d40d048175dacfe$export$67ade628725afe90) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$67ade628725afe90) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$67ade628725afe90) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$f03ef3c27a8e4a4b && y instanceof $4d40d048175dacfe$export$f03ef3c27a8e4a4b) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$f03ef3c27a8e4a4b) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$f03ef3c27a8e4a4b) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$1b45801580e5182f && y instanceof $4d40d048175dacfe$export$1b45801580e5182f) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$1b45801580e5182f) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$1b45801580e5182f) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$d906c17550f3b6f1 && y instanceof $4d40d048175dacfe$export$d906c17550f3b6f1) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$d906c17550f3b6f1) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$d906c17550f3b6f1) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$267a9616c09f33fa && y instanceof $4d40d048175dacfe$export$267a9616c09f33fa) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$267a9616c09f33fa) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$267a9616c09f33fa) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$4ac537c498251bbf && y instanceof $4d40d048175dacfe$export$4ac537c498251bbf) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$4ac537c498251bbf) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$4ac537c498251bbf) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$2e15cf96bd811454 && y instanceof $4d40d048175dacfe$export$2e15cf96bd811454) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$2e15cf96bd811454) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$2e15cf96bd811454) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$7c4efb1d2d0a7d5d && y instanceof $4d40d048175dacfe$export$7c4efb1d2d0a7d5d) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$7c4efb1d2d0a7d5d) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$7c4efb1d2d0a7d5d) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$42f27b71e570e84c && y instanceof $4d40d048175dacfe$export$42f27b71e570e84c) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$42f27b71e570e84c) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$42f27b71e570e84c) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$7dd055ac3e2d902c && y instanceof $4d40d048175dacfe$export$7dd055ac3e2d902c) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$7dd055ac3e2d902c) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$7dd055ac3e2d902c) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$918eb55efc9f2e5c && y instanceof $4d40d048175dacfe$export$918eb55efc9f2e5c) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$918eb55efc9f2e5c) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$918eb55efc9f2e5c) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$9d4a96b43ef247de && y instanceof $4d40d048175dacfe$export$9d4a96b43ef247de) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$9d4a96b43ef247de) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$9d4a96b43ef247de) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$f69bc69473d6d1fa && y instanceof $4d40d048175dacfe$export$f69bc69473d6d1fa) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$f69bc69473d6d1fa) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$f69bc69473d6d1fa) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$db103677e4262f74 && y instanceof $4d40d048175dacfe$export$db103677e4262f74) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$db103677e4262f74) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$db103677e4262f74) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$976267f1375fd072 && y instanceof $4d40d048175dacfe$export$976267f1375fd072) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$976267f1375fd072) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$976267f1375fd072) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$345017daa9311763 && y instanceof $4d40d048175dacfe$export$345017daa9311763) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$345017daa9311763) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$345017daa9311763) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$a58218c48fdc359f && y instanceof $4d40d048175dacfe$export$a58218c48fdc359f) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$a58218c48fdc359f) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$a58218c48fdc359f) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$41a3d5735ecfd56f && y instanceof $4d40d048175dacfe$export$41a3d5735ecfd56f) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$41a3d5735ecfd56f) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$41a3d5735ecfd56f) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$dc25bbd279bd7147 && y instanceof $4d40d048175dacfe$export$dc25bbd279bd7147) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$dc25bbd279bd7147) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$dc25bbd279bd7147) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$f37489576ac4e3f5 && y instanceof $4d40d048175dacfe$export$f37489576ac4e3f5) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$f37489576ac4e3f5) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$f37489576ac4e3f5) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$85265d7dd09c0246 && y instanceof $4d40d048175dacfe$export$85265d7dd09c0246) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$85265d7dd09c0246) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$85265d7dd09c0246) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$fb4e6d66ca842722 && y instanceof $4d40d048175dacfe$export$fb4e6d66ca842722) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$fb4e6d66ca842722) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$fb4e6d66ca842722) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$149dc202c94ba771 && y instanceof $4d40d048175dacfe$export$149dc202c94ba771) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$149dc202c94ba771) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$149dc202c94ba771) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$c3fb770456fc7a2e && y instanceof $4d40d048175dacfe$export$c3fb770456fc7a2e) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$c3fb770456fc7a2e) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$c3fb770456fc7a2e) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$97df2b5615a1b054 && y instanceof $4d40d048175dacfe$export$97df2b5615a1b054) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$97df2b5615a1b054) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$97df2b5615a1b054) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$7aa0294a80b301d4 && y instanceof $4d40d048175dacfe$export$7aa0294a80b301d4) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$7aa0294a80b301d4) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$7aa0294a80b301d4) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$1294e96da410451d && y instanceof $4d40d048175dacfe$export$1294e96da410451d) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$1294e96da410451d) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$1294e96da410451d) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$acf71e1d98edce93 && y instanceof $4d40d048175dacfe$export$acf71e1d98edce93) return $6SDUu.EQ.value;
            if (x instanceof $4d40d048175dacfe$export$acf71e1d98edce93) return $6SDUu.LT.value;
            if (y instanceof $4d40d048175dacfe$export$acf71e1d98edce93) return $6SDUu.GT.value;
            if (x instanceof $4d40d048175dacfe$export$7a4045fb80d6a5eb && y instanceof $4d40d048175dacfe$export$7a4045fb80d6a5eb) return $6SDUu.EQ.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.AutocompleteType (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $4d40d048175dacfe$export$51a22934b9cdbac4;
    }
};

});

parcelRegister("h2vLF", function(module, exports) {

$parcel$export(module.exports, "renderButtonType", () => $c67b43ffea069cfb$export$354e79e7f4fdf8f9);
// Generated by purs version 0.15.16

var $6SDUu = parcelRequire("6SDUu");
var $c67b43ffea069cfb$export$f2f6344eac5a3091 = /* #__PURE__ */ function() {
    function ButtonButton() {}
    ButtonButton.value = new ButtonButton();
    return ButtonButton;
}();
var $c67b43ffea069cfb$export$883ac606d954afa4 = /* #__PURE__ */ function() {
    function ButtonSubmit() {}
    ButtonSubmit.value = new ButtonSubmit();
    return ButtonSubmit;
}();
var $c67b43ffea069cfb$export$7c5d4436120726a7 = /* #__PURE__ */ function() {
    function ButtonReset() {}
    ButtonReset.value = new ButtonReset();
    return ButtonReset;
}();
var $c67b43ffea069cfb$export$354e79e7f4fdf8f9 = function(v) {
    if (v instanceof $c67b43ffea069cfb$export$f2f6344eac5a3091) return "button";
    if (v instanceof $c67b43ffea069cfb$export$883ac606d954afa4) return "submit";
    if (v instanceof $c67b43ffea069cfb$export$7c5d4436120726a7) return "reset";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.ButtonType (line 14, column 20 - line 17, column 25): " + [
        v.constructor.name
    ]);
};
var $c67b43ffea069cfb$export$eedf6d78b7217aa7 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $c67b43ffea069cfb$export$f2f6344eac5a3091 && y instanceof $c67b43ffea069cfb$export$f2f6344eac5a3091) return true;
            if (x instanceof $c67b43ffea069cfb$export$883ac606d954afa4 && y instanceof $c67b43ffea069cfb$export$883ac606d954afa4) return true;
            if (x instanceof $c67b43ffea069cfb$export$7c5d4436120726a7 && y instanceof $c67b43ffea069cfb$export$7c5d4436120726a7) return true;
            return false;
        };
    }
};
var $c67b43ffea069cfb$export$d2ecbd2aa2e5439c = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $c67b43ffea069cfb$export$f2f6344eac5a3091 && y instanceof $c67b43ffea069cfb$export$f2f6344eac5a3091) return $6SDUu.EQ.value;
            if (x instanceof $c67b43ffea069cfb$export$f2f6344eac5a3091) return $6SDUu.LT.value;
            if (y instanceof $c67b43ffea069cfb$export$f2f6344eac5a3091) return $6SDUu.GT.value;
            if (x instanceof $c67b43ffea069cfb$export$883ac606d954afa4 && y instanceof $c67b43ffea069cfb$export$883ac606d954afa4) return $6SDUu.EQ.value;
            if (x instanceof $c67b43ffea069cfb$export$883ac606d954afa4) return $6SDUu.LT.value;
            if (y instanceof $c67b43ffea069cfb$export$883ac606d954afa4) return $6SDUu.GT.value;
            if (x instanceof $c67b43ffea069cfb$export$7c5d4436120726a7 && y instanceof $c67b43ffea069cfb$export$7c5d4436120726a7) return $6SDUu.EQ.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.ButtonType (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $c67b43ffea069cfb$export$eedf6d78b7217aa7;
    }
};

});

parcelRegister("kOhUj", function(module, exports) {

$parcel$export(module.exports, "renderCrossOriginValue", () => $f2665e311d0e2c2e$export$8cede0459d8015c9);
// Generated by purs version 0.15.16

var $6SDUu = parcelRequire("6SDUu");
var $f2665e311d0e2c2e$export$e1bb774e9664e700 = /* #__PURE__ */ function() {
    function Anonymous() {}
    Anonymous.value = new Anonymous();
    return Anonymous;
}();
var $f2665e311d0e2c2e$export$bf6fef082af5a2d3 = /* #__PURE__ */ function() {
    function UseCredentials() {}
    UseCredentials.value = new UseCredentials();
    return UseCredentials;
}();
var $f2665e311d0e2c2e$export$8cede0459d8015c9 = function(v) {
    if (v instanceof $f2665e311d0e2c2e$export$e1bb774e9664e700) return "anonymous";
    if (v instanceof $f2665e311d0e2c2e$export$bf6fef082af5a2d3) return "use-credentials";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.CrossOriginValue (line 13, column 26 - line 15, column 38): " + [
        v.constructor.name
    ]);
};
var $f2665e311d0e2c2e$export$63add5f8c2317041 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $f2665e311d0e2c2e$export$e1bb774e9664e700 && y instanceof $f2665e311d0e2c2e$export$e1bb774e9664e700) return true;
            if (x instanceof $f2665e311d0e2c2e$export$bf6fef082af5a2d3 && y instanceof $f2665e311d0e2c2e$export$bf6fef082af5a2d3) return true;
            return false;
        };
    }
};
var $f2665e311d0e2c2e$export$8999465764c5da85 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $f2665e311d0e2c2e$export$e1bb774e9664e700 && y instanceof $f2665e311d0e2c2e$export$e1bb774e9664e700) return $6SDUu.EQ.value;
            if (x instanceof $f2665e311d0e2c2e$export$e1bb774e9664e700) return $6SDUu.LT.value;
            if (y instanceof $f2665e311d0e2c2e$export$e1bb774e9664e700) return $6SDUu.GT.value;
            if (x instanceof $f2665e311d0e2c2e$export$bf6fef082af5a2d3 && y instanceof $f2665e311d0e2c2e$export$bf6fef082af5a2d3) return $6SDUu.EQ.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.CrossOriginValue (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $f2665e311d0e2c2e$export$63add5f8c2317041;
    }
};

});

parcelRegister("1fwLN", function(module, exports) {

$parcel$export(module.exports, "renderDirValue", () => $0e909c93feacf06e$export$5f8a4393c9c60d1a);
// Generated by purs version 0.15.16

var $6SDUu = parcelRequire("6SDUu");
var $0e909c93feacf06e$export$c75f22af8298685 = /* #__PURE__ */ function() {
    function DirLTR() {}
    DirLTR.value = new DirLTR();
    return DirLTR;
}();
var $0e909c93feacf06e$export$f3ecd00e2fcb9ec1 = /* #__PURE__ */ function() {
    function DirRTL() {}
    DirRTL.value = new DirRTL();
    return DirRTL;
}();
var $0e909c93feacf06e$export$db0b550dbafe50c7 = /* #__PURE__ */ function() {
    function DirAuto() {}
    DirAuto.value = new DirAuto();
    return DirAuto;
}();
var $0e909c93feacf06e$export$5f8a4393c9c60d1a = function(v) {
    if (v instanceof $0e909c93feacf06e$export$c75f22af8298685) return "ltr";
    if (v instanceof $0e909c93feacf06e$export$f3ecd00e2fcb9ec1) return "rtl";
    if (v instanceof $0e909c93feacf06e$export$db0b550dbafe50c7) return "auto";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.DirValue (line 14, column 18 - line 17, column 20): " + [
        v.constructor.name
    ]);
};
var $0e909c93feacf06e$export$c646568b5e94d926 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $0e909c93feacf06e$export$c75f22af8298685 && y instanceof $0e909c93feacf06e$export$c75f22af8298685) return true;
            if (x instanceof $0e909c93feacf06e$export$f3ecd00e2fcb9ec1 && y instanceof $0e909c93feacf06e$export$f3ecd00e2fcb9ec1) return true;
            if (x instanceof $0e909c93feacf06e$export$db0b550dbafe50c7 && y instanceof $0e909c93feacf06e$export$db0b550dbafe50c7) return true;
            return false;
        };
    }
};
var $0e909c93feacf06e$export$e1551c9d6a26f7f3 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $0e909c93feacf06e$export$c75f22af8298685 && y instanceof $0e909c93feacf06e$export$c75f22af8298685) return $6SDUu.EQ.value;
            if (x instanceof $0e909c93feacf06e$export$c75f22af8298685) return $6SDUu.LT.value;
            if (y instanceof $0e909c93feacf06e$export$c75f22af8298685) return $6SDUu.GT.value;
            if (x instanceof $0e909c93feacf06e$export$f3ecd00e2fcb9ec1 && y instanceof $0e909c93feacf06e$export$f3ecd00e2fcb9ec1) return $6SDUu.EQ.value;
            if (x instanceof $0e909c93feacf06e$export$f3ecd00e2fcb9ec1) return $6SDUu.LT.value;
            if (y instanceof $0e909c93feacf06e$export$f3ecd00e2fcb9ec1) return $6SDUu.GT.value;
            if (x instanceof $0e909c93feacf06e$export$db0b550dbafe50c7 && y instanceof $0e909c93feacf06e$export$db0b550dbafe50c7) return $6SDUu.EQ.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.DirValue (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $0e909c93feacf06e$export$c646568b5e94d926;
    }
};

});

parcelRegister("ibAKj", function(module, exports) {

$parcel$export(module.exports, "renderFormMethod", () => $d3d5c2135d61b9e7$export$ac1e6270deebeb79);
// Generated by purs version 0.15.16

var $6SDUu = parcelRequire("6SDUu");
var $d3d5c2135d61b9e7$export$484f3009c2ee32ad = /* #__PURE__ */ function() {
    function POST() {}
    POST.value = new POST();
    return POST;
}();
var $d3d5c2135d61b9e7$export$1bb358554aac31c1 = /* #__PURE__ */ function() {
    function GET() {}
    GET.value = new GET();
    return GET;
}();
var $d3d5c2135d61b9e7$export$3ddf2d174ce01153 = /* #__PURE__ */ function() {
    function Dialog() {}
    Dialog.value = new Dialog();
    return Dialog;
}();
var $d3d5c2135d61b9e7$export$ac1e6270deebeb79 = function(v) {
    if (v instanceof $d3d5c2135d61b9e7$export$484f3009c2ee32ad) return "post";
    if (v instanceof $d3d5c2135d61b9e7$export$1bb358554aac31c1) return "get";
    if (v instanceof $d3d5c2135d61b9e7$export$3ddf2d174ce01153) return "dialog";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.FormMethod (line 14, column 20 - line 17, column 21): " + [
        v.constructor.name
    ]);
};
var $d3d5c2135d61b9e7$export$f6f118a39bdefe44 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $d3d5c2135d61b9e7$export$484f3009c2ee32ad && y instanceof $d3d5c2135d61b9e7$export$484f3009c2ee32ad) return true;
            if (x instanceof $d3d5c2135d61b9e7$export$1bb358554aac31c1 && y instanceof $d3d5c2135d61b9e7$export$1bb358554aac31c1) return true;
            if (x instanceof $d3d5c2135d61b9e7$export$3ddf2d174ce01153 && y instanceof $d3d5c2135d61b9e7$export$3ddf2d174ce01153) return true;
            return false;
        };
    }
};
var $d3d5c2135d61b9e7$export$5fa44f1be85134a1 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $d3d5c2135d61b9e7$export$484f3009c2ee32ad && y instanceof $d3d5c2135d61b9e7$export$484f3009c2ee32ad) return $6SDUu.EQ.value;
            if (x instanceof $d3d5c2135d61b9e7$export$484f3009c2ee32ad) return $6SDUu.LT.value;
            if (y instanceof $d3d5c2135d61b9e7$export$484f3009c2ee32ad) return $6SDUu.GT.value;
            if (x instanceof $d3d5c2135d61b9e7$export$1bb358554aac31c1 && y instanceof $d3d5c2135d61b9e7$export$1bb358554aac31c1) return $6SDUu.EQ.value;
            if (x instanceof $d3d5c2135d61b9e7$export$1bb358554aac31c1) return $6SDUu.LT.value;
            if (y instanceof $d3d5c2135d61b9e7$export$1bb358554aac31c1) return $6SDUu.GT.value;
            if (x instanceof $d3d5c2135d61b9e7$export$3ddf2d174ce01153 && y instanceof $d3d5c2135d61b9e7$export$3ddf2d174ce01153) return $6SDUu.EQ.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.FormMethod (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $d3d5c2135d61b9e7$export$f6f118a39bdefe44;
    }
};

});

parcelRegister("ebWzy", function(module, exports) {

$parcel$export(module.exports, "renderInputAcceptType", () => $a54f870bf00314e8$export$67347a102a60396a);
// Generated by purs version 0.15.16

var $4MBcA = parcelRequire("4MBcA");

var $l0wDR = parcelRequire("l0wDR");

var $3equM = parcelRequire("3equM");

var $d0PPW = parcelRequire("d0PPW");

var $6SDUu = parcelRequire("6SDUu");

var $iwqgS = parcelRequire("iwqgS");
parcelRequire("2Zpo4");
var $7OyoZ = parcelRequire("7OyoZ");
var $a54f870bf00314e8$var$append = /* #__PURE__ */ $iwqgS.append($iwqgS.semigroupArray);
var $a54f870bf00314e8$var$map = /* #__PURE__ */ $l0wDR.map($l0wDR.functorArray);
var $a54f870bf00314e8$var$eq = /* #__PURE__ */ $4MBcA.eq($3equM.eqMediaType);
var $a54f870bf00314e8$var$compare = /* #__PURE__ */ $d0PPW.compare($3equM.ordMediaType);
var $a54f870bf00314e8$var$compare1 = /* #__PURE__ */ $d0PPW.compare($d0PPW.ordString);
var $a54f870bf00314e8$export$8e926b7ab266774b = /* #__PURE__ */ function() {
    function AcceptMediaType(value0) {
        this.value0 = value0;
    }
    AcceptMediaType.create = function(value0) {
        return new AcceptMediaType(value0);
    };
    return AcceptMediaType;
}();
var $a54f870bf00314e8$export$f7dfb125ffc1f9b2 = /* #__PURE__ */ function() {
    function AcceptFileExtension(value0) {
        this.value0 = value0;
    }
    AcceptFileExtension.create = function(value0) {
        return new AcceptFileExtension(value0);
    };
    return AcceptFileExtension;
}();
var $a54f870bf00314e8$export$cdbf5a093552f797 = function(x) {
    return x;
};
var $a54f870bf00314e8$export$335b3365a1f7dcb5 = {
    append: function(v) {
        return function(v1) {
            return $a54f870bf00314e8$var$append(v)(v1);
        };
    }
};
var $a54f870bf00314e8$export$ef578e44d5d087ca = function(v) {
    if (v instanceof $a54f870bf00314e8$export$8e926b7ab266774b) return v.value0;
    if (v instanceof $a54f870bf00314e8$export$f7dfb125ffc1f9b2) return v.value0;
    throw new Error("Failed pattern match at DOM.HTML.Indexed.InputAcceptType (line 34, column 29 - line 36, column 33): " + [
        v.constructor.name
    ]);
};
var $a54f870bf00314e8$export$67347a102a60396a = function(v) {
    return $7OyoZ.joinWith(",")($a54f870bf00314e8$var$map($a54f870bf00314e8$export$ef578e44d5d087ca)(v));
};
var $a54f870bf00314e8$export$48e9de57e04e82db = function(mt) {
    return [
        new $a54f870bf00314e8$export$8e926b7ab266774b(mt)
    ];
};
var $a54f870bf00314e8$export$1b45514b112dd749 = function(ext) {
    return [
        new $a54f870bf00314e8$export$f7dfb125ffc1f9b2(ext)
    ];
};
var $a54f870bf00314e8$export$d6146bb235b883d4 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $a54f870bf00314e8$export$8e926b7ab266774b && y instanceof $a54f870bf00314e8$export$8e926b7ab266774b) return $a54f870bf00314e8$var$eq(x.value0)(y.value0);
            if (x instanceof $a54f870bf00314e8$export$f7dfb125ffc1f9b2 && y instanceof $a54f870bf00314e8$export$f7dfb125ffc1f9b2) return x.value0 === y.value0;
            return false;
        };
    }
};
var $a54f870bf00314e8$var$eq2 = /* #__PURE__ */ $4MBcA.eq(/* #__PURE__ */ $4MBcA.eqArray($a54f870bf00314e8$export$d6146bb235b883d4));
var $a54f870bf00314e8$export$56a1e1f55aab9839 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $a54f870bf00314e8$export$8e926b7ab266774b && y instanceof $a54f870bf00314e8$export$8e926b7ab266774b) return $a54f870bf00314e8$var$compare(x.value0)(y.value0);
            if (x instanceof $a54f870bf00314e8$export$8e926b7ab266774b) return $6SDUu.LT.value;
            if (y instanceof $a54f870bf00314e8$export$8e926b7ab266774b) return $6SDUu.GT.value;
            if (x instanceof $a54f870bf00314e8$export$f7dfb125ffc1f9b2 && y instanceof $a54f870bf00314e8$export$f7dfb125ffc1f9b2) return $a54f870bf00314e8$var$compare1(x.value0)(y.value0);
            throw new Error("Failed pattern match at DOM.HTML.Indexed.InputAcceptType (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $a54f870bf00314e8$export$d6146bb235b883d4;
    }
};
var $a54f870bf00314e8$var$compare2 = /* #__PURE__ */ $d0PPW.compare(/* #__PURE__ */ $d0PPW.ordArray($a54f870bf00314e8$export$56a1e1f55aab9839));
var $a54f870bf00314e8$export$6683b104f83faddd = {
    eq: function(x) {
        return function(y) {
            return $a54f870bf00314e8$var$eq2(x)(y);
        };
    }
};
var $a54f870bf00314e8$export$5822e39e3fdf7b = {
    compare: function(x) {
        return function(y) {
            return $a54f870bf00314e8$var$compare2(x)(y);
        };
    },
    Eq0: function() {
        return $a54f870bf00314e8$export$6683b104f83faddd;
    }
};

});
parcelRegister("3equM", function(module, exports) {

$parcel$export(module.exports, "eqMediaType", () => $25a73b5eff39e983$export$2fed9e13b0c7effc);
$parcel$export(module.exports, "ordMediaType", () => $25a73b5eff39e983$export$11071179e210ac75);
// Generated by purs version 0.15.16

var $d0PPW = parcelRequire("d0PPW");

var $3Orkn = parcelRequire("3Orkn");
var $25a73b5eff39e983$var$show = /* #__PURE__ */ $3Orkn.show($3Orkn.showString);
var $25a73b5eff39e983$var$compare = /* #__PURE__ */ $d0PPW.compare($d0PPW.ordString);
var $25a73b5eff39e983$export$483c11740a902fcd = function(x) {
    return x;
};
var $25a73b5eff39e983$export$74c0afb45691d798 = {
    show: function(v) {
        return "(MediaType " + ($25a73b5eff39e983$var$show(v) + ")");
    }
};
var $25a73b5eff39e983$export$37246347bfd87552 = {
    Coercible0: function() {
        return undefined;
    }
};
var $25a73b5eff39e983$export$2fed9e13b0c7effc = {
    eq: function(x) {
        return function(y) {
            return x === y;
        };
    }
};
var $25a73b5eff39e983$export$11071179e210ac75 = {
    compare: function(x) {
        return function(y) {
            return $25a73b5eff39e983$var$compare(x)(y);
        };
    },
    Eq0: function() {
        return $25a73b5eff39e983$export$2fed9e13b0c7effc;
    }
};

});

parcelRegister("2Zpo4", function(module, exports) {

$parcel$export(module.exports, "null", () => $22d4f8ab6946d33a$export$7b1b591b262c240);
$parcel$export(module.exports, "toLower", () => (parcelRequire("7OyoZ")).toLower);
$parcel$export(module.exports, "toUpper", () => (parcelRequire("7OyoZ")).toUpper);
$parcel$export(module.exports, "joinWith", () => (parcelRequire("7OyoZ")).joinWith);
// Generated by purs version 0.15.16

var $7OyoZ = parcelRequire("7OyoZ");

var $6SDUu = parcelRequire("6SDUu");
var $22d4f8ab6946d33a$export$7b1b591b262c240 = function(s) {
    return s === "";
};
var $22d4f8ab6946d33a$export$35652c12e6caefdf = /* #__PURE__ */ function() {
    return $7OyoZ._localeCompare($6SDUu.LT.value)($6SDUu.EQ.value)($6SDUu.GT.value);
}();

});
parcelRegister("7OyoZ", function(module, exports) {

$parcel$export(module.exports, "_localeCompare", () => $5b07e36f812dd04b$export$3ece336175b57f19);
$parcel$export(module.exports, "toLower", () => $5b07e36f812dd04b$export$b1ceac3893cbda6b);
$parcel$export(module.exports, "toUpper", () => $5b07e36f812dd04b$export$43df7fc17cca38a4);
$parcel$export(module.exports, "joinWith", () => $5b07e36f812dd04b$export$ec1dc8fbeea3467e);
const $5b07e36f812dd04b$export$3ece336175b57f19 = function(lt) {
    return function(eq) {
        return function(gt) {
            return function(s1) {
                return function(s2) {
                    var result = s1.localeCompare(s2);
                    return result < 0 ? lt : result > 0 ? gt : eq;
                };
            };
        };
    };
};
const $5b07e36f812dd04b$export$77ad94ebf1c2b9ed = function(s1) {
    return function(s2) {
        return function(s3) {
            return s3.replace(s1, s2);
        };
    };
};
const $5b07e36f812dd04b$export$b8b3234b4edfc4c2 = function(s1) {
    return function(s2) {
        return function(s3) {
            return s3.replace(new RegExp(s1.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&"), "g"), s2); // eslint-disable-line no-useless-escape
        };
    };
};
const $5b07e36f812dd04b$export$65980d18b75784e2 = function(sep) {
    return function(s) {
        return s.split(sep);
    };
};
const $5b07e36f812dd04b$export$b1ceac3893cbda6b = function(s) {
    return s.toLowerCase();
};
const $5b07e36f812dd04b$export$43df7fc17cca38a4 = function(s) {
    return s.toUpperCase();
};
const $5b07e36f812dd04b$export$87c2784dc9fc4ab = function(s) {
    return s.trim();
};
const $5b07e36f812dd04b$export$ec1dc8fbeea3467e = function(s) {
    return function(xs) {
        return xs.join(s);
    };
};

});



parcelRegister("hKGK1", function(module, exports) {

$parcel$export(module.exports, "renderInputType", () => $cec7e3152401d818$export$349063a07c8ae46b);
// Generated by purs version 0.15.16

var $6SDUu = parcelRequire("6SDUu");
var $cec7e3152401d818$export$80f44e7a00b6023f = /* #__PURE__ */ function() {
    function InputButton() {}
    InputButton.value = new InputButton();
    return InputButton;
}();
var $cec7e3152401d818$export$fa1253a65a9e747d = /* #__PURE__ */ function() {
    function InputCheckbox() {}
    InputCheckbox.value = new InputCheckbox();
    return InputCheckbox;
}();
var $cec7e3152401d818$export$c860ea55e361ded9 = /* #__PURE__ */ function() {
    function InputColor() {}
    InputColor.value = new InputColor();
    return InputColor;
}();
var $cec7e3152401d818$export$7ac9d04ce3f22c96 = /* #__PURE__ */ function() {
    function InputDate() {}
    InputDate.value = new InputDate();
    return InputDate;
}();
var $cec7e3152401d818$export$6a70bbf20f9e4d15 = /* #__PURE__ */ function() {
    function InputDatetimeLocal() {}
    InputDatetimeLocal.value = new InputDatetimeLocal();
    return InputDatetimeLocal;
}();
var $cec7e3152401d818$export$497a6aaf7dad75ee = /* #__PURE__ */ function() {
    function InputEmail() {}
    InputEmail.value = new InputEmail();
    return InputEmail;
}();
var $cec7e3152401d818$export$688bf7bc8f9a8891 = /* #__PURE__ */ function() {
    function InputFile() {}
    InputFile.value = new InputFile();
    return InputFile;
}();
var $cec7e3152401d818$export$f953fc739c1a72e8 = /* #__PURE__ */ function() {
    function InputHidden() {}
    InputHidden.value = new InputHidden();
    return InputHidden;
}();
var $cec7e3152401d818$export$94c7ee1e602c3016 = /* #__PURE__ */ function() {
    function InputImage() {}
    InputImage.value = new InputImage();
    return InputImage;
}();
var $cec7e3152401d818$export$e3f21b3e5e110727 = /* #__PURE__ */ function() {
    function InputMonth() {}
    InputMonth.value = new InputMonth();
    return InputMonth;
}();
var $cec7e3152401d818$export$cf9581d419a141cf = /* #__PURE__ */ function() {
    function InputNumber() {}
    InputNumber.value = new InputNumber();
    return InputNumber;
}();
var $cec7e3152401d818$export$66ebaee5e192c141 = /* #__PURE__ */ function() {
    function InputPassword() {}
    InputPassword.value = new InputPassword();
    return InputPassword;
}();
var $cec7e3152401d818$export$324f219e224c2ba4 = /* #__PURE__ */ function() {
    function InputRadio() {}
    InputRadio.value = new InputRadio();
    return InputRadio;
}();
var $cec7e3152401d818$export$7fd9b60c3e71d3cc = /* #__PURE__ */ function() {
    function InputRange() {}
    InputRange.value = new InputRange();
    return InputRange;
}();
var $cec7e3152401d818$export$e5f0f61dd2ad15f5 = /* #__PURE__ */ function() {
    function InputReset() {}
    InputReset.value = new InputReset();
    return InputReset;
}();
var $cec7e3152401d818$export$28044d9a5dbb104e = /* #__PURE__ */ function() {
    function InputSearch() {}
    InputSearch.value = new InputSearch();
    return InputSearch;
}();
var $cec7e3152401d818$export$41cafe4e2581754d = /* #__PURE__ */ function() {
    function InputSubmit() {}
    InputSubmit.value = new InputSubmit();
    return InputSubmit;
}();
var $cec7e3152401d818$export$5a51e0eecea5d8bd = /* #__PURE__ */ function() {
    function InputTel() {}
    InputTel.value = new InputTel();
    return InputTel;
}();
var $cec7e3152401d818$export$7034fcb7d6351061 = /* #__PURE__ */ function() {
    function InputText() {}
    InputText.value = new InputText();
    return InputText;
}();
var $cec7e3152401d818$export$d62c52bf2c44ba6f = /* #__PURE__ */ function() {
    function InputTime() {}
    InputTime.value = new InputTime();
    return InputTime;
}();
var $cec7e3152401d818$export$dfe56e1f58ed5cb2 = /* #__PURE__ */ function() {
    function InputUrl() {}
    InputUrl.value = new InputUrl();
    return InputUrl;
}();
var $cec7e3152401d818$export$8e8a9e74dfcf346a = /* #__PURE__ */ function() {
    function InputWeek() {}
    InputWeek.value = new InputWeek();
    return InputWeek;
}();
var $cec7e3152401d818$export$349063a07c8ae46b = function(v) {
    if (v instanceof $cec7e3152401d818$export$80f44e7a00b6023f) return "button";
    if (v instanceof $cec7e3152401d818$export$fa1253a65a9e747d) return "checkbox";
    if (v instanceof $cec7e3152401d818$export$c860ea55e361ded9) return "color";
    if (v instanceof $cec7e3152401d818$export$7ac9d04ce3f22c96) return "date";
    if (v instanceof $cec7e3152401d818$export$6a70bbf20f9e4d15) return "datetime-local";
    if (v instanceof $cec7e3152401d818$export$497a6aaf7dad75ee) return "email";
    if (v instanceof $cec7e3152401d818$export$688bf7bc8f9a8891) return "file";
    if (v instanceof $cec7e3152401d818$export$f953fc739c1a72e8) return "hidden";
    if (v instanceof $cec7e3152401d818$export$94c7ee1e602c3016) return "image";
    if (v instanceof $cec7e3152401d818$export$e3f21b3e5e110727) return "month";
    if (v instanceof $cec7e3152401d818$export$cf9581d419a141cf) return "number";
    if (v instanceof $cec7e3152401d818$export$66ebaee5e192c141) return "password";
    if (v instanceof $cec7e3152401d818$export$324f219e224c2ba4) return "radio";
    if (v instanceof $cec7e3152401d818$export$7fd9b60c3e71d3cc) return "range";
    if (v instanceof $cec7e3152401d818$export$e5f0f61dd2ad15f5) return "reset";
    if (v instanceof $cec7e3152401d818$export$28044d9a5dbb104e) return "search";
    if (v instanceof $cec7e3152401d818$export$41cafe4e2581754d) return "submit";
    if (v instanceof $cec7e3152401d818$export$5a51e0eecea5d8bd) return "tel";
    if (v instanceof $cec7e3152401d818$export$7034fcb7d6351061) return "text";
    if (v instanceof $cec7e3152401d818$export$d62c52bf2c44ba6f) return "time";
    if (v instanceof $cec7e3152401d818$export$dfe56e1f58ed5cb2) return "url";
    if (v instanceof $cec7e3152401d818$export$8e8a9e74dfcf346a) return "week";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.InputType (line 33, column 19 - line 55, column 22): " + [
        v.constructor.name
    ]);
};
var $cec7e3152401d818$export$417491cbf879eb77 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $cec7e3152401d818$export$80f44e7a00b6023f && y instanceof $cec7e3152401d818$export$80f44e7a00b6023f) return true;
            if (x instanceof $cec7e3152401d818$export$fa1253a65a9e747d && y instanceof $cec7e3152401d818$export$fa1253a65a9e747d) return true;
            if (x instanceof $cec7e3152401d818$export$c860ea55e361ded9 && y instanceof $cec7e3152401d818$export$c860ea55e361ded9) return true;
            if (x instanceof $cec7e3152401d818$export$7ac9d04ce3f22c96 && y instanceof $cec7e3152401d818$export$7ac9d04ce3f22c96) return true;
            if (x instanceof $cec7e3152401d818$export$6a70bbf20f9e4d15 && y instanceof $cec7e3152401d818$export$6a70bbf20f9e4d15) return true;
            if (x instanceof $cec7e3152401d818$export$497a6aaf7dad75ee && y instanceof $cec7e3152401d818$export$497a6aaf7dad75ee) return true;
            if (x instanceof $cec7e3152401d818$export$688bf7bc8f9a8891 && y instanceof $cec7e3152401d818$export$688bf7bc8f9a8891) return true;
            if (x instanceof $cec7e3152401d818$export$f953fc739c1a72e8 && y instanceof $cec7e3152401d818$export$f953fc739c1a72e8) return true;
            if (x instanceof $cec7e3152401d818$export$94c7ee1e602c3016 && y instanceof $cec7e3152401d818$export$94c7ee1e602c3016) return true;
            if (x instanceof $cec7e3152401d818$export$e3f21b3e5e110727 && y instanceof $cec7e3152401d818$export$e3f21b3e5e110727) return true;
            if (x instanceof $cec7e3152401d818$export$cf9581d419a141cf && y instanceof $cec7e3152401d818$export$cf9581d419a141cf) return true;
            if (x instanceof $cec7e3152401d818$export$66ebaee5e192c141 && y instanceof $cec7e3152401d818$export$66ebaee5e192c141) return true;
            if (x instanceof $cec7e3152401d818$export$324f219e224c2ba4 && y instanceof $cec7e3152401d818$export$324f219e224c2ba4) return true;
            if (x instanceof $cec7e3152401d818$export$7fd9b60c3e71d3cc && y instanceof $cec7e3152401d818$export$7fd9b60c3e71d3cc) return true;
            if (x instanceof $cec7e3152401d818$export$e5f0f61dd2ad15f5 && y instanceof $cec7e3152401d818$export$e5f0f61dd2ad15f5) return true;
            if (x instanceof $cec7e3152401d818$export$28044d9a5dbb104e && y instanceof $cec7e3152401d818$export$28044d9a5dbb104e) return true;
            if (x instanceof $cec7e3152401d818$export$41cafe4e2581754d && y instanceof $cec7e3152401d818$export$41cafe4e2581754d) return true;
            if (x instanceof $cec7e3152401d818$export$5a51e0eecea5d8bd && y instanceof $cec7e3152401d818$export$5a51e0eecea5d8bd) return true;
            if (x instanceof $cec7e3152401d818$export$7034fcb7d6351061 && y instanceof $cec7e3152401d818$export$7034fcb7d6351061) return true;
            if (x instanceof $cec7e3152401d818$export$d62c52bf2c44ba6f && y instanceof $cec7e3152401d818$export$d62c52bf2c44ba6f) return true;
            if (x instanceof $cec7e3152401d818$export$dfe56e1f58ed5cb2 && y instanceof $cec7e3152401d818$export$dfe56e1f58ed5cb2) return true;
            if (x instanceof $cec7e3152401d818$export$8e8a9e74dfcf346a && y instanceof $cec7e3152401d818$export$8e8a9e74dfcf346a) return true;
            return false;
        };
    }
};
var $cec7e3152401d818$export$6dd7322953dee4dc = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $cec7e3152401d818$export$80f44e7a00b6023f && y instanceof $cec7e3152401d818$export$80f44e7a00b6023f) return $6SDUu.EQ.value;
            if (x instanceof $cec7e3152401d818$export$80f44e7a00b6023f) return $6SDUu.LT.value;
            if (y instanceof $cec7e3152401d818$export$80f44e7a00b6023f) return $6SDUu.GT.value;
            if (x instanceof $cec7e3152401d818$export$fa1253a65a9e747d && y instanceof $cec7e3152401d818$export$fa1253a65a9e747d) return $6SDUu.EQ.value;
            if (x instanceof $cec7e3152401d818$export$fa1253a65a9e747d) return $6SDUu.LT.value;
            if (y instanceof $cec7e3152401d818$export$fa1253a65a9e747d) return $6SDUu.GT.value;
            if (x instanceof $cec7e3152401d818$export$c860ea55e361ded9 && y instanceof $cec7e3152401d818$export$c860ea55e361ded9) return $6SDUu.EQ.value;
            if (x instanceof $cec7e3152401d818$export$c860ea55e361ded9) return $6SDUu.LT.value;
            if (y instanceof $cec7e3152401d818$export$c860ea55e361ded9) return $6SDUu.GT.value;
            if (x instanceof $cec7e3152401d818$export$7ac9d04ce3f22c96 && y instanceof $cec7e3152401d818$export$7ac9d04ce3f22c96) return $6SDUu.EQ.value;
            if (x instanceof $cec7e3152401d818$export$7ac9d04ce3f22c96) return $6SDUu.LT.value;
            if (y instanceof $cec7e3152401d818$export$7ac9d04ce3f22c96) return $6SDUu.GT.value;
            if (x instanceof $cec7e3152401d818$export$6a70bbf20f9e4d15 && y instanceof $cec7e3152401d818$export$6a70bbf20f9e4d15) return $6SDUu.EQ.value;
            if (x instanceof $cec7e3152401d818$export$6a70bbf20f9e4d15) return $6SDUu.LT.value;
            if (y instanceof $cec7e3152401d818$export$6a70bbf20f9e4d15) return $6SDUu.GT.value;
            if (x instanceof $cec7e3152401d818$export$497a6aaf7dad75ee && y instanceof $cec7e3152401d818$export$497a6aaf7dad75ee) return $6SDUu.EQ.value;
            if (x instanceof $cec7e3152401d818$export$497a6aaf7dad75ee) return $6SDUu.LT.value;
            if (y instanceof $cec7e3152401d818$export$497a6aaf7dad75ee) return $6SDUu.GT.value;
            if (x instanceof $cec7e3152401d818$export$688bf7bc8f9a8891 && y instanceof $cec7e3152401d818$export$688bf7bc8f9a8891) return $6SDUu.EQ.value;
            if (x instanceof $cec7e3152401d818$export$688bf7bc8f9a8891) return $6SDUu.LT.value;
            if (y instanceof $cec7e3152401d818$export$688bf7bc8f9a8891) return $6SDUu.GT.value;
            if (x instanceof $cec7e3152401d818$export$f953fc739c1a72e8 && y instanceof $cec7e3152401d818$export$f953fc739c1a72e8) return $6SDUu.EQ.value;
            if (x instanceof $cec7e3152401d818$export$f953fc739c1a72e8) return $6SDUu.LT.value;
            if (y instanceof $cec7e3152401d818$export$f953fc739c1a72e8) return $6SDUu.GT.value;
            if (x instanceof $cec7e3152401d818$export$94c7ee1e602c3016 && y instanceof $cec7e3152401d818$export$94c7ee1e602c3016) return $6SDUu.EQ.value;
            if (x instanceof $cec7e3152401d818$export$94c7ee1e602c3016) return $6SDUu.LT.value;
            if (y instanceof $cec7e3152401d818$export$94c7ee1e602c3016) return $6SDUu.GT.value;
            if (x instanceof $cec7e3152401d818$export$e3f21b3e5e110727 && y instanceof $cec7e3152401d818$export$e3f21b3e5e110727) return $6SDUu.EQ.value;
            if (x instanceof $cec7e3152401d818$export$e3f21b3e5e110727) return $6SDUu.LT.value;
            if (y instanceof $cec7e3152401d818$export$e3f21b3e5e110727) return $6SDUu.GT.value;
            if (x instanceof $cec7e3152401d818$export$cf9581d419a141cf && y instanceof $cec7e3152401d818$export$cf9581d419a141cf) return $6SDUu.EQ.value;
            if (x instanceof $cec7e3152401d818$export$cf9581d419a141cf) return $6SDUu.LT.value;
            if (y instanceof $cec7e3152401d818$export$cf9581d419a141cf) return $6SDUu.GT.value;
            if (x instanceof $cec7e3152401d818$export$66ebaee5e192c141 && y instanceof $cec7e3152401d818$export$66ebaee5e192c141) return $6SDUu.EQ.value;
            if (x instanceof $cec7e3152401d818$export$66ebaee5e192c141) return $6SDUu.LT.value;
            if (y instanceof $cec7e3152401d818$export$66ebaee5e192c141) return $6SDUu.GT.value;
            if (x instanceof $cec7e3152401d818$export$324f219e224c2ba4 && y instanceof $cec7e3152401d818$export$324f219e224c2ba4) return $6SDUu.EQ.value;
            if (x instanceof $cec7e3152401d818$export$324f219e224c2ba4) return $6SDUu.LT.value;
            if (y instanceof $cec7e3152401d818$export$324f219e224c2ba4) return $6SDUu.GT.value;
            if (x instanceof $cec7e3152401d818$export$7fd9b60c3e71d3cc && y instanceof $cec7e3152401d818$export$7fd9b60c3e71d3cc) return $6SDUu.EQ.value;
            if (x instanceof $cec7e3152401d818$export$7fd9b60c3e71d3cc) return $6SDUu.LT.value;
            if (y instanceof $cec7e3152401d818$export$7fd9b60c3e71d3cc) return $6SDUu.GT.value;
            if (x instanceof $cec7e3152401d818$export$e5f0f61dd2ad15f5 && y instanceof $cec7e3152401d818$export$e5f0f61dd2ad15f5) return $6SDUu.EQ.value;
            if (x instanceof $cec7e3152401d818$export$e5f0f61dd2ad15f5) return $6SDUu.LT.value;
            if (y instanceof $cec7e3152401d818$export$e5f0f61dd2ad15f5) return $6SDUu.GT.value;
            if (x instanceof $cec7e3152401d818$export$28044d9a5dbb104e && y instanceof $cec7e3152401d818$export$28044d9a5dbb104e) return $6SDUu.EQ.value;
            if (x instanceof $cec7e3152401d818$export$28044d9a5dbb104e) return $6SDUu.LT.value;
            if (y instanceof $cec7e3152401d818$export$28044d9a5dbb104e) return $6SDUu.GT.value;
            if (x instanceof $cec7e3152401d818$export$41cafe4e2581754d && y instanceof $cec7e3152401d818$export$41cafe4e2581754d) return $6SDUu.EQ.value;
            if (x instanceof $cec7e3152401d818$export$41cafe4e2581754d) return $6SDUu.LT.value;
            if (y instanceof $cec7e3152401d818$export$41cafe4e2581754d) return $6SDUu.GT.value;
            if (x instanceof $cec7e3152401d818$export$5a51e0eecea5d8bd && y instanceof $cec7e3152401d818$export$5a51e0eecea5d8bd) return $6SDUu.EQ.value;
            if (x instanceof $cec7e3152401d818$export$5a51e0eecea5d8bd) return $6SDUu.LT.value;
            if (y instanceof $cec7e3152401d818$export$5a51e0eecea5d8bd) return $6SDUu.GT.value;
            if (x instanceof $cec7e3152401d818$export$7034fcb7d6351061 && y instanceof $cec7e3152401d818$export$7034fcb7d6351061) return $6SDUu.EQ.value;
            if (x instanceof $cec7e3152401d818$export$7034fcb7d6351061) return $6SDUu.LT.value;
            if (y instanceof $cec7e3152401d818$export$7034fcb7d6351061) return $6SDUu.GT.value;
            if (x instanceof $cec7e3152401d818$export$d62c52bf2c44ba6f && y instanceof $cec7e3152401d818$export$d62c52bf2c44ba6f) return $6SDUu.EQ.value;
            if (x instanceof $cec7e3152401d818$export$d62c52bf2c44ba6f) return $6SDUu.LT.value;
            if (y instanceof $cec7e3152401d818$export$d62c52bf2c44ba6f) return $6SDUu.GT.value;
            if (x instanceof $cec7e3152401d818$export$dfe56e1f58ed5cb2 && y instanceof $cec7e3152401d818$export$dfe56e1f58ed5cb2) return $6SDUu.EQ.value;
            if (x instanceof $cec7e3152401d818$export$dfe56e1f58ed5cb2) return $6SDUu.LT.value;
            if (y instanceof $cec7e3152401d818$export$dfe56e1f58ed5cb2) return $6SDUu.GT.value;
            if (x instanceof $cec7e3152401d818$export$8e8a9e74dfcf346a && y instanceof $cec7e3152401d818$export$8e8a9e74dfcf346a) return $6SDUu.EQ.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.InputType (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $cec7e3152401d818$export$417491cbf879eb77;
    }
};

});

parcelRegister("19t60", function(module, exports) {

$parcel$export(module.exports, "renderKindValue", () => $0d6d338ad81e2ec3$export$8d81b1ec6c8c1d53);
// Generated by purs version 0.15.16

var $6SDUu = parcelRequire("6SDUu");
var $0d6d338ad81e2ec3$export$35c6296c72c0b98 = /* #__PURE__ */ function() {
    function KindSubtitles() {}
    KindSubtitles.value = new KindSubtitles();
    return KindSubtitles;
}();
var $0d6d338ad81e2ec3$export$57c7f27d38c9b1fa = /* #__PURE__ */ function() {
    function KindCaptions() {}
    KindCaptions.value = new KindCaptions();
    return KindCaptions;
}();
var $0d6d338ad81e2ec3$export$ed9577fa4e97a113 = /* #__PURE__ */ function() {
    function KindDescriptions() {}
    KindDescriptions.value = new KindDescriptions();
    return KindDescriptions;
}();
var $0d6d338ad81e2ec3$export$6b7135087206d174 = /* #__PURE__ */ function() {
    function KindChapters() {}
    KindChapters.value = new KindChapters();
    return KindChapters;
}();
var $0d6d338ad81e2ec3$export$a2734ee0406012d8 = /* #__PURE__ */ function() {
    function KindMetadata() {}
    KindMetadata.value = new KindMetadata();
    return KindMetadata;
}();
var $0d6d338ad81e2ec3$export$8d81b1ec6c8c1d53 = function(v) {
    if (v instanceof $0d6d338ad81e2ec3$export$35c6296c72c0b98) return "subtitles";
    if (v instanceof $0d6d338ad81e2ec3$export$57c7f27d38c9b1fa) return "captions";
    if (v instanceof $0d6d338ad81e2ec3$export$ed9577fa4e97a113) return "descriptions";
    if (v instanceof $0d6d338ad81e2ec3$export$6b7135087206d174) return "chapters";
    if (v instanceof $0d6d338ad81e2ec3$export$a2734ee0406012d8) return "metadata";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.KindValue (line 16, column 19 - line 21, column 29): " + [
        v.constructor.name
    ]);
};
var $0d6d338ad81e2ec3$export$4037dad5bbd136 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $0d6d338ad81e2ec3$export$35c6296c72c0b98 && y instanceof $0d6d338ad81e2ec3$export$35c6296c72c0b98) return true;
            if (x instanceof $0d6d338ad81e2ec3$export$57c7f27d38c9b1fa && y instanceof $0d6d338ad81e2ec3$export$57c7f27d38c9b1fa) return true;
            if (x instanceof $0d6d338ad81e2ec3$export$ed9577fa4e97a113 && y instanceof $0d6d338ad81e2ec3$export$ed9577fa4e97a113) return true;
            if (x instanceof $0d6d338ad81e2ec3$export$6b7135087206d174 && y instanceof $0d6d338ad81e2ec3$export$6b7135087206d174) return true;
            if (x instanceof $0d6d338ad81e2ec3$export$a2734ee0406012d8 && y instanceof $0d6d338ad81e2ec3$export$a2734ee0406012d8) return true;
            return false;
        };
    }
};
var $0d6d338ad81e2ec3$export$70ddb214b8742e4 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $0d6d338ad81e2ec3$export$35c6296c72c0b98 && y instanceof $0d6d338ad81e2ec3$export$35c6296c72c0b98) return $6SDUu.EQ.value;
            if (x instanceof $0d6d338ad81e2ec3$export$35c6296c72c0b98) return $6SDUu.LT.value;
            if (y instanceof $0d6d338ad81e2ec3$export$35c6296c72c0b98) return $6SDUu.GT.value;
            if (x instanceof $0d6d338ad81e2ec3$export$57c7f27d38c9b1fa && y instanceof $0d6d338ad81e2ec3$export$57c7f27d38c9b1fa) return $6SDUu.EQ.value;
            if (x instanceof $0d6d338ad81e2ec3$export$57c7f27d38c9b1fa) return $6SDUu.LT.value;
            if (y instanceof $0d6d338ad81e2ec3$export$57c7f27d38c9b1fa) return $6SDUu.GT.value;
            if (x instanceof $0d6d338ad81e2ec3$export$ed9577fa4e97a113 && y instanceof $0d6d338ad81e2ec3$export$ed9577fa4e97a113) return $6SDUu.EQ.value;
            if (x instanceof $0d6d338ad81e2ec3$export$ed9577fa4e97a113) return $6SDUu.LT.value;
            if (y instanceof $0d6d338ad81e2ec3$export$ed9577fa4e97a113) return $6SDUu.GT.value;
            if (x instanceof $0d6d338ad81e2ec3$export$6b7135087206d174 && y instanceof $0d6d338ad81e2ec3$export$6b7135087206d174) return $6SDUu.EQ.value;
            if (x instanceof $0d6d338ad81e2ec3$export$6b7135087206d174) return $6SDUu.LT.value;
            if (y instanceof $0d6d338ad81e2ec3$export$6b7135087206d174) return $6SDUu.GT.value;
            if (x instanceof $0d6d338ad81e2ec3$export$a2734ee0406012d8 && y instanceof $0d6d338ad81e2ec3$export$a2734ee0406012d8) return $6SDUu.EQ.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.KindValue (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $0d6d338ad81e2ec3$export$4037dad5bbd136;
    }
};

});

parcelRegister("7odkg", function(module, exports) {

$parcel$export(module.exports, "renderMenuType", () => $01636ff1929ca3b5$export$1746677a19c76ca);
// Generated by purs version 0.15.16

var $6SDUu = parcelRequire("6SDUu");
var $01636ff1929ca3b5$export$d4c4e98c5044dc8 = /* #__PURE__ */ function() {
    function MenuList() {}
    MenuList.value = new MenuList();
    return MenuList;
}();
var $01636ff1929ca3b5$export$c7e742effb1c51e2 = /* #__PURE__ */ function() {
    function MenuContext() {}
    MenuContext.value = new MenuContext();
    return MenuContext;
}();
var $01636ff1929ca3b5$export$5ed3d899d0b4c46b = /* #__PURE__ */ function() {
    function MenuToolbar() {}
    MenuToolbar.value = new MenuToolbar();
    return MenuToolbar;
}();
var $01636ff1929ca3b5$export$1746677a19c76ca = function(v) {
    if (v instanceof $01636ff1929ca3b5$export$d4c4e98c5044dc8) return "list";
    if (v instanceof $01636ff1929ca3b5$export$c7e742effb1c51e2) return "context";
    if (v instanceof $01636ff1929ca3b5$export$5ed3d899d0b4c46b) return "toolbar";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.MenuType (line 14, column 18 - line 17, column 27): " + [
        v.constructor.name
    ]);
};
var $01636ff1929ca3b5$export$fb82239a3dd454ef = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $01636ff1929ca3b5$export$d4c4e98c5044dc8 && y instanceof $01636ff1929ca3b5$export$d4c4e98c5044dc8) return true;
            if (x instanceof $01636ff1929ca3b5$export$c7e742effb1c51e2 && y instanceof $01636ff1929ca3b5$export$c7e742effb1c51e2) return true;
            if (x instanceof $01636ff1929ca3b5$export$5ed3d899d0b4c46b && y instanceof $01636ff1929ca3b5$export$5ed3d899d0b4c46b) return true;
            return false;
        };
    }
};
var $01636ff1929ca3b5$export$93b0f2b60788283e = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $01636ff1929ca3b5$export$d4c4e98c5044dc8 && y instanceof $01636ff1929ca3b5$export$d4c4e98c5044dc8) return $6SDUu.EQ.value;
            if (x instanceof $01636ff1929ca3b5$export$d4c4e98c5044dc8) return $6SDUu.LT.value;
            if (y instanceof $01636ff1929ca3b5$export$d4c4e98c5044dc8) return $6SDUu.GT.value;
            if (x instanceof $01636ff1929ca3b5$export$c7e742effb1c51e2 && y instanceof $01636ff1929ca3b5$export$c7e742effb1c51e2) return $6SDUu.EQ.value;
            if (x instanceof $01636ff1929ca3b5$export$c7e742effb1c51e2) return $6SDUu.LT.value;
            if (y instanceof $01636ff1929ca3b5$export$c7e742effb1c51e2) return $6SDUu.GT.value;
            if (x instanceof $01636ff1929ca3b5$export$5ed3d899d0b4c46b && y instanceof $01636ff1929ca3b5$export$5ed3d899d0b4c46b) return $6SDUu.EQ.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.MenuType (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $01636ff1929ca3b5$export$fb82239a3dd454ef;
    }
};

});

parcelRegister("1UfuE", function(module, exports) {

$parcel$export(module.exports, "renderMenuitemType", () => $16370a0f58f1c8c4$export$3e035bf7a26d866f);
// Generated by purs version 0.15.16

var $6SDUu = parcelRequire("6SDUu");
var $16370a0f58f1c8c4$export$45504f2104ec46b9 = /* #__PURE__ */ function() {
    function MenuitemCommand() {}
    MenuitemCommand.value = new MenuitemCommand();
    return MenuitemCommand;
}();
var $16370a0f58f1c8c4$export$eea2e5b7a15a4e39 = /* #__PURE__ */ function() {
    function MenuitemCheckbox() {}
    MenuitemCheckbox.value = new MenuitemCheckbox();
    return MenuitemCheckbox;
}();
var $16370a0f58f1c8c4$export$d4d65a7e83785e4a = /* #__PURE__ */ function() {
    function MenuitemRadio() {}
    MenuitemRadio.value = new MenuitemRadio();
    return MenuitemRadio;
}();
var $16370a0f58f1c8c4$export$3e035bf7a26d866f = function(v) {
    if (v instanceof $16370a0f58f1c8c4$export$45504f2104ec46b9) return "command";
    if (v instanceof $16370a0f58f1c8c4$export$eea2e5b7a15a4e39) return "checkbox";
    if (v instanceof $16370a0f58f1c8c4$export$d4d65a7e83785e4a) return "radio";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.MenuitemType (line 14, column 22 - line 17, column 27): " + [
        v.constructor.name
    ]);
};
var $16370a0f58f1c8c4$export$e73111b8eb7b1a2f = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $16370a0f58f1c8c4$export$45504f2104ec46b9 && y instanceof $16370a0f58f1c8c4$export$45504f2104ec46b9) return true;
            if (x instanceof $16370a0f58f1c8c4$export$eea2e5b7a15a4e39 && y instanceof $16370a0f58f1c8c4$export$eea2e5b7a15a4e39) return true;
            if (x instanceof $16370a0f58f1c8c4$export$d4d65a7e83785e4a && y instanceof $16370a0f58f1c8c4$export$d4d65a7e83785e4a) return true;
            return false;
        };
    }
};
var $16370a0f58f1c8c4$export$67edf3145dec517a = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $16370a0f58f1c8c4$export$45504f2104ec46b9 && y instanceof $16370a0f58f1c8c4$export$45504f2104ec46b9) return $6SDUu.EQ.value;
            if (x instanceof $16370a0f58f1c8c4$export$45504f2104ec46b9) return $6SDUu.LT.value;
            if (y instanceof $16370a0f58f1c8c4$export$45504f2104ec46b9) return $6SDUu.GT.value;
            if (x instanceof $16370a0f58f1c8c4$export$eea2e5b7a15a4e39 && y instanceof $16370a0f58f1c8c4$export$eea2e5b7a15a4e39) return $6SDUu.EQ.value;
            if (x instanceof $16370a0f58f1c8c4$export$eea2e5b7a15a4e39) return $6SDUu.LT.value;
            if (y instanceof $16370a0f58f1c8c4$export$eea2e5b7a15a4e39) return $6SDUu.GT.value;
            if (x instanceof $16370a0f58f1c8c4$export$d4d65a7e83785e4a && y instanceof $16370a0f58f1c8c4$export$d4d65a7e83785e4a) return $6SDUu.EQ.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.MenuitemType (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $16370a0f58f1c8c4$export$e73111b8eb7b1a2f;
    }
};

});

parcelRegister("8cBb2", function(module, exports) {

$parcel$export(module.exports, "renderOrderedListType", () => $018a854b7e87c5c3$export$a347b8fb4fdf4d6c);
// Generated by purs version 0.15.16

var $4MBcA = parcelRequire("4MBcA");

var $d0PPW = parcelRequire("d0PPW");

var $6SDUu = parcelRequire("6SDUu");
var $018a854b7e87c5c3$export$44ce537f0c9df246 = /* #__PURE__ */ function() {
    function Uppercase() {}
    Uppercase.value = new Uppercase();
    return Uppercase;
}();
var $018a854b7e87c5c3$export$83336b6c62a5a6d9 = /* #__PURE__ */ function() {
    function Lowercase() {}
    Lowercase.value = new Lowercase();
    return Lowercase;
}();
var $018a854b7e87c5c3$export$4ae8afa1ef3b3b36 = /* #__PURE__ */ function() {
    function NumeralDecimal() {}
    NumeralDecimal.value = new NumeralDecimal();
    return NumeralDecimal;
}();
var $018a854b7e87c5c3$export$d7365b08e0f1de3f = /* #__PURE__ */ function() {
    function NumeralRoman(value0) {
        this.value0 = value0;
    }
    NumeralRoman.create = function(value0) {
        return new NumeralRoman(value0);
    };
    return NumeralRoman;
}();
var $018a854b7e87c5c3$export$d3365947fb5d3bc = /* #__PURE__ */ function() {
    function OrderedListNumeric(value0) {
        this.value0 = value0;
    }
    OrderedListNumeric.create = function(value0) {
        return new OrderedListNumeric(value0);
    };
    return OrderedListNumeric;
}();
var $018a854b7e87c5c3$export$6f21557799b70c7b = /* #__PURE__ */ function() {
    function OrderedListAlphabetic(value0) {
        this.value0 = value0;
    }
    OrderedListAlphabetic.create = function(value0) {
        return new OrderedListAlphabetic(value0);
    };
    return OrderedListAlphabetic;
}();
var $018a854b7e87c5c3$export$a347b8fb4fdf4d6c = function(v) {
    if (v instanceof $018a854b7e87c5c3$export$d3365947fb5d3bc && v.value0 instanceof $018a854b7e87c5c3$export$4ae8afa1ef3b3b36) return "1";
    if (v instanceof $018a854b7e87c5c3$export$d3365947fb5d3bc && v.value0 instanceof $018a854b7e87c5c3$export$d7365b08e0f1de3f && v.value0.value0 instanceof $018a854b7e87c5c3$export$83336b6c62a5a6d9) return "i";
    if (v instanceof $018a854b7e87c5c3$export$d3365947fb5d3bc && v.value0 instanceof $018a854b7e87c5c3$export$d7365b08e0f1de3f && v.value0.value0 instanceof $018a854b7e87c5c3$export$44ce537f0c9df246) return "I";
    if (v instanceof $018a854b7e87c5c3$export$6f21557799b70c7b && v.value0 instanceof $018a854b7e87c5c3$export$83336b6c62a5a6d9) return "a";
    if (v instanceof $018a854b7e87c5c3$export$6f21557799b70c7b && v.value0 instanceof $018a854b7e87c5c3$export$44ce537f0c9df246) return "A";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.OrderedListType (line 27, column 25 - line 32, column 41): " + [
        v.constructor.name
    ]);
};
var $018a854b7e87c5c3$export$9fb147ac07d57455 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $018a854b7e87c5c3$export$44ce537f0c9df246 && y instanceof $018a854b7e87c5c3$export$44ce537f0c9df246) return true;
            if (x instanceof $018a854b7e87c5c3$export$83336b6c62a5a6d9 && y instanceof $018a854b7e87c5c3$export$83336b6c62a5a6d9) return true;
            return false;
        };
    }
};
var $018a854b7e87c5c3$var$eq = /* #__PURE__ */ $4MBcA.eq($018a854b7e87c5c3$export$9fb147ac07d57455);
var $018a854b7e87c5c3$export$7549aa54c7bac647 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $018a854b7e87c5c3$export$4ae8afa1ef3b3b36 && y instanceof $018a854b7e87c5c3$export$4ae8afa1ef3b3b36) return true;
            if (x instanceof $018a854b7e87c5c3$export$d7365b08e0f1de3f && y instanceof $018a854b7e87c5c3$export$d7365b08e0f1de3f) return $018a854b7e87c5c3$var$eq(x.value0)(y.value0);
            return false;
        };
    }
};
var $018a854b7e87c5c3$var$eq1 = /* #__PURE__ */ $4MBcA.eq($018a854b7e87c5c3$export$7549aa54c7bac647);
var $018a854b7e87c5c3$export$e819e2655e0fcc28 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $018a854b7e87c5c3$export$d3365947fb5d3bc && y instanceof $018a854b7e87c5c3$export$d3365947fb5d3bc) return $018a854b7e87c5c3$var$eq1(x.value0)(y.value0);
            if (x instanceof $018a854b7e87c5c3$export$6f21557799b70c7b && y instanceof $018a854b7e87c5c3$export$6f21557799b70c7b) return $018a854b7e87c5c3$var$eq(x.value0)(y.value0);
            return false;
        };
    }
};
var $018a854b7e87c5c3$export$1bd622e0e5e4efb1 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $018a854b7e87c5c3$export$44ce537f0c9df246 && y instanceof $018a854b7e87c5c3$export$44ce537f0c9df246) return $6SDUu.EQ.value;
            if (x instanceof $018a854b7e87c5c3$export$44ce537f0c9df246) return $6SDUu.LT.value;
            if (y instanceof $018a854b7e87c5c3$export$44ce537f0c9df246) return $6SDUu.GT.value;
            if (x instanceof $018a854b7e87c5c3$export$83336b6c62a5a6d9 && y instanceof $018a854b7e87c5c3$export$83336b6c62a5a6d9) return $6SDUu.EQ.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.OrderedListType (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $018a854b7e87c5c3$export$9fb147ac07d57455;
    }
};
var $018a854b7e87c5c3$var$compare = /* #__PURE__ */ $d0PPW.compare($018a854b7e87c5c3$export$1bd622e0e5e4efb1);
var $018a854b7e87c5c3$export$cd9389dd72b9960d = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $018a854b7e87c5c3$export$4ae8afa1ef3b3b36 && y instanceof $018a854b7e87c5c3$export$4ae8afa1ef3b3b36) return $6SDUu.EQ.value;
            if (x instanceof $018a854b7e87c5c3$export$4ae8afa1ef3b3b36) return $6SDUu.LT.value;
            if (y instanceof $018a854b7e87c5c3$export$4ae8afa1ef3b3b36) return $6SDUu.GT.value;
            if (x instanceof $018a854b7e87c5c3$export$d7365b08e0f1de3f && y instanceof $018a854b7e87c5c3$export$d7365b08e0f1de3f) return $018a854b7e87c5c3$var$compare(x.value0)(y.value0);
            throw new Error("Failed pattern match at DOM.HTML.Indexed.OrderedListType (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $018a854b7e87c5c3$export$7549aa54c7bac647;
    }
};
var $018a854b7e87c5c3$var$compare1 = /* #__PURE__ */ $d0PPW.compare($018a854b7e87c5c3$export$cd9389dd72b9960d);
var $018a854b7e87c5c3$export$8c507121dc4e4ea6 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $018a854b7e87c5c3$export$d3365947fb5d3bc && y instanceof $018a854b7e87c5c3$export$d3365947fb5d3bc) return $018a854b7e87c5c3$var$compare1(x.value0)(y.value0);
            if (x instanceof $018a854b7e87c5c3$export$d3365947fb5d3bc) return $6SDUu.LT.value;
            if (y instanceof $018a854b7e87c5c3$export$d3365947fb5d3bc) return $6SDUu.GT.value;
            if (x instanceof $018a854b7e87c5c3$export$6f21557799b70c7b && y instanceof $018a854b7e87c5c3$export$6f21557799b70c7b) return $018a854b7e87c5c3$var$compare(x.value0)(y.value0);
            throw new Error("Failed pattern match at DOM.HTML.Indexed.OrderedListType (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $018a854b7e87c5c3$export$e819e2655e0fcc28;
    }
};

});

parcelRegister("7ZKwO", function(module, exports) {

$parcel$export(module.exports, "renderPreloadValue", () => $5d22526bed7c1d63$export$d6626656355d8e39);
// Generated by purs version 0.15.16

var $6SDUu = parcelRequire("6SDUu");
var $5d22526bed7c1d63$export$c9ce58abf53417e5 = /* #__PURE__ */ function() {
    function PreloadNone() {}
    PreloadNone.value = new PreloadNone();
    return PreloadNone;
}();
var $5d22526bed7c1d63$export$5e05b189d974313d = /* #__PURE__ */ function() {
    function PreloadAuto() {}
    PreloadAuto.value = new PreloadAuto();
    return PreloadAuto;
}();
var $5d22526bed7c1d63$export$177dbf7da98d3f0a = /* #__PURE__ */ function() {
    function PreloadMetadata() {}
    PreloadMetadata.value = new PreloadMetadata();
    return PreloadMetadata;
}();
var $5d22526bed7c1d63$export$d6626656355d8e39 = function(v) {
    if (v instanceof $5d22526bed7c1d63$export$c9ce58abf53417e5) return "none";
    if (v instanceof $5d22526bed7c1d63$export$5e05b189d974313d) return "auto";
    if (v instanceof $5d22526bed7c1d63$export$177dbf7da98d3f0a) return "metadata";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.PreloadValue (line 14, column 22 - line 17, column 32): " + [
        v.constructor.name
    ]);
};
var $5d22526bed7c1d63$export$2dcc86def1e5568e = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $5d22526bed7c1d63$export$c9ce58abf53417e5 && y instanceof $5d22526bed7c1d63$export$c9ce58abf53417e5) return true;
            if (x instanceof $5d22526bed7c1d63$export$5e05b189d974313d && y instanceof $5d22526bed7c1d63$export$5e05b189d974313d) return true;
            if (x instanceof $5d22526bed7c1d63$export$177dbf7da98d3f0a && y instanceof $5d22526bed7c1d63$export$177dbf7da98d3f0a) return true;
            return false;
        };
    }
};
var $5d22526bed7c1d63$export$c419e612a877bba3 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $5d22526bed7c1d63$export$c9ce58abf53417e5 && y instanceof $5d22526bed7c1d63$export$c9ce58abf53417e5) return $6SDUu.EQ.value;
            if (x instanceof $5d22526bed7c1d63$export$c9ce58abf53417e5) return $6SDUu.LT.value;
            if (y instanceof $5d22526bed7c1d63$export$c9ce58abf53417e5) return $6SDUu.GT.value;
            if (x instanceof $5d22526bed7c1d63$export$5e05b189d974313d && y instanceof $5d22526bed7c1d63$export$5e05b189d974313d) return $6SDUu.EQ.value;
            if (x instanceof $5d22526bed7c1d63$export$5e05b189d974313d) return $6SDUu.LT.value;
            if (y instanceof $5d22526bed7c1d63$export$5e05b189d974313d) return $6SDUu.GT.value;
            if (x instanceof $5d22526bed7c1d63$export$177dbf7da98d3f0a && y instanceof $5d22526bed7c1d63$export$177dbf7da98d3f0a) return $6SDUu.EQ.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.PreloadValue (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $5d22526bed7c1d63$export$2dcc86def1e5568e;
    }
};

});

parcelRegister("3rLU8", function(module, exports) {

$parcel$export(module.exports, "renderScopeValue", () => $28290d8d8d6af995$export$ce228bdd501ce63);
// Generated by purs version 0.15.16

var $6SDUu = parcelRequire("6SDUu");
var $28290d8d8d6af995$export$85b4c654d12206aa = /* #__PURE__ */ function() {
    function ScopeRow() {}
    ScopeRow.value = new ScopeRow();
    return ScopeRow;
}();
var $28290d8d8d6af995$export$bf0d11cf8bd9f5de = /* #__PURE__ */ function() {
    function ScopeCol() {}
    ScopeCol.value = new ScopeCol();
    return ScopeCol;
}();
var $28290d8d8d6af995$export$5910a17af6f76381 = /* #__PURE__ */ function() {
    function ScopeRowGroup() {}
    ScopeRowGroup.value = new ScopeRowGroup();
    return ScopeRowGroup;
}();
var $28290d8d8d6af995$export$6ce944503089dadd = /* #__PURE__ */ function() {
    function ScopeColGroup() {}
    ScopeColGroup.value = new ScopeColGroup();
    return ScopeColGroup;
}();
var $28290d8d8d6af995$export$5663b51bd1c6c084 = /* #__PURE__ */ function() {
    function ScopeAuto() {}
    ScopeAuto.value = new ScopeAuto();
    return ScopeAuto;
}();
var $28290d8d8d6af995$export$ce228bdd501ce63 = function(v) {
    if (v instanceof $28290d8d8d6af995$export$85b4c654d12206aa) return "row";
    if (v instanceof $28290d8d8d6af995$export$bf0d11cf8bd9f5de) return "col";
    if (v instanceof $28290d8d8d6af995$export$5910a17af6f76381) return "rowgroup";
    if (v instanceof $28290d8d8d6af995$export$6ce944503089dadd) return "colgroup";
    if (v instanceof $28290d8d8d6af995$export$5663b51bd1c6c084) return "auto";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.ScopeValue (line 16, column 20 - line 21, column 22): " + [
        v.constructor.name
    ]);
};
var $28290d8d8d6af995$export$118ba639ca4f9d14 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $28290d8d8d6af995$export$85b4c654d12206aa && y instanceof $28290d8d8d6af995$export$85b4c654d12206aa) return true;
            if (x instanceof $28290d8d8d6af995$export$bf0d11cf8bd9f5de && y instanceof $28290d8d8d6af995$export$bf0d11cf8bd9f5de) return true;
            if (x instanceof $28290d8d8d6af995$export$5910a17af6f76381 && y instanceof $28290d8d8d6af995$export$5910a17af6f76381) return true;
            if (x instanceof $28290d8d8d6af995$export$6ce944503089dadd && y instanceof $28290d8d8d6af995$export$6ce944503089dadd) return true;
            if (x instanceof $28290d8d8d6af995$export$5663b51bd1c6c084 && y instanceof $28290d8d8d6af995$export$5663b51bd1c6c084) return true;
            return false;
        };
    }
};
var $28290d8d8d6af995$export$4afeaf27b056d536 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $28290d8d8d6af995$export$85b4c654d12206aa && y instanceof $28290d8d8d6af995$export$85b4c654d12206aa) return $6SDUu.EQ.value;
            if (x instanceof $28290d8d8d6af995$export$85b4c654d12206aa) return $6SDUu.LT.value;
            if (y instanceof $28290d8d8d6af995$export$85b4c654d12206aa) return $6SDUu.GT.value;
            if (x instanceof $28290d8d8d6af995$export$bf0d11cf8bd9f5de && y instanceof $28290d8d8d6af995$export$bf0d11cf8bd9f5de) return $6SDUu.EQ.value;
            if (x instanceof $28290d8d8d6af995$export$bf0d11cf8bd9f5de) return $6SDUu.LT.value;
            if (y instanceof $28290d8d8d6af995$export$bf0d11cf8bd9f5de) return $6SDUu.GT.value;
            if (x instanceof $28290d8d8d6af995$export$5910a17af6f76381 && y instanceof $28290d8d8d6af995$export$5910a17af6f76381) return $6SDUu.EQ.value;
            if (x instanceof $28290d8d8d6af995$export$5910a17af6f76381) return $6SDUu.LT.value;
            if (y instanceof $28290d8d8d6af995$export$5910a17af6f76381) return $6SDUu.GT.value;
            if (x instanceof $28290d8d8d6af995$export$6ce944503089dadd && y instanceof $28290d8d8d6af995$export$6ce944503089dadd) return $6SDUu.EQ.value;
            if (x instanceof $28290d8d8d6af995$export$6ce944503089dadd) return $6SDUu.LT.value;
            if (y instanceof $28290d8d8d6af995$export$6ce944503089dadd) return $6SDUu.GT.value;
            if (x instanceof $28290d8d8d6af995$export$5663b51bd1c6c084 && y instanceof $28290d8d8d6af995$export$5663b51bd1c6c084) return $6SDUu.EQ.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.ScopeValue (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $28290d8d8d6af995$export$118ba639ca4f9d14;
    }
};

});

parcelRegister("dqDZn", function(module, exports) {

$parcel$export(module.exports, "renderStepValue", () => $9c6cb90b338ac9f8$export$eb5efa61a2272b57);
// Generated by purs version 0.15.16

var $d0PPW = parcelRequire("d0PPW");

var $6SDUu = parcelRequire("6SDUu");

var $3Orkn = parcelRequire("3Orkn");
var $9c6cb90b338ac9f8$var$show = /* #__PURE__ */ $3Orkn.show($3Orkn.showNumber);
var $9c6cb90b338ac9f8$var$compare = /* #__PURE__ */ $d0PPW.compare($d0PPW.ordNumber);
var $9c6cb90b338ac9f8$export$b24b633b1364b94b = /* #__PURE__ */ function() {
    function Any() {}
    Any.value = new Any();
    return Any;
}();
var $9c6cb90b338ac9f8$export$fd55ce593607084a = /* #__PURE__ */ function() {
    function Step(value0) {
        this.value0 = value0;
    }
    Step.create = function(value0) {
        return new Step(value0);
    };
    return Step;
}();
var $9c6cb90b338ac9f8$export$eb5efa61a2272b57 = function(v) {
    if (v instanceof $9c6cb90b338ac9f8$export$b24b633b1364b94b) return "any";
    if (v instanceof $9c6cb90b338ac9f8$export$fd55ce593607084a) return $9c6cb90b338ac9f8$var$show(v.value0);
    throw new Error("Failed pattern match at DOM.HTML.Indexed.StepValue (line 13, column 19 - line 15, column 19): " + [
        v.constructor.name
    ]);
};
var $9c6cb90b338ac9f8$export$8db64ca9ca089cac = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $9c6cb90b338ac9f8$export$b24b633b1364b94b && y instanceof $9c6cb90b338ac9f8$export$b24b633b1364b94b) return true;
            if (x instanceof $9c6cb90b338ac9f8$export$fd55ce593607084a && y instanceof $9c6cb90b338ac9f8$export$fd55ce593607084a) return x.value0 === y.value0;
            return false;
        };
    }
};
var $9c6cb90b338ac9f8$export$848021523941663f = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $9c6cb90b338ac9f8$export$b24b633b1364b94b && y instanceof $9c6cb90b338ac9f8$export$b24b633b1364b94b) return $6SDUu.EQ.value;
            if (x instanceof $9c6cb90b338ac9f8$export$b24b633b1364b94b) return $6SDUu.LT.value;
            if (y instanceof $9c6cb90b338ac9f8$export$b24b633b1364b94b) return $6SDUu.GT.value;
            if (x instanceof $9c6cb90b338ac9f8$export$fd55ce593607084a && y instanceof $9c6cb90b338ac9f8$export$fd55ce593607084a) return $9c6cb90b338ac9f8$var$compare(x.value0)(y.value0);
            throw new Error("Failed pattern match at DOM.HTML.Indexed.StepValue (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $9c6cb90b338ac9f8$export$8db64ca9ca089cac;
    }
};

});

parcelRegister("7f5Dk", function(module, exports) {

$parcel$export(module.exports, "renderWrapValue", () => $545e4dccf243e400$export$a763fdfe677a0aa9);
// Generated by purs version 0.15.16

var $6SDUu = parcelRequire("6SDUu");
var $545e4dccf243e400$export$a12ca0aab327cfc7 = /* #__PURE__ */ function() {
    function Hard() {}
    Hard.value = new Hard();
    return Hard;
}();
var $545e4dccf243e400$export$f8ab8e157e94ef80 = /* #__PURE__ */ function() {
    function Soft() {}
    Soft.value = new Soft();
    return Soft;
}();
var $545e4dccf243e400$export$a763fdfe677a0aa9 = function(v) {
    if (v instanceof $545e4dccf243e400$export$a12ca0aab327cfc7) return "hard";
    if (v instanceof $545e4dccf243e400$export$f8ab8e157e94ef80) return "soft";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.WrapValue (line 13, column 19 - line 15, column 17): " + [
        v.constructor.name
    ]);
};
var $545e4dccf243e400$export$2ca5a4c778c64452 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $545e4dccf243e400$export$a12ca0aab327cfc7 && y instanceof $545e4dccf243e400$export$a12ca0aab327cfc7) return true;
            if (x instanceof $545e4dccf243e400$export$f8ab8e157e94ef80 && y instanceof $545e4dccf243e400$export$f8ab8e157e94ef80) return true;
            return false;
        };
    }
};
var $545e4dccf243e400$export$7166197b77e6499a = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $545e4dccf243e400$export$a12ca0aab327cfc7 && y instanceof $545e4dccf243e400$export$a12ca0aab327cfc7) return $6SDUu.EQ.value;
            if (x instanceof $545e4dccf243e400$export$a12ca0aab327cfc7) return $6SDUu.LT.value;
            if (y instanceof $545e4dccf243e400$export$a12ca0aab327cfc7) return $6SDUu.GT.value;
            if (x instanceof $545e4dccf243e400$export$f8ab8e157e94ef80 && y instanceof $545e4dccf243e400$export$f8ab8e157e94ef80) return $6SDUu.EQ.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.WrapValue (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $545e4dccf243e400$export$2ca5a4c778c64452;
    }
};

});

parcelRegister("cVGsR", function(module, exports) {

$parcel$export(module.exports, "RefUpdate", () => $969bbf7e7aa55092$export$f4c20fd541e0bbe4);
$parcel$export(module.exports, "Action", () => $969bbf7e7aa55092$export$e19cd5f9376f8cee);
$parcel$export(module.exports, "functorInput", () => $969bbf7e7aa55092$export$5158bce98a089317);
// Generated by purs version 0.15.16

var $4MBcA = parcelRequire("4MBcA");

var $d0PPW = parcelRequire("d0PPW");
var $969bbf7e7aa55092$export$37de0cf0f2f21d21 = function(x) {
    return x;
};
var $969bbf7e7aa55092$export$f4c20fd541e0bbe4 = /* #__PURE__ */ function() {
    function RefUpdate(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    RefUpdate.create = function(value0) {
        return function(value1) {
            return new RefUpdate(value0, value1);
        };
    };
    return RefUpdate;
}();
var $969bbf7e7aa55092$export$e19cd5f9376f8cee = /* #__PURE__ */ function() {
    function Action(value0) {
        this.value0 = value0;
    }
    Action.create = function(value0) {
        return new Action(value0);
    };
    return Action;
}();
var $969bbf7e7aa55092$export$e4f50b41777b2135 = $d0PPW.ordString;
var $969bbf7e7aa55092$export$f406a712694a6a92 = {
    Coercible0: function() {
        return undefined;
    }
};
var $969bbf7e7aa55092$export$5158bce98a089317 = {
    map: function(f) {
        return function(m) {
            if (m instanceof $969bbf7e7aa55092$export$f4c20fd541e0bbe4) return new $969bbf7e7aa55092$export$f4c20fd541e0bbe4(m.value0, m.value1);
            if (m instanceof $969bbf7e7aa55092$export$e19cd5f9376f8cee) return new $969bbf7e7aa55092$export$e19cd5f9376f8cee(f(m.value0));
            throw new Error("Failed pattern match at Halogen.Query.Input (line 0, column 0 - line 0, column 0): " + [
                m.constructor.name
            ]);
        };
    }
};
var $969bbf7e7aa55092$export$9947dab6e2c9dd9d = $4MBcA.eqString;

});

parcelRegister("lnVhq", function(module, exports) {
// Generated by purs version 0.15.16

var $akkXi = parcelRequire("akkXi");

var $69gPG = parcelRequire("69gPG");

var $gorft = parcelRequire("gorft");

});
parcelRegister("akkXi", function(module, exports) {

$parcel$export(module.exports, "buildVDom", () => $784c06f0344d34c4$export$7d13c0f6790d0505);
// Generated by purs version 0.15.16
parcelRequire("4VF0K");
var $lGiKR = parcelRequire("lGiKR");

var $6UHO6 = parcelRequire("6UHO6");

var $ykHdR = parcelRequire("ykHdR");

var $T79xE = parcelRequire("T79xE");

var $9MxTl = parcelRequire("9MxTl");

var $69gPG = parcelRequire("69gPG");

var $gorft = parcelRequire("gorft");
parcelRequire("eO7Z3");
var $4Y58b = parcelRequire("4Y58b");

var $9kRqf = parcelRequire("9kRqf");
var $784c06f0344d34c4$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $784c06f0344d34c4$export$db317447723f2845 = function(x) {
    return x;
};
var $784c06f0344d34c4$var$haltWidget = function(v) {
    return $69gPG.halt(v.widget);
};
var $784c06f0344d34c4$var$$lazy_patchWidget = /* #__PURE__ */ $784c06f0344d34c4$var$$runtime_lazy("patchWidget", "Halogen.VDom.DOM", function() {
    return function(state, vdom) {
        if (vdom instanceof $gorft.Grafted) return $784c06f0344d34c4$var$$lazy_patchWidget(291)(state, $gorft.runGraft(vdom.value0));
        if (vdom instanceof $gorft.Widget) {
            var res = $69gPG.step(state.widget, vdom.value0);
            var res$prime = $69gPG.unStep(function(v) {
                return $69gPG.mkStep(new $69gPG.Step(v.value0, {
                    build: state.build,
                    widget: res
                }, $784c06f0344d34c4$var$$lazy_patchWidget(296), $784c06f0344d34c4$var$haltWidget));
            })(res);
            return res$prime;
        }
        $784c06f0344d34c4$var$haltWidget(state);
        return state.build(vdom);
    };
});
var $784c06f0344d34c4$var$patchWidget = /* #__PURE__ */ $784c06f0344d34c4$var$$lazy_patchWidget(286);
var $784c06f0344d34c4$var$haltText = function(v) {
    var parent = $4Y58b.parentNode(v.node);
    return $4Y58b.removeChild(v.node, parent);
};
var $784c06f0344d34c4$var$$lazy_patchText = /* #__PURE__ */ $784c06f0344d34c4$var$$runtime_lazy("patchText", "Halogen.VDom.DOM", function() {
    return function(state, vdom) {
        if (vdom instanceof $gorft.Grafted) return $784c06f0344d34c4$var$$lazy_patchText(82)(state, $gorft.runGraft(vdom.value0));
        if (vdom instanceof $gorft.Text) {
            if (state.value === vdom.value0) return $69gPG.mkStep(new $69gPG.Step(state.node, state, $784c06f0344d34c4$var$$lazy_patchText(85), $784c06f0344d34c4$var$haltText));
            if ($6UHO6.otherwise) {
                var nextState = {
                    build: state.build,
                    node: state.node,
                    value: vdom.value0
                };
                $4Y58b.setTextContent(vdom.value0, state.node);
                return $69gPG.mkStep(new $69gPG.Step(state.node, nextState, $784c06f0344d34c4$var$$lazy_patchText(89), $784c06f0344d34c4$var$haltText));
            }
        }
        $784c06f0344d34c4$var$haltText(state);
        return state.build(vdom);
    };
});
var $784c06f0344d34c4$var$patchText = /* #__PURE__ */ $784c06f0344d34c4$var$$lazy_patchText(77);
var $784c06f0344d34c4$var$haltKeyed = function(v) {
    var parent = $4Y58b.parentNode(v.node);
    $4Y58b.removeChild(v.node, parent);
    $4Y58b.forInE(v.children, function(v1, s) {
        return $69gPG.halt(s);
    });
    return $69gPG.halt(v.attrs);
};
var $784c06f0344d34c4$var$haltElem = function(v) {
    var parent = $4Y58b.parentNode(v.node);
    $4Y58b.removeChild(v.node, parent);
    $4Y58b.forEachE(v.children, $69gPG.halt);
    return $69gPG.halt(v.attrs);
};
var $784c06f0344d34c4$var$eqElemSpec = function(ns1, v, ns2, v1) {
    var $63 = v === v1;
    if ($63) {
        if (ns1 instanceof $ykHdR.Just && ns2 instanceof $ykHdR.Just && ns1.value0 === ns2.value0) return true;
        if (ns1 instanceof $ykHdR.Nothing && ns2 instanceof $ykHdR.Nothing) return true;
        return false;
    }
    return false;
};
var $784c06f0344d34c4$var$$lazy_patchElem = /* #__PURE__ */ $784c06f0344d34c4$var$$runtime_lazy("patchElem", "Halogen.VDom.DOM", function() {
    return function(state, vdom) {
        if (vdom instanceof $gorft.Grafted) return $784c06f0344d34c4$var$$lazy_patchElem(135)(state, $gorft.runGraft(vdom.value0));
        if (vdom instanceof $gorft.Elem && $784c06f0344d34c4$var$eqElemSpec(state.ns, state.name, vdom.value0, vdom.value1)) {
            var v = $lGiKR.length(vdom.value3);
            var v1 = $lGiKR.length(state.children);
            if (v1 === 0 && v === 0) {
                var attrs2 = $69gPG.step(state.attrs, vdom.value2);
                var nextState = {
                    build: state.build,
                    node: state.node,
                    attrs: attrs2,
                    ns: vdom.value0,
                    name: vdom.value1,
                    children: state.children
                };
                return $69gPG.mkStep(new $69gPG.Step(state.node, nextState, $784c06f0344d34c4$var$$lazy_patchElem(149), $784c06f0344d34c4$var$haltElem));
            }
            var onThis = function(v2, s) {
                return $69gPG.halt(s);
            };
            var onThese = function(ix, s, v2) {
                var res = $69gPG.step(s, v2);
                $4Y58b.insertChildIx(ix, $69gPG.extract(res), state.node);
                return res;
            };
            var onThat = function(ix, v2) {
                var res = state.build(v2);
                $4Y58b.insertChildIx(ix, $69gPG.extract(res), state.node);
                return res;
            };
            var children2 = $4Y58b.diffWithIxE(state.children, vdom.value3, onThese, onThis, onThat);
            var attrs2 = $69gPG.step(state.attrs, vdom.value2);
            var nextState = {
                build: state.build,
                node: state.node,
                attrs: attrs2,
                ns: vdom.value0,
                name: vdom.value1,
                children: children2
            };
            return $69gPG.mkStep(new $69gPG.Step(state.node, nextState, $784c06f0344d34c4$var$$lazy_patchElem(172), $784c06f0344d34c4$var$haltElem));
        }
        $784c06f0344d34c4$var$haltElem(state);
        return state.build(vdom);
    };
});
var $784c06f0344d34c4$var$patchElem = /* #__PURE__ */ $784c06f0344d34c4$var$$lazy_patchElem(130);
var $784c06f0344d34c4$var$$lazy_patchKeyed = /* #__PURE__ */ $784c06f0344d34c4$var$$runtime_lazy("patchKeyed", "Halogen.VDom.DOM", function() {
    return function(state, vdom) {
        if (vdom instanceof $gorft.Grafted) return $784c06f0344d34c4$var$$lazy_patchKeyed(222)(state, $gorft.runGraft(vdom.value0));
        if (vdom instanceof $gorft.Keyed && $784c06f0344d34c4$var$eqElemSpec(state.ns, state.name, vdom.value0, vdom.value1)) {
            var v = $lGiKR.length(vdom.value3);
            if (state.length === 0 && v === 0) {
                var attrs2 = $69gPG.step(state.attrs, vdom.value2);
                var nextState = {
                    build: state.build,
                    node: state.node,
                    attrs: attrs2,
                    ns: vdom.value0,
                    name: vdom.value1,
                    children: state.children,
                    length: 0
                };
                return $69gPG.mkStep(new $69gPG.Step(state.node, nextState, $784c06f0344d34c4$var$$lazy_patchKeyed(237), $784c06f0344d34c4$var$haltKeyed));
            }
            var onThis = function(v2, s) {
                return $69gPG.halt(s);
            };
            var onThese = function(v2, ix$prime, s, v3) {
                var res = $69gPG.step(s, v3.value1);
                $4Y58b.insertChildIx(ix$prime, $69gPG.extract(res), state.node);
                return res;
            };
            var onThat = function(v2, ix, v3) {
                var res = state.build(v3.value1);
                $4Y58b.insertChildIx(ix, $69gPG.extract(res), state.node);
                return res;
            };
            var children2 = $4Y58b.diffWithKeyAndIxE(state.children, vdom.value3, $9MxTl.fst, onThese, onThis, onThat);
            var attrs2 = $69gPG.step(state.attrs, vdom.value2);
            var nextState = {
                build: state.build,
                node: state.node,
                attrs: attrs2,
                ns: vdom.value0,
                name: vdom.value1,
                children: children2,
                length: v
            };
            return $69gPG.mkStep(new $69gPG.Step(state.node, nextState, $784c06f0344d34c4$var$$lazy_patchKeyed(261), $784c06f0344d34c4$var$haltKeyed));
        }
        $784c06f0344d34c4$var$haltKeyed(state);
        return state.build(vdom);
    };
});
var $784c06f0344d34c4$var$patchKeyed = /* #__PURE__ */ $784c06f0344d34c4$var$$lazy_patchKeyed(217);
var $784c06f0344d34c4$export$150cc32b4adaaae = function(v, build, w) {
    var res = v.buildWidget(v)(w);
    var res$prime = $69gPG.unStep(function(v1) {
        return $69gPG.mkStep(new $69gPG.Step(v1.value0, {
            build: build,
            widget: res
        }, $784c06f0344d34c4$var$patchWidget, $784c06f0344d34c4$var$haltWidget));
    })(res);
    return res$prime;
};
var $784c06f0344d34c4$export$97ed363902aee1ba = function(v, build, s) {
    var node = $4Y58b.createTextNode(s, v.document);
    var state = {
        build: build,
        node: node,
        value: s
    };
    return $69gPG.mkStep(new $69gPG.Step(node, state, $784c06f0344d34c4$var$patchText, $784c06f0344d34c4$var$haltText));
};
var $784c06f0344d34c4$export$198573fdc68576c0 = function(v, build, ns1, name1, as1, ch1) {
    var el = $4Y58b.createElement($T79xE.toNullable(ns1), name1, v.document);
    var node = $9kRqf.toNode(el);
    var onChild = function(v1, ix, v2) {
        var res = build(v2.value1);
        $4Y58b.insertChildIx(ix, $69gPG.extract(res), node);
        return res;
    };
    var children = $4Y58b.strMapWithIxE(ch1, $9MxTl.fst, onChild);
    var attrs = v.buildAttributes(el)(as1);
    var state = {
        build: build,
        node: node,
        attrs: attrs,
        ns: ns1,
        name: name1,
        children: children,
        length: $lGiKR.length(ch1)
    };
    return $69gPG.mkStep(new $69gPG.Step(node, state, $784c06f0344d34c4$var$patchKeyed, $784c06f0344d34c4$var$haltKeyed));
};
var $784c06f0344d34c4$export$88209766f38bf9bf = function(v, build, ns1, name1, as1, ch1) {
    var el = $4Y58b.createElement($T79xE.toNullable(ns1), name1, v.document);
    var node = $9kRqf.toNode(el);
    var onChild = function(ix, child) {
        var res = build(child);
        $4Y58b.insertChildIx(ix, $69gPG.extract(res), node);
        return res;
    };
    var children = $4Y58b.forE(ch1, onChild);
    var attrs = v.buildAttributes(el)(as1);
    var state = {
        build: build,
        node: node,
        attrs: attrs,
        ns: ns1,
        name: name1,
        children: children
    };
    return $69gPG.mkStep(new $69gPG.Step(node, state, $784c06f0344d34c4$var$patchElem, $784c06f0344d34c4$var$haltElem));
};
var $784c06f0344d34c4$export$7d13c0f6790d0505 = function(spec) {
    var $lazy_build = $784c06f0344d34c4$var$$runtime_lazy("build", "Halogen.VDom.DOM", function() {
        return function(v) {
            if (v instanceof $gorft.Text) return $784c06f0344d34c4$export$97ed363902aee1ba(spec, $lazy_build(59), v.value0);
            if (v instanceof $gorft.Elem) return $784c06f0344d34c4$export$88209766f38bf9bf(spec, $lazy_build(60), v.value0, v.value1, v.value2, v.value3);
            if (v instanceof $gorft.Keyed) return $784c06f0344d34c4$export$198573fdc68576c0(spec, $lazy_build(61), v.value0, v.value1, v.value2, v.value3);
            if (v instanceof $gorft.Widget) return $784c06f0344d34c4$export$150cc32b4adaaae(spec, $lazy_build(62), v.value0);
            if (v instanceof $gorft.Grafted) return $lazy_build(63)($gorft.runGraft(v.value0));
            throw new Error("Failed pattern match at Halogen.VDom.DOM (line 58, column 27 - line 63, column 52): " + [
                v.constructor.name
            ]);
        };
    });
    var build = $lazy_build(58);
    return build;
};

});
parcelRegister("T79xE", function(module, exports) {

$parcel$export(module.exports, "toNullable", () => $0a5aaf95f168428e$export$b187f57ee1822bc5);
$parcel$export(module.exports, "toMaybe", () => $0a5aaf95f168428e$export$1ba013b88f4f21f3);
$parcel$export(module.exports, "null", () => (parcelRequire("49gSO")).null);
// Generated by purs version 0.15.16

var $49gSO = parcelRequire("49gSO");

var $4MBcA = parcelRequire("4MBcA");

var $l4M7e = parcelRequire("l4M7e");

var $ykHdR = parcelRequire("ykHdR");

var $d0PPW = parcelRequire("d0PPW");

var $3Orkn = parcelRequire("3Orkn");
var $0a5aaf95f168428e$export$b187f57ee1822bc5 = /* #__PURE__ */ $ykHdR.maybe($49gSO.null)($49gSO.notNull);
var $0a5aaf95f168428e$export$1ba013b88f4f21f3 = function(n) {
    return $49gSO.nullable(n, $ykHdR.Nothing.value, $ykHdR.Just.create);
};
var $0a5aaf95f168428e$export$643760463fdd14c1 = function(dictShow) {
    return {
        show: function() {
            var $17 = $ykHdR.maybe("null")($3Orkn.show(dictShow));
            return function($18) {
                return $17($0a5aaf95f168428e$export$1ba013b88f4f21f3($18));
            };
        }()
    };
};
var $0a5aaf95f168428e$export$1d97b52fc2e07cdc = function(dictEq) {
    return {
        eq: $l4M7e.on($4MBcA.eq($ykHdR.eqMaybe(dictEq)))($0a5aaf95f168428e$export$1ba013b88f4f21f3)
    };
};
var $0a5aaf95f168428e$export$4fb7d8da662af215 = function(dictOrd) {
    var eqNullable1 = $0a5aaf95f168428e$export$1d97b52fc2e07cdc(dictOrd.Eq0());
    return {
        compare: $l4M7e.on($d0PPW.compare($ykHdR.ordMaybe(dictOrd)))($0a5aaf95f168428e$export$1ba013b88f4f21f3),
        Eq0: function() {
            return eqNullable1;
        }
    };
};
var $0a5aaf95f168428e$export$1b7ecac9aff49fbc = {
    eq1: function(dictEq) {
        return $4MBcA.eq($0a5aaf95f168428e$export$1d97b52fc2e07cdc(dictEq));
    }
};
var $0a5aaf95f168428e$export$46a371b99e80ea42 = {
    compare1: function(dictOrd) {
        return $d0PPW.compare($0a5aaf95f168428e$export$4fb7d8da662af215(dictOrd));
    },
    Eq10: function() {
        return $0a5aaf95f168428e$export$1b7ecac9aff49fbc;
    }
};

});
parcelRegister("49gSO", function(module, exports) {

$parcel$export(module.exports, "null", () => $305519516124a7ff$export$7b1b591b262c240);
$parcel$export(module.exports, "nullable", () => $305519516124a7ff$export$133fc36489ac9add);
$parcel$export(module.exports, "notNull", () => $305519516124a7ff$export$9b7835891cf7097a);
/* eslint-disable no-eq-null, eqeqeq */ const $305519516124a7ff$export$7b1b591b262c240 = null;
function $305519516124a7ff$export$133fc36489ac9add(a, r, f) {
    return a == null ? r : f(a);
}
function $305519516124a7ff$export$9b7835891cf7097a(x) {
    return x;
}

});


parcelRegister("69gPG", function(module, exports) {

$parcel$export(module.exports, "Step", () => $47a0a3ebf66dcc6a$export$fd55ce593607084a);
$parcel$export(module.exports, "unStep", () => $47a0a3ebf66dcc6a$export$4f45170fb98a7886);
$parcel$export(module.exports, "step", () => $47a0a3ebf66dcc6a$export$35d34bc0ed591a92);
$parcel$export(module.exports, "mkStep", () => $47a0a3ebf66dcc6a$export$dc52c2e07163a142);
$parcel$export(module.exports, "halt", () => $47a0a3ebf66dcc6a$export$ba038fef9cd0a0de);
$parcel$export(module.exports, "extract", () => $47a0a3ebf66dcc6a$export$f9380c9a627682d3);
// Generated by purs version 0.15.16
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");
var $47a0a3ebf66dcc6a$export$fd55ce593607084a = /* #__PURE__ */ function() {
    function Step(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    }
    Step.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return new Step(value0, value1, value2, value3);
                };
            };
        };
    };
    return Step;
}();
var $47a0a3ebf66dcc6a$export$4f45170fb98a7886 = $eOrGk.unsafeCoerce;
var $47a0a3ebf66dcc6a$export$35d34bc0ed591a92 = function(v, a) {
    return v.value2(v.value1, a);
};
var $47a0a3ebf66dcc6a$export$dc52c2e07163a142 = $eOrGk.unsafeCoerce;
var $47a0a3ebf66dcc6a$export$ba038fef9cd0a0de = function(v) {
    return v.value3(v.value1);
};
var $47a0a3ebf66dcc6a$export$f9380c9a627682d3 = /* #__PURE__ */ $47a0a3ebf66dcc6a$export$4f45170fb98a7886(function(v) {
    return v.value0;
});

});

parcelRegister("gorft", function(module, exports) {

$parcel$export(module.exports, "Text", () => $bef4063d6d8fe507$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "Elem", () => $bef4063d6d8fe507$export$cc2832fafe367c5e);
$parcel$export(module.exports, "Keyed", () => $bef4063d6d8fe507$export$bade370ab89110b);
$parcel$export(module.exports, "Widget", () => $bef4063d6d8fe507$export$a829527ff4e4114a);
$parcel$export(module.exports, "Grafted", () => $bef4063d6d8fe507$export$b73d5241bf90e3b6);
$parcel$export(module.exports, "eqNamespace", () => $bef4063d6d8fe507$export$520c9b3bf6c7d33a);
$parcel$export(module.exports, "eqElemName", () => $bef4063d6d8fe507$export$23ec092d74ce9fd);
$parcel$export(module.exports, "bifunctorVDom", () => $bef4063d6d8fe507$export$cb4b70c26113b373);
$parcel$export(module.exports, "runGraft", () => $bef4063d6d8fe507$export$355e219ccdea0aec);
$parcel$export(module.exports, "renderWidget", () => $bef4063d6d8fe507$export$8b4d9aa5702dece6);
// Generated by purs version 0.15.16

var $7T8P4 = parcelRequire("7T8P4");

var $2Mmje = parcelRequire("2Mmje");

var $4MBcA = parcelRequire("4MBcA");

var $l0wDR = parcelRequire("l0wDR");

var $d0PPW = parcelRequire("d0PPW");

var $9MxTl = parcelRequire("9MxTl");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");
var $bef4063d6d8fe507$var$identity = /* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn);
var $bef4063d6d8fe507$var$map = /* #__PURE__ */ $l0wDR.map($l0wDR.functorArray);
var $bef4063d6d8fe507$var$map1 = /* #__PURE__ */ $l0wDR.map($9MxTl.functorTuple);
var $bef4063d6d8fe507$export$f89ac22183df46e9 = function(x) {
    return x;
};
var $bef4063d6d8fe507$export$4d8ac795221d227 = function(x) {
    return x;
};
var $bef4063d6d8fe507$export$5f1af8db9871e1d6 = /* #__PURE__ */ function() {
    function Text(value0) {
        this.value0 = value0;
    }
    Text.create = function(value0) {
        return new Text(value0);
    };
    return Text;
}();
var $bef4063d6d8fe507$export$cc2832fafe367c5e = /* #__PURE__ */ function() {
    function Elem(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    }
    Elem.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return new Elem(value0, value1, value2, value3);
                };
            };
        };
    };
    return Elem;
}();
var $bef4063d6d8fe507$export$bade370ab89110b = /* #__PURE__ */ function() {
    function Keyed(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    }
    Keyed.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return new Keyed(value0, value1, value2, value3);
                };
            };
        };
    };
    return Keyed;
}();
var $bef4063d6d8fe507$export$a829527ff4e4114a = /* #__PURE__ */ function() {
    function Widget(value0) {
        this.value0 = value0;
    }
    Widget.create = function(value0) {
        return new Widget(value0);
    };
    return Widget;
}();
var $bef4063d6d8fe507$export$b73d5241bf90e3b6 = /* #__PURE__ */ function() {
    function Grafted(value0) {
        this.value0 = value0;
    }
    Grafted.create = function(value0) {
        return new Grafted(value0);
    };
    return Grafted;
}();
var $bef4063d6d8fe507$export$8ac9228c788aaa24 = /* #__PURE__ */ function() {
    function Graft(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    Graft.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new Graft(value0, value1, value2);
            };
        };
    };
    return Graft;
}();
var $bef4063d6d8fe507$export$c0694dcc5ceec5fe = function(f) {
    return function($61) {
        return f($61);
    };
};
var $bef4063d6d8fe507$export$1b27a95e780e7371 = $d0PPW.ordString;
var $bef4063d6d8fe507$export$2de60fdae46e330f = $d0PPW.ordString;
var $bef4063d6d8fe507$export$15ad108a4eed29f5 = {
    Coercible0: function() {
        return undefined;
    }
};
var $bef4063d6d8fe507$export$79c9400ffffba296 = {
    Coercible0: function() {
        return undefined;
    }
};
var $bef4063d6d8fe507$export$9bae923d92949c2f = $eOrGk.unsafeCoerce;
var $bef4063d6d8fe507$export$d77f48fa96824602 = {
    map: function(g) {
        return $bef4063d6d8fe507$export$c0694dcc5ceec5fe(function(v) {
            return $bef4063d6d8fe507$export$9bae923d92949c2f(new $bef4063d6d8fe507$export$8ac9228c788aaa24(v.value0, function($62) {
                return g(v.value1($62));
            }, v.value2));
        });
    }
};
var $bef4063d6d8fe507$var$map2 = /* #__PURE__ */ $l0wDR.map($bef4063d6d8fe507$export$d77f48fa96824602);
var $bef4063d6d8fe507$export$1654609171f4374f = {
    map: function(v) {
        return function(v1) {
            if (v1 instanceof $bef4063d6d8fe507$export$5f1af8db9871e1d6) return new $bef4063d6d8fe507$export$5f1af8db9871e1d6(v1.value0);
            if (v1 instanceof $bef4063d6d8fe507$export$b73d5241bf90e3b6) return new $bef4063d6d8fe507$export$b73d5241bf90e3b6($bef4063d6d8fe507$var$map2(v)(v1.value0));
            return new $bef4063d6d8fe507$export$b73d5241bf90e3b6($bef4063d6d8fe507$export$9bae923d92949c2f(new $bef4063d6d8fe507$export$8ac9228c788aaa24($bef4063d6d8fe507$var$identity, v, v1)));
        };
    }
};
var $bef4063d6d8fe507$export$520c9b3bf6c7d33a = $4MBcA.eqString;
var $bef4063d6d8fe507$export$23ec092d74ce9fd = $4MBcA.eqString;
var $bef4063d6d8fe507$export$45ea1942547d2591 = {
    bimap: function(f) {
        return function(g) {
            return $bef4063d6d8fe507$export$c0694dcc5ceec5fe(function(v) {
                return $bef4063d6d8fe507$export$9bae923d92949c2f(new $bef4063d6d8fe507$export$8ac9228c788aaa24(function($63) {
                    return f(v.value0($63));
                }, function($64) {
                    return g(v.value1($64));
                }, v.value2));
            });
        };
    }
};
var $bef4063d6d8fe507$var$bimap = /* #__PURE__ */ $2Mmje.bimap($bef4063d6d8fe507$export$45ea1942547d2591);
var $bef4063d6d8fe507$export$cb4b70c26113b373 = {
    bimap: function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $bef4063d6d8fe507$export$5f1af8db9871e1d6) return new $bef4063d6d8fe507$export$5f1af8db9871e1d6(v2.value0);
                if (v2 instanceof $bef4063d6d8fe507$export$b73d5241bf90e3b6) return new $bef4063d6d8fe507$export$b73d5241bf90e3b6($bef4063d6d8fe507$var$bimap(v)(v1)(v2.value0));
                return new $bef4063d6d8fe507$export$b73d5241bf90e3b6($bef4063d6d8fe507$export$9bae923d92949c2f(new $bef4063d6d8fe507$export$8ac9228c788aaa24(v, v1, v2)));
            };
        };
    }
};
var $bef4063d6d8fe507$export$355e219ccdea0aec = /* #__PURE__ */ $bef4063d6d8fe507$export$c0694dcc5ceec5fe(function(v) {
    var go = function(v2) {
        if (v2 instanceof $bef4063d6d8fe507$export$5f1af8db9871e1d6) return new $bef4063d6d8fe507$export$5f1af8db9871e1d6(v2.value0);
        if (v2 instanceof $bef4063d6d8fe507$export$cc2832fafe367c5e) return new $bef4063d6d8fe507$export$cc2832fafe367c5e(v2.value0, v2.value1, v.value0(v2.value2), $bef4063d6d8fe507$var$map(go)(v2.value3));
        if (v2 instanceof $bef4063d6d8fe507$export$bade370ab89110b) return new $bef4063d6d8fe507$export$bade370ab89110b(v2.value0, v2.value1, v.value0(v2.value2), $bef4063d6d8fe507$var$map($bef4063d6d8fe507$var$map1(go))(v2.value3));
        if (v2 instanceof $bef4063d6d8fe507$export$a829527ff4e4114a) return new $bef4063d6d8fe507$export$a829527ff4e4114a(v.value1(v2.value0));
        if (v2 instanceof $bef4063d6d8fe507$export$b73d5241bf90e3b6) return new $bef4063d6d8fe507$export$b73d5241bf90e3b6($bef4063d6d8fe507$var$bimap(v.value0)(v.value1)(v2.value0));
        throw new Error("Failed pattern match at Halogen.VDom.Types (line 86, column 7 - line 86, column 27): " + [
            v2.constructor.name
        ]);
    };
    return go(v.value2);
});
var $bef4063d6d8fe507$export$8b4d9aa5702dece6 = function(f) {
    return function(g) {
        return function(v) {
            if (v instanceof $bef4063d6d8fe507$export$5f1af8db9871e1d6) return new $bef4063d6d8fe507$export$5f1af8db9871e1d6(v.value0);
            if (v instanceof $bef4063d6d8fe507$export$cc2832fafe367c5e) return new $bef4063d6d8fe507$export$cc2832fafe367c5e(v.value0, v.value1, f(v.value2), $bef4063d6d8fe507$var$map($bef4063d6d8fe507$export$8b4d9aa5702dece6(f)(g))(v.value3));
            if (v instanceof $bef4063d6d8fe507$export$bade370ab89110b) return new $bef4063d6d8fe507$export$bade370ab89110b(v.value0, v.value1, f(v.value2), $bef4063d6d8fe507$var$map($bef4063d6d8fe507$var$map1($bef4063d6d8fe507$export$8b4d9aa5702dece6(f)(g)))(v.value3));
            if (v instanceof $bef4063d6d8fe507$export$a829527ff4e4114a) return g(v.value0);
            if (v instanceof $bef4063d6d8fe507$export$b73d5241bf90e3b6) return $bef4063d6d8fe507$export$8b4d9aa5702dece6(f)(g)($bef4063d6d8fe507$export$355e219ccdea0aec(v.value0));
            throw new Error("Failed pattern match at Halogen.VDom.Types (line 48, column 20 - line 53, column 48): " + [
                v.constructor.name
            ]);
        };
    };
};

});

parcelRegister("eO7Z3", function(module, exports) {

$parcel$export(module.exports, "unsafeLookup", () => $ac7bed94ac89bf37$export$7ff190aa1ea44157);
$parcel$export(module.exports, "unsafeFreeze", () => $ac7bed94ac89bf37$export$7c850c5af9b9983e);
$parcel$export(module.exports, "pokeMutMap", () => $ac7bed94ac89bf37$export$fcec48ff7d1e433f);
$parcel$export(module.exports, "newMutMap", () => $ac7bed94ac89bf37$export$af208d62fa81d7e9);
$parcel$export(module.exports, "unsafeGetAny", () => (parcelRequire("4Y58b")).unsafeGetAny);
$parcel$export(module.exports, "unsafeHasAny", () => (parcelRequire("4Y58b")).unsafeHasAny);
$parcel$export(module.exports, "unsafeSetAny", () => (parcelRequire("4Y58b")).unsafeSetAny);
$parcel$export(module.exports, "forE", () => (parcelRequire("4Y58b")).forE);
$parcel$export(module.exports, "forEachE", () => (parcelRequire("4Y58b")).forEachE);
$parcel$export(module.exports, "forInE", () => (parcelRequire("4Y58b")).forInE);
$parcel$export(module.exports, "diffWithIxE", () => (parcelRequire("4Y58b")).diffWithIxE);
$parcel$export(module.exports, "diffWithKeyAndIxE", () => (parcelRequire("4Y58b")).diffWithKeyAndIxE);
$parcel$export(module.exports, "strMapWithIxE", () => (parcelRequire("4Y58b")).strMapWithIxE);
$parcel$export(module.exports, "refEq", () => (parcelRequire("4Y58b")).refEq);
$parcel$export(module.exports, "createTextNode", () => (parcelRequire("4Y58b")).createTextNode);
$parcel$export(module.exports, "setTextContent", () => (parcelRequire("4Y58b")).setTextContent);
$parcel$export(module.exports, "createElement", () => (parcelRequire("4Y58b")).createElement);
$parcel$export(module.exports, "insertChildIx", () => (parcelRequire("4Y58b")).insertChildIx);
$parcel$export(module.exports, "removeChild", () => (parcelRequire("4Y58b")).removeChild);
$parcel$export(module.exports, "parentNode", () => (parcelRequire("4Y58b")).parentNode);
$parcel$export(module.exports, "setAttribute", () => (parcelRequire("4Y58b")).setAttribute);
$parcel$export(module.exports, "removeAttribute", () => (parcelRequire("4Y58b")).removeAttribute);
$parcel$export(module.exports, "hasAttribute", () => (parcelRequire("4Y58b")).hasAttribute);
$parcel$export(module.exports, "addEventListener", () => (parcelRequire("4Y58b")).addEventListener);
$parcel$export(module.exports, "removeEventListener", () => (parcelRequire("4Y58b")).removeEventListener);
$parcel$export(module.exports, "jsUndefined", () => (parcelRequire("4Y58b")).jsUndefined);
// Generated by purs version 0.15.16

var $4Y58b = parcelRequire("4Y58b");
parcelRequire("69Fcq");
var $021yS = parcelRequire("021yS");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");
var $ac7bed94ac89bf37$export$7ff190aa1ea44157 = $4Y58b.unsafeGetAny;
var $ac7bed94ac89bf37$export$7c850c5af9b9983e = $eOrGk.unsafeCoerce;
var $ac7bed94ac89bf37$export$fcec48ff7d1e433f = $4Y58b.unsafeSetAny;
var $ac7bed94ac89bf37$export$af208d62fa81d7e9 = $021yS.new;
var $ac7bed94ac89bf37$export$60e478053f1f2ade = $4Y58b.unsafeDeleteAny;

});
parcelRegister("4Y58b", function(module, exports) {

$parcel$export(module.exports, "unsafeGetAny", () => $39e0beec4569345c$export$e21bd765865a4e96);
$parcel$export(module.exports, "unsafeHasAny", () => $39e0beec4569345c$export$2d12e28667eef122);
$parcel$export(module.exports, "unsafeSetAny", () => $39e0beec4569345c$export$eecc4ddbfda9d798);
$parcel$export(module.exports, "unsafeDeleteAny", () => $39e0beec4569345c$export$97784d9c47ea0c18);
$parcel$export(module.exports, "forE", () => $39e0beec4569345c$export$3dfbdd78bf0090db);
$parcel$export(module.exports, "forEachE", () => $39e0beec4569345c$export$b658ad92e4f7ae19);
$parcel$export(module.exports, "forInE", () => $39e0beec4569345c$export$2da2a225d7cdb301);
$parcel$export(module.exports, "diffWithIxE", () => $39e0beec4569345c$export$2422518e1f611f3f);
$parcel$export(module.exports, "strMapWithIxE", () => $39e0beec4569345c$export$e766566cf460084);
$parcel$export(module.exports, "diffWithKeyAndIxE", () => $39e0beec4569345c$export$ca7590ccd55f275f);
$parcel$export(module.exports, "refEq", () => $39e0beec4569345c$export$9bc2d847a861e3d8);
$parcel$export(module.exports, "createTextNode", () => $39e0beec4569345c$export$b2ce9ad90858ed7a);
$parcel$export(module.exports, "setTextContent", () => $39e0beec4569345c$export$94b0296cab6203e);
$parcel$export(module.exports, "createElement", () => $39e0beec4569345c$export$c8a8987d4410bf2d);
$parcel$export(module.exports, "insertChildIx", () => $39e0beec4569345c$export$11c1557a40268f0f);
$parcel$export(module.exports, "removeChild", () => $39e0beec4569345c$export$7ae609f7af59e4f7);
$parcel$export(module.exports, "parentNode", () => $39e0beec4569345c$export$b54be7ce267a037b);
$parcel$export(module.exports, "setAttribute", () => $39e0beec4569345c$export$9fec4d97f1922e0b);
$parcel$export(module.exports, "removeAttribute", () => $39e0beec4569345c$export$6399f3bb52316b2c);
$parcel$export(module.exports, "hasAttribute", () => $39e0beec4569345c$export$7895096fcdde5712);
$parcel$export(module.exports, "addEventListener", () => $39e0beec4569345c$export$3f65cefe8380dbea);
$parcel$export(module.exports, "removeEventListener", () => $39e0beec4569345c$export$8ff9f68337b520c0);
$parcel$export(module.exports, "jsUndefined", () => $39e0beec4569345c$export$1e4bb18162c9f619);
"use strict";
function $39e0beec4569345c$export$e21bd765865a4e96(key, obj) {
    return obj[key];
}
function $39e0beec4569345c$export$2d12e28667eef122(key, obj) {
    return obj.hasOwnProperty(key);
}
function $39e0beec4569345c$export$eecc4ddbfda9d798(key, val, obj) {
    obj[key] = val;
}
function $39e0beec4569345c$export$97784d9c47ea0c18(key, obj) {
    delete obj[key];
}
function $39e0beec4569345c$export$3dfbdd78bf0090db(a, f) {
    var b = [];
    for(var i = 0; i < a.length; i++)b.push(f(i, a[i]));
    return b;
}
function $39e0beec4569345c$export$b658ad92e4f7ae19(a, f) {
    for(var i = 0; i < a.length; i++)f(a[i]);
}
function $39e0beec4569345c$export$2da2a225d7cdb301(o, f) {
    var ks = Object.keys(o);
    for(var i = 0; i < ks.length; i++){
        var k = ks[i];
        f(k, o[k]);
    }
}
function $39e0beec4569345c$export$eb8acc503e07b694(n, f) {
    for(var i = 0; i < n; i++)f();
}
function $39e0beec4569345c$export$2422518e1f611f3f(a1, a2, f1, f2, f3) {
    var a3 = [];
    var l1 = a1.length;
    var l2 = a2.length;
    var i = 0;
    while(true){
        if (i < l1) {
            if (i < l2) a3.push(f1(i, a1[i], a2[i]));
            else f2(i, a1[i]);
        } else if (i < l2) a3.push(f3(i, a2[i]));
        else break;
        i++;
    }
    return a3;
}
function $39e0beec4569345c$export$e766566cf460084(as, fk, f) {
    var o = {};
    for(var i = 0; i < as.length; i++){
        var a = as[i];
        var k = fk(a);
        o[k] = f(k, i, a);
    }
    return o;
}
function $39e0beec4569345c$export$ca7590ccd55f275f(o1, as, fk, f1, f2, f3) {
    var o2 = {};
    for(var i = 0; i < as.length; i++){
        var a = as[i];
        var k = fk(a);
        if (o1.hasOwnProperty(k)) o2[k] = f1(k, i, o1[k], a);
        else o2[k] = f3(k, i, a);
    }
    for(var k in o1){
        if (k in o2) continue;
        f2(k, o1[k]);
    }
    return o2;
}
function $39e0beec4569345c$export$9bc2d847a861e3d8(a, b) {
    return a === b;
}
function $39e0beec4569345c$export$b2ce9ad90858ed7a(s, doc) {
    return doc.createTextNode(s);
}
function $39e0beec4569345c$export$94b0296cab6203e(s, n) {
    n.textContent = s;
}
function $39e0beec4569345c$export$c8a8987d4410bf2d(ns, name, doc) {
    if (ns != null) return doc.createElementNS(ns, name);
    else return doc.createElement(name);
}
function $39e0beec4569345c$export$11c1557a40268f0f(i, a, b) {
    var n = b.childNodes.item(i) || null;
    if (n !== a) b.insertBefore(a, n);
}
function $39e0beec4569345c$export$7ae609f7af59e4f7(a, b) {
    if (b && a.parentNode === b) b.removeChild(a);
}
function $39e0beec4569345c$export$b54be7ce267a037b(a) {
    return a.parentNode;
}
function $39e0beec4569345c$export$9fec4d97f1922e0b(ns, attr, val, el) {
    if (ns != null) el.setAttributeNS(ns, attr, val);
    else el.setAttribute(attr, val);
}
function $39e0beec4569345c$export$6399f3bb52316b2c(ns, attr, el) {
    if (ns != null) el.removeAttributeNS(ns, attr);
    else el.removeAttribute(attr);
}
function $39e0beec4569345c$export$7895096fcdde5712(ns, attr, el) {
    if (ns != null) return el.hasAttributeNS(ns, attr);
    else return el.hasAttribute(attr);
}
function $39e0beec4569345c$export$3f65cefe8380dbea(ev, listener, el) {
    el.addEventListener(ev, listener, false);
}
function $39e0beec4569345c$export$8ff9f68337b520c0(ev, listener, el) {
    el.removeEventListener(ev, listener, false);
}
var $39e0beec4569345c$export$1e4bb18162c9f619 = void 0;

});

parcelRegister("69Fcq", function(module, exports) {

$parcel$export(module.exports, "new", () => (parcelRequire("021yS")).new);
$parcel$export(module.exports, "poke", () => (parcelRequire("021yS")).poke);
$parcel$export(module.exports, "delete", () => (parcelRequire("021yS")).delete);
// Generated by purs version 0.15.16

var $021yS = parcelRequire("021yS");

var $ykHdR = parcelRequire("ykHdR");
var $47b38aa8c72308f2$export$4d3fb11e950abb9e = /* #__PURE__ */ function() {
    return $021yS.peekImpl($ykHdR.Just.create)($ykHdR.Nothing.value);
}();

});
parcelRegister("021yS", function(module, exports) {

$parcel$export(module.exports, "new", () => $0061661dcaa2328e$export$b8cb59497041ffe4);
$parcel$export(module.exports, "peekImpl", () => $0061661dcaa2328e$export$6dc5f95d8548a16a);
$parcel$export(module.exports, "poke", () => $0061661dcaa2328e$export$dc13bdd74c909d26);
$parcel$export(module.exports, "delete", () => $0061661dcaa2328e$export$1822828d790e23ee);
const $0061661dcaa2328e$export$b8cb59497041ffe4 = function() {
    return {};
};
function $0061661dcaa2328e$export$6dc5f95d8548a16a(just) {
    return function(nothing) {
        return function(k) {
            return function(m) {
                return function() {
                    return ({}).hasOwnProperty.call(m, k) ? just(m[k]) : nothing;
                };
            };
        };
    };
}
function $0061661dcaa2328e$export$dc13bdd74c909d26(k) {
    return function(v) {
        return function(m) {
            return function() {
                m[k] = v;
                return m;
            };
        };
    };
}
const $0061661dcaa2328e$export$1822828d790e23ee = function(k) {
    return function(m) {
        return function() {
            delete m[k];
            return m;
        };
    };
};

});



parcelRegister("9kRqf", function(module, exports) {

$parcel$export(module.exports, "toNode", () => $6cbf6bdab8368bba$export$83a0de4644f1fbc4);
// Generated by purs version 0.15.16

var $bCA32 = parcelRequire("bCA32");

var $l0wDR = parcelRequire("l0wDR");

var $T79xE = parcelRequire("T79xE");

var $3Orkn = parcelRequire("3Orkn");

var $9hRVP = parcelRequire("9hRVP");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");
parcelRequire("bmTaV");
parcelRequire("ai79w");

var $4rrnG = parcelRequire("4rrnG");

var $6EJMX = parcelRequire("6EJMX");
var $6cbf6bdab8368bba$var$show = /* #__PURE__ */ $3Orkn.show($4rrnG.showShadowRootMode);
var $6cbf6bdab8368bba$var$map = /* #__PURE__ */ $l0wDR.map($9hRVP.functorEffect);
var $6cbf6bdab8368bba$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $6cbf6bdab8368bba$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $6cbf6bdab8368bba$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $6cbf6bdab8368bba$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $6cbf6bdab8368bba$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $6cbf6bdab8368bba$export$82e9f45cca5ba907 = function($3) {
    return $T79xE.toMaybe($bCA32._prefix($3));
};
var $6cbf6bdab8368bba$export$4bb31c815825375a = function($4) {
    return $T79xE.toMaybe($bCA32._namespaceURI($4));
};
var $6cbf6bdab8368bba$var$initToProps = function(init) {
    return {
        mode: $6cbf6bdab8368bba$var$show(init.mode),
        delegatesFocus: init.delegatesFocus
    };
};
var $6cbf6bdab8368bba$export$5c5bb02a2f64596a = function($5) {
    return $bCA32._getElementsByTagNameNS($T79xE.toNullable($5));
};
var $6cbf6bdab8368bba$export$735ee1799fd02602 = function(attr) {
    var $6 = $6cbf6bdab8368bba$var$map($T79xE.toMaybe);
    var $7 = $bCA32._getAttribute(attr);
    return function($8) {
        return $6($7($8));
    };
};
var $6cbf6bdab8368bba$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("Element");
var $6cbf6bdab8368bba$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("Element");
var $6cbf6bdab8368bba$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("Element");
var $6cbf6bdab8368bba$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("Element");
var $6cbf6bdab8368bba$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("Element");
var $6cbf6bdab8368bba$export$ff7f7c97cdce86e = function(qs) {
    var $9 = $6cbf6bdab8368bba$var$map($T79xE.toMaybe);
    var $10 = $bCA32._closest(qs);
    return function($11) {
        return $9($10($11));
    };
};
var $6cbf6bdab8368bba$export$c9f3f5ba3dfbdf61 = function($12) {
    return $bCA32._attachShadow($6cbf6bdab8368bba$var$initToProps($12));
};

});
parcelRegister("bCA32", function(module, exports) {

$parcel$export(module.exports, "_namespaceURI", () => $875f34aecc7bf161$export$3c44083a252eeb14);
$parcel$export(module.exports, "_prefix", () => $875f34aecc7bf161$export$6ae22f6d74087c1a);
$parcel$export(module.exports, "_getElementsByTagNameNS", () => $875f34aecc7bf161$export$83374683e5723893);
$parcel$export(module.exports, "_getAttribute", () => $875f34aecc7bf161$export$2dc9d886be7724ad);
$parcel$export(module.exports, "_closest", () => $875f34aecc7bf161$export$15ddd5fd0edb3555);
$parcel$export(module.exports, "_attachShadow", () => $875f34aecc7bf161$export$4afda0764643aba3);
var $875f34aecc7bf161$var$getProp = function(name) {
    return function(doctype) {
        return doctype[name];
    };
};
const $875f34aecc7bf161$export$3c44083a252eeb14 = $875f34aecc7bf161$var$getProp("namespaceURI");
const $875f34aecc7bf161$export$6ae22f6d74087c1a = $875f34aecc7bf161$var$getProp("prefix");
const $875f34aecc7bf161$export$cbef64f03c7768af = $875f34aecc7bf161$var$getProp("localName");
const $875f34aecc7bf161$export$45e0b80f1e500bd4 = $875f34aecc7bf161$var$getProp("tagName");
function $875f34aecc7bf161$export$d560c7e4a29451c2(node) {
    return function() {
        return node.id;
    };
}
function $875f34aecc7bf161$export$5fd54ffb744fa241(id) {
    return function(node) {
        return function() {
            node.id = id;
        };
    };
}
function $875f34aecc7bf161$export$2913c0c0b5623090(node) {
    return function() {
        return node.className;
    };
}
function $875f34aecc7bf161$export$11c615ce16f87241(element) {
    return function() {
        return element.classList;
    };
}
function $875f34aecc7bf161$export$826e926e0c74f2b8(className) {
    return function(node) {
        return function() {
            node.className = className;
        };
    };
}
function $875f34aecc7bf161$export$af941c3c7c3b40f5(localName) {
    return function(doc) {
        return function() {
            return doc.getElementsByTagName(localName);
        };
    };
}
function $875f34aecc7bf161$export$83374683e5723893(ns) {
    return function(localName) {
        return function(doc) {
            return function() {
                return doc.getElementsByTagNameNS(ns, localName);
            };
        };
    };
}
function $875f34aecc7bf161$export$764e2797d3aa1cff(classNames) {
    return function(doc) {
        return function() {
            return doc.getElementsByClassName(classNames);
        };
    };
}
function $875f34aecc7bf161$export$9fec4d97f1922e0b(name) {
    return function(value) {
        return function(element) {
            return function() {
                element.setAttribute(name, value);
            };
        };
    };
}
function $875f34aecc7bf161$export$2dc9d886be7724ad(name) {
    return function(element) {
        return function() {
            return element.getAttribute(name);
        };
    };
}
function $875f34aecc7bf161$export$7895096fcdde5712(name) {
    return function(element) {
        return function() {
            return element.hasAttribute(name);
        };
    };
}
function $875f34aecc7bf161$export$6399f3bb52316b2c(name) {
    return function(element) {
        return function() {
            element.removeAttribute(name);
        };
    };
}
function $875f34aecc7bf161$export$de994efd351b291c(selector) {
    return function(element) {
        return function() {
            return element.matches(selector);
        };
    };
}
function $875f34aecc7bf161$export$15ddd5fd0edb3555(selector) {
    return function(element) {
        return function() {
            return element.closest(selector);
        };
    };
}
function $875f34aecc7bf161$export$3e0c8fa3b5e4b3b9(node) {
    return function() {
        return node.scrollTop;
    };
}
function $875f34aecc7bf161$export$38a81aac5c9c320d(scrollTop) {
    return function(node) {
        return function() {
            node.scrollTop = scrollTop;
        };
    };
}
function $875f34aecc7bf161$export$6eddf9bc7f2b7d80(node) {
    return function() {
        return node.scrollLeft;
    };
}
function $875f34aecc7bf161$export$ed5fd5ffe5ab0ac(scrollLeft) {
    return function(node) {
        return function() {
            node.scrollLeft = scrollLeft;
        };
    };
}
function $875f34aecc7bf161$export$dc81048565b75a98(el) {
    return function() {
        return el.scrollWidth;
    };
}
function $875f34aecc7bf161$export$5a0845c0f7cb1511(el) {
    return function() {
        return el.scrollHeight;
    };
}
function $875f34aecc7bf161$export$b570871c7d022cff(el) {
    return function() {
        return el.clientTop;
    };
}
function $875f34aecc7bf161$export$6af8701396d90b51(el) {
    return function() {
        return el.clientLeft;
    };
}
function $875f34aecc7bf161$export$f451d61d633bfdbe(el) {
    return function() {
        return el.clientWidth;
    };
}
function $875f34aecc7bf161$export$1ceecc078aa19b72(el) {
    return function() {
        return el.clientHeight;
    };
}
function $875f34aecc7bf161$export$84fe60b31769e95f(el) {
    return function() {
        var rect = el.getBoundingClientRect();
        return {
            top: rect.top,
            right: rect.right,
            bottom: rect.bottom,
            left: rect.left,
            width: rect.width,
            height: rect.height,
            x: rect.x,
            y: rect.y
        };
    };
}
function $875f34aecc7bf161$export$4afda0764643aba3(props) {
    return function(el) {
        return function() {
            return el.attachShadow(props);
        };
    };
}

});

parcelRegister("bmTaV", function(module, exports) {
// Generated by purs version 0.15.16

});

parcelRegister("ai79w", function(module, exports) {

$parcel$export(module.exports, "querySelector", () => $77e12228cc269e35$export$78fb49a702cc1f2);
// Generated by purs version 0.15.16

var $21RJx = parcelRequire("21RJx");

var $4MBcA = parcelRequire("4MBcA");

var $l0wDR = parcelRequire("l0wDR");

var $T79xE = parcelRequire("T79xE");

var $d0PPW = parcelRequire("d0PPW");

var $9hRVP = parcelRequire("9hRVP");
var $77e12228cc269e35$var$map = /* #__PURE__ */ $l0wDR.map($9hRVP.functorEffect);
var $77e12228cc269e35$export$fe9de06a57e74a75 = function(x) {
    return x;
};
var $77e12228cc269e35$export$78fb49a702cc1f2 = function(qs) {
    var $2 = $77e12228cc269e35$var$map($T79xE.toMaybe);
    var $3 = $21RJx._querySelector(qs);
    return function($4) {
        return $2($3($4));
    };
};
var $77e12228cc269e35$export$52785ae9e93eaaf8 = $d0PPW.ordString;
var $77e12228cc269e35$export$ed55255aef9f10db = {
    Coercible0: function() {
        return undefined;
    }
};
var $77e12228cc269e35$export$80cfcf47c97f2a3 = /* #__PURE__ */ function() {
    var $5 = $77e12228cc269e35$var$map($T79xE.toMaybe);
    return function($6) {
        return $5($21RJx._lastElementChild($6));
    };
}();
var $77e12228cc269e35$export$ef511da7c0e45881 = /* #__PURE__ */ function() {
    var $7 = $77e12228cc269e35$var$map($T79xE.toMaybe);
    return function($8) {
        return $7($21RJx._firstElementChild($8));
    };
}();
var $77e12228cc269e35$export$d5769763ca9e4d49 = $4MBcA.eqString;

});
parcelRegister("21RJx", function(module, exports) {

$parcel$export(module.exports, "_firstElementChild", () => $17a55b211df71f15$export$52f4bb9f897f1dda);
$parcel$export(module.exports, "_lastElementChild", () => $17a55b211df71f15$export$b58800d9b8f19191);
$parcel$export(module.exports, "_querySelector", () => $17a55b211df71f15$export$242934abc2863db9);
var $17a55b211df71f15$var$getEffProp = function(name) {
    return function(node) {
        return function() {
            return node[name];
        };
    };
};
const $17a55b211df71f15$export$bacb5cc5a11aef16 = $17a55b211df71f15$var$getEffProp("children");
const $17a55b211df71f15$export$52f4bb9f897f1dda = $17a55b211df71f15$var$getEffProp("firstElementChild");
const $17a55b211df71f15$export$b58800d9b8f19191 = $17a55b211df71f15$var$getEffProp("lastElementChild");
const $17a55b211df71f15$export$f89766fb54dff747 = $17a55b211df71f15$var$getEffProp("childElementCount");
function $17a55b211df71f15$export$242934abc2863db9(selector) {
    return function(node) {
        return function() {
            return node.querySelector(selector);
        };
    };
}
function $17a55b211df71f15$export$2e83b5c43fb7af7b(selector) {
    return function(node) {
        return function() {
            return node.querySelectorAll(selector);
        };
    };
}

});


parcelRegister("4rrnG", function(module, exports) {

$parcel$export(module.exports, "showShadowRootMode", () => $33beec599fea318b$export$2197b54dae41dfe4);
// Generated by purs version 0.15.16

var $ir4NV = parcelRequire("ir4NV");

var $ykHdR = parcelRequire("ykHdR");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");
var $33beec599fea318b$export$779aeef03935e9f3 = /* #__PURE__ */ function() {
    function Open() {}
    Open.value = new Open();
    return Open;
}();
var $33beec599fea318b$export$b6448e3d47beddf0 = /* #__PURE__ */ function() {
    function Closed() {}
    Closed.value = new Closed();
    return Closed;
}();
var $33beec599fea318b$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $33beec599fea318b$export$2197b54dae41dfe4 = {
    show: function(v) {
        if (v instanceof $33beec599fea318b$export$779aeef03935e9f3) return "open";
        if (v instanceof $33beec599fea318b$export$b6448e3d47beddf0) return "closed";
        throw new Error("Failed pattern match at Web.DOM.ShadowRoot (line 22, column 1 - line 24, column 25): " + [
            v.constructor.name
        ]);
    }
};
var $33beec599fea318b$export$549ff81930776885 = /* #__PURE__ */ function() {
    var modeFromString = function(v) {
        if (v === "open") return new $ykHdR.Just($33beec599fea318b$export$779aeef03935e9f3.value);
        if (v === "closed") return new $ykHdR.Just($33beec599fea318b$export$b6448e3d47beddf0.value);
        return $ykHdR.Nothing.value;
    };
    return function($5) {
        return modeFromString($ir4NV._mode($5));
    };
}();

});
parcelRegister("ir4NV", function(module, exports) {

$parcel$export(module.exports, "_mode", () => $d6be799e52b0a69c$export$fe54a26f58202d85);
function $d6be799e52b0a69c$export$fe54a26f58202d85(el) {
    return el.mode;
}
function $d6be799e52b0a69c$export$5e032988b71f6158(el) {
    return function() {
        return el.host;
    };
}

});


parcelRegister("6EJMX", function(module, exports) {

$parcel$export(module.exports, "unsafeReadProtoTagged", () => $4d89ff275c04492e$export$e3dc45f84eae905c);
// Generated by purs version 0.15.16

var $9p7UW = parcelRequire("9p7UW");

var $ykHdR = parcelRequire("ykHdR");
var $4d89ff275c04492e$export$e3dc45f84eae905c = function(name) {
    return function(value) {
        return $9p7UW._unsafeReadProtoTagged($ykHdR.Nothing.value, $ykHdR.Just.create, name, value);
    };
};

});
parcelRegister("9p7UW", function(module, exports) {

$parcel$export(module.exports, "_unsafeReadProtoTagged", () => $6d8c9719a60f7848$export$5235d6e581ca586e);
function $6d8c9719a60f7848$export$5235d6e581ca586e(nothing, just, name, value) {
    if (typeof window !== "undefined") {
        var ty = window[name];
        if (ty != null && value instanceof ty) return just(value);
    }
    var obj = value;
    while(obj != null){
        var proto = Object.getPrototypeOf(obj);
        var constructorName = proto.constructor.name;
        if (constructorName === name) return just(value);
        else if (constructorName === "Object") return nothing;
        obj = proto;
    }
    return nothing;
}

});





parcelRegister("lrGyk", function(module, exports) {

$parcel$export(module.exports, "Created", () => $f9cd20a8b77a6bf5$export$f880a2f905254b02);
$parcel$export(module.exports, "Removed", () => $f9cd20a8b77a6bf5$export$bf3e0e645ed29ea3);
$parcel$export(module.exports, "Attribute", () => $f9cd20a8b77a6bf5$export$ab9c25261cd8c720);
$parcel$export(module.exports, "Property", () => $f9cd20a8b77a6bf5$export$41b04b3a73e7216d);
$parcel$export(module.exports, "Handler", () => $f9cd20a8b77a6bf5$export$a428cd33b25d5283);
$parcel$export(module.exports, "Ref", () => $f9cd20a8b77a6bf5$export$9bcc32033bdd12aa);
$parcel$export(module.exports, "propFromString", () => $f9cd20a8b77a6bf5$export$681fbf510ccdea38);
$parcel$export(module.exports, "propFromNumber", () => $f9cd20a8b77a6bf5$export$c90971b081d8b87e);
$parcel$export(module.exports, "propFromInt", () => $f9cd20a8b77a6bf5$export$e6c76fe186213c01);
$parcel$export(module.exports, "propFromBoolean", () => $f9cd20a8b77a6bf5$export$cb9950a5a4987d69);
$parcel$export(module.exports, "functorProp", () => $f9cd20a8b77a6bf5$export$537b40a6761b64a);
$parcel$export(module.exports, "buildProp", () => $f9cd20a8b77a6bf5$export$ff441cf2113a23d9);
// Generated by purs version 0.15.16

var $l0wDR = parcelRequire("l0wDR");

var $ykHdR = parcelRequire("ykHdR");
parcelRequire("T79xE");
var $49gSO = parcelRequire("49gSO");
var $T79xE = parcelRequire("T79xE");

var $9MxTl = parcelRequire("9MxTl");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");

var $cnyA5 = parcelRequire("cnyA5");
var $jFEU8 = parcelRequire("jFEU8");
parcelRequire("hiwiV");
var $gILGT = parcelRequire("gILGT");

var $gvsQn = parcelRequire("gvsQn");

var $69gPG = parcelRequire("69gPG");
parcelRequire("eO7Z3");
var $4Y58b = parcelRequire("4Y58b");
var $eO7Z3 = parcelRequire("eO7Z3");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");
parcelRequire("cehdW");
var $d7ECG = parcelRequire("d7ECG");
var $f9cd20a8b77a6bf5$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $f9cd20a8b77a6bf5$var$map = /* #__PURE__ */ $l0wDR.map($l0wDR.functorFn);
var $f9cd20a8b77a6bf5$var$map1 = /* #__PURE__ */ $l0wDR.map($ykHdR.functorMaybe);
var $f9cd20a8b77a6bf5$export$f880a2f905254b02 = /* #__PURE__ */ function() {
    function Created(value0) {
        this.value0 = value0;
    }
    Created.create = function(value0) {
        return new Created(value0);
    };
    return Created;
}();
var $f9cd20a8b77a6bf5$export$bf3e0e645ed29ea3 = /* #__PURE__ */ function() {
    function Removed(value0) {
        this.value0 = value0;
    }
    Removed.create = function(value0) {
        return new Removed(value0);
    };
    return Removed;
}();
var $f9cd20a8b77a6bf5$export$ab9c25261cd8c720 = /* #__PURE__ */ function() {
    function Attribute(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    Attribute.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new Attribute(value0, value1, value2);
            };
        };
    };
    return Attribute;
}();
var $f9cd20a8b77a6bf5$export$41b04b3a73e7216d = /* #__PURE__ */ function() {
    function Property(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Property.create = function(value0) {
        return function(value1) {
            return new Property(value0, value1);
        };
    };
    return Property;
}();
var $f9cd20a8b77a6bf5$export$a428cd33b25d5283 = /* #__PURE__ */ function() {
    function Handler(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Handler.create = function(value0) {
        return function(value1) {
            return new Handler(value0, value1);
        };
    };
    return Handler;
}();
var $f9cd20a8b77a6bf5$export$9bcc32033bdd12aa = /* #__PURE__ */ function() {
    function Ref(value0) {
        this.value0 = value0;
    }
    Ref.create = function(value0) {
        return new Ref(value0);
    };
    return Ref;
}();
var $f9cd20a8b77a6bf5$var$unsafeGetProperty = $4Y58b.unsafeGetAny;
var $f9cd20a8b77a6bf5$var$setProperty = $4Y58b.unsafeSetAny;
var $f9cd20a8b77a6bf5$var$removeProperty = function(key, el) {
    var v = $4Y58b.hasAttribute($49gSO.null, key, el);
    if (v) return $4Y58b.removeAttribute($49gSO.null, key, el);
    var v1 = $gILGT.typeOf($4Y58b.unsafeGetAny(key, el));
    if (v1 === "string") return $4Y58b.unsafeSetAny(key, "", el);
    if (key === "rowSpan") return $4Y58b.unsafeSetAny(key, 1, el);
    if (key === "colSpan") return $4Y58b.unsafeSetAny(key, 1, el);
    return $4Y58b.unsafeSetAny(key, $4Y58b.jsUndefined, el);
};
var $f9cd20a8b77a6bf5$var$propToStrKey = function(v) {
    if (v instanceof $f9cd20a8b77a6bf5$export$ab9c25261cd8c720 && v.value0 instanceof $ykHdR.Just) return "attr/" + (v.value0.value0 + (":" + v.value1));
    if (v instanceof $f9cd20a8b77a6bf5$export$ab9c25261cd8c720) return "attr/:" + v.value1;
    if (v instanceof $f9cd20a8b77a6bf5$export$41b04b3a73e7216d) return "prop/" + v.value0;
    if (v instanceof $f9cd20a8b77a6bf5$export$a428cd33b25d5283) return "handler/" + v.value0;
    if (v instanceof $f9cd20a8b77a6bf5$export$9bcc32033bdd12aa) return "ref";
    throw new Error("Failed pattern match at Halogen.VDom.DOM.Prop (line 182, column 16 - line 187, column 16): " + [
        v.constructor.name
    ]);
};
var $f9cd20a8b77a6bf5$export$681fbf510ccdea38 = $eOrGk.unsafeCoerce;
var $f9cd20a8b77a6bf5$export$c90971b081d8b87e = $eOrGk.unsafeCoerce;
var $f9cd20a8b77a6bf5$export$e6c76fe186213c01 = $eOrGk.unsafeCoerce;
var $f9cd20a8b77a6bf5$export$cb9950a5a4987d69 = $eOrGk.unsafeCoerce;
var $f9cd20a8b77a6bf5$export$537b40a6761b64a = {
    map: function(v) {
        return function(v1) {
            if (v1 instanceof $f9cd20a8b77a6bf5$export$a428cd33b25d5283) return new $f9cd20a8b77a6bf5$export$a428cd33b25d5283(v1.value0, $f9cd20a8b77a6bf5$var$map($f9cd20a8b77a6bf5$var$map1(v))(v1.value1));
            if (v1 instanceof $f9cd20a8b77a6bf5$export$9bcc32033bdd12aa) return new $f9cd20a8b77a6bf5$export$9bcc32033bdd12aa($f9cd20a8b77a6bf5$var$map($f9cd20a8b77a6bf5$var$map1(v))(v1.value0));
            return v1;
        };
    }
};
var $f9cd20a8b77a6bf5$export$14e000ba7a516325 = {
    map: function(v) {
        return function(v1) {
            if (v1 instanceof $f9cd20a8b77a6bf5$export$f880a2f905254b02) return new $f9cd20a8b77a6bf5$export$f880a2f905254b02(v(v1.value0));
            if (v1 instanceof $f9cd20a8b77a6bf5$export$bf3e0e645ed29ea3) return new $f9cd20a8b77a6bf5$export$bf3e0e645ed29ea3(v(v1.value0));
            throw new Error("Failed pattern match at Halogen.VDom.DOM.Prop (line 49, column 1 - line 51, column 36): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    }
};
var $f9cd20a8b77a6bf5$export$ff441cf2113a23d9 = function(emit) {
    return function(el) {
        var removeProp = function(prevEvents) {
            return function(v, v1) {
                if (v1 instanceof $f9cd20a8b77a6bf5$export$ab9c25261cd8c720) return $4Y58b.removeAttribute($T79xE.toNullable(v1.value0), v1.value1, el);
                if (v1 instanceof $f9cd20a8b77a6bf5$export$41b04b3a73e7216d) return $f9cd20a8b77a6bf5$var$removeProperty(v1.value0, el);
                if (v1 instanceof $f9cd20a8b77a6bf5$export$a428cd33b25d5283) {
                    var handler = $eO7Z3.unsafeLookup(v1.value0, prevEvents);
                    return $4Y58b.removeEventListener(v1.value0, $9MxTl.fst(handler), el);
                }
                if (v1 instanceof $f9cd20a8b77a6bf5$export$9bcc32033bdd12aa) return $r2HHk.unit;
                throw new Error("Failed pattern match at Halogen.VDom.DOM.Prop (line 169, column 5 - line 179, column 18): " + [
                    v1.constructor.name
                ]);
            };
        };
        var mbEmit = function(v) {
            if (v instanceof $ykHdR.Just) return emit(v.value0)();
            return $r2HHk.unit;
        };
        var haltProp = function(state) {
            var v = $gvsQn.lookup("ref")(state.props);
            if (v instanceof $ykHdR.Just && v.value0 instanceof $f9cd20a8b77a6bf5$export$9bcc32033bdd12aa) return mbEmit(v.value0.value0(new $f9cd20a8b77a6bf5$export$bf3e0e645ed29ea3(el)));
            return $r2HHk.unit;
        };
        var diffProp = function(prevEvents, events) {
            return function(v, v1, v11, v2) {
                if (v11 instanceof $f9cd20a8b77a6bf5$export$ab9c25261cd8c720 && v2 instanceof $f9cd20a8b77a6bf5$export$ab9c25261cd8c720) {
                    var $66 = v11.value2 === v2.value2;
                    if ($66) return v2;
                    $4Y58b.setAttribute($T79xE.toNullable(v2.value0), v2.value1, v2.value2, el);
                    return v2;
                }
                if (v11 instanceof $f9cd20a8b77a6bf5$export$41b04b3a73e7216d && v2 instanceof $f9cd20a8b77a6bf5$export$41b04b3a73e7216d) {
                    var v4 = $4Y58b.refEq(v11.value1, v2.value1);
                    if (v4) return v2;
                    if (v2.value0 === "value") {
                        var elVal = $f9cd20a8b77a6bf5$var$unsafeGetProperty("value", el);
                        var $75 = $4Y58b.refEq(elVal, v2.value1);
                        if ($75) return v2;
                        $f9cd20a8b77a6bf5$var$setProperty(v2.value0, v2.value1, el);
                        return v2;
                    }
                    $f9cd20a8b77a6bf5$var$setProperty(v2.value0, v2.value1, el);
                    return v2;
                }
                if (v11 instanceof $f9cd20a8b77a6bf5$export$a428cd33b25d5283 && v2 instanceof $f9cd20a8b77a6bf5$export$a428cd33b25d5283) {
                    var handler = $eO7Z3.unsafeLookup(v2.value0, prevEvents);
                    $jFEU8.write(v2.value1)($9MxTl.snd(handler))();
                    $eO7Z3.pokeMutMap(v2.value0, handler, events);
                    return v2;
                }
                return v2;
            };
        };
        var applyProp = function(events) {
            return function(v, v1, v2) {
                if (v2 instanceof $f9cd20a8b77a6bf5$export$ab9c25261cd8c720) {
                    $4Y58b.setAttribute($T79xE.toNullable(v2.value0), v2.value1, v2.value2, el);
                    return v2;
                }
                if (v2 instanceof $f9cd20a8b77a6bf5$export$41b04b3a73e7216d) {
                    $f9cd20a8b77a6bf5$var$setProperty(v2.value0, v2.value1, el);
                    return v2;
                }
                if (v2 instanceof $f9cd20a8b77a6bf5$export$a428cd33b25d5283) {
                    var v3 = $4Y58b.unsafeGetAny(v2.value0, events);
                    if ($4Y58b.unsafeHasAny(v2.value0, events)) {
                        $jFEU8.write(v2.value1)($9MxTl.snd(v3))();
                        return v2;
                    }
                    var ref = $cnyA5.new(v2.value1)();
                    var listener = $d7ECG.eventListener(function(ev) {
                        return function __do() {
                            var f$prime = $jFEU8.read(ref)();
                            return mbEmit(f$prime(ev));
                        };
                    })();
                    $eO7Z3.pokeMutMap(v2.value0, new $9MxTl.Tuple(listener, ref), events);
                    $4Y58b.addEventListener(v2.value0, listener, el);
                    return v2;
                }
                if (v2 instanceof $f9cd20a8b77a6bf5$export$9bcc32033bdd12aa) {
                    mbEmit(v2.value0(new $f9cd20a8b77a6bf5$export$f880a2f905254b02(el)));
                    return v2;
                }
                throw new Error("Failed pattern match at Halogen.VDom.DOM.Prop (line 113, column 5 - line 135, column 15): " + [
                    v2.constructor.name
                ]);
            };
        };
        var $lazy_patchProp = $f9cd20a8b77a6bf5$var$$runtime_lazy("patchProp", "Halogen.VDom.DOM.Prop", function() {
            return function(state, ps2) {
                var events = $eO7Z3.newMutMap();
                var onThis = removeProp(state.events);
                var onThese = diffProp(state.events, events);
                var onThat = applyProp(events);
                var props = $4Y58b.diffWithKeyAndIxE(state.props, ps2, $f9cd20a8b77a6bf5$var$propToStrKey, onThese, onThis, onThat);
                var nextState = {
                    events: $eO7Z3.unsafeFreeze(events),
                    props: props
                };
                return $69gPG.mkStep(new $69gPG.Step($r2HHk.unit, nextState, $lazy_patchProp(100), haltProp));
            };
        });
        var patchProp = $lazy_patchProp(87);
        var renderProp = function(ps1) {
            var events = $eO7Z3.newMutMap();
            var ps1$prime = $4Y58b.strMapWithIxE(ps1, $f9cd20a8b77a6bf5$var$propToStrKey, applyProp(events));
            var state = {
                events: $eO7Z3.unsafeFreeze(events),
                props: ps1$prime
            };
            return $69gPG.mkStep(new $69gPG.Step($r2HHk.unit, state, patchProp, haltProp));
        };
        return renderProp;
    };
};

});
parcelRegister("hiwiV", function(module, exports) {

$parcel$export(module.exports, "TypeMismatch", () => $c97d2d0f578f81ad$export$168e2d3b16829a);
$parcel$export(module.exports, "ErrorAtIndex", () => $c97d2d0f578f81ad$export$20d9a5af040a79f1);
$parcel$export(module.exports, "ErrorAtProperty", () => $c97d2d0f578f81ad$export$92e5795aa905bd26);
$parcel$export(module.exports, "unsafeToForeign", () => $c97d2d0f578f81ad$export$9d82982d31d9d171);
$parcel$export(module.exports, "fail", () => $c97d2d0f578f81ad$export$2b62a06a9fee979c);
$parcel$export(module.exports, "readBoolean", () => $c97d2d0f578f81ad$export$f9a84177eae95ed5);
$parcel$export(module.exports, "readInt", () => $c97d2d0f578f81ad$export$ac3747cb00139c63);
$parcel$export(module.exports, "readString", () => $c97d2d0f578f81ad$export$dda73877cb166cd3);
$parcel$export(module.exports, "typeOf", () => (parcelRequire("gILGT")).typeOf);
$parcel$export(module.exports, "isNull", () => (parcelRequire("gILGT")).isNull);
$parcel$export(module.exports, "isUndefined", () => (parcelRequire("gILGT")).isUndefined);
// Generated by purs version 0.15.16

var $gILGT = parcelRequire("gILGT");

var $gUTA8 = parcelRequire("gUTA8");

var $84kZf = parcelRequire("84kZf");

var $i2F6a = parcelRequire("i2F6a");

var $6UHO6 = parcelRequire("6UHO6");

var $aKY4H = parcelRequire("aKY4H");

var $4MBcA = parcelRequire("4MBcA");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");

var $c8kPS = parcelRequire("c8kPS");

var $fZM3T = parcelRequire("fZM3T");

var $ykHdR = parcelRequire("ykHdR");

var $d0PPW = parcelRequire("d0PPW");

var $6SDUu = parcelRequire("6SDUu");

var $3Orkn = parcelRequire("3Orkn");

var $2gT7Y = parcelRequire("2gT7Y");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");
var $c97d2d0f578f81ad$var$show = /* #__PURE__ */ $3Orkn.show($3Orkn.showString);
var $c97d2d0f578f81ad$var$show1 = /* #__PURE__ */ $3Orkn.show($3Orkn.showInt);
var $c97d2d0f578f81ad$var$pure = /* #__PURE__ */ $gUTA8.pure($aKY4H.applicativeEither);
var $c97d2d0f578f81ad$var$compare = /* #__PURE__ */ $d0PPW.compare($d0PPW.ordString);
var $c97d2d0f578f81ad$var$compare1 = /* #__PURE__ */ $d0PPW.compare($d0PPW.ordInt);
var $c97d2d0f578f81ad$export$f6a37cc43a8b8898 = /* #__PURE__ */ function() {
    function ForeignError(value0) {
        this.value0 = value0;
    }
    ForeignError.create = function(value0) {
        return new ForeignError(value0);
    };
    return ForeignError;
}();
var $c97d2d0f578f81ad$export$168e2d3b16829a = /* #__PURE__ */ function() {
    function TypeMismatch(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    TypeMismatch.create = function(value0) {
        return function(value1) {
            return new TypeMismatch(value0, value1);
        };
    };
    return TypeMismatch;
}();
var $c97d2d0f578f81ad$export$20d9a5af040a79f1 = /* #__PURE__ */ function() {
    function ErrorAtIndex(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    ErrorAtIndex.create = function(value0) {
        return function(value1) {
            return new ErrorAtIndex(value0, value1);
        };
    };
    return ErrorAtIndex;
}();
var $c97d2d0f578f81ad$export$92e5795aa905bd26 = /* #__PURE__ */ function() {
    function ErrorAtProperty(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    ErrorAtProperty.create = function(value0) {
        return function(value1) {
            return new ErrorAtProperty(value0, value1);
        };
    };
    return ErrorAtProperty;
}();
var $c97d2d0f578f81ad$export$9d82982d31d9d171 = $eOrGk.unsafeCoerce;
var $c97d2d0f578f81ad$export$19df04dfac508e15 = $eOrGk.unsafeCoerce;
var $c97d2d0f578f81ad$export$ca110433ecb89bbf = {
    show: function(v) {
        if (v instanceof $c97d2d0f578f81ad$export$f6a37cc43a8b8898) return "(ForeignError " + ($c97d2d0f578f81ad$var$show(v.value0) + ")");
        if (v instanceof $c97d2d0f578f81ad$export$20d9a5af040a79f1) return "(ErrorAtIndex " + ($c97d2d0f578f81ad$var$show1(v.value0) + (" " + ($3Orkn.show($c97d2d0f578f81ad$export$ca110433ecb89bbf)(v.value1) + ")")));
        if (v instanceof $c97d2d0f578f81ad$export$92e5795aa905bd26) return "(ErrorAtProperty " + ($c97d2d0f578f81ad$var$show(v.value0) + (" " + ($3Orkn.show($c97d2d0f578f81ad$export$ca110433ecb89bbf)(v.value1) + ")")));
        if (v instanceof $c97d2d0f578f81ad$export$168e2d3b16829a) return "(TypeMismatch " + ($c97d2d0f578f81ad$var$show(v.value0) + (" " + ($c97d2d0f578f81ad$var$show(v.value1) + ")")));
        throw new Error("Failed pattern match at Foreign (line 69, column 1 - line 73, column 89): " + [
            v.constructor.name
        ]);
    }
};
var $c97d2d0f578f81ad$export$a2293656e769bd56 = function(v) {
    if (v instanceof $c97d2d0f578f81ad$export$f6a37cc43a8b8898) return v.value0;
    if (v instanceof $c97d2d0f578f81ad$export$20d9a5af040a79f1) return "Error at array index " + ($c97d2d0f578f81ad$var$show1(v.value0) + (": " + $c97d2d0f578f81ad$export$a2293656e769bd56(v.value1)));
    if (v instanceof $c97d2d0f578f81ad$export$92e5795aa905bd26) return "Error at property " + ($c97d2d0f578f81ad$var$show(v.value0) + (": " + $c97d2d0f578f81ad$export$a2293656e769bd56(v.value1)));
    if (v instanceof $c97d2d0f578f81ad$export$168e2d3b16829a) return "Type mismatch: expected " + (v.value0 + (", found " + v.value1));
    throw new Error("Failed pattern match at Foreign (line 78, column 1 - line 78, column 45): " + [
        v.constructor.name
    ]);
};
var $c97d2d0f578f81ad$export$4e0f52105ee4b19b = function(dictMonad) {
    var pure1 = $gUTA8.pure($i2F6a.applicativeExceptT(dictMonad));
    return function(value) {
        if ($gILGT.isUndefined(value)) return pure1($ykHdR.Nothing.value);
        if ($6UHO6.otherwise) return pure1(new $ykHdR.Just(value));
        throw new Error("Failed pattern match at Foreign (line 174, column 1 - line 174, column 103): " + [
            value.constructor.name
        ]);
    };
};
var $c97d2d0f578f81ad$export$a540325489296c24 = function(dictMonad) {
    var pure1 = $gUTA8.pure($i2F6a.applicativeExceptT(dictMonad));
    return function(value) {
        if ($gILGT.isNull(value) || $gILGT.isUndefined(value)) return pure1($ykHdR.Nothing.value);
        if ($6UHO6.otherwise) return pure1(new $ykHdR.Just(value));
        throw new Error("Failed pattern match at Foreign (line 179, column 1 - line 179, column 109): " + [
            value.constructor.name
        ]);
    };
};
var $c97d2d0f578f81ad$export$62e87727fba30d8d = function(dictMonad) {
    var pure1 = $gUTA8.pure($i2F6a.applicativeExceptT(dictMonad));
    return function(value) {
        if ($gILGT.isNull(value)) return pure1($ykHdR.Nothing.value);
        if ($6UHO6.otherwise) return pure1(new $ykHdR.Just(value));
        throw new Error("Failed pattern match at Foreign (line 169, column 1 - line 169, column 98): " + [
            value.constructor.name
        ]);
    };
};
var $c97d2d0f578f81ad$export$2b62a06a9fee979c = function(dictMonad) {
    var $153 = $84kZf.throwError($i2F6a.monadThrowExceptT(dictMonad));
    return function($154) {
        return $153($fZM3T.singleton($154));
    };
};
var $c97d2d0f578f81ad$export$d3f4ca0e55363719 = function(dictMonad) {
    var pure1 = $gUTA8.pure($i2F6a.applicativeExceptT(dictMonad));
    var fail1 = $c97d2d0f578f81ad$export$2b62a06a9fee979c(dictMonad);
    return function(value) {
        if ($gILGT.isArray(value)) return pure1($c97d2d0f578f81ad$export$19df04dfac508e15(value));
        if ($6UHO6.otherwise) return fail1(new $c97d2d0f578f81ad$export$168e2d3b16829a("array", $gILGT.tagOf(value)));
        throw new Error("Failed pattern match at Foreign (line 164, column 1 - line 164, column 99): " + [
            value.constructor.name
        ]);
    };
};
var $c97d2d0f578f81ad$export$6190f2182377b437 = function(dictMonad) {
    var pure1 = $gUTA8.pure($i2F6a.applicativeExceptT(dictMonad));
    var fail1 = $c97d2d0f578f81ad$export$2b62a06a9fee979c(dictMonad);
    return function(tag) {
        return function(value) {
            if ($gILGT.tagOf(value) === tag) return pure1($c97d2d0f578f81ad$export$19df04dfac508e15(value));
            if ($6UHO6.otherwise) return fail1(new $c97d2d0f578f81ad$export$168e2d3b16829a(tag, $gILGT.tagOf(value)));
            throw new Error("Failed pattern match at Foreign (line 123, column 1 - line 123, column 104): " + [
                tag.constructor.name,
                value.constructor.name
            ]);
        };
    };
};
var $c97d2d0f578f81ad$export$f9a84177eae95ed5 = function(dictMonad) {
    return $c97d2d0f578f81ad$export$6190f2182377b437(dictMonad)("Boolean");
};
var $c97d2d0f578f81ad$export$347fd215c36b10be = function(dictMonad) {
    return $c97d2d0f578f81ad$export$6190f2182377b437(dictMonad)("Number");
};
var $c97d2d0f578f81ad$export$ac3747cb00139c63 = function(dictMonad) {
    var map = $l0wDR.map(dictMonad.Bind1().Apply0().Functor0());
    var readNumber1 = $c97d2d0f578f81ad$export$347fd215c36b10be(dictMonad);
    return function(value) {
        var error = new $aKY4H.Left($fZM3T.singleton(new $c97d2d0f578f81ad$export$168e2d3b16829a("Int", $gILGT.tagOf(value))));
        var fromNumber = function() {
            var $155 = $ykHdR.maybe(error)($c97d2d0f578f81ad$var$pure);
            return function($156) {
                return $155($c8kPS.fromNumber($156));
            };
        }();
        return $i2F6a.mapExceptT(map($aKY4H.either($l4M7e.const(error))(fromNumber)))(readNumber1(value));
    };
};
var $c97d2d0f578f81ad$export$dda73877cb166cd3 = function(dictMonad) {
    return $c97d2d0f578f81ad$export$6190f2182377b437(dictMonad)("String");
};
var $c97d2d0f578f81ad$export$85b98eeba3f0a3b4 = function(dictMonad) {
    var map = $l0wDR.map(dictMonad.Bind1().Apply0().Functor0());
    var readString1 = $c97d2d0f578f81ad$export$dda73877cb166cd3(dictMonad);
    return function(value) {
        var error = new $aKY4H.Left($fZM3T.singleton(new $c97d2d0f578f81ad$export$168e2d3b16829a("Char", $gILGT.tagOf(value))));
        var fromString = function() {
            var $157 = $ykHdR.maybe(error)($c97d2d0f578f81ad$var$pure);
            return function($158) {
                return $157($2gT7Y.toChar($158));
            };
        }();
        return $i2F6a.mapExceptT(map($aKY4H.either($l4M7e.const(error))(fromString)))(readString1(value));
    };
};
var $c97d2d0f578f81ad$export$29dc7ef345289543 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $c97d2d0f578f81ad$export$f6a37cc43a8b8898 && y instanceof $c97d2d0f578f81ad$export$f6a37cc43a8b8898) return x.value0 === y.value0;
            if (x instanceof $c97d2d0f578f81ad$export$168e2d3b16829a && y instanceof $c97d2d0f578f81ad$export$168e2d3b16829a) return x.value0 === y.value0 && x.value1 === y.value1;
            if (x instanceof $c97d2d0f578f81ad$export$20d9a5af040a79f1 && y instanceof $c97d2d0f578f81ad$export$20d9a5af040a79f1) return x.value0 === y.value0 && $4MBcA.eq($c97d2d0f578f81ad$export$29dc7ef345289543)(x.value1)(y.value1);
            if (x instanceof $c97d2d0f578f81ad$export$92e5795aa905bd26 && y instanceof $c97d2d0f578f81ad$export$92e5795aa905bd26) return x.value0 === y.value0 && $4MBcA.eq($c97d2d0f578f81ad$export$29dc7ef345289543)(x.value1)(y.value1);
            return false;
        };
    }
};
var $c97d2d0f578f81ad$export$661e78eef4f027af = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $c97d2d0f578f81ad$export$f6a37cc43a8b8898 && y instanceof $c97d2d0f578f81ad$export$f6a37cc43a8b8898) return $c97d2d0f578f81ad$var$compare(x.value0)(y.value0);
            if (x instanceof $c97d2d0f578f81ad$export$f6a37cc43a8b8898) return $6SDUu.LT.value;
            if (y instanceof $c97d2d0f578f81ad$export$f6a37cc43a8b8898) return $6SDUu.GT.value;
            if (x instanceof $c97d2d0f578f81ad$export$168e2d3b16829a && y instanceof $c97d2d0f578f81ad$export$168e2d3b16829a) {
                var v = $c97d2d0f578f81ad$var$compare(x.value0)(y.value0);
                if (v instanceof $6SDUu.LT) return $6SDUu.LT.value;
                if (v instanceof $6SDUu.GT) return $6SDUu.GT.value;
                return $c97d2d0f578f81ad$var$compare(x.value1)(y.value1);
            }
            if (x instanceof $c97d2d0f578f81ad$export$168e2d3b16829a) return $6SDUu.LT.value;
            if (y instanceof $c97d2d0f578f81ad$export$168e2d3b16829a) return $6SDUu.GT.value;
            if (x instanceof $c97d2d0f578f81ad$export$20d9a5af040a79f1 && y instanceof $c97d2d0f578f81ad$export$20d9a5af040a79f1) {
                var v = $c97d2d0f578f81ad$var$compare1(x.value0)(y.value0);
                if (v instanceof $6SDUu.LT) return $6SDUu.LT.value;
                if (v instanceof $6SDUu.GT) return $6SDUu.GT.value;
                return $d0PPW.compare($c97d2d0f578f81ad$export$661e78eef4f027af)(x.value1)(y.value1);
            }
            if (x instanceof $c97d2d0f578f81ad$export$20d9a5af040a79f1) return $6SDUu.LT.value;
            if (y instanceof $c97d2d0f578f81ad$export$20d9a5af040a79f1) return $6SDUu.GT.value;
            if (x instanceof $c97d2d0f578f81ad$export$92e5795aa905bd26 && y instanceof $c97d2d0f578f81ad$export$92e5795aa905bd26) {
                var v = $c97d2d0f578f81ad$var$compare(x.value0)(y.value0);
                if (v instanceof $6SDUu.LT) return $6SDUu.LT.value;
                if (v instanceof $6SDUu.GT) return $6SDUu.GT.value;
                return $d0PPW.compare($c97d2d0f578f81ad$export$661e78eef4f027af)(x.value1)(y.value1);
            }
            throw new Error("Failed pattern match at Foreign (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $c97d2d0f578f81ad$export$29dc7ef345289543;
    }
};

});
parcelRegister("gILGT", function(module, exports) {

$parcel$export(module.exports, "typeOf", () => $c2c5bfcfd98ddabb$export$f5bbd400c2f4426f);
$parcel$export(module.exports, "tagOf", () => $c2c5bfcfd98ddabb$export$348caad1e8d41c5f);
$parcel$export(module.exports, "isNull", () => $c2c5bfcfd98ddabb$export$630801d484da15df);
$parcel$export(module.exports, "isUndefined", () => $c2c5bfcfd98ddabb$export$fce6876652108ab);
$parcel$export(module.exports, "isArray", () => $c2c5bfcfd98ddabb$export$43bee75e5e14138e);
function $c2c5bfcfd98ddabb$export$f5bbd400c2f4426f(value) {
    return typeof value;
}
function $c2c5bfcfd98ddabb$export$348caad1e8d41c5f(value) {
    return Object.prototype.toString.call(value).slice(8, -1);
}
function $c2c5bfcfd98ddabb$export$630801d484da15df(value) {
    return value === null;
}
function $c2c5bfcfd98ddabb$export$fce6876652108ab(value) {
    return value === undefined;
}
const $c2c5bfcfd98ddabb$export$43bee75e5e14138e = Array.isArray || function(value) {
    return Object.prototype.toString.call(value) === "[object Array]";
};

});

parcelRegister("c8kPS", function(module, exports) {

$parcel$export(module.exports, "odd", () => $8d5664f12212b23e$export$74b48c691cc42eb1);
$parcel$export(module.exports, "hexadecimal", () => $8d5664f12212b23e$export$9c12a48020146abe);
$parcel$export(module.exports, "fromString", () => $8d5664f12212b23e$export$3004f64547af360e);
$parcel$export(module.exports, "fromNumber", () => $8d5664f12212b23e$export$7bbb4164c9a77bc2);
$parcel$export(module.exports, "trunc", () => $8d5664f12212b23e$export$1fe87bd59b089f0);
$parcel$export(module.exports, "floor", () => $8d5664f12212b23e$export$a3fe094919f356fd);
$parcel$export(module.exports, "toNumber", () => (parcelRequire("6pI6x")).toNumber);
$parcel$export(module.exports, "toStringAs", () => (parcelRequire("6pI6x")).toStringAs);
$parcel$export(module.exports, "quot", () => (parcelRequire("6pI6x")).quot);
// Generated by purs version 0.15.16

var $6pI6x = parcelRequire("6pI6x");

var $7T8P4 = parcelRequire("7T8P4");

var $6UHO6 = parcelRequire("6UHO6");

var $95fRU = parcelRequire("95fRU");

var $4MBcA = parcelRequire("4MBcA");

var $ykHdR = parcelRequire("ykHdR");
parcelRequire("rzgQX");
var $deaB6 = parcelRequire("deaB6");

var $6SDUu = parcelRequire("6SDUu");

var $gyPYh = parcelRequire("gyPYh");
var $8d5664f12212b23e$var$top = /* #__PURE__ */ $95fRU.top($95fRU.boundedInt);
var $8d5664f12212b23e$var$bottom = /* #__PURE__ */ $95fRU.bottom($95fRU.boundedInt);
var $8d5664f12212b23e$var$Radix = function(x) {
    return x;
};
var $8d5664f12212b23e$export$33ca3b017f2e3089 = /* #__PURE__ */ function() {
    function Even() {}
    Even.value = new Even();
    return Even;
}();
var $8d5664f12212b23e$export$6bbc73627dceae86 = /* #__PURE__ */ function() {
    function Odd() {}
    Odd.value = new Odd();
    return Odd;
}();
var $8d5664f12212b23e$export$9f422d81718beff7 = {
    show: function(v) {
        if (v instanceof $8d5664f12212b23e$export$33ca3b017f2e3089) return "Even";
        if (v instanceof $8d5664f12212b23e$export$6bbc73627dceae86) return "Odd";
        throw new Error("Failed pattern match at Data.Int (line 117, column 1 - line 119, column 19): " + [
            v.constructor.name
        ]);
    }
};
var $8d5664f12212b23e$export$1db3e511bfb04803 = function(n) {
    if (n >= 2 && n <= 36) return new $ykHdR.Just(n);
    if ($6UHO6.otherwise) return $ykHdR.Nothing.value;
    throw new Error("Failed pattern match at Data.Int (line 198, column 1 - line 198, column 28): " + [
        n.constructor.name
    ]);
};
var $8d5664f12212b23e$export$74b48c691cc42eb1 = function(x) {
    return (x & 1) !== 0;
};
var $8d5664f12212b23e$export$90d8fbb029b06afc = 8;
var $8d5664f12212b23e$export$9c12a48020146abe = 16;
var $8d5664f12212b23e$export$d7a050b0311540b9 = /* #__PURE__ */ function() {
    return $6pI6x.fromStringAsImpl($ykHdR.Just.create)($ykHdR.Nothing.value);
}();
var $8d5664f12212b23e$export$3004f64547af360e = /* #__PURE__ */ $8d5664f12212b23e$export$d7a050b0311540b9(10);
var $8d5664f12212b23e$export$7bbb4164c9a77bc2 = /* #__PURE__ */ function() {
    return $6pI6x.fromNumberImpl($ykHdR.Just.create)($ykHdR.Nothing.value);
}();
var $8d5664f12212b23e$var$unsafeClamp = function(x) {
    if (!$deaB6.isFinite(x)) return 0;
    if (x >= $6pI6x.toNumber($8d5664f12212b23e$var$top)) return $8d5664f12212b23e$var$top;
    if (x <= $6pI6x.toNumber($8d5664f12212b23e$var$bottom)) return $8d5664f12212b23e$var$bottom;
    if ($6UHO6.otherwise) return $ykHdR.fromMaybe(0)($8d5664f12212b23e$export$7bbb4164c9a77bc2(x));
    throw new Error("Failed pattern match at Data.Int (line 72, column 1 - line 72, column 29): " + [
        x.constructor.name
    ]);
};
var $8d5664f12212b23e$export$2077e0241d6afd3c = function($37) {
    return $8d5664f12212b23e$var$unsafeClamp($deaB6.round($37));
};
var $8d5664f12212b23e$export$1fe87bd59b089f0 = function($38) {
    return $8d5664f12212b23e$var$unsafeClamp($deaB6.trunc($38));
};
var $8d5664f12212b23e$export$a3fe094919f356fd = function($39) {
    return $8d5664f12212b23e$var$unsafeClamp($deaB6.floor($39));
};
var $8d5664f12212b23e$export$df5fefc55a4eba3c = function(x) {
    return (x & 1) === 0;
};
var $8d5664f12212b23e$export$efe353078db02e10 = function(n) {
    var $28 = $8d5664f12212b23e$export$df5fefc55a4eba3c(n);
    if ($28) return $8d5664f12212b23e$export$33ca3b017f2e3089.value;
    return $8d5664f12212b23e$export$6bbc73627dceae86.value;
};
var $8d5664f12212b23e$export$8424267183f54e9d = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $8d5664f12212b23e$export$33ca3b017f2e3089 && y instanceof $8d5664f12212b23e$export$33ca3b017f2e3089) return true;
            if (x instanceof $8d5664f12212b23e$export$6bbc73627dceae86 && y instanceof $8d5664f12212b23e$export$6bbc73627dceae86) return true;
            return false;
        };
    }
};
var $8d5664f12212b23e$var$eq1 = /* #__PURE__ */ $4MBcA.eq($8d5664f12212b23e$export$8424267183f54e9d);
var $8d5664f12212b23e$export$8b12bf30fdd3264f = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $8d5664f12212b23e$export$33ca3b017f2e3089 && y instanceof $8d5664f12212b23e$export$33ca3b017f2e3089) return $6SDUu.EQ.value;
            if (x instanceof $8d5664f12212b23e$export$33ca3b017f2e3089) return $6SDUu.LT.value;
            if (y instanceof $8d5664f12212b23e$export$33ca3b017f2e3089) return $6SDUu.GT.value;
            if (x instanceof $8d5664f12212b23e$export$6bbc73627dceae86 && y instanceof $8d5664f12212b23e$export$6bbc73627dceae86) return $6SDUu.EQ.value;
            throw new Error("Failed pattern match at Data.Int (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $8d5664f12212b23e$export$8424267183f54e9d;
    }
};
var $8d5664f12212b23e$export$39d55cbe74216cbe = /* #__PURE__ */ function() {
    return {
        zero: $8d5664f12212b23e$export$33ca3b017f2e3089.value,
        add: function(x) {
            return function(y) {
                var $33 = $8d5664f12212b23e$var$eq1(x)(y);
                if ($33) return $8d5664f12212b23e$export$33ca3b017f2e3089.value;
                return $8d5664f12212b23e$export$6bbc73627dceae86.value;
            };
        },
        one: $8d5664f12212b23e$export$6bbc73627dceae86.value,
        mul: function(v) {
            return function(v1) {
                if (v instanceof $8d5664f12212b23e$export$6bbc73627dceae86 && v1 instanceof $8d5664f12212b23e$export$6bbc73627dceae86) return $8d5664f12212b23e$export$6bbc73627dceae86.value;
                return $8d5664f12212b23e$export$33ca3b017f2e3089.value;
            };
        }
    };
}();
var $8d5664f12212b23e$export$e741c28ebd8a3552 = {
    sub: /* #__PURE__ */ $gyPYh.add($8d5664f12212b23e$export$39d55cbe74216cbe),
    Semiring0: function() {
        return $8d5664f12212b23e$export$39d55cbe74216cbe;
    }
};
var $8d5664f12212b23e$export$5bd06fe87b344eef = {
    recip: /* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn),
    Ring0: function() {
        return $8d5664f12212b23e$export$e741c28ebd8a3552;
    }
};
var $8d5664f12212b23e$export$78a48a3d1e5dbe89 = 10;
var $8d5664f12212b23e$export$cf50720682a32a87 = {
    Ring0: function() {
        return $8d5664f12212b23e$export$e741c28ebd8a3552;
    }
};
var $8d5664f12212b23e$export$965db879d0c14bc1 = {
    degree: function(v) {
        if (v instanceof $8d5664f12212b23e$export$33ca3b017f2e3089) return 0;
        if (v instanceof $8d5664f12212b23e$export$6bbc73627dceae86) return 1;
        throw new Error("Failed pattern match at Data.Int (line 137, column 1 - line 141, column 17): " + [
            v.constructor.name
        ]);
    },
    div: function(x) {
        return function(v) {
            return x;
        };
    },
    mod: function(v) {
        return function(v1) {
            return $8d5664f12212b23e$export$33ca3b017f2e3089.value;
        };
    },
    CommutativeRing0: function() {
        return $8d5664f12212b23e$export$cf50720682a32a87;
    }
};
var $8d5664f12212b23e$export$803ce6b71a0a94b2 = function($40) {
    return $8d5664f12212b23e$var$unsafeClamp($deaB6.ceil($40));
};
var $8d5664f12212b23e$export$fc5d11f6ca2bf4fc = /* #__PURE__ */ function() {
    return {
        bottom: $8d5664f12212b23e$export$33ca3b017f2e3089.value,
        top: $8d5664f12212b23e$export$6bbc73627dceae86.value,
        Ord0: function() {
            return $8d5664f12212b23e$export$8b12bf30fdd3264f;
        }
    };
}();
var $8d5664f12212b23e$export$33902b7329277358 = 2;
var $8d5664f12212b23e$export$95b61e7c39ae893a = 36;

});
parcelRegister("6pI6x", function(module, exports) {

$parcel$export(module.exports, "fromNumberImpl", () => $4ab74a20512cef04$export$5b3229f64c38e483);
$parcel$export(module.exports, "toNumber", () => $4ab74a20512cef04$export$a0a81dc3380ce7d3);
$parcel$export(module.exports, "fromStringAsImpl", () => $4ab74a20512cef04$export$221b4f162df9878c);
$parcel$export(module.exports, "toStringAs", () => $4ab74a20512cef04$export$f601457c5ee3082f);
$parcel$export(module.exports, "quot", () => $4ab74a20512cef04$export$dcbbe75d5a67af21);
const $4ab74a20512cef04$export$5b3229f64c38e483 = function(just) {
    return function(nothing) {
        return function(n) {
            /* jshint bitwise: false */ return (n | 0) === n ? just(n) : nothing;
        };
    };
};
const $4ab74a20512cef04$export$a0a81dc3380ce7d3 = function(n) {
    return n;
};
const $4ab74a20512cef04$export$221b4f162df9878c = function(just) {
    return function(nothing) {
        return function(radix) {
            var digits;
            if (radix < 11) digits = "[0-" + (radix - 1).toString() + "]";
            else if (radix === 11) digits = "[0-9a]";
            else digits = "[0-9a-" + String.fromCharCode(86 + radix) + "]";
            var pattern = new RegExp("^[\\+\\-]?" + digits + "+$", "i");
            return function(s) {
                /* jshint bitwise: false */ if (pattern.test(s)) {
                    var i = parseInt(s, radix);
                    return (i | 0) === i ? just(i) : nothing;
                } else return nothing;
            };
        };
    };
};
const $4ab74a20512cef04$export$f601457c5ee3082f = function(radix) {
    return function(i) {
        return i.toString(radix);
    };
};
const $4ab74a20512cef04$export$dcbbe75d5a67af21 = function(x) {
    return function(y) {
        /* jshint bitwise: false */ return x / y | 0;
    };
};
const $4ab74a20512cef04$export$fb1897a40d146f7f = function(x) {
    return function(y) {
        return x % y;
    };
};
const $4ab74a20512cef04$export$9c297f60e22e3389 = function(x) {
    return function(y) {
        /* jshint bitwise: false */ return Math.pow(x, y) | 0;
    };
};

});

parcelRegister("rzgQX", function(module, exports) {

$parcel$export(module.exports, "fromString", () => $052de1c85deb22bf$export$3004f64547af360e);
$parcel$export(module.exports, "nan", () => (parcelRequire("deaB6")).nan);
$parcel$export(module.exports, "infinity", () => (parcelRequire("deaB6")).infinity);
$parcel$export(module.exports, "isFinite", () => (parcelRequire("deaB6")).isFinite);
$parcel$export(module.exports, "ceil", () => (parcelRequire("deaB6")).ceil);
$parcel$export(module.exports, "floor", () => (parcelRequire("deaB6")).floor);
$parcel$export(module.exports, "pow", () => (parcelRequire("deaB6")).pow);
$parcel$export(module.exports, "remainder", () => (parcelRequire("deaB6")).remainder);
$parcel$export(module.exports, "round", () => (parcelRequire("deaB6")).round);
$parcel$export(module.exports, "sqrt", () => (parcelRequire("deaB6")).sqrt);
$parcel$export(module.exports, "trunc", () => (parcelRequire("deaB6")).trunc);
// Generated by purs version 0.15.16

var $deaB6 = parcelRequire("deaB6");

var $ykHdR = parcelRequire("ykHdR");
var $052de1c85deb22bf$export$a4b4b4d4d776fe92 = 6.283185307179586;
var $052de1c85deb22bf$export$2fa35f36c870f3b7 = 1.4142135623730951;
var $052de1c85deb22bf$export$9eaf1e6179158e34 = 0.7071067811865476;
var $052de1c85deb22bf$export$18c7bea995a110f = 3.141592653589793;
var $052de1c85deb22bf$export$4d03748825f009b9 = 1.4426950408889634;
var $052de1c85deb22bf$export$4ca92b5d1d793bd5 = 0.4342944819032518;
var $052de1c85deb22bf$export$27692bafabcf0fdc = 0.6931471805599453;
var $052de1c85deb22bf$export$e1abf6863d05a89e = 2.302585092994046;
var $052de1c85deb22bf$export$3004f64547af360e = function(str) {
    return $deaB6.fromStringImpl(str, $deaB6.isFinite, $ykHdR.Just.create, $ykHdR.Nothing.value);
};
var $052de1c85deb22bf$export$f1e1789686576879 = 2.718281828459045;

});
parcelRegister("deaB6", function(module, exports) {

$parcel$export(module.exports, "nan", () => $9a14cd925227149d$export$9e06de0973666692);
$parcel$export(module.exports, "infinity", () => $9a14cd925227149d$export$a0978488bc4efbee);
$parcel$export(module.exports, "isFinite", () => $9a14cd925227149d$export$65f0b13f2f82375a);
$parcel$export(module.exports, "fromStringImpl", () => $9a14cd925227149d$export$3ffe08ccbe76f69e);
$parcel$export(module.exports, "ceil", () => $9a14cd925227149d$export$803ce6b71a0a94b2);
$parcel$export(module.exports, "floor", () => $9a14cd925227149d$export$a3fe094919f356fd);
$parcel$export(module.exports, "pow", () => $9a14cd925227149d$export$9c297f60e22e3389);
$parcel$export(module.exports, "remainder", () => $9a14cd925227149d$export$159037f780d3415c);
$parcel$export(module.exports, "round", () => $9a14cd925227149d$export$2077e0241d6afd3c);
$parcel$export(module.exports, "sqrt", () => $9a14cd925227149d$export$eba8049fb5020b81);
$parcel$export(module.exports, "trunc", () => $9a14cd925227149d$export$1fe87bd59b089f0);
/* globals exports */ const $9a14cd925227149d$export$9e06de0973666692 = NaN;
const $9a14cd925227149d$export$c9f5652083b8129d = isNaN;
const $9a14cd925227149d$export$a0978488bc4efbee = Infinity;
const $9a14cd925227149d$export$65f0b13f2f82375a = isFinite;
function $9a14cd925227149d$export$3ffe08ccbe76f69e(str, isFinite1, just, nothing) {
    var num = parseFloat(str);
    if (isFinite1(num)) return just(num);
    else return nothing;
}
const $9a14cd925227149d$export$2335f513bbd82c6d = Math.abs;
const $9a14cd925227149d$export$fd6306be3fde5b04 = Math.acos;
const $9a14cd925227149d$export$41726bdb1fc63f = Math.asin;
const $9a14cd925227149d$export$628dc4eed22b0fbd = Math.atan;
const $9a14cd925227149d$export$b8b770ee6a0d9760 = function(y) {
    return function(x) {
        return Math.atan2(y, x);
    };
};
const $9a14cd925227149d$export$803ce6b71a0a94b2 = Math.ceil;
const $9a14cd925227149d$export$50d414a77b60d802 = Math.cos;
const $9a14cd925227149d$export$b310ec824aaee37f = Math.exp;
const $9a14cd925227149d$export$a3fe094919f356fd = Math.floor;
const $9a14cd925227149d$export$bef1f36f5486a6a3 = Math.log;
const $9a14cd925227149d$export$8960430cfd85939f = function(n1) {
    return function(n2) {
        return Math.max(n1, n2);
    };
};
const $9a14cd925227149d$export$96ec731ed4dcb222 = function(n1) {
    return function(n2) {
        return Math.min(n1, n2);
    };
};
const $9a14cd925227149d$export$9c297f60e22e3389 = function(n) {
    return function(p) {
        return Math.pow(n, p);
    };
};
const $9a14cd925227149d$export$159037f780d3415c = function(n) {
    return function(m) {
        return n % m;
    };
};
const $9a14cd925227149d$export$2077e0241d6afd3c = Math.round;
const $9a14cd925227149d$export$c5552dfdbc7cec71 = Math.sign ? Math.sign : function(x) {
    return x === 0 || x !== x ? x : x < 0 ? -1 : 1;
};
const $9a14cd925227149d$export$5de3937cb4b592ed = Math.sin;
const $9a14cd925227149d$export$eba8049fb5020b81 = Math.sqrt;
const $9a14cd925227149d$export$fcdd3b0b3246a325 = Math.tan;
const $9a14cd925227149d$export$1fe87bd59b089f0 = Math.trunc ? Math.trunc : function(x) {
    return x < 0 ? Math.ceil(x) : Math.floor(x);
};

});



parcelRegister("fZM3T", function(module, exports) {

$parcel$export(module.exports, "toList", () => $ba51d599f79a6310$export$effcdbd76139450);
$parcel$export(module.exports, "singleton", () => $ba51d599f79a6310$export$439306a4dcaafbb9);
$parcel$export(module.exports, "cons$prime", () => $ba51d599f79a6310$export$cc3b5f3f66225fbe);
$parcel$export(module.exports, "cons", () => $ba51d599f79a6310$export$8327ebbef2a0ba76);
// Generated by purs version 0.15.16

var $9Grh5 = parcelRequire("9Grh5");

var $7T8P4 = parcelRequire("7T8P4");

var $6UHO6 = parcelRequire("6UHO6");

var $4MBcA = parcelRequire("4MBcA");

var $6RkEA = parcelRequire("6RkEA");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");

var $5gmr2 = parcelRequire("5gmr2");

var $amUgg = parcelRequire("amUgg");

var $ykHdR = parcelRequire("ykHdR");

var $2FBb2 = parcelRequire("2FBb2");

var $d0PPW = parcelRequire("d0PPW");

var $iwqgS = parcelRequire("iwqgS");

var $IFMV2 = parcelRequire("IFMV2");

var $jERGJ = parcelRequire("jERGJ");

var $1wR1l = parcelRequire("1wR1l");

var $9MxTl = parcelRequire("9MxTl");

var $hsyEi = parcelRequire("hsyEi");

var $c0aRt = parcelRequire("c0aRt");
var $ba51d599f79a6310$var$sequence1 = /* #__PURE__ */ $jERGJ.sequence1($amUgg.traversable1NonEmptyList);
var $ba51d599f79a6310$var$map = /* #__PURE__ */ $l0wDR.map($ykHdR.functorMaybe);
var $ba51d599f79a6310$var$map1 = /* #__PURE__ */ $l0wDR.map($amUgg.functorNonEmptyList);
var $ba51d599f79a6310$var$bind = /* #__PURE__ */ $9Grh5.bind($amUgg.bindNonEmptyList);
var $ba51d599f79a6310$var$identity = /* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn);
var $ba51d599f79a6310$var$append1 = /* #__PURE__ */ $iwqgS.append($amUgg.semigroupList);
var $ba51d599f79a6310$export$b634740ce272acb5 = function(f) {
    return function(v) {
        return function(v1) {
            return new $2FBb2.NonEmpty(f(v.value0)(v1.value0), $5gmr2.zipWith(f)(v.value1)(v1.value1));
        };
    };
};
var $ba51d599f79a6310$export$e00c1e5c5a2b1ad7 = function(dictApplicative) {
    var sequence11 = $ba51d599f79a6310$var$sequence1(dictApplicative.Apply0());
    return function(f) {
        return function(xs) {
            return function(ys) {
                return sequence11($ba51d599f79a6310$export$b634740ce272acb5(f)(xs)(ys));
            };
        };
    };
};
var $ba51d599f79a6310$export$8901015135f2fb22 = /* #__PURE__ */ function() {
    return $ba51d599f79a6310$export$b634740ce272acb5($9MxTl.Tuple.create);
}();
var $ba51d599f79a6310$var$wrappedOperation2 = function(name) {
    return function(f) {
        return function(v) {
            return function(v1) {
                var v2 = f(new $amUgg.Cons(v.value0, v.value1))(new $amUgg.Cons(v1.value0, v1.value1));
                if (v2 instanceof $amUgg.Cons) return new $2FBb2.NonEmpty(v2.value0, v2.value1);
                if (v2 instanceof $amUgg.Nil) return $c0aRt.unsafeCrashWith("Impossible: empty list in NonEmptyList " + name);
                throw new Error("Failed pattern match at Data.List.NonEmpty (line 105, column 3 - line 107, column 81): " + [
                    v2.constructor.name
                ]);
            };
        };
    };
};
var $ba51d599f79a6310$var$wrappedOperation = function(name) {
    return function(f) {
        return function(v) {
            var v1 = f(new $amUgg.Cons(v.value0, v.value1));
            if (v1 instanceof $amUgg.Cons) return new $2FBb2.NonEmpty(v1.value0, v1.value1);
            if (v1 instanceof $amUgg.Nil) return $c0aRt.unsafeCrashWith("Impossible: empty list in NonEmptyList " + name);
            throw new Error("Failed pattern match at Data.List.NonEmpty (line 92, column 3 - line 94, column 81): " + [
                v1.constructor.name
            ]);
        };
    };
};
var $ba51d599f79a6310$export$b6d8713d53419d4c = function(i) {
    return function(a) {
        return function(v) {
            if (i === 0) return new $ykHdR.Just(new $2FBb2.NonEmpty(a, v.value1));
            if ($6UHO6.otherwise) return $ba51d599f79a6310$var$map(function($193) {
                return $amUgg.NonEmptyList(function(v1) {
                    return new $2FBb2.NonEmpty(v.value0, v1);
                }($193));
            })($5gmr2.updateAt(i - 1 | 0)(a)(v.value1));
            throw new Error("Failed pattern match at Data.List.NonEmpty (line 198, column 1 - line 198, column 75): " + [
                i.constructor.name,
                a.constructor.name,
                v.constructor.name
            ]);
        };
    };
};
var $ba51d599f79a6310$export$23c8d3f8757cab88 = function(ts) {
    return new $9MxTl.Tuple($ba51d599f79a6310$var$map1($9MxTl.fst)(ts), $ba51d599f79a6310$var$map1($9MxTl.snd)(ts));
};
var $ba51d599f79a6310$export$712962e076096ed4 = function(v) {
    var v1 = $5gmr2.unsnoc(v.value1);
    if (v1 instanceof $ykHdR.Nothing) return {
        init: $amUgg.Nil.value,
        last: v.value0
    };
    if (v1 instanceof $ykHdR.Just) return {
        init: new $amUgg.Cons(v.value0, v1.value0.init),
        last: v1.value0.last
    };
    throw new Error("Failed pattern match at Data.List.NonEmpty (line 160, column 35 - line 162, column 50): " + [
        v1.constructor.name
    ]);
};
var $ba51d599f79a6310$export$ef1d06dc4d91d507 = /* #__PURE__ */ function() {
    var $194 = $ba51d599f79a6310$var$wrappedOperation2("unionBy");
    return function($195) {
        return $194($5gmr2.unionBy($195));
    };
}();
var $ba51d599f79a6310$export$971dd5b0dfd021b6 = function(dictEq) {
    return $ba51d599f79a6310$var$wrappedOperation2("union")($5gmr2.union(dictEq));
};
var $ba51d599f79a6310$export$b446f6baa3bb1430 = function(v) {
    return {
        head: v.value0,
        tail: v.value1
    };
};
var $ba51d599f79a6310$export$effcdbd76139450 = function(v) {
    return new $amUgg.Cons(v.value0, v.value1);
};
var $ba51d599f79a6310$export$823be24f8766da23 = function(dictUnfoldable) {
    var $196 = $hsyEi.unfoldr(dictUnfoldable)(function(xs) {
        return $ba51d599f79a6310$var$map(function(rec) {
            return new $9MxTl.Tuple(rec.head, rec.tail);
        })($5gmr2.uncons(xs));
    });
    return function($197) {
        return $196($ba51d599f79a6310$export$effcdbd76139450($197));
    };
};
var $ba51d599f79a6310$export$c01875f616615628 = function(v) {
    return v.value1;
};
var $ba51d599f79a6310$export$b035e44d7bb4278f = /* #__PURE__ */ function() {
    var $198 = $ba51d599f79a6310$var$wrappedOperation("sortBy");
    return function($199) {
        return $198($5gmr2.sortBy($199));
    };
}();
var $ba51d599f79a6310$export$97db5808d8f88186 = function(dictOrd) {
    var compare = $d0PPW.compare(dictOrd);
    return function(xs) {
        return $ba51d599f79a6310$export$b035e44d7bb4278f(compare)(xs);
    };
};
var $ba51d599f79a6310$export$c40cf5aab899f397 = function(v) {
    return function(y) {
        return new $2FBb2.NonEmpty(v.value0, $5gmr2.snoc(v.value1)(y));
    };
};
var $ba51d599f79a6310$export$439306a4dcaafbb9 = /* #__PURE__ */ function() {
    var $200 = $2FBb2.singleton($amUgg.plusList);
    return function($201) {
        return $amUgg.NonEmptyList($200($201));
    };
}();
var $ba51d599f79a6310$export$5b6d1d165591a48c = function(v) {
    return function(v1) {
        if (v instanceof $amUgg.Cons) return new $2FBb2.NonEmpty(v.value0, $5gmr2.snoc(v.value1)(v1));
        if (v instanceof $amUgg.Nil) return $ba51d599f79a6310$export$439306a4dcaafbb9(v1);
        throw new Error("Failed pattern match at Data.List.NonEmpty (line 140, column 1 - line 140, column 51): " + [
            v.constructor.name,
            v1.constructor.name
        ]);
    };
};
var $ba51d599f79a6310$export$66c1ae025e96b4bc = /* #__PURE__ */ $ba51d599f79a6310$var$wrappedOperation("reverse")($5gmr2.reverse);
var $ba51d599f79a6310$export$edce5881c815871 = function(dictEq) {
    return $ba51d599f79a6310$var$wrappedOperation("nubEq")($5gmr2.nubEq(dictEq));
};
var $ba51d599f79a6310$export$45273896c792ff3b = /* #__PURE__ */ function() {
    var $202 = $ba51d599f79a6310$var$wrappedOperation("nubByEq");
    return function($203) {
        return $202($5gmr2.nubByEq($203));
    };
}();
var $ba51d599f79a6310$export$18f77a3bafa759b9 = /* #__PURE__ */ function() {
    var $204 = $ba51d599f79a6310$var$wrappedOperation("nubBy");
    return function($205) {
        return $204($5gmr2.nubBy($205));
    };
}();
var $ba51d599f79a6310$export$94f4066a75b10404 = function(dictOrd) {
    return $ba51d599f79a6310$var$wrappedOperation("nub")($5gmr2.nub(dictOrd));
};
var $ba51d599f79a6310$export$cba09f9e3d3e58eb = function(i) {
    return function(f) {
        return function(v) {
            if (i === 0) return new $ykHdR.Just(new $2FBb2.NonEmpty(f(v.value0), v.value1));
            if ($6UHO6.otherwise) return $ba51d599f79a6310$var$map(function($206) {
                return $amUgg.NonEmptyList(function(v1) {
                    return new $2FBb2.NonEmpty(v.value0, v1);
                }($206));
            })($5gmr2.modifyAt(i - 1 | 0)(f)(v.value1));
            throw new Error("Failed pattern match at Data.List.NonEmpty (line 203, column 1 - line 203, column 82): " + [
                i.constructor.name,
                f.constructor.name,
                v.constructor.name
            ]);
        };
    };
};
var $ba51d599f79a6310$var$lift = function(f) {
    return function(v) {
        return f(new $amUgg.Cons(v.value0, v.value1));
    };
};
var $ba51d599f79a6310$export$e70771d2e7e590a = function($207) {
    return $ba51d599f79a6310$var$lift($5gmr2.mapMaybe($207));
};
var $ba51d599f79a6310$export$b29f828819edca8d = function($208) {
    return $ba51d599f79a6310$var$lift($5gmr2.partition($208));
};
var $ba51d599f79a6310$export$afc1bfabebaf28a2 = function($209) {
    return $ba51d599f79a6310$var$lift($5gmr2.span($209));
};
var $ba51d599f79a6310$export$b7df5d561049483a = function($210) {
    return $ba51d599f79a6310$var$lift($5gmr2.take($210));
};
var $ba51d599f79a6310$export$9384c7afe4015e42 = function($211) {
    return $ba51d599f79a6310$var$lift($5gmr2.takeWhile($211));
};
var $ba51d599f79a6310$export$f24224f1c91d8156 = function(v) {
    return 1 + $5gmr2.length(v.value1) | 0;
};
var $ba51d599f79a6310$export$4c7897fafd92b108 = function(v) {
    return $ykHdR.fromMaybe(v.value0)($5gmr2.last(v.value1));
};
var $ba51d599f79a6310$export$f161f39e9c06ab2d = /* #__PURE__ */ function() {
    var $212 = $ba51d599f79a6310$var$wrappedOperation2("intersectBy");
    return function($213) {
        return $212($5gmr2.intersectBy($213));
    };
}();
var $ba51d599f79a6310$export$1f4807a235930d45 = function(dictEq) {
    return $ba51d599f79a6310$var$wrappedOperation2("intersect")($5gmr2.intersect(dictEq));
};
var $ba51d599f79a6310$export$9f200c4466975173 = function(i) {
    return function(a) {
        return function(v) {
            if (i === 0) return new $ykHdR.Just(new $2FBb2.NonEmpty(a, new $amUgg.Cons(v.value0, v.value1)));
            if ($6UHO6.otherwise) return $ba51d599f79a6310$var$map(function($214) {
                return $amUgg.NonEmptyList(function(v1) {
                    return new $2FBb2.NonEmpty(v.value0, v1);
                }($214));
            })($5gmr2.insertAt(i - 1 | 0)(a)(v.value1));
            throw new Error("Failed pattern match at Data.List.NonEmpty (line 193, column 1 - line 193, column 75): " + [
                i.constructor.name,
                a.constructor.name,
                v.constructor.name
            ]);
        };
    };
};
var $ba51d599f79a6310$export$2cd8252107eb640b = function(v) {
    return $ykHdR.maybe($amUgg.Nil.value)(function(v1) {
        return new $amUgg.Cons(v.value0, v1);
    })($5gmr2.init(v.value1));
};
var $ba51d599f79a6310$export$b610b8812bbcded9 = function(v) {
    return function(i) {
        if (i === 0) return new $ykHdR.Just(v.value0);
        if ($6UHO6.otherwise) return $5gmr2.index(v.value1)(i - 1 | 0);
        throw new Error("Failed pattern match at Data.List.NonEmpty (line 167, column 1 - line 167, column 52): " + [
            v.constructor.name,
            i.constructor.name
        ]);
    };
};
var $ba51d599f79a6310$export$5fd5031fecdacec3 = function(v) {
    return v.value0;
};
var $ba51d599f79a6310$export$3f063810d7bf01bd = /* #__PURE__ */ function() {
    var $215 = $ba51d599f79a6310$var$wrappedOperation("groupBy");
    return function($216) {
        return $215($5gmr2.groupBy($216));
    };
}();
var $ba51d599f79a6310$export$1f7a5bf12caafbd = /* #__PURE__ */ function() {
    var $217 = $ba51d599f79a6310$var$wrappedOperation("groupAllBy");
    return function($218) {
        return $217($5gmr2.groupAllBy($218));
    };
}();
var $ba51d599f79a6310$export$361434b95a7d965 = function(dictOrd) {
    return $ba51d599f79a6310$var$wrappedOperation("groupAll")($5gmr2.groupAll(dictOrd));
};
var $ba51d599f79a6310$export$e5e25fbcc1f7affe = function(dictEq) {
    return $ba51d599f79a6310$var$wrappedOperation("group")($5gmr2.group(dictEq));
};
var $ba51d599f79a6310$export$88e0dae599377b39 = function(v) {
    if (v instanceof $amUgg.Nil) return $ykHdR.Nothing.value;
    if (v instanceof $amUgg.Cons) return new $ykHdR.Just(new $2FBb2.NonEmpty(v.value0, v.value1));
    throw new Error("Failed pattern match at Data.List.NonEmpty (line 121, column 1 - line 121, column 57): " + [
        v.constructor.name
    ]);
};
var $ba51d599f79a6310$export$b7d5d9bb9ff52072 = function(dictFoldable) {
    var $219 = $5gmr2.fromFoldable(dictFoldable);
    return function($220) {
        return $ba51d599f79a6310$export$88e0dae599377b39($219($220));
    };
};
var $ba51d599f79a6310$export$7a067f9280ad8af0 = function(dictMonad) {
    var bind1 = $9Grh5.bind(dictMonad.Bind1());
    var foldM1 = $5gmr2.foldM(dictMonad);
    return function(f) {
        return function(b) {
            return function(v) {
                return bind1(f(b)(v.value0))(function(b$prime) {
                    return foldM1(f)(b$prime)(v.value1);
                });
            };
        };
    };
};
var $ba51d599f79a6310$export$8855a8be7bd3e9f8 = function(f) {
    return function(v) {
        var v1 = $5gmr2.findLastIndex(f)(v.value1);
        if (v1 instanceof $ykHdR.Just) return new $ykHdR.Just(v1.value0 + 1 | 0);
        if (v1 instanceof $ykHdR.Nothing) {
            if (f(v.value0)) return new $ykHdR.Just(0);
            if ($6UHO6.otherwise) return $ykHdR.Nothing.value;
        }
        throw new Error("Failed pattern match at Data.List.NonEmpty (line 187, column 3 - line 191, column 29): " + [
            v1.constructor.name
        ]);
    };
};
var $ba51d599f79a6310$export$de3a4d4a0d731119 = function(f) {
    return function(v) {
        if (f(v.value0)) return new $ykHdR.Just(0);
        if ($6UHO6.otherwise) return $ba51d599f79a6310$var$map(function(v1) {
            return v1 + 1 | 0;
        })($5gmr2.findIndex(f)(v.value1));
        throw new Error("Failed pattern match at Data.List.NonEmpty (line 180, column 1 - line 180, column 69): " + [
            f.constructor.name,
            v.constructor.name
        ]);
    };
};
var $ba51d599f79a6310$export$20098ecb074a31e6 = function(dictMonad) {
    var $221 = $5gmr2.filterM(dictMonad);
    return function($222) {
        return $ba51d599f79a6310$var$lift($221($222));
    };
};
var $ba51d599f79a6310$export$3dea766d36a8935f = function($223) {
    return $ba51d599f79a6310$var$lift($5gmr2.filter($223));
};
var $ba51d599f79a6310$export$c19d79386f4ed99a = function(dictEq) {
    var eq1 = $4MBcA.eq(dictEq);
    return function(x) {
        return $ba51d599f79a6310$export$8855a8be7bd3e9f8(function(v) {
            return eq1(v)(x);
        });
    };
};
var $ba51d599f79a6310$export$f444781b0adb7e4d = function(dictEq) {
    var eq1 = $4MBcA.eq(dictEq);
    return function(x) {
        return $ba51d599f79a6310$export$de3a4d4a0d731119(function(v) {
            return eq1(v)(x);
        });
    };
};
var $ba51d599f79a6310$export$533af5c8cd6afa16 = function($224) {
    return $ba51d599f79a6310$var$lift($5gmr2.dropWhile($224));
};
var $ba51d599f79a6310$export$663103110d94aac9 = function($225) {
    return $ba51d599f79a6310$var$lift($5gmr2.drop($225));
};
var $ba51d599f79a6310$export$cc3b5f3f66225fbe = function(x) {
    return function(xs) {
        return new $2FBb2.NonEmpty(x, xs);
    };
};
var $ba51d599f79a6310$export$8327ebbef2a0ba76 = function(y) {
    return function(v) {
        return new $2FBb2.NonEmpty(y, new $amUgg.Cons(v.value0, v.value1));
    };
};
var $ba51d599f79a6310$export$c28c8388be0ab31a = /* #__PURE__ */ $l4M7e.flip($ba51d599f79a6310$var$bind);
var $ba51d599f79a6310$export$ee1b3e54f0441b22 = function(v) {
    return $ba51d599f79a6310$var$bind(v)($ba51d599f79a6310$var$identity);
};
var $ba51d599f79a6310$export$986c2bbe7a34be0b = /* #__PURE__ */ $ba51d599f79a6310$var$lift($5gmr2.catMaybes);
var $ba51d599f79a6310$export$89c5a0ebe497f8c7 = function(dictFoldable) {
    var fromFoldable1 = $5gmr2.fromFoldable(dictFoldable);
    return function(v) {
        return function(ys) {
            return new $2FBb2.NonEmpty(v.value0, $ba51d599f79a6310$var$append1(v.value1)(fromFoldable1(ys)));
        };
    };
};

});
parcelRegister("5gmr2", function(module, exports) {

$parcel$export(module.exports, "updateAt", () => $3d4fd987da5242ff$export$b6d8713d53419d4c);
$parcel$export(module.exports, "uncons", () => $3d4fd987da5242ff$export$b446f6baa3bb1430);
$parcel$export(module.exports, "toUnfoldable", () => $3d4fd987da5242ff$export$823be24f8766da23);
$parcel$export(module.exports, "span", () => $3d4fd987da5242ff$export$afc1bfabebaf28a2);
$parcel$export(module.exports, "snoc", () => $3d4fd987da5242ff$export$c40cf5aab899f397);
$parcel$export(module.exports, "sortBy", () => $3d4fd987da5242ff$export$b035e44d7bb4278f);
$parcel$export(module.exports, "reverse", () => $3d4fd987da5242ff$export$66c1ae025e96b4bc);
$parcel$export(module.exports, "take", () => $3d4fd987da5242ff$export$b7df5d561049483a);
$parcel$export(module.exports, "takeWhile", () => $3d4fd987da5242ff$export$9384c7afe4015e42);
$parcel$export(module.exports, "unsnoc", () => $3d4fd987da5242ff$export$712962e076096ed4);
$parcel$export(module.exports, "zipWith", () => $3d4fd987da5242ff$export$b634740ce272acb5);
$parcel$export(module.exports, "partition", () => $3d4fd987da5242ff$export$b29f828819edca8d);
$parcel$export(module.exports, "null", () => $3d4fd987da5242ff$export$7b1b591b262c240);
$parcel$export(module.exports, "nubBy", () => $3d4fd987da5242ff$export$18f77a3bafa759b9);
$parcel$export(module.exports, "nub", () => $3d4fd987da5242ff$export$94f4066a75b10404);
$parcel$export(module.exports, "mapMaybe", () => $3d4fd987da5242ff$export$e70771d2e7e590a);
$parcel$export(module.exports, "manyRec", () => $3d4fd987da5242ff$export$17771a97d85ba7eb);
$parcel$export(module.exports, "many", () => $3d4fd987da5242ff$export$14badfee79ea396f);
$parcel$export(module.exports, "length", () => $3d4fd987da5242ff$export$f24224f1c91d8156);
$parcel$export(module.exports, "last", () => $3d4fd987da5242ff$export$4c7897fafd92b108);
$parcel$export(module.exports, "insertAt", () => $3d4fd987da5242ff$export$9f200c4466975173);
$parcel$export(module.exports, "init", () => $3d4fd987da5242ff$export$2cd8252107eb640b);
$parcel$export(module.exports, "index", () => $3d4fd987da5242ff$export$b610b8812bbcded9);
$parcel$export(module.exports, "groupBy", () => $3d4fd987da5242ff$export$3f063810d7bf01bd);
$parcel$export(module.exports, "groupAllBy", () => $3d4fd987da5242ff$export$1f7a5bf12caafbd);
$parcel$export(module.exports, "group", () => $3d4fd987da5242ff$export$e5e25fbcc1f7affe);
$parcel$export(module.exports, "groupAll", () => $3d4fd987da5242ff$export$361434b95a7d965);
$parcel$export(module.exports, "fromFoldable", () => $3d4fd987da5242ff$export$b7d5d9bb9ff52072);
$parcel$export(module.exports, "foldM", () => $3d4fd987da5242ff$export$7a067f9280ad8af0);
$parcel$export(module.exports, "findIndex", () => $3d4fd987da5242ff$export$de3a4d4a0d731119);
$parcel$export(module.exports, "findLastIndex", () => $3d4fd987da5242ff$export$8855a8be7bd3e9f8);
$parcel$export(module.exports, "filterM", () => $3d4fd987da5242ff$export$20098ecb074a31e6);
$parcel$export(module.exports, "filter", () => $3d4fd987da5242ff$export$3dea766d36a8935f);
$parcel$export(module.exports, "intersectBy", () => $3d4fd987da5242ff$export$f161f39e9c06ab2d);
$parcel$export(module.exports, "intersect", () => $3d4fd987da5242ff$export$1f4807a235930d45);
$parcel$export(module.exports, "nubByEq", () => $3d4fd987da5242ff$export$45273896c792ff3b);
$parcel$export(module.exports, "nubEq", () => $3d4fd987da5242ff$export$edce5881c815871);
$parcel$export(module.exports, "dropWhile", () => $3d4fd987da5242ff$export$533af5c8cd6afa16);
$parcel$export(module.exports, "drop", () => $3d4fd987da5242ff$export$663103110d94aac9);
$parcel$export(module.exports, "unionBy", () => $3d4fd987da5242ff$export$ef1d06dc4d91d507);
$parcel$export(module.exports, "union", () => $3d4fd987da5242ff$export$971dd5b0dfd021b6);
$parcel$export(module.exports, "catMaybes", () => $3d4fd987da5242ff$export$986c2bbe7a34be0b);
$parcel$export(module.exports, "modifyAt", () => $3d4fd987da5242ff$export$cba09f9e3d3e58eb);
// Generated by purs version 0.15.16

var $a7Dxq = parcelRequire("a7Dxq");

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $9Grh5 = parcelRequire("9Grh5");

var $7T8P4 = parcelRequire("7T8P4");

var $dTFzl = parcelRequire("dTFzl");

var $lowBm = parcelRequire("lowBm");

var $2Mmje = parcelRequire("2Mmje");

var $6UHO6 = parcelRequire("6UHO6");

var $4MBcA = parcelRequire("4MBcA");

var $6RkEA = parcelRequire("6RkEA");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");

var $lnl7Y = parcelRequire("lnl7Y");

var $7YrkG = parcelRequire("7YrkG");

var $amUgg = parcelRequire("amUgg");

var $ykHdR = parcelRequire("ykHdR");

var $2FBb2 = parcelRequire("2FBb2");

var $d0PPW = parcelRequire("d0PPW");

var $6SDUu = parcelRequire("6SDUu");

var $iwqgS = parcelRequire("iwqgS");

var $3Orkn = parcelRequire("3Orkn");

var $1wR1l = parcelRequire("1wR1l");

var $9MxTl = parcelRequire("9MxTl");

var $hsyEi = parcelRequire("hsyEi");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");
var $3d4fd987da5242ff$var$map = /* #__PURE__ */ $l0wDR.map($ykHdR.functorMaybe);
var $3d4fd987da5242ff$var$foldr = /* #__PURE__ */ $6RkEA.foldr($amUgg.foldableList);
var $3d4fd987da5242ff$var$tailRecM2 = /* #__PURE__ */ $lowBm.tailRecM2($lowBm.monadRecMaybe);
var $3d4fd987da5242ff$var$eq = /* #__PURE__ */ $4MBcA.eq($6SDUu.eqOrdering);
var $3d4fd987da5242ff$var$notEq = /* #__PURE__ */ $4MBcA.notEq($6SDUu.eqOrdering);
var $3d4fd987da5242ff$var$sequence = /* #__PURE__ */ $1wR1l.sequence($amUgg.traversableList);
var $3d4fd987da5242ff$var$bimap = /* #__PURE__ */ $2Mmje.bimap($lowBm.bifunctorStep);
var $3d4fd987da5242ff$var$foldl = /* #__PURE__ */ $6RkEA.foldl($amUgg.foldableList);
var $3d4fd987da5242ff$var$any = /* #__PURE__ */ $6RkEA.any($amUgg.foldableList)($lnl7Y.heytingAlgebraBoolean);
var $3d4fd987da5242ff$var$append1 = /* #__PURE__ */ $iwqgS.append($amUgg.semigroupList);
var $3d4fd987da5242ff$var$bind = /* #__PURE__ */ $9Grh5.bind($amUgg.bindList);
var $3d4fd987da5242ff$var$identity = /* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn);
var $3d4fd987da5242ff$export$47606a6ae3eaed8e = function(x) {
    return x;
};
var $3d4fd987da5242ff$export$b6d8713d53419d4c = function(v) {
    return function(v1) {
        return function(v2) {
            if (v === 0 && v2 instanceof $amUgg.Cons) return new $ykHdR.Just(new $amUgg.Cons(v1, v2.value1));
            if (v2 instanceof $amUgg.Cons) return $3d4fd987da5242ff$var$map(function(v3) {
                return new $amUgg.Cons(v2.value0, v3);
            })($3d4fd987da5242ff$export$b6d8713d53419d4c(v - 1 | 0)(v1)(v2.value1));
            return $ykHdR.Nothing.value;
        };
    };
};
var $3d4fd987da5242ff$export$23c8d3f8757cab88 = /* #__PURE__ */ function() {
    return $3d4fd987da5242ff$var$foldr(function(v) {
        return function(v1) {
            return new $9MxTl.Tuple(new $amUgg.Cons(v.value0, v1.value0), new $amUgg.Cons(v.value1, v1.value1));
        };
    })(new $9MxTl.Tuple($amUgg.Nil.value, $amUgg.Nil.value));
}();
var $3d4fd987da5242ff$export$b446f6baa3bb1430 = function(v) {
    if (v instanceof $amUgg.Nil) return $ykHdR.Nothing.value;
    if (v instanceof $amUgg.Cons) return new $ykHdR.Just({
        head: v.value0,
        tail: v.value1
    });
    throw new Error("Failed pattern match at Data.List (line 259, column 1 - line 259, column 66): " + [
        v.constructor.name
    ]);
};
var $3d4fd987da5242ff$export$823be24f8766da23 = function(dictUnfoldable) {
    return $hsyEi.unfoldr(dictUnfoldable)(function(xs) {
        return $3d4fd987da5242ff$var$map(function(rec) {
            return new $9MxTl.Tuple(rec.head, rec.tail);
        })($3d4fd987da5242ff$export$b446f6baa3bb1430(xs));
    });
};
var $3d4fd987da5242ff$export$c01875f616615628 = function(v) {
    if (v instanceof $amUgg.Nil) return $ykHdR.Nothing.value;
    if (v instanceof $amUgg.Cons) return new $ykHdR.Just(v.value1);
    throw new Error("Failed pattern match at Data.List (line 245, column 1 - line 245, column 43): " + [
        v.constructor.name
    ]);
};
var $3d4fd987da5242ff$export$71c2a1babd78d286 = function(dictEq) {
    var eq2 = $4MBcA.eq(dictEq);
    return function(v) {
        return function(s) {
            var go = function(prefix) {
                return function(input) {
                    if (prefix instanceof $amUgg.Cons && input instanceof $amUgg.Cons && eq2(prefix.value0)(input.value0)) return new $ykHdR.Just(new $lowBm.Loop({
                        a: prefix.value1,
                        b: input.value1
                    }));
                    if (prefix instanceof $amUgg.Nil) return new $ykHdR.Just(new $lowBm.Done(input));
                    return $ykHdR.Nothing.value;
                };
            };
            return $3d4fd987da5242ff$var$tailRecM2(go)(v)(s);
        };
    };
};
var $3d4fd987da5242ff$export$afc1bfabebaf28a2 = function(v) {
    return function(v1) {
        if (v1 instanceof $amUgg.Cons && v(v1.value0)) {
            var v2 = $3d4fd987da5242ff$export$afc1bfabebaf28a2(v)(v1.value1);
            return {
                init: new $amUgg.Cons(v1.value0, v2.init),
                rest: v2.rest
            };
        }
        return {
            init: $amUgg.Nil.value,
            rest: v1
        };
    };
};
var $3d4fd987da5242ff$export$c40cf5aab899f397 = function(xs) {
    return function(x) {
        return $3d4fd987da5242ff$var$foldr($amUgg.Cons.create)(new $amUgg.Cons(x, $amUgg.Nil.value))(xs);
    };
};
var $3d4fd987da5242ff$export$439306a4dcaafbb9 = function(a) {
    return new $amUgg.Cons(a, $amUgg.Nil.value);
};
var $3d4fd987da5242ff$export$b035e44d7bb4278f = function(cmp) {
    var merge = function(v) {
        return function(v1) {
            if (v instanceof $amUgg.Cons && v1 instanceof $amUgg.Cons) {
                if ($3d4fd987da5242ff$var$eq(cmp(v.value0)(v1.value0))($6SDUu.GT.value)) return new $amUgg.Cons(v1.value0, merge(v)(v1.value1));
                if ($6UHO6.otherwise) return new $amUgg.Cons(v.value0, merge(v.value1)(v1));
            }
            if (v instanceof $amUgg.Nil) return v1;
            if (v1 instanceof $amUgg.Nil) return v;
            throw new Error("Failed pattern match at Data.List (line 466, column 3 - line 466, column 38): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    };
    var mergePairs = function(v) {
        if (v instanceof $amUgg.Cons && v.value1 instanceof $amUgg.Cons) return new $amUgg.Cons(merge(v.value0)(v.value1.value0), mergePairs(v.value1.value1));
        return v;
    };
    var mergeAll = function($copy_v) {
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v) {
            if (v instanceof $amUgg.Cons && v.value1 instanceof $amUgg.Nil) {
                $tco_done = true;
                return v.value0;
            }
            $copy_v = mergePairs(v);
            return;
        }
        while(!$tco_done)$tco_result = $tco_loop($copy_v);
        return $tco_result;
    };
    var sequences = function(v) {
        if (v instanceof $amUgg.Cons && v.value1 instanceof $amUgg.Cons) {
            if ($3d4fd987da5242ff$var$eq(cmp(v.value0)(v.value1.value0))($6SDUu.GT.value)) return descending(v.value1.value0)($3d4fd987da5242ff$export$439306a4dcaafbb9(v.value0))(v.value1.value1);
            if ($6UHO6.otherwise) return ascending(v.value1.value0)(function(v1) {
                return new $amUgg.Cons(v.value0, v1);
            })(v.value1.value1);
        }
        return $3d4fd987da5242ff$export$439306a4dcaafbb9(v);
    };
    var descending = function($copy_v) {
        return function($copy_v1) {
            return function($copy_v2) {
                var $tco_var_v = $copy_v;
                var $tco_var_v1 = $copy_v1;
                var $tco_done1 = false;
                var $tco_result;
                function $tco_loop(v, v1, v2) {
                    if (v2 instanceof $amUgg.Cons && $3d4fd987da5242ff$var$eq(cmp(v)(v2.value0))($6SDUu.GT.value)) {
                        $tco_var_v = v2.value0;
                        $tco_var_v1 = new $amUgg.Cons(v, v1);
                        $copy_v2 = v2.value1;
                        return;
                    }
                    $tco_done1 = true;
                    return new $amUgg.Cons(new $amUgg.Cons(v, v1), sequences(v2));
                }
                while(!$tco_done1)$tco_result = $tco_loop($tco_var_v, $tco_var_v1, $copy_v2);
                return $tco_result;
            };
        };
    };
    var ascending = function($copy_v) {
        return function($copy_v1) {
            return function($copy_v2) {
                var $tco_var_v = $copy_v;
                var $tco_var_v1 = $copy_v1;
                var $tco_done2 = false;
                var $tco_result;
                function $tco_loop(v, v1, v2) {
                    if (v2 instanceof $amUgg.Cons && $3d4fd987da5242ff$var$notEq(cmp(v)(v2.value0))($6SDUu.GT.value)) {
                        $tco_var_v = v2.value0;
                        $tco_var_v1 = function(ys) {
                            return v1(new $amUgg.Cons(v, ys));
                        };
                        $copy_v2 = v2.value1;
                        return;
                    }
                    $tco_done2 = true;
                    return new $amUgg.Cons(v1($3d4fd987da5242ff$export$439306a4dcaafbb9(v)), sequences(v2));
                }
                while(!$tco_done2)$tco_result = $tco_loop($tco_var_v, $tco_var_v1, $copy_v2);
                return $tco_result;
            };
        };
    };
    return function($444) {
        return mergeAll(sequences($444));
    };
};
var $3d4fd987da5242ff$export$97db5808d8f88186 = function(dictOrd) {
    var compare = $d0PPW.compare(dictOrd);
    return function(xs) {
        return $3d4fd987da5242ff$export$b035e44d7bb4278f(compare)(xs);
    };
};
var $3d4fd987da5242ff$var$tails = function(v) {
    if (v instanceof $amUgg.Nil) return $3d4fd987da5242ff$export$439306a4dcaafbb9($amUgg.Nil.value);
    if (v instanceof $amUgg.Cons) return new $amUgg.Cons(v, $3d4fd987da5242ff$var$tails(v.value1));
    throw new Error("Failed pattern match at Data.List (line 641, column 1 - line 641, column 43): " + [
        v.constructor.name
    ]);
};
var $3d4fd987da5242ff$export$b5c655b9d1f9203e = function(dictShow) {
    var show = $3Orkn.show($amUgg.showList(dictShow));
    return {
        show: function(v) {
            return "(Pattern " + (show(v) + ")");
        }
    };
};
var $3d4fd987da5242ff$export$66c1ae025e96b4bc = /* #__PURE__ */ function() {
    var go = function($copy_v) {
        return function($copy_v1) {
            var $tco_var_v = $copy_v;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v, v1) {
                if (v1 instanceof $amUgg.Nil) {
                    $tco_done = true;
                    return v;
                }
                if (v1 instanceof $amUgg.Cons) {
                    $tco_var_v = new $amUgg.Cons(v1.value0, v);
                    $copy_v1 = v1.value1;
                    return;
                }
                throw new Error("Failed pattern match at Data.List (line 368, column 3 - line 368, column 19): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
            return $tco_result;
        };
    };
    return go($amUgg.Nil.value);
}();
var $3d4fd987da5242ff$export$b7df5d561049483a = /* #__PURE__ */ function() {
    var go = function($copy_v) {
        return function($copy_v1) {
            return function($copy_v2) {
                var $tco_var_v = $copy_v;
                var $tco_var_v1 = $copy_v1;
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(v, v1, v2) {
                    if (v1 < 1) {
                        $tco_done = true;
                        return $3d4fd987da5242ff$export$66c1ae025e96b4bc(v);
                    }
                    if (v2 instanceof $amUgg.Nil) {
                        $tco_done = true;
                        return $3d4fd987da5242ff$export$66c1ae025e96b4bc(v);
                    }
                    if (v2 instanceof $amUgg.Cons) {
                        $tco_var_v = new $amUgg.Cons(v2.value0, v);
                        $tco_var_v1 = v1 - 1 | 0;
                        $copy_v2 = v2.value1;
                        return;
                    }
                    throw new Error("Failed pattern match at Data.List (line 513, column 3 - line 513, column 35): " + [
                        v.constructor.name,
                        v1.constructor.name,
                        v2.constructor.name
                    ]);
                }
                while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $tco_var_v1, $copy_v2);
                return $tco_result;
            };
        };
    };
    return go($amUgg.Nil.value);
}();
var $3d4fd987da5242ff$export$9384c7afe4015e42 = function(p) {
    var go = function($copy_v) {
        return function($copy_v1) {
            var $tco_var_v = $copy_v;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v, v1) {
                if (v1 instanceof $amUgg.Cons && p(v1.value0)) {
                    $tco_var_v = new $amUgg.Cons(v1.value0, v);
                    $copy_v1 = v1.value1;
                    return;
                }
                $tco_done = true;
                return $3d4fd987da5242ff$export$66c1ae025e96b4bc(v);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
            return $tco_result;
        };
    };
    return go($amUgg.Nil.value);
};
var $3d4fd987da5242ff$export$712962e076096ed4 = function(lst) {
    var go = function($copy_v) {
        return function($copy_v1) {
            var $tco_var_v = $copy_v;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v, v1) {
                if (v instanceof $amUgg.Nil) {
                    $tco_done = true;
                    return $ykHdR.Nothing.value;
                }
                if (v instanceof $amUgg.Cons && v.value1 instanceof $amUgg.Nil) {
                    $tco_done = true;
                    return new $ykHdR.Just({
                        revInit: v1,
                        last: v.value0
                    });
                }
                if (v instanceof $amUgg.Cons) {
                    $tco_var_v = v.value1;
                    $copy_v1 = new $amUgg.Cons(v.value0, v1);
                    return;
                }
                throw new Error("Failed pattern match at Data.List (line 270, column 3 - line 270, column 21): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
            return $tco_result;
        };
    };
    return $3d4fd987da5242ff$var$map(function(h) {
        return {
            init: $3d4fd987da5242ff$export$66c1ae025e96b4bc(h.revInit),
            last: h.last
        };
    })(go(lst)($amUgg.Nil.value));
};
var $3d4fd987da5242ff$export$b634740ce272acb5 = function(f) {
    return function(xs) {
        return function(ys) {
            var go = function($copy_v) {
                return function($copy_v1) {
                    return function($copy_v2) {
                        var $tco_var_v = $copy_v;
                        var $tco_var_v1 = $copy_v1;
                        var $tco_done = false;
                        var $tco_result;
                        function $tco_loop(v, v1, v2) {
                            if (v instanceof $amUgg.Nil) {
                                $tco_done = true;
                                return v2;
                            }
                            if (v1 instanceof $amUgg.Nil) {
                                $tco_done = true;
                                return v2;
                            }
                            if (v instanceof $amUgg.Cons && v1 instanceof $amUgg.Cons) {
                                $tco_var_v = v.value1;
                                $tco_var_v1 = v1.value1;
                                $copy_v2 = new $amUgg.Cons(f(v.value0)(v1.value0), v2);
                                return;
                            }
                            throw new Error("Failed pattern match at Data.List (line 779, column 3 - line 779, column 21): " + [
                                v.constructor.name,
                                v1.constructor.name,
                                v2.constructor.name
                            ]);
                        }
                        while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $tco_var_v1, $copy_v2);
                        return $tco_result;
                    };
                };
            };
            return $3d4fd987da5242ff$export$66c1ae025e96b4bc(go(xs)(ys)($amUgg.Nil.value));
        };
    };
};
var $3d4fd987da5242ff$export$8901015135f2fb22 = /* #__PURE__ */ function() {
    return $3d4fd987da5242ff$export$b634740ce272acb5($9MxTl.Tuple.create);
}();
var $3d4fd987da5242ff$export$e00c1e5c5a2b1ad7 = function(dictApplicative) {
    var sequence1 = $3d4fd987da5242ff$var$sequence(dictApplicative);
    return function(f) {
        return function(xs) {
            return function(ys) {
                return sequence1($3d4fd987da5242ff$export$b634740ce272acb5(f)(xs)(ys));
            };
        };
    };
};
var $3d4fd987da5242ff$export$d02631cccf789723 = function(start) {
    return function(end) {
        if (start === end) return $3d4fd987da5242ff$export$439306a4dcaafbb9(start);
        if ($6UHO6.otherwise) {
            var go = function($copy_s) {
                return function($copy_e) {
                    return function($copy_step) {
                        return function($copy_rest) {
                            var $tco_var_s = $copy_s;
                            var $tco_var_e = $copy_e;
                            var $tco_var_step = $copy_step;
                            var $tco_done = false;
                            var $tco_result;
                            function $tco_loop(s, e, step, rest) {
                                if (s === e) {
                                    $tco_done = true;
                                    return new $amUgg.Cons(s, rest);
                                }
                                if ($6UHO6.otherwise) {
                                    $tco_var_s = s + step | 0;
                                    $tco_var_e = e;
                                    $tco_var_step = step;
                                    $copy_rest = new $amUgg.Cons(s, rest);
                                    return;
                                }
                                throw new Error("Failed pattern match at Data.List (line 148, column 3 - line 149, column 65): " + [
                                    s.constructor.name,
                                    e.constructor.name,
                                    step.constructor.name,
                                    rest.constructor.name
                                ]);
                            }
                            while(!$tco_done)$tco_result = $tco_loop($tco_var_s, $tco_var_e, $tco_var_step, $copy_rest);
                            return $tco_result;
                        };
                    };
                };
            };
            return go(end)(start)(function() {
                var $325 = start > end;
                if ($325) return 1;
                return -1;
            }())($amUgg.Nil.value);
        }
        throw new Error("Failed pattern match at Data.List (line 144, column 1 - line 144, column 32): " + [
            start.constructor.name,
            end.constructor.name
        ]);
    };
};
var $3d4fd987da5242ff$export$b29f828819edca8d = function(p) {
    return function(xs) {
        var select = function(x) {
            return function(v) {
                var $328 = p(x);
                if ($328) return {
                    no: v.no,
                    yes: new $amUgg.Cons(x, v.yes)
                };
                return {
                    no: new $amUgg.Cons(x, v.no),
                    yes: v.yes
                };
            };
        };
        return $3d4fd987da5242ff$var$foldr(select)({
            no: $amUgg.Nil.value,
            yes: $amUgg.Nil.value
        })(xs);
    };
};
var $3d4fd987da5242ff$export$7b1b591b262c240 = function(v) {
    if (v instanceof $amUgg.Nil) return true;
    return false;
};
var $3d4fd987da5242ff$export$18f77a3bafa759b9 = function(p) {
    var go = function($copy_v) {
        return function($copy_v1) {
            return function($copy_v2) {
                var $tco_var_v = $copy_v;
                var $tco_var_v1 = $copy_v1;
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(v, v1, v2) {
                    if (v2 instanceof $amUgg.Nil) {
                        $tco_done = true;
                        return v1;
                    }
                    if (v2 instanceof $amUgg.Cons) {
                        var v3 = $7YrkG.insertAndLookupBy(p)(v2.value0)(v);
                        if (v3.found) {
                            $tco_var_v = v3.result;
                            $tco_var_v1 = v1;
                            $copy_v2 = v2.value1;
                            return;
                        }
                        $tco_var_v = v3.result;
                        $tco_var_v1 = new $amUgg.Cons(v2.value0, v1);
                        $copy_v2 = v2.value1;
                        return;
                    }
                    throw new Error("Failed pattern match at Data.List (line 673, column 5 - line 673, column 23): " + [
                        v.constructor.name,
                        v1.constructor.name,
                        v2.constructor.name
                    ]);
                }
                while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $tco_var_v1, $copy_v2);
                return $tco_result;
            };
        };
    };
    var $445 = go($7YrkG.emptySet)($amUgg.Nil.value);
    return function($446) {
        return $3d4fd987da5242ff$export$66c1ae025e96b4bc($445($446));
    };
};
var $3d4fd987da5242ff$export$94f4066a75b10404 = function(dictOrd) {
    return $3d4fd987da5242ff$export$18f77a3bafa759b9($d0PPW.compare(dictOrd));
};
var $3d4fd987da5242ff$export$86c9b635481112b7 = {
    Coercible0: function() {
        return undefined;
    }
};
var $3d4fd987da5242ff$export$e70771d2e7e590a = function(f) {
    var go = function($copy_v) {
        return function($copy_v1) {
            var $tco_var_v = $copy_v;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v, v1) {
                if (v1 instanceof $amUgg.Nil) {
                    $tco_done = true;
                    return $3d4fd987da5242ff$export$66c1ae025e96b4bc(v);
                }
                if (v1 instanceof $amUgg.Cons) {
                    var v2 = f(v1.value0);
                    if (v2 instanceof $ykHdR.Nothing) {
                        $tco_var_v = v;
                        $copy_v1 = v1.value1;
                        return;
                    }
                    if (v2 instanceof $ykHdR.Just) {
                        $tco_var_v = new $amUgg.Cons(v2.value0, v);
                        $copy_v1 = v1.value1;
                        return;
                    }
                    throw new Error("Failed pattern match at Data.List (line 419, column 5 - line 421, column 32): " + [
                        v2.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Data.List (line 417, column 3 - line 417, column 27): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
            return $tco_result;
        };
    };
    return go($amUgg.Nil.value);
};
var $3d4fd987da5242ff$export$17771a97d85ba7eb = function(dictMonadRec) {
    var bind1 = $9Grh5.bind(dictMonadRec.Monad0().Bind1());
    var tailRecM = $lowBm.tailRecM(dictMonadRec);
    return function(dictAlternative) {
        var Alt0 = dictAlternative.Plus1().Alt0();
        var alt = $a7Dxq.alt(Alt0);
        var map1 = $l0wDR.map(Alt0.Functor0());
        var pure = $gUTA8.pure(dictAlternative.Applicative0());
        return function(p) {
            var go = function(acc) {
                return bind1(alt(map1($lowBm.Loop.create)(p))(pure(new $lowBm.Done($r2HHk.unit))))(function(aa) {
                    return pure($3d4fd987da5242ff$var$bimap(function(v) {
                        return new $amUgg.Cons(v, acc);
                    })(function(v) {
                        return $3d4fd987da5242ff$export$66c1ae025e96b4bc(acc);
                    })(aa));
                });
            };
            return tailRecM(go)($amUgg.Nil.value);
        };
    };
};
var $3d4fd987da5242ff$export$934820ddadec516f = function(dictMonadRec) {
    var manyRec1 = $3d4fd987da5242ff$export$17771a97d85ba7eb(dictMonadRec);
    return function(dictAlternative) {
        var apply = $a5g3C.apply(dictAlternative.Applicative0().Apply0());
        var map1 = $l0wDR.map(dictAlternative.Plus1().Alt0().Functor0());
        var manyRec2 = manyRec1(dictAlternative);
        return function(v) {
            return apply(map1($amUgg.Cons.create)(v))(manyRec2(v));
        };
    };
};
var $3d4fd987da5242ff$export$ad14ef4001db2bcd = function(dictAlternative) {
    var apply = $a5g3C.apply(dictAlternative.Applicative0().Apply0());
    var map1 = $l0wDR.map(dictAlternative.Plus1().Alt0().Functor0());
    return function(dictLazy) {
        var defer = $dTFzl.defer(dictLazy);
        return function(v) {
            return apply(map1($amUgg.Cons.create)(v))(defer(function(v1) {
                return $3d4fd987da5242ff$export$14badfee79ea396f(dictAlternative)(dictLazy)(v);
            }));
        };
    };
};
var $3d4fd987da5242ff$export$14badfee79ea396f = function(dictAlternative) {
    var alt = $a7Dxq.alt(dictAlternative.Plus1().Alt0());
    var pure = $gUTA8.pure(dictAlternative.Applicative0());
    return function(dictLazy) {
        return function(v) {
            return alt($3d4fd987da5242ff$export$ad14ef4001db2bcd(dictAlternative)(dictLazy)(v))(pure($amUgg.Nil.value));
        };
    };
};
var $3d4fd987da5242ff$export$f24224f1c91d8156 = /* #__PURE__ */ $3d4fd987da5242ff$var$foldl(function(acc) {
    return function(v) {
        return acc + 1 | 0;
    };
})(0);
var $3d4fd987da5242ff$export$4c7897fafd92b108 = function($copy_v) {
    var $tco_done = false;
    var $tco_result;
    function $tco_loop(v) {
        if (v instanceof $amUgg.Cons && v.value1 instanceof $amUgg.Nil) {
            $tco_done = true;
            return new $ykHdR.Just(v.value0);
        }
        if (v instanceof $amUgg.Cons) {
            $copy_v = v.value1;
            return;
        }
        $tco_done = true;
        return $ykHdR.Nothing.value;
    }
    while(!$tco_done)$tco_result = $tco_loop($copy_v);
    return $tco_result;
};
var $3d4fd987da5242ff$export$b8bc901090d2b1d4 = function(v) {
    return function(v1) {
        return function(v2) {
            if (v2 instanceof $amUgg.Nil) return $3d4fd987da5242ff$export$439306a4dcaafbb9(v1);
            if (v2 instanceof $amUgg.Cons) {
                var v3 = v(v1)(v2.value0);
                if (v3 instanceof $6SDUu.GT) return new $amUgg.Cons(v2.value0, $3d4fd987da5242ff$export$b8bc901090d2b1d4(v)(v1)(v2.value1));
                return new $amUgg.Cons(v1, v2);
            }
            throw new Error("Failed pattern match at Data.List (line 216, column 1 - line 216, column 68): " + [
                v.constructor.name,
                v1.constructor.name,
                v2.constructor.name
            ]);
        };
    };
};
var $3d4fd987da5242ff$export$9f200c4466975173 = function(v) {
    return function(v1) {
        return function(v2) {
            if (v === 0) return new $ykHdR.Just(new $amUgg.Cons(v1, v2));
            if (v2 instanceof $amUgg.Cons) return $3d4fd987da5242ff$var$map(function(v3) {
                return new $amUgg.Cons(v2.value0, v3);
            })($3d4fd987da5242ff$export$9f200c4466975173(v - 1 | 0)(v1)(v2.value1));
            return $ykHdR.Nothing.value;
        };
    };
};
var $3d4fd987da5242ff$export$21a5ca8aa77d35ff = function(dictOrd) {
    return $3d4fd987da5242ff$export$b8bc901090d2b1d4($d0PPW.compare(dictOrd));
};
var $3d4fd987da5242ff$export$2cd8252107eb640b = function(lst) {
    return $3d4fd987da5242ff$var$map(function(v) {
        return v.init;
    })($3d4fd987da5242ff$export$712962e076096ed4(lst));
};
var $3d4fd987da5242ff$export$b610b8812bbcded9 = function($copy_v) {
    return function($copy_v1) {
        var $tco_var_v = $copy_v;
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v, v1) {
            if (v instanceof $amUgg.Nil) {
                $tco_done = true;
                return $ykHdR.Nothing.value;
            }
            if (v instanceof $amUgg.Cons && v1 === 0) {
                $tco_done = true;
                return new $ykHdR.Just(v.value0);
            }
            if (v instanceof $amUgg.Cons) {
                $tco_var_v = v.value1;
                $copy_v1 = v1 - 1 | 0;
                return;
            }
            throw new Error("Failed pattern match at Data.List (line 281, column 1 - line 281, column 44): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        }
        while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
        return $tco_result;
    };
};
var $3d4fd987da5242ff$export$5fd5031fecdacec3 = function(v) {
    if (v instanceof $amUgg.Nil) return $ykHdR.Nothing.value;
    if (v instanceof $amUgg.Cons) return new $ykHdR.Just(v.value0);
    throw new Error("Failed pattern match at Data.List (line 230, column 1 - line 230, column 22): " + [
        v.constructor.name
    ]);
};
var $3d4fd987da5242ff$export$9cb09a71b7d66923 = function(v) {
    if (v instanceof $amUgg.Nil) return $amUgg.Nil.value;
    if (v instanceof $amUgg.Cons && v.value0 instanceof $amUgg.Nil) return $3d4fd987da5242ff$export$9cb09a71b7d66923(v.value1);
    if (v instanceof $amUgg.Cons && v.value0 instanceof $amUgg.Cons) return new $amUgg.Cons(new $amUgg.Cons(v.value0.value0, $3d4fd987da5242ff$export$e70771d2e7e590a($3d4fd987da5242ff$export$5fd5031fecdacec3)(v.value1)), $3d4fd987da5242ff$export$9cb09a71b7d66923(new $amUgg.Cons(v.value0.value1, $3d4fd987da5242ff$export$e70771d2e7e590a($3d4fd987da5242ff$export$c01875f616615628)(v.value1))));
    throw new Error("Failed pattern match at Data.List (line 813, column 1 - line 813, column 54): " + [
        v.constructor.name
    ]);
};
var $3d4fd987da5242ff$export$3f063810d7bf01bd = function(v) {
    return function(v1) {
        if (v1 instanceof $amUgg.Nil) return $amUgg.Nil.value;
        if (v1 instanceof $amUgg.Cons) {
            var v2 = $3d4fd987da5242ff$export$afc1bfabebaf28a2(v(v1.value0))(v1.value1);
            return new $amUgg.Cons(new $2FBb2.NonEmpty(v1.value0, v2.init), $3d4fd987da5242ff$export$3f063810d7bf01bd(v)(v2.rest));
        }
        throw new Error("Failed pattern match at Data.List (line 609, column 1 - line 609, column 80): " + [
            v.constructor.name,
            v1.constructor.name
        ]);
    };
};
var $3d4fd987da5242ff$export$1f7a5bf12caafbd = function(p) {
    var $447 = $3d4fd987da5242ff$export$3f063810d7bf01bd(function(x) {
        return function(y) {
            return $3d4fd987da5242ff$var$eq(p(x)(y))($6SDUu.EQ.value);
        };
    });
    var $448 = $3d4fd987da5242ff$export$b035e44d7bb4278f(p);
    return function($449) {
        return $447($448($449));
    };
};
var $3d4fd987da5242ff$export$e5e25fbcc1f7affe = function(dictEq) {
    return $3d4fd987da5242ff$export$3f063810d7bf01bd($4MBcA.eq(dictEq));
};
var $3d4fd987da5242ff$export$361434b95a7d965 = function(dictOrd) {
    var $450 = $3d4fd987da5242ff$export$e5e25fbcc1f7affe(dictOrd.Eq0());
    var $451 = $3d4fd987da5242ff$export$97db5808d8f88186(dictOrd);
    return function($452) {
        return $450($451($452));
    };
};
var $3d4fd987da5242ff$export$b7d5d9bb9ff52072 = function(dictFoldable) {
    return $6RkEA.foldr(dictFoldable)($amUgg.Cons.create)($amUgg.Nil.value);
};
var $3d4fd987da5242ff$export$7a067f9280ad8af0 = function(dictMonad) {
    var pure = $gUTA8.pure(dictMonad.Applicative0());
    var bind1 = $9Grh5.bind(dictMonad.Bind1());
    return function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $amUgg.Nil) return pure(v1);
                if (v2 instanceof $amUgg.Cons) return bind1(v(v1)(v2.value0))(function(b$prime) {
                    return $3d4fd987da5242ff$export$7a067f9280ad8af0(dictMonad)(v)(b$prime)(v2.value1);
                });
                throw new Error("Failed pattern match at Data.List (line 824, column 1 - line 824, column 72): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    };
};
var $3d4fd987da5242ff$export$de3a4d4a0d731119 = function(fn) {
    var go = function($copy_v) {
        return function($copy_v1) {
            var $tco_var_v = $copy_v;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v, v1) {
                if (v1 instanceof $amUgg.Cons) {
                    if (fn(v1.value0)) {
                        $tco_done = true;
                        return new $ykHdR.Just(v);
                    }
                    if ($6UHO6.otherwise) {
                        $tco_var_v = v + 1 | 0;
                        $copy_v1 = v1.value1;
                        return;
                    }
                }
                if (v1 instanceof $amUgg.Nil) {
                    $tco_done = true;
                    return $ykHdR.Nothing.value;
                }
                throw new Error("Failed pattern match at Data.List (line 301, column 3 - line 301, column 35): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
            return $tco_result;
        };
    };
    return go(0);
};
var $3d4fd987da5242ff$export$8855a8be7bd3e9f8 = function(fn) {
    return function(xs) {
        return $3d4fd987da5242ff$var$map(function(v) {
            return ($3d4fd987da5242ff$export$f24224f1c91d8156(xs) - 1 | 0) - v | 0;
        })($3d4fd987da5242ff$export$de3a4d4a0d731119(fn)($3d4fd987da5242ff$export$66c1ae025e96b4bc(xs)));
    };
};
var $3d4fd987da5242ff$export$20098ecb074a31e6 = function(dictMonad) {
    var pure = $gUTA8.pure(dictMonad.Applicative0());
    var bind1 = $9Grh5.bind(dictMonad.Bind1());
    return function(v) {
        return function(v1) {
            if (v1 instanceof $amUgg.Nil) return pure($amUgg.Nil.value);
            if (v1 instanceof $amUgg.Cons) return bind1(v(v1.value0))(function(b) {
                return bind1($3d4fd987da5242ff$export$20098ecb074a31e6(dictMonad)(v)(v1.value1))(function(xs$prime) {
                    return pure(function() {
                        if (b) return new $amUgg.Cons(v1.value0, xs$prime);
                        return xs$prime;
                    }());
                });
            });
            throw new Error("Failed pattern match at Data.List (line 403, column 1 - line 403, column 75): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    };
};
var $3d4fd987da5242ff$export$3dea766d36a8935f = function(p) {
    var go = function($copy_v) {
        return function($copy_v1) {
            var $tco_var_v = $copy_v;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v, v1) {
                if (v1 instanceof $amUgg.Nil) {
                    $tco_done = true;
                    return $3d4fd987da5242ff$export$66c1ae025e96b4bc(v);
                }
                if (v1 instanceof $amUgg.Cons) {
                    if (p(v1.value0)) {
                        $tco_var_v = new $amUgg.Cons(v1.value0, v);
                        $copy_v1 = v1.value1;
                        return;
                    }
                    if ($6UHO6.otherwise) {
                        $tco_var_v = v;
                        $copy_v1 = v1.value1;
                        return;
                    }
                }
                throw new Error("Failed pattern match at Data.List (line 390, column 3 - line 390, column 27): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
            return $tco_result;
        };
    };
    return go($amUgg.Nil.value);
};
var $3d4fd987da5242ff$export$f161f39e9c06ab2d = function(v) {
    return function(v1) {
        return function(v2) {
            if (v1 instanceof $amUgg.Nil) return $amUgg.Nil.value;
            if (v2 instanceof $amUgg.Nil) return $amUgg.Nil.value;
            return $3d4fd987da5242ff$export$3dea766d36a8935f(function(x) {
                return $3d4fd987da5242ff$var$any(v(x))(v2);
            })(v1);
        };
    };
};
var $3d4fd987da5242ff$export$1f4807a235930d45 = function(dictEq) {
    return $3d4fd987da5242ff$export$f161f39e9c06ab2d($4MBcA.eq(dictEq));
};
var $3d4fd987da5242ff$export$45273896c792ff3b = function(v) {
    return function(v1) {
        if (v1 instanceof $amUgg.Nil) return $amUgg.Nil.value;
        if (v1 instanceof $amUgg.Cons) return new $amUgg.Cons(v1.value0, $3d4fd987da5242ff$export$45273896c792ff3b(v)($3d4fd987da5242ff$export$3dea766d36a8935f(function(y) {
            return !v(v1.value0)(y);
        })(v1.value1)));
        throw new Error("Failed pattern match at Data.List (line 705, column 1 - line 705, column 61): " + [
            v.constructor.name,
            v1.constructor.name
        ]);
    };
};
var $3d4fd987da5242ff$export$edce5881c815871 = function(dictEq) {
    return $3d4fd987da5242ff$export$45273896c792ff3b($4MBcA.eq(dictEq));
};
var $3d4fd987da5242ff$export$3c57592525e2b27e = function(dictEq) {
    var eq2 = $4MBcA.eq($amUgg.eqList(dictEq));
    return {
        eq: function(x) {
            return function(y) {
                return eq2(x)(y);
            };
        }
    };
};
var $3d4fd987da5242ff$export$21c206d752eba296 = function(dictOrd) {
    var compare = $d0PPW.compare($amUgg.ordList(dictOrd));
    var eqPattern1 = $3d4fd987da5242ff$export$3c57592525e2b27e(dictOrd.Eq0());
    return {
        compare: function(x) {
            return function(y) {
                return compare(x)(y);
            };
        },
        Eq0: function() {
            return eqPattern1;
        }
    };
};
var $3d4fd987da5242ff$export$c19d79386f4ed99a = function(dictEq) {
    var eq2 = $4MBcA.eq(dictEq);
    return function(x) {
        return $3d4fd987da5242ff$export$8855a8be7bd3e9f8(function(v) {
            return eq2(v)(x);
        });
    };
};
var $3d4fd987da5242ff$export$f444781b0adb7e4d = function(dictEq) {
    var eq2 = $4MBcA.eq(dictEq);
    return function(x) {
        return $3d4fd987da5242ff$export$de3a4d4a0d731119(function(v) {
            return eq2(v)(x);
        });
    };
};
var $3d4fd987da5242ff$export$533af5c8cd6afa16 = function(p) {
    var go = function($copy_v) {
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v) {
            if (v instanceof $amUgg.Cons && p(v.value0)) {
                $copy_v = v.value1;
                return;
            }
            $tco_done = true;
            return v;
        }
        while(!$tco_done)$tco_result = $tco_loop($copy_v);
        return $tco_result;
    };
    return go;
};
var $3d4fd987da5242ff$export$2b3b686e33c80c56 = function(n) {
    return function(xs) {
        return $3d4fd987da5242ff$export$b7df5d561049483a($3d4fd987da5242ff$export$f24224f1c91d8156(xs) - n | 0)(xs);
    };
};
var $3d4fd987da5242ff$export$663103110d94aac9 = function($copy_v) {
    return function($copy_v1) {
        var $tco_var_v = $copy_v;
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v, v1) {
            if (v < 1) {
                $tco_done = true;
                return v1;
            }
            if (v1 instanceof $amUgg.Nil) {
                $tco_done = true;
                return $amUgg.Nil.value;
            }
            if (v1 instanceof $amUgg.Cons) {
                $tco_var_v = v - 1 | 0;
                $copy_v1 = v1.value1;
                return;
            }
            throw new Error("Failed pattern match at Data.List (line 536, column 1 - line 536, column 42): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        }
        while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
        return $tco_result;
    };
};
var $3d4fd987da5242ff$export$58adb3bec8346d0f = function(start) {
    return function(end) {
        return function(xs) {
            return $3d4fd987da5242ff$export$b7df5d561049483a(end - start | 0)($3d4fd987da5242ff$export$663103110d94aac9(start)(xs));
        };
    };
};
var $3d4fd987da5242ff$export$9100289823a975b0 = function(n) {
    return function(xs) {
        return $3d4fd987da5242ff$export$663103110d94aac9($3d4fd987da5242ff$export$f24224f1c91d8156(xs) - n | 0)(xs);
    };
};
var $3d4fd987da5242ff$export$9ea2b6c3fae093d8 = function(v) {
    return function(v1) {
        return function(v2) {
            if (v2 instanceof $amUgg.Nil) return $amUgg.Nil.value;
            if (v2 instanceof $amUgg.Cons && v(v1)(v2.value0)) return v2.value1;
            if (v2 instanceof $amUgg.Cons) return new $amUgg.Cons(v2.value0, $3d4fd987da5242ff$export$9ea2b6c3fae093d8(v)(v1)(v2.value1));
            throw new Error("Failed pattern match at Data.List (line 732, column 1 - line 732, column 67): " + [
                v.constructor.name,
                v1.constructor.name,
                v2.constructor.name
            ]);
        };
    };
};
var $3d4fd987da5242ff$export$ef1d06dc4d91d507 = function(eq2) {
    return function(xs) {
        return function(ys) {
            return $3d4fd987da5242ff$var$append1(xs)($3d4fd987da5242ff$var$foldl($l4M7e.flip($3d4fd987da5242ff$export$9ea2b6c3fae093d8(eq2)))($3d4fd987da5242ff$export$45273896c792ff3b(eq2)(ys))(xs));
        };
    };
};
var $3d4fd987da5242ff$export$971dd5b0dfd021b6 = function(dictEq) {
    return $3d4fd987da5242ff$export$ef1d06dc4d91d507($4MBcA.eq(dictEq));
};
var $3d4fd987da5242ff$export$90f9093465da3136 = function(v) {
    return function(v1) {
        if (v === 0 && v1 instanceof $amUgg.Cons) return new $ykHdR.Just(v1.value1);
        if (v1 instanceof $amUgg.Cons) return $3d4fd987da5242ff$var$map(function(v2) {
            return new $amUgg.Cons(v1.value0, v2);
        })($3d4fd987da5242ff$export$90f9093465da3136(v - 1 | 0)(v1.value1));
        return $ykHdR.Nothing.value;
    };
};
var $3d4fd987da5242ff$export$1822828d790e23ee = function(dictEq) {
    return $3d4fd987da5242ff$export$9ea2b6c3fae093d8($4MBcA.eq(dictEq));
};
var $3d4fd987da5242ff$export$acaf96a27438246b = function(dictEq) {
    return $3d4fd987da5242ff$var$foldl($l4M7e.flip($3d4fd987da5242ff$export$1822828d790e23ee(dictEq)));
};
var $3d4fd987da5242ff$export$c28c8388be0ab31a = /* #__PURE__ */ $l4M7e.flip($3d4fd987da5242ff$var$bind);
var $3d4fd987da5242ff$export$ee1b3e54f0441b22 = function(v) {
    return $3d4fd987da5242ff$var$bind(v)($3d4fd987da5242ff$var$identity);
};
var $3d4fd987da5242ff$export$986c2bbe7a34be0b = /* #__PURE__ */ $3d4fd987da5242ff$export$e70771d2e7e590a($3d4fd987da5242ff$var$identity);
var $3d4fd987da5242ff$export$2dd9d44f93be5e22 = function(v) {
    return function(v1) {
        return function(v2) {
            if (v === 0 && v2 instanceof $amUgg.Cons) return new $ykHdR.Just(function() {
                var v3 = v1(v2.value0);
                if (v3 instanceof $ykHdR.Nothing) return v2.value1;
                if (v3 instanceof $ykHdR.Just) return new $amUgg.Cons(v3.value0, v2.value1);
                throw new Error("Failed pattern match at Data.List (line 352, column 3 - line 354, column 23): " + [
                    v3.constructor.name
                ]);
            }());
            if (v2 instanceof $amUgg.Cons) return $3d4fd987da5242ff$var$map(function(v3) {
                return new $amUgg.Cons(v2.value0, v3);
            })($3d4fd987da5242ff$export$2dd9d44f93be5e22(v - 1 | 0)(v1)(v2.value1));
            return $ykHdR.Nothing.value;
        };
    };
};
var $3d4fd987da5242ff$export$cba09f9e3d3e58eb = function(n) {
    return function(f) {
        return $3d4fd987da5242ff$export$2dd9d44f93be5e22(n)(function($453) {
            return $ykHdR.Just.create(f($453));
        });
    };
};

});
parcelRegister("7YrkG", function(module, exports) {

$parcel$export(module.exports, "insertAndLookupBy", () => $5ce356b15dd97b57$export$b5a179e49e0f2907);
$parcel$export(module.exports, "emptySet", () => $5ce356b15dd97b57$export$4e5bc754a9c955a);
// Generated by purs version 0.15.16

var $amUgg = parcelRequire("amUgg");

var $6SDUu = parcelRequire("6SDUu");
var $5ce356b15dd97b57$var$Leaf = /* #__PURE__ */ function() {
    function Leaf() {}
    Leaf.value = new Leaf();
    return Leaf;
}();
var $5ce356b15dd97b57$var$Two = /* #__PURE__ */ function() {
    function Two(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    Two.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new Two(value0, value1, value2);
            };
        };
    };
    return Two;
}();
var $5ce356b15dd97b57$var$Three = /* #__PURE__ */ function() {
    function Three(value0, value1, value2, value3, value4) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
        this.value4 = value4;
    }
    Three.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return function(value4) {
                        return new Three(value0, value1, value2, value3, value4);
                    };
                };
            };
        };
    };
    return Three;
}();
var $5ce356b15dd97b57$var$TwoLeft = /* #__PURE__ */ function() {
    function TwoLeft(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    TwoLeft.create = function(value0) {
        return function(value1) {
            return new TwoLeft(value0, value1);
        };
    };
    return TwoLeft;
}();
var $5ce356b15dd97b57$var$TwoRight = /* #__PURE__ */ function() {
    function TwoRight(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    TwoRight.create = function(value0) {
        return function(value1) {
            return new TwoRight(value0, value1);
        };
    };
    return TwoRight;
}();
var $5ce356b15dd97b57$var$ThreeLeft = /* #__PURE__ */ function() {
    function ThreeLeft(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    }
    ThreeLeft.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return new ThreeLeft(value0, value1, value2, value3);
                };
            };
        };
    };
    return ThreeLeft;
}();
var $5ce356b15dd97b57$var$ThreeMiddle = /* #__PURE__ */ function() {
    function ThreeMiddle(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    }
    ThreeMiddle.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return new ThreeMiddle(value0, value1, value2, value3);
                };
            };
        };
    };
    return ThreeMiddle;
}();
var $5ce356b15dd97b57$var$ThreeRight = /* #__PURE__ */ function() {
    function ThreeRight(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    }
    ThreeRight.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return new ThreeRight(value0, value1, value2, value3);
                };
            };
        };
    };
    return ThreeRight;
}();
var $5ce356b15dd97b57$var$KickUp = /* #__PURE__ */ function() {
    function KickUp(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    KickUp.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new KickUp(value0, value1, value2);
            };
        };
    };
    return KickUp;
}();
var $5ce356b15dd97b57$var$fromZipper = function($copy_v) {
    return function($copy_v1) {
        var $tco_var_v = $copy_v;
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v, v1) {
            if (v instanceof $amUgg.Nil) {
                $tco_done = true;
                return v1;
            }
            if (v instanceof $amUgg.Cons) {
                if (v.value0 instanceof $5ce356b15dd97b57$var$TwoLeft) {
                    $tco_var_v = v.value1;
                    $copy_v1 = new $5ce356b15dd97b57$var$Two(v1, v.value0.value0, v.value0.value1);
                    return;
                }
                if (v.value0 instanceof $5ce356b15dd97b57$var$TwoRight) {
                    $tco_var_v = v.value1;
                    $copy_v1 = new $5ce356b15dd97b57$var$Two(v.value0.value0, v.value0.value1, v1);
                    return;
                }
                if (v.value0 instanceof $5ce356b15dd97b57$var$ThreeLeft) {
                    $tco_var_v = v.value1;
                    $copy_v1 = new $5ce356b15dd97b57$var$Three(v1, v.value0.value0, v.value0.value1, v.value0.value2, v.value0.value3);
                    return;
                }
                if (v.value0 instanceof $5ce356b15dd97b57$var$ThreeMiddle) {
                    $tco_var_v = v.value1;
                    $copy_v1 = new $5ce356b15dd97b57$var$Three(v.value0.value0, v.value0.value1, v1, v.value0.value2, v.value0.value3);
                    return;
                }
                if (v.value0 instanceof $5ce356b15dd97b57$var$ThreeRight) {
                    $tco_var_v = v.value1;
                    $copy_v1 = new $5ce356b15dd97b57$var$Three(v.value0.value0, v.value0.value1, v.value0.value2, v.value0.value3, v1);
                    return;
                }
                throw new Error("Failed pattern match at Data.List.Internal (line 25, column 3 - line 30, column 76): " + [
                    v.value0.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Data.List.Internal (line 22, column 1 - line 22, column 63): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        }
        while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
        return $tco_result;
    };
};
var $5ce356b15dd97b57$export$b5a179e49e0f2907 = function(comp) {
    return function(k) {
        return function(orig) {
            var up = function($copy_v) {
                return function($copy_v1) {
                    var $tco_var_v = $copy_v;
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(v, v1) {
                        if (v instanceof $amUgg.Nil) {
                            $tco_done = true;
                            return new $5ce356b15dd97b57$var$Two(v1.value0, v1.value1, v1.value2);
                        }
                        if (v instanceof $amUgg.Cons) {
                            if (v.value0 instanceof $5ce356b15dd97b57$var$TwoLeft) {
                                $tco_done = true;
                                return $5ce356b15dd97b57$var$fromZipper(v.value1)(new $5ce356b15dd97b57$var$Three(v1.value0, v1.value1, v1.value2, v.value0.value0, v.value0.value1));
                            }
                            if (v.value0 instanceof $5ce356b15dd97b57$var$TwoRight) {
                                $tco_done = true;
                                return $5ce356b15dd97b57$var$fromZipper(v.value1)(new $5ce356b15dd97b57$var$Three(v.value0.value0, v.value0.value1, v1.value0, v1.value1, v1.value2));
                            }
                            if (v.value0 instanceof $5ce356b15dd97b57$var$ThreeLeft) {
                                $tco_var_v = v.value1;
                                $copy_v1 = new $5ce356b15dd97b57$var$KickUp(new $5ce356b15dd97b57$var$Two(v1.value0, v1.value1, v1.value2), v.value0.value0, new $5ce356b15dd97b57$var$Two(v.value0.value1, v.value0.value2, v.value0.value3));
                                return;
                            }
                            if (v.value0 instanceof $5ce356b15dd97b57$var$ThreeMiddle) {
                                $tco_var_v = v.value1;
                                $copy_v1 = new $5ce356b15dd97b57$var$KickUp(new $5ce356b15dd97b57$var$Two(v.value0.value0, v.value0.value1, v1.value0), v1.value1, new $5ce356b15dd97b57$var$Two(v1.value2, v.value0.value2, v.value0.value3));
                                return;
                            }
                            if (v.value0 instanceof $5ce356b15dd97b57$var$ThreeRight) {
                                $tco_var_v = v.value1;
                                $copy_v1 = new $5ce356b15dd97b57$var$KickUp(new $5ce356b15dd97b57$var$Two(v.value0.value0, v.value0.value1, v.value0.value2), v.value0.value3, new $5ce356b15dd97b57$var$Two(v1.value0, v1.value1, v1.value2));
                                return;
                            }
                            throw new Error("Failed pattern match at Data.List.Internal (line 58, column 5 - line 63, column 90): " + [
                                v.value0.constructor.name,
                                v1.constructor.name
                            ]);
                        }
                        throw new Error("Failed pattern match at Data.List.Internal (line 55, column 3 - line 55, column 50): " + [
                            v.constructor.name,
                            v1.constructor.name
                        ]);
                    }
                    while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
                    return $tco_result;
                };
            };
            var down = function($copy_v) {
                return function($copy_v1) {
                    var $tco_var_v = $copy_v;
                    var $tco_done1 = false;
                    var $tco_result;
                    function $tco_loop(v, v1) {
                        if (v1 instanceof $5ce356b15dd97b57$var$Leaf) {
                            $tco_done1 = true;
                            return {
                                found: false,
                                result: up(v)(new $5ce356b15dd97b57$var$KickUp($5ce356b15dd97b57$var$Leaf.value, k, $5ce356b15dd97b57$var$Leaf.value))
                            };
                        }
                        if (v1 instanceof $5ce356b15dd97b57$var$Two) {
                            var v2 = comp(k)(v1.value1);
                            if (v2 instanceof $6SDUu.EQ) {
                                $tco_done1 = true;
                                return {
                                    found: true,
                                    result: orig
                                };
                            }
                            if (v2 instanceof $6SDUu.LT) {
                                $tco_var_v = new $amUgg.Cons(new $5ce356b15dd97b57$var$TwoLeft(v1.value1, v1.value2), v);
                                $copy_v1 = v1.value0;
                                return;
                            }
                            $tco_var_v = new $amUgg.Cons(new $5ce356b15dd97b57$var$TwoRight(v1.value0, v1.value1), v);
                            $copy_v1 = v1.value2;
                            return;
                        }
                        if (v1 instanceof $5ce356b15dd97b57$var$Three) {
                            var v2 = comp(k)(v1.value1);
                            if (v2 instanceof $6SDUu.EQ) {
                                $tco_done1 = true;
                                return {
                                    found: true,
                                    result: orig
                                };
                            }
                            var v3 = comp(k)(v1.value3);
                            if (v3 instanceof $6SDUu.EQ) {
                                $tco_done1 = true;
                                return {
                                    found: true,
                                    result: orig
                                };
                            }
                            if (v2 instanceof $6SDUu.LT) {
                                $tco_var_v = new $amUgg.Cons(new $5ce356b15dd97b57$var$ThreeLeft(v1.value1, v1.value2, v1.value3, v1.value4), v);
                                $copy_v1 = v1.value0;
                                return;
                            }
                            if (v2 instanceof $6SDUu.GT && v3 instanceof $6SDUu.LT) {
                                $tco_var_v = new $amUgg.Cons(new $5ce356b15dd97b57$var$ThreeMiddle(v1.value0, v1.value1, v1.value3, v1.value4), v);
                                $copy_v1 = v1.value2;
                                return;
                            }
                            $tco_var_v = new $amUgg.Cons(new $5ce356b15dd97b57$var$ThreeRight(v1.value0, v1.value1, v1.value2, v1.value3), v);
                            $copy_v1 = v1.value4;
                            return;
                        }
                        throw new Error("Failed pattern match at Data.List.Internal (line 38, column 3 - line 38, column 81): " + [
                            v.constructor.name,
                            v1.constructor.name
                        ]);
                    }
                    while(!$tco_done1)$tco_result = $tco_loop($tco_var_v, $copy_v1);
                    return $tco_result;
                };
            };
            return down($amUgg.Nil.value)(orig);
        };
    };
};
var $5ce356b15dd97b57$export$4e5bc754a9c955a = /* #__PURE__ */ function() {
    return $5ce356b15dd97b57$var$Leaf.value;
}();

});
parcelRegister("amUgg", function(module, exports) {

$parcel$export(module.exports, "Nil", () => $78c799cba34fcb8d$export$c1bed610ade55e1c);
$parcel$export(module.exports, "Cons", () => $78c799cba34fcb8d$export$74c44e616647f5c0);
$parcel$export(module.exports, "NonEmptyList", () => $78c799cba34fcb8d$export$ab241a3582569781);
$parcel$export(module.exports, "functorList", () => $78c799cba34fcb8d$export$40b9e4330ffd17e3);
$parcel$export(module.exports, "functorNonEmptyList", () => $78c799cba34fcb8d$export$3c979cc7d75b024c);
$parcel$export(module.exports, "foldableList", () => $78c799cba34fcb8d$export$92659ee1fc91a075);
$parcel$export(module.exports, "semigroupList", () => $78c799cba34fcb8d$export$11cb7909a85856b);
$parcel$export(module.exports, "monoidList", () => $78c799cba34fcb8d$export$14584e231e9c63ca);
$parcel$export(module.exports, "showList", () => $78c799cba34fcb8d$export$36831384a74c4427);
$parcel$export(module.exports, "traversableList", () => $78c799cba34fcb8d$export$99c2ce29c0ead637);
$parcel$export(module.exports, "eqList", () => $78c799cba34fcb8d$export$1ae88a7f3c5f59ef);
$parcel$export(module.exports, "ordList", () => $78c799cba34fcb8d$export$86359cd4476084f8);
$parcel$export(module.exports, "bindList", () => $78c799cba34fcb8d$export$497dcf96eb2383ec);
$parcel$export(module.exports, "bindNonEmptyList", () => $78c799cba34fcb8d$export$12e3398ee6f4a417);
$parcel$export(module.exports, "applicativeList", () => $78c799cba34fcb8d$export$25cda6d3e08b28fe);
$parcel$export(module.exports, "plusList", () => $78c799cba34fcb8d$export$55d622505c452dcb);
$parcel$export(module.exports, "traversable1NonEmptyList", () => $78c799cba34fcb8d$export$fac1bbd0707bc766);
// Generated by purs version 0.15.16

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $9Grh5 = parcelRequire("9Grh5");

var $7T8P4 = parcelRequire("7T8P4");

var $4MBcA = parcelRequire("4MBcA");

var $6RkEA = parcelRequire("6RkEA");

var $70sTh = parcelRequire("70sTh");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");

var $4oUwX = parcelRequire("4oUwX");

var $ykHdR = parcelRequire("ykHdR");

var $aknDF = parcelRequire("aknDF");

var $2FBb2 = parcelRequire("2FBb2");

var $d0PPW = parcelRequire("d0PPW");

var $6SDUu = parcelRequire("6SDUu");

var $iwqgS = parcelRequire("iwqgS");

var $jERGJ = parcelRequire("jERGJ");

var $gyPYh = parcelRequire("gyPYh");

var $3Orkn = parcelRequire("3Orkn");

var $1wR1l = parcelRequire("1wR1l");

var $3OKRG = parcelRequire("3OKRG");

var $9MxTl = parcelRequire("9MxTl");
var $78c799cba34fcb8d$var$add = /* #__PURE__ */ $gyPYh.add($gyPYh.semiringInt);
var $78c799cba34fcb8d$var$identity = /* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn);
var $78c799cba34fcb8d$export$c1bed610ade55e1c = /* #__PURE__ */ function() {
    function Nil() {}
    Nil.value = new Nil();
    return Nil;
}();
var $78c799cba34fcb8d$export$74c44e616647f5c0 = /* #__PURE__ */ function() {
    function Cons(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Cons.create = function(value0) {
        return function(value1) {
            return new Cons(value0, value1);
        };
    };
    return Cons;
}();
var $78c799cba34fcb8d$export$ab241a3582569781 = function(x) {
    return x;
};
var $78c799cba34fcb8d$export$effcdbd76139450 = function(v) {
    return new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, v.value1);
};
var $78c799cba34fcb8d$export$e1330f0deced5836 = {
    Coercible0: function() {
        return undefined;
    }
};
var $78c799cba34fcb8d$export$4fa915e2865b1814 = function(a) {
    return function(v) {
        return new $2FBb2.NonEmpty(a, new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, v.value1));
    };
};
var $78c799cba34fcb8d$var$listMap = function(f) {
    var chunkedRevMap = function($copy_v) {
        return function($copy_v1) {
            var $tco_var_v = $copy_v;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v, v1) {
                if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v1.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v1.value1.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                    $tco_var_v = new $78c799cba34fcb8d$export$74c44e616647f5c0(v1, v);
                    $copy_v1 = v1.value1.value1.value1;
                    return;
                }
                var unrolledMap = function(v2) {
                    if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v2.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v2.value1.value1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return new $78c799cba34fcb8d$export$74c44e616647f5c0(f(v2.value0), new $78c799cba34fcb8d$export$74c44e616647f5c0(f(v2.value1.value0), $78c799cba34fcb8d$export$c1bed610ade55e1c.value));
                    if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v2.value1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return new $78c799cba34fcb8d$export$74c44e616647f5c0(f(v2.value0), $78c799cba34fcb8d$export$c1bed610ade55e1c.value);
                    return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
                };
                var reverseUnrolledMap = function($copy_v2) {
                    return function($copy_v3) {
                        var $tco_var_v2 = $copy_v2;
                        var $tco_done1 = false;
                        var $tco_result;
                        function $tco_loop(v2, v3) {
                            if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v2.value0 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v2.value0.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v2.value0.value1.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                                $tco_var_v2 = v2.value1;
                                $copy_v3 = new $78c799cba34fcb8d$export$74c44e616647f5c0(f(v2.value0.value0), new $78c799cba34fcb8d$export$74c44e616647f5c0(f(v2.value0.value1.value0), new $78c799cba34fcb8d$export$74c44e616647f5c0(f(v2.value0.value1.value1.value0), v3)));
                                return;
                            }
                            $tco_done1 = true;
                            return v3;
                        }
                        while(!$tco_done1)$tco_result = $tco_loop($tco_var_v2, $copy_v3);
                        return $tco_result;
                    };
                };
                $tco_done = true;
                return reverseUnrolledMap(v)(unrolledMap(v1));
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
            return $tco_result;
        };
    };
    return chunkedRevMap($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
};
var $78c799cba34fcb8d$export$40b9e4330ffd17e3 = {
    map: $78c799cba34fcb8d$var$listMap
};
var $78c799cba34fcb8d$var$map = /* #__PURE__ */ $l0wDR.map($78c799cba34fcb8d$export$40b9e4330ffd17e3);
var $78c799cba34fcb8d$export$3c979cc7d75b024c = /* #__PURE__ */ $2FBb2.functorNonEmpty($78c799cba34fcb8d$export$40b9e4330ffd17e3);
var $78c799cba34fcb8d$export$92659ee1fc91a075 = {
    foldr: function(f) {
        return function(b) {
            var rev = function() {
                var go = function($copy_v) {
                    return function($copy_v1) {
                        var $tco_var_v = $copy_v;
                        var $tco_done = false;
                        var $tco_result;
                        function $tco_loop(v, v1) {
                            if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                                $tco_done = true;
                                return v;
                            }
                            if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                                $tco_var_v = new $78c799cba34fcb8d$export$74c44e616647f5c0(v1.value0, v);
                                $copy_v1 = v1.value1;
                                return;
                            }
                            throw new Error("Failed pattern match at Data.List.Types (line 107, column 7 - line 107, column 23): " + [
                                v.constructor.name,
                                v1.constructor.name
                            ]);
                        }
                        while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
                        return $tco_result;
                    };
                };
                return go($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
            }();
            var $284 = $6RkEA.foldl($78c799cba34fcb8d$export$92659ee1fc91a075)($l4M7e.flip(f))(b);
            return function($285) {
                return $284(rev($285));
            };
        };
    },
    foldl: function(f) {
        var go = function($copy_b) {
            return function($copy_v) {
                var $tco_var_b = $copy_b;
                var $tco_done1 = false;
                var $tco_result;
                function $tco_loop(b, v) {
                    if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                        $tco_done1 = true;
                        return b;
                    }
                    if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                        $tco_var_b = f(b)(v.value0);
                        $copy_v = v.value1;
                        return;
                    }
                    throw new Error("Failed pattern match at Data.List.Types (line 111, column 12 - line 113, column 30): " + [
                        v.constructor.name
                    ]);
                }
                while(!$tco_done1)$tco_result = $tco_loop($tco_var_b, $copy_v);
                return $tco_result;
            };
        };
        return go;
    },
    foldMap: function(dictMonoid) {
        var append2 = $iwqgS.append(dictMonoid.Semigroup0());
        var mempty = $aknDF.mempty(dictMonoid);
        return function(f) {
            return $6RkEA.foldl($78c799cba34fcb8d$export$92659ee1fc91a075)(function(acc) {
                var $286 = append2(acc);
                return function($287) {
                    return $286(f($287));
                };
            })(mempty);
        };
    }
};
var $78c799cba34fcb8d$var$foldl = /* #__PURE__ */ $6RkEA.foldl($78c799cba34fcb8d$export$92659ee1fc91a075);
var $78c799cba34fcb8d$var$foldr = /* #__PURE__ */ $6RkEA.foldr($78c799cba34fcb8d$export$92659ee1fc91a075);
var $78c799cba34fcb8d$var$intercalate = /* #__PURE__ */ $6RkEA.intercalate($78c799cba34fcb8d$export$92659ee1fc91a075)($aknDF.monoidString);
var $78c799cba34fcb8d$export$604c31769a93bbe0 = /* #__PURE__ */ $2FBb2.foldableNonEmpty($78c799cba34fcb8d$export$92659ee1fc91a075);
var $78c799cba34fcb8d$export$465bfc9894c20a50 = {
    foldrWithIndex: function(f) {
        return function(b) {
            return function(xs) {
                var v = function() {
                    var rev = $78c799cba34fcb8d$var$foldl(function(v1) {
                        return function(a) {
                            return new $9MxTl.Tuple(v1.value0 + 1 | 0, new $78c799cba34fcb8d$export$74c44e616647f5c0(a, v1.value1));
                        };
                    });
                    return rev(new $9MxTl.Tuple(0, $78c799cba34fcb8d$export$c1bed610ade55e1c.value))(xs);
                }();
                return $9MxTl.snd($78c799cba34fcb8d$var$foldl(function(v1) {
                    return function(a) {
                        return new $9MxTl.Tuple(v1.value0 - 1 | 0, f(v1.value0 - 1 | 0)(a)(v1.value1));
                    };
                })(new $9MxTl.Tuple(v.value0, b))(v.value1));
            };
        };
    },
    foldlWithIndex: function(f) {
        return function(acc) {
            var $288 = $78c799cba34fcb8d$var$foldl(function(v) {
                return function(a) {
                    return new $9MxTl.Tuple(v.value0 + 1 | 0, f(v.value0)(v.value1)(a));
                };
            })(new $9MxTl.Tuple(0, acc));
            return function($289) {
                return $9MxTl.snd($288($289));
            };
        };
    },
    foldMapWithIndex: function(dictMonoid) {
        var append2 = $iwqgS.append(dictMonoid.Semigroup0());
        var mempty = $aknDF.mempty(dictMonoid);
        return function(f) {
            return $70sTh.foldlWithIndex($78c799cba34fcb8d$export$465bfc9894c20a50)(function(i) {
                return function(acc) {
                    var $290 = append2(acc);
                    var $291 = f(i);
                    return function($292) {
                        return $290($291($292));
                    };
                };
            })(mempty);
        };
    },
    Foldable0: function() {
        return $78c799cba34fcb8d$export$92659ee1fc91a075;
    }
};
var $78c799cba34fcb8d$var$foldableWithIndexNonEmpty = /* #__PURE__ */ $2FBb2.foldableWithIndexNonEmpty($78c799cba34fcb8d$export$465bfc9894c20a50);
var $78c799cba34fcb8d$var$foldMapWithIndex = /* #__PURE__ */ $70sTh.foldMapWithIndex($78c799cba34fcb8d$var$foldableWithIndexNonEmpty);
var $78c799cba34fcb8d$var$foldlWithIndex = /* #__PURE__ */ $70sTh.foldlWithIndex($78c799cba34fcb8d$var$foldableWithIndexNonEmpty);
var $78c799cba34fcb8d$var$foldrWithIndex = /* #__PURE__ */ $70sTh.foldrWithIndex($78c799cba34fcb8d$var$foldableWithIndexNonEmpty);
var $78c799cba34fcb8d$var$foldrWithIndex1 = /* #__PURE__ */ $70sTh.foldrWithIndex($78c799cba34fcb8d$export$465bfc9894c20a50);
var $78c799cba34fcb8d$var$foldlWithIndex1 = /* #__PURE__ */ $70sTh.foldlWithIndex($78c799cba34fcb8d$export$465bfc9894c20a50);
var $78c799cba34fcb8d$export$181d5b43cf38a79a = {
    foldMapWithIndex: function(dictMonoid) {
        var foldMapWithIndex1 = $78c799cba34fcb8d$var$foldMapWithIndex(dictMonoid);
        return function(f) {
            return function(v) {
                return foldMapWithIndex1(function() {
                    var $293 = $ykHdR.maybe(0)($78c799cba34fcb8d$var$add(1));
                    return function($294) {
                        return f($293($294));
                    };
                }())(v);
            };
        };
    },
    foldlWithIndex: function(f) {
        return function(b) {
            return function(v) {
                return $78c799cba34fcb8d$var$foldlWithIndex(function() {
                    var $295 = $ykHdR.maybe(0)($78c799cba34fcb8d$var$add(1));
                    return function($296) {
                        return f($295($296));
                    };
                }())(b)(v);
            };
        };
    },
    foldrWithIndex: function(f) {
        return function(b) {
            return function(v) {
                return $78c799cba34fcb8d$var$foldrWithIndex(function() {
                    var $297 = $ykHdR.maybe(0)($78c799cba34fcb8d$var$add(1));
                    return function($298) {
                        return f($297($298));
                    };
                }())(b)(v);
            };
        };
    },
    Foldable0: function() {
        return $78c799cba34fcb8d$export$604c31769a93bbe0;
    }
};
var $78c799cba34fcb8d$export$3951fb12c9649f2b = {
    mapWithIndex: function(f) {
        return $78c799cba34fcb8d$var$foldrWithIndex1(function(i) {
            return function(x) {
                return function(acc) {
                    return new $78c799cba34fcb8d$export$74c44e616647f5c0(f(i)(x), acc);
                };
            };
        })($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
    },
    Functor0: function() {
        return $78c799cba34fcb8d$export$40b9e4330ffd17e3;
    }
};
var $78c799cba34fcb8d$var$mapWithIndex = /* #__PURE__ */ $4oUwX.mapWithIndex(/* #__PURE__ */ $2FBb2.functorWithIndex($78c799cba34fcb8d$export$3951fb12c9649f2b));
var $78c799cba34fcb8d$export$116ff457f4ca2f6a = {
    mapWithIndex: function(fn) {
        return function(v) {
            return $78c799cba34fcb8d$var$mapWithIndex(function() {
                var $299 = $ykHdR.maybe(0)($78c799cba34fcb8d$var$add(1));
                return function($300) {
                    return fn($299($300));
                };
            }())(v);
        };
    },
    Functor0: function() {
        return $78c799cba34fcb8d$export$3c979cc7d75b024c;
    }
};
var $78c799cba34fcb8d$export$11cb7909a85856b = {
    append: function(xs) {
        return function(ys) {
            return $78c799cba34fcb8d$var$foldr($78c799cba34fcb8d$export$74c44e616647f5c0.create)(ys)(xs);
        };
    }
};
var $78c799cba34fcb8d$var$append1 = /* #__PURE__ */ $iwqgS.append($78c799cba34fcb8d$export$11cb7909a85856b);
var $78c799cba34fcb8d$export$14584e231e9c63ca = /* #__PURE__ */ function() {
    return {
        mempty: $78c799cba34fcb8d$export$c1bed610ade55e1c.value,
        Semigroup0: function() {
            return $78c799cba34fcb8d$export$11cb7909a85856b;
        }
    };
}();
var $78c799cba34fcb8d$export$a8cfc3dfdfca72cf = {
    append: function(v) {
        return function(as$prime) {
            return new $2FBb2.NonEmpty(v.value0, $78c799cba34fcb8d$var$append1(v.value1)($78c799cba34fcb8d$export$effcdbd76139450(as$prime)));
        };
    }
};
var $78c799cba34fcb8d$export$36831384a74c4427 = function(dictShow) {
    var show = $3Orkn.show(dictShow);
    return {
        show: function(v) {
            if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return "Nil";
            return "(" + ($78c799cba34fcb8d$var$intercalate(" : ")($78c799cba34fcb8d$var$map(show)(v)) + " : Nil)");
        }
    };
};
var $78c799cba34fcb8d$export$3a5290e21dfc0ad7 = function(dictShow) {
    var show = $3Orkn.show($2FBb2.showNonEmpty(dictShow)($78c799cba34fcb8d$export$36831384a74c4427(dictShow)));
    return {
        show: function(v) {
            return "(NonEmptyList " + (show(v) + ")");
        }
    };
};
var $78c799cba34fcb8d$export$99c2ce29c0ead637 = {
    traverse: function(dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        var map1 = $l0wDR.map(Apply0.Functor0());
        var lift2 = $a5g3C.lift2(Apply0);
        var pure1 = $gUTA8.pure(dictApplicative);
        return function(f) {
            var $301 = map1($78c799cba34fcb8d$var$foldl($l4M7e.flip($78c799cba34fcb8d$export$74c44e616647f5c0.create))($78c799cba34fcb8d$export$c1bed610ade55e1c.value));
            var $302 = $78c799cba34fcb8d$var$foldl(function(acc) {
                var $304 = lift2($l4M7e.flip($78c799cba34fcb8d$export$74c44e616647f5c0.create))(acc);
                return function($305) {
                    return $304(f($305));
                };
            })(pure1($78c799cba34fcb8d$export$c1bed610ade55e1c.value));
            return function($303) {
                return $301($302($303));
            };
        };
    },
    sequence: function(dictApplicative) {
        return $1wR1l.traverse($78c799cba34fcb8d$export$99c2ce29c0ead637)(dictApplicative)($78c799cba34fcb8d$var$identity);
    },
    Functor0: function() {
        return $78c799cba34fcb8d$export$40b9e4330ffd17e3;
    },
    Foldable1: function() {
        return $78c799cba34fcb8d$export$92659ee1fc91a075;
    }
};
var $78c799cba34fcb8d$export$d0a0d45336d2d3e3 = /* #__PURE__ */ $2FBb2.traversableNonEmpty($78c799cba34fcb8d$export$99c2ce29c0ead637);
var $78c799cba34fcb8d$export$aed77e3b7bbfc02d = {
    traverseWithIndex: function(dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        var map1 = $l0wDR.map(Apply0.Functor0());
        var lift2 = $a5g3C.lift2(Apply0);
        var pure1 = $gUTA8.pure(dictApplicative);
        return function(f) {
            var rev = $78c799cba34fcb8d$var$foldl($l4M7e.flip($78c799cba34fcb8d$export$74c44e616647f5c0.create))($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
            var $306 = map1(rev);
            var $307 = $78c799cba34fcb8d$var$foldlWithIndex1(function(i) {
                return function(acc) {
                    var $309 = lift2($l4M7e.flip($78c799cba34fcb8d$export$74c44e616647f5c0.create))(acc);
                    var $310 = f(i);
                    return function($311) {
                        return $309($310($311));
                    };
                };
            })(pure1($78c799cba34fcb8d$export$c1bed610ade55e1c.value));
            return function($308) {
                return $306($307($308));
            };
        };
    },
    FunctorWithIndex0: function() {
        return $78c799cba34fcb8d$export$3951fb12c9649f2b;
    },
    FoldableWithIndex1: function() {
        return $78c799cba34fcb8d$export$465bfc9894c20a50;
    },
    Traversable2: function() {
        return $78c799cba34fcb8d$export$99c2ce29c0ead637;
    }
};
var $78c799cba34fcb8d$var$traverseWithIndex = /* #__PURE__ */ $3OKRG.traverseWithIndex(/* #__PURE__ */ $2FBb2.traversableWithIndexNonEmpty($78c799cba34fcb8d$export$aed77e3b7bbfc02d));
var $78c799cba34fcb8d$export$29974dc3d1d7196b = {
    traverseWithIndex: function(dictApplicative) {
        var map1 = $l0wDR.map(dictApplicative.Apply0().Functor0());
        var traverseWithIndex1 = $78c799cba34fcb8d$var$traverseWithIndex(dictApplicative);
        return function(f) {
            return function(v) {
                return map1($78c799cba34fcb8d$export$ab241a3582569781)(traverseWithIndex1(function() {
                    var $312 = $ykHdR.maybe(0)($78c799cba34fcb8d$var$add(1));
                    return function($313) {
                        return f($312($313));
                    };
                }())(v));
            };
        };
    },
    FunctorWithIndex0: function() {
        return $78c799cba34fcb8d$export$116ff457f4ca2f6a;
    },
    FoldableWithIndex1: function() {
        return $78c799cba34fcb8d$export$181d5b43cf38a79a;
    },
    Traversable2: function() {
        return $78c799cba34fcb8d$export$d0a0d45336d2d3e3;
    }
};
var $78c799cba34fcb8d$export$c7fe2ca4bf0cb8df = {
    unfoldr1: function(f) {
        return function(b) {
            var go = function($copy_source) {
                return function($copy_memo) {
                    var $tco_var_source = $copy_source;
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(source, memo) {
                        var v = f(source);
                        if (v.value1 instanceof $ykHdR.Just) {
                            $tco_var_source = v.value1.value0;
                            $copy_memo = new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, memo);
                            return;
                        }
                        if (v.value1 instanceof $ykHdR.Nothing) {
                            $tco_done = true;
                            return $78c799cba34fcb8d$var$foldl($l4M7e.flip($78c799cba34fcb8d$export$74c44e616647f5c0.create))($78c799cba34fcb8d$export$c1bed610ade55e1c.value)(new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, memo));
                        }
                        throw new Error("Failed pattern match at Data.List.Types (line 135, column 22 - line 137, column 61): " + [
                            v.constructor.name
                        ]);
                    }
                    while(!$tco_done)$tco_result = $tco_loop($tco_var_source, $copy_memo);
                    return $tco_result;
                };
            };
            return go(b)($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
        };
    }
};
var $78c799cba34fcb8d$export$1d41caf0a0a6a680 = {
    unfoldr: function(f) {
        return function(b) {
            var go = function($copy_source) {
                return function($copy_memo) {
                    var $tco_var_source = $copy_source;
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(source, memo) {
                        var v = f(source);
                        if (v instanceof $ykHdR.Nothing) {
                            $tco_done = true;
                            return $78c799cba34fcb8d$var$foldl($l4M7e.flip($78c799cba34fcb8d$export$74c44e616647f5c0.create))($78c799cba34fcb8d$export$c1bed610ade55e1c.value)(memo);
                        }
                        if (v instanceof $ykHdR.Just) {
                            $tco_var_source = v.value0.value1;
                            $copy_memo = new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0.value0, memo);
                            return;
                        }
                        throw new Error("Failed pattern match at Data.List.Types (line 142, column 22 - line 144, column 52): " + [
                            v.constructor.name
                        ]);
                    }
                    while(!$tco_done)$tco_result = $tco_loop($tco_var_source, $copy_memo);
                    return $tco_result;
                };
            };
            return go(b)($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
        };
    },
    Unfoldable10: function() {
        return $78c799cba34fcb8d$export$c7fe2ca4bf0cb8df;
    }
};
var $78c799cba34fcb8d$export$6907256bb4275b5b = /* #__PURE__ */ $2FBb2.unfoldable1NonEmpty($78c799cba34fcb8d$export$1d41caf0a0a6a680);
var $78c799cba34fcb8d$export$b16c60cd2a91c938 = /* #__PURE__ */ $2FBb2.foldable1NonEmpty($78c799cba34fcb8d$export$92659ee1fc91a075);
var $78c799cba34fcb8d$export$44a6d15320cfc4c5 = {
    extend: function(f) {
        return function(v) {
            var go = function(a) {
                return function(v1) {
                    return {
                        val: new $78c799cba34fcb8d$export$74c44e616647f5c0(f(new $2FBb2.NonEmpty(a, v1.acc)), v1.val),
                        acc: new $78c799cba34fcb8d$export$74c44e616647f5c0(a, v1.acc)
                    };
                };
            };
            return new $2FBb2.NonEmpty(f(v), $78c799cba34fcb8d$var$foldr(go)({
                val: $78c799cba34fcb8d$export$c1bed610ade55e1c.value,
                acc: $78c799cba34fcb8d$export$c1bed610ade55e1c.value
            })(v.value1).val);
        };
    },
    Functor0: function() {
        return $78c799cba34fcb8d$export$3c979cc7d75b024c;
    }
};
var $78c799cba34fcb8d$export$a2b02e086d468c06 = {
    extend: function(v) {
        return function(v1) {
            if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
            if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                var go = function(a$prime) {
                    return function(v2) {
                        var acc$prime = new $78c799cba34fcb8d$export$74c44e616647f5c0(a$prime, v2.acc);
                        return {
                            val: new $78c799cba34fcb8d$export$74c44e616647f5c0(v(acc$prime), v2.val),
                            acc: acc$prime
                        };
                    };
                };
                return new $78c799cba34fcb8d$export$74c44e616647f5c0(v(v1), $78c799cba34fcb8d$var$foldr(go)({
                    val: $78c799cba34fcb8d$export$c1bed610ade55e1c.value,
                    acc: $78c799cba34fcb8d$export$c1bed610ade55e1c.value
                })(v1.value1).val);
            }
            throw new Error("Failed pattern match at Data.List.Types (line 180, column 1 - line 187, column 42): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    Functor0: function() {
        return $78c799cba34fcb8d$export$40b9e4330ffd17e3;
    }
};
var $78c799cba34fcb8d$export$b7e705972f3b8317 = {
    eq1: function(dictEq) {
        var eq = $4MBcA.eq(dictEq);
        return function(xs) {
            return function(ys) {
                var go = function($copy_v) {
                    return function($copy_v1) {
                        return function($copy_v2) {
                            var $tco_var_v = $copy_v;
                            var $tco_var_v1 = $copy_v1;
                            var $tco_done = false;
                            var $tco_result;
                            function $tco_loop(v, v1, v2) {
                                if (!v2) {
                                    $tco_done = true;
                                    return false;
                                }
                                if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c && v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                                    $tco_done = true;
                                    return v2;
                                }
                                if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                                    $tco_var_v = v.value1;
                                    $tco_var_v1 = v1.value1;
                                    $copy_v2 = v2 && eq(v1.value0)(v.value0);
                                    return;
                                }
                                $tco_done = true;
                                return false;
                            }
                            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $tco_var_v1, $copy_v2);
                            return $tco_result;
                        };
                    };
                };
                return go(xs)(ys)(true);
            };
        };
    }
};
var $78c799cba34fcb8d$var$eq1 = /* #__PURE__ */ $4MBcA.eq1($78c799cba34fcb8d$export$b7e705972f3b8317);
var $78c799cba34fcb8d$var$eqNonEmpty = /* #__PURE__ */ $2FBb2.eqNonEmpty($78c799cba34fcb8d$export$b7e705972f3b8317);
var $78c799cba34fcb8d$export$80901a10e94c964a = /* #__PURE__ */ $2FBb2.eq1NonEmpty($78c799cba34fcb8d$export$b7e705972f3b8317);
var $78c799cba34fcb8d$export$1ae88a7f3c5f59ef = function(dictEq) {
    return {
        eq: $78c799cba34fcb8d$var$eq1(dictEq)
    };
};
var $78c799cba34fcb8d$export$25985b0447eac39b = function(dictEq) {
    return $78c799cba34fcb8d$var$eqNonEmpty(dictEq);
};
var $78c799cba34fcb8d$export$a37dd417b96243af = {
    compare1: function(dictOrd) {
        var compare = $d0PPW.compare(dictOrd);
        return function(xs) {
            return function(ys) {
                var go = function($copy_v) {
                    return function($copy_v1) {
                        var $tco_var_v = $copy_v;
                        var $tco_done = false;
                        var $tco_result;
                        function $tco_loop(v, v1) {
                            if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c && v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                                $tco_done = true;
                                return $6SDUu.EQ.value;
                            }
                            if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                                $tco_done = true;
                                return $6SDUu.LT.value;
                            }
                            if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                                $tco_done = true;
                                return $6SDUu.GT.value;
                            }
                            if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                                var v2 = compare(v.value0)(v1.value0);
                                if (v2 instanceof $6SDUu.EQ) {
                                    $tco_var_v = v.value1;
                                    $copy_v1 = v1.value1;
                                    return;
                                }
                                $tco_done = true;
                                return v2;
                            }
                            throw new Error("Failed pattern match at Data.List.Types (line 60, column 5 - line 60, column 20): " + [
                                v.constructor.name,
                                v1.constructor.name
                            ]);
                        }
                        while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
                        return $tco_result;
                    };
                };
                return go(xs)(ys);
            };
        };
    },
    Eq10: function() {
        return $78c799cba34fcb8d$export$b7e705972f3b8317;
    }
};
var $78c799cba34fcb8d$var$compare1 = /* #__PURE__ */ $d0PPW.compare1($78c799cba34fcb8d$export$a37dd417b96243af);
var $78c799cba34fcb8d$var$ordNonEmpty = /* #__PURE__ */ $2FBb2.ordNonEmpty($78c799cba34fcb8d$export$a37dd417b96243af);
var $78c799cba34fcb8d$export$bf20701e75931fe8 = /* #__PURE__ */ $2FBb2.ord1NonEmpty($78c799cba34fcb8d$export$a37dd417b96243af);
var $78c799cba34fcb8d$export$86359cd4476084f8 = function(dictOrd) {
    var eqList1 = $78c799cba34fcb8d$export$1ae88a7f3c5f59ef(dictOrd.Eq0());
    return {
        compare: $78c799cba34fcb8d$var$compare1(dictOrd),
        Eq0: function() {
            return eqList1;
        }
    };
};
var $78c799cba34fcb8d$export$783a13ebf5a1203d = function(dictOrd) {
    return $78c799cba34fcb8d$var$ordNonEmpty(dictOrd);
};
var $78c799cba34fcb8d$export$7bc4d4de9c57db1f = {
    extract: function(v) {
        return v.value0;
    },
    Extend0: function() {
        return $78c799cba34fcb8d$export$44a6d15320cfc4c5;
    }
};
var $78c799cba34fcb8d$export$7e49f2fa1ca16fbc = {
    apply: function(v) {
        return function(v1) {
            if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
            if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return $78c799cba34fcb8d$var$append1($78c799cba34fcb8d$var$map(v.value0)(v1))($a5g3C.apply($78c799cba34fcb8d$export$7e49f2fa1ca16fbc)(v.value1)(v1));
            throw new Error("Failed pattern match at Data.List.Types (line 157, column 1 - line 159, column 48): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    Functor0: function() {
        return $78c799cba34fcb8d$export$40b9e4330ffd17e3;
    }
};
var $78c799cba34fcb8d$var$apply = /* #__PURE__ */ $a5g3C.apply($78c799cba34fcb8d$export$7e49f2fa1ca16fbc);
var $78c799cba34fcb8d$export$18f1a42667f2921e = {
    apply: function(v) {
        return function(v1) {
            return new $2FBb2.NonEmpty(v.value0(v1.value0), $78c799cba34fcb8d$var$append1($78c799cba34fcb8d$var$apply(v.value1)(new $78c799cba34fcb8d$export$74c44e616647f5c0(v1.value0, $78c799cba34fcb8d$export$c1bed610ade55e1c.value)))($78c799cba34fcb8d$var$apply(new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, v.value1))(v1.value1)));
        };
    },
    Functor0: function() {
        return $78c799cba34fcb8d$export$3c979cc7d75b024c;
    }
};
var $78c799cba34fcb8d$export$497dcf96eb2383ec = {
    bind: function(v) {
        return function(v1) {
            if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
            if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return $78c799cba34fcb8d$var$append1(v1(v.value0))($9Grh5.bind($78c799cba34fcb8d$export$497dcf96eb2383ec)(v.value1)(v1));
            throw new Error("Failed pattern match at Data.List.Types (line 164, column 1 - line 166, column 37): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    Apply0: function() {
        return $78c799cba34fcb8d$export$7e49f2fa1ca16fbc;
    }
};
var $78c799cba34fcb8d$var$bind = /* #__PURE__ */ $9Grh5.bind($78c799cba34fcb8d$export$497dcf96eb2383ec);
var $78c799cba34fcb8d$export$12e3398ee6f4a417 = {
    bind: function(v) {
        return function(f) {
            var v1 = f(v.value0);
            return new $2FBb2.NonEmpty(v1.value0, $78c799cba34fcb8d$var$append1(v1.value1)($78c799cba34fcb8d$var$bind(v.value1)(function($314) {
                return $78c799cba34fcb8d$export$effcdbd76139450(f($314));
            })));
        };
    },
    Apply0: function() {
        return $78c799cba34fcb8d$export$18f1a42667f2921e;
    }
};
var $78c799cba34fcb8d$export$25cda6d3e08b28fe = {
    pure: function(a) {
        return new $78c799cba34fcb8d$export$74c44e616647f5c0(a, $78c799cba34fcb8d$export$c1bed610ade55e1c.value);
    },
    Apply0: function() {
        return $78c799cba34fcb8d$export$7e49f2fa1ca16fbc;
    }
};
var $78c799cba34fcb8d$export$7c78e86b21f51881 = {
    Applicative0: function() {
        return $78c799cba34fcb8d$export$25cda6d3e08b28fe;
    },
    Bind1: function() {
        return $78c799cba34fcb8d$export$497dcf96eb2383ec;
    }
};
var $78c799cba34fcb8d$export$852a754cd45a1ed = {
    alt: /* #__PURE__ */ $iwqgS.append($78c799cba34fcb8d$export$a8cfc3dfdfca72cf),
    Functor0: function() {
        return $78c799cba34fcb8d$export$3c979cc7d75b024c;
    }
};
var $78c799cba34fcb8d$export$97980ce7ea95015b = {
    alt: $78c799cba34fcb8d$var$append1,
    Functor0: function() {
        return $78c799cba34fcb8d$export$40b9e4330ffd17e3;
    }
};
var $78c799cba34fcb8d$export$55d622505c452dcb = /* #__PURE__ */ function() {
    return {
        empty: $78c799cba34fcb8d$export$c1bed610ade55e1c.value,
        Alt0: function() {
            return $78c799cba34fcb8d$export$97980ce7ea95015b;
        }
    };
}();
var $78c799cba34fcb8d$export$503ce72759d93980 = {
    Applicative0: function() {
        return $78c799cba34fcb8d$export$25cda6d3e08b28fe;
    },
    Plus1: function() {
        return $78c799cba34fcb8d$export$55d622505c452dcb;
    }
};
var $78c799cba34fcb8d$export$9ea554ee3c75e458 = {
    Monad0: function() {
        return $78c799cba34fcb8d$export$7c78e86b21f51881;
    },
    Alternative1: function() {
        return $78c799cba34fcb8d$export$503ce72759d93980;
    }
};
var $78c799cba34fcb8d$export$e5d0ed5dac805e10 = {
    pure: /* #__PURE__ */ function() {
        var $315 = $2FBb2.singleton($78c799cba34fcb8d$export$55d622505c452dcb);
        return function($316) {
            return $78c799cba34fcb8d$export$ab241a3582569781($315($316));
        };
    }(),
    Apply0: function() {
        return $78c799cba34fcb8d$export$18f1a42667f2921e;
    }
};
var $78c799cba34fcb8d$var$pure = /* #__PURE__ */ $gUTA8.pure($78c799cba34fcb8d$export$e5d0ed5dac805e10);
var $78c799cba34fcb8d$export$f444cc7484072e62 = {
    Applicative0: function() {
        return $78c799cba34fcb8d$export$e5d0ed5dac805e10;
    },
    Bind1: function() {
        return $78c799cba34fcb8d$export$12e3398ee6f4a417;
    }
};
var $78c799cba34fcb8d$export$fac1bbd0707bc766 = {
    traverse1: function(dictApply) {
        var Functor0 = dictApply.Functor0();
        var mapFlipped = $l0wDR.mapFlipped(Functor0);
        var lift2 = $a5g3C.lift2(dictApply);
        var map1 = $l0wDR.map(Functor0);
        return function(f) {
            return function(v) {
                return mapFlipped($78c799cba34fcb8d$var$foldl(function(acc) {
                    var $317 = lift2($l4M7e.flip($78c799cba34fcb8d$export$4fa915e2865b1814))(acc);
                    return function($318) {
                        return $317(f($318));
                    };
                })(map1($78c799cba34fcb8d$var$pure)(f(v.value0)))(v.value1))(function(v1) {
                    return $78c799cba34fcb8d$var$foldl($l4M7e.flip($78c799cba34fcb8d$export$4fa915e2865b1814))($78c799cba34fcb8d$var$pure(v1.value0))(v1.value1);
                });
            };
        };
    },
    sequence1: function(dictApply) {
        return $jERGJ.traverse1($78c799cba34fcb8d$export$fac1bbd0707bc766)(dictApply)($78c799cba34fcb8d$var$identity);
    },
    Foldable10: function() {
        return $78c799cba34fcb8d$export$b16c60cd2a91c938;
    },
    Traversable1: function() {
        return $78c799cba34fcb8d$export$d0a0d45336d2d3e3;
    }
};

});
parcelRegister("70sTh", function(module, exports) {

$parcel$export(module.exports, "foldrWithIndex", () => $519ef1967f17d101$export$d859ed9adfa064ca);
$parcel$export(module.exports, "forWithIndex_", () => $519ef1967f17d101$export$f441c83f81b7710f);
$parcel$export(module.exports, "foldlWithIndex", () => $519ef1967f17d101$export$2d70b9efb960f478);
$parcel$export(module.exports, "foldableWithIndexTuple", () => $519ef1967f17d101$export$a0208fa03195d5a3);
$parcel$export(module.exports, "foldableWithIndexMultiplicative", () => $519ef1967f17d101$export$e07746a44d4d0673);
$parcel$export(module.exports, "foldableWithIndexMaybe", () => $519ef1967f17d101$export$db675654cef60b9a);
$parcel$export(module.exports, "foldableWithIndexLast", () => $519ef1967f17d101$export$3a92905df29453fa);
$parcel$export(module.exports, "foldableWithIndexIdentity", () => $519ef1967f17d101$export$92c42163dd2c46ce);
$parcel$export(module.exports, "foldableWithIndexFirst", () => $519ef1967f17d101$export$328d1f7f0045c999);
$parcel$export(module.exports, "foldableWithIndexEither", () => $519ef1967f17d101$export$617fc130b23797ca);
$parcel$export(module.exports, "foldableWithIndexDual", () => $519ef1967f17d101$export$dc8026a24f95d0a9);
$parcel$export(module.exports, "foldableWithIndexDisj", () => $519ef1967f17d101$export$a77c731c3b37cfd);
$parcel$export(module.exports, "foldableWithIndexConst", () => $519ef1967f17d101$export$1add8b24fb58b747);
$parcel$export(module.exports, "foldableWithIndexConj", () => $519ef1967f17d101$export$707470fe74326665);
$parcel$export(module.exports, "foldableWithIndexAdditive", () => $519ef1967f17d101$export$f9ed9b5a8131479e);
$parcel$export(module.exports, "foldableWithIndexArray", () => $519ef1967f17d101$export$e728f47f20b1eb28);
$parcel$export(module.exports, "foldMapWithIndex", () => $519ef1967f17d101$export$18153bb1181268e5);
$parcel$export(module.exports, "foldableWithIndexApp", () => $519ef1967f17d101$export$ca1485f10f9ca9ee);
$parcel$export(module.exports, "foldableWithIndexCompose", () => $519ef1967f17d101$export$ed9dddd4d2a66e4d);
$parcel$export(module.exports, "foldableWithIndexCoproduct", () => $519ef1967f17d101$export$c8998bd70c04c75d);
$parcel$export(module.exports, "foldableWithIndexProduct", () => $519ef1967f17d101$export$e0fd1e7d0cab0fb2);
// Generated by purs version 0.15.16

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $9Grh5 = parcelRequire("9Grh5");

var $7T8P4 = parcelRequire("7T8P4");

var $aKY4H = parcelRequire("aKY4H");

var $6RkEA = parcelRequire("6RkEA");

var $l4M7e = parcelRequire("l4M7e");

var $6gSOm = parcelRequire("6gSOm");

var $4oUwX = parcelRequire("4oUwX");

var $ykHdR = parcelRequire("ykHdR");

var $aknDF = parcelRequire("aknDF");

var $8JeQl = parcelRequire("8JeQl");

var $1zczT = parcelRequire("1zczT");

var $bbOAS = parcelRequire("bbOAS");

var $7wVLo = parcelRequire("7wVLo");

var $6PW1p = parcelRequire("6PW1p");

var $iwqgS = parcelRequire("iwqgS");

var $9MxTl = parcelRequire("9MxTl");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");
var $519ef1967f17d101$var$foldr = /* #__PURE__ */ $6RkEA.foldr($6RkEA.foldableMultiplicative);
var $519ef1967f17d101$var$foldl = /* #__PURE__ */ $6RkEA.foldl($6RkEA.foldableMultiplicative);
var $519ef1967f17d101$var$foldMap = /* #__PURE__ */ $6RkEA.foldMap($6RkEA.foldableMultiplicative);
var $519ef1967f17d101$var$foldr1 = /* #__PURE__ */ $6RkEA.foldr($6RkEA.foldableMaybe);
var $519ef1967f17d101$var$foldl1 = /* #__PURE__ */ $6RkEA.foldl($6RkEA.foldableMaybe);
var $519ef1967f17d101$var$foldMap1 = /* #__PURE__ */ $6RkEA.foldMap($6RkEA.foldableMaybe);
var $519ef1967f17d101$var$foldr2 = /* #__PURE__ */ $6RkEA.foldr($6RkEA.foldableLast);
var $519ef1967f17d101$var$foldl2 = /* #__PURE__ */ $6RkEA.foldl($6RkEA.foldableLast);
var $519ef1967f17d101$var$foldMap2 = /* #__PURE__ */ $6RkEA.foldMap($6RkEA.foldableLast);
var $519ef1967f17d101$var$foldr3 = /* #__PURE__ */ $6RkEA.foldr($6RkEA.foldableFirst);
var $519ef1967f17d101$var$foldl3 = /* #__PURE__ */ $6RkEA.foldl($6RkEA.foldableFirst);
var $519ef1967f17d101$var$foldMap3 = /* #__PURE__ */ $6RkEA.foldMap($6RkEA.foldableFirst);
var $519ef1967f17d101$var$foldr4 = /* #__PURE__ */ $6RkEA.foldr($6RkEA.foldableDual);
var $519ef1967f17d101$var$foldl4 = /* #__PURE__ */ $6RkEA.foldl($6RkEA.foldableDual);
var $519ef1967f17d101$var$foldMap4 = /* #__PURE__ */ $6RkEA.foldMap($6RkEA.foldableDual);
var $519ef1967f17d101$var$foldr5 = /* #__PURE__ */ $6RkEA.foldr($6RkEA.foldableDisj);
var $519ef1967f17d101$var$foldl5 = /* #__PURE__ */ $6RkEA.foldl($6RkEA.foldableDisj);
var $519ef1967f17d101$var$foldMap5 = /* #__PURE__ */ $6RkEA.foldMap($6RkEA.foldableDisj);
var $519ef1967f17d101$var$foldr6 = /* #__PURE__ */ $6RkEA.foldr($6RkEA.foldableConj);
var $519ef1967f17d101$var$foldl6 = /* #__PURE__ */ $6RkEA.foldl($6RkEA.foldableConj);
var $519ef1967f17d101$var$foldMap6 = /* #__PURE__ */ $6RkEA.foldMap($6RkEA.foldableConj);
var $519ef1967f17d101$var$foldr7 = /* #__PURE__ */ $6RkEA.foldr($6RkEA.foldableAdditive);
var $519ef1967f17d101$var$foldl7 = /* #__PURE__ */ $6RkEA.foldl($6RkEA.foldableAdditive);
var $519ef1967f17d101$var$foldMap7 = /* #__PURE__ */ $6RkEA.foldMap($6RkEA.foldableAdditive);
var $519ef1967f17d101$var$foldr8 = /* #__PURE__ */ $6RkEA.foldr($6RkEA.foldableArray);
var $519ef1967f17d101$var$mapWithIndex = /* #__PURE__ */ $4oUwX.mapWithIndex($4oUwX.functorWithIndexArray);
var $519ef1967f17d101$var$foldl8 = /* #__PURE__ */ $6RkEA.foldl($6RkEA.foldableArray);
var $519ef1967f17d101$var$unwrap = /* #__PURE__ */ $6PW1p.unwrap();
var $519ef1967f17d101$var$monoidEndo = /* #__PURE__ */ $7wVLo.monoidEndo($7T8P4.categoryFn);
var $519ef1967f17d101$var$monoidDual = /* #__PURE__ */ $bbOAS.monoidDual($519ef1967f17d101$var$monoidEndo);
var $519ef1967f17d101$export$d859ed9adfa064ca = function(dict) {
    return dict.foldrWithIndex;
};
var $519ef1967f17d101$export$d13ff16378fefe83 = function(dictApplicative) {
    var applySecond = $a5g3C.applySecond(dictApplicative.Apply0());
    var pure = $gUTA8.pure(dictApplicative);
    return function(dictFoldableWithIndex) {
        var foldrWithIndex1 = $519ef1967f17d101$export$d859ed9adfa064ca(dictFoldableWithIndex);
        return function(f) {
            return foldrWithIndex1(function(i) {
                var $289 = f(i);
                return function($290) {
                    return applySecond($289($290));
                };
            })(pure($r2HHk.unit));
        };
    };
};
var $519ef1967f17d101$export$f441c83f81b7710f = function(dictApplicative) {
    var traverseWithIndex_1 = $519ef1967f17d101$export$d13ff16378fefe83(dictApplicative);
    return function(dictFoldableWithIndex) {
        return $l4M7e.flip(traverseWithIndex_1(dictFoldableWithIndex));
    };
};
var $519ef1967f17d101$export$9b986141719153e = function(dictFoldableWithIndex) {
    var foldrWithIndex1 = $519ef1967f17d101$export$d859ed9adfa064ca(dictFoldableWithIndex);
    return function(f) {
        return foldrWithIndex1($l4M7e.const(f));
    };
};
var $519ef1967f17d101$export$2d70b9efb960f478 = function(dict) {
    return dict.foldlWithIndex;
};
var $519ef1967f17d101$export$e623e8bf74059b22 = function(dictFoldableWithIndex) {
    var foldlWithIndex1 = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex);
    return function(f) {
        return foldlWithIndex1($l4M7e.const(f));
    };
};
var $519ef1967f17d101$export$a0208fa03195d5a3 = {
    foldrWithIndex: function(f) {
        return function(z) {
            return function(v) {
                return f($r2HHk.unit)(v.value1)(z);
            };
        };
    },
    foldlWithIndex: function(f) {
        return function(z) {
            return function(v) {
                return f($r2HHk.unit)(z)(v.value1);
            };
        };
    },
    foldMapWithIndex: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return f($r2HHk.unit)(v.value1);
            };
        };
    },
    Foldable0: function() {
        return $6RkEA.foldableTuple;
    }
};
var $519ef1967f17d101$export$e07746a44d4d0673 = {
    foldrWithIndex: function(f) {
        return $519ef1967f17d101$var$foldr(f($r2HHk.unit));
    },
    foldlWithIndex: function(f) {
        return $519ef1967f17d101$var$foldl(f($r2HHk.unit));
    },
    foldMapWithIndex: function(dictMonoid) {
        var foldMap8 = $519ef1967f17d101$var$foldMap(dictMonoid);
        return function(f) {
            return foldMap8(f($r2HHk.unit));
        };
    },
    Foldable0: function() {
        return $6RkEA.foldableMultiplicative;
    }
};
var $519ef1967f17d101$export$db675654cef60b9a = {
    foldrWithIndex: function(f) {
        return $519ef1967f17d101$var$foldr1(f($r2HHk.unit));
    },
    foldlWithIndex: function(f) {
        return $519ef1967f17d101$var$foldl1(f($r2HHk.unit));
    },
    foldMapWithIndex: function(dictMonoid) {
        var foldMap8 = $519ef1967f17d101$var$foldMap1(dictMonoid);
        return function(f) {
            return foldMap8(f($r2HHk.unit));
        };
    },
    Foldable0: function() {
        return $6RkEA.foldableMaybe;
    }
};
var $519ef1967f17d101$export$3a92905df29453fa = {
    foldrWithIndex: function(f) {
        return $519ef1967f17d101$var$foldr2(f($r2HHk.unit));
    },
    foldlWithIndex: function(f) {
        return $519ef1967f17d101$var$foldl2(f($r2HHk.unit));
    },
    foldMapWithIndex: function(dictMonoid) {
        var foldMap8 = $519ef1967f17d101$var$foldMap2(dictMonoid);
        return function(f) {
            return foldMap8(f($r2HHk.unit));
        };
    },
    Foldable0: function() {
        return $6RkEA.foldableLast;
    }
};
var $519ef1967f17d101$export$92c42163dd2c46ce = {
    foldrWithIndex: function(f) {
        return function(z) {
            return function(v) {
                return f($r2HHk.unit)(v)(z);
            };
        };
    },
    foldlWithIndex: function(f) {
        return function(z) {
            return function(v) {
                return f($r2HHk.unit)(z)(v);
            };
        };
    },
    foldMapWithIndex: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return f($r2HHk.unit)(v);
            };
        };
    },
    Foldable0: function() {
        return $6RkEA.foldableIdentity;
    }
};
var $519ef1967f17d101$export$328d1f7f0045c999 = {
    foldrWithIndex: function(f) {
        return $519ef1967f17d101$var$foldr3(f($r2HHk.unit));
    },
    foldlWithIndex: function(f) {
        return $519ef1967f17d101$var$foldl3(f($r2HHk.unit));
    },
    foldMapWithIndex: function(dictMonoid) {
        var foldMap8 = $519ef1967f17d101$var$foldMap3(dictMonoid);
        return function(f) {
            return foldMap8(f($r2HHk.unit));
        };
    },
    Foldable0: function() {
        return $6RkEA.foldableFirst;
    }
};
var $519ef1967f17d101$export$617fc130b23797ca = {
    foldrWithIndex: function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $aKY4H.Left) return v1;
                if (v2 instanceof $aKY4H.Right) return v($r2HHk.unit)(v2.value0)(v1);
                throw new Error("Failed pattern match at Data.FoldableWithIndex (line 164, column 1 - line 170, column 42): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    },
    foldlWithIndex: function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $aKY4H.Left) return v1;
                if (v2 instanceof $aKY4H.Right) return v($r2HHk.unit)(v1)(v2.value0);
                throw new Error("Failed pattern match at Data.FoldableWithIndex (line 164, column 1 - line 170, column 42): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    },
    foldMapWithIndex: function(dictMonoid) {
        var mempty = $aknDF.mempty(dictMonoid);
        return function(v) {
            return function(v1) {
                if (v1 instanceof $aKY4H.Left) return mempty;
                if (v1 instanceof $aKY4H.Right) return v($r2HHk.unit)(v1.value0);
                throw new Error("Failed pattern match at Data.FoldableWithIndex (line 164, column 1 - line 170, column 42): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    },
    Foldable0: function() {
        return $6RkEA.foldableEither;
    }
};
var $519ef1967f17d101$export$dc8026a24f95d0a9 = {
    foldrWithIndex: function(f) {
        return $519ef1967f17d101$var$foldr4(f($r2HHk.unit));
    },
    foldlWithIndex: function(f) {
        return $519ef1967f17d101$var$foldl4(f($r2HHk.unit));
    },
    foldMapWithIndex: function(dictMonoid) {
        var foldMap8 = $519ef1967f17d101$var$foldMap4(dictMonoid);
        return function(f) {
            return foldMap8(f($r2HHk.unit));
        };
    },
    Foldable0: function() {
        return $6RkEA.foldableDual;
    }
};
var $519ef1967f17d101$export$a77c731c3b37cfd = {
    foldrWithIndex: function(f) {
        return $519ef1967f17d101$var$foldr5(f($r2HHk.unit));
    },
    foldlWithIndex: function(f) {
        return $519ef1967f17d101$var$foldl5(f($r2HHk.unit));
    },
    foldMapWithIndex: function(dictMonoid) {
        var foldMap8 = $519ef1967f17d101$var$foldMap5(dictMonoid);
        return function(f) {
            return foldMap8(f($r2HHk.unit));
        };
    },
    Foldable0: function() {
        return $6RkEA.foldableDisj;
    }
};
var $519ef1967f17d101$export$1add8b24fb58b747 = {
    foldrWithIndex: function(v) {
        return function(z) {
            return function(v1) {
                return z;
            };
        };
    },
    foldlWithIndex: function(v) {
        return function(z) {
            return function(v1) {
                return z;
            };
        };
    },
    foldMapWithIndex: function(dictMonoid) {
        var mempty = $aknDF.mempty(dictMonoid);
        return function(v) {
            return function(v1) {
                return mempty;
            };
        };
    },
    Foldable0: function() {
        return $6RkEA.foldableConst;
    }
};
var $519ef1967f17d101$export$707470fe74326665 = {
    foldrWithIndex: function(f) {
        return $519ef1967f17d101$var$foldr6(f($r2HHk.unit));
    },
    foldlWithIndex: function(f) {
        return $519ef1967f17d101$var$foldl6(f($r2HHk.unit));
    },
    foldMapWithIndex: function(dictMonoid) {
        var foldMap8 = $519ef1967f17d101$var$foldMap6(dictMonoid);
        return function(f) {
            return foldMap8(f($r2HHk.unit));
        };
    },
    Foldable0: function() {
        return $6RkEA.foldableConj;
    }
};
var $519ef1967f17d101$export$f9ed9b5a8131479e = {
    foldrWithIndex: function(f) {
        return $519ef1967f17d101$var$foldr7(f($r2HHk.unit));
    },
    foldlWithIndex: function(f) {
        return $519ef1967f17d101$var$foldl7(f($r2HHk.unit));
    },
    foldMapWithIndex: function(dictMonoid) {
        var foldMap8 = $519ef1967f17d101$var$foldMap7(dictMonoid);
        return function(f) {
            return foldMap8(f($r2HHk.unit));
        };
    },
    Foldable0: function() {
        return $6RkEA.foldableAdditive;
    }
};
var $519ef1967f17d101$export$ca16238ae0303ef0 = function(dictFoldableWithIndex) {
    var foldlWithIndex1 = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex);
    return function(dictMonad) {
        var bind = $9Grh5.bind(dictMonad.Bind1());
        var pure = $gUTA8.pure(dictMonad.Applicative0());
        return function(f) {
            return function(a0) {
                return foldlWithIndex1(function(i) {
                    return function(ma) {
                        return function(b) {
                            return bind(ma)($l4M7e.flip(f(i))(b));
                        };
                    };
                })(pure(a0));
            };
        };
    };
};
var $519ef1967f17d101$export$998b3d14abdd8136 = function(dictFoldableWithIndex) {
    var foldrWithIndex1 = $519ef1967f17d101$export$d859ed9adfa064ca(dictFoldableWithIndex);
    return function(dictMonoid) {
        var append = $iwqgS.append(dictMonoid.Semigroup0());
        var mempty = $aknDF.mempty(dictMonoid);
        return function(f) {
            return foldrWithIndex1(function(i) {
                return function(x) {
                    return function(acc) {
                        return append(f(i)(x))(acc);
                    };
                };
            })(mempty);
        };
    };
};
var $519ef1967f17d101$export$e728f47f20b1eb28 = {
    foldrWithIndex: function(f) {
        return function(z) {
            var $291 = $519ef1967f17d101$var$foldr8(function(v) {
                return function(y) {
                    return f(v.value0)(v.value1)(y);
                };
            })(z);
            var $292 = $519ef1967f17d101$var$mapWithIndex($9MxTl.Tuple.create);
            return function($293) {
                return $291($292($293));
            };
        };
    },
    foldlWithIndex: function(f) {
        return function(z) {
            var $294 = $519ef1967f17d101$var$foldl8(function(y) {
                return function(v) {
                    return f(v.value0)(y)(v.value1);
                };
            })(z);
            var $295 = $519ef1967f17d101$var$mapWithIndex($9MxTl.Tuple.create);
            return function($296) {
                return $294($295($296));
            };
        };
    },
    foldMapWithIndex: function(dictMonoid) {
        return $519ef1967f17d101$export$998b3d14abdd8136($519ef1967f17d101$export$e728f47f20b1eb28)(dictMonoid);
    },
    Foldable0: function() {
        return $6RkEA.foldableArray;
    }
};
var $519ef1967f17d101$export$d58f3ffea0efd404 = function(dictFoldableWithIndex) {
    var foldlWithIndex1 = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex);
    return function(dictMonoid) {
        var append = $iwqgS.append(dictMonoid.Semigroup0());
        var mempty = $aknDF.mempty(dictMonoid);
        return function(f) {
            return foldlWithIndex1(function(i) {
                return function(acc) {
                    return function(x) {
                        return append(acc)(f(i)(x));
                    };
                };
            })(mempty);
        };
    };
};
var $519ef1967f17d101$export$18153bb1181268e5 = function(dict) {
    return dict.foldMapWithIndex;
};
var $519ef1967f17d101$export$ca1485f10f9ca9ee = function(dictFoldableWithIndex) {
    var foldrWithIndex1 = $519ef1967f17d101$export$d859ed9adfa064ca(dictFoldableWithIndex);
    var foldlWithIndex1 = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex);
    var foldMapWithIndex1 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex);
    var foldableApp = $6RkEA.foldableApp(dictFoldableWithIndex.Foldable0());
    return {
        foldrWithIndex: function(f) {
            return function(z) {
                return function(v) {
                    return foldrWithIndex1(f)(z)(v);
                };
            };
        },
        foldlWithIndex: function(f) {
            return function(z) {
                return function(v) {
                    return foldlWithIndex1(f)(z)(v);
                };
            };
        },
        foldMapWithIndex: function(dictMonoid) {
            var foldMapWithIndex2 = foldMapWithIndex1(dictMonoid);
            return function(f) {
                return function(v) {
                    return foldMapWithIndex2(f)(v);
                };
            };
        },
        Foldable0: function() {
            return foldableApp;
        }
    };
};
var $519ef1967f17d101$export$ed9dddd4d2a66e4d = function(dictFoldableWithIndex) {
    var foldrWithIndex1 = $519ef1967f17d101$export$d859ed9adfa064ca(dictFoldableWithIndex);
    var foldlWithIndex1 = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex);
    var foldMapWithIndex1 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex);
    var foldableCompose = $6RkEA.foldableCompose(dictFoldableWithIndex.Foldable0());
    return function(dictFoldableWithIndex1) {
        var foldrWithIndex2 = $519ef1967f17d101$export$d859ed9adfa064ca(dictFoldableWithIndex1);
        var foldlWithIndex2 = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex1);
        var foldMapWithIndex2 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex1);
        var foldableCompose1 = foldableCompose(dictFoldableWithIndex1.Foldable0());
        return {
            foldrWithIndex: function(f) {
                return function(i) {
                    return function(v) {
                        return foldrWithIndex1(function(a) {
                            return $l4M7e.flip(foldrWithIndex2($9MxTl.curry(f)(a)));
                        })(i)(v);
                    };
                };
            },
            foldlWithIndex: function(f) {
                return function(i) {
                    return function(v) {
                        return foldlWithIndex1(function() {
                            var $297 = $9MxTl.curry(f);
                            return function($298) {
                                return foldlWithIndex2($297($298));
                            };
                        }())(i)(v);
                    };
                };
            },
            foldMapWithIndex: function(dictMonoid) {
                var foldMapWithIndex3 = foldMapWithIndex1(dictMonoid);
                var foldMapWithIndex4 = foldMapWithIndex2(dictMonoid);
                return function(f) {
                    return function(v) {
                        return foldMapWithIndex3(function() {
                            var $299 = $9MxTl.curry(f);
                            return function($300) {
                                return foldMapWithIndex4($299($300));
                            };
                        }())(v);
                    };
                };
            },
            Foldable0: function() {
                return foldableCompose1;
            }
        };
    };
};
var $519ef1967f17d101$export$c8998bd70c04c75d = function(dictFoldableWithIndex) {
    var foldrWithIndex1 = $519ef1967f17d101$export$d859ed9adfa064ca(dictFoldableWithIndex);
    var foldlWithIndex1 = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex);
    var foldMapWithIndex1 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex);
    var foldableCoproduct = $6RkEA.foldableCoproduct(dictFoldableWithIndex.Foldable0());
    return function(dictFoldableWithIndex1) {
        var foldrWithIndex2 = $519ef1967f17d101$export$d859ed9adfa064ca(dictFoldableWithIndex1);
        var foldlWithIndex2 = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex1);
        var foldMapWithIndex2 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex1);
        var foldableCoproduct1 = foldableCoproduct(dictFoldableWithIndex1.Foldable0());
        return {
            foldrWithIndex: function(f) {
                return function(z) {
                    return $6gSOm.coproduct(foldrWithIndex1(function($301) {
                        return f($aKY4H.Left.create($301));
                    })(z))(foldrWithIndex2(function($302) {
                        return f($aKY4H.Right.create($302));
                    })(z));
                };
            },
            foldlWithIndex: function(f) {
                return function(z) {
                    return $6gSOm.coproduct(foldlWithIndex1(function($303) {
                        return f($aKY4H.Left.create($303));
                    })(z))(foldlWithIndex2(function($304) {
                        return f($aKY4H.Right.create($304));
                    })(z));
                };
            },
            foldMapWithIndex: function(dictMonoid) {
                var foldMapWithIndex3 = foldMapWithIndex1(dictMonoid);
                var foldMapWithIndex4 = foldMapWithIndex2(dictMonoid);
                return function(f) {
                    return $6gSOm.coproduct(foldMapWithIndex3(function($305) {
                        return f($aKY4H.Left.create($305));
                    }))(foldMapWithIndex4(function($306) {
                        return f($aKY4H.Right.create($306));
                    }));
                };
            },
            Foldable0: function() {
                return foldableCoproduct1;
            }
        };
    };
};
var $519ef1967f17d101$export$e0fd1e7d0cab0fb2 = function(dictFoldableWithIndex) {
    var foldrWithIndex1 = $519ef1967f17d101$export$d859ed9adfa064ca(dictFoldableWithIndex);
    var foldlWithIndex1 = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex);
    var foldMapWithIndex1 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex);
    var foldableProduct = $6RkEA.foldableProduct(dictFoldableWithIndex.Foldable0());
    return function(dictFoldableWithIndex1) {
        var foldrWithIndex2 = $519ef1967f17d101$export$d859ed9adfa064ca(dictFoldableWithIndex1);
        var foldlWithIndex2 = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex1);
        var foldMapWithIndex2 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex1);
        var foldableProduct1 = foldableProduct(dictFoldableWithIndex1.Foldable0());
        return {
            foldrWithIndex: function(f) {
                return function(z) {
                    return function(v) {
                        return foldrWithIndex1(function($307) {
                            return f($aKY4H.Left.create($307));
                        })(foldrWithIndex2(function($308) {
                            return f($aKY4H.Right.create($308));
                        })(z)(v.value1))(v.value0);
                    };
                };
            },
            foldlWithIndex: function(f) {
                return function(z) {
                    return function(v) {
                        return foldlWithIndex2(function($309) {
                            return f($aKY4H.Right.create($309));
                        })(foldlWithIndex1(function($310) {
                            return f($aKY4H.Left.create($310));
                        })(z)(v.value0))(v.value1);
                    };
                };
            },
            foldMapWithIndex: function(dictMonoid) {
                var append = $iwqgS.append(dictMonoid.Semigroup0());
                var foldMapWithIndex3 = foldMapWithIndex1(dictMonoid);
                var foldMapWithIndex4 = foldMapWithIndex2(dictMonoid);
                return function(f) {
                    return function(v) {
                        return append(foldMapWithIndex3(function($311) {
                            return f($aKY4H.Left.create($311));
                        })(v.value0))(foldMapWithIndex4(function($312) {
                            return f($aKY4H.Right.create($312));
                        })(v.value1));
                    };
                };
            },
            Foldable0: function() {
                return foldableProduct1;
            }
        };
    };
};
var $519ef1967f17d101$export$a2a2be54aa786fa = function(dictFoldableWithIndex) {
    var foldMapWithIndex1 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex)($519ef1967f17d101$var$monoidDual);
    return function(c) {
        return function(u) {
            return function(xs) {
                return $519ef1967f17d101$var$unwrap($519ef1967f17d101$var$unwrap(foldMapWithIndex1(function(i) {
                    var $313 = $l4M7e.flip(c(i));
                    return function($314) {
                        return $bbOAS.Dual($7wVLo.Endo($313($314)));
                    };
                })(xs)))(u);
            };
        };
    };
};
var $519ef1967f17d101$export$f48decfd8b6d8740 = function(dictFoldableWithIndex) {
    var foldMapWithIndex1 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex)($519ef1967f17d101$var$monoidEndo);
    return function(c) {
        return function(u) {
            return function(xs) {
                return $519ef1967f17d101$var$unwrap(foldMapWithIndex1(function(i) {
                    var $315 = c(i);
                    return function($316) {
                        return $7wVLo.Endo($315($316));
                    };
                })(xs))(u);
            };
        };
    };
};
var $519ef1967f17d101$export$9f81331332e444a = function(dictFoldableWithIndex) {
    var foldMapWithIndex1 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex)($519ef1967f17d101$var$monoidEndo);
    return function(dictSemigroup) {
        var append = $iwqgS.append(dictSemigroup);
        return function(d) {
            return function(t) {
                return function(f) {
                    var joined = function(i) {
                        return function(a) {
                            return function(m) {
                                return append(d)(append(t(i)(a))(m));
                            };
                        };
                    };
                    return $519ef1967f17d101$var$unwrap(foldMapWithIndex1(joined)(f))(d);
                };
            };
        };
    };
};
var $519ef1967f17d101$export$222b6fd2bc53ca7a = function(dictFoldableWithIndex) {
    var foldMapWithIndex1 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex);
    return function(dictMonoid) {
        var foldMapWithIndex2 = foldMapWithIndex1(dictMonoid);
        return function(f) {
            return foldMapWithIndex2($l4M7e.const(f));
        };
    };
};
var $519ef1967f17d101$export$d803998e74b07aa8 = function(dictFoldableWithIndex) {
    var foldlWithIndex1 = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex);
    return function(p) {
        var go = function(v) {
            return function(v1) {
                return function(v2) {
                    if (v1 instanceof $ykHdR.Nothing && p(v)(v2)) return new $ykHdR.Just({
                        index: v,
                        value: v2
                    });
                    return v1;
                };
            };
        };
        return foldlWithIndex1(go)($ykHdR.Nothing.value);
    };
};
var $519ef1967f17d101$export$c34ce7d3b9a0e = function(dictFoldableWithIndex) {
    var foldlWithIndex1 = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex);
    return function(f) {
        var go = function(v) {
            return function(v1) {
                return function(v2) {
                    if (v1 instanceof $ykHdR.Nothing) return f(v)(v2);
                    return v1;
                };
            };
        };
        return foldlWithIndex1(go)($ykHdR.Nothing.value);
    };
};
var $519ef1967f17d101$export$6d3978b14e304a71 = function(dictFoldableWithIndex) {
    var foldMapWithIndex1 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex);
    return function(dictHeytingAlgebra) {
        var foldMapWithIndex2 = foldMapWithIndex1($1zczT.monoidDisj(dictHeytingAlgebra));
        return function(t) {
            var $317 = foldMapWithIndex2(function(i) {
                var $319 = t(i);
                return function($320) {
                    return $1zczT.Disj($319($320));
                };
            });
            return function($318) {
                return $519ef1967f17d101$var$unwrap($317($318));
            };
        };
    };
};
var $519ef1967f17d101$export$5dc11e929c02e763 = function(dictFoldableWithIndex) {
    var foldMapWithIndex1 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex);
    return function(dictHeytingAlgebra) {
        var foldMapWithIndex2 = foldMapWithIndex1($8JeQl.monoidConj(dictHeytingAlgebra));
        return function(t) {
            var $321 = foldMapWithIndex2(function(i) {
                var $323 = t(i);
                return function($324) {
                    return $8JeQl.Conj($323($324));
                };
            });
            return function($322) {
                return $519ef1967f17d101$var$unwrap($321($322));
            };
        };
    };
};

});

parcelRegister("2FBb2", function(module, exports) {

$parcel$export(module.exports, "NonEmpty", () => $1f1c3fb67e79b37f$export$d8deaab87a4e223a);
$parcel$export(module.exports, "unfoldable1NonEmpty", () => $1f1c3fb67e79b37f$export$3d29df45c3f8cf54);
$parcel$export(module.exports, "singleton", () => $1f1c3fb67e79b37f$export$439306a4dcaafbb9);
$parcel$export(module.exports, "showNonEmpty", () => $1f1c3fb67e79b37f$export$ffafc93d2cc87798);
$parcel$export(module.exports, "head", () => $1f1c3fb67e79b37f$export$5fd5031fecdacec3);
$parcel$export(module.exports, "functorNonEmpty", () => $1f1c3fb67e79b37f$export$a6ffbf6bde05f5c0);
$parcel$export(module.exports, "functorWithIndex", () => $1f1c3fb67e79b37f$export$cdee60b0fe4303fd);
$parcel$export(module.exports, "foldableNonEmpty", () => $1f1c3fb67e79b37f$export$20ebd08132411556);
$parcel$export(module.exports, "foldableWithIndexNonEmpty", () => $1f1c3fb67e79b37f$export$9a79a74e355c28b1);
$parcel$export(module.exports, "traversableNonEmpty", () => $1f1c3fb67e79b37f$export$dbb721137b3f0cf6);
$parcel$export(module.exports, "traversableWithIndexNonEmpty", () => $1f1c3fb67e79b37f$export$6e693a2e8188a772);
$parcel$export(module.exports, "foldable1NonEmpty", () => $1f1c3fb67e79b37f$export$ca19152d833c8d01);
$parcel$export(module.exports, "eqNonEmpty", () => $1f1c3fb67e79b37f$export$460809894af54b0a);
$parcel$export(module.exports, "ordNonEmpty", () => $1f1c3fb67e79b37f$export$ec32b9103f985218);
$parcel$export(module.exports, "eq1NonEmpty", () => $1f1c3fb67e79b37f$export$6a8b366193197b51);
$parcel$export(module.exports, "ord1NonEmpty", () => $1f1c3fb67e79b37f$export$de0dd6c052e29447);
// Generated by purs version 0.15.16

var $a7Dxq = parcelRequire("a7Dxq");

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $axmEP = parcelRequire("axmEP");

var $4MBcA = parcelRequire("4MBcA");

var $6RkEA = parcelRequire("6RkEA");

var $70sTh = parcelRequire("70sTh");

var $l0wDR = parcelRequire("l0wDR");

var $4oUwX = parcelRequire("4oUwX");

var $ykHdR = parcelRequire("ykHdR");

var $d0PPW = parcelRequire("d0PPW");

var $6SDUu = parcelRequire("6SDUu");

var $iwqgS = parcelRequire("iwqgS");

var $IFMV2 = parcelRequire("IFMV2");

var $3Orkn = parcelRequire("3Orkn");

var $1wR1l = parcelRequire("1wR1l");

var $3OKRG = parcelRequire("3OKRG");

var $9MxTl = parcelRequire("9MxTl");

var $hsyEi = parcelRequire("hsyEi");
var $1f1c3fb67e79b37f$var$map = /* #__PURE__ */ $l0wDR.map($9MxTl.functorTuple);
var $1f1c3fb67e79b37f$var$map1 = /* #__PURE__ */ $l0wDR.map($ykHdR.functorMaybe);
var $1f1c3fb67e79b37f$export$d8deaab87a4e223a = /* #__PURE__ */ function() {
    function NonEmpty(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    NonEmpty.create = function(value0) {
        return function(value1) {
            return new NonEmpty(value0, value1);
        };
    };
    return NonEmpty;
}();
var $1f1c3fb67e79b37f$export$3d29df45c3f8cf54 = function(dictUnfoldable) {
    var unfoldr = $hsyEi.unfoldr(dictUnfoldable);
    return {
        unfoldr1: function(f) {
            return function(b) {
                return $9MxTl.uncurry($1f1c3fb67e79b37f$export$d8deaab87a4e223a.create)($1f1c3fb67e79b37f$var$map(unfoldr($1f1c3fb67e79b37f$var$map1(f)))(f(b)));
            };
        }
    };
};
var $1f1c3fb67e79b37f$export$c01875f616615628 = function(v) {
    return v.value1;
};
var $1f1c3fb67e79b37f$export$439306a4dcaafbb9 = function(dictPlus) {
    var empty = $axmEP.empty(dictPlus);
    return function(a) {
        return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(a, empty);
    };
};
var $1f1c3fb67e79b37f$export$ffafc93d2cc87798 = function(dictShow) {
    var show = $3Orkn.show(dictShow);
    return function(dictShow1) {
        var show1 = $3Orkn.show(dictShow1);
        return {
            show: function(v) {
                return "(NonEmpty " + (show(v.value0) + (" " + (show1(v.value1) + ")")));
            }
        };
    };
};
var $1f1c3fb67e79b37f$export$d0a7bd743ccb8d67 = function(dictApplicative) {
    var pure = $gUTA8.pure(dictApplicative);
    return function(dictSemigroup) {
        var append1 = $iwqgS.append(dictSemigroup);
        return {
            append: function(v) {
                return function(v1) {
                    return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v.value0, append1(v.value1)(append1(pure(v1.value0))(v1.value1)));
                };
            }
        };
    };
};
var $1f1c3fb67e79b37f$export$a9a18ae5ba42aeab = function(dictAlternative) {
    var alt = $a7Dxq.alt(dictAlternative.Plus1().Alt0());
    var pure = $gUTA8.pure(dictAlternative.Applicative0());
    return function(v) {
        return alt(pure(v.value0))(v.value1);
    };
};
var $1f1c3fb67e79b37f$export$5fd5031fecdacec3 = function(v) {
    return v.value0;
};
var $1f1c3fb67e79b37f$export$a6ffbf6bde05f5c0 = function(dictFunctor) {
    var map2 = $l0wDR.map(dictFunctor);
    return {
        map: function(f) {
            return function(m) {
                return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(f(m.value0), map2(f)(m.value1));
            };
        }
    };
};
var $1f1c3fb67e79b37f$export$cdee60b0fe4303fd = function(dictFunctorWithIndex) {
    var mapWithIndex = $4oUwX.mapWithIndex(dictFunctorWithIndex);
    var functorNonEmpty1 = $1f1c3fb67e79b37f$export$a6ffbf6bde05f5c0(dictFunctorWithIndex.Functor0());
    return {
        mapWithIndex: function(f) {
            return function(v) {
                return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(f($ykHdR.Nothing.value)(v.value0), mapWithIndex(function($245) {
                    return f($ykHdR.Just.create($245));
                })(v.value1));
            };
        },
        Functor0: function() {
            return functorNonEmpty1;
        }
    };
};
var $1f1c3fb67e79b37f$export$1d4c49925323035a = function(f) {
    return function(v) {
        return f(v.value0)(v.value1);
    };
};
var $1f1c3fb67e79b37f$export$20ebd08132411556 = function(dictFoldable) {
    var foldMap = $6RkEA.foldMap(dictFoldable);
    var foldl = $6RkEA.foldl(dictFoldable);
    var foldr = $6RkEA.foldr(dictFoldable);
    return {
        foldMap: function(dictMonoid) {
            var append1 = $iwqgS.append(dictMonoid.Semigroup0());
            var foldMap1 = foldMap(dictMonoid);
            return function(f) {
                return function(v) {
                    return append1(f(v.value0))(foldMap1(f)(v.value1));
                };
            };
        },
        foldl: function(f) {
            return function(b) {
                return function(v) {
                    return foldl(f)(f(b)(v.value0))(v.value1);
                };
            };
        },
        foldr: function(f) {
            return function(b) {
                return function(v) {
                    return f(v.value0)(foldr(f)(b)(v.value1));
                };
            };
        }
    };
};
var $1f1c3fb67e79b37f$export$9a79a74e355c28b1 = function(dictFoldableWithIndex) {
    var foldMapWithIndex = $70sTh.foldMapWithIndex(dictFoldableWithIndex);
    var foldlWithIndex = $70sTh.foldlWithIndex(dictFoldableWithIndex);
    var foldrWithIndex = $70sTh.foldrWithIndex(dictFoldableWithIndex);
    var foldableNonEmpty1 = $1f1c3fb67e79b37f$export$20ebd08132411556(dictFoldableWithIndex.Foldable0());
    return {
        foldMapWithIndex: function(dictMonoid) {
            var append1 = $iwqgS.append(dictMonoid.Semigroup0());
            var foldMapWithIndex1 = foldMapWithIndex(dictMonoid);
            return function(f) {
                return function(v) {
                    return append1(f($ykHdR.Nothing.value)(v.value0))(foldMapWithIndex1(function($246) {
                        return f($ykHdR.Just.create($246));
                    })(v.value1));
                };
            };
        },
        foldlWithIndex: function(f) {
            return function(b) {
                return function(v) {
                    return foldlWithIndex(function($247) {
                        return f($ykHdR.Just.create($247));
                    })(f($ykHdR.Nothing.value)(b)(v.value0))(v.value1);
                };
            };
        },
        foldrWithIndex: function(f) {
            return function(b) {
                return function(v) {
                    return f($ykHdR.Nothing.value)(v.value0)(foldrWithIndex(function($248) {
                        return f($ykHdR.Just.create($248));
                    })(b)(v.value1));
                };
            };
        },
        Foldable0: function() {
            return foldableNonEmpty1;
        }
    };
};
var $1f1c3fb67e79b37f$export$dbb721137b3f0cf6 = function(dictTraversable) {
    var sequence = $1wR1l.sequence(dictTraversable);
    var traverse = $1wR1l.traverse(dictTraversable);
    var functorNonEmpty1 = $1f1c3fb67e79b37f$export$a6ffbf6bde05f5c0(dictTraversable.Functor0());
    var foldableNonEmpty1 = $1f1c3fb67e79b37f$export$20ebd08132411556(dictTraversable.Foldable1());
    return {
        sequence: function(dictApplicative) {
            var Apply0 = dictApplicative.Apply0();
            var apply = $a5g3C.apply(Apply0);
            var map2 = $l0wDR.map(Apply0.Functor0());
            var sequence1 = sequence(dictApplicative);
            return function(v) {
                return apply(map2($1f1c3fb67e79b37f$export$d8deaab87a4e223a.create)(v.value0))(sequence1(v.value1));
            };
        },
        traverse: function(dictApplicative) {
            var Apply0 = dictApplicative.Apply0();
            var apply = $a5g3C.apply(Apply0);
            var map2 = $l0wDR.map(Apply0.Functor0());
            var traverse1 = traverse(dictApplicative);
            return function(f) {
                return function(v) {
                    return apply(map2($1f1c3fb67e79b37f$export$d8deaab87a4e223a.create)(f(v.value0)))(traverse1(f)(v.value1));
                };
            };
        },
        Functor0: function() {
            return functorNonEmpty1;
        },
        Foldable1: function() {
            return foldableNonEmpty1;
        }
    };
};
var $1f1c3fb67e79b37f$export$6e693a2e8188a772 = function(dictTraversableWithIndex) {
    var traverseWithIndex = $3OKRG.traverseWithIndex(dictTraversableWithIndex);
    var functorWithIndex1 = $1f1c3fb67e79b37f$export$cdee60b0fe4303fd(dictTraversableWithIndex.FunctorWithIndex0());
    var foldableWithIndexNonEmpty1 = $1f1c3fb67e79b37f$export$9a79a74e355c28b1(dictTraversableWithIndex.FoldableWithIndex1());
    var traversableNonEmpty1 = $1f1c3fb67e79b37f$export$dbb721137b3f0cf6(dictTraversableWithIndex.Traversable2());
    return {
        traverseWithIndex: function(dictApplicative) {
            var Apply0 = dictApplicative.Apply0();
            var apply = $a5g3C.apply(Apply0);
            var map2 = $l0wDR.map(Apply0.Functor0());
            var traverseWithIndex1 = traverseWithIndex(dictApplicative);
            return function(f) {
                return function(v) {
                    return apply(map2($1f1c3fb67e79b37f$export$d8deaab87a4e223a.create)(f($ykHdR.Nothing.value)(v.value0)))(traverseWithIndex1(function($249) {
                        return f($ykHdR.Just.create($249));
                    })(v.value1));
                };
            };
        },
        FunctorWithIndex0: function() {
            return functorWithIndex1;
        },
        FoldableWithIndex1: function() {
            return foldableWithIndexNonEmpty1;
        },
        Traversable2: function() {
            return traversableNonEmpty1;
        }
    };
};
var $1f1c3fb67e79b37f$export$ca19152d833c8d01 = function(dictFoldable) {
    var foldl = $6RkEA.foldl(dictFoldable);
    var foldr = $6RkEA.foldr(dictFoldable);
    var foldableNonEmpty1 = $1f1c3fb67e79b37f$export$20ebd08132411556(dictFoldable);
    return {
        foldMap1: function(dictSemigroup) {
            var append1 = $iwqgS.append(dictSemigroup);
            return function(f) {
                return function(v) {
                    return foldl(function(s) {
                        return function(a1) {
                            return append1(s)(f(a1));
                        };
                    })(f(v.value0))(v.value1);
                };
            };
        },
        foldr1: function(f) {
            return function(v) {
                return $ykHdR.maybe(v.value0)(f(v.value0))(foldr(function(a1) {
                    var $250 = $ykHdR.maybe(a1)(f(a1));
                    return function($251) {
                        return $ykHdR.Just.create($250($251));
                    };
                })($ykHdR.Nothing.value)(v.value1));
            };
        },
        foldl1: function(f) {
            return function(v) {
                return foldl(f)(v.value0)(v.value1);
            };
        },
        Foldable0: function() {
            return foldableNonEmpty1;
        }
    };
};
var $1f1c3fb67e79b37f$export$eb5e1ef4ea2eca3d = function(dictFoldable) {
    return $IFMV2.foldl1($1f1c3fb67e79b37f$export$ca19152d833c8d01(dictFoldable));
};
var $1f1c3fb67e79b37f$export$460809894af54b0a = function(dictEq1) {
    var eq1 = $4MBcA.eq1(dictEq1);
    return function(dictEq) {
        var eq = $4MBcA.eq(dictEq);
        var eq11 = eq1(dictEq);
        return {
            eq: function(x) {
                return function(y) {
                    return eq(x.value0)(y.value0) && eq11(x.value1)(y.value1);
                };
            }
        };
    };
};
var $1f1c3fb67e79b37f$export$ec32b9103f985218 = function(dictOrd1) {
    var compare1 = $d0PPW.compare1(dictOrd1);
    var eqNonEmpty1 = $1f1c3fb67e79b37f$export$460809894af54b0a(dictOrd1.Eq10());
    return function(dictOrd) {
        var compare = $d0PPW.compare(dictOrd);
        var compare11 = compare1(dictOrd);
        var eqNonEmpty2 = eqNonEmpty1(dictOrd.Eq0());
        return {
            compare: function(x) {
                return function(y) {
                    var v = compare(x.value0)(y.value0);
                    if (v instanceof $6SDUu.LT) return $6SDUu.LT.value;
                    if (v instanceof $6SDUu.GT) return $6SDUu.GT.value;
                    return compare11(x.value1)(y.value1);
                };
            },
            Eq0: function() {
                return eqNonEmpty2;
            }
        };
    };
};
var $1f1c3fb67e79b37f$export$6a8b366193197b51 = function(dictEq1) {
    var eqNonEmpty1 = $1f1c3fb67e79b37f$export$460809894af54b0a(dictEq1);
    return {
        eq1: function(dictEq) {
            return $4MBcA.eq(eqNonEmpty1(dictEq));
        }
    };
};
var $1f1c3fb67e79b37f$export$de0dd6c052e29447 = function(dictOrd1) {
    var ordNonEmpty1 = $1f1c3fb67e79b37f$export$ec32b9103f985218(dictOrd1);
    var eq1NonEmpty1 = $1f1c3fb67e79b37f$export$6a8b366193197b51(dictOrd1.Eq10());
    return {
        compare1: function(dictOrd) {
            return $d0PPW.compare(ordNonEmpty1(dictOrd));
        },
        Eq10: function() {
            return eq1NonEmpty1;
        }
    };
};

});
parcelRegister("3OKRG", function(module, exports) {

$parcel$export(module.exports, "traverseWithIndex", () => $2c7a64ff78781336$export$955fdc0d24efa249);
$parcel$export(module.exports, "traversableWithIndexArray", () => $2c7a64ff78781336$export$96888504550934b5);
// Generated by purs version 0.15.16

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $aKY4H = parcelRequire("aKY4H");

var $70sTh = parcelRequire("70sTh");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");

var $8jFkD = parcelRequire("8jFkD");

var $8gI0w = parcelRequire("8gI0w");

var $6gSOm = parcelRequire("6gSOm");

var $dUqA2 = parcelRequire("dUqA2");

var $4oUwX = parcelRequire("4oUwX");

var $6VVZC = parcelRequire("6VVZC");

var $1wR1l = parcelRequire("1wR1l");
parcelRequire("dbQBZ");

var $fAYru = parcelRequire("fAYru");

var $9MxTl = parcelRequire("9MxTl");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");
var $2c7a64ff78781336$var$traverse = /* #__PURE__ */ $1wR1l.traverse($1wR1l.traversableMultiplicative);
var $2c7a64ff78781336$var$traverse1 = /* #__PURE__ */ $1wR1l.traverse($1wR1l.traversableMaybe);
var $2c7a64ff78781336$var$traverse2 = /* #__PURE__ */ $1wR1l.traverse($1wR1l.traversableLast);
var $2c7a64ff78781336$var$traverse3 = /* #__PURE__ */ $1wR1l.traverse($1wR1l.traversableFirst);
var $2c7a64ff78781336$var$traverse4 = /* #__PURE__ */ $1wR1l.traverse($1wR1l.traversableDual);
var $2c7a64ff78781336$var$traverse5 = /* #__PURE__ */ $1wR1l.traverse($1wR1l.traversableDisj);
var $2c7a64ff78781336$var$traverse6 = /* #__PURE__ */ $1wR1l.traverse($1wR1l.traversableConj);
var $2c7a64ff78781336$var$traverse7 = /* #__PURE__ */ $1wR1l.traverse($1wR1l.traversableAdditive);
var $2c7a64ff78781336$export$37034f8d74d84f8b = function(dictTraversableWithIndex) {
    var sequence = $1wR1l.sequence(dictTraversableWithIndex.Traversable2());
    var mapWithIndex = $4oUwX.mapWithIndex(dictTraversableWithIndex.FunctorWithIndex0());
    return function(dictApplicative) {
        var sequence1 = sequence(dictApplicative);
        return function(f) {
            var $174 = mapWithIndex(f);
            return function($175) {
                return sequence1($174($175));
            };
        };
    };
};
var $2c7a64ff78781336$export$955fdc0d24efa249 = function(dict) {
    return dict.traverseWithIndex;
};
var $2c7a64ff78781336$export$d50a9c31d69ee13c = function(dictTraversableWithIndex) {
    var traverseWithIndex1 = $2c7a64ff78781336$export$955fdc0d24efa249(dictTraversableWithIndex);
    return function(dictApplicative) {
        var traverseWithIndex2 = traverseWithIndex1(dictApplicative);
        return function(f) {
            return traverseWithIndex2($l4M7e.const(f));
        };
    };
};
var $2c7a64ff78781336$export$649571d878667376 = {
    traverseWithIndex: function(dictApplicative) {
        var map = $l0wDR.map(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return map($9MxTl.Tuple.create(v.value0))(f($r2HHk.unit)(v.value1));
            };
        };
    },
    FunctorWithIndex0: function() {
        return $4oUwX.functorWithIndexTuple;
    },
    FoldableWithIndex1: function() {
        return $70sTh.foldableWithIndexTuple;
    },
    Traversable2: function() {
        return $1wR1l.traversableTuple;
    }
};
var $2c7a64ff78781336$export$f5fab9ea43775499 = function(dictTraversableWithIndex) {
    var traverseWithIndex1 = $2c7a64ff78781336$export$955fdc0d24efa249(dictTraversableWithIndex);
    var functorWithIndexProduct = $4oUwX.functorWithIndexProduct(dictTraversableWithIndex.FunctorWithIndex0());
    var foldableWithIndexProduct = $70sTh.foldableWithIndexProduct(dictTraversableWithIndex.FoldableWithIndex1());
    var traversableProduct = $1wR1l.traversableProduct(dictTraversableWithIndex.Traversable2());
    return function(dictTraversableWithIndex1) {
        var traverseWithIndex2 = $2c7a64ff78781336$export$955fdc0d24efa249(dictTraversableWithIndex1);
        var functorWithIndexProduct1 = functorWithIndexProduct(dictTraversableWithIndex1.FunctorWithIndex0());
        var foldableWithIndexProduct1 = foldableWithIndexProduct(dictTraversableWithIndex1.FoldableWithIndex1());
        var traversableProduct1 = traversableProduct(dictTraversableWithIndex1.Traversable2());
        return {
            traverseWithIndex: function(dictApplicative) {
                var lift2 = $a5g3C.lift2(dictApplicative.Apply0());
                var traverseWithIndex3 = traverseWithIndex1(dictApplicative);
                var traverseWithIndex4 = traverseWithIndex2(dictApplicative);
                return function(f) {
                    return function(v) {
                        return lift2($dUqA2.product)(traverseWithIndex3(function($176) {
                            return f($aKY4H.Left.create($176));
                        })(v.value0))(traverseWithIndex4(function($177) {
                            return f($aKY4H.Right.create($177));
                        })(v.value1));
                    };
                };
            },
            FunctorWithIndex0: function() {
                return functorWithIndexProduct1;
            },
            FoldableWithIndex1: function() {
                return foldableWithIndexProduct1;
            },
            Traversable2: function() {
                return traversableProduct1;
            }
        };
    };
};
var $2c7a64ff78781336$export$340ca064331c9524 = {
    traverseWithIndex: function(dictApplicative) {
        var traverse8 = $2c7a64ff78781336$var$traverse(dictApplicative);
        return function(f) {
            return traverse8(f($r2HHk.unit));
        };
    },
    FunctorWithIndex0: function() {
        return $4oUwX.functorWithIndexMultiplicative;
    },
    FoldableWithIndex1: function() {
        return $70sTh.foldableWithIndexMultiplicative;
    },
    Traversable2: function() {
        return $1wR1l.traversableMultiplicative;
    }
};
var $2c7a64ff78781336$export$971c834447f08858 = {
    traverseWithIndex: function(dictApplicative) {
        var traverse8 = $2c7a64ff78781336$var$traverse1(dictApplicative);
        return function(f) {
            return traverse8(f($r2HHk.unit));
        };
    },
    FunctorWithIndex0: function() {
        return $4oUwX.functorWithIndexMaybe;
    },
    FoldableWithIndex1: function() {
        return $70sTh.foldableWithIndexMaybe;
    },
    Traversable2: function() {
        return $1wR1l.traversableMaybe;
    }
};
var $2c7a64ff78781336$export$82bf3aff27014955 = {
    traverseWithIndex: function(dictApplicative) {
        var traverse8 = $2c7a64ff78781336$var$traverse2(dictApplicative);
        return function(f) {
            return traverse8(f($r2HHk.unit));
        };
    },
    FunctorWithIndex0: function() {
        return $4oUwX.functorWithIndexLast;
    },
    FoldableWithIndex1: function() {
        return $70sTh.foldableWithIndexLast;
    },
    Traversable2: function() {
        return $1wR1l.traversableLast;
    }
};
var $2c7a64ff78781336$export$e4fe4683618a40ff = {
    traverseWithIndex: function(dictApplicative) {
        var map = $l0wDR.map(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return map($6VVZC.Identity)(f($r2HHk.unit)(v));
            };
        };
    },
    FunctorWithIndex0: function() {
        return $4oUwX.functorWithIndexIdentity;
    },
    FoldableWithIndex1: function() {
        return $70sTh.foldableWithIndexIdentity;
    },
    Traversable2: function() {
        return $1wR1l.traversableIdentity;
    }
};
var $2c7a64ff78781336$export$c0565467517236ee = {
    traverseWithIndex: function(dictApplicative) {
        var traverse8 = $2c7a64ff78781336$var$traverse3(dictApplicative);
        return function(f) {
            return traverse8(f($r2HHk.unit));
        };
    },
    FunctorWithIndex0: function() {
        return $4oUwX.functorWithIndexFirst;
    },
    FoldableWithIndex1: function() {
        return $70sTh.foldableWithIndexFirst;
    },
    Traversable2: function() {
        return $1wR1l.traversableFirst;
    }
};
var $2c7a64ff78781336$export$c5842444d22f461a = {
    traverseWithIndex: function(dictApplicative) {
        var pure = $gUTA8.pure(dictApplicative);
        var map = $l0wDR.map(dictApplicative.Apply0().Functor0());
        return function(v) {
            return function(v1) {
                if (v1 instanceof $aKY4H.Left) return pure(new $aKY4H.Left(v1.value0));
                if (v1 instanceof $aKY4H.Right) return map($aKY4H.Right.create)(v($r2HHk.unit)(v1.value0));
                throw new Error("Failed pattern match at Data.TraversableWithIndex (line 95, column 1 - line 97, column 53): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    },
    FunctorWithIndex0: function() {
        return $4oUwX.functorWithIndexEither;
    },
    FoldableWithIndex1: function() {
        return $70sTh.foldableWithIndexEither;
    },
    Traversable2: function() {
        return $1wR1l.traversableEither;
    }
};
var $2c7a64ff78781336$export$f81f0b3aaf5918a5 = {
    traverseWithIndex: function(dictApplicative) {
        var traverse8 = $2c7a64ff78781336$var$traverse4(dictApplicative);
        return function(f) {
            return traverse8(f($r2HHk.unit));
        };
    },
    FunctorWithIndex0: function() {
        return $4oUwX.functorWithIndexDual;
    },
    FoldableWithIndex1: function() {
        return $70sTh.foldableWithIndexDual;
    },
    Traversable2: function() {
        return $1wR1l.traversableDual;
    }
};
var $2c7a64ff78781336$export$298c1e0a7ee97588 = {
    traverseWithIndex: function(dictApplicative) {
        var traverse8 = $2c7a64ff78781336$var$traverse5(dictApplicative);
        return function(f) {
            return traverse8(f($r2HHk.unit));
        };
    },
    FunctorWithIndex0: function() {
        return $4oUwX.functorWithIndexDisj;
    },
    FoldableWithIndex1: function() {
        return $70sTh.foldableWithIndexDisj;
    },
    Traversable2: function() {
        return $1wR1l.traversableDisj;
    }
};
var $2c7a64ff78781336$export$fad1c006f410e5e2 = function(dictTraversableWithIndex) {
    var traverseWithIndex1 = $2c7a64ff78781336$export$955fdc0d24efa249(dictTraversableWithIndex);
    var functorWithIndexCoproduct = $4oUwX.functorWithIndexCoproduct(dictTraversableWithIndex.FunctorWithIndex0());
    var foldableWithIndexCoproduct = $70sTh.foldableWithIndexCoproduct(dictTraversableWithIndex.FoldableWithIndex1());
    var traversableCoproduct = $1wR1l.traversableCoproduct(dictTraversableWithIndex.Traversable2());
    return function(dictTraversableWithIndex1) {
        var traverseWithIndex2 = $2c7a64ff78781336$export$955fdc0d24efa249(dictTraversableWithIndex1);
        var functorWithIndexCoproduct1 = functorWithIndexCoproduct(dictTraversableWithIndex1.FunctorWithIndex0());
        var foldableWithIndexCoproduct1 = foldableWithIndexCoproduct(dictTraversableWithIndex1.FoldableWithIndex1());
        var traversableCoproduct1 = traversableCoproduct(dictTraversableWithIndex1.Traversable2());
        return {
            traverseWithIndex: function(dictApplicative) {
                var map = $l0wDR.map(dictApplicative.Apply0().Functor0());
                var traverseWithIndex3 = traverseWithIndex1(dictApplicative);
                var traverseWithIndex4 = traverseWithIndex2(dictApplicative);
                return function(f) {
                    return $6gSOm.coproduct(function() {
                        var $178 = map(function($181) {
                            return $6gSOm.Coproduct($aKY4H.Left.create($181));
                        });
                        var $179 = traverseWithIndex3(function($182) {
                            return f($aKY4H.Left.create($182));
                        });
                        return function($180) {
                            return $178($179($180));
                        };
                    }())(function() {
                        var $183 = map(function($186) {
                            return $6gSOm.Coproduct($aKY4H.Right.create($186));
                        });
                        var $184 = traverseWithIndex4(function($187) {
                            return f($aKY4H.Right.create($187));
                        });
                        return function($185) {
                            return $183($184($185));
                        };
                    }());
                };
            },
            FunctorWithIndex0: function() {
                return functorWithIndexCoproduct1;
            },
            FoldableWithIndex1: function() {
                return foldableWithIndexCoproduct1;
            },
            Traversable2: function() {
                return traversableCoproduct1;
            }
        };
    };
};
var $2c7a64ff78781336$export$8270215089848547 = {
    traverseWithIndex: function(dictApplicative) {
        var pure = $gUTA8.pure(dictApplicative);
        return function(v) {
            return function(v1) {
                return pure(v1);
            };
        };
    },
    FunctorWithIndex0: function() {
        return $4oUwX.functorWithIndexConst;
    },
    FoldableWithIndex1: function() {
        return $70sTh.foldableWithIndexConst;
    },
    Traversable2: function() {
        return $1wR1l.traversableConst;
    }
};
var $2c7a64ff78781336$export$b78ffb8a06781844 = {
    traverseWithIndex: function(dictApplicative) {
        var traverse8 = $2c7a64ff78781336$var$traverse6(dictApplicative);
        return function(f) {
            return traverse8(f($r2HHk.unit));
        };
    },
    FunctorWithIndex0: function() {
        return $4oUwX.functorWithIndexConj;
    },
    FoldableWithIndex1: function() {
        return $70sTh.foldableWithIndexConj;
    },
    Traversable2: function() {
        return $1wR1l.traversableConj;
    }
};
var $2c7a64ff78781336$export$e1331c7aac1da04e = function(dictTraversableWithIndex) {
    var traverseWithIndex1 = $2c7a64ff78781336$export$955fdc0d24efa249(dictTraversableWithIndex);
    var functorWithIndexCompose = $4oUwX.functorWithIndexCompose(dictTraversableWithIndex.FunctorWithIndex0());
    var foldableWithIndexCompose = $70sTh.foldableWithIndexCompose(dictTraversableWithIndex.FoldableWithIndex1());
    var traversableCompose = $1wR1l.traversableCompose(dictTraversableWithIndex.Traversable2());
    return function(dictTraversableWithIndex1) {
        var traverseWithIndex2 = $2c7a64ff78781336$export$955fdc0d24efa249(dictTraversableWithIndex1);
        var functorWithIndexCompose1 = functorWithIndexCompose(dictTraversableWithIndex1.FunctorWithIndex0());
        var foldableWithIndexCompose1 = foldableWithIndexCompose(dictTraversableWithIndex1.FoldableWithIndex1());
        var traversableCompose1 = traversableCompose(dictTraversableWithIndex1.Traversable2());
        return {
            traverseWithIndex: function(dictApplicative) {
                var map = $l0wDR.map(dictApplicative.Apply0().Functor0());
                var traverseWithIndex3 = traverseWithIndex1(dictApplicative);
                var traverseWithIndex4 = traverseWithIndex2(dictApplicative);
                return function(f) {
                    return function(v) {
                        return map($8gI0w.Compose)(traverseWithIndex3(function() {
                            var $188 = $9MxTl.curry(f);
                            return function($189) {
                                return traverseWithIndex4($188($189));
                            };
                        }())(v));
                    };
                };
            },
            FunctorWithIndex0: function() {
                return functorWithIndexCompose1;
            },
            FoldableWithIndex1: function() {
                return foldableWithIndexCompose1;
            },
            Traversable2: function() {
                return traversableCompose1;
            }
        };
    };
};
var $2c7a64ff78781336$export$96888504550934b5 = {
    traverseWithIndex: function(dictApplicative) {
        return $2c7a64ff78781336$export$37034f8d74d84f8b($2c7a64ff78781336$export$96888504550934b5)(dictApplicative);
    },
    FunctorWithIndex0: function() {
        return $4oUwX.functorWithIndexArray;
    },
    FoldableWithIndex1: function() {
        return $70sTh.foldableWithIndexArray;
    },
    Traversable2: function() {
        return $1wR1l.traversableArray;
    }
};
var $2c7a64ff78781336$export$fc84432b7fe0f34e = function(dictTraversableWithIndex) {
    var traverseWithIndex1 = $2c7a64ff78781336$export$955fdc0d24efa249(dictTraversableWithIndex);
    var functorWithIndexApp = $4oUwX.functorWithIndexApp(dictTraversableWithIndex.FunctorWithIndex0());
    var foldableWithIndexApp = $70sTh.foldableWithIndexApp(dictTraversableWithIndex.FoldableWithIndex1());
    var traversableApp = $1wR1l.traversableApp(dictTraversableWithIndex.Traversable2());
    return {
        traverseWithIndex: function(dictApplicative) {
            var map = $l0wDR.map(dictApplicative.Apply0().Functor0());
            var traverseWithIndex2 = traverseWithIndex1(dictApplicative);
            return function(f) {
                return function(v) {
                    return map($8jFkD.App)(traverseWithIndex2(f)(v));
                };
            };
        },
        FunctorWithIndex0: function() {
            return functorWithIndexApp;
        },
        FoldableWithIndex1: function() {
            return foldableWithIndexApp;
        },
        Traversable2: function() {
            return traversableApp;
        }
    };
};
var $2c7a64ff78781336$export$3d12857a1613dde6 = {
    traverseWithIndex: function(dictApplicative) {
        var traverse8 = $2c7a64ff78781336$var$traverse7(dictApplicative);
        return function(f) {
            return traverse8(f($r2HHk.unit));
        };
    },
    FunctorWithIndex0: function() {
        return $4oUwX.functorWithIndexAdditive;
    },
    FoldableWithIndex1: function() {
        return $70sTh.foldableWithIndexAdditive;
    },
    Traversable2: function() {
        return $1wR1l.traversableAdditive;
    }
};
var $2c7a64ff78781336$export$34e92304ce7da557 = function(dictTraversableWithIndex) {
    var traverseWithIndex1 = $2c7a64ff78781336$export$955fdc0d24efa249(dictTraversableWithIndex)($fAYru.applicativeStateR);
    return function(f) {
        return function(s0) {
            return function(xs) {
                return $fAYru.stateR(traverseWithIndex1(function(i) {
                    return function(a) {
                        return function(s) {
                            return f(i)(s)(a);
                        };
                    };
                })(xs))(s0);
            };
        };
    };
};
var $2c7a64ff78781336$export$6062de19d97bcfe7 = function(dictTraversableWithIndex) {
    var mapAccumRWithIndex1 = $2c7a64ff78781336$export$34e92304ce7da557(dictTraversableWithIndex);
    return function(f) {
        return function(b0) {
            return function(xs) {
                return mapAccumRWithIndex1(function(i) {
                    return function(b) {
                        return function(a) {
                            var b$prime = f(i)(a)(b);
                            return {
                                accum: b$prime,
                                value: b$prime
                            };
                        };
                    };
                })(b0)(xs).value;
            };
        };
    };
};
var $2c7a64ff78781336$export$2594b6cb66070a = function(dictTraversableWithIndex) {
    var traverseWithIndex1 = $2c7a64ff78781336$export$955fdc0d24efa249(dictTraversableWithIndex)($fAYru.applicativeStateL);
    return function(f) {
        return function(s0) {
            return function(xs) {
                return $fAYru.stateL(traverseWithIndex1(function(i) {
                    return function(a) {
                        return function(s) {
                            return f(i)(s)(a);
                        };
                    };
                })(xs))(s0);
            };
        };
    };
};
var $2c7a64ff78781336$export$2aa973d5e57cdb6b = function(dictTraversableWithIndex) {
    var mapAccumLWithIndex1 = $2c7a64ff78781336$export$2594b6cb66070a(dictTraversableWithIndex);
    return function(f) {
        return function(b0) {
            return function(xs) {
                return mapAccumLWithIndex1(function(i) {
                    return function(b) {
                        return function(a) {
                            var b$prime = f(i)(b)(a);
                            return {
                                accum: b$prime,
                                value: b$prime
                            };
                        };
                    };
                })(b0)(xs).value;
            };
        };
    };
};
var $2c7a64ff78781336$export$363f6bf7e04ec632 = function(dictApplicative) {
    return function(dictTraversableWithIndex) {
        return $l4M7e.flip($2c7a64ff78781336$export$955fdc0d24efa249(dictTraversableWithIndex)(dictApplicative));
    };
};

});






parcelRegister("2gT7Y", function(module, exports) {

$parcel$export(module.exports, "uncons", () => $1a77d6934b592676$export$b446f6baa3bb1430);
$parcel$export(module.exports, "toChar", () => $1a77d6934b592676$export$bafb3da1554990db);
$parcel$export(module.exports, "stripPrefix", () => $1a77d6934b592676$export$71c2a1babd78d286);
$parcel$export(module.exports, "lastIndexOf$prime", () => $1a77d6934b592676$export$9dc3eed83bb14216);
$parcel$export(module.exports, "lastIndexOf", () => $1a77d6934b592676$export$557cfb7ed375eeb7);
$parcel$export(module.exports, "indexOf", () => $1a77d6934b592676$export$305f7d4e9d4624f2);
$parcel$export(module.exports, "contains", () => $1a77d6934b592676$export$2344b14b097df817);
$parcel$export(module.exports, "singleton", () => (parcelRequire("MTXA4")).singleton);
$parcel$export(module.exports, "fromCharArray", () => (parcelRequire("MTXA4")).fromCharArray);
$parcel$export(module.exports, "toCharArray", () => (parcelRequire("MTXA4")).toCharArray);
$parcel$export(module.exports, "length", () => (parcelRequire("MTXA4")).length);
$parcel$export(module.exports, "take", () => (parcelRequire("MTXA4")).take);
$parcel$export(module.exports, "drop", () => (parcelRequire("MTXA4")).drop);
// Generated by purs version 0.15.16

var $MTXA4 = parcelRequire("MTXA4");

var $ykHdR = parcelRequire("ykHdR");
parcelRequire("jUjvc");
var $4lhF1 = parcelRequire("4lhF1");
var $1a77d6934b592676$export$b446f6baa3bb1430 = function(v) {
    if (v === "") return $ykHdR.Nothing.value;
    return new $ykHdR.Just({
        head: $4lhF1.charAt(0)(v),
        tail: $MTXA4.drop(1)(v)
    });
};
var $1a77d6934b592676$export$bafb3da1554990db = /* #__PURE__ */ function() {
    return $MTXA4._toChar($ykHdR.Just.create)($ykHdR.Nothing.value);
}();
var $1a77d6934b592676$export$9384c7afe4015e42 = function(p) {
    return function(s) {
        return $MTXA4.take($MTXA4.countPrefix(p)(s))(s);
    };
};
var $1a77d6934b592676$export$1bbc425ddca7f2c6 = function(i) {
    return function(s) {
        return $MTXA4.drop($MTXA4.length(s) - i | 0)(s);
    };
};
var $1a77d6934b592676$export$cc5663efaab5bcf6 = function(v) {
    return function(str) {
        var v1 = $MTXA4.splitAt($MTXA4.length(str) - $MTXA4.length(v) | 0)(str);
        var $14 = v1.after === v;
        if ($14) return new $ykHdR.Just(v1.before);
        return $ykHdR.Nothing.value;
    };
};
var $1a77d6934b592676$export$71c2a1babd78d286 = function(v) {
    return function(str) {
        var v1 = $MTXA4.splitAt($MTXA4.length(v))(str);
        var $20 = v1.before === v;
        if ($20) return new $ykHdR.Just(v1.after);
        return $ykHdR.Nothing.value;
    };
};
var $1a77d6934b592676$export$9dc3eed83bb14216 = /* #__PURE__ */ function() {
    return $MTXA4._lastIndexOfStartingAt($ykHdR.Just.create)($ykHdR.Nothing.value);
}();
var $1a77d6934b592676$export$557cfb7ed375eeb7 = /* #__PURE__ */ function() {
    return $MTXA4._lastIndexOf($ykHdR.Just.create)($ykHdR.Nothing.value);
}();
var $1a77d6934b592676$export$7f0e23922170149a = /* #__PURE__ */ function() {
    return $MTXA4._indexOfStartingAt($ykHdR.Just.create)($ykHdR.Nothing.value);
}();
var $1a77d6934b592676$export$305f7d4e9d4624f2 = /* #__PURE__ */ function() {
    return $MTXA4._indexOf($ykHdR.Just.create)($ykHdR.Nothing.value);
}();
var $1a77d6934b592676$export$533af5c8cd6afa16 = function(p) {
    return function(s) {
        return $MTXA4.drop($MTXA4.countPrefix(p)(s))(s);
    };
};
var $1a77d6934b592676$export$6ba801e3e123536e = function(i) {
    return function(s) {
        return $MTXA4.take($MTXA4.length(s) - i | 0)(s);
    };
};
var $1a77d6934b592676$export$2344b14b097df817 = function(pat) {
    var $23 = $1a77d6934b592676$export$305f7d4e9d4624f2(pat);
    return function($24) {
        return $ykHdR.isJust($23($24));
    };
};
var $1a77d6934b592676$export$bbcf894add1d392c = /* #__PURE__ */ function() {
    return $MTXA4._charAt($ykHdR.Just.create)($ykHdR.Nothing.value);
}();

});
parcelRegister("MTXA4", function(module, exports) {

$parcel$export(module.exports, "fromCharArray", () => $092fe44bc0883be6$export$709e3b51bf2e2249);
$parcel$export(module.exports, "toCharArray", () => $092fe44bc0883be6$export$f718f38b069557c4);
$parcel$export(module.exports, "singleton", () => $092fe44bc0883be6$export$439306a4dcaafbb9);
$parcel$export(module.exports, "_charAt", () => $092fe44bc0883be6$export$f23b62aaf3f3dcce);
$parcel$export(module.exports, "_toChar", () => $092fe44bc0883be6$export$dc80a44c5e0495a);
$parcel$export(module.exports, "length", () => $092fe44bc0883be6$export$f24224f1c91d8156);
$parcel$export(module.exports, "countPrefix", () => $092fe44bc0883be6$export$29a68f758c141c85);
$parcel$export(module.exports, "_indexOf", () => $092fe44bc0883be6$export$7e78e83ef6946ae3);
$parcel$export(module.exports, "_indexOfStartingAt", () => $092fe44bc0883be6$export$dbaa25b6da818165);
$parcel$export(module.exports, "_lastIndexOf", () => $092fe44bc0883be6$export$a83518545dfc0fc1);
$parcel$export(module.exports, "_lastIndexOfStartingAt", () => $092fe44bc0883be6$export$12738dfb878f3de0);
$parcel$export(module.exports, "take", () => $092fe44bc0883be6$export$b7df5d561049483a);
$parcel$export(module.exports, "drop", () => $092fe44bc0883be6$export$663103110d94aac9);
$parcel$export(module.exports, "splitAt", () => $092fe44bc0883be6$export$b0d75975ac0be0e1);
const $092fe44bc0883be6$export$709e3b51bf2e2249 = function(a) {
    return a.join("");
};
const $092fe44bc0883be6$export$f718f38b069557c4 = function(s) {
    return s.split("");
};
const $092fe44bc0883be6$export$439306a4dcaafbb9 = function(c) {
    return c;
};
const $092fe44bc0883be6$export$f23b62aaf3f3dcce = function(just) {
    return function(nothing) {
        return function(i) {
            return function(s) {
                return i >= 0 && i < s.length ? just(s.charAt(i)) : nothing;
            };
        };
    };
};
const $092fe44bc0883be6$export$dc80a44c5e0495a = function(just) {
    return function(nothing) {
        return function(s) {
            return s.length === 1 ? just(s) : nothing;
        };
    };
};
const $092fe44bc0883be6$export$f24224f1c91d8156 = function(s) {
    return s.length;
};
const $092fe44bc0883be6$export$29a68f758c141c85 = function(p) {
    return function(s) {
        var i = 0;
        while(i < s.length && p(s.charAt(i)))i++;
        return i;
    };
};
const $092fe44bc0883be6$export$7e78e83ef6946ae3 = function(just) {
    return function(nothing) {
        return function(x) {
            return function(s) {
                var i = s.indexOf(x);
                return i === -1 ? nothing : just(i);
            };
        };
    };
};
const $092fe44bc0883be6$export$dbaa25b6da818165 = function(just) {
    return function(nothing) {
        return function(x) {
            return function(startAt) {
                return function(s) {
                    if (startAt < 0 || startAt > s.length) return nothing;
                    var i = s.indexOf(x, startAt);
                    return i === -1 ? nothing : just(i);
                };
            };
        };
    };
};
const $092fe44bc0883be6$export$a83518545dfc0fc1 = function(just) {
    return function(nothing) {
        return function(x) {
            return function(s) {
                var i = s.lastIndexOf(x);
                return i === -1 ? nothing : just(i);
            };
        };
    };
};
const $092fe44bc0883be6$export$12738dfb878f3de0 = function(just) {
    return function(nothing) {
        return function(x) {
            return function(startAt) {
                return function(s) {
                    var i = s.lastIndexOf(x, startAt);
                    return i === -1 ? nothing : just(i);
                };
            };
        };
    };
};
const $092fe44bc0883be6$export$b7df5d561049483a = function(n) {
    return function(s) {
        return s.substr(0, n);
    };
};
const $092fe44bc0883be6$export$663103110d94aac9 = function(n) {
    return function(s) {
        return s.substring(n);
    };
};
const $092fe44bc0883be6$export$58adb3bec8346d0f = function(b) {
    return function(e) {
        return function(s) {
            return s.slice(b, e);
        };
    };
};
const $092fe44bc0883be6$export$b0d75975ac0be0e1 = function(i) {
    return function(s) {
        return {
            before: s.substring(0, i),
            after: s.substring(i)
        };
    };
};

});

parcelRegister("jUjvc", function(module, exports) {

$parcel$export(module.exports, "charAt", () => (parcelRequire("4lhF1")).charAt);
// Generated by purs version 0.15.16

var $4lhF1 = parcelRequire("4lhF1");

});
parcelRegister("4lhF1", function(module, exports) {

$parcel$export(module.exports, "charAt", () => $3296d29fc7ea4822$export$bbcf894add1d392c);
const $3296d29fc7ea4822$export$bbcf894add1d392c = function(i) {
    return function(s) {
        if (i >= 0 && i < s.length) return s.charAt(i);
        throw new Error("Data.String.Unsafe.charAt: Invalid index.");
    };
};
const $3296d29fc7ea4822$export$eba6f6f03b0a92e7 = function(s) {
    if (s.length === 1) return s.charAt(0);
    throw new Error("Data.String.Unsafe.char: Expected string of length 1.");
};

});




parcelRegister("gvsQn", function(module, exports) {

$parcel$export(module.exports, "lookup", () => $c045ea5df33bba60$export$dfc7155ac0343b8);
// Generated by purs version 0.15.16

var $jLDjt = parcelRequire("jLDjt");

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $9Grh5 = parcelRequire("9Grh5");

var $7T8P4 = parcelRequire("7T8P4");

var $JFoio = parcelRequire("JFoio");
var $kHt3z = parcelRequire("kHt3z");

var $4VF0K = parcelRequire("4VF0K");

var $4MBcA = parcelRequire("4MBcA");

var $6RkEA = parcelRequire("6RkEA");

var $70sTh = parcelRequire("70sTh");

var $l4M7e = parcelRequire("l4M7e");
parcelRequire("ikChJ");
var $chZgc = parcelRequire("chZgc");

var $l0wDR = parcelRequire("l0wDR");

var $ykHdR = parcelRequire("ykHdR");

var $aknDF = parcelRequire("aknDF");

var $d0PPW = parcelRequire("d0PPW");

var $iwqgS = parcelRequire("iwqgS");

var $3Orkn = parcelRequire("3Orkn");

var $1wR1l = parcelRequire("1wR1l");

var $3OKRG = parcelRequire("3OKRG");

var $9MxTl = parcelRequire("9MxTl");

var $hsyEi = parcelRequire("hsyEi");
parcelRequire("69Fcq");
var $021yS = parcelRequire("021yS");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");
var $c045ea5df33bba60$var$sortWith = /* #__PURE__ */ $4VF0K.sortWith($d0PPW.ordString);
var $c045ea5df33bba60$var$bindFlipped = /* #__PURE__ */ $9Grh5.bindFlipped($JFoio.bindST);
var $c045ea5df33bba60$var$showTuple = /* #__PURE__ */ $9MxTl.showTuple($3Orkn.showString);
var $c045ea5df33bba60$var$pure = /* #__PURE__ */ $gUTA8.pure($JFoio.applicativeST);
var $c045ea5df33bba60$var$forWithIndex_ = /* #__PURE__ */ $70sTh.forWithIndex_($JFoio.applicativeST);
var $c045ea5df33bba60$var$for_ = /* #__PURE__ */ $6RkEA.for_($JFoio.applicativeST);
var $c045ea5df33bba60$var$$$void = /* #__PURE__ */ $l0wDR.void($JFoio.functorST);
var $c045ea5df33bba60$var$foldr = /* #__PURE__ */ $6RkEA.foldr($6RkEA.foldableArray);
var $c045ea5df33bba60$var$identity = /* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn);
var $c045ea5df33bba60$var$ordTuple = /* #__PURE__ */ $9MxTl.ordTuple($d0PPW.ordString);
var $c045ea5df33bba60$var$mapFlipped = /* #__PURE__ */ $l0wDR.mapFlipped($ykHdR.functorMaybe);
var $c045ea5df33bba60$export$68c286be0e7e55b7 = /* #__PURE__ */ $jLDjt.toArrayWithKey(function(v) {
    return function(v1) {
        return v1;
    };
});
var $c045ea5df33bba60$export$823be24f8766da23 = function(dictUnfoldable) {
    var $89 = $4VF0K.toUnfoldable(dictUnfoldable);
    var $90 = $jLDjt.toArrayWithKey($9MxTl.Tuple.create);
    return function($91) {
        return $89($90($91));
    };
};
var $c045ea5df33bba60$export$930399be55d0753b = function(dictUnfoldable) {
    var $92 = $4VF0K.toUnfoldable(dictUnfoldable);
    var $93 = $c045ea5df33bba60$var$sortWith($9MxTl.fst);
    var $94 = $jLDjt.toArrayWithKey($9MxTl.Tuple.create);
    return function($95) {
        return $92($93($94($95)));
    };
};
var $c045ea5df33bba60$var$toAscArray = /* #__PURE__ */ $c045ea5df33bba60$export$930399be55d0753b($hsyEi.unfoldableArray);
var $c045ea5df33bba60$var$toArray = /* #__PURE__ */ function() {
    return $jLDjt.toArrayWithKey($9MxTl.Tuple.create);
}();
var $c045ea5df33bba60$export$170df9728335f27d = $jLDjt._copyST;
var $c045ea5df33bba60$export$439306a4dcaafbb9 = function(k) {
    return function(v) {
        return $jLDjt.runST($c045ea5df33bba60$var$bindFlipped($021yS.poke(k)(v))($021yS.new));
    };
};
var $c045ea5df33bba60$export$4cfa48b10b7cd72d = function(dictShow) {
    var show = $3Orkn.show($3Orkn.showArray($c045ea5df33bba60$var$showTuple(dictShow)));
    return {
        show: function(m) {
            return "(fromFoldable " + (show($c045ea5df33bba60$var$toArray(m)) + ")");
        }
    };
};
var $c045ea5df33bba60$var$mutate = function(f) {
    return function(m) {
        return $jLDjt.runST(function __do() {
            var s = $c045ea5df33bba60$export$170df9728335f27d(m)();
            f(s)();
            return s;
        });
    };
};
var $c045ea5df33bba60$export$6a0d13241802fe80 = /* #__PURE__ */ $chZgc.runFn4($jLDjt._lookup)(false)(/* #__PURE__ */ $l4M7e.const(true));
var $c045ea5df33bba60$export$1292458786b96e98 = function(f) {
    return function(m) {
        return $jLDjt._mapWithKey(m, f);
    };
};
var $c045ea5df33bba60$export$dfc7155ac0343b8 = /* #__PURE__ */ function() {
    return $chZgc.runFn4($jLDjt._lookup)($ykHdR.Nothing.value)($ykHdR.Just.create);
}();
var $c045ea5df33bba60$export$35d0420a84c5d3ae = function(dictEq) {
    var eq = $4MBcA.eq(dictEq);
    return function(m1) {
        return function(m2) {
            var f = function(k) {
                return function(v) {
                    return $jLDjt._lookup(false, eq(v), k, m2);
                };
            };
            return $jLDjt.all(f)(m1);
        };
    };
};
var $c045ea5df33bba60$export$dd1bc94b04021eeb = /* #__PURE__ */ $jLDjt.all(function(v) {
    return function(v1) {
        return false;
    };
});
var $c045ea5df33bba60$export$21a5ca8aa77d35ff = function(k) {
    return function(v) {
        return $c045ea5df33bba60$var$mutate($021yS.poke(k)(v));
    };
};
var $c045ea5df33bba60$export$b7bb4265e2e489e0 = {
    map: function(f) {
        return function(m) {
            return $jLDjt._fmapObject(m, f);
        };
    }
};
var $c045ea5df33bba60$export$9c938d99ebec5017 = {
    mapWithIndex: $c045ea5df33bba60$export$1292458786b96e98,
    Functor0: function() {
        return $c045ea5df33bba60$export$b7bb4265e2e489e0;
    }
};
var $c045ea5df33bba60$export$a47a4d0fc4d6b25 = function() {
    return $eOrGk.unsafeCoerce;
};
var $c045ea5df33bba60$export$78cfe3464e7eb77b = function(dictFoldableWithIndex) {
    var forWithIndex_1 = $c045ea5df33bba60$var$forWithIndex_(dictFoldableWithIndex);
    return function(l) {
        return $jLDjt.runST(function __do() {
            var s = $021yS.new();
            forWithIndex_1(l)(function(k) {
                return function(v) {
                    return $021yS.poke(k)(v)(s);
                };
            })();
            return s;
        });
    };
};
var $c045ea5df33bba60$export$690be49d504fc7f = function(dictFoldable) {
    var for_1 = $c045ea5df33bba60$var$for_(dictFoldable);
    return function(f) {
        return function(l) {
            return $jLDjt.runST(function __do() {
                var s = $021yS.new();
                for_1(l)(function(v) {
                    return function __do() {
                        var v$prime = $jLDjt._lookupST(v.value1, f(v.value1), v.value0, s)();
                        return $021yS.poke(v.value0)(v$prime)(s)();
                    };
                })();
                return s;
            });
        };
    };
};
var $c045ea5df33bba60$export$b7d5d9bb9ff52072 = function(dictFoldable) {
    var fromFoldable1 = $4VF0K.fromFoldable(dictFoldable);
    return function(l) {
        return $jLDjt.runST(function __do() {
            var s = $021yS.new();
            $kHt3z.foreach(fromFoldable1(l))(function(v) {
                return $c045ea5df33bba60$var$$$void($021yS.poke(v.value0)(v.value1)(s));
            })();
            return s;
        });
    };
};
var $c045ea5df33bba60$export$a153ee4522d3545b = $jLDjt._copyST;
var $c045ea5df33bba60$export$a769d86e5b325bcf = function(f) {
    return function(z) {
        return function(m) {
            return $jLDjt._foldSCObject(m, z, f, $ykHdR.fromMaybe);
        };
    };
};
var $c045ea5df33bba60$export$7a067f9280ad8af0 = function(dictMonad) {
    var bind1 = $9Grh5.bind(dictMonad.Bind1());
    var pure1 = $gUTA8.pure(dictMonad.Applicative0());
    return function(f) {
        return function(z) {
            return $jLDjt._foldM(bind1)(f)(pure1(z));
        };
    };
};
var $c045ea5df33bba60$var$foldM1 = /* #__PURE__ */ $c045ea5df33bba60$export$7a067f9280ad8af0($JFoio.monadST);
var $c045ea5df33bba60$export$971dd5b0dfd021b6 = function(m) {
    return $c045ea5df33bba60$var$mutate(function(s) {
        return $c045ea5df33bba60$var$foldM1(function(s$prime) {
            return function(k) {
                return function(v) {
                    return $021yS.poke(k)(v)(s$prime);
                };
            };
        })(s)(m);
    });
};
var $c045ea5df33bba60$export$30b2db2f7030f6cf = function(dictFoldable) {
    return $6RkEA.foldl(dictFoldable)($c045ea5df33bba60$export$971dd5b0dfd021b6)($jLDjt.empty);
};
var $c045ea5df33bba60$export$ed1b4f34a0e8b0cc = function(f) {
    return function(m1) {
        return function(m2) {
            return $c045ea5df33bba60$var$mutate(function(s1) {
                return $c045ea5df33bba60$var$foldM1(function(s2) {
                    return function(k) {
                        return function(v1) {
                            return $021yS.poke(k)($jLDjt._lookup(v1, function(v2) {
                                return f(v1)(v2);
                            }, k, m2))(s2);
                        };
                    };
                })(s1)(m1);
            })(m2);
        };
    };
};
var $c045ea5df33bba60$export$7d0c6e9c5931d4de = function(dictSemigroup) {
    return {
        append: $c045ea5df33bba60$export$ed1b4f34a0e8b0cc($iwqgS.append(dictSemigroup))
    };
};
var $c045ea5df33bba60$export$cd8dd1e1b4d46833 = function(dictSemigroup) {
    var semigroupObject1 = $c045ea5df33bba60$export$7d0c6e9c5931d4de(dictSemigroup);
    return {
        mempty: $jLDjt.empty,
        Semigroup0: function() {
            return semigroupObject1;
        }
    };
};
var $c045ea5df33bba60$export$93e2b83da34ff82a = /* #__PURE__ */ $jLDjt._foldM($l4M7e.applyFlipped);
var $c045ea5df33bba60$export$b66cdc0497d8a99a = function(dictMonoid) {
    var append1 = $iwqgS.append(dictMonoid.Semigroup0());
    var mempty = $aknDF.mempty(dictMonoid);
    return function(f) {
        return $c045ea5df33bba60$export$93e2b83da34ff82a(function(acc) {
            return function(k) {
                return function(v) {
                    return append1(acc)(f(k)(v));
                };
            };
        })(mempty);
    };
};
var $c045ea5df33bba60$export$fb5657e12344d3bf = {
    foldl: function(f) {
        return $c045ea5df33bba60$export$93e2b83da34ff82a(function(z) {
            return function(v) {
                return f(z);
            };
        });
    },
    foldr: function(f) {
        return function(z) {
            return function(m) {
                return $c045ea5df33bba60$var$foldr(f)(z)($c045ea5df33bba60$export$68c286be0e7e55b7(m));
            };
        };
    },
    foldMap: function(dictMonoid) {
        var foldMap1 = $c045ea5df33bba60$export$b66cdc0497d8a99a(dictMonoid);
        return function(f) {
            return foldMap1($l4M7e.const(f));
        };
    }
};
var $c045ea5df33bba60$export$341deb6f42c48978 = {
    foldlWithIndex: function(f) {
        return $c045ea5df33bba60$export$93e2b83da34ff82a($l4M7e.flip(f));
    },
    foldrWithIndex: function(f) {
        return function(z) {
            return function(m) {
                return $c045ea5df33bba60$var$foldr($9MxTl.uncurry(f))(z)($jLDjt.toArrayWithKey($9MxTl.Tuple.create)(m));
            };
        };
    },
    foldMapWithIndex: function(dictMonoid) {
        return $c045ea5df33bba60$export$b66cdc0497d8a99a(dictMonoid);
    },
    Foldable0: function() {
        return $c045ea5df33bba60$export$fb5657e12344d3bf;
    }
};
var $c045ea5df33bba60$export$cffdb9059fc42749 = {
    traverseWithIndex: function(dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        var apply = $a5g3C.apply(Apply0);
        var map = $l0wDR.map(Apply0.Functor0());
        var pure1 = $gUTA8.pure(dictApplicative);
        return function(f) {
            return function(ms) {
                return $c045ea5df33bba60$export$93e2b83da34ff82a(function(acc) {
                    return function(k) {
                        return function(v) {
                            return apply(map($l4M7e.flip($c045ea5df33bba60$export$21a5ca8aa77d35ff(k)))(acc))(f(k)(v));
                        };
                    };
                })(pure1($jLDjt.empty))(ms);
            };
        };
    },
    FunctorWithIndex0: function() {
        return $c045ea5df33bba60$export$9c938d99ebec5017;
    },
    FoldableWithIndex1: function() {
        return $c045ea5df33bba60$export$341deb6f42c48978;
    },
    Traversable2: function() {
        return $c045ea5df33bba60$export$aeab5e284d2f12ed;
    }
};
var $c045ea5df33bba60$export$aeab5e284d2f12ed = {
    traverse: function(dictApplicative) {
        var $96 = $3OKRG.traverseWithIndex($c045ea5df33bba60$export$cffdb9059fc42749)(dictApplicative);
        return function($97) {
            return $96($l4M7e.const($97));
        };
    },
    sequence: function(dictApplicative) {
        return $1wR1l.traverse($c045ea5df33bba60$export$aeab5e284d2f12ed)(dictApplicative)($c045ea5df33bba60$var$identity);
    },
    Functor0: function() {
        return $c045ea5df33bba60$export$b7bb4265e2e489e0;
    },
    Foldable1: function() {
        return $c045ea5df33bba60$export$fb5657e12344d3bf;
    }
};
var $c045ea5df33bba60$export$d7a60370122a9ab0 = function(predicate) {
    return function(m) {
        var go = function() {
            var step = function(acc) {
                return function(k) {
                    return function(v) {
                        var $86 = predicate(k)(v);
                        if ($86) return $021yS.poke(k)(v)(acc);
                        return $c045ea5df33bba60$var$pure(acc);
                    };
                };
            };
            return function __do() {
                var m$prime = $021yS.new();
                return $c045ea5df33bba60$var$foldM1(step)(m$prime)(m)();
            };
        }();
        return $jLDjt.runST(go);
    };
};
var $c045ea5df33bba60$export$151f9a87a7fd5652 = function(predicate) {
    return $c045ea5df33bba60$export$d7a60370122a9ab0(function($98) {
        return $l4M7e.const(predicate($98));
    });
};
var $c045ea5df33bba60$export$3dea766d36a8935f = function(predicate) {
    return $c045ea5df33bba60$export$d7a60370122a9ab0($l4M7e.const(predicate));
};
var $c045ea5df33bba60$export$fddc1e6ca29dc4b4 = function(dictEq) {
    var isSubmap1 = $c045ea5df33bba60$export$35d0420a84c5d3ae(dictEq);
    return {
        eq: function(m1) {
            return function(m2) {
                return isSubmap1(m1)(m2) && isSubmap1(m2)(m1);
            };
        }
    };
};
var $c045ea5df33bba60$export$6393680ec5f1a42e = function(dictOrd) {
    var compare = $d0PPW.compare($d0PPW.ordArray($c045ea5df33bba60$var$ordTuple(dictOrd)));
    var eqObject1 = $c045ea5df33bba60$export$fddc1e6ca29dc4b4(dictOrd.Eq0());
    return {
        compare: function(m1) {
            return function(m2) {
                return compare($c045ea5df33bba60$var$toAscArray(m1))($c045ea5df33bba60$var$toAscArray(m2));
            };
        },
        Eq0: function() {
            return eqObject1;
        }
    };
};
var $c045ea5df33bba60$export$11e732c5af6e2d9f = {
    eq1: function(dictEq) {
        return $4MBcA.eq($c045ea5df33bba60$export$fddc1e6ca29dc4b4(dictEq));
    }
};
var $c045ea5df33bba60$export$1822828d790e23ee = function(k) {
    return $c045ea5df33bba60$var$mutate($021yS.delete(k));
};
var $c045ea5df33bba60$export$3e41007ebfff0e64 = function(k) {
    return function(m) {
        return $c045ea5df33bba60$var$mapFlipped($c045ea5df33bba60$export$dfc7155ac0343b8(k)(m))(function(a) {
            return new $9MxTl.Tuple(a, $c045ea5df33bba60$export$1822828d790e23ee(k)(m));
        });
    };
};
var $c045ea5df33bba60$export$22a7378e1d3307a4 = function(f) {
    return function(k) {
        return function(m) {
            var v = f($c045ea5df33bba60$export$dfc7155ac0343b8(k)(m));
            if (v instanceof $ykHdR.Nothing) return $c045ea5df33bba60$export$1822828d790e23ee(k)(m);
            if (v instanceof $ykHdR.Just) return $c045ea5df33bba60$export$21a5ca8aa77d35ff(k)(v.value0)(m);
            throw new Error("Failed pattern match at Foreign.Object (line 210, column 15 - line 212, column 25): " + [
                v.constructor.name
            ]);
        };
    };
};
var $c045ea5df33bba60$export$722fbec263ad908a = function(f) {
    return function(k) {
        return function(m) {
            return $c045ea5df33bba60$export$22a7378e1d3307a4($ykHdR.maybe($ykHdR.Nothing.value)(f))(k)(m);
        };
    };
};

});
parcelRegister("jLDjt", function(module, exports) {

$parcel$export(module.exports, "_copyST", () => $03b6b966974423fe$export$86b08f6436aa565c);
$parcel$export(module.exports, "empty", () => $03b6b966974423fe$export$6e22c362a0406a2c);
$parcel$export(module.exports, "runST", () => $03b6b966974423fe$export$c764c4f4747e1972);
$parcel$export(module.exports, "_fmapObject", () => $03b6b966974423fe$export$7c3aa937ffdd4482);
$parcel$export(module.exports, "_mapWithKey", () => $03b6b966974423fe$export$b583322487d15176);
$parcel$export(module.exports, "_foldM", () => $03b6b966974423fe$export$882f367473bfeff9);
$parcel$export(module.exports, "_foldSCObject", () => $03b6b966974423fe$export$b807e7b34437e8a6);
$parcel$export(module.exports, "all", () => $03b6b966974423fe$export$84bf76cd7afc7469);
$parcel$export(module.exports, "_lookup", () => $03b6b966974423fe$export$75b750e7d0325364);
$parcel$export(module.exports, "_lookupST", () => $03b6b966974423fe$export$d947399a194fcef2);
$parcel$export(module.exports, "toArrayWithKey", () => $03b6b966974423fe$export$4b1360bff9337362);
function $03b6b966974423fe$export$86b08f6436aa565c(m) {
    return function() {
        var r = {};
        for(var k in m)if (hasOwnProperty.call(m, k)) r[k] = m[k];
        return r;
    };
}
const $03b6b966974423fe$export$6e22c362a0406a2c = {};
function $03b6b966974423fe$export$c764c4f4747e1972(f) {
    return f();
}
function $03b6b966974423fe$export$7c3aa937ffdd4482(m0, f) {
    var m = {};
    for(var k in m0)if (hasOwnProperty.call(m0, k)) m[k] = f(m0[k]);
    return m;
}
function $03b6b966974423fe$export$b583322487d15176(m0, f) {
    var m = {};
    for(var k in m0)if (hasOwnProperty.call(m0, k)) m[k] = f(k)(m0[k]);
    return m;
}
function $03b6b966974423fe$export$882f367473bfeff9(bind) {
    return function(f) {
        return function(mz) {
            return function(m) {
                var acc = mz;
                function g(k) {
                    return function(z) {
                        return f(z)(k)(m[k]);
                    };
                }
                for(var k in m)if (hasOwnProperty.call(m, k)) acc = bind(acc)(g(k));
                return acc;
            };
        };
    };
}
function $03b6b966974423fe$export$b807e7b34437e8a6(m, z, f, fromMaybe) {
    var acc = z;
    for(var k in m)if (hasOwnProperty.call(m, k)) {
        var maybeR = f(acc)(k)(m[k]);
        var r = fromMaybe(null)(maybeR);
        if (r === null) return acc;
        else acc = r;
    }
    return acc;
}
function $03b6b966974423fe$export$84bf76cd7afc7469(f) {
    return function(m) {
        for(var k in m){
            if (hasOwnProperty.call(m, k) && !f(k)(m[k])) return false;
        }
        return true;
    };
}
function $03b6b966974423fe$export$346677f925de839c(m) {
    var s = 0;
    for(var k in m)if (hasOwnProperty.call(m, k)) ++s;
    return s;
}
function $03b6b966974423fe$export$75b750e7d0325364(no, yes, k, m) {
    return k in m ? yes(m[k]) : no;
}
function $03b6b966974423fe$export$d947399a194fcef2(no, yes, k, m) {
    return function() {
        return k in m ? yes(m[k]) : no;
    };
}
function $03b6b966974423fe$export$4b1360bff9337362(f) {
    return function(m) {
        var r = [];
        for(var k in m)if (hasOwnProperty.call(m, k)) r.push(f(k)(m[k]));
        return r;
    };
}
const $03b6b966974423fe$export$ed97f33186d4b816 = Object.keys || $03b6b966974423fe$export$4b1360bff9337362(function(k) {
    return function() {
        return k;
    };
});

});


parcelRegister("cehdW", function(module, exports) {

$parcel$export(module.exports, "eventListener", () => (parcelRequire("d7ECG")).eventListener);
$parcel$export(module.exports, "addEventListener", () => (parcelRequire("d7ECG")).addEventListener);
$parcel$export(module.exports, "removeEventListener", () => (parcelRequire("d7ECG")).removeEventListener);
// Generated by purs version 0.15.16

var $d7ECG = parcelRequire("d7ECG");
parcelRequire("9Iupi");

});
parcelRegister("d7ECG", function(module, exports) {

$parcel$export(module.exports, "eventListener", () => $98db70b23aa8a6ea$export$f5cdf3809b4587f3);
$parcel$export(module.exports, "addEventListener", () => $98db70b23aa8a6ea$export$3f65cefe8380dbea);
$parcel$export(module.exports, "removeEventListener", () => $98db70b23aa8a6ea$export$8ff9f68337b520c0);
function $98db70b23aa8a6ea$export$f5cdf3809b4587f3(fn) {
    return function() {
        return function(event) {
            return fn(event)();
        };
    };
}
function $98db70b23aa8a6ea$export$d5d038f71f8391de(type) {
    return function(listener) {
        return function(options) {
            return function(target) {
                return function() {
                    return target.addEventListener(type, listener, options);
                };
            };
        };
    };
}
function $98db70b23aa8a6ea$export$3f65cefe8380dbea(type) {
    return function(listener) {
        return function(useCapture) {
            return function(target) {
                return function() {
                    return target.addEventListener(type, listener, useCapture);
                };
            };
        };
    };
}
function $98db70b23aa8a6ea$export$8ff9f68337b520c0(type) {
    return function(listener) {
        return function(useCapture) {
            return function(target) {
                return function() {
                    return target.removeEventListener(type, listener, useCapture);
                };
            };
        };
    };
}
function $98db70b23aa8a6ea$export$716a11175c03fb4e(event) {
    return function(target) {
        return function() {
            return target.dispatchEvent(event);
        };
    };
}

});

parcelRegister("9Iupi", function(module, exports) {
// Generated by purs version 0.15.16

});



parcelRegister("iBWyn", function(module, exports) {
// Generated by purs version 0.15.16

var $4MBcA = parcelRequire("4MBcA");

var $d0PPW = parcelRequire("d0PPW");
var $d8c91a2be15f75cb$export$212382f8c1a1154e = function(x) {
    return x;
};
var $d8c91a2be15f75cb$export$880a60b2adf28011 = function(x) {
    return x;
};
var $d8c91a2be15f75cb$export$ede06c734afe650b = function(x) {
    return x;
};
var $d8c91a2be15f75cb$export$95abab3275973ab6 = $d0PPW.ordString;
var $d8c91a2be15f75cb$export$c58d7d69adf07268 = $d0PPW.ordString;
var $d8c91a2be15f75cb$export$6d81548222f15a9a = $d0PPW.ordString;
var $d8c91a2be15f75cb$export$e2c5e238f46c1980 = {
    Coercible0: function() {
        return undefined;
    }
};
var $d8c91a2be15f75cb$export$a0bcd3a016e5808d = {
    Coercible0: function() {
        return undefined;
    }
};
var $d8c91a2be15f75cb$export$7e4243c3c9480b2b = {
    Coercible0: function() {
        return undefined;
    }
};
var $d8c91a2be15f75cb$export$24a4aa0a132c9555 = $4MBcA.eqString;
var $d8c91a2be15f75cb$export$b50b66d86c8b8bf = $4MBcA.eqString;
var $d8c91a2be15f75cb$export$10c76280137f9306 = $4MBcA.eqString;

});


parcelRegister("jIMHU", function(module, exports) {

$parcel$export(module.exports, "h2_", () => $e5b7e89a68d9c456$export$fb9cd428790d91ac);
$parcel$export(module.exports, "h3_", () => $e5b7e89a68d9c456$export$d3f2bf86163ce5b1);
$parcel$export(module.exports, "li_", () => $e5b7e89a68d9c456$export$867ad32b190d58af);
$parcel$export(module.exports, "ol", () => $e5b7e89a68d9c456$export$b2235297ee22a6fe);
$parcel$export(module.exports, "p_", () => $e5b7e89a68d9c456$export$3950a0ab4293f4c0);
$parcel$export(module.exports, "span", () => $e5b7e89a68d9c456$export$afc1bfabebaf28a2);
$parcel$export(module.exports, "table", () => $e5b7e89a68d9c456$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tbody_", () => $e5b7e89a68d9c456$export$a78509387f11524c);
$parcel$export(module.exports, "td", () => $e5b7e89a68d9c456$export$2beef8af2014e5c6);
$parcel$export(module.exports, "td_", () => $e5b7e89a68d9c456$export$bf83c8517c04b4f6);
$parcel$export(module.exports, "textarea", () => $e5b7e89a68d9c456$export$a3574df893ffa88d);
$parcel$export(module.exports, "th_", () => $e5b7e89a68d9c456$export$5e18a33d145a9a4c);
$parcel$export(module.exports, "thead_", () => $e5b7e89a68d9c456$export$e607565248beba15);
$parcel$export(module.exports, "tr", () => $e5b7e89a68d9c456$export$72451b88a72ad9c2);
$parcel$export(module.exports, "tr_", () => $e5b7e89a68d9c456$export$6645783692722b88);
$parcel$export(module.exports, "div", () => $e5b7e89a68d9c456$export$159d9494db57879b);
$parcel$export(module.exports, "div_", () => $e5b7e89a68d9c456$export$3327f90baeaa2cb3);
$parcel$export(module.exports, "button", () => $e5b7e89a68d9c456$export$2ba01fb71ed41cb6);
$parcel$export(module.exports, "a", () => $e5b7e89a68d9c456$export$407448d2b89b1813);
// Generated by purs version 0.15.16

var $gUTA8 = parcelRequire("gUTA8");

var $ykHdR = parcelRequire("ykHdR");

var $hhMAk = parcelRequire("hhMAk");

var $gorft = parcelRequire("gorft");
var $e5b7e89a68d9c456$var$pure = /* #__PURE__ */ $gUTA8.pure($ykHdR.applicativeMaybe);
var $e5b7e89a68d9c456$export$f4752d802d3c730b = function(ctor) {
    return function(children) {
        var v = ctor([]);
        if (v instanceof $gorft.Elem) return new $gorft.Keyed(v.value0, v.value1, v.value2, children);
        return v;
    };
};
var $e5b7e89a68d9c456$export$f691a8759658f782 = function(ctor) {
    return function(props) {
        return function(children) {
            var v = ctor(props)([]);
            if (v instanceof $gorft.Elem) return new $gorft.Keyed(v.value0, v.value1, v.value2, children);
            return v;
        };
    };
};
var $e5b7e89a68d9c456$export$8a24d5472c669cc1 = function($14) {
    return $hhMAk.keyed($e5b7e89a68d9c456$var$pure($14));
};
var $e5b7e89a68d9c456$export$8dbf9c790527241e = /* #__PURE__ */ function() {
    return $hhMAk.keyed($ykHdR.Nothing.value);
}();
var $e5b7e89a68d9c456$export$cba2bb7f1b8927c4 = function($15) {
    return $hhMAk.element($e5b7e89a68d9c456$var$pure($15));
};
var $e5b7e89a68d9c456$export$8454457683f90105 = /* #__PURE__ */ function() {
    return $hhMAk.element($ykHdR.Nothing.value);
}();
var $e5b7e89a68d9c456$export$c63c6f932822f543 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("em");
var $e5b7e89a68d9c456$export$a5c38c2752f1223a = /* #__PURE__ */ $e5b7e89a68d9c456$export$c63c6f932822f543([]);
var $e5b7e89a68d9c456$export$2be46bb7e96db87f = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("embed");
var $e5b7e89a68d9c456$export$b53e7b77250f04f9 = /* #__PURE__ */ $e5b7e89a68d9c456$export$2be46bb7e96db87f([]);
var $e5b7e89a68d9c456$export$a38812d1aa1302d9 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("fieldset");
var $e5b7e89a68d9c456$export$2dc1b8d0924efe56 = /* #__PURE__ */ $e5b7e89a68d9c456$export$a38812d1aa1302d9([]);
var $e5b7e89a68d9c456$export$b75acb72a9c69c26 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("figcaption");
var $e5b7e89a68d9c456$export$60dfbef68b872a19 = /* #__PURE__ */ $e5b7e89a68d9c456$export$b75acb72a9c69c26([]);
var $e5b7e89a68d9c456$export$991dc94f816a1d48 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("figure");
var $e5b7e89a68d9c456$export$e3500458218031e0 = /* #__PURE__ */ $e5b7e89a68d9c456$export$991dc94f816a1d48([]);
var $e5b7e89a68d9c456$export$adb608be33961c98 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("footer");
var $e5b7e89a68d9c456$export$70a8ff4564bfd029 = /* #__PURE__ */ $e5b7e89a68d9c456$export$adb608be33961c98([]);
var $e5b7e89a68d9c456$export$6210fa4921d2a466 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("form");
var $e5b7e89a68d9c456$export$1df82cba65ddbdc7 = /* #__PURE__ */ $e5b7e89a68d9c456$export$6210fa4921d2a466([]);
var $e5b7e89a68d9c456$export$448e4850cad7c7b0 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("h1");
var $e5b7e89a68d9c456$export$762b01c17cd5ef84 = /* #__PURE__ */ $e5b7e89a68d9c456$export$448e4850cad7c7b0([]);
var $e5b7e89a68d9c456$export$a943aa9a0fca3f0b = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("h2");
var $e5b7e89a68d9c456$export$fb9cd428790d91ac = /* #__PURE__ */ $e5b7e89a68d9c456$export$a943aa9a0fca3f0b([]);
var $e5b7e89a68d9c456$export$7edd4a21fac8ce55 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("h3");
var $e5b7e89a68d9c456$export$d3f2bf86163ce5b1 = /* #__PURE__ */ $e5b7e89a68d9c456$export$7edd4a21fac8ce55([]);
var $e5b7e89a68d9c456$export$51a85cc1b68f452c = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("h4");
var $e5b7e89a68d9c456$export$44266b9d6c80e925 = /* #__PURE__ */ $e5b7e89a68d9c456$export$51a85cc1b68f452c([]);
var $e5b7e89a68d9c456$export$f44841a11990acb2 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("h5");
var $e5b7e89a68d9c456$export$29e7034271223ef2 = /* #__PURE__ */ $e5b7e89a68d9c456$export$f44841a11990acb2([]);
var $e5b7e89a68d9c456$export$c9ccd321d64f47e3 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("h6");
var $e5b7e89a68d9c456$export$454ef0c5c33a2870 = /* #__PURE__ */ $e5b7e89a68d9c456$export$c9ccd321d64f47e3([]);
var $e5b7e89a68d9c456$export$5fd5031fecdacec3 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("head");
var $e5b7e89a68d9c456$export$1139b773e3687c26 = /* #__PURE__ */ $e5b7e89a68d9c456$export$5fd5031fecdacec3([]);
var $e5b7e89a68d9c456$export$38e42c68cf43b5d4 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("header");
var $e5b7e89a68d9c456$export$8bf7349458487350 = /* #__PURE__ */ $e5b7e89a68d9c456$export$38e42c68cf43b5d4([]);
var $e5b7e89a68d9c456$export$b4adb3f464574dcf = function(props) {
    return $e5b7e89a68d9c456$export$8454457683f90105("hr")(props)([]);
};
var $e5b7e89a68d9c456$export$d5ef68f9e25856a2 = /* #__PURE__ */ $e5b7e89a68d9c456$export$b4adb3f464574dcf([]);
var $e5b7e89a68d9c456$export$c0bb0b647f701bb5 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("html");
var $e5b7e89a68d9c456$export$435678c2016b20e2 = /* #__PURE__ */ $e5b7e89a68d9c456$export$c0bb0b647f701bb5([]);
var $e5b7e89a68d9c456$export$23f2a1d2818174ef = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("i");
var $e5b7e89a68d9c456$export$3d4cba5f342e903e = /* #__PURE__ */ $e5b7e89a68d9c456$export$23f2a1d2818174ef([]);
var $e5b7e89a68d9c456$export$8cde213409fd6377 = function(props) {
    return $e5b7e89a68d9c456$export$8454457683f90105("iframe")(props)([]);
};
var $e5b7e89a68d9c456$export$463b44d9bf3628be = function(props) {
    return $e5b7e89a68d9c456$export$8454457683f90105("img")(props)([]);
};
var $e5b7e89a68d9c456$export$b7e3ae3d7c15e42e = function(props) {
    return $e5b7e89a68d9c456$export$8454457683f90105("input")(props)([]);
};
var $e5b7e89a68d9c456$export$27a48efc044c200a = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("ins");
var $e5b7e89a68d9c456$export$be13014404ffcf2b = /* #__PURE__ */ $e5b7e89a68d9c456$export$27a48efc044c200a([]);
var $e5b7e89a68d9c456$export$1ed45b69d23c052b = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("kbd");
var $e5b7e89a68d9c456$export$4a6534c938817498 = /* #__PURE__ */ $e5b7e89a68d9c456$export$1ed45b69d23c052b([]);
var $e5b7e89a68d9c456$export$1237798dc640739a = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("label");
var $e5b7e89a68d9c456$export$71f1ceb3290c95d7 = /* #__PURE__ */ $e5b7e89a68d9c456$export$1237798dc640739a([]);
var $e5b7e89a68d9c456$export$9a9b59e08de24cef = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("legend");
var $e5b7e89a68d9c456$export$d57b7c1bdf9a3bfc = /* #__PURE__ */ $e5b7e89a68d9c456$export$9a9b59e08de24cef([]);
var $e5b7e89a68d9c456$export$19caeaf7d9d84644 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("li");
var $e5b7e89a68d9c456$export$867ad32b190d58af = /* #__PURE__ */ $e5b7e89a68d9c456$export$19caeaf7d9d84644([]);
var $e5b7e89a68d9c456$export$9c30223ca0a664fb = function(props) {
    return $e5b7e89a68d9c456$export$8454457683f90105("link")(props)([]);
};
var $e5b7e89a68d9c456$export$f22da7240b7add18 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("main");
var $e5b7e89a68d9c456$export$88d8d81b07aa78ac = /* #__PURE__ */ $e5b7e89a68d9c456$export$f22da7240b7add18([]);
var $e5b7e89a68d9c456$export$871de8747c9eaa88 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("map");
var $e5b7e89a68d9c456$export$aca8cce159e578de = /* #__PURE__ */ $e5b7e89a68d9c456$export$871de8747c9eaa88([]);
var $e5b7e89a68d9c456$export$bf7f2fce5c1cf636 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("mark");
var $e5b7e89a68d9c456$export$8e88f701cd5c1522 = /* #__PURE__ */ $e5b7e89a68d9c456$export$bf7f2fce5c1cf636([]);
var $e5b7e89a68d9c456$export$b1e5508a851be14d = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("menu");
var $e5b7e89a68d9c456$export$d18229b57986002 = /* #__PURE__ */ $e5b7e89a68d9c456$export$b1e5508a851be14d([]);
var $e5b7e89a68d9c456$export$f68e44d881264486 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("menuitem");
var $e5b7e89a68d9c456$export$e25e9f3e172962c6 = /* #__PURE__ */ $e5b7e89a68d9c456$export$f68e44d881264486([]);
var $e5b7e89a68d9c456$export$6990040ee07315 = function(props) {
    return $e5b7e89a68d9c456$export$8454457683f90105("meta")(props)([]);
};
var $e5b7e89a68d9c456$export$82334bbdfcebb57 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("meter");
var $e5b7e89a68d9c456$export$86fa78168c2ac21a = /* #__PURE__ */ $e5b7e89a68d9c456$export$82334bbdfcebb57([]);
var $e5b7e89a68d9c456$export$80e4b313e5e6b30d = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("nav");
var $e5b7e89a68d9c456$export$5c8b9c326353f574 = /* #__PURE__ */ $e5b7e89a68d9c456$export$80e4b313e5e6b30d([]);
var $e5b7e89a68d9c456$export$528ba0e6da49e146 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("noscript");
var $e5b7e89a68d9c456$export$6d2a3f75abf3cf2f = /* #__PURE__ */ $e5b7e89a68d9c456$export$528ba0e6da49e146([]);
var $e5b7e89a68d9c456$export$be5493f9613cbbe = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("object");
var $e5b7e89a68d9c456$export$5486b676036981c0 = /* #__PURE__ */ $e5b7e89a68d9c456$export$be5493f9613cbbe([]);
var $e5b7e89a68d9c456$export$b2235297ee22a6fe = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("ol");
var $e5b7e89a68d9c456$export$ccd58f56d982d30 = /* #__PURE__ */ $e5b7e89a68d9c456$export$b2235297ee22a6fe([]);
var $e5b7e89a68d9c456$export$b9d336f245a516e8 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("optgroup");
var $e5b7e89a68d9c456$export$5e41220970d85779 = /* #__PURE__ */ $e5b7e89a68d9c456$export$b9d336f245a516e8([]);
var $e5b7e89a68d9c456$export$a75d1723e6bda2ec = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("option");
var $e5b7e89a68d9c456$export$32e31af4e5fb3144 = /* #__PURE__ */ $e5b7e89a68d9c456$export$a75d1723e6bda2ec([]);
var $e5b7e89a68d9c456$export$c789db2c85949867 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("output");
var $e5b7e89a68d9c456$export$8874a395de964196 = /* #__PURE__ */ $e5b7e89a68d9c456$export$c789db2c85949867([]);
var $e5b7e89a68d9c456$export$ffb5f4729a158638 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("p");
var $e5b7e89a68d9c456$export$3950a0ab4293f4c0 = /* #__PURE__ */ $e5b7e89a68d9c456$export$ffb5f4729a158638([]);
var $e5b7e89a68d9c456$export$6f7d1d9d04558207 = function(props) {
    return $e5b7e89a68d9c456$export$8454457683f90105("param")(props)([]);
};
var $e5b7e89a68d9c456$export$2af2ac64526e2aa9 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("pre");
var $e5b7e89a68d9c456$export$40eb7481a9b1d565 = /* #__PURE__ */ $e5b7e89a68d9c456$export$2af2ac64526e2aa9([]);
var $e5b7e89a68d9c456$export$504d7abb21fa8c9 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("progress");
var $e5b7e89a68d9c456$export$c56c869b2fd24a27 = /* #__PURE__ */ $e5b7e89a68d9c456$export$504d7abb21fa8c9([]);
var $e5b7e89a68d9c456$export$9e5f44173e64f162 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("q");
var $e5b7e89a68d9c456$export$cfeebac18d15c854 = /* #__PURE__ */ $e5b7e89a68d9c456$export$9e5f44173e64f162([]);
var $e5b7e89a68d9c456$export$6d4c73e3ddf8818b = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("rp");
var $e5b7e89a68d9c456$export$16adec6ab929083f = /* #__PURE__ */ $e5b7e89a68d9c456$export$6d4c73e3ddf8818b([]);
var $e5b7e89a68d9c456$export$f08282231bb71285 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("rt");
var $e5b7e89a68d9c456$export$512c1f41f1ce606b = /* #__PURE__ */ $e5b7e89a68d9c456$export$f08282231bb71285([]);
var $e5b7e89a68d9c456$export$f2b283820b448b35 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("ruby");
var $e5b7e89a68d9c456$export$8e70c3d96e82daa8 = /* #__PURE__ */ $e5b7e89a68d9c456$export$f2b283820b448b35([]);
var $e5b7e89a68d9c456$export$8c1cb8fb6818c292 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("samp");
var $e5b7e89a68d9c456$export$6d135438f4b2f058 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8c1cb8fb6818c292([]);
var $e5b7e89a68d9c456$export$bc237d627614fc48 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("script");
var $e5b7e89a68d9c456$export$dc29c33250ef6a12 = /* #__PURE__ */ $e5b7e89a68d9c456$export$bc237d627614fc48([]);
var $e5b7e89a68d9c456$export$fe2e36411d703b3d = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("section");
var $e5b7e89a68d9c456$export$23973f3de41ad862 = /* #__PURE__ */ $e5b7e89a68d9c456$export$fe2e36411d703b3d([]);
var $e5b7e89a68d9c456$export$2e6c959c16ff56b8 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("select");
var $e5b7e89a68d9c456$export$626530082bbb6846 = /* #__PURE__ */ $e5b7e89a68d9c456$export$2e6c959c16ff56b8([]);
var $e5b7e89a68d9c456$export$3c17b0e969a90510 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("small");
var $e5b7e89a68d9c456$export$7c956911267b1bca = /* #__PURE__ */ $e5b7e89a68d9c456$export$3c17b0e969a90510([]);
var $e5b7e89a68d9c456$export$b4d5da5f34fb77ad = function(props) {
    return $e5b7e89a68d9c456$export$8454457683f90105("source")(props)([]);
};
var $e5b7e89a68d9c456$export$afc1bfabebaf28a2 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("span");
var $e5b7e89a68d9c456$export$727654ffe296bd78 = /* #__PURE__ */ $e5b7e89a68d9c456$export$afc1bfabebaf28a2([]);
var $e5b7e89a68d9c456$export$59ae2c325a998f89 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("strong");
var $e5b7e89a68d9c456$export$e4a9f9f4befb34d3 = /* #__PURE__ */ $e5b7e89a68d9c456$export$59ae2c325a998f89([]);
var $e5b7e89a68d9c456$export$1d567c320f4763bc = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("style");
var $e5b7e89a68d9c456$export$91f114121fd8ef96 = /* #__PURE__ */ $e5b7e89a68d9c456$export$1d567c320f4763bc([]);
var $e5b7e89a68d9c456$export$f93b5905241a7cca = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("sub");
var $e5b7e89a68d9c456$export$1b578d76e1a8b229 = /* #__PURE__ */ $e5b7e89a68d9c456$export$f93b5905241a7cca([]);
var $e5b7e89a68d9c456$export$9a2dbef7a17e2e58 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("summary");
var $e5b7e89a68d9c456$export$2107ebccf1a0ff3d = /* #__PURE__ */ $e5b7e89a68d9c456$export$9a2dbef7a17e2e58([]);
var $e5b7e89a68d9c456$export$abe1cd54efe9b9cd = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("sup");
var $e5b7e89a68d9c456$export$2ed99a076908dcca = /* #__PURE__ */ $e5b7e89a68d9c456$export$abe1cd54efe9b9cd([]);
var $e5b7e89a68d9c456$export$9852986a3ec5f6a0 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("table");
var $e5b7e89a68d9c456$export$67d0d859a50d84a3 = /* #__PURE__ */ $e5b7e89a68d9c456$export$9852986a3ec5f6a0([]);
var $e5b7e89a68d9c456$export$7cdd536eaa8f163c = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("tbody");
var $e5b7e89a68d9c456$export$a78509387f11524c = /* #__PURE__ */ $e5b7e89a68d9c456$export$7cdd536eaa8f163c([]);
var $e5b7e89a68d9c456$export$2beef8af2014e5c6 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("td");
var $e5b7e89a68d9c456$export$bf83c8517c04b4f6 = /* #__PURE__ */ $e5b7e89a68d9c456$export$2beef8af2014e5c6([]);
var $e5b7e89a68d9c456$export$a3574df893ffa88d = function(es) {
    return $e5b7e89a68d9c456$export$8454457683f90105("textarea")(es)([]);
};
var $e5b7e89a68d9c456$export$9396b2f97a03ad14 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("tfoot");
var $e5b7e89a68d9c456$export$7f741d66040a80c8 = /* #__PURE__ */ $e5b7e89a68d9c456$export$9396b2f97a03ad14([]);
var $e5b7e89a68d9c456$export$d657bc098992a431 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("th");
var $e5b7e89a68d9c456$export$5e18a33d145a9a4c = /* #__PURE__ */ $e5b7e89a68d9c456$export$d657bc098992a431([]);
var $e5b7e89a68d9c456$export$e3f32a5920890b82 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("thead");
var $e5b7e89a68d9c456$export$e607565248beba15 = /* #__PURE__ */ $e5b7e89a68d9c456$export$e3f32a5920890b82([]);
var $e5b7e89a68d9c456$export$2da9be4cfdb689b1 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("time");
var $e5b7e89a68d9c456$export$cf828072303f47a1 = /* #__PURE__ */ $e5b7e89a68d9c456$export$2da9be4cfdb689b1([]);
var $e5b7e89a68d9c456$export$fb184b623420d9be = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("title");
var $e5b7e89a68d9c456$export$913d7d8b8f172930 = /* #__PURE__ */ $e5b7e89a68d9c456$export$fb184b623420d9be([]);
var $e5b7e89a68d9c456$export$72451b88a72ad9c2 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("tr");
var $e5b7e89a68d9c456$export$6645783692722b88 = /* #__PURE__ */ $e5b7e89a68d9c456$export$72451b88a72ad9c2([]);
var $e5b7e89a68d9c456$export$6b2a7d5132615086 = function(props) {
    return $e5b7e89a68d9c456$export$8454457683f90105("track")(props)([]);
};
var $e5b7e89a68d9c456$export$3b14a55fb2447963 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("u");
var $e5b7e89a68d9c456$export$cea9ae7324478a0a = /* #__PURE__ */ $e5b7e89a68d9c456$export$3b14a55fb2447963([]);
var $e5b7e89a68d9c456$export$b5023c870cb34848 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("ul");
var $e5b7e89a68d9c456$export$995bef5d59d32608 = /* #__PURE__ */ $e5b7e89a68d9c456$export$b5023c870cb34848([]);
var $e5b7e89a68d9c456$export$4732baac96d948aa = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("var");
var $e5b7e89a68d9c456$export$f6567ad6eb928d58 = /* #__PURE__ */ $e5b7e89a68d9c456$export$4732baac96d948aa([]);
var $e5b7e89a68d9c456$export$5f8d3589eb8441ca = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("video");
var $e5b7e89a68d9c456$export$aeb4f4e4f36fb9d9 = /* #__PURE__ */ $e5b7e89a68d9c456$export$5f8d3589eb8441ca([]);
var $e5b7e89a68d9c456$export$ee8f8f9447a35bdc = function(props) {
    return $e5b7e89a68d9c456$export$8454457683f90105("wbr")(props)([]);
};
var $e5b7e89a68d9c456$export$9198f9466fc833e = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("dt");
var $e5b7e89a68d9c456$export$eaec8774df2ce75c = /* #__PURE__ */ $e5b7e89a68d9c456$export$9198f9466fc833e([]);
var $e5b7e89a68d9c456$export$53d26b7a9a23d594 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("dl");
var $e5b7e89a68d9c456$export$e8817a08353617fb = /* #__PURE__ */ $e5b7e89a68d9c456$export$53d26b7a9a23d594([]);
var $e5b7e89a68d9c456$export$159d9494db57879b = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("div");
var $e5b7e89a68d9c456$export$3327f90baeaa2cb3 = /* #__PURE__ */ $e5b7e89a68d9c456$export$159d9494db57879b([]);
var $e5b7e89a68d9c456$export$518824cf31321346 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("dialog");
var $e5b7e89a68d9c456$export$95cd7f04cb5b4aa5 = /* #__PURE__ */ $e5b7e89a68d9c456$export$518824cf31321346([]);
var $e5b7e89a68d9c456$export$771f54d1a902afc9 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("dfn");
var $e5b7e89a68d9c456$export$afe13c5e7d9b4a7 = /* #__PURE__ */ $e5b7e89a68d9c456$export$771f54d1a902afc9([]);
var $e5b7e89a68d9c456$export$41ee12f6f6f05843 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("details");
var $e5b7e89a68d9c456$export$a47bcbad56ffd401 = /* #__PURE__ */ $e5b7e89a68d9c456$export$41ee12f6f6f05843([]);
var $e5b7e89a68d9c456$export$1d2f21e549771e67 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("del");
var $e5b7e89a68d9c456$export$965d9e1c56547986 = /* #__PURE__ */ $e5b7e89a68d9c456$export$1d2f21e549771e67([]);
var $e5b7e89a68d9c456$export$eaaeafa904fe3ddf = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("dd");
var $e5b7e89a68d9c456$export$333318a39958213e = /* #__PURE__ */ $e5b7e89a68d9c456$export$eaaeafa904fe3ddf([]);
var $e5b7e89a68d9c456$export$d6956b5f6d5ee87d = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("datalist");
var $e5b7e89a68d9c456$export$4479caebc8699400 = /* #__PURE__ */ $e5b7e89a68d9c456$export$d6956b5f6d5ee87d([]);
var $e5b7e89a68d9c456$export$ae50443ffc990749 = function(props) {
    return $e5b7e89a68d9c456$export$8454457683f90105("command")(props)([]);
};
var $e5b7e89a68d9c456$export$3db318dd257cd653 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("colgroup");
var $e5b7e89a68d9c456$export$4d89c25fc3dc3ce6 = /* #__PURE__ */ $e5b7e89a68d9c456$export$3db318dd257cd653([]);
var $e5b7e89a68d9c456$export$aba86695643891f5 = function(props) {
    return $e5b7e89a68d9c456$export$8454457683f90105("col")(props)([]);
};
var $e5b7e89a68d9c456$export$6565f9f03506010b = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("code");
var $e5b7e89a68d9c456$export$a82e8ec18d45f1e3 = /* #__PURE__ */ $e5b7e89a68d9c456$export$6565f9f03506010b([]);
var $e5b7e89a68d9c456$export$3035df57df42c31a = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("cite");
var $e5b7e89a68d9c456$export$4371c8153c03edbd = /* #__PURE__ */ $e5b7e89a68d9c456$export$3035df57df42c31a([]);
var $e5b7e89a68d9c456$export$8e3c2dfdc4f0453d = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("caption");
var $e5b7e89a68d9c456$export$63f9754c9b1fac36 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8e3c2dfdc4f0453d([]);
var $e5b7e89a68d9c456$export$67ea982130081db = function(props) {
    return $e5b7e89a68d9c456$export$8454457683f90105("canvas")(props)([]);
};
var $e5b7e89a68d9c456$export$2ba01fb71ed41cb6 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("button");
var $e5b7e89a68d9c456$export$ff362f92cc25e36a = /* #__PURE__ */ $e5b7e89a68d9c456$export$2ba01fb71ed41cb6([]);
var $e5b7e89a68d9c456$export$479ac0420f53ed26 = function(props) {
    return $e5b7e89a68d9c456$export$8454457683f90105("br")(props)([]);
};
var $e5b7e89a68d9c456$export$73cdcb65e5517a4b = /* #__PURE__ */ $e5b7e89a68d9c456$export$479ac0420f53ed26([]);
var $e5b7e89a68d9c456$export$32180ef41b15b513 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("body");
var $e5b7e89a68d9c456$export$72fbd758d159fe4b = /* #__PURE__ */ $e5b7e89a68d9c456$export$32180ef41b15b513([]);
var $e5b7e89a68d9c456$export$67dc04e652a298ca = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("blockquote");
var $e5b7e89a68d9c456$export$3b176ffafe2ecb0b = /* #__PURE__ */ $e5b7e89a68d9c456$export$67dc04e652a298ca([]);
var $e5b7e89a68d9c456$export$fae0db89ef70aab2 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("bdo");
var $e5b7e89a68d9c456$export$e57ac2b1cb1a62e1 = /* #__PURE__ */ $e5b7e89a68d9c456$export$fae0db89ef70aab2([]);
var $e5b7e89a68d9c456$export$2d20a4e9df674436 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("bdi");
var $e5b7e89a68d9c456$export$f5459c7588d93378 = /* #__PURE__ */ $e5b7e89a68d9c456$export$2d20a4e9df674436([]);
var $e5b7e89a68d9c456$export$e2253033e6e1df16 = function(props) {
    return $e5b7e89a68d9c456$export$8454457683f90105("base")(props)([]);
};
var $e5b7e89a68d9c456$export$8b22cf2602fb60ce = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("b");
var $e5b7e89a68d9c456$export$c69d65aa55814164 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8b22cf2602fb60ce([]);
var $e5b7e89a68d9c456$export$592b77e6034db746 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("audio");
var $e5b7e89a68d9c456$export$610b618347792e57 = /* #__PURE__ */ $e5b7e89a68d9c456$export$592b77e6034db746([]);
var $e5b7e89a68d9c456$export$64a02cd6422b91be = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("aside");
var $e5b7e89a68d9c456$export$a3ab01131aa7ecca = /* #__PURE__ */ $e5b7e89a68d9c456$export$64a02cd6422b91be([]);
var $e5b7e89a68d9c456$export$bba2aacf8566461b = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("article");
var $e5b7e89a68d9c456$export$1cb8fa25968bee4e = /* #__PURE__ */ $e5b7e89a68d9c456$export$bba2aacf8566461b([]);
var $e5b7e89a68d9c456$export$bb3edc44842b5f2e = function(props) {
    return $e5b7e89a68d9c456$export$8454457683f90105("area")(props)([]);
};
var $e5b7e89a68d9c456$export$f7d3c097ceca6c15 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("address");
var $e5b7e89a68d9c456$export$acfbe12b190f4a67 = /* #__PURE__ */ $e5b7e89a68d9c456$export$f7d3c097ceca6c15([]);
var $e5b7e89a68d9c456$export$2bcb785951133fe5 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("abbr");
var $e5b7e89a68d9c456$export$b4f279e367d2ba24 = /* #__PURE__ */ $e5b7e89a68d9c456$export$2bcb785951133fe5([]);
var $e5b7e89a68d9c456$export$407448d2b89b1813 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("a");
var $e5b7e89a68d9c456$export$a17c37559e1db147 = /* #__PURE__ */ $e5b7e89a68d9c456$export$407448d2b89b1813([]);

});

parcelRegister("cLQJF", function(module, exports) {

$parcel$export(module.exports, "prop", () => $94c2c7ff32ca5bd1$export$977f3f6a9323c0f6);
$parcel$export(module.exports, "id", () => $94c2c7ff32ca5bd1$export$d560c7e4a29451c2);
$parcel$export(module.exports, "href", () => $94c2c7ff32ca5bd1$export$8f51af5840e0602a);
$parcel$export(module.exports, "disabled", () => $94c2c7ff32ca5bd1$export$683472f6198a076e);
$parcel$export(module.exports, "classes", () => $94c2c7ff32ca5bd1$export$188d75d71883854a);
$parcel$export(module.exports, "class_", () => $94c2c7ff32ca5bd1$export$dbf49ecbc3d3d264);
// Generated by purs version 0.15.16

var $gUTA8 = parcelRequire("gUTA8");
parcelRequire("2YJNp");

var $6DdrA = parcelRequire("6DdrA");

var $h2vLF = parcelRequire("h2vLF");

var $ibAKj = parcelRequire("ibAKj");

var $ebWzy = parcelRequire("ebWzy");

var $hKGK1 = parcelRequire("hKGK1");

var $7odkg = parcelRequire("7odkg");

var $1UfuE = parcelRequire("1UfuE");

var $8cBb2 = parcelRequire("8cBb2");

var $7ZKwO = parcelRequire("7ZKwO");

var $3rLU8 = parcelRequire("3rLU8");

var $dqDZn = parcelRequire("dqDZn");

var $l0wDR = parcelRequire("l0wDR");

var $lnl7Y = parcelRequire("lnl7Y");

var $ykHdR = parcelRequire("ykHdR");

var $6PW1p = parcelRequire("6PW1p");
parcelRequire("2Zpo4");
var $7OyoZ = parcelRequire("7OyoZ");

var $hhMAk = parcelRequire("hhMAk");

var $cVGsR = parcelRequire("cVGsR");

var $lrGyk = parcelRequire("lrGyk");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");
var $94c2c7ff32ca5bd1$var$map = /* #__PURE__ */ $l0wDR.map($lrGyk.functorProp);
var $94c2c7ff32ca5bd1$var$map1 = /* #__PURE__ */ $l0wDR.map($cVGsR.functorInput);
var $94c2c7ff32ca5bd1$var$unwrap = /* #__PURE__ */ $6PW1p.unwrap();
var $94c2c7ff32ca5bd1$export$4a4574f653808a56 = function(x) {
    return x;
};
var $94c2c7ff32ca5bd1$export$eff4d24c3ff7876e = /* #__PURE__ */ function() {
    var go = function(p) {
        return function(mel) {
            return new $ykHdR.Just(new $cVGsR.RefUpdate(p, mel));
        };
    };
    return function($29) {
        return $hhMAk.ref(go($29));
    };
}();
var $94c2c7ff32ca5bd1$export$977f3f6a9323c0f6 = function(dictIsProp) {
    return $hhMAk.prop(dictIsProp);
};
var $94c2c7ff32ca5bd1$var$prop1 = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$977f3f6a9323c0f6($hhMAk.isPropBoolean);
var $94c2c7ff32ca5bd1$var$prop2 = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$977f3f6a9323c0f6($hhMAk.isPropString);
var $94c2c7ff32ca5bd1$var$prop3 = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$977f3f6a9323c0f6($hhMAk.isPropInt);
var $94c2c7ff32ca5bd1$var$prop4 = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$977f3f6a9323c0f6($hhMAk.isPropNumber);
var $94c2c7ff32ca5bd1$export$b2cbc93d4da94977 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop1("readOnly");
var $94c2c7ff32ca5bd1$export$bad408f43b005bc8 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop2("rel");
var $94c2c7ff32ca5bd1$export$a7a0278c004aac3f = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop1("required");
var $94c2c7ff32ca5bd1$export$a5ce0649174d616e = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop3("rowSpan");
var $94c2c7ff32ca5bd1$export$2dd197b55cf13440 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop3("rows");
var $94c2c7ff32ca5bd1$export$5cff813ca8e50db9 = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$977f3f6a9323c0f6($hhMAk.isPropScopeValue)("scope");
var $94c2c7ff32ca5bd1$export$d90250155de6d7e7 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop1("selected");
var $94c2c7ff32ca5bd1$export$9ea87e299ff6a368 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop3("selectedIndex");
var $94c2c7ff32ca5bd1$export$afbe3196582d9f14 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop1("spellcheck");
var $94c2c7ff32ca5bd1$export$2e40c9e35e9506f4 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop2("src");
var $94c2c7ff32ca5bd1$export$1c5fb2289a93dd05 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop2("srcdoc");
var $94c2c7ff32ca5bd1$export$35d34bc0ed591a92 = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$977f3f6a9323c0f6($hhMAk.isPropStepValue)("step");
var $94c2c7ff32ca5bd1$export$9a625f9de50bf0b7 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop3("tabIndex");
var $94c2c7ff32ca5bd1$export$44271b4f0c6a3563 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop2("target");
var $94c2c7ff32ca5bd1$export$fb184b623420d9be = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop2("title");
var $94c2c7ff32ca5bd1$export$d4a6a4db5b31e621 = function(dictIsProp) {
    return $94c2c7ff32ca5bd1$export$977f3f6a9323c0f6(dictIsProp)("type");
};
var $94c2c7ff32ca5bd1$export$2ab9a8f9f1186f14 = function(dictIsProp) {
    return $94c2c7ff32ca5bd1$export$977f3f6a9323c0f6(dictIsProp)("value");
};
var $94c2c7ff32ca5bd1$export$7e3df82ee760448c = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop3("width");
var $94c2c7ff32ca5bd1$export$513ccb98c53b8039 = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$977f3f6a9323c0f6($hhMAk.isPropPreloadValue)("preload");
var $94c2c7ff32ca5bd1$export$b840e55573b2d2e7 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop2("poster");
var $94c2c7ff32ca5bd1$export$c7187bbd1a7a9244 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop2("placeholder");
var $94c2c7ff32ca5bd1$export$24f82734ea047e6f = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop2("pattern");
var $94c2c7ff32ca5bd1$export$f50297589147f25e = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop1("noValidate");
var $94c2c7ff32ca5bd1$export$18bca78ee4b12477 = {
    Coercible0: function() {
        return undefined;
    }
};
var $94c2c7ff32ca5bd1$export$a8ff84c12d48cfa6 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop2("name");
var $94c2c7ff32ca5bd1$export$987a4e3838aef8c6 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop1("muted");
var $94c2c7ff32ca5bd1$export$939ddaa3205df08e = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop1("multiple");
var $94c2c7ff32ca5bd1$export$96ec731ed4dcb222 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop4("min");
var $94c2c7ff32ca5bd1$export$26f73335cc2e7868 = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$977f3f6a9323c0f6($hhMAk.isPropFormMethod)("method");
var $94c2c7ff32ca5bd1$export$8960430cfd85939f = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop4("max");
var $94c2c7ff32ca5bd1$export$f9ef67375ddc185 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop1("loop");
var $94c2c7ff32ca5bd1$export$d560c7e4a29451c2 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop2("id");
var $94c2c7ff32ca5bd1$export$8f51af5840e0602a = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop2("href");
var $94c2c7ff32ca5bd1$export$ac607276a8fe9f0a = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop3("height");
var $94c2c7ff32ca5bd1$export$f268b02200c313cd = {
    map: function(f) {
        return function(m) {
            return $94c2c7ff32ca5bd1$var$map($94c2c7ff32ca5bd1$var$map1(f))(m);
        };
    }
};
var $94c2c7ff32ca5bd1$export$f89de2e5bf57e5e6 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop2("htmlFor");
var $94c2c7ff32ca5bd1$export$9f77e0932fb78f72 = function() {
    return $eOrGk.unsafeCoerce;
};
var $94c2c7ff32ca5bd1$export$9fc5d082ec250407 = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$977f3f6a9323c0f6($hhMAk.isPropMediaType)("enctype");
var $94c2c7ff32ca5bd1$export$c746a5152d4ba26c = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop1("draggable");
var $94c2c7ff32ca5bd1$export$24422be91ad4011f = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop2("download");
var $94c2c7ff32ca5bd1$export$683472f6198a076e = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop1("disabled");
var $94c2c7ff32ca5bd1$export$25eaa035e2e3a214 = /* #__PURE__ */ function() {
    var $30 = $lnl7Y.not($lnl7Y.heytingAlgebraBoolean);
    return function($31) {
        return $94c2c7ff32ca5bd1$export$683472f6198a076e($30($31));
    };
}();
var $94c2c7ff32ca5bd1$export$cc1adf6fb659c762 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop1("controls");
var $94c2c7ff32ca5bd1$export$1eebcb1e706ab348 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop3("cols");
var $94c2c7ff32ca5bd1$export$47be69ffacd0da98 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop3("colSpan");
var $94c2c7ff32ca5bd1$export$188d75d71883854a = /* #__PURE__ */ function() {
    var $32 = $94c2c7ff32ca5bd1$var$prop2("className");
    var $33 = $7OyoZ.joinWith(" ");
    var $34 = $l0wDR.map($l0wDR.functorArray)($94c2c7ff32ca5bd1$var$unwrap);
    return function($35) {
        return $32($33($34($35)));
    };
}();
var $94c2c7ff32ca5bd1$export$dbf49ecbc3d3d264 = /* #__PURE__ */ function() {
    var $36 = $94c2c7ff32ca5bd1$var$prop2("className");
    return function($37) {
        return $36($94c2c7ff32ca5bd1$var$unwrap($37));
    };
}();
var $94c2c7ff32ca5bd1$export$b96bb35bc88d6fa = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop1("checked");
var $94c2c7ff32ca5bd1$export$e4c823724462c3fd = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop2("charset");
var $94c2c7ff32ca5bd1$export$b243096046abd58 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop1("autoplay");
var $94c2c7ff32ca5bd1$export$4c47992fc278c9a0 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop1("autofocus");
var $94c2c7ff32ca5bd1$export$485ded5f26ebe08d = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$977f3f6a9323c0f6($hhMAk.isPropAutocompleteType)("autocomplete");
var $94c2c7ff32ca5bd1$export$3c95eba0a7ef85d = /* #__PURE__ */ function() {
    var $38 = $gUTA8.pure($ykHdR.applicativeMaybe);
    return function($39) {
        return $hhMAk.attr($38($39));
    };
}();
var $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd = /* #__PURE__ */ function() {
    return $hhMAk.attr($ykHdR.Nothing.value);
}();
var $94c2c7ff32ca5bd1$export$8837f4fc672e936d = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("list");
var $94c2c7ff32ca5bd1$export$1d567c320f4763bc = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("style");
var $94c2c7ff32ca5bd1$export$228be17d80722ab = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop2("alt");
var $94c2c7ff32ca5bd1$export$31eb53bd5b582a97 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop2("action");
var $94c2c7ff32ca5bd1$export$73f57eecff448cc8 = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$977f3f6a9323c0f6($hhMAk.isPropInputAcceptType)("accept");

});
parcelRegister("2YJNp", function(module, exports) {
// Generated by purs version 0.15.16

});



parcelRegister("jxBf5", function(module, exports) {

$parcel$export(module.exports, "some", () => $e39dfcf102cdca3c$export$ad14ef4001db2bcd);
$parcel$export(module.exports, "snoc", () => $e39dfcf102cdca3c$export$c40cf5aab899f397);
$parcel$export(module.exports, "fromArray", () => $e39dfcf102cdca3c$export$571d59b505e6bb4e);
$parcel$export(module.exports, "foldl1", () => $e39dfcf102cdca3c$export$eb5e1ef4ea2eca3d);
$parcel$export(module.exports, "cons$prime", () => $e39dfcf102cdca3c$export$cc3b5f3f66225fbe);
$parcel$export(module.exports, "head", () => $e39dfcf102cdca3c$export$5fd5031fecdacec3);
$parcel$export(module.exports, "index", () => $e39dfcf102cdca3c$export$b610b8812bbcded9);
$parcel$export(module.exports, "length", () => $e39dfcf102cdca3c$export$f24224f1c91d8156);
$parcel$export(module.exports, "cons", () => $e39dfcf102cdca3c$export$8327ebbef2a0ba76);
$parcel$export(module.exports, "unsafeIndex", () => $e39dfcf102cdca3c$export$90bcd20c17ae578e);
// Generated by purs version 0.15.16

var $9Grh5 = parcelRequire("9Grh5");

var $4VF0K = parcelRequire("4VF0K");
var $lGiKR = parcelRequire("lGiKR");

var $cwMDv = parcelRequire("cwMDv");

var $2Mmje = parcelRequire("2Mmje");

var $6UHO6 = parcelRequire("6UHO6");

var $4MBcA = parcelRequire("4MBcA");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");

var $ykHdR = parcelRequire("ykHdR");

var $2FBb2 = parcelRequire("2FBb2");

var $d0PPW = parcelRequire("d0PPW");

var $iwqgS = parcelRequire("iwqgS");

var $IFMV2 = parcelRequire("IFMV2");

var $9MxTl = parcelRequire("9MxTl");

var $hNKjN = parcelRequire("hNKjN");

var $e9Lv5 = parcelRequire("e9Lv5");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");
var $e39dfcf102cdca3c$var$coerce = /* #__PURE__ */ $e9Lv5.coerce();
var $e39dfcf102cdca3c$var$max = /* #__PURE__ */ $d0PPW.max($d0PPW.ordInt);
var $e39dfcf102cdca3c$var$append = /* #__PURE__ */ $iwqgS.append($iwqgS.semigroupArray);
var $e39dfcf102cdca3c$var$intercalate1 = /* #__PURE__ */ $IFMV2.intercalate($cwMDv.foldable1NonEmptyArray);
var $e39dfcf102cdca3c$var$foldMap11 = /* #__PURE__ */ $IFMV2.foldMap1($cwMDv.foldable1NonEmptyArray);
var $e39dfcf102cdca3c$var$fold11 = /* #__PURE__ */ $IFMV2.fold1($cwMDv.foldable1NonEmptyArray);
var $e39dfcf102cdca3c$var$fromJust = /* #__PURE__ */ $ykHdR.fromJust();
var $e39dfcf102cdca3c$var$unsafeIndex1 = /* #__PURE__ */ $4VF0K.unsafeIndex();
var $e39dfcf102cdca3c$var$unsafeFromArrayF = $eOrGk.unsafeCoerce;
var $e39dfcf102cdca3c$var$unsafeFromArray = $cwMDv.NonEmptyArray;
var $e39dfcf102cdca3c$export$9cb09a71b7d66923 = function($99) {
    return $e39dfcf102cdca3c$var$coerce($4VF0K.transpose($e39dfcf102cdca3c$var$coerce($99)));
};
var $e39dfcf102cdca3c$export$45b10814cc054894 = function(v) {
    return v;
};
var $e39dfcf102cdca3c$export$c2d77a2584a0f97e = function(eq) {
    return function(xs) {
        var $100 = $4VF0K.unionBy(eq)($e39dfcf102cdca3c$export$45b10814cc054894(xs));
        return function($101) {
            return $e39dfcf102cdca3c$var$unsafeFromArray($100($101));
        };
    };
};
var $e39dfcf102cdca3c$export$437026b4e0b5fcf6 = function(dictEq) {
    return $e39dfcf102cdca3c$export$c2d77a2584a0f97e($4MBcA.eq(dictEq));
};
var $e39dfcf102cdca3c$export$ef1d06dc4d91d507 = function(eq) {
    return function(xs) {
        var $102 = $e39dfcf102cdca3c$export$c2d77a2584a0f97e(eq)(xs);
        return function($103) {
            return $102($e39dfcf102cdca3c$export$45b10814cc054894($103));
        };
    };
};
var $e39dfcf102cdca3c$export$971dd5b0dfd021b6 = function(dictEq) {
    return $e39dfcf102cdca3c$export$ef1d06dc4d91d507($4MBcA.eq(dictEq));
};
var $e39dfcf102cdca3c$export$23c8d3f8757cab88 = /* #__PURE__ */ function() {
    var $104 = $2Mmje.bimap($2Mmje.bifunctorTuple)($e39dfcf102cdca3c$var$unsafeFromArray)($e39dfcf102cdca3c$var$unsafeFromArray);
    return function($105) {
        return $104($4VF0K.unzip($e39dfcf102cdca3c$export$45b10814cc054894($105)));
    };
}();
var $e39dfcf102cdca3c$export$b6d8713d53419d4c = function(i) {
    return function(x) {
        var $106 = $4VF0K.updateAt(i)(x);
        return function($107) {
            return $e39dfcf102cdca3c$var$unsafeFromArrayF($106($e39dfcf102cdca3c$export$45b10814cc054894($107)));
        };
    };
};
var $e39dfcf102cdca3c$export$8901015135f2fb22 = function(xs) {
    return function(ys) {
        return $e39dfcf102cdca3c$var$unsafeFromArray($4VF0K.zip($e39dfcf102cdca3c$export$45b10814cc054894(xs))($e39dfcf102cdca3c$export$45b10814cc054894(ys)));
    };
};
var $e39dfcf102cdca3c$export$b634740ce272acb5 = function(f) {
    return function(xs) {
        return function(ys) {
            return $e39dfcf102cdca3c$var$unsafeFromArray($4VF0K.zipWith(f)($e39dfcf102cdca3c$export$45b10814cc054894(xs))($e39dfcf102cdca3c$export$45b10814cc054894(ys)));
        };
    };
};
var $e39dfcf102cdca3c$export$e00c1e5c5a2b1ad7 = function(dictApplicative) {
    var zipWithA1 = $4VF0K.zipWithA(dictApplicative);
    return function(f) {
        return function(xs) {
            return function(ys) {
                return $e39dfcf102cdca3c$var$unsafeFromArrayF(zipWithA1(f)($e39dfcf102cdca3c$export$45b10814cc054894(xs))($e39dfcf102cdca3c$export$45b10814cc054894(ys)));
            };
        };
    };
};
var $e39dfcf102cdca3c$export$b0d75975ac0be0e1 = function(i) {
    return function(xs) {
        return $4VF0K.splitAt(i)($e39dfcf102cdca3c$export$45b10814cc054894(xs));
    };
};
var $e39dfcf102cdca3c$export$ad14ef4001db2bcd = function(dictAlternative) {
    var some1 = $4VF0K.some(dictAlternative);
    return function(dictLazy) {
        var $108 = some1(dictLazy);
        return function($109) {
            return $e39dfcf102cdca3c$var$unsafeFromArrayF($108($109));
        };
    };
};
var $e39dfcf102cdca3c$export$5b6d1d165591a48c = function(xs) {
    return function(x) {
        return $e39dfcf102cdca3c$var$unsafeFromArray($4VF0K.snoc(xs)(x));
    };
};
var $e39dfcf102cdca3c$export$c40cf5aab899f397 = function(xs) {
    return function(x) {
        return $e39dfcf102cdca3c$var$unsafeFromArray($4VF0K.snoc($e39dfcf102cdca3c$export$45b10814cc054894(xs))(x));
    };
};
var $e39dfcf102cdca3c$export$439306a4dcaafbb9 = function($110) {
    return $e39dfcf102cdca3c$var$unsafeFromArray($4VF0K.singleton($110));
};
var $e39dfcf102cdca3c$export$606959e7ccb797f0 = function(i) {
    return function(x) {
        return $e39dfcf102cdca3c$var$unsafeFromArray($4VF0K.replicate($e39dfcf102cdca3c$var$max(1)(i))(x));
    };
};
var $e39dfcf102cdca3c$export$d02631cccf789723 = function(x) {
    return function(y) {
        return $e39dfcf102cdca3c$var$unsafeFromArray($4VF0K.range(x)(y));
    };
};
var $e39dfcf102cdca3c$export$25b721c466a8ec4a = function(xs) {
    return function(ys) {
        return $e39dfcf102cdca3c$var$unsafeFromArray($e39dfcf102cdca3c$var$append(xs)($e39dfcf102cdca3c$export$45b10814cc054894(ys)));
    };
};
var $e39dfcf102cdca3c$export$cba09f9e3d3e58eb = function(i) {
    return function(f) {
        var $111 = $4VF0K.modifyAt(i)(f);
        return function($112) {
            return $e39dfcf102cdca3c$var$unsafeFromArrayF($111($e39dfcf102cdca3c$export$45b10814cc054894($112)));
        };
    };
};
var $e39dfcf102cdca3c$export$df22145cad61b1dc = function(eq) {
    return function(xs) {
        return $4VF0K.intersectBy(eq)($e39dfcf102cdca3c$export$45b10814cc054894(xs));
    };
};
var $e39dfcf102cdca3c$export$f161f39e9c06ab2d = function(eq) {
    return function(xs) {
        var $113 = $e39dfcf102cdca3c$export$df22145cad61b1dc(eq)(xs);
        return function($114) {
            return $113($e39dfcf102cdca3c$export$45b10814cc054894($114));
        };
    };
};
var $e39dfcf102cdca3c$export$5c3f7b482f544831 = function(dictEq) {
    return $e39dfcf102cdca3c$export$df22145cad61b1dc($4MBcA.eq(dictEq));
};
var $e39dfcf102cdca3c$export$1f4807a235930d45 = function(dictEq) {
    return $e39dfcf102cdca3c$export$f161f39e9c06ab2d($4MBcA.eq(dictEq));
};
var $e39dfcf102cdca3c$export$739ec22334c44788 = function(dictSemigroup) {
    return $e39dfcf102cdca3c$var$intercalate1(dictSemigroup);
};
var $e39dfcf102cdca3c$export$9f200c4466975173 = function(i) {
    return function(x) {
        var $115 = $4VF0K.insertAt(i)(x);
        return function($116) {
            return $e39dfcf102cdca3c$var$unsafeFromArrayF($115($e39dfcf102cdca3c$export$45b10814cc054894($116)));
        };
    };
};
var $e39dfcf102cdca3c$export$95b95426129653f6 = function(dictFoldable1) {
    var $117 = $4VF0K.fromFoldable(dictFoldable1.Foldable0());
    return function($118) {
        return $e39dfcf102cdca3c$var$unsafeFromArray($117($118));
    };
};
var $e39dfcf102cdca3c$export$571d59b505e6bb4e = function(xs) {
    if ($lGiKR.length(xs) > 0) return new $ykHdR.Just($e39dfcf102cdca3c$var$unsafeFromArray(xs));
    if ($6UHO6.otherwise) return $ykHdR.Nothing.value;
    throw new Error("Failed pattern match at Data.Array.NonEmpty (line 161, column 1 - line 161, column 58): " + [
        xs.constructor.name
    ]);
};
var $e39dfcf102cdca3c$export$b7d5d9bb9ff52072 = function(dictFoldable) {
    var $119 = $4VF0K.fromFoldable(dictFoldable);
    return function($120) {
        return $e39dfcf102cdca3c$export$571d59b505e6bb4e($119($120));
    };
};
var $e39dfcf102cdca3c$export$55f57584ad1f8cc9 = function($121) {
    return $e39dfcf102cdca3c$export$571d59b505e6bb4e($4VF0K.transpose($e39dfcf102cdca3c$var$coerce($121)));
};
var $e39dfcf102cdca3c$export$c8b99533c112636f = /* #__PURE__ */ $IFMV2.foldr1($cwMDv.foldable1NonEmptyArray);
var $e39dfcf102cdca3c$export$eb5e1ef4ea2eca3d = /* #__PURE__ */ $IFMV2.foldl1($cwMDv.foldable1NonEmptyArray);
var $e39dfcf102cdca3c$export$b50c31bb8aebd2a7 = function(dictSemigroup) {
    return $e39dfcf102cdca3c$var$foldMap11(dictSemigroup);
};
var $e39dfcf102cdca3c$export$2e430a6d03f6ee23 = function(dictSemigroup) {
    return $e39dfcf102cdca3c$var$fold11(dictSemigroup);
};
var $e39dfcf102cdca3c$export$244bb8babc536271 = function(dictEq) {
    var difference1 = $4VF0K.difference(dictEq);
    return function(xs) {
        return difference1($e39dfcf102cdca3c$export$45b10814cc054894(xs));
    };
};
var $e39dfcf102cdca3c$export$cc3b5f3f66225fbe = function(x) {
    return function(xs) {
        return $e39dfcf102cdca3c$var$unsafeFromArray($4VF0K.cons(x)(xs));
    };
};
var $e39dfcf102cdca3c$export$1d4c49925323035a = function(v) {
    return $e39dfcf102cdca3c$export$cc3b5f3f66225fbe(v.value0)(v.value1);
};
var $e39dfcf102cdca3c$export$c28c8388be0ab31a = /* #__PURE__ */ $l4M7e.flip(/* #__PURE__ */ $9Grh5.bind($cwMDv.bindNonEmptyArray));
var $e39dfcf102cdca3c$export$ee1b3e54f0441b22 = /* #__PURE__ */ function() {
    var $122 = $l0wDR.map($cwMDv.functorNonEmptyArray)($e39dfcf102cdca3c$export$45b10814cc054894);
    return function($123) {
        return $e39dfcf102cdca3c$var$unsafeFromArray($lGiKR.concat($e39dfcf102cdca3c$export$45b10814cc054894($122($123))));
    };
}();
var $e39dfcf102cdca3c$export$caf8a2f37e9533e = function(xs) {
    return function(ys) {
        return $e39dfcf102cdca3c$var$unsafeFromArray($e39dfcf102cdca3c$var$append($e39dfcf102cdca3c$export$45b10814cc054894(xs))(ys));
    };
};
var $e39dfcf102cdca3c$export$2dd9d44f93be5e22 = function(i) {
    return function(f) {
        var $124 = $4VF0K.alterAt(i)(f);
        return function($125) {
            return $124($e39dfcf102cdca3c$export$45b10814cc054894($125));
        };
    };
};
var $e39dfcf102cdca3c$var$adaptMaybe = function(f) {
    return function($126) {
        return $e39dfcf102cdca3c$var$fromJust(f($e39dfcf102cdca3c$export$45b10814cc054894($126)));
    };
};
var $e39dfcf102cdca3c$export$5fd5031fecdacec3 = /* #__PURE__ */ $e39dfcf102cdca3c$var$adaptMaybe($4VF0K.head);
var $e39dfcf102cdca3c$export$2cd8252107eb640b = /* #__PURE__ */ $e39dfcf102cdca3c$var$adaptMaybe($4VF0K.init);
var $e39dfcf102cdca3c$export$4c7897fafd92b108 = /* #__PURE__ */ $e39dfcf102cdca3c$var$adaptMaybe($4VF0K.last);
var $e39dfcf102cdca3c$export$c01875f616615628 = /* #__PURE__ */ $e39dfcf102cdca3c$var$adaptMaybe($4VF0K.tail);
var $e39dfcf102cdca3c$export$b446f6baa3bb1430 = /* #__PURE__ */ $e39dfcf102cdca3c$var$adaptMaybe($4VF0K.uncons);
var $e39dfcf102cdca3c$export$bdf81af0000aaf5a = function($127) {
    return function(v) {
        return new $2FBb2.NonEmpty(v.head, v.tail);
    }($e39dfcf102cdca3c$export$b446f6baa3bb1430($127));
};
var $e39dfcf102cdca3c$export$712962e076096ed4 = /* #__PURE__ */ $e39dfcf102cdca3c$var$adaptMaybe($4VF0K.unsnoc);
var $e39dfcf102cdca3c$var$adaptAny = function(f) {
    return function($128) {
        return f($e39dfcf102cdca3c$export$45b10814cc054894($128));
    };
};
var $e39dfcf102cdca3c$export$84bf76cd7afc7469 = function(p) {
    return $e39dfcf102cdca3c$var$adaptAny($4VF0K.all(p));
};
var $e39dfcf102cdca3c$export$4154a199d7d90455 = function(p) {
    return $e39dfcf102cdca3c$var$adaptAny($4VF0K.any(p));
};
var $e39dfcf102cdca3c$export$986c2bbe7a34be0b = /* #__PURE__ */ $e39dfcf102cdca3c$var$adaptAny($4VF0K.catMaybes);
var $e39dfcf102cdca3c$export$1822828d790e23ee = function(dictEq) {
    var delete1 = $4VF0K.delete(dictEq);
    return function(x) {
        return $e39dfcf102cdca3c$var$adaptAny(delete1(x));
    };
};
var $e39dfcf102cdca3c$export$90f9093465da3136 = function(i) {
    return $e39dfcf102cdca3c$var$adaptAny($4VF0K.deleteAt(i));
};
var $e39dfcf102cdca3c$export$9ea2b6c3fae093d8 = function(f) {
    return function(x) {
        return $e39dfcf102cdca3c$var$adaptAny($4VF0K.deleteBy(f)(x));
    };
};
var $e39dfcf102cdca3c$export$acaf96a27438246b = function(dictEq) {
    var difference$prime1 = $e39dfcf102cdca3c$export$244bb8babc536271(dictEq);
    return function(xs) {
        return $e39dfcf102cdca3c$var$adaptAny(difference$prime1(xs));
    };
};
var $e39dfcf102cdca3c$export$663103110d94aac9 = function(i) {
    return $e39dfcf102cdca3c$var$adaptAny($4VF0K.drop(i));
};
var $e39dfcf102cdca3c$export$2b3b686e33c80c56 = function(i) {
    return $e39dfcf102cdca3c$var$adaptAny($4VF0K.dropEnd(i));
};
var $e39dfcf102cdca3c$export$533af5c8cd6afa16 = function(f) {
    return $e39dfcf102cdca3c$var$adaptAny($4VF0K.dropWhile(f));
};
var $e39dfcf102cdca3c$export$5bf96401662340b7 = function(dictEq) {
    var elem1 = $4VF0K.elem(dictEq);
    return function(x) {
        return $e39dfcf102cdca3c$var$adaptAny(elem1(x));
    };
};
var $e39dfcf102cdca3c$export$f444781b0adb7e4d = function(dictEq) {
    var elemIndex1 = $4VF0K.elemIndex(dictEq);
    return function(x) {
        return $e39dfcf102cdca3c$var$adaptAny(elemIndex1(x));
    };
};
var $e39dfcf102cdca3c$export$c19d79386f4ed99a = function(dictEq) {
    var elemLastIndex1 = $4VF0K.elemLastIndex(dictEq);
    return function(x) {
        return $e39dfcf102cdca3c$var$adaptAny(elemLastIndex1(x));
    };
};
var $e39dfcf102cdca3c$export$3dea766d36a8935f = function(f) {
    return $e39dfcf102cdca3c$var$adaptAny($4VF0K.filter(f));
};
var $e39dfcf102cdca3c$export$e6e803076c284bc5 = function(dictApplicative) {
    var filterA1 = $4VF0K.filterA(dictApplicative);
    return function(f) {
        return $e39dfcf102cdca3c$var$adaptAny(filterA1(f));
    };
};
var $e39dfcf102cdca3c$export$71aa6c912b956294 = function(p) {
    return $e39dfcf102cdca3c$var$adaptAny($4VF0K.find(p));
};
var $e39dfcf102cdca3c$export$de3a4d4a0d731119 = function(p) {
    return $e39dfcf102cdca3c$var$adaptAny($4VF0K.findIndex(p));
};
var $e39dfcf102cdca3c$export$8855a8be7bd3e9f8 = function(x) {
    return $e39dfcf102cdca3c$var$adaptAny($4VF0K.findLastIndex(x));
};
var $e39dfcf102cdca3c$export$23e5dcedfce4509c = function(p) {
    return $e39dfcf102cdca3c$var$adaptAny($4VF0K.findMap(p));
};
var $e39dfcf102cdca3c$export$7a067f9280ad8af0 = function(dictMonad) {
    var foldM1 = $4VF0K.foldM(dictMonad);
    return function(f) {
        return function(acc) {
            return $e39dfcf102cdca3c$var$adaptAny(foldM1(f)(acc));
        };
    };
};
var $e39dfcf102cdca3c$export$61b0588efceffce4 = function(dictMonadRec) {
    var foldRecM1 = $4VF0K.foldRecM(dictMonadRec);
    return function(f) {
        return function(acc) {
            return $e39dfcf102cdca3c$var$adaptAny(foldRecM1(f)(acc));
        };
    };
};
var $e39dfcf102cdca3c$export$b610b8812bbcded9 = /* #__PURE__ */ $e39dfcf102cdca3c$var$adaptAny($4VF0K.index);
var $e39dfcf102cdca3c$export$f24224f1c91d8156 = /* #__PURE__ */ $e39dfcf102cdca3c$var$adaptAny($lGiKR.length);
var $e39dfcf102cdca3c$export$e70771d2e7e590a = function(f) {
    return $e39dfcf102cdca3c$var$adaptAny($4VF0K.mapMaybe(f));
};
var $e39dfcf102cdca3c$export$63faa62a0284a4a6 = function(dictEq) {
    var notElem1 = $4VF0K.notElem(dictEq);
    return function(x) {
        return $e39dfcf102cdca3c$var$adaptAny(notElem1(x));
    };
};
var $e39dfcf102cdca3c$export$b29f828819edca8d = function(f) {
    return $e39dfcf102cdca3c$var$adaptAny($4VF0K.partition(f));
};
var $e39dfcf102cdca3c$export$58adb3bec8346d0f = function(start) {
    return function(end) {
        return $e39dfcf102cdca3c$var$adaptAny($4VF0K.slice(start)(end));
    };
};
var $e39dfcf102cdca3c$export$afc1bfabebaf28a2 = function(f) {
    return $e39dfcf102cdca3c$var$adaptAny($4VF0K.span(f));
};
var $e39dfcf102cdca3c$export$b7df5d561049483a = function(i) {
    return $e39dfcf102cdca3c$var$adaptAny($4VF0K.take(i));
};
var $e39dfcf102cdca3c$export$9100289823a975b0 = function(i) {
    return $e39dfcf102cdca3c$var$adaptAny($4VF0K.takeEnd(i));
};
var $e39dfcf102cdca3c$export$9384c7afe4015e42 = function(f) {
    return $e39dfcf102cdca3c$var$adaptAny($4VF0K.takeWhile(f));
};
var $e39dfcf102cdca3c$export$823be24f8766da23 = function(dictUnfoldable) {
    return $e39dfcf102cdca3c$var$adaptAny($4VF0K.toUnfoldable(dictUnfoldable));
};
var $e39dfcf102cdca3c$var$unsafeAdapt = function(f) {
    var $129 = $e39dfcf102cdca3c$var$adaptAny(f);
    return function($130) {
        return $e39dfcf102cdca3c$var$unsafeFromArray($129($130));
    };
};
var $e39dfcf102cdca3c$export$8327ebbef2a0ba76 = function(x) {
    return $e39dfcf102cdca3c$var$unsafeAdapt($4VF0K.cons(x));
};
var $e39dfcf102cdca3c$export$e5e25fbcc1f7affe = function(dictEq) {
    return $e39dfcf102cdca3c$var$unsafeAdapt($4VF0K.group(dictEq));
};
var $e39dfcf102cdca3c$export$1f7a5bf12caafbd = function(op) {
    return $e39dfcf102cdca3c$var$unsafeAdapt($4VF0K.groupAllBy(op));
};
var $e39dfcf102cdca3c$export$361434b95a7d965 = function(dictOrd) {
    return $e39dfcf102cdca3c$export$1f7a5bf12caafbd($d0PPW.compare(dictOrd));
};
var $e39dfcf102cdca3c$export$3f063810d7bf01bd = function(op) {
    return $e39dfcf102cdca3c$var$unsafeAdapt($4VF0K.groupBy(op));
};
var $e39dfcf102cdca3c$export$21a5ca8aa77d35ff = function(dictOrd) {
    var insert1 = $4VF0K.insert(dictOrd);
    return function(x) {
        return $e39dfcf102cdca3c$var$unsafeAdapt(insert1(x));
    };
};
var $e39dfcf102cdca3c$export$b8bc901090d2b1d4 = function(f) {
    return function(x) {
        return $e39dfcf102cdca3c$var$unsafeAdapt($4VF0K.insertBy(f)(x));
    };
};
var $e39dfcf102cdca3c$export$af200dcf8b7cb5de = function(x) {
    return $e39dfcf102cdca3c$var$unsafeAdapt($4VF0K.intersperse(x));
};
var $e39dfcf102cdca3c$export$8f07ddce13659f50 = function(f) {
    return $e39dfcf102cdca3c$var$unsafeAdapt($4VF0K.mapWithIndex(f));
};
var $e39dfcf102cdca3c$export$7fd3d81fba5daa58 = function(dictFoldable) {
    var modifyAtIndices1 = $4VF0K.modifyAtIndices(dictFoldable);
    return function(is) {
        return function(f) {
            return $e39dfcf102cdca3c$var$unsafeAdapt(modifyAtIndices1(is)(f));
        };
    };
};
var $e39dfcf102cdca3c$export$94f4066a75b10404 = function(dictOrd) {
    return $e39dfcf102cdca3c$var$unsafeAdapt($4VF0K.nub(dictOrd));
};
var $e39dfcf102cdca3c$export$18f77a3bafa759b9 = function(f) {
    return $e39dfcf102cdca3c$var$unsafeAdapt($4VF0K.nubBy(f));
};
var $e39dfcf102cdca3c$export$45273896c792ff3b = function(f) {
    return $e39dfcf102cdca3c$var$unsafeAdapt($4VF0K.nubByEq(f));
};
var $e39dfcf102cdca3c$export$edce5881c815871 = function(dictEq) {
    return $e39dfcf102cdca3c$var$unsafeAdapt($4VF0K.nubEq(dictEq));
};
var $e39dfcf102cdca3c$export$66c1ae025e96b4bc = /* #__PURE__ */ $e39dfcf102cdca3c$var$unsafeAdapt($lGiKR.reverse);
var $e39dfcf102cdca3c$export$65f513eaf3c582b8 = function(f) {
    return function(x) {
        return $e39dfcf102cdca3c$var$unsafeAdapt($4VF0K.scanl(f)(x));
    };
};
var $e39dfcf102cdca3c$export$64df51ac031d4ad2 = function(f) {
    return function(x) {
        return $e39dfcf102cdca3c$var$unsafeAdapt($4VF0K.scanr(f)(x));
    };
};
var $e39dfcf102cdca3c$export$97db5808d8f88186 = function(dictOrd) {
    return $e39dfcf102cdca3c$var$unsafeAdapt($4VF0K.sort(dictOrd));
};
var $e39dfcf102cdca3c$export$b035e44d7bb4278f = function(f) {
    return $e39dfcf102cdca3c$var$unsafeAdapt($4VF0K.sortBy(f));
};
var $e39dfcf102cdca3c$export$a9e7d1a6fdcfefde = function(dictOrd) {
    var sortWith1 = $4VF0K.sortWith(dictOrd);
    return function(f) {
        return $e39dfcf102cdca3c$var$unsafeAdapt(sortWith1(f));
    };
};
var $e39dfcf102cdca3c$export$f2a09b3ef2c0e257 = function(dictFoldable) {
    var updateAtIndices1 = $4VF0K.updateAtIndices(dictFoldable);
    return function(pairs) {
        return $e39dfcf102cdca3c$var$unsafeAdapt(updateAtIndices1(pairs));
    };
};
var $e39dfcf102cdca3c$export$90bcd20c17ae578e = function() {
    return $e39dfcf102cdca3c$var$adaptAny($e39dfcf102cdca3c$var$unsafeIndex1);
};
var $e39dfcf102cdca3c$var$unsafeIndex2 = /* #__PURE__ */ $e39dfcf102cdca3c$export$90bcd20c17ae578e();
var $e39dfcf102cdca3c$export$d1f81bca2a8c7b07 = function(dictUnfoldable1) {
    var unfoldr1 = $hNKjN.unfoldr1(dictUnfoldable1);
    return function(xs) {
        var len = $e39dfcf102cdca3c$export$f24224f1c91d8156(xs);
        var f = function(i) {
            return new $9MxTl.Tuple($e39dfcf102cdca3c$var$unsafeIndex2(xs)(i), function() {
                var $98 = i < (len - 1 | 0);
                if ($98) return new $ykHdR.Just(i + 1 | 0);
                return $ykHdR.Nothing.value;
            }());
        };
        return unfoldr1(f)(0);
    };
};

});
parcelRegister("cwMDv", function(module, exports) {

$parcel$export(module.exports, "NonEmptyArray", () => $91ee3359f6bcea22$export$f2d78e4bd16a0737);
$parcel$export(module.exports, "semigroupNonEmptyArray", () => $91ee3359f6bcea22$export$7e27c982686236c);
$parcel$export(module.exports, "functorNonEmptyArray", () => $91ee3359f6bcea22$export$cf42eb1af12f469e);
$parcel$export(module.exports, "foldableNonEmptyArray", () => $91ee3359f6bcea22$export$7090c31be3a1e8ea);
$parcel$export(module.exports, "foldable1NonEmptyArray", () => $91ee3359f6bcea22$export$33591d20dac5147e);
$parcel$export(module.exports, "bindNonEmptyArray", () => $91ee3359f6bcea22$export$4b9e170bb3e49bd0);
// Generated by purs version 0.15.16

var $fyWiV = parcelRequire("fyWiV");

var $a7Dxq = parcelRequire("a7Dxq");

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $9Grh5 = parcelRequire("9Grh5");

var $ibtPS = parcelRequire("ibtPS");

var $4MBcA = parcelRequire("4MBcA");

var $6RkEA = parcelRequire("6RkEA");

var $70sTh = parcelRequire("70sTh");
parcelRequire("ikChJ");
var $chZgc = parcelRequire("chZgc");

var $l0wDR = parcelRequire("l0wDR");

var $4oUwX = parcelRequire("4oUwX");

var $d0PPW = parcelRequire("d0PPW");

var $iwqgS = parcelRequire("iwqgS");

var $IFMV2 = parcelRequire("IFMV2");

var $jERGJ = parcelRequire("jERGJ");

var $3Orkn = parcelRequire("3Orkn");

var $1wR1l = parcelRequire("1wR1l");

var $3OKRG = parcelRequire("3OKRG");

var $hNKjN = parcelRequire("hNKjN");
var $91ee3359f6bcea22$export$f2d78e4bd16a0737 = function(x) {
    return x;
};
var $91ee3359f6bcea22$export$5cc19ce746f40583 = $hNKjN.unfoldable1Array;
var $91ee3359f6bcea22$export$24956e78dc18af4a = $3OKRG.traversableWithIndexArray;
var $91ee3359f6bcea22$export$81b6a4240b5ed5ff = $1wR1l.traversableArray;
var $91ee3359f6bcea22$export$58eaac0549d62906 = function(dictShow) {
    var show = $3Orkn.show($3Orkn.showArray(dictShow));
    return {
        show: function(v) {
            return "(NonEmptyArray " + (show(v) + ")");
        }
    };
};
var $91ee3359f6bcea22$export$7e27c982686236c = $iwqgS.semigroupArray;
var $91ee3359f6bcea22$export$ba5ac798a83b9940 = function(dictOrd) {
    return $d0PPW.ordArray(dictOrd);
};
var $91ee3359f6bcea22$export$576ea700d31dfbbe = $d0PPW.ord1Array;
var $91ee3359f6bcea22$export$b6607029fd0e1ebc = $ibtPS.monadArray;
var $91ee3359f6bcea22$export$e1a7484e8d239345 = $4oUwX.functorWithIndexArray;
var $91ee3359f6bcea22$export$cf42eb1af12f469e = $l0wDR.functorArray;
var $91ee3359f6bcea22$export$277d8f0716691388 = $70sTh.foldableWithIndexArray;
var $91ee3359f6bcea22$export$7090c31be3a1e8ea = $6RkEA.foldableArray;
var $91ee3359f6bcea22$export$33591d20dac5147e = {
    foldMap1: function(dictSemigroup) {
        return $IFMV2.foldMap1DefaultL($91ee3359f6bcea22$export$33591d20dac5147e)($91ee3359f6bcea22$export$cf42eb1af12f469e)(dictSemigroup);
    },
    foldr1: /* #__PURE__ */ $chZgc.runFn2($fyWiV.foldr1Impl),
    foldl1: /* #__PURE__ */ $chZgc.runFn2($fyWiV.foldl1Impl),
    Foldable0: function() {
        return $91ee3359f6bcea22$export$7090c31be3a1e8ea;
    }
};
var $91ee3359f6bcea22$export$a72b8d310e29f00f = {
    traverse1: function(dictApply) {
        var apply = $a5g3C.apply(dictApply);
        var map = $l0wDR.map(dictApply.Functor0());
        return function(f) {
            return $fyWiV.traverse1Impl(apply, map, f);
        };
    },
    sequence1: function(dictApply) {
        return $jERGJ.sequence1Default($91ee3359f6bcea22$export$a72b8d310e29f00f)(dictApply);
    },
    Foldable10: function() {
        return $91ee3359f6bcea22$export$33591d20dac5147e;
    },
    Traversable1: function() {
        return $91ee3359f6bcea22$export$81b6a4240b5ed5ff;
    }
};
var $91ee3359f6bcea22$export$e2c877c9efbd93a4 = function(dictEq) {
    return $4MBcA.eqArray(dictEq);
};
var $91ee3359f6bcea22$export$5f4f90502fd988f7 = $4MBcA.eq1Array;
var $91ee3359f6bcea22$export$4b9e170bb3e49bd0 = $9Grh5.bindArray;
var $91ee3359f6bcea22$export$8f8661c5387016c3 = $a5g3C.applyArray;
var $91ee3359f6bcea22$export$df94f54a91732973 = $gUTA8.applicativeArray;
var $91ee3359f6bcea22$export$4d39f82ee37f3a51 = $a7Dxq.altArray;

});
parcelRegister("fyWiV", function(module, exports) {

$parcel$export(module.exports, "foldr1Impl", () => $b54742048bb717e1$export$2e94f3cfb1cd0b3b);
$parcel$export(module.exports, "foldl1Impl", () => $b54742048bb717e1$export$a723804e3f3d0e95);
$parcel$export(module.exports, "traverse1Impl", () => $b54742048bb717e1$export$c510f955a36e0bd4);
const $b54742048bb717e1$export$2e94f3cfb1cd0b3b = function(f, xs) {
    var acc = xs[xs.length - 1];
    for(var i = xs.length - 2; i >= 0; i--)acc = f(xs[i])(acc);
    return acc;
};
const $b54742048bb717e1$export$a723804e3f3d0e95 = function(f, xs) {
    var acc = xs[0];
    var len = xs.length;
    for(var i = 1; i < len; i++)acc = f(acc)(xs[i]);
    return acc;
};
const $b54742048bb717e1$export$c510f955a36e0bd4 = function() {
    function Cont(fn) {
        this.fn = fn;
    }
    var emptyList = {};
    var ConsCell = function(head, tail) {
        this.head = head;
        this.tail = tail;
    };
    function finalCell(head) {
        return new ConsCell(head, emptyList);
    }
    function consList(x) {
        return function(xs) {
            return new ConsCell(x, xs);
        };
    }
    function listToArray(list) {
        var arr = [];
        var xs = list;
        while(xs !== emptyList){
            arr.push(xs.head);
            xs = xs.tail;
        }
        return arr;
    }
    return function(apply, map, f) {
        var buildFrom = function(x, ys) {
            return apply(map(consList)(f(x)))(ys);
        };
        var go = function(acc, currentLen, xs) {
            if (currentLen === 0) return acc;
            else {
                var last = xs[currentLen - 1];
                return new Cont(function() {
                    var built = go(buildFrom(last, acc), currentLen - 1, xs);
                    return built;
                });
            }
        };
        return function(array) {
            var acc = map(finalCell)(f(array[array.length - 1]));
            var result = go(acc, array.length - 1, array);
            while(result instanceof Cont)result = result.fn();
            return map(listToArray)(result);
        };
    };
}();

});



parcelRegister("79GDW", function(module, exports) {

$parcel$export(module.exports, "genAlphaString", () => $535a73bcba17419f$export$cb524dc0c7bb8650);
// Generated by purs version 0.15.16

var $9Grh5 = parcelRequire("9Grh5");

var $8D18I = parcelRequire("8D18I");

var $kUmUH = parcelRequire("kUmUH");

var $13WdO = parcelRequire("13WdO");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");

var $d0PPW = parcelRequire("d0PPW");
parcelRequire("2gT7Y");
var $MTXA4 = parcelRequire("MTXA4");

var $hsyEi = parcelRequire("hsyEi");
var $535a73bcba17419f$var$max = /* #__PURE__ */ $d0PPW.max($d0PPW.ordInt);
var $535a73bcba17419f$export$45537208bcee6a56 = function(dictMonadRec) {
    var unfoldable = $8D18I.unfoldable(dictMonadRec);
    return function(dictMonadGen) {
        var sized = $kUmUH.sized(dictMonadGen);
        var Bind1 = dictMonadGen.Monad0().Bind1();
        var bind = $9Grh5.bind(Bind1);
        var chooseInt = $kUmUH.chooseInt(dictMonadGen);
        var resize = $kUmUH.resize(dictMonadGen);
        var map = $l0wDR.map(Bind1.Apply0().Functor0());
        var unfoldable1 = unfoldable(dictMonadGen)($hsyEi.unfoldableArray);
        return function(genChar) {
            return sized(function(size) {
                return bind(chooseInt(1)($535a73bcba17419f$var$max(1)(size)))(function(newSize) {
                    return resize($l4M7e.const(newSize))(map($MTXA4.fromCharArray)(unfoldable1(genChar)));
                });
            });
        };
    };
};
var $535a73bcba17419f$export$69727eac53a0153f = function(dictMonadRec) {
    var genString1 = $535a73bcba17419f$export$45537208bcee6a56(dictMonadRec);
    return function(dictMonadGen) {
        return genString1(dictMonadGen)($13WdO.genUnicodeChar(dictMonadGen));
    };
};
var $535a73bcba17419f$export$e3c958904e696d1c = function(dictMonadRec) {
    var genString1 = $535a73bcba17419f$export$45537208bcee6a56(dictMonadRec);
    return function(dictMonadGen) {
        return genString1(dictMonadGen)($13WdO.genDigitChar(dictMonadGen));
    };
};
var $535a73bcba17419f$export$c789a482da21617d = function(dictMonadRec) {
    var genString1 = $535a73bcba17419f$export$45537208bcee6a56(dictMonadRec);
    return function(dictMonadGen) {
        return genString1(dictMonadGen)($13WdO.genAsciiChar$prime(dictMonadGen));
    };
};
var $535a73bcba17419f$export$51202facb7de6ce5 = function(dictMonadRec) {
    var genString1 = $535a73bcba17419f$export$45537208bcee6a56(dictMonadRec);
    return function(dictMonadGen) {
        return genString1(dictMonadGen)($13WdO.genAsciiChar(dictMonadGen));
    };
};
var $535a73bcba17419f$export$447c089e5462efee = function(dictMonadRec) {
    var genString1 = $535a73bcba17419f$export$45537208bcee6a56(dictMonadRec);
    return function(dictMonadGen) {
        return genString1(dictMonadGen)($13WdO.genAlphaUppercase(dictMonadGen));
    };
};
var $535a73bcba17419f$export$cb524dc0c7bb8650 = function(dictMonadRec) {
    var genString1 = $535a73bcba17419f$export$45537208bcee6a56(dictMonadRec);
    return function(dictMonadGen) {
        return genString1(dictMonadGen)($13WdO.genAlpha(dictMonadGen));
    };
};
var $535a73bcba17419f$export$ce6be37f14c4437d = function(dictMonadRec) {
    var genString1 = $535a73bcba17419f$export$45537208bcee6a56(dictMonadRec);
    return function(dictMonadGen) {
        return genString1(dictMonadGen)($13WdO.genAlphaLowercase(dictMonadGen));
    };
};

});
parcelRegister("13WdO", function(module, exports) {

$parcel$export(module.exports, "genUnicodeChar", () => $0c633be4d8e052da$export$c3873651c0bfb169);
$parcel$export(module.exports, "genDigitChar", () => $0c633be4d8e052da$export$622e4e3c65b056d1);
$parcel$export(module.exports, "genAsciiChar$prime", () => $0c633be4d8e052da$export$d506629759e3f2b3);
$parcel$export(module.exports, "genAsciiChar", () => $0c633be4d8e052da$export$76527d271b5d4ec9);
$parcel$export(module.exports, "genAlphaUppercase", () => $0c633be4d8e052da$export$811374749f502c63);
$parcel$export(module.exports, "genAlphaLowercase", () => $0c633be4d8e052da$export$c2d16c452ec7b999);
$parcel$export(module.exports, "genAlpha", () => $0c633be4d8e052da$export$3ceea21665ded9a0);
// Generated by purs version 0.15.16

var $8D18I = parcelRequire("8D18I");

var $kUmUH = parcelRequire("kUmUH");

var $95fRU = parcelRequire("95fRU");

var $loxi1 = parcelRequire("loxi1");

var $6RkEA = parcelRequire("6RkEA");

var $l0wDR = parcelRequire("l0wDR");

var $2FBb2 = parcelRequire("2FBb2");
var $0c633be4d8e052da$var$toEnumWithDefaults = /* #__PURE__ */ $loxi1.toEnumWithDefaults($loxi1.boundedEnumChar);
var $0c633be4d8e052da$var$bottom = /* #__PURE__ */ $95fRU.bottom($95fRU.boundedChar);
var $0c633be4d8e052da$var$top = /* #__PURE__ */ $95fRU.top($95fRU.boundedChar);
var $0c633be4d8e052da$var$foldable1NonEmpty = /* #__PURE__ */ $2FBb2.foldable1NonEmpty($6RkEA.foldableArray);
var $0c633be4d8e052da$export$c3873651c0bfb169 = function(dictMonadGen) {
    return $l0wDR.map(dictMonadGen.Monad0().Bind1().Apply0().Functor0())($0c633be4d8e052da$var$toEnumWithDefaults($0c633be4d8e052da$var$bottom)($0c633be4d8e052da$var$top))($kUmUH.chooseInt(dictMonadGen)(0)(65536));
};
var $0c633be4d8e052da$export$622e4e3c65b056d1 = function(dictMonadGen) {
    return $l0wDR.map(dictMonadGen.Monad0().Bind1().Apply0().Functor0())($0c633be4d8e052da$var$toEnumWithDefaults($0c633be4d8e052da$var$bottom)($0c633be4d8e052da$var$top))($kUmUH.chooseInt(dictMonadGen)(48)(57));
};
var $0c633be4d8e052da$export$d506629759e3f2b3 = function(dictMonadGen) {
    return $l0wDR.map(dictMonadGen.Monad0().Bind1().Apply0().Functor0())($0c633be4d8e052da$var$toEnumWithDefaults($0c633be4d8e052da$var$bottom)($0c633be4d8e052da$var$top))($kUmUH.chooseInt(dictMonadGen)(0)(127));
};
var $0c633be4d8e052da$export$76527d271b5d4ec9 = function(dictMonadGen) {
    return $l0wDR.map(dictMonadGen.Monad0().Bind1().Apply0().Functor0())($0c633be4d8e052da$var$toEnumWithDefaults($0c633be4d8e052da$var$bottom)($0c633be4d8e052da$var$top))($kUmUH.chooseInt(dictMonadGen)(32)(127));
};
var $0c633be4d8e052da$export$811374749f502c63 = function(dictMonadGen) {
    return $l0wDR.map(dictMonadGen.Monad0().Bind1().Apply0().Functor0())($0c633be4d8e052da$var$toEnumWithDefaults($0c633be4d8e052da$var$bottom)($0c633be4d8e052da$var$top))($kUmUH.chooseInt(dictMonadGen)(65)(90));
};
var $0c633be4d8e052da$export$c2d16c452ec7b999 = function(dictMonadGen) {
    return $l0wDR.map(dictMonadGen.Monad0().Bind1().Apply0().Functor0())($0c633be4d8e052da$var$toEnumWithDefaults($0c633be4d8e052da$var$bottom)($0c633be4d8e052da$var$top))($kUmUH.chooseInt(dictMonadGen)(97)(122));
};
var $0c633be4d8e052da$export$3ceea21665ded9a0 = function(dictMonadGen) {
    return $8D18I.oneOf(dictMonadGen)($0c633be4d8e052da$var$foldable1NonEmpty)(new $2FBb2.NonEmpty($0c633be4d8e052da$export$c2d16c452ec7b999(dictMonadGen), [
        $0c633be4d8e052da$export$811374749f502c63(dictMonadGen)
    ]));
};

});
parcelRegister("loxi1", function(module, exports) {

$parcel$export(module.exports, "toEnum", () => $f935a9866e211c00$export$45328c01562fb205);
$parcel$export(module.exports, "fromEnum", () => $f935a9866e211c00$export$b385cb642735011f);
$parcel$export(module.exports, "toEnumWithDefaults", () => $f935a9866e211c00$export$1e2c188a485bdeae);
$parcel$export(module.exports, "defaultSucc", () => $f935a9866e211c00$export$11e799785deb08e4);
$parcel$export(module.exports, "defaultPred", () => $f935a9866e211c00$export$dc42af8461b24233);
$parcel$export(module.exports, "boundedEnumChar", () => $f935a9866e211c00$export$be1f07c3580164c);
// Generated by purs version 0.15.16

var $2u4gw = parcelRequire("2u4gw");

var $kK1nx = parcelRequire("kK1nx");

var $a5g3C = parcelRequire("a5g3C");

var $9Grh5 = parcelRequire("9Grh5");

var $6UHO6 = parcelRequire("6UHO6");

var $95fRU = parcelRequire("95fRU");

var $aKY4H = parcelRequire("aKY4H");

var $4MBcA = parcelRequire("4MBcA");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");

var $ykHdR = parcelRequire("ykHdR");

var $d0PPW = parcelRequire("d0PPW");

var $6SDUu = parcelRequire("6SDUu");

var $3Orkn = parcelRequire("3Orkn");

var $9MxTl = parcelRequire("9MxTl");

var $hsyEi = parcelRequire("hsyEi");

var $hNKjN = parcelRequire("hNKjN");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");
var $f935a9866e211c00$var$apply = /* #__PURE__ */ $a5g3C.apply($a5g3C.applyFn);
var $f935a9866e211c00$var$show = /* #__PURE__ */ $3Orkn.show($3Orkn.showInt);
var $f935a9866e211c00$var$map = /* #__PURE__ */ $l0wDR.map($ykHdR.functorMaybe);
var $f935a9866e211c00$var$top = /* #__PURE__ */ $95fRU.top($95fRU.boundedInt);
var $f935a9866e211c00$var$bottom = /* #__PURE__ */ $95fRU.bottom($95fRU.boundedInt);
var $f935a9866e211c00$var$bind = /* #__PURE__ */ $9Grh5.bind($ykHdR.bindMaybe);
var $f935a9866e211c00$var$voidLeft = /* #__PURE__ */ $l0wDR.voidLeft($ykHdR.functorMaybe);
var $f935a9866e211c00$var$guard = /* #__PURE__ */ $kK1nx.guard($ykHdR.alternativeMaybe);
var $f935a9866e211c00$var$fromJust = /* #__PURE__ */ $ykHdR.fromJust();
var $f935a9866e211c00$var$bottom1 = /* #__PURE__ */ $95fRU.bottom($95fRU.boundedChar);
var $f935a9866e211c00$var$top1 = /* #__PURE__ */ $95fRU.top($95fRU.boundedChar);
var $f935a9866e211c00$export$a3fdfde49d86b899 = function(x) {
    return x;
};
var $f935a9866e211c00$export$45328c01562fb205 = function(dict) {
    return dict.toEnum;
};
var $f935a9866e211c00$export$61d85e1612867711 = function(dict) {
    return dict.succ;
};
var $f935a9866e211c00$export$f55455e25c350f35 = function(dictEnum) {
    var succ1 = $f935a9866e211c00$export$61d85e1612867711(dictEnum);
    return function(dictUnfoldable1) {
        return $hNKjN.unfoldr1(dictUnfoldable1)($f935a9866e211c00$var$apply($9MxTl.Tuple.create)(succ1));
    };
};
var $f935a9866e211c00$export$3d0bc2efe492e4f7 = {
    show: function(v) {
        return "(Cardinality " + ($f935a9866e211c00$var$show(v) + ")");
    }
};
var $f935a9866e211c00$export$c238ae40a8cccc17 = function(dict) {
    return dict.pred;
};
var $f935a9866e211c00$export$68d5f1a472f8251a = $d0PPW.ordInt;
var $f935a9866e211c00$export$d3d8047a35329ac2 = {
    Coercible0: function() {
        return undefined;
    }
};
var $f935a9866e211c00$export$b385cb642735011f = function(dict) {
    return dict.fromEnum;
};
var $f935a9866e211c00$export$1e2c188a485bdeae = function(dictBoundedEnum) {
    var toEnum1 = $f935a9866e211c00$export$45328c01562fb205(dictBoundedEnum);
    var fromEnum1 = $f935a9866e211c00$export$b385cb642735011f(dictBoundedEnum);
    var bottom2 = $95fRU.bottom(dictBoundedEnum.Bounded0());
    return function(low) {
        return function(high) {
            return function(x) {
                var v = toEnum1(x);
                if (v instanceof $ykHdR.Just) return v.value0;
                if (v instanceof $ykHdR.Nothing) {
                    var $140 = x < fromEnum1(bottom2);
                    if ($140) return low;
                    return high;
                }
                throw new Error("Failed pattern match at Data.Enum (line 158, column 33 - line 160, column 62): " + [
                    v.constructor.name
                ]);
            };
        };
    };
};
var $f935a9866e211c00$export$63b732e1f89f043e = $4MBcA.eqInt;
var $f935a9866e211c00$export$c0a99362196d7617 = /* #__PURE__ */ function() {
    return {
        succ: $l4M7e.const($ykHdR.Nothing.value),
        pred: $l4M7e.const($ykHdR.Nothing.value),
        Ord0: function() {
            return $d0PPW.ordUnit;
        }
    };
}();
var $f935a9866e211c00$export$51ea709069e9f759 = function(dictEnum) {
    var succ1 = $f935a9866e211c00$export$61d85e1612867711(dictEnum);
    var pred1 = $f935a9866e211c00$export$c238ae40a8cccc17(dictEnum);
    var ordTuple = $9MxTl.ordTuple(dictEnum.Ord0());
    return function(dictBoundedEnum) {
        var Bounded0 = dictBoundedEnum.Bounded0();
        var bottom2 = $95fRU.bottom(Bounded0);
        var Enum1 = dictBoundedEnum.Enum1();
        var succ2 = $f935a9866e211c00$export$61d85e1612867711(Enum1);
        var top2 = $95fRU.top(Bounded0);
        var pred2 = $f935a9866e211c00$export$c238ae40a8cccc17(Enum1);
        var ordTuple1 = ordTuple(Enum1.Ord0());
        return {
            succ: function(v) {
                return $ykHdR.maybe($f935a9866e211c00$var$map($l4M7e.flip($9MxTl.Tuple.create)(bottom2))(succ1(v.value0)))(function() {
                    var $183 = $9MxTl.Tuple.create(v.value0);
                    return function($184) {
                        return $ykHdR.Just.create($183($184));
                    };
                }())(succ2(v.value1));
            },
            pred: function(v) {
                return $ykHdR.maybe($f935a9866e211c00$var$map($l4M7e.flip($9MxTl.Tuple.create)(top2))(pred1(v.value0)))(function() {
                    var $185 = $9MxTl.Tuple.create(v.value0);
                    return function($186) {
                        return $ykHdR.Just.create($185($186));
                    };
                }())(pred2(v.value1));
            },
            Ord0: function() {
                return ordTuple1;
            }
        };
    };
};
var $f935a9866e211c00$export$94be50e509bf721a = {
    succ: function(v) {
        if (v instanceof $6SDUu.LT) return new $ykHdR.Just($6SDUu.EQ.value);
        if (v instanceof $6SDUu.EQ) return new $ykHdR.Just($6SDUu.GT.value);
        if (v instanceof $6SDUu.GT) return $ykHdR.Nothing.value;
        throw new Error("Failed pattern match at Data.Enum (line 72, column 1 - line 78, column 20): " + [
            v.constructor.name
        ]);
    },
    pred: function(v) {
        if (v instanceof $6SDUu.LT) return $ykHdR.Nothing.value;
        if (v instanceof $6SDUu.EQ) return new $ykHdR.Just($6SDUu.LT.value);
        if (v instanceof $6SDUu.GT) return new $ykHdR.Just($6SDUu.EQ.value);
        throw new Error("Failed pattern match at Data.Enum (line 72, column 1 - line 78, column 20): " + [
            v.constructor.name
        ]);
    },
    Ord0: function() {
        return $d0PPW.ordOrdering;
    }
};
var $f935a9866e211c00$export$4d9047d2b06c2498 = function(dictBoundedEnum) {
    var bottom2 = $95fRU.bottom(dictBoundedEnum.Bounded0());
    var Enum1 = dictBoundedEnum.Enum1();
    var succ1 = $f935a9866e211c00$export$61d85e1612867711(Enum1);
    var pred1 = $f935a9866e211c00$export$c238ae40a8cccc17(Enum1);
    var ordMaybe = $ykHdR.ordMaybe(Enum1.Ord0());
    return {
        succ: function(v) {
            if (v instanceof $ykHdR.Nothing) return new $ykHdR.Just(new $ykHdR.Just(bottom2));
            if (v instanceof $ykHdR.Just) return $f935a9866e211c00$var$map($ykHdR.Just.create)(succ1(v.value0));
            throw new Error("Failed pattern match at Data.Enum (line 80, column 1 - line 84, column 32): " + [
                v.constructor.name
            ]);
        },
        pred: function(v) {
            if (v instanceof $ykHdR.Nothing) return $ykHdR.Nothing.value;
            if (v instanceof $ykHdR.Just) return new $ykHdR.Just(pred1(v.value0));
            throw new Error("Failed pattern match at Data.Enum (line 80, column 1 - line 84, column 32): " + [
                v.constructor.name
            ]);
        },
        Ord0: function() {
            return ordMaybe;
        }
    };
};
var $f935a9866e211c00$export$f8cd1ff55b5d915b = {
    succ: function(n) {
        var $153 = n < $f935a9866e211c00$var$top;
        if ($153) return new $ykHdR.Just(n + 1 | 0);
        return $ykHdR.Nothing.value;
    },
    pred: function(n) {
        var $154 = n > $f935a9866e211c00$var$bottom;
        if ($154) return new $ykHdR.Just(n - 1 | 0);
        return $ykHdR.Nothing.value;
    },
    Ord0: function() {
        return $d0PPW.ordInt;
    }
};
var $f935a9866e211c00$export$51bf4ec4e9fd2fba = function(dictEnum) {
    var Ord0 = dictEnum.Ord0();
    var eq1 = $4MBcA.eq(Ord0.Eq0());
    var lessThan1 = $d0PPW.lessThan(Ord0);
    var succ1 = $f935a9866e211c00$export$61d85e1612867711(dictEnum);
    var lessThanOrEq1 = $d0PPW.lessThanOrEq(Ord0);
    var pred1 = $f935a9866e211c00$export$c238ae40a8cccc17(dictEnum);
    var greaterThanOrEq1 = $d0PPW.greaterThanOrEq(Ord0);
    return function(dictUnfoldable1) {
        var singleton = $hNKjN.singleton(dictUnfoldable1);
        var unfoldr1 = $hNKjN.unfoldr1(dictUnfoldable1);
        var go = function(step) {
            return function(op) {
                return function(to) {
                    return function(a) {
                        return new $9MxTl.Tuple(a, $f935a9866e211c00$var$bind(step(a))(function(a$prime) {
                            return $f935a9866e211c00$var$voidLeft($f935a9866e211c00$var$guard(op(a$prime)(to)))(a$prime);
                        }));
                    };
                };
            };
        };
        return function(v) {
            return function(v1) {
                if (eq1(v)(v1)) return singleton(v);
                if (lessThan1(v)(v1)) return unfoldr1(go(succ1)(lessThanOrEq1)(v1))(v);
                if ($6UHO6.otherwise) return unfoldr1(go(pred1)(greaterThanOrEq1)(v1))(v);
                throw new Error("Failed pattern match at Data.Enum (line 186, column 14 - line 190, column 51): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    };
};
var $f935a9866e211c00$export$c023000aca534be0 = function(dictUnfoldable) {
    var unfoldr = $hsyEi.unfoldr(dictUnfoldable);
    return function(dictFunctor) {
        var map1 = $l0wDR.map(dictFunctor);
        return function(dictBoundedEnum) {
            var fromEnum1 = $f935a9866e211c00$export$b385cb642735011f(dictBoundedEnum);
            var toEnum1 = $f935a9866e211c00$export$45328c01562fb205(dictBoundedEnum);
            var go = function(step) {
                return function(to) {
                    return function(e) {
                        if (e <= to) return new $ykHdR.Just(new $9MxTl.Tuple(e, e + step | 0));
                        if ($6UHO6.otherwise) return $ykHdR.Nothing.value;
                        throw new Error("Failed pattern match at Data.Enum (line 217, column 5 - line 219, column 28): " + [
                            step.constructor.name,
                            to.constructor.name,
                            e.constructor.name
                        ]);
                    };
                };
            };
            return function(a) {
                return function(b) {
                    return function(c) {
                        var c$prime = fromEnum1(c);
                        var b$prime = fromEnum1(b);
                        var a$prime = fromEnum1(a);
                        return map1(function($187) {
                            return $f935a9866e211c00$var$fromJust(toEnum1($187));
                        })(unfoldr(go(b$prime - a$prime | 0)(c$prime))(a$prime));
                    };
                };
            };
        };
    };
};
var $f935a9866e211c00$export$3733bec825dc17c = function(dictBoundedEnum) {
    var Enum1 = dictBoundedEnum.Enum1();
    var succ1 = $f935a9866e211c00$export$61d85e1612867711(Enum1);
    var pred1 = $f935a9866e211c00$export$c238ae40a8cccc17(Enum1);
    var top2 = $95fRU.top(dictBoundedEnum.Bounded0());
    var ordEither = $aKY4H.ordEither(Enum1.Ord0());
    return function(dictBoundedEnum1) {
        var bottom2 = $95fRU.bottom(dictBoundedEnum1.Bounded0());
        var Enum11 = dictBoundedEnum1.Enum1();
        var succ2 = $f935a9866e211c00$export$61d85e1612867711(Enum11);
        var pred2 = $f935a9866e211c00$export$c238ae40a8cccc17(Enum11);
        var ordEither1 = ordEither(Enum11.Ord0());
        return {
            succ: function(v) {
                if (v instanceof $aKY4H.Left) return $ykHdR.maybe(new $ykHdR.Just(new $aKY4H.Right(bottom2)))(function($188) {
                    return $ykHdR.Just.create($aKY4H.Left.create($188));
                })(succ1(v.value0));
                if (v instanceof $aKY4H.Right) return $ykHdR.maybe($ykHdR.Nothing.value)(function($189) {
                    return $ykHdR.Just.create($aKY4H.Right.create($189));
                })(succ2(v.value0));
                throw new Error("Failed pattern match at Data.Enum (line 86, column 1 - line 90, column 69): " + [
                    v.constructor.name
                ]);
            },
            pred: function(v) {
                if (v instanceof $aKY4H.Left) return $ykHdR.maybe($ykHdR.Nothing.value)(function($190) {
                    return $ykHdR.Just.create($aKY4H.Left.create($190));
                })(pred1(v.value0));
                if (v instanceof $aKY4H.Right) return $ykHdR.maybe(new $ykHdR.Just(new $aKY4H.Left(top2)))(function($191) {
                    return $ykHdR.Just.create($aKY4H.Right.create($191));
                })(pred2(v.value0));
                throw new Error("Failed pattern match at Data.Enum (line 86, column 1 - line 90, column 69): " + [
                    v.constructor.name
                ]);
            },
            Ord0: function() {
                return ordEither1;
            }
        };
    };
};
var $f935a9866e211c00$export$6670eb63482acbe8 = {
    succ: function(v) {
        if (!v) return new $ykHdR.Just(true);
        return $ykHdR.Nothing.value;
    },
    pred: function(v) {
        if (v) return new $ykHdR.Just(false);
        return $ykHdR.Nothing.value;
    },
    Ord0: function() {
        return $d0PPW.ordBoolean;
    }
};
var $f935a9866e211c00$export$ab0f40ba1313e2bb = function(dictEnum) {
    var pred1 = $f935a9866e211c00$export$c238ae40a8cccc17(dictEnum);
    return function(dictUnfoldable1) {
        return $hNKjN.unfoldr1(dictUnfoldable1)($f935a9866e211c00$var$apply($9MxTl.Tuple.create)(pred1));
    };
};
var $f935a9866e211c00$var$diag = function(a) {
    return new $9MxTl.Tuple(a, a);
};
var $f935a9866e211c00$export$c0c53cc9a0565905 = function(dictEnum) {
    var pred1 = $f935a9866e211c00$export$c238ae40a8cccc17(dictEnum);
    return function(dictUnfoldable) {
        return $hsyEi.unfoldr(dictUnfoldable)(function() {
            var $192 = $f935a9866e211c00$var$map($f935a9866e211c00$var$diag);
            return function($193) {
                return $192(pred1($193));
            };
        }());
    };
};
var $f935a9866e211c00$export$556edd6c9fb1e655 = function(dictEnum) {
    var succ1 = $f935a9866e211c00$export$61d85e1612867711(dictEnum);
    return function(dictUnfoldable) {
        return $hsyEi.unfoldr(dictUnfoldable)(function() {
            var $194 = $f935a9866e211c00$var$map($f935a9866e211c00$var$diag);
            return function($195) {
                return $194(succ1($195));
            };
        }());
    };
};
var $f935a9866e211c00$export$9263b51426343c61 = function(dictBounded) {
    var bottom2 = $95fRU.bottom(dictBounded);
    return function(dictEnum) {
        var succ1 = $f935a9866e211c00$export$61d85e1612867711(dictEnum);
        return function(i$prime) {
            var go = function($copy_i) {
                return function($copy_x) {
                    var $tco_var_i = $copy_i;
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(i, x) {
                        var $168 = i === 0;
                        if ($168) {
                            $tco_done = true;
                            return new $ykHdR.Just(x);
                        }
                        var v = succ1(x);
                        if (v instanceof $ykHdR.Just) {
                            $tco_var_i = i - 1 | 0;
                            $copy_x = v.value0;
                            return;
                        }
                        if (v instanceof $ykHdR.Nothing) {
                            $tco_done = true;
                            return $ykHdR.Nothing.value;
                        }
                        throw new Error("Failed pattern match at Data.Enum (line 296, column 12 - line 298, column 33): " + [
                            v.constructor.name
                        ]);
                    }
                    while(!$tco_done)$tco_result = $tco_loop($tco_var_i, $copy_x);
                    return $tco_result;
                };
            };
            var $171 = i$prime < 0;
            if ($171) return $ykHdR.Nothing.value;
            return go(i$prime)(bottom2);
        };
    };
};
var $f935a9866e211c00$export$11e799785deb08e4 = function(toEnum$prime) {
    return function(fromEnum$prime) {
        return function(a) {
            return toEnum$prime(fromEnum$prime(a) + 1 | 0);
        };
    };
};
var $f935a9866e211c00$export$dc42af8461b24233 = function(toEnum$prime) {
    return function(fromEnum$prime) {
        return function(a) {
            return toEnum$prime(fromEnum$prime(a) - 1 | 0);
        };
    };
};
var $f935a9866e211c00$export$21fa49008ecbb00a = function(dictEnum) {
    var pred1 = $f935a9866e211c00$export$c238ae40a8cccc17(dictEnum);
    var go = function($copy_i) {
        return function($copy_x) {
            var $tco_var_i = $copy_i;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(i, x) {
                var v = pred1(x);
                if (v instanceof $ykHdR.Just) {
                    $tco_var_i = i + 1 | 0;
                    $copy_x = v.value0;
                    return;
                }
                if (v instanceof $ykHdR.Nothing) {
                    $tco_done = true;
                    return i;
                }
                throw new Error("Failed pattern match at Data.Enum (line 309, column 5 - line 311, column 19): " + [
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_i, $copy_x);
            return $tco_result;
        };
    };
    return go(0);
};
var $f935a9866e211c00$export$18eeb03d5b80a339 = function(dictBounded) {
    var bottom2 = $95fRU.bottom(dictBounded);
    return function(dictEnum) {
        var succ1 = $f935a9866e211c00$export$61d85e1612867711(dictEnum);
        var go = function($copy_i) {
            return function($copy_x) {
                var $tco_var_i = $copy_i;
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(i, x) {
                    var v = succ1(x);
                    if (v instanceof $ykHdR.Just) {
                        $tco_var_i = i + 1 | 0;
                        $copy_x = v.value0;
                        return;
                    }
                    if (v instanceof $ykHdR.Nothing) {
                        $tco_done = true;
                        return i;
                    }
                    throw new Error("Failed pattern match at Data.Enum (line 276, column 5 - line 278, column 19): " + [
                        v.constructor.name
                    ]);
                }
                while(!$tco_done)$tco_result = $tco_loop($tco_var_i, $copy_x);
                return $tco_result;
            };
        };
        return go(1)(bottom2);
    };
};
var $f935a9866e211c00$var$charToEnum = function(v) {
    if (v >= $2u4gw.toCharCode($f935a9866e211c00$var$bottom1) && v <= $2u4gw.toCharCode($f935a9866e211c00$var$top1)) return new $ykHdR.Just($2u4gw.fromCharCode(v));
    return $ykHdR.Nothing.value;
};
var $f935a9866e211c00$export$8ff57056df5ff58e = {
    succ: /* #__PURE__ */ $f935a9866e211c00$export$11e799785deb08e4($f935a9866e211c00$var$charToEnum)($2u4gw.toCharCode),
    pred: /* #__PURE__ */ $f935a9866e211c00$export$dc42af8461b24233($f935a9866e211c00$var$charToEnum)($2u4gw.toCharCode),
    Ord0: function() {
        return $d0PPW.ordChar;
    }
};
var $f935a9866e211c00$export$9e9949f96c411257 = function(dict) {
    return dict.cardinality;
};
var $f935a9866e211c00$export$670c12fc7b01c16 = {
    cardinality: 1,
    toEnum: function(v) {
        if (v === 0) return new $ykHdR.Just($r2HHk.unit);
        return $ykHdR.Nothing.value;
    },
    fromEnum: /* #__PURE__ */ $l4M7e.const(0),
    Bounded0: function() {
        return $95fRU.boundedUnit;
    },
    Enum1: function() {
        return $f935a9866e211c00$export$c0a99362196d7617;
    }
};
var $f935a9866e211c00$export$fe7add2041208ec9 = {
    cardinality: 3,
    toEnum: function(v) {
        if (v === 0) return new $ykHdR.Just($6SDUu.LT.value);
        if (v === 1) return new $ykHdR.Just($6SDUu.EQ.value);
        if (v === 2) return new $ykHdR.Just($6SDUu.GT.value);
        return $ykHdR.Nothing.value;
    },
    fromEnum: function(v) {
        if (v instanceof $6SDUu.LT) return 0;
        if (v instanceof $6SDUu.EQ) return 1;
        if (v instanceof $6SDUu.GT) return 2;
        throw new Error("Failed pattern match at Data.Enum (line 137, column 1 - line 145, column 18): " + [
            v.constructor.name
        ]);
    },
    Bounded0: function() {
        return $95fRU.boundedOrdering;
    },
    Enum1: function() {
        return $f935a9866e211c00$export$94be50e509bf721a;
    }
};
var $f935a9866e211c00$export$be1f07c3580164c = /* #__PURE__ */ function() {
    return {
        cardinality: $2u4gw.toCharCode($f935a9866e211c00$var$top1) - $2u4gw.toCharCode($f935a9866e211c00$var$bottom1) | 0,
        toEnum: $f935a9866e211c00$var$charToEnum,
        fromEnum: $2u4gw.toCharCode,
        Bounded0: function() {
            return $95fRU.boundedChar;
        },
        Enum1: function() {
            return $f935a9866e211c00$export$8ff57056df5ff58e;
        }
    };
}();
var $f935a9866e211c00$export$3d0fa7de09d15272 = {
    cardinality: 2,
    toEnum: function(v) {
        if (v === 0) return new $ykHdR.Just(false);
        if (v === 1) return new $ykHdR.Just(true);
        return $ykHdR.Nothing.value;
    },
    fromEnum: function(v) {
        if (!v) return 0;
        if (v) return 1;
        throw new Error("Failed pattern match at Data.Enum (line 118, column 1 - line 124, column 20): " + [
            v.constructor.name
        ]);
    },
    Bounded0: function() {
        return $95fRU.boundedBoolean;
    },
    Enum1: function() {
        return $f935a9866e211c00$export$6670eb63482acbe8;
    }
};

});
parcelRegister("2u4gw", function(module, exports) {

$parcel$export(module.exports, "toCharCode", () => $1cf1b1293ed20ecf$export$d90166409dd04e85);
$parcel$export(module.exports, "fromCharCode", () => $1cf1b1293ed20ecf$export$30216c0101da0ee0);
function $1cf1b1293ed20ecf$export$d90166409dd04e85(c) {
    return c.charCodeAt(0);
}
function $1cf1b1293ed20ecf$export$30216c0101da0ee0(c) {
    return String.fromCharCode(c);
}

});

parcelRegister("kK1nx", function(module, exports) {

$parcel$export(module.exports, "guard", () => $f1992c51575cdea6$export$864d727b48066337);
$parcel$export(module.exports, "alternativeArray", () => $f1992c51575cdea6$export$5e87c78e215371ee);
// Generated by purs version 0.15.16

var $a7Dxq = parcelRequire("a7Dxq");

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $axmEP = parcelRequire("axmEP");

var $l0wDR = parcelRequire("l0wDR");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");
var $f1992c51575cdea6$export$864d727b48066337 = function(dictAlternative) {
    var pure = $gUTA8.pure(dictAlternative.Applicative0());
    var empty = $axmEP.empty(dictAlternative.Plus1());
    return function(v) {
        if (v) return pure($r2HHk.unit);
        if (!v) return empty;
        throw new Error("Failed pattern match at Control.Alternative (line 48, column 1 - line 48, column 54): " + [
            v.constructor.name
        ]);
    };
};
var $f1992c51575cdea6$export$5e87c78e215371ee = {
    Applicative0: function() {
        return $gUTA8.applicativeArray;
    },
    Plus1: function() {
        return $axmEP.plusArray;
    }
};

});




parcelRegister("kugLX", function(module, exports) {

$parcel$export(module.exports, "ComponentSlot", () => $eea39ea934373596$export$bbf8b056cc92e88d);
$parcel$export(module.exports, "ThunkSlot", () => $eea39ea934373596$export$5e46cfa5e835a582);
$parcel$export(module.exports, "unComponentSlot", () => $eea39ea934373596$export$48f0293959eb16ec);
$parcel$export(module.exports, "unComponent", () => $eea39ea934373596$export$802c6b8ce0f42195);
$parcel$export(module.exports, "mkEval", () => $eea39ea934373596$export$9eef9effff68b10a);
$parcel$export(module.exports, "mkComponent", () => $eea39ea934373596$export$3bb93a8213d3ef21);
$parcel$export(module.exports, "componentSlot", () => $eea39ea934373596$export$f7e7e2efed606f4a);
// Generated by purs version 0.15.16

var $gUTA8 = parcelRequire("gUTA8");

var $2Mmje = parcelRequire("2Mmje");

var $cYgrH = parcelRequire("cYgrH");

var $6RkEA = parcelRequire("6RkEA");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");

var $ykHdR = parcelRequire("ykHdR");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");

var $1j54f = parcelRequire("1j54f");

var $hhMAk = parcelRequire("hhMAk");

var $bllhK = parcelRequire("bllhK");

var $5OEb5 = parcelRequire("5OEb5");

var $kKOpj = parcelRequire("kKOpj");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");
var $eea39ea934373596$var$voidLeft = /* #__PURE__ */ $l0wDR.voidLeft($bllhK.functorHalogenM);
var $eea39ea934373596$var$traverse_ = /* #__PURE__ */ $6RkEA.traverse_($bllhK.applicativeHalogenM)($6RkEA.foldableMaybe);
var $eea39ea934373596$var$map = /* #__PURE__ */ $l0wDR.map($bllhK.functorHalogenM);
var $eea39ea934373596$var$lmap = /* #__PURE__ */ $2Mmje.lmap($hhMAk.bifunctorHTML);
var $eea39ea934373596$var$map1 = /* #__PURE__ */ $l0wDR.map($l0wDR.functorFn);
var $eea39ea934373596$var$map2 = /* #__PURE__ */ $l0wDR.map($ykHdR.functorMaybe);
var $eea39ea934373596$var$bimap = /* #__PURE__ */ $2Mmje.bimap($hhMAk.bifunctorHTML);
var $eea39ea934373596$var$pure = /* #__PURE__ */ $gUTA8.pure($bllhK.applicativeHalogenM);
var $eea39ea934373596$var$lookup = /* #__PURE__ */ $1j54f.lookup();
var $eea39ea934373596$var$pop = /* #__PURE__ */ $1j54f.pop();
var $eea39ea934373596$var$insert = /* #__PURE__ */ $1j54f.insert();
var $eea39ea934373596$export$bbf8b056cc92e88d = /* #__PURE__ */ function() {
    function ComponentSlot(value0) {
        this.value0 = value0;
    }
    ComponentSlot.create = function(value0) {
        return new ComponentSlot(value0);
    };
    return ComponentSlot;
}();
var $eea39ea934373596$export$5e46cfa5e835a582 = /* #__PURE__ */ function() {
    function ThunkSlot(value0) {
        this.value0 = value0;
    }
    ThunkSlot.create = function(value0) {
        return new ThunkSlot(value0);
    };
    return ThunkSlot;
}();
var $eea39ea934373596$export$48f0293959eb16ec = $eOrGk.unsafeCoerce;
var $eea39ea934373596$export$802c6b8ce0f42195 = $eOrGk.unsafeCoerce;
var $eea39ea934373596$export$9eef9effff68b10a = function(args) {
    return function(v) {
        if (v instanceof $5OEb5.Initialize) return $eea39ea934373596$var$voidLeft($eea39ea934373596$var$traverse_(args.handleAction)(args.initialize))(v.value0);
        if (v instanceof $5OEb5.Finalize) return $eea39ea934373596$var$voidLeft($eea39ea934373596$var$traverse_(args.handleAction)(args.finalize))(v.value0);
        if (v instanceof $5OEb5.Receive) return $eea39ea934373596$var$voidLeft($eea39ea934373596$var$traverse_(args.handleAction)(args.receive(v.value0)))(v.value1);
        if (v instanceof $5OEb5.Action) return $eea39ea934373596$var$voidLeft(args.handleAction(v.value0))(v.value1);
        if (v instanceof $5OEb5.Query) return $cYgrH.unCoyoneda(function(g) {
            var $45 = $eea39ea934373596$var$map($ykHdR.maybe(v.value1($r2HHk.unit))(g));
            return function($46) {
                return $45(args.handleQuery($46));
            };
        })(v.value0);
        throw new Error("Failed pattern match at Halogen.Component (line 182, column 15 - line 192, column 71): " + [
            v.constructor.name
        ]);
    };
};
var $eea39ea934373596$export$89c807d7ece13702 = $eOrGk.unsafeCoerce;
var $eea39ea934373596$export$3bb93a8213d3ef21 = $eOrGk.unsafeCoerce;
var $eea39ea934373596$export$6294a7576a4b06c3 = function(dictFunctor) {
    return function(nat) {
        return function(v) {
            if (v instanceof $eea39ea934373596$export$bbf8b056cc92e88d) return $eea39ea934373596$export$48f0293959eb16ec(function(slot) {
                return new $eea39ea934373596$export$bbf8b056cc92e88d($eea39ea934373596$export$89c807d7ece13702({
                    get: slot.get,
                    pop: slot.pop,
                    set: slot.set,
                    input: slot.input,
                    output: slot.output,
                    component: $eea39ea934373596$export$b2cccb4e0928a3a6(dictFunctor)(nat)(slot.component)
                }));
            })(v.value0);
            if (v instanceof $eea39ea934373596$export$5e46cfa5e835a582) return new $eea39ea934373596$export$5e46cfa5e835a582($kKOpj.hoist($eea39ea934373596$var$lmap($eea39ea934373596$export$6294a7576a4b06c3(dictFunctor)(nat)))(v.value0));
            throw new Error("Failed pattern match at Halogen.Component (line 279, column 17 - line 284, column 53): " + [
                v.constructor.name
            ]);
        };
    };
};
var $eea39ea934373596$export$b2cccb4e0928a3a6 = function(dictFunctor) {
    var hoist1 = $bllhK.hoist(dictFunctor);
    return function(nat) {
        return $eea39ea934373596$export$802c6b8ce0f42195(function(c) {
            return $eea39ea934373596$export$3bb93a8213d3ef21({
                initialState: c.initialState,
                render: function() {
                    var $47 = $eea39ea934373596$var$lmap($eea39ea934373596$export$6294a7576a4b06c3(dictFunctor)(nat));
                    return function($48) {
                        return $47(c.render($48));
                    };
                }(),
                "eval": function() {
                    var $49 = hoist1(nat);
                    return function($50) {
                        return $49(c["eval"]($50));
                    };
                }()
            });
        });
    };
};
var $eea39ea934373596$export$ed5606d1e76f4b8b = {
    map: function(f) {
        return $eea39ea934373596$export$48f0293959eb16ec(function(slot) {
            return $eea39ea934373596$export$89c807d7ece13702({
                get: slot.get,
                pop: slot.pop,
                set: slot.set,
                component: slot.component,
                input: slot.input,
                output: $eea39ea934373596$var$map1($eea39ea934373596$var$map2(f))(slot.output)
            });
        });
    }
};
var $eea39ea934373596$var$map3 = /* #__PURE__ */ $l0wDR.map($eea39ea934373596$export$ed5606d1e76f4b8b);
var $eea39ea934373596$export$e299aa0f47209936 = {
    map: function(f) {
        return function(v) {
            if (v instanceof $eea39ea934373596$export$bbf8b056cc92e88d) return new $eea39ea934373596$export$bbf8b056cc92e88d($eea39ea934373596$var$map3(f)(v.value0));
            if (v instanceof $eea39ea934373596$export$5e46cfa5e835a582) return new $eea39ea934373596$export$5e46cfa5e835a582($kKOpj.mapThunk($eea39ea934373596$var$bimap($l0wDR.map($eea39ea934373596$export$e299aa0f47209936)(f))(f))(v.value0));
            throw new Error("Failed pattern match at Halogen.Component (line 209, column 11 - line 211, column 74): " + [
                v.constructor.name
            ]);
        };
    }
};
var $eea39ea934373596$export$cb95887a94082d64 = /* #__PURE__ */ function() {
    return {
        handleAction: $l4M7e.const($eea39ea934373596$var$pure($r2HHk.unit)),
        handleQuery: $l4M7e.const($eea39ea934373596$var$pure($ykHdR.Nothing.value)),
        receive: $l4M7e.const($ykHdR.Nothing.value),
        initialize: $ykHdR.Nothing.value,
        finalize: $ykHdR.Nothing.value
    };
}();
var $eea39ea934373596$export$f7e7e2efed606f4a = function() {
    return function(dictIsSymbol) {
        var lookup1 = $eea39ea934373596$var$lookup(dictIsSymbol);
        var pop1 = $eea39ea934373596$var$pop(dictIsSymbol);
        var insert1 = $eea39ea934373596$var$insert(dictIsSymbol);
        return function(dictOrd) {
            var lookup2 = lookup1(dictOrd);
            var pop2 = pop1(dictOrd);
            var insert2 = insert1(dictOrd);
            return function(label) {
                return function(p) {
                    return function(comp) {
                        return function(input) {
                            return function(output) {
                                return $eea39ea934373596$export$89c807d7ece13702({
                                    get: lookup2(label)(p),
                                    pop: pop2(label)(p),
                                    set: insert2(label)(p),
                                    component: comp,
                                    input: input,
                                    output: output
                                });
                            };
                        };
                    };
                };
            };
        };
    };
};

});
parcelRegister("1j54f", function(module, exports) {

$parcel$export(module.exports, "slots", () => $0f3b7f18059106fc$export$bbd679b9fab4c947);
$parcel$export(module.exports, "pop", () => $0f3b7f18059106fc$export$3e41007ebfff0e64);
$parcel$export(module.exports, "lookup", () => $0f3b7f18059106fc$export$dfc7155ac0343b8);
$parcel$export(module.exports, "insert", () => $0f3b7f18059106fc$export$21a5ca8aa77d35ff);
$parcel$export(module.exports, "foreachSlot", () => $0f3b7f18059106fc$export$91dbfdfb14db6990);
$parcel$export(module.exports, "empty", () => $0f3b7f18059106fc$export$6e22c362a0406a2c);
// Generated by purs version 0.15.16

var $6UHO6 = parcelRequire("6UHO6");

var $6RkEA = parcelRequire("6RkEA");

var $k6SBa = parcelRequire("k6SBa");

var $ykHdR = parcelRequire("ykHdR");

var $irO3r = parcelRequire("irO3r");

var $6PW1p = parcelRequire("6PW1p");

var $d0PPW = parcelRequire("d0PPW");

var $2HEu8 = parcelRequire("2HEu8");

var $9MxTl = parcelRequire("9MxTl");

var $lqMYl = parcelRequire("lqMYl");
var $0f3b7f18059106fc$var$un = /* #__PURE__ */ $6PW1p.un();
var $0f3b7f18059106fc$var$ordTuple = /* #__PURE__ */ $9MxTl.ordTuple($d0PPW.ordString)($lqMYl.ordOrdBox);
var $0f3b7f18059106fc$var$foldSubmap = /* #__PURE__ */ $k6SBa.foldSubmap($0f3b7f18059106fc$var$ordTuple);
var $0f3b7f18059106fc$var$pop1 = /* #__PURE__ */ $k6SBa.pop($0f3b7f18059106fc$var$ordTuple);
var $0f3b7f18059106fc$var$lookup1 = /* #__PURE__ */ $k6SBa.lookup($0f3b7f18059106fc$var$ordTuple);
var $0f3b7f18059106fc$var$insert1 = /* #__PURE__ */ $k6SBa.insert($0f3b7f18059106fc$var$ordTuple);
var $0f3b7f18059106fc$var$SlotStorage = function(x) {
    return x;
};
var $0f3b7f18059106fc$export$bbd679b9fab4c947 = function() {
    return function(dictIsSymbol) {
        var reflectSymbol = $2HEu8.reflectSymbol(dictIsSymbol);
        return function(dictOrd) {
            var foldSubmap1 = $0f3b7f18059106fc$var$foldSubmap($irO3r.monoidAlternate($k6SBa.plusMap(dictOrd)));
            return function(sym) {
                return function(v) {
                    var key = reflectSymbol(sym);
                    var go = function(v1) {
                        return function(val) {
                            if (key === v1.value0) return $k6SBa.singleton($lqMYl.unOrdBox(v1.value1))(val);
                            if ($6UHO6.otherwise) return $k6SBa.empty;
                            throw new Error("Failed pattern match at Halogen.Data.Slot (line 121, column 3 - line 123, column 38): " + [
                                v1.constructor.name,
                                val.constructor.name
                            ]);
                        };
                    };
                    return $0f3b7f18059106fc$var$un($irO3r.Alternate)(foldSubmap1($ykHdR.Nothing.value)($ykHdR.Nothing.value)(go)(v));
                };
            };
        };
    };
};
var $0f3b7f18059106fc$export$3e41007ebfff0e64 = function() {
    return function(dictIsSymbol) {
        var reflectSymbol = $2HEu8.reflectSymbol(dictIsSymbol);
        return function(dictOrd) {
            var mkOrdBox = $lqMYl.mkOrdBox(dictOrd);
            return function(sym) {
                return function(key) {
                    return function(v) {
                        return $0f3b7f18059106fc$var$pop1(new $9MxTl.Tuple(reflectSymbol(sym), mkOrdBox(key)))(v);
                    };
                };
            };
        };
    };
};
var $0f3b7f18059106fc$export$dfc7155ac0343b8 = function() {
    return function(dictIsSymbol) {
        var reflectSymbol = $2HEu8.reflectSymbol(dictIsSymbol);
        return function(dictOrd) {
            var mkOrdBox = $lqMYl.mkOrdBox(dictOrd);
            return function(sym) {
                return function(key) {
                    return function(v) {
                        return $0f3b7f18059106fc$var$lookup1(new $9MxTl.Tuple(reflectSymbol(sym), mkOrdBox(key)))(v);
                    };
                };
            };
        };
    };
};
var $0f3b7f18059106fc$export$21a5ca8aa77d35ff = function() {
    return function(dictIsSymbol) {
        var reflectSymbol = $2HEu8.reflectSymbol(dictIsSymbol);
        return function(dictOrd) {
            var mkOrdBox = $lqMYl.mkOrdBox(dictOrd);
            return function(sym) {
                return function(key) {
                    return function(val) {
                        return function(v) {
                            return $0f3b7f18059106fc$var$insert1(new $9MxTl.Tuple(reflectSymbol(sym), mkOrdBox(key)))(val)(v);
                        };
                    };
                };
            };
        };
    };
};
var $0f3b7f18059106fc$export$91dbfdfb14db6990 = function(dictApplicative) {
    var traverse_ = $6RkEA.traverse_(dictApplicative)($k6SBa.foldableMap);
    return function(v) {
        return function(k) {
            return traverse_(function($54) {
                return k($54);
            })(v);
        };
    };
};
var $0f3b7f18059106fc$export$6e22c362a0406a2c = $k6SBa.empty;

});
parcelRegister("k6SBa", function(module, exports) {

$parcel$export(module.exports, "singleton", () => $ea3eb84de0acf574$export$439306a4dcaafbb9);
$parcel$export(module.exports, "pop", () => $ea3eb84de0acf574$export$3e41007ebfff0e64);
$parcel$export(module.exports, "lookup", () => $ea3eb84de0acf574$export$dfc7155ac0343b8);
$parcel$export(module.exports, "insert", () => $ea3eb84de0acf574$export$21a5ca8aa77d35ff);
$parcel$export(module.exports, "foldableMap", () => $ea3eb84de0acf574$export$4295a0c2ad7aa544);
$parcel$export(module.exports, "foldableWithIndexMap", () => $ea3eb84de0acf574$export$91e1c50dfb7225a6);
$parcel$export(module.exports, "traversableMap", () => $ea3eb84de0acf574$export$78146089411e393d);
$parcel$export(module.exports, "foldSubmap", () => $ea3eb84de0acf574$export$3f9a381f67a51fcd);
$parcel$export(module.exports, "empty", () => $ea3eb84de0acf574$export$6e22c362a0406a2c);
$parcel$export(module.exports, "delete", () => $ea3eb84de0acf574$export$1822828d790e23ee);
$parcel$export(module.exports, "alter", () => $ea3eb84de0acf574$export$22a7378e1d3307a4);
$parcel$export(module.exports, "plusMap", () => $ea3eb84de0acf574$export$4c085c510196daa3);
// Generated by purs version 0.15.16

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $7T8P4 = parcelRequire("7T8P4");

var $6UHO6 = parcelRequire("6UHO6");

var $4MBcA = parcelRequire("4MBcA");

var $6RkEA = parcelRequire("6RkEA");

var $70sTh = parcelRequire("70sTh");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");

var $amUgg = parcelRequire("amUgg");

var $ykHdR = parcelRequire("ykHdR");

var $aknDF = parcelRequire("aknDF");

var $d0PPW = parcelRequire("d0PPW");

var $6SDUu = parcelRequire("6SDUu");

var $hTcAb = parcelRequire("hTcAb");

var $iwqgS = parcelRequire("iwqgS");

var $3Orkn = parcelRequire("3Orkn");

var $1wR1l = parcelRequire("1wR1l");

var $9MxTl = parcelRequire("9MxTl");

var $hsyEi = parcelRequire("hsyEi");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");
var $ea3eb84de0acf574$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $ea3eb84de0acf574$var$show = /* #__PURE__ */ $3Orkn.show($3Orkn.showInt);
var $ea3eb84de0acf574$var$map = /* #__PURE__ */ $l0wDR.map($ykHdR.functorMaybe);
var $ea3eb84de0acf574$var$identity = /* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn);
var $ea3eb84de0acf574$var$abs = /* #__PURE__ */ $d0PPW.abs($d0PPW.ordInt)($hTcAb.ringInt);
var $ea3eb84de0acf574$export$3024f3bfb62054a3 = /* #__PURE__ */ function() {
    function Leaf() {}
    Leaf.value = new Leaf();
    return Leaf;
}();
var $ea3eb84de0acf574$export$85c928794f8d04d4 = /* #__PURE__ */ function() {
    function Node(value0, value1, value2, value3, value4, value5) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
        this.value4 = value4;
        this.value5 = value5;
    }
    Node.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return function(value4) {
                        return function(value5) {
                            return new Node(value0, value1, value2, value3, value4, value5);
                        };
                    };
                };
            };
        };
    };
    return Node;
}();
var $ea3eb84de0acf574$var$IterLeaf = /* #__PURE__ */ function() {
    function IterLeaf() {}
    IterLeaf.value = new IterLeaf();
    return IterLeaf;
}();
var $ea3eb84de0acf574$var$IterEmit = /* #__PURE__ */ function() {
    function IterEmit(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    IterEmit.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new IterEmit(value0, value1, value2);
            };
        };
    };
    return IterEmit;
}();
var $ea3eb84de0acf574$var$IterNode = /* #__PURE__ */ function() {
    function IterNode(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    IterNode.create = function(value0) {
        return function(value1) {
            return new IterNode(value0, value1);
        };
    };
    return IterNode;
}();
var $ea3eb84de0acf574$export$4546c67049b8e195 = /* #__PURE__ */ function() {
    function IterDone() {}
    IterDone.value = new IterDone();
    return IterDone;
}();
var $ea3eb84de0acf574$export$e512af67edd28ac0 = /* #__PURE__ */ function() {
    function IterNext(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    IterNext.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new IterNext(value0, value1, value2);
            };
        };
    };
    return IterNext;
}();
var $ea3eb84de0acf574$export$f836382419f64c98 = /* #__PURE__ */ function() {
    function Split(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    Split.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new Split(value0, value1, value2);
            };
        };
    };
    return Split;
}();
var $ea3eb84de0acf574$var$SplitLast = /* #__PURE__ */ function() {
    function SplitLast(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    SplitLast.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new SplitLast(value0, value1, value2);
            };
        };
    };
    return SplitLast;
}();
var $ea3eb84de0acf574$export$8cd737e72cfcb4cd = function(k, v, l, r) {
    if (l instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
        if (r instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return new $ea3eb84de0acf574$export$85c928794f8d04d4(1, 1, k, v, l, r);
        if (r instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return new $ea3eb84de0acf574$export$85c928794f8d04d4(1 + r.value0 | 0, 1 + r.value1 | 0, k, v, l, r);
        throw new Error("Failed pattern match at Data.Map.Internal (line 702, column 5 - line 706, column 39): " + [
            r.constructor.name
        ]);
    }
    if (l instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
        if (r instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return new $ea3eb84de0acf574$export$85c928794f8d04d4(1 + l.value0 | 0, 1 + l.value1 | 0, k, v, l, r);
        if (r instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return new $ea3eb84de0acf574$export$85c928794f8d04d4(1 + function() {
            var $280 = l.value0 > r.value0;
            if ($280) return l.value0;
            return r.value0;
        }() | 0, (1 + l.value1 | 0) + r.value1 | 0, k, v, l, r);
        throw new Error("Failed pattern match at Data.Map.Internal (line 708, column 5 - line 712, column 68): " + [
            r.constructor.name
        ]);
    }
    throw new Error("Failed pattern match at Data.Map.Internal (line 700, column 32 - line 712, column 68): " + [
        l.constructor.name
    ]);
};
var $ea3eb84de0acf574$export$a07cd7d770cb0fb3 = /* #__PURE__ */ function() {
    return $l4M7e.flip($ea3eb84de0acf574$var$IterNode.create)($ea3eb84de0acf574$var$IterLeaf.value);
}();
var $ea3eb84de0acf574$var$stepWith = function(f) {
    return function(next) {
        return function(done) {
            var go = function($copy_v) {
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(v) {
                    if (v instanceof $ea3eb84de0acf574$var$IterLeaf) {
                        $tco_done = true;
                        return done($r2HHk.unit);
                    }
                    if (v instanceof $ea3eb84de0acf574$var$IterEmit) {
                        $tco_done = true;
                        return next(v.value0, v.value1, v.value2);
                    }
                    if (v instanceof $ea3eb84de0acf574$var$IterNode) {
                        $copy_v = f(v.value1)(v.value0);
                        return;
                    }
                    throw new Error("Failed pattern match at Data.Map.Internal (line 940, column 8 - line 946, column 20): " + [
                        v.constructor.name
                    ]);
                }
                while(!$tco_done)$tco_result = $tco_loop($copy_v);
                return $tco_result;
            };
            return go;
        };
    };
};
var $ea3eb84de0acf574$export$346677f925de839c = function(v) {
    if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return 0;
    if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return v.value1;
    throw new Error("Failed pattern match at Data.Map.Internal (line 618, column 8 - line 620, column 24): " + [
        v.constructor.name
    ]);
};
var $ea3eb84de0acf574$export$439306a4dcaafbb9 = function(k) {
    return function(v) {
        return new $ea3eb84de0acf574$export$85c928794f8d04d4(1, 1, k, v, $ea3eb84de0acf574$export$3024f3bfb62054a3.value, $ea3eb84de0acf574$export$3024f3bfb62054a3.value);
    };
};
var $ea3eb84de0acf574$export$807b724170e609fd = /* #__PURE__ */ function() {
    var height = function(v) {
        if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return 0;
        if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return v.value0;
        throw new Error("Failed pattern match at Data.Map.Internal (line 757, column 12 - line 759, column 26): " + [
            v.constructor.name
        ]);
    };
    var rotateLeft = function(k, v, l, rk, rv, rl, rr) {
        if (rl instanceof $ea3eb84de0acf574$export$85c928794f8d04d4 && rl.value0 > height(rr)) return $ea3eb84de0acf574$export$8cd737e72cfcb4cd(rl.value2, rl.value3, $ea3eb84de0acf574$export$8cd737e72cfcb4cd(k, v, l, rl.value4), $ea3eb84de0acf574$export$8cd737e72cfcb4cd(rk, rv, rl.value5, rr));
        return $ea3eb84de0acf574$export$8cd737e72cfcb4cd(rk, rv, $ea3eb84de0acf574$export$8cd737e72cfcb4cd(k, v, l, rl), rr);
    };
    var rotateRight = function(k, v, lk, lv, ll, lr, r) {
        if (lr instanceof $ea3eb84de0acf574$export$85c928794f8d04d4 && height(ll) <= lr.value0) return $ea3eb84de0acf574$export$8cd737e72cfcb4cd(lr.value2, lr.value3, $ea3eb84de0acf574$export$8cd737e72cfcb4cd(lk, lv, ll, lr.value4), $ea3eb84de0acf574$export$8cd737e72cfcb4cd(k, v, lr.value5, r));
        return $ea3eb84de0acf574$export$8cd737e72cfcb4cd(lk, lv, ll, $ea3eb84de0acf574$export$8cd737e72cfcb4cd(k, v, lr, r));
    };
    return function(k, v, l, r) {
        if (l instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
            if (r instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$439306a4dcaafbb9(k)(v);
            if (r instanceof $ea3eb84de0acf574$export$85c928794f8d04d4 && r.value0 > 1) return rotateLeft(k, v, l, r.value2, r.value3, r.value4, r.value5);
            return $ea3eb84de0acf574$export$8cd737e72cfcb4cd(k, v, l, r);
        }
        if (l instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
            if (r instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                if (r.value0 > (l.value0 + 1 | 0)) return rotateLeft(k, v, l, r.value2, r.value3, r.value4, r.value5);
                if (l.value0 > (r.value0 + 1 | 0)) return rotateRight(k, v, l.value2, l.value3, l.value4, l.value5, r);
            }
            if (r instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3 && l.value0 > 1) return rotateRight(k, v, l.value2, l.value3, l.value4, l.value5, r);
            return $ea3eb84de0acf574$export$8cd737e72cfcb4cd(k, v, l, r);
        }
        throw new Error("Failed pattern match at Data.Map.Internal (line 717, column 40 - line 738, column 34): " + [
            l.constructor.name
        ]);
    };
}();
var $ea3eb84de0acf574$var$$lazy_unsafeSplit = /* #__PURE__ */ $ea3eb84de0acf574$var$$runtime_lazy("unsafeSplit", "Data.Map.Internal", function() {
    return function(comp, k, m) {
        if (m instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return new $ea3eb84de0acf574$export$f836382419f64c98($ykHdR.Nothing.value, $ea3eb84de0acf574$export$3024f3bfb62054a3.value, $ea3eb84de0acf574$export$3024f3bfb62054a3.value);
        if (m instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
            var v = comp(k)(m.value2);
            if (v instanceof $6SDUu.LT) {
                var v1 = $ea3eb84de0acf574$var$$lazy_unsafeSplit(793)(comp, k, m.value4);
                return new $ea3eb84de0acf574$export$f836382419f64c98(v1.value0, v1.value1, $ea3eb84de0acf574$export$807b724170e609fd(m.value2, m.value3, v1.value2, m.value5));
            }
            if (v instanceof $6SDUu.GT) {
                var v1 = $ea3eb84de0acf574$var$$lazy_unsafeSplit(796)(comp, k, m.value5);
                return new $ea3eb84de0acf574$export$f836382419f64c98(v1.value0, $ea3eb84de0acf574$export$807b724170e609fd(m.value2, m.value3, m.value4, v1.value1), v1.value2);
            }
            if (v instanceof $6SDUu.EQ) return new $ea3eb84de0acf574$export$f836382419f64c98(new $ykHdR.Just(m.value3), m.value4, m.value5);
            throw new Error("Failed pattern match at Data.Map.Internal (line 791, column 5 - line 799, column 30): " + [
                v.constructor.name
            ]);
        }
        throw new Error("Failed pattern match at Data.Map.Internal (line 787, column 34 - line 799, column 30): " + [
            m.constructor.name
        ]);
    };
});
var $ea3eb84de0acf574$export$9827c6ff7b07c8a4 = /* #__PURE__ */ $ea3eb84de0acf574$var$$lazy_unsafeSplit(786);
var $ea3eb84de0acf574$var$$lazy_unsafeSplitLast = /* #__PURE__ */ $ea3eb84de0acf574$var$$runtime_lazy("unsafeSplitLast", "Data.Map.Internal", function() {
    return function(k, v, l, r) {
        if (r instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return new $ea3eb84de0acf574$var$SplitLast(k, v, l);
        if (r instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
            var v1 = $ea3eb84de0acf574$var$$lazy_unsafeSplitLast(779)(r.value2, r.value3, r.value4, r.value5);
            return new $ea3eb84de0acf574$var$SplitLast(v1.value0, v1.value1, $ea3eb84de0acf574$export$807b724170e609fd(k, v, l, v1.value2));
        }
        throw new Error("Failed pattern match at Data.Map.Internal (line 776, column 37 - line 780, column 57): " + [
            r.constructor.name
        ]);
    };
});
var $ea3eb84de0acf574$var$unsafeSplitLast = /* #__PURE__ */ $ea3eb84de0acf574$var$$lazy_unsafeSplitLast(775);
var $ea3eb84de0acf574$export$76d750f4290aa12 = function(v, v1) {
    if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return v1;
    if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
        var v2 = $ea3eb84de0acf574$var$unsafeSplitLast(v.value2, v.value3, v.value4, v.value5);
        return $ea3eb84de0acf574$export$807b724170e609fd(v2.value0, v2.value1, v2.value2, v1);
    }
    throw new Error("Failed pattern match at Data.Map.Internal (line 764, column 25 - line 768, column 38): " + [
        v.constructor.name,
        v1.constructor.name
    ]);
};
var $ea3eb84de0acf574$var$$lazy_unsafeDifference = /* #__PURE__ */ $ea3eb84de0acf574$var$$runtime_lazy("unsafeDifference", "Data.Map.Internal", function() {
    return function(comp, l, r) {
        if (l instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$3024f3bfb62054a3.value;
        if (r instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return l;
        if (r instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
            var v = $ea3eb84de0acf574$export$9827c6ff7b07c8a4(comp, r.value2, l);
            var l$prime = $ea3eb84de0acf574$var$$lazy_unsafeDifference(841)(comp, v.value1, r.value4);
            var r$prime = $ea3eb84de0acf574$var$$lazy_unsafeDifference(842)(comp, v.value2, r.value5);
            return $ea3eb84de0acf574$export$76d750f4290aa12(l$prime, r$prime);
        }
        throw new Error("Failed pattern match at Data.Map.Internal (line 836, column 39 - line 843, column 33): " + [
            l.constructor.name,
            r.constructor.name
        ]);
    };
});
var $ea3eb84de0acf574$var$unsafeDifference = /* #__PURE__ */ $ea3eb84de0acf574$var$$lazy_unsafeDifference(835);
var $ea3eb84de0acf574$var$$lazy_unsafeIntersectionWith = /* #__PURE__ */ $ea3eb84de0acf574$var$$runtime_lazy("unsafeIntersectionWith", "Data.Map.Internal", function() {
    return function(comp, app, l, r) {
        if (l instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$3024f3bfb62054a3.value;
        if (r instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$3024f3bfb62054a3.value;
        if (r instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
            var v = $ea3eb84de0acf574$export$9827c6ff7b07c8a4(comp, r.value2, l);
            var l$prime = $ea3eb84de0acf574$var$$lazy_unsafeIntersectionWith(825)(comp, app, v.value1, r.value4);
            var r$prime = $ea3eb84de0acf574$var$$lazy_unsafeIntersectionWith(826)(comp, app, v.value2, r.value5);
            if (v.value0 instanceof $ykHdR.Just) return $ea3eb84de0acf574$export$807b724170e609fd(r.value2, app(v.value0.value0)(r.value3), l$prime, r$prime);
            if (v.value0 instanceof $ykHdR.Nothing) return $ea3eb84de0acf574$export$76d750f4290aa12(l$prime, r$prime);
            throw new Error("Failed pattern match at Data.Map.Internal (line 827, column 5 - line 831, column 37): " + [
                v.value0.constructor.name
            ]);
        }
        throw new Error("Failed pattern match at Data.Map.Internal (line 820, column 49 - line 831, column 37): " + [
            l.constructor.name,
            r.constructor.name
        ]);
    };
});
var $ea3eb84de0acf574$var$unsafeIntersectionWith = /* #__PURE__ */ $ea3eb84de0acf574$var$$lazy_unsafeIntersectionWith(819);
var $ea3eb84de0acf574$var$$lazy_unsafeUnionWith = /* #__PURE__ */ $ea3eb84de0acf574$var$$runtime_lazy("unsafeUnionWith", "Data.Map.Internal", function() {
    return function(comp, app, l, r) {
        if (l instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return r;
        if (r instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return l;
        if (r instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
            var v = $ea3eb84de0acf574$export$9827c6ff7b07c8a4(comp, r.value2, l);
            var l$prime = $ea3eb84de0acf574$var$$lazy_unsafeUnionWith(809)(comp, app, v.value1, r.value4);
            var r$prime = $ea3eb84de0acf574$var$$lazy_unsafeUnionWith(810)(comp, app, v.value2, r.value5);
            if (v.value0 instanceof $ykHdR.Just) return $ea3eb84de0acf574$export$807b724170e609fd(r.value2, app(v.value0.value0)(r.value3), l$prime, r$prime);
            if (v.value0 instanceof $ykHdR.Nothing) return $ea3eb84de0acf574$export$807b724170e609fd(r.value2, r.value3, l$prime, r$prime);
            throw new Error("Failed pattern match at Data.Map.Internal (line 811, column 5 - line 815, column 46): " + [
                v.value0.constructor.name
            ]);
        }
        throw new Error("Failed pattern match at Data.Map.Internal (line 804, column 42 - line 815, column 46): " + [
            l.constructor.name,
            r.constructor.name
        ]);
    };
});
var $ea3eb84de0acf574$var$unsafeUnionWith = /* #__PURE__ */ $ea3eb84de0acf574$var$$lazy_unsafeUnionWith(803);
var $ea3eb84de0acf574$export$ed1b4f34a0e8b0cc = function(dictOrd) {
    var compare = $d0PPW.compare(dictOrd);
    return function(app) {
        return function(m1) {
            return function(m2) {
                return $ea3eb84de0acf574$var$unsafeUnionWith(compare, app, m1, m2);
            };
        };
    };
};
var $ea3eb84de0acf574$export$971dd5b0dfd021b6 = function(dictOrd) {
    return $ea3eb84de0acf574$export$ed1b4f34a0e8b0cc(dictOrd)($l4M7e.const);
};
var $ea3eb84de0acf574$export$722fbec263ad908a = function(dictOrd) {
    var compare = $d0PPW.compare(dictOrd);
    return function(f) {
        return function(k) {
            var go = function(v) {
                if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$3024f3bfb62054a3.value;
                if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                    var v1 = compare(k)(v.value2);
                    if (v1 instanceof $6SDUu.LT) return $ea3eb84de0acf574$export$807b724170e609fd(v.value2, v.value3, go(v.value4), v.value5);
                    if (v1 instanceof $6SDUu.GT) return $ea3eb84de0acf574$export$807b724170e609fd(v.value2, v.value3, v.value4, go(v.value5));
                    if (v1 instanceof $6SDUu.EQ) {
                        var v2 = f(v.value3);
                        if (v2 instanceof $ykHdR.Nothing) return $ea3eb84de0acf574$export$76d750f4290aa12(v.value4, v.value5);
                        if (v2 instanceof $ykHdR.Just) return new $ea3eb84de0acf574$export$85c928794f8d04d4(v.value0, v.value1, v.value2, v2.value0, v.value4, v.value5);
                        throw new Error("Failed pattern match at Data.Map.Internal (line 531, column 11 - line 535, column 38): " + [
                            v2.constructor.name
                        ]);
                    }
                    throw new Error("Failed pattern match at Data.Map.Internal (line 527, column 7 - line 535, column 38): " + [
                        v1.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Data.Map.Internal (line 524, column 8 - line 535, column 38): " + [
                    v.constructor.name
                ]);
            };
            return go;
        };
    };
};
var $ea3eb84de0acf574$export$b072eafdc1d506c3 = function(dictShow) {
    var show1 = $3Orkn.show(dictShow);
    return function(dictShow1) {
        var show2 = $3Orkn.show(dictShow1);
        var go = function(ind) {
            return function(v) {
                if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return ind + "Leaf";
                if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return ind + ("[" + ($ea3eb84de0acf574$var$show(v.value0) + ("] " + (show1(v.value2) + (" => " + (show2(v.value3) + "\x0a")))))) + (go(ind + "    ")(v.value4) + "\x0a" + go(ind + "    ")(v.value5));
                throw new Error("Failed pattern match at Data.Map.Internal (line 233, column 12 - line 238, column 34): " + [
                    v.constructor.name
                ]);
            };
        };
        return go("");
    };
};
var $ea3eb84de0acf574$export$12ebb66e272c23f3 = function() {
    return function(dictOrd) {
        var unionWith1 = $ea3eb84de0acf574$export$ed1b4f34a0e8b0cc(dictOrd);
        return function(dictSemigroup) {
            return {
                append: unionWith1($iwqgS.append(dictSemigroup))
            };
        };
    };
};
var $ea3eb84de0acf574$var$semigroupMap1 = /* #__PURE__ */ $ea3eb84de0acf574$export$12ebb66e272c23f3();
var $ea3eb84de0acf574$export$3e41007ebfff0e64 = function(dictOrd) {
    var compare = $d0PPW.compare(dictOrd);
    return function(k) {
        return function(m) {
            var v = $ea3eb84de0acf574$export$9827c6ff7b07c8a4(compare, k, m);
            return $ea3eb84de0acf574$var$map(function(a) {
                return new $9MxTl.Tuple(a, $ea3eb84de0acf574$export$76d750f4290aa12(v.value1, v.value2));
            })(v.value0);
        };
    };
};
var $ea3eb84de0acf574$export$6a0d13241802fe80 = function(dictOrd) {
    var compare = $d0PPW.compare(dictOrd);
    return function(k) {
        var go = function($copy_v) {
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v) {
                if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
                    $tco_done = true;
                    return false;
                }
                if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                    var v1 = compare(k)(v.value2);
                    if (v1 instanceof $6SDUu.LT) {
                        $copy_v = v.value4;
                        return;
                    }
                    if (v1 instanceof $6SDUu.GT) {
                        $copy_v = v.value5;
                        return;
                    }
                    if (v1 instanceof $6SDUu.EQ) {
                        $tco_done = true;
                        return true;
                    }
                    throw new Error("Failed pattern match at Data.Map.Internal (line 459, column 7 - line 462, column 19): " + [
                        v1.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Data.Map.Internal (line 456, column 8 - line 462, column 19): " + [
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($copy_v);
            return $tco_result;
        };
        return go;
    };
};
var $ea3eb84de0acf574$export$6be5ce76a5140a15 = function(dictOrd) {
    return function(f) {
        var go = function(v) {
            if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$3024f3bfb62054a3.value;
            if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                var v2 = f(v.value2)(v.value3);
                if (v2 instanceof $ykHdR.Just) return $ea3eb84de0acf574$export$807b724170e609fd(v.value2, v2.value0, go(v.value4), go(v.value5));
                if (v2 instanceof $ykHdR.Nothing) return $ea3eb84de0acf574$export$76d750f4290aa12(go(v.value4), go(v.value5));
                throw new Error("Failed pattern match at Data.Map.Internal (line 661, column 7 - line 665, column 47): " + [
                    v2.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Data.Map.Internal (line 658, column 8 - line 665, column 47): " + [
                v.constructor.name
            ]);
        };
        return go;
    };
};
var $ea3eb84de0acf574$export$e70771d2e7e590a = function(dictOrd) {
    var $780 = $ea3eb84de0acf574$export$6be5ce76a5140a15(dictOrd);
    return function($781) {
        return $780($l4M7e.const($781));
    };
};
var $ea3eb84de0acf574$export$6c45e13560e32a55 = function(dictOrd) {
    var compare = $d0PPW.compare(dictOrd);
    return function(k) {
        var go = function(v) {
            if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ykHdR.Nothing.value;
            if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                var v1 = compare(k)(v.value2);
                if (v1 instanceof $6SDUu.LT) return go(v.value4);
                if (v1 instanceof $6SDUu.GT) {
                    var v2 = go(v.value5);
                    if (v2 instanceof $ykHdR.Nothing) return new $ykHdR.Just({
                        key: v.value2,
                        value: v.value3
                    });
                    return v2;
                }
                if (v1 instanceof $6SDUu.EQ) return new $ykHdR.Just({
                    key: v.value2,
                    value: v.value3
                });
                throw new Error("Failed pattern match at Data.Map.Internal (line 295, column 7 - line 302, column 38): " + [
                    v1.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Data.Map.Internal (line 292, column 8 - line 302, column 38): " + [
                v.constructor.name
            ]);
        };
        return go;
    };
};
var $ea3eb84de0acf574$export$7b26f9c4323be72 = function(dictOrd) {
    var compare = $d0PPW.compare(dictOrd);
    return function(k) {
        var go = function(v) {
            if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ykHdR.Nothing.value;
            if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                var v1 = compare(k)(v.value2);
                if (v1 instanceof $6SDUu.LT) {
                    var v2 = go(v.value4);
                    if (v2 instanceof $ykHdR.Nothing) return new $ykHdR.Just({
                        key: v.value2,
                        value: v.value3
                    });
                    return v2;
                }
                if (v1 instanceof $6SDUu.GT) return go(v.value5);
                if (v1 instanceof $6SDUu.EQ) return new $ykHdR.Just({
                    key: v.value2,
                    value: v.value3
                });
                throw new Error("Failed pattern match at Data.Map.Internal (line 327, column 7 - line 333, column 42): " + [
                    v1.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Data.Map.Internal (line 324, column 8 - line 333, column 42): " + [
                v.constructor.name
            ]);
        };
        return go;
    };
};
var $ea3eb84de0acf574$export$dfc7155ac0343b8 = function(dictOrd) {
    var compare = $d0PPW.compare(dictOrd);
    return function(k) {
        var go = function($copy_v) {
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v) {
                if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
                    $tco_done = true;
                    return $ykHdR.Nothing.value;
                }
                if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                    var v1 = compare(k)(v.value2);
                    if (v1 instanceof $6SDUu.LT) {
                        $copy_v = v.value4;
                        return;
                    }
                    if (v1 instanceof $6SDUu.GT) {
                        $copy_v = v.value5;
                        return;
                    }
                    if (v1 instanceof $6SDUu.EQ) {
                        $tco_done = true;
                        return new $ykHdR.Just(v.value3);
                    }
                    throw new Error("Failed pattern match at Data.Map.Internal (line 283, column 7 - line 286, column 22): " + [
                        v1.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Data.Map.Internal (line 280, column 8 - line 286, column 22): " + [
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($copy_v);
            return $tco_result;
        };
        return go;
    };
};
var $ea3eb84de0acf574$var$iterMapU = function(iter) {
    return function(v) {
        if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return iter;
        if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
            if (v.value4 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
                if (v.value5 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return new $ea3eb84de0acf574$var$IterEmit(v.value2, v.value3, iter);
                return new $ea3eb84de0acf574$var$IterEmit(v.value2, v.value3, new $ea3eb84de0acf574$var$IterNode(v.value5, iter));
            }
            if (v.value5 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return new $ea3eb84de0acf574$var$IterEmit(v.value2, v.value3, new $ea3eb84de0acf574$var$IterNode(v.value4, iter));
            return new $ea3eb84de0acf574$var$IterEmit(v.value2, v.value3, new $ea3eb84de0acf574$var$IterNode(v.value4, new $ea3eb84de0acf574$var$IterNode(v.value5, iter)));
        }
        throw new Error("Failed pattern match at Data.Map.Internal (line 973, column 17 - line 988, column 56): " + [
            v.constructor.name
        ]);
    };
};
var $ea3eb84de0acf574$export$882785ec79906152 = /* #__PURE__ */ $ea3eb84de0acf574$var$stepWith($ea3eb84de0acf574$var$iterMapU);
var $ea3eb84de0acf574$var$stepUnfoldrUnordered = /* #__PURE__ */ function() {
    var step = function(k, v, next) {
        return new $ykHdR.Just(new $9MxTl.Tuple(new $9MxTl.Tuple(k, v), next));
    };
    return $ea3eb84de0acf574$export$882785ec79906152(step)(function(v) {
        return $ykHdR.Nothing.value;
    });
}();
var $ea3eb84de0acf574$export$4e1300b52a76ba3a = function(dictUnfoldable) {
    var $782 = $hsyEi.unfoldr(dictUnfoldable)($ea3eb84de0acf574$var$stepUnfoldrUnordered);
    return function($783) {
        return $782($ea3eb84de0acf574$export$a07cd7d770cb0fb3($783));
    };
};
var $ea3eb84de0acf574$export$b60b523eeb066dbd = /* #__PURE__ */ function() {
    return $ea3eb84de0acf574$export$882785ec79906152(function(k, v, next) {
        return new $ea3eb84de0acf574$export$e512af67edd28ac0(k, v, next);
    })($l4M7e.const($ea3eb84de0acf574$export$4546c67049b8e195.value));
}();
var $ea3eb84de0acf574$var$iterMapR = /* #__PURE__ */ function() {
    var go = function($copy_iter) {
        return function($copy_v) {
            var $tco_var_iter = $copy_iter;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(iter, v) {
                if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
                    $tco_done = true;
                    return iter;
                }
                if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                    if (v.value5 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
                        $tco_var_iter = new $ea3eb84de0acf574$var$IterEmit(v.value2, v.value3, iter);
                        $copy_v = v.value4;
                        return;
                    }
                    $tco_var_iter = new $ea3eb84de0acf574$var$IterEmit(v.value2, v.value3, new $ea3eb84de0acf574$var$IterNode(v.value4, iter));
                    $copy_v = v.value5;
                    return;
                }
                throw new Error("Failed pattern match at Data.Map.Internal (line 963, column 13 - line 970, column 48): " + [
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_iter, $copy_v);
            return $tco_result;
        };
    };
    return go;
}();
var $ea3eb84de0acf574$export$dc5b2553d8583b72 = /* #__PURE__ */ $ea3eb84de0acf574$var$stepWith($ea3eb84de0acf574$var$iterMapR);
var $ea3eb84de0acf574$export$cdc6b87d9fb979 = /* #__PURE__ */ function() {
    return $ea3eb84de0acf574$export$dc5b2553d8583b72(function(k, v, next) {
        return new $ea3eb84de0acf574$export$e512af67edd28ac0(k, v, next);
    })($l4M7e.const($ea3eb84de0acf574$export$4546c67049b8e195.value));
}();
var $ea3eb84de0acf574$var$iterMapL = /* #__PURE__ */ function() {
    var go = function($copy_iter) {
        return function($copy_v) {
            var $tco_var_iter = $copy_iter;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(iter, v) {
                if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
                    $tco_done = true;
                    return iter;
                }
                if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                    if (v.value5 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
                        $tco_var_iter = new $ea3eb84de0acf574$var$IterEmit(v.value2, v.value3, iter);
                        $copy_v = v.value4;
                        return;
                    }
                    $tco_var_iter = new $ea3eb84de0acf574$var$IterEmit(v.value2, v.value3, new $ea3eb84de0acf574$var$IterNode(v.value5, iter));
                    $copy_v = v.value4;
                    return;
                }
                throw new Error("Failed pattern match at Data.Map.Internal (line 951, column 13 - line 958, column 48): " + [
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_iter, $copy_v);
            return $tco_result;
        };
    };
    return go;
}();
var $ea3eb84de0acf574$export$273c44542cac8efe = /* #__PURE__ */ $ea3eb84de0acf574$var$stepWith($ea3eb84de0acf574$var$iterMapL);
var $ea3eb84de0acf574$export$3b67892037786a5b = /* #__PURE__ */ function() {
    return $ea3eb84de0acf574$export$273c44542cac8efe(function(k, v, next) {
        return new $ea3eb84de0acf574$export$e512af67edd28ac0(k, v, next);
    })($l4M7e.const($ea3eb84de0acf574$export$4546c67049b8e195.value));
}();
var $ea3eb84de0acf574$export$4719e5aa2706059f = function(dictEq) {
    var eq1 = $4MBcA.eq(dictEq);
    return function(dictEq1) {
        var eq2 = $4MBcA.eq(dictEq1);
        return {
            eq: function() {
                var go = function($copy_a) {
                    return function($copy_b) {
                        var $tco_var_a = $copy_a;
                        var $tco_done = false;
                        var $tco_result;
                        function $tco_loop(a, b) {
                            var v = $ea3eb84de0acf574$export$3b67892037786a5b(a);
                            if (v instanceof $ea3eb84de0acf574$export$e512af67edd28ac0) {
                                var v2 = $ea3eb84de0acf574$export$3b67892037786a5b(b);
                                if (v2 instanceof $ea3eb84de0acf574$export$e512af67edd28ac0 && eq1(v.value0)(v2.value0) && eq2(v.value1)(v2.value1)) {
                                    $tco_var_a = v.value2;
                                    $copy_b = v2.value2;
                                    return;
                                }
                                $tco_done = true;
                                return false;
                            }
                            if (v instanceof $ea3eb84de0acf574$export$4546c67049b8e195) {
                                $tco_done = true;
                                return true;
                            }
                            throw new Error("Failed pattern match at Data.Map.Internal (line 859, column 14 - line 868, column 13): " + [
                                v.constructor.name
                            ]);
                        }
                        while(!$tco_done)$tco_result = $tco_loop($tco_var_a, $copy_b);
                        return $tco_result;
                    };
                };
                return go;
            }()
        };
    };
};
var $ea3eb84de0acf574$export$2b627c4f0ac5579b = function(dictOrd) {
    var compare = $d0PPW.compare(dictOrd);
    var eqMapIter1 = $ea3eb84de0acf574$export$4719e5aa2706059f(dictOrd.Eq0());
    return function(dictOrd1) {
        var compare1 = $d0PPW.compare(dictOrd1);
        var eqMapIter2 = eqMapIter1(dictOrd1.Eq0());
        return {
            compare: function() {
                var go = function($copy_a) {
                    return function($copy_b) {
                        var $tco_var_a = $copy_a;
                        var $tco_done = false;
                        var $tco_result;
                        function $tco_loop(a, b) {
                            var v = $ea3eb84de0acf574$export$3b67892037786a5b(b);
                            var v1 = $ea3eb84de0acf574$export$3b67892037786a5b(a);
                            if (v1 instanceof $ea3eb84de0acf574$export$e512af67edd28ac0 && v instanceof $ea3eb84de0acf574$export$e512af67edd28ac0) {
                                var v3 = compare(v1.value0)(v.value0);
                                if (v3 instanceof $6SDUu.EQ) {
                                    var v4 = compare1(v1.value1)(v.value1);
                                    if (v4 instanceof $6SDUu.EQ) {
                                        $tco_var_a = v1.value2;
                                        $copy_b = v.value2;
                                        return;
                                    }
                                    $tco_done = true;
                                    return v4;
                                }
                                $tco_done = true;
                                return v3;
                            }
                            if (v1 instanceof $ea3eb84de0acf574$export$4546c67049b8e195) {
                                if (v instanceof $ea3eb84de0acf574$export$4546c67049b8e195) {
                                    $tco_done = true;
                                    return $6SDUu.EQ.value;
                                }
                                $tco_done = true;
                                return $6SDUu.LT.value;
                            }
                            if (v instanceof $ea3eb84de0acf574$export$4546c67049b8e195) {
                                $tco_done = true;
                                return $6SDUu.GT.value;
                            }
                            throw new Error("Failed pattern match at Data.Map.Internal (line 873, column 14 - line 891, column 11): " + [
                                v1.constructor.name,
                                v.constructor.name
                            ]);
                        }
                        while(!$tco_done)$tco_result = $tco_loop($tco_var_a, $copy_b);
                        return $tco_result;
                    };
                };
                return go;
            }(),
            Eq0: function() {
                return eqMapIter2;
            }
        };
    };
};
var $ea3eb84de0acf574$var$stepUnfoldr = /* #__PURE__ */ function() {
    var step = function(k, v, next) {
        return new $ykHdR.Just(new $9MxTl.Tuple(new $9MxTl.Tuple(k, v), next));
    };
    return $ea3eb84de0acf574$export$273c44542cac8efe(step)(function(v) {
        return $ykHdR.Nothing.value;
    });
}();
var $ea3eb84de0acf574$export$823be24f8766da23 = function(dictUnfoldable) {
    var $784 = $hsyEi.unfoldr(dictUnfoldable)($ea3eb84de0acf574$var$stepUnfoldr);
    return function($785) {
        return $784($ea3eb84de0acf574$export$a07cd7d770cb0fb3($785));
    };
};
var $ea3eb84de0acf574$var$toUnfoldable1 = /* #__PURE__ */ $ea3eb84de0acf574$export$823be24f8766da23($hsyEi.unfoldableArray);
var $ea3eb84de0acf574$export$c448526daa762015 = function(dictShow) {
    var showTuple = $9MxTl.showTuple(dictShow);
    return function(dictShow1) {
        var show1 = $3Orkn.show($3Orkn.showArray(showTuple(dictShow1)));
        return {
            show: function(as) {
                return "(fromFoldable " + (show1($ea3eb84de0acf574$var$toUnfoldable1(as)) + ")");
            }
        };
    };
};
var $ea3eb84de0acf574$export$35d0420a84c5d3ae = function(dictOrd) {
    var lookup1 = $ea3eb84de0acf574$export$dfc7155ac0343b8(dictOrd);
    return function(dictEq) {
        var eq1 = $4MBcA.eq(dictEq);
        var go = function(m1) {
            return function(m2) {
                if (m1 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return true;
                if (m1 instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                    var v1 = lookup1(m1.value2)(m2);
                    if (v1 instanceof $ykHdR.Nothing) return false;
                    if (v1 instanceof $ykHdR.Just) return eq1(m1.value3)(v1.value0) && go(m1.value4)(m2) && go(m1.value5)(m2);
                    throw new Error("Failed pattern match at Data.Map.Internal (line 611, column 7 - line 614, column 40): " + [
                        v1.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Data.Map.Internal (line 608, column 14 - line 614, column 40): " + [
                    m1.constructor.name
                ]);
            };
        };
        return go;
    };
};
var $ea3eb84de0acf574$export$dd1bc94b04021eeb = function(v) {
    if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return true;
    return false;
};
var $ea3eb84de0acf574$export$a6c74cde0675b326 = function(dictOrd) {
    var compare = $d0PPW.compare(dictOrd);
    return function(app) {
        return function(m1) {
            return function(m2) {
                return $ea3eb84de0acf574$var$unsafeIntersectionWith(compare, app, m1, m2);
            };
        };
    };
};
var $ea3eb84de0acf574$export$bc86dfbf7795668c = function(dictOrd) {
    return $ea3eb84de0acf574$export$a6c74cde0675b326(dictOrd)($l4M7e.const);
};
var $ea3eb84de0acf574$export$435aa68287e449bf = function(dictOrd) {
    var compare = $d0PPW.compare(dictOrd);
    return function(app) {
        return function(k) {
            return function(v) {
                var go = function(v1) {
                    if (v1 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$439306a4dcaafbb9(k)(v);
                    if (v1 instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                        var v2 = compare(k)(v1.value2);
                        if (v2 instanceof $6SDUu.LT) return $ea3eb84de0acf574$export$807b724170e609fd(v1.value2, v1.value3, go(v1.value4), v1.value5);
                        if (v2 instanceof $6SDUu.GT) return $ea3eb84de0acf574$export$807b724170e609fd(v1.value2, v1.value3, v1.value4, go(v1.value5));
                        if (v2 instanceof $6SDUu.EQ) return new $ea3eb84de0acf574$export$85c928794f8d04d4(v1.value0, v1.value1, k, app(v1.value3)(v), v1.value4, v1.value5);
                        throw new Error("Failed pattern match at Data.Map.Internal (line 486, column 7 - line 489, column 44): " + [
                            v2.constructor.name
                        ]);
                    }
                    throw new Error("Failed pattern match at Data.Map.Internal (line 483, column 8 - line 489, column 44): " + [
                        v1.constructor.name
                    ]);
                };
                return go;
            };
        };
    };
};
var $ea3eb84de0acf574$export$21a5ca8aa77d35ff = function(dictOrd) {
    var compare = $d0PPW.compare(dictOrd);
    return function(k) {
        return function(v) {
            var go = function(v1) {
                if (v1 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$439306a4dcaafbb9(k)(v);
                if (v1 instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                    var v2 = compare(k)(v1.value2);
                    if (v2 instanceof $6SDUu.LT) return $ea3eb84de0acf574$export$807b724170e609fd(v1.value2, v1.value3, go(v1.value4), v1.value5);
                    if (v2 instanceof $6SDUu.GT) return $ea3eb84de0acf574$export$807b724170e609fd(v1.value2, v1.value3, v1.value4, go(v1.value5));
                    if (v2 instanceof $6SDUu.EQ) return new $ea3eb84de0acf574$export$85c928794f8d04d4(v1.value0, v1.value1, k, v, v1.value4, v1.value5);
                    throw new Error("Failed pattern match at Data.Map.Internal (line 471, column 7 - line 474, column 35): " + [
                        v2.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Data.Map.Internal (line 468, column 8 - line 474, column 35): " + [
                    v1.constructor.name
                ]);
            };
            return go;
        };
    };
};
var $ea3eb84de0acf574$export$3930f636962ed944 = {
    map: function(f) {
        var go = function(v) {
            if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$3024f3bfb62054a3.value;
            if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return new $ea3eb84de0acf574$export$85c928794f8d04d4(v.value0, v.value1, v.value2, f(v.value3), go(v.value4), go(v.value5));
            throw new Error("Failed pattern match at Data.Map.Internal (line 147, column 10 - line 150, column 39): " + [
                v.constructor.name
            ]);
        };
        return go;
    }
};
var $ea3eb84de0acf574$export$d7c684e0b3e84e77 = {
    mapWithIndex: function(f) {
        var go = function(v) {
            if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$3024f3bfb62054a3.value;
            if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return new $ea3eb84de0acf574$export$85c928794f8d04d4(v.value0, v.value1, v.value2, f(v.value2)(v.value3), go(v.value4), go(v.value5));
            throw new Error("Failed pattern match at Data.Map.Internal (line 155, column 10 - line 158, column 41): " + [
                v.constructor.name
            ]);
        };
        return go;
    },
    Functor0: function() {
        return $ea3eb84de0acf574$export$3930f636962ed944;
    }
};
var $ea3eb84de0acf574$export$4295a0c2ad7aa544 = {
    foldr: function(f) {
        return function(z) {
            var $lazy_go = $ea3eb84de0acf574$var$$runtime_lazy("go", "Data.Map.Internal", function() {
                return function(m$prime, z$prime) {
                    if (m$prime instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return z$prime;
                    if (m$prime instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return $lazy_go(172)(m$prime.value4, f(m$prime.value3)($lazy_go(172)(m$prime.value5, z$prime)));
                    throw new Error("Failed pattern match at Data.Map.Internal (line 169, column 26 - line 172, column 43): " + [
                        m$prime.constructor.name
                    ]);
                };
            });
            var go = $lazy_go(169);
            return function(m) {
                return go(m, z);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            var $lazy_go = $ea3eb84de0acf574$var$$runtime_lazy("go", "Data.Map.Internal", function() {
                return function(z$prime, m$prime) {
                    if (m$prime instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return z$prime;
                    if (m$prime instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return $lazy_go(178)(f($lazy_go(178)(z$prime, m$prime.value4))(m$prime.value3), m$prime.value5);
                    throw new Error("Failed pattern match at Data.Map.Internal (line 175, column 26 - line 178, column 43): " + [
                        m$prime.constructor.name
                    ]);
                };
            });
            var go = $lazy_go(175);
            return function(m) {
                return go(z, m);
            };
        };
    },
    foldMap: function(dictMonoid) {
        var mempty = $aknDF.mempty(dictMonoid);
        var append1 = $iwqgS.append(dictMonoid.Semigroup0());
        return function(f) {
            var go = function(v) {
                if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return mempty;
                if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return append1(go(v.value4))(append1(f(v.value3))(go(v.value5)));
                throw new Error("Failed pattern match at Data.Map.Internal (line 181, column 10 - line 184, column 28): " + [
                    v.constructor.name
                ]);
            };
            return go;
        };
    }
};
var $ea3eb84de0acf574$export$91e1c50dfb7225a6 = {
    foldrWithIndex: function(f) {
        return function(z) {
            var $lazy_go = $ea3eb84de0acf574$var$$runtime_lazy("go", "Data.Map.Internal", function() {
                return function(m$prime, z$prime) {
                    if (m$prime instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return z$prime;
                    if (m$prime instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return $lazy_go(192)(m$prime.value4, f(m$prime.value2)(m$prime.value3)($lazy_go(192)(m$prime.value5, z$prime)));
                    throw new Error("Failed pattern match at Data.Map.Internal (line 189, column 26 - line 192, column 45): " + [
                        m$prime.constructor.name
                    ]);
                };
            });
            var go = $lazy_go(189);
            return function(m) {
                return go(m, z);
            };
        };
    },
    foldlWithIndex: function(f) {
        return function(z) {
            var $lazy_go = $ea3eb84de0acf574$var$$runtime_lazy("go", "Data.Map.Internal", function() {
                return function(z$prime, m$prime) {
                    if (m$prime instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return z$prime;
                    if (m$prime instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return $lazy_go(198)(f(m$prime.value2)($lazy_go(198)(z$prime, m$prime.value4))(m$prime.value3), m$prime.value5);
                    throw new Error("Failed pattern match at Data.Map.Internal (line 195, column 26 - line 198, column 45): " + [
                        m$prime.constructor.name
                    ]);
                };
            });
            var go = $lazy_go(195);
            return function(m) {
                return go(z, m);
            };
        };
    },
    foldMapWithIndex: function(dictMonoid) {
        var mempty = $aknDF.mempty(dictMonoid);
        var append1 = $iwqgS.append(dictMonoid.Semigroup0());
        return function(f) {
            var go = function(v) {
                if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return mempty;
                if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return append1(go(v.value4))(append1(f(v.value2)(v.value3))(go(v.value5)));
                throw new Error("Failed pattern match at Data.Map.Internal (line 201, column 10 - line 204, column 30): " + [
                    v.constructor.name
                ]);
            };
            return go;
        };
    },
    Foldable0: function() {
        return $ea3eb84de0acf574$export$4295a0c2ad7aa544;
    }
};
var $ea3eb84de0acf574$export$ed97f33186d4b816 = /* #__PURE__ */ function() {
    return $70sTh.foldrWithIndex($ea3eb84de0acf574$export$91e1c50dfb7225a6)(function(k) {
        return function(v) {
            return function(acc) {
                return new $amUgg.Cons(k, acc);
            };
        };
    })($amUgg.Nil.value);
}();
var $ea3eb84de0acf574$export$78146089411e393d = {
    traverse: function(dictApplicative) {
        var pure = $gUTA8.pure(dictApplicative);
        var Apply0 = dictApplicative.Apply0();
        var apply = $a5g3C.apply(Apply0);
        var map1 = $l0wDR.map(Apply0.Functor0());
        return function(f) {
            var go = function(v) {
                if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return pure($ea3eb84de0acf574$export$3024f3bfb62054a3.value);
                if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return apply(apply(map1(function(l$prime) {
                    return function(v$prime) {
                        return function(r$prime) {
                            return new $ea3eb84de0acf574$export$85c928794f8d04d4(v.value0, v.value1, v.value2, v$prime, l$prime, r$prime);
                        };
                    };
                })(go(v.value4)))(f(v.value3)))(go(v.value5));
                throw new Error("Failed pattern match at Data.Map.Internal (line 209, column 10 - line 215, column 19): " + [
                    v.constructor.name
                ]);
            };
            return go;
        };
    },
    sequence: function(dictApplicative) {
        return $1wR1l.traverse($ea3eb84de0acf574$export$78146089411e393d)(dictApplicative)($ea3eb84de0acf574$var$identity);
    },
    Functor0: function() {
        return $ea3eb84de0acf574$export$3930f636962ed944;
    },
    Foldable1: function() {
        return $ea3eb84de0acf574$export$4295a0c2ad7aa544;
    }
};
var $ea3eb84de0acf574$export$8999febf5cd85b5c = {
    traverseWithIndex: function(dictApplicative) {
        var pure = $gUTA8.pure(dictApplicative);
        var Apply0 = dictApplicative.Apply0();
        var apply = $a5g3C.apply(Apply0);
        var map1 = $l0wDR.map(Apply0.Functor0());
        return function(f) {
            var go = function(v) {
                if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return pure($ea3eb84de0acf574$export$3024f3bfb62054a3.value);
                if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return apply(apply(map1(function(l$prime) {
                    return function(v$prime) {
                        return function(r$prime) {
                            return new $ea3eb84de0acf574$export$85c928794f8d04d4(v.value0, v.value1, v.value2, v$prime, l$prime, r$prime);
                        };
                    };
                })(go(v.value4)))(f(v.value2)(v.value3)))(go(v.value5));
                throw new Error("Failed pattern match at Data.Map.Internal (line 221, column 10 - line 227, column 19): " + [
                    v.constructor.name
                ]);
            };
            return go;
        };
    },
    FunctorWithIndex0: function() {
        return $ea3eb84de0acf574$export$d7c684e0b3e84e77;
    },
    FoldableWithIndex1: function() {
        return $ea3eb84de0acf574$export$91e1c50dfb7225a6;
    },
    Traversable2: function() {
        return $ea3eb84de0acf574$export$78146089411e393d;
    }
};
var $ea3eb84de0acf574$export$68c286be0e7e55b7 = /* #__PURE__ */ function() {
    return $6RkEA.foldr($ea3eb84de0acf574$export$4295a0c2ad7aa544)($amUgg.Cons.create)($amUgg.Nil.value);
}();
var $ea3eb84de0acf574$var$foldSubmapBy = function(dictOrd) {
    var lessThan1 = $d0PPW.lessThan(dictOrd);
    var greaterThan1 = $d0PPW.greaterThan(dictOrd);
    var lessThanOrEq1 = $d0PPW.lessThanOrEq(dictOrd);
    return function(appendFn) {
        return function(memptyValue) {
            return function(kmin) {
                return function(kmax) {
                    return function(f) {
                        var tooSmall = function() {
                            if (kmin instanceof $ykHdR.Just) return function(k) {
                                return lessThan1(k)(kmin.value0);
                            };
                            if (kmin instanceof $ykHdR.Nothing) return $l4M7e.const(false);
                            throw new Error("Failed pattern match at Data.Map.Internal (line 389, column 7 - line 393, column 22): " + [
                                kmin.constructor.name
                            ]);
                        }();
                        var tooLarge = function() {
                            if (kmax instanceof $ykHdR.Just) return function(k) {
                                return greaterThan1(k)(kmax.value0);
                            };
                            if (kmax instanceof $ykHdR.Nothing) return $l4M7e.const(false);
                            throw new Error("Failed pattern match at Data.Map.Internal (line 396, column 7 - line 400, column 22): " + [
                                kmax.constructor.name
                            ]);
                        }();
                        var inBounds = function() {
                            if (kmin instanceof $ykHdR.Just && kmax instanceof $ykHdR.Just) return function(k) {
                                return lessThanOrEq1(kmin.value0)(k) && lessThanOrEq1(k)(kmax.value0);
                            };
                            if (kmin instanceof $ykHdR.Just && kmax instanceof $ykHdR.Nothing) return function(k) {
                                return lessThanOrEq1(kmin.value0)(k);
                            };
                            if (kmin instanceof $ykHdR.Nothing && kmax instanceof $ykHdR.Just) return function(k) {
                                return lessThanOrEq1(k)(kmax.value0);
                            };
                            if (kmin instanceof $ykHdR.Nothing && kmax instanceof $ykHdR.Nothing) return $l4M7e.const(true);
                            throw new Error("Failed pattern match at Data.Map.Internal (line 403, column 7 - line 411, column 21): " + [
                                kmin.constructor.name,
                                kmax.constructor.name
                            ]);
                        }();
                        var go = function(v) {
                            if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return memptyValue;
                            if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return appendFn(appendFn(function() {
                                var $643 = tooSmall(v.value2);
                                if ($643) return memptyValue;
                                return go(v.value4);
                            }())(function() {
                                var $644 = inBounds(v.value2);
                                if ($644) return f(v.value2)(v.value3);
                                return memptyValue;
                            }()))(function() {
                                var $645 = tooLarge(v.value2);
                                if ($645) return memptyValue;
                                return go(v.value5);
                            }());
                            throw new Error("Failed pattern match at Data.Map.Internal (line 413, column 10 - line 419, column 66): " + [
                                v.constructor.name
                            ]);
                        };
                        return go;
                    };
                };
            };
        };
    };
};
var $ea3eb84de0acf574$export$3f9a381f67a51fcd = function(dictOrd) {
    var foldSubmapBy1 = $ea3eb84de0acf574$var$foldSubmapBy(dictOrd);
    return function(dictMonoid) {
        return foldSubmapBy1($iwqgS.append(dictMonoid.Semigroup0()))($aknDF.mempty(dictMonoid));
    };
};
var $ea3eb84de0acf574$export$3c39a95b7a4d5e28 = function($copy_v) {
    var $tco_done = false;
    var $tco_result;
    function $tco_loop(v) {
        if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
            $tco_done = true;
            return $ykHdR.Nothing.value;
        }
        if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
            if (v.value4 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
                $tco_done = true;
                return new $ykHdR.Just({
                    key: v.value2,
                    value: v.value3
                });
            }
            $copy_v = v.value4;
            return;
        }
        throw new Error("Failed pattern match at Data.Map.Internal (line 361, column 11 - line 366, column 21): " + [
            v.constructor.name
        ]);
    }
    while(!$tco_done)$tco_result = $tco_loop($copy_v);
    return $tco_result;
};
var $ea3eb84de0acf574$export$211c88c643c40f46 = function(dictOrd) {
    var compare = $d0PPW.compare(dictOrd);
    return function(k) {
        var go = function(v) {
            if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ykHdR.Nothing.value;
            if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                var v1 = compare(k)(v.value2);
                if (v1 instanceof $6SDUu.LT) {
                    var v2 = go(v.value4);
                    if (v2 instanceof $ykHdR.Nothing) return new $ykHdR.Just({
                        key: v.value2,
                        value: v.value3
                    });
                    return v2;
                }
                if (v1 instanceof $6SDUu.GT) return go(v.value5);
                if (v1 instanceof $6SDUu.EQ) return $ea3eb84de0acf574$export$3c39a95b7a4d5e28(v.value5);
                throw new Error("Failed pattern match at Data.Map.Internal (line 342, column 7 - line 348, column 25): " + [
                    v1.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Data.Map.Internal (line 339, column 8 - line 348, column 25): " + [
                v.constructor.name
            ]);
        };
        return go;
    };
};
var $ea3eb84de0acf574$export$35f577b3da447d17 = function($copy_v) {
    var $tco_done = false;
    var $tco_result;
    function $tco_loop(v) {
        if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
            $tco_done = true;
            return $ykHdR.Nothing.value;
        }
        if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
            if (v.value5 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
                $tco_done = true;
                return new $ykHdR.Just({
                    key: v.value2,
                    value: v.value3
                });
            }
            $copy_v = v.value5;
            return;
        }
        throw new Error("Failed pattern match at Data.Map.Internal (line 352, column 11 - line 357, column 21): " + [
            v.constructor.name
        ]);
    }
    while(!$tco_done)$tco_result = $tco_loop($copy_v);
    return $tco_result;
};
var $ea3eb84de0acf574$export$9318a1f920537b0d = function(dictOrd) {
    var compare = $d0PPW.compare(dictOrd);
    return function(k) {
        var go = function(v) {
            if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ykHdR.Nothing.value;
            if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                var v1 = compare(k)(v.value2);
                if (v1 instanceof $6SDUu.LT) return go(v.value4);
                if (v1 instanceof $6SDUu.GT) {
                    var v2 = go(v.value5);
                    if (v2 instanceof $ykHdR.Nothing) return new $ykHdR.Just({
                        key: v.value2,
                        value: v.value3
                    });
                    return v2;
                }
                if (v1 instanceof $6SDUu.EQ) return $ea3eb84de0acf574$export$35f577b3da447d17(v.value4);
                throw new Error("Failed pattern match at Data.Map.Internal (line 311, column 7 - line 318, column 21): " + [
                    v1.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Data.Map.Internal (line 308, column 8 - line 318, column 21): " + [
                v.constructor.name
            ]);
        };
        return go;
    };
};
var $ea3eb84de0acf574$export$d7a60370122a9ab0 = function(dictOrd) {
    return function(f) {
        var go = function(v) {
            if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$3024f3bfb62054a3.value;
            if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                if (f(v.value2)(v.value3)) return $ea3eb84de0acf574$export$807b724170e609fd(v.value2, v.value3, go(v.value4), go(v.value5));
                if ($6UHO6.otherwise) return $ea3eb84de0acf574$export$76d750f4290aa12(go(v.value4), go(v.value5));
            }
            throw new Error("Failed pattern match at Data.Map.Internal (line 627, column 8 - line 633, column 47): " + [
                v.constructor.name
            ]);
        };
        return go;
    };
};
var $ea3eb84de0acf574$export$151f9a87a7fd5652 = function(dictOrd) {
    return function(f) {
        var go = function(v) {
            if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$3024f3bfb62054a3.value;
            if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                if (f(v.value2)) return $ea3eb84de0acf574$export$807b724170e609fd(v.value2, v.value3, go(v.value4), go(v.value5));
                if ($6UHO6.otherwise) return $ea3eb84de0acf574$export$76d750f4290aa12(go(v.value4), go(v.value5));
            }
            throw new Error("Failed pattern match at Data.Map.Internal (line 640, column 8 - line 646, column 47): " + [
                v.constructor.name
            ]);
        };
        return go;
    };
};
var $ea3eb84de0acf574$export$3dea766d36a8935f = function(dictOrd) {
    var $786 = $ea3eb84de0acf574$export$d7a60370122a9ab0(dictOrd);
    return function($787) {
        return $786($l4M7e.const($787));
    };
};
var $ea3eb84de0acf574$export$85aac4508ff70b8 = function(dictEq) {
    var eqMapIter1 = $ea3eb84de0acf574$export$4719e5aa2706059f(dictEq);
    return function(dictEq1) {
        var eq1 = $4MBcA.eq(eqMapIter1(dictEq1));
        return {
            eq: function(xs) {
                return function(ys) {
                    if (xs instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
                        if (ys instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return true;
                        return false;
                    }
                    if (xs instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                        if (ys instanceof $ea3eb84de0acf574$export$85c928794f8d04d4 && xs.value1 === ys.value1) return eq1($ea3eb84de0acf574$export$a07cd7d770cb0fb3(xs))($ea3eb84de0acf574$export$a07cd7d770cb0fb3(ys));
                        return false;
                    }
                    throw new Error("Failed pattern match at Data.Map.Internal (line 94, column 14 - line 105, column 16): " + [
                        xs.constructor.name
                    ]);
                };
            }
        };
    };
};
var $ea3eb84de0acf574$export$3d0d4caf881d6855 = function(dictOrd) {
    var ordMapIter1 = $ea3eb84de0acf574$export$2b627c4f0ac5579b(dictOrd);
    var eqMap1 = $ea3eb84de0acf574$export$85aac4508ff70b8(dictOrd.Eq0());
    return function(dictOrd1) {
        var compare = $d0PPW.compare(ordMapIter1(dictOrd1));
        var eqMap2 = eqMap1(dictOrd1.Eq0());
        return {
            compare: function(xs) {
                return function(ys) {
                    if (xs instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
                        if (ys instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $6SDUu.EQ.value;
                        return $6SDUu.LT.value;
                    }
                    if (ys instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $6SDUu.GT.value;
                    return compare($ea3eb84de0acf574$export$a07cd7d770cb0fb3(xs))($ea3eb84de0acf574$export$a07cd7d770cb0fb3(ys));
                };
            },
            Eq0: function() {
                return eqMap2;
            }
        };
    };
};
var $ea3eb84de0acf574$export$e321b34a2787dc8d = function(dictEq) {
    var eqMap1 = $ea3eb84de0acf574$export$85aac4508ff70b8(dictEq);
    return {
        eq1: function(dictEq1) {
            return $4MBcA.eq(eqMap1(dictEq1));
        }
    };
};
var $ea3eb84de0acf574$export$e2f3c1862bab1bff = function(dictOrd) {
    var ordMap1 = $ea3eb84de0acf574$export$3d0d4caf881d6855(dictOrd);
    var eq1Map1 = $ea3eb84de0acf574$export$e321b34a2787dc8d(dictOrd.Eq0());
    return {
        compare1: function(dictOrd1) {
            return $d0PPW.compare(ordMap1(dictOrd1));
        },
        Eq10: function() {
            return eq1Map1;
        }
    };
};
var $ea3eb84de0acf574$export$6e22c362a0406a2c = /* #__PURE__ */ function() {
    return $ea3eb84de0acf574$export$3024f3bfb62054a3.value;
}();
var $ea3eb84de0acf574$export$b7d5d9bb9ff52072 = function(dictOrd) {
    var insert1 = $ea3eb84de0acf574$export$21a5ca8aa77d35ff(dictOrd);
    return function(dictFoldable) {
        return $6RkEA.foldl(dictFoldable)(function(m) {
            return function(v) {
                return insert1(v.value0)(v.value1)(m);
            };
        })($ea3eb84de0acf574$export$6e22c362a0406a2c);
    };
};
var $ea3eb84de0acf574$export$690be49d504fc7f = function(dictOrd) {
    var insertWith1 = $ea3eb84de0acf574$export$435aa68287e449bf(dictOrd);
    return function(dictFoldable) {
        var foldl = $6RkEA.foldl(dictFoldable);
        return function(f) {
            var f$prime = insertWith1($l4M7e.flip(f));
            return foldl(function(m) {
                return function(v) {
                    return f$prime(v.value0)(v.value1)(m);
                };
            })($ea3eb84de0acf574$export$6e22c362a0406a2c);
        };
    };
};
var $ea3eb84de0acf574$export$78cfe3464e7eb77b = function(dictOrd) {
    var insert1 = $ea3eb84de0acf574$export$21a5ca8aa77d35ff(dictOrd);
    return function(dictFoldableWithIndex) {
        return $70sTh.foldlWithIndex(dictFoldableWithIndex)(function(k) {
            return function(m) {
                return function(v) {
                    return insert1(k)(v)(m);
                };
            };
        })($ea3eb84de0acf574$export$6e22c362a0406a2c);
    };
};
var $ea3eb84de0acf574$export$546d2468bc9efbc6 = function() {
    return function(dictOrd) {
        var semigroupMap2 = $ea3eb84de0acf574$var$semigroupMap1(dictOrd);
        return function(dictSemigroup) {
            var semigroupMap3 = semigroupMap2(dictSemigroup);
            return {
                mempty: $ea3eb84de0acf574$export$6e22c362a0406a2c,
                Semigroup0: function() {
                    return semigroupMap3;
                }
            };
        };
    };
};
var $ea3eb84de0acf574$export$d6b4f308683e59db = function(dictOrd) {
    var foldSubmapBy1 = $ea3eb84de0acf574$var$foldSubmapBy(dictOrd);
    var union1 = $ea3eb84de0acf574$export$971dd5b0dfd021b6(dictOrd);
    return function(kmin) {
        return function(kmax) {
            return foldSubmapBy1(union1)($ea3eb84de0acf574$export$6e22c362a0406a2c)(kmin)(kmax)($ea3eb84de0acf574$export$439306a4dcaafbb9);
        };
    };
};
var $ea3eb84de0acf574$export$30b2db2f7030f6cf = function(dictOrd) {
    var union1 = $ea3eb84de0acf574$export$971dd5b0dfd021b6(dictOrd);
    return function(dictFoldable) {
        return $6RkEA.foldl(dictFoldable)(union1)($ea3eb84de0acf574$export$6e22c362a0406a2c);
    };
};
var $ea3eb84de0acf574$export$acaf96a27438246b = function(dictOrd) {
    var compare = $d0PPW.compare(dictOrd);
    return function(m1) {
        return function(m2) {
            return $ea3eb84de0acf574$var$unsafeDifference(compare, m1, m2);
        };
    };
};
var $ea3eb84de0acf574$export$1822828d790e23ee = function(dictOrd) {
    var compare = $d0PPW.compare(dictOrd);
    return function(k) {
        var go = function(v) {
            if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$3024f3bfb62054a3.value;
            if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                var v1 = compare(k)(v.value2);
                if (v1 instanceof $6SDUu.LT) return $ea3eb84de0acf574$export$807b724170e609fd(v.value2, v.value3, go(v.value4), v.value5);
                if (v1 instanceof $6SDUu.GT) return $ea3eb84de0acf574$export$807b724170e609fd(v.value2, v.value3, v.value4, go(v.value5));
                if (v1 instanceof $6SDUu.EQ) return $ea3eb84de0acf574$export$76d750f4290aa12(v.value4, v.value5);
                throw new Error("Failed pattern match at Data.Map.Internal (line 498, column 7 - line 501, column 43): " + [
                    v1.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Data.Map.Internal (line 495, column 8 - line 501, column 43): " + [
                v.constructor.name
            ]);
        };
        return go;
    };
};
var $ea3eb84de0acf574$export$6583e3e95cb5e9d1 = function(dictOrd) {
    var greaterThan1 = $d0PPW.greaterThan(dictOrd);
    var lessThan1 = $d0PPW.lessThan(dictOrd);
    var go = function(v) {
        if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return true;
        if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
            if (v.value4 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
                if (v.value5 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return true;
                if (v.value5 instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return v.value0 === 2 && v.value5.value0 === 1 && v.value1 > v.value5.value1 && greaterThan1(v.value5.value2)(v.value2) && go(v.value5);
                throw new Error("Failed pattern match at Data.Map.Internal (line 264, column 11 - line 268, column 60): " + [
                    v.value5.constructor.name
                ]);
            }
            if (v.value4 instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                if (v.value5 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return v.value0 === 2 && v.value4.value0 === 1 && v.value1 > v.value4.value1 && lessThan1(v.value4.value2)(v.value2) && go(v.value4);
                if (v.value5 instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return v.value0 > v.value5.value0 && greaterThan1(v.value5.value2)(v.value2) && v.value0 > v.value4.value0 && lessThan1(v.value4.value2)(v.value2) && $ea3eb84de0acf574$var$abs(v.value5.value0 - v.value4.value0 | 0) < 2 && ((v.value5.value1 + v.value4.value1 | 0) + 1 | 0) === v.value1 && go(v.value4) && go(v.value5);
                throw new Error("Failed pattern match at Data.Map.Internal (line 270, column 11 - line 274, column 108): " + [
                    v.value5.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Data.Map.Internal (line 262, column 7 - line 274, column 108): " + [
                v.value4.constructor.name
            ]);
        }
        throw new Error("Failed pattern match at Data.Map.Internal (line 259, column 8 - line 274, column 108): " + [
            v.constructor.name
        ]);
    };
    return go;
};
var $ea3eb84de0acf574$export$986c2bbe7a34be0b = function(dictOrd) {
    return $ea3eb84de0acf574$export$e70771d2e7e590a(dictOrd)($ea3eb84de0acf574$var$identity);
};
var $ea3eb84de0acf574$export$8952a3dc6f3cd264 = function(dictOrd) {
    return {
        apply: $ea3eb84de0acf574$export$a6c74cde0675b326(dictOrd)($ea3eb84de0acf574$var$identity),
        Functor0: function() {
            return $ea3eb84de0acf574$export$3930f636962ed944;
        }
    };
};
var $ea3eb84de0acf574$export$886591aa0ffe34d5 = function(dictOrd) {
    var mapMaybeWithKey1 = $ea3eb84de0acf574$export$6be5ce76a5140a15(dictOrd);
    var lookup1 = $ea3eb84de0acf574$export$dfc7155ac0343b8(dictOrd);
    var applyMap1 = $ea3eb84de0acf574$export$8952a3dc6f3cd264(dictOrd);
    return {
        bind: function(m) {
            return function(f) {
                return mapMaybeWithKey1(function(k) {
                    var $788 = lookup1(k);
                    return function($789) {
                        return $788(f($789));
                    };
                })(m);
            };
        },
        Apply0: function() {
            return applyMap1;
        }
    };
};
var $ea3eb84de0acf574$export$2fa1dac9e337f670 = function(predicate) {
    var go = function(v) {
        if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return false;
        if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return predicate(v.value2)(v.value3) || go(v.value4) || go(v.value5);
        throw new Error("Failed pattern match at Data.Map.Internal (line 693, column 8 - line 695, column 62): " + [
            v.constructor.name
        ]);
    };
    return go;
};
var $ea3eb84de0acf574$export$4154a199d7d90455 = function(predicate) {
    var go = function(v) {
        if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return false;
        if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return predicate(v.value3) || go(v.value4) || go(v.value5);
        throw new Error("Failed pattern match at Data.Map.Internal (line 683, column 8 - line 685, column 58): " + [
            v.constructor.name
        ]);
    };
    return go;
};
var $ea3eb84de0acf574$export$22a7378e1d3307a4 = function(dictOrd) {
    var compare = $d0PPW.compare(dictOrd);
    return function(f) {
        return function(k) {
            return function(m) {
                var v = $ea3eb84de0acf574$export$9827c6ff7b07c8a4(compare, k, m);
                var v2 = f(v.value0);
                if (v2 instanceof $ykHdR.Nothing) return $ea3eb84de0acf574$export$76d750f4290aa12(v.value1, v.value2);
                if (v2 instanceof $ykHdR.Just) return $ea3eb84de0acf574$export$807b724170e609fd(k, v2.value0, v.value1, v.value2);
                throw new Error("Failed pattern match at Data.Map.Internal (line 514, column 3 - line 518, column 41): " + [
                    v2.constructor.name
                ]);
            };
        };
    };
};
var $ea3eb84de0acf574$export$9030392ec4d635ff = function(dictOrd) {
    return {
        alt: $ea3eb84de0acf574$export$971dd5b0dfd021b6(dictOrd),
        Functor0: function() {
            return $ea3eb84de0acf574$export$3930f636962ed944;
        }
    };
};
var $ea3eb84de0acf574$export$4c085c510196daa3 = function(dictOrd) {
    var altMap1 = $ea3eb84de0acf574$export$9030392ec4d635ff(dictOrd);
    return {
        empty: $ea3eb84de0acf574$export$6e22c362a0406a2c,
        Alt0: function() {
            return altMap1;
        }
    };
};

});

parcelRegister("irO3r", function(module, exports) {

$parcel$export(module.exports, "Alternate", () => $d6e193625ed1395d$export$f120638069846a46);
$parcel$export(module.exports, "monoidAlternate", () => $d6e193625ed1395d$export$6e373ee97dbd5f68);
// Generated by purs version 0.15.16

var $a7Dxq = parcelRequire("a7Dxq");

var $axmEP = parcelRequire("axmEP");

var $3Orkn = parcelRequire("3Orkn");
var $d6e193625ed1395d$export$f120638069846a46 = function(x) {
    return x;
};
var $d6e193625ed1395d$export$f0a5727b2ca16d5e = function(dictShow) {
    var show = $3Orkn.show(dictShow);
    return {
        show: function(v) {
            return "(Alternate " + (show(v) + ")");
        }
    };
};
var $d6e193625ed1395d$export$74ec47bea0d6428d = function(dictAlt) {
    var alt = $a7Dxq.alt(dictAlt);
    return {
        append: function(v) {
            return function(v1) {
                return alt(v)(v1);
            };
        }
    };
};
var $d6e193625ed1395d$export$aa34ebff6fae0aee = function(dictPlus) {
    return dictPlus;
};
var $d6e193625ed1395d$export$19a135ecc0f14c10 = function(dictOrd) {
    return dictOrd;
};
var $d6e193625ed1395d$export$48cb8ce12ac615c3 = function(dictOrd1) {
    return dictOrd1;
};
var $d6e193625ed1395d$export$bbb1334b7c1198d0 = {
    Coercible0: function() {
        return undefined;
    }
};
var $d6e193625ed1395d$export$6e373ee97dbd5f68 = function(dictPlus) {
    var semigroupAlternate1 = $d6e193625ed1395d$export$74ec47bea0d6428d(dictPlus.Alt0());
    return {
        mempty: $axmEP.empty(dictPlus),
        Semigroup0: function() {
            return semigroupAlternate1;
        }
    };
};
var $d6e193625ed1395d$export$748db8accd45ad60 = function(dictMonad) {
    return dictMonad;
};
var $d6e193625ed1395d$export$912ca5da2b71dd9f = function(dictFunctor) {
    return dictFunctor;
};
var $d6e193625ed1395d$export$45877b7cfa857b08 = function(dictExtend) {
    return dictExtend;
};
var $d6e193625ed1395d$export$744ff834b4c5965c = function(dictEq) {
    return dictEq;
};
var $d6e193625ed1395d$export$d92024b57d6b2a3c = function(dictEq1) {
    return dictEq1;
};
var $d6e193625ed1395d$export$eecf6e094270f0ca = function(dictComonad) {
    return dictComonad;
};
var $d6e193625ed1395d$export$d72d6cfff25c7246 = function(dictBounded) {
    return dictBounded;
};
var $d6e193625ed1395d$export$8c4b2dd7bc59a54a = function(dictBind) {
    return dictBind;
};
var $d6e193625ed1395d$export$cddaca6aae5306c4 = function(dictApply) {
    return dictApply;
};
var $d6e193625ed1395d$export$3655a3e6b92e2b2a = function(dictApplicative) {
    return dictApplicative;
};
var $d6e193625ed1395d$export$a428b63860a2744 = function(dictAlternative) {
    return dictAlternative;
};
var $d6e193625ed1395d$export$ca414a3aae651090 = function(dictAlt) {
    return dictAlt;
};

});

parcelRegister("lqMYl", function(module, exports) {

$parcel$export(module.exports, "unOrdBox", () => $f9a2039294f26822$export$6a3ff69c92a20cd2);
$parcel$export(module.exports, "mkOrdBox", () => $f9a2039294f26822$export$c2a88327b4ac50f8);
$parcel$export(module.exports, "ordOrdBox", () => $f9a2039294f26822$export$a4fa2470ead172bd);
// Generated by purs version 0.15.16

var $4MBcA = parcelRequire("4MBcA");

var $d0PPW = parcelRequire("d0PPW");
var $f9a2039294f26822$var$OrdBox = /* #__PURE__ */ function() {
    function OrdBox(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    OrdBox.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new OrdBox(value0, value1, value2);
            };
        };
    };
    return OrdBox;
}();
var $f9a2039294f26822$export$6a3ff69c92a20cd2 = function(v) {
    return v.value2;
};
var $f9a2039294f26822$export$c2a88327b4ac50f8 = function(dictOrd) {
    return $f9a2039294f26822$var$OrdBox.create($4MBcA.eq(dictOrd.Eq0()))($d0PPW.compare(dictOrd));
};
var $f9a2039294f26822$export$1aabb6943cc59794 = {
    eq: function(v) {
        return function(v1) {
            return v.value0(v.value2)(v1.value2);
        };
    }
};
var $f9a2039294f26822$export$a4fa2470ead172bd = {
    compare: function(v) {
        return function(v1) {
            return v.value1(v.value2)(v1.value2);
        };
    },
    Eq0: function() {
        return $f9a2039294f26822$export$1aabb6943cc59794;
    }
};

});


parcelRegister("bllhK", function(module, exports) {

$parcel$export(module.exports, "SubscriptionId", () => $84222ab19bdc98bd$export$f3ce0030ce21b322);
$parcel$export(module.exports, "ForkId", () => $84222ab19bdc98bd$export$77e8fa738093aa8c);
$parcel$export(module.exports, "State", () => $84222ab19bdc98bd$export$7254cc27399e90bd);
$parcel$export(module.exports, "Subscribe", () => $84222ab19bdc98bd$export$b5b6bb8bb5273115);
$parcel$export(module.exports, "Unsubscribe", () => $84222ab19bdc98bd$export$cf424b9d16eab6b0);
$parcel$export(module.exports, "Lift", () => $84222ab19bdc98bd$export$5ba9ac88cb4a4c17);
$parcel$export(module.exports, "ChildQuery", () => $84222ab19bdc98bd$export$c9e0c97aebb96176);
$parcel$export(module.exports, "Raise", () => $84222ab19bdc98bd$export$c97bcbb53b4e15e4);
$parcel$export(module.exports, "Par", () => $84222ab19bdc98bd$export$6e7e621f508eff66);
$parcel$export(module.exports, "Fork", () => $84222ab19bdc98bd$export$8cdfc2927e464854);
$parcel$export(module.exports, "Join", () => $84222ab19bdc98bd$export$26aa7833c998c5d3);
$parcel$export(module.exports, "Kill", () => $84222ab19bdc98bd$export$25e269b2a286b4be);
$parcel$export(module.exports, "GetRef", () => $84222ab19bdc98bd$export$c2ea277386f73da0);
$parcel$export(module.exports, "raise", () => $84222ab19bdc98bd$export$66313c302b2ea154);
$parcel$export(module.exports, "queryAll", () => $84222ab19bdc98bd$export$dcd0d083aa86c355);
$parcel$export(module.exports, "query", () => $84222ab19bdc98bd$export$2fa187e846a241c4);
$parcel$export(module.exports, "ordSubscriptionId", () => $84222ab19bdc98bd$export$2a9fc99fce80131a);
$parcel$export(module.exports, "ordForkId", () => $84222ab19bdc98bd$export$7e953d51c2b3343e);
$parcel$export(module.exports, "monadStateHalogenM", () => $84222ab19bdc98bd$export$87bf621137788b28);
$parcel$export(module.exports, "monadEffectHalogenM", () => $84222ab19bdc98bd$export$aecceb0bc1bf10d9);
$parcel$export(module.exports, "hoist", () => $84222ab19bdc98bd$export$b2cccb4e0928a3a6);
$parcel$export(module.exports, "getRef", () => $84222ab19bdc98bd$export$f0c653cfd7dea798);
$parcel$export(module.exports, "functorHalogenM", () => $84222ab19bdc98bd$export$bf09f5de576f9cf1);
$parcel$export(module.exports, "bindHalogenM", () => $84222ab19bdc98bd$export$172cc2b2b4e6467a);
$parcel$export(module.exports, "applicativeHalogenM", () => $84222ab19bdc98bd$export$be2318e898dcc68);
// Generated by purs version 0.15.16

var $gUTA8 = parcelRequire("gUTA8");

var $iVIp8 = parcelRequire("iVIp8");

var $9Grh5 = parcelRequire("9Grh5");

var $7T8P4 = parcelRequire("7T8P4");

var $84kZf = parcelRequire("84kZf");

var $hV7d0 = parcelRequire("hV7d0");

var $9ZRMq = parcelRequire("9ZRMq");

var $lowBm = parcelRequire("lowBm");

var $3NKEZ = parcelRequire("3NKEZ");

var $2Mmje = parcelRequire("2Mmje");

var $4MBcA = parcelRequire("4MBcA");

var $70sTh = parcelRequire("70sTh");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");

var $k6SBa = parcelRequire("k6SBa");

var $ykHdR = parcelRequire("ykHdR");

var $6PW1p = parcelRequire("6PW1p");

var $d0PPW = parcelRequire("d0PPW");

var $1wR1l = parcelRequire("1wR1l");

var $9MxTl = parcelRequire("9MxTl");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");

var $fHfnu = parcelRequire("fHfnu");

var $kQlZ1 = parcelRequire("kQlZ1");

var $1j54f = parcelRequire("1j54f");

var $1nuum = parcelRequire("1nuum");

var $bhj9Z = parcelRequire("bhj9Z");
var $84222ab19bdc98bd$var$identity = /* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn);
var $84222ab19bdc98bd$var$foldrWithIndex = /* #__PURE__ */ $70sTh.foldrWithIndex($k6SBa.foldableWithIndexMap);
var $84222ab19bdc98bd$var$traverse = /* #__PURE__ */ $1wR1l.traverse($k6SBa.traversableMap);
var $84222ab19bdc98bd$var$slots = /* #__PURE__ */ $1j54f.slots();
var $84222ab19bdc98bd$var$lookup = /* #__PURE__ */ $1j54f.lookup();
var $84222ab19bdc98bd$var$over = /* #__PURE__ */ $6PW1p.over()();
var $84222ab19bdc98bd$var$map = /* #__PURE__ */ $l0wDR.map($bhj9Z.functorEmitter);
var $84222ab19bdc98bd$var$map1 = /* #__PURE__ */ $l0wDR.map($9MxTl.functorTuple);
var $84222ab19bdc98bd$var$lmap = /* #__PURE__ */ $2Mmje.lmap($2Mmje.bifunctorTuple);
var $84222ab19bdc98bd$var$map2 = /* #__PURE__ */ $l0wDR.map($1nuum.functorChildQuery);
var $84222ab19bdc98bd$export$f3ce0030ce21b322 = function(x) {
    return x;
};
var $84222ab19bdc98bd$export$77e8fa738093aa8c = function(x) {
    return x;
};
var $84222ab19bdc98bd$export$7254cc27399e90bd = /* #__PURE__ */ function() {
    function State(value0) {
        this.value0 = value0;
    }
    State.create = function(value0) {
        return new State(value0);
    };
    return State;
}();
var $84222ab19bdc98bd$export$b5b6bb8bb5273115 = /* #__PURE__ */ function() {
    function Subscribe(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Subscribe.create = function(value0) {
        return function(value1) {
            return new Subscribe(value0, value1);
        };
    };
    return Subscribe;
}();
var $84222ab19bdc98bd$export$cf424b9d16eab6b0 = /* #__PURE__ */ function() {
    function Unsubscribe(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Unsubscribe.create = function(value0) {
        return function(value1) {
            return new Unsubscribe(value0, value1);
        };
    };
    return Unsubscribe;
}();
var $84222ab19bdc98bd$export$5ba9ac88cb4a4c17 = /* #__PURE__ */ function() {
    function Lift(value0) {
        this.value0 = value0;
    }
    Lift.create = function(value0) {
        return new Lift(value0);
    };
    return Lift;
}();
var $84222ab19bdc98bd$export$c9e0c97aebb96176 = /* #__PURE__ */ function() {
    function ChildQuery(value0) {
        this.value0 = value0;
    }
    ChildQuery.create = function(value0) {
        return new ChildQuery(value0);
    };
    return ChildQuery;
}();
var $84222ab19bdc98bd$export$c97bcbb53b4e15e4 = /* #__PURE__ */ function() {
    function Raise(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Raise.create = function(value0) {
        return function(value1) {
            return new Raise(value0, value1);
        };
    };
    return Raise;
}();
var $84222ab19bdc98bd$export$6e7e621f508eff66 = /* #__PURE__ */ function() {
    function Par(value0) {
        this.value0 = value0;
    }
    Par.create = function(value0) {
        return new Par(value0);
    };
    return Par;
}();
var $84222ab19bdc98bd$export$8cdfc2927e464854 = /* #__PURE__ */ function() {
    function Fork(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Fork.create = function(value0) {
        return function(value1) {
            return new Fork(value0, value1);
        };
    };
    return Fork;
}();
var $84222ab19bdc98bd$export$26aa7833c998c5d3 = /* #__PURE__ */ function() {
    function Join(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Join.create = function(value0) {
        return function(value1) {
            return new Join(value0, value1);
        };
    };
    return Join;
}();
var $84222ab19bdc98bd$export$25e269b2a286b4be = /* #__PURE__ */ function() {
    function Kill(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Kill.create = function(value0) {
        return function(value1) {
            return new Kill(value0, value1);
        };
    };
    return Kill;
}();
var $84222ab19bdc98bd$export$c2ea277386f73da0 = /* #__PURE__ */ function() {
    function GetRef(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    GetRef.create = function(value0) {
        return function(value1) {
            return new GetRef(value0, value1);
        };
    };
    return GetRef;
}();
var $84222ab19bdc98bd$export$a719947860ecc9c1 = function(x) {
    return x;
};
var $84222ab19bdc98bd$export$9599f158307d5f79 = function(x) {
    return x;
};
var $84222ab19bdc98bd$export$f500693cef883ffd = function(sid) {
    return $hV7d0.liftF(new $84222ab19bdc98bd$export$cf424b9d16eab6b0(sid, $r2HHk.unit));
};
var $84222ab19bdc98bd$export$614bd1e27186eef8 = function(esc) {
    return $hV7d0.liftF(new $84222ab19bdc98bd$export$b5b6bb8bb5273115(esc, $l4M7e.const($r2HHk.unit)));
};
var $84222ab19bdc98bd$export$ec068583843480e7 = function(es) {
    return $hV7d0.liftF(new $84222ab19bdc98bd$export$b5b6bb8bb5273115(function(v) {
        return es;
    }, $84222ab19bdc98bd$var$identity));
};
var $84222ab19bdc98bd$export$24cfcc8b33bdb8e8 = function(dictSemigroup) {
    return $hV7d0.semigroupFree(dictSemigroup);
};
var $84222ab19bdc98bd$export$66313c302b2ea154 = function(o) {
    return $hV7d0.liftF(new $84222ab19bdc98bd$export$c97bcbb53b4e15e4(o, $r2HHk.unit));
};
var $84222ab19bdc98bd$export$dcd0d083aa86c355 = function() {
    return function(dictIsSymbol) {
        var slots1 = $84222ab19bdc98bd$var$slots(dictIsSymbol);
        return function(dictOrd) {
            var slots2 = slots1(dictOrd);
            return function(label) {
                return function(q) {
                    var catMapMaybes = function(dictOrd1) {
                        var insert = $k6SBa.insert(dictOrd1);
                        return $84222ab19bdc98bd$var$foldrWithIndex(function(k) {
                            return function(v) {
                                return function(acc) {
                                    return $ykHdR.maybe(acc)($l4M7e.flip(insert(k))(acc))(v);
                                };
                            };
                        })($k6SBa.empty);
                    };
                    var catMapMaybes1 = catMapMaybes(dictOrd);
                    return $hV7d0.liftF(new $84222ab19bdc98bd$export$c9e0c97aebb96176($1nuum.mkChildQueryBox(new $1nuum.ChildQuery(function(dictApplicative) {
                        var map4 = $l0wDR.map(dictApplicative.Apply0().Functor0());
                        var traverse1 = $84222ab19bdc98bd$var$traverse(dictApplicative);
                        return function(k) {
                            var $173 = map4(catMapMaybes1);
                            var $174 = traverse1(k);
                            var $175 = slots2(label);
                            return function($176) {
                                return $173($174($175($176)));
                            };
                        };
                    }, q, $84222ab19bdc98bd$var$identity))));
                };
            };
        };
    };
};
var $84222ab19bdc98bd$export$2fa187e846a241c4 = function() {
    return function(dictIsSymbol) {
        var lookup1 = $84222ab19bdc98bd$var$lookup(dictIsSymbol);
        return function(dictOrd) {
            var lookup2 = lookup1(dictOrd);
            return function(label) {
                return function(p) {
                    return function(q) {
                        return $hV7d0.liftF(new $84222ab19bdc98bd$export$c9e0c97aebb96176($1nuum.mkChildQueryBox(new $1nuum.ChildQuery(function(dictApplicative) {
                            var pure1 = $gUTA8.pure(dictApplicative);
                            return function(k) {
                                var $177 = $ykHdR.maybe(pure1($ykHdR.Nothing.value))(k);
                                var $178 = lookup2(label)(p);
                                return function($179) {
                                    return $177($178($179));
                                };
                            };
                        }, q, $84222ab19bdc98bd$var$identity))));
                    };
                };
            };
        };
    };
};
var $84222ab19bdc98bd$export$2a9fc99fce80131a = $d0PPW.ordInt;
var $84222ab19bdc98bd$export$7e953d51c2b3343e = $d0PPW.ordInt;
var $84222ab19bdc98bd$export$e0bae42e641783be = {
    Coercible0: function() {
        return undefined;
    }
};
var $84222ab19bdc98bd$export$2b4680b78d507e0e = function(dictMonoid) {
    return $hV7d0.monoidFree(dictMonoid);
};
var $84222ab19bdc98bd$export$a19097d0708c88b2 = {
    lift: function(dictMonad) {
        return function($180) {
            return $84222ab19bdc98bd$export$9599f158307d5f79($hV7d0.liftF($84222ab19bdc98bd$export$5ba9ac88cb4a4c17.create($180)));
        };
    }
};
var $84222ab19bdc98bd$export$a558113f6f2e3f2d = $hV7d0.freeMonad;
var $84222ab19bdc98bd$export$87bf621137788b28 = {
    state: function($181) {
        return $84222ab19bdc98bd$export$9599f158307d5f79($hV7d0.liftF($84222ab19bdc98bd$export$7254cc27399e90bd.create($181)));
    },
    Monad0: function() {
        return $84222ab19bdc98bd$export$a558113f6f2e3f2d;
    }
};
var $84222ab19bdc98bd$export$cf461d6710b3adc = function(dictMonadTell) {
    var Semigroup0 = dictMonadTell.Semigroup0();
    return {
        tell: function() {
            var $182 = $3NKEZ.tell(dictMonadTell);
            return function($183) {
                return $84222ab19bdc98bd$export$9599f158307d5f79($hV7d0.liftF($84222ab19bdc98bd$export$5ba9ac88cb4a4c17.create($182($183))));
            };
        }(),
        Semigroup0: function() {
            return Semigroup0;
        },
        Monad1: function() {
            return $84222ab19bdc98bd$export$a558113f6f2e3f2d;
        }
    };
};
var $84222ab19bdc98bd$export$4671b1f72e4f4ad4 = function(dictMonadThrow) {
    return {
        throwError: function() {
            var $184 = $84kZf.throwError(dictMonadThrow);
            return function($185) {
                return $84222ab19bdc98bd$export$9599f158307d5f79($hV7d0.liftF($84222ab19bdc98bd$export$5ba9ac88cb4a4c17.create($184($185))));
            };
        }(),
        Monad0: function() {
            return $84222ab19bdc98bd$export$a558113f6f2e3f2d;
        }
    };
};
var $84222ab19bdc98bd$export$aecceb0bc1bf10d9 = function(dictMonadEffect) {
    return {
        liftEffect: function() {
            var $186 = $kQlZ1.liftEffect(dictMonadEffect);
            return function($187) {
                return $84222ab19bdc98bd$export$9599f158307d5f79($hV7d0.liftF($84222ab19bdc98bd$export$5ba9ac88cb4a4c17.create($186($187))));
            };
        }(),
        Monad0: function() {
            return $84222ab19bdc98bd$export$a558113f6f2e3f2d;
        }
    };
};
var $84222ab19bdc98bd$export$8feaa16df4090813 = function(dictMonadAsk) {
    return {
        ask: $hV7d0.liftF(new $84222ab19bdc98bd$export$5ba9ac88cb4a4c17($9ZRMq.ask(dictMonadAsk))),
        Monad0: function() {
            return $84222ab19bdc98bd$export$a558113f6f2e3f2d;
        }
    };
};
var $84222ab19bdc98bd$export$6f4dec227404555 = function(dictMonadAff) {
    var monadEffectHalogenM1 = $84222ab19bdc98bd$export$aecceb0bc1bf10d9(dictMonadAff.MonadEffect0());
    return {
        liftAff: function() {
            var $188 = $fHfnu.liftAff(dictMonadAff);
            return function($189) {
                return $84222ab19bdc98bd$export$9599f158307d5f79($hV7d0.liftF($84222ab19bdc98bd$export$5ba9ac88cb4a4c17.create($188($189))));
            };
        }(),
        MonadEffect0: function() {
            return monadEffectHalogenM1;
        }
    };
};
var $84222ab19bdc98bd$export$88e5a30f85fcd860 = function(f) {
    return function(v) {
        var go = function(v1) {
            if (v1 instanceof $84222ab19bdc98bd$export$7254cc27399e90bd) return new $84222ab19bdc98bd$export$7254cc27399e90bd(v1.value0);
            if (v1 instanceof $84222ab19bdc98bd$export$b5b6bb8bb5273115) return new $84222ab19bdc98bd$export$b5b6bb8bb5273115(v1.value0, v1.value1);
            if (v1 instanceof $84222ab19bdc98bd$export$cf424b9d16eab6b0) return new $84222ab19bdc98bd$export$cf424b9d16eab6b0(v1.value0, v1.value1);
            if (v1 instanceof $84222ab19bdc98bd$export$5ba9ac88cb4a4c17) return new $84222ab19bdc98bd$export$5ba9ac88cb4a4c17(v1.value0);
            if (v1 instanceof $84222ab19bdc98bd$export$c9e0c97aebb96176) return new $84222ab19bdc98bd$export$c9e0c97aebb96176(v1.value0);
            if (v1 instanceof $84222ab19bdc98bd$export$c97bcbb53b4e15e4) return new $84222ab19bdc98bd$export$c97bcbb53b4e15e4(f(v1.value0), v1.value1);
            if (v1 instanceof $84222ab19bdc98bd$export$6e7e621f508eff66) return new $84222ab19bdc98bd$export$6e7e621f508eff66($84222ab19bdc98bd$var$over($84222ab19bdc98bd$export$a719947860ecc9c1)($iVIp8.hoistFreeAp($84222ab19bdc98bd$export$88e5a30f85fcd860(f)))(v1.value0));
            if (v1 instanceof $84222ab19bdc98bd$export$8cdfc2927e464854) return new $84222ab19bdc98bd$export$8cdfc2927e464854($84222ab19bdc98bd$export$88e5a30f85fcd860(f)(v1.value0), v1.value1);
            if (v1 instanceof $84222ab19bdc98bd$export$26aa7833c998c5d3) return new $84222ab19bdc98bd$export$26aa7833c998c5d3(v1.value0, v1.value1);
            if (v1 instanceof $84222ab19bdc98bd$export$25e269b2a286b4be) return new $84222ab19bdc98bd$export$25e269b2a286b4be(v1.value0, v1.value1);
            if (v1 instanceof $84222ab19bdc98bd$export$c2ea277386f73da0) return new $84222ab19bdc98bd$export$c2ea277386f73da0(v1.value0, v1.value1);
            throw new Error("Failed pattern match at Halogen.Query.HalogenM (line 290, column 8 - line 301, column 29): " + [
                v1.constructor.name
            ]);
        };
        return $hV7d0.hoistFree(go)(v);
    };
};
var $84222ab19bdc98bd$export$77c80fee367384a1 = function(dictFunctor) {
    return function(f) {
        return function(v) {
            var go = function(v1) {
                if (v1 instanceof $84222ab19bdc98bd$export$7254cc27399e90bd) return new $84222ab19bdc98bd$export$7254cc27399e90bd(v1.value0);
                if (v1 instanceof $84222ab19bdc98bd$export$b5b6bb8bb5273115) return new $84222ab19bdc98bd$export$b5b6bb8bb5273115(function() {
                    var $190 = $84222ab19bdc98bd$var$map(f);
                    return function($191) {
                        return $190(v1.value0($191));
                    };
                }(), v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$cf424b9d16eab6b0) return new $84222ab19bdc98bd$export$cf424b9d16eab6b0(v1.value0, v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$5ba9ac88cb4a4c17) return new $84222ab19bdc98bd$export$5ba9ac88cb4a4c17(v1.value0);
                if (v1 instanceof $84222ab19bdc98bd$export$c9e0c97aebb96176) return new $84222ab19bdc98bd$export$c9e0c97aebb96176(v1.value0);
                if (v1 instanceof $84222ab19bdc98bd$export$c97bcbb53b4e15e4) return new $84222ab19bdc98bd$export$c97bcbb53b4e15e4(v1.value0, v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$6e7e621f508eff66) return new $84222ab19bdc98bd$export$6e7e621f508eff66($84222ab19bdc98bd$var$over($84222ab19bdc98bd$export$a719947860ecc9c1)($iVIp8.hoistFreeAp($84222ab19bdc98bd$export$77c80fee367384a1(dictFunctor)(f)))(v1.value0));
                if (v1 instanceof $84222ab19bdc98bd$export$8cdfc2927e464854) return new $84222ab19bdc98bd$export$8cdfc2927e464854($84222ab19bdc98bd$export$77c80fee367384a1(dictFunctor)(f)(v1.value0), v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$26aa7833c998c5d3) return new $84222ab19bdc98bd$export$26aa7833c998c5d3(v1.value0, v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$25e269b2a286b4be) return new $84222ab19bdc98bd$export$25e269b2a286b4be(v1.value0, v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$c2ea277386f73da0) return new $84222ab19bdc98bd$export$c2ea277386f73da0(v1.value0, v1.value1);
                throw new Error("Failed pattern match at Halogen.Query.HalogenM (line 269, column 8 - line 280, column 29): " + [
                    v1.constructor.name
                ]);
            };
            return $hV7d0.hoistFree(go)(v);
        };
    };
};
var $84222ab19bdc98bd$export$dfdb508572caf3d7 = function(fid) {
    return $hV7d0.liftF(new $84222ab19bdc98bd$export$25e269b2a286b4be(fid, $r2HHk.unit));
};
var $84222ab19bdc98bd$export$f7e2c8231c57a8bd = function(fid) {
    return $hV7d0.liftF(new $84222ab19bdc98bd$export$26aa7833c998c5d3(fid, $r2HHk.unit));
};
var $84222ab19bdc98bd$export$d4721e7c31d91ccb = function(f) {
    return function(f$prime) {
        return function(v) {
            var go = function(v1) {
                if (v1 instanceof $84222ab19bdc98bd$export$7254cc27399e90bd) return new $84222ab19bdc98bd$export$7254cc27399e90bd(function() {
                    var $192 = $84222ab19bdc98bd$var$map1(f);
                    return function($193) {
                        return $192(v1.value0(f$prime($193)));
                    };
                }());
                if (v1 instanceof $84222ab19bdc98bd$export$b5b6bb8bb5273115) return new $84222ab19bdc98bd$export$b5b6bb8bb5273115(v1.value0, v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$cf424b9d16eab6b0) return new $84222ab19bdc98bd$export$cf424b9d16eab6b0(v1.value0, v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$5ba9ac88cb4a4c17) return new $84222ab19bdc98bd$export$5ba9ac88cb4a4c17(v1.value0);
                if (v1 instanceof $84222ab19bdc98bd$export$c9e0c97aebb96176) return new $84222ab19bdc98bd$export$c9e0c97aebb96176(v1.value0);
                if (v1 instanceof $84222ab19bdc98bd$export$c97bcbb53b4e15e4) return new $84222ab19bdc98bd$export$c97bcbb53b4e15e4(v1.value0, v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$6e7e621f508eff66) return new $84222ab19bdc98bd$export$6e7e621f508eff66($84222ab19bdc98bd$var$over($84222ab19bdc98bd$export$a719947860ecc9c1)($iVIp8.hoistFreeAp($84222ab19bdc98bd$export$d4721e7c31d91ccb(f)(f$prime)))(v1.value0));
                if (v1 instanceof $84222ab19bdc98bd$export$8cdfc2927e464854) return new $84222ab19bdc98bd$export$8cdfc2927e464854($84222ab19bdc98bd$export$d4721e7c31d91ccb(f)(f$prime)(v1.value0), v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$26aa7833c998c5d3) return new $84222ab19bdc98bd$export$26aa7833c998c5d3(v1.value0, v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$25e269b2a286b4be) return new $84222ab19bdc98bd$export$25e269b2a286b4be(v1.value0, v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$c2ea277386f73da0) return new $84222ab19bdc98bd$export$c2ea277386f73da0(v1.value0, v1.value1);
                throw new Error("Failed pattern match at Halogen.Query.HalogenM (line 247, column 8 - line 258, column 29): " + [
                    v1.constructor.name
                ]);
            };
            return $hV7d0.hoistFree(go)(v);
        };
    };
};
var $84222ab19bdc98bd$export$b2cccb4e0928a3a6 = function(dictFunctor) {
    return function(nat) {
        return function(v) {
            var go = function(v1) {
                if (v1 instanceof $84222ab19bdc98bd$export$7254cc27399e90bd) return new $84222ab19bdc98bd$export$7254cc27399e90bd(v1.value0);
                if (v1 instanceof $84222ab19bdc98bd$export$b5b6bb8bb5273115) return new $84222ab19bdc98bd$export$b5b6bb8bb5273115(v1.value0, v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$cf424b9d16eab6b0) return new $84222ab19bdc98bd$export$cf424b9d16eab6b0(v1.value0, v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$5ba9ac88cb4a4c17) return new $84222ab19bdc98bd$export$5ba9ac88cb4a4c17(nat(v1.value0));
                if (v1 instanceof $84222ab19bdc98bd$export$c9e0c97aebb96176) return new $84222ab19bdc98bd$export$c9e0c97aebb96176(v1.value0);
                if (v1 instanceof $84222ab19bdc98bd$export$c97bcbb53b4e15e4) return new $84222ab19bdc98bd$export$c97bcbb53b4e15e4(v1.value0, v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$6e7e621f508eff66) return new $84222ab19bdc98bd$export$6e7e621f508eff66($84222ab19bdc98bd$var$over($84222ab19bdc98bd$export$a719947860ecc9c1)($iVIp8.hoistFreeAp($84222ab19bdc98bd$export$b2cccb4e0928a3a6(dictFunctor)(nat)))(v1.value0));
                if (v1 instanceof $84222ab19bdc98bd$export$8cdfc2927e464854) return new $84222ab19bdc98bd$export$8cdfc2927e464854($84222ab19bdc98bd$export$b2cccb4e0928a3a6(dictFunctor)(nat)(v1.value0), v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$26aa7833c998c5d3) return new $84222ab19bdc98bd$export$26aa7833c998c5d3(v1.value0, v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$25e269b2a286b4be) return new $84222ab19bdc98bd$export$25e269b2a286b4be(v1.value0, v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$c2ea277386f73da0) return new $84222ab19bdc98bd$export$c2ea277386f73da0(v1.value0, v1.value1);
                throw new Error("Failed pattern match at Halogen.Query.HalogenM (line 312, column 8 - line 323, column 29): " + [
                    v1.constructor.name
                ]);
            };
            return $hV7d0.hoistFree(go)(v);
        };
    };
};
var $84222ab19bdc98bd$export$f0c653cfd7dea798 = function(p) {
    return $hV7d0.liftF(new $84222ab19bdc98bd$export$c2ea277386f73da0(p, $84222ab19bdc98bd$var$identity));
};
var $84222ab19bdc98bd$export$bf09f5de576f9cf1 = $hV7d0.freeFunctor;
var $84222ab19bdc98bd$export$e670701c689a627c = $iVIp8.functorFreeAp;
var $84222ab19bdc98bd$var$map3 = /* #__PURE__ */ $l0wDR.map($84222ab19bdc98bd$export$e670701c689a627c);
var $84222ab19bdc98bd$export$12e8711db3d90a36 = function(dictFunctor) {
    var map4 = $l0wDR.map(dictFunctor);
    return {
        map: function(f) {
            return function(v) {
                if (v instanceof $84222ab19bdc98bd$export$7254cc27399e90bd) return new $84222ab19bdc98bd$export$7254cc27399e90bd(function() {
                    var $194 = $84222ab19bdc98bd$var$lmap(f);
                    return function($195) {
                        return $194(v.value0($195));
                    };
                }());
                if (v instanceof $84222ab19bdc98bd$export$b5b6bb8bb5273115) return new $84222ab19bdc98bd$export$b5b6bb8bb5273115(v.value0, function($196) {
                    return f(v.value1($196));
                });
                if (v instanceof $84222ab19bdc98bd$export$cf424b9d16eab6b0) return new $84222ab19bdc98bd$export$cf424b9d16eab6b0(v.value0, f(v.value1));
                if (v instanceof $84222ab19bdc98bd$export$5ba9ac88cb4a4c17) return new $84222ab19bdc98bd$export$5ba9ac88cb4a4c17(map4(f)(v.value0));
                if (v instanceof $84222ab19bdc98bd$export$c9e0c97aebb96176) return new $84222ab19bdc98bd$export$c9e0c97aebb96176($84222ab19bdc98bd$var$map2(f)(v.value0));
                if (v instanceof $84222ab19bdc98bd$export$c97bcbb53b4e15e4) return new $84222ab19bdc98bd$export$c97bcbb53b4e15e4(v.value0, f(v.value1));
                if (v instanceof $84222ab19bdc98bd$export$6e7e621f508eff66) return new $84222ab19bdc98bd$export$6e7e621f508eff66($84222ab19bdc98bd$var$map3(f)(v.value0));
                if (v instanceof $84222ab19bdc98bd$export$8cdfc2927e464854) return new $84222ab19bdc98bd$export$8cdfc2927e464854(v.value0, function($197) {
                    return f(v.value1($197));
                });
                if (v instanceof $84222ab19bdc98bd$export$26aa7833c998c5d3) return new $84222ab19bdc98bd$export$26aa7833c998c5d3(v.value0, f(v.value1));
                if (v instanceof $84222ab19bdc98bd$export$25e269b2a286b4be) return new $84222ab19bdc98bd$export$25e269b2a286b4be(v.value0, f(v.value1));
                if (v instanceof $84222ab19bdc98bd$export$c2ea277386f73da0) return new $84222ab19bdc98bd$export$c2ea277386f73da0(v.value0, function($198) {
                    return f(v.value1($198));
                });
                throw new Error("Failed pattern match at Halogen.Query.HalogenM (line 57, column 11 - line 68, column 37): " + [
                    v.constructor.name
                ]);
            };
        }
    };
};
var $84222ab19bdc98bd$export$7a5058c6b79333e0 = function(hmu) {
    return $hV7d0.liftF(new $84222ab19bdc98bd$export$8cdfc2927e464854(hmu, $84222ab19bdc98bd$var$identity));
};
var $84222ab19bdc98bd$export$5e41ee1c67709c46 = $4MBcA.eqInt;
var $84222ab19bdc98bd$export$5d7b8e78e43e2e55 = $4MBcA.eqInt;
var $84222ab19bdc98bd$export$172cc2b2b4e6467a = $hV7d0.freeBind;
var $84222ab19bdc98bd$var$bind = /* #__PURE__ */ $9Grh5.bind($84222ab19bdc98bd$export$172cc2b2b4e6467a);
var $84222ab19bdc98bd$export$728fdd75cbe6b202 = $hV7d0.freeApply;
var $84222ab19bdc98bd$export$86681bd6e5a32e67 = $iVIp8.applyFreeAp;
var $84222ab19bdc98bd$export$c43a5691f7e31126 = {
    parallel: function($199) {
        return $84222ab19bdc98bd$export$a719947860ecc9c1($iVIp8.liftFreeAp($199));
    },
    sequential: function($200) {
        return $84222ab19bdc98bd$export$9599f158307d5f79($hV7d0.liftF($84222ab19bdc98bd$export$6e7e621f508eff66.create($200)));
    },
    Apply0: function() {
        return $84222ab19bdc98bd$export$728fdd75cbe6b202;
    },
    Apply1: function() {
        return $84222ab19bdc98bd$export$86681bd6e5a32e67;
    }
};
var $84222ab19bdc98bd$export$be2318e898dcc68 = $hV7d0.freeApplicative;
var $84222ab19bdc98bd$var$pure = /* #__PURE__ */ $gUTA8.pure($84222ab19bdc98bd$export$be2318e898dcc68);
var $84222ab19bdc98bd$export$5cb2ea25322ba73e = {
    tailRecM: function(k) {
        return function(a) {
            return $84222ab19bdc98bd$var$bind(k(a))(function(v) {
                if (v instanceof $lowBm.Loop) return $lowBm.tailRecM($84222ab19bdc98bd$export$5cb2ea25322ba73e)(k)(v.value0);
                if (v instanceof $lowBm.Done) return $84222ab19bdc98bd$var$pure(v.value0);
                throw new Error("Failed pattern match at Halogen.Query.HalogenM (line 105, column 26 - line 107, column 21): " + [
                    v.constructor.name
                ]);
            });
        };
    },
    Monad0: function() {
        return $84222ab19bdc98bd$export$a558113f6f2e3f2d;
    }
};
var $84222ab19bdc98bd$export$a8dcf11c663b5a8c = $iVIp8.applicativeFreeAp;

});
parcelRegister("iVIp8", function(module, exports) {

$parcel$export(module.exports, "liftFreeAp", () => $dc7ffeabd143829e$export$9f6cb61afbf051fa);
$parcel$export(module.exports, "functorFreeAp", () => $dc7ffeabd143829e$export$a37c0cfb408cb5d9);
$parcel$export(module.exports, "retractFreeAp", () => $dc7ffeabd143829e$export$ab82a8987829bde0);
$parcel$export(module.exports, "applyFreeAp", () => $dc7ffeabd143829e$export$6b0545b2ed7e7da2);
$parcel$export(module.exports, "applicativeFreeAp", () => $dc7ffeabd143829e$export$b8278c4ac41154ad);
$parcel$export(module.exports, "hoistFreeAp", () => $dc7ffeabd143829e$export$2a17b194dc6daf5e);
// Generated by purs version 0.15.16

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $7T8P4 = parcelRequire("7T8P4");

var $1qMIU = parcelRequire("1qMIU");

var $aKY4H = parcelRequire("aKY4H");

var $fZM3T = parcelRequire("fZM3T");

var $amUgg = parcelRequire("amUgg");

var $6PW1p = parcelRequire("6PW1p");

var $2FBb2 = parcelRequire("2FBb2");

var $9MxTl = parcelRequire("9MxTl");
var $dc7ffeabd143829e$var$identity = /* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn);
var $dc7ffeabd143829e$var$unwrap = /* #__PURE__ */ $6PW1p.unwrap();
var $dc7ffeabd143829e$var$Pure = /* #__PURE__ */ function() {
    function Pure(value0) {
        this.value0 = value0;
    }
    Pure.create = function(value0) {
        return new Pure(value0);
    };
    return Pure;
}();
var $dc7ffeabd143829e$var$Lift = /* #__PURE__ */ function() {
    function Lift(value0) {
        this.value0 = value0;
    }
    Lift.create = function(value0) {
        return new Lift(value0);
    };
    return Lift;
}();
var $dc7ffeabd143829e$var$Ap = /* #__PURE__ */ function() {
    function Ap(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Ap.create = function(value0) {
        return function(value1) {
            return new Ap(value0, value1);
        };
    };
    return Ap;
}();
var $dc7ffeabd143829e$var$mkAp = function(fba) {
    return function(fb) {
        return new $dc7ffeabd143829e$var$Ap(fba, fb);
    };
};
var $dc7ffeabd143829e$export$9f6cb61afbf051fa = /* #__PURE__ */ function() {
    return $dc7ffeabd143829e$var$Lift.create;
}();
var $dc7ffeabd143829e$var$goLeft = function(dictApplicative) {
    var pure = $gUTA8.pure(dictApplicative);
    return function(fStack) {
        return function(valStack) {
            return function(nat) {
                return function(func) {
                    return function(count) {
                        if (func instanceof $dc7ffeabd143829e$var$Pure) return new $9MxTl.Tuple(new $amUgg.Cons({
                            func: pure(func.value0),
                            count: count
                        }, fStack), valStack);
                        if (func instanceof $dc7ffeabd143829e$var$Lift) return new $9MxTl.Tuple(new $amUgg.Cons({
                            func: nat(func.value0),
                            count: count
                        }, fStack), valStack);
                        if (func instanceof $dc7ffeabd143829e$var$Ap) return $dc7ffeabd143829e$var$goLeft(dictApplicative)(fStack)($fZM3T.cons(func.value1)(valStack))(nat)(func.value0)(count + 1 | 0);
                        throw new Error("Failed pattern match at Control.Applicative.Free (line 102, column 41 - line 105, column 81): " + [
                            func.constructor.name
                        ]);
                    };
                };
            };
        };
    };
};
var $dc7ffeabd143829e$var$goApply = function(dictApplicative) {
    var apply = $a5g3C.apply(dictApplicative.Apply0());
    return function(fStack) {
        return function(vals) {
            return function(gVal) {
                if (fStack instanceof $amUgg.Nil) return new $aKY4H.Left(gVal);
                if (fStack instanceof $amUgg.Cons) {
                    var gRes = apply(fStack.value0.func)(gVal);
                    var $31 = fStack.value0.count === 1;
                    if ($31) {
                        if (fStack.value1 instanceof $amUgg.Nil) return new $aKY4H.Left(gRes);
                        return $dc7ffeabd143829e$var$goApply(dictApplicative)(fStack.value1)(vals)(gRes);
                    }
                    if (vals instanceof $amUgg.Nil) return new $aKY4H.Left(gRes);
                    if (vals instanceof $amUgg.Cons) return new $aKY4H.Right(new $9MxTl.Tuple(new $amUgg.Cons({
                        func: gRes,
                        count: fStack.value0.count - 1 | 0
                    }, fStack.value1), new $2FBb2.NonEmpty(vals.value0, vals.value1)));
                    throw new Error("Failed pattern match at Control.Applicative.Free (line 83, column 11 - line 88, column 50): " + [
                        vals.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Control.Applicative.Free (line 72, column 3 - line 88, column 50): " + [
                    fStack.constructor.name
                ]);
            };
        };
    };
};
var $dc7ffeabd143829e$export$a37c0cfb408cb5d9 = {
    map: function(f) {
        return function(x) {
            return $dc7ffeabd143829e$var$mkAp(new $dc7ffeabd143829e$var$Pure(f))(x);
        };
    }
};
var $dc7ffeabd143829e$export$952b32e119338067 = function(dictApplicative) {
    var goApply1 = $dc7ffeabd143829e$var$goApply(dictApplicative);
    var pure = $gUTA8.pure(dictApplicative);
    var goLeft1 = $dc7ffeabd143829e$var$goLeft(dictApplicative);
    return function(nat) {
        return function(z) {
            var go = function($copy_v) {
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(v) {
                    if (v.value1.value0 instanceof $dc7ffeabd143829e$var$Pure) {
                        var v1 = goApply1(v.value0)(v.value1.value1)(pure(v.value1.value0.value0));
                        if (v1 instanceof $aKY4H.Left) {
                            $tco_done = true;
                            return v1.value0;
                        }
                        if (v1 instanceof $aKY4H.Right) {
                            $copy_v = v1.value0;
                            return;
                        }
                        throw new Error("Failed pattern match at Control.Applicative.Free (line 54, column 17 - line 56, column 24): " + [
                            v1.constructor.name
                        ]);
                    }
                    if (v.value1.value0 instanceof $dc7ffeabd143829e$var$Lift) {
                        var v1 = goApply1(v.value0)(v.value1.value1)(nat(v.value1.value0.value0));
                        if (v1 instanceof $aKY4H.Left) {
                            $tco_done = true;
                            return v1.value0;
                        }
                        if (v1 instanceof $aKY4H.Right) {
                            $copy_v = v1.value0;
                            return;
                        }
                        throw new Error("Failed pattern match at Control.Applicative.Free (line 57, column 17 - line 59, column 24): " + [
                            v1.constructor.name
                        ]);
                    }
                    if (v.value1.value0 instanceof $dc7ffeabd143829e$var$Ap) {
                        var nextVals = new $2FBb2.NonEmpty(v.value1.value0.value1, v.value1.value1);
                        $copy_v = goLeft1(v.value0)(nextVals)(nat)(v.value1.value0.value0)(1);
                        return;
                    }
                    throw new Error("Failed pattern match at Control.Applicative.Free (line 53, column 5 - line 62, column 47): " + [
                        v.value1.value0.constructor.name
                    ]);
                }
                while(!$tco_done)$tco_result = $tco_loop($copy_v);
                return $tco_result;
            };
            return go(new $9MxTl.Tuple($amUgg.Nil.value, $fZM3T.singleton(z)));
        };
    };
};
var $dc7ffeabd143829e$export$ab82a8987829bde0 = function(dictApplicative) {
    return $dc7ffeabd143829e$export$952b32e119338067(dictApplicative)($dc7ffeabd143829e$var$identity);
};
var $dc7ffeabd143829e$export$6b0545b2ed7e7da2 = {
    apply: function(fba) {
        return function(fb) {
            return $dc7ffeabd143829e$var$mkAp(fba)(fb);
        };
    },
    Functor0: function() {
        return $dc7ffeabd143829e$export$a37c0cfb408cb5d9;
    }
};
var $dc7ffeabd143829e$export$b8278c4ac41154ad = /* #__PURE__ */ function() {
    return {
        pure: $dc7ffeabd143829e$var$Pure.create,
        Apply0: function() {
            return $dc7ffeabd143829e$export$6b0545b2ed7e7da2;
        }
    };
}();
var $dc7ffeabd143829e$var$foldFreeAp1 = /* #__PURE__ */ $dc7ffeabd143829e$export$952b32e119338067($dc7ffeabd143829e$export$b8278c4ac41154ad);
var $dc7ffeabd143829e$export$2a17b194dc6daf5e = function(f) {
    return $dc7ffeabd143829e$var$foldFreeAp1(function($54) {
        return $dc7ffeabd143829e$export$9f6cb61afbf051fa(f($54));
    });
};
var $dc7ffeabd143829e$export$1d298f88ddccfbbf = function(dictMonoid) {
    var foldFreeAp2 = $dc7ffeabd143829e$export$952b32e119338067($1qMIU.applicativeConst(dictMonoid));
    return function(k) {
        var $55 = foldFreeAp2(function($57) {
            return $1qMIU.Const(k($57));
        });
        return function($56) {
            return $dc7ffeabd143829e$var$unwrap($55($56));
        };
    };
};

});

parcelRegister("hV7d0", function(module, exports) {

$parcel$export(module.exports, "runFreeM", () => $d0bd5a116d2d5f24$export$2bd79f4d19aaa2f7);
$parcel$export(module.exports, "resume", () => $d0bd5a116d2d5f24$export$fbb4d68fe60c1629);
$parcel$export(module.exports, "freeMonad", () => $d0bd5a116d2d5f24$export$25ad06f1eebea5a0);
$parcel$export(module.exports, "freeApplicative", () => $d0bd5a116d2d5f24$export$b9ce46e7f510eb18);
$parcel$export(module.exports, "freeBind", () => $d0bd5a116d2d5f24$export$39486fc5c75854c8);
$parcel$export(module.exports, "freeFunctor", () => $d0bd5a116d2d5f24$export$245cefec95375d9a);
$parcel$export(module.exports, "freeApply", () => $d0bd5a116d2d5f24$export$2d6a2fb8bce0f112);
$parcel$export(module.exports, "semigroupFree", () => $d0bd5a116d2d5f24$export$d68567ac4fd5624d);
$parcel$export(module.exports, "liftF", () => $d0bd5a116d2d5f24$export$8040756fd4c77395);
$parcel$export(module.exports, "monoidFree", () => $d0bd5a116d2d5f24$export$cb3638ab887278d6);
$parcel$export(module.exports, "hoistFree", () => $d0bd5a116d2d5f24$export$9624ed458578c422);
$parcel$export(module.exports, "foldFree", () => $d0bd5a116d2d5f24$export$eb0e66a9104d4874);
// Generated by purs version 0.15.16

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $9Grh5 = parcelRequire("9Grh5");

var $7T8P4 = parcelRequire("7T8P4");

var $ibtPS = parcelRequire("ibtPS");

var $lowBm = parcelRequire("lowBm");

var $4506h = parcelRequire("4506h");

var $aKY4H = parcelRequire("aKY4H");

var $4MBcA = parcelRequire("4MBcA");

var $6RkEA = parcelRequire("6RkEA");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");

var $ykHdR = parcelRequire("ykHdR");

var $aknDF = parcelRequire("aknDF");

var $d0PPW = parcelRequire("d0PPW");

var $6SDUu = parcelRequire("6SDUu");

var $iwqgS = parcelRequire("iwqgS");

var $1wR1l = parcelRequire("1wR1l");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");
var $d0bd5a116d2d5f24$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $d0bd5a116d2d5f24$var$append = /* #__PURE__ */ $iwqgS.append($4506h.semigroupCatList);
var $d0bd5a116d2d5f24$var$map = /* #__PURE__ */ $l0wDR.map($l0wDR.functorFn);
var $d0bd5a116d2d5f24$var$identity = /* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn);
var $d0bd5a116d2d5f24$var$ExpF = function(x) {
    return x;
};
var $d0bd5a116d2d5f24$var$Free = /* #__PURE__ */ function() {
    function Free(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Free.create = function(value0) {
        return function(value1) {
            return new Free(value0, value1);
        };
    };
    return Free;
}();
var $d0bd5a116d2d5f24$var$Return = /* #__PURE__ */ function() {
    function Return(value0) {
        this.value0 = value0;
    }
    Return.create = function(value0) {
        return new Return(value0);
    };
    return Return;
}();
var $d0bd5a116d2d5f24$var$Bind = /* #__PURE__ */ function() {
    function Bind(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Bind.create = function(value0) {
        return function(value1) {
            return new Bind(value0, value1);
        };
    };
    return Bind;
}();
var $d0bd5a116d2d5f24$var$toView = function($copy_v) {
    var $tco_done = false;
    var $tco_result;
    function $tco_loop(v) {
        var runExpF = function(v2) {
            return v2;
        };
        var concatF = function(v2) {
            return function(r) {
                return new $d0bd5a116d2d5f24$var$Free(v2.value0, $d0bd5a116d2d5f24$var$append(v2.value1)(r));
            };
        };
        if (v.value0 instanceof $d0bd5a116d2d5f24$var$Return) {
            var v2 = $4506h.uncons(v.value1);
            if (v2 instanceof $ykHdR.Nothing) {
                $tco_done = true;
                return new $d0bd5a116d2d5f24$var$Return(v.value0.value0);
            }
            if (v2 instanceof $ykHdR.Just) {
                $copy_v = concatF(runExpF(v2.value0.value0)(v.value0.value0))(v2.value0.value1);
                return;
            }
            throw new Error("Failed pattern match at Control.Monad.Free (line 227, column 7 - line 231, column 64): " + [
                v2.constructor.name
            ]);
        }
        if (v.value0 instanceof $d0bd5a116d2d5f24$var$Bind) {
            $tco_done = true;
            return new $d0bd5a116d2d5f24$var$Bind(v.value0.value0, function(a) {
                return concatF(v.value0.value1(a))(v.value1);
            });
        }
        throw new Error("Failed pattern match at Control.Monad.Free (line 225, column 3 - line 233, column 56): " + [
            v.value0.constructor.name
        ]);
    }
    while(!$tco_done)$tco_result = $tco_loop($copy_v);
    return $tco_result;
};
var $d0bd5a116d2d5f24$export$2bd79f4d19aaa2f7 = function(dictFunctor) {
    var map1 = $l0wDR.map(dictFunctor);
    return function(dictMonadRec) {
        var Monad0 = dictMonadRec.Monad0();
        var map2 = $l0wDR.map(Monad0.Bind1().Apply0().Functor0());
        var pure1 = $gUTA8.pure(Monad0.Applicative0());
        var tailRecM = $lowBm.tailRecM(dictMonadRec);
        return function(k) {
            var go = function(f) {
                var v = $d0bd5a116d2d5f24$var$toView(f);
                if (v instanceof $d0bd5a116d2d5f24$var$Return) return map2($lowBm.Done.create)(pure1(v.value0));
                if (v instanceof $d0bd5a116d2d5f24$var$Bind) return map2($lowBm.Loop.create)(k(map1(v.value1)(v.value0)));
                throw new Error("Failed pattern match at Control.Monad.Free (line 194, column 10 - line 196, column 37): " + [
                    v.constructor.name
                ]);
            };
            return tailRecM(go);
        };
    };
};
var $d0bd5a116d2d5f24$export$39b8ebacf8133f4f = function(dictFunctor) {
    var map1 = $l0wDR.map(dictFunctor);
    return function(k) {
        var go = function($copy_f) {
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(f) {
                var v = $d0bd5a116d2d5f24$var$toView(f);
                if (v instanceof $d0bd5a116d2d5f24$var$Return) {
                    $tco_done = true;
                    return v.value0;
                }
                if (v instanceof $d0bd5a116d2d5f24$var$Bind) {
                    $copy_f = k(map1(v.value1)(v.value0));
                    return;
                }
                throw new Error("Failed pattern match at Control.Monad.Free (line 178, column 10 - line 180, column 33): " + [
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($copy_f);
            return $tco_result;
        };
        return go;
    };
};
var $d0bd5a116d2d5f24$export$a7b5be099b56a644 = function(k) {
    return function(j) {
        return function(f) {
            var v = $d0bd5a116d2d5f24$var$toView(f);
            if (v instanceof $d0bd5a116d2d5f24$var$Return) return j(v.value0);
            if (v instanceof $d0bd5a116d2d5f24$var$Bind) return k(v.value0)(v.value1);
            throw new Error("Failed pattern match at Control.Monad.Free (line 213, column 17 - line 215, column 20): " + [
                v.constructor.name
            ]);
        };
    };
};
var $d0bd5a116d2d5f24$export$fbb4d68fe60c1629 = function(dictFunctor) {
    var map1 = $l0wDR.map(dictFunctor);
    return $d0bd5a116d2d5f24$export$a7b5be099b56a644(function(g) {
        return function(i) {
            return new $aKY4H.Left(map1(i)(g));
        };
    })($aKY4H.Right.create);
};
var $d0bd5a116d2d5f24$var$fromView = function(f) {
    return new $d0bd5a116d2d5f24$var$Free(f, $4506h.empty);
};
var $d0bd5a116d2d5f24$export$4997ffc0176396a6 = function(f) {
    return $d0bd5a116d2d5f24$var$fromView(new $d0bd5a116d2d5f24$var$Bind(f, $eOrGk.unsafeCoerce));
};
var $d0bd5a116d2d5f24$export$7c20f42c1b2b8c79 = function(dictApplicative) {
    var pure1 = $gUTA8.pure(dictApplicative);
    return function(f) {
        return $d0bd5a116d2d5f24$export$4997ffc0176396a6(pure1(f));
    };
};
var $d0bd5a116d2d5f24$export$25ad06f1eebea5a0 = {
    Applicative0: function() {
        return $d0bd5a116d2d5f24$export$b9ce46e7f510eb18;
    },
    Bind1: function() {
        return $d0bd5a116d2d5f24$export$39486fc5c75854c8;
    }
};
var $d0bd5a116d2d5f24$export$245cefec95375d9a = {
    map: function(k) {
        return function(f) {
            return $9Grh5.bindFlipped($d0bd5a116d2d5f24$export$39486fc5c75854c8)(function() {
                var $189 = $gUTA8.pure($d0bd5a116d2d5f24$export$b9ce46e7f510eb18);
                return function($190) {
                    return $189(k($190));
                };
            }())(f);
        };
    }
};
var $d0bd5a116d2d5f24$export$39486fc5c75854c8 = {
    bind: function(v) {
        return function(k) {
            return new $d0bd5a116d2d5f24$var$Free(v.value0, $4506h.snoc(v.value1)(k));
        };
    },
    Apply0: function() {
        return $d0bd5a116d2d5f24$var$$lazy_freeApply(0);
    }
};
var $d0bd5a116d2d5f24$export$b9ce46e7f510eb18 = {
    pure: function($191) {
        return $d0bd5a116d2d5f24$var$fromView($d0bd5a116d2d5f24$var$Return.create($191));
    },
    Apply0: function() {
        return $d0bd5a116d2d5f24$var$$lazy_freeApply(0);
    }
};
var $d0bd5a116d2d5f24$var$$lazy_freeApply = /* #__PURE__ */ $d0bd5a116d2d5f24$var$$runtime_lazy("freeApply", "Control.Monad.Free", function() {
    return {
        apply: $ibtPS.ap($d0bd5a116d2d5f24$export$25ad06f1eebea5a0),
        Functor0: function() {
            return $d0bd5a116d2d5f24$export$245cefec95375d9a;
        }
    };
});
var $d0bd5a116d2d5f24$export$2d6a2fb8bce0f112 = /* #__PURE__ */ $d0bd5a116d2d5f24$var$$lazy_freeApply(77);
var $d0bd5a116d2d5f24$var$lift2 = /* #__PURE__ */ $a5g3C.lift2($d0bd5a116d2d5f24$export$2d6a2fb8bce0f112);
var $d0bd5a116d2d5f24$var$bind = /* #__PURE__ */ $9Grh5.bind($d0bd5a116d2d5f24$export$39486fc5c75854c8);
var $d0bd5a116d2d5f24$var$pure = /* #__PURE__ */ $gUTA8.pure($d0bd5a116d2d5f24$export$b9ce46e7f510eb18);
var $d0bd5a116d2d5f24$var$join = /* #__PURE__ */ $9Grh5.join($d0bd5a116d2d5f24$export$39486fc5c75854c8);
var $d0bd5a116d2d5f24$export$d68567ac4fd5624d = function(dictSemigroup) {
    return {
        append: $d0bd5a116d2d5f24$var$lift2($iwqgS.append(dictSemigroup))
    };
};
var $d0bd5a116d2d5f24$export$b3d357ba4a1dabd2 = {
    tailRecM: function(k) {
        return function(a) {
            return $d0bd5a116d2d5f24$var$bind(k(a))(function(v) {
                if (v instanceof $lowBm.Loop) return $lowBm.tailRecM($d0bd5a116d2d5f24$export$b3d357ba4a1dabd2)(k)(v.value0);
                if (v instanceof $lowBm.Done) return $d0bd5a116d2d5f24$var$pure(v.value0);
                throw new Error("Failed pattern match at Control.Monad.Free (line 86, column 26 - line 88, column 21): " + [
                    v.constructor.name
                ]);
            });
        };
    },
    Monad0: function() {
        return $d0bd5a116d2d5f24$export$25ad06f1eebea5a0;
    }
};
var $d0bd5a116d2d5f24$export$8040756fd4c77395 = function(f) {
    return $d0bd5a116d2d5f24$var$fromView(new $d0bd5a116d2d5f24$var$Bind(f, function($192) {
        return $d0bd5a116d2d5f24$var$pure($192);
    }));
};
var $d0bd5a116d2d5f24$export$5eeb2de8b5f5121f = {
    lift: function(dictMonad) {
        return $d0bd5a116d2d5f24$export$8040756fd4c77395;
    }
};
var $d0bd5a116d2d5f24$export$cb3638ab887278d6 = function(dictMonoid) {
    var semigroupFree1 = $d0bd5a116d2d5f24$export$d68567ac4fd5624d(dictMonoid.Semigroup0());
    return {
        mempty: $d0bd5a116d2d5f24$var$pure($aknDF.mempty(dictMonoid)),
        Semigroup0: function() {
            return semigroupFree1;
        }
    };
};
var $d0bd5a116d2d5f24$export$d6dbe5e3073f84e = function(k) {
    var go = function(f) {
        var v = $d0bd5a116d2d5f24$var$toView(f);
        if (v instanceof $d0bd5a116d2d5f24$var$Return) return $d0bd5a116d2d5f24$var$pure(v.value0);
        if (v instanceof $d0bd5a116d2d5f24$var$Bind) return $d0bd5a116d2d5f24$var$bind(k(v.value0))($d0bd5a116d2d5f24$var$map(go)(v.value1));
        throw new Error("Failed pattern match at Control.Monad.Free (line 168, column 10 - line 170, column 33): " + [
            v.constructor.name
        ]);
    };
    return go;
};
var $d0bd5a116d2d5f24$export$9624ed458578c422 = function(k) {
    return $d0bd5a116d2d5f24$export$d6dbe5e3073f84e(function($193) {
        return $d0bd5a116d2d5f24$export$8040756fd4c77395(k($193));
    });
};
var $d0bd5a116d2d5f24$export$7bf6537c73f09eab = function(dictFunctor) {
    var resume1 = $d0bd5a116d2d5f24$export$fbb4d68fe60c1629(dictFunctor);
    return function(dictFoldable) {
        var foldMap = $6RkEA.foldMap(dictFoldable);
        var foldl = $6RkEA.foldl(dictFoldable);
        var foldr = $6RkEA.foldr(dictFoldable);
        return {
            foldMap: function(dictMonoid) {
                var foldMap1 = foldMap(dictMonoid);
                return function(f) {
                    var $lazy_go = $d0bd5a116d2d5f24$var$$runtime_lazy("go", "Control.Monad.Free", function() {
                        return function($194) {
                            return function(v) {
                                if (v instanceof $aKY4H.Left) return foldMap1($lazy_go(94))(v.value0);
                                if (v instanceof $aKY4H.Right) return f(v.value0);
                                throw new Error("Failed pattern match at Control.Monad.Free (line 93, column 21 - line 95, column 21): " + [
                                    v.constructor.name
                                ]);
                            }(resume1($194));
                        };
                    });
                    var go = $lazy_go(93);
                    return go;
                };
            },
            foldl: function(f) {
                var go = function(r) {
                    return function($195) {
                        return function(v) {
                            if (v instanceof $aKY4H.Left) return foldl(go)(r)(v.value0);
                            if (v instanceof $aKY4H.Right) return f(r)(v.value0);
                            throw new Error("Failed pattern match at Control.Monad.Free (line 98, column 23 - line 100, column 23): " + [
                                v.constructor.name
                            ]);
                        }(resume1($195));
                    };
                };
                return go;
            },
            foldr: function(f) {
                var go = function(r) {
                    return function($196) {
                        return function(v) {
                            if (v instanceof $aKY4H.Left) return foldr($l4M7e.flip(go))(r)(v.value0);
                            if (v instanceof $aKY4H.Right) return f(v.value0)(r);
                            throw new Error("Failed pattern match at Control.Monad.Free (line 103, column 23 - line 105, column 23): " + [
                                v.constructor.name
                            ]);
                        }(resume1($196));
                    };
                };
                return go;
            }
        };
    };
};
var $d0bd5a116d2d5f24$export$816b93e586e4c75c = function(dictTraversable) {
    var Functor0 = dictTraversable.Functor0();
    var resume1 = $d0bd5a116d2d5f24$export$fbb4d68fe60c1629(Functor0);
    var traverse = $1wR1l.traverse(dictTraversable);
    var foldableFree1 = $d0bd5a116d2d5f24$export$7bf6537c73f09eab(Functor0)(dictTraversable.Foldable1());
    return {
        traverse: function(dictApplicative) {
            var map1 = $l0wDR.map(dictApplicative.Apply0().Functor0());
            var traverse1 = traverse(dictApplicative);
            return function(f) {
                var $lazy_go = $d0bd5a116d2d5f24$var$$runtime_lazy("go", "Control.Monad.Free", function() {
                    return function($197) {
                        return function(v) {
                            if (v instanceof $aKY4H.Left) return map1(function($198) {
                                return $d0bd5a116d2d5f24$var$join($d0bd5a116d2d5f24$export$8040756fd4c77395($198));
                            })(traverse1($lazy_go(111))(v.value0));
                            if (v instanceof $aKY4H.Right) return map1($d0bd5a116d2d5f24$var$pure)(f(v.value0));
                            throw new Error("Failed pattern match at Control.Monad.Free (line 110, column 21 - line 112, column 30): " + [
                                v.constructor.name
                            ]);
                        }(resume1($197));
                    };
                });
                var go = $lazy_go(110);
                return go;
            };
        },
        sequence: function(dictApplicative) {
            return function(tma) {
                return $1wR1l.traverse($d0bd5a116d2d5f24$export$816b93e586e4c75c(dictTraversable))(dictApplicative)($d0bd5a116d2d5f24$var$identity)(tma);
            };
        },
        Functor0: function() {
            return $d0bd5a116d2d5f24$export$245cefec95375d9a;
        },
        Foldable1: function() {
            return foldableFree1;
        }
    };
};
var $d0bd5a116d2d5f24$export$eb0e66a9104d4874 = function(dictMonadRec) {
    var Monad0 = dictMonadRec.Monad0();
    var map1 = $l0wDR.map(Monad0.Bind1().Apply0().Functor0());
    var pure1 = $gUTA8.pure(Monad0.Applicative0());
    var tailRecM = $lowBm.tailRecM(dictMonadRec);
    return function(k) {
        var go = function(f) {
            var v = $d0bd5a116d2d5f24$var$toView(f);
            if (v instanceof $d0bd5a116d2d5f24$var$Return) return map1($lowBm.Done.create)(pure1(v.value0));
            if (v instanceof $d0bd5a116d2d5f24$var$Bind) return map1(function($199) {
                return $lowBm.Loop.create(v.value1($199));
            })(k(v.value0));
            throw new Error("Failed pattern match at Control.Monad.Free (line 158, column 10 - line 160, column 37): " + [
                v.constructor.name
            ]);
        };
        return tailRecM(go);
    };
};
var $d0bd5a116d2d5f24$export$14742287b71545dd = function(dictFunctor) {
    var resume1 = $d0bd5a116d2d5f24$export$fbb4d68fe60c1629(dictFunctor);
    return function(dictEq1) {
        var eq1 = $4MBcA.eq1(dictEq1);
        return function(dictEq) {
            var eq = $4MBcA.eq(dictEq);
            return {
                eq: function(x) {
                    return function(y) {
                        var v = resume1(y);
                        var v1 = resume1(x);
                        if (v1 instanceof $aKY4H.Left && v instanceof $aKY4H.Left) return eq1($d0bd5a116d2d5f24$export$14742287b71545dd(dictFunctor)(dictEq1)(dictEq))(v1.value0)(v.value0);
                        if (v1 instanceof $aKY4H.Right && v instanceof $aKY4H.Right) return eq(v1.value0)(v.value0);
                        return false;
                    };
                }
            };
        };
    };
};
var $d0bd5a116d2d5f24$export$10be470239ca56c7 = function(dictFunctor) {
    var resume1 = $d0bd5a116d2d5f24$export$fbb4d68fe60c1629(dictFunctor);
    var eqFree1 = $d0bd5a116d2d5f24$export$14742287b71545dd(dictFunctor);
    return function(dictOrd1) {
        var compare1 = $d0PPW.compare1(dictOrd1);
        var eqFree2 = eqFree1(dictOrd1.Eq10());
        return function(dictOrd) {
            var compare = $d0PPW.compare(dictOrd);
            var eqFree3 = eqFree2(dictOrd.Eq0());
            return {
                compare: function(x) {
                    return function(y) {
                        var v = resume1(y);
                        var v1 = resume1(x);
                        if (v1 instanceof $aKY4H.Left && v instanceof $aKY4H.Left) return compare1($d0bd5a116d2d5f24$export$10be470239ca56c7(dictFunctor)(dictOrd1)(dictOrd))(v1.value0)(v.value0);
                        if (v1 instanceof $aKY4H.Left) return $6SDUu.LT.value;
                        if (v instanceof $aKY4H.Left) return $6SDUu.GT.value;
                        if (v1 instanceof $aKY4H.Right && v instanceof $aKY4H.Right) return compare(v1.value0)(v.value0);
                        throw new Error("Failed pattern match at Control.Monad.Free (line 56, column 17 - line 60, column 36): " + [
                            v1.constructor.name,
                            v.constructor.name
                        ]);
                    };
                },
                Eq0: function() {
                    return eqFree3;
                }
            };
        };
    };
};
var $d0bd5a116d2d5f24$export$269c49b8f4785316 = function(dictFunctor) {
    var eqFree1 = $d0bd5a116d2d5f24$export$14742287b71545dd(dictFunctor);
    return function(dictEq1) {
        var eqFree2 = eqFree1(dictEq1);
        return {
            eq1: function(dictEq) {
                return $4MBcA.eq(eqFree2(dictEq));
            }
        };
    };
};
var $d0bd5a116d2d5f24$export$915c63020dce06b2 = function(dictFunctor) {
    var ordFree1 = $d0bd5a116d2d5f24$export$10be470239ca56c7(dictFunctor);
    var eq1Free1 = $d0bd5a116d2d5f24$export$269c49b8f4785316(dictFunctor);
    return function(dictOrd1) {
        var ordFree2 = ordFree1(dictOrd1);
        var eq1Free2 = eq1Free1(dictOrd1.Eq10());
        return {
            compare1: function(dictOrd) {
                return $d0PPW.compare(ordFree2(dictOrd));
            },
            Eq10: function() {
                return eq1Free2;
            }
        };
    };
};

});
parcelRegister("4506h", function(module, exports) {

$parcel$export(module.exports, "uncons", () => $2f87b4fe4d8f7a0f$export$b446f6baa3bb1430);
$parcel$export(module.exports, "empty", () => $2f87b4fe4d8f7a0f$export$6e22c362a0406a2c);
$parcel$export(module.exports, "semigroupCatList", () => $2f87b4fe4d8f7a0f$export$da599a1924f5bf13);
$parcel$export(module.exports, "snoc", () => $2f87b4fe4d8f7a0f$export$c40cf5aab899f397);
// Generated by purs version 0.15.16

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $ibtPS = parcelRequire("ibtPS");

var $c4Pbd = parcelRequire("c4Pbd");

var $6RkEA = parcelRequire("6RkEA");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");

var $amUgg = parcelRequire("amUgg");

var $ykHdR = parcelRequire("ykHdR");

var $aknDF = parcelRequire("aknDF");

var $iwqgS = parcelRequire("iwqgS");

var $gyPYh = parcelRequire("gyPYh");

var $3Orkn = parcelRequire("3Orkn");

var $1wR1l = parcelRequire("1wR1l");

var $9MxTl = parcelRequire("9MxTl");
var $2f87b4fe4d8f7a0f$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $2f87b4fe4d8f7a0f$export$7475bf8196f095ad = /* #__PURE__ */ function() {
    function CatNil() {}
    CatNil.value = new CatNil();
    return CatNil;
}();
var $2f87b4fe4d8f7a0f$export$4cc9fe8c7ead393e = /* #__PURE__ */ function() {
    function CatCons(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    CatCons.create = function(value0) {
        return function(value1) {
            return new CatCons(value0, value1);
        };
    };
    return CatCons;
}();
var $2f87b4fe4d8f7a0f$export$eb80e9167e4f6b99 = function(dictShow) {
    var show = $3Orkn.show(dictShow);
    return {
        show: function(v) {
            if (v instanceof $2f87b4fe4d8f7a0f$export$7475bf8196f095ad) return "CatNil";
            if (v instanceof $2f87b4fe4d8f7a0f$export$4cc9fe8c7ead393e) return "(CatList " + (show(v.value0) + (" " + ($3Orkn.show($c4Pbd.showCatQueue($2f87b4fe4d8f7a0f$export$eb80e9167e4f6b99(dictShow)))(v.value1) + ")")));
            throw new Error("Failed pattern match at Data.CatList (line 147, column 1 - line 149, column 71): " + [
                v.constructor.name
            ]);
        }
    };
};
var $2f87b4fe4d8f7a0f$export$7b1b591b262c240 = function(v) {
    if (v instanceof $2f87b4fe4d8f7a0f$export$7475bf8196f095ad) return true;
    return false;
};
var $2f87b4fe4d8f7a0f$var$link = function(v) {
    return function(v1) {
        if (v instanceof $2f87b4fe4d8f7a0f$export$7475bf8196f095ad) return v1;
        if (v1 instanceof $2f87b4fe4d8f7a0f$export$7475bf8196f095ad) return v;
        if (v instanceof $2f87b4fe4d8f7a0f$export$4cc9fe8c7ead393e) return new $2f87b4fe4d8f7a0f$export$4cc9fe8c7ead393e(v.value0, $c4Pbd.snoc(v.value1)(v1));
        throw new Error("Failed pattern match at Data.CatList (line 108, column 1 - line 108, column 54): " + [
            v.constructor.name,
            v1.constructor.name
        ]);
    };
};
var $2f87b4fe4d8f7a0f$var$foldr = function(k) {
    return function(b) {
        return function(q) {
            var foldl = function($copy_v) {
                return function($copy_v1) {
                    return function($copy_v2) {
                        var $tco_var_v = $copy_v;
                        var $tco_var_v1 = $copy_v1;
                        var $tco_done = false;
                        var $tco_result;
                        function $tco_loop(v, v1, v2) {
                            if (v2 instanceof $amUgg.Nil) {
                                $tco_done = true;
                                return v1;
                            }
                            if (v2 instanceof $amUgg.Cons) {
                                $tco_var_v = v;
                                $tco_var_v1 = v(v1)(v2.value0);
                                $copy_v2 = v2.value1;
                                return;
                            }
                            throw new Error("Failed pattern match at Data.CatList (line 124, column 3 - line 124, column 59): " + [
                                v.constructor.name,
                                v1.constructor.name,
                                v2.constructor.name
                            ]);
                        }
                        while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $tco_var_v1, $copy_v2);
                        return $tco_result;
                    };
                };
            };
            var go = function($copy_xs) {
                return function($copy_ys) {
                    var $tco_var_xs = $copy_xs;
                    var $tco_done1 = false;
                    var $tco_result;
                    function $tco_loop(xs, ys) {
                        var v = $c4Pbd.uncons(xs);
                        if (v instanceof $ykHdR.Nothing) {
                            $tco_done1 = true;
                            return foldl(function(x) {
                                return function(i) {
                                    return i(x);
                                };
                            })(b)(ys);
                        }
                        if (v instanceof $ykHdR.Just) {
                            $tco_var_xs = v.value0.value1;
                            $copy_ys = new $amUgg.Cons(k(v.value0.value0), ys);
                            return;
                        }
                        throw new Error("Failed pattern match at Data.CatList (line 120, column 14 - line 122, column 67): " + [
                            v.constructor.name
                        ]);
                    }
                    while(!$tco_done1)$tco_result = $tco_loop($tco_var_xs, $copy_ys);
                    return $tco_result;
                };
            };
            return go(q)($amUgg.Nil.value);
        };
    };
};
var $2f87b4fe4d8f7a0f$export$b446f6baa3bb1430 = function(v) {
    if (v instanceof $2f87b4fe4d8f7a0f$export$7475bf8196f095ad) return $ykHdR.Nothing.value;
    if (v instanceof $2f87b4fe4d8f7a0f$export$4cc9fe8c7ead393e) return new $ykHdR.Just(new $9MxTl.Tuple(v.value0, function() {
        var $66 = $c4Pbd.null(v.value1);
        if ($66) return $2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value;
        return $2f87b4fe4d8f7a0f$var$foldr($2f87b4fe4d8f7a0f$var$link)($2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value)(v.value1);
    }()));
    throw new Error("Failed pattern match at Data.CatList (line 99, column 1 - line 99, column 61): " + [
        v.constructor.name
    ]);
};
var $2f87b4fe4d8f7a0f$export$9dc212839863b867 = {
    foldMap: function(dictMonoid) {
        return $6RkEA.foldMapDefaultL($2f87b4fe4d8f7a0f$export$9dc212839863b867)(dictMonoid);
    },
    foldr: function(f) {
        return function(s) {
            return function(l) {
                return $6RkEA.foldrDefault($2f87b4fe4d8f7a0f$export$9dc212839863b867)(f)(s)(l);
            };
        };
    },
    foldl: function(f) {
        var go = function($copy_acc) {
            return function($copy_q) {
                var $tco_var_acc = $copy_acc;
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(acc, q) {
                    var v = $2f87b4fe4d8f7a0f$export$b446f6baa3bb1430(q);
                    if (v instanceof $ykHdR.Just) {
                        $tco_var_acc = f(acc)(v.value0.value0);
                        $copy_q = v.value0.value1;
                        return;
                    }
                    if (v instanceof $ykHdR.Nothing) {
                        $tco_done = true;
                        return acc;
                    }
                    throw new Error("Failed pattern match at Data.CatList (line 156, column 16 - line 158, column 22): " + [
                        v.constructor.name
                    ]);
                }
                while(!$tco_done)$tco_result = $tco_loop($tco_var_acc, $copy_q);
                return $tco_result;
            };
        };
        return go;
    }
};
var $2f87b4fe4d8f7a0f$export$f24224f1c91d8156 = /* #__PURE__ */ $6RkEA.length($2f87b4fe4d8f7a0f$export$9dc212839863b867)($gyPYh.semiringInt);
var $2f87b4fe4d8f7a0f$var$foldMap = function(dictMonoid) {
    var mempty = $aknDF.mempty(dictMonoid);
    var append2 = $iwqgS.append(dictMonoid.Semigroup0());
    return function(v) {
        return function(v1) {
            if (v1 instanceof $2f87b4fe4d8f7a0f$export$7475bf8196f095ad) return mempty;
            if (v1 instanceof $2f87b4fe4d8f7a0f$export$4cc9fe8c7ead393e) {
                var d = function() {
                    var $75 = $c4Pbd.null(v1.value1);
                    if ($75) return $2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value;
                    return $2f87b4fe4d8f7a0f$var$foldr($2f87b4fe4d8f7a0f$var$link)($2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value)(v1.value1);
                }();
                return append2(v(v1.value0))($2f87b4fe4d8f7a0f$var$foldMap(dictMonoid)(v)(d));
            }
            throw new Error("Failed pattern match at Data.CatList (line 134, column 1 - line 134, column 62): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    };
};
var $2f87b4fe4d8f7a0f$export$6e22c362a0406a2c = /* #__PURE__ */ function() {
    return $2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value;
}();
var $2f87b4fe4d8f7a0f$export$10d8903dec122b9d = $2f87b4fe4d8f7a0f$var$link;
var $2f87b4fe4d8f7a0f$export$8327ebbef2a0ba76 = function(a) {
    return function(cat) {
        return $2f87b4fe4d8f7a0f$export$10d8903dec122b9d(new $2f87b4fe4d8f7a0f$export$4cc9fe8c7ead393e(a, $c4Pbd.empty))(cat);
    };
};
var $2f87b4fe4d8f7a0f$export$2fa88228892893e6 = {
    map: function(v) {
        return function(v1) {
            if (v1 instanceof $2f87b4fe4d8f7a0f$export$7475bf8196f095ad) return $2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value;
            if (v1 instanceof $2f87b4fe4d8f7a0f$export$4cc9fe8c7ead393e) {
                var d = function() {
                    var $80 = $c4Pbd.null(v1.value1);
                    if ($80) return $2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value;
                    return $2f87b4fe4d8f7a0f$var$foldr($2f87b4fe4d8f7a0f$var$link)($2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value)(v1.value1);
                }();
                return $2f87b4fe4d8f7a0f$export$8327ebbef2a0ba76(v(v1.value0))($l0wDR.map($2f87b4fe4d8f7a0f$export$2fa88228892893e6)(v)(d));
            }
            throw new Error("Failed pattern match at Data.CatList (line 184, column 1 - line 188, column 26): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    }
};
var $2f87b4fe4d8f7a0f$export$439306a4dcaafbb9 = function(a) {
    return $2f87b4fe4d8f7a0f$export$8327ebbef2a0ba76(a)($2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value);
};
var $2f87b4fe4d8f7a0f$export$e0c854626a3eddb8 = {
    traverse: function(dictApplicative) {
        var pure = $gUTA8.pure(dictApplicative);
        var Apply0 = dictApplicative.Apply0();
        var apply = $a5g3C.apply(Apply0);
        var map = $l0wDR.map(Apply0.Functor0());
        return function(v) {
            return function(v1) {
                if (v1 instanceof $2f87b4fe4d8f7a0f$export$7475bf8196f095ad) return pure($2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value);
                if (v1 instanceof $2f87b4fe4d8f7a0f$export$4cc9fe8c7ead393e) {
                    var d = function() {
                        var $85 = $c4Pbd.null(v1.value1);
                        if ($85) return $2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value;
                        return $2f87b4fe4d8f7a0f$var$foldr($2f87b4fe4d8f7a0f$var$link)($2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value)(v1.value1);
                    }();
                    return apply(map($2f87b4fe4d8f7a0f$export$8327ebbef2a0ba76)(v(v1.value0)))($1wR1l.traverse($2f87b4fe4d8f7a0f$export$e0c854626a3eddb8)(dictApplicative)(v)(d));
                }
                throw new Error("Failed pattern match at Data.CatList (line 174, column 1 - line 182, column 33): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    },
    sequence: function(dictApplicative) {
        var pure = $gUTA8.pure(dictApplicative);
        var Apply0 = dictApplicative.Apply0();
        var apply = $a5g3C.apply(Apply0);
        var map = $l0wDR.map(Apply0.Functor0());
        return function(v) {
            if (v instanceof $2f87b4fe4d8f7a0f$export$7475bf8196f095ad) return pure($2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value);
            if (v instanceof $2f87b4fe4d8f7a0f$export$4cc9fe8c7ead393e) {
                var d = function() {
                    var $89 = $c4Pbd.null(v.value1);
                    if ($89) return $2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value;
                    return $2f87b4fe4d8f7a0f$var$foldr($2f87b4fe4d8f7a0f$var$link)($2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value)(v.value1);
                }();
                return apply(map($2f87b4fe4d8f7a0f$export$8327ebbef2a0ba76)(v.value0))($1wR1l.sequence($2f87b4fe4d8f7a0f$export$e0c854626a3eddb8)(dictApplicative)(d));
            }
            throw new Error("Failed pattern match at Data.CatList (line 174, column 1 - line 182, column 33): " + [
                v.constructor.name
            ]);
        };
    },
    Functor0: function() {
        return $2f87b4fe4d8f7a0f$export$2fa88228892893e6;
    },
    Foldable1: function() {
        return $2f87b4fe4d8f7a0f$export$9dc212839863b867;
    }
};
var $2f87b4fe4d8f7a0f$export$da599a1924f5bf13 = {
    append: $2f87b4fe4d8f7a0f$export$10d8903dec122b9d
};
var $2f87b4fe4d8f7a0f$export$f4b77959e4023828 = /* #__PURE__ */ function() {
    return {
        mempty: $2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value,
        Semigroup0: function() {
            return $2f87b4fe4d8f7a0f$export$da599a1924f5bf13;
        }
    };
}();
var $2f87b4fe4d8f7a0f$export$607c251688bb5f73 = {
    Applicative0: function() {
        return $2f87b4fe4d8f7a0f$export$360f55d5496233b2;
    },
    Bind1: function() {
        return $2f87b4fe4d8f7a0f$export$23e6c815e87cdf22;
    }
};
var $2f87b4fe4d8f7a0f$export$23e6c815e87cdf22 = {
    bind: /* #__PURE__ */ $l4M7e.flip(/* #__PURE__ */ $2f87b4fe4d8f7a0f$var$foldMap($2f87b4fe4d8f7a0f$export$f4b77959e4023828)),
    Apply0: function() {
        return $2f87b4fe4d8f7a0f$var$$lazy_applyCatList(0);
    }
};
var $2f87b4fe4d8f7a0f$export$360f55d5496233b2 = {
    pure: $2f87b4fe4d8f7a0f$export$439306a4dcaafbb9,
    Apply0: function() {
        return $2f87b4fe4d8f7a0f$var$$lazy_applyCatList(0);
    }
};
var $2f87b4fe4d8f7a0f$var$$lazy_applyCatList = /* #__PURE__ */ $2f87b4fe4d8f7a0f$var$$runtime_lazy("applyCatList", "Data.CatList", function() {
    return {
        apply: $ibtPS.ap($2f87b4fe4d8f7a0f$export$607c251688bb5f73),
        Functor0: function() {
            return $2f87b4fe4d8f7a0f$export$2fa88228892893e6;
        }
    };
});
var $2f87b4fe4d8f7a0f$export$6c3a453d31b3c12e = /* #__PURE__ */ $2f87b4fe4d8f7a0f$var$$lazy_applyCatList(190);
var $2f87b4fe4d8f7a0f$export$b7d5d9bb9ff52072 = function(dictFoldable) {
    var foldMap1 = $6RkEA.foldMap(dictFoldable)($2f87b4fe4d8f7a0f$export$f4b77959e4023828);
    return function(f) {
        return foldMap1($2f87b4fe4d8f7a0f$export$439306a4dcaafbb9)(f);
    };
};
var $2f87b4fe4d8f7a0f$export$c40cf5aab899f397 = function(cat) {
    return function(a) {
        return $2f87b4fe4d8f7a0f$export$10d8903dec122b9d(cat)(new $2f87b4fe4d8f7a0f$export$4cc9fe8c7ead393e(a, $c4Pbd.empty));
    };
};
var $2f87b4fe4d8f7a0f$export$bc32e6f55ceec345 = {
    unfoldr1: function(f) {
        return function(b) {
            var go = function($copy_source) {
                return function($copy_memo) {
                    var $tco_var_source = $copy_source;
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(source, memo) {
                        var v = f(source);
                        if (v.value1 instanceof $ykHdR.Nothing) {
                            $tco_done = true;
                            return $2f87b4fe4d8f7a0f$export$c40cf5aab899f397(memo)(v.value0);
                        }
                        if (v.value1 instanceof $ykHdR.Just) {
                            $tco_var_source = v.value1.value0;
                            $copy_memo = $2f87b4fe4d8f7a0f$export$c40cf5aab899f397(memo)(v.value0);
                            return;
                        }
                        throw new Error("Failed pattern match at Data.CatList (line 170, column 24 - line 172, column 57): " + [
                            v.constructor.name
                        ]);
                    }
                    while(!$tco_done)$tco_result = $tco_loop($tco_var_source, $copy_memo);
                    return $tco_result;
                };
            };
            return go(b)($2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value);
        };
    }
};
var $2f87b4fe4d8f7a0f$export$6cb6a5647a60bec3 = {
    unfoldr: function(f) {
        return function(b) {
            var go = function($copy_source) {
                return function($copy_memo) {
                    var $tco_var_source = $copy_source;
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(source, memo) {
                        var v = f(source);
                        if (v instanceof $ykHdR.Nothing) {
                            $tco_done = true;
                            return memo;
                        }
                        if (v instanceof $ykHdR.Just) {
                            $tco_var_source = v.value0.value1;
                            $copy_memo = $2f87b4fe4d8f7a0f$export$c40cf5aab899f397(memo)(v.value0.value0);
                            return;
                        }
                        throw new Error("Failed pattern match at Data.CatList (line 163, column 24 - line 165, column 57): " + [
                            v.constructor.name
                        ]);
                    }
                    while(!$tco_done)$tco_result = $tco_loop($tco_var_source, $copy_memo);
                    return $tco_result;
                };
            };
            return go(b)($2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value);
        };
    },
    Unfoldable10: function() {
        return $2f87b4fe4d8f7a0f$export$bc32e6f55ceec345;
    }
};
var $2f87b4fe4d8f7a0f$export$c5b7cf0f3fda96ad = {
    alt: $2f87b4fe4d8f7a0f$export$10d8903dec122b9d,
    Functor0: function() {
        return $2f87b4fe4d8f7a0f$export$2fa88228892893e6;
    }
};
var $2f87b4fe4d8f7a0f$export$7790c39ae1bfafa2 = {
    empty: $2f87b4fe4d8f7a0f$export$6e22c362a0406a2c,
    Alt0: function() {
        return $2f87b4fe4d8f7a0f$export$c5b7cf0f3fda96ad;
    }
};
var $2f87b4fe4d8f7a0f$export$37a37f49d0feb489 = {
    Applicative0: function() {
        return $2f87b4fe4d8f7a0f$export$360f55d5496233b2;
    },
    Plus1: function() {
        return $2f87b4fe4d8f7a0f$export$7790c39ae1bfafa2;
    }
};
var $2f87b4fe4d8f7a0f$export$2074eaaf9933bfe1 = {
    Monad0: function() {
        return $2f87b4fe4d8f7a0f$export$607c251688bb5f73;
    },
    Alternative1: function() {
        return $2f87b4fe4d8f7a0f$export$37a37f49d0feb489;
    }
};

});
parcelRegister("c4Pbd", function(module, exports) {

$parcel$export(module.exports, "uncons", () => $8cad8efed8fc4b93$export$b446f6baa3bb1430);
$parcel$export(module.exports, "snoc", () => $8cad8efed8fc4b93$export$c40cf5aab899f397);
$parcel$export(module.exports, "showCatQueue", () => $8cad8efed8fc4b93$export$76888aafd695b76f);
$parcel$export(module.exports, "null", () => $8cad8efed8fc4b93$export$7b1b591b262c240);
$parcel$export(module.exports, "empty", () => $8cad8efed8fc4b93$export$6e22c362a0406a2c);
// Generated by purs version 0.15.16

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $ibtPS = parcelRequire("ibtPS");

var $4MBcA = parcelRequire("4MBcA");

var $6RkEA = parcelRequire("6RkEA");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");

var $5gmr2 = parcelRequire("5gmr2");

var $amUgg = parcelRequire("amUgg");

var $ykHdR = parcelRequire("ykHdR");

var $d0PPW = parcelRequire("d0PPW");

var $6SDUu = parcelRequire("6SDUu");

var $iwqgS = parcelRequire("iwqgS");

var $3Orkn = parcelRequire("3Orkn");

var $1wR1l = parcelRequire("1wR1l");

var $9MxTl = parcelRequire("9MxTl");
var $8cad8efed8fc4b93$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $8cad8efed8fc4b93$var$map = /* #__PURE__ */ $l0wDR.map($amUgg.functorList);
var $8cad8efed8fc4b93$export$a9e3236c55b65445 = /* #__PURE__ */ function() {
    function CatQueue(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    CatQueue.create = function(value0) {
        return function(value1) {
            return new CatQueue(value0, value1);
        };
    };
    return CatQueue;
}();
var $8cad8efed8fc4b93$export$712962e076096ed4 = function($copy_v) {
    var $tco_done = false;
    var $tco_result;
    function $tco_loop(v) {
        if (v.value1 instanceof $amUgg.Cons) {
            $tco_done = true;
            return new $ykHdR.Just(new $9MxTl.Tuple(v.value1.value0, new $8cad8efed8fc4b93$export$a9e3236c55b65445(v.value0, v.value1.value1)));
        }
        if (v.value0 instanceof $amUgg.Nil && v.value1 instanceof $amUgg.Nil) {
            $tco_done = true;
            return $ykHdR.Nothing.value;
        }
        if (v.value1 instanceof $amUgg.Nil) {
            $copy_v = new $8cad8efed8fc4b93$export$a9e3236c55b65445($amUgg.Nil.value, $5gmr2.reverse(v.value0));
            return;
        }
        throw new Error("Failed pattern match at Data.CatQueue (line 92, column 1 - line 92, column 63): " + [
            v.constructor.name
        ]);
    }
    while(!$tco_done)$tco_result = $tco_loop($copy_v);
    return $tco_result;
};
var $8cad8efed8fc4b93$export$b446f6baa3bb1430 = function($copy_v) {
    var $tco_done = false;
    var $tco_result;
    function $tco_loop(v) {
        if (v.value0 instanceof $amUgg.Nil && v.value1 instanceof $amUgg.Nil) {
            $tco_done = true;
            return $ykHdR.Nothing.value;
        }
        if (v.value0 instanceof $amUgg.Nil) {
            $copy_v = new $8cad8efed8fc4b93$export$a9e3236c55b65445($5gmr2.reverse(v.value1), $amUgg.Nil.value);
            return;
        }
        if (v.value0 instanceof $amUgg.Cons) {
            $tco_done = true;
            return new $ykHdR.Just(new $9MxTl.Tuple(v.value0.value0, new $8cad8efed8fc4b93$export$a9e3236c55b65445(v.value0.value1, v.value1)));
        }
        throw new Error("Failed pattern match at Data.CatQueue (line 82, column 1 - line 82, column 63): " + [
            v.constructor.name
        ]);
    }
    while(!$tco_done)$tco_result = $tco_loop($copy_v);
    return $tco_result;
};
var $8cad8efed8fc4b93$export$c40cf5aab899f397 = function(v) {
    return function(a) {
        return new $8cad8efed8fc4b93$export$a9e3236c55b65445(v.value0, new $amUgg.Cons(a, v.value1));
    };
};
var $8cad8efed8fc4b93$export$76888aafd695b76f = function(dictShow) {
    var show = $3Orkn.show($amUgg.showList(dictShow));
    return {
        show: function(v) {
            return "(CatQueue " + (show(v.value0) + (" " + (show(v.value1) + ")")));
        }
    };
};
var $8cad8efed8fc4b93$export$7b1b591b262c240 = function(v) {
    if (v.value0 instanceof $amUgg.Nil && v.value1 instanceof $amUgg.Nil) return true;
    return false;
};
var $8cad8efed8fc4b93$export$f24224f1c91d8156 = function(v) {
    return $5gmr2.length(v.value0) + $5gmr2.length(v.value1) | 0;
};
var $8cad8efed8fc4b93$export$cd9df59029b2f7f5 = {
    map: function(f) {
        return function(v) {
            return new $8cad8efed8fc4b93$export$a9e3236c55b65445($8cad8efed8fc4b93$var$map(f)(v.value0), $8cad8efed8fc4b93$var$map(f)(v.value1));
        };
    }
};
var $8cad8efed8fc4b93$export$2411eb790d3ef577 = {
    foldMap: function(dictMonoid) {
        return $6RkEA.foldMapDefaultL($8cad8efed8fc4b93$export$2411eb790d3ef577)(dictMonoid);
    },
    foldr: function(f) {
        return $6RkEA.foldrDefault($8cad8efed8fc4b93$export$2411eb790d3ef577)(f);
    },
    foldl: function(f) {
        var go = function($copy_acc) {
            return function($copy_q) {
                var $tco_var_acc = $copy_acc;
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(acc, q) {
                    var v = $8cad8efed8fc4b93$export$b446f6baa3bb1430(q);
                    if (v instanceof $ykHdR.Just) {
                        $tco_var_acc = f(acc)(v.value0.value0);
                        $copy_q = v.value0.value1;
                        return;
                    }
                    if (v instanceof $ykHdR.Nothing) {
                        $tco_done = true;
                        return acc;
                    }
                    throw new Error("Failed pattern match at Data.CatQueue (line 147, column 16 - line 149, column 22): " + [
                        v.constructor.name
                    ]);
                }
                while(!$tco_done)$tco_result = $tco_loop($tco_var_acc, $copy_q);
                return $tco_result;
            };
        };
        return go;
    }
};
var $8cad8efed8fc4b93$var$foldl = /* #__PURE__ */ $6RkEA.foldl($8cad8efed8fc4b93$export$2411eb790d3ef577);
var $8cad8efed8fc4b93$export$12a82fa16f3fa685 = {
    append: /* #__PURE__ */ $8cad8efed8fc4b93$var$foldl($8cad8efed8fc4b93$export$c40cf5aab899f397)
};
var $8cad8efed8fc4b93$export$6e22c362a0406a2c = /* #__PURE__ */ function() {
    return new $8cad8efed8fc4b93$export$a9e3236c55b65445($amUgg.Nil.value, $amUgg.Nil.value);
}();
var $8cad8efed8fc4b93$export$82bbee97f7dffc83 = {
    mempty: $8cad8efed8fc4b93$export$6e22c362a0406a2c,
    Semigroup0: function() {
        return $8cad8efed8fc4b93$export$12a82fa16f3fa685;
    }
};
var $8cad8efed8fc4b93$export$439306a4dcaafbb9 = /* #__PURE__ */ $8cad8efed8fc4b93$export$c40cf5aab899f397($8cad8efed8fc4b93$export$6e22c362a0406a2c);
var $8cad8efed8fc4b93$export$b7d5d9bb9ff52072 = function(dictFoldable) {
    var foldMap = $6RkEA.foldMap(dictFoldable)($8cad8efed8fc4b93$export$82bbee97f7dffc83);
    return function(f) {
        return foldMap($8cad8efed8fc4b93$export$439306a4dcaafbb9)(f);
    };
};
var $8cad8efed8fc4b93$export$402e17453440564b = {
    traverse: function(dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        var map1 = $l0wDR.map(Apply0.Functor0());
        var lift2 = $a5g3C.lift2(Apply0);
        var pure = $gUTA8.pure(dictApplicative);
        return function(f) {
            var $123 = map1($8cad8efed8fc4b93$var$foldl($8cad8efed8fc4b93$export$c40cf5aab899f397)($8cad8efed8fc4b93$export$6e22c362a0406a2c));
            var $124 = $8cad8efed8fc4b93$var$foldl(function(acc) {
                var $126 = lift2($8cad8efed8fc4b93$export$c40cf5aab899f397)(acc);
                return function($127) {
                    return $126(f($127));
                };
            })(pure($8cad8efed8fc4b93$export$6e22c362a0406a2c));
            return function($125) {
                return $123($124($125));
            };
        };
    },
    sequence: function(dictApplicative) {
        return $1wR1l.sequenceDefault($8cad8efed8fc4b93$export$402e17453440564b)(dictApplicative);
    },
    Functor0: function() {
        return $8cad8efed8fc4b93$export$cd9df59029b2f7f5;
    },
    Foldable1: function() {
        return $8cad8efed8fc4b93$export$2411eb790d3ef577;
    }
};
var $8cad8efed8fc4b93$export$4d02617d29cfe99c = {
    unfoldr1: function(f) {
        return function(b) {
            var go = function($copy_source) {
                return function($copy_memo) {
                    var $tco_var_source = $copy_source;
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(source, memo) {
                        var v = f(source);
                        if (v.value1 instanceof $ykHdR.Nothing) {
                            $tco_done = true;
                            return $8cad8efed8fc4b93$export$c40cf5aab899f397(memo)(v.value0);
                        }
                        if (v.value1 instanceof $ykHdR.Just) {
                            $tco_var_source = v.value1.value0;
                            $copy_memo = $8cad8efed8fc4b93$export$c40cf5aab899f397(memo)(v.value0);
                            return;
                        }
                        throw new Error("Failed pattern match at Data.CatQueue (line 154, column 24 - line 156, column 57): " + [
                            v.constructor.name
                        ]);
                    }
                    while(!$tco_done)$tco_result = $tco_loop($tco_var_source, $copy_memo);
                    return $tco_result;
                };
            };
            return go(b)($8cad8efed8fc4b93$export$6e22c362a0406a2c);
        };
    }
};
var $8cad8efed8fc4b93$export$7536d90e702d15a6 = {
    unfoldr: function(f) {
        return function(b) {
            var go = function($copy_source) {
                return function($copy_memo) {
                    var $tco_var_source = $copy_source;
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(source, memo) {
                        var v = f(source);
                        if (v instanceof $ykHdR.Nothing) {
                            $tco_done = true;
                            return memo;
                        }
                        if (v instanceof $ykHdR.Just) {
                            $tco_var_source = v.value0.value1;
                            $copy_memo = $8cad8efed8fc4b93$export$c40cf5aab899f397(memo)(v.value0.value0);
                            return;
                        }
                        throw new Error("Failed pattern match at Data.CatQueue (line 161, column 24 - line 163, column 57): " + [
                            v.constructor.name
                        ]);
                    }
                    while(!$tco_done)$tco_result = $tco_loop($tco_var_source, $copy_memo);
                    return $tco_result;
                };
            };
            return go(b)($8cad8efed8fc4b93$export$6e22c362a0406a2c);
        };
    },
    Unfoldable10: function() {
        return $8cad8efed8fc4b93$export$4d02617d29cfe99c;
    }
};
var $8cad8efed8fc4b93$var$cqEq = function(dictEq) {
    var elemEq = $4MBcA.eq(dictEq);
    var go = function($copy_xs) {
        return function($copy_ys) {
            var $tco_var_xs = $copy_xs;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(xs, ys) {
                var v = $8cad8efed8fc4b93$export$b446f6baa3bb1430(ys);
                var v1 = $8cad8efed8fc4b93$export$b446f6baa3bb1430(xs);
                if (v1 instanceof $ykHdR.Just && v instanceof $ykHdR.Just && elemEq(v1.value0.value0)(v.value0.value0)) {
                    $tco_var_xs = v1.value0.value1;
                    $copy_ys = v.value0.value1;
                    return;
                }
                if (v1 instanceof $ykHdR.Nothing && v instanceof $ykHdR.Nothing) {
                    $tco_done = true;
                    return true;
                }
                $tco_done = true;
                return false;
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_xs, $copy_ys);
            return $tco_result;
        };
    };
    return go;
};
var $8cad8efed8fc4b93$export$8d0b86d96cb644e8 = function(dictEq) {
    return {
        eq: $8cad8efed8fc4b93$var$cqEq(dictEq)
    };
};
var $8cad8efed8fc4b93$var$cqCompare = function(dictOrd) {
    var elemCompare = $d0PPW.compare(dictOrd);
    var go = function($copy_xs) {
        return function($copy_ys) {
            var $tco_var_xs = $copy_xs;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(xs, ys) {
                var v = $8cad8efed8fc4b93$export$b446f6baa3bb1430(ys);
                var v1 = $8cad8efed8fc4b93$export$b446f6baa3bb1430(xs);
                if (v1 instanceof $ykHdR.Just && v instanceof $ykHdR.Just) {
                    var v2 = elemCompare(v1.value0.value0)(v.value0.value0);
                    if (v2 instanceof $6SDUu.EQ) {
                        $tco_var_xs = v1.value0.value1;
                        $copy_ys = v.value0.value1;
                        return;
                    }
                    $tco_done = true;
                    return v2;
                }
                if (v1 instanceof $ykHdR.Just && v instanceof $ykHdR.Nothing) {
                    $tco_done = true;
                    return $6SDUu.GT.value;
                }
                if (v1 instanceof $ykHdR.Nothing && v instanceof $ykHdR.Just) {
                    $tco_done = true;
                    return $6SDUu.LT.value;
                }
                if (v1 instanceof $ykHdR.Nothing && v instanceof $ykHdR.Nothing) {
                    $tco_done = true;
                    return $6SDUu.EQ.value;
                }
                throw new Error("Failed pattern match at Data.CatQueue (line 117, column 16 - line 124, column 30): " + [
                    v1.constructor.name,
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_xs, $copy_ys);
            return $tco_result;
        };
    };
    return go;
};
var $8cad8efed8fc4b93$export$cce3b6ca8e6b304d = function(dictOrd) {
    var eqCatQueue1 = $8cad8efed8fc4b93$export$8d0b86d96cb644e8(dictOrd.Eq0());
    return {
        compare: $8cad8efed8fc4b93$var$cqCompare(dictOrd),
        Eq0: function() {
            return eqCatQueue1;
        }
    };
};
var $8cad8efed8fc4b93$export$8327ebbef2a0ba76 = function(a) {
    return function(v) {
        return new $8cad8efed8fc4b93$export$a9e3236c55b65445(new $amUgg.Cons(a, v.value0), v.value1);
    };
};
var $8cad8efed8fc4b93$export$64857ab1e7904bd4 = {
    Applicative0: function() {
        return $8cad8efed8fc4b93$export$6d9d1867ada2692e;
    },
    Bind1: function() {
        return $8cad8efed8fc4b93$export$5f82bc311535f1fb;
    }
};
var $8cad8efed8fc4b93$export$5f82bc311535f1fb = {
    bind: /* #__PURE__ */ $l4M7e.flip(/* #__PURE__ */ $6RkEA.foldMap($8cad8efed8fc4b93$export$2411eb790d3ef577)($8cad8efed8fc4b93$export$82bbee97f7dffc83)),
    Apply0: function() {
        return $8cad8efed8fc4b93$var$$lazy_applyCatQueue(0);
    }
};
var $8cad8efed8fc4b93$export$6d9d1867ada2692e = {
    pure: $8cad8efed8fc4b93$export$439306a4dcaafbb9,
    Apply0: function() {
        return $8cad8efed8fc4b93$var$$lazy_applyCatQueue(0);
    }
};
var $8cad8efed8fc4b93$var$$lazy_applyCatQueue = /* #__PURE__ */ $8cad8efed8fc4b93$var$$runtime_lazy("applyCatQueue", "Data.CatQueue", function() {
    return {
        apply: $ibtPS.ap($8cad8efed8fc4b93$export$64857ab1e7904bd4),
        Functor0: function() {
            return $8cad8efed8fc4b93$export$cd9df59029b2f7f5;
        }
    };
});
var $8cad8efed8fc4b93$export$b30f70c26a58b039 = /* #__PURE__ */ $8cad8efed8fc4b93$var$$lazy_applyCatQueue(174);
var $8cad8efed8fc4b93$export$ece98441a77a02d = {
    alt: /* #__PURE__ */ $iwqgS.append($8cad8efed8fc4b93$export$12a82fa16f3fa685),
    Functor0: function() {
        return $8cad8efed8fc4b93$export$cd9df59029b2f7f5;
    }
};
var $8cad8efed8fc4b93$export$f14c1a5864c2efe5 = {
    empty: $8cad8efed8fc4b93$export$6e22c362a0406a2c,
    Alt0: function() {
        return $8cad8efed8fc4b93$export$ece98441a77a02d;
    }
};
var $8cad8efed8fc4b93$export$6613cb99fa5f98f9 = {
    Applicative0: function() {
        return $8cad8efed8fc4b93$export$6d9d1867ada2692e;
    },
    Plus1: function() {
        return $8cad8efed8fc4b93$export$f14c1a5864c2efe5;
    }
};
var $8cad8efed8fc4b93$export$3e8f97b430646754 = {
    Monad0: function() {
        return $8cad8efed8fc4b93$export$64857ab1e7904bd4;
    },
    Alternative1: function() {
        return $8cad8efed8fc4b93$export$6613cb99fa5f98f9;
    }
};

});



parcelRegister("1nuum", function(module, exports) {

$parcel$export(module.exports, "ChildQuery", () => $100f96dc727fa3bb$export$c9e0c97aebb96176);
$parcel$export(module.exports, "unChildQueryBox", () => $100f96dc727fa3bb$export$183d7a788d583d00);
$parcel$export(module.exports, "mkChildQueryBox", () => $100f96dc727fa3bb$export$edf7909ca53834c6);
$parcel$export(module.exports, "functorChildQuery", () => $100f96dc727fa3bb$export$22f9ac696d7058c1);
// Generated by purs version 0.15.16
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");
var $100f96dc727fa3bb$export$c9e0c97aebb96176 = /* #__PURE__ */ function() {
    function ChildQuery(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    ChildQuery.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new ChildQuery(value0, value1, value2);
            };
        };
    };
    return ChildQuery;
}();
var $100f96dc727fa3bb$export$183d7a788d583d00 = $eOrGk.unsafeCoerce;
var $100f96dc727fa3bb$export$edf7909ca53834c6 = $eOrGk.unsafeCoerce;
var $100f96dc727fa3bb$export$22f9ac696d7058c1 = {
    map: function(f) {
        return $100f96dc727fa3bb$export$183d7a788d583d00(function(v) {
            return $100f96dc727fa3bb$export$edf7909ca53834c6(new $100f96dc727fa3bb$export$c9e0c97aebb96176(function(dictApplicative) {
                return v.value0(dictApplicative);
            }, v.value1, function($8) {
                return f(v.value2($8));
            }));
        });
    }
};

});

parcelRegister("bhj9Z", function(module, exports) {

$parcel$export(module.exports, "unsubscribe", () => $8360250a454b77aa$export$f500693cef883ffd);
$parcel$export(module.exports, "subscribe", () => $8360250a454b77aa$export$ec068583843480e7);
$parcel$export(module.exports, "notify", () => $8360250a454b77aa$export$5e14cdade93d6f7b);
$parcel$export(module.exports, "functorEmitter", () => $8360250a454b77aa$export$8fdc462d887e88b6);
$parcel$export(module.exports, "create", () => $8360250a454b77aa$export$185802fd694ee1f5);
// Generated by purs version 0.15.16

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $9Grh5 = parcelRequire("9Grh5");

var $4VF0K = parcelRequire("4VF0K");

var $6RkEA = parcelRequire("6RkEA");

var $l0wDR = parcelRequire("l0wDR");

var $ykHdR = parcelRequire("ykHdR");

var $aknDF = parcelRequire("aknDF");

var $iwqgS = parcelRequire("iwqgS");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");

var $9hRVP = parcelRequire("9hRVP");

var $cnyA5 = parcelRequire("cnyA5");
var $jFEU8 = parcelRequire("jFEU8");
parcelRequire("k5Trf");
var $guZlc = parcelRequire("guZlc");

var $e9Lv5 = parcelRequire("e9Lv5");

var $bBd0x = parcelRequire("bBd0x");
var $8360250a454b77aa$var$$$void = /* #__PURE__ */ $l0wDR.void($9hRVP.functorEffect);
var $8360250a454b77aa$var$coerce = /* #__PURE__ */ $e9Lv5.coerce();
var $8360250a454b77aa$var$bind = /* #__PURE__ */ $9Grh5.bind($9hRVP.bindEffect);
var $8360250a454b77aa$var$pure = /* #__PURE__ */ $gUTA8.pure($9hRVP.applicativeEffect);
var $8360250a454b77aa$var$append = /* #__PURE__ */ $iwqgS.append($iwqgS.semigroupArray);
var $8360250a454b77aa$var$traverse_ = /* #__PURE__ */ $6RkEA.traverse_($9hRVP.applicativeEffect);
var $8360250a454b77aa$var$traverse_1 = /* #__PURE__ */ $8360250a454b77aa$var$traverse_($6RkEA.foldableArray);
var $8360250a454b77aa$var$applySecond = /* #__PURE__ */ $a5g3C.applySecond($9hRVP.applyEffect);
var $8360250a454b77aa$var$traverse_2 = /* #__PURE__ */ $8360250a454b77aa$var$traverse_($6RkEA.foldableMaybe);
var $8360250a454b77aa$var$Subscription = function(x) {
    return x;
};
var $8360250a454b77aa$var$Listener = function(x) {
    return x;
};
var $8360250a454b77aa$var$Emitter = function(x) {
    return x;
};
var $8360250a454b77aa$export$f500693cef883ffd = function(v) {
    return v;
};
var $8360250a454b77aa$export$ec068583843480e7 = function(v) {
    return function(k) {
        return v(function($76) {
            return $8360250a454b77aa$var$$$void(k($76));
        });
    };
};
var $8360250a454b77aa$export$7251a5ca64435ded = /* #__PURE__ */ $9hRVP.semigroupEffect($iwqgS.semigroupUnit);
var $8360250a454b77aa$export$5e14cdade93d6f7b = function(v) {
    return function(a) {
        return v(a);
    };
};
var $8360250a454b77aa$export$f78eaf36ddcc5627 = /* #__PURE__ */ $9hRVP.monoidEffect($aknDF.monoidUnit);
var $8360250a454b77aa$var$mempty = /* #__PURE__ */ $aknDF.mempty(/* #__PURE__ */ $aknDF.monoidFn(/* #__PURE__ */ $9hRVP.monoidEffect($8360250a454b77aa$export$f78eaf36ddcc5627)));
var $8360250a454b77aa$export$59cc8049ccd39a18 = $8360250a454b77aa$var$coerce;
var $8360250a454b77aa$export$8fdc462d887e88b6 = {
    map: function(f) {
        return function(v) {
            return function(k) {
                return v(function($77) {
                    return k(f($77));
                });
            };
        };
    }
};
var $8360250a454b77aa$export$93e2b83da34ff82a = function(f) {
    return function(v) {
        return function(b) {
            return function(k) {
                return function __do() {
                    var result = $cnyA5.new(b)();
                    return v(function(a) {
                        return $8360250a454b77aa$var$bind($cnyA5.modify(f(a))(result))(k);
                    })();
                };
            };
        };
    };
};
var $8360250a454b77aa$export$3dea766d36a8935f = function(p) {
    return function(v) {
        return function(k) {
            return v(function(a) {
                var $57 = p(a);
                if ($57) return k(a);
                return $8360250a454b77aa$var$pure($r2HHk.unit);
            });
        };
    };
};
var $8360250a454b77aa$export$185802fd694ee1f5 = function __do() {
    var subscribers = $cnyA5.new([])();
    return {
        emitter: function(k) {
            return function __do() {
                $cnyA5.modify_(function(v) {
                    return $8360250a454b77aa$var$append(v)([
                        k
                    ]);
                })(subscribers)();
                return $cnyA5.modify_($4VF0K.deleteBy($bBd0x.unsafeRefEq)(k))(subscribers);
            };
        },
        listener: function(a) {
            return $8360250a454b77aa$var$bind($jFEU8.read(subscribers))($8360250a454b77aa$var$traverse_1(function(k) {
                return k(a);
            }));
        }
    };
};
var $8360250a454b77aa$export$d838837eb5b184e3 = function(f) {
    var v = $guZlc.unsafePerformEffect($8360250a454b77aa$export$185802fd694ee1f5);
    var v1 = f(v.emitter);
    return function(k) {
        return function __do() {
            var v2 = $8360250a454b77aa$export$ec068583843480e7(v1.input)($8360250a454b77aa$export$5e14cdade93d6f7b(v.listener))();
            var v3 = $8360250a454b77aa$export$ec068583843480e7(v1.output)(k)();
            return $8360250a454b77aa$var$applySecond(v2)(v3);
        };
    };
};
var $8360250a454b77aa$export$98d7d43cbbc38ca1 = {
    cmap: function(f) {
        return function(v) {
            return $8360250a454b77aa$var$coerce(function($78) {
                return v(f($78));
            });
        };
    }
};
var $8360250a454b77aa$export$641721d49e3b53db = {
    apply: function(v) {
        return function(v1) {
            return function(k) {
                return function __do() {
                    var latestA = $cnyA5.new($ykHdR.Nothing.value)();
                    var latestB = $cnyA5.new($ykHdR.Nothing.value)();
                    var v2 = v(function(a) {
                        return function __do() {
                            $jFEU8.write(new $ykHdR.Just(a))(latestA)();
                            return $8360250a454b77aa$var$bind($jFEU8.read(latestB))($8360250a454b77aa$var$traverse_2(function($79) {
                                return k(a($79));
                            }))();
                        };
                    })();
                    var v3 = v1(function(b) {
                        return function __do() {
                            $jFEU8.write(new $ykHdR.Just(b))(latestB)();
                            return $8360250a454b77aa$var$bind($jFEU8.read(latestA))($8360250a454b77aa$var$traverse_2(function($80) {
                                return k(function(v3) {
                                    return v3(b);
                                }($80));
                            }))();
                        };
                    })();
                    return $8360250a454b77aa$var$applySecond(v2)(v3);
                };
            };
        };
    },
    Functor0: function() {
        return $8360250a454b77aa$export$8fdc462d887e88b6;
    }
};
var $8360250a454b77aa$var$lift2 = /* #__PURE__ */ $a5g3C.lift2($8360250a454b77aa$export$641721d49e3b53db);
var $8360250a454b77aa$export$1096768271b079ef = function(dictSemigroup) {
    return {
        append: $8360250a454b77aa$var$lift2($iwqgS.append(dictSemigroup))
    };
};
var $8360250a454b77aa$export$3b69707d5efd35bb = function(dictMonoid) {
    var semigroupEmitter1 = $8360250a454b77aa$export$1096768271b079ef(dictMonoid.Semigroup0());
    return {
        mempty: $8360250a454b77aa$var$mempty,
        Semigroup0: function() {
            return semigroupEmitter1;
        }
    };
};
var $8360250a454b77aa$export$b87fc96b41f99504 = {
    pure: function(a) {
        return function(k) {
            return function __do() {
                k(a)();
                return $8360250a454b77aa$var$pure($r2HHk.unit);
            };
        };
    },
    Apply0: function() {
        return $8360250a454b77aa$export$641721d49e3b53db;
    }
};
var $8360250a454b77aa$export$e54eec101f91650d = {
    alt: function(v) {
        return function(v1) {
            return function(k) {
                return function __do() {
                    var v2 = v(k)();
                    var v3 = v1(k)();
                    return $8360250a454b77aa$var$applySecond(v2)(v3);
                };
            };
        };
    },
    Functor0: function() {
        return $8360250a454b77aa$export$8fdc462d887e88b6;
    }
};
var $8360250a454b77aa$export$18c97e2c4a95b65b = {
    empty: function(v) {
        return $8360250a454b77aa$var$pure($8360250a454b77aa$var$pure($r2HHk.unit));
    },
    Alt0: function() {
        return $8360250a454b77aa$export$e54eec101f91650d;
    }
};
var $8360250a454b77aa$export$9afcd97a0eb7b5aa = {
    Applicative0: function() {
        return $8360250a454b77aa$export$b87fc96b41f99504;
    },
    Plus1: function() {
        return $8360250a454b77aa$export$18c97e2c4a95b65b;
    }
};

});
parcelRegister("bBd0x", function(module, exports) {

$parcel$export(module.exports, "unsafeRefEq", () => $871d3d7bcf6be72e$export$54d9901699893a6);
// Generated by purs version 0.15.16

var $ky15e = parcelRequire("ky15e");

var $4MBcA = parcelRequire("4MBcA");
var $871d3d7bcf6be72e$export$4fd25d6ead33df13 = function(x) {
    return x;
};
var $871d3d7bcf6be72e$export$50f4602e25613a3e = function(x) {
    return x;
};
var $871d3d7bcf6be72e$export$54d9901699893a6 = $ky15e.reallyUnsafeRefEq;
var $871d3d7bcf6be72e$export$139829c37543f0b8 = function(dictEq) {
    var eq = $4MBcA.eq(dictEq);
    return {
        eq: function(v) {
            return function(v1) {
                return $871d3d7bcf6be72e$export$54d9901699893a6(v)(v1) || eq(v)(v1);
            };
        }
    };
};
var $871d3d7bcf6be72e$export$32e537f465b3365f = {
    eq: function(v) {
        return function(v1) {
            return $871d3d7bcf6be72e$export$54d9901699893a6(v)(v1);
        };
    }
};

});
parcelRegister("ky15e", function(module, exports) {

$parcel$export(module.exports, "reallyUnsafeRefEq", () => $ef57d2bf6d374935$export$2230c7466f27d38a);
function $ef57d2bf6d374935$export$2230c7466f27d38a(a) {
    return function(b) {
        return a === b;
    };
}

});




parcelRegister("5OEb5", function(module, exports) {

$parcel$export(module.exports, "Initialize", () => $43c0c9babefbb793$export$b03b1c699c90a9b4);
$parcel$export(module.exports, "Finalize", () => $43c0c9babefbb793$export$29defdae7b3f3a01);
$parcel$export(module.exports, "Receive", () => $43c0c9babefbb793$export$fc713a64b8ca1b7a);
$parcel$export(module.exports, "Action", () => $43c0c9babefbb793$export$e19cd5f9376f8cee);
$parcel$export(module.exports, "Query", () => $43c0c9babefbb793$export$62297b13309008b2);
// Generated by purs version 0.15.16

var $cYgrH = parcelRequire("cYgrH");

var $l0wDR = parcelRequire("l0wDR");
var $43c0c9babefbb793$var$map = /* #__PURE__ */ $l0wDR.map($cYgrH.functorCoyoneda);
var $43c0c9babefbb793$var$map1 = /* #__PURE__ */ $l0wDR.map($l0wDR.functorFn);
var $43c0c9babefbb793$export$b03b1c699c90a9b4 = /* #__PURE__ */ function() {
    function Initialize(value0) {
        this.value0 = value0;
    }
    Initialize.create = function(value0) {
        return new Initialize(value0);
    };
    return Initialize;
}();
var $43c0c9babefbb793$export$29defdae7b3f3a01 = /* #__PURE__ */ function() {
    function Finalize(value0) {
        this.value0 = value0;
    }
    Finalize.create = function(value0) {
        return new Finalize(value0);
    };
    return Finalize;
}();
var $43c0c9babefbb793$export$fc713a64b8ca1b7a = /* #__PURE__ */ function() {
    function Receive(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Receive.create = function(value0) {
        return function(value1) {
            return new Receive(value0, value1);
        };
    };
    return Receive;
}();
var $43c0c9babefbb793$export$e19cd5f9376f8cee = /* #__PURE__ */ function() {
    function Action(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Action.create = function(value0) {
        return function(value1) {
            return new Action(value0, value1);
        };
    };
    return Action;
}();
var $43c0c9babefbb793$export$62297b13309008b2 = /* #__PURE__ */ function() {
    function Query(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Query.create = function(value0) {
        return function(value1) {
            return new Query(value0, value1);
        };
    };
    return Query;
}();
var $43c0c9babefbb793$export$dc697e7b72225166 = {
    map: function(f) {
        return function(m) {
            if (m instanceof $43c0c9babefbb793$export$b03b1c699c90a9b4) return new $43c0c9babefbb793$export$b03b1c699c90a9b4(f(m.value0));
            if (m instanceof $43c0c9babefbb793$export$29defdae7b3f3a01) return new $43c0c9babefbb793$export$29defdae7b3f3a01(f(m.value0));
            if (m instanceof $43c0c9babefbb793$export$fc713a64b8ca1b7a) return new $43c0c9babefbb793$export$fc713a64b8ca1b7a(m.value0, f(m.value1));
            if (m instanceof $43c0c9babefbb793$export$e19cd5f9376f8cee) return new $43c0c9babefbb793$export$e19cd5f9376f8cee(m.value0, f(m.value1));
            if (m instanceof $43c0c9babefbb793$export$62297b13309008b2) return new $43c0c9babefbb793$export$62297b13309008b2($43c0c9babefbb793$var$map(f)(m.value0), $43c0c9babefbb793$var$map1(f)(m.value1));
            throw new Error("Failed pattern match at Halogen.Query.HalogenQ (line 0, column 0 - line 0, column 0): " + [
                m.constructor.name
            ]);
        };
    }
};
var $43c0c9babefbb793$export$211dae0362bd77c6 = {
    bimap: function(f) {
        return function(g) {
            return function(v) {
                if (v instanceof $43c0c9babefbb793$export$b03b1c699c90a9b4) return new $43c0c9babefbb793$export$b03b1c699c90a9b4(g(v.value0));
                if (v instanceof $43c0c9babefbb793$export$29defdae7b3f3a01) return new $43c0c9babefbb793$export$29defdae7b3f3a01(g(v.value0));
                if (v instanceof $43c0c9babefbb793$export$fc713a64b8ca1b7a) return new $43c0c9babefbb793$export$fc713a64b8ca1b7a(f(v.value0), g(v.value1));
                if (v instanceof $43c0c9babefbb793$export$e19cd5f9376f8cee) return new $43c0c9babefbb793$export$e19cd5f9376f8cee(v.value0, g(v.value1));
                if (v instanceof $43c0c9babefbb793$export$62297b13309008b2) return new $43c0c9babefbb793$export$62297b13309008b2($43c0c9babefbb793$var$map(g)(v.value0), $43c0c9babefbb793$var$map1(g)(v.value1));
                throw new Error("Failed pattern match at Halogen.Query.HalogenQ (line 16, column 15 - line 21, column 45): " + [
                    v.constructor.name
                ]);
            };
        };
    }
};

});

parcelRegister("kKOpj", function(module, exports) {

$parcel$export(module.exports, "thunk1", () => $f1bf345cdb6c789d$export$c6666e7f0d2efc62);
$parcel$export(module.exports, "thunk2", () => $f1bf345cdb6c789d$export$8a29159161b2b8a6);
$parcel$export(module.exports, "thunk3", () => $f1bf345cdb6c789d$export$7f0ccf52046143dd);
$parcel$export(module.exports, "thunked", () => $f1bf345cdb6c789d$export$6fa757c467a343e);
$parcel$export(module.exports, "mapThunk", () => $f1bf345cdb6c789d$export$ad7ceecc341abc7e);
$parcel$export(module.exports, "hoist", () => $f1bf345cdb6c789d$export$b2cccb4e0928a3a6);
$parcel$export(module.exports, "buildThunk", () => $f1bf345cdb6c789d$export$d46b23c375182cf8);
// Generated by purs version 0.15.16
parcelRequire("ikChJ");
var $chZgc = parcelRequire("chZgc");

var $l0wDR = parcelRequire("l0wDR");

var $akkXi = parcelRequire("akkXi");

var $69gPG = parcelRequire("69gPG");
parcelRequire("eO7Z3");
var $4Y58b = parcelRequire("4Y58b");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");
var $f1bf345cdb6c789d$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $f1bf345cdb6c789d$var$Thunk = /* #__PURE__ */ function() {
    function Thunk(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    }
    Thunk.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return new Thunk(value0, value1, value2, value3);
                };
            };
        };
    };
    return Thunk;
}();
var $f1bf345cdb6c789d$var$unsafeThunkId = $eOrGk.unsafeCoerce;
var $f1bf345cdb6c789d$var$unsafeEqThunk = function(v, v1) {
    return $4Y58b.refEq(v.value0, v1.value0) && $4Y58b.refEq(v.value1, v1.value1) && v.value1(v.value3, v1.value3);
};
var $f1bf345cdb6c789d$var$thunk = function(tid, eqFn, f, a) {
    return new $f1bf345cdb6c789d$var$Thunk(tid, eqFn, f, a);
};
var $f1bf345cdb6c789d$export$c6666e7f0d2efc62 = function(f, a) {
    return $f1bf345cdb6c789d$var$thunk($f1bf345cdb6c789d$var$unsafeThunkId(f), $4Y58b.refEq, f, a);
};
var $f1bf345cdb6c789d$export$8a29159161b2b8a6 = /* #__PURE__ */ function() {
    var eqFn = function(a, b) {
        return $4Y58b.refEq(a["_1"], b["_1"]) && $4Y58b.refEq(a["_2"], b["_2"]);
    };
    return function(f, a, b) {
        return $f1bf345cdb6c789d$var$thunk($f1bf345cdb6c789d$var$unsafeThunkId(f), eqFn, function(v) {
            return f(v["_1"])(v["_2"]);
        }, {
            "_1": a,
            "_2": b
        });
    };
}();
var $f1bf345cdb6c789d$export$7f0ccf52046143dd = /* #__PURE__ */ function() {
    var eqFn = function(a, b) {
        return $4Y58b.refEq(a["_1"], b["_1"]) && $4Y58b.refEq(a["_2"], b["_2"]) && $4Y58b.refEq(a["_3"], b["_3"]);
    };
    return function(f, a, b, c) {
        return $f1bf345cdb6c789d$var$thunk($f1bf345cdb6c789d$var$unsafeThunkId(f), eqFn, function(v) {
            return f(v["_1"])(v["_2"])(v["_3"]);
        }, {
            "_1": a,
            "_2": b,
            "_3": c
        });
    };
}();
var $f1bf345cdb6c789d$export$6fa757c467a343e = function(eqFn) {
    return function(f) {
        var tid = $f1bf345cdb6c789d$var$unsafeThunkId({
            f: f
        });
        var eqFn$prime = $chZgc.mkFn2(eqFn);
        return function(a) {
            return $f1bf345cdb6c789d$var$thunk(tid, eqFn$prime, f, a);
        };
    };
};
var $f1bf345cdb6c789d$export$1a6f8a190b47b840 = function(v) {
    return v.value2(v.value3);
};
var $f1bf345cdb6c789d$export$ad7ceecc341abc7e = function(k) {
    return function(v) {
        return new $f1bf345cdb6c789d$var$Thunk(v.value0, v.value1, function($51) {
            return k(v.value2($51));
        }, v.value3);
    };
};
var $f1bf345cdb6c789d$export$b2cccb4e0928a3a6 = $f1bf345cdb6c789d$export$ad7ceecc341abc7e;
var $f1bf345cdb6c789d$export$2d03ed83ba31f127 = function(dictFunctor) {
    var map = $l0wDR.map(dictFunctor);
    return {
        map: function(f) {
            return function(v) {
                return new $f1bf345cdb6c789d$var$Thunk(v.value0, v.value1, function() {
                    var $52 = map(f);
                    return function($53) {
                        return $52(v.value2($53));
                    };
                }(), v.value3);
            };
        }
    };
};
var $f1bf345cdb6c789d$export$d46b23c375182cf8 = function(toVDom) {
    var haltThunk = function(state) {
        return $69gPG.halt(state.vdom);
    };
    var $lazy_patchThunk = $f1bf345cdb6c789d$var$$runtime_lazy("patchThunk", "Halogen.VDom.Thunk", function() {
        return function(state, t2) {
            var $48 = $f1bf345cdb6c789d$var$unsafeEqThunk(state.thunk, t2);
            if ($48) return $69gPG.mkStep(new $69gPG.Step($69gPG.extract(state.vdom), state, $lazy_patchThunk(112), haltThunk));
            var vdom = $69gPG.step(state.vdom, toVDom($f1bf345cdb6c789d$export$1a6f8a190b47b840(t2)));
            return $69gPG.mkStep(new $69gPG.Step($69gPG.extract(vdom), {
                vdom: vdom,
                thunk: t2
            }, $lazy_patchThunk(115), haltThunk));
        };
    });
    var patchThunk = $lazy_patchThunk(108);
    var renderThunk = function(spec) {
        return function(t) {
            var vdom = $akkXi.buildVDom(spec)(toVDom($f1bf345cdb6c789d$export$1a6f8a190b47b840(t)));
            return $69gPG.mkStep(new $69gPG.Step($69gPG.extract(vdom), {
                thunk: t,
                vdom: vdom
            }, patchThunk, haltThunk));
        };
    };
    return renderThunk;
};

});


parcelRegister("5tIT8", function(module, exports) {

$parcel$export(module.exports, "Lambda", () => $3fd27b134c85cda7$export$4d5bd360b6390e98);
$parcel$export(module.exports, "Identifier", () => $3fd27b134c85cda7$export$989167234458594d);
$parcel$export(module.exports, "Dot", () => $3fd27b134c85cda7$export$d046b3c4a416f60d);
$parcel$export(module.exports, "OpenParen", () => $3fd27b134c85cda7$export$8f6fcf85ae6713b3);
$parcel$export(module.exports, "CloseParen", () => $3fd27b134c85cda7$export$2d72370f04ddc1a1);
$parcel$export(module.exports, "renderMany", () => $3fd27b134c85cda7$export$fce72850947ca415);
$parcel$export(module.exports, "print", () => $3fd27b134c85cda7$export$c2d084dc44961371);
$parcel$export(module.exports, "printMany", () => $3fd27b134c85cda7$export$a438c3a1b8645bfe);
$parcel$export(module.exports, "parser", () => $3fd27b134c85cda7$export$8f49e4af10703ce3);
$parcel$export(module.exports, "showLexeme", () => $3fd27b134c85cda7$export$188ef90131b17b70);
$parcel$export(module.exports, "eqLexeme", () => $3fd27b134c85cda7$export$6525700e0232a3f5);
// Generated by purs version 0.15.16

var $gUTA8 = parcelRequire("gUTA8");

var $9Grh5 = parcelRequire("9Grh5");

var $8D18I = parcelRequire("8D18I");

var $4VF0K = parcelRequire("4VF0K");

var $jxBf5 = parcelRequire("jxBf5");

var $cwMDv = parcelRequire("cwMDv");

var $eWReo = parcelRequire("eWReo");

var $aKY4H = parcelRequire("aKY4H");

var $4MBcA = parcelRequire("4MBcA");

var $6RkEA = parcelRequire("6RkEA");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");

var $cw1rg = parcelRequire("cw1rg");

var $3Orkn = parcelRequire("3Orkn");

var $7eHfd = parcelRequire("7eHfd");

var $5oIYL = parcelRequire("5oIYL");
parcelRequire("2gT7Y");
var $MTXA4 = parcelRequire("MTXA4");

var $79GDW = parcelRequire("79GDW");

var $9MxTl = parcelRequire("9MxTl");

var $hhMAk = parcelRequire("hhMAk");

var $jIMHU = parcelRequire("jIMHU");

var $cLQJF = parcelRequire("cLQJF");

var $3J9zV = parcelRequire("3J9zV");

var $1woEV = parcelRequire("1woEV");

var $hmOcH = parcelRequire("hmOcH");
var $3fd27b134c85cda7$var$map = /* #__PURE__ */ $l0wDR.map($3J9zV.functorParserT);
var $3fd27b134c85cda7$var$voidRight = /* #__PURE__ */ $l0wDR.voidRight($3J9zV.functorParserT);
var $3fd27b134c85cda7$var$bind = /* #__PURE__ */ $9Grh5.bind($3J9zV.bindParserT);
var $3fd27b134c85cda7$var$show = /* #__PURE__ */ $3Orkn.show($3Orkn.showChar);
var $3fd27b134c85cda7$var$show1 = /* #__PURE__ */ $3Orkn.show($5oIYL.showCodePoint);
var $3fd27b134c85cda7$var$genericShowConstructor = /* #__PURE__ */ $7eHfd.genericShowConstructor($7eHfd.genericShowArgsNoArguments);
var $3fd27b134c85cda7$var$map1 = /* #__PURE__ */ $l0wDR.map($l0wDR.functorArray);
var $3fd27b134c85cda7$export$4d5bd360b6390e98 = /* #__PURE__ */ function() {
    function Lambda() {}
    Lambda.value = new Lambda();
    return Lambda;
}();
var $3fd27b134c85cda7$export$989167234458594d = /* #__PURE__ */ function() {
    function Identifier(value0) {
        this.value0 = value0;
    }
    Identifier.create = function(value0) {
        return new Identifier(value0);
    };
    return Identifier;
}();
var $3fd27b134c85cda7$export$d046b3c4a416f60d = /* #__PURE__ */ function() {
    function Dot() {}
    Dot.value = new Dot();
    return Dot;
}();
var $3fd27b134c85cda7$export$8f6fcf85ae6713b3 = /* #__PURE__ */ function() {
    function OpenParen() {}
    OpenParen.value = new OpenParen();
    return OpenParen;
}();
var $3fd27b134c85cda7$export$2d72370f04ddc1a1 = /* #__PURE__ */ function() {
    function CloseParen() {}
    CloseParen.value = new CloseParen();
    return CloseParen;
}();
var $3fd27b134c85cda7$export$b3890eb0ae9dca99 = function(lex) {
    var v = function() {
        if (lex instanceof $3fd27b134c85cda7$export$4d5bd360b6390e98) return new $9MxTl.Tuple("lambda", "\\");
        if (lex instanceof $3fd27b134c85cda7$export$989167234458594d) return new $9MxTl.Tuple("identifier", lex.value0);
        if (lex instanceof $3fd27b134c85cda7$export$d046b3c4a416f60d) return new $9MxTl.Tuple("dot", ".");
        if (lex instanceof $3fd27b134c85cda7$export$8f6fcf85ae6713b3) return new $9MxTl.Tuple("openParen", "(");
        if (lex instanceof $3fd27b134c85cda7$export$2d72370f04ddc1a1) return new $9MxTl.Tuple("closeParen", ")");
        throw new Error("Failed pattern match at Lexeme (line 102, column 5 - line 107, column 43): " + [
            lex.constructor.name
        ]);
    }();
    var cLexeme = function(c) {
        return "lexeme_" + c;
    };
    var cType = function(c) {
        return cLexeme("tag_" + c);
    };
    return $jIMHU.span([
        $cLQJF.classes([
            cLexeme("display"),
            cType(v.value0)
        ])
    ])([
        $hhMAk.text(v.value1)
    ]);
};
var $3fd27b134c85cda7$export$fce72850947ca415 = function(dictFunctor) {
    var map2 = $l0wDR.map(dictFunctor);
    return function(dictFoldable) {
        var fromFoldable = $4VF0K.fromFoldable(dictFoldable);
        return function(ls) {
            return $jIMHU.div([
                $cLQJF.class_("lexemes_display")
            ])(fromFoldable(map2($3fd27b134c85cda7$export$b3890eb0ae9dca99)(ls)));
        };
    };
};
var $3fd27b134c85cda7$export$c2d084dc44961371 = function(v) {
    if (v instanceof $3fd27b134c85cda7$export$4d5bd360b6390e98) return $MTXA4.singleton("\\");
    if (v instanceof $3fd27b134c85cda7$export$989167234458594d) return v.value0;
    if (v instanceof $3fd27b134c85cda7$export$d046b3c4a416f60d) return $MTXA4.singleton(".");
    if (v instanceof $3fd27b134c85cda7$export$8f6fcf85ae6713b3) return $MTXA4.singleton("(");
    if (v instanceof $3fd27b134c85cda7$export$2d72370f04ddc1a1) return $MTXA4.singleton(")");
    throw new Error("Failed pattern match at Lexeme (line 76, column 1 - line 76, column 26): " + [
        v.constructor.name
    ]);
};
var $3fd27b134c85cda7$export$a438c3a1b8645bfe = function(dictFoldable) {
    var foldr = $6RkEA.foldr(dictFoldable);
    return function(ls) {
        var alg = function(l) {
            return function(leadingId) {
                return function(t) {
                    if (l instanceof $3fd27b134c85cda7$export$989167234458594d) return new $9MxTl.Tuple(true, function() {
                        if (leadingId) return l.value0 + " ";
                        return l.value0;
                    }() + t);
                    return new $9MxTl.Tuple(false, $3fd27b134c85cda7$export$c2d084dc44961371(l) + t);
                };
            };
        };
        return $9MxTl.snd(foldr(function($97) {
            return $9MxTl.uncurry(alg($97));
        })(new $9MxTl.Tuple(false, ""))(ls));
    };
};
var $3fd27b134c85cda7$var$identifier = /* #__PURE__ */ $1woEV.try(/* #__PURE__ */ $3fd27b134c85cda7$var$map($MTXA4.fromCharArray)(/* #__PURE__ */ $4VF0K.some($3J9zV.alternativeParserT)($3J9zV.lazyParserT)(/* #__PURE__ */ $hmOcH.satisfy(function($98) {
    return $eWReo.isLetter($5oIYL.codePointFromChar($98));
}))));
var $3fd27b134c85cda7$export$8f49e4af10703ce3 = /* #__PURE__ */ function() {
    return $6RkEA.oneOf($6RkEA.foldableArray)($3J9zV.plusParserT)([
        $3fd27b134c85cda7$var$voidRight($3fd27b134c85cda7$export$4d5bd360b6390e98.value)($hmOcH.char("\\")),
        $3fd27b134c85cda7$var$voidRight($3fd27b134c85cda7$export$d046b3c4a416f60d.value)($hmOcH.char(".")),
        $3fd27b134c85cda7$var$voidRight($3fd27b134c85cda7$export$8f6fcf85ae6713b3.value)($hmOcH.char("(")),
        $3fd27b134c85cda7$var$voidRight($3fd27b134c85cda7$export$2d72370f04ddc1a1.value)($hmOcH.char(")")),
        $3fd27b134c85cda7$var$map($3fd27b134c85cda7$export$989167234458594d.create)($3fd27b134c85cda7$var$identifier),
        $3fd27b134c85cda7$var$bind($hmOcH.anyChar)(function(badChar) {
            return $3J9zV.fail("Bad input character: " + $3fd27b134c85cda7$var$show(badChar));
        }),
        $3fd27b134c85cda7$var$bind($hmOcH.anyCodePoint)(function(badCode) {
            return $3J9zV.fail("Bad input code point (!): " + $3fd27b134c85cda7$var$show1(badCode));
        })
    ]);
}();
var $3fd27b134c85cda7$export$95f8b977bef6249b = {
    to: function(x) {
        if (x instanceof $cw1rg.Inl) return $3fd27b134c85cda7$export$4d5bd360b6390e98.value;
        if (x instanceof $cw1rg.Inr && x.value0 instanceof $cw1rg.Inl) return new $3fd27b134c85cda7$export$989167234458594d(x.value0.value0);
        if (x instanceof $cw1rg.Inr && x.value0 instanceof $cw1rg.Inr && x.value0.value0 instanceof $cw1rg.Inl) return $3fd27b134c85cda7$export$d046b3c4a416f60d.value;
        if (x instanceof $cw1rg.Inr && x.value0 instanceof $cw1rg.Inr && x.value0.value0 instanceof $cw1rg.Inr && x.value0.value0.value0 instanceof $cw1rg.Inl) return $3fd27b134c85cda7$export$8f6fcf85ae6713b3.value;
        if (x instanceof $cw1rg.Inr && x.value0 instanceof $cw1rg.Inr && x.value0.value0 instanceof $cw1rg.Inr && x.value0.value0.value0 instanceof $cw1rg.Inr) return $3fd27b134c85cda7$export$2d72370f04ddc1a1.value;
        throw new Error("Failed pattern match at Lexeme (line 44, column 1 - line 44, column 50): " + [
            x.constructor.name
        ]);
    },
    from: function(x) {
        if (x instanceof $3fd27b134c85cda7$export$4d5bd360b6390e98) return new $cw1rg.Inl($cw1rg.NoArguments.value);
        if (x instanceof $3fd27b134c85cda7$export$989167234458594d) return new $cw1rg.Inr(new $cw1rg.Inl(x.value0));
        if (x instanceof $3fd27b134c85cda7$export$d046b3c4a416f60d) return new $cw1rg.Inr(new $cw1rg.Inr(new $cw1rg.Inl($cw1rg.NoArguments.value)));
        if (x instanceof $3fd27b134c85cda7$export$8f6fcf85ae6713b3) return new $cw1rg.Inr(new $cw1rg.Inr(new $cw1rg.Inr(new $cw1rg.Inl($cw1rg.NoArguments.value))));
        if (x instanceof $3fd27b134c85cda7$export$2d72370f04ddc1a1) return new $cw1rg.Inr(new $cw1rg.Inr(new $cw1rg.Inr(new $cw1rg.Inr($cw1rg.NoArguments.value))));
        throw new Error("Failed pattern match at Lexeme (line 44, column 1 - line 44, column 50): " + [
            x.constructor.name
        ]);
    }
};
var $3fd27b134c85cda7$export$188ef90131b17b70 = {
    show: /* #__PURE__ */ $7eHfd.genericShow($3fd27b134c85cda7$export$95f8b977bef6249b)(/* #__PURE__ */ $7eHfd.genericShowSum(/* #__PURE__ */ $3fd27b134c85cda7$var$genericShowConstructor({
        reflectSymbol: function() {
            return "Lambda";
        }
    }))(/* #__PURE__ */ $7eHfd.genericShowSum(/* #__PURE__ */ $7eHfd.genericShowConstructor(/* #__PURE__ */ $7eHfd.genericShowArgsArgument($3Orkn.showString))({
        reflectSymbol: function() {
            return "Identifier";
        }
    }))(/* #__PURE__ */ $7eHfd.genericShowSum(/* #__PURE__ */ $3fd27b134c85cda7$var$genericShowConstructor({
        reflectSymbol: function() {
            return "Dot";
        }
    }))(/* #__PURE__ */ $7eHfd.genericShowSum(/* #__PURE__ */ $3fd27b134c85cda7$var$genericShowConstructor({
        reflectSymbol: function() {
            return "OpenParen";
        }
    }))(/* #__PURE__ */ $3fd27b134c85cda7$var$genericShowConstructor({
        reflectSymbol: function() {
            return "CloseParen";
        }
    }))))))
};
var $3fd27b134c85cda7$export$2b513308e642d699 = function(dictMonadRec) {
    var genAlphaString = $79GDW.genAlphaString(dictMonadRec);
    return function(dictMonadGen) {
        var Monad0 = dictMonadGen.Monad0();
        return $8D18I.oneOf(dictMonadGen)($cwMDv.foldable1NonEmptyArray)($jxBf5.cons$prime($l0wDR.map(Monad0.Bind1().Apply0().Functor0())($3fd27b134c85cda7$export$989167234458594d.create)(genAlphaString(dictMonadGen)))($3fd27b134c85cda7$var$map1($gUTA8.pure(Monad0.Applicative0()))([
            $3fd27b134c85cda7$export$4d5bd360b6390e98.value,
            $3fd27b134c85cda7$export$d046b3c4a416f60d.value,
            $3fd27b134c85cda7$export$8f6fcf85ae6713b3.value,
            $3fd27b134c85cda7$export$2d72370f04ddc1a1.value
        ])));
    };
};
var $3fd27b134c85cda7$export$6525700e0232a3f5 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $3fd27b134c85cda7$export$4d5bd360b6390e98 && y instanceof $3fd27b134c85cda7$export$4d5bd360b6390e98) return true;
            if (x instanceof $3fd27b134c85cda7$export$989167234458594d && y instanceof $3fd27b134c85cda7$export$989167234458594d) return x.value0 === y.value0;
            if (x instanceof $3fd27b134c85cda7$export$d046b3c4a416f60d && y instanceof $3fd27b134c85cda7$export$d046b3c4a416f60d) return true;
            if (x instanceof $3fd27b134c85cda7$export$8f6fcf85ae6713b3 && y instanceof $3fd27b134c85cda7$export$8f6fcf85ae6713b3) return true;
            if (x instanceof $3fd27b134c85cda7$export$2d72370f04ddc1a1 && y instanceof $3fd27b134c85cda7$export$2d72370f04ddc1a1) return true;
            return false;
        };
    }
};
var $3fd27b134c85cda7$var$eq1 = /* #__PURE__ */ $4MBcA.eq($3fd27b134c85cda7$export$6525700e0232a3f5);
var $3fd27b134c85cda7$export$580e507dd0b42f5 = function(x) {
    return $aKY4H.either($l4M7e.const(false))(function(v) {
        return $3fd27b134c85cda7$var$eq1(x)(v);
    })($3J9zV.runParser($3fd27b134c85cda7$export$c2d084dc44961371(x))($3fd27b134c85cda7$export$8f49e4af10703ce3));
};

});
parcelRegister("eWReo", function(module, exports) {

$parcel$export(module.exports, "toLower", () => $ae1fc60b21f03c62$export$b1ceac3893cbda6b);
$parcel$export(module.exports, "toUpper", () => $ae1fc60b21f03c62$export$43df7fc17cca38a4);
$parcel$export(module.exports, "toLowerSimple", () => $ae1fc60b21f03c62$export$3407ec4ae1791d82);
$parcel$export(module.exports, "toUpperSimple", () => $ae1fc60b21f03c62$export$758e327c875e235b);
$parcel$export(module.exports, "isUpper", () => $ae1fc60b21f03c62$export$ae50dec7acbeb690);
$parcel$export(module.exports, "isSpace", () => $ae1fc60b21f03c62$export$1d5ccafae59b4926);
$parcel$export(module.exports, "isOctDigit", () => $ae1fc60b21f03c62$export$537eb6b62c8dbc27);
$parcel$export(module.exports, "isLower", () => $ae1fc60b21f03c62$export$612428811da8e7ba);
$parcel$export(module.exports, "isDecDigit", () => $ae1fc60b21f03c62$export$e03c54e9ed5bdad0);
$parcel$export(module.exports, "isHexDigit", () => $ae1fc60b21f03c62$export$2a81dc4d1a2f9334);
$parcel$export(module.exports, "isAlphaNum", () => $ae1fc60b21f03c62$export$bbe6438367709b6a);
$parcel$export(module.exports, "isAlpha", () => $ae1fc60b21f03c62$export$4f1b4fd0a80ed3b5);
$parcel$export(module.exports, "hexDigitToInt", () => $ae1fc60b21f03c62$export$a9520415cc1c4631);
$parcel$export(module.exports, "isLetter", () => $ae1fc60b21f03c62$export$79c5d5217943d6a7);
$parcel$export(module.exports, "caseFoldSimple", () => $ae1fc60b21f03c62$export$aa379662b51020a0);
$parcel$export(module.exports, "caseFold", () => $ae1fc60b21f03c62$export$ed703a87961582a2);
// Generated by purs version 0.15.16

var $6UHO6 = parcelRequire("6UHO6");

var $6VC7y = parcelRequire("6VC7y");

var $lkGFT = parcelRequire("lkGFT");

var $ayTiF = parcelRequire("ayTiF");

var $loxi1 = parcelRequire("loxi1");

var $l0wDR = parcelRequire("l0wDR");

var $ykHdR = parcelRequire("ykHdR");

var $d0PPW = parcelRequire("d0PPW");

var $5oIYL = parcelRequire("5oIYL");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");
var $ae1fc60b21f03c62$var$fromEnum = /* #__PURE__ */ $loxi1.fromEnum($5oIYL.boundedEnumCodePoint);
var $ae1fc60b21f03c62$var$lessThanOrEq1 = /* #__PURE__ */ $d0PPW.lessThanOrEq($5oIYL.ordCodePoint);
var $ae1fc60b21f03c62$var$greaterThanOrEq1 = /* #__PURE__ */ $d0PPW.greaterThanOrEq($5oIYL.ordCodePoint);
var $ae1fc60b21f03c62$var$lessThan = /* #__PURE__ */ $d0PPW.lessThan($5oIYL.ordCodePoint);
var $ae1fc60b21f03c62$var$compare = /* #__PURE__ */ $d0PPW.compare($d0PPW.ordInt);
var $ae1fc60b21f03c62$export$ba163c2257d3dcff = /* #__PURE__ */ function() {
    function UppercaseLetter() {}
    UppercaseLetter.value = new UppercaseLetter();
    return UppercaseLetter;
}();
var $ae1fc60b21f03c62$export$f97856bb28e7278d = /* #__PURE__ */ function() {
    function LowercaseLetter() {}
    LowercaseLetter.value = new LowercaseLetter();
    return LowercaseLetter;
}();
var $ae1fc60b21f03c62$export$ee42eb148e8da2d3 = /* #__PURE__ */ function() {
    function TitlecaseLetter() {}
    TitlecaseLetter.value = new TitlecaseLetter();
    return TitlecaseLetter;
}();
var $ae1fc60b21f03c62$export$1143edeb415eb3db = /* #__PURE__ */ function() {
    function ModifierLetter() {}
    ModifierLetter.value = new ModifierLetter();
    return ModifierLetter;
}();
var $ae1fc60b21f03c62$export$bc7f3db2d3cba36f = /* #__PURE__ */ function() {
    function OtherLetter() {}
    OtherLetter.value = new OtherLetter();
    return OtherLetter;
}();
var $ae1fc60b21f03c62$export$f196939a6e3c6116 = /* #__PURE__ */ function() {
    function NonSpacingMark() {}
    NonSpacingMark.value = new NonSpacingMark();
    return NonSpacingMark;
}();
var $ae1fc60b21f03c62$export$88093afafbb74ea5 = /* #__PURE__ */ function() {
    function SpacingCombiningMark() {}
    SpacingCombiningMark.value = new SpacingCombiningMark();
    return SpacingCombiningMark;
}();
var $ae1fc60b21f03c62$export$5d50d5f906d4a533 = /* #__PURE__ */ function() {
    function EnclosingMark() {}
    EnclosingMark.value = new EnclosingMark();
    return EnclosingMark;
}();
var $ae1fc60b21f03c62$export$b6fbbffa48fbb725 = /* #__PURE__ */ function() {
    function DecimalNumber() {}
    DecimalNumber.value = new DecimalNumber();
    return DecimalNumber;
}();
var $ae1fc60b21f03c62$export$24be45a284e3902b = /* #__PURE__ */ function() {
    function LetterNumber() {}
    LetterNumber.value = new LetterNumber();
    return LetterNumber;
}();
var $ae1fc60b21f03c62$export$94c512b4b5438d90 = /* #__PURE__ */ function() {
    function OtherNumber() {}
    OtherNumber.value = new OtherNumber();
    return OtherNumber;
}();
var $ae1fc60b21f03c62$export$befef8e3bda25d8d = /* #__PURE__ */ function() {
    function ConnectorPunctuation() {}
    ConnectorPunctuation.value = new ConnectorPunctuation();
    return ConnectorPunctuation;
}();
var $ae1fc60b21f03c62$export$f65249b82daae727 = /* #__PURE__ */ function() {
    function DashPunctuation() {}
    DashPunctuation.value = new DashPunctuation();
    return DashPunctuation;
}();
var $ae1fc60b21f03c62$export$91846c2aea856cce = /* #__PURE__ */ function() {
    function OpenPunctuation() {}
    OpenPunctuation.value = new OpenPunctuation();
    return OpenPunctuation;
}();
var $ae1fc60b21f03c62$export$a4d3a0253b65f083 = /* #__PURE__ */ function() {
    function ClosePunctuation() {}
    ClosePunctuation.value = new ClosePunctuation();
    return ClosePunctuation;
}();
var $ae1fc60b21f03c62$export$35d55de78258e09c = /* #__PURE__ */ function() {
    function InitialQuote() {}
    InitialQuote.value = new InitialQuote();
    return InitialQuote;
}();
var $ae1fc60b21f03c62$export$84e1e73db8a6fcf4 = /* #__PURE__ */ function() {
    function FinalQuote() {}
    FinalQuote.value = new FinalQuote();
    return FinalQuote;
}();
var $ae1fc60b21f03c62$export$7bc2110f87f79574 = /* #__PURE__ */ function() {
    function OtherPunctuation() {}
    OtherPunctuation.value = new OtherPunctuation();
    return OtherPunctuation;
}();
var $ae1fc60b21f03c62$export$2d8ad6e0bc55950e = /* #__PURE__ */ function() {
    function MathSymbol() {}
    MathSymbol.value = new MathSymbol();
    return MathSymbol;
}();
var $ae1fc60b21f03c62$export$45568c72b5c00715 = /* #__PURE__ */ function() {
    function CurrencySymbol() {}
    CurrencySymbol.value = new CurrencySymbol();
    return CurrencySymbol;
}();
var $ae1fc60b21f03c62$export$44424ac90397f38c = /* #__PURE__ */ function() {
    function ModifierSymbol() {}
    ModifierSymbol.value = new ModifierSymbol();
    return ModifierSymbol;
}();
var $ae1fc60b21f03c62$export$f602d6b39d1f67cf = /* #__PURE__ */ function() {
    function OtherSymbol() {}
    OtherSymbol.value = new OtherSymbol();
    return OtherSymbol;
}();
var $ae1fc60b21f03c62$export$eef1e68107c58ef2 = /* #__PURE__ */ function() {
    function Space() {}
    Space.value = new Space();
    return Space;
}();
var $ae1fc60b21f03c62$export$d3714c887ff0b3a1 = /* #__PURE__ */ function() {
    function LineSeparator() {}
    LineSeparator.value = new LineSeparator();
    return LineSeparator;
}();
var $ae1fc60b21f03c62$export$55d91bb2895e56f6 = /* #__PURE__ */ function() {
    function ParagraphSeparator() {}
    ParagraphSeparator.value = new ParagraphSeparator();
    return ParagraphSeparator;
}();
var $ae1fc60b21f03c62$export$7a7fa4424cb20976 = /* #__PURE__ */ function() {
    function Control() {}
    Control.value = new Control();
    return Control;
}();
var $ae1fc60b21f03c62$export$93514d28bd18d75a = /* #__PURE__ */ function() {
    function Format() {}
    Format.value = new Format();
    return Format;
}();
var $ae1fc60b21f03c62$export$47ecfea156e07ce1 = /* #__PURE__ */ function() {
    function Surrogate() {}
    Surrogate.value = new Surrogate();
    return Surrogate;
}();
var $ae1fc60b21f03c62$export$99814c886715a026 = /* #__PURE__ */ function() {
    function PrivateUse() {}
    PrivateUse.value = new PrivateUse();
    return PrivateUse;
}();
var $ae1fc60b21f03c62$export$6f449c45ca2e4ef5 = /* #__PURE__ */ function() {
    function NotAssigned() {}
    NotAssigned.value = new NotAssigned();
    return NotAssigned;
}();
var $ae1fc60b21f03c62$export$8c566994308f50f1 = function(v) {
    if (v instanceof $lkGFT.NUMCAT_LU) return $ae1fc60b21f03c62$export$ba163c2257d3dcff.value;
    if (v instanceof $lkGFT.NUMCAT_LL) return $ae1fc60b21f03c62$export$f97856bb28e7278d.value;
    if (v instanceof $lkGFT.NUMCAT_LT) return $ae1fc60b21f03c62$export$ee42eb148e8da2d3.value;
    if (v instanceof $lkGFT.NUMCAT_LM) return $ae1fc60b21f03c62$export$1143edeb415eb3db.value;
    if (v instanceof $lkGFT.NUMCAT_LO) return $ae1fc60b21f03c62$export$bc7f3db2d3cba36f.value;
    if (v instanceof $lkGFT.NUMCAT_MN) return $ae1fc60b21f03c62$export$f196939a6e3c6116.value;
    if (v instanceof $lkGFT.NUMCAT_MC) return $ae1fc60b21f03c62$export$88093afafbb74ea5.value;
    if (v instanceof $lkGFT.NUMCAT_ME) return $ae1fc60b21f03c62$export$5d50d5f906d4a533.value;
    if (v instanceof $lkGFT.NUMCAT_ND) return $ae1fc60b21f03c62$export$b6fbbffa48fbb725.value;
    if (v instanceof $lkGFT.NUMCAT_NL) return $ae1fc60b21f03c62$export$24be45a284e3902b.value;
    if (v instanceof $lkGFT.NUMCAT_NO) return $ae1fc60b21f03c62$export$94c512b4b5438d90.value;
    if (v instanceof $lkGFT.NUMCAT_PC) return $ae1fc60b21f03c62$export$befef8e3bda25d8d.value;
    if (v instanceof $lkGFT.NUMCAT_PD) return $ae1fc60b21f03c62$export$f65249b82daae727.value;
    if (v instanceof $lkGFT.NUMCAT_PS) return $ae1fc60b21f03c62$export$91846c2aea856cce.value;
    if (v instanceof $lkGFT.NUMCAT_PE) return $ae1fc60b21f03c62$export$a4d3a0253b65f083.value;
    if (v instanceof $lkGFT.NUMCAT_PI) return $ae1fc60b21f03c62$export$35d55de78258e09c.value;
    if (v instanceof $lkGFT.NUMCAT_PF) return $ae1fc60b21f03c62$export$84e1e73db8a6fcf4.value;
    if (v instanceof $lkGFT.NUMCAT_PO) return $ae1fc60b21f03c62$export$7bc2110f87f79574.value;
    if (v instanceof $lkGFT.NUMCAT_SM) return $ae1fc60b21f03c62$export$2d8ad6e0bc55950e.value;
    if (v instanceof $lkGFT.NUMCAT_SC) return $ae1fc60b21f03c62$export$45568c72b5c00715.value;
    if (v instanceof $lkGFT.NUMCAT_SK) return $ae1fc60b21f03c62$export$44424ac90397f38c.value;
    if (v instanceof $lkGFT.NUMCAT_SO) return $ae1fc60b21f03c62$export$f602d6b39d1f67cf.value;
    if (v instanceof $lkGFT.NUMCAT_ZS) return $ae1fc60b21f03c62$export$eef1e68107c58ef2.value;
    if (v instanceof $lkGFT.NUMCAT_ZL) return $ae1fc60b21f03c62$export$d3714c887ff0b3a1.value;
    if (v instanceof $lkGFT.NUMCAT_ZP) return $ae1fc60b21f03c62$export$55d91bb2895e56f6.value;
    if (v instanceof $lkGFT.NUMCAT_CC) return $ae1fc60b21f03c62$export$7a7fa4424cb20976.value;
    if (v instanceof $lkGFT.NUMCAT_CF) return $ae1fc60b21f03c62$export$93514d28bd18d75a.value;
    if (v instanceof $lkGFT.NUMCAT_CS) return $ae1fc60b21f03c62$export$47ecfea156e07ce1.value;
    if (v instanceof $lkGFT.NUMCAT_CO) return $ae1fc60b21f03c62$export$99814c886715a026.value;
    if (v instanceof $lkGFT.NUMCAT_CN) return $ae1fc60b21f03c62$export$6f449c45ca2e4ef5.value;
    throw new Error("Failed pattern match at Data.CodePoint.Unicode (line 206, column 1 - line 206, column 61): " + [
        v.constructor.name
    ]);
};
var $ae1fc60b21f03c62$export$261cacb5fb2d0b3c = {
    show: function(v) {
        if (v instanceof $ae1fc60b21f03c62$export$ba163c2257d3dcff) return "UppercaseLetter";
        if (v instanceof $ae1fc60b21f03c62$export$f97856bb28e7278d) return "LowercaseLetter";
        if (v instanceof $ae1fc60b21f03c62$export$ee42eb148e8da2d3) return "TitlecaseLetter";
        if (v instanceof $ae1fc60b21f03c62$export$1143edeb415eb3db) return "ModifierLetter";
        if (v instanceof $ae1fc60b21f03c62$export$bc7f3db2d3cba36f) return "OtherLetter";
        if (v instanceof $ae1fc60b21f03c62$export$f196939a6e3c6116) return "NonSpacingMark";
        if (v instanceof $ae1fc60b21f03c62$export$88093afafbb74ea5) return "SpacingCombiningMark";
        if (v instanceof $ae1fc60b21f03c62$export$5d50d5f906d4a533) return "EnclosingMark";
        if (v instanceof $ae1fc60b21f03c62$export$b6fbbffa48fbb725) return "DecimalNumber";
        if (v instanceof $ae1fc60b21f03c62$export$24be45a284e3902b) return "LetterNumber";
        if (v instanceof $ae1fc60b21f03c62$export$94c512b4b5438d90) return "OtherNumber";
        if (v instanceof $ae1fc60b21f03c62$export$befef8e3bda25d8d) return "ConnectorPunctuation";
        if (v instanceof $ae1fc60b21f03c62$export$f65249b82daae727) return "DashPunctuation";
        if (v instanceof $ae1fc60b21f03c62$export$91846c2aea856cce) return "OpenPunctuation";
        if (v instanceof $ae1fc60b21f03c62$export$a4d3a0253b65f083) return "ClosePunctuation";
        if (v instanceof $ae1fc60b21f03c62$export$35d55de78258e09c) return "InitialQuote";
        if (v instanceof $ae1fc60b21f03c62$export$84e1e73db8a6fcf4) return "FinalQuote";
        if (v instanceof $ae1fc60b21f03c62$export$7bc2110f87f79574) return "OtherPunctuation";
        if (v instanceof $ae1fc60b21f03c62$export$2d8ad6e0bc55950e) return "MathSymbol";
        if (v instanceof $ae1fc60b21f03c62$export$45568c72b5c00715) return "CurrencySymbol";
        if (v instanceof $ae1fc60b21f03c62$export$44424ac90397f38c) return "ModifierSymbol";
        if (v instanceof $ae1fc60b21f03c62$export$f602d6b39d1f67cf) return "OtherSymbol";
        if (v instanceof $ae1fc60b21f03c62$export$eef1e68107c58ef2) return "Space";
        if (v instanceof $ae1fc60b21f03c62$export$d3714c887ff0b3a1) return "LineSeparator";
        if (v instanceof $ae1fc60b21f03c62$export$55d91bb2895e56f6) return "ParagraphSeparator";
        if (v instanceof $ae1fc60b21f03c62$export$7a7fa4424cb20976) return "Control";
        if (v instanceof $ae1fc60b21f03c62$export$93514d28bd18d75a) return "Format";
        if (v instanceof $ae1fc60b21f03c62$export$47ecfea156e07ce1) return "Surrogate";
        if (v instanceof $ae1fc60b21f03c62$export$99814c886715a026) return "PrivateUse";
        if (v instanceof $ae1fc60b21f03c62$export$6f449c45ca2e4ef5) return "NotAssigned";
        throw new Error("Failed pattern match at Data.CodePoint.Unicode (line 238, column 1 - line 268, column 35): " + [
            v.constructor.name
        ]);
    }
};
var $ae1fc60b21f03c62$var$modifyFull = $eOrGk.unsafeCoerce;
var $ae1fc60b21f03c62$export$b1ceac3893cbda6b = /* #__PURE__ */ $ae1fc60b21f03c62$var$modifyFull($ayTiF.lower);
var $ae1fc60b21f03c62$export$1294308be85b4eca = /* #__PURE__ */ $ae1fc60b21f03c62$var$modifyFull($ayTiF.title);
var $ae1fc60b21f03c62$export$43df7fc17cca38a4 = /* #__PURE__ */ $ae1fc60b21f03c62$var$modifyFull($ayTiF.upper);
var $ae1fc60b21f03c62$var$modify = $eOrGk.unsafeCoerce;
var $ae1fc60b21f03c62$export$3407ec4ae1791d82 = /* #__PURE__ */ $ae1fc60b21f03c62$var$modify($lkGFT.uTowlower);
var $ae1fc60b21f03c62$export$ce8e628e067c78e7 = /* #__PURE__ */ $ae1fc60b21f03c62$var$modify($lkGFT.uTowtitle);
var $ae1fc60b21f03c62$export$758e327c875e235b = /* #__PURE__ */ $ae1fc60b21f03c62$var$modify($lkGFT.uTowupper);
var $ae1fc60b21f03c62$export$ae50dec7acbeb690 = function($66) {
    return $lkGFT.uIswupper($ae1fc60b21f03c62$var$fromEnum($66));
};
var $ae1fc60b21f03c62$export$1d5ccafae59b4926 = function(c) {
    var uc = $ae1fc60b21f03c62$var$fromEnum(c);
    var $28 = uc <= 823;
    if ($28) return uc === 32 || uc >= 9 && uc <= 13 || uc === 160;
    return $lkGFT.uIswspace(uc);
};
var $ae1fc60b21f03c62$export$70fd39c87e72de00 = function($67) {
    return $lkGFT.uIswprint($ae1fc60b21f03c62$var$fromEnum($67));
};
var $ae1fc60b21f03c62$export$537eb6b62c8dbc27 = function(c) {
    var diff = $ae1fc60b21f03c62$var$fromEnum(c) - $6VC7y.toCharCode("0") | 0;
    return diff <= 7 && diff >= 0;
};
var $ae1fc60b21f03c62$export$e826a59393915b9 = function(c) {
    if ($ae1fc60b21f03c62$export$537eb6b62c8dbc27(c)) return new $ykHdR.Just($ae1fc60b21f03c62$var$fromEnum(c) - $6VC7y.toCharCode("0") | 0);
    if ($6UHO6.otherwise) return $ykHdR.Nothing.value;
    throw new Error("Failed pattern match at Data.CodePoint.Unicode (line 636, column 1 - line 636, column 40): " + [
        c.constructor.name
    ]);
};
var $ae1fc60b21f03c62$export$612428811da8e7ba = function($68) {
    return $lkGFT.uIswlower($ae1fc60b21f03c62$var$fromEnum($68));
};
var $ae1fc60b21f03c62$export$a33149e31f083a2b = function(c) {
    return $ae1fc60b21f03c62$var$lessThanOrEq1(c)($5oIYL.codePointFromChar("\xff"));
};
var $ae1fc60b21f03c62$export$e03c54e9ed5bdad0 = function(c) {
    var diff = $ae1fc60b21f03c62$var$fromEnum(c) - $6VC7y.toCharCode("0") | 0;
    return diff <= 9 && diff >= 0;
};
var $ae1fc60b21f03c62$export$727d9dbc4fbb948f = function() {
    return $ae1fc60b21f03c62$export$e03c54e9ed5bdad0;
};
var $ae1fc60b21f03c62$export$2a81dc4d1a2f9334 = function(c) {
    return $ae1fc60b21f03c62$export$e03c54e9ed5bdad0(c) || function() {
        var diff = $ae1fc60b21f03c62$var$fromEnum(c) - $6VC7y.toCharCode("A") | 0;
        return diff <= 5 && diff >= 0;
    }() || function() {
        var diff = $ae1fc60b21f03c62$var$fromEnum(c) - $6VC7y.toCharCode("a") | 0;
        return diff <= 5 && diff >= 0;
    }();
};
var $ae1fc60b21f03c62$export$5a68459d5634ec09 = function($69) {
    return $lkGFT.uIswcntrl($ae1fc60b21f03c62$var$fromEnum($69));
};
var $ae1fc60b21f03c62$export$66b98c3a43d12999 = function(c) {
    return $ae1fc60b21f03c62$var$greaterThanOrEq1(c)($5oIYL.codePointFromChar("A")) && $ae1fc60b21f03c62$var$lessThanOrEq1(c)($5oIYL.codePointFromChar("Z"));
};
var $ae1fc60b21f03c62$export$201a409c4b42ac0d = function(c) {
    return $ae1fc60b21f03c62$var$greaterThanOrEq1(c)($5oIYL.codePointFromChar("a")) && $ae1fc60b21f03c62$var$lessThanOrEq1(c)($5oIYL.codePointFromChar("z"));
};
var $ae1fc60b21f03c62$export$5687edf39827d1cd = function(c) {
    return $ae1fc60b21f03c62$var$lessThan(c)($5oIYL.codePointFromChar("\x80"));
};
var $ae1fc60b21f03c62$export$bbe6438367709b6a = function($70) {
    return $lkGFT.uIswalnum($ae1fc60b21f03c62$var$fromEnum($70));
};
var $ae1fc60b21f03c62$export$4f1b4fd0a80ed3b5 = function($71) {
    return $lkGFT.uIswalpha($ae1fc60b21f03c62$var$fromEnum($71));
};
var $ae1fc60b21f03c62$export$a9520415cc1c4631 = function(c) {
    var hexUpper = $ae1fc60b21f03c62$var$fromEnum(c) - $6VC7y.toCharCode("A") | 0;
    var hexLower = $ae1fc60b21f03c62$var$fromEnum(c) - $6VC7y.toCharCode("a") | 0;
    var dec = $ae1fc60b21f03c62$var$fromEnum(c) - $6VC7y.toCharCode("0") | 0;
    var result = function() {
        if (dec <= 9 && dec >= 0) return new $ykHdR.Just(dec);
        if (hexLower <= 5 && hexLower >= 0) return new $ykHdR.Just(hexLower + 10 | 0);
        if (hexUpper <= 5 && hexUpper >= 0) return new $ykHdR.Just(hexUpper + 10 | 0);
        if ($6UHO6.otherwise) return $ykHdR.Nothing.value;
        throw new Error("Failed pattern match at Data.CodePoint.Unicode (line 591, column 3 - line 591, column 22): ");
    }();
    return result;
};
var $ae1fc60b21f03c62$export$6476fa500734b59e = /* #__PURE__ */ function() {
    var $72 = $l0wDR.map($ykHdR.functorMaybe)($ae1fc60b21f03c62$export$8c566994308f50f1);
    return function($73) {
        return $72($lkGFT.uGencat($ae1fc60b21f03c62$var$fromEnum($73)));
    };
}();
var $ae1fc60b21f03c62$export$79c5d5217943d6a7 = function(c) {
    var v = $ae1fc60b21f03c62$export$6476fa500734b59e(c);
    if (v instanceof $ykHdR.Just && v.value0 instanceof $ae1fc60b21f03c62$export$ba163c2257d3dcff) return true;
    if (v instanceof $ykHdR.Just && v.value0 instanceof $ae1fc60b21f03c62$export$f97856bb28e7278d) return true;
    if (v instanceof $ykHdR.Just && v.value0 instanceof $ae1fc60b21f03c62$export$ee42eb148e8da2d3) return true;
    if (v instanceof $ykHdR.Just && v.value0 instanceof $ae1fc60b21f03c62$export$1143edeb415eb3db) return true;
    if (v instanceof $ykHdR.Just && v.value0 instanceof $ae1fc60b21f03c62$export$bc7f3db2d3cba36f) return true;
    return false;
};
var $ae1fc60b21f03c62$export$e33ad6871e762338 = function(c) {
    var v = $ae1fc60b21f03c62$export$6476fa500734b59e(c);
    if (v instanceof $ykHdR.Just && v.value0 instanceof $ae1fc60b21f03c62$export$f196939a6e3c6116) return true;
    if (v instanceof $ykHdR.Just && v.value0 instanceof $ae1fc60b21f03c62$export$88093afafbb74ea5) return true;
    if (v instanceof $ykHdR.Just && v.value0 instanceof $ae1fc60b21f03c62$export$5d50d5f906d4a533) return true;
    return false;
};
var $ae1fc60b21f03c62$export$7e4aa119212bc614 = function(c) {
    var v = $ae1fc60b21f03c62$export$6476fa500734b59e(c);
    if (v instanceof $ykHdR.Just && v.value0 instanceof $ae1fc60b21f03c62$export$b6fbbffa48fbb725) return true;
    if (v instanceof $ykHdR.Just && v.value0 instanceof $ae1fc60b21f03c62$export$24be45a284e3902b) return true;
    if (v instanceof $ykHdR.Just && v.value0 instanceof $ae1fc60b21f03c62$export$94c512b4b5438d90) return true;
    return false;
};
var $ae1fc60b21f03c62$export$a5b49f4dc6a07d2c = function(c) {
    var v = $ae1fc60b21f03c62$export$6476fa500734b59e(c);
    if (v instanceof $ykHdR.Just && v.value0 instanceof $ae1fc60b21f03c62$export$befef8e3bda25d8d) return true;
    if (v instanceof $ykHdR.Just && v.value0 instanceof $ae1fc60b21f03c62$export$f65249b82daae727) return true;
    if (v instanceof $ykHdR.Just && v.value0 instanceof $ae1fc60b21f03c62$export$91846c2aea856cce) return true;
    if (v instanceof $ykHdR.Just && v.value0 instanceof $ae1fc60b21f03c62$export$a4d3a0253b65f083) return true;
    if (v instanceof $ykHdR.Just && v.value0 instanceof $ae1fc60b21f03c62$export$35d55de78258e09c) return true;
    if (v instanceof $ykHdR.Just && v.value0 instanceof $ae1fc60b21f03c62$export$84e1e73db8a6fcf4) return true;
    if (v instanceof $ykHdR.Just && v.value0 instanceof $ae1fc60b21f03c62$export$7bc2110f87f79574) return true;
    return false;
};
var $ae1fc60b21f03c62$export$aa03971fc638f7dd = function(c) {
    var v = $ae1fc60b21f03c62$export$6476fa500734b59e(c);
    if (v instanceof $ykHdR.Just && v.value0 instanceof $ae1fc60b21f03c62$export$eef1e68107c58ef2) return true;
    if (v instanceof $ykHdR.Just && v.value0 instanceof $ae1fc60b21f03c62$export$d3714c887ff0b3a1) return true;
    if (v instanceof $ykHdR.Just && v.value0 instanceof $ae1fc60b21f03c62$export$55d91bb2895e56f6) return true;
    return false;
};
var $ae1fc60b21f03c62$export$a244864fd9645c7f = function(c) {
    var v = $ae1fc60b21f03c62$export$6476fa500734b59e(c);
    if (v instanceof $ykHdR.Just && v.value0 instanceof $ae1fc60b21f03c62$export$2d8ad6e0bc55950e) return true;
    if (v instanceof $ykHdR.Just && v.value0 instanceof $ae1fc60b21f03c62$export$45568c72b5c00715) return true;
    if (v instanceof $ykHdR.Just && v.value0 instanceof $ae1fc60b21f03c62$export$44424ac90397f38c) return true;
    if (v instanceof $ykHdR.Just && v.value0 instanceof $ae1fc60b21f03c62$export$f602d6b39d1f67cf) return true;
    return false;
};
var $ae1fc60b21f03c62$export$d47bed3dfc848b44 = function(v) {
    if (v instanceof $ae1fc60b21f03c62$export$ba163c2257d3dcff) return $lkGFT.NUMCAT_LU.value;
    if (v instanceof $ae1fc60b21f03c62$export$f97856bb28e7278d) return $lkGFT.NUMCAT_LL.value;
    if (v instanceof $ae1fc60b21f03c62$export$ee42eb148e8da2d3) return $lkGFT.NUMCAT_LT.value;
    if (v instanceof $ae1fc60b21f03c62$export$1143edeb415eb3db) return $lkGFT.NUMCAT_LM.value;
    if (v instanceof $ae1fc60b21f03c62$export$bc7f3db2d3cba36f) return $lkGFT.NUMCAT_LO.value;
    if (v instanceof $ae1fc60b21f03c62$export$f196939a6e3c6116) return $lkGFT.NUMCAT_MN.value;
    if (v instanceof $ae1fc60b21f03c62$export$88093afafbb74ea5) return $lkGFT.NUMCAT_MC.value;
    if (v instanceof $ae1fc60b21f03c62$export$5d50d5f906d4a533) return $lkGFT.NUMCAT_ME.value;
    if (v instanceof $ae1fc60b21f03c62$export$b6fbbffa48fbb725) return $lkGFT.NUMCAT_ND.value;
    if (v instanceof $ae1fc60b21f03c62$export$24be45a284e3902b) return $lkGFT.NUMCAT_NL.value;
    if (v instanceof $ae1fc60b21f03c62$export$94c512b4b5438d90) return $lkGFT.NUMCAT_NO.value;
    if (v instanceof $ae1fc60b21f03c62$export$befef8e3bda25d8d) return $lkGFT.NUMCAT_PC.value;
    if (v instanceof $ae1fc60b21f03c62$export$f65249b82daae727) return $lkGFT.NUMCAT_PD.value;
    if (v instanceof $ae1fc60b21f03c62$export$91846c2aea856cce) return $lkGFT.NUMCAT_PS.value;
    if (v instanceof $ae1fc60b21f03c62$export$a4d3a0253b65f083) return $lkGFT.NUMCAT_PE.value;
    if (v instanceof $ae1fc60b21f03c62$export$35d55de78258e09c) return $lkGFT.NUMCAT_PI.value;
    if (v instanceof $ae1fc60b21f03c62$export$84e1e73db8a6fcf4) return $lkGFT.NUMCAT_PF.value;
    if (v instanceof $ae1fc60b21f03c62$export$7bc2110f87f79574) return $lkGFT.NUMCAT_PO.value;
    if (v instanceof $ae1fc60b21f03c62$export$2d8ad6e0bc55950e) return $lkGFT.NUMCAT_SM.value;
    if (v instanceof $ae1fc60b21f03c62$export$45568c72b5c00715) return $lkGFT.NUMCAT_SC.value;
    if (v instanceof $ae1fc60b21f03c62$export$44424ac90397f38c) return $lkGFT.NUMCAT_SK.value;
    if (v instanceof $ae1fc60b21f03c62$export$f602d6b39d1f67cf) return $lkGFT.NUMCAT_SO.value;
    if (v instanceof $ae1fc60b21f03c62$export$eef1e68107c58ef2) return $lkGFT.NUMCAT_ZS.value;
    if (v instanceof $ae1fc60b21f03c62$export$d3714c887ff0b3a1) return $lkGFT.NUMCAT_ZL.value;
    if (v instanceof $ae1fc60b21f03c62$export$55d91bb2895e56f6) return $lkGFT.NUMCAT_ZP.value;
    if (v instanceof $ae1fc60b21f03c62$export$7a7fa4424cb20976) return $lkGFT.NUMCAT_CC.value;
    if (v instanceof $ae1fc60b21f03c62$export$93514d28bd18d75a) return $lkGFT.NUMCAT_CF.value;
    if (v instanceof $ae1fc60b21f03c62$export$47ecfea156e07ce1) return $lkGFT.NUMCAT_CS.value;
    if (v instanceof $ae1fc60b21f03c62$export$99814c886715a026) return $lkGFT.NUMCAT_CO.value;
    if (v instanceof $ae1fc60b21f03c62$export$6f449c45ca2e4ef5) return $lkGFT.NUMCAT_CN.value;
    throw new Error("Failed pattern match at Data.CodePoint.Unicode (line 174, column 1 - line 174, column 61): " + [
        v.constructor.name
    ]);
};
var $ae1fc60b21f03c62$export$4a6f37acacca068c = function(v) {
    if (v instanceof $ae1fc60b21f03c62$export$ba163c2257d3dcff) return 1;
    if (v instanceof $ae1fc60b21f03c62$export$f97856bb28e7278d) return 2;
    if (v instanceof $ae1fc60b21f03c62$export$ee42eb148e8da2d3) return 3;
    if (v instanceof $ae1fc60b21f03c62$export$1143edeb415eb3db) return 4;
    if (v instanceof $ae1fc60b21f03c62$export$bc7f3db2d3cba36f) return 5;
    if (v instanceof $ae1fc60b21f03c62$export$f196939a6e3c6116) return 6;
    if (v instanceof $ae1fc60b21f03c62$export$88093afafbb74ea5) return 7;
    if (v instanceof $ae1fc60b21f03c62$export$5d50d5f906d4a533) return 8;
    if (v instanceof $ae1fc60b21f03c62$export$b6fbbffa48fbb725) return 9;
    if (v instanceof $ae1fc60b21f03c62$export$24be45a284e3902b) return 10;
    if (v instanceof $ae1fc60b21f03c62$export$94c512b4b5438d90) return 11;
    if (v instanceof $ae1fc60b21f03c62$export$befef8e3bda25d8d) return 12;
    if (v instanceof $ae1fc60b21f03c62$export$f65249b82daae727) return 13;
    if (v instanceof $ae1fc60b21f03c62$export$91846c2aea856cce) return 14;
    if (v instanceof $ae1fc60b21f03c62$export$a4d3a0253b65f083) return 15;
    if (v instanceof $ae1fc60b21f03c62$export$35d55de78258e09c) return 16;
    if (v instanceof $ae1fc60b21f03c62$export$84e1e73db8a6fcf4) return 17;
    if (v instanceof $ae1fc60b21f03c62$export$7bc2110f87f79574) return 18;
    if (v instanceof $ae1fc60b21f03c62$export$2d8ad6e0bc55950e) return 19;
    if (v instanceof $ae1fc60b21f03c62$export$45568c72b5c00715) return 20;
    if (v instanceof $ae1fc60b21f03c62$export$44424ac90397f38c) return 21;
    if (v instanceof $ae1fc60b21f03c62$export$f602d6b39d1f67cf) return 22;
    if (v instanceof $ae1fc60b21f03c62$export$eef1e68107c58ef2) return 23;
    if (v instanceof $ae1fc60b21f03c62$export$d3714c887ff0b3a1) return 24;
    if (v instanceof $ae1fc60b21f03c62$export$55d91bb2895e56f6) return 25;
    if (v instanceof $ae1fc60b21f03c62$export$7a7fa4424cb20976) return 26;
    if (v instanceof $ae1fc60b21f03c62$export$93514d28bd18d75a) return 27;
    if (v instanceof $ae1fc60b21f03c62$export$47ecfea156e07ce1) return 28;
    if (v instanceof $ae1fc60b21f03c62$export$99814c886715a026) return 29;
    if (v instanceof $ae1fc60b21f03c62$export$6f449c45ca2e4ef5) return 30;
    throw new Error("Failed pattern match at Data.CodePoint.Unicode (line 142, column 1 - line 142, column 42): " + [
        v.constructor.name
    ]);
};
var $ae1fc60b21f03c62$export$a33be10dfbfb0fd9 = {
    eq: function(v) {
        return function(v1) {
            if (v instanceof $ae1fc60b21f03c62$export$ba163c2257d3dcff && v1 instanceof $ae1fc60b21f03c62$export$ba163c2257d3dcff) return true;
            if (v instanceof $ae1fc60b21f03c62$export$f97856bb28e7278d && v1 instanceof $ae1fc60b21f03c62$export$f97856bb28e7278d) return true;
            if (v instanceof $ae1fc60b21f03c62$export$ee42eb148e8da2d3 && v1 instanceof $ae1fc60b21f03c62$export$ee42eb148e8da2d3) return true;
            if (v instanceof $ae1fc60b21f03c62$export$1143edeb415eb3db && v1 instanceof $ae1fc60b21f03c62$export$1143edeb415eb3db) return true;
            if (v instanceof $ae1fc60b21f03c62$export$bc7f3db2d3cba36f && v1 instanceof $ae1fc60b21f03c62$export$bc7f3db2d3cba36f) return true;
            if (v instanceof $ae1fc60b21f03c62$export$f196939a6e3c6116 && v1 instanceof $ae1fc60b21f03c62$export$f196939a6e3c6116) return true;
            if (v instanceof $ae1fc60b21f03c62$export$88093afafbb74ea5 && v1 instanceof $ae1fc60b21f03c62$export$88093afafbb74ea5) return true;
            if (v instanceof $ae1fc60b21f03c62$export$5d50d5f906d4a533 && v1 instanceof $ae1fc60b21f03c62$export$5d50d5f906d4a533) return true;
            if (v instanceof $ae1fc60b21f03c62$export$b6fbbffa48fbb725 && v1 instanceof $ae1fc60b21f03c62$export$b6fbbffa48fbb725) return true;
            if (v instanceof $ae1fc60b21f03c62$export$24be45a284e3902b && v1 instanceof $ae1fc60b21f03c62$export$24be45a284e3902b) return true;
            if (v instanceof $ae1fc60b21f03c62$export$94c512b4b5438d90 && v1 instanceof $ae1fc60b21f03c62$export$94c512b4b5438d90) return true;
            if (v instanceof $ae1fc60b21f03c62$export$befef8e3bda25d8d && v1 instanceof $ae1fc60b21f03c62$export$befef8e3bda25d8d) return true;
            if (v instanceof $ae1fc60b21f03c62$export$f65249b82daae727 && v1 instanceof $ae1fc60b21f03c62$export$f65249b82daae727) return true;
            if (v instanceof $ae1fc60b21f03c62$export$91846c2aea856cce && v1 instanceof $ae1fc60b21f03c62$export$91846c2aea856cce) return true;
            if (v instanceof $ae1fc60b21f03c62$export$a4d3a0253b65f083 && v1 instanceof $ae1fc60b21f03c62$export$a4d3a0253b65f083) return true;
            if (v instanceof $ae1fc60b21f03c62$export$35d55de78258e09c && v1 instanceof $ae1fc60b21f03c62$export$35d55de78258e09c) return true;
            if (v instanceof $ae1fc60b21f03c62$export$84e1e73db8a6fcf4 && v1 instanceof $ae1fc60b21f03c62$export$84e1e73db8a6fcf4) return true;
            if (v instanceof $ae1fc60b21f03c62$export$7bc2110f87f79574 && v1 instanceof $ae1fc60b21f03c62$export$7bc2110f87f79574) return true;
            if (v instanceof $ae1fc60b21f03c62$export$2d8ad6e0bc55950e && v1 instanceof $ae1fc60b21f03c62$export$2d8ad6e0bc55950e) return true;
            if (v instanceof $ae1fc60b21f03c62$export$45568c72b5c00715 && v1 instanceof $ae1fc60b21f03c62$export$45568c72b5c00715) return true;
            if (v instanceof $ae1fc60b21f03c62$export$44424ac90397f38c && v1 instanceof $ae1fc60b21f03c62$export$44424ac90397f38c) return true;
            if (v instanceof $ae1fc60b21f03c62$export$f602d6b39d1f67cf && v1 instanceof $ae1fc60b21f03c62$export$f602d6b39d1f67cf) return true;
            if (v instanceof $ae1fc60b21f03c62$export$eef1e68107c58ef2 && v1 instanceof $ae1fc60b21f03c62$export$eef1e68107c58ef2) return true;
            if (v instanceof $ae1fc60b21f03c62$export$d3714c887ff0b3a1 && v1 instanceof $ae1fc60b21f03c62$export$d3714c887ff0b3a1) return true;
            if (v instanceof $ae1fc60b21f03c62$export$55d91bb2895e56f6 && v1 instanceof $ae1fc60b21f03c62$export$55d91bb2895e56f6) return true;
            if (v instanceof $ae1fc60b21f03c62$export$7a7fa4424cb20976 && v1 instanceof $ae1fc60b21f03c62$export$7a7fa4424cb20976) return true;
            if (v instanceof $ae1fc60b21f03c62$export$93514d28bd18d75a && v1 instanceof $ae1fc60b21f03c62$export$93514d28bd18d75a) return true;
            if (v instanceof $ae1fc60b21f03c62$export$47ecfea156e07ce1 && v1 instanceof $ae1fc60b21f03c62$export$47ecfea156e07ce1) return true;
            if (v instanceof $ae1fc60b21f03c62$export$99814c886715a026 && v1 instanceof $ae1fc60b21f03c62$export$99814c886715a026) return true;
            if (v instanceof $ae1fc60b21f03c62$export$6f449c45ca2e4ef5 && v1 instanceof $ae1fc60b21f03c62$export$6f449c45ca2e4ef5) return true;
            return false;
        };
    }
};
var $ae1fc60b21f03c62$export$c4022f78235b5179 = {
    compare: function(catA) {
        return function(catB) {
            return $ae1fc60b21f03c62$var$compare($ae1fc60b21f03c62$export$4a6f37acacca068c(catA))($ae1fc60b21f03c62$export$4a6f37acacca068c(catB));
        };
    },
    Eq0: function() {
        return $ae1fc60b21f03c62$export$a33be10dfbfb0fd9;
    }
};
var $ae1fc60b21f03c62$export$87f6f309ec737545 = function() {
    return $ae1fc60b21f03c62$export$a9520415cc1c4631;
};
var $ae1fc60b21f03c62$export$affdad0e6d95dbf1 = function(c) {
    if ($ae1fc60b21f03c62$export$e03c54e9ed5bdad0(c)) return new $ykHdR.Just($ae1fc60b21f03c62$var$fromEnum(c) - $6VC7y.toCharCode("0") | 0);
    if ($6UHO6.otherwise) return $ykHdR.Nothing.value;
    throw new Error("Failed pattern match at Data.CodePoint.Unicode (line 619, column 1 - line 619, column 40): " + [
        c.constructor.name
    ]);
};
var $ae1fc60b21f03c62$export$aa379662b51020a0 = /* #__PURE__ */ $ae1fc60b21f03c62$var$modify($ayTiF.fold);
var $ae1fc60b21f03c62$export$ed703a87961582a2 = /* #__PURE__ */ $ae1fc60b21f03c62$var$modifyFull($ayTiF.foldFull);
var $ae1fc60b21f03c62$export$46ec243958c72e02 = /* #__PURE__ */ function() {
    return {
        bottom: $ae1fc60b21f03c62$export$ba163c2257d3dcff.value,
        top: $ae1fc60b21f03c62$export$6f449c45ca2e4ef5.value,
        Ord0: function() {
            return $ae1fc60b21f03c62$export$c4022f78235b5179;
        }
    };
}();

});
parcelRegister("6VC7y", function(module, exports) {

$parcel$export(module.exports, "toCharCode", () => $50b5a2f2b28bbba4$export$d90166409dd04e85);
$parcel$export(module.exports, "fromCharCode", () => $50b5a2f2b28bbba4$export$30216c0101da0ee0);
// Generated by purs version 0.15.16

var $loxi1 = parcelRequire("loxi1");
var $50b5a2f2b28bbba4$export$d90166409dd04e85 = /* #__PURE__ */ $loxi1.fromEnum($loxi1.boundedEnumChar);
var $50b5a2f2b28bbba4$export$30216c0101da0ee0 = /* #__PURE__ */ $loxi1.toEnum($loxi1.boundedEnumChar);

});

parcelRegister("lkGFT", function(module, exports) {

$parcel$export(module.exports, "NUMCAT_LU", () => $f87c9187b968257a$export$74fad270c4b7b59c);
$parcel$export(module.exports, "NUMCAT_LL", () => $f87c9187b968257a$export$d4598102ceb86c96);
$parcel$export(module.exports, "NUMCAT_LT", () => $f87c9187b968257a$export$676a18bdacd919c8);
$parcel$export(module.exports, "NUMCAT_LM", () => $f87c9187b968257a$export$3be55c3cc7f2867);
$parcel$export(module.exports, "NUMCAT_LO", () => $f87c9187b968257a$export$20b05fa78ae7527a);
$parcel$export(module.exports, "NUMCAT_MN", () => $f87c9187b968257a$export$79b57d103eae7039);
$parcel$export(module.exports, "NUMCAT_MC", () => $f87c9187b968257a$export$60e41f2154339dc7);
$parcel$export(module.exports, "NUMCAT_ME", () => $f87c9187b968257a$export$77f7cb14f5a8a8ea);
$parcel$export(module.exports, "NUMCAT_ND", () => $f87c9187b968257a$export$1a1df9278c5a4522);
$parcel$export(module.exports, "NUMCAT_NL", () => $f87c9187b968257a$export$ffe624f4617a733d);
$parcel$export(module.exports, "NUMCAT_NO", () => $f87c9187b968257a$export$21de707035b964f7);
$parcel$export(module.exports, "NUMCAT_PC", () => $f87c9187b968257a$export$edda2e74149c5a6e);
$parcel$export(module.exports, "NUMCAT_PD", () => $f87c9187b968257a$export$8ef7193d38bceddf);
$parcel$export(module.exports, "NUMCAT_PS", () => $f87c9187b968257a$export$a44baae05e4dd261);
$parcel$export(module.exports, "NUMCAT_PE", () => $f87c9187b968257a$export$3e12887efe278a41);
$parcel$export(module.exports, "NUMCAT_PI", () => $f87c9187b968257a$export$594ecb1526fb138a);
$parcel$export(module.exports, "NUMCAT_PF", () => $f87c9187b968257a$export$18c5ebc155f51ada);
$parcel$export(module.exports, "NUMCAT_PO", () => $f87c9187b968257a$export$e57c737c9939aaf8);
$parcel$export(module.exports, "NUMCAT_SM", () => $f87c9187b968257a$export$b699f9c90222e3b1);
$parcel$export(module.exports, "NUMCAT_SC", () => $f87c9187b968257a$export$afd75ca7ec085208);
$parcel$export(module.exports, "NUMCAT_SK", () => $f87c9187b968257a$export$fcf99045e4ea7aa7);
$parcel$export(module.exports, "NUMCAT_SO", () => $f87c9187b968257a$export$cbb37359c0c92ac5);
$parcel$export(module.exports, "NUMCAT_ZS", () => $f87c9187b968257a$export$f359e26b05cf8d05);
$parcel$export(module.exports, "NUMCAT_ZL", () => $f87c9187b968257a$export$bb5b519c0a0e45c0);
$parcel$export(module.exports, "NUMCAT_ZP", () => $f87c9187b968257a$export$c5677ea07a95661f);
$parcel$export(module.exports, "NUMCAT_CC", () => $f87c9187b968257a$export$88d4031ea4604c81);
$parcel$export(module.exports, "NUMCAT_CF", () => $f87c9187b968257a$export$a566777c5e1513f9);
$parcel$export(module.exports, "NUMCAT_CS", () => $f87c9187b968257a$export$ef2df197b5c4ec96);
$parcel$export(module.exports, "NUMCAT_CO", () => $f87c9187b968257a$export$86eb9fe5fb3b572b);
$parcel$export(module.exports, "NUMCAT_CN", () => $f87c9187b968257a$export$1ae025eae1298b53);
$parcel$export(module.exports, "bsearch", () => $f87c9187b968257a$export$6029ab542afbcf48);
$parcel$export(module.exports, "uTowlower", () => $f87c9187b968257a$export$c8e8c950fabdf148);
$parcel$export(module.exports, "uTowtitle", () => $f87c9187b968257a$export$60bc89e8f464ddae);
$parcel$export(module.exports, "uTowupper", () => $f87c9187b968257a$export$d3a8c5dfd48993e0);
$parcel$export(module.exports, "uIswspace", () => $f87c9187b968257a$export$882876e1e8ba136f);
$parcel$export(module.exports, "uIswalnum", () => $f87c9187b968257a$export$a0fec735e7d145b);
$parcel$export(module.exports, "uIswalpha", () => $f87c9187b968257a$export$edcbae4531e40b8a);
$parcel$export(module.exports, "uIswcntrl", () => $f87c9187b968257a$export$fed91e20fe04f313);
$parcel$export(module.exports, "uIswlower", () => $f87c9187b968257a$export$7a4a3ef8a70b2a6);
$parcel$export(module.exports, "uIswprint", () => $f87c9187b968257a$export$8b4972b3757fc3c7);
$parcel$export(module.exports, "uIswupper", () => $f87c9187b968257a$export$3cb76ee86c1f055b);
$parcel$export(module.exports, "uGencat", () => $f87c9187b968257a$export$6d2646f79a263fa8);
// Generated by purs version 0.15.16

var $4VF0K = parcelRequire("4VF0K");
var $lGiKR = parcelRequire("lGiKR");

var $6UHO6 = parcelRequire("6UHO6");

var $4MBcA = parcelRequire("4MBcA");

var $l0wDR = parcelRequire("l0wDR");

var $c8kPS = parcelRequire("c8kPS");
var $6pI6x = parcelRequire("6pI6x");

var $ykHdR = parcelRequire("ykHdR");

var $6SDUu = parcelRequire("6SDUu");

var $3Orkn = parcelRequire("3Orkn");
var $f87c9187b968257a$var$show = /* #__PURE__ */ $3Orkn.show($3Orkn.showInt);
var $f87c9187b968257a$var$unsafeIndex = /* #__PURE__ */ $4VF0K.unsafeIndex();
var $f87c9187b968257a$var$elemIndex = /* #__PURE__ */ $4VF0K.elemIndex($4MBcA.eqInt);
var $f87c9187b968257a$var$map = /* #__PURE__ */ $l0wDR.map($ykHdR.functorMaybe);
var $f87c9187b968257a$export$74fad270c4b7b59c = /* #__PURE__ */ function() {
    function NUMCAT_LU() {}
    NUMCAT_LU.value = new NUMCAT_LU();
    return NUMCAT_LU;
}();
var $f87c9187b968257a$export$d4598102ceb86c96 = /* #__PURE__ */ function() {
    function NUMCAT_LL() {}
    NUMCAT_LL.value = new NUMCAT_LL();
    return NUMCAT_LL;
}();
var $f87c9187b968257a$export$676a18bdacd919c8 = /* #__PURE__ */ function() {
    function NUMCAT_LT() {}
    NUMCAT_LT.value = new NUMCAT_LT();
    return NUMCAT_LT;
}();
var $f87c9187b968257a$export$3be55c3cc7f2867 = /* #__PURE__ */ function() {
    function NUMCAT_LM() {}
    NUMCAT_LM.value = new NUMCAT_LM();
    return NUMCAT_LM;
}();
var $f87c9187b968257a$export$20b05fa78ae7527a = /* #__PURE__ */ function() {
    function NUMCAT_LO() {}
    NUMCAT_LO.value = new NUMCAT_LO();
    return NUMCAT_LO;
}();
var $f87c9187b968257a$export$79b57d103eae7039 = /* #__PURE__ */ function() {
    function NUMCAT_MN() {}
    NUMCAT_MN.value = new NUMCAT_MN();
    return NUMCAT_MN;
}();
var $f87c9187b968257a$export$60e41f2154339dc7 = /* #__PURE__ */ function() {
    function NUMCAT_MC() {}
    NUMCAT_MC.value = new NUMCAT_MC();
    return NUMCAT_MC;
}();
var $f87c9187b968257a$export$77f7cb14f5a8a8ea = /* #__PURE__ */ function() {
    function NUMCAT_ME() {}
    NUMCAT_ME.value = new NUMCAT_ME();
    return NUMCAT_ME;
}();
var $f87c9187b968257a$export$1a1df9278c5a4522 = /* #__PURE__ */ function() {
    function NUMCAT_ND() {}
    NUMCAT_ND.value = new NUMCAT_ND();
    return NUMCAT_ND;
}();
var $f87c9187b968257a$export$ffe624f4617a733d = /* #__PURE__ */ function() {
    function NUMCAT_NL() {}
    NUMCAT_NL.value = new NUMCAT_NL();
    return NUMCAT_NL;
}();
var $f87c9187b968257a$export$21de707035b964f7 = /* #__PURE__ */ function() {
    function NUMCAT_NO() {}
    NUMCAT_NO.value = new NUMCAT_NO();
    return NUMCAT_NO;
}();
var $f87c9187b968257a$export$edda2e74149c5a6e = /* #__PURE__ */ function() {
    function NUMCAT_PC() {}
    NUMCAT_PC.value = new NUMCAT_PC();
    return NUMCAT_PC;
}();
var $f87c9187b968257a$export$8ef7193d38bceddf = /* #__PURE__ */ function() {
    function NUMCAT_PD() {}
    NUMCAT_PD.value = new NUMCAT_PD();
    return NUMCAT_PD;
}();
var $f87c9187b968257a$export$a44baae05e4dd261 = /* #__PURE__ */ function() {
    function NUMCAT_PS() {}
    NUMCAT_PS.value = new NUMCAT_PS();
    return NUMCAT_PS;
}();
var $f87c9187b968257a$export$3e12887efe278a41 = /* #__PURE__ */ function() {
    function NUMCAT_PE() {}
    NUMCAT_PE.value = new NUMCAT_PE();
    return NUMCAT_PE;
}();
var $f87c9187b968257a$export$594ecb1526fb138a = /* #__PURE__ */ function() {
    function NUMCAT_PI() {}
    NUMCAT_PI.value = new NUMCAT_PI();
    return NUMCAT_PI;
}();
var $f87c9187b968257a$export$18c5ebc155f51ada = /* #__PURE__ */ function() {
    function NUMCAT_PF() {}
    NUMCAT_PF.value = new NUMCAT_PF();
    return NUMCAT_PF;
}();
var $f87c9187b968257a$export$e57c737c9939aaf8 = /* #__PURE__ */ function() {
    function NUMCAT_PO() {}
    NUMCAT_PO.value = new NUMCAT_PO();
    return NUMCAT_PO;
}();
var $f87c9187b968257a$export$b699f9c90222e3b1 = /* #__PURE__ */ function() {
    function NUMCAT_SM() {}
    NUMCAT_SM.value = new NUMCAT_SM();
    return NUMCAT_SM;
}();
var $f87c9187b968257a$export$afd75ca7ec085208 = /* #__PURE__ */ function() {
    function NUMCAT_SC() {}
    NUMCAT_SC.value = new NUMCAT_SC();
    return NUMCAT_SC;
}();
var $f87c9187b968257a$export$fcf99045e4ea7aa7 = /* #__PURE__ */ function() {
    function NUMCAT_SK() {}
    NUMCAT_SK.value = new NUMCAT_SK();
    return NUMCAT_SK;
}();
var $f87c9187b968257a$export$cbb37359c0c92ac5 = /* #__PURE__ */ function() {
    function NUMCAT_SO() {}
    NUMCAT_SO.value = new NUMCAT_SO();
    return NUMCAT_SO;
}();
var $f87c9187b968257a$export$f359e26b05cf8d05 = /* #__PURE__ */ function() {
    function NUMCAT_ZS() {}
    NUMCAT_ZS.value = new NUMCAT_ZS();
    return NUMCAT_ZS;
}();
var $f87c9187b968257a$export$bb5b519c0a0e45c0 = /* #__PURE__ */ function() {
    function NUMCAT_ZL() {}
    NUMCAT_ZL.value = new NUMCAT_ZL();
    return NUMCAT_ZL;
}();
var $f87c9187b968257a$export$c5677ea07a95661f = /* #__PURE__ */ function() {
    function NUMCAT_ZP() {}
    NUMCAT_ZP.value = new NUMCAT_ZP();
    return NUMCAT_ZP;
}();
var $f87c9187b968257a$export$88d4031ea4604c81 = /* #__PURE__ */ function() {
    function NUMCAT_CC() {}
    NUMCAT_CC.value = new NUMCAT_CC();
    return NUMCAT_CC;
}();
var $f87c9187b968257a$export$a566777c5e1513f9 = /* #__PURE__ */ function() {
    function NUMCAT_CF() {}
    NUMCAT_CF.value = new NUMCAT_CF();
    return NUMCAT_CF;
}();
var $f87c9187b968257a$export$ef2df197b5c4ec96 = /* #__PURE__ */ function() {
    function NUMCAT_CS() {}
    NUMCAT_CS.value = new NUMCAT_CS();
    return NUMCAT_CS;
}();
var $f87c9187b968257a$export$86eb9fe5fb3b572b = /* #__PURE__ */ function() {
    function NUMCAT_CO() {}
    NUMCAT_CO.value = new NUMCAT_CO();
    return NUMCAT_CO;
}();
var $f87c9187b968257a$export$1ae025eae1298b53 = /* #__PURE__ */ function() {
    function NUMCAT_CN() {}
    NUMCAT_CN.value = new NUMCAT_CN();
    return NUMCAT_CN;
}();
var $f87c9187b968257a$export$154f02f2beb6faa8 = function(x) {
    return x;
};
var $f87c9187b968257a$export$9ed3095a7f93f608 = function(x) {
    return x;
};
var $f87c9187b968257a$export$4c3dd2d20cbe23e4 = {
    show: function(v) {
        if (v instanceof $f87c9187b968257a$export$74fad270c4b7b59c) return "NUMCAT_LU";
        if (v instanceof $f87c9187b968257a$export$d4598102ceb86c96) return "NUMCAT_LL";
        if (v instanceof $f87c9187b968257a$export$676a18bdacd919c8) return "NUMCAT_LT";
        if (v instanceof $f87c9187b968257a$export$3be55c3cc7f2867) return "NUMCAT_LM";
        if (v instanceof $f87c9187b968257a$export$20b05fa78ae7527a) return "NUMCAT_LO";
        if (v instanceof $f87c9187b968257a$export$79b57d103eae7039) return "NUMCAT_MN";
        if (v instanceof $f87c9187b968257a$export$60e41f2154339dc7) return "NUMCAT_MC";
        if (v instanceof $f87c9187b968257a$export$77f7cb14f5a8a8ea) return "NUMCAT_ME";
        if (v instanceof $f87c9187b968257a$export$1a1df9278c5a4522) return "NUMCAT_ND";
        if (v instanceof $f87c9187b968257a$export$ffe624f4617a733d) return "NUMCAT_NL";
        if (v instanceof $f87c9187b968257a$export$21de707035b964f7) return "NUMCAT_NO";
        if (v instanceof $f87c9187b968257a$export$edda2e74149c5a6e) return "NUMCAT_PC";
        if (v instanceof $f87c9187b968257a$export$8ef7193d38bceddf) return "NUMCAT_PD";
        if (v instanceof $f87c9187b968257a$export$a44baae05e4dd261) return "NUMCAT_PS";
        if (v instanceof $f87c9187b968257a$export$3e12887efe278a41) return "NUMCAT_PE";
        if (v instanceof $f87c9187b968257a$export$594ecb1526fb138a) return "NUMCAT_PI";
        if (v instanceof $f87c9187b968257a$export$18c5ebc155f51ada) return "NUMCAT_PF";
        if (v instanceof $f87c9187b968257a$export$e57c737c9939aaf8) return "NUMCAT_PO";
        if (v instanceof $f87c9187b968257a$export$b699f9c90222e3b1) return "NUMCAT_SM";
        if (v instanceof $f87c9187b968257a$export$afd75ca7ec085208) return "NUMCAT_SC";
        if (v instanceof $f87c9187b968257a$export$fcf99045e4ea7aa7) return "NUMCAT_SK";
        if (v instanceof $f87c9187b968257a$export$cbb37359c0c92ac5) return "NUMCAT_SO";
        if (v instanceof $f87c9187b968257a$export$f359e26b05cf8d05) return "NUMCAT_ZS";
        if (v instanceof $f87c9187b968257a$export$bb5b519c0a0e45c0) return "NUMCAT_ZL";
        if (v instanceof $f87c9187b968257a$export$c5677ea07a95661f) return "NUMCAT_ZP";
        if (v instanceof $f87c9187b968257a$export$88d4031ea4604c81) return "NUMCAT_CC";
        if (v instanceof $f87c9187b968257a$export$a566777c5e1513f9) return "NUMCAT_CF";
        if (v instanceof $f87c9187b968257a$export$ef2df197b5c4ec96) return "NUMCAT_CS";
        if (v instanceof $f87c9187b968257a$export$86eb9fe5fb3b572b) return "NUMCAT_CO";
        if (v instanceof $f87c9187b968257a$export$1ae025eae1298b53) return "NUMCAT_CN";
        throw new Error("Failed pattern match at Data.CodePoint.Unicode.Internal (line 49, column 1 - line 79, column 31): " + [
            v.constructor.name
        ]);
    }
};
var $f87c9187b968257a$var$show1 = /* #__PURE__ */ $3Orkn.show($f87c9187b968257a$export$4c3dd2d20cbe23e4);
var $f87c9187b968257a$export$421f3f6a9cd52817 = {
    show: function(v) {
        return "ConversionRule { category: " + ($f87c9187b968257a$var$show(v.category) + (", unicodeCat: " + ($f87c9187b968257a$var$show1(v.unicodeCat) + (", possible: " + ($f87c9187b968257a$var$show(v.possible) + (", updist: " + ($f87c9187b968257a$var$show(v.updist) + (", lowdist: " + ($f87c9187b968257a$var$show(v.lowdist) + (", titledist: " + ($f87c9187b968257a$var$show(v.titledist) + " }")))))))))));
    }
};
var $f87c9187b968257a$var$show2 = /* #__PURE__ */ $3Orkn.show($f87c9187b968257a$export$421f3f6a9cd52817);
var $f87c9187b968257a$export$499a224d8474750c = {
    show: function(v) {
        return "CharBlock { start: " + ($f87c9187b968257a$var$show(v.start) + (", length: " + ($f87c9187b968257a$var$show(v.length) + (", convRule: " + ($f87c9187b968257a$var$show2(v.convRule) + " }")))));
    }
};
var $f87c9187b968257a$export$4a55201518f6815a = 7;
var $f87c9187b968257a$export$89d8ce56cc204d98 = 205;
var $f87c9187b968257a$export$7f6a2f09c9988b4f = 63;
var $f87c9187b968257a$export$7fc0e22034febfb5 = 1332;
var $f87c9187b968257a$export$d769d73966952fc5 = 3396;
var $f87c9187b968257a$export$7e18a596ae5ccbdf = 1114109;
var $f87c9187b968257a$export$8e8b15481dfb814b = 2;
var $f87c9187b968257a$export$51ebcaadb3c67176 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$8e8b15481dfb814b,
        unicodeCat: $f87c9187b968257a$export$f359e26b05cf8d05.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$ba10242678b7b4dd = [
    {
        start: 32,
        length: 1,
        convRule: $f87c9187b968257a$export$51ebcaadb3c67176
    },
    {
        start: 160,
        length: 1,
        convRule: $f87c9187b968257a$export$51ebcaadb3c67176
    },
    {
        start: 5760,
        length: 1,
        convRule: $f87c9187b968257a$export$51ebcaadb3c67176
    },
    {
        start: 8192,
        length: 11,
        convRule: $f87c9187b968257a$export$51ebcaadb3c67176
    },
    {
        start: 8239,
        length: 1,
        convRule: $f87c9187b968257a$export$51ebcaadb3c67176
    },
    {
        start: 8287,
        length: 1,
        convRule: $f87c9187b968257a$export$51ebcaadb3c67176
    },
    {
        start: 12288,
        length: 1,
        convRule: $f87c9187b968257a$export$51ebcaadb3c67176
    }
];
var $f87c9187b968257a$export$ca68228673da9c74 = 67108864;
var $f87c9187b968257a$export$f862c925a5027a25 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$ca68228673da9c74,
        unicodeCat: $f87c9187b968257a$export$c5677ea07a95661f.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$23cae0324393e20a = 33554432;
var $f87c9187b968257a$export$6b7d2f092933a352 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$23cae0324393e20a,
        unicodeCat: $f87c9187b968257a$export$bb5b519c0a0e45c0.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$a88f47445a8e3717 = 8192;
var $f87c9187b968257a$export$d8f896e54b4d4d94 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$a88f47445a8e3717,
        unicodeCat: $f87c9187b968257a$export$cbb37359c0c92ac5.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$d7ef16e275a7be6 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$a88f47445a8e3717,
        unicodeCat: $f87c9187b968257a$export$cbb37359c0c92ac5.value,
        possible: 1,
        updist: 0,
        lowdist: 26,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$99dabaca8c45da79 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$a88f47445a8e3717,
        unicodeCat: $f87c9187b968257a$export$cbb37359c0c92ac5.value,
        possible: 1,
        updist: -26,
        lowdist: 0,
        titledist: -26
    };
}();
var $f87c9187b968257a$export$19ffa5f679fe11c0 = 64;
var $f87c9187b968257a$export$794fb0e11b7dc9ad = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$19ffa5f679fe11c0,
        unicodeCat: $f87c9187b968257a$export$b699f9c90222e3b1.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$12ed53279ee450c4 = 1024;
var $f87c9187b968257a$export$24824e665deb80e4 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$12ed53279ee450c4,
        unicodeCat: $f87c9187b968257a$export$fcf99045e4ea7aa7.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$c3ab662ef084c6ac = 8;
var $f87c9187b968257a$export$866935d782a1adf9 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$c3ab662ef084c6ac,
        unicodeCat: $f87c9187b968257a$export$afd75ca7ec085208.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$657f9ea297735c46 = 16;
var $f87c9187b968257a$export$e8bb70a7af6f494 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$657f9ea297735c46,
        unicodeCat: $f87c9187b968257a$export$a44baae05e4dd261.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$a143e8efcc235a35 = 4;
var $f87c9187b968257a$export$fb53d86ce7e0a34e = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$a143e8efcc235a35,
        unicodeCat: $f87c9187b968257a$export$e57c737c9939aaf8.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$e01a543066f4428d = 32768;
var $f87c9187b968257a$export$6d507407c09b2bdb = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$e01a543066f4428d,
        unicodeCat: $f87c9187b968257a$export$594ecb1526fb138a.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$845a9d462a039d1b = 262144;
var $f87c9187b968257a$export$b954bed55b55ec5c = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$845a9d462a039d1b,
        unicodeCat: $f87c9187b968257a$export$18c5ebc155f51ada.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$fd83b20886c8feaa = 32;
var $f87c9187b968257a$export$29b16d96ce047ca9 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$fd83b20886c8feaa,
        unicodeCat: $f87c9187b968257a$export$3e12887efe278a41.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$fd5605db2a5deb4d = 128;
var $f87c9187b968257a$export$3db8b2fe6cbecf3b = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$fd5605db2a5deb4d,
        unicodeCat: $f87c9187b968257a$export$8ef7193d38bceddf.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$686b010d74c757cc = 2048;
var $f87c9187b968257a$export$3e4e0426de951c07 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$686b010d74c757cc,
        unicodeCat: $f87c9187b968257a$export$edda2e74149c5a6e.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$b6e1d994a4b080a2 = 131072;
var $f87c9187b968257a$export$33c1a8bf25446776 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$b6e1d994a4b080a2,
        unicodeCat: $f87c9187b968257a$export$21de707035b964f7.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$a933a29cf15fc29a = 16777216;
var $f87c9187b968257a$export$cb3182d6558993ee = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$a933a29cf15fc29a,
        unicodeCat: $f87c9187b968257a$export$ffe624f4617a733d.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$e687e84bc5c52c67 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$a933a29cf15fc29a,
        unicodeCat: $f87c9187b968257a$export$ffe624f4617a733d.value,
        possible: 1,
        updist: 0,
        lowdist: 16,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$a7141f854b2c3f56 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$a933a29cf15fc29a,
        unicodeCat: $f87c9187b968257a$export$ffe624f4617a733d.value,
        possible: 1,
        updist: -16,
        lowdist: 0,
        titledist: -16
    };
}();
var $f87c9187b968257a$export$a698e2e1192c5125 = 256;
var $f87c9187b968257a$export$81f55ec0bbc32b6e = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$a698e2e1192c5125,
        unicodeCat: $f87c9187b968257a$export$1a1df9278c5a4522.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$f3ac9c79570e46a = 2097152;
var $f87c9187b968257a$export$87fde0d9cf78d1f = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$f3ac9c79570e46a,
        unicodeCat: $f87c9187b968257a$export$79b57d103eae7039.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$dd16db91a51d355b = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$f3ac9c79570e46a,
        unicodeCat: $f87c9187b968257a$export$79b57d103eae7039.value,
        possible: 1,
        updist: 84,
        lowdist: 0,
        titledist: 84
    };
}();
var $f87c9187b968257a$export$ad5a9d75e70e6c80 = 4194304;
var $f87c9187b968257a$export$69945c68dca01b70 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$ad5a9d75e70e6c80,
        unicodeCat: $f87c9187b968257a$export$77f7cb14f5a8a8ea.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$b2d990af7ab79d15 = 8388608;
var $f87c9187b968257a$export$7132832865eb9304 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$b2d990af7ab79d15,
        unicodeCat: $f87c9187b968257a$export$60e41f2154339dc7.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$87f3132a44b1d0ea = 512;
var $f87c9187b968257a$export$1532ce0136c37755 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$1ae025eae1298b53.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$679c844c5f2e021b = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 8,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$36a4b98da6bb954e = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$9e78c7e0e3c1bda1 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -60,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$9568c26f20ab8b54 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -7,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$3d630acc0c1aeac3 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 80,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$9bb9980a5fba9cf6 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 15,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$663d5f91785521bc = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 48,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$4373e966038dbe47 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 7264,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$2f42ee7f4ae770fa = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 38864,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$ea5950d132bda3cb = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -3008,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$6ed378352675c85b = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -7615,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$f07dab3e1e2f044b = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -8,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$b6ed7bef3aaad2a4 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -74,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$a2950913305bfd2f = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -86,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$4debf059fdd78967 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -100,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$3cc60af0b8fe51fb = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -112,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$c251b05d03bb1b09 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -128,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$db469ad8291bc174 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -126,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$c50d507ea3901971 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -7517,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$c3ea2d19789db55a = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -8383,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$757246ae7800bfc2 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -8262,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$3c9855e4a4f89f58 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 28,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$7c2398d5fd516c81 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -10743,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$474b42537797e1da = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -3814,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$364aece97ca575d1 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -10727,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$5744c09a46214cda = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -10780,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$cbfae993dd34ee83 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -10749,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$a51fc7ab2fc1de9b = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -10783,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$e0af8c92046dd53d = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -10782,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$2b358c6ece5bacbe = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -10815,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$5c0a6992d16a2cde = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -35332,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$4e7f444f251bc9f3 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -42280,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$e5aa8d48ff844b5 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -42308,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$56d3f806283387c4 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -42319,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$f4c6bcc526d116d5 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -42315,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$9b012ad386207454 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -42305,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$8ecae8a612aae856 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -42258,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$126aa15c1eb2342d = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -42282,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$9d1fbeb551ba701e = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -42261,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$b525d0e4ac5bf938 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 928,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$c8d4bace2652a68 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -48,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$9e706749f691962d = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -42307,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$df8ee31db7227919 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -35384,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$5f381834e520bfa8 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 40,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$f0d6a468761d4066 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 34,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$7dea77bc2e51a670 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 1,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$3905653af80b0d3e = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -199,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$17cb0979b5fdd87b = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -121,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$acd6a2e0e1f36119 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 210,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$622de29d3b1ec6a9 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 206,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$e5b51f2dbdbfec58 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 205,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$6e688fec7aa0bec0 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 79,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$2307e0c1f6060bff = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 202,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$ee0aa35c8a71be4a = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 203,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$335d579666536cd9 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 207,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$f0789b3782dd73b9 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 211,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$4d4410af2f036ea6 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 209,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$f9bf0a40bfb66578 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 213,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$1fcc3cbf89bafa25 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 214,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$dd4c0f14baaae57 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 218,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$b9e0d5ea32762a6c = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 217,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$893538eb43bbf231 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 219,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$8d167c964d5a8755 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 2,
        titledist: 1
    };
}();
var $f87c9187b968257a$export$7d86d2448c3bc365 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -97,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$42cea668cab33501 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -56,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$b1b9763a354df855 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -130,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$806b8f4997f947bb = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 10795,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$e685c0641eef8ee5 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -163,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$68150a2ac77076df = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 10792,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$5018e8548b89e0b8 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -195,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$b91e7d7ce718aa5e = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 69,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$d2e4e93aee941b65 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 71,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$5a8ad4756351e1a2 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 32,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$cb38bf493c63b044 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 116,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$1e277fd57a02853c = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 38,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$cf251c63ab3fda90 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 37,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$31515a1452fded76 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 64,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$c78a5306187d3d1a = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 63,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$c216bdb3b7384b3d = 524288;
var $f87c9187b968257a$export$9073887b88a95a65 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$c216bdb3b7384b3d,
        unicodeCat: $f87c9187b968257a$export$676a18bdacd919c8.value,
        possible: 1,
        updist: 0,
        lowdist: -8,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$a9178d4e39cbf99b = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$c216bdb3b7384b3d,
        unicodeCat: $f87c9187b968257a$export$676a18bdacd919c8.value,
        possible: 1,
        updist: 0,
        lowdist: -9,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$765a30f3fb53310f = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$c216bdb3b7384b3d,
        unicodeCat: $f87c9187b968257a$export$676a18bdacd919c8.value,
        possible: 1,
        updist: -1,
        lowdist: 1,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$e589cea9a12b5fd5 = 16384;
var $f87c9187b968257a$export$3ce418d90f721a6f = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$e589cea9a12b5fd5,
        unicodeCat: $f87c9187b968257a$export$20b05fa78ae7527a.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$f1770ca2c5ffe2d = 1048576;
var $f87c9187b968257a$export$74a12340c61f1f97 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$f1770ca2c5ffe2d,
        unicodeCat: $f87c9187b968257a$export$3be55c3cc7f2867.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$2bb2c2963662e583 = 4096;
var $f87c9187b968257a$export$8c9d0b2e40231e86 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -37,
        lowdist: 0,
        titledist: -37
    };
}();
var $f87c9187b968257a$export$f96cf9acbd4d5317 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -31,
        lowdist: 0,
        titledist: -31
    };
}();
var $f87c9187b968257a$export$3fc150f61f8b8954 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -64,
        lowdist: 0,
        titledist: -64
    };
}();
var $f87c9187b968257a$export$a555eb1807a2d462 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -63,
        lowdist: 0,
        titledist: -63
    };
}();
var $f87c9187b968257a$export$4e1e7ce4c3737105 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -62,
        lowdist: 0,
        titledist: -62
    };
}();
var $f87c9187b968257a$export$e78c54e089b97a10 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -57,
        lowdist: 0,
        titledist: -57
    };
}();
var $f87c9187b968257a$export$10e7925a46b9a72 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -47,
        lowdist: 0,
        titledist: -47
    };
}();
var $f87c9187b968257a$export$1103c35de4bfac55 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -54,
        lowdist: 0,
        titledist: -54
    };
}();
var $f87c9187b968257a$export$9773cf18228b1a46 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -8,
        lowdist: 0,
        titledist: -8
    };
}();
var $f87c9187b968257a$export$b8ffbf54f5716e89 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -86,
        lowdist: 0,
        titledist: -86
    };
}();
var $f87c9187b968257a$export$19657fe4412c06ca = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -80,
        lowdist: 0,
        titledist: -80
    };
}();
var $f87c9187b968257a$export$541be5c98ac427fb = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 7,
        lowdist: 0,
        titledist: 7
    };
}();
var $f87c9187b968257a$export$7ca1b59fddace17a = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -116,
        lowdist: 0,
        titledist: -116
    };
}();
var $f87c9187b968257a$export$a40e98a4ed4424b0 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -96,
        lowdist: 0,
        titledist: -96
    };
}();
var $f87c9187b968257a$export$7173d2ee342e278 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -32,
        lowdist: 0,
        titledist: -32
    };
}();
var $f87c9187b968257a$export$467bc6be00b6e5f7 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -15,
        lowdist: 0,
        titledist: -15
    };
}();
var $f87c9187b968257a$export$31855f4179a9d698 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -48,
        lowdist: 0,
        titledist: -48
    };
}();
var $f87c9187b968257a$export$659683f76ff91445 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 3008,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$959ab01c5a7aed98 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -6254,
        lowdist: 0,
        titledist: -6254
    };
}();
var $f87c9187b968257a$export$4b86aace1bd7e1bd = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -6253,
        lowdist: 0,
        titledist: -6253
    };
}();
var $f87c9187b968257a$export$af46a44506145125 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -6244,
        lowdist: 0,
        titledist: -6244
    };
}();
var $f87c9187b968257a$export$5b58a7342deeffb1 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -6242,
        lowdist: 0,
        titledist: -6242
    };
}();
var $f87c9187b968257a$export$ce586bf4d1a1e66 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -6243,
        lowdist: 0,
        titledist: -6243
    };
}();
var $f87c9187b968257a$export$2da14ab05c277ce3 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -6236,
        lowdist: 0,
        titledist: -6236
    };
}();
var $f87c9187b968257a$export$50efda91b0b7cb4d = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -6181,
        lowdist: 0,
        titledist: -6181
    };
}();
var $f87c9187b968257a$export$a003c458cd158704 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 35266,
        lowdist: 0,
        titledist: 35266
    };
}();
var $f87c9187b968257a$export$72fbf6834eb62a3 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 35332,
        lowdist: 0,
        titledist: 35332
    };
}();
var $f87c9187b968257a$export$a54f88f7b56ccb1b = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 3814,
        lowdist: 0,
        titledist: 3814
    };
}();
var $f87c9187b968257a$export$1630391a83c31f3f = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 35384,
        lowdist: 0,
        titledist: 35384
    };
}();
var $f87c9187b968257a$export$77879d885a56be5b = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -59,
        lowdist: 0,
        titledist: -59
    };
}();
var $f87c9187b968257a$export$2bf374c619a884c0 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 8,
        lowdist: 0,
        titledist: 8
    };
}();
var $f87c9187b968257a$export$5d5cff08baa82bb3 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 74,
        lowdist: 0,
        titledist: 74
    };
}();
var $f87c9187b968257a$export$30cbf10eadff8354 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 86,
        lowdist: 0,
        titledist: 86
    };
}();
var $f87c9187b968257a$export$625a4e9662bb8009 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 100,
        lowdist: 0,
        titledist: 100
    };
}();
var $f87c9187b968257a$export$bfd29a26bb9c7604 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 128,
        lowdist: 0,
        titledist: 128
    };
}();
var $f87c9187b968257a$export$84e329f80ee32d86 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 112,
        lowdist: 0,
        titledist: 112
    };
}();
var $f87c9187b968257a$export$ec097e7d1326c9d8 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 126,
        lowdist: 0,
        titledist: 126
    };
}();
var $f87c9187b968257a$export$14cf3cf7fed1ce4 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 9,
        lowdist: 0,
        titledist: 9
    };
}();
var $f87c9187b968257a$export$847447ed9edca5f = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -7205,
        lowdist: 0,
        titledist: -7205
    };
}();
var $f87c9187b968257a$export$3f567b3eda4c98ad = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -28,
        lowdist: 0,
        titledist: -28
    };
}();
var $f87c9187b968257a$export$3cf8e408ecc23ac8 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -10795,
        lowdist: 0,
        titledist: -10795
    };
}();
var $f87c9187b968257a$export$625d51f562fcdce = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -10792,
        lowdist: 0,
        titledist: -10792
    };
}();
var $f87c9187b968257a$export$26575529bb6b00f3 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 743,
        lowdist: 0,
        titledist: 743
    };
}();
var $f87c9187b968257a$export$7c5cb8ca51bc2320 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -7264,
        lowdist: 0,
        titledist: -7264
    };
}();
var $f87c9187b968257a$export$3eb062d0712525b5 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 48,
        lowdist: 0,
        titledist: 48
    };
}();
var $f87c9187b968257a$export$4b12fa44376611d5 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -928,
        lowdist: 0,
        titledist: -928
    };
}();
var $f87c9187b968257a$export$5b2d7b2d5041cd36 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -38864,
        lowdist: 0,
        titledist: -38864
    };
}();
var $f87c9187b968257a$export$d27b372c28d7cd4 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$fb16bdb144aa72d1 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -40,
        lowdist: 0,
        titledist: -40
    };
}();
var $f87c9187b968257a$export$2a95711cd575be0d = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -34,
        lowdist: 0,
        titledist: -34
    };
}();
var $f87c9187b968257a$export$faf1fbc46b682d31 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 121,
        lowdist: 0,
        titledist: 121
    };
}();
var $f87c9187b968257a$export$ad90e8d621d1d2f5 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -1,
        lowdist: 0,
        titledist: -1
    };
}();
var $f87c9187b968257a$export$825149518e5256a = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -232,
        lowdist: 0,
        titledist: -232
    };
}();
var $f87c9187b968257a$export$498eb5d479bb7ce7 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -300,
        lowdist: 0,
        titledist: -300
    };
}();
var $f87c9187b968257a$export$86720d766a71c0f = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 195,
        lowdist: 0,
        titledist: 195
    };
}();
var $f87c9187b968257a$export$5c6d53f26f6a0003 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 97,
        lowdist: 0,
        titledist: 97
    };
}();
var $f87c9187b968257a$export$c3f89e13d99585be = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 163,
        lowdist: 0,
        titledist: 163
    };
}();
var $f87c9187b968257a$export$f540d74c78ee7c6f = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 130,
        lowdist: 0,
        titledist: 130
    };
}();
var $f87c9187b968257a$export$60fbc66d1ed52465 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 56,
        lowdist: 0,
        titledist: 56
    };
}();
var $f87c9187b968257a$export$518ccb34de7e3cbb = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -2,
        lowdist: 0,
        titledist: -1
    };
}();
var $f87c9187b968257a$export$e943da14442eb991 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -79,
        lowdist: 0,
        titledist: -79
    };
}();
var $f87c9187b968257a$export$b5d11fd411ae7308 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 10815,
        lowdist: 0,
        titledist: 10815
    };
}();
var $f87c9187b968257a$export$43152f1584a84996 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 10783,
        lowdist: 0,
        titledist: 10783
    };
}();
var $f87c9187b968257a$export$fc83989919685fe0 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 10780,
        lowdist: 0,
        titledist: 10780
    };
}();
var $f87c9187b968257a$export$19fce1b8696a0382 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 10782,
        lowdist: 0,
        titledist: 10782
    };
}();
var $f87c9187b968257a$export$5858d445afcb1060 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -210,
        lowdist: 0,
        titledist: -210
    };
}();
var $f87c9187b968257a$export$7d23753ed8606c3c = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -206,
        lowdist: 0,
        titledist: -206
    };
}();
var $f87c9187b968257a$export$b0442e2b6e2e396f = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -205,
        lowdist: 0,
        titledist: -205
    };
}();
var $f87c9187b968257a$export$994a8a9eebf1e80f = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -202,
        lowdist: 0,
        titledist: -202
    };
}();
var $f87c9187b968257a$export$f4cdedc47d618c = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -203,
        lowdist: 0,
        titledist: -203
    };
}();
var $f87c9187b968257a$export$edf7537a5466cbbd = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 42319,
        lowdist: 0,
        titledist: 42319
    };
}();
var $f87c9187b968257a$export$8a875ec5816630ca = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 42315,
        lowdist: 0,
        titledist: 42315
    };
}();
var $f87c9187b968257a$export$5f2cc4a9566fc84f = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -207,
        lowdist: 0,
        titledist: -207
    };
}();
var $f87c9187b968257a$export$77796939240e1153 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 42280,
        lowdist: 0,
        titledist: 42280
    };
}();
var $f87c9187b968257a$export$87bde82168b7b62f = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 42308,
        lowdist: 0,
        titledist: 42308
    };
}();
var $f87c9187b968257a$export$bfd284cd195987b2 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -209,
        lowdist: 0,
        titledist: -209
    };
}();
var $f87c9187b968257a$export$9bce57c33159db29 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -211,
        lowdist: 0,
        titledist: -211
    };
}();
var $f87c9187b968257a$export$beaa5bc52e18b6f8 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 10743,
        lowdist: 0,
        titledist: 10743
    };
}();
var $f87c9187b968257a$export$6fd5d6fa96b32e1c = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 42305,
        lowdist: 0,
        titledist: 42305
    };
}();
var $f87c9187b968257a$export$bff6f6acb9080a71 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 10749,
        lowdist: 0,
        titledist: 10749
    };
}();
var $f87c9187b968257a$export$47c98be6407fc86b = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -213,
        lowdist: 0,
        titledist: -213
    };
}();
var $f87c9187b968257a$export$bdfd084f94b8abe4 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -214,
        lowdist: 0,
        titledist: -214
    };
}();
var $f87c9187b968257a$export$8da9e42c98688195 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 10727,
        lowdist: 0,
        titledist: 10727
    };
}();
var $f87c9187b968257a$export$86b5f28b6c0e0fc1 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -218,
        lowdist: 0,
        titledist: -218
    };
}();
var $f87c9187b968257a$export$a2aa412b2731fae3 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 42307,
        lowdist: 0,
        titledist: 42307
    };
}();
var $f87c9187b968257a$export$9b9a33d1752912b = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 42282,
        lowdist: 0,
        titledist: 42282
    };
}();
var $f87c9187b968257a$export$5785034bbc9842fc = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -69,
        lowdist: 0,
        titledist: -69
    };
}();
var $f87c9187b968257a$export$13d1ec53b7904ae2 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -217,
        lowdist: 0,
        titledist: -217
    };
}();
var $f87c9187b968257a$export$21ce3a5d14104c9c = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -71,
        lowdist: 0,
        titledist: -71
    };
}();
var $f87c9187b968257a$export$db5c3b84d1bf1368 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -219,
        lowdist: 0,
        titledist: -219
    };
}();
var $f87c9187b968257a$export$ee9294eaaf9c94c2 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 42261,
        lowdist: 0,
        titledist: 42261
    };
}();
var $f87c9187b968257a$export$8e30aa3c367beb33 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 42258,
        lowdist: 0,
        titledist: 42258
    };
}();
var $f87c9187b968257a$export$66d8fe2369335850 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -38,
        lowdist: 0,
        titledist: -38
    };
}();
var $f87c9187b968257a$export$1f5712044a662533 = 134217728;
var $f87c9187b968257a$export$8664fc4768208d13 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$1f5712044a662533,
        unicodeCat: $f87c9187b968257a$export$ef2df197b5c4ec96.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$9b456472c58eac67 = 268435456;
var $f87c9187b968257a$export$d3f5d9ad8c1cc11c = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$9b456472c58eac67,
        unicodeCat: $f87c9187b968257a$export$86eb9fe5fb3b572b.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$80ab533b3ecfc10d = 65536;
var $f87c9187b968257a$export$def784bda4c4ba83 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$80ab533b3ecfc10d,
        unicodeCat: $f87c9187b968257a$export$a566777c5e1513f9.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$3546ca4e02dbfe5f = 1;
var $f87c9187b968257a$export$516a0353e84e6d2c = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$3546ca4e02dbfe5f,
        unicodeCat: $f87c9187b968257a$export$88d4031ea4604c81.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$bfccab8956ac9f85 = [
    {
        start: 65,
        length: 26,
        convRule: $f87c9187b968257a$export$5a8ad4756351e1a2
    },
    {
        start: 97,
        length: 26,
        convRule: $f87c9187b968257a$export$7173d2ee342e278
    },
    {
        start: 181,
        length: 1,
        convRule: $f87c9187b968257a$export$26575529bb6b00f3
    },
    {
        start: 192,
        length: 23,
        convRule: $f87c9187b968257a$export$5a8ad4756351e1a2
    },
    {
        start: 216,
        length: 7,
        convRule: $f87c9187b968257a$export$5a8ad4756351e1a2
    },
    {
        start: 224,
        length: 23,
        convRule: $f87c9187b968257a$export$7173d2ee342e278
    },
    {
        start: 248,
        length: 7,
        convRule: $f87c9187b968257a$export$7173d2ee342e278
    },
    {
        start: 255,
        length: 1,
        convRule: $f87c9187b968257a$export$faf1fbc46b682d31
    },
    {
        start: 256,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 257,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 258,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 259,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 260,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 261,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 262,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 263,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 264,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 265,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 266,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 267,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 268,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 269,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 270,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 271,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 272,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 273,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 274,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 275,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 276,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 277,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 278,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 279,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 280,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 281,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 282,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 283,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 284,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 285,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 286,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 287,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 288,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 289,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 290,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 291,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 292,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 293,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 294,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 295,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 296,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 297,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 298,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 299,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 300,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 301,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 302,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 303,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 304,
        length: 1,
        convRule: $f87c9187b968257a$export$3905653af80b0d3e
    },
    {
        start: 305,
        length: 1,
        convRule: $f87c9187b968257a$export$825149518e5256a
    },
    {
        start: 306,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 307,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 308,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 309,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 310,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 311,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 313,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 314,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 315,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 316,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 317,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 318,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 319,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 320,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 321,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 322,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 323,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 324,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 325,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 326,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 327,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 328,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 330,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 331,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 332,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 333,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 334,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 335,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 336,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 337,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 338,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 339,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 340,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 341,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 342,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 343,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 344,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 345,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 346,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 347,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 348,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 349,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 350,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 351,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 352,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 353,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 354,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 355,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 356,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 357,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 358,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 359,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 360,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 361,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 362,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 363,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 364,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 365,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 366,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 367,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 368,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 369,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 370,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 371,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 372,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 373,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 374,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 375,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 376,
        length: 1,
        convRule: $f87c9187b968257a$export$17cb0979b5fdd87b
    },
    {
        start: 377,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 378,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 379,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 380,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 381,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 382,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 383,
        length: 1,
        convRule: $f87c9187b968257a$export$498eb5d479bb7ce7
    },
    {
        start: 384,
        length: 1,
        convRule: $f87c9187b968257a$export$86720d766a71c0f
    },
    {
        start: 385,
        length: 1,
        convRule: $f87c9187b968257a$export$acd6a2e0e1f36119
    },
    {
        start: 386,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 387,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 388,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 389,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 390,
        length: 1,
        convRule: $f87c9187b968257a$export$622de29d3b1ec6a9
    },
    {
        start: 391,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 392,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 393,
        length: 2,
        convRule: $f87c9187b968257a$export$e5b51f2dbdbfec58
    },
    {
        start: 395,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 396,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 398,
        length: 1,
        convRule: $f87c9187b968257a$export$6e688fec7aa0bec0
    },
    {
        start: 399,
        length: 1,
        convRule: $f87c9187b968257a$export$2307e0c1f6060bff
    },
    {
        start: 400,
        length: 1,
        convRule: $f87c9187b968257a$export$ee0aa35c8a71be4a
    },
    {
        start: 401,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 402,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 403,
        length: 1,
        convRule: $f87c9187b968257a$export$e5b51f2dbdbfec58
    },
    {
        start: 404,
        length: 1,
        convRule: $f87c9187b968257a$export$335d579666536cd9
    },
    {
        start: 405,
        length: 1,
        convRule: $f87c9187b968257a$export$5c6d53f26f6a0003
    },
    {
        start: 406,
        length: 1,
        convRule: $f87c9187b968257a$export$f0789b3782dd73b9
    },
    {
        start: 407,
        length: 1,
        convRule: $f87c9187b968257a$export$4d4410af2f036ea6
    },
    {
        start: 408,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 409,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 410,
        length: 1,
        convRule: $f87c9187b968257a$export$c3f89e13d99585be
    },
    {
        start: 412,
        length: 1,
        convRule: $f87c9187b968257a$export$f0789b3782dd73b9
    },
    {
        start: 413,
        length: 1,
        convRule: $f87c9187b968257a$export$f9bf0a40bfb66578
    },
    {
        start: 414,
        length: 1,
        convRule: $f87c9187b968257a$export$f540d74c78ee7c6f
    },
    {
        start: 415,
        length: 1,
        convRule: $f87c9187b968257a$export$1fcc3cbf89bafa25
    },
    {
        start: 416,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 417,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 418,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 419,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 420,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 421,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 422,
        length: 1,
        convRule: $f87c9187b968257a$export$dd4c0f14baaae57
    },
    {
        start: 423,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 424,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 425,
        length: 1,
        convRule: $f87c9187b968257a$export$dd4c0f14baaae57
    },
    {
        start: 428,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 429,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 430,
        length: 1,
        convRule: $f87c9187b968257a$export$dd4c0f14baaae57
    },
    {
        start: 431,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 432,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 433,
        length: 2,
        convRule: $f87c9187b968257a$export$b9e0d5ea32762a6c
    },
    {
        start: 435,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 436,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 437,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 438,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 439,
        length: 1,
        convRule: $f87c9187b968257a$export$893538eb43bbf231
    },
    {
        start: 440,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 441,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 444,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 445,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 447,
        length: 1,
        convRule: $f87c9187b968257a$export$60fbc66d1ed52465
    },
    {
        start: 452,
        length: 1,
        convRule: $f87c9187b968257a$export$8d167c964d5a8755
    },
    {
        start: 453,
        length: 1,
        convRule: $f87c9187b968257a$export$765a30f3fb53310f
    },
    {
        start: 454,
        length: 1,
        convRule: $f87c9187b968257a$export$518ccb34de7e3cbb
    },
    {
        start: 455,
        length: 1,
        convRule: $f87c9187b968257a$export$8d167c964d5a8755
    },
    {
        start: 456,
        length: 1,
        convRule: $f87c9187b968257a$export$765a30f3fb53310f
    },
    {
        start: 457,
        length: 1,
        convRule: $f87c9187b968257a$export$518ccb34de7e3cbb
    },
    {
        start: 458,
        length: 1,
        convRule: $f87c9187b968257a$export$8d167c964d5a8755
    },
    {
        start: 459,
        length: 1,
        convRule: $f87c9187b968257a$export$765a30f3fb53310f
    },
    {
        start: 460,
        length: 1,
        convRule: $f87c9187b968257a$export$518ccb34de7e3cbb
    },
    {
        start: 461,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 462,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 463,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 464,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 465,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 466,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 467,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 468,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 469,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 470,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 471,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 472,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 473,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 474,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 475,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 476,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 477,
        length: 1,
        convRule: $f87c9187b968257a$export$e943da14442eb991
    },
    {
        start: 478,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 479,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 480,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 481,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 482,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 483,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 484,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 485,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 486,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 487,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 488,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 489,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 490,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 491,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 492,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 493,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 494,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 495,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 497,
        length: 1,
        convRule: $f87c9187b968257a$export$8d167c964d5a8755
    },
    {
        start: 498,
        length: 1,
        convRule: $f87c9187b968257a$export$765a30f3fb53310f
    },
    {
        start: 499,
        length: 1,
        convRule: $f87c9187b968257a$export$518ccb34de7e3cbb
    },
    {
        start: 500,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 501,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 502,
        length: 1,
        convRule: $f87c9187b968257a$export$7d86d2448c3bc365
    },
    {
        start: 503,
        length: 1,
        convRule: $f87c9187b968257a$export$42cea668cab33501
    },
    {
        start: 504,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 505,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 506,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 507,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 508,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 509,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 510,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 511,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 512,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 513,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 514,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 515,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 516,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 517,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 518,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 519,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 520,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 521,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 522,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 523,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 524,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 525,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 526,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 527,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 528,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 529,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 530,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 531,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 532,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 533,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 534,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 535,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 536,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 537,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 538,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 539,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 540,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 541,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 542,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 543,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 544,
        length: 1,
        convRule: $f87c9187b968257a$export$b1b9763a354df855
    },
    {
        start: 546,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 547,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 548,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 549,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 550,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 551,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 552,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 553,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 554,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 555,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 556,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 557,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 558,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 559,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 560,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 561,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 562,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 563,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 570,
        length: 1,
        convRule: $f87c9187b968257a$export$806b8f4997f947bb
    },
    {
        start: 571,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 572,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 573,
        length: 1,
        convRule: $f87c9187b968257a$export$e685c0641eef8ee5
    },
    {
        start: 574,
        length: 1,
        convRule: $f87c9187b968257a$export$68150a2ac77076df
    },
    {
        start: 575,
        length: 2,
        convRule: $f87c9187b968257a$export$b5d11fd411ae7308
    },
    {
        start: 577,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 578,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 579,
        length: 1,
        convRule: $f87c9187b968257a$export$5018e8548b89e0b8
    },
    {
        start: 580,
        length: 1,
        convRule: $f87c9187b968257a$export$b91e7d7ce718aa5e
    },
    {
        start: 581,
        length: 1,
        convRule: $f87c9187b968257a$export$d2e4e93aee941b65
    },
    {
        start: 582,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 583,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 584,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 585,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 586,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 587,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 588,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 589,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 590,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 591,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 592,
        length: 1,
        convRule: $f87c9187b968257a$export$43152f1584a84996
    },
    {
        start: 593,
        length: 1,
        convRule: $f87c9187b968257a$export$fc83989919685fe0
    },
    {
        start: 594,
        length: 1,
        convRule: $f87c9187b968257a$export$19fce1b8696a0382
    },
    {
        start: 595,
        length: 1,
        convRule: $f87c9187b968257a$export$5858d445afcb1060
    },
    {
        start: 596,
        length: 1,
        convRule: $f87c9187b968257a$export$7d23753ed8606c3c
    },
    {
        start: 598,
        length: 2,
        convRule: $f87c9187b968257a$export$b0442e2b6e2e396f
    },
    {
        start: 601,
        length: 1,
        convRule: $f87c9187b968257a$export$994a8a9eebf1e80f
    },
    {
        start: 603,
        length: 1,
        convRule: $f87c9187b968257a$export$f4cdedc47d618c
    },
    {
        start: 604,
        length: 1,
        convRule: $f87c9187b968257a$export$edf7537a5466cbbd
    },
    {
        start: 608,
        length: 1,
        convRule: $f87c9187b968257a$export$b0442e2b6e2e396f
    },
    {
        start: 609,
        length: 1,
        convRule: $f87c9187b968257a$export$8a875ec5816630ca
    },
    {
        start: 611,
        length: 1,
        convRule: $f87c9187b968257a$export$5f2cc4a9566fc84f
    },
    {
        start: 613,
        length: 1,
        convRule: $f87c9187b968257a$export$77796939240e1153
    },
    {
        start: 614,
        length: 1,
        convRule: $f87c9187b968257a$export$87bde82168b7b62f
    },
    {
        start: 616,
        length: 1,
        convRule: $f87c9187b968257a$export$bfd284cd195987b2
    },
    {
        start: 617,
        length: 1,
        convRule: $f87c9187b968257a$export$9bce57c33159db29
    },
    {
        start: 618,
        length: 1,
        convRule: $f87c9187b968257a$export$87bde82168b7b62f
    },
    {
        start: 619,
        length: 1,
        convRule: $f87c9187b968257a$export$beaa5bc52e18b6f8
    },
    {
        start: 620,
        length: 1,
        convRule: $f87c9187b968257a$export$6fd5d6fa96b32e1c
    },
    {
        start: 623,
        length: 1,
        convRule: $f87c9187b968257a$export$9bce57c33159db29
    },
    {
        start: 625,
        length: 1,
        convRule: $f87c9187b968257a$export$bff6f6acb9080a71
    },
    {
        start: 626,
        length: 1,
        convRule: $f87c9187b968257a$export$47c98be6407fc86b
    },
    {
        start: 629,
        length: 1,
        convRule: $f87c9187b968257a$export$bdfd084f94b8abe4
    },
    {
        start: 637,
        length: 1,
        convRule: $f87c9187b968257a$export$8da9e42c98688195
    },
    {
        start: 640,
        length: 1,
        convRule: $f87c9187b968257a$export$86b5f28b6c0e0fc1
    },
    {
        start: 642,
        length: 1,
        convRule: $f87c9187b968257a$export$a2aa412b2731fae3
    },
    {
        start: 643,
        length: 1,
        convRule: $f87c9187b968257a$export$86b5f28b6c0e0fc1
    },
    {
        start: 647,
        length: 1,
        convRule: $f87c9187b968257a$export$9b9a33d1752912b
    },
    {
        start: 648,
        length: 1,
        convRule: $f87c9187b968257a$export$86b5f28b6c0e0fc1
    },
    {
        start: 649,
        length: 1,
        convRule: $f87c9187b968257a$export$5785034bbc9842fc
    },
    {
        start: 650,
        length: 2,
        convRule: $f87c9187b968257a$export$13d1ec53b7904ae2
    },
    {
        start: 652,
        length: 1,
        convRule: $f87c9187b968257a$export$21ce3a5d14104c9c
    },
    {
        start: 658,
        length: 1,
        convRule: $f87c9187b968257a$export$db5c3b84d1bf1368
    },
    {
        start: 669,
        length: 1,
        convRule: $f87c9187b968257a$export$ee9294eaaf9c94c2
    },
    {
        start: 670,
        length: 1,
        convRule: $f87c9187b968257a$export$8e30aa3c367beb33
    },
    {
        start: 837,
        length: 1,
        convRule: $f87c9187b968257a$export$dd16db91a51d355b
    },
    {
        start: 880,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 881,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 882,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 883,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 886,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 887,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 891,
        length: 3,
        convRule: $f87c9187b968257a$export$f540d74c78ee7c6f
    },
    {
        start: 895,
        length: 1,
        convRule: $f87c9187b968257a$export$cb38bf493c63b044
    },
    {
        start: 902,
        length: 1,
        convRule: $f87c9187b968257a$export$1e277fd57a02853c
    },
    {
        start: 904,
        length: 3,
        convRule: $f87c9187b968257a$export$cf251c63ab3fda90
    },
    {
        start: 908,
        length: 1,
        convRule: $f87c9187b968257a$export$31515a1452fded76
    },
    {
        start: 910,
        length: 2,
        convRule: $f87c9187b968257a$export$c78a5306187d3d1a
    },
    {
        start: 913,
        length: 17,
        convRule: $f87c9187b968257a$export$5a8ad4756351e1a2
    },
    {
        start: 931,
        length: 9,
        convRule: $f87c9187b968257a$export$5a8ad4756351e1a2
    },
    {
        start: 940,
        length: 1,
        convRule: $f87c9187b968257a$export$66d8fe2369335850
    },
    {
        start: 941,
        length: 3,
        convRule: $f87c9187b968257a$export$8c9d0b2e40231e86
    },
    {
        start: 945,
        length: 17,
        convRule: $f87c9187b968257a$export$7173d2ee342e278
    },
    {
        start: 962,
        length: 1,
        convRule: $f87c9187b968257a$export$f96cf9acbd4d5317
    },
    {
        start: 963,
        length: 9,
        convRule: $f87c9187b968257a$export$7173d2ee342e278
    },
    {
        start: 972,
        length: 1,
        convRule: $f87c9187b968257a$export$3fc150f61f8b8954
    },
    {
        start: 973,
        length: 2,
        convRule: $f87c9187b968257a$export$a555eb1807a2d462
    },
    {
        start: 975,
        length: 1,
        convRule: $f87c9187b968257a$export$679c844c5f2e021b
    },
    {
        start: 976,
        length: 1,
        convRule: $f87c9187b968257a$export$4e1e7ce4c3737105
    },
    {
        start: 977,
        length: 1,
        convRule: $f87c9187b968257a$export$e78c54e089b97a10
    },
    {
        start: 981,
        length: 1,
        convRule: $f87c9187b968257a$export$10e7925a46b9a72
    },
    {
        start: 982,
        length: 1,
        convRule: $f87c9187b968257a$export$1103c35de4bfac55
    },
    {
        start: 983,
        length: 1,
        convRule: $f87c9187b968257a$export$9773cf18228b1a46
    },
    {
        start: 984,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 985,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 986,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 987,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 988,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 989,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 990,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 991,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 992,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 993,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 994,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 995,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 996,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 997,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 998,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 999,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1000,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1001,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1002,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1003,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1004,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1005,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1006,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1007,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1008,
        length: 1,
        convRule: $f87c9187b968257a$export$b8ffbf54f5716e89
    },
    {
        start: 1009,
        length: 1,
        convRule: $f87c9187b968257a$export$19657fe4412c06ca
    },
    {
        start: 1010,
        length: 1,
        convRule: $f87c9187b968257a$export$541be5c98ac427fb
    },
    {
        start: 1011,
        length: 1,
        convRule: $f87c9187b968257a$export$7ca1b59fddace17a
    },
    {
        start: 1012,
        length: 1,
        convRule: $f87c9187b968257a$export$9e78c7e0e3c1bda1
    },
    {
        start: 1013,
        length: 1,
        convRule: $f87c9187b968257a$export$a40e98a4ed4424b0
    },
    {
        start: 1015,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1016,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1017,
        length: 1,
        convRule: $f87c9187b968257a$export$9568c26f20ab8b54
    },
    {
        start: 1018,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1019,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1021,
        length: 3,
        convRule: $f87c9187b968257a$export$b1b9763a354df855
    },
    {
        start: 1024,
        length: 16,
        convRule: $f87c9187b968257a$export$3d630acc0c1aeac3
    },
    {
        start: 1040,
        length: 32,
        convRule: $f87c9187b968257a$export$5a8ad4756351e1a2
    },
    {
        start: 1072,
        length: 32,
        convRule: $f87c9187b968257a$export$7173d2ee342e278
    },
    {
        start: 1104,
        length: 16,
        convRule: $f87c9187b968257a$export$19657fe4412c06ca
    },
    {
        start: 1120,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1121,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1122,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1123,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1124,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1125,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1126,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1127,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1128,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1129,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1130,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1131,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1132,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1133,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1134,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1135,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1136,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1137,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1138,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1139,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1140,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1141,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1142,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1143,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1144,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1145,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1146,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1147,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1148,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1149,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1150,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1151,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1152,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1153,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1162,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1163,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1164,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1165,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1166,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1167,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1168,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1169,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1170,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1171,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1172,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1173,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1174,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1175,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1176,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1177,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1178,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1179,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1180,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1181,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1182,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1183,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1184,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1185,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1186,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1187,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1188,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1189,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1190,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1191,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1192,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1193,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1194,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1195,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1196,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1197,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1198,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1199,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1200,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1201,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1202,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1203,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1204,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1205,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1206,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1207,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1208,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1209,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1210,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1211,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1212,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1213,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1214,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1215,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1216,
        length: 1,
        convRule: $f87c9187b968257a$export$9bb9980a5fba9cf6
    },
    {
        start: 1217,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1218,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1219,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1220,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1221,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1222,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1223,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1224,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1225,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1226,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1227,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1228,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1229,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1230,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1231,
        length: 1,
        convRule: $f87c9187b968257a$export$467bc6be00b6e5f7
    },
    {
        start: 1232,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1233,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1234,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1235,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1236,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1237,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1238,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1239,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1240,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1241,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1242,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1243,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1244,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1245,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1246,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1247,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1248,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1249,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1250,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1251,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1252,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1253,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1254,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1255,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1256,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1257,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1258,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1259,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1260,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1261,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1262,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1263,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1264,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1265,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1266,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1267,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1268,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1269,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1270,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1271,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1272,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1273,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1274,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1275,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1276,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1277,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1278,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1279,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1280,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1281,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1282,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1283,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1284,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1285,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1286,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1287,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1288,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1289,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1290,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1291,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1292,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1293,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1294,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1295,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1296,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1297,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1298,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1299,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1300,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1301,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1302,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1303,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1304,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1305,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1306,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1307,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1308,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1309,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1310,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1311,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1312,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1313,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1314,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1315,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1316,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1317,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1318,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1319,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1320,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1321,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1322,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1323,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1324,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1325,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1326,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1327,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1329,
        length: 38,
        convRule: $f87c9187b968257a$export$663d5f91785521bc
    },
    {
        start: 1377,
        length: 38,
        convRule: $f87c9187b968257a$export$31855f4179a9d698
    },
    {
        start: 4256,
        length: 38,
        convRule: $f87c9187b968257a$export$4373e966038dbe47
    },
    {
        start: 4295,
        length: 1,
        convRule: $f87c9187b968257a$export$4373e966038dbe47
    },
    {
        start: 4301,
        length: 1,
        convRule: $f87c9187b968257a$export$4373e966038dbe47
    },
    {
        start: 4304,
        length: 43,
        convRule: $f87c9187b968257a$export$659683f76ff91445
    },
    {
        start: 4349,
        length: 3,
        convRule: $f87c9187b968257a$export$659683f76ff91445
    },
    {
        start: 5024,
        length: 80,
        convRule: $f87c9187b968257a$export$2f42ee7f4ae770fa
    },
    {
        start: 5104,
        length: 6,
        convRule: $f87c9187b968257a$export$679c844c5f2e021b
    },
    {
        start: 5112,
        length: 6,
        convRule: $f87c9187b968257a$export$9773cf18228b1a46
    },
    {
        start: 7296,
        length: 1,
        convRule: $f87c9187b968257a$export$959ab01c5a7aed98
    },
    {
        start: 7297,
        length: 1,
        convRule: $f87c9187b968257a$export$4b86aace1bd7e1bd
    },
    {
        start: 7298,
        length: 1,
        convRule: $f87c9187b968257a$export$af46a44506145125
    },
    {
        start: 7299,
        length: 2,
        convRule: $f87c9187b968257a$export$5b58a7342deeffb1
    },
    {
        start: 7301,
        length: 1,
        convRule: $f87c9187b968257a$export$ce586bf4d1a1e66
    },
    {
        start: 7302,
        length: 1,
        convRule: $f87c9187b968257a$export$2da14ab05c277ce3
    },
    {
        start: 7303,
        length: 1,
        convRule: $f87c9187b968257a$export$50efda91b0b7cb4d
    },
    {
        start: 7304,
        length: 1,
        convRule: $f87c9187b968257a$export$a003c458cd158704
    },
    {
        start: 7312,
        length: 43,
        convRule: $f87c9187b968257a$export$ea5950d132bda3cb
    },
    {
        start: 7357,
        length: 3,
        convRule: $f87c9187b968257a$export$ea5950d132bda3cb
    },
    {
        start: 7545,
        length: 1,
        convRule: $f87c9187b968257a$export$72fbf6834eb62a3
    },
    {
        start: 7549,
        length: 1,
        convRule: $f87c9187b968257a$export$a54f88f7b56ccb1b
    },
    {
        start: 7566,
        length: 1,
        convRule: $f87c9187b968257a$export$1630391a83c31f3f
    },
    {
        start: 7680,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7681,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7682,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7683,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7684,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7685,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7686,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7687,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7688,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7689,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7690,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7691,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7692,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7693,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7694,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7695,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7696,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7697,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7698,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7699,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7700,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7701,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7702,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7703,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7704,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7705,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7706,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7707,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7708,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7709,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7710,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7711,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7712,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7713,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7714,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7715,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7716,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7717,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7718,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7719,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7720,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7721,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7722,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7723,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7724,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7725,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7726,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7727,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7728,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7729,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7730,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7731,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7732,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7733,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7734,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7735,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7736,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7737,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7738,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7739,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7740,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7741,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7742,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7743,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7744,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7745,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7746,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7747,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7748,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7749,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7750,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7751,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7752,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7753,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7754,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7755,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7756,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7757,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7758,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7759,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7760,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7761,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7762,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7763,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7764,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7765,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7766,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7767,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7768,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7769,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7770,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7771,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7772,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7773,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7774,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7775,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7776,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7777,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7778,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7779,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7780,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7781,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7782,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7783,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7784,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7785,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7786,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7787,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7788,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7789,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7790,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7791,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7792,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7793,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7794,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7795,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7796,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7797,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7798,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7799,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7800,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7801,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7802,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7803,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7804,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7805,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7806,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7807,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7808,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7809,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7810,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7811,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7812,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7813,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7814,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7815,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7816,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7817,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7818,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7819,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7820,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7821,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7822,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7823,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7824,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7825,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7826,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7827,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7828,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7829,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7835,
        length: 1,
        convRule: $f87c9187b968257a$export$77879d885a56be5b
    },
    {
        start: 7838,
        length: 1,
        convRule: $f87c9187b968257a$export$6ed378352675c85b
    },
    {
        start: 7840,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7841,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7842,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7843,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7844,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7845,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7846,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7847,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7848,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7849,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7850,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7851,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7852,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7853,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7854,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7855,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7856,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7857,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7858,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7859,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7860,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7861,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7862,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7863,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7864,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7865,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7866,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7867,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7868,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7869,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7870,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7871,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7872,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7873,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7874,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7875,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7876,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7877,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7878,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7879,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7880,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7881,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7882,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7883,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7884,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7885,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7886,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7887,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7888,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7889,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7890,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7891,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7892,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7893,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7894,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7895,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7896,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7897,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7898,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7899,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7900,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7901,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7902,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7903,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7904,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7905,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7906,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7907,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7908,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7909,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7910,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7911,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7912,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7913,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7914,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7915,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7916,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7917,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7918,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7919,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7920,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7921,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7922,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7923,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7924,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7925,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7926,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7927,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7928,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7929,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7930,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7931,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7932,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7933,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7934,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7935,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7936,
        length: 8,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 7944,
        length: 8,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 7952,
        length: 6,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 7960,
        length: 6,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 7968,
        length: 8,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 7976,
        length: 8,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 7984,
        length: 8,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 7992,
        length: 8,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 8000,
        length: 6,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 8008,
        length: 6,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 8017,
        length: 1,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 8019,
        length: 1,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 8021,
        length: 1,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 8023,
        length: 1,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 8025,
        length: 1,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 8027,
        length: 1,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 8029,
        length: 1,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 8031,
        length: 1,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 8032,
        length: 8,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 8040,
        length: 8,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 8048,
        length: 2,
        convRule: $f87c9187b968257a$export$5d5cff08baa82bb3
    },
    {
        start: 8050,
        length: 4,
        convRule: $f87c9187b968257a$export$30cbf10eadff8354
    },
    {
        start: 8054,
        length: 2,
        convRule: $f87c9187b968257a$export$625a4e9662bb8009
    },
    {
        start: 8056,
        length: 2,
        convRule: $f87c9187b968257a$export$bfd29a26bb9c7604
    },
    {
        start: 8058,
        length: 2,
        convRule: $f87c9187b968257a$export$84e329f80ee32d86
    },
    {
        start: 8060,
        length: 2,
        convRule: $f87c9187b968257a$export$ec097e7d1326c9d8
    },
    {
        start: 8064,
        length: 8,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 8072,
        length: 8,
        convRule: $f87c9187b968257a$export$9073887b88a95a65
    },
    {
        start: 8080,
        length: 8,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 8088,
        length: 8,
        convRule: $f87c9187b968257a$export$9073887b88a95a65
    },
    {
        start: 8096,
        length: 8,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 8104,
        length: 8,
        convRule: $f87c9187b968257a$export$9073887b88a95a65
    },
    {
        start: 8112,
        length: 2,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 8115,
        length: 1,
        convRule: $f87c9187b968257a$export$14cf3cf7fed1ce4
    },
    {
        start: 8120,
        length: 2,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 8122,
        length: 2,
        convRule: $f87c9187b968257a$export$b6ed7bef3aaad2a4
    },
    {
        start: 8124,
        length: 1,
        convRule: $f87c9187b968257a$export$a9178d4e39cbf99b
    },
    {
        start: 8126,
        length: 1,
        convRule: $f87c9187b968257a$export$847447ed9edca5f
    },
    {
        start: 8131,
        length: 1,
        convRule: $f87c9187b968257a$export$14cf3cf7fed1ce4
    },
    {
        start: 8136,
        length: 4,
        convRule: $f87c9187b968257a$export$a2950913305bfd2f
    },
    {
        start: 8140,
        length: 1,
        convRule: $f87c9187b968257a$export$a9178d4e39cbf99b
    },
    {
        start: 8144,
        length: 2,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 8152,
        length: 2,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 8154,
        length: 2,
        convRule: $f87c9187b968257a$export$4debf059fdd78967
    },
    {
        start: 8160,
        length: 2,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 8165,
        length: 1,
        convRule: $f87c9187b968257a$export$541be5c98ac427fb
    },
    {
        start: 8168,
        length: 2,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 8170,
        length: 2,
        convRule: $f87c9187b968257a$export$3cc60af0b8fe51fb
    },
    {
        start: 8172,
        length: 1,
        convRule: $f87c9187b968257a$export$9568c26f20ab8b54
    },
    {
        start: 8179,
        length: 1,
        convRule: $f87c9187b968257a$export$14cf3cf7fed1ce4
    },
    {
        start: 8184,
        length: 2,
        convRule: $f87c9187b968257a$export$c251b05d03bb1b09
    },
    {
        start: 8186,
        length: 2,
        convRule: $f87c9187b968257a$export$db469ad8291bc174
    },
    {
        start: 8188,
        length: 1,
        convRule: $f87c9187b968257a$export$a9178d4e39cbf99b
    },
    {
        start: 8486,
        length: 1,
        convRule: $f87c9187b968257a$export$c50d507ea3901971
    },
    {
        start: 8490,
        length: 1,
        convRule: $f87c9187b968257a$export$c3ea2d19789db55a
    },
    {
        start: 8491,
        length: 1,
        convRule: $f87c9187b968257a$export$757246ae7800bfc2
    },
    {
        start: 8498,
        length: 1,
        convRule: $f87c9187b968257a$export$3c9855e4a4f89f58
    },
    {
        start: 8526,
        length: 1,
        convRule: $f87c9187b968257a$export$3f567b3eda4c98ad
    },
    {
        start: 8544,
        length: 16,
        convRule: $f87c9187b968257a$export$e687e84bc5c52c67
    },
    {
        start: 8560,
        length: 16,
        convRule: $f87c9187b968257a$export$a7141f854b2c3f56
    },
    {
        start: 8579,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 8580,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 9398,
        length: 26,
        convRule: $f87c9187b968257a$export$d7ef16e275a7be6
    },
    {
        start: 9424,
        length: 26,
        convRule: $f87c9187b968257a$export$99dabaca8c45da79
    },
    {
        start: 11264,
        length: 47,
        convRule: $f87c9187b968257a$export$663d5f91785521bc
    },
    {
        start: 11312,
        length: 47,
        convRule: $f87c9187b968257a$export$31855f4179a9d698
    },
    {
        start: 11360,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11361,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11362,
        length: 1,
        convRule: $f87c9187b968257a$export$7c2398d5fd516c81
    },
    {
        start: 11363,
        length: 1,
        convRule: $f87c9187b968257a$export$474b42537797e1da
    },
    {
        start: 11364,
        length: 1,
        convRule: $f87c9187b968257a$export$364aece97ca575d1
    },
    {
        start: 11365,
        length: 1,
        convRule: $f87c9187b968257a$export$3cf8e408ecc23ac8
    },
    {
        start: 11366,
        length: 1,
        convRule: $f87c9187b968257a$export$625d51f562fcdce
    },
    {
        start: 11367,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11368,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11369,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11370,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11371,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11372,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11373,
        length: 1,
        convRule: $f87c9187b968257a$export$5744c09a46214cda
    },
    {
        start: 11374,
        length: 1,
        convRule: $f87c9187b968257a$export$cbfae993dd34ee83
    },
    {
        start: 11375,
        length: 1,
        convRule: $f87c9187b968257a$export$a51fc7ab2fc1de9b
    },
    {
        start: 11376,
        length: 1,
        convRule: $f87c9187b968257a$export$e0af8c92046dd53d
    },
    {
        start: 11378,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11379,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11381,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11382,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11390,
        length: 2,
        convRule: $f87c9187b968257a$export$2b358c6ece5bacbe
    },
    {
        start: 11392,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11393,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11394,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11395,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11396,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11397,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11398,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11399,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11400,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11401,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11402,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11403,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11404,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11405,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11406,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11407,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11408,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11409,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11410,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11411,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11412,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11413,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11414,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11415,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11416,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11417,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11418,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11419,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11420,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11421,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11422,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11423,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11424,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11425,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11426,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11427,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11428,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11429,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11430,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11431,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11432,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11433,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11434,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11435,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11436,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11437,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11438,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11439,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11440,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11441,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11442,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11443,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11444,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11445,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11446,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11447,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11448,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11449,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11450,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11451,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11452,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11453,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11454,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11455,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11456,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11457,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11458,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11459,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11460,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11461,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11462,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11463,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11464,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11465,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11466,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11467,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11468,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11469,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11470,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11471,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11472,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11473,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11474,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11475,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11476,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11477,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11478,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11479,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11480,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11481,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11482,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11483,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11484,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11485,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11486,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11487,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11488,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11489,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11490,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11491,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11499,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11500,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11501,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11502,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11506,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11507,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11520,
        length: 38,
        convRule: $f87c9187b968257a$export$7c5cb8ca51bc2320
    },
    {
        start: 11559,
        length: 1,
        convRule: $f87c9187b968257a$export$7c5cb8ca51bc2320
    },
    {
        start: 11565,
        length: 1,
        convRule: $f87c9187b968257a$export$7c5cb8ca51bc2320
    },
    {
        start: 42560,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42561,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42562,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42563,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42564,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42565,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42566,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42567,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42568,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42569,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42570,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42571,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42572,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42573,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42574,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42575,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42576,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42577,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42578,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42579,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42580,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42581,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42582,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42583,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42584,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42585,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42586,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42587,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42588,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42589,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42590,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42591,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42592,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42593,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42594,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42595,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42596,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42597,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42598,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42599,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42600,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42601,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42602,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42603,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42604,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42605,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42624,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42625,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42626,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42627,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42628,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42629,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42630,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42631,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42632,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42633,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42634,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42635,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42636,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42637,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42638,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42639,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42640,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42641,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42642,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42643,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42644,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42645,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42646,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42647,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42648,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42649,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42650,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42651,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42786,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42787,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42788,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42789,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42790,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42791,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42792,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42793,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42794,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42795,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42796,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42797,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42798,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42799,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42802,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42803,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42804,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42805,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42806,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42807,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42808,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42809,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42810,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42811,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42812,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42813,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42814,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42815,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42816,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42817,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42818,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42819,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42820,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42821,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42822,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42823,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42824,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42825,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42826,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42827,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42828,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42829,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42830,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42831,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42832,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42833,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42834,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42835,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42836,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42837,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42838,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42839,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42840,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42841,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42842,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42843,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42844,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42845,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42846,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42847,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42848,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42849,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42850,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42851,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42852,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42853,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42854,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42855,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42856,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42857,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42858,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42859,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42860,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42861,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42862,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42863,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42873,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42874,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42875,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42876,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42877,
        length: 1,
        convRule: $f87c9187b968257a$export$5c0a6992d16a2cde
    },
    {
        start: 42878,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42879,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42880,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42881,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42882,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42883,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42884,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42885,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42886,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42887,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42891,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42892,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42893,
        length: 1,
        convRule: $f87c9187b968257a$export$4e7f444f251bc9f3
    },
    {
        start: 42896,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42897,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42898,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42899,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42900,
        length: 1,
        convRule: $f87c9187b968257a$export$3eb062d0712525b5
    },
    {
        start: 42902,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42903,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42904,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42905,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42906,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42907,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42908,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42909,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42910,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42911,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42912,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42913,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42914,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42915,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42916,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42917,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42918,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42919,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42920,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42921,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42922,
        length: 1,
        convRule: $f87c9187b968257a$export$e5aa8d48ff844b5
    },
    {
        start: 42923,
        length: 1,
        convRule: $f87c9187b968257a$export$56d3f806283387c4
    },
    {
        start: 42924,
        length: 1,
        convRule: $f87c9187b968257a$export$f4c6bcc526d116d5
    },
    {
        start: 42925,
        length: 1,
        convRule: $f87c9187b968257a$export$9b012ad386207454
    },
    {
        start: 42926,
        length: 1,
        convRule: $f87c9187b968257a$export$e5aa8d48ff844b5
    },
    {
        start: 42928,
        length: 1,
        convRule: $f87c9187b968257a$export$8ecae8a612aae856
    },
    {
        start: 42929,
        length: 1,
        convRule: $f87c9187b968257a$export$126aa15c1eb2342d
    },
    {
        start: 42930,
        length: 1,
        convRule: $f87c9187b968257a$export$9d1fbeb551ba701e
    },
    {
        start: 42931,
        length: 1,
        convRule: $f87c9187b968257a$export$b525d0e4ac5bf938
    },
    {
        start: 42932,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42933,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42934,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42935,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42936,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42937,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42938,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42939,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42940,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42941,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42942,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42943,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42946,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42947,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42948,
        length: 1,
        convRule: $f87c9187b968257a$export$c8d4bace2652a68
    },
    {
        start: 42949,
        length: 1,
        convRule: $f87c9187b968257a$export$9e706749f691962d
    },
    {
        start: 42950,
        length: 1,
        convRule: $f87c9187b968257a$export$df8ee31db7227919
    },
    {
        start: 42951,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42952,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42953,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42954,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42997,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42998,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 43859,
        length: 1,
        convRule: $f87c9187b968257a$export$4b12fa44376611d5
    },
    {
        start: 43888,
        length: 80,
        convRule: $f87c9187b968257a$export$5b2d7b2d5041cd36
    },
    {
        start: 65313,
        length: 26,
        convRule: $f87c9187b968257a$export$5a8ad4756351e1a2
    },
    {
        start: 65345,
        length: 26,
        convRule: $f87c9187b968257a$export$7173d2ee342e278
    },
    {
        start: 66560,
        length: 40,
        convRule: $f87c9187b968257a$export$5f381834e520bfa8
    },
    {
        start: 66600,
        length: 40,
        convRule: $f87c9187b968257a$export$fb16bdb144aa72d1
    },
    {
        start: 66736,
        length: 36,
        convRule: $f87c9187b968257a$export$5f381834e520bfa8
    },
    {
        start: 66776,
        length: 36,
        convRule: $f87c9187b968257a$export$fb16bdb144aa72d1
    },
    {
        start: 68736,
        length: 51,
        convRule: $f87c9187b968257a$export$31515a1452fded76
    },
    {
        start: 68800,
        length: 51,
        convRule: $f87c9187b968257a$export$3fc150f61f8b8954
    },
    {
        start: 71840,
        length: 32,
        convRule: $f87c9187b968257a$export$5a8ad4756351e1a2
    },
    {
        start: 71872,
        length: 32,
        convRule: $f87c9187b968257a$export$7173d2ee342e278
    },
    {
        start: 93760,
        length: 32,
        convRule: $f87c9187b968257a$export$5a8ad4756351e1a2
    },
    {
        start: 93792,
        length: 32,
        convRule: $f87c9187b968257a$export$7173d2ee342e278
    },
    {
        start: 125184,
        length: 34,
        convRule: $f87c9187b968257a$export$f0d6a468761d4066
    },
    {
        start: 125218,
        length: 34,
        convRule: $f87c9187b968257a$export$2a95711cd575be0d
    }
];
var $f87c9187b968257a$export$6029ab542afbcf48 = function(a) {
    return function(array) {
        return function(size) {
            return function(compare) {
                var go = function($copy_i) {
                    return function($copy_k) {
                        var $tco_var_i = $copy_i;
                        var $tco_done = false;
                        var $tco_result;
                        function $tco_loop(i, k) {
                            if (i > k || i >= $lGiKR.length(array)) {
                                $tco_done = true;
                                return $ykHdR.Nothing.value;
                            }
                            if ($6UHO6.otherwise) {
                                var j = $c8kPS.floor($6pI6x.toNumber(i + k | 0) / 2.0);
                                var b = $f87c9187b968257a$var$unsafeIndex(array)(j);
                                var v = compare(a)(b);
                                if (v instanceof $6SDUu.EQ) {
                                    $tco_done = true;
                                    return new $ykHdR.Just(b);
                                }
                                if (v instanceof $6SDUu.GT) {
                                    $tco_var_i = j + 1 | 0;
                                    $copy_k = k;
                                    return;
                                }
                                $tco_var_i = i;
                                $copy_k = j - 1 | 0;
                                return;
                            }
                            throw new Error("Failed pattern match at Data.CodePoint.Unicode.Internal (line 5622, column 3 - line 5632, column 30): " + [
                                i.constructor.name,
                                k.constructor.name
                            ]);
                        }
                        while(!$tco_done)$tco_result = $tco_loop($tco_var_i, $copy_k);
                        return $tco_result;
                    };
                };
                return go(0)(size);
            };
        };
    };
};
var $f87c9187b968257a$export$37ec41d8baf7e4c2 = function(v) {
    return function(v1) {
        if (v.start >= v1.start && v.start < (v1.start + v1.length | 0)) return $6SDUu.EQ.value;
        if (v.start > v1.start) return $6SDUu.GT.value;
        if ($6UHO6.otherwise) return $6SDUu.LT.value;
        throw new Error("Failed pattern match at Data.CodePoint.Unicode.Internal (line 5598, column 1 - line 5598, column 45): " + [
            v.constructor.name,
            v1.constructor.name
        ]);
    };
};
var $f87c9187b968257a$export$8a73d6c1af11382a = function(blocks) {
    return function(unichar) {
        return function(size) {
            var key = {
                start: unichar,
                length: 1,
                convRule: $f87c9187b968257a$export$1532ce0136c37755
            };
            var maybeCharBlock = $f87c9187b968257a$export$6029ab542afbcf48(key)(blocks)(size)($f87c9187b968257a$export$37ec41d8baf7e4c2);
            if (maybeCharBlock instanceof $ykHdR.Nothing) return $ykHdR.Nothing.value;
            if (maybeCharBlock instanceof $ykHdR.Just) return new $ykHdR.Just(maybeCharBlock.value0.convRule);
            throw new Error("Failed pattern match at Data.CodePoint.Unicode.Internal (line 5612, column 5 - line 5614, column 60): " + [
                maybeCharBlock.constructor.name
            ]);
        };
    };
};
var $f87c9187b968257a$export$15b55fe776496b2f = function(f) {
    return function($$char) {
        var maybeConversionRule = $f87c9187b968257a$export$8a73d6c1af11382a($f87c9187b968257a$export$bfccab8956ac9f85)($$char)($f87c9187b968257a$export$7fc0e22034febfb5);
        if (maybeConversionRule instanceof $ykHdR.Nothing) return $$char;
        if (maybeConversionRule instanceof $ykHdR.Just) return $$char + f(maybeConversionRule.value0) | 0;
        throw new Error("Failed pattern match at Data.CodePoint.Unicode.Internal (line 5727, column 5 - line 5729, column 53): " + [
            maybeConversionRule.constructor.name
        ]);
    };
};
var $f87c9187b968257a$export$c8e8c950fabdf148 = /* #__PURE__ */ $f87c9187b968257a$export$15b55fe776496b2f(function(v) {
    return v.lowdist;
});
var $f87c9187b968257a$export$60bc89e8f464ddae = /* #__PURE__ */ $f87c9187b968257a$export$15b55fe776496b2f(function(v) {
    return v.titledist;
});
var $f87c9187b968257a$export$d3a8c5dfd48993e0 = /* #__PURE__ */ $f87c9187b968257a$export$15b55fe776496b2f(function(v) {
    return v.updist;
});
var $f87c9187b968257a$export$eee0beb4445e5ae6 = function(categories) {
    return function($$char) {
        var maybeConversionRule = $f87c9187b968257a$export$8a73d6c1af11382a($f87c9187b968257a$export$ba10242678b7b4dd)($$char)($f87c9187b968257a$export$4a55201518f6815a);
        if (maybeConversionRule instanceof $ykHdR.Nothing) return false;
        if (maybeConversionRule instanceof $ykHdR.Just) return $ykHdR.isJust($f87c9187b968257a$var$elemIndex(maybeConversionRule.value0.category)(categories));
        throw new Error("Failed pattern match at Data.CodePoint.Unicode.Internal (line 5654, column 5 - line 5656, column 86): " + [
            maybeConversionRule.constructor.name
        ]);
    };
};
var $f87c9187b968257a$export$882876e1e8ba136f = /* #__PURE__ */ $f87c9187b968257a$export$eee0beb4445e5ae6([
    $f87c9187b968257a$export$8e8b15481dfb814b
]);
var $f87c9187b968257a$export$865f22e68241060 = [
    {
        start: 0,
        length: 32,
        convRule: $f87c9187b968257a$export$516a0353e84e6d2c
    },
    {
        start: 32,
        length: 1,
        convRule: $f87c9187b968257a$export$51ebcaadb3c67176
    },
    {
        start: 33,
        length: 3,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 36,
        length: 1,
        convRule: $f87c9187b968257a$export$866935d782a1adf9
    },
    {
        start: 37,
        length: 3,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 40,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 41,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 42,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 43,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 44,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 45,
        length: 1,
        convRule: $f87c9187b968257a$export$3db8b2fe6cbecf3b
    },
    {
        start: 46,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 48,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 58,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 60,
        length: 3,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 63,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 65,
        length: 26,
        convRule: $f87c9187b968257a$export$5a8ad4756351e1a2
    },
    {
        start: 91,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 92,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 93,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 94,
        length: 1,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 95,
        length: 1,
        convRule: $f87c9187b968257a$export$3e4e0426de951c07
    },
    {
        start: 96,
        length: 1,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 97,
        length: 26,
        convRule: $f87c9187b968257a$export$7173d2ee342e278
    },
    {
        start: 123,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 124,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 125,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 126,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 127,
        length: 33,
        convRule: $f87c9187b968257a$export$516a0353e84e6d2c
    },
    {
        start: 160,
        length: 1,
        convRule: $f87c9187b968257a$export$51ebcaadb3c67176
    },
    {
        start: 161,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 162,
        length: 4,
        convRule: $f87c9187b968257a$export$866935d782a1adf9
    },
    {
        start: 166,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 167,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 168,
        length: 1,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 169,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 170,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 171,
        length: 1,
        convRule: $f87c9187b968257a$export$6d507407c09b2bdb
    },
    {
        start: 172,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 173,
        length: 1,
        convRule: $f87c9187b968257a$export$def784bda4c4ba83
    },
    {
        start: 174,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 175,
        length: 1,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 176,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 177,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 178,
        length: 2,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 180,
        length: 1,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 181,
        length: 1,
        convRule: $f87c9187b968257a$export$26575529bb6b00f3
    },
    {
        start: 182,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 184,
        length: 1,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 185,
        length: 1,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 186,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 187,
        length: 1,
        convRule: $f87c9187b968257a$export$b954bed55b55ec5c
    },
    {
        start: 188,
        length: 3,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 191,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 192,
        length: 23,
        convRule: $f87c9187b968257a$export$5a8ad4756351e1a2
    },
    {
        start: 215,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 216,
        length: 7,
        convRule: $f87c9187b968257a$export$5a8ad4756351e1a2
    },
    {
        start: 223,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 224,
        length: 23,
        convRule: $f87c9187b968257a$export$7173d2ee342e278
    },
    {
        start: 247,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 248,
        length: 7,
        convRule: $f87c9187b968257a$export$7173d2ee342e278
    },
    {
        start: 255,
        length: 1,
        convRule: $f87c9187b968257a$export$faf1fbc46b682d31
    },
    {
        start: 256,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 257,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 258,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 259,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 260,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 261,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 262,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 263,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 264,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 265,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 266,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 267,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 268,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 269,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 270,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 271,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 272,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 273,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 274,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 275,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 276,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 277,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 278,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 279,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 280,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 281,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 282,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 283,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 284,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 285,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 286,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 287,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 288,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 289,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 290,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 291,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 292,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 293,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 294,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 295,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 296,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 297,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 298,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 299,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 300,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 301,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 302,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 303,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 304,
        length: 1,
        convRule: $f87c9187b968257a$export$3905653af80b0d3e
    },
    {
        start: 305,
        length: 1,
        convRule: $f87c9187b968257a$export$825149518e5256a
    },
    {
        start: 306,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 307,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 308,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 309,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 310,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 311,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 312,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 313,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 314,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 315,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 316,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 317,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 318,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 319,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 320,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 321,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 322,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 323,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 324,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 325,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 326,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 327,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 328,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 329,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 330,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 331,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 332,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 333,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 334,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 335,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 336,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 337,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 338,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 339,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 340,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 341,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 342,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 343,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 344,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 345,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 346,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 347,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 348,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 349,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 350,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 351,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 352,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 353,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 354,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 355,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 356,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 357,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 358,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 359,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 360,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 361,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 362,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 363,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 364,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 365,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 366,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 367,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 368,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 369,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 370,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 371,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 372,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 373,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 374,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 375,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 376,
        length: 1,
        convRule: $f87c9187b968257a$export$17cb0979b5fdd87b
    },
    {
        start: 377,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 378,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 379,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 380,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 381,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 382,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 383,
        length: 1,
        convRule: $f87c9187b968257a$export$498eb5d479bb7ce7
    },
    {
        start: 384,
        length: 1,
        convRule: $f87c9187b968257a$export$86720d766a71c0f
    },
    {
        start: 385,
        length: 1,
        convRule: $f87c9187b968257a$export$acd6a2e0e1f36119
    },
    {
        start: 386,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 387,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 388,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 389,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 390,
        length: 1,
        convRule: $f87c9187b968257a$export$622de29d3b1ec6a9
    },
    {
        start: 391,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 392,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 393,
        length: 2,
        convRule: $f87c9187b968257a$export$e5b51f2dbdbfec58
    },
    {
        start: 395,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 396,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 397,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 398,
        length: 1,
        convRule: $f87c9187b968257a$export$6e688fec7aa0bec0
    },
    {
        start: 399,
        length: 1,
        convRule: $f87c9187b968257a$export$2307e0c1f6060bff
    },
    {
        start: 400,
        length: 1,
        convRule: $f87c9187b968257a$export$ee0aa35c8a71be4a
    },
    {
        start: 401,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 402,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 403,
        length: 1,
        convRule: $f87c9187b968257a$export$e5b51f2dbdbfec58
    },
    {
        start: 404,
        length: 1,
        convRule: $f87c9187b968257a$export$335d579666536cd9
    },
    {
        start: 405,
        length: 1,
        convRule: $f87c9187b968257a$export$5c6d53f26f6a0003
    },
    {
        start: 406,
        length: 1,
        convRule: $f87c9187b968257a$export$f0789b3782dd73b9
    },
    {
        start: 407,
        length: 1,
        convRule: $f87c9187b968257a$export$4d4410af2f036ea6
    },
    {
        start: 408,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 409,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 410,
        length: 1,
        convRule: $f87c9187b968257a$export$c3f89e13d99585be
    },
    {
        start: 411,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 412,
        length: 1,
        convRule: $f87c9187b968257a$export$f0789b3782dd73b9
    },
    {
        start: 413,
        length: 1,
        convRule: $f87c9187b968257a$export$f9bf0a40bfb66578
    },
    {
        start: 414,
        length: 1,
        convRule: $f87c9187b968257a$export$f540d74c78ee7c6f
    },
    {
        start: 415,
        length: 1,
        convRule: $f87c9187b968257a$export$1fcc3cbf89bafa25
    },
    {
        start: 416,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 417,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 418,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 419,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 420,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 421,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 422,
        length: 1,
        convRule: $f87c9187b968257a$export$dd4c0f14baaae57
    },
    {
        start: 423,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 424,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 425,
        length: 1,
        convRule: $f87c9187b968257a$export$dd4c0f14baaae57
    },
    {
        start: 426,
        length: 2,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 428,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 429,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 430,
        length: 1,
        convRule: $f87c9187b968257a$export$dd4c0f14baaae57
    },
    {
        start: 431,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 432,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 433,
        length: 2,
        convRule: $f87c9187b968257a$export$b9e0d5ea32762a6c
    },
    {
        start: 435,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 436,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 437,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 438,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 439,
        length: 1,
        convRule: $f87c9187b968257a$export$893538eb43bbf231
    },
    {
        start: 440,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 441,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 442,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 443,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 444,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 445,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 446,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 447,
        length: 1,
        convRule: $f87c9187b968257a$export$60fbc66d1ed52465
    },
    {
        start: 448,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 452,
        length: 1,
        convRule: $f87c9187b968257a$export$8d167c964d5a8755
    },
    {
        start: 453,
        length: 1,
        convRule: $f87c9187b968257a$export$765a30f3fb53310f
    },
    {
        start: 454,
        length: 1,
        convRule: $f87c9187b968257a$export$518ccb34de7e3cbb
    },
    {
        start: 455,
        length: 1,
        convRule: $f87c9187b968257a$export$8d167c964d5a8755
    },
    {
        start: 456,
        length: 1,
        convRule: $f87c9187b968257a$export$765a30f3fb53310f
    },
    {
        start: 457,
        length: 1,
        convRule: $f87c9187b968257a$export$518ccb34de7e3cbb
    },
    {
        start: 458,
        length: 1,
        convRule: $f87c9187b968257a$export$8d167c964d5a8755
    },
    {
        start: 459,
        length: 1,
        convRule: $f87c9187b968257a$export$765a30f3fb53310f
    },
    {
        start: 460,
        length: 1,
        convRule: $f87c9187b968257a$export$518ccb34de7e3cbb
    },
    {
        start: 461,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 462,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 463,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 464,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 465,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 466,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 467,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 468,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 469,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 470,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 471,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 472,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 473,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 474,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 475,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 476,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 477,
        length: 1,
        convRule: $f87c9187b968257a$export$e943da14442eb991
    },
    {
        start: 478,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 479,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 480,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 481,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 482,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 483,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 484,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 485,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 486,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 487,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 488,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 489,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 490,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 491,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 492,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 493,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 494,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 495,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 496,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 497,
        length: 1,
        convRule: $f87c9187b968257a$export$8d167c964d5a8755
    },
    {
        start: 498,
        length: 1,
        convRule: $f87c9187b968257a$export$765a30f3fb53310f
    },
    {
        start: 499,
        length: 1,
        convRule: $f87c9187b968257a$export$518ccb34de7e3cbb
    },
    {
        start: 500,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 501,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 502,
        length: 1,
        convRule: $f87c9187b968257a$export$7d86d2448c3bc365
    },
    {
        start: 503,
        length: 1,
        convRule: $f87c9187b968257a$export$42cea668cab33501
    },
    {
        start: 504,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 505,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 506,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 507,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 508,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 509,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 510,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 511,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 512,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 513,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 514,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 515,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 516,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 517,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 518,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 519,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 520,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 521,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 522,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 523,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 524,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 525,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 526,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 527,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 528,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 529,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 530,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 531,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 532,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 533,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 534,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 535,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 536,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 537,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 538,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 539,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 540,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 541,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 542,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 543,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 544,
        length: 1,
        convRule: $f87c9187b968257a$export$b1b9763a354df855
    },
    {
        start: 545,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 546,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 547,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 548,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 549,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 550,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 551,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 552,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 553,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 554,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 555,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 556,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 557,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 558,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 559,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 560,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 561,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 562,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 563,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 564,
        length: 6,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 570,
        length: 1,
        convRule: $f87c9187b968257a$export$806b8f4997f947bb
    },
    {
        start: 571,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 572,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 573,
        length: 1,
        convRule: $f87c9187b968257a$export$e685c0641eef8ee5
    },
    {
        start: 574,
        length: 1,
        convRule: $f87c9187b968257a$export$68150a2ac77076df
    },
    {
        start: 575,
        length: 2,
        convRule: $f87c9187b968257a$export$b5d11fd411ae7308
    },
    {
        start: 577,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 578,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 579,
        length: 1,
        convRule: $f87c9187b968257a$export$5018e8548b89e0b8
    },
    {
        start: 580,
        length: 1,
        convRule: $f87c9187b968257a$export$b91e7d7ce718aa5e
    },
    {
        start: 581,
        length: 1,
        convRule: $f87c9187b968257a$export$d2e4e93aee941b65
    },
    {
        start: 582,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 583,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 584,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 585,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 586,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 587,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 588,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 589,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 590,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 591,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 592,
        length: 1,
        convRule: $f87c9187b968257a$export$43152f1584a84996
    },
    {
        start: 593,
        length: 1,
        convRule: $f87c9187b968257a$export$fc83989919685fe0
    },
    {
        start: 594,
        length: 1,
        convRule: $f87c9187b968257a$export$19fce1b8696a0382
    },
    {
        start: 595,
        length: 1,
        convRule: $f87c9187b968257a$export$5858d445afcb1060
    },
    {
        start: 596,
        length: 1,
        convRule: $f87c9187b968257a$export$7d23753ed8606c3c
    },
    {
        start: 597,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 598,
        length: 2,
        convRule: $f87c9187b968257a$export$b0442e2b6e2e396f
    },
    {
        start: 600,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 601,
        length: 1,
        convRule: $f87c9187b968257a$export$994a8a9eebf1e80f
    },
    {
        start: 602,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 603,
        length: 1,
        convRule: $f87c9187b968257a$export$f4cdedc47d618c
    },
    {
        start: 604,
        length: 1,
        convRule: $f87c9187b968257a$export$edf7537a5466cbbd
    },
    {
        start: 605,
        length: 3,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 608,
        length: 1,
        convRule: $f87c9187b968257a$export$b0442e2b6e2e396f
    },
    {
        start: 609,
        length: 1,
        convRule: $f87c9187b968257a$export$8a875ec5816630ca
    },
    {
        start: 610,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 611,
        length: 1,
        convRule: $f87c9187b968257a$export$5f2cc4a9566fc84f
    },
    {
        start: 612,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 613,
        length: 1,
        convRule: $f87c9187b968257a$export$77796939240e1153
    },
    {
        start: 614,
        length: 1,
        convRule: $f87c9187b968257a$export$87bde82168b7b62f
    },
    {
        start: 615,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 616,
        length: 1,
        convRule: $f87c9187b968257a$export$bfd284cd195987b2
    },
    {
        start: 617,
        length: 1,
        convRule: $f87c9187b968257a$export$9bce57c33159db29
    },
    {
        start: 618,
        length: 1,
        convRule: $f87c9187b968257a$export$87bde82168b7b62f
    },
    {
        start: 619,
        length: 1,
        convRule: $f87c9187b968257a$export$beaa5bc52e18b6f8
    },
    {
        start: 620,
        length: 1,
        convRule: $f87c9187b968257a$export$6fd5d6fa96b32e1c
    },
    {
        start: 621,
        length: 2,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 623,
        length: 1,
        convRule: $f87c9187b968257a$export$9bce57c33159db29
    },
    {
        start: 624,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 625,
        length: 1,
        convRule: $f87c9187b968257a$export$bff6f6acb9080a71
    },
    {
        start: 626,
        length: 1,
        convRule: $f87c9187b968257a$export$47c98be6407fc86b
    },
    {
        start: 627,
        length: 2,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 629,
        length: 1,
        convRule: $f87c9187b968257a$export$bdfd084f94b8abe4
    },
    {
        start: 630,
        length: 7,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 637,
        length: 1,
        convRule: $f87c9187b968257a$export$8da9e42c98688195
    },
    {
        start: 638,
        length: 2,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 640,
        length: 1,
        convRule: $f87c9187b968257a$export$86b5f28b6c0e0fc1
    },
    {
        start: 641,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 642,
        length: 1,
        convRule: $f87c9187b968257a$export$a2aa412b2731fae3
    },
    {
        start: 643,
        length: 1,
        convRule: $f87c9187b968257a$export$86b5f28b6c0e0fc1
    },
    {
        start: 644,
        length: 3,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 647,
        length: 1,
        convRule: $f87c9187b968257a$export$9b9a33d1752912b
    },
    {
        start: 648,
        length: 1,
        convRule: $f87c9187b968257a$export$86b5f28b6c0e0fc1
    },
    {
        start: 649,
        length: 1,
        convRule: $f87c9187b968257a$export$5785034bbc9842fc
    },
    {
        start: 650,
        length: 2,
        convRule: $f87c9187b968257a$export$13d1ec53b7904ae2
    },
    {
        start: 652,
        length: 1,
        convRule: $f87c9187b968257a$export$21ce3a5d14104c9c
    },
    {
        start: 653,
        length: 5,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 658,
        length: 1,
        convRule: $f87c9187b968257a$export$db5c3b84d1bf1368
    },
    {
        start: 659,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 660,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 661,
        length: 8,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 669,
        length: 1,
        convRule: $f87c9187b968257a$export$ee9294eaaf9c94c2
    },
    {
        start: 670,
        length: 1,
        convRule: $f87c9187b968257a$export$8e30aa3c367beb33
    },
    {
        start: 671,
        length: 17,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 688,
        length: 18,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 706,
        length: 4,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 710,
        length: 12,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 722,
        length: 14,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 736,
        length: 5,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 741,
        length: 7,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 748,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 749,
        length: 1,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 750,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 751,
        length: 17,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 768,
        length: 69,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 837,
        length: 1,
        convRule: $f87c9187b968257a$export$dd16db91a51d355b
    },
    {
        start: 838,
        length: 42,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 880,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 881,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 882,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 883,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 884,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 885,
        length: 1,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 886,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 887,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 890,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 891,
        length: 3,
        convRule: $f87c9187b968257a$export$f540d74c78ee7c6f
    },
    {
        start: 894,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 895,
        length: 1,
        convRule: $f87c9187b968257a$export$cb38bf493c63b044
    },
    {
        start: 900,
        length: 2,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 902,
        length: 1,
        convRule: $f87c9187b968257a$export$1e277fd57a02853c
    },
    {
        start: 903,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 904,
        length: 3,
        convRule: $f87c9187b968257a$export$cf251c63ab3fda90
    },
    {
        start: 908,
        length: 1,
        convRule: $f87c9187b968257a$export$31515a1452fded76
    },
    {
        start: 910,
        length: 2,
        convRule: $f87c9187b968257a$export$c78a5306187d3d1a
    },
    {
        start: 912,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 913,
        length: 17,
        convRule: $f87c9187b968257a$export$5a8ad4756351e1a2
    },
    {
        start: 931,
        length: 9,
        convRule: $f87c9187b968257a$export$5a8ad4756351e1a2
    },
    {
        start: 940,
        length: 1,
        convRule: $f87c9187b968257a$export$66d8fe2369335850
    },
    {
        start: 941,
        length: 3,
        convRule: $f87c9187b968257a$export$8c9d0b2e40231e86
    },
    {
        start: 944,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 945,
        length: 17,
        convRule: $f87c9187b968257a$export$7173d2ee342e278
    },
    {
        start: 962,
        length: 1,
        convRule: $f87c9187b968257a$export$f96cf9acbd4d5317
    },
    {
        start: 963,
        length: 9,
        convRule: $f87c9187b968257a$export$7173d2ee342e278
    },
    {
        start: 972,
        length: 1,
        convRule: $f87c9187b968257a$export$3fc150f61f8b8954
    },
    {
        start: 973,
        length: 2,
        convRule: $f87c9187b968257a$export$a555eb1807a2d462
    },
    {
        start: 975,
        length: 1,
        convRule: $f87c9187b968257a$export$679c844c5f2e021b
    },
    {
        start: 976,
        length: 1,
        convRule: $f87c9187b968257a$export$4e1e7ce4c3737105
    },
    {
        start: 977,
        length: 1,
        convRule: $f87c9187b968257a$export$e78c54e089b97a10
    },
    {
        start: 978,
        length: 3,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 981,
        length: 1,
        convRule: $f87c9187b968257a$export$10e7925a46b9a72
    },
    {
        start: 982,
        length: 1,
        convRule: $f87c9187b968257a$export$1103c35de4bfac55
    },
    {
        start: 983,
        length: 1,
        convRule: $f87c9187b968257a$export$9773cf18228b1a46
    },
    {
        start: 984,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 985,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 986,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 987,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 988,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 989,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 990,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 991,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 992,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 993,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 994,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 995,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 996,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 997,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 998,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 999,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1000,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1001,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1002,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1003,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1004,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1005,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1006,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1007,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1008,
        length: 1,
        convRule: $f87c9187b968257a$export$b8ffbf54f5716e89
    },
    {
        start: 1009,
        length: 1,
        convRule: $f87c9187b968257a$export$19657fe4412c06ca
    },
    {
        start: 1010,
        length: 1,
        convRule: $f87c9187b968257a$export$541be5c98ac427fb
    },
    {
        start: 1011,
        length: 1,
        convRule: $f87c9187b968257a$export$7ca1b59fddace17a
    },
    {
        start: 1012,
        length: 1,
        convRule: $f87c9187b968257a$export$9e78c7e0e3c1bda1
    },
    {
        start: 1013,
        length: 1,
        convRule: $f87c9187b968257a$export$a40e98a4ed4424b0
    },
    {
        start: 1014,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 1015,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1016,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1017,
        length: 1,
        convRule: $f87c9187b968257a$export$9568c26f20ab8b54
    },
    {
        start: 1018,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1019,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1020,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 1021,
        length: 3,
        convRule: $f87c9187b968257a$export$b1b9763a354df855
    },
    {
        start: 1024,
        length: 16,
        convRule: $f87c9187b968257a$export$3d630acc0c1aeac3
    },
    {
        start: 1040,
        length: 32,
        convRule: $f87c9187b968257a$export$5a8ad4756351e1a2
    },
    {
        start: 1072,
        length: 32,
        convRule: $f87c9187b968257a$export$7173d2ee342e278
    },
    {
        start: 1104,
        length: 16,
        convRule: $f87c9187b968257a$export$19657fe4412c06ca
    },
    {
        start: 1120,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1121,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1122,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1123,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1124,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1125,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1126,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1127,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1128,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1129,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1130,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1131,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1132,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1133,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1134,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1135,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1136,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1137,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1138,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1139,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1140,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1141,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1142,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1143,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1144,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1145,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1146,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1147,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1148,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1149,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1150,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1151,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1152,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1153,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1154,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 1155,
        length: 5,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 1160,
        length: 2,
        convRule: $f87c9187b968257a$export$69945c68dca01b70
    },
    {
        start: 1162,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1163,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1164,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1165,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1166,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1167,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1168,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1169,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1170,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1171,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1172,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1173,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1174,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1175,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1176,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1177,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1178,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1179,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1180,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1181,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1182,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1183,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1184,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1185,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1186,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1187,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1188,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1189,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1190,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1191,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1192,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1193,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1194,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1195,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1196,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1197,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1198,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1199,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1200,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1201,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1202,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1203,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1204,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1205,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1206,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1207,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1208,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1209,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1210,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1211,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1212,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1213,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1214,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1215,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1216,
        length: 1,
        convRule: $f87c9187b968257a$export$9bb9980a5fba9cf6
    },
    {
        start: 1217,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1218,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1219,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1220,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1221,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1222,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1223,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1224,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1225,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1226,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1227,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1228,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1229,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1230,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1231,
        length: 1,
        convRule: $f87c9187b968257a$export$467bc6be00b6e5f7
    },
    {
        start: 1232,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1233,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1234,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1235,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1236,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1237,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1238,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1239,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1240,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1241,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1242,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1243,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1244,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1245,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1246,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1247,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1248,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1249,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1250,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1251,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1252,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1253,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1254,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1255,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1256,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1257,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1258,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1259,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1260,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1261,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1262,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1263,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1264,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1265,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1266,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1267,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1268,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1269,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1270,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1271,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1272,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1273,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1274,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1275,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1276,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1277,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1278,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1279,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1280,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1281,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1282,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1283,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1284,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1285,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1286,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1287,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1288,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1289,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1290,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1291,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1292,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1293,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1294,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1295,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1296,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1297,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1298,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1299,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1300,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1301,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1302,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1303,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1304,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1305,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1306,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1307,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1308,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1309,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1310,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1311,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1312,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1313,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1314,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1315,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1316,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1317,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1318,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1319,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1320,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1321,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1322,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1323,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1324,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1325,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1326,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1327,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1329,
        length: 38,
        convRule: $f87c9187b968257a$export$663d5f91785521bc
    },
    {
        start: 1369,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 1370,
        length: 6,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 1376,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 1377,
        length: 38,
        convRule: $f87c9187b968257a$export$31855f4179a9d698
    },
    {
        start: 1415,
        length: 2,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 1417,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 1418,
        length: 1,
        convRule: $f87c9187b968257a$export$3db8b2fe6cbecf3b
    },
    {
        start: 1421,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 1423,
        length: 1,
        convRule: $f87c9187b968257a$export$866935d782a1adf9
    },
    {
        start: 1425,
        length: 45,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 1470,
        length: 1,
        convRule: $f87c9187b968257a$export$3db8b2fe6cbecf3b
    },
    {
        start: 1471,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 1472,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 1473,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 1475,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 1476,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 1478,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 1479,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 1488,
        length: 27,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 1519,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 1523,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 1536,
        length: 6,
        convRule: $f87c9187b968257a$export$def784bda4c4ba83
    },
    {
        start: 1542,
        length: 3,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 1545,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 1547,
        length: 1,
        convRule: $f87c9187b968257a$export$866935d782a1adf9
    },
    {
        start: 1548,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 1550,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 1552,
        length: 11,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 1563,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 1564,
        length: 1,
        convRule: $f87c9187b968257a$export$def784bda4c4ba83
    },
    {
        start: 1566,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 1568,
        length: 32,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 1600,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 1601,
        length: 10,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 1611,
        length: 21,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 1632,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 1642,
        length: 4,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 1646,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 1648,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 1649,
        length: 99,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 1748,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 1749,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 1750,
        length: 7,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 1757,
        length: 1,
        convRule: $f87c9187b968257a$export$def784bda4c4ba83
    },
    {
        start: 1758,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 1759,
        length: 6,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 1765,
        length: 2,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 1767,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 1769,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 1770,
        length: 4,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 1774,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 1776,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 1786,
        length: 3,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 1789,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 1791,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 1792,
        length: 14,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 1807,
        length: 1,
        convRule: $f87c9187b968257a$export$def784bda4c4ba83
    },
    {
        start: 1808,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 1809,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 1810,
        length: 30,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 1840,
        length: 27,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 1869,
        length: 89,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 1958,
        length: 11,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 1969,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 1984,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 1994,
        length: 33,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2027,
        length: 9,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2036,
        length: 2,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 2038,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 2039,
        length: 3,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 2042,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 2045,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2046,
        length: 2,
        convRule: $f87c9187b968257a$export$866935d782a1adf9
    },
    {
        start: 2048,
        length: 22,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2070,
        length: 4,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2074,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 2075,
        length: 9,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2084,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 2085,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2088,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 2089,
        length: 5,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2096,
        length: 15,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 2112,
        length: 25,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2137,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2142,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 2144,
        length: 11,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2208,
        length: 21,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2230,
        length: 18,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2259,
        length: 15,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2274,
        length: 1,
        convRule: $f87c9187b968257a$export$def784bda4c4ba83
    },
    {
        start: 2275,
        length: 32,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2307,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 2308,
        length: 54,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2362,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2363,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 2364,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2365,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2366,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 2369,
        length: 8,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2377,
        length: 4,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 2381,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2382,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 2384,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2385,
        length: 7,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2392,
        length: 10,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2402,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2404,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 2406,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 2416,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 2417,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 2418,
        length: 15,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2433,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2434,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 2437,
        length: 8,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2447,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2451,
        length: 22,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2474,
        length: 7,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2482,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2486,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2492,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2493,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2494,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 2497,
        length: 4,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2503,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 2507,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 2509,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2510,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2519,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 2524,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2527,
        length: 3,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2530,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2534,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 2544,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2546,
        length: 2,
        convRule: $f87c9187b968257a$export$866935d782a1adf9
    },
    {
        start: 2548,
        length: 6,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 2554,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 2555,
        length: 1,
        convRule: $f87c9187b968257a$export$866935d782a1adf9
    },
    {
        start: 2556,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2557,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 2558,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2561,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2563,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 2565,
        length: 6,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2575,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2579,
        length: 22,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2602,
        length: 7,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2610,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2613,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2616,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2620,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2622,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 2625,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2631,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2635,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2641,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2649,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2654,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2662,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 2672,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2674,
        length: 3,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2677,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2678,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 2689,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2691,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 2693,
        length: 9,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2703,
        length: 3,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2707,
        length: 22,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2730,
        length: 7,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2738,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2741,
        length: 5,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2748,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2749,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2750,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 2753,
        length: 5,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2759,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2761,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 2763,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 2765,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2768,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2784,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2786,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2790,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 2800,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 2801,
        length: 1,
        convRule: $f87c9187b968257a$export$866935d782a1adf9
    },
    {
        start: 2809,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2810,
        length: 6,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2817,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2818,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 2821,
        length: 8,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2831,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2835,
        length: 22,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2858,
        length: 7,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2866,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2869,
        length: 5,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2876,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2877,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2878,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 2879,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2880,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 2881,
        length: 4,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2887,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 2891,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 2893,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2901,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2903,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 2908,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2911,
        length: 3,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2914,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2918,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 2928,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 2929,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2930,
        length: 6,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 2946,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2947,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2949,
        length: 6,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2958,
        length: 3,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2962,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2969,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2972,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2974,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2979,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2984,
        length: 3,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2990,
        length: 12,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3006,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 3008,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3009,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 3014,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 3018,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 3021,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3024,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3031,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 3046,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 3056,
        length: 3,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 3059,
        length: 6,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 3065,
        length: 1,
        convRule: $f87c9187b968257a$export$866935d782a1adf9
    },
    {
        start: 3066,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 3072,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3073,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 3076,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3077,
        length: 8,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3086,
        length: 3,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3090,
        length: 23,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3114,
        length: 16,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3133,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3134,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3137,
        length: 4,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 3142,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3146,
        length: 4,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3157,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3160,
        length: 3,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3168,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3170,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3174,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 3191,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 3192,
        length: 7,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 3199,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 3200,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3201,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3202,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 3204,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 3205,
        length: 8,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3214,
        length: 3,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3218,
        length: 23,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3242,
        length: 10,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3253,
        length: 5,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3260,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3261,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3262,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 3263,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3264,
        length: 5,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 3270,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3271,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 3274,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 3276,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3285,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 3294,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3296,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3298,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3302,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 3313,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3328,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3330,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 3332,
        length: 9,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3342,
        length: 3,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3346,
        length: 41,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3387,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3389,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3390,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 3393,
        length: 4,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3398,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 3402,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 3405,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3406,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3407,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 3412,
        length: 3,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3415,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 3416,
        length: 7,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 3423,
        length: 3,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3426,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3430,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 3440,
        length: 9,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 3449,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 3450,
        length: 6,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3457,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3458,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 3461,
        length: 18,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3482,
        length: 24,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3507,
        length: 9,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3517,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3520,
        length: 7,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3530,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3535,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 3538,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3542,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3544,
        length: 8,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 3558,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 3570,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 3572,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 3585,
        length: 48,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3633,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3634,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3636,
        length: 7,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3647,
        length: 1,
        convRule: $f87c9187b968257a$export$866935d782a1adf9
    },
    {
        start: 3648,
        length: 6,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3654,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 3655,
        length: 8,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3663,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 3664,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 3674,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 3713,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3716,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3718,
        length: 5,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3724,
        length: 24,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3749,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3751,
        length: 10,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3761,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3762,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3764,
        length: 9,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3773,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3776,
        length: 5,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3782,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 3784,
        length: 6,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3792,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 3804,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3840,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3841,
        length: 3,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 3844,
        length: 15,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 3859,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 3860,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 3861,
        length: 3,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 3864,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3866,
        length: 6,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 3872,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 3882,
        length: 10,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 3892,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 3893,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3894,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 3895,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3896,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 3897,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3898,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 3899,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 3900,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 3901,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 3902,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 3904,
        length: 8,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3913,
        length: 36,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3953,
        length: 14,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3967,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 3968,
        length: 5,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3973,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 3974,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3976,
        length: 5,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3981,
        length: 11,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3993,
        length: 36,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 4030,
        length: 8,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 4038,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 4039,
        length: 6,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 4046,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 4048,
        length: 5,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 4053,
        length: 4,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 4057,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 4096,
        length: 43,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4139,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 4141,
        length: 4,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 4145,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 4146,
        length: 6,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 4152,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 4153,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 4155,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 4157,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 4159,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4160,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 4170,
        length: 6,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 4176,
        length: 6,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4182,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 4184,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 4186,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4190,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 4193,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4194,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 4197,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4199,
        length: 7,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 4206,
        length: 3,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4209,
        length: 4,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 4213,
        length: 13,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4226,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 4227,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 4229,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 4231,
        length: 6,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 4237,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 4238,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4239,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 4240,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 4250,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 4253,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 4254,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 4256,
        length: 38,
        convRule: $f87c9187b968257a$export$4373e966038dbe47
    },
    {
        start: 4295,
        length: 1,
        convRule: $f87c9187b968257a$export$4373e966038dbe47
    },
    {
        start: 4301,
        length: 1,
        convRule: $f87c9187b968257a$export$4373e966038dbe47
    },
    {
        start: 4304,
        length: 43,
        convRule: $f87c9187b968257a$export$659683f76ff91445
    },
    {
        start: 4347,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 4348,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 4349,
        length: 3,
        convRule: $f87c9187b968257a$export$659683f76ff91445
    },
    {
        start: 4352,
        length: 329,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4682,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4688,
        length: 7,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4696,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4698,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4704,
        length: 41,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4746,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4752,
        length: 33,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4786,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4792,
        length: 7,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4800,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4802,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4808,
        length: 15,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4824,
        length: 57,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4882,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4888,
        length: 67,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4957,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 4960,
        length: 9,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 4969,
        length: 20,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 4992,
        length: 16,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 5008,
        length: 10,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 5024,
        length: 80,
        convRule: $f87c9187b968257a$export$2f42ee7f4ae770fa
    },
    {
        start: 5104,
        length: 6,
        convRule: $f87c9187b968257a$export$679c844c5f2e021b
    },
    {
        start: 5112,
        length: 6,
        convRule: $f87c9187b968257a$export$9773cf18228b1a46
    },
    {
        start: 5120,
        length: 1,
        convRule: $f87c9187b968257a$export$3db8b2fe6cbecf3b
    },
    {
        start: 5121,
        length: 620,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 5741,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 5742,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 5743,
        length: 17,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 5760,
        length: 1,
        convRule: $f87c9187b968257a$export$51ebcaadb3c67176
    },
    {
        start: 5761,
        length: 26,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 5787,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 5788,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 5792,
        length: 75,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 5867,
        length: 3,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 5870,
        length: 3,
        convRule: $f87c9187b968257a$export$cb3182d6558993ee
    },
    {
        start: 5873,
        length: 8,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 5888,
        length: 13,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 5902,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 5906,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 5920,
        length: 18,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 5938,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 5941,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 5952,
        length: 18,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 5970,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 5984,
        length: 13,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 5998,
        length: 3,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 6002,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6016,
        length: 52,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 6068,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6070,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 6071,
        length: 7,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6078,
        length: 8,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 6086,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6087,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 6089,
        length: 11,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6100,
        length: 3,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 6103,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 6104,
        length: 3,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 6107,
        length: 1,
        convRule: $f87c9187b968257a$export$866935d782a1adf9
    },
    {
        start: 6108,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 6109,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6112,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 6128,
        length: 10,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 6144,
        length: 6,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 6150,
        length: 1,
        convRule: $f87c9187b968257a$export$3db8b2fe6cbecf3b
    },
    {
        start: 6151,
        length: 4,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 6155,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6158,
        length: 1,
        convRule: $f87c9187b968257a$export$def784bda4c4ba83
    },
    {
        start: 6160,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 6176,
        length: 35,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 6211,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 6212,
        length: 53,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 6272,
        length: 5,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 6277,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6279,
        length: 34,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 6313,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6314,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 6320,
        length: 70,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 6400,
        length: 31,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 6432,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6435,
        length: 4,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 6439,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6441,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 6448,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 6450,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6451,
        length: 6,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 6457,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6464,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 6468,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 6470,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 6480,
        length: 30,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 6512,
        length: 5,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 6528,
        length: 44,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 6576,
        length: 26,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 6608,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 6618,
        length: 1,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 6622,
        length: 34,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 6656,
        length: 23,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 6679,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6681,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 6683,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6686,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 6688,
        length: 53,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 6741,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 6742,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6743,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 6744,
        length: 7,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6752,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6753,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 6754,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6755,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 6757,
        length: 8,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6765,
        length: 6,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 6771,
        length: 10,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6783,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6784,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 6800,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 6816,
        length: 7,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 6823,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 6824,
        length: 6,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 6832,
        length: 14,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6846,
        length: 1,
        convRule: $f87c9187b968257a$export$69945c68dca01b70
    },
    {
        start: 6847,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6912,
        length: 4,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6916,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 6917,
        length: 47,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 6964,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6965,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 6966,
        length: 5,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6971,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 6972,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6973,
        length: 5,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 6978,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6979,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 6981,
        length: 7,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 6992,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 7002,
        length: 7,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 7009,
        length: 10,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 7019,
        length: 9,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 7028,
        length: 9,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 7040,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 7042,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 7043,
        length: 30,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 7073,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 7074,
        length: 4,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 7078,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 7080,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 7082,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 7083,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 7086,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 7088,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 7098,
        length: 44,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 7142,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 7143,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 7144,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 7146,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 7149,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 7150,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 7151,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 7154,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 7164,
        length: 4,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 7168,
        length: 36,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 7204,
        length: 8,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 7212,
        length: 8,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 7220,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 7222,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 7227,
        length: 5,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 7232,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 7245,
        length: 3,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 7248,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 7258,
        length: 30,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 7288,
        length: 6,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 7294,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 7296,
        length: 1,
        convRule: $f87c9187b968257a$export$959ab01c5a7aed98
    },
    {
        start: 7297,
        length: 1,
        convRule: $f87c9187b968257a$export$4b86aace1bd7e1bd
    },
    {
        start: 7298,
        length: 1,
        convRule: $f87c9187b968257a$export$af46a44506145125
    },
    {
        start: 7299,
        length: 2,
        convRule: $f87c9187b968257a$export$5b58a7342deeffb1
    },
    {
        start: 7301,
        length: 1,
        convRule: $f87c9187b968257a$export$ce586bf4d1a1e66
    },
    {
        start: 7302,
        length: 1,
        convRule: $f87c9187b968257a$export$2da14ab05c277ce3
    },
    {
        start: 7303,
        length: 1,
        convRule: $f87c9187b968257a$export$50efda91b0b7cb4d
    },
    {
        start: 7304,
        length: 1,
        convRule: $f87c9187b968257a$export$a003c458cd158704
    },
    {
        start: 7312,
        length: 43,
        convRule: $f87c9187b968257a$export$ea5950d132bda3cb
    },
    {
        start: 7357,
        length: 3,
        convRule: $f87c9187b968257a$export$ea5950d132bda3cb
    },
    {
        start: 7360,
        length: 8,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 7376,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 7379,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 7380,
        length: 13,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 7393,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 7394,
        length: 7,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 7401,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 7405,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 7406,
        length: 6,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 7412,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 7413,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 7415,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 7416,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 7418,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 7424,
        length: 44,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 7468,
        length: 63,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 7531,
        length: 13,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 7544,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 7545,
        length: 1,
        convRule: $f87c9187b968257a$export$72fbf6834eb62a3
    },
    {
        start: 7546,
        length: 3,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 7549,
        length: 1,
        convRule: $f87c9187b968257a$export$a54f88f7b56ccb1b
    },
    {
        start: 7550,
        length: 16,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 7566,
        length: 1,
        convRule: $f87c9187b968257a$export$1630391a83c31f3f
    },
    {
        start: 7567,
        length: 12,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 7579,
        length: 37,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 7616,
        length: 58,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 7675,
        length: 5,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 7680,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7681,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7682,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7683,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7684,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7685,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7686,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7687,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7688,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7689,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7690,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7691,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7692,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7693,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7694,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7695,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7696,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7697,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7698,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7699,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7700,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7701,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7702,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7703,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7704,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7705,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7706,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7707,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7708,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7709,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7710,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7711,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7712,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7713,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7714,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7715,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7716,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7717,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7718,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7719,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7720,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7721,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7722,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7723,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7724,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7725,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7726,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7727,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7728,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7729,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7730,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7731,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7732,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7733,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7734,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7735,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7736,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7737,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7738,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7739,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7740,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7741,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7742,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7743,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7744,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7745,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7746,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7747,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7748,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7749,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7750,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7751,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7752,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7753,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7754,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7755,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7756,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7757,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7758,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7759,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7760,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7761,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7762,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7763,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7764,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7765,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7766,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7767,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7768,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7769,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7770,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7771,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7772,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7773,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7774,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7775,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7776,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7777,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7778,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7779,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7780,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7781,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7782,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7783,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7784,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7785,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7786,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7787,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7788,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7789,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7790,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7791,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7792,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7793,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7794,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7795,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7796,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7797,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7798,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7799,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7800,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7801,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7802,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7803,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7804,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7805,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7806,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7807,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7808,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7809,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7810,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7811,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7812,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7813,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7814,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7815,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7816,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7817,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7818,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7819,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7820,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7821,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7822,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7823,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7824,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7825,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7826,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7827,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7828,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7829,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7830,
        length: 5,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 7835,
        length: 1,
        convRule: $f87c9187b968257a$export$77879d885a56be5b
    },
    {
        start: 7836,
        length: 2,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 7838,
        length: 1,
        convRule: $f87c9187b968257a$export$6ed378352675c85b
    },
    {
        start: 7839,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 7840,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7841,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7842,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7843,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7844,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7845,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7846,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7847,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7848,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7849,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7850,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7851,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7852,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7853,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7854,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7855,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7856,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7857,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7858,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7859,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7860,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7861,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7862,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7863,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7864,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7865,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7866,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7867,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7868,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7869,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7870,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7871,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7872,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7873,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7874,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7875,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7876,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7877,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7878,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7879,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7880,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7881,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7882,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7883,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7884,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7885,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7886,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7887,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7888,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7889,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7890,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7891,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7892,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7893,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7894,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7895,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7896,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7897,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7898,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7899,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7900,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7901,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7902,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7903,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7904,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7905,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7906,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7907,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7908,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7909,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7910,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7911,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7912,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7913,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7914,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7915,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7916,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7917,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7918,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7919,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7920,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7921,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7922,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7923,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7924,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7925,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7926,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7927,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7928,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7929,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7930,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7931,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7932,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7933,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7934,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7935,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7936,
        length: 8,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 7944,
        length: 8,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 7952,
        length: 6,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 7960,
        length: 6,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 7968,
        length: 8,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 7976,
        length: 8,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 7984,
        length: 8,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 7992,
        length: 8,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 8000,
        length: 6,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 8008,
        length: 6,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 8016,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8017,
        length: 1,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 8018,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8019,
        length: 1,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 8020,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8021,
        length: 1,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 8022,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8023,
        length: 1,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 8025,
        length: 1,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 8027,
        length: 1,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 8029,
        length: 1,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 8031,
        length: 1,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 8032,
        length: 8,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 8040,
        length: 8,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 8048,
        length: 2,
        convRule: $f87c9187b968257a$export$5d5cff08baa82bb3
    },
    {
        start: 8050,
        length: 4,
        convRule: $f87c9187b968257a$export$30cbf10eadff8354
    },
    {
        start: 8054,
        length: 2,
        convRule: $f87c9187b968257a$export$625a4e9662bb8009
    },
    {
        start: 8056,
        length: 2,
        convRule: $f87c9187b968257a$export$bfd29a26bb9c7604
    },
    {
        start: 8058,
        length: 2,
        convRule: $f87c9187b968257a$export$84e329f80ee32d86
    },
    {
        start: 8060,
        length: 2,
        convRule: $f87c9187b968257a$export$ec097e7d1326c9d8
    },
    {
        start: 8064,
        length: 8,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 8072,
        length: 8,
        convRule: $f87c9187b968257a$export$9073887b88a95a65
    },
    {
        start: 8080,
        length: 8,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 8088,
        length: 8,
        convRule: $f87c9187b968257a$export$9073887b88a95a65
    },
    {
        start: 8096,
        length: 8,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 8104,
        length: 8,
        convRule: $f87c9187b968257a$export$9073887b88a95a65
    },
    {
        start: 8112,
        length: 2,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 8114,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8115,
        length: 1,
        convRule: $f87c9187b968257a$export$14cf3cf7fed1ce4
    },
    {
        start: 8116,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8118,
        length: 2,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8120,
        length: 2,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 8122,
        length: 2,
        convRule: $f87c9187b968257a$export$b6ed7bef3aaad2a4
    },
    {
        start: 8124,
        length: 1,
        convRule: $f87c9187b968257a$export$a9178d4e39cbf99b
    },
    {
        start: 8125,
        length: 1,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 8126,
        length: 1,
        convRule: $f87c9187b968257a$export$847447ed9edca5f
    },
    {
        start: 8127,
        length: 3,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 8130,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8131,
        length: 1,
        convRule: $f87c9187b968257a$export$14cf3cf7fed1ce4
    },
    {
        start: 8132,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8134,
        length: 2,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8136,
        length: 4,
        convRule: $f87c9187b968257a$export$a2950913305bfd2f
    },
    {
        start: 8140,
        length: 1,
        convRule: $f87c9187b968257a$export$a9178d4e39cbf99b
    },
    {
        start: 8141,
        length: 3,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 8144,
        length: 2,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 8146,
        length: 2,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8150,
        length: 2,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8152,
        length: 2,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 8154,
        length: 2,
        convRule: $f87c9187b968257a$export$4debf059fdd78967
    },
    {
        start: 8157,
        length: 3,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 8160,
        length: 2,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 8162,
        length: 3,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8165,
        length: 1,
        convRule: $f87c9187b968257a$export$541be5c98ac427fb
    },
    {
        start: 8166,
        length: 2,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8168,
        length: 2,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 8170,
        length: 2,
        convRule: $f87c9187b968257a$export$3cc60af0b8fe51fb
    },
    {
        start: 8172,
        length: 1,
        convRule: $f87c9187b968257a$export$9568c26f20ab8b54
    },
    {
        start: 8173,
        length: 3,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 8178,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8179,
        length: 1,
        convRule: $f87c9187b968257a$export$14cf3cf7fed1ce4
    },
    {
        start: 8180,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8182,
        length: 2,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8184,
        length: 2,
        convRule: $f87c9187b968257a$export$c251b05d03bb1b09
    },
    {
        start: 8186,
        length: 2,
        convRule: $f87c9187b968257a$export$db469ad8291bc174
    },
    {
        start: 8188,
        length: 1,
        convRule: $f87c9187b968257a$export$a9178d4e39cbf99b
    },
    {
        start: 8189,
        length: 2,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 8192,
        length: 11,
        convRule: $f87c9187b968257a$export$51ebcaadb3c67176
    },
    {
        start: 8203,
        length: 5,
        convRule: $f87c9187b968257a$export$def784bda4c4ba83
    },
    {
        start: 8208,
        length: 6,
        convRule: $f87c9187b968257a$export$3db8b2fe6cbecf3b
    },
    {
        start: 8214,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 8216,
        length: 1,
        convRule: $f87c9187b968257a$export$6d507407c09b2bdb
    },
    {
        start: 8217,
        length: 1,
        convRule: $f87c9187b968257a$export$b954bed55b55ec5c
    },
    {
        start: 8218,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 8219,
        length: 2,
        convRule: $f87c9187b968257a$export$6d507407c09b2bdb
    },
    {
        start: 8221,
        length: 1,
        convRule: $f87c9187b968257a$export$b954bed55b55ec5c
    },
    {
        start: 8222,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 8223,
        length: 1,
        convRule: $f87c9187b968257a$export$6d507407c09b2bdb
    },
    {
        start: 8224,
        length: 8,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 8232,
        length: 1,
        convRule: $f87c9187b968257a$export$6b7d2f092933a352
    },
    {
        start: 8233,
        length: 1,
        convRule: $f87c9187b968257a$export$f862c925a5027a25
    },
    {
        start: 8234,
        length: 5,
        convRule: $f87c9187b968257a$export$def784bda4c4ba83
    },
    {
        start: 8239,
        length: 1,
        convRule: $f87c9187b968257a$export$51ebcaadb3c67176
    },
    {
        start: 8240,
        length: 9,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 8249,
        length: 1,
        convRule: $f87c9187b968257a$export$6d507407c09b2bdb
    },
    {
        start: 8250,
        length: 1,
        convRule: $f87c9187b968257a$export$b954bed55b55ec5c
    },
    {
        start: 8251,
        length: 4,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 8255,
        length: 2,
        convRule: $f87c9187b968257a$export$3e4e0426de951c07
    },
    {
        start: 8257,
        length: 3,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 8260,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 8261,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 8262,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 8263,
        length: 11,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 8274,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 8275,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 8276,
        length: 1,
        convRule: $f87c9187b968257a$export$3e4e0426de951c07
    },
    {
        start: 8277,
        length: 10,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 8287,
        length: 1,
        convRule: $f87c9187b968257a$export$51ebcaadb3c67176
    },
    {
        start: 8288,
        length: 5,
        convRule: $f87c9187b968257a$export$def784bda4c4ba83
    },
    {
        start: 8294,
        length: 10,
        convRule: $f87c9187b968257a$export$def784bda4c4ba83
    },
    {
        start: 8304,
        length: 1,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 8305,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 8308,
        length: 6,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 8314,
        length: 3,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 8317,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 8318,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 8319,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 8320,
        length: 10,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 8330,
        length: 3,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 8333,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 8334,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 8336,
        length: 13,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 8352,
        length: 32,
        convRule: $f87c9187b968257a$export$866935d782a1adf9
    },
    {
        start: 8400,
        length: 13,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 8413,
        length: 4,
        convRule: $f87c9187b968257a$export$69945c68dca01b70
    },
    {
        start: 8417,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 8418,
        length: 3,
        convRule: $f87c9187b968257a$export$69945c68dca01b70
    },
    {
        start: 8421,
        length: 12,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 8448,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8450,
        length: 1,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 8451,
        length: 4,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8455,
        length: 1,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 8456,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8458,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8459,
        length: 3,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 8462,
        length: 2,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8464,
        length: 3,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 8467,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8468,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8469,
        length: 1,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 8470,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8472,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 8473,
        length: 5,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 8478,
        length: 6,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8484,
        length: 1,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 8485,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8486,
        length: 1,
        convRule: $f87c9187b968257a$export$c50d507ea3901971
    },
    {
        start: 8487,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8488,
        length: 1,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 8489,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8490,
        length: 1,
        convRule: $f87c9187b968257a$export$c3ea2d19789db55a
    },
    {
        start: 8491,
        length: 1,
        convRule: $f87c9187b968257a$export$757246ae7800bfc2
    },
    {
        start: 8492,
        length: 2,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 8494,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8495,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8496,
        length: 2,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 8498,
        length: 1,
        convRule: $f87c9187b968257a$export$3c9855e4a4f89f58
    },
    {
        start: 8499,
        length: 1,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 8500,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8501,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 8505,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8506,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8508,
        length: 2,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8510,
        length: 2,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 8512,
        length: 5,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 8517,
        length: 1,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 8518,
        length: 4,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8522,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8523,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 8524,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8526,
        length: 1,
        convRule: $f87c9187b968257a$export$3f567b3eda4c98ad
    },
    {
        start: 8527,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8528,
        length: 16,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 8544,
        length: 16,
        convRule: $f87c9187b968257a$export$e687e84bc5c52c67
    },
    {
        start: 8560,
        length: 16,
        convRule: $f87c9187b968257a$export$a7141f854b2c3f56
    },
    {
        start: 8576,
        length: 3,
        convRule: $f87c9187b968257a$export$cb3182d6558993ee
    },
    {
        start: 8579,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 8580,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 8581,
        length: 4,
        convRule: $f87c9187b968257a$export$cb3182d6558993ee
    },
    {
        start: 8585,
        length: 1,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 8586,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8592,
        length: 5,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 8597,
        length: 5,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8602,
        length: 2,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 8604,
        length: 4,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8608,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 8609,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8611,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 8612,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8614,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 8615,
        length: 7,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8622,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 8623,
        length: 31,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8654,
        length: 2,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 8656,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8658,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 8659,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8660,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 8661,
        length: 31,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8692,
        length: 268,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 8960,
        length: 8,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8968,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 8969,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 8970,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 8971,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 8972,
        length: 20,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8992,
        length: 2,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 8994,
        length: 7,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 9001,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 9002,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 9003,
        length: 81,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 9084,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 9085,
        length: 30,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 9115,
        length: 25,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 9140,
        length: 40,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 9180,
        length: 6,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 9186,
        length: 69,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 9280,
        length: 11,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 9312,
        length: 60,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 9372,
        length: 26,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 9398,
        length: 26,
        convRule: $f87c9187b968257a$export$d7ef16e275a7be6
    },
    {
        start: 9424,
        length: 26,
        convRule: $f87c9187b968257a$export$99dabaca8c45da79
    },
    {
        start: 9450,
        length: 22,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 9472,
        length: 183,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 9655,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 9656,
        length: 9,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 9665,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 9666,
        length: 54,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 9720,
        length: 8,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 9728,
        length: 111,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 9839,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 9840,
        length: 248,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 10088,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10089,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10090,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10091,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10092,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10093,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10094,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10095,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10096,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10097,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10098,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10099,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10100,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10101,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10102,
        length: 30,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 10132,
        length: 44,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 10176,
        length: 5,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 10181,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10182,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10183,
        length: 31,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 10214,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10215,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10216,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10217,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10218,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10219,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10220,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10221,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10222,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10223,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10224,
        length: 16,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 10240,
        length: 256,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 10496,
        length: 131,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 10627,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10628,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10629,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10630,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10631,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10632,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10633,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10634,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10635,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10636,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10637,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10638,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10639,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10640,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10641,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10642,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10643,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10644,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10645,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10646,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10647,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10648,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10649,
        length: 63,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 10712,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10713,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10714,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10715,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10716,
        length: 32,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 10748,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10749,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10750,
        length: 258,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 11008,
        length: 48,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 11056,
        length: 21,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 11077,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 11079,
        length: 6,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 11085,
        length: 39,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 11126,
        length: 32,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 11159,
        length: 105,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 11264,
        length: 47,
        convRule: $f87c9187b968257a$export$663d5f91785521bc
    },
    {
        start: 11312,
        length: 47,
        convRule: $f87c9187b968257a$export$31855f4179a9d698
    },
    {
        start: 11360,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11361,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11362,
        length: 1,
        convRule: $f87c9187b968257a$export$7c2398d5fd516c81
    },
    {
        start: 11363,
        length: 1,
        convRule: $f87c9187b968257a$export$474b42537797e1da
    },
    {
        start: 11364,
        length: 1,
        convRule: $f87c9187b968257a$export$364aece97ca575d1
    },
    {
        start: 11365,
        length: 1,
        convRule: $f87c9187b968257a$export$3cf8e408ecc23ac8
    },
    {
        start: 11366,
        length: 1,
        convRule: $f87c9187b968257a$export$625d51f562fcdce
    },
    {
        start: 11367,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11368,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11369,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11370,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11371,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11372,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11373,
        length: 1,
        convRule: $f87c9187b968257a$export$5744c09a46214cda
    },
    {
        start: 11374,
        length: 1,
        convRule: $f87c9187b968257a$export$cbfae993dd34ee83
    },
    {
        start: 11375,
        length: 1,
        convRule: $f87c9187b968257a$export$a51fc7ab2fc1de9b
    },
    {
        start: 11376,
        length: 1,
        convRule: $f87c9187b968257a$export$e0af8c92046dd53d
    },
    {
        start: 11377,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 11378,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11379,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11380,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 11381,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11382,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11383,
        length: 5,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 11388,
        length: 2,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 11390,
        length: 2,
        convRule: $f87c9187b968257a$export$2b358c6ece5bacbe
    },
    {
        start: 11392,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11393,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11394,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11395,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11396,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11397,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11398,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11399,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11400,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11401,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11402,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11403,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11404,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11405,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11406,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11407,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11408,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11409,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11410,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11411,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11412,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11413,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11414,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11415,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11416,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11417,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11418,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11419,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11420,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11421,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11422,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11423,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11424,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11425,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11426,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11427,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11428,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11429,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11430,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11431,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11432,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11433,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11434,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11435,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11436,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11437,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11438,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11439,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11440,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11441,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11442,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11443,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11444,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11445,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11446,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11447,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11448,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11449,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11450,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11451,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11452,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11453,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11454,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11455,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11456,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11457,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11458,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11459,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11460,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11461,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11462,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11463,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11464,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11465,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11466,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11467,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11468,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11469,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11470,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11471,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11472,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11473,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11474,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11475,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11476,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11477,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11478,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11479,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11480,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11481,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11482,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11483,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11484,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11485,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11486,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11487,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11488,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11489,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11490,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11491,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11492,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 11493,
        length: 6,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 11499,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11500,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11501,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11502,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11503,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 11506,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11507,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11513,
        length: 4,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 11517,
        length: 1,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 11518,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 11520,
        length: 38,
        convRule: $f87c9187b968257a$export$7c5cb8ca51bc2320
    },
    {
        start: 11559,
        length: 1,
        convRule: $f87c9187b968257a$export$7c5cb8ca51bc2320
    },
    {
        start: 11565,
        length: 1,
        convRule: $f87c9187b968257a$export$7c5cb8ca51bc2320
    },
    {
        start: 11568,
        length: 56,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 11631,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 11632,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 11647,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 11648,
        length: 23,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 11680,
        length: 7,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 11688,
        length: 7,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 11696,
        length: 7,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 11704,
        length: 7,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 11712,
        length: 7,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 11720,
        length: 7,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 11728,
        length: 7,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 11736,
        length: 7,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 11744,
        length: 32,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 11776,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 11778,
        length: 1,
        convRule: $f87c9187b968257a$export$6d507407c09b2bdb
    },
    {
        start: 11779,
        length: 1,
        convRule: $f87c9187b968257a$export$b954bed55b55ec5c
    },
    {
        start: 11780,
        length: 1,
        convRule: $f87c9187b968257a$export$6d507407c09b2bdb
    },
    {
        start: 11781,
        length: 1,
        convRule: $f87c9187b968257a$export$b954bed55b55ec5c
    },
    {
        start: 11782,
        length: 3,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 11785,
        length: 1,
        convRule: $f87c9187b968257a$export$6d507407c09b2bdb
    },
    {
        start: 11786,
        length: 1,
        convRule: $f87c9187b968257a$export$b954bed55b55ec5c
    },
    {
        start: 11787,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 11788,
        length: 1,
        convRule: $f87c9187b968257a$export$6d507407c09b2bdb
    },
    {
        start: 11789,
        length: 1,
        convRule: $f87c9187b968257a$export$b954bed55b55ec5c
    },
    {
        start: 11790,
        length: 9,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 11799,
        length: 1,
        convRule: $f87c9187b968257a$export$3db8b2fe6cbecf3b
    },
    {
        start: 11800,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 11802,
        length: 1,
        convRule: $f87c9187b968257a$export$3db8b2fe6cbecf3b
    },
    {
        start: 11803,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 11804,
        length: 1,
        convRule: $f87c9187b968257a$export$6d507407c09b2bdb
    },
    {
        start: 11805,
        length: 1,
        convRule: $f87c9187b968257a$export$b954bed55b55ec5c
    },
    {
        start: 11806,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 11808,
        length: 1,
        convRule: $f87c9187b968257a$export$6d507407c09b2bdb
    },
    {
        start: 11809,
        length: 1,
        convRule: $f87c9187b968257a$export$b954bed55b55ec5c
    },
    {
        start: 11810,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 11811,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 11812,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 11813,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 11814,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 11815,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 11816,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 11817,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 11818,
        length: 5,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 11823,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 11824,
        length: 10,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 11834,
        length: 2,
        convRule: $f87c9187b968257a$export$3db8b2fe6cbecf3b
    },
    {
        start: 11836,
        length: 4,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 11840,
        length: 1,
        convRule: $f87c9187b968257a$export$3db8b2fe6cbecf3b
    },
    {
        start: 11841,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 11842,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 11843,
        length: 13,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 11856,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 11858,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 11904,
        length: 26,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 11931,
        length: 89,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 12032,
        length: 214,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 12272,
        length: 12,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 12288,
        length: 1,
        convRule: $f87c9187b968257a$export$51ebcaadb3c67176
    },
    {
        start: 12289,
        length: 3,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 12292,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 12293,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 12294,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 12295,
        length: 1,
        convRule: $f87c9187b968257a$export$cb3182d6558993ee
    },
    {
        start: 12296,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 12297,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 12298,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 12299,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 12300,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 12301,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 12302,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 12303,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 12304,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 12305,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 12306,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 12308,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 12309,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 12310,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 12311,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 12312,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 12313,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 12314,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 12315,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 12316,
        length: 1,
        convRule: $f87c9187b968257a$export$3db8b2fe6cbecf3b
    },
    {
        start: 12317,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 12318,
        length: 2,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 12320,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 12321,
        length: 9,
        convRule: $f87c9187b968257a$export$cb3182d6558993ee
    },
    {
        start: 12330,
        length: 4,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 12334,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 12336,
        length: 1,
        convRule: $f87c9187b968257a$export$3db8b2fe6cbecf3b
    },
    {
        start: 12337,
        length: 5,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 12342,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 12344,
        length: 3,
        convRule: $f87c9187b968257a$export$cb3182d6558993ee
    },
    {
        start: 12347,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 12348,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 12349,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 12350,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 12353,
        length: 86,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 12441,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 12443,
        length: 2,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 12445,
        length: 2,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 12447,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 12448,
        length: 1,
        convRule: $f87c9187b968257a$export$3db8b2fe6cbecf3b
    },
    {
        start: 12449,
        length: 90,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 12539,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 12540,
        length: 3,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 12543,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 12549,
        length: 43,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 12593,
        length: 94,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 12688,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 12690,
        length: 4,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 12694,
        length: 10,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 12704,
        length: 32,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 12736,
        length: 36,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 12784,
        length: 16,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 12800,
        length: 31,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 12832,
        length: 10,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 12842,
        length: 30,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 12872,
        length: 8,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 12880,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 12881,
        length: 15,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 12896,
        length: 32,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 12928,
        length: 10,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 12938,
        length: 39,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 12977,
        length: 15,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 12992,
        length: 320,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 13312,
        length: 6592,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 19904,
        length: 64,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 19968,
        length: 20989,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 40960,
        length: 21,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 40981,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 40982,
        length: 1143,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 42128,
        length: 55,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 42192,
        length: 40,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 42232,
        length: 6,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 42238,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 42240,
        length: 268,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 42508,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 42509,
        length: 3,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 42512,
        length: 16,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 42528,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 42538,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 42560,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42561,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42562,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42563,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42564,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42565,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42566,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42567,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42568,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42569,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42570,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42571,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42572,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42573,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42574,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42575,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42576,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42577,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42578,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42579,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42580,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42581,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42582,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42583,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42584,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42585,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42586,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42587,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42588,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42589,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42590,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42591,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42592,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42593,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42594,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42595,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42596,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42597,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42598,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42599,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42600,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42601,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42602,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42603,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42604,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42605,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42606,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 42607,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 42608,
        length: 3,
        convRule: $f87c9187b968257a$export$69945c68dca01b70
    },
    {
        start: 42611,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 42612,
        length: 10,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 42622,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 42623,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 42624,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42625,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42626,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42627,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42628,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42629,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42630,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42631,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42632,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42633,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42634,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42635,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42636,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42637,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42638,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42639,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42640,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42641,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42642,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42643,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42644,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42645,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42646,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42647,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42648,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42649,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42650,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42651,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42652,
        length: 2,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 42654,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 42656,
        length: 70,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 42726,
        length: 10,
        convRule: $f87c9187b968257a$export$cb3182d6558993ee
    },
    {
        start: 42736,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 42738,
        length: 6,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 42752,
        length: 23,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 42775,
        length: 9,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 42784,
        length: 2,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 42786,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42787,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42788,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42789,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42790,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42791,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42792,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42793,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42794,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42795,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42796,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42797,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42798,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42799,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42800,
        length: 2,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 42802,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42803,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42804,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42805,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42806,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42807,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42808,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42809,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42810,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42811,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42812,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42813,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42814,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42815,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42816,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42817,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42818,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42819,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42820,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42821,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42822,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42823,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42824,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42825,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42826,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42827,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42828,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42829,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42830,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42831,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42832,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42833,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42834,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42835,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42836,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42837,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42838,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42839,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42840,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42841,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42842,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42843,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42844,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42845,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42846,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42847,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42848,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42849,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42850,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42851,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42852,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42853,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42854,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42855,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42856,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42857,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42858,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42859,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42860,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42861,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42862,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42863,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42864,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 42865,
        length: 8,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 42873,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42874,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42875,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42876,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42877,
        length: 1,
        convRule: $f87c9187b968257a$export$5c0a6992d16a2cde
    },
    {
        start: 42878,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42879,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42880,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42881,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42882,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42883,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42884,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42885,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42886,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42887,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42888,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 42889,
        length: 2,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 42891,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42892,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42893,
        length: 1,
        convRule: $f87c9187b968257a$export$4e7f444f251bc9f3
    },
    {
        start: 42894,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 42895,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 42896,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42897,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42898,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42899,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42900,
        length: 1,
        convRule: $f87c9187b968257a$export$3eb062d0712525b5
    },
    {
        start: 42901,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 42902,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42903,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42904,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42905,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42906,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42907,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42908,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42909,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42910,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42911,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42912,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42913,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42914,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42915,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42916,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42917,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42918,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42919,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42920,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42921,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42922,
        length: 1,
        convRule: $f87c9187b968257a$export$e5aa8d48ff844b5
    },
    {
        start: 42923,
        length: 1,
        convRule: $f87c9187b968257a$export$56d3f806283387c4
    },
    {
        start: 42924,
        length: 1,
        convRule: $f87c9187b968257a$export$f4c6bcc526d116d5
    },
    {
        start: 42925,
        length: 1,
        convRule: $f87c9187b968257a$export$9b012ad386207454
    },
    {
        start: 42926,
        length: 1,
        convRule: $f87c9187b968257a$export$e5aa8d48ff844b5
    },
    {
        start: 42927,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 42928,
        length: 1,
        convRule: $f87c9187b968257a$export$8ecae8a612aae856
    },
    {
        start: 42929,
        length: 1,
        convRule: $f87c9187b968257a$export$126aa15c1eb2342d
    },
    {
        start: 42930,
        length: 1,
        convRule: $f87c9187b968257a$export$9d1fbeb551ba701e
    },
    {
        start: 42931,
        length: 1,
        convRule: $f87c9187b968257a$export$b525d0e4ac5bf938
    },
    {
        start: 42932,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42933,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42934,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42935,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42936,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42937,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42938,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42939,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42940,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42941,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42942,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42943,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42946,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42947,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42948,
        length: 1,
        convRule: $f87c9187b968257a$export$c8d4bace2652a68
    },
    {
        start: 42949,
        length: 1,
        convRule: $f87c9187b968257a$export$9e706749f691962d
    },
    {
        start: 42950,
        length: 1,
        convRule: $f87c9187b968257a$export$df8ee31db7227919
    },
    {
        start: 42951,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42952,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42953,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42954,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42997,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42998,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42999,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43000,
        length: 2,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 43002,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 43003,
        length: 7,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43010,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43011,
        length: 3,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43014,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43015,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43019,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43020,
        length: 23,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43043,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 43045,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43047,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 43048,
        length: 4,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 43052,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43056,
        length: 6,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 43062,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 43064,
        length: 1,
        convRule: $f87c9187b968257a$export$866935d782a1adf9
    },
    {
        start: 43065,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 43072,
        length: 52,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43124,
        length: 4,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 43136,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 43138,
        length: 50,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43188,
        length: 16,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 43204,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43214,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 43216,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 43232,
        length: 18,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43250,
        length: 6,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43256,
        length: 3,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 43259,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43260,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 43261,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43263,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43264,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 43274,
        length: 28,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43302,
        length: 8,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43310,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 43312,
        length: 23,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43335,
        length: 11,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43346,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 43359,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 43360,
        length: 29,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43392,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43395,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 43396,
        length: 47,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43443,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43444,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 43446,
        length: 4,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43450,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 43452,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43454,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 43457,
        length: 13,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 43471,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 43472,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 43486,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 43488,
        length: 5,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43493,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43494,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 43495,
        length: 9,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43504,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 43514,
        length: 5,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43520,
        length: 41,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43561,
        length: 6,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43567,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 43569,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43571,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 43573,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43584,
        length: 3,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43587,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43588,
        length: 8,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43596,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43597,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 43600,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 43612,
        length: 4,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 43616,
        length: 16,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43632,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 43633,
        length: 6,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43639,
        length: 3,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 43642,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43643,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 43644,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43645,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 43646,
        length: 50,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43696,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43697,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43698,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43701,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43703,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43705,
        length: 5,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43710,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43712,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43713,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43714,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43739,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43741,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 43742,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 43744,
        length: 11,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43755,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 43756,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43758,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 43760,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 43762,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43763,
        length: 2,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 43765,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 43766,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43777,
        length: 6,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43785,
        length: 6,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43793,
        length: 6,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43808,
        length: 7,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43816,
        length: 7,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43824,
        length: 35,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 43859,
        length: 1,
        convRule: $f87c9187b968257a$export$4b12fa44376611d5
    },
    {
        start: 43860,
        length: 7,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 43867,
        length: 1,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 43868,
        length: 4,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 43872,
        length: 9,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 43881,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 43882,
        length: 2,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 43888,
        length: 80,
        convRule: $f87c9187b968257a$export$5b2d7b2d5041cd36
    },
    {
        start: 43968,
        length: 35,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 44003,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 44005,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 44006,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 44008,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 44009,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 44011,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 44012,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 44013,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 44016,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 44032,
        length: 11172,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 55216,
        length: 23,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 55243,
        length: 49,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 55296,
        length: 896,
        convRule: $f87c9187b968257a$export$8664fc4768208d13
    },
    {
        start: 56192,
        length: 128,
        convRule: $f87c9187b968257a$export$8664fc4768208d13
    },
    {
        start: 56320,
        length: 1024,
        convRule: $f87c9187b968257a$export$8664fc4768208d13
    },
    {
        start: 57344,
        length: 6400,
        convRule: $f87c9187b968257a$export$d3f5d9ad8c1cc11c
    },
    {
        start: 63744,
        length: 366,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 64112,
        length: 106,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 64256,
        length: 7,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 64275,
        length: 5,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 64285,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 64286,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 64287,
        length: 10,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 64297,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 64298,
        length: 13,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 64312,
        length: 5,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 64318,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 64320,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 64323,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 64326,
        length: 108,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 64434,
        length: 16,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 64467,
        length: 363,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 64830,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 64831,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 64848,
        length: 64,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 64914,
        length: 54,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 65008,
        length: 12,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 65020,
        length: 1,
        convRule: $f87c9187b968257a$export$866935d782a1adf9
    },
    {
        start: 65021,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 65024,
        length: 16,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 65040,
        length: 7,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 65047,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 65048,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 65049,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 65056,
        length: 16,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 65072,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 65073,
        length: 2,
        convRule: $f87c9187b968257a$export$3db8b2fe6cbecf3b
    },
    {
        start: 65075,
        length: 2,
        convRule: $f87c9187b968257a$export$3e4e0426de951c07
    },
    {
        start: 65077,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 65078,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 65079,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 65080,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 65081,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 65082,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 65083,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 65084,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 65085,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 65086,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 65087,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 65088,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 65089,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 65090,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 65091,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 65092,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 65093,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 65095,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 65096,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 65097,
        length: 4,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 65101,
        length: 3,
        convRule: $f87c9187b968257a$export$3e4e0426de951c07
    },
    {
        start: 65104,
        length: 3,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 65108,
        length: 4,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 65112,
        length: 1,
        convRule: $f87c9187b968257a$export$3db8b2fe6cbecf3b
    },
    {
        start: 65113,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 65114,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 65115,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 65116,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 65117,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 65118,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 65119,
        length: 3,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 65122,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 65123,
        length: 1,
        convRule: $f87c9187b968257a$export$3db8b2fe6cbecf3b
    },
    {
        start: 65124,
        length: 3,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 65128,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 65129,
        length: 1,
        convRule: $f87c9187b968257a$export$866935d782a1adf9
    },
    {
        start: 65130,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 65136,
        length: 5,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 65142,
        length: 135,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 65279,
        length: 1,
        convRule: $f87c9187b968257a$export$def784bda4c4ba83
    },
    {
        start: 65281,
        length: 3,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 65284,
        length: 1,
        convRule: $f87c9187b968257a$export$866935d782a1adf9
    },
    {
        start: 65285,
        length: 3,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 65288,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 65289,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 65290,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 65291,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 65292,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 65293,
        length: 1,
        convRule: $f87c9187b968257a$export$3db8b2fe6cbecf3b
    },
    {
        start: 65294,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 65296,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 65306,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 65308,
        length: 3,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 65311,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 65313,
        length: 26,
        convRule: $f87c9187b968257a$export$5a8ad4756351e1a2
    },
    {
        start: 65339,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 65340,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 65341,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 65342,
        length: 1,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 65343,
        length: 1,
        convRule: $f87c9187b968257a$export$3e4e0426de951c07
    },
    {
        start: 65344,
        length: 1,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 65345,
        length: 26,
        convRule: $f87c9187b968257a$export$7173d2ee342e278
    },
    {
        start: 65371,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 65372,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 65373,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 65374,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 65375,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 65376,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 65377,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 65378,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 65379,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 65380,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 65382,
        length: 10,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 65392,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 65393,
        length: 45,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 65438,
        length: 2,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 65440,
        length: 31,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 65474,
        length: 6,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 65482,
        length: 6,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 65490,
        length: 6,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 65498,
        length: 3,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 65504,
        length: 2,
        convRule: $f87c9187b968257a$export$866935d782a1adf9
    },
    {
        start: 65506,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 65507,
        length: 1,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 65508,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 65509,
        length: 2,
        convRule: $f87c9187b968257a$export$866935d782a1adf9
    },
    {
        start: 65512,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 65513,
        length: 4,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 65517,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 65529,
        length: 3,
        convRule: $f87c9187b968257a$export$def784bda4c4ba83
    },
    {
        start: 65532,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 65536,
        length: 12,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 65549,
        length: 26,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 65576,
        length: 19,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 65596,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 65599,
        length: 15,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 65616,
        length: 14,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 65664,
        length: 123,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 65792,
        length: 3,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 65799,
        length: 45,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 65847,
        length: 9,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 65856,
        length: 53,
        convRule: $f87c9187b968257a$export$cb3182d6558993ee
    },
    {
        start: 65909,
        length: 4,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 65913,
        length: 17,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 65930,
        length: 2,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 65932,
        length: 3,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 65936,
        length: 13,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 65952,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 66000,
        length: 45,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 66045,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 66176,
        length: 29,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 66208,
        length: 49,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 66272,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 66273,
        length: 27,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 66304,
        length: 32,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 66336,
        length: 4,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 66349,
        length: 20,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 66369,
        length: 1,
        convRule: $f87c9187b968257a$export$cb3182d6558993ee
    },
    {
        start: 66370,
        length: 8,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 66378,
        length: 1,
        convRule: $f87c9187b968257a$export$cb3182d6558993ee
    },
    {
        start: 66384,
        length: 38,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 66422,
        length: 5,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 66432,
        length: 30,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 66463,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 66464,
        length: 36,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 66504,
        length: 8,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 66512,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 66513,
        length: 5,
        convRule: $f87c9187b968257a$export$cb3182d6558993ee
    },
    {
        start: 66560,
        length: 40,
        convRule: $f87c9187b968257a$export$5f381834e520bfa8
    },
    {
        start: 66600,
        length: 40,
        convRule: $f87c9187b968257a$export$fb16bdb144aa72d1
    },
    {
        start: 66640,
        length: 78,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 66720,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 66736,
        length: 36,
        convRule: $f87c9187b968257a$export$5f381834e520bfa8
    },
    {
        start: 66776,
        length: 36,
        convRule: $f87c9187b968257a$export$fb16bdb144aa72d1
    },
    {
        start: 66816,
        length: 40,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 66864,
        length: 52,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 66927,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 67072,
        length: 311,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 67392,
        length: 22,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 67424,
        length: 8,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 67584,
        length: 6,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 67592,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 67594,
        length: 44,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 67639,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 67644,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 67647,
        length: 23,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 67671,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 67672,
        length: 8,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 67680,
        length: 23,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 67703,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 67705,
        length: 7,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 67712,
        length: 31,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 67751,
        length: 9,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 67808,
        length: 19,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 67828,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 67835,
        length: 5,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 67840,
        length: 22,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 67862,
        length: 6,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 67871,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 67872,
        length: 26,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 67903,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 67968,
        length: 56,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 68028,
        length: 2,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 68030,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 68032,
        length: 16,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 68050,
        length: 46,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 68096,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 68097,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 68101,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 68108,
        length: 4,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 68112,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 68117,
        length: 3,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 68121,
        length: 29,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 68152,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 68159,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 68160,
        length: 9,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 68176,
        length: 9,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 68192,
        length: 29,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 68221,
        length: 2,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 68223,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 68224,
        length: 29,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 68253,
        length: 3,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 68288,
        length: 8,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 68296,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 68297,
        length: 28,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 68325,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 68331,
        length: 5,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 68336,
        length: 7,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 68352,
        length: 54,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 68409,
        length: 7,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 68416,
        length: 22,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 68440,
        length: 8,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 68448,
        length: 19,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 68472,
        length: 8,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 68480,
        length: 18,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 68505,
        length: 4,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 68521,
        length: 7,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 68608,
        length: 73,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 68736,
        length: 51,
        convRule: $f87c9187b968257a$export$31515a1452fded76
    },
    {
        start: 68800,
        length: 51,
        convRule: $f87c9187b968257a$export$3fc150f61f8b8954
    },
    {
        start: 68858,
        length: 6,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 68864,
        length: 36,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 68900,
        length: 4,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 68912,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 69216,
        length: 31,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 69248,
        length: 42,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 69291,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 69293,
        length: 1,
        convRule: $f87c9187b968257a$export$3db8b2fe6cbecf3b
    },
    {
        start: 69296,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 69376,
        length: 29,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 69405,
        length: 10,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 69415,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 69424,
        length: 22,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 69446,
        length: 11,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 69457,
        length: 4,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 69461,
        length: 5,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 69552,
        length: 21,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 69573,
        length: 7,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 69600,
        length: 23,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 69632,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 69633,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 69634,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 69635,
        length: 53,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 69688,
        length: 15,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 69703,
        length: 7,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 69714,
        length: 20,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 69734,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 69759,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 69762,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 69763,
        length: 45,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 69808,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 69811,
        length: 4,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 69815,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 69817,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 69819,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 69821,
        length: 1,
        convRule: $f87c9187b968257a$export$def784bda4c4ba83
    },
    {
        start: 69822,
        length: 4,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 69837,
        length: 1,
        convRule: $f87c9187b968257a$export$def784bda4c4ba83
    },
    {
        start: 69840,
        length: 25,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 69872,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 69888,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 69891,
        length: 36,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 69927,
        length: 5,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 69932,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 69933,
        length: 8,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 69942,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 69952,
        length: 4,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 69956,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 69957,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 69959,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 69968,
        length: 35,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70003,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 70004,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 70006,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70016,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 70018,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 70019,
        length: 48,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70067,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 70070,
        length: 9,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 70079,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 70081,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70085,
        length: 4,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 70089,
        length: 4,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 70093,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 70094,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 70095,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 70096,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 70106,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70107,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 70108,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70109,
        length: 3,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 70113,
        length: 20,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 70144,
        length: 18,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70163,
        length: 25,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70188,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 70191,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 70194,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 70196,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 70197,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 70198,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 70200,
        length: 6,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 70206,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 70272,
        length: 7,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70280,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70282,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70287,
        length: 15,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70303,
        length: 10,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70313,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 70320,
        length: 47,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70367,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 70368,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 70371,
        length: 8,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 70384,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 70400,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 70402,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 70405,
        length: 8,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70415,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70419,
        length: 22,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70442,
        length: 7,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70450,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70453,
        length: 5,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70459,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 70461,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70462,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 70464,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 70465,
        length: 4,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 70471,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 70475,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 70480,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70487,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 70493,
        length: 5,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70498,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 70502,
        length: 7,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 70512,
        length: 5,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 70656,
        length: 53,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70709,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 70712,
        length: 8,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 70720,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 70722,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 70725,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 70726,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 70727,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70731,
        length: 5,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 70736,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 70746,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 70749,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 70750,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 70751,
        length: 3,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70784,
        length: 48,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70832,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 70835,
        length: 6,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 70841,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 70842,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 70843,
        length: 4,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 70847,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 70849,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 70850,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 70852,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70854,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 70855,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70864,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 71040,
        length: 47,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 71087,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 71090,
        length: 4,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 71096,
        length: 4,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 71100,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 71102,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 71103,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 71105,
        length: 23,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 71128,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 71132,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 71168,
        length: 48,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 71216,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 71219,
        length: 8,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 71227,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 71229,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 71230,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 71231,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 71233,
        length: 3,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 71236,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 71248,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 71264,
        length: 13,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 71296,
        length: 43,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 71339,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 71340,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 71341,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 71342,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 71344,
        length: 6,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 71350,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 71351,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 71352,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 71360,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 71424,
        length: 27,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 71453,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 71456,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 71458,
        length: 4,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 71462,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 71463,
        length: 5,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 71472,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 71482,
        length: 2,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 71484,
        length: 3,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 71487,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 71680,
        length: 44,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 71724,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 71727,
        length: 9,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 71736,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 71737,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 71739,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 71840,
        length: 32,
        convRule: $f87c9187b968257a$export$5a8ad4756351e1a2
    },
    {
        start: 71872,
        length: 32,
        convRule: $f87c9187b968257a$export$7173d2ee342e278
    },
    {
        start: 71904,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 71914,
        length: 9,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 71935,
        length: 8,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 71945,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 71948,
        length: 8,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 71957,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 71960,
        length: 24,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 71984,
        length: 6,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 71991,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 71995,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 71997,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 71998,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 71999,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 72000,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 72001,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 72002,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 72003,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 72004,
        length: 3,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 72016,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 72096,
        length: 8,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 72106,
        length: 39,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 72145,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 72148,
        length: 4,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 72154,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 72156,
        length: 4,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 72160,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 72161,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 72162,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 72163,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 72164,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 72192,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 72193,
        length: 10,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 72203,
        length: 40,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 72243,
        length: 6,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 72249,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 72250,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 72251,
        length: 4,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 72255,
        length: 8,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 72263,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 72272,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 72273,
        length: 6,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 72279,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 72281,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 72284,
        length: 46,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 72330,
        length: 13,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 72343,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 72344,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 72346,
        length: 3,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 72349,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 72350,
        length: 5,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 72384,
        length: 57,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 72704,
        length: 9,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 72714,
        length: 37,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 72751,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 72752,
        length: 7,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 72760,
        length: 6,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 72766,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 72767,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 72768,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 72769,
        length: 5,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 72784,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 72794,
        length: 19,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 72816,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 72818,
        length: 30,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 72850,
        length: 22,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 72873,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 72874,
        length: 7,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 72881,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 72882,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 72884,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 72885,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 72960,
        length: 7,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 72968,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 72971,
        length: 38,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 73009,
        length: 6,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 73018,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 73020,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 73023,
        length: 7,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 73030,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 73031,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 73040,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 73056,
        length: 6,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 73063,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 73066,
        length: 32,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 73098,
        length: 5,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 73104,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 73107,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 73109,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 73110,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 73111,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 73112,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 73120,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 73440,
        length: 19,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 73459,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 73461,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 73463,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 73648,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 73664,
        length: 21,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 73685,
        length: 8,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 73693,
        length: 4,
        convRule: $f87c9187b968257a$export$866935d782a1adf9
    },
    {
        start: 73697,
        length: 17,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 73727,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 73728,
        length: 922,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 74752,
        length: 111,
        convRule: $f87c9187b968257a$export$cb3182d6558993ee
    },
    {
        start: 74864,
        length: 5,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 74880,
        length: 196,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 77824,
        length: 1071,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 78896,
        length: 9,
        convRule: $f87c9187b968257a$export$def784bda4c4ba83
    },
    {
        start: 82944,
        length: 583,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 92160,
        length: 569,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 92736,
        length: 31,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 92768,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 92782,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 92880,
        length: 30,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 92912,
        length: 5,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 92917,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 92928,
        length: 48,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 92976,
        length: 7,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 92983,
        length: 5,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 92988,
        length: 4,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 92992,
        length: 4,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 92996,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 92997,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 93008,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 93019,
        length: 7,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 93027,
        length: 21,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 93053,
        length: 19,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 93760,
        length: 32,
        convRule: $f87c9187b968257a$export$5a8ad4756351e1a2
    },
    {
        start: 93792,
        length: 32,
        convRule: $f87c9187b968257a$export$7173d2ee342e278
    },
    {
        start: 93824,
        length: 23,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 93847,
        length: 4,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 93952,
        length: 75,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 94031,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 94032,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 94033,
        length: 55,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 94095,
        length: 4,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 94099,
        length: 13,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 94176,
        length: 2,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 94178,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 94179,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 94180,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 94192,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 94208,
        length: 6136,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 100352,
        length: 1238,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 101632,
        length: 9,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 110592,
        length: 287,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 110928,
        length: 3,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 110948,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 110960,
        length: 396,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 113664,
        length: 107,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 113776,
        length: 13,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 113792,
        length: 9,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 113808,
        length: 10,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 113820,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 113821,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 113823,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 113824,
        length: 4,
        convRule: $f87c9187b968257a$export$def784bda4c4ba83
    },
    {
        start: 118784,
        length: 246,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 119040,
        length: 39,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 119081,
        length: 60,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 119141,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 119143,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 119146,
        length: 3,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 119149,
        length: 6,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 119155,
        length: 8,
        convRule: $f87c9187b968257a$export$def784bda4c4ba83
    },
    {
        start: 119163,
        length: 8,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 119171,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 119173,
        length: 7,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 119180,
        length: 30,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 119210,
        length: 4,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 119214,
        length: 59,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 119296,
        length: 66,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 119362,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 119365,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 119520,
        length: 20,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 119552,
        length: 87,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 119648,
        length: 25,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 119808,
        length: 26,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 119834,
        length: 26,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 119860,
        length: 26,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 119886,
        length: 7,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 119894,
        length: 18,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 119912,
        length: 26,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 119938,
        length: 26,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 119964,
        length: 1,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 119966,
        length: 2,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 119970,
        length: 1,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 119973,
        length: 2,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 119977,
        length: 4,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 119982,
        length: 8,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 119990,
        length: 4,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 119995,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 119997,
        length: 7,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 120005,
        length: 11,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 120016,
        length: 26,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 120042,
        length: 26,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 120068,
        length: 2,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 120071,
        length: 4,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 120077,
        length: 8,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 120086,
        length: 7,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 120094,
        length: 26,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 120120,
        length: 2,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 120123,
        length: 4,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 120128,
        length: 5,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 120134,
        length: 1,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 120138,
        length: 7,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 120146,
        length: 26,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 120172,
        length: 26,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 120198,
        length: 26,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 120224,
        length: 26,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 120250,
        length: 26,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 120276,
        length: 26,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 120302,
        length: 26,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 120328,
        length: 26,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 120354,
        length: 26,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 120380,
        length: 26,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 120406,
        length: 26,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 120432,
        length: 26,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 120458,
        length: 28,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 120488,
        length: 25,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 120513,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 120514,
        length: 25,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 120539,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 120540,
        length: 6,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 120546,
        length: 25,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 120571,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 120572,
        length: 25,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 120597,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 120598,
        length: 6,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 120604,
        length: 25,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 120629,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 120630,
        length: 25,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 120655,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 120656,
        length: 6,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 120662,
        length: 25,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 120687,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 120688,
        length: 25,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 120713,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 120714,
        length: 6,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 120720,
        length: 25,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 120745,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 120746,
        length: 25,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 120771,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 120772,
        length: 6,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 120778,
        length: 1,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 120779,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 120782,
        length: 50,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 120832,
        length: 512,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 121344,
        length: 55,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 121399,
        length: 4,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 121403,
        length: 50,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 121453,
        length: 8,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 121461,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 121462,
        length: 14,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 121476,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 121477,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 121479,
        length: 5,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 121499,
        length: 5,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 121505,
        length: 15,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 122880,
        length: 7,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 122888,
        length: 17,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 122907,
        length: 7,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 122915,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 122918,
        length: 5,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 123136,
        length: 45,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 123184,
        length: 7,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 123191,
        length: 7,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 123200,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 123214,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 123215,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 123584,
        length: 44,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 123628,
        length: 4,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 123632,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 123647,
        length: 1,
        convRule: $f87c9187b968257a$export$866935d782a1adf9
    },
    {
        start: 124928,
        length: 197,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 125127,
        length: 9,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 125136,
        length: 7,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 125184,
        length: 34,
        convRule: $f87c9187b968257a$export$f0d6a468761d4066
    },
    {
        start: 125218,
        length: 34,
        convRule: $f87c9187b968257a$export$2a95711cd575be0d
    },
    {
        start: 125252,
        length: 7,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 125259,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 125264,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 125278,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 126065,
        length: 59,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 126124,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 126125,
        length: 3,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 126128,
        length: 1,
        convRule: $f87c9187b968257a$export$866935d782a1adf9
    },
    {
        start: 126129,
        length: 4,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 126209,
        length: 45,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 126254,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 126255,
        length: 15,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 126464,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126469,
        length: 27,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126497,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126500,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126503,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126505,
        length: 10,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126516,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126521,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126523,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126530,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126535,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126537,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126539,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126541,
        length: 3,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126545,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126548,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126551,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126553,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126555,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126557,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126559,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126561,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126564,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126567,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126572,
        length: 7,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126580,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126585,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126590,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126592,
        length: 10,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126603,
        length: 17,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126625,
        length: 3,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126629,
        length: 5,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126635,
        length: 17,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126704,
        length: 2,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 126976,
        length: 44,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 127024,
        length: 100,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 127136,
        length: 15,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 127153,
        length: 15,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 127169,
        length: 15,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 127185,
        length: 37,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 127232,
        length: 13,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 127245,
        length: 161,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 127462,
        length: 29,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 127504,
        length: 44,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 127552,
        length: 9,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 127568,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 127584,
        length: 6,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 127744,
        length: 251,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 127995,
        length: 5,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 128000,
        length: 728,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 128736,
        length: 13,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 128752,
        length: 13,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 128768,
        length: 116,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 128896,
        length: 89,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 128992,
        length: 12,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 129024,
        length: 12,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 129040,
        length: 56,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 129104,
        length: 10,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 129120,
        length: 40,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 129168,
        length: 30,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 129200,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 129280,
        length: 121,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 129402,
        length: 82,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 129485,
        length: 135,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 129632,
        length: 14,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 129648,
        length: 5,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 129656,
        length: 3,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 129664,
        length: 7,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 129680,
        length: 25,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 129712,
        length: 7,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 129728,
        length: 3,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 129744,
        length: 7,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 129792,
        length: 147,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 129940,
        length: 55,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 130032,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 131072,
        length: 42718,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 173824,
        length: 4149,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 177984,
        length: 222,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 178208,
        length: 5762,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 183984,
        length: 7473,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 194560,
        length: 542,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 196608,
        length: 4939,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 917505,
        length: 1,
        convRule: $f87c9187b968257a$export$def784bda4c4ba83
    },
    {
        start: 917536,
        length: 96,
        convRule: $f87c9187b968257a$export$def784bda4c4ba83
    },
    {
        start: 917760,
        length: 240,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 983040,
        length: 65534,
        convRule: $f87c9187b968257a$export$d3f5d9ad8c1cc11c
    },
    {
        start: 1048576,
        length: 65534,
        convRule: $f87c9187b968257a$export$d3f5d9ad8c1cc11c
    }
];
var $f87c9187b968257a$export$392fe5f697aae183 = function(categories) {
    return function($$char) {
        var numOfBlocks = function() {
            var $43 = $$char < 256;
            if ($43) return $f87c9187b968257a$export$7f6a2f09c9988b4f;
            return $f87c9187b968257a$export$d769d73966952fc5;
        }();
        var maybeConversionRule = $f87c9187b968257a$export$8a73d6c1af11382a($f87c9187b968257a$export$865f22e68241060)($$char)(numOfBlocks);
        if (maybeConversionRule instanceof $ykHdR.Nothing) return false;
        if (maybeConversionRule instanceof $ykHdR.Just) return $ykHdR.isJust($f87c9187b968257a$var$elemIndex(maybeConversionRule.value0.category)(categories));
        throw new Error("Failed pattern match at Data.CodePoint.Unicode.Internal (line 5645, column 5 - line 5647, column 86): " + [
            maybeConversionRule.constructor.name
        ]);
    };
};
var $f87c9187b968257a$export$a0fec735e7d145b = /* #__PURE__ */ $f87c9187b968257a$export$392fe5f697aae183([
    $f87c9187b968257a$export$c216bdb3b7384b3d,
    $f87c9187b968257a$export$87f3132a44b1d0ea,
    $f87c9187b968257a$export$2bb2c2963662e583,
    $f87c9187b968257a$export$f1770ca2c5ffe2d,
    $f87c9187b968257a$export$e589cea9a12b5fd5,
    $f87c9187b968257a$export$b2d990af7ab79d15,
    $f87c9187b968257a$export$ad5a9d75e70e6c80,
    $f87c9187b968257a$export$f3ac9c79570e46a,
    $f87c9187b968257a$export$b6e1d994a4b080a2,
    $f87c9187b968257a$export$a698e2e1192c5125,
    $f87c9187b968257a$export$a933a29cf15fc29a
]);
var $f87c9187b968257a$export$edcbae4531e40b8a = /* #__PURE__ */ $f87c9187b968257a$export$392fe5f697aae183([
    $f87c9187b968257a$export$2bb2c2963662e583,
    $f87c9187b968257a$export$87f3132a44b1d0ea,
    $f87c9187b968257a$export$c216bdb3b7384b3d,
    $f87c9187b968257a$export$f1770ca2c5ffe2d,
    $f87c9187b968257a$export$e589cea9a12b5fd5
]);
var $f87c9187b968257a$export$fed91e20fe04f313 = /* #__PURE__ */ $f87c9187b968257a$export$392fe5f697aae183([
    $f87c9187b968257a$export$3546ca4e02dbfe5f
]);
var $f87c9187b968257a$export$5d47dfc33b19ad38 = /* #__PURE__ */ $f87c9187b968257a$export$392fe5f697aae183([
    $f87c9187b968257a$export$a698e2e1192c5125
]);
var $f87c9187b968257a$export$7a4a3ef8a70b2a6 = /* #__PURE__ */ $f87c9187b968257a$export$392fe5f697aae183([
    $f87c9187b968257a$export$2bb2c2963662e583
]);
var $f87c9187b968257a$export$8b4972b3757fc3c7 = /* #__PURE__ */ $f87c9187b968257a$export$392fe5f697aae183([
    $f87c9187b968257a$export$b2d990af7ab79d15,
    $f87c9187b968257a$export$b6e1d994a4b080a2,
    $f87c9187b968257a$export$12ed53279ee450c4,
    $f87c9187b968257a$export$ad5a9d75e70e6c80,
    $f87c9187b968257a$export$a698e2e1192c5125,
    $f87c9187b968257a$export$a143e8efcc235a35,
    $f87c9187b968257a$export$c216bdb3b7384b3d,
    $f87c9187b968257a$export$686b010d74c757cc,
    $f87c9187b968257a$export$19ffa5f679fe11c0,
    $f87c9187b968257a$export$8e8b15481dfb814b,
    $f87c9187b968257a$export$87f3132a44b1d0ea,
    $f87c9187b968257a$export$fd5605db2a5deb4d,
    $f87c9187b968257a$export$a88f47445a8e3717,
    $f87c9187b968257a$export$fd83b20886c8feaa,
    $f87c9187b968257a$export$845a9d462a039d1b,
    $f87c9187b968257a$export$657f9ea297735c46,
    $f87c9187b968257a$export$c3ab662ef084c6ac,
    $f87c9187b968257a$export$2bb2c2963662e583,
    $f87c9187b968257a$export$f1770ca2c5ffe2d,
    $f87c9187b968257a$export$e01a543066f4428d,
    $f87c9187b968257a$export$a933a29cf15fc29a,
    $f87c9187b968257a$export$f3ac9c79570e46a,
    $f87c9187b968257a$export$e589cea9a12b5fd5
]);
var $f87c9187b968257a$export$3cb76ee86c1f055b = /* #__PURE__ */ $f87c9187b968257a$export$392fe5f697aae183([
    $f87c9187b968257a$export$87f3132a44b1d0ea,
    $f87c9187b968257a$export$c216bdb3b7384b3d
]);
var $f87c9187b968257a$export$6d2646f79a263fa8 = function($$char) {
    var conversionRule = $f87c9187b968257a$export$8a73d6c1af11382a($f87c9187b968257a$export$865f22e68241060)($$char)($f87c9187b968257a$export$d769d73966952fc5);
    return $f87c9187b968257a$var$map(function(v) {
        return v.unicodeCat;
    })(conversionRule);
};

});

parcelRegister("ayTiF", function(module, exports) {

$parcel$export(module.exports, "fold", () => $7b07f9d0d04434a1$export$93e2b83da34ff82a);
$parcel$export(module.exports, "foldFull", () => $7b07f9d0d04434a1$export$c86ab0718f163a93);
$parcel$export(module.exports, "lower", () => $7b07f9d0d04434a1$export$abae053c7acf36bb);
$parcel$export(module.exports, "title", () => $7b07f9d0d04434a1$export$fb184b623420d9be);
$parcel$export(module.exports, "upper", () => $7b07f9d0d04434a1$export$74b75dbc6083f1f5);
// Generated by purs version 0.15.16
parcelRequire("4VF0K");
var $lGiKR = parcelRequire("lGiKR");
var $4VF0K = parcelRequire("4VF0K");

var $lkGFT = parcelRequire("lkGFT");

var $ykHdR = parcelRequire("ykHdR");

var $d0PPW = parcelRequire("d0PPW");
var $7b07f9d0d04434a1$var$compare = /* #__PURE__ */ $d0PPW.compare($d0PPW.ordInt);
var $7b07f9d0d04434a1$export$b6e1a177a4bea09c = function(code) {
    return {
        code: code,
        lower: [],
        title: [],
        upper: [],
        fold: 0,
        foldFull: []
    };
};
var $7b07f9d0d04434a1$export$354076178bdef094 = [
    {
        code: 65,
        lower: [],
        title: [],
        upper: [],
        fold: 97,
        foldFull: [
            97
        ]
    },
    {
        code: 66,
        lower: [],
        title: [],
        upper: [],
        fold: 98,
        foldFull: [
            98
        ]
    },
    {
        code: 67,
        lower: [],
        title: [],
        upper: [],
        fold: 99,
        foldFull: [
            99
        ]
    },
    {
        code: 68,
        lower: [],
        title: [],
        upper: [],
        fold: 100,
        foldFull: [
            100
        ]
    },
    {
        code: 69,
        lower: [],
        title: [],
        upper: [],
        fold: 101,
        foldFull: [
            101
        ]
    },
    {
        code: 70,
        lower: [],
        title: [],
        upper: [],
        fold: 102,
        foldFull: [
            102
        ]
    },
    {
        code: 71,
        lower: [],
        title: [],
        upper: [],
        fold: 103,
        foldFull: [
            103
        ]
    },
    {
        code: 72,
        lower: [],
        title: [],
        upper: [],
        fold: 104,
        foldFull: [
            104
        ]
    },
    {
        code: 73,
        lower: [],
        title: [],
        upper: [],
        fold: 105,
        foldFull: [
            105
        ]
    },
    {
        code: 74,
        lower: [],
        title: [],
        upper: [],
        fold: 106,
        foldFull: [
            106
        ]
    },
    {
        code: 75,
        lower: [],
        title: [],
        upper: [],
        fold: 107,
        foldFull: [
            107
        ]
    },
    {
        code: 76,
        lower: [],
        title: [],
        upper: [],
        fold: 108,
        foldFull: [
            108
        ]
    },
    {
        code: 77,
        lower: [],
        title: [],
        upper: [],
        fold: 109,
        foldFull: [
            109
        ]
    },
    {
        code: 78,
        lower: [],
        title: [],
        upper: [],
        fold: 110,
        foldFull: [
            110
        ]
    },
    {
        code: 79,
        lower: [],
        title: [],
        upper: [],
        fold: 111,
        foldFull: [
            111
        ]
    },
    {
        code: 80,
        lower: [],
        title: [],
        upper: [],
        fold: 112,
        foldFull: [
            112
        ]
    },
    {
        code: 81,
        lower: [],
        title: [],
        upper: [],
        fold: 113,
        foldFull: [
            113
        ]
    },
    {
        code: 82,
        lower: [],
        title: [],
        upper: [],
        fold: 114,
        foldFull: [
            114
        ]
    },
    {
        code: 83,
        lower: [],
        title: [],
        upper: [],
        fold: 115,
        foldFull: [
            115
        ]
    },
    {
        code: 84,
        lower: [],
        title: [],
        upper: [],
        fold: 116,
        foldFull: [
            116
        ]
    },
    {
        code: 85,
        lower: [],
        title: [],
        upper: [],
        fold: 117,
        foldFull: [
            117
        ]
    },
    {
        code: 86,
        lower: [],
        title: [],
        upper: [],
        fold: 118,
        foldFull: [
            118
        ]
    },
    {
        code: 87,
        lower: [],
        title: [],
        upper: [],
        fold: 119,
        foldFull: [
            119
        ]
    },
    {
        code: 88,
        lower: [],
        title: [],
        upper: [],
        fold: 120,
        foldFull: [
            120
        ]
    },
    {
        code: 89,
        lower: [],
        title: [],
        upper: [],
        fold: 121,
        foldFull: [
            121
        ]
    },
    {
        code: 90,
        lower: [],
        title: [],
        upper: [],
        fold: 122,
        foldFull: [
            122
        ]
    },
    {
        code: 181,
        lower: [],
        title: [],
        upper: [],
        fold: 956,
        foldFull: [
            956
        ]
    },
    {
        code: 192,
        lower: [],
        title: [],
        upper: [],
        fold: 224,
        foldFull: [
            224
        ]
    },
    {
        code: 193,
        lower: [],
        title: [],
        upper: [],
        fold: 225,
        foldFull: [
            225
        ]
    },
    {
        code: 194,
        lower: [],
        title: [],
        upper: [],
        fold: 226,
        foldFull: [
            226
        ]
    },
    {
        code: 195,
        lower: [],
        title: [],
        upper: [],
        fold: 227,
        foldFull: [
            227
        ]
    },
    {
        code: 196,
        lower: [],
        title: [],
        upper: [],
        fold: 228,
        foldFull: [
            228
        ]
    },
    {
        code: 197,
        lower: [],
        title: [],
        upper: [],
        fold: 229,
        foldFull: [
            229
        ]
    },
    {
        code: 198,
        lower: [],
        title: [],
        upper: [],
        fold: 230,
        foldFull: [
            230
        ]
    },
    {
        code: 199,
        lower: [],
        title: [],
        upper: [],
        fold: 231,
        foldFull: [
            231
        ]
    },
    {
        code: 200,
        lower: [],
        title: [],
        upper: [],
        fold: 232,
        foldFull: [
            232
        ]
    },
    {
        code: 201,
        lower: [],
        title: [],
        upper: [],
        fold: 233,
        foldFull: [
            233
        ]
    },
    {
        code: 202,
        lower: [],
        title: [],
        upper: [],
        fold: 234,
        foldFull: [
            234
        ]
    },
    {
        code: 203,
        lower: [],
        title: [],
        upper: [],
        fold: 235,
        foldFull: [
            235
        ]
    },
    {
        code: 204,
        lower: [],
        title: [],
        upper: [],
        fold: 236,
        foldFull: [
            236
        ]
    },
    {
        code: 205,
        lower: [],
        title: [],
        upper: [],
        fold: 237,
        foldFull: [
            237
        ]
    },
    {
        code: 206,
        lower: [],
        title: [],
        upper: [],
        fold: 238,
        foldFull: [
            238
        ]
    },
    {
        code: 207,
        lower: [],
        title: [],
        upper: [],
        fold: 239,
        foldFull: [
            239
        ]
    },
    {
        code: 208,
        lower: [],
        title: [],
        upper: [],
        fold: 240,
        foldFull: [
            240
        ]
    },
    {
        code: 209,
        lower: [],
        title: [],
        upper: [],
        fold: 241,
        foldFull: [
            241
        ]
    },
    {
        code: 210,
        lower: [],
        title: [],
        upper: [],
        fold: 242,
        foldFull: [
            242
        ]
    },
    {
        code: 211,
        lower: [],
        title: [],
        upper: [],
        fold: 243,
        foldFull: [
            243
        ]
    },
    {
        code: 212,
        lower: [],
        title: [],
        upper: [],
        fold: 244,
        foldFull: [
            244
        ]
    },
    {
        code: 213,
        lower: [],
        title: [],
        upper: [],
        fold: 245,
        foldFull: [
            245
        ]
    },
    {
        code: 214,
        lower: [],
        title: [],
        upper: [],
        fold: 246,
        foldFull: [
            246
        ]
    },
    {
        code: 216,
        lower: [],
        title: [],
        upper: [],
        fold: 248,
        foldFull: [
            248
        ]
    },
    {
        code: 217,
        lower: [],
        title: [],
        upper: [],
        fold: 249,
        foldFull: [
            249
        ]
    },
    {
        code: 218,
        lower: [],
        title: [],
        upper: [],
        fold: 250,
        foldFull: [
            250
        ]
    },
    {
        code: 219,
        lower: [],
        title: [],
        upper: [],
        fold: 251,
        foldFull: [
            251
        ]
    },
    {
        code: 220,
        lower: [],
        title: [],
        upper: [],
        fold: 252,
        foldFull: [
            252
        ]
    },
    {
        code: 221,
        lower: [],
        title: [],
        upper: [],
        fold: 253,
        foldFull: [
            253
        ]
    },
    {
        code: 222,
        lower: [],
        title: [],
        upper: [],
        fold: 254,
        foldFull: [
            254
        ]
    },
    {
        code: 223,
        lower: [
            223
        ],
        title: [
            83,
            115
        ],
        upper: [
            83,
            83
        ],
        fold: 0,
        foldFull: [
            115,
            115
        ]
    },
    {
        code: 223,
        lower: [
            223
        ],
        title: [
            83,
            115
        ],
        upper: [
            83,
            83
        ],
        fold: 0,
        foldFull: [
            115,
            115
        ]
    },
    {
        code: 256,
        lower: [],
        title: [],
        upper: [],
        fold: 257,
        foldFull: [
            257
        ]
    },
    {
        code: 258,
        lower: [],
        title: [],
        upper: [],
        fold: 259,
        foldFull: [
            259
        ]
    },
    {
        code: 260,
        lower: [],
        title: [],
        upper: [],
        fold: 261,
        foldFull: [
            261
        ]
    },
    {
        code: 262,
        lower: [],
        title: [],
        upper: [],
        fold: 263,
        foldFull: [
            263
        ]
    },
    {
        code: 264,
        lower: [],
        title: [],
        upper: [],
        fold: 265,
        foldFull: [
            265
        ]
    },
    {
        code: 266,
        lower: [],
        title: [],
        upper: [],
        fold: 267,
        foldFull: [
            267
        ]
    },
    {
        code: 268,
        lower: [],
        title: [],
        upper: [],
        fold: 269,
        foldFull: [
            269
        ]
    },
    {
        code: 270,
        lower: [],
        title: [],
        upper: [],
        fold: 271,
        foldFull: [
            271
        ]
    },
    {
        code: 272,
        lower: [],
        title: [],
        upper: [],
        fold: 273,
        foldFull: [
            273
        ]
    },
    {
        code: 274,
        lower: [],
        title: [],
        upper: [],
        fold: 275,
        foldFull: [
            275
        ]
    },
    {
        code: 276,
        lower: [],
        title: [],
        upper: [],
        fold: 277,
        foldFull: [
            277
        ]
    },
    {
        code: 278,
        lower: [],
        title: [],
        upper: [],
        fold: 279,
        foldFull: [
            279
        ]
    },
    {
        code: 280,
        lower: [],
        title: [],
        upper: [],
        fold: 281,
        foldFull: [
            281
        ]
    },
    {
        code: 282,
        lower: [],
        title: [],
        upper: [],
        fold: 283,
        foldFull: [
            283
        ]
    },
    {
        code: 284,
        lower: [],
        title: [],
        upper: [],
        fold: 285,
        foldFull: [
            285
        ]
    },
    {
        code: 286,
        lower: [],
        title: [],
        upper: [],
        fold: 287,
        foldFull: [
            287
        ]
    },
    {
        code: 288,
        lower: [],
        title: [],
        upper: [],
        fold: 289,
        foldFull: [
            289
        ]
    },
    {
        code: 290,
        lower: [],
        title: [],
        upper: [],
        fold: 291,
        foldFull: [
            291
        ]
    },
    {
        code: 292,
        lower: [],
        title: [],
        upper: [],
        fold: 293,
        foldFull: [
            293
        ]
    },
    {
        code: 294,
        lower: [],
        title: [],
        upper: [],
        fold: 295,
        foldFull: [
            295
        ]
    },
    {
        code: 296,
        lower: [],
        title: [],
        upper: [],
        fold: 297,
        foldFull: [
            297
        ]
    },
    {
        code: 298,
        lower: [],
        title: [],
        upper: [],
        fold: 299,
        foldFull: [
            299
        ]
    },
    {
        code: 300,
        lower: [],
        title: [],
        upper: [],
        fold: 301,
        foldFull: [
            301
        ]
    },
    {
        code: 302,
        lower: [],
        title: [],
        upper: [],
        fold: 303,
        foldFull: [
            303
        ]
    },
    {
        code: 304,
        lower: [
            105,
            775
        ],
        title: [
            304
        ],
        upper: [
            304
        ],
        fold: 0,
        foldFull: [
            105,
            775
        ]
    },
    {
        code: 304,
        lower: [
            105,
            775
        ],
        title: [
            304
        ],
        upper: [
            304
        ],
        fold: 0,
        foldFull: [
            105,
            775
        ]
    },
    {
        code: 306,
        lower: [],
        title: [],
        upper: [],
        fold: 307,
        foldFull: [
            307
        ]
    },
    {
        code: 308,
        lower: [],
        title: [],
        upper: [],
        fold: 309,
        foldFull: [
            309
        ]
    },
    {
        code: 310,
        lower: [],
        title: [],
        upper: [],
        fold: 311,
        foldFull: [
            311
        ]
    },
    {
        code: 313,
        lower: [],
        title: [],
        upper: [],
        fold: 314,
        foldFull: [
            314
        ]
    },
    {
        code: 315,
        lower: [],
        title: [],
        upper: [],
        fold: 316,
        foldFull: [
            316
        ]
    },
    {
        code: 317,
        lower: [],
        title: [],
        upper: [],
        fold: 318,
        foldFull: [
            318
        ]
    },
    {
        code: 319,
        lower: [],
        title: [],
        upper: [],
        fold: 320,
        foldFull: [
            320
        ]
    },
    {
        code: 321,
        lower: [],
        title: [],
        upper: [],
        fold: 322,
        foldFull: [
            322
        ]
    },
    {
        code: 323,
        lower: [],
        title: [],
        upper: [],
        fold: 324,
        foldFull: [
            324
        ]
    },
    {
        code: 325,
        lower: [],
        title: [],
        upper: [],
        fold: 326,
        foldFull: [
            326
        ]
    },
    {
        code: 327,
        lower: [],
        title: [],
        upper: [],
        fold: 328,
        foldFull: [
            328
        ]
    },
    {
        code: 329,
        lower: [
            329
        ],
        title: [
            700,
            78
        ],
        upper: [
            700,
            78
        ],
        fold: 0,
        foldFull: [
            700,
            110
        ]
    },
    {
        code: 329,
        lower: [
            329
        ],
        title: [
            700,
            78
        ],
        upper: [
            700,
            78
        ],
        fold: 0,
        foldFull: [
            700,
            110
        ]
    },
    {
        code: 330,
        lower: [],
        title: [],
        upper: [],
        fold: 331,
        foldFull: [
            331
        ]
    },
    {
        code: 332,
        lower: [],
        title: [],
        upper: [],
        fold: 333,
        foldFull: [
            333
        ]
    },
    {
        code: 334,
        lower: [],
        title: [],
        upper: [],
        fold: 335,
        foldFull: [
            335
        ]
    },
    {
        code: 336,
        lower: [],
        title: [],
        upper: [],
        fold: 337,
        foldFull: [
            337
        ]
    },
    {
        code: 338,
        lower: [],
        title: [],
        upper: [],
        fold: 339,
        foldFull: [
            339
        ]
    },
    {
        code: 340,
        lower: [],
        title: [],
        upper: [],
        fold: 341,
        foldFull: [
            341
        ]
    },
    {
        code: 342,
        lower: [],
        title: [],
        upper: [],
        fold: 343,
        foldFull: [
            343
        ]
    },
    {
        code: 344,
        lower: [],
        title: [],
        upper: [],
        fold: 345,
        foldFull: [
            345
        ]
    },
    {
        code: 346,
        lower: [],
        title: [],
        upper: [],
        fold: 347,
        foldFull: [
            347
        ]
    },
    {
        code: 348,
        lower: [],
        title: [],
        upper: [],
        fold: 349,
        foldFull: [
            349
        ]
    },
    {
        code: 350,
        lower: [],
        title: [],
        upper: [],
        fold: 351,
        foldFull: [
            351
        ]
    },
    {
        code: 352,
        lower: [],
        title: [],
        upper: [],
        fold: 353,
        foldFull: [
            353
        ]
    },
    {
        code: 354,
        lower: [],
        title: [],
        upper: [],
        fold: 355,
        foldFull: [
            355
        ]
    },
    {
        code: 356,
        lower: [],
        title: [],
        upper: [],
        fold: 357,
        foldFull: [
            357
        ]
    },
    {
        code: 358,
        lower: [],
        title: [],
        upper: [],
        fold: 359,
        foldFull: [
            359
        ]
    },
    {
        code: 360,
        lower: [],
        title: [],
        upper: [],
        fold: 361,
        foldFull: [
            361
        ]
    },
    {
        code: 362,
        lower: [],
        title: [],
        upper: [],
        fold: 363,
        foldFull: [
            363
        ]
    },
    {
        code: 364,
        lower: [],
        title: [],
        upper: [],
        fold: 365,
        foldFull: [
            365
        ]
    },
    {
        code: 366,
        lower: [],
        title: [],
        upper: [],
        fold: 367,
        foldFull: [
            367
        ]
    },
    {
        code: 368,
        lower: [],
        title: [],
        upper: [],
        fold: 369,
        foldFull: [
            369
        ]
    },
    {
        code: 370,
        lower: [],
        title: [],
        upper: [],
        fold: 371,
        foldFull: [
            371
        ]
    },
    {
        code: 372,
        lower: [],
        title: [],
        upper: [],
        fold: 373,
        foldFull: [
            373
        ]
    },
    {
        code: 374,
        lower: [],
        title: [],
        upper: [],
        fold: 375,
        foldFull: [
            375
        ]
    },
    {
        code: 376,
        lower: [],
        title: [],
        upper: [],
        fold: 255,
        foldFull: [
            255
        ]
    },
    {
        code: 377,
        lower: [],
        title: [],
        upper: [],
        fold: 378,
        foldFull: [
            378
        ]
    },
    {
        code: 379,
        lower: [],
        title: [],
        upper: [],
        fold: 380,
        foldFull: [
            380
        ]
    },
    {
        code: 381,
        lower: [],
        title: [],
        upper: [],
        fold: 382,
        foldFull: [
            382
        ]
    },
    {
        code: 383,
        lower: [],
        title: [],
        upper: [],
        fold: 115,
        foldFull: [
            115
        ]
    },
    {
        code: 385,
        lower: [],
        title: [],
        upper: [],
        fold: 595,
        foldFull: [
            595
        ]
    },
    {
        code: 386,
        lower: [],
        title: [],
        upper: [],
        fold: 387,
        foldFull: [
            387
        ]
    },
    {
        code: 388,
        lower: [],
        title: [],
        upper: [],
        fold: 389,
        foldFull: [
            389
        ]
    },
    {
        code: 390,
        lower: [],
        title: [],
        upper: [],
        fold: 596,
        foldFull: [
            596
        ]
    },
    {
        code: 391,
        lower: [],
        title: [],
        upper: [],
        fold: 392,
        foldFull: [
            392
        ]
    },
    {
        code: 393,
        lower: [],
        title: [],
        upper: [],
        fold: 598,
        foldFull: [
            598
        ]
    },
    {
        code: 394,
        lower: [],
        title: [],
        upper: [],
        fold: 599,
        foldFull: [
            599
        ]
    },
    {
        code: 395,
        lower: [],
        title: [],
        upper: [],
        fold: 396,
        foldFull: [
            396
        ]
    },
    {
        code: 398,
        lower: [],
        title: [],
        upper: [],
        fold: 477,
        foldFull: [
            477
        ]
    },
    {
        code: 399,
        lower: [],
        title: [],
        upper: [],
        fold: 601,
        foldFull: [
            601
        ]
    },
    {
        code: 400,
        lower: [],
        title: [],
        upper: [],
        fold: 603,
        foldFull: [
            603
        ]
    },
    {
        code: 401,
        lower: [],
        title: [],
        upper: [],
        fold: 402,
        foldFull: [
            402
        ]
    },
    {
        code: 403,
        lower: [],
        title: [],
        upper: [],
        fold: 608,
        foldFull: [
            608
        ]
    },
    {
        code: 404,
        lower: [],
        title: [],
        upper: [],
        fold: 611,
        foldFull: [
            611
        ]
    },
    {
        code: 406,
        lower: [],
        title: [],
        upper: [],
        fold: 617,
        foldFull: [
            617
        ]
    },
    {
        code: 407,
        lower: [],
        title: [],
        upper: [],
        fold: 616,
        foldFull: [
            616
        ]
    },
    {
        code: 408,
        lower: [],
        title: [],
        upper: [],
        fold: 409,
        foldFull: [
            409
        ]
    },
    {
        code: 412,
        lower: [],
        title: [],
        upper: [],
        fold: 623,
        foldFull: [
            623
        ]
    },
    {
        code: 413,
        lower: [],
        title: [],
        upper: [],
        fold: 626,
        foldFull: [
            626
        ]
    },
    {
        code: 415,
        lower: [],
        title: [],
        upper: [],
        fold: 629,
        foldFull: [
            629
        ]
    },
    {
        code: 416,
        lower: [],
        title: [],
        upper: [],
        fold: 417,
        foldFull: [
            417
        ]
    },
    {
        code: 418,
        lower: [],
        title: [],
        upper: [],
        fold: 419,
        foldFull: [
            419
        ]
    },
    {
        code: 420,
        lower: [],
        title: [],
        upper: [],
        fold: 421,
        foldFull: [
            421
        ]
    },
    {
        code: 422,
        lower: [],
        title: [],
        upper: [],
        fold: 640,
        foldFull: [
            640
        ]
    },
    {
        code: 423,
        lower: [],
        title: [],
        upper: [],
        fold: 424,
        foldFull: [
            424
        ]
    },
    {
        code: 425,
        lower: [],
        title: [],
        upper: [],
        fold: 643,
        foldFull: [
            643
        ]
    },
    {
        code: 428,
        lower: [],
        title: [],
        upper: [],
        fold: 429,
        foldFull: [
            429
        ]
    },
    {
        code: 430,
        lower: [],
        title: [],
        upper: [],
        fold: 648,
        foldFull: [
            648
        ]
    },
    {
        code: 431,
        lower: [],
        title: [],
        upper: [],
        fold: 432,
        foldFull: [
            432
        ]
    },
    {
        code: 433,
        lower: [],
        title: [],
        upper: [],
        fold: 650,
        foldFull: [
            650
        ]
    },
    {
        code: 434,
        lower: [],
        title: [],
        upper: [],
        fold: 651,
        foldFull: [
            651
        ]
    },
    {
        code: 435,
        lower: [],
        title: [],
        upper: [],
        fold: 436,
        foldFull: [
            436
        ]
    },
    {
        code: 437,
        lower: [],
        title: [],
        upper: [],
        fold: 438,
        foldFull: [
            438
        ]
    },
    {
        code: 439,
        lower: [],
        title: [],
        upper: [],
        fold: 658,
        foldFull: [
            658
        ]
    },
    {
        code: 440,
        lower: [],
        title: [],
        upper: [],
        fold: 441,
        foldFull: [
            441
        ]
    },
    {
        code: 444,
        lower: [],
        title: [],
        upper: [],
        fold: 445,
        foldFull: [
            445
        ]
    },
    {
        code: 452,
        lower: [],
        title: [],
        upper: [],
        fold: 454,
        foldFull: [
            454
        ]
    },
    {
        code: 453,
        lower: [],
        title: [],
        upper: [],
        fold: 454,
        foldFull: [
            454
        ]
    },
    {
        code: 455,
        lower: [],
        title: [],
        upper: [],
        fold: 457,
        foldFull: [
            457
        ]
    },
    {
        code: 456,
        lower: [],
        title: [],
        upper: [],
        fold: 457,
        foldFull: [
            457
        ]
    },
    {
        code: 458,
        lower: [],
        title: [],
        upper: [],
        fold: 460,
        foldFull: [
            460
        ]
    },
    {
        code: 459,
        lower: [],
        title: [],
        upper: [],
        fold: 460,
        foldFull: [
            460
        ]
    },
    {
        code: 461,
        lower: [],
        title: [],
        upper: [],
        fold: 462,
        foldFull: [
            462
        ]
    },
    {
        code: 463,
        lower: [],
        title: [],
        upper: [],
        fold: 464,
        foldFull: [
            464
        ]
    },
    {
        code: 465,
        lower: [],
        title: [],
        upper: [],
        fold: 466,
        foldFull: [
            466
        ]
    },
    {
        code: 467,
        lower: [],
        title: [],
        upper: [],
        fold: 468,
        foldFull: [
            468
        ]
    },
    {
        code: 469,
        lower: [],
        title: [],
        upper: [],
        fold: 470,
        foldFull: [
            470
        ]
    },
    {
        code: 471,
        lower: [],
        title: [],
        upper: [],
        fold: 472,
        foldFull: [
            472
        ]
    },
    {
        code: 473,
        lower: [],
        title: [],
        upper: [],
        fold: 474,
        foldFull: [
            474
        ]
    },
    {
        code: 475,
        lower: [],
        title: [],
        upper: [],
        fold: 476,
        foldFull: [
            476
        ]
    },
    {
        code: 478,
        lower: [],
        title: [],
        upper: [],
        fold: 479,
        foldFull: [
            479
        ]
    },
    {
        code: 480,
        lower: [],
        title: [],
        upper: [],
        fold: 481,
        foldFull: [
            481
        ]
    },
    {
        code: 482,
        lower: [],
        title: [],
        upper: [],
        fold: 483,
        foldFull: [
            483
        ]
    },
    {
        code: 484,
        lower: [],
        title: [],
        upper: [],
        fold: 485,
        foldFull: [
            485
        ]
    },
    {
        code: 486,
        lower: [],
        title: [],
        upper: [],
        fold: 487,
        foldFull: [
            487
        ]
    },
    {
        code: 488,
        lower: [],
        title: [],
        upper: [],
        fold: 489,
        foldFull: [
            489
        ]
    },
    {
        code: 490,
        lower: [],
        title: [],
        upper: [],
        fold: 491,
        foldFull: [
            491
        ]
    },
    {
        code: 492,
        lower: [],
        title: [],
        upper: [],
        fold: 493,
        foldFull: [
            493
        ]
    },
    {
        code: 494,
        lower: [],
        title: [],
        upper: [],
        fold: 495,
        foldFull: [
            495
        ]
    },
    {
        code: 496,
        lower: [
            496
        ],
        title: [
            74,
            780
        ],
        upper: [
            74,
            780
        ],
        fold: 0,
        foldFull: [
            106,
            780
        ]
    },
    {
        code: 496,
        lower: [
            496
        ],
        title: [
            74,
            780
        ],
        upper: [
            74,
            780
        ],
        fold: 0,
        foldFull: [
            106,
            780
        ]
    },
    {
        code: 497,
        lower: [],
        title: [],
        upper: [],
        fold: 499,
        foldFull: [
            499
        ]
    },
    {
        code: 498,
        lower: [],
        title: [],
        upper: [],
        fold: 499,
        foldFull: [
            499
        ]
    },
    {
        code: 500,
        lower: [],
        title: [],
        upper: [],
        fold: 501,
        foldFull: [
            501
        ]
    },
    {
        code: 502,
        lower: [],
        title: [],
        upper: [],
        fold: 405,
        foldFull: [
            405
        ]
    },
    {
        code: 503,
        lower: [],
        title: [],
        upper: [],
        fold: 447,
        foldFull: [
            447
        ]
    },
    {
        code: 504,
        lower: [],
        title: [],
        upper: [],
        fold: 505,
        foldFull: [
            505
        ]
    },
    {
        code: 506,
        lower: [],
        title: [],
        upper: [],
        fold: 507,
        foldFull: [
            507
        ]
    },
    {
        code: 508,
        lower: [],
        title: [],
        upper: [],
        fold: 509,
        foldFull: [
            509
        ]
    },
    {
        code: 510,
        lower: [],
        title: [],
        upper: [],
        fold: 511,
        foldFull: [
            511
        ]
    },
    {
        code: 512,
        lower: [],
        title: [],
        upper: [],
        fold: 513,
        foldFull: [
            513
        ]
    },
    {
        code: 514,
        lower: [],
        title: [],
        upper: [],
        fold: 515,
        foldFull: [
            515
        ]
    },
    {
        code: 516,
        lower: [],
        title: [],
        upper: [],
        fold: 517,
        foldFull: [
            517
        ]
    },
    {
        code: 518,
        lower: [],
        title: [],
        upper: [],
        fold: 519,
        foldFull: [
            519
        ]
    },
    {
        code: 520,
        lower: [],
        title: [],
        upper: [],
        fold: 521,
        foldFull: [
            521
        ]
    },
    {
        code: 522,
        lower: [],
        title: [],
        upper: [],
        fold: 523,
        foldFull: [
            523
        ]
    },
    {
        code: 524,
        lower: [],
        title: [],
        upper: [],
        fold: 525,
        foldFull: [
            525
        ]
    },
    {
        code: 526,
        lower: [],
        title: [],
        upper: [],
        fold: 527,
        foldFull: [
            527
        ]
    },
    {
        code: 528,
        lower: [],
        title: [],
        upper: [],
        fold: 529,
        foldFull: [
            529
        ]
    },
    {
        code: 530,
        lower: [],
        title: [],
        upper: [],
        fold: 531,
        foldFull: [
            531
        ]
    },
    {
        code: 532,
        lower: [],
        title: [],
        upper: [],
        fold: 533,
        foldFull: [
            533
        ]
    },
    {
        code: 534,
        lower: [],
        title: [],
        upper: [],
        fold: 535,
        foldFull: [
            535
        ]
    },
    {
        code: 536,
        lower: [],
        title: [],
        upper: [],
        fold: 537,
        foldFull: [
            537
        ]
    },
    {
        code: 538,
        lower: [],
        title: [],
        upper: [],
        fold: 539,
        foldFull: [
            539
        ]
    },
    {
        code: 540,
        lower: [],
        title: [],
        upper: [],
        fold: 541,
        foldFull: [
            541
        ]
    },
    {
        code: 542,
        lower: [],
        title: [],
        upper: [],
        fold: 543,
        foldFull: [
            543
        ]
    },
    {
        code: 544,
        lower: [],
        title: [],
        upper: [],
        fold: 414,
        foldFull: [
            414
        ]
    },
    {
        code: 546,
        lower: [],
        title: [],
        upper: [],
        fold: 547,
        foldFull: [
            547
        ]
    },
    {
        code: 548,
        lower: [],
        title: [],
        upper: [],
        fold: 549,
        foldFull: [
            549
        ]
    },
    {
        code: 550,
        lower: [],
        title: [],
        upper: [],
        fold: 551,
        foldFull: [
            551
        ]
    },
    {
        code: 552,
        lower: [],
        title: [],
        upper: [],
        fold: 553,
        foldFull: [
            553
        ]
    },
    {
        code: 554,
        lower: [],
        title: [],
        upper: [],
        fold: 555,
        foldFull: [
            555
        ]
    },
    {
        code: 556,
        lower: [],
        title: [],
        upper: [],
        fold: 557,
        foldFull: [
            557
        ]
    },
    {
        code: 558,
        lower: [],
        title: [],
        upper: [],
        fold: 559,
        foldFull: [
            559
        ]
    },
    {
        code: 560,
        lower: [],
        title: [],
        upper: [],
        fold: 561,
        foldFull: [
            561
        ]
    },
    {
        code: 562,
        lower: [],
        title: [],
        upper: [],
        fold: 563,
        foldFull: [
            563
        ]
    },
    {
        code: 570,
        lower: [],
        title: [],
        upper: [],
        fold: 11365,
        foldFull: [
            11365
        ]
    },
    {
        code: 571,
        lower: [],
        title: [],
        upper: [],
        fold: 572,
        foldFull: [
            572
        ]
    },
    {
        code: 573,
        lower: [],
        title: [],
        upper: [],
        fold: 410,
        foldFull: [
            410
        ]
    },
    {
        code: 574,
        lower: [],
        title: [],
        upper: [],
        fold: 11366,
        foldFull: [
            11366
        ]
    },
    {
        code: 577,
        lower: [],
        title: [],
        upper: [],
        fold: 578,
        foldFull: [
            578
        ]
    },
    {
        code: 579,
        lower: [],
        title: [],
        upper: [],
        fold: 384,
        foldFull: [
            384
        ]
    },
    {
        code: 580,
        lower: [],
        title: [],
        upper: [],
        fold: 649,
        foldFull: [
            649
        ]
    },
    {
        code: 581,
        lower: [],
        title: [],
        upper: [],
        fold: 652,
        foldFull: [
            652
        ]
    },
    {
        code: 582,
        lower: [],
        title: [],
        upper: [],
        fold: 583,
        foldFull: [
            583
        ]
    },
    {
        code: 584,
        lower: [],
        title: [],
        upper: [],
        fold: 585,
        foldFull: [
            585
        ]
    },
    {
        code: 586,
        lower: [],
        title: [],
        upper: [],
        fold: 587,
        foldFull: [
            587
        ]
    },
    {
        code: 588,
        lower: [],
        title: [],
        upper: [],
        fold: 589,
        foldFull: [
            589
        ]
    },
    {
        code: 590,
        lower: [],
        title: [],
        upper: [],
        fold: 591,
        foldFull: [
            591
        ]
    },
    {
        code: 837,
        lower: [],
        title: [],
        upper: [],
        fold: 953,
        foldFull: [
            953
        ]
    },
    {
        code: 880,
        lower: [],
        title: [],
        upper: [],
        fold: 881,
        foldFull: [
            881
        ]
    },
    {
        code: 882,
        lower: [],
        title: [],
        upper: [],
        fold: 883,
        foldFull: [
            883
        ]
    },
    {
        code: 886,
        lower: [],
        title: [],
        upper: [],
        fold: 887,
        foldFull: [
            887
        ]
    },
    {
        code: 895,
        lower: [],
        title: [],
        upper: [],
        fold: 1011,
        foldFull: [
            1011
        ]
    },
    {
        code: 902,
        lower: [],
        title: [],
        upper: [],
        fold: 940,
        foldFull: [
            940
        ]
    },
    {
        code: 904,
        lower: [],
        title: [],
        upper: [],
        fold: 941,
        foldFull: [
            941
        ]
    },
    {
        code: 905,
        lower: [],
        title: [],
        upper: [],
        fold: 942,
        foldFull: [
            942
        ]
    },
    {
        code: 906,
        lower: [],
        title: [],
        upper: [],
        fold: 943,
        foldFull: [
            943
        ]
    },
    {
        code: 908,
        lower: [],
        title: [],
        upper: [],
        fold: 972,
        foldFull: [
            972
        ]
    },
    {
        code: 910,
        lower: [],
        title: [],
        upper: [],
        fold: 973,
        foldFull: [
            973
        ]
    },
    {
        code: 911,
        lower: [],
        title: [],
        upper: [],
        fold: 974,
        foldFull: [
            974
        ]
    },
    {
        code: 912,
        lower: [
            912
        ],
        title: [
            921,
            776,
            769
        ],
        upper: [
            921,
            776,
            769
        ],
        fold: 0,
        foldFull: [
            953,
            776,
            769
        ]
    },
    {
        code: 912,
        lower: [
            912
        ],
        title: [
            921,
            776,
            769
        ],
        upper: [
            921,
            776,
            769
        ],
        fold: 0,
        foldFull: [
            953,
            776,
            769
        ]
    },
    {
        code: 913,
        lower: [],
        title: [],
        upper: [],
        fold: 945,
        foldFull: [
            945
        ]
    },
    {
        code: 914,
        lower: [],
        title: [],
        upper: [],
        fold: 946,
        foldFull: [
            946
        ]
    },
    {
        code: 915,
        lower: [],
        title: [],
        upper: [],
        fold: 947,
        foldFull: [
            947
        ]
    },
    {
        code: 916,
        lower: [],
        title: [],
        upper: [],
        fold: 948,
        foldFull: [
            948
        ]
    },
    {
        code: 917,
        lower: [],
        title: [],
        upper: [],
        fold: 949,
        foldFull: [
            949
        ]
    },
    {
        code: 918,
        lower: [],
        title: [],
        upper: [],
        fold: 950,
        foldFull: [
            950
        ]
    },
    {
        code: 919,
        lower: [],
        title: [],
        upper: [],
        fold: 951,
        foldFull: [
            951
        ]
    },
    {
        code: 920,
        lower: [],
        title: [],
        upper: [],
        fold: 952,
        foldFull: [
            952
        ]
    },
    {
        code: 921,
        lower: [],
        title: [],
        upper: [],
        fold: 953,
        foldFull: [
            953
        ]
    },
    {
        code: 922,
        lower: [],
        title: [],
        upper: [],
        fold: 954,
        foldFull: [
            954
        ]
    },
    {
        code: 923,
        lower: [],
        title: [],
        upper: [],
        fold: 955,
        foldFull: [
            955
        ]
    },
    {
        code: 924,
        lower: [],
        title: [],
        upper: [],
        fold: 956,
        foldFull: [
            956
        ]
    },
    {
        code: 925,
        lower: [],
        title: [],
        upper: [],
        fold: 957,
        foldFull: [
            957
        ]
    },
    {
        code: 926,
        lower: [],
        title: [],
        upper: [],
        fold: 958,
        foldFull: [
            958
        ]
    },
    {
        code: 927,
        lower: [],
        title: [],
        upper: [],
        fold: 959,
        foldFull: [
            959
        ]
    },
    {
        code: 928,
        lower: [],
        title: [],
        upper: [],
        fold: 960,
        foldFull: [
            960
        ]
    },
    {
        code: 929,
        lower: [],
        title: [],
        upper: [],
        fold: 961,
        foldFull: [
            961
        ]
    },
    {
        code: 931,
        lower: [],
        title: [],
        upper: [],
        fold: 963,
        foldFull: [
            963
        ]
    },
    {
        code: 932,
        lower: [],
        title: [],
        upper: [],
        fold: 964,
        foldFull: [
            964
        ]
    },
    {
        code: 933,
        lower: [],
        title: [],
        upper: [],
        fold: 965,
        foldFull: [
            965
        ]
    },
    {
        code: 934,
        lower: [],
        title: [],
        upper: [],
        fold: 966,
        foldFull: [
            966
        ]
    },
    {
        code: 935,
        lower: [],
        title: [],
        upper: [],
        fold: 967,
        foldFull: [
            967
        ]
    },
    {
        code: 936,
        lower: [],
        title: [],
        upper: [],
        fold: 968,
        foldFull: [
            968
        ]
    },
    {
        code: 937,
        lower: [],
        title: [],
        upper: [],
        fold: 969,
        foldFull: [
            969
        ]
    },
    {
        code: 938,
        lower: [],
        title: [],
        upper: [],
        fold: 970,
        foldFull: [
            970
        ]
    },
    {
        code: 939,
        lower: [],
        title: [],
        upper: [],
        fold: 971,
        foldFull: [
            971
        ]
    },
    {
        code: 944,
        lower: [
            944
        ],
        title: [
            933,
            776,
            769
        ],
        upper: [
            933,
            776,
            769
        ],
        fold: 0,
        foldFull: [
            965,
            776,
            769
        ]
    },
    {
        code: 944,
        lower: [
            944
        ],
        title: [
            933,
            776,
            769
        ],
        upper: [
            933,
            776,
            769
        ],
        fold: 0,
        foldFull: [
            965,
            776,
            769
        ]
    },
    {
        code: 962,
        lower: [],
        title: [],
        upper: [],
        fold: 963,
        foldFull: [
            963
        ]
    },
    {
        code: 975,
        lower: [],
        title: [],
        upper: [],
        fold: 983,
        foldFull: [
            983
        ]
    },
    {
        code: 976,
        lower: [],
        title: [],
        upper: [],
        fold: 946,
        foldFull: [
            946
        ]
    },
    {
        code: 977,
        lower: [],
        title: [],
        upper: [],
        fold: 952,
        foldFull: [
            952
        ]
    },
    {
        code: 981,
        lower: [],
        title: [],
        upper: [],
        fold: 966,
        foldFull: [
            966
        ]
    },
    {
        code: 982,
        lower: [],
        title: [],
        upper: [],
        fold: 960,
        foldFull: [
            960
        ]
    },
    {
        code: 984,
        lower: [],
        title: [],
        upper: [],
        fold: 985,
        foldFull: [
            985
        ]
    },
    {
        code: 986,
        lower: [],
        title: [],
        upper: [],
        fold: 987,
        foldFull: [
            987
        ]
    },
    {
        code: 988,
        lower: [],
        title: [],
        upper: [],
        fold: 989,
        foldFull: [
            989
        ]
    },
    {
        code: 990,
        lower: [],
        title: [],
        upper: [],
        fold: 991,
        foldFull: [
            991
        ]
    },
    {
        code: 992,
        lower: [],
        title: [],
        upper: [],
        fold: 993,
        foldFull: [
            993
        ]
    },
    {
        code: 994,
        lower: [],
        title: [],
        upper: [],
        fold: 995,
        foldFull: [
            995
        ]
    },
    {
        code: 996,
        lower: [],
        title: [],
        upper: [],
        fold: 997,
        foldFull: [
            997
        ]
    },
    {
        code: 998,
        lower: [],
        title: [],
        upper: [],
        fold: 999,
        foldFull: [
            999
        ]
    },
    {
        code: 1000,
        lower: [],
        title: [],
        upper: [],
        fold: 1001,
        foldFull: [
            1001
        ]
    },
    {
        code: 1002,
        lower: [],
        title: [],
        upper: [],
        fold: 1003,
        foldFull: [
            1003
        ]
    },
    {
        code: 1004,
        lower: [],
        title: [],
        upper: [],
        fold: 1005,
        foldFull: [
            1005
        ]
    },
    {
        code: 1006,
        lower: [],
        title: [],
        upper: [],
        fold: 1007,
        foldFull: [
            1007
        ]
    },
    {
        code: 1008,
        lower: [],
        title: [],
        upper: [],
        fold: 954,
        foldFull: [
            954
        ]
    },
    {
        code: 1009,
        lower: [],
        title: [],
        upper: [],
        fold: 961,
        foldFull: [
            961
        ]
    },
    {
        code: 1012,
        lower: [],
        title: [],
        upper: [],
        fold: 952,
        foldFull: [
            952
        ]
    },
    {
        code: 1013,
        lower: [],
        title: [],
        upper: [],
        fold: 949,
        foldFull: [
            949
        ]
    },
    {
        code: 1015,
        lower: [],
        title: [],
        upper: [],
        fold: 1016,
        foldFull: [
            1016
        ]
    },
    {
        code: 1017,
        lower: [],
        title: [],
        upper: [],
        fold: 1010,
        foldFull: [
            1010
        ]
    },
    {
        code: 1018,
        lower: [],
        title: [],
        upper: [],
        fold: 1019,
        foldFull: [
            1019
        ]
    },
    {
        code: 1021,
        lower: [],
        title: [],
        upper: [],
        fold: 891,
        foldFull: [
            891
        ]
    },
    {
        code: 1022,
        lower: [],
        title: [],
        upper: [],
        fold: 892,
        foldFull: [
            892
        ]
    },
    {
        code: 1023,
        lower: [],
        title: [],
        upper: [],
        fold: 893,
        foldFull: [
            893
        ]
    },
    {
        code: 1024,
        lower: [],
        title: [],
        upper: [],
        fold: 1104,
        foldFull: [
            1104
        ]
    },
    {
        code: 1025,
        lower: [],
        title: [],
        upper: [],
        fold: 1105,
        foldFull: [
            1105
        ]
    },
    {
        code: 1026,
        lower: [],
        title: [],
        upper: [],
        fold: 1106,
        foldFull: [
            1106
        ]
    },
    {
        code: 1027,
        lower: [],
        title: [],
        upper: [],
        fold: 1107,
        foldFull: [
            1107
        ]
    },
    {
        code: 1028,
        lower: [],
        title: [],
        upper: [],
        fold: 1108,
        foldFull: [
            1108
        ]
    },
    {
        code: 1029,
        lower: [],
        title: [],
        upper: [],
        fold: 1109,
        foldFull: [
            1109
        ]
    },
    {
        code: 1030,
        lower: [],
        title: [],
        upper: [],
        fold: 1110,
        foldFull: [
            1110
        ]
    },
    {
        code: 1031,
        lower: [],
        title: [],
        upper: [],
        fold: 1111,
        foldFull: [
            1111
        ]
    },
    {
        code: 1032,
        lower: [],
        title: [],
        upper: [],
        fold: 1112,
        foldFull: [
            1112
        ]
    },
    {
        code: 1033,
        lower: [],
        title: [],
        upper: [],
        fold: 1113,
        foldFull: [
            1113
        ]
    },
    {
        code: 1034,
        lower: [],
        title: [],
        upper: [],
        fold: 1114,
        foldFull: [
            1114
        ]
    },
    {
        code: 1035,
        lower: [],
        title: [],
        upper: [],
        fold: 1115,
        foldFull: [
            1115
        ]
    },
    {
        code: 1036,
        lower: [],
        title: [],
        upper: [],
        fold: 1116,
        foldFull: [
            1116
        ]
    },
    {
        code: 1037,
        lower: [],
        title: [],
        upper: [],
        fold: 1117,
        foldFull: [
            1117
        ]
    },
    {
        code: 1038,
        lower: [],
        title: [],
        upper: [],
        fold: 1118,
        foldFull: [
            1118
        ]
    },
    {
        code: 1039,
        lower: [],
        title: [],
        upper: [],
        fold: 1119,
        foldFull: [
            1119
        ]
    },
    {
        code: 1040,
        lower: [],
        title: [],
        upper: [],
        fold: 1072,
        foldFull: [
            1072
        ]
    },
    {
        code: 1041,
        lower: [],
        title: [],
        upper: [],
        fold: 1073,
        foldFull: [
            1073
        ]
    },
    {
        code: 1042,
        lower: [],
        title: [],
        upper: [],
        fold: 1074,
        foldFull: [
            1074
        ]
    },
    {
        code: 1043,
        lower: [],
        title: [],
        upper: [],
        fold: 1075,
        foldFull: [
            1075
        ]
    },
    {
        code: 1044,
        lower: [],
        title: [],
        upper: [],
        fold: 1076,
        foldFull: [
            1076
        ]
    },
    {
        code: 1045,
        lower: [],
        title: [],
        upper: [],
        fold: 1077,
        foldFull: [
            1077
        ]
    },
    {
        code: 1046,
        lower: [],
        title: [],
        upper: [],
        fold: 1078,
        foldFull: [
            1078
        ]
    },
    {
        code: 1047,
        lower: [],
        title: [],
        upper: [],
        fold: 1079,
        foldFull: [
            1079
        ]
    },
    {
        code: 1048,
        lower: [],
        title: [],
        upper: [],
        fold: 1080,
        foldFull: [
            1080
        ]
    },
    {
        code: 1049,
        lower: [],
        title: [],
        upper: [],
        fold: 1081,
        foldFull: [
            1081
        ]
    },
    {
        code: 1050,
        lower: [],
        title: [],
        upper: [],
        fold: 1082,
        foldFull: [
            1082
        ]
    },
    {
        code: 1051,
        lower: [],
        title: [],
        upper: [],
        fold: 1083,
        foldFull: [
            1083
        ]
    },
    {
        code: 1052,
        lower: [],
        title: [],
        upper: [],
        fold: 1084,
        foldFull: [
            1084
        ]
    },
    {
        code: 1053,
        lower: [],
        title: [],
        upper: [],
        fold: 1085,
        foldFull: [
            1085
        ]
    },
    {
        code: 1054,
        lower: [],
        title: [],
        upper: [],
        fold: 1086,
        foldFull: [
            1086
        ]
    },
    {
        code: 1055,
        lower: [],
        title: [],
        upper: [],
        fold: 1087,
        foldFull: [
            1087
        ]
    },
    {
        code: 1056,
        lower: [],
        title: [],
        upper: [],
        fold: 1088,
        foldFull: [
            1088
        ]
    },
    {
        code: 1057,
        lower: [],
        title: [],
        upper: [],
        fold: 1089,
        foldFull: [
            1089
        ]
    },
    {
        code: 1058,
        lower: [],
        title: [],
        upper: [],
        fold: 1090,
        foldFull: [
            1090
        ]
    },
    {
        code: 1059,
        lower: [],
        title: [],
        upper: [],
        fold: 1091,
        foldFull: [
            1091
        ]
    },
    {
        code: 1060,
        lower: [],
        title: [],
        upper: [],
        fold: 1092,
        foldFull: [
            1092
        ]
    },
    {
        code: 1061,
        lower: [],
        title: [],
        upper: [],
        fold: 1093,
        foldFull: [
            1093
        ]
    },
    {
        code: 1062,
        lower: [],
        title: [],
        upper: [],
        fold: 1094,
        foldFull: [
            1094
        ]
    },
    {
        code: 1063,
        lower: [],
        title: [],
        upper: [],
        fold: 1095,
        foldFull: [
            1095
        ]
    },
    {
        code: 1064,
        lower: [],
        title: [],
        upper: [],
        fold: 1096,
        foldFull: [
            1096
        ]
    },
    {
        code: 1065,
        lower: [],
        title: [],
        upper: [],
        fold: 1097,
        foldFull: [
            1097
        ]
    },
    {
        code: 1066,
        lower: [],
        title: [],
        upper: [],
        fold: 1098,
        foldFull: [
            1098
        ]
    },
    {
        code: 1067,
        lower: [],
        title: [],
        upper: [],
        fold: 1099,
        foldFull: [
            1099
        ]
    },
    {
        code: 1068,
        lower: [],
        title: [],
        upper: [],
        fold: 1100,
        foldFull: [
            1100
        ]
    },
    {
        code: 1069,
        lower: [],
        title: [],
        upper: [],
        fold: 1101,
        foldFull: [
            1101
        ]
    },
    {
        code: 1070,
        lower: [],
        title: [],
        upper: [],
        fold: 1102,
        foldFull: [
            1102
        ]
    },
    {
        code: 1071,
        lower: [],
        title: [],
        upper: [],
        fold: 1103,
        foldFull: [
            1103
        ]
    },
    {
        code: 1120,
        lower: [],
        title: [],
        upper: [],
        fold: 1121,
        foldFull: [
            1121
        ]
    },
    {
        code: 1122,
        lower: [],
        title: [],
        upper: [],
        fold: 1123,
        foldFull: [
            1123
        ]
    },
    {
        code: 1124,
        lower: [],
        title: [],
        upper: [],
        fold: 1125,
        foldFull: [
            1125
        ]
    },
    {
        code: 1126,
        lower: [],
        title: [],
        upper: [],
        fold: 1127,
        foldFull: [
            1127
        ]
    },
    {
        code: 1128,
        lower: [],
        title: [],
        upper: [],
        fold: 1129,
        foldFull: [
            1129
        ]
    },
    {
        code: 1130,
        lower: [],
        title: [],
        upper: [],
        fold: 1131,
        foldFull: [
            1131
        ]
    },
    {
        code: 1132,
        lower: [],
        title: [],
        upper: [],
        fold: 1133,
        foldFull: [
            1133
        ]
    },
    {
        code: 1134,
        lower: [],
        title: [],
        upper: [],
        fold: 1135,
        foldFull: [
            1135
        ]
    },
    {
        code: 1136,
        lower: [],
        title: [],
        upper: [],
        fold: 1137,
        foldFull: [
            1137
        ]
    },
    {
        code: 1138,
        lower: [],
        title: [],
        upper: [],
        fold: 1139,
        foldFull: [
            1139
        ]
    },
    {
        code: 1140,
        lower: [],
        title: [],
        upper: [],
        fold: 1141,
        foldFull: [
            1141
        ]
    },
    {
        code: 1142,
        lower: [],
        title: [],
        upper: [],
        fold: 1143,
        foldFull: [
            1143
        ]
    },
    {
        code: 1144,
        lower: [],
        title: [],
        upper: [],
        fold: 1145,
        foldFull: [
            1145
        ]
    },
    {
        code: 1146,
        lower: [],
        title: [],
        upper: [],
        fold: 1147,
        foldFull: [
            1147
        ]
    },
    {
        code: 1148,
        lower: [],
        title: [],
        upper: [],
        fold: 1149,
        foldFull: [
            1149
        ]
    },
    {
        code: 1150,
        lower: [],
        title: [],
        upper: [],
        fold: 1151,
        foldFull: [
            1151
        ]
    },
    {
        code: 1152,
        lower: [],
        title: [],
        upper: [],
        fold: 1153,
        foldFull: [
            1153
        ]
    },
    {
        code: 1162,
        lower: [],
        title: [],
        upper: [],
        fold: 1163,
        foldFull: [
            1163
        ]
    },
    {
        code: 1164,
        lower: [],
        title: [],
        upper: [],
        fold: 1165,
        foldFull: [
            1165
        ]
    },
    {
        code: 1166,
        lower: [],
        title: [],
        upper: [],
        fold: 1167,
        foldFull: [
            1167
        ]
    },
    {
        code: 1168,
        lower: [],
        title: [],
        upper: [],
        fold: 1169,
        foldFull: [
            1169
        ]
    },
    {
        code: 1170,
        lower: [],
        title: [],
        upper: [],
        fold: 1171,
        foldFull: [
            1171
        ]
    },
    {
        code: 1172,
        lower: [],
        title: [],
        upper: [],
        fold: 1173,
        foldFull: [
            1173
        ]
    },
    {
        code: 1174,
        lower: [],
        title: [],
        upper: [],
        fold: 1175,
        foldFull: [
            1175
        ]
    },
    {
        code: 1176,
        lower: [],
        title: [],
        upper: [],
        fold: 1177,
        foldFull: [
            1177
        ]
    },
    {
        code: 1178,
        lower: [],
        title: [],
        upper: [],
        fold: 1179,
        foldFull: [
            1179
        ]
    },
    {
        code: 1180,
        lower: [],
        title: [],
        upper: [],
        fold: 1181,
        foldFull: [
            1181
        ]
    },
    {
        code: 1182,
        lower: [],
        title: [],
        upper: [],
        fold: 1183,
        foldFull: [
            1183
        ]
    },
    {
        code: 1184,
        lower: [],
        title: [],
        upper: [],
        fold: 1185,
        foldFull: [
            1185
        ]
    },
    {
        code: 1186,
        lower: [],
        title: [],
        upper: [],
        fold: 1187,
        foldFull: [
            1187
        ]
    },
    {
        code: 1188,
        lower: [],
        title: [],
        upper: [],
        fold: 1189,
        foldFull: [
            1189
        ]
    },
    {
        code: 1190,
        lower: [],
        title: [],
        upper: [],
        fold: 1191,
        foldFull: [
            1191
        ]
    },
    {
        code: 1192,
        lower: [],
        title: [],
        upper: [],
        fold: 1193,
        foldFull: [
            1193
        ]
    },
    {
        code: 1194,
        lower: [],
        title: [],
        upper: [],
        fold: 1195,
        foldFull: [
            1195
        ]
    },
    {
        code: 1196,
        lower: [],
        title: [],
        upper: [],
        fold: 1197,
        foldFull: [
            1197
        ]
    },
    {
        code: 1198,
        lower: [],
        title: [],
        upper: [],
        fold: 1199,
        foldFull: [
            1199
        ]
    },
    {
        code: 1200,
        lower: [],
        title: [],
        upper: [],
        fold: 1201,
        foldFull: [
            1201
        ]
    },
    {
        code: 1202,
        lower: [],
        title: [],
        upper: [],
        fold: 1203,
        foldFull: [
            1203
        ]
    },
    {
        code: 1204,
        lower: [],
        title: [],
        upper: [],
        fold: 1205,
        foldFull: [
            1205
        ]
    },
    {
        code: 1206,
        lower: [],
        title: [],
        upper: [],
        fold: 1207,
        foldFull: [
            1207
        ]
    },
    {
        code: 1208,
        lower: [],
        title: [],
        upper: [],
        fold: 1209,
        foldFull: [
            1209
        ]
    },
    {
        code: 1210,
        lower: [],
        title: [],
        upper: [],
        fold: 1211,
        foldFull: [
            1211
        ]
    },
    {
        code: 1212,
        lower: [],
        title: [],
        upper: [],
        fold: 1213,
        foldFull: [
            1213
        ]
    },
    {
        code: 1214,
        lower: [],
        title: [],
        upper: [],
        fold: 1215,
        foldFull: [
            1215
        ]
    },
    {
        code: 1216,
        lower: [],
        title: [],
        upper: [],
        fold: 1231,
        foldFull: [
            1231
        ]
    },
    {
        code: 1217,
        lower: [],
        title: [],
        upper: [],
        fold: 1218,
        foldFull: [
            1218
        ]
    },
    {
        code: 1219,
        lower: [],
        title: [],
        upper: [],
        fold: 1220,
        foldFull: [
            1220
        ]
    },
    {
        code: 1221,
        lower: [],
        title: [],
        upper: [],
        fold: 1222,
        foldFull: [
            1222
        ]
    },
    {
        code: 1223,
        lower: [],
        title: [],
        upper: [],
        fold: 1224,
        foldFull: [
            1224
        ]
    },
    {
        code: 1225,
        lower: [],
        title: [],
        upper: [],
        fold: 1226,
        foldFull: [
            1226
        ]
    },
    {
        code: 1227,
        lower: [],
        title: [],
        upper: [],
        fold: 1228,
        foldFull: [
            1228
        ]
    },
    {
        code: 1229,
        lower: [],
        title: [],
        upper: [],
        fold: 1230,
        foldFull: [
            1230
        ]
    },
    {
        code: 1232,
        lower: [],
        title: [],
        upper: [],
        fold: 1233,
        foldFull: [
            1233
        ]
    },
    {
        code: 1234,
        lower: [],
        title: [],
        upper: [],
        fold: 1235,
        foldFull: [
            1235
        ]
    },
    {
        code: 1236,
        lower: [],
        title: [],
        upper: [],
        fold: 1237,
        foldFull: [
            1237
        ]
    },
    {
        code: 1238,
        lower: [],
        title: [],
        upper: [],
        fold: 1239,
        foldFull: [
            1239
        ]
    },
    {
        code: 1240,
        lower: [],
        title: [],
        upper: [],
        fold: 1241,
        foldFull: [
            1241
        ]
    },
    {
        code: 1242,
        lower: [],
        title: [],
        upper: [],
        fold: 1243,
        foldFull: [
            1243
        ]
    },
    {
        code: 1244,
        lower: [],
        title: [],
        upper: [],
        fold: 1245,
        foldFull: [
            1245
        ]
    },
    {
        code: 1246,
        lower: [],
        title: [],
        upper: [],
        fold: 1247,
        foldFull: [
            1247
        ]
    },
    {
        code: 1248,
        lower: [],
        title: [],
        upper: [],
        fold: 1249,
        foldFull: [
            1249
        ]
    },
    {
        code: 1250,
        lower: [],
        title: [],
        upper: [],
        fold: 1251,
        foldFull: [
            1251
        ]
    },
    {
        code: 1252,
        lower: [],
        title: [],
        upper: [],
        fold: 1253,
        foldFull: [
            1253
        ]
    },
    {
        code: 1254,
        lower: [],
        title: [],
        upper: [],
        fold: 1255,
        foldFull: [
            1255
        ]
    },
    {
        code: 1256,
        lower: [],
        title: [],
        upper: [],
        fold: 1257,
        foldFull: [
            1257
        ]
    },
    {
        code: 1258,
        lower: [],
        title: [],
        upper: [],
        fold: 1259,
        foldFull: [
            1259
        ]
    },
    {
        code: 1260,
        lower: [],
        title: [],
        upper: [],
        fold: 1261,
        foldFull: [
            1261
        ]
    },
    {
        code: 1262,
        lower: [],
        title: [],
        upper: [],
        fold: 1263,
        foldFull: [
            1263
        ]
    },
    {
        code: 1264,
        lower: [],
        title: [],
        upper: [],
        fold: 1265,
        foldFull: [
            1265
        ]
    },
    {
        code: 1266,
        lower: [],
        title: [],
        upper: [],
        fold: 1267,
        foldFull: [
            1267
        ]
    },
    {
        code: 1268,
        lower: [],
        title: [],
        upper: [],
        fold: 1269,
        foldFull: [
            1269
        ]
    },
    {
        code: 1270,
        lower: [],
        title: [],
        upper: [],
        fold: 1271,
        foldFull: [
            1271
        ]
    },
    {
        code: 1272,
        lower: [],
        title: [],
        upper: [],
        fold: 1273,
        foldFull: [
            1273
        ]
    },
    {
        code: 1274,
        lower: [],
        title: [],
        upper: [],
        fold: 1275,
        foldFull: [
            1275
        ]
    },
    {
        code: 1276,
        lower: [],
        title: [],
        upper: [],
        fold: 1277,
        foldFull: [
            1277
        ]
    },
    {
        code: 1278,
        lower: [],
        title: [],
        upper: [],
        fold: 1279,
        foldFull: [
            1279
        ]
    },
    {
        code: 1280,
        lower: [],
        title: [],
        upper: [],
        fold: 1281,
        foldFull: [
            1281
        ]
    },
    {
        code: 1282,
        lower: [],
        title: [],
        upper: [],
        fold: 1283,
        foldFull: [
            1283
        ]
    },
    {
        code: 1284,
        lower: [],
        title: [],
        upper: [],
        fold: 1285,
        foldFull: [
            1285
        ]
    },
    {
        code: 1286,
        lower: [],
        title: [],
        upper: [],
        fold: 1287,
        foldFull: [
            1287
        ]
    },
    {
        code: 1288,
        lower: [],
        title: [],
        upper: [],
        fold: 1289,
        foldFull: [
            1289
        ]
    },
    {
        code: 1290,
        lower: [],
        title: [],
        upper: [],
        fold: 1291,
        foldFull: [
            1291
        ]
    },
    {
        code: 1292,
        lower: [],
        title: [],
        upper: [],
        fold: 1293,
        foldFull: [
            1293
        ]
    },
    {
        code: 1294,
        lower: [],
        title: [],
        upper: [],
        fold: 1295,
        foldFull: [
            1295
        ]
    },
    {
        code: 1296,
        lower: [],
        title: [],
        upper: [],
        fold: 1297,
        foldFull: [
            1297
        ]
    },
    {
        code: 1298,
        lower: [],
        title: [],
        upper: [],
        fold: 1299,
        foldFull: [
            1299
        ]
    },
    {
        code: 1300,
        lower: [],
        title: [],
        upper: [],
        fold: 1301,
        foldFull: [
            1301
        ]
    },
    {
        code: 1302,
        lower: [],
        title: [],
        upper: [],
        fold: 1303,
        foldFull: [
            1303
        ]
    },
    {
        code: 1304,
        lower: [],
        title: [],
        upper: [],
        fold: 1305,
        foldFull: [
            1305
        ]
    },
    {
        code: 1306,
        lower: [],
        title: [],
        upper: [],
        fold: 1307,
        foldFull: [
            1307
        ]
    },
    {
        code: 1308,
        lower: [],
        title: [],
        upper: [],
        fold: 1309,
        foldFull: [
            1309
        ]
    },
    {
        code: 1310,
        lower: [],
        title: [],
        upper: [],
        fold: 1311,
        foldFull: [
            1311
        ]
    },
    {
        code: 1312,
        lower: [],
        title: [],
        upper: [],
        fold: 1313,
        foldFull: [
            1313
        ]
    },
    {
        code: 1314,
        lower: [],
        title: [],
        upper: [],
        fold: 1315,
        foldFull: [
            1315
        ]
    },
    {
        code: 1316,
        lower: [],
        title: [],
        upper: [],
        fold: 1317,
        foldFull: [
            1317
        ]
    },
    {
        code: 1318,
        lower: [],
        title: [],
        upper: [],
        fold: 1319,
        foldFull: [
            1319
        ]
    },
    {
        code: 1320,
        lower: [],
        title: [],
        upper: [],
        fold: 1321,
        foldFull: [
            1321
        ]
    },
    {
        code: 1322,
        lower: [],
        title: [],
        upper: [],
        fold: 1323,
        foldFull: [
            1323
        ]
    },
    {
        code: 1324,
        lower: [],
        title: [],
        upper: [],
        fold: 1325,
        foldFull: [
            1325
        ]
    },
    {
        code: 1326,
        lower: [],
        title: [],
        upper: [],
        fold: 1327,
        foldFull: [
            1327
        ]
    },
    {
        code: 1329,
        lower: [],
        title: [],
        upper: [],
        fold: 1377,
        foldFull: [
            1377
        ]
    },
    {
        code: 1330,
        lower: [],
        title: [],
        upper: [],
        fold: 1378,
        foldFull: [
            1378
        ]
    },
    {
        code: 1331,
        lower: [],
        title: [],
        upper: [],
        fold: 1379,
        foldFull: [
            1379
        ]
    },
    {
        code: 1332,
        lower: [],
        title: [],
        upper: [],
        fold: 1380,
        foldFull: [
            1380
        ]
    },
    {
        code: 1333,
        lower: [],
        title: [],
        upper: [],
        fold: 1381,
        foldFull: [
            1381
        ]
    },
    {
        code: 1334,
        lower: [],
        title: [],
        upper: [],
        fold: 1382,
        foldFull: [
            1382
        ]
    },
    {
        code: 1335,
        lower: [],
        title: [],
        upper: [],
        fold: 1383,
        foldFull: [
            1383
        ]
    },
    {
        code: 1336,
        lower: [],
        title: [],
        upper: [],
        fold: 1384,
        foldFull: [
            1384
        ]
    },
    {
        code: 1337,
        lower: [],
        title: [],
        upper: [],
        fold: 1385,
        foldFull: [
            1385
        ]
    },
    {
        code: 1338,
        lower: [],
        title: [],
        upper: [],
        fold: 1386,
        foldFull: [
            1386
        ]
    },
    {
        code: 1339,
        lower: [],
        title: [],
        upper: [],
        fold: 1387,
        foldFull: [
            1387
        ]
    },
    {
        code: 1340,
        lower: [],
        title: [],
        upper: [],
        fold: 1388,
        foldFull: [
            1388
        ]
    },
    {
        code: 1341,
        lower: [],
        title: [],
        upper: [],
        fold: 1389,
        foldFull: [
            1389
        ]
    },
    {
        code: 1342,
        lower: [],
        title: [],
        upper: [],
        fold: 1390,
        foldFull: [
            1390
        ]
    },
    {
        code: 1343,
        lower: [],
        title: [],
        upper: [],
        fold: 1391,
        foldFull: [
            1391
        ]
    },
    {
        code: 1344,
        lower: [],
        title: [],
        upper: [],
        fold: 1392,
        foldFull: [
            1392
        ]
    },
    {
        code: 1345,
        lower: [],
        title: [],
        upper: [],
        fold: 1393,
        foldFull: [
            1393
        ]
    },
    {
        code: 1346,
        lower: [],
        title: [],
        upper: [],
        fold: 1394,
        foldFull: [
            1394
        ]
    },
    {
        code: 1347,
        lower: [],
        title: [],
        upper: [],
        fold: 1395,
        foldFull: [
            1395
        ]
    },
    {
        code: 1348,
        lower: [],
        title: [],
        upper: [],
        fold: 1396,
        foldFull: [
            1396
        ]
    },
    {
        code: 1349,
        lower: [],
        title: [],
        upper: [],
        fold: 1397,
        foldFull: [
            1397
        ]
    },
    {
        code: 1350,
        lower: [],
        title: [],
        upper: [],
        fold: 1398,
        foldFull: [
            1398
        ]
    },
    {
        code: 1351,
        lower: [],
        title: [],
        upper: [],
        fold: 1399,
        foldFull: [
            1399
        ]
    },
    {
        code: 1352,
        lower: [],
        title: [],
        upper: [],
        fold: 1400,
        foldFull: [
            1400
        ]
    },
    {
        code: 1353,
        lower: [],
        title: [],
        upper: [],
        fold: 1401,
        foldFull: [
            1401
        ]
    },
    {
        code: 1354,
        lower: [],
        title: [],
        upper: [],
        fold: 1402,
        foldFull: [
            1402
        ]
    },
    {
        code: 1355,
        lower: [],
        title: [],
        upper: [],
        fold: 1403,
        foldFull: [
            1403
        ]
    },
    {
        code: 1356,
        lower: [],
        title: [],
        upper: [],
        fold: 1404,
        foldFull: [
            1404
        ]
    },
    {
        code: 1357,
        lower: [],
        title: [],
        upper: [],
        fold: 1405,
        foldFull: [
            1405
        ]
    },
    {
        code: 1358,
        lower: [],
        title: [],
        upper: [],
        fold: 1406,
        foldFull: [
            1406
        ]
    },
    {
        code: 1359,
        lower: [],
        title: [],
        upper: [],
        fold: 1407,
        foldFull: [
            1407
        ]
    },
    {
        code: 1360,
        lower: [],
        title: [],
        upper: [],
        fold: 1408,
        foldFull: [
            1408
        ]
    },
    {
        code: 1361,
        lower: [],
        title: [],
        upper: [],
        fold: 1409,
        foldFull: [
            1409
        ]
    },
    {
        code: 1362,
        lower: [],
        title: [],
        upper: [],
        fold: 1410,
        foldFull: [
            1410
        ]
    },
    {
        code: 1363,
        lower: [],
        title: [],
        upper: [],
        fold: 1411,
        foldFull: [
            1411
        ]
    },
    {
        code: 1364,
        lower: [],
        title: [],
        upper: [],
        fold: 1412,
        foldFull: [
            1412
        ]
    },
    {
        code: 1365,
        lower: [],
        title: [],
        upper: [],
        fold: 1413,
        foldFull: [
            1413
        ]
    },
    {
        code: 1366,
        lower: [],
        title: [],
        upper: [],
        fold: 1414,
        foldFull: [
            1414
        ]
    },
    {
        code: 1415,
        lower: [
            1415
        ],
        title: [
            1333,
            1410
        ],
        upper: [
            1333,
            1362
        ],
        fold: 0,
        foldFull: [
            1381,
            1410
        ]
    },
    {
        code: 1415,
        lower: [
            1415
        ],
        title: [
            1333,
            1410
        ],
        upper: [
            1333,
            1362
        ],
        fold: 0,
        foldFull: [
            1381,
            1410
        ]
    },
    {
        code: 4256,
        lower: [],
        title: [],
        upper: [],
        fold: 11520,
        foldFull: [
            11520
        ]
    },
    {
        code: 4257,
        lower: [],
        title: [],
        upper: [],
        fold: 11521,
        foldFull: [
            11521
        ]
    },
    {
        code: 4258,
        lower: [],
        title: [],
        upper: [],
        fold: 11522,
        foldFull: [
            11522
        ]
    },
    {
        code: 4259,
        lower: [],
        title: [],
        upper: [],
        fold: 11523,
        foldFull: [
            11523
        ]
    },
    {
        code: 4260,
        lower: [],
        title: [],
        upper: [],
        fold: 11524,
        foldFull: [
            11524
        ]
    },
    {
        code: 4261,
        lower: [],
        title: [],
        upper: [],
        fold: 11525,
        foldFull: [
            11525
        ]
    },
    {
        code: 4262,
        lower: [],
        title: [],
        upper: [],
        fold: 11526,
        foldFull: [
            11526
        ]
    },
    {
        code: 4263,
        lower: [],
        title: [],
        upper: [],
        fold: 11527,
        foldFull: [
            11527
        ]
    },
    {
        code: 4264,
        lower: [],
        title: [],
        upper: [],
        fold: 11528,
        foldFull: [
            11528
        ]
    },
    {
        code: 4265,
        lower: [],
        title: [],
        upper: [],
        fold: 11529,
        foldFull: [
            11529
        ]
    },
    {
        code: 4266,
        lower: [],
        title: [],
        upper: [],
        fold: 11530,
        foldFull: [
            11530
        ]
    },
    {
        code: 4267,
        lower: [],
        title: [],
        upper: [],
        fold: 11531,
        foldFull: [
            11531
        ]
    },
    {
        code: 4268,
        lower: [],
        title: [],
        upper: [],
        fold: 11532,
        foldFull: [
            11532
        ]
    },
    {
        code: 4269,
        lower: [],
        title: [],
        upper: [],
        fold: 11533,
        foldFull: [
            11533
        ]
    },
    {
        code: 4270,
        lower: [],
        title: [],
        upper: [],
        fold: 11534,
        foldFull: [
            11534
        ]
    },
    {
        code: 4271,
        lower: [],
        title: [],
        upper: [],
        fold: 11535,
        foldFull: [
            11535
        ]
    },
    {
        code: 4272,
        lower: [],
        title: [],
        upper: [],
        fold: 11536,
        foldFull: [
            11536
        ]
    },
    {
        code: 4273,
        lower: [],
        title: [],
        upper: [],
        fold: 11537,
        foldFull: [
            11537
        ]
    },
    {
        code: 4274,
        lower: [],
        title: [],
        upper: [],
        fold: 11538,
        foldFull: [
            11538
        ]
    },
    {
        code: 4275,
        lower: [],
        title: [],
        upper: [],
        fold: 11539,
        foldFull: [
            11539
        ]
    },
    {
        code: 4276,
        lower: [],
        title: [],
        upper: [],
        fold: 11540,
        foldFull: [
            11540
        ]
    },
    {
        code: 4277,
        lower: [],
        title: [],
        upper: [],
        fold: 11541,
        foldFull: [
            11541
        ]
    },
    {
        code: 4278,
        lower: [],
        title: [],
        upper: [],
        fold: 11542,
        foldFull: [
            11542
        ]
    },
    {
        code: 4279,
        lower: [],
        title: [],
        upper: [],
        fold: 11543,
        foldFull: [
            11543
        ]
    },
    {
        code: 4280,
        lower: [],
        title: [],
        upper: [],
        fold: 11544,
        foldFull: [
            11544
        ]
    },
    {
        code: 4281,
        lower: [],
        title: [],
        upper: [],
        fold: 11545,
        foldFull: [
            11545
        ]
    },
    {
        code: 4282,
        lower: [],
        title: [],
        upper: [],
        fold: 11546,
        foldFull: [
            11546
        ]
    },
    {
        code: 4283,
        lower: [],
        title: [],
        upper: [],
        fold: 11547,
        foldFull: [
            11547
        ]
    },
    {
        code: 4284,
        lower: [],
        title: [],
        upper: [],
        fold: 11548,
        foldFull: [
            11548
        ]
    },
    {
        code: 4285,
        lower: [],
        title: [],
        upper: [],
        fold: 11549,
        foldFull: [
            11549
        ]
    },
    {
        code: 4286,
        lower: [],
        title: [],
        upper: [],
        fold: 11550,
        foldFull: [
            11550
        ]
    },
    {
        code: 4287,
        lower: [],
        title: [],
        upper: [],
        fold: 11551,
        foldFull: [
            11551
        ]
    },
    {
        code: 4288,
        lower: [],
        title: [],
        upper: [],
        fold: 11552,
        foldFull: [
            11552
        ]
    },
    {
        code: 4289,
        lower: [],
        title: [],
        upper: [],
        fold: 11553,
        foldFull: [
            11553
        ]
    },
    {
        code: 4290,
        lower: [],
        title: [],
        upper: [],
        fold: 11554,
        foldFull: [
            11554
        ]
    },
    {
        code: 4291,
        lower: [],
        title: [],
        upper: [],
        fold: 11555,
        foldFull: [
            11555
        ]
    },
    {
        code: 4292,
        lower: [],
        title: [],
        upper: [],
        fold: 11556,
        foldFull: [
            11556
        ]
    },
    {
        code: 4293,
        lower: [],
        title: [],
        upper: [],
        fold: 11557,
        foldFull: [
            11557
        ]
    },
    {
        code: 4295,
        lower: [],
        title: [],
        upper: [],
        fold: 11559,
        foldFull: [
            11559
        ]
    },
    {
        code: 4301,
        lower: [],
        title: [],
        upper: [],
        fold: 11565,
        foldFull: [
            11565
        ]
    },
    {
        code: 5112,
        lower: [],
        title: [],
        upper: [],
        fold: 5104,
        foldFull: [
            5104
        ]
    },
    {
        code: 5113,
        lower: [],
        title: [],
        upper: [],
        fold: 5105,
        foldFull: [
            5105
        ]
    },
    {
        code: 5114,
        lower: [],
        title: [],
        upper: [],
        fold: 5106,
        foldFull: [
            5106
        ]
    },
    {
        code: 5115,
        lower: [],
        title: [],
        upper: [],
        fold: 5107,
        foldFull: [
            5107
        ]
    },
    {
        code: 5116,
        lower: [],
        title: [],
        upper: [],
        fold: 5108,
        foldFull: [
            5108
        ]
    },
    {
        code: 5117,
        lower: [],
        title: [],
        upper: [],
        fold: 5109,
        foldFull: [
            5109
        ]
    },
    {
        code: 7296,
        lower: [],
        title: [],
        upper: [],
        fold: 1074,
        foldFull: [
            1074
        ]
    },
    {
        code: 7297,
        lower: [],
        title: [],
        upper: [],
        fold: 1076,
        foldFull: [
            1076
        ]
    },
    {
        code: 7298,
        lower: [],
        title: [],
        upper: [],
        fold: 1086,
        foldFull: [
            1086
        ]
    },
    {
        code: 7299,
        lower: [],
        title: [],
        upper: [],
        fold: 1089,
        foldFull: [
            1089
        ]
    },
    {
        code: 7300,
        lower: [],
        title: [],
        upper: [],
        fold: 1090,
        foldFull: [
            1090
        ]
    },
    {
        code: 7301,
        lower: [],
        title: [],
        upper: [],
        fold: 1090,
        foldFull: [
            1090
        ]
    },
    {
        code: 7302,
        lower: [],
        title: [],
        upper: [],
        fold: 1098,
        foldFull: [
            1098
        ]
    },
    {
        code: 7303,
        lower: [],
        title: [],
        upper: [],
        fold: 1123,
        foldFull: [
            1123
        ]
    },
    {
        code: 7304,
        lower: [],
        title: [],
        upper: [],
        fold: 42571,
        foldFull: [
            42571
        ]
    },
    {
        code: 7312,
        lower: [],
        title: [],
        upper: [],
        fold: 4304,
        foldFull: [
            4304
        ]
    },
    {
        code: 7313,
        lower: [],
        title: [],
        upper: [],
        fold: 4305,
        foldFull: [
            4305
        ]
    },
    {
        code: 7314,
        lower: [],
        title: [],
        upper: [],
        fold: 4306,
        foldFull: [
            4306
        ]
    },
    {
        code: 7315,
        lower: [],
        title: [],
        upper: [],
        fold: 4307,
        foldFull: [
            4307
        ]
    },
    {
        code: 7316,
        lower: [],
        title: [],
        upper: [],
        fold: 4308,
        foldFull: [
            4308
        ]
    },
    {
        code: 7317,
        lower: [],
        title: [],
        upper: [],
        fold: 4309,
        foldFull: [
            4309
        ]
    },
    {
        code: 7318,
        lower: [],
        title: [],
        upper: [],
        fold: 4310,
        foldFull: [
            4310
        ]
    },
    {
        code: 7319,
        lower: [],
        title: [],
        upper: [],
        fold: 4311,
        foldFull: [
            4311
        ]
    },
    {
        code: 7320,
        lower: [],
        title: [],
        upper: [],
        fold: 4312,
        foldFull: [
            4312
        ]
    },
    {
        code: 7321,
        lower: [],
        title: [],
        upper: [],
        fold: 4313,
        foldFull: [
            4313
        ]
    },
    {
        code: 7322,
        lower: [],
        title: [],
        upper: [],
        fold: 4314,
        foldFull: [
            4314
        ]
    },
    {
        code: 7323,
        lower: [],
        title: [],
        upper: [],
        fold: 4315,
        foldFull: [
            4315
        ]
    },
    {
        code: 7324,
        lower: [],
        title: [],
        upper: [],
        fold: 4316,
        foldFull: [
            4316
        ]
    },
    {
        code: 7325,
        lower: [],
        title: [],
        upper: [],
        fold: 4317,
        foldFull: [
            4317
        ]
    },
    {
        code: 7326,
        lower: [],
        title: [],
        upper: [],
        fold: 4318,
        foldFull: [
            4318
        ]
    },
    {
        code: 7327,
        lower: [],
        title: [],
        upper: [],
        fold: 4319,
        foldFull: [
            4319
        ]
    },
    {
        code: 7328,
        lower: [],
        title: [],
        upper: [],
        fold: 4320,
        foldFull: [
            4320
        ]
    },
    {
        code: 7329,
        lower: [],
        title: [],
        upper: [],
        fold: 4321,
        foldFull: [
            4321
        ]
    },
    {
        code: 7330,
        lower: [],
        title: [],
        upper: [],
        fold: 4322,
        foldFull: [
            4322
        ]
    },
    {
        code: 7331,
        lower: [],
        title: [],
        upper: [],
        fold: 4323,
        foldFull: [
            4323
        ]
    },
    {
        code: 7332,
        lower: [],
        title: [],
        upper: [],
        fold: 4324,
        foldFull: [
            4324
        ]
    },
    {
        code: 7333,
        lower: [],
        title: [],
        upper: [],
        fold: 4325,
        foldFull: [
            4325
        ]
    },
    {
        code: 7334,
        lower: [],
        title: [],
        upper: [],
        fold: 4326,
        foldFull: [
            4326
        ]
    },
    {
        code: 7335,
        lower: [],
        title: [],
        upper: [],
        fold: 4327,
        foldFull: [
            4327
        ]
    },
    {
        code: 7336,
        lower: [],
        title: [],
        upper: [],
        fold: 4328,
        foldFull: [
            4328
        ]
    },
    {
        code: 7337,
        lower: [],
        title: [],
        upper: [],
        fold: 4329,
        foldFull: [
            4329
        ]
    },
    {
        code: 7338,
        lower: [],
        title: [],
        upper: [],
        fold: 4330,
        foldFull: [
            4330
        ]
    },
    {
        code: 7339,
        lower: [],
        title: [],
        upper: [],
        fold: 4331,
        foldFull: [
            4331
        ]
    },
    {
        code: 7340,
        lower: [],
        title: [],
        upper: [],
        fold: 4332,
        foldFull: [
            4332
        ]
    },
    {
        code: 7341,
        lower: [],
        title: [],
        upper: [],
        fold: 4333,
        foldFull: [
            4333
        ]
    },
    {
        code: 7342,
        lower: [],
        title: [],
        upper: [],
        fold: 4334,
        foldFull: [
            4334
        ]
    },
    {
        code: 7343,
        lower: [],
        title: [],
        upper: [],
        fold: 4335,
        foldFull: [
            4335
        ]
    },
    {
        code: 7344,
        lower: [],
        title: [],
        upper: [],
        fold: 4336,
        foldFull: [
            4336
        ]
    },
    {
        code: 7345,
        lower: [],
        title: [],
        upper: [],
        fold: 4337,
        foldFull: [
            4337
        ]
    },
    {
        code: 7346,
        lower: [],
        title: [],
        upper: [],
        fold: 4338,
        foldFull: [
            4338
        ]
    },
    {
        code: 7347,
        lower: [],
        title: [],
        upper: [],
        fold: 4339,
        foldFull: [
            4339
        ]
    },
    {
        code: 7348,
        lower: [],
        title: [],
        upper: [],
        fold: 4340,
        foldFull: [
            4340
        ]
    },
    {
        code: 7349,
        lower: [],
        title: [],
        upper: [],
        fold: 4341,
        foldFull: [
            4341
        ]
    },
    {
        code: 7350,
        lower: [],
        title: [],
        upper: [],
        fold: 4342,
        foldFull: [
            4342
        ]
    },
    {
        code: 7351,
        lower: [],
        title: [],
        upper: [],
        fold: 4343,
        foldFull: [
            4343
        ]
    },
    {
        code: 7352,
        lower: [],
        title: [],
        upper: [],
        fold: 4344,
        foldFull: [
            4344
        ]
    },
    {
        code: 7353,
        lower: [],
        title: [],
        upper: [],
        fold: 4345,
        foldFull: [
            4345
        ]
    },
    {
        code: 7354,
        lower: [],
        title: [],
        upper: [],
        fold: 4346,
        foldFull: [
            4346
        ]
    },
    {
        code: 7357,
        lower: [],
        title: [],
        upper: [],
        fold: 4349,
        foldFull: [
            4349
        ]
    },
    {
        code: 7358,
        lower: [],
        title: [],
        upper: [],
        fold: 4350,
        foldFull: [
            4350
        ]
    },
    {
        code: 7359,
        lower: [],
        title: [],
        upper: [],
        fold: 4351,
        foldFull: [
            4351
        ]
    },
    {
        code: 7680,
        lower: [],
        title: [],
        upper: [],
        fold: 7681,
        foldFull: [
            7681
        ]
    },
    {
        code: 7682,
        lower: [],
        title: [],
        upper: [],
        fold: 7683,
        foldFull: [
            7683
        ]
    },
    {
        code: 7684,
        lower: [],
        title: [],
        upper: [],
        fold: 7685,
        foldFull: [
            7685
        ]
    },
    {
        code: 7686,
        lower: [],
        title: [],
        upper: [],
        fold: 7687,
        foldFull: [
            7687
        ]
    },
    {
        code: 7688,
        lower: [],
        title: [],
        upper: [],
        fold: 7689,
        foldFull: [
            7689
        ]
    },
    {
        code: 7690,
        lower: [],
        title: [],
        upper: [],
        fold: 7691,
        foldFull: [
            7691
        ]
    },
    {
        code: 7692,
        lower: [],
        title: [],
        upper: [],
        fold: 7693,
        foldFull: [
            7693
        ]
    },
    {
        code: 7694,
        lower: [],
        title: [],
        upper: [],
        fold: 7695,
        foldFull: [
            7695
        ]
    },
    {
        code: 7696,
        lower: [],
        title: [],
        upper: [],
        fold: 7697,
        foldFull: [
            7697
        ]
    },
    {
        code: 7698,
        lower: [],
        title: [],
        upper: [],
        fold: 7699,
        foldFull: [
            7699
        ]
    },
    {
        code: 7700,
        lower: [],
        title: [],
        upper: [],
        fold: 7701,
        foldFull: [
            7701
        ]
    },
    {
        code: 7702,
        lower: [],
        title: [],
        upper: [],
        fold: 7703,
        foldFull: [
            7703
        ]
    },
    {
        code: 7704,
        lower: [],
        title: [],
        upper: [],
        fold: 7705,
        foldFull: [
            7705
        ]
    },
    {
        code: 7706,
        lower: [],
        title: [],
        upper: [],
        fold: 7707,
        foldFull: [
            7707
        ]
    },
    {
        code: 7708,
        lower: [],
        title: [],
        upper: [],
        fold: 7709,
        foldFull: [
            7709
        ]
    },
    {
        code: 7710,
        lower: [],
        title: [],
        upper: [],
        fold: 7711,
        foldFull: [
            7711
        ]
    },
    {
        code: 7712,
        lower: [],
        title: [],
        upper: [],
        fold: 7713,
        foldFull: [
            7713
        ]
    },
    {
        code: 7714,
        lower: [],
        title: [],
        upper: [],
        fold: 7715,
        foldFull: [
            7715
        ]
    },
    {
        code: 7716,
        lower: [],
        title: [],
        upper: [],
        fold: 7717,
        foldFull: [
            7717
        ]
    },
    {
        code: 7718,
        lower: [],
        title: [],
        upper: [],
        fold: 7719,
        foldFull: [
            7719
        ]
    },
    {
        code: 7720,
        lower: [],
        title: [],
        upper: [],
        fold: 7721,
        foldFull: [
            7721
        ]
    },
    {
        code: 7722,
        lower: [],
        title: [],
        upper: [],
        fold: 7723,
        foldFull: [
            7723
        ]
    },
    {
        code: 7724,
        lower: [],
        title: [],
        upper: [],
        fold: 7725,
        foldFull: [
            7725
        ]
    },
    {
        code: 7726,
        lower: [],
        title: [],
        upper: [],
        fold: 7727,
        foldFull: [
            7727
        ]
    },
    {
        code: 7728,
        lower: [],
        title: [],
        upper: [],
        fold: 7729,
        foldFull: [
            7729
        ]
    },
    {
        code: 7730,
        lower: [],
        title: [],
        upper: [],
        fold: 7731,
        foldFull: [
            7731
        ]
    },
    {
        code: 7732,
        lower: [],
        title: [],
        upper: [],
        fold: 7733,
        foldFull: [
            7733
        ]
    },
    {
        code: 7734,
        lower: [],
        title: [],
        upper: [],
        fold: 7735,
        foldFull: [
            7735
        ]
    },
    {
        code: 7736,
        lower: [],
        title: [],
        upper: [],
        fold: 7737,
        foldFull: [
            7737
        ]
    },
    {
        code: 7738,
        lower: [],
        title: [],
        upper: [],
        fold: 7739,
        foldFull: [
            7739
        ]
    },
    {
        code: 7740,
        lower: [],
        title: [],
        upper: [],
        fold: 7741,
        foldFull: [
            7741
        ]
    },
    {
        code: 7742,
        lower: [],
        title: [],
        upper: [],
        fold: 7743,
        foldFull: [
            7743
        ]
    },
    {
        code: 7744,
        lower: [],
        title: [],
        upper: [],
        fold: 7745,
        foldFull: [
            7745
        ]
    },
    {
        code: 7746,
        lower: [],
        title: [],
        upper: [],
        fold: 7747,
        foldFull: [
            7747
        ]
    },
    {
        code: 7748,
        lower: [],
        title: [],
        upper: [],
        fold: 7749,
        foldFull: [
            7749
        ]
    },
    {
        code: 7750,
        lower: [],
        title: [],
        upper: [],
        fold: 7751,
        foldFull: [
            7751
        ]
    },
    {
        code: 7752,
        lower: [],
        title: [],
        upper: [],
        fold: 7753,
        foldFull: [
            7753
        ]
    },
    {
        code: 7754,
        lower: [],
        title: [],
        upper: [],
        fold: 7755,
        foldFull: [
            7755
        ]
    },
    {
        code: 7756,
        lower: [],
        title: [],
        upper: [],
        fold: 7757,
        foldFull: [
            7757
        ]
    },
    {
        code: 7758,
        lower: [],
        title: [],
        upper: [],
        fold: 7759,
        foldFull: [
            7759
        ]
    },
    {
        code: 7760,
        lower: [],
        title: [],
        upper: [],
        fold: 7761,
        foldFull: [
            7761
        ]
    },
    {
        code: 7762,
        lower: [],
        title: [],
        upper: [],
        fold: 7763,
        foldFull: [
            7763
        ]
    },
    {
        code: 7764,
        lower: [],
        title: [],
        upper: [],
        fold: 7765,
        foldFull: [
            7765
        ]
    },
    {
        code: 7766,
        lower: [],
        title: [],
        upper: [],
        fold: 7767,
        foldFull: [
            7767
        ]
    },
    {
        code: 7768,
        lower: [],
        title: [],
        upper: [],
        fold: 7769,
        foldFull: [
            7769
        ]
    },
    {
        code: 7770,
        lower: [],
        title: [],
        upper: [],
        fold: 7771,
        foldFull: [
            7771
        ]
    },
    {
        code: 7772,
        lower: [],
        title: [],
        upper: [],
        fold: 7773,
        foldFull: [
            7773
        ]
    },
    {
        code: 7774,
        lower: [],
        title: [],
        upper: [],
        fold: 7775,
        foldFull: [
            7775
        ]
    },
    {
        code: 7776,
        lower: [],
        title: [],
        upper: [],
        fold: 7777,
        foldFull: [
            7777
        ]
    },
    {
        code: 7778,
        lower: [],
        title: [],
        upper: [],
        fold: 7779,
        foldFull: [
            7779
        ]
    },
    {
        code: 7780,
        lower: [],
        title: [],
        upper: [],
        fold: 7781,
        foldFull: [
            7781
        ]
    },
    {
        code: 7782,
        lower: [],
        title: [],
        upper: [],
        fold: 7783,
        foldFull: [
            7783
        ]
    },
    {
        code: 7784,
        lower: [],
        title: [],
        upper: [],
        fold: 7785,
        foldFull: [
            7785
        ]
    },
    {
        code: 7786,
        lower: [],
        title: [],
        upper: [],
        fold: 7787,
        foldFull: [
            7787
        ]
    },
    {
        code: 7788,
        lower: [],
        title: [],
        upper: [],
        fold: 7789,
        foldFull: [
            7789
        ]
    },
    {
        code: 7790,
        lower: [],
        title: [],
        upper: [],
        fold: 7791,
        foldFull: [
            7791
        ]
    },
    {
        code: 7792,
        lower: [],
        title: [],
        upper: [],
        fold: 7793,
        foldFull: [
            7793
        ]
    },
    {
        code: 7794,
        lower: [],
        title: [],
        upper: [],
        fold: 7795,
        foldFull: [
            7795
        ]
    },
    {
        code: 7796,
        lower: [],
        title: [],
        upper: [],
        fold: 7797,
        foldFull: [
            7797
        ]
    },
    {
        code: 7798,
        lower: [],
        title: [],
        upper: [],
        fold: 7799,
        foldFull: [
            7799
        ]
    },
    {
        code: 7800,
        lower: [],
        title: [],
        upper: [],
        fold: 7801,
        foldFull: [
            7801
        ]
    },
    {
        code: 7802,
        lower: [],
        title: [],
        upper: [],
        fold: 7803,
        foldFull: [
            7803
        ]
    },
    {
        code: 7804,
        lower: [],
        title: [],
        upper: [],
        fold: 7805,
        foldFull: [
            7805
        ]
    },
    {
        code: 7806,
        lower: [],
        title: [],
        upper: [],
        fold: 7807,
        foldFull: [
            7807
        ]
    },
    {
        code: 7808,
        lower: [],
        title: [],
        upper: [],
        fold: 7809,
        foldFull: [
            7809
        ]
    },
    {
        code: 7810,
        lower: [],
        title: [],
        upper: [],
        fold: 7811,
        foldFull: [
            7811
        ]
    },
    {
        code: 7812,
        lower: [],
        title: [],
        upper: [],
        fold: 7813,
        foldFull: [
            7813
        ]
    },
    {
        code: 7814,
        lower: [],
        title: [],
        upper: [],
        fold: 7815,
        foldFull: [
            7815
        ]
    },
    {
        code: 7816,
        lower: [],
        title: [],
        upper: [],
        fold: 7817,
        foldFull: [
            7817
        ]
    },
    {
        code: 7818,
        lower: [],
        title: [],
        upper: [],
        fold: 7819,
        foldFull: [
            7819
        ]
    },
    {
        code: 7820,
        lower: [],
        title: [],
        upper: [],
        fold: 7821,
        foldFull: [
            7821
        ]
    },
    {
        code: 7822,
        lower: [],
        title: [],
        upper: [],
        fold: 7823,
        foldFull: [
            7823
        ]
    },
    {
        code: 7824,
        lower: [],
        title: [],
        upper: [],
        fold: 7825,
        foldFull: [
            7825
        ]
    },
    {
        code: 7826,
        lower: [],
        title: [],
        upper: [],
        fold: 7827,
        foldFull: [
            7827
        ]
    },
    {
        code: 7828,
        lower: [],
        title: [],
        upper: [],
        fold: 7829,
        foldFull: [
            7829
        ]
    },
    {
        code: 7830,
        lower: [
            7830
        ],
        title: [
            72,
            817
        ],
        upper: [
            72,
            817
        ],
        fold: 0,
        foldFull: [
            104,
            817
        ]
    },
    {
        code: 7830,
        lower: [
            7830
        ],
        title: [
            72,
            817
        ],
        upper: [
            72,
            817
        ],
        fold: 0,
        foldFull: [
            104,
            817
        ]
    },
    {
        code: 7831,
        lower: [
            7831
        ],
        title: [
            84,
            776
        ],
        upper: [
            84,
            776
        ],
        fold: 0,
        foldFull: [
            116,
            776
        ]
    },
    {
        code: 7831,
        lower: [
            7831
        ],
        title: [
            84,
            776
        ],
        upper: [
            84,
            776
        ],
        fold: 0,
        foldFull: [
            116,
            776
        ]
    },
    {
        code: 7832,
        lower: [
            7832
        ],
        title: [
            87,
            778
        ],
        upper: [
            87,
            778
        ],
        fold: 0,
        foldFull: [
            119,
            778
        ]
    },
    {
        code: 7832,
        lower: [
            7832
        ],
        title: [
            87,
            778
        ],
        upper: [
            87,
            778
        ],
        fold: 0,
        foldFull: [
            119,
            778
        ]
    },
    {
        code: 7833,
        lower: [
            7833
        ],
        title: [
            89,
            778
        ],
        upper: [
            89,
            778
        ],
        fold: 0,
        foldFull: [
            121,
            778
        ]
    },
    {
        code: 7833,
        lower: [
            7833
        ],
        title: [
            89,
            778
        ],
        upper: [
            89,
            778
        ],
        fold: 0,
        foldFull: [
            121,
            778
        ]
    },
    {
        code: 7834,
        lower: [
            7834
        ],
        title: [
            65,
            702
        ],
        upper: [
            65,
            702
        ],
        fold: 0,
        foldFull: [
            97,
            702
        ]
    },
    {
        code: 7834,
        lower: [
            7834
        ],
        title: [
            65,
            702
        ],
        upper: [
            65,
            702
        ],
        fold: 0,
        foldFull: [
            97,
            702
        ]
    },
    {
        code: 7835,
        lower: [],
        title: [],
        upper: [],
        fold: 7777,
        foldFull: [
            7777
        ]
    },
    {
        code: 7838,
        lower: [],
        title: [],
        upper: [],
        fold: 223,
        foldFull: [
            115,
            115
        ]
    },
    {
        code: 7840,
        lower: [],
        title: [],
        upper: [],
        fold: 7841,
        foldFull: [
            7841
        ]
    },
    {
        code: 7842,
        lower: [],
        title: [],
        upper: [],
        fold: 7843,
        foldFull: [
            7843
        ]
    },
    {
        code: 7844,
        lower: [],
        title: [],
        upper: [],
        fold: 7845,
        foldFull: [
            7845
        ]
    },
    {
        code: 7846,
        lower: [],
        title: [],
        upper: [],
        fold: 7847,
        foldFull: [
            7847
        ]
    },
    {
        code: 7848,
        lower: [],
        title: [],
        upper: [],
        fold: 7849,
        foldFull: [
            7849
        ]
    },
    {
        code: 7850,
        lower: [],
        title: [],
        upper: [],
        fold: 7851,
        foldFull: [
            7851
        ]
    },
    {
        code: 7852,
        lower: [],
        title: [],
        upper: [],
        fold: 7853,
        foldFull: [
            7853
        ]
    },
    {
        code: 7854,
        lower: [],
        title: [],
        upper: [],
        fold: 7855,
        foldFull: [
            7855
        ]
    },
    {
        code: 7856,
        lower: [],
        title: [],
        upper: [],
        fold: 7857,
        foldFull: [
            7857
        ]
    },
    {
        code: 7858,
        lower: [],
        title: [],
        upper: [],
        fold: 7859,
        foldFull: [
            7859
        ]
    },
    {
        code: 7860,
        lower: [],
        title: [],
        upper: [],
        fold: 7861,
        foldFull: [
            7861
        ]
    },
    {
        code: 7862,
        lower: [],
        title: [],
        upper: [],
        fold: 7863,
        foldFull: [
            7863
        ]
    },
    {
        code: 7864,
        lower: [],
        title: [],
        upper: [],
        fold: 7865,
        foldFull: [
            7865
        ]
    },
    {
        code: 7866,
        lower: [],
        title: [],
        upper: [],
        fold: 7867,
        foldFull: [
            7867
        ]
    },
    {
        code: 7868,
        lower: [],
        title: [],
        upper: [],
        fold: 7869,
        foldFull: [
            7869
        ]
    },
    {
        code: 7870,
        lower: [],
        title: [],
        upper: [],
        fold: 7871,
        foldFull: [
            7871
        ]
    },
    {
        code: 7872,
        lower: [],
        title: [],
        upper: [],
        fold: 7873,
        foldFull: [
            7873
        ]
    },
    {
        code: 7874,
        lower: [],
        title: [],
        upper: [],
        fold: 7875,
        foldFull: [
            7875
        ]
    },
    {
        code: 7876,
        lower: [],
        title: [],
        upper: [],
        fold: 7877,
        foldFull: [
            7877
        ]
    },
    {
        code: 7878,
        lower: [],
        title: [],
        upper: [],
        fold: 7879,
        foldFull: [
            7879
        ]
    },
    {
        code: 7880,
        lower: [],
        title: [],
        upper: [],
        fold: 7881,
        foldFull: [
            7881
        ]
    },
    {
        code: 7882,
        lower: [],
        title: [],
        upper: [],
        fold: 7883,
        foldFull: [
            7883
        ]
    },
    {
        code: 7884,
        lower: [],
        title: [],
        upper: [],
        fold: 7885,
        foldFull: [
            7885
        ]
    },
    {
        code: 7886,
        lower: [],
        title: [],
        upper: [],
        fold: 7887,
        foldFull: [
            7887
        ]
    },
    {
        code: 7888,
        lower: [],
        title: [],
        upper: [],
        fold: 7889,
        foldFull: [
            7889
        ]
    },
    {
        code: 7890,
        lower: [],
        title: [],
        upper: [],
        fold: 7891,
        foldFull: [
            7891
        ]
    },
    {
        code: 7892,
        lower: [],
        title: [],
        upper: [],
        fold: 7893,
        foldFull: [
            7893
        ]
    },
    {
        code: 7894,
        lower: [],
        title: [],
        upper: [],
        fold: 7895,
        foldFull: [
            7895
        ]
    },
    {
        code: 7896,
        lower: [],
        title: [],
        upper: [],
        fold: 7897,
        foldFull: [
            7897
        ]
    },
    {
        code: 7898,
        lower: [],
        title: [],
        upper: [],
        fold: 7899,
        foldFull: [
            7899
        ]
    },
    {
        code: 7900,
        lower: [],
        title: [],
        upper: [],
        fold: 7901,
        foldFull: [
            7901
        ]
    },
    {
        code: 7902,
        lower: [],
        title: [],
        upper: [],
        fold: 7903,
        foldFull: [
            7903
        ]
    },
    {
        code: 7904,
        lower: [],
        title: [],
        upper: [],
        fold: 7905,
        foldFull: [
            7905
        ]
    },
    {
        code: 7906,
        lower: [],
        title: [],
        upper: [],
        fold: 7907,
        foldFull: [
            7907
        ]
    },
    {
        code: 7908,
        lower: [],
        title: [],
        upper: [],
        fold: 7909,
        foldFull: [
            7909
        ]
    },
    {
        code: 7910,
        lower: [],
        title: [],
        upper: [],
        fold: 7911,
        foldFull: [
            7911
        ]
    },
    {
        code: 7912,
        lower: [],
        title: [],
        upper: [],
        fold: 7913,
        foldFull: [
            7913
        ]
    },
    {
        code: 7914,
        lower: [],
        title: [],
        upper: [],
        fold: 7915,
        foldFull: [
            7915
        ]
    },
    {
        code: 7916,
        lower: [],
        title: [],
        upper: [],
        fold: 7917,
        foldFull: [
            7917
        ]
    },
    {
        code: 7918,
        lower: [],
        title: [],
        upper: [],
        fold: 7919,
        foldFull: [
            7919
        ]
    },
    {
        code: 7920,
        lower: [],
        title: [],
        upper: [],
        fold: 7921,
        foldFull: [
            7921
        ]
    },
    {
        code: 7922,
        lower: [],
        title: [],
        upper: [],
        fold: 7923,
        foldFull: [
            7923
        ]
    },
    {
        code: 7924,
        lower: [],
        title: [],
        upper: [],
        fold: 7925,
        foldFull: [
            7925
        ]
    },
    {
        code: 7926,
        lower: [],
        title: [],
        upper: [],
        fold: 7927,
        foldFull: [
            7927
        ]
    },
    {
        code: 7928,
        lower: [],
        title: [],
        upper: [],
        fold: 7929,
        foldFull: [
            7929
        ]
    },
    {
        code: 7930,
        lower: [],
        title: [],
        upper: [],
        fold: 7931,
        foldFull: [
            7931
        ]
    },
    {
        code: 7932,
        lower: [],
        title: [],
        upper: [],
        fold: 7933,
        foldFull: [
            7933
        ]
    },
    {
        code: 7934,
        lower: [],
        title: [],
        upper: [],
        fold: 7935,
        foldFull: [
            7935
        ]
    },
    {
        code: 7944,
        lower: [],
        title: [],
        upper: [],
        fold: 7936,
        foldFull: [
            7936
        ]
    },
    {
        code: 7945,
        lower: [],
        title: [],
        upper: [],
        fold: 7937,
        foldFull: [
            7937
        ]
    },
    {
        code: 7946,
        lower: [],
        title: [],
        upper: [],
        fold: 7938,
        foldFull: [
            7938
        ]
    },
    {
        code: 7947,
        lower: [],
        title: [],
        upper: [],
        fold: 7939,
        foldFull: [
            7939
        ]
    },
    {
        code: 7948,
        lower: [],
        title: [],
        upper: [],
        fold: 7940,
        foldFull: [
            7940
        ]
    },
    {
        code: 7949,
        lower: [],
        title: [],
        upper: [],
        fold: 7941,
        foldFull: [
            7941
        ]
    },
    {
        code: 7950,
        lower: [],
        title: [],
        upper: [],
        fold: 7942,
        foldFull: [
            7942
        ]
    },
    {
        code: 7951,
        lower: [],
        title: [],
        upper: [],
        fold: 7943,
        foldFull: [
            7943
        ]
    },
    {
        code: 7960,
        lower: [],
        title: [],
        upper: [],
        fold: 7952,
        foldFull: [
            7952
        ]
    },
    {
        code: 7961,
        lower: [],
        title: [],
        upper: [],
        fold: 7953,
        foldFull: [
            7953
        ]
    },
    {
        code: 7962,
        lower: [],
        title: [],
        upper: [],
        fold: 7954,
        foldFull: [
            7954
        ]
    },
    {
        code: 7963,
        lower: [],
        title: [],
        upper: [],
        fold: 7955,
        foldFull: [
            7955
        ]
    },
    {
        code: 7964,
        lower: [],
        title: [],
        upper: [],
        fold: 7956,
        foldFull: [
            7956
        ]
    },
    {
        code: 7965,
        lower: [],
        title: [],
        upper: [],
        fold: 7957,
        foldFull: [
            7957
        ]
    },
    {
        code: 7976,
        lower: [],
        title: [],
        upper: [],
        fold: 7968,
        foldFull: [
            7968
        ]
    },
    {
        code: 7977,
        lower: [],
        title: [],
        upper: [],
        fold: 7969,
        foldFull: [
            7969
        ]
    },
    {
        code: 7978,
        lower: [],
        title: [],
        upper: [],
        fold: 7970,
        foldFull: [
            7970
        ]
    },
    {
        code: 7979,
        lower: [],
        title: [],
        upper: [],
        fold: 7971,
        foldFull: [
            7971
        ]
    },
    {
        code: 7980,
        lower: [],
        title: [],
        upper: [],
        fold: 7972,
        foldFull: [
            7972
        ]
    },
    {
        code: 7981,
        lower: [],
        title: [],
        upper: [],
        fold: 7973,
        foldFull: [
            7973
        ]
    },
    {
        code: 7982,
        lower: [],
        title: [],
        upper: [],
        fold: 7974,
        foldFull: [
            7974
        ]
    },
    {
        code: 7983,
        lower: [],
        title: [],
        upper: [],
        fold: 7975,
        foldFull: [
            7975
        ]
    },
    {
        code: 7992,
        lower: [],
        title: [],
        upper: [],
        fold: 7984,
        foldFull: [
            7984
        ]
    },
    {
        code: 7993,
        lower: [],
        title: [],
        upper: [],
        fold: 7985,
        foldFull: [
            7985
        ]
    },
    {
        code: 7994,
        lower: [],
        title: [],
        upper: [],
        fold: 7986,
        foldFull: [
            7986
        ]
    },
    {
        code: 7995,
        lower: [],
        title: [],
        upper: [],
        fold: 7987,
        foldFull: [
            7987
        ]
    },
    {
        code: 7996,
        lower: [],
        title: [],
        upper: [],
        fold: 7988,
        foldFull: [
            7988
        ]
    },
    {
        code: 7997,
        lower: [],
        title: [],
        upper: [],
        fold: 7989,
        foldFull: [
            7989
        ]
    },
    {
        code: 7998,
        lower: [],
        title: [],
        upper: [],
        fold: 7990,
        foldFull: [
            7990
        ]
    },
    {
        code: 7999,
        lower: [],
        title: [],
        upper: [],
        fold: 7991,
        foldFull: [
            7991
        ]
    },
    {
        code: 8008,
        lower: [],
        title: [],
        upper: [],
        fold: 8000,
        foldFull: [
            8000
        ]
    },
    {
        code: 8009,
        lower: [],
        title: [],
        upper: [],
        fold: 8001,
        foldFull: [
            8001
        ]
    },
    {
        code: 8010,
        lower: [],
        title: [],
        upper: [],
        fold: 8002,
        foldFull: [
            8002
        ]
    },
    {
        code: 8011,
        lower: [],
        title: [],
        upper: [],
        fold: 8003,
        foldFull: [
            8003
        ]
    },
    {
        code: 8012,
        lower: [],
        title: [],
        upper: [],
        fold: 8004,
        foldFull: [
            8004
        ]
    },
    {
        code: 8013,
        lower: [],
        title: [],
        upper: [],
        fold: 8005,
        foldFull: [
            8005
        ]
    },
    {
        code: 8016,
        lower: [
            8016
        ],
        title: [
            933,
            787
        ],
        upper: [
            933,
            787
        ],
        fold: 0,
        foldFull: [
            965,
            787
        ]
    },
    {
        code: 8016,
        lower: [
            8016
        ],
        title: [
            933,
            787
        ],
        upper: [
            933,
            787
        ],
        fold: 0,
        foldFull: [
            965,
            787
        ]
    },
    {
        code: 8018,
        lower: [
            8018
        ],
        title: [
            933,
            787,
            768
        ],
        upper: [
            933,
            787,
            768
        ],
        fold: 0,
        foldFull: [
            965,
            787,
            768
        ]
    },
    {
        code: 8018,
        lower: [
            8018
        ],
        title: [
            933,
            787,
            768
        ],
        upper: [
            933,
            787,
            768
        ],
        fold: 0,
        foldFull: [
            965,
            787,
            768
        ]
    },
    {
        code: 8020,
        lower: [
            8020
        ],
        title: [
            933,
            787,
            769
        ],
        upper: [
            933,
            787,
            769
        ],
        fold: 0,
        foldFull: [
            965,
            787,
            769
        ]
    },
    {
        code: 8020,
        lower: [
            8020
        ],
        title: [
            933,
            787,
            769
        ],
        upper: [
            933,
            787,
            769
        ],
        fold: 0,
        foldFull: [
            965,
            787,
            769
        ]
    },
    {
        code: 8022,
        lower: [
            8022
        ],
        title: [
            933,
            787,
            834
        ],
        upper: [
            933,
            787,
            834
        ],
        fold: 0,
        foldFull: [
            965,
            787,
            834
        ]
    },
    {
        code: 8022,
        lower: [
            8022
        ],
        title: [
            933,
            787,
            834
        ],
        upper: [
            933,
            787,
            834
        ],
        fold: 0,
        foldFull: [
            965,
            787,
            834
        ]
    },
    {
        code: 8025,
        lower: [],
        title: [],
        upper: [],
        fold: 8017,
        foldFull: [
            8017
        ]
    },
    {
        code: 8027,
        lower: [],
        title: [],
        upper: [],
        fold: 8019,
        foldFull: [
            8019
        ]
    },
    {
        code: 8029,
        lower: [],
        title: [],
        upper: [],
        fold: 8021,
        foldFull: [
            8021
        ]
    },
    {
        code: 8031,
        lower: [],
        title: [],
        upper: [],
        fold: 8023,
        foldFull: [
            8023
        ]
    },
    {
        code: 8040,
        lower: [],
        title: [],
        upper: [],
        fold: 8032,
        foldFull: [
            8032
        ]
    },
    {
        code: 8041,
        lower: [],
        title: [],
        upper: [],
        fold: 8033,
        foldFull: [
            8033
        ]
    },
    {
        code: 8042,
        lower: [],
        title: [],
        upper: [],
        fold: 8034,
        foldFull: [
            8034
        ]
    },
    {
        code: 8043,
        lower: [],
        title: [],
        upper: [],
        fold: 8035,
        foldFull: [
            8035
        ]
    },
    {
        code: 8044,
        lower: [],
        title: [],
        upper: [],
        fold: 8036,
        foldFull: [
            8036
        ]
    },
    {
        code: 8045,
        lower: [],
        title: [],
        upper: [],
        fold: 8037,
        foldFull: [
            8037
        ]
    },
    {
        code: 8046,
        lower: [],
        title: [],
        upper: [],
        fold: 8038,
        foldFull: [
            8038
        ]
    },
    {
        code: 8047,
        lower: [],
        title: [],
        upper: [],
        fold: 8039,
        foldFull: [
            8039
        ]
    },
    {
        code: 8064,
        lower: [
            8064
        ],
        title: [
            8072
        ],
        upper: [
            7944,
            921
        ],
        fold: 0,
        foldFull: [
            7936,
            953
        ]
    },
    {
        code: 8064,
        lower: [
            8064
        ],
        title: [
            8072
        ],
        upper: [
            7944,
            921
        ],
        fold: 0,
        foldFull: [
            7936,
            953
        ]
    },
    {
        code: 8065,
        lower: [
            8065
        ],
        title: [
            8073
        ],
        upper: [
            7945,
            921
        ],
        fold: 0,
        foldFull: [
            7937,
            953
        ]
    },
    {
        code: 8065,
        lower: [
            8065
        ],
        title: [
            8073
        ],
        upper: [
            7945,
            921
        ],
        fold: 0,
        foldFull: [
            7937,
            953
        ]
    },
    {
        code: 8066,
        lower: [
            8066
        ],
        title: [
            8074
        ],
        upper: [
            7946,
            921
        ],
        fold: 0,
        foldFull: [
            7938,
            953
        ]
    },
    {
        code: 8066,
        lower: [
            8066
        ],
        title: [
            8074
        ],
        upper: [
            7946,
            921
        ],
        fold: 0,
        foldFull: [
            7938,
            953
        ]
    },
    {
        code: 8067,
        lower: [
            8067
        ],
        title: [
            8075
        ],
        upper: [
            7947,
            921
        ],
        fold: 0,
        foldFull: [
            7939,
            953
        ]
    },
    {
        code: 8067,
        lower: [
            8067
        ],
        title: [
            8075
        ],
        upper: [
            7947,
            921
        ],
        fold: 0,
        foldFull: [
            7939,
            953
        ]
    },
    {
        code: 8068,
        lower: [
            8068
        ],
        title: [
            8076
        ],
        upper: [
            7948,
            921
        ],
        fold: 0,
        foldFull: [
            7940,
            953
        ]
    },
    {
        code: 8068,
        lower: [
            8068
        ],
        title: [
            8076
        ],
        upper: [
            7948,
            921
        ],
        fold: 0,
        foldFull: [
            7940,
            953
        ]
    },
    {
        code: 8069,
        lower: [
            8069
        ],
        title: [
            8077
        ],
        upper: [
            7949,
            921
        ],
        fold: 0,
        foldFull: [
            7941,
            953
        ]
    },
    {
        code: 8069,
        lower: [
            8069
        ],
        title: [
            8077
        ],
        upper: [
            7949,
            921
        ],
        fold: 0,
        foldFull: [
            7941,
            953
        ]
    },
    {
        code: 8070,
        lower: [
            8070
        ],
        title: [
            8078
        ],
        upper: [
            7950,
            921
        ],
        fold: 0,
        foldFull: [
            7942,
            953
        ]
    },
    {
        code: 8070,
        lower: [
            8070
        ],
        title: [
            8078
        ],
        upper: [
            7950,
            921
        ],
        fold: 0,
        foldFull: [
            7942,
            953
        ]
    },
    {
        code: 8071,
        lower: [
            8071
        ],
        title: [
            8079
        ],
        upper: [
            7951,
            921
        ],
        fold: 0,
        foldFull: [
            7943,
            953
        ]
    },
    {
        code: 8071,
        lower: [
            8071
        ],
        title: [
            8079
        ],
        upper: [
            7951,
            921
        ],
        fold: 0,
        foldFull: [
            7943,
            953
        ]
    },
    {
        code: 8072,
        lower: [
            8064
        ],
        title: [
            8072
        ],
        upper: [
            7944,
            921
        ],
        fold: 8064,
        foldFull: [
            7936,
            953
        ]
    },
    {
        code: 8072,
        lower: [
            8064
        ],
        title: [
            8072
        ],
        upper: [
            7944,
            921
        ],
        fold: 8064,
        foldFull: [
            7936,
            953
        ]
    },
    {
        code: 8073,
        lower: [
            8065
        ],
        title: [
            8073
        ],
        upper: [
            7945,
            921
        ],
        fold: 8065,
        foldFull: [
            7937,
            953
        ]
    },
    {
        code: 8073,
        lower: [
            8065
        ],
        title: [
            8073
        ],
        upper: [
            7945,
            921
        ],
        fold: 8065,
        foldFull: [
            7937,
            953
        ]
    },
    {
        code: 8074,
        lower: [
            8066
        ],
        title: [
            8074
        ],
        upper: [
            7946,
            921
        ],
        fold: 8066,
        foldFull: [
            7938,
            953
        ]
    },
    {
        code: 8074,
        lower: [
            8066
        ],
        title: [
            8074
        ],
        upper: [
            7946,
            921
        ],
        fold: 8066,
        foldFull: [
            7938,
            953
        ]
    },
    {
        code: 8075,
        lower: [
            8067
        ],
        title: [
            8075
        ],
        upper: [
            7947,
            921
        ],
        fold: 8067,
        foldFull: [
            7939,
            953
        ]
    },
    {
        code: 8075,
        lower: [
            8067
        ],
        title: [
            8075
        ],
        upper: [
            7947,
            921
        ],
        fold: 8067,
        foldFull: [
            7939,
            953
        ]
    },
    {
        code: 8076,
        lower: [
            8068
        ],
        title: [
            8076
        ],
        upper: [
            7948,
            921
        ],
        fold: 8068,
        foldFull: [
            7940,
            953
        ]
    },
    {
        code: 8076,
        lower: [
            8068
        ],
        title: [
            8076
        ],
        upper: [
            7948,
            921
        ],
        fold: 8068,
        foldFull: [
            7940,
            953
        ]
    },
    {
        code: 8077,
        lower: [
            8069
        ],
        title: [
            8077
        ],
        upper: [
            7949,
            921
        ],
        fold: 8069,
        foldFull: [
            7941,
            953
        ]
    },
    {
        code: 8077,
        lower: [
            8069
        ],
        title: [
            8077
        ],
        upper: [
            7949,
            921
        ],
        fold: 8069,
        foldFull: [
            7941,
            953
        ]
    },
    {
        code: 8078,
        lower: [
            8070
        ],
        title: [
            8078
        ],
        upper: [
            7950,
            921
        ],
        fold: 8070,
        foldFull: [
            7942,
            953
        ]
    },
    {
        code: 8078,
        lower: [
            8070
        ],
        title: [
            8078
        ],
        upper: [
            7950,
            921
        ],
        fold: 8070,
        foldFull: [
            7942,
            953
        ]
    },
    {
        code: 8079,
        lower: [
            8071
        ],
        title: [
            8079
        ],
        upper: [
            7951,
            921
        ],
        fold: 8071,
        foldFull: [
            7943,
            953
        ]
    },
    {
        code: 8079,
        lower: [
            8071
        ],
        title: [
            8079
        ],
        upper: [
            7951,
            921
        ],
        fold: 8071,
        foldFull: [
            7943,
            953
        ]
    },
    {
        code: 8080,
        lower: [
            8080
        ],
        title: [
            8088
        ],
        upper: [
            7976,
            921
        ],
        fold: 0,
        foldFull: [
            7968,
            953
        ]
    },
    {
        code: 8080,
        lower: [
            8080
        ],
        title: [
            8088
        ],
        upper: [
            7976,
            921
        ],
        fold: 0,
        foldFull: [
            7968,
            953
        ]
    },
    {
        code: 8081,
        lower: [
            8081
        ],
        title: [
            8089
        ],
        upper: [
            7977,
            921
        ],
        fold: 0,
        foldFull: [
            7969,
            953
        ]
    },
    {
        code: 8081,
        lower: [
            8081
        ],
        title: [
            8089
        ],
        upper: [
            7977,
            921
        ],
        fold: 0,
        foldFull: [
            7969,
            953
        ]
    },
    {
        code: 8082,
        lower: [
            8082
        ],
        title: [
            8090
        ],
        upper: [
            7978,
            921
        ],
        fold: 0,
        foldFull: [
            7970,
            953
        ]
    },
    {
        code: 8082,
        lower: [
            8082
        ],
        title: [
            8090
        ],
        upper: [
            7978,
            921
        ],
        fold: 0,
        foldFull: [
            7970,
            953
        ]
    },
    {
        code: 8083,
        lower: [
            8083
        ],
        title: [
            8091
        ],
        upper: [
            7979,
            921
        ],
        fold: 0,
        foldFull: [
            7971,
            953
        ]
    },
    {
        code: 8083,
        lower: [
            8083
        ],
        title: [
            8091
        ],
        upper: [
            7979,
            921
        ],
        fold: 0,
        foldFull: [
            7971,
            953
        ]
    },
    {
        code: 8084,
        lower: [
            8084
        ],
        title: [
            8092
        ],
        upper: [
            7980,
            921
        ],
        fold: 0,
        foldFull: [
            7972,
            953
        ]
    },
    {
        code: 8084,
        lower: [
            8084
        ],
        title: [
            8092
        ],
        upper: [
            7980,
            921
        ],
        fold: 0,
        foldFull: [
            7972,
            953
        ]
    },
    {
        code: 8085,
        lower: [
            8085
        ],
        title: [
            8093
        ],
        upper: [
            7981,
            921
        ],
        fold: 0,
        foldFull: [
            7973,
            953
        ]
    },
    {
        code: 8085,
        lower: [
            8085
        ],
        title: [
            8093
        ],
        upper: [
            7981,
            921
        ],
        fold: 0,
        foldFull: [
            7973,
            953
        ]
    },
    {
        code: 8086,
        lower: [
            8086
        ],
        title: [
            8094
        ],
        upper: [
            7982,
            921
        ],
        fold: 0,
        foldFull: [
            7974,
            953
        ]
    },
    {
        code: 8086,
        lower: [
            8086
        ],
        title: [
            8094
        ],
        upper: [
            7982,
            921
        ],
        fold: 0,
        foldFull: [
            7974,
            953
        ]
    },
    {
        code: 8087,
        lower: [
            8087
        ],
        title: [
            8095
        ],
        upper: [
            7983,
            921
        ],
        fold: 0,
        foldFull: [
            7975,
            953
        ]
    },
    {
        code: 8087,
        lower: [
            8087
        ],
        title: [
            8095
        ],
        upper: [
            7983,
            921
        ],
        fold: 0,
        foldFull: [
            7975,
            953
        ]
    },
    {
        code: 8088,
        lower: [
            8080
        ],
        title: [
            8088
        ],
        upper: [
            7976,
            921
        ],
        fold: 8080,
        foldFull: [
            7968,
            953
        ]
    },
    {
        code: 8088,
        lower: [
            8080
        ],
        title: [
            8088
        ],
        upper: [
            7976,
            921
        ],
        fold: 8080,
        foldFull: [
            7968,
            953
        ]
    },
    {
        code: 8089,
        lower: [
            8081
        ],
        title: [
            8089
        ],
        upper: [
            7977,
            921
        ],
        fold: 8081,
        foldFull: [
            7969,
            953
        ]
    },
    {
        code: 8089,
        lower: [
            8081
        ],
        title: [
            8089
        ],
        upper: [
            7977,
            921
        ],
        fold: 8081,
        foldFull: [
            7969,
            953
        ]
    },
    {
        code: 8090,
        lower: [
            8082
        ],
        title: [
            8090
        ],
        upper: [
            7978,
            921
        ],
        fold: 8082,
        foldFull: [
            7970,
            953
        ]
    },
    {
        code: 8090,
        lower: [
            8082
        ],
        title: [
            8090
        ],
        upper: [
            7978,
            921
        ],
        fold: 8082,
        foldFull: [
            7970,
            953
        ]
    },
    {
        code: 8091,
        lower: [
            8083
        ],
        title: [
            8091
        ],
        upper: [
            7979,
            921
        ],
        fold: 8083,
        foldFull: [
            7971,
            953
        ]
    },
    {
        code: 8091,
        lower: [
            8083
        ],
        title: [
            8091
        ],
        upper: [
            7979,
            921
        ],
        fold: 8083,
        foldFull: [
            7971,
            953
        ]
    },
    {
        code: 8092,
        lower: [
            8084
        ],
        title: [
            8092
        ],
        upper: [
            7980,
            921
        ],
        fold: 8084,
        foldFull: [
            7972,
            953
        ]
    },
    {
        code: 8092,
        lower: [
            8084
        ],
        title: [
            8092
        ],
        upper: [
            7980,
            921
        ],
        fold: 8084,
        foldFull: [
            7972,
            953
        ]
    },
    {
        code: 8093,
        lower: [
            8085
        ],
        title: [
            8093
        ],
        upper: [
            7981,
            921
        ],
        fold: 8085,
        foldFull: [
            7973,
            953
        ]
    },
    {
        code: 8093,
        lower: [
            8085
        ],
        title: [
            8093
        ],
        upper: [
            7981,
            921
        ],
        fold: 8085,
        foldFull: [
            7973,
            953
        ]
    },
    {
        code: 8094,
        lower: [
            8086
        ],
        title: [
            8094
        ],
        upper: [
            7982,
            921
        ],
        fold: 8086,
        foldFull: [
            7974,
            953
        ]
    },
    {
        code: 8094,
        lower: [
            8086
        ],
        title: [
            8094
        ],
        upper: [
            7982,
            921
        ],
        fold: 8086,
        foldFull: [
            7974,
            953
        ]
    },
    {
        code: 8095,
        lower: [
            8087
        ],
        title: [
            8095
        ],
        upper: [
            7983,
            921
        ],
        fold: 8087,
        foldFull: [
            7975,
            953
        ]
    },
    {
        code: 8095,
        lower: [
            8087
        ],
        title: [
            8095
        ],
        upper: [
            7983,
            921
        ],
        fold: 8087,
        foldFull: [
            7975,
            953
        ]
    },
    {
        code: 8096,
        lower: [
            8096
        ],
        title: [
            8104
        ],
        upper: [
            8040,
            921
        ],
        fold: 0,
        foldFull: [
            8032,
            953
        ]
    },
    {
        code: 8096,
        lower: [
            8096
        ],
        title: [
            8104
        ],
        upper: [
            8040,
            921
        ],
        fold: 0,
        foldFull: [
            8032,
            953
        ]
    },
    {
        code: 8097,
        lower: [
            8097
        ],
        title: [
            8105
        ],
        upper: [
            8041,
            921
        ],
        fold: 0,
        foldFull: [
            8033,
            953
        ]
    },
    {
        code: 8097,
        lower: [
            8097
        ],
        title: [
            8105
        ],
        upper: [
            8041,
            921
        ],
        fold: 0,
        foldFull: [
            8033,
            953
        ]
    },
    {
        code: 8098,
        lower: [
            8098
        ],
        title: [
            8106
        ],
        upper: [
            8042,
            921
        ],
        fold: 0,
        foldFull: [
            8034,
            953
        ]
    },
    {
        code: 8098,
        lower: [
            8098
        ],
        title: [
            8106
        ],
        upper: [
            8042,
            921
        ],
        fold: 0,
        foldFull: [
            8034,
            953
        ]
    },
    {
        code: 8099,
        lower: [
            8099
        ],
        title: [
            8107
        ],
        upper: [
            8043,
            921
        ],
        fold: 0,
        foldFull: [
            8035,
            953
        ]
    },
    {
        code: 8099,
        lower: [
            8099
        ],
        title: [
            8107
        ],
        upper: [
            8043,
            921
        ],
        fold: 0,
        foldFull: [
            8035,
            953
        ]
    },
    {
        code: 8100,
        lower: [
            8100
        ],
        title: [
            8108
        ],
        upper: [
            8044,
            921
        ],
        fold: 0,
        foldFull: [
            8036,
            953
        ]
    },
    {
        code: 8100,
        lower: [
            8100
        ],
        title: [
            8108
        ],
        upper: [
            8044,
            921
        ],
        fold: 0,
        foldFull: [
            8036,
            953
        ]
    },
    {
        code: 8101,
        lower: [
            8101
        ],
        title: [
            8109
        ],
        upper: [
            8045,
            921
        ],
        fold: 0,
        foldFull: [
            8037,
            953
        ]
    },
    {
        code: 8101,
        lower: [
            8101
        ],
        title: [
            8109
        ],
        upper: [
            8045,
            921
        ],
        fold: 0,
        foldFull: [
            8037,
            953
        ]
    },
    {
        code: 8102,
        lower: [
            8102
        ],
        title: [
            8110
        ],
        upper: [
            8046,
            921
        ],
        fold: 0,
        foldFull: [
            8038,
            953
        ]
    },
    {
        code: 8102,
        lower: [
            8102
        ],
        title: [
            8110
        ],
        upper: [
            8046,
            921
        ],
        fold: 0,
        foldFull: [
            8038,
            953
        ]
    },
    {
        code: 8103,
        lower: [
            8103
        ],
        title: [
            8111
        ],
        upper: [
            8047,
            921
        ],
        fold: 0,
        foldFull: [
            8039,
            953
        ]
    },
    {
        code: 8103,
        lower: [
            8103
        ],
        title: [
            8111
        ],
        upper: [
            8047,
            921
        ],
        fold: 0,
        foldFull: [
            8039,
            953
        ]
    },
    {
        code: 8104,
        lower: [
            8096
        ],
        title: [
            8104
        ],
        upper: [
            8040,
            921
        ],
        fold: 8096,
        foldFull: [
            8032,
            953
        ]
    },
    {
        code: 8104,
        lower: [
            8096
        ],
        title: [
            8104
        ],
        upper: [
            8040,
            921
        ],
        fold: 8096,
        foldFull: [
            8032,
            953
        ]
    },
    {
        code: 8105,
        lower: [
            8097
        ],
        title: [
            8105
        ],
        upper: [
            8041,
            921
        ],
        fold: 8097,
        foldFull: [
            8033,
            953
        ]
    },
    {
        code: 8105,
        lower: [
            8097
        ],
        title: [
            8105
        ],
        upper: [
            8041,
            921
        ],
        fold: 8097,
        foldFull: [
            8033,
            953
        ]
    },
    {
        code: 8106,
        lower: [
            8098
        ],
        title: [
            8106
        ],
        upper: [
            8042,
            921
        ],
        fold: 8098,
        foldFull: [
            8034,
            953
        ]
    },
    {
        code: 8106,
        lower: [
            8098
        ],
        title: [
            8106
        ],
        upper: [
            8042,
            921
        ],
        fold: 8098,
        foldFull: [
            8034,
            953
        ]
    },
    {
        code: 8107,
        lower: [
            8099
        ],
        title: [
            8107
        ],
        upper: [
            8043,
            921
        ],
        fold: 8099,
        foldFull: [
            8035,
            953
        ]
    },
    {
        code: 8107,
        lower: [
            8099
        ],
        title: [
            8107
        ],
        upper: [
            8043,
            921
        ],
        fold: 8099,
        foldFull: [
            8035,
            953
        ]
    },
    {
        code: 8108,
        lower: [
            8100
        ],
        title: [
            8108
        ],
        upper: [
            8044,
            921
        ],
        fold: 8100,
        foldFull: [
            8036,
            953
        ]
    },
    {
        code: 8108,
        lower: [
            8100
        ],
        title: [
            8108
        ],
        upper: [
            8044,
            921
        ],
        fold: 8100,
        foldFull: [
            8036,
            953
        ]
    },
    {
        code: 8109,
        lower: [
            8101
        ],
        title: [
            8109
        ],
        upper: [
            8045,
            921
        ],
        fold: 8101,
        foldFull: [
            8037,
            953
        ]
    },
    {
        code: 8109,
        lower: [
            8101
        ],
        title: [
            8109
        ],
        upper: [
            8045,
            921
        ],
        fold: 8101,
        foldFull: [
            8037,
            953
        ]
    },
    {
        code: 8110,
        lower: [
            8102
        ],
        title: [
            8110
        ],
        upper: [
            8046,
            921
        ],
        fold: 8102,
        foldFull: [
            8038,
            953
        ]
    },
    {
        code: 8110,
        lower: [
            8102
        ],
        title: [
            8110
        ],
        upper: [
            8046,
            921
        ],
        fold: 8102,
        foldFull: [
            8038,
            953
        ]
    },
    {
        code: 8111,
        lower: [
            8103
        ],
        title: [
            8111
        ],
        upper: [
            8047,
            921
        ],
        fold: 8103,
        foldFull: [
            8039,
            953
        ]
    },
    {
        code: 8111,
        lower: [
            8103
        ],
        title: [
            8111
        ],
        upper: [
            8047,
            921
        ],
        fold: 8103,
        foldFull: [
            8039,
            953
        ]
    },
    {
        code: 8114,
        lower: [
            8114
        ],
        title: [
            8122,
            837
        ],
        upper: [
            8122,
            921
        ],
        fold: 0,
        foldFull: [
            8048,
            953
        ]
    },
    {
        code: 8114,
        lower: [
            8114
        ],
        title: [
            8122,
            837
        ],
        upper: [
            8122,
            921
        ],
        fold: 0,
        foldFull: [
            8048,
            953
        ]
    },
    {
        code: 8115,
        lower: [
            8115
        ],
        title: [
            8124
        ],
        upper: [
            913,
            921
        ],
        fold: 0,
        foldFull: [
            945,
            953
        ]
    },
    {
        code: 8115,
        lower: [
            8115
        ],
        title: [
            8124
        ],
        upper: [
            913,
            921
        ],
        fold: 0,
        foldFull: [
            945,
            953
        ]
    },
    {
        code: 8116,
        lower: [
            8116
        ],
        title: [
            902,
            837
        ],
        upper: [
            902,
            921
        ],
        fold: 0,
        foldFull: [
            940,
            953
        ]
    },
    {
        code: 8116,
        lower: [
            8116
        ],
        title: [
            902,
            837
        ],
        upper: [
            902,
            921
        ],
        fold: 0,
        foldFull: [
            940,
            953
        ]
    },
    {
        code: 8118,
        lower: [
            8118
        ],
        title: [
            913,
            834
        ],
        upper: [
            913,
            834
        ],
        fold: 0,
        foldFull: [
            945,
            834
        ]
    },
    {
        code: 8118,
        lower: [
            8118
        ],
        title: [
            913,
            834
        ],
        upper: [
            913,
            834
        ],
        fold: 0,
        foldFull: [
            945,
            834
        ]
    },
    {
        code: 8119,
        lower: [
            8119
        ],
        title: [
            913,
            834,
            837
        ],
        upper: [
            913,
            834,
            921
        ],
        fold: 0,
        foldFull: [
            945,
            834,
            953
        ]
    },
    {
        code: 8119,
        lower: [
            8119
        ],
        title: [
            913,
            834,
            837
        ],
        upper: [
            913,
            834,
            921
        ],
        fold: 0,
        foldFull: [
            945,
            834,
            953
        ]
    },
    {
        code: 8120,
        lower: [],
        title: [],
        upper: [],
        fold: 8112,
        foldFull: [
            8112
        ]
    },
    {
        code: 8121,
        lower: [],
        title: [],
        upper: [],
        fold: 8113,
        foldFull: [
            8113
        ]
    },
    {
        code: 8122,
        lower: [],
        title: [],
        upper: [],
        fold: 8048,
        foldFull: [
            8048
        ]
    },
    {
        code: 8123,
        lower: [],
        title: [],
        upper: [],
        fold: 8049,
        foldFull: [
            8049
        ]
    },
    {
        code: 8124,
        lower: [
            8115
        ],
        title: [
            8124
        ],
        upper: [
            913,
            921
        ],
        fold: 8115,
        foldFull: [
            945,
            953
        ]
    },
    {
        code: 8124,
        lower: [
            8115
        ],
        title: [
            8124
        ],
        upper: [
            913,
            921
        ],
        fold: 8115,
        foldFull: [
            945,
            953
        ]
    },
    {
        code: 8126,
        lower: [],
        title: [],
        upper: [],
        fold: 953,
        foldFull: [
            953
        ]
    },
    {
        code: 8130,
        lower: [
            8130
        ],
        title: [
            8138,
            837
        ],
        upper: [
            8138,
            921
        ],
        fold: 0,
        foldFull: [
            8052,
            953
        ]
    },
    {
        code: 8130,
        lower: [
            8130
        ],
        title: [
            8138,
            837
        ],
        upper: [
            8138,
            921
        ],
        fold: 0,
        foldFull: [
            8052,
            953
        ]
    },
    {
        code: 8131,
        lower: [
            8131
        ],
        title: [
            8140
        ],
        upper: [
            919,
            921
        ],
        fold: 0,
        foldFull: [
            951,
            953
        ]
    },
    {
        code: 8131,
        lower: [
            8131
        ],
        title: [
            8140
        ],
        upper: [
            919,
            921
        ],
        fold: 0,
        foldFull: [
            951,
            953
        ]
    },
    {
        code: 8132,
        lower: [
            8132
        ],
        title: [
            905,
            837
        ],
        upper: [
            905,
            921
        ],
        fold: 0,
        foldFull: [
            942,
            953
        ]
    },
    {
        code: 8132,
        lower: [
            8132
        ],
        title: [
            905,
            837
        ],
        upper: [
            905,
            921
        ],
        fold: 0,
        foldFull: [
            942,
            953
        ]
    },
    {
        code: 8134,
        lower: [
            8134
        ],
        title: [
            919,
            834
        ],
        upper: [
            919,
            834
        ],
        fold: 0,
        foldFull: [
            951,
            834
        ]
    },
    {
        code: 8134,
        lower: [
            8134
        ],
        title: [
            919,
            834
        ],
        upper: [
            919,
            834
        ],
        fold: 0,
        foldFull: [
            951,
            834
        ]
    },
    {
        code: 8135,
        lower: [
            8135
        ],
        title: [
            919,
            834,
            837
        ],
        upper: [
            919,
            834,
            921
        ],
        fold: 0,
        foldFull: [
            951,
            834,
            953
        ]
    },
    {
        code: 8135,
        lower: [
            8135
        ],
        title: [
            919,
            834,
            837
        ],
        upper: [
            919,
            834,
            921
        ],
        fold: 0,
        foldFull: [
            951,
            834,
            953
        ]
    },
    {
        code: 8136,
        lower: [],
        title: [],
        upper: [],
        fold: 8050,
        foldFull: [
            8050
        ]
    },
    {
        code: 8137,
        lower: [],
        title: [],
        upper: [],
        fold: 8051,
        foldFull: [
            8051
        ]
    },
    {
        code: 8138,
        lower: [],
        title: [],
        upper: [],
        fold: 8052,
        foldFull: [
            8052
        ]
    },
    {
        code: 8139,
        lower: [],
        title: [],
        upper: [],
        fold: 8053,
        foldFull: [
            8053
        ]
    },
    {
        code: 8140,
        lower: [
            8131
        ],
        title: [
            8140
        ],
        upper: [
            919,
            921
        ],
        fold: 8131,
        foldFull: [
            951,
            953
        ]
    },
    {
        code: 8140,
        lower: [
            8131
        ],
        title: [
            8140
        ],
        upper: [
            919,
            921
        ],
        fold: 8131,
        foldFull: [
            951,
            953
        ]
    },
    {
        code: 8146,
        lower: [
            8146
        ],
        title: [
            921,
            776,
            768
        ],
        upper: [
            921,
            776,
            768
        ],
        fold: 0,
        foldFull: [
            953,
            776,
            768
        ]
    },
    {
        code: 8146,
        lower: [
            8146
        ],
        title: [
            921,
            776,
            768
        ],
        upper: [
            921,
            776,
            768
        ],
        fold: 0,
        foldFull: [
            953,
            776,
            768
        ]
    },
    {
        code: 8147,
        lower: [
            8147
        ],
        title: [
            921,
            776,
            769
        ],
        upper: [
            921,
            776,
            769
        ],
        fold: 0,
        foldFull: [
            953,
            776,
            769
        ]
    },
    {
        code: 8147,
        lower: [
            8147
        ],
        title: [
            921,
            776,
            769
        ],
        upper: [
            921,
            776,
            769
        ],
        fold: 0,
        foldFull: [
            953,
            776,
            769
        ]
    },
    {
        code: 8150,
        lower: [
            8150
        ],
        title: [
            921,
            834
        ],
        upper: [
            921,
            834
        ],
        fold: 0,
        foldFull: [
            953,
            834
        ]
    },
    {
        code: 8150,
        lower: [
            8150
        ],
        title: [
            921,
            834
        ],
        upper: [
            921,
            834
        ],
        fold: 0,
        foldFull: [
            953,
            834
        ]
    },
    {
        code: 8151,
        lower: [
            8151
        ],
        title: [
            921,
            776,
            834
        ],
        upper: [
            921,
            776,
            834
        ],
        fold: 0,
        foldFull: [
            953,
            776,
            834
        ]
    },
    {
        code: 8151,
        lower: [
            8151
        ],
        title: [
            921,
            776,
            834
        ],
        upper: [
            921,
            776,
            834
        ],
        fold: 0,
        foldFull: [
            953,
            776,
            834
        ]
    },
    {
        code: 8152,
        lower: [],
        title: [],
        upper: [],
        fold: 8144,
        foldFull: [
            8144
        ]
    },
    {
        code: 8153,
        lower: [],
        title: [],
        upper: [],
        fold: 8145,
        foldFull: [
            8145
        ]
    },
    {
        code: 8154,
        lower: [],
        title: [],
        upper: [],
        fold: 8054,
        foldFull: [
            8054
        ]
    },
    {
        code: 8155,
        lower: [],
        title: [],
        upper: [],
        fold: 8055,
        foldFull: [
            8055
        ]
    },
    {
        code: 8162,
        lower: [
            8162
        ],
        title: [
            933,
            776,
            768
        ],
        upper: [
            933,
            776,
            768
        ],
        fold: 0,
        foldFull: [
            965,
            776,
            768
        ]
    },
    {
        code: 8162,
        lower: [
            8162
        ],
        title: [
            933,
            776,
            768
        ],
        upper: [
            933,
            776,
            768
        ],
        fold: 0,
        foldFull: [
            965,
            776,
            768
        ]
    },
    {
        code: 8163,
        lower: [
            8163
        ],
        title: [
            933,
            776,
            769
        ],
        upper: [
            933,
            776,
            769
        ],
        fold: 0,
        foldFull: [
            965,
            776,
            769
        ]
    },
    {
        code: 8163,
        lower: [
            8163
        ],
        title: [
            933,
            776,
            769
        ],
        upper: [
            933,
            776,
            769
        ],
        fold: 0,
        foldFull: [
            965,
            776,
            769
        ]
    },
    {
        code: 8164,
        lower: [
            8164
        ],
        title: [
            929,
            787
        ],
        upper: [
            929,
            787
        ],
        fold: 0,
        foldFull: [
            961,
            787
        ]
    },
    {
        code: 8164,
        lower: [
            8164
        ],
        title: [
            929,
            787
        ],
        upper: [
            929,
            787
        ],
        fold: 0,
        foldFull: [
            961,
            787
        ]
    },
    {
        code: 8166,
        lower: [
            8166
        ],
        title: [
            933,
            834
        ],
        upper: [
            933,
            834
        ],
        fold: 0,
        foldFull: [
            965,
            834
        ]
    },
    {
        code: 8166,
        lower: [
            8166
        ],
        title: [
            933,
            834
        ],
        upper: [
            933,
            834
        ],
        fold: 0,
        foldFull: [
            965,
            834
        ]
    },
    {
        code: 8167,
        lower: [
            8167
        ],
        title: [
            933,
            776,
            834
        ],
        upper: [
            933,
            776,
            834
        ],
        fold: 0,
        foldFull: [
            965,
            776,
            834
        ]
    },
    {
        code: 8167,
        lower: [
            8167
        ],
        title: [
            933,
            776,
            834
        ],
        upper: [
            933,
            776,
            834
        ],
        fold: 0,
        foldFull: [
            965,
            776,
            834
        ]
    },
    {
        code: 8168,
        lower: [],
        title: [],
        upper: [],
        fold: 8160,
        foldFull: [
            8160
        ]
    },
    {
        code: 8169,
        lower: [],
        title: [],
        upper: [],
        fold: 8161,
        foldFull: [
            8161
        ]
    },
    {
        code: 8170,
        lower: [],
        title: [],
        upper: [],
        fold: 8058,
        foldFull: [
            8058
        ]
    },
    {
        code: 8171,
        lower: [],
        title: [],
        upper: [],
        fold: 8059,
        foldFull: [
            8059
        ]
    },
    {
        code: 8172,
        lower: [],
        title: [],
        upper: [],
        fold: 8165,
        foldFull: [
            8165
        ]
    },
    {
        code: 8178,
        lower: [
            8178
        ],
        title: [
            8186,
            837
        ],
        upper: [
            8186,
            921
        ],
        fold: 0,
        foldFull: [
            8060,
            953
        ]
    },
    {
        code: 8178,
        lower: [
            8178
        ],
        title: [
            8186,
            837
        ],
        upper: [
            8186,
            921
        ],
        fold: 0,
        foldFull: [
            8060,
            953
        ]
    },
    {
        code: 8179,
        lower: [
            8179
        ],
        title: [
            8188
        ],
        upper: [
            937,
            921
        ],
        fold: 0,
        foldFull: [
            969,
            953
        ]
    },
    {
        code: 8179,
        lower: [
            8179
        ],
        title: [
            8188
        ],
        upper: [
            937,
            921
        ],
        fold: 0,
        foldFull: [
            969,
            953
        ]
    },
    {
        code: 8180,
        lower: [
            8180
        ],
        title: [
            911,
            837
        ],
        upper: [
            911,
            921
        ],
        fold: 0,
        foldFull: [
            974,
            953
        ]
    },
    {
        code: 8180,
        lower: [
            8180
        ],
        title: [
            911,
            837
        ],
        upper: [
            911,
            921
        ],
        fold: 0,
        foldFull: [
            974,
            953
        ]
    },
    {
        code: 8182,
        lower: [
            8182
        ],
        title: [
            937,
            834
        ],
        upper: [
            937,
            834
        ],
        fold: 0,
        foldFull: [
            969,
            834
        ]
    },
    {
        code: 8182,
        lower: [
            8182
        ],
        title: [
            937,
            834
        ],
        upper: [
            937,
            834
        ],
        fold: 0,
        foldFull: [
            969,
            834
        ]
    },
    {
        code: 8183,
        lower: [
            8183
        ],
        title: [
            937,
            834,
            837
        ],
        upper: [
            937,
            834,
            921
        ],
        fold: 0,
        foldFull: [
            969,
            834,
            953
        ]
    },
    {
        code: 8183,
        lower: [
            8183
        ],
        title: [
            937,
            834,
            837
        ],
        upper: [
            937,
            834,
            921
        ],
        fold: 0,
        foldFull: [
            969,
            834,
            953
        ]
    },
    {
        code: 8184,
        lower: [],
        title: [],
        upper: [],
        fold: 8056,
        foldFull: [
            8056
        ]
    },
    {
        code: 8185,
        lower: [],
        title: [],
        upper: [],
        fold: 8057,
        foldFull: [
            8057
        ]
    },
    {
        code: 8186,
        lower: [],
        title: [],
        upper: [],
        fold: 8060,
        foldFull: [
            8060
        ]
    },
    {
        code: 8187,
        lower: [],
        title: [],
        upper: [],
        fold: 8061,
        foldFull: [
            8061
        ]
    },
    {
        code: 8188,
        lower: [
            8179
        ],
        title: [
            8188
        ],
        upper: [
            937,
            921
        ],
        fold: 8179,
        foldFull: [
            969,
            953
        ]
    },
    {
        code: 8188,
        lower: [
            8179
        ],
        title: [
            8188
        ],
        upper: [
            937,
            921
        ],
        fold: 8179,
        foldFull: [
            969,
            953
        ]
    },
    {
        code: 8486,
        lower: [],
        title: [],
        upper: [],
        fold: 969,
        foldFull: [
            969
        ]
    },
    {
        code: 8490,
        lower: [],
        title: [],
        upper: [],
        fold: 107,
        foldFull: [
            107
        ]
    },
    {
        code: 8491,
        lower: [],
        title: [],
        upper: [],
        fold: 229,
        foldFull: [
            229
        ]
    },
    {
        code: 8498,
        lower: [],
        title: [],
        upper: [],
        fold: 8526,
        foldFull: [
            8526
        ]
    },
    {
        code: 8544,
        lower: [],
        title: [],
        upper: [],
        fold: 8560,
        foldFull: [
            8560
        ]
    },
    {
        code: 8545,
        lower: [],
        title: [],
        upper: [],
        fold: 8561,
        foldFull: [
            8561
        ]
    },
    {
        code: 8546,
        lower: [],
        title: [],
        upper: [],
        fold: 8562,
        foldFull: [
            8562
        ]
    },
    {
        code: 8547,
        lower: [],
        title: [],
        upper: [],
        fold: 8563,
        foldFull: [
            8563
        ]
    },
    {
        code: 8548,
        lower: [],
        title: [],
        upper: [],
        fold: 8564,
        foldFull: [
            8564
        ]
    },
    {
        code: 8549,
        lower: [],
        title: [],
        upper: [],
        fold: 8565,
        foldFull: [
            8565
        ]
    },
    {
        code: 8550,
        lower: [],
        title: [],
        upper: [],
        fold: 8566,
        foldFull: [
            8566
        ]
    },
    {
        code: 8551,
        lower: [],
        title: [],
        upper: [],
        fold: 8567,
        foldFull: [
            8567
        ]
    },
    {
        code: 8552,
        lower: [],
        title: [],
        upper: [],
        fold: 8568,
        foldFull: [
            8568
        ]
    },
    {
        code: 8553,
        lower: [],
        title: [],
        upper: [],
        fold: 8569,
        foldFull: [
            8569
        ]
    },
    {
        code: 8554,
        lower: [],
        title: [],
        upper: [],
        fold: 8570,
        foldFull: [
            8570
        ]
    },
    {
        code: 8555,
        lower: [],
        title: [],
        upper: [],
        fold: 8571,
        foldFull: [
            8571
        ]
    },
    {
        code: 8556,
        lower: [],
        title: [],
        upper: [],
        fold: 8572,
        foldFull: [
            8572
        ]
    },
    {
        code: 8557,
        lower: [],
        title: [],
        upper: [],
        fold: 8573,
        foldFull: [
            8573
        ]
    },
    {
        code: 8558,
        lower: [],
        title: [],
        upper: [],
        fold: 8574,
        foldFull: [
            8574
        ]
    },
    {
        code: 8559,
        lower: [],
        title: [],
        upper: [],
        fold: 8575,
        foldFull: [
            8575
        ]
    },
    {
        code: 8579,
        lower: [],
        title: [],
        upper: [],
        fold: 8580,
        foldFull: [
            8580
        ]
    },
    {
        code: 9398,
        lower: [],
        title: [],
        upper: [],
        fold: 9424,
        foldFull: [
            9424
        ]
    },
    {
        code: 9399,
        lower: [],
        title: [],
        upper: [],
        fold: 9425,
        foldFull: [
            9425
        ]
    },
    {
        code: 9400,
        lower: [],
        title: [],
        upper: [],
        fold: 9426,
        foldFull: [
            9426
        ]
    },
    {
        code: 9401,
        lower: [],
        title: [],
        upper: [],
        fold: 9427,
        foldFull: [
            9427
        ]
    },
    {
        code: 9402,
        lower: [],
        title: [],
        upper: [],
        fold: 9428,
        foldFull: [
            9428
        ]
    },
    {
        code: 9403,
        lower: [],
        title: [],
        upper: [],
        fold: 9429,
        foldFull: [
            9429
        ]
    },
    {
        code: 9404,
        lower: [],
        title: [],
        upper: [],
        fold: 9430,
        foldFull: [
            9430
        ]
    },
    {
        code: 9405,
        lower: [],
        title: [],
        upper: [],
        fold: 9431,
        foldFull: [
            9431
        ]
    },
    {
        code: 9406,
        lower: [],
        title: [],
        upper: [],
        fold: 9432,
        foldFull: [
            9432
        ]
    },
    {
        code: 9407,
        lower: [],
        title: [],
        upper: [],
        fold: 9433,
        foldFull: [
            9433
        ]
    },
    {
        code: 9408,
        lower: [],
        title: [],
        upper: [],
        fold: 9434,
        foldFull: [
            9434
        ]
    },
    {
        code: 9409,
        lower: [],
        title: [],
        upper: [],
        fold: 9435,
        foldFull: [
            9435
        ]
    },
    {
        code: 9410,
        lower: [],
        title: [],
        upper: [],
        fold: 9436,
        foldFull: [
            9436
        ]
    },
    {
        code: 9411,
        lower: [],
        title: [],
        upper: [],
        fold: 9437,
        foldFull: [
            9437
        ]
    },
    {
        code: 9412,
        lower: [],
        title: [],
        upper: [],
        fold: 9438,
        foldFull: [
            9438
        ]
    },
    {
        code: 9413,
        lower: [],
        title: [],
        upper: [],
        fold: 9439,
        foldFull: [
            9439
        ]
    },
    {
        code: 9414,
        lower: [],
        title: [],
        upper: [],
        fold: 9440,
        foldFull: [
            9440
        ]
    },
    {
        code: 9415,
        lower: [],
        title: [],
        upper: [],
        fold: 9441,
        foldFull: [
            9441
        ]
    },
    {
        code: 9416,
        lower: [],
        title: [],
        upper: [],
        fold: 9442,
        foldFull: [
            9442
        ]
    },
    {
        code: 9417,
        lower: [],
        title: [],
        upper: [],
        fold: 9443,
        foldFull: [
            9443
        ]
    },
    {
        code: 9418,
        lower: [],
        title: [],
        upper: [],
        fold: 9444,
        foldFull: [
            9444
        ]
    },
    {
        code: 9419,
        lower: [],
        title: [],
        upper: [],
        fold: 9445,
        foldFull: [
            9445
        ]
    },
    {
        code: 9420,
        lower: [],
        title: [],
        upper: [],
        fold: 9446,
        foldFull: [
            9446
        ]
    },
    {
        code: 9421,
        lower: [],
        title: [],
        upper: [],
        fold: 9447,
        foldFull: [
            9447
        ]
    },
    {
        code: 9422,
        lower: [],
        title: [],
        upper: [],
        fold: 9448,
        foldFull: [
            9448
        ]
    },
    {
        code: 9423,
        lower: [],
        title: [],
        upper: [],
        fold: 9449,
        foldFull: [
            9449
        ]
    },
    {
        code: 11264,
        lower: [],
        title: [],
        upper: [],
        fold: 11312,
        foldFull: [
            11312
        ]
    },
    {
        code: 11265,
        lower: [],
        title: [],
        upper: [],
        fold: 11313,
        foldFull: [
            11313
        ]
    },
    {
        code: 11266,
        lower: [],
        title: [],
        upper: [],
        fold: 11314,
        foldFull: [
            11314
        ]
    },
    {
        code: 11267,
        lower: [],
        title: [],
        upper: [],
        fold: 11315,
        foldFull: [
            11315
        ]
    },
    {
        code: 11268,
        lower: [],
        title: [],
        upper: [],
        fold: 11316,
        foldFull: [
            11316
        ]
    },
    {
        code: 11269,
        lower: [],
        title: [],
        upper: [],
        fold: 11317,
        foldFull: [
            11317
        ]
    },
    {
        code: 11270,
        lower: [],
        title: [],
        upper: [],
        fold: 11318,
        foldFull: [
            11318
        ]
    },
    {
        code: 11271,
        lower: [],
        title: [],
        upper: [],
        fold: 11319,
        foldFull: [
            11319
        ]
    },
    {
        code: 11272,
        lower: [],
        title: [],
        upper: [],
        fold: 11320,
        foldFull: [
            11320
        ]
    },
    {
        code: 11273,
        lower: [],
        title: [],
        upper: [],
        fold: 11321,
        foldFull: [
            11321
        ]
    },
    {
        code: 11274,
        lower: [],
        title: [],
        upper: [],
        fold: 11322,
        foldFull: [
            11322
        ]
    },
    {
        code: 11275,
        lower: [],
        title: [],
        upper: [],
        fold: 11323,
        foldFull: [
            11323
        ]
    },
    {
        code: 11276,
        lower: [],
        title: [],
        upper: [],
        fold: 11324,
        foldFull: [
            11324
        ]
    },
    {
        code: 11277,
        lower: [],
        title: [],
        upper: [],
        fold: 11325,
        foldFull: [
            11325
        ]
    },
    {
        code: 11278,
        lower: [],
        title: [],
        upper: [],
        fold: 11326,
        foldFull: [
            11326
        ]
    },
    {
        code: 11279,
        lower: [],
        title: [],
        upper: [],
        fold: 11327,
        foldFull: [
            11327
        ]
    },
    {
        code: 11280,
        lower: [],
        title: [],
        upper: [],
        fold: 11328,
        foldFull: [
            11328
        ]
    },
    {
        code: 11281,
        lower: [],
        title: [],
        upper: [],
        fold: 11329,
        foldFull: [
            11329
        ]
    },
    {
        code: 11282,
        lower: [],
        title: [],
        upper: [],
        fold: 11330,
        foldFull: [
            11330
        ]
    },
    {
        code: 11283,
        lower: [],
        title: [],
        upper: [],
        fold: 11331,
        foldFull: [
            11331
        ]
    },
    {
        code: 11284,
        lower: [],
        title: [],
        upper: [],
        fold: 11332,
        foldFull: [
            11332
        ]
    },
    {
        code: 11285,
        lower: [],
        title: [],
        upper: [],
        fold: 11333,
        foldFull: [
            11333
        ]
    },
    {
        code: 11286,
        lower: [],
        title: [],
        upper: [],
        fold: 11334,
        foldFull: [
            11334
        ]
    },
    {
        code: 11287,
        lower: [],
        title: [],
        upper: [],
        fold: 11335,
        foldFull: [
            11335
        ]
    },
    {
        code: 11288,
        lower: [],
        title: [],
        upper: [],
        fold: 11336,
        foldFull: [
            11336
        ]
    },
    {
        code: 11289,
        lower: [],
        title: [],
        upper: [],
        fold: 11337,
        foldFull: [
            11337
        ]
    },
    {
        code: 11290,
        lower: [],
        title: [],
        upper: [],
        fold: 11338,
        foldFull: [
            11338
        ]
    },
    {
        code: 11291,
        lower: [],
        title: [],
        upper: [],
        fold: 11339,
        foldFull: [
            11339
        ]
    },
    {
        code: 11292,
        lower: [],
        title: [],
        upper: [],
        fold: 11340,
        foldFull: [
            11340
        ]
    },
    {
        code: 11293,
        lower: [],
        title: [],
        upper: [],
        fold: 11341,
        foldFull: [
            11341
        ]
    },
    {
        code: 11294,
        lower: [],
        title: [],
        upper: [],
        fold: 11342,
        foldFull: [
            11342
        ]
    },
    {
        code: 11295,
        lower: [],
        title: [],
        upper: [],
        fold: 11343,
        foldFull: [
            11343
        ]
    },
    {
        code: 11296,
        lower: [],
        title: [],
        upper: [],
        fold: 11344,
        foldFull: [
            11344
        ]
    },
    {
        code: 11297,
        lower: [],
        title: [],
        upper: [],
        fold: 11345,
        foldFull: [
            11345
        ]
    },
    {
        code: 11298,
        lower: [],
        title: [],
        upper: [],
        fold: 11346,
        foldFull: [
            11346
        ]
    },
    {
        code: 11299,
        lower: [],
        title: [],
        upper: [],
        fold: 11347,
        foldFull: [
            11347
        ]
    },
    {
        code: 11300,
        lower: [],
        title: [],
        upper: [],
        fold: 11348,
        foldFull: [
            11348
        ]
    },
    {
        code: 11301,
        lower: [],
        title: [],
        upper: [],
        fold: 11349,
        foldFull: [
            11349
        ]
    },
    {
        code: 11302,
        lower: [],
        title: [],
        upper: [],
        fold: 11350,
        foldFull: [
            11350
        ]
    },
    {
        code: 11303,
        lower: [],
        title: [],
        upper: [],
        fold: 11351,
        foldFull: [
            11351
        ]
    },
    {
        code: 11304,
        lower: [],
        title: [],
        upper: [],
        fold: 11352,
        foldFull: [
            11352
        ]
    },
    {
        code: 11305,
        lower: [],
        title: [],
        upper: [],
        fold: 11353,
        foldFull: [
            11353
        ]
    },
    {
        code: 11306,
        lower: [],
        title: [],
        upper: [],
        fold: 11354,
        foldFull: [
            11354
        ]
    },
    {
        code: 11307,
        lower: [],
        title: [],
        upper: [],
        fold: 11355,
        foldFull: [
            11355
        ]
    },
    {
        code: 11308,
        lower: [],
        title: [],
        upper: [],
        fold: 11356,
        foldFull: [
            11356
        ]
    },
    {
        code: 11309,
        lower: [],
        title: [],
        upper: [],
        fold: 11357,
        foldFull: [
            11357
        ]
    },
    {
        code: 11310,
        lower: [],
        title: [],
        upper: [],
        fold: 11358,
        foldFull: [
            11358
        ]
    },
    {
        code: 11360,
        lower: [],
        title: [],
        upper: [],
        fold: 11361,
        foldFull: [
            11361
        ]
    },
    {
        code: 11362,
        lower: [],
        title: [],
        upper: [],
        fold: 619,
        foldFull: [
            619
        ]
    },
    {
        code: 11363,
        lower: [],
        title: [],
        upper: [],
        fold: 7549,
        foldFull: [
            7549
        ]
    },
    {
        code: 11364,
        lower: [],
        title: [],
        upper: [],
        fold: 637,
        foldFull: [
            637
        ]
    },
    {
        code: 11367,
        lower: [],
        title: [],
        upper: [],
        fold: 11368,
        foldFull: [
            11368
        ]
    },
    {
        code: 11369,
        lower: [],
        title: [],
        upper: [],
        fold: 11370,
        foldFull: [
            11370
        ]
    },
    {
        code: 11371,
        lower: [],
        title: [],
        upper: [],
        fold: 11372,
        foldFull: [
            11372
        ]
    },
    {
        code: 11373,
        lower: [],
        title: [],
        upper: [],
        fold: 593,
        foldFull: [
            593
        ]
    },
    {
        code: 11374,
        lower: [],
        title: [],
        upper: [],
        fold: 625,
        foldFull: [
            625
        ]
    },
    {
        code: 11375,
        lower: [],
        title: [],
        upper: [],
        fold: 592,
        foldFull: [
            592
        ]
    },
    {
        code: 11376,
        lower: [],
        title: [],
        upper: [],
        fold: 594,
        foldFull: [
            594
        ]
    },
    {
        code: 11378,
        lower: [],
        title: [],
        upper: [],
        fold: 11379,
        foldFull: [
            11379
        ]
    },
    {
        code: 11381,
        lower: [],
        title: [],
        upper: [],
        fold: 11382,
        foldFull: [
            11382
        ]
    },
    {
        code: 11390,
        lower: [],
        title: [],
        upper: [],
        fold: 575,
        foldFull: [
            575
        ]
    },
    {
        code: 11391,
        lower: [],
        title: [],
        upper: [],
        fold: 576,
        foldFull: [
            576
        ]
    },
    {
        code: 11392,
        lower: [],
        title: [],
        upper: [],
        fold: 11393,
        foldFull: [
            11393
        ]
    },
    {
        code: 11394,
        lower: [],
        title: [],
        upper: [],
        fold: 11395,
        foldFull: [
            11395
        ]
    },
    {
        code: 11396,
        lower: [],
        title: [],
        upper: [],
        fold: 11397,
        foldFull: [
            11397
        ]
    },
    {
        code: 11398,
        lower: [],
        title: [],
        upper: [],
        fold: 11399,
        foldFull: [
            11399
        ]
    },
    {
        code: 11400,
        lower: [],
        title: [],
        upper: [],
        fold: 11401,
        foldFull: [
            11401
        ]
    },
    {
        code: 11402,
        lower: [],
        title: [],
        upper: [],
        fold: 11403,
        foldFull: [
            11403
        ]
    },
    {
        code: 11404,
        lower: [],
        title: [],
        upper: [],
        fold: 11405,
        foldFull: [
            11405
        ]
    },
    {
        code: 11406,
        lower: [],
        title: [],
        upper: [],
        fold: 11407,
        foldFull: [
            11407
        ]
    },
    {
        code: 11408,
        lower: [],
        title: [],
        upper: [],
        fold: 11409,
        foldFull: [
            11409
        ]
    },
    {
        code: 11410,
        lower: [],
        title: [],
        upper: [],
        fold: 11411,
        foldFull: [
            11411
        ]
    },
    {
        code: 11412,
        lower: [],
        title: [],
        upper: [],
        fold: 11413,
        foldFull: [
            11413
        ]
    },
    {
        code: 11414,
        lower: [],
        title: [],
        upper: [],
        fold: 11415,
        foldFull: [
            11415
        ]
    },
    {
        code: 11416,
        lower: [],
        title: [],
        upper: [],
        fold: 11417,
        foldFull: [
            11417
        ]
    },
    {
        code: 11418,
        lower: [],
        title: [],
        upper: [],
        fold: 11419,
        foldFull: [
            11419
        ]
    },
    {
        code: 11420,
        lower: [],
        title: [],
        upper: [],
        fold: 11421,
        foldFull: [
            11421
        ]
    },
    {
        code: 11422,
        lower: [],
        title: [],
        upper: [],
        fold: 11423,
        foldFull: [
            11423
        ]
    },
    {
        code: 11424,
        lower: [],
        title: [],
        upper: [],
        fold: 11425,
        foldFull: [
            11425
        ]
    },
    {
        code: 11426,
        lower: [],
        title: [],
        upper: [],
        fold: 11427,
        foldFull: [
            11427
        ]
    },
    {
        code: 11428,
        lower: [],
        title: [],
        upper: [],
        fold: 11429,
        foldFull: [
            11429
        ]
    },
    {
        code: 11430,
        lower: [],
        title: [],
        upper: [],
        fold: 11431,
        foldFull: [
            11431
        ]
    },
    {
        code: 11432,
        lower: [],
        title: [],
        upper: [],
        fold: 11433,
        foldFull: [
            11433
        ]
    },
    {
        code: 11434,
        lower: [],
        title: [],
        upper: [],
        fold: 11435,
        foldFull: [
            11435
        ]
    },
    {
        code: 11436,
        lower: [],
        title: [],
        upper: [],
        fold: 11437,
        foldFull: [
            11437
        ]
    },
    {
        code: 11438,
        lower: [],
        title: [],
        upper: [],
        fold: 11439,
        foldFull: [
            11439
        ]
    },
    {
        code: 11440,
        lower: [],
        title: [],
        upper: [],
        fold: 11441,
        foldFull: [
            11441
        ]
    },
    {
        code: 11442,
        lower: [],
        title: [],
        upper: [],
        fold: 11443,
        foldFull: [
            11443
        ]
    },
    {
        code: 11444,
        lower: [],
        title: [],
        upper: [],
        fold: 11445,
        foldFull: [
            11445
        ]
    },
    {
        code: 11446,
        lower: [],
        title: [],
        upper: [],
        fold: 11447,
        foldFull: [
            11447
        ]
    },
    {
        code: 11448,
        lower: [],
        title: [],
        upper: [],
        fold: 11449,
        foldFull: [
            11449
        ]
    },
    {
        code: 11450,
        lower: [],
        title: [],
        upper: [],
        fold: 11451,
        foldFull: [
            11451
        ]
    },
    {
        code: 11452,
        lower: [],
        title: [],
        upper: [],
        fold: 11453,
        foldFull: [
            11453
        ]
    },
    {
        code: 11454,
        lower: [],
        title: [],
        upper: [],
        fold: 11455,
        foldFull: [
            11455
        ]
    },
    {
        code: 11456,
        lower: [],
        title: [],
        upper: [],
        fold: 11457,
        foldFull: [
            11457
        ]
    },
    {
        code: 11458,
        lower: [],
        title: [],
        upper: [],
        fold: 11459,
        foldFull: [
            11459
        ]
    },
    {
        code: 11460,
        lower: [],
        title: [],
        upper: [],
        fold: 11461,
        foldFull: [
            11461
        ]
    },
    {
        code: 11462,
        lower: [],
        title: [],
        upper: [],
        fold: 11463,
        foldFull: [
            11463
        ]
    },
    {
        code: 11464,
        lower: [],
        title: [],
        upper: [],
        fold: 11465,
        foldFull: [
            11465
        ]
    },
    {
        code: 11466,
        lower: [],
        title: [],
        upper: [],
        fold: 11467,
        foldFull: [
            11467
        ]
    },
    {
        code: 11468,
        lower: [],
        title: [],
        upper: [],
        fold: 11469,
        foldFull: [
            11469
        ]
    },
    {
        code: 11470,
        lower: [],
        title: [],
        upper: [],
        fold: 11471,
        foldFull: [
            11471
        ]
    },
    {
        code: 11472,
        lower: [],
        title: [],
        upper: [],
        fold: 11473,
        foldFull: [
            11473
        ]
    },
    {
        code: 11474,
        lower: [],
        title: [],
        upper: [],
        fold: 11475,
        foldFull: [
            11475
        ]
    },
    {
        code: 11476,
        lower: [],
        title: [],
        upper: [],
        fold: 11477,
        foldFull: [
            11477
        ]
    },
    {
        code: 11478,
        lower: [],
        title: [],
        upper: [],
        fold: 11479,
        foldFull: [
            11479
        ]
    },
    {
        code: 11480,
        lower: [],
        title: [],
        upper: [],
        fold: 11481,
        foldFull: [
            11481
        ]
    },
    {
        code: 11482,
        lower: [],
        title: [],
        upper: [],
        fold: 11483,
        foldFull: [
            11483
        ]
    },
    {
        code: 11484,
        lower: [],
        title: [],
        upper: [],
        fold: 11485,
        foldFull: [
            11485
        ]
    },
    {
        code: 11486,
        lower: [],
        title: [],
        upper: [],
        fold: 11487,
        foldFull: [
            11487
        ]
    },
    {
        code: 11488,
        lower: [],
        title: [],
        upper: [],
        fold: 11489,
        foldFull: [
            11489
        ]
    },
    {
        code: 11490,
        lower: [],
        title: [],
        upper: [],
        fold: 11491,
        foldFull: [
            11491
        ]
    },
    {
        code: 11499,
        lower: [],
        title: [],
        upper: [],
        fold: 11500,
        foldFull: [
            11500
        ]
    },
    {
        code: 11501,
        lower: [],
        title: [],
        upper: [],
        fold: 11502,
        foldFull: [
            11502
        ]
    },
    {
        code: 11506,
        lower: [],
        title: [],
        upper: [],
        fold: 11507,
        foldFull: [
            11507
        ]
    },
    {
        code: 42560,
        lower: [],
        title: [],
        upper: [],
        fold: 42561,
        foldFull: [
            42561
        ]
    },
    {
        code: 42562,
        lower: [],
        title: [],
        upper: [],
        fold: 42563,
        foldFull: [
            42563
        ]
    },
    {
        code: 42564,
        lower: [],
        title: [],
        upper: [],
        fold: 42565,
        foldFull: [
            42565
        ]
    },
    {
        code: 42566,
        lower: [],
        title: [],
        upper: [],
        fold: 42567,
        foldFull: [
            42567
        ]
    },
    {
        code: 42568,
        lower: [],
        title: [],
        upper: [],
        fold: 42569,
        foldFull: [
            42569
        ]
    },
    {
        code: 42570,
        lower: [],
        title: [],
        upper: [],
        fold: 42571,
        foldFull: [
            42571
        ]
    },
    {
        code: 42572,
        lower: [],
        title: [],
        upper: [],
        fold: 42573,
        foldFull: [
            42573
        ]
    },
    {
        code: 42574,
        lower: [],
        title: [],
        upper: [],
        fold: 42575,
        foldFull: [
            42575
        ]
    },
    {
        code: 42576,
        lower: [],
        title: [],
        upper: [],
        fold: 42577,
        foldFull: [
            42577
        ]
    },
    {
        code: 42578,
        lower: [],
        title: [],
        upper: [],
        fold: 42579,
        foldFull: [
            42579
        ]
    },
    {
        code: 42580,
        lower: [],
        title: [],
        upper: [],
        fold: 42581,
        foldFull: [
            42581
        ]
    },
    {
        code: 42582,
        lower: [],
        title: [],
        upper: [],
        fold: 42583,
        foldFull: [
            42583
        ]
    },
    {
        code: 42584,
        lower: [],
        title: [],
        upper: [],
        fold: 42585,
        foldFull: [
            42585
        ]
    },
    {
        code: 42586,
        lower: [],
        title: [],
        upper: [],
        fold: 42587,
        foldFull: [
            42587
        ]
    },
    {
        code: 42588,
        lower: [],
        title: [],
        upper: [],
        fold: 42589,
        foldFull: [
            42589
        ]
    },
    {
        code: 42590,
        lower: [],
        title: [],
        upper: [],
        fold: 42591,
        foldFull: [
            42591
        ]
    },
    {
        code: 42592,
        lower: [],
        title: [],
        upper: [],
        fold: 42593,
        foldFull: [
            42593
        ]
    },
    {
        code: 42594,
        lower: [],
        title: [],
        upper: [],
        fold: 42595,
        foldFull: [
            42595
        ]
    },
    {
        code: 42596,
        lower: [],
        title: [],
        upper: [],
        fold: 42597,
        foldFull: [
            42597
        ]
    },
    {
        code: 42598,
        lower: [],
        title: [],
        upper: [],
        fold: 42599,
        foldFull: [
            42599
        ]
    },
    {
        code: 42600,
        lower: [],
        title: [],
        upper: [],
        fold: 42601,
        foldFull: [
            42601
        ]
    },
    {
        code: 42602,
        lower: [],
        title: [],
        upper: [],
        fold: 42603,
        foldFull: [
            42603
        ]
    },
    {
        code: 42604,
        lower: [],
        title: [],
        upper: [],
        fold: 42605,
        foldFull: [
            42605
        ]
    },
    {
        code: 42624,
        lower: [],
        title: [],
        upper: [],
        fold: 42625,
        foldFull: [
            42625
        ]
    },
    {
        code: 42626,
        lower: [],
        title: [],
        upper: [],
        fold: 42627,
        foldFull: [
            42627
        ]
    },
    {
        code: 42628,
        lower: [],
        title: [],
        upper: [],
        fold: 42629,
        foldFull: [
            42629
        ]
    },
    {
        code: 42630,
        lower: [],
        title: [],
        upper: [],
        fold: 42631,
        foldFull: [
            42631
        ]
    },
    {
        code: 42632,
        lower: [],
        title: [],
        upper: [],
        fold: 42633,
        foldFull: [
            42633
        ]
    },
    {
        code: 42634,
        lower: [],
        title: [],
        upper: [],
        fold: 42635,
        foldFull: [
            42635
        ]
    },
    {
        code: 42636,
        lower: [],
        title: [],
        upper: [],
        fold: 42637,
        foldFull: [
            42637
        ]
    },
    {
        code: 42638,
        lower: [],
        title: [],
        upper: [],
        fold: 42639,
        foldFull: [
            42639
        ]
    },
    {
        code: 42640,
        lower: [],
        title: [],
        upper: [],
        fold: 42641,
        foldFull: [
            42641
        ]
    },
    {
        code: 42642,
        lower: [],
        title: [],
        upper: [],
        fold: 42643,
        foldFull: [
            42643
        ]
    },
    {
        code: 42644,
        lower: [],
        title: [],
        upper: [],
        fold: 42645,
        foldFull: [
            42645
        ]
    },
    {
        code: 42646,
        lower: [],
        title: [],
        upper: [],
        fold: 42647,
        foldFull: [
            42647
        ]
    },
    {
        code: 42648,
        lower: [],
        title: [],
        upper: [],
        fold: 42649,
        foldFull: [
            42649
        ]
    },
    {
        code: 42650,
        lower: [],
        title: [],
        upper: [],
        fold: 42651,
        foldFull: [
            42651
        ]
    },
    {
        code: 42786,
        lower: [],
        title: [],
        upper: [],
        fold: 42787,
        foldFull: [
            42787
        ]
    },
    {
        code: 42788,
        lower: [],
        title: [],
        upper: [],
        fold: 42789,
        foldFull: [
            42789
        ]
    },
    {
        code: 42790,
        lower: [],
        title: [],
        upper: [],
        fold: 42791,
        foldFull: [
            42791
        ]
    },
    {
        code: 42792,
        lower: [],
        title: [],
        upper: [],
        fold: 42793,
        foldFull: [
            42793
        ]
    },
    {
        code: 42794,
        lower: [],
        title: [],
        upper: [],
        fold: 42795,
        foldFull: [
            42795
        ]
    },
    {
        code: 42796,
        lower: [],
        title: [],
        upper: [],
        fold: 42797,
        foldFull: [
            42797
        ]
    },
    {
        code: 42798,
        lower: [],
        title: [],
        upper: [],
        fold: 42799,
        foldFull: [
            42799
        ]
    },
    {
        code: 42802,
        lower: [],
        title: [],
        upper: [],
        fold: 42803,
        foldFull: [
            42803
        ]
    },
    {
        code: 42804,
        lower: [],
        title: [],
        upper: [],
        fold: 42805,
        foldFull: [
            42805
        ]
    },
    {
        code: 42806,
        lower: [],
        title: [],
        upper: [],
        fold: 42807,
        foldFull: [
            42807
        ]
    },
    {
        code: 42808,
        lower: [],
        title: [],
        upper: [],
        fold: 42809,
        foldFull: [
            42809
        ]
    },
    {
        code: 42810,
        lower: [],
        title: [],
        upper: [],
        fold: 42811,
        foldFull: [
            42811
        ]
    },
    {
        code: 42812,
        lower: [],
        title: [],
        upper: [],
        fold: 42813,
        foldFull: [
            42813
        ]
    },
    {
        code: 42814,
        lower: [],
        title: [],
        upper: [],
        fold: 42815,
        foldFull: [
            42815
        ]
    },
    {
        code: 42816,
        lower: [],
        title: [],
        upper: [],
        fold: 42817,
        foldFull: [
            42817
        ]
    },
    {
        code: 42818,
        lower: [],
        title: [],
        upper: [],
        fold: 42819,
        foldFull: [
            42819
        ]
    },
    {
        code: 42820,
        lower: [],
        title: [],
        upper: [],
        fold: 42821,
        foldFull: [
            42821
        ]
    },
    {
        code: 42822,
        lower: [],
        title: [],
        upper: [],
        fold: 42823,
        foldFull: [
            42823
        ]
    },
    {
        code: 42824,
        lower: [],
        title: [],
        upper: [],
        fold: 42825,
        foldFull: [
            42825
        ]
    },
    {
        code: 42826,
        lower: [],
        title: [],
        upper: [],
        fold: 42827,
        foldFull: [
            42827
        ]
    },
    {
        code: 42828,
        lower: [],
        title: [],
        upper: [],
        fold: 42829,
        foldFull: [
            42829
        ]
    },
    {
        code: 42830,
        lower: [],
        title: [],
        upper: [],
        fold: 42831,
        foldFull: [
            42831
        ]
    },
    {
        code: 42832,
        lower: [],
        title: [],
        upper: [],
        fold: 42833,
        foldFull: [
            42833
        ]
    },
    {
        code: 42834,
        lower: [],
        title: [],
        upper: [],
        fold: 42835,
        foldFull: [
            42835
        ]
    },
    {
        code: 42836,
        lower: [],
        title: [],
        upper: [],
        fold: 42837,
        foldFull: [
            42837
        ]
    },
    {
        code: 42838,
        lower: [],
        title: [],
        upper: [],
        fold: 42839,
        foldFull: [
            42839
        ]
    },
    {
        code: 42840,
        lower: [],
        title: [],
        upper: [],
        fold: 42841,
        foldFull: [
            42841
        ]
    },
    {
        code: 42842,
        lower: [],
        title: [],
        upper: [],
        fold: 42843,
        foldFull: [
            42843
        ]
    },
    {
        code: 42844,
        lower: [],
        title: [],
        upper: [],
        fold: 42845,
        foldFull: [
            42845
        ]
    },
    {
        code: 42846,
        lower: [],
        title: [],
        upper: [],
        fold: 42847,
        foldFull: [
            42847
        ]
    },
    {
        code: 42848,
        lower: [],
        title: [],
        upper: [],
        fold: 42849,
        foldFull: [
            42849
        ]
    },
    {
        code: 42850,
        lower: [],
        title: [],
        upper: [],
        fold: 42851,
        foldFull: [
            42851
        ]
    },
    {
        code: 42852,
        lower: [],
        title: [],
        upper: [],
        fold: 42853,
        foldFull: [
            42853
        ]
    },
    {
        code: 42854,
        lower: [],
        title: [],
        upper: [],
        fold: 42855,
        foldFull: [
            42855
        ]
    },
    {
        code: 42856,
        lower: [],
        title: [],
        upper: [],
        fold: 42857,
        foldFull: [
            42857
        ]
    },
    {
        code: 42858,
        lower: [],
        title: [],
        upper: [],
        fold: 42859,
        foldFull: [
            42859
        ]
    },
    {
        code: 42860,
        lower: [],
        title: [],
        upper: [],
        fold: 42861,
        foldFull: [
            42861
        ]
    },
    {
        code: 42862,
        lower: [],
        title: [],
        upper: [],
        fold: 42863,
        foldFull: [
            42863
        ]
    },
    {
        code: 42873,
        lower: [],
        title: [],
        upper: [],
        fold: 42874,
        foldFull: [
            42874
        ]
    },
    {
        code: 42875,
        lower: [],
        title: [],
        upper: [],
        fold: 42876,
        foldFull: [
            42876
        ]
    },
    {
        code: 42877,
        lower: [],
        title: [],
        upper: [],
        fold: 7545,
        foldFull: [
            7545
        ]
    },
    {
        code: 42878,
        lower: [],
        title: [],
        upper: [],
        fold: 42879,
        foldFull: [
            42879
        ]
    },
    {
        code: 42880,
        lower: [],
        title: [],
        upper: [],
        fold: 42881,
        foldFull: [
            42881
        ]
    },
    {
        code: 42882,
        lower: [],
        title: [],
        upper: [],
        fold: 42883,
        foldFull: [
            42883
        ]
    },
    {
        code: 42884,
        lower: [],
        title: [],
        upper: [],
        fold: 42885,
        foldFull: [
            42885
        ]
    },
    {
        code: 42886,
        lower: [],
        title: [],
        upper: [],
        fold: 42887,
        foldFull: [
            42887
        ]
    },
    {
        code: 42891,
        lower: [],
        title: [],
        upper: [],
        fold: 42892,
        foldFull: [
            42892
        ]
    },
    {
        code: 42893,
        lower: [],
        title: [],
        upper: [],
        fold: 613,
        foldFull: [
            613
        ]
    },
    {
        code: 42896,
        lower: [],
        title: [],
        upper: [],
        fold: 42897,
        foldFull: [
            42897
        ]
    },
    {
        code: 42898,
        lower: [],
        title: [],
        upper: [],
        fold: 42899,
        foldFull: [
            42899
        ]
    },
    {
        code: 42902,
        lower: [],
        title: [],
        upper: [],
        fold: 42903,
        foldFull: [
            42903
        ]
    },
    {
        code: 42904,
        lower: [],
        title: [],
        upper: [],
        fold: 42905,
        foldFull: [
            42905
        ]
    },
    {
        code: 42906,
        lower: [],
        title: [],
        upper: [],
        fold: 42907,
        foldFull: [
            42907
        ]
    },
    {
        code: 42908,
        lower: [],
        title: [],
        upper: [],
        fold: 42909,
        foldFull: [
            42909
        ]
    },
    {
        code: 42910,
        lower: [],
        title: [],
        upper: [],
        fold: 42911,
        foldFull: [
            42911
        ]
    },
    {
        code: 42912,
        lower: [],
        title: [],
        upper: [],
        fold: 42913,
        foldFull: [
            42913
        ]
    },
    {
        code: 42914,
        lower: [],
        title: [],
        upper: [],
        fold: 42915,
        foldFull: [
            42915
        ]
    },
    {
        code: 42916,
        lower: [],
        title: [],
        upper: [],
        fold: 42917,
        foldFull: [
            42917
        ]
    },
    {
        code: 42918,
        lower: [],
        title: [],
        upper: [],
        fold: 42919,
        foldFull: [
            42919
        ]
    },
    {
        code: 42920,
        lower: [],
        title: [],
        upper: [],
        fold: 42921,
        foldFull: [
            42921
        ]
    },
    {
        code: 42922,
        lower: [],
        title: [],
        upper: [],
        fold: 614,
        foldFull: [
            614
        ]
    },
    {
        code: 42923,
        lower: [],
        title: [],
        upper: [],
        fold: 604,
        foldFull: [
            604
        ]
    },
    {
        code: 42924,
        lower: [],
        title: [],
        upper: [],
        fold: 609,
        foldFull: [
            609
        ]
    },
    {
        code: 42925,
        lower: [],
        title: [],
        upper: [],
        fold: 620,
        foldFull: [
            620
        ]
    },
    {
        code: 42926,
        lower: [],
        title: [],
        upper: [],
        fold: 618,
        foldFull: [
            618
        ]
    },
    {
        code: 42928,
        lower: [],
        title: [],
        upper: [],
        fold: 670,
        foldFull: [
            670
        ]
    },
    {
        code: 42929,
        lower: [],
        title: [],
        upper: [],
        fold: 647,
        foldFull: [
            647
        ]
    },
    {
        code: 42930,
        lower: [],
        title: [],
        upper: [],
        fold: 669,
        foldFull: [
            669
        ]
    },
    {
        code: 42931,
        lower: [],
        title: [],
        upper: [],
        fold: 43859,
        foldFull: [
            43859
        ]
    },
    {
        code: 42932,
        lower: [],
        title: [],
        upper: [],
        fold: 42933,
        foldFull: [
            42933
        ]
    },
    {
        code: 42934,
        lower: [],
        title: [],
        upper: [],
        fold: 42935,
        foldFull: [
            42935
        ]
    },
    {
        code: 42936,
        lower: [],
        title: [],
        upper: [],
        fold: 42937,
        foldFull: [
            42937
        ]
    },
    {
        code: 42938,
        lower: [],
        title: [],
        upper: [],
        fold: 42939,
        foldFull: [
            42939
        ]
    },
    {
        code: 42940,
        lower: [],
        title: [],
        upper: [],
        fold: 42941,
        foldFull: [
            42941
        ]
    },
    {
        code: 42942,
        lower: [],
        title: [],
        upper: [],
        fold: 42943,
        foldFull: [
            42943
        ]
    },
    {
        code: 42946,
        lower: [],
        title: [],
        upper: [],
        fold: 42947,
        foldFull: [
            42947
        ]
    },
    {
        code: 42948,
        lower: [],
        title: [],
        upper: [],
        fold: 42900,
        foldFull: [
            42900
        ]
    },
    {
        code: 42949,
        lower: [],
        title: [],
        upper: [],
        fold: 642,
        foldFull: [
            642
        ]
    },
    {
        code: 42950,
        lower: [],
        title: [],
        upper: [],
        fold: 7566,
        foldFull: [
            7566
        ]
    },
    {
        code: 42951,
        lower: [],
        title: [],
        upper: [],
        fold: 42952,
        foldFull: [
            42952
        ]
    },
    {
        code: 42953,
        lower: [],
        title: [],
        upper: [],
        fold: 42954,
        foldFull: [
            42954
        ]
    },
    {
        code: 42997,
        lower: [],
        title: [],
        upper: [],
        fold: 42998,
        foldFull: [
            42998
        ]
    },
    {
        code: 43888,
        lower: [],
        title: [],
        upper: [],
        fold: 5024,
        foldFull: [
            5024
        ]
    },
    {
        code: 43889,
        lower: [],
        title: [],
        upper: [],
        fold: 5025,
        foldFull: [
            5025
        ]
    },
    {
        code: 43890,
        lower: [],
        title: [],
        upper: [],
        fold: 5026,
        foldFull: [
            5026
        ]
    },
    {
        code: 43891,
        lower: [],
        title: [],
        upper: [],
        fold: 5027,
        foldFull: [
            5027
        ]
    },
    {
        code: 43892,
        lower: [],
        title: [],
        upper: [],
        fold: 5028,
        foldFull: [
            5028
        ]
    },
    {
        code: 43893,
        lower: [],
        title: [],
        upper: [],
        fold: 5029,
        foldFull: [
            5029
        ]
    },
    {
        code: 43894,
        lower: [],
        title: [],
        upper: [],
        fold: 5030,
        foldFull: [
            5030
        ]
    },
    {
        code: 43895,
        lower: [],
        title: [],
        upper: [],
        fold: 5031,
        foldFull: [
            5031
        ]
    },
    {
        code: 43896,
        lower: [],
        title: [],
        upper: [],
        fold: 5032,
        foldFull: [
            5032
        ]
    },
    {
        code: 43897,
        lower: [],
        title: [],
        upper: [],
        fold: 5033,
        foldFull: [
            5033
        ]
    },
    {
        code: 43898,
        lower: [],
        title: [],
        upper: [],
        fold: 5034,
        foldFull: [
            5034
        ]
    },
    {
        code: 43899,
        lower: [],
        title: [],
        upper: [],
        fold: 5035,
        foldFull: [
            5035
        ]
    },
    {
        code: 43900,
        lower: [],
        title: [],
        upper: [],
        fold: 5036,
        foldFull: [
            5036
        ]
    },
    {
        code: 43901,
        lower: [],
        title: [],
        upper: [],
        fold: 5037,
        foldFull: [
            5037
        ]
    },
    {
        code: 43902,
        lower: [],
        title: [],
        upper: [],
        fold: 5038,
        foldFull: [
            5038
        ]
    },
    {
        code: 43903,
        lower: [],
        title: [],
        upper: [],
        fold: 5039,
        foldFull: [
            5039
        ]
    },
    {
        code: 43904,
        lower: [],
        title: [],
        upper: [],
        fold: 5040,
        foldFull: [
            5040
        ]
    },
    {
        code: 43905,
        lower: [],
        title: [],
        upper: [],
        fold: 5041,
        foldFull: [
            5041
        ]
    },
    {
        code: 43906,
        lower: [],
        title: [],
        upper: [],
        fold: 5042,
        foldFull: [
            5042
        ]
    },
    {
        code: 43907,
        lower: [],
        title: [],
        upper: [],
        fold: 5043,
        foldFull: [
            5043
        ]
    },
    {
        code: 43908,
        lower: [],
        title: [],
        upper: [],
        fold: 5044,
        foldFull: [
            5044
        ]
    },
    {
        code: 43909,
        lower: [],
        title: [],
        upper: [],
        fold: 5045,
        foldFull: [
            5045
        ]
    },
    {
        code: 43910,
        lower: [],
        title: [],
        upper: [],
        fold: 5046,
        foldFull: [
            5046
        ]
    },
    {
        code: 43911,
        lower: [],
        title: [],
        upper: [],
        fold: 5047,
        foldFull: [
            5047
        ]
    },
    {
        code: 43912,
        lower: [],
        title: [],
        upper: [],
        fold: 5048,
        foldFull: [
            5048
        ]
    },
    {
        code: 43913,
        lower: [],
        title: [],
        upper: [],
        fold: 5049,
        foldFull: [
            5049
        ]
    },
    {
        code: 43914,
        lower: [],
        title: [],
        upper: [],
        fold: 5050,
        foldFull: [
            5050
        ]
    },
    {
        code: 43915,
        lower: [],
        title: [],
        upper: [],
        fold: 5051,
        foldFull: [
            5051
        ]
    },
    {
        code: 43916,
        lower: [],
        title: [],
        upper: [],
        fold: 5052,
        foldFull: [
            5052
        ]
    },
    {
        code: 43917,
        lower: [],
        title: [],
        upper: [],
        fold: 5053,
        foldFull: [
            5053
        ]
    },
    {
        code: 43918,
        lower: [],
        title: [],
        upper: [],
        fold: 5054,
        foldFull: [
            5054
        ]
    },
    {
        code: 43919,
        lower: [],
        title: [],
        upper: [],
        fold: 5055,
        foldFull: [
            5055
        ]
    },
    {
        code: 43920,
        lower: [],
        title: [],
        upper: [],
        fold: 5056,
        foldFull: [
            5056
        ]
    },
    {
        code: 43921,
        lower: [],
        title: [],
        upper: [],
        fold: 5057,
        foldFull: [
            5057
        ]
    },
    {
        code: 43922,
        lower: [],
        title: [],
        upper: [],
        fold: 5058,
        foldFull: [
            5058
        ]
    },
    {
        code: 43923,
        lower: [],
        title: [],
        upper: [],
        fold: 5059,
        foldFull: [
            5059
        ]
    },
    {
        code: 43924,
        lower: [],
        title: [],
        upper: [],
        fold: 5060,
        foldFull: [
            5060
        ]
    },
    {
        code: 43925,
        lower: [],
        title: [],
        upper: [],
        fold: 5061,
        foldFull: [
            5061
        ]
    },
    {
        code: 43926,
        lower: [],
        title: [],
        upper: [],
        fold: 5062,
        foldFull: [
            5062
        ]
    },
    {
        code: 43927,
        lower: [],
        title: [],
        upper: [],
        fold: 5063,
        foldFull: [
            5063
        ]
    },
    {
        code: 43928,
        lower: [],
        title: [],
        upper: [],
        fold: 5064,
        foldFull: [
            5064
        ]
    },
    {
        code: 43929,
        lower: [],
        title: [],
        upper: [],
        fold: 5065,
        foldFull: [
            5065
        ]
    },
    {
        code: 43930,
        lower: [],
        title: [],
        upper: [],
        fold: 5066,
        foldFull: [
            5066
        ]
    },
    {
        code: 43931,
        lower: [],
        title: [],
        upper: [],
        fold: 5067,
        foldFull: [
            5067
        ]
    },
    {
        code: 43932,
        lower: [],
        title: [],
        upper: [],
        fold: 5068,
        foldFull: [
            5068
        ]
    },
    {
        code: 43933,
        lower: [],
        title: [],
        upper: [],
        fold: 5069,
        foldFull: [
            5069
        ]
    },
    {
        code: 43934,
        lower: [],
        title: [],
        upper: [],
        fold: 5070,
        foldFull: [
            5070
        ]
    },
    {
        code: 43935,
        lower: [],
        title: [],
        upper: [],
        fold: 5071,
        foldFull: [
            5071
        ]
    },
    {
        code: 43936,
        lower: [],
        title: [],
        upper: [],
        fold: 5072,
        foldFull: [
            5072
        ]
    },
    {
        code: 43937,
        lower: [],
        title: [],
        upper: [],
        fold: 5073,
        foldFull: [
            5073
        ]
    },
    {
        code: 43938,
        lower: [],
        title: [],
        upper: [],
        fold: 5074,
        foldFull: [
            5074
        ]
    },
    {
        code: 43939,
        lower: [],
        title: [],
        upper: [],
        fold: 5075,
        foldFull: [
            5075
        ]
    },
    {
        code: 43940,
        lower: [],
        title: [],
        upper: [],
        fold: 5076,
        foldFull: [
            5076
        ]
    },
    {
        code: 43941,
        lower: [],
        title: [],
        upper: [],
        fold: 5077,
        foldFull: [
            5077
        ]
    },
    {
        code: 43942,
        lower: [],
        title: [],
        upper: [],
        fold: 5078,
        foldFull: [
            5078
        ]
    },
    {
        code: 43943,
        lower: [],
        title: [],
        upper: [],
        fold: 5079,
        foldFull: [
            5079
        ]
    },
    {
        code: 43944,
        lower: [],
        title: [],
        upper: [],
        fold: 5080,
        foldFull: [
            5080
        ]
    },
    {
        code: 43945,
        lower: [],
        title: [],
        upper: [],
        fold: 5081,
        foldFull: [
            5081
        ]
    },
    {
        code: 43946,
        lower: [],
        title: [],
        upper: [],
        fold: 5082,
        foldFull: [
            5082
        ]
    },
    {
        code: 43947,
        lower: [],
        title: [],
        upper: [],
        fold: 5083,
        foldFull: [
            5083
        ]
    },
    {
        code: 43948,
        lower: [],
        title: [],
        upper: [],
        fold: 5084,
        foldFull: [
            5084
        ]
    },
    {
        code: 43949,
        lower: [],
        title: [],
        upper: [],
        fold: 5085,
        foldFull: [
            5085
        ]
    },
    {
        code: 43950,
        lower: [],
        title: [],
        upper: [],
        fold: 5086,
        foldFull: [
            5086
        ]
    },
    {
        code: 43951,
        lower: [],
        title: [],
        upper: [],
        fold: 5087,
        foldFull: [
            5087
        ]
    },
    {
        code: 43952,
        lower: [],
        title: [],
        upper: [],
        fold: 5088,
        foldFull: [
            5088
        ]
    },
    {
        code: 43953,
        lower: [],
        title: [],
        upper: [],
        fold: 5089,
        foldFull: [
            5089
        ]
    },
    {
        code: 43954,
        lower: [],
        title: [],
        upper: [],
        fold: 5090,
        foldFull: [
            5090
        ]
    },
    {
        code: 43955,
        lower: [],
        title: [],
        upper: [],
        fold: 5091,
        foldFull: [
            5091
        ]
    },
    {
        code: 43956,
        lower: [],
        title: [],
        upper: [],
        fold: 5092,
        foldFull: [
            5092
        ]
    },
    {
        code: 43957,
        lower: [],
        title: [],
        upper: [],
        fold: 5093,
        foldFull: [
            5093
        ]
    },
    {
        code: 43958,
        lower: [],
        title: [],
        upper: [],
        fold: 5094,
        foldFull: [
            5094
        ]
    },
    {
        code: 43959,
        lower: [],
        title: [],
        upper: [],
        fold: 5095,
        foldFull: [
            5095
        ]
    },
    {
        code: 43960,
        lower: [],
        title: [],
        upper: [],
        fold: 5096,
        foldFull: [
            5096
        ]
    },
    {
        code: 43961,
        lower: [],
        title: [],
        upper: [],
        fold: 5097,
        foldFull: [
            5097
        ]
    },
    {
        code: 43962,
        lower: [],
        title: [],
        upper: [],
        fold: 5098,
        foldFull: [
            5098
        ]
    },
    {
        code: 43963,
        lower: [],
        title: [],
        upper: [],
        fold: 5099,
        foldFull: [
            5099
        ]
    },
    {
        code: 43964,
        lower: [],
        title: [],
        upper: [],
        fold: 5100,
        foldFull: [
            5100
        ]
    },
    {
        code: 43965,
        lower: [],
        title: [],
        upper: [],
        fold: 5101,
        foldFull: [
            5101
        ]
    },
    {
        code: 43966,
        lower: [],
        title: [],
        upper: [],
        fold: 5102,
        foldFull: [
            5102
        ]
    },
    {
        code: 43967,
        lower: [],
        title: [],
        upper: [],
        fold: 5103,
        foldFull: [
            5103
        ]
    },
    {
        code: 64256,
        lower: [
            64256
        ],
        title: [
            70,
            102
        ],
        upper: [
            70,
            70
        ],
        fold: 0,
        foldFull: [
            102,
            102
        ]
    },
    {
        code: 64256,
        lower: [
            64256
        ],
        title: [
            70,
            102
        ],
        upper: [
            70,
            70
        ],
        fold: 0,
        foldFull: [
            102,
            102
        ]
    },
    {
        code: 64257,
        lower: [
            64257
        ],
        title: [
            70,
            105
        ],
        upper: [
            70,
            73
        ],
        fold: 0,
        foldFull: [
            102,
            105
        ]
    },
    {
        code: 64257,
        lower: [
            64257
        ],
        title: [
            70,
            105
        ],
        upper: [
            70,
            73
        ],
        fold: 0,
        foldFull: [
            102,
            105
        ]
    },
    {
        code: 64258,
        lower: [
            64258
        ],
        title: [
            70,
            108
        ],
        upper: [
            70,
            76
        ],
        fold: 0,
        foldFull: [
            102,
            108
        ]
    },
    {
        code: 64258,
        lower: [
            64258
        ],
        title: [
            70,
            108
        ],
        upper: [
            70,
            76
        ],
        fold: 0,
        foldFull: [
            102,
            108
        ]
    },
    {
        code: 64259,
        lower: [
            64259
        ],
        title: [
            70,
            102,
            105
        ],
        upper: [
            70,
            70,
            73
        ],
        fold: 0,
        foldFull: [
            102,
            102,
            105
        ]
    },
    {
        code: 64259,
        lower: [
            64259
        ],
        title: [
            70,
            102,
            105
        ],
        upper: [
            70,
            70,
            73
        ],
        fold: 0,
        foldFull: [
            102,
            102,
            105
        ]
    },
    {
        code: 64260,
        lower: [
            64260
        ],
        title: [
            70,
            102,
            108
        ],
        upper: [
            70,
            70,
            76
        ],
        fold: 0,
        foldFull: [
            102,
            102,
            108
        ]
    },
    {
        code: 64260,
        lower: [
            64260
        ],
        title: [
            70,
            102,
            108
        ],
        upper: [
            70,
            70,
            76
        ],
        fold: 0,
        foldFull: [
            102,
            102,
            108
        ]
    },
    {
        code: 64261,
        lower: [
            64261
        ],
        title: [
            83,
            116
        ],
        upper: [
            83,
            84
        ],
        fold: 0,
        foldFull: [
            115,
            116
        ]
    },
    {
        code: 64261,
        lower: [
            64261
        ],
        title: [
            83,
            116
        ],
        upper: [
            83,
            84
        ],
        fold: 0,
        foldFull: [
            115,
            116
        ]
    },
    {
        code: 64262,
        lower: [
            64262
        ],
        title: [
            83,
            116
        ],
        upper: [
            83,
            84
        ],
        fold: 0,
        foldFull: [
            115,
            116
        ]
    },
    {
        code: 64262,
        lower: [
            64262
        ],
        title: [
            83,
            116
        ],
        upper: [
            83,
            84
        ],
        fold: 0,
        foldFull: [
            115,
            116
        ]
    },
    {
        code: 64275,
        lower: [
            64275
        ],
        title: [
            1348,
            1398
        ],
        upper: [
            1348,
            1350
        ],
        fold: 0,
        foldFull: [
            1396,
            1398
        ]
    },
    {
        code: 64275,
        lower: [
            64275
        ],
        title: [
            1348,
            1398
        ],
        upper: [
            1348,
            1350
        ],
        fold: 0,
        foldFull: [
            1396,
            1398
        ]
    },
    {
        code: 64276,
        lower: [
            64276
        ],
        title: [
            1348,
            1381
        ],
        upper: [
            1348,
            1333
        ],
        fold: 0,
        foldFull: [
            1396,
            1381
        ]
    },
    {
        code: 64276,
        lower: [
            64276
        ],
        title: [
            1348,
            1381
        ],
        upper: [
            1348,
            1333
        ],
        fold: 0,
        foldFull: [
            1396,
            1381
        ]
    },
    {
        code: 64277,
        lower: [
            64277
        ],
        title: [
            1348,
            1387
        ],
        upper: [
            1348,
            1339
        ],
        fold: 0,
        foldFull: [
            1396,
            1387
        ]
    },
    {
        code: 64277,
        lower: [
            64277
        ],
        title: [
            1348,
            1387
        ],
        upper: [
            1348,
            1339
        ],
        fold: 0,
        foldFull: [
            1396,
            1387
        ]
    },
    {
        code: 64278,
        lower: [
            64278
        ],
        title: [
            1358,
            1398
        ],
        upper: [
            1358,
            1350
        ],
        fold: 0,
        foldFull: [
            1406,
            1398
        ]
    },
    {
        code: 64278,
        lower: [
            64278
        ],
        title: [
            1358,
            1398
        ],
        upper: [
            1358,
            1350
        ],
        fold: 0,
        foldFull: [
            1406,
            1398
        ]
    },
    {
        code: 64279,
        lower: [
            64279
        ],
        title: [
            1348,
            1389
        ],
        upper: [
            1348,
            1341
        ],
        fold: 0,
        foldFull: [
            1396,
            1389
        ]
    },
    {
        code: 64279,
        lower: [
            64279
        ],
        title: [
            1348,
            1389
        ],
        upper: [
            1348,
            1341
        ],
        fold: 0,
        foldFull: [
            1396,
            1389
        ]
    },
    {
        code: 65313,
        lower: [],
        title: [],
        upper: [],
        fold: 65345,
        foldFull: [
            65345
        ]
    },
    {
        code: 65314,
        lower: [],
        title: [],
        upper: [],
        fold: 65346,
        foldFull: [
            65346
        ]
    },
    {
        code: 65315,
        lower: [],
        title: [],
        upper: [],
        fold: 65347,
        foldFull: [
            65347
        ]
    },
    {
        code: 65316,
        lower: [],
        title: [],
        upper: [],
        fold: 65348,
        foldFull: [
            65348
        ]
    },
    {
        code: 65317,
        lower: [],
        title: [],
        upper: [],
        fold: 65349,
        foldFull: [
            65349
        ]
    },
    {
        code: 65318,
        lower: [],
        title: [],
        upper: [],
        fold: 65350,
        foldFull: [
            65350
        ]
    },
    {
        code: 65319,
        lower: [],
        title: [],
        upper: [],
        fold: 65351,
        foldFull: [
            65351
        ]
    },
    {
        code: 65320,
        lower: [],
        title: [],
        upper: [],
        fold: 65352,
        foldFull: [
            65352
        ]
    },
    {
        code: 65321,
        lower: [],
        title: [],
        upper: [],
        fold: 65353,
        foldFull: [
            65353
        ]
    },
    {
        code: 65322,
        lower: [],
        title: [],
        upper: [],
        fold: 65354,
        foldFull: [
            65354
        ]
    },
    {
        code: 65323,
        lower: [],
        title: [],
        upper: [],
        fold: 65355,
        foldFull: [
            65355
        ]
    },
    {
        code: 65324,
        lower: [],
        title: [],
        upper: [],
        fold: 65356,
        foldFull: [
            65356
        ]
    },
    {
        code: 65325,
        lower: [],
        title: [],
        upper: [],
        fold: 65357,
        foldFull: [
            65357
        ]
    },
    {
        code: 65326,
        lower: [],
        title: [],
        upper: [],
        fold: 65358,
        foldFull: [
            65358
        ]
    },
    {
        code: 65327,
        lower: [],
        title: [],
        upper: [],
        fold: 65359,
        foldFull: [
            65359
        ]
    },
    {
        code: 65328,
        lower: [],
        title: [],
        upper: [],
        fold: 65360,
        foldFull: [
            65360
        ]
    },
    {
        code: 65329,
        lower: [],
        title: [],
        upper: [],
        fold: 65361,
        foldFull: [
            65361
        ]
    },
    {
        code: 65330,
        lower: [],
        title: [],
        upper: [],
        fold: 65362,
        foldFull: [
            65362
        ]
    },
    {
        code: 65331,
        lower: [],
        title: [],
        upper: [],
        fold: 65363,
        foldFull: [
            65363
        ]
    },
    {
        code: 65332,
        lower: [],
        title: [],
        upper: [],
        fold: 65364,
        foldFull: [
            65364
        ]
    },
    {
        code: 65333,
        lower: [],
        title: [],
        upper: [],
        fold: 65365,
        foldFull: [
            65365
        ]
    },
    {
        code: 65334,
        lower: [],
        title: [],
        upper: [],
        fold: 65366,
        foldFull: [
            65366
        ]
    },
    {
        code: 65335,
        lower: [],
        title: [],
        upper: [],
        fold: 65367,
        foldFull: [
            65367
        ]
    },
    {
        code: 65336,
        lower: [],
        title: [],
        upper: [],
        fold: 65368,
        foldFull: [
            65368
        ]
    },
    {
        code: 65337,
        lower: [],
        title: [],
        upper: [],
        fold: 65369,
        foldFull: [
            65369
        ]
    },
    {
        code: 65338,
        lower: [],
        title: [],
        upper: [],
        fold: 65370,
        foldFull: [
            65370
        ]
    },
    {
        code: 66560,
        lower: [],
        title: [],
        upper: [],
        fold: 66600,
        foldFull: [
            66600
        ]
    },
    {
        code: 66561,
        lower: [],
        title: [],
        upper: [],
        fold: 66601,
        foldFull: [
            66601
        ]
    },
    {
        code: 66562,
        lower: [],
        title: [],
        upper: [],
        fold: 66602,
        foldFull: [
            66602
        ]
    },
    {
        code: 66563,
        lower: [],
        title: [],
        upper: [],
        fold: 66603,
        foldFull: [
            66603
        ]
    },
    {
        code: 66564,
        lower: [],
        title: [],
        upper: [],
        fold: 66604,
        foldFull: [
            66604
        ]
    },
    {
        code: 66565,
        lower: [],
        title: [],
        upper: [],
        fold: 66605,
        foldFull: [
            66605
        ]
    },
    {
        code: 66566,
        lower: [],
        title: [],
        upper: [],
        fold: 66606,
        foldFull: [
            66606
        ]
    },
    {
        code: 66567,
        lower: [],
        title: [],
        upper: [],
        fold: 66607,
        foldFull: [
            66607
        ]
    },
    {
        code: 66568,
        lower: [],
        title: [],
        upper: [],
        fold: 66608,
        foldFull: [
            66608
        ]
    },
    {
        code: 66569,
        lower: [],
        title: [],
        upper: [],
        fold: 66609,
        foldFull: [
            66609
        ]
    },
    {
        code: 66570,
        lower: [],
        title: [],
        upper: [],
        fold: 66610,
        foldFull: [
            66610
        ]
    },
    {
        code: 66571,
        lower: [],
        title: [],
        upper: [],
        fold: 66611,
        foldFull: [
            66611
        ]
    },
    {
        code: 66572,
        lower: [],
        title: [],
        upper: [],
        fold: 66612,
        foldFull: [
            66612
        ]
    },
    {
        code: 66573,
        lower: [],
        title: [],
        upper: [],
        fold: 66613,
        foldFull: [
            66613
        ]
    },
    {
        code: 66574,
        lower: [],
        title: [],
        upper: [],
        fold: 66614,
        foldFull: [
            66614
        ]
    },
    {
        code: 66575,
        lower: [],
        title: [],
        upper: [],
        fold: 66615,
        foldFull: [
            66615
        ]
    },
    {
        code: 66576,
        lower: [],
        title: [],
        upper: [],
        fold: 66616,
        foldFull: [
            66616
        ]
    },
    {
        code: 66577,
        lower: [],
        title: [],
        upper: [],
        fold: 66617,
        foldFull: [
            66617
        ]
    },
    {
        code: 66578,
        lower: [],
        title: [],
        upper: [],
        fold: 66618,
        foldFull: [
            66618
        ]
    },
    {
        code: 66579,
        lower: [],
        title: [],
        upper: [],
        fold: 66619,
        foldFull: [
            66619
        ]
    },
    {
        code: 66580,
        lower: [],
        title: [],
        upper: [],
        fold: 66620,
        foldFull: [
            66620
        ]
    },
    {
        code: 66581,
        lower: [],
        title: [],
        upper: [],
        fold: 66621,
        foldFull: [
            66621
        ]
    },
    {
        code: 66582,
        lower: [],
        title: [],
        upper: [],
        fold: 66622,
        foldFull: [
            66622
        ]
    },
    {
        code: 66583,
        lower: [],
        title: [],
        upper: [],
        fold: 66623,
        foldFull: [
            66623
        ]
    },
    {
        code: 66584,
        lower: [],
        title: [],
        upper: [],
        fold: 66624,
        foldFull: [
            66624
        ]
    },
    {
        code: 66585,
        lower: [],
        title: [],
        upper: [],
        fold: 66625,
        foldFull: [
            66625
        ]
    },
    {
        code: 66586,
        lower: [],
        title: [],
        upper: [],
        fold: 66626,
        foldFull: [
            66626
        ]
    },
    {
        code: 66587,
        lower: [],
        title: [],
        upper: [],
        fold: 66627,
        foldFull: [
            66627
        ]
    },
    {
        code: 66588,
        lower: [],
        title: [],
        upper: [],
        fold: 66628,
        foldFull: [
            66628
        ]
    },
    {
        code: 66589,
        lower: [],
        title: [],
        upper: [],
        fold: 66629,
        foldFull: [
            66629
        ]
    },
    {
        code: 66590,
        lower: [],
        title: [],
        upper: [],
        fold: 66630,
        foldFull: [
            66630
        ]
    },
    {
        code: 66591,
        lower: [],
        title: [],
        upper: [],
        fold: 66631,
        foldFull: [
            66631
        ]
    },
    {
        code: 66592,
        lower: [],
        title: [],
        upper: [],
        fold: 66632,
        foldFull: [
            66632
        ]
    },
    {
        code: 66593,
        lower: [],
        title: [],
        upper: [],
        fold: 66633,
        foldFull: [
            66633
        ]
    },
    {
        code: 66594,
        lower: [],
        title: [],
        upper: [],
        fold: 66634,
        foldFull: [
            66634
        ]
    },
    {
        code: 66595,
        lower: [],
        title: [],
        upper: [],
        fold: 66635,
        foldFull: [
            66635
        ]
    },
    {
        code: 66596,
        lower: [],
        title: [],
        upper: [],
        fold: 66636,
        foldFull: [
            66636
        ]
    },
    {
        code: 66597,
        lower: [],
        title: [],
        upper: [],
        fold: 66637,
        foldFull: [
            66637
        ]
    },
    {
        code: 66598,
        lower: [],
        title: [],
        upper: [],
        fold: 66638,
        foldFull: [
            66638
        ]
    },
    {
        code: 66599,
        lower: [],
        title: [],
        upper: [],
        fold: 66639,
        foldFull: [
            66639
        ]
    },
    {
        code: 66736,
        lower: [],
        title: [],
        upper: [],
        fold: 66776,
        foldFull: [
            66776
        ]
    },
    {
        code: 66737,
        lower: [],
        title: [],
        upper: [],
        fold: 66777,
        foldFull: [
            66777
        ]
    },
    {
        code: 66738,
        lower: [],
        title: [],
        upper: [],
        fold: 66778,
        foldFull: [
            66778
        ]
    },
    {
        code: 66739,
        lower: [],
        title: [],
        upper: [],
        fold: 66779,
        foldFull: [
            66779
        ]
    },
    {
        code: 66740,
        lower: [],
        title: [],
        upper: [],
        fold: 66780,
        foldFull: [
            66780
        ]
    },
    {
        code: 66741,
        lower: [],
        title: [],
        upper: [],
        fold: 66781,
        foldFull: [
            66781
        ]
    },
    {
        code: 66742,
        lower: [],
        title: [],
        upper: [],
        fold: 66782,
        foldFull: [
            66782
        ]
    },
    {
        code: 66743,
        lower: [],
        title: [],
        upper: [],
        fold: 66783,
        foldFull: [
            66783
        ]
    },
    {
        code: 66744,
        lower: [],
        title: [],
        upper: [],
        fold: 66784,
        foldFull: [
            66784
        ]
    },
    {
        code: 66745,
        lower: [],
        title: [],
        upper: [],
        fold: 66785,
        foldFull: [
            66785
        ]
    },
    {
        code: 66746,
        lower: [],
        title: [],
        upper: [],
        fold: 66786,
        foldFull: [
            66786
        ]
    },
    {
        code: 66747,
        lower: [],
        title: [],
        upper: [],
        fold: 66787,
        foldFull: [
            66787
        ]
    },
    {
        code: 66748,
        lower: [],
        title: [],
        upper: [],
        fold: 66788,
        foldFull: [
            66788
        ]
    },
    {
        code: 66749,
        lower: [],
        title: [],
        upper: [],
        fold: 66789,
        foldFull: [
            66789
        ]
    },
    {
        code: 66750,
        lower: [],
        title: [],
        upper: [],
        fold: 66790,
        foldFull: [
            66790
        ]
    },
    {
        code: 66751,
        lower: [],
        title: [],
        upper: [],
        fold: 66791,
        foldFull: [
            66791
        ]
    },
    {
        code: 66752,
        lower: [],
        title: [],
        upper: [],
        fold: 66792,
        foldFull: [
            66792
        ]
    },
    {
        code: 66753,
        lower: [],
        title: [],
        upper: [],
        fold: 66793,
        foldFull: [
            66793
        ]
    },
    {
        code: 66754,
        lower: [],
        title: [],
        upper: [],
        fold: 66794,
        foldFull: [
            66794
        ]
    },
    {
        code: 66755,
        lower: [],
        title: [],
        upper: [],
        fold: 66795,
        foldFull: [
            66795
        ]
    },
    {
        code: 66756,
        lower: [],
        title: [],
        upper: [],
        fold: 66796,
        foldFull: [
            66796
        ]
    },
    {
        code: 66757,
        lower: [],
        title: [],
        upper: [],
        fold: 66797,
        foldFull: [
            66797
        ]
    },
    {
        code: 66758,
        lower: [],
        title: [],
        upper: [],
        fold: 66798,
        foldFull: [
            66798
        ]
    },
    {
        code: 66759,
        lower: [],
        title: [],
        upper: [],
        fold: 66799,
        foldFull: [
            66799
        ]
    },
    {
        code: 66760,
        lower: [],
        title: [],
        upper: [],
        fold: 66800,
        foldFull: [
            66800
        ]
    },
    {
        code: 66761,
        lower: [],
        title: [],
        upper: [],
        fold: 66801,
        foldFull: [
            66801
        ]
    },
    {
        code: 66762,
        lower: [],
        title: [],
        upper: [],
        fold: 66802,
        foldFull: [
            66802
        ]
    },
    {
        code: 66763,
        lower: [],
        title: [],
        upper: [],
        fold: 66803,
        foldFull: [
            66803
        ]
    },
    {
        code: 66764,
        lower: [],
        title: [],
        upper: [],
        fold: 66804,
        foldFull: [
            66804
        ]
    },
    {
        code: 66765,
        lower: [],
        title: [],
        upper: [],
        fold: 66805,
        foldFull: [
            66805
        ]
    },
    {
        code: 66766,
        lower: [],
        title: [],
        upper: [],
        fold: 66806,
        foldFull: [
            66806
        ]
    },
    {
        code: 66767,
        lower: [],
        title: [],
        upper: [],
        fold: 66807,
        foldFull: [
            66807
        ]
    },
    {
        code: 66768,
        lower: [],
        title: [],
        upper: [],
        fold: 66808,
        foldFull: [
            66808
        ]
    },
    {
        code: 66769,
        lower: [],
        title: [],
        upper: [],
        fold: 66809,
        foldFull: [
            66809
        ]
    },
    {
        code: 66770,
        lower: [],
        title: [],
        upper: [],
        fold: 66810,
        foldFull: [
            66810
        ]
    },
    {
        code: 66771,
        lower: [],
        title: [],
        upper: [],
        fold: 66811,
        foldFull: [
            66811
        ]
    },
    {
        code: 68736,
        lower: [],
        title: [],
        upper: [],
        fold: 68800,
        foldFull: [
            68800
        ]
    },
    {
        code: 68737,
        lower: [],
        title: [],
        upper: [],
        fold: 68801,
        foldFull: [
            68801
        ]
    },
    {
        code: 68738,
        lower: [],
        title: [],
        upper: [],
        fold: 68802,
        foldFull: [
            68802
        ]
    },
    {
        code: 68739,
        lower: [],
        title: [],
        upper: [],
        fold: 68803,
        foldFull: [
            68803
        ]
    },
    {
        code: 68740,
        lower: [],
        title: [],
        upper: [],
        fold: 68804,
        foldFull: [
            68804
        ]
    },
    {
        code: 68741,
        lower: [],
        title: [],
        upper: [],
        fold: 68805,
        foldFull: [
            68805
        ]
    },
    {
        code: 68742,
        lower: [],
        title: [],
        upper: [],
        fold: 68806,
        foldFull: [
            68806
        ]
    },
    {
        code: 68743,
        lower: [],
        title: [],
        upper: [],
        fold: 68807,
        foldFull: [
            68807
        ]
    },
    {
        code: 68744,
        lower: [],
        title: [],
        upper: [],
        fold: 68808,
        foldFull: [
            68808
        ]
    },
    {
        code: 68745,
        lower: [],
        title: [],
        upper: [],
        fold: 68809,
        foldFull: [
            68809
        ]
    },
    {
        code: 68746,
        lower: [],
        title: [],
        upper: [],
        fold: 68810,
        foldFull: [
            68810
        ]
    },
    {
        code: 68747,
        lower: [],
        title: [],
        upper: [],
        fold: 68811,
        foldFull: [
            68811
        ]
    },
    {
        code: 68748,
        lower: [],
        title: [],
        upper: [],
        fold: 68812,
        foldFull: [
            68812
        ]
    },
    {
        code: 68749,
        lower: [],
        title: [],
        upper: [],
        fold: 68813,
        foldFull: [
            68813
        ]
    },
    {
        code: 68750,
        lower: [],
        title: [],
        upper: [],
        fold: 68814,
        foldFull: [
            68814
        ]
    },
    {
        code: 68751,
        lower: [],
        title: [],
        upper: [],
        fold: 68815,
        foldFull: [
            68815
        ]
    },
    {
        code: 68752,
        lower: [],
        title: [],
        upper: [],
        fold: 68816,
        foldFull: [
            68816
        ]
    },
    {
        code: 68753,
        lower: [],
        title: [],
        upper: [],
        fold: 68817,
        foldFull: [
            68817
        ]
    },
    {
        code: 68754,
        lower: [],
        title: [],
        upper: [],
        fold: 68818,
        foldFull: [
            68818
        ]
    },
    {
        code: 68755,
        lower: [],
        title: [],
        upper: [],
        fold: 68819,
        foldFull: [
            68819
        ]
    },
    {
        code: 68756,
        lower: [],
        title: [],
        upper: [],
        fold: 68820,
        foldFull: [
            68820
        ]
    },
    {
        code: 68757,
        lower: [],
        title: [],
        upper: [],
        fold: 68821,
        foldFull: [
            68821
        ]
    },
    {
        code: 68758,
        lower: [],
        title: [],
        upper: [],
        fold: 68822,
        foldFull: [
            68822
        ]
    },
    {
        code: 68759,
        lower: [],
        title: [],
        upper: [],
        fold: 68823,
        foldFull: [
            68823
        ]
    },
    {
        code: 68760,
        lower: [],
        title: [],
        upper: [],
        fold: 68824,
        foldFull: [
            68824
        ]
    },
    {
        code: 68761,
        lower: [],
        title: [],
        upper: [],
        fold: 68825,
        foldFull: [
            68825
        ]
    },
    {
        code: 68762,
        lower: [],
        title: [],
        upper: [],
        fold: 68826,
        foldFull: [
            68826
        ]
    },
    {
        code: 68763,
        lower: [],
        title: [],
        upper: [],
        fold: 68827,
        foldFull: [
            68827
        ]
    },
    {
        code: 68764,
        lower: [],
        title: [],
        upper: [],
        fold: 68828,
        foldFull: [
            68828
        ]
    },
    {
        code: 68765,
        lower: [],
        title: [],
        upper: [],
        fold: 68829,
        foldFull: [
            68829
        ]
    },
    {
        code: 68766,
        lower: [],
        title: [],
        upper: [],
        fold: 68830,
        foldFull: [
            68830
        ]
    },
    {
        code: 68767,
        lower: [],
        title: [],
        upper: [],
        fold: 68831,
        foldFull: [
            68831
        ]
    },
    {
        code: 68768,
        lower: [],
        title: [],
        upper: [],
        fold: 68832,
        foldFull: [
            68832
        ]
    },
    {
        code: 68769,
        lower: [],
        title: [],
        upper: [],
        fold: 68833,
        foldFull: [
            68833
        ]
    },
    {
        code: 68770,
        lower: [],
        title: [],
        upper: [],
        fold: 68834,
        foldFull: [
            68834
        ]
    },
    {
        code: 68771,
        lower: [],
        title: [],
        upper: [],
        fold: 68835,
        foldFull: [
            68835
        ]
    },
    {
        code: 68772,
        lower: [],
        title: [],
        upper: [],
        fold: 68836,
        foldFull: [
            68836
        ]
    },
    {
        code: 68773,
        lower: [],
        title: [],
        upper: [],
        fold: 68837,
        foldFull: [
            68837
        ]
    },
    {
        code: 68774,
        lower: [],
        title: [],
        upper: [],
        fold: 68838,
        foldFull: [
            68838
        ]
    },
    {
        code: 68775,
        lower: [],
        title: [],
        upper: [],
        fold: 68839,
        foldFull: [
            68839
        ]
    },
    {
        code: 68776,
        lower: [],
        title: [],
        upper: [],
        fold: 68840,
        foldFull: [
            68840
        ]
    },
    {
        code: 68777,
        lower: [],
        title: [],
        upper: [],
        fold: 68841,
        foldFull: [
            68841
        ]
    },
    {
        code: 68778,
        lower: [],
        title: [],
        upper: [],
        fold: 68842,
        foldFull: [
            68842
        ]
    },
    {
        code: 68779,
        lower: [],
        title: [],
        upper: [],
        fold: 68843,
        foldFull: [
            68843
        ]
    },
    {
        code: 68780,
        lower: [],
        title: [],
        upper: [],
        fold: 68844,
        foldFull: [
            68844
        ]
    },
    {
        code: 68781,
        lower: [],
        title: [],
        upper: [],
        fold: 68845,
        foldFull: [
            68845
        ]
    },
    {
        code: 68782,
        lower: [],
        title: [],
        upper: [],
        fold: 68846,
        foldFull: [
            68846
        ]
    },
    {
        code: 68783,
        lower: [],
        title: [],
        upper: [],
        fold: 68847,
        foldFull: [
            68847
        ]
    },
    {
        code: 68784,
        lower: [],
        title: [],
        upper: [],
        fold: 68848,
        foldFull: [
            68848
        ]
    },
    {
        code: 68785,
        lower: [],
        title: [],
        upper: [],
        fold: 68849,
        foldFull: [
            68849
        ]
    },
    {
        code: 68786,
        lower: [],
        title: [],
        upper: [],
        fold: 68850,
        foldFull: [
            68850
        ]
    },
    {
        code: 71840,
        lower: [],
        title: [],
        upper: [],
        fold: 71872,
        foldFull: [
            71872
        ]
    },
    {
        code: 71841,
        lower: [],
        title: [],
        upper: [],
        fold: 71873,
        foldFull: [
            71873
        ]
    },
    {
        code: 71842,
        lower: [],
        title: [],
        upper: [],
        fold: 71874,
        foldFull: [
            71874
        ]
    },
    {
        code: 71843,
        lower: [],
        title: [],
        upper: [],
        fold: 71875,
        foldFull: [
            71875
        ]
    },
    {
        code: 71844,
        lower: [],
        title: [],
        upper: [],
        fold: 71876,
        foldFull: [
            71876
        ]
    },
    {
        code: 71845,
        lower: [],
        title: [],
        upper: [],
        fold: 71877,
        foldFull: [
            71877
        ]
    },
    {
        code: 71846,
        lower: [],
        title: [],
        upper: [],
        fold: 71878,
        foldFull: [
            71878
        ]
    },
    {
        code: 71847,
        lower: [],
        title: [],
        upper: [],
        fold: 71879,
        foldFull: [
            71879
        ]
    },
    {
        code: 71848,
        lower: [],
        title: [],
        upper: [],
        fold: 71880,
        foldFull: [
            71880
        ]
    },
    {
        code: 71849,
        lower: [],
        title: [],
        upper: [],
        fold: 71881,
        foldFull: [
            71881
        ]
    },
    {
        code: 71850,
        lower: [],
        title: [],
        upper: [],
        fold: 71882,
        foldFull: [
            71882
        ]
    },
    {
        code: 71851,
        lower: [],
        title: [],
        upper: [],
        fold: 71883,
        foldFull: [
            71883
        ]
    },
    {
        code: 71852,
        lower: [],
        title: [],
        upper: [],
        fold: 71884,
        foldFull: [
            71884
        ]
    },
    {
        code: 71853,
        lower: [],
        title: [],
        upper: [],
        fold: 71885,
        foldFull: [
            71885
        ]
    },
    {
        code: 71854,
        lower: [],
        title: [],
        upper: [],
        fold: 71886,
        foldFull: [
            71886
        ]
    },
    {
        code: 71855,
        lower: [],
        title: [],
        upper: [],
        fold: 71887,
        foldFull: [
            71887
        ]
    },
    {
        code: 71856,
        lower: [],
        title: [],
        upper: [],
        fold: 71888,
        foldFull: [
            71888
        ]
    },
    {
        code: 71857,
        lower: [],
        title: [],
        upper: [],
        fold: 71889,
        foldFull: [
            71889
        ]
    },
    {
        code: 71858,
        lower: [],
        title: [],
        upper: [],
        fold: 71890,
        foldFull: [
            71890
        ]
    },
    {
        code: 71859,
        lower: [],
        title: [],
        upper: [],
        fold: 71891,
        foldFull: [
            71891
        ]
    },
    {
        code: 71860,
        lower: [],
        title: [],
        upper: [],
        fold: 71892,
        foldFull: [
            71892
        ]
    },
    {
        code: 71861,
        lower: [],
        title: [],
        upper: [],
        fold: 71893,
        foldFull: [
            71893
        ]
    },
    {
        code: 71862,
        lower: [],
        title: [],
        upper: [],
        fold: 71894,
        foldFull: [
            71894
        ]
    },
    {
        code: 71863,
        lower: [],
        title: [],
        upper: [],
        fold: 71895,
        foldFull: [
            71895
        ]
    },
    {
        code: 71864,
        lower: [],
        title: [],
        upper: [],
        fold: 71896,
        foldFull: [
            71896
        ]
    },
    {
        code: 71865,
        lower: [],
        title: [],
        upper: [],
        fold: 71897,
        foldFull: [
            71897
        ]
    },
    {
        code: 71866,
        lower: [],
        title: [],
        upper: [],
        fold: 71898,
        foldFull: [
            71898
        ]
    },
    {
        code: 71867,
        lower: [],
        title: [],
        upper: [],
        fold: 71899,
        foldFull: [
            71899
        ]
    },
    {
        code: 71868,
        lower: [],
        title: [],
        upper: [],
        fold: 71900,
        foldFull: [
            71900
        ]
    },
    {
        code: 71869,
        lower: [],
        title: [],
        upper: [],
        fold: 71901,
        foldFull: [
            71901
        ]
    },
    {
        code: 71870,
        lower: [],
        title: [],
        upper: [],
        fold: 71902,
        foldFull: [
            71902
        ]
    },
    {
        code: 71871,
        lower: [],
        title: [],
        upper: [],
        fold: 71903,
        foldFull: [
            71903
        ]
    },
    {
        code: 93760,
        lower: [],
        title: [],
        upper: [],
        fold: 93792,
        foldFull: [
            93792
        ]
    },
    {
        code: 93761,
        lower: [],
        title: [],
        upper: [],
        fold: 93793,
        foldFull: [
            93793
        ]
    },
    {
        code: 93762,
        lower: [],
        title: [],
        upper: [],
        fold: 93794,
        foldFull: [
            93794
        ]
    },
    {
        code: 93763,
        lower: [],
        title: [],
        upper: [],
        fold: 93795,
        foldFull: [
            93795
        ]
    },
    {
        code: 93764,
        lower: [],
        title: [],
        upper: [],
        fold: 93796,
        foldFull: [
            93796
        ]
    },
    {
        code: 93765,
        lower: [],
        title: [],
        upper: [],
        fold: 93797,
        foldFull: [
            93797
        ]
    },
    {
        code: 93766,
        lower: [],
        title: [],
        upper: [],
        fold: 93798,
        foldFull: [
            93798
        ]
    },
    {
        code: 93767,
        lower: [],
        title: [],
        upper: [],
        fold: 93799,
        foldFull: [
            93799
        ]
    },
    {
        code: 93768,
        lower: [],
        title: [],
        upper: [],
        fold: 93800,
        foldFull: [
            93800
        ]
    },
    {
        code: 93769,
        lower: [],
        title: [],
        upper: [],
        fold: 93801,
        foldFull: [
            93801
        ]
    },
    {
        code: 93770,
        lower: [],
        title: [],
        upper: [],
        fold: 93802,
        foldFull: [
            93802
        ]
    },
    {
        code: 93771,
        lower: [],
        title: [],
        upper: [],
        fold: 93803,
        foldFull: [
            93803
        ]
    },
    {
        code: 93772,
        lower: [],
        title: [],
        upper: [],
        fold: 93804,
        foldFull: [
            93804
        ]
    },
    {
        code: 93773,
        lower: [],
        title: [],
        upper: [],
        fold: 93805,
        foldFull: [
            93805
        ]
    },
    {
        code: 93774,
        lower: [],
        title: [],
        upper: [],
        fold: 93806,
        foldFull: [
            93806
        ]
    },
    {
        code: 93775,
        lower: [],
        title: [],
        upper: [],
        fold: 93807,
        foldFull: [
            93807
        ]
    },
    {
        code: 93776,
        lower: [],
        title: [],
        upper: [],
        fold: 93808,
        foldFull: [
            93808
        ]
    },
    {
        code: 93777,
        lower: [],
        title: [],
        upper: [],
        fold: 93809,
        foldFull: [
            93809
        ]
    },
    {
        code: 93778,
        lower: [],
        title: [],
        upper: [],
        fold: 93810,
        foldFull: [
            93810
        ]
    },
    {
        code: 93779,
        lower: [],
        title: [],
        upper: [],
        fold: 93811,
        foldFull: [
            93811
        ]
    },
    {
        code: 93780,
        lower: [],
        title: [],
        upper: [],
        fold: 93812,
        foldFull: [
            93812
        ]
    },
    {
        code: 93781,
        lower: [],
        title: [],
        upper: [],
        fold: 93813,
        foldFull: [
            93813
        ]
    },
    {
        code: 93782,
        lower: [],
        title: [],
        upper: [],
        fold: 93814,
        foldFull: [
            93814
        ]
    },
    {
        code: 93783,
        lower: [],
        title: [],
        upper: [],
        fold: 93815,
        foldFull: [
            93815
        ]
    },
    {
        code: 93784,
        lower: [],
        title: [],
        upper: [],
        fold: 93816,
        foldFull: [
            93816
        ]
    },
    {
        code: 93785,
        lower: [],
        title: [],
        upper: [],
        fold: 93817,
        foldFull: [
            93817
        ]
    },
    {
        code: 93786,
        lower: [],
        title: [],
        upper: [],
        fold: 93818,
        foldFull: [
            93818
        ]
    },
    {
        code: 93787,
        lower: [],
        title: [],
        upper: [],
        fold: 93819,
        foldFull: [
            93819
        ]
    },
    {
        code: 93788,
        lower: [],
        title: [],
        upper: [],
        fold: 93820,
        foldFull: [
            93820
        ]
    },
    {
        code: 93789,
        lower: [],
        title: [],
        upper: [],
        fold: 93821,
        foldFull: [
            93821
        ]
    },
    {
        code: 93790,
        lower: [],
        title: [],
        upper: [],
        fold: 93822,
        foldFull: [
            93822
        ]
    },
    {
        code: 93791,
        lower: [],
        title: [],
        upper: [],
        fold: 93823,
        foldFull: [
            93823
        ]
    },
    {
        code: 125184,
        lower: [],
        title: [],
        upper: [],
        fold: 125218,
        foldFull: [
            125218
        ]
    },
    {
        code: 125185,
        lower: [],
        title: [],
        upper: [],
        fold: 125219,
        foldFull: [
            125219
        ]
    },
    {
        code: 125186,
        lower: [],
        title: [],
        upper: [],
        fold: 125220,
        foldFull: [
            125220
        ]
    },
    {
        code: 125187,
        lower: [],
        title: [],
        upper: [],
        fold: 125221,
        foldFull: [
            125221
        ]
    },
    {
        code: 125188,
        lower: [],
        title: [],
        upper: [],
        fold: 125222,
        foldFull: [
            125222
        ]
    },
    {
        code: 125189,
        lower: [],
        title: [],
        upper: [],
        fold: 125223,
        foldFull: [
            125223
        ]
    },
    {
        code: 125190,
        lower: [],
        title: [],
        upper: [],
        fold: 125224,
        foldFull: [
            125224
        ]
    },
    {
        code: 125191,
        lower: [],
        title: [],
        upper: [],
        fold: 125225,
        foldFull: [
            125225
        ]
    },
    {
        code: 125192,
        lower: [],
        title: [],
        upper: [],
        fold: 125226,
        foldFull: [
            125226
        ]
    },
    {
        code: 125193,
        lower: [],
        title: [],
        upper: [],
        fold: 125227,
        foldFull: [
            125227
        ]
    },
    {
        code: 125194,
        lower: [],
        title: [],
        upper: [],
        fold: 125228,
        foldFull: [
            125228
        ]
    },
    {
        code: 125195,
        lower: [],
        title: [],
        upper: [],
        fold: 125229,
        foldFull: [
            125229
        ]
    },
    {
        code: 125196,
        lower: [],
        title: [],
        upper: [],
        fold: 125230,
        foldFull: [
            125230
        ]
    },
    {
        code: 125197,
        lower: [],
        title: [],
        upper: [],
        fold: 125231,
        foldFull: [
            125231
        ]
    },
    {
        code: 125198,
        lower: [],
        title: [],
        upper: [],
        fold: 125232,
        foldFull: [
            125232
        ]
    },
    {
        code: 125199,
        lower: [],
        title: [],
        upper: [],
        fold: 125233,
        foldFull: [
            125233
        ]
    },
    {
        code: 125200,
        lower: [],
        title: [],
        upper: [],
        fold: 125234,
        foldFull: [
            125234
        ]
    },
    {
        code: 125201,
        lower: [],
        title: [],
        upper: [],
        fold: 125235,
        foldFull: [
            125235
        ]
    },
    {
        code: 125202,
        lower: [],
        title: [],
        upper: [],
        fold: 125236,
        foldFull: [
            125236
        ]
    },
    {
        code: 125203,
        lower: [],
        title: [],
        upper: [],
        fold: 125237,
        foldFull: [
            125237
        ]
    },
    {
        code: 125204,
        lower: [],
        title: [],
        upper: [],
        fold: 125238,
        foldFull: [
            125238
        ]
    },
    {
        code: 125205,
        lower: [],
        title: [],
        upper: [],
        fold: 125239,
        foldFull: [
            125239
        ]
    },
    {
        code: 125206,
        lower: [],
        title: [],
        upper: [],
        fold: 125240,
        foldFull: [
            125240
        ]
    },
    {
        code: 125207,
        lower: [],
        title: [],
        upper: [],
        fold: 125241,
        foldFull: [
            125241
        ]
    },
    {
        code: 125208,
        lower: [],
        title: [],
        upper: [],
        fold: 125242,
        foldFull: [
            125242
        ]
    },
    {
        code: 125209,
        lower: [],
        title: [],
        upper: [],
        fold: 125243,
        foldFull: [
            125243
        ]
    },
    {
        code: 125210,
        lower: [],
        title: [],
        upper: [],
        fold: 125244,
        foldFull: [
            125244
        ]
    },
    {
        code: 125211,
        lower: [],
        title: [],
        upper: [],
        fold: 125245,
        foldFull: [
            125245
        ]
    },
    {
        code: 125212,
        lower: [],
        title: [],
        upper: [],
        fold: 125246,
        foldFull: [
            125246
        ]
    },
    {
        code: 125213,
        lower: [],
        title: [],
        upper: [],
        fold: 125247,
        foldFull: [
            125247
        ]
    },
    {
        code: 125214,
        lower: [],
        title: [],
        upper: [],
        fold: 125248,
        foldFull: [
            125248
        ]
    },
    {
        code: 125215,
        lower: [],
        title: [],
        upper: [],
        fold: 125249,
        foldFull: [
            125249
        ]
    },
    {
        code: 125216,
        lower: [],
        title: [],
        upper: [],
        fold: 125250,
        foldFull: [
            125250
        ]
    },
    {
        code: 125217,
        lower: [],
        title: [],
        upper: [],
        fold: 125251,
        foldFull: [
            125251
        ]
    }
];
var $7b07f9d0d04434a1$export$11ed315285584913 = function(v) {
    return function(v1) {
        return $7b07f9d0d04434a1$var$compare(v.code)(v1.code);
    };
};
var $7b07f9d0d04434a1$export$19817ff19468d542 = function(code) {
    var v = $lkGFT.bsearch($7b07f9d0d04434a1$export$b6e1a177a4bea09c(code))($7b07f9d0d04434a1$export$354076178bdef094)($lGiKR.length($7b07f9d0d04434a1$export$354076178bdef094))($7b07f9d0d04434a1$export$11ed315285584913);
    if (v instanceof $ykHdR.Nothing) return $7b07f9d0d04434a1$export$b6e1a177a4bea09c(code);
    if (v instanceof $ykHdR.Just) return v.value0;
    throw new Error("Failed pattern match at Data.CodePoint.Unicode.Internal.Casing (line 1627, column 17 - line 1629, column 14): " + [
        v.constructor.name
    ]);
};
var $7b07f9d0d04434a1$export$93e2b83da34ff82a = function(code) {
    var folded = $7b07f9d0d04434a1$export$19817ff19468d542(code).fold;
    var $11 = folded === 0;
    if ($11) return $lkGFT.uTowlower(code);
    return folded;
};
var $7b07f9d0d04434a1$export$c86ab0718f163a93 = function(code) {
    var folded = $7b07f9d0d04434a1$export$19817ff19468d542(code).foldFull;
    var $12 = $4VF0K.null(folded);
    if ($12) return [
        $lkGFT.uTowlower(code)
    ];
    return folded;
};
var $7b07f9d0d04434a1$export$abae053c7acf36bb = function(code) {
    var lowered = $7b07f9d0d04434a1$export$19817ff19468d542(code).lower;
    var $13 = $4VF0K.null(lowered);
    if ($13) return [
        $lkGFT.uTowlower(code)
    ];
    return lowered;
};
var $7b07f9d0d04434a1$export$fb184b623420d9be = function(code) {
    var titled = $7b07f9d0d04434a1$export$19817ff19468d542(code).title;
    var $14 = $4VF0K.null(titled);
    if ($14) return [
        $lkGFT.uTowtitle(code)
    ];
    return titled;
};
var $7b07f9d0d04434a1$export$74b75dbc6083f1f5 = function(code) {
    var uppered = $7b07f9d0d04434a1$export$19817ff19468d542(code).upper;
    var $15 = $4VF0K.null(uppered);
    if ($15) return [
        $lkGFT.uTowupper(code)
    ];
    return uppered;
};

});

parcelRegister("5oIYL", function(module, exports) {

$parcel$export(module.exports, "showCodePoint", () => $3ee2158c14339cc9$export$1e278a1fb25ff338);
$parcel$export(module.exports, "uncons", () => $3ee2158c14339cc9$export$b446f6baa3bb1430);
$parcel$export(module.exports, "toCodePointArray", () => $3ee2158c14339cc9$export$50a427d3c041e0d2);
$parcel$export(module.exports, "length", () => $3ee2158c14339cc9$export$f24224f1c91d8156);
$parcel$export(module.exports, "fromCodePointArray", () => $3ee2158c14339cc9$export$6fadda5ad927586c);
$parcel$export(module.exports, "singleton", () => $3ee2158c14339cc9$export$439306a4dcaafbb9);
$parcel$export(module.exports, "take", () => $3ee2158c14339cc9$export$b7df5d561049483a);
$parcel$export(module.exports, "splitAt", () => $3ee2158c14339cc9$export$b0d75975ac0be0e1);
$parcel$export(module.exports, "eqCodePoint", () => $3ee2158c14339cc9$export$e200a5917becef04);
$parcel$export(module.exports, "ordCodePoint", () => $3ee2158c14339cc9$export$b08a820ff2b5847d);
$parcel$export(module.exports, "drop", () => $3ee2158c14339cc9$export$663103110d94aac9);
$parcel$export(module.exports, "takeWhile", () => $3ee2158c14339cc9$export$9384c7afe4015e42);
$parcel$export(module.exports, "codePointFromChar", () => $3ee2158c14339cc9$export$dd1029f96c3dd62a);
$parcel$export(module.exports, "codePointAt", () => $3ee2158c14339cc9$export$42977f40461e1360);
$parcel$export(module.exports, "boundedEnumCodePoint", () => $3ee2158c14339cc9$export$2a3400c6862992c1);
// Generated by purs version 0.15.16

var $gsMIK = parcelRequire("gsMIK");
parcelRequire("4VF0K");
var $lGiKR = parcelRequire("lGiKR");

var $6UHO6 = parcelRequire("6UHO6");

var $95fRU = parcelRequire("95fRU");

var $loxi1 = parcelRequire("loxi1");

var $fb7aO = parcelRequire("fb7aO");

var $l0wDR = parcelRequire("l0wDR");

var $c8kPS = parcelRequire("c8kPS");
var $6pI6x = parcelRequire("6pI6x");

var $ykHdR = parcelRequire("ykHdR");

var $d0PPW = parcelRequire("d0PPW");
parcelRequire("2gT7Y");
var $MTXA4 = parcelRequire("MTXA4");
var $2gT7Y = parcelRequire("2gT7Y");
parcelRequire("2Zpo4");
var $7OyoZ = parcelRequire("7OyoZ");
parcelRequire("jUjvc");
var $4lhF1 = parcelRequire("4lhF1");

var $9MxTl = parcelRequire("9MxTl");

var $hsyEi = parcelRequire("hsyEi");
var $3ee2158c14339cc9$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $3ee2158c14339cc9$var$fromEnum = /* #__PURE__ */ $loxi1.fromEnum($loxi1.boundedEnumChar);
var $3ee2158c14339cc9$var$map = /* #__PURE__ */ $l0wDR.map($ykHdR.functorMaybe);
var $3ee2158c14339cc9$var$unfoldr = /* #__PURE__ */ $hsyEi.unfoldr($hsyEi.unfoldableArray);
var $3ee2158c14339cc9$var$div = /* #__PURE__ */ $fb7aO.div($fb7aO.euclideanRingInt);
var $3ee2158c14339cc9$var$mod = /* #__PURE__ */ $fb7aO.mod($fb7aO.euclideanRingInt);
var $3ee2158c14339cc9$var$compare = /* #__PURE__ */ $d0PPW.compare($d0PPW.ordInt);
var $3ee2158c14339cc9$var$CodePoint = function(x) {
    return x;
};
var $3ee2158c14339cc9$var$unsurrogate = function(lead) {
    return function(trail) {
        return (((lead - 55296 | 0) * 1024 | 0) + (trail - 56320 | 0) | 0) + 65536 | 0;
    };
};
var $3ee2158c14339cc9$export$1e278a1fb25ff338 = {
    show: function(v) {
        return "(CodePoint 0x" + ($7OyoZ.toUpper($6pI6x.toStringAs($c8kPS.hexadecimal)(v)) + ")");
    }
};
var $3ee2158c14339cc9$var$isTrail = function(cu) {
    return 56320 <= cu && cu <= 57343;
};
var $3ee2158c14339cc9$var$isLead = function(cu) {
    return 55296 <= cu && cu <= 56319;
};
var $3ee2158c14339cc9$export$b446f6baa3bb1430 = function(s) {
    var v = $MTXA4.length(s);
    if (v === 0) return $ykHdR.Nothing.value;
    if (v === 1) return new $ykHdR.Just({
        head: $3ee2158c14339cc9$var$fromEnum($4lhF1.charAt(0)(s)),
        tail: ""
    });
    var cu1 = $3ee2158c14339cc9$var$fromEnum($4lhF1.charAt(1)(s));
    var cu0 = $3ee2158c14339cc9$var$fromEnum($4lhF1.charAt(0)(s));
    var $43 = $3ee2158c14339cc9$var$isLead(cu0) && $3ee2158c14339cc9$var$isTrail(cu1);
    if ($43) return new $ykHdR.Just({
        head: $3ee2158c14339cc9$var$unsurrogate(cu0)(cu1),
        tail: $MTXA4.drop(2)(s)
    });
    return new $ykHdR.Just({
        head: cu0,
        tail: $MTXA4.drop(1)(s)
    });
};
var $3ee2158c14339cc9$var$unconsButWithTuple = function(s) {
    return $3ee2158c14339cc9$var$map(function(v) {
        return new $9MxTl.Tuple(v.head, v.tail);
    })($3ee2158c14339cc9$export$b446f6baa3bb1430(s));
};
var $3ee2158c14339cc9$var$toCodePointArrayFallback = function(s) {
    return $3ee2158c14339cc9$var$unfoldr($3ee2158c14339cc9$var$unconsButWithTuple)(s);
};
var $3ee2158c14339cc9$var$unsafeCodePointAt0Fallback = function(s) {
    var cu0 = $3ee2158c14339cc9$var$fromEnum($4lhF1.charAt(0)(s));
    var $47 = $3ee2158c14339cc9$var$isLead(cu0) && $MTXA4.length(s) > 1;
    if ($47) {
        var cu1 = $3ee2158c14339cc9$var$fromEnum($4lhF1.charAt(1)(s));
        var $48 = $3ee2158c14339cc9$var$isTrail(cu1);
        if ($48) return $3ee2158c14339cc9$var$unsurrogate(cu0)(cu1);
        return cu0;
    }
    return cu0;
};
var $3ee2158c14339cc9$var$unsafeCodePointAt0 = /* #__PURE__ */ $gsMIK._unsafeCodePointAt0($3ee2158c14339cc9$var$unsafeCodePointAt0Fallback);
var $3ee2158c14339cc9$export$50a427d3c041e0d2 = /* #__PURE__ */ $gsMIK._toCodePointArray($3ee2158c14339cc9$var$toCodePointArrayFallback)($3ee2158c14339cc9$var$unsafeCodePointAt0);
var $3ee2158c14339cc9$export$f24224f1c91d8156 = function($74) {
    return $lGiKR.length($3ee2158c14339cc9$export$50a427d3c041e0d2($74));
};
var $3ee2158c14339cc9$export$557cfb7ed375eeb7 = function(p) {
    return function(s) {
        return $3ee2158c14339cc9$var$map(function(i) {
            return $3ee2158c14339cc9$export$f24224f1c91d8156($MTXA4.take(i)(s));
        })($2gT7Y.lastIndexOf(p)(s));
    };
};
var $3ee2158c14339cc9$export$305f7d4e9d4624f2 = function(p) {
    return function(s) {
        return $3ee2158c14339cc9$var$map(function(i) {
            return $3ee2158c14339cc9$export$f24224f1c91d8156($MTXA4.take(i)(s));
        })($2gT7Y.indexOf(p)(s));
    };
};
var $3ee2158c14339cc9$var$fromCharCode = /* #__PURE__ */ function() {
    var $75 = $loxi1.toEnumWithDefaults($loxi1.boundedEnumChar)($95fRU.bottom($95fRU.boundedChar))($95fRU.top($95fRU.boundedChar));
    return function($76) {
        return $MTXA4.singleton($75($76));
    };
}();
var $3ee2158c14339cc9$var$singletonFallback = function(v) {
    if (v <= 65535) return $3ee2158c14339cc9$var$fromCharCode(v);
    var lead = $3ee2158c14339cc9$var$div(v - 65536 | 0)(1024) + 55296 | 0;
    var trail = $3ee2158c14339cc9$var$mod(v - 65536 | 0)(1024) + 56320 | 0;
    return $3ee2158c14339cc9$var$fromCharCode(lead) + $3ee2158c14339cc9$var$fromCharCode(trail);
};
var $3ee2158c14339cc9$export$6fadda5ad927586c = /* #__PURE__ */ $gsMIK._fromCodePointArray($3ee2158c14339cc9$var$singletonFallback);
var $3ee2158c14339cc9$export$439306a4dcaafbb9 = /* #__PURE__ */ $gsMIK._singleton($3ee2158c14339cc9$var$singletonFallback);
var $3ee2158c14339cc9$var$takeFallback = function(v) {
    return function(v1) {
        if (v < 1) return "";
        var v2 = $3ee2158c14339cc9$export$b446f6baa3bb1430(v1);
        if (v2 instanceof $ykHdR.Just) return $3ee2158c14339cc9$export$439306a4dcaafbb9(v2.value0.head) + $3ee2158c14339cc9$var$takeFallback(v - 1 | 0)(v2.value0.tail);
        return v1;
    };
};
var $3ee2158c14339cc9$export$b7df5d561049483a = /* #__PURE__ */ $gsMIK._take($3ee2158c14339cc9$var$takeFallback);
var $3ee2158c14339cc9$export$9dc3eed83bb14216 = function(p) {
    return function(i) {
        return function(s) {
            var i$prime = $MTXA4.length($3ee2158c14339cc9$export$b7df5d561049483a(i)(s));
            return $3ee2158c14339cc9$var$map(function(k) {
                return $3ee2158c14339cc9$export$f24224f1c91d8156($MTXA4.take(k)(s));
            })($2gT7Y.lastIndexOf$prime(p)(i$prime)(s));
        };
    };
};
var $3ee2158c14339cc9$export$b0d75975ac0be0e1 = function(i) {
    return function(s) {
        var before = $3ee2158c14339cc9$export$b7df5d561049483a(i)(s);
        return {
            before: before,
            after: $MTXA4.drop($MTXA4.length(before))(s)
        };
    };
};
var $3ee2158c14339cc9$export$e200a5917becef04 = {
    eq: function(x) {
        return function(y) {
            return x === y;
        };
    }
};
var $3ee2158c14339cc9$export$b08a820ff2b5847d = {
    compare: function(x) {
        return function(y) {
            return $3ee2158c14339cc9$var$compare(x)(y);
        };
    },
    Eq0: function() {
        return $3ee2158c14339cc9$export$e200a5917becef04;
    }
};
var $3ee2158c14339cc9$export$663103110d94aac9 = function(n) {
    return function(s) {
        return $MTXA4.drop($MTXA4.length($3ee2158c14339cc9$export$b7df5d561049483a(n)(s)))(s);
    };
};
var $3ee2158c14339cc9$export$7f0e23922170149a = function(p) {
    return function(i) {
        return function(s) {
            var s$prime = $3ee2158c14339cc9$export$663103110d94aac9(i)(s);
            return $3ee2158c14339cc9$var$map(function(k) {
                return i + $3ee2158c14339cc9$export$f24224f1c91d8156($MTXA4.take(k)(s$prime)) | 0;
            })($2gT7Y.indexOf(p)(s$prime));
        };
    };
};
var $3ee2158c14339cc9$var$countTail = function($copy_p) {
    return function($copy_s) {
        return function($copy_accum) {
            var $tco_var_p = $copy_p;
            var $tco_var_s = $copy_s;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(p, s, accum) {
                var v = $3ee2158c14339cc9$export$b446f6baa3bb1430(s);
                if (v instanceof $ykHdR.Just) {
                    var $61 = p(v.value0.head);
                    if ($61) {
                        $tco_var_p = p;
                        $tco_var_s = v.value0.tail;
                        $copy_accum = accum + 1 | 0;
                        return;
                    }
                    $tco_done = true;
                    return accum;
                }
                $tco_done = true;
                return accum;
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_p, $tco_var_s, $copy_accum);
            return $tco_result;
        };
    };
};
var $3ee2158c14339cc9$var$countFallback = function(p) {
    return function(s) {
        return $3ee2158c14339cc9$var$countTail(p)(s)(0);
    };
};
var $3ee2158c14339cc9$export$29a68f758c141c85 = /* #__PURE__ */ $gsMIK._countPrefix($3ee2158c14339cc9$var$countFallback)($3ee2158c14339cc9$var$unsafeCodePointAt0);
var $3ee2158c14339cc9$export$533af5c8cd6afa16 = function(p) {
    return function(s) {
        return $3ee2158c14339cc9$export$663103110d94aac9($3ee2158c14339cc9$export$29a68f758c141c85(p)(s))(s);
    };
};
var $3ee2158c14339cc9$export$9384c7afe4015e42 = function(p) {
    return function(s) {
        return $3ee2158c14339cc9$export$b7df5d561049483a($3ee2158c14339cc9$export$29a68f758c141c85(p)(s))(s);
    };
};
var $3ee2158c14339cc9$export$dd1029f96c3dd62a = function($77) {
    return $3ee2158c14339cc9$var$CodePoint($3ee2158c14339cc9$var$fromEnum($77));
};
var $3ee2158c14339cc9$var$codePointAtFallback = function($copy_n) {
    return function($copy_s) {
        var $tco_var_n = $copy_n;
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(n, s) {
            var v = $3ee2158c14339cc9$export$b446f6baa3bb1430(s);
            if (v instanceof $ykHdR.Just) {
                var $66 = n === 0;
                if ($66) {
                    $tco_done = true;
                    return new $ykHdR.Just(v.value0.head);
                }
                $tco_var_n = n - 1 | 0;
                $copy_s = v.value0.tail;
                return;
            }
            $tco_done = true;
            return $ykHdR.Nothing.value;
        }
        while(!$tco_done)$tco_result = $tco_loop($tco_var_n, $copy_s);
        return $tco_result;
    };
};
var $3ee2158c14339cc9$export$42977f40461e1360 = function(v) {
    return function(v1) {
        if (v < 0) return $ykHdR.Nothing.value;
        if (v === 0 && v1 === "") return $ykHdR.Nothing.value;
        if (v === 0) return new $ykHdR.Just($3ee2158c14339cc9$var$unsafeCodePointAt0(v1));
        return $gsMIK._codePointAt($3ee2158c14339cc9$var$codePointAtFallback)($ykHdR.Just.create)($ykHdR.Nothing.value)($3ee2158c14339cc9$var$unsafeCodePointAt0)(v)(v1);
    };
};
var $3ee2158c14339cc9$export$1c2b30ab4636bf91 = {
    bottom: 0,
    top: 1114111,
    Ord0: function() {
        return $3ee2158c14339cc9$export$b08a820ff2b5847d;
    }
};
var $3ee2158c14339cc9$export$2a3400c6862992c1 = /* #__PURE__ */ function() {
    return {
        cardinality: 1114112,
        fromEnum: function(v) {
            return v;
        },
        toEnum: function(n) {
            if (n >= 0 && n <= 1114111) return new $ykHdR.Just(n);
            if ($6UHO6.otherwise) return $ykHdR.Nothing.value;
            throw new Error("Failed pattern match at Data.String.CodePoints (line 63, column 1 - line 68, column 26): " + [
                n.constructor.name
            ]);
        },
        Bounded0: function() {
            return $3ee2158c14339cc9$export$1c2b30ab4636bf91;
        },
        Enum1: function() {
            return $3ee2158c14339cc9$var$$lazy_enumCodePoint(0);
        }
    };
}();
var $3ee2158c14339cc9$var$$lazy_enumCodePoint = /* #__PURE__ */ $3ee2158c14339cc9$var$$runtime_lazy("enumCodePoint", "Data.String.CodePoints", function() {
    return {
        succ: $loxi1.defaultSucc($loxi1.toEnum($3ee2158c14339cc9$export$2a3400c6862992c1))($loxi1.fromEnum($3ee2158c14339cc9$export$2a3400c6862992c1)),
        pred: $loxi1.defaultPred($loxi1.toEnum($3ee2158c14339cc9$export$2a3400c6862992c1))($loxi1.fromEnum($3ee2158c14339cc9$export$2a3400c6862992c1)),
        Ord0: function() {
            return $3ee2158c14339cc9$export$b08a820ff2b5847d;
        }
    };
});
var $3ee2158c14339cc9$export$4bc346dd2fb559f7 = /* #__PURE__ */ $3ee2158c14339cc9$var$$lazy_enumCodePoint(59);

});
parcelRegister("gsMIK", function(module, exports) {

$parcel$export(module.exports, "_unsafeCodePointAt0", () => $bfc50dc5547207b7$export$81daff3801c9c982);
$parcel$export(module.exports, "_codePointAt", () => $bfc50dc5547207b7$export$5f0398d7608003c3);
$parcel$export(module.exports, "_countPrefix", () => $bfc50dc5547207b7$export$2964bc4d0a1ede06);
$parcel$export(module.exports, "_fromCodePointArray", () => $bfc50dc5547207b7$export$c41b441de25e3d55);
$parcel$export(module.exports, "_singleton", () => $bfc50dc5547207b7$export$ecb7b38eca4fe9ff);
$parcel$export(module.exports, "_take", () => $bfc50dc5547207b7$export$6d9af221d75dd06f);
$parcel$export(module.exports, "_toCodePointArray", () => $bfc50dc5547207b7$export$c61d72f8b05641be);
/* global Symbol */ var $bfc50dc5547207b7$var$hasArrayFrom = typeof Array.from === "function";
var $bfc50dc5547207b7$var$hasStringIterator = typeof Symbol !== "undefined" && Symbol != null && typeof Symbol.iterator !== "undefined" && typeof String.prototype[Symbol.iterator] === "function";
var $bfc50dc5547207b7$var$hasFromCodePoint = typeof String.prototype.fromCodePoint === "function";
var $bfc50dc5547207b7$var$hasCodePointAt = typeof String.prototype.codePointAt === "function";
const $bfc50dc5547207b7$export$81daff3801c9c982 = function(fallback) {
    return $bfc50dc5547207b7$var$hasCodePointAt ? function(str) {
        return str.codePointAt(0);
    } : fallback;
};
const $bfc50dc5547207b7$export$5f0398d7608003c3 = function(fallback) {
    return function(Just) {
        return function(Nothing) {
            return function(unsafeCodePointAt0) {
                return function(index) {
                    return function(str) {
                        var length = str.length;
                        if (index < 0 || index >= length) return Nothing;
                        if ($bfc50dc5547207b7$var$hasStringIterator) {
                            var iter = str[Symbol.iterator]();
                            for(var i = index;; --i){
                                var o = iter.next();
                                if (o.done) return Nothing;
                                if (i === 0) return Just(unsafeCodePointAt0(o.value));
                            }
                        }
                        return fallback(index)(str);
                    };
                };
            };
        };
    };
};
const $bfc50dc5547207b7$export$2964bc4d0a1ede06 = function(fallback) {
    return function(unsafeCodePointAt0) {
        if ($bfc50dc5547207b7$var$hasStringIterator) return function(pred) {
            return function(str) {
                var iter = str[Symbol.iterator]();
                for(var cpCount = 0;; ++cpCount){
                    var o = iter.next();
                    if (o.done) return cpCount;
                    var cp = unsafeCodePointAt0(o.value);
                    if (!pred(cp)) return cpCount;
                }
            };
        };
        return fallback;
    };
};
const $bfc50dc5547207b7$export$c41b441de25e3d55 = function(singleton) {
    return $bfc50dc5547207b7$var$hasFromCodePoint ? function(cps) {
        // Function.prototype.apply will fail for very large second parameters,
        // so we don't use it for arrays with 10,000 or more entries.
        if (cps.length < 10e3) return String.fromCodePoint.apply(String, cps);
        return cps.map(singleton).join("");
    } : function(cps) {
        return cps.map(singleton).join("");
    };
};
const $bfc50dc5547207b7$export$ecb7b38eca4fe9ff = function(fallback) {
    return $bfc50dc5547207b7$var$hasFromCodePoint ? String.fromCodePoint : fallback;
};
const $bfc50dc5547207b7$export$6d9af221d75dd06f = function(fallback) {
    return function(n) {
        if ($bfc50dc5547207b7$var$hasStringIterator) return function(str) {
            var accum = "";
            var iter = str[Symbol.iterator]();
            for(var i = 0; i < n; ++i){
                var o = iter.next();
                if (o.done) return accum;
                accum += o.value;
            }
            return accum;
        };
        return fallback(n);
    };
};
const $bfc50dc5547207b7$export$c61d72f8b05641be = function(fallback) {
    return function(unsafeCodePointAt0) {
        if ($bfc50dc5547207b7$var$hasArrayFrom) return function(str) {
            return Array.from(str, unsafeCodePointAt0);
        };
        return fallback;
    };
};

});



parcelRegister("3J9zV", function(module, exports) {

$parcel$export(module.exports, "ParseState", () => $2b6d012b5a71a466$export$c791339539b80010);
$parcel$export(module.exports, "ParseError", () => $2b6d012b5a71a466$export$f9c837a54db411d);
$parcel$export(module.exports, "lazyParserT", () => $2b6d012b5a71a466$export$e21af47273e843bd);
$parcel$export(module.exports, "functorParserT", () => $2b6d012b5a71a466$export$858eabc7228a4f5b);
$parcel$export(module.exports, "altParserT", () => $2b6d012b5a71a466$export$6d6c2eed9b26bef3);
$parcel$export(module.exports, "stateParserT", () => $2b6d012b5a71a466$export$a961fe75161cc564);
$parcel$export(module.exports, "showParseError", () => $2b6d012b5a71a466$export$7967a4332fb063d4);
$parcel$export(module.exports, "position", () => $2b6d012b5a71a466$export$5880b8b5730aff45);
$parcel$export(module.exports, "parseErrorPosition", () => $2b6d012b5a71a466$export$f6224d1ee5ebdf6a);
$parcel$export(module.exports, "parseErrorMessage", () => $2b6d012b5a71a466$export$91c32f1b22d29b2d);
$parcel$export(module.exports, "runParser", () => $2b6d012b5a71a466$export$4ad9239eebc1597f);
$parcel$export(module.exports, "getParserT", () => $2b6d012b5a71a466$export$99cb5271137cc3e6);
$parcel$export(module.exports, "consume", () => $2b6d012b5a71a466$export$e11e6a155c5c4d9d);
$parcel$export(module.exports, "applyParserT", () => $2b6d012b5a71a466$export$8808000bb50bc47);
$parcel$export(module.exports, "applicativeParserT", () => $2b6d012b5a71a466$export$a80a9dff0c4321f9);
$parcel$export(module.exports, "bindParserT", () => $2b6d012b5a71a466$export$d3d664fa4d5a96c6);
$parcel$export(module.exports, "monadThrowParseErrorParse", () => $2b6d012b5a71a466$export$728b06f25edead82);
$parcel$export(module.exports, "fail", () => $2b6d012b5a71a466$export$2b62a06a9fee979c);
$parcel$export(module.exports, "plusParserT", () => $2b6d012b5a71a466$export$304c3a29e5bb9689);
$parcel$export(module.exports, "alternativeParserT", () => $2b6d012b5a71a466$export$5220689f708908c3);
$parcel$export(module.exports, "monadErrorParseErrorParse", () => $2b6d012b5a71a466$export$ce3dafa370e28e44);
$parcel$export(module.exports, "monadRecParserT", () => $2b6d012b5a71a466$export$c97488a047bfb404);
// Generated by purs version 0.15.16

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $9Grh5 = parcelRequire("9Grh5");

var $84kZf = parcelRequire("84kZf");

var $i2F6a = parcelRequire("i2F6a");

var $9ZRMq = parcelRequire("9ZRMq");

var $lowBm = parcelRequire("lowBm");

var $kQAxW = parcelRequire("kQAxW");

var $4PFx6 = parcelRequire("4PFx6");

var $aKY4H = parcelRequire("aKY4H");

var $4MBcA = parcelRequire("4MBcA");

var $l0wDR = parcelRequire("l0wDR");
parcelRequire("9VGs1");
var $dc43y = parcelRequire("dc43y");

var $ykHdR = parcelRequire("ykHdR");

var $aknDF = parcelRequire("aknDF");

var $6PW1p = parcelRequire("6PW1p");

var $d0PPW = parcelRequire("d0PPW");

var $6SDUu = parcelRequire("6SDUu");

var $iwqgS = parcelRequire("iwqgS");

var $3Orkn = parcelRequire("3Orkn");

var $7eHfd = parcelRequire("7eHfd");

var $9MxTl = parcelRequire("9MxTl");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");
var $2b6d012b5a71a466$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $2b6d012b5a71a466$var$compare = /* #__PURE__ */ $d0PPW.compare($d0PPW.ordInt);
var $2b6d012b5a71a466$var$show = /* #__PURE__ */ $3Orkn.show($3Orkn.showString);
var $2b6d012b5a71a466$var$unwrap = /* #__PURE__ */ $6PW1p.unwrap();
var $2b6d012b5a71a466$var$compare1 = /* #__PURE__ */ $d0PPW.compare($d0PPW.ordString);
var $2b6d012b5a71a466$export$13807d9ee5a34a42 = function(x) {
    return x;
};
var $2b6d012b5a71a466$export$c791339539b80010 = /* #__PURE__ */ function() {
    function ParseState(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    ParseState.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new ParseState(value0, value1, value2);
            };
        };
    };
    return ParseState;
}();
var $2b6d012b5a71a466$export$f9c837a54db411d = /* #__PURE__ */ function() {
    function ParseError(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    ParseError.create = function(value0) {
        return function(value1) {
            return new ParseError(value0, value1);
        };
    };
    return ParseError;
}();
var $2b6d012b5a71a466$export$9a8df86115a1646c = function(x) {
    return x;
};
var $2b6d012b5a71a466$var$More = /* #__PURE__ */ function() {
    function More(value0) {
        this.value0 = value0;
    }
    More.create = function(value0) {
        return new More(value0);
    };
    return More;
}();
var $2b6d012b5a71a466$var$Lift = /* #__PURE__ */ function() {
    function Lift(value0) {
        this.value0 = value0;
    }
    Lift.create = function(value0) {
        return new Lift(value0);
    };
    return Lift;
}();
var $2b6d012b5a71a466$var$Stop = /* #__PURE__ */ function() {
    function Stop(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Stop.create = function(value0) {
        return function(value1) {
            return new Stop(value0, value1);
        };
    };
    return Stop;
}();
var $2b6d012b5a71a466$export$61e09139d046f494 = {
    lift: function(dictMonad) {
        var map = $l0wDR.map(dictMonad.Bind1().Apply0().Functor0());
        return function(m) {
            return function(state1, v, lift$prime, v1, done) {
                return lift$prime(map(function(a) {
                    return function(v2) {
                        return done(state1, a);
                    };
                })(m));
            };
        };
    }
};
var $2b6d012b5a71a466$var$lift = /* #__PURE__ */ $4PFx6.lift($2b6d012b5a71a466$export$61e09139d046f494);
var $2b6d012b5a71a466$export$e21af47273e843bd = {
    defer: function(f) {
        var m = $dc43y.defer(f);
        return function(state1, more, lift1, $$throw, done) {
            var v = $dc43y.force(m);
            return v(state1, more, lift1, $$throw, done);
        };
    }
};
var $2b6d012b5a71a466$export$11f7f1f26222322b = {
    to: function(x) {
        return x;
    },
    from: function(x) {
        return x;
    }
};
var $2b6d012b5a71a466$var$genericShow = /* #__PURE__ */ $7eHfd.genericShow($2b6d012b5a71a466$export$11f7f1f26222322b)(/* #__PURE__ */ $7eHfd.genericShowConstructor(/* #__PURE__ */ $7eHfd.genericShowArgsArgument(/* #__PURE__ */ $3Orkn.showRecord()()(/* #__PURE__ */ $3Orkn.showRecordFieldsCons({
    reflectSymbol: function() {
        return "column";
    }
})(/* #__PURE__ */ $3Orkn.showRecordFieldsCons({
    reflectSymbol: function() {
        return "index";
    }
})(/* #__PURE__ */ $3Orkn.showRecordFieldsConsNil({
    reflectSymbol: function() {
        return "line";
    }
})($3Orkn.showInt))($3Orkn.showInt))($3Orkn.showInt))))({
    reflectSymbol: function() {
        return "Position";
    }
}));
var $2b6d012b5a71a466$export$f8dfc55d5069b2 = {
    show: function(x) {
        return $2b6d012b5a71a466$var$genericShow(x);
    }
};
var $2b6d012b5a71a466$var$show1 = /* #__PURE__ */ $3Orkn.show($2b6d012b5a71a466$export$f8dfc55d5069b2);
var $2b6d012b5a71a466$export$858eabc7228a4f5b = {
    map: function(f) {
        return function(v) {
            return function(state1, more, lift1, $$throw, done) {
                return more(function(v1) {
                    return v(state1, more, lift1, $$throw, function(state2, a) {
                        return more(function(v2) {
                            return done(state2, f(a));
                        });
                    });
                });
            };
        };
    }
};
var $2b6d012b5a71a466$export$364314875de70a73 = {
    eq: function(v) {
        return function(v1) {
            return v.index === v1.index;
        };
    }
};
var $2b6d012b5a71a466$var$eq2 = /* #__PURE__ */ $4MBcA.eq($2b6d012b5a71a466$export$364314875de70a73);
var $2b6d012b5a71a466$export$a1b20bb8f2712ebf = {
    compare: function(v) {
        return function(v1) {
            return $2b6d012b5a71a466$var$compare(v.index)(v1.index);
        };
    },
    Eq0: function() {
        return $2b6d012b5a71a466$export$364314875de70a73;
    }
};
var $2b6d012b5a71a466$var$compare2 = /* #__PURE__ */ $d0PPW.compare($2b6d012b5a71a466$export$a1b20bb8f2712ebf);
var $2b6d012b5a71a466$export$6d6c2eed9b26bef3 = {
    alt: function(v) {
        return function(v1) {
            return function(v2, more, lift1, $$throw, done) {
                return more(function(v3) {
                    return v(new $2b6d012b5a71a466$export$c791339539b80010(v2.value0, v2.value1, false), more, lift1, function(v4, err) {
                        return more(function(v5) {
                            if (v4.value2) return $$throw(v4, err);
                            return v1(v2, more, lift1, $$throw, done);
                        });
                    }, done);
                });
            };
        };
    },
    Functor0: function() {
        return $2b6d012b5a71a466$export$858eabc7228a4f5b;
    }
};
var $2b6d012b5a71a466$export$a961fe75161cc564 = function(k) {
    return function(state1, v, v1, v2, done) {
        var v3 = k(state1);
        return done(v3.value1, v3.value0);
    };
};
var $2b6d012b5a71a466$export$7967a4332fb063d4 = {
    show: function(v) {
        return "(ParseError " + ($2b6d012b5a71a466$var$show(v.value0) + (" " + ($2b6d012b5a71a466$var$show1(v.value1) + ")")));
    }
};
var $2b6d012b5a71a466$export$cadc613b8e93558 = function(dictMonadRec) {
    var Monad0 = dictMonadRec.Monad0();
    var map = $l0wDR.map(Monad0.Bind1().Apply0().Functor0());
    var pure1 = $gUTA8.pure(Monad0.Applicative0());
    var tailRecM = $lowBm.tailRecM(dictMonadRec);
    return function(state1) {
        return function(v) {
            var go = function($copy_step) {
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(step) {
                    var v1 = step($r2HHk.unit);
                    if (v1 instanceof $2b6d012b5a71a466$var$More) {
                        $copy_step = v1.value0;
                        return;
                    }
                    if (v1 instanceof $2b6d012b5a71a466$var$Lift) {
                        $tco_done = true;
                        return map($lowBm.Loop.create)(v1.value0);
                    }
                    if (v1 instanceof $2b6d012b5a71a466$var$Stop) {
                        $tco_done = true;
                        return pure1(new $lowBm.Done(new $9MxTl.Tuple(v1.value1, v1.value0)));
                    }
                    throw new Error("Failed pattern match at Parsing (line 160, column 13 - line 166, column 32): " + [
                        v1.constructor.name
                    ]);
                }
                while(!$tco_done)$tco_result = $tco_loop($copy_step);
                return $tco_result;
            };
            return tailRecM(go)(function(v1) {
                return v(state1, $2b6d012b5a71a466$var$More.create, $2b6d012b5a71a466$var$Lift.create, function(state2, err) {
                    return new $2b6d012b5a71a466$var$Stop(state2, new $aKY4H.Left(err));
                }, function(state2, res) {
                    return new $2b6d012b5a71a466$var$Stop(state2, new $aKY4H.Right(res));
                });
            });
        };
    };
};
var $2b6d012b5a71a466$export$5880b8b5730aff45 = /* #__PURE__ */ $2b6d012b5a71a466$export$a961fe75161cc564(function(v) {
    return new $9MxTl.Tuple(v.value1, v);
});
var $2b6d012b5a71a466$export$f6224d1ee5ebdf6a = function(v) {
    return v.value1;
};
var $2b6d012b5a71a466$export$91c32f1b22d29b2d = function(v) {
    return v.value0;
};
var $2b6d012b5a71a466$export$b2a98702105c3a71 = function(dictMonadRec) {
    var runParserT$prime1 = $2b6d012b5a71a466$export$cadc613b8e93558(dictMonadRec);
    return function(dictFunctor) {
        var map = $l0wDR.map(dictFunctor);
        return function(f) {
            return function(p) {
                return function(state1, v, lift1, $$throw, done) {
                    return lift1(map(function(v1) {
                        return function(v2) {
                            if (v1.value0 instanceof $aKY4H.Left) return $$throw(v1.value1, v1.value0.value0);
                            if (v1.value0 instanceof $aKY4H.Right) return done(v1.value1, v1.value0.value0);
                            throw new Error("Failed pattern match at Parsing (line 200, column 13 - line 204, column 37): " + [
                                v1.value0.constructor.name
                            ]);
                        };
                    })(f(runParserT$prime1(state1)(p))));
                };
            };
        };
    };
};
var $2b6d012b5a71a466$export$3b2cd57af4544298 = {
    index: 0,
    line: 1,
    column: 1
};
var $2b6d012b5a71a466$export$9f9314778b57da70 = function(dictMonadRec) {
    var map = $l0wDR.map(dictMonadRec.Monad0().Bind1().Apply0().Functor0());
    var runParserT$prime1 = $2b6d012b5a71a466$export$cadc613b8e93558(dictMonadRec);
    return function(s) {
        return function(p) {
            var initialState = new $2b6d012b5a71a466$export$c791339539b80010(s, $2b6d012b5a71a466$export$3b2cd57af4544298, false);
            return map($9MxTl.fst)(runParserT$prime1(initialState)(p));
        };
    };
};
var $2b6d012b5a71a466$var$runParserT1 = /* #__PURE__ */ $2b6d012b5a71a466$export$9f9314778b57da70($lowBm.monadRecIdentity);
var $2b6d012b5a71a466$export$4ad9239eebc1597f = function(s) {
    var $295 = $2b6d012b5a71a466$var$runParserT1(s);
    return function($296) {
        return $2b6d012b5a71a466$var$unwrap($295($296));
    };
};
var $2b6d012b5a71a466$export$ee5cf94f27827250 = function(f) {
    return function(v) {
        return function(state1, more, lift1, $$throw, done) {
            return v(state1, more, function($297) {
                return lift1(f($297));
            }, $$throw, done);
        };
    };
};
var $2b6d012b5a71a466$export$99cb5271137cc3e6 = function(state1, v, v1, v2, done) {
    return done(state1, state1);
};
var $2b6d012b5a71a466$export$effc34fd18fa8d8a = function(v) {
    return function(v1) {
        return v.index === v1.index && v.line === v1.line && v.column === v1.column;
    };
};
var $2b6d012b5a71a466$export$adbb70a5bd2c0146 = {
    eq: function(x) {
        return function(y) {
            return x.value0 === y.value0 && $2b6d012b5a71a466$var$eq2(x.value1)(y.value1);
        };
    }
};
var $2b6d012b5a71a466$export$3f38bd25419f2c1c = {
    compare: function(x) {
        return function(y) {
            var v = $2b6d012b5a71a466$var$compare1(x.value0)(y.value0);
            if (v instanceof $6SDUu.LT) return $6SDUu.LT.value;
            if (v instanceof $6SDUu.GT) return $6SDUu.GT.value;
            return $2b6d012b5a71a466$var$compare2(x.value1)(y.value1);
        };
    },
    Eq0: function() {
        return $2b6d012b5a71a466$export$adbb70a5bd2c0146;
    }
};
var $2b6d012b5a71a466$export$e11e6a155c5c4d9d = /* #__PURE__ */ $2b6d012b5a71a466$export$a961fe75161cc564(function(v) {
    return new $9MxTl.Tuple($r2HHk.unit, new $2b6d012b5a71a466$export$c791339539b80010(v.value0, v.value1, true));
});
var $2b6d012b5a71a466$var$appendConsumed = function(v) {
    return function(v1) {
        if (v.value2 && !v1.value2) return new $2b6d012b5a71a466$export$c791339539b80010(v1.value0, v1.value1, true);
        return v1;
    };
};
var $2b6d012b5a71a466$export$8808000bb50bc47 = {
    apply: function(v) {
        return function(v1) {
            return function(state1, more, lift1, $$throw, done) {
                return more(function(v2) {
                    return v(state1, more, lift1, $$throw, function(state2, f) {
                        return more(function(v3) {
                            var state2$prime = $2b6d012b5a71a466$var$appendConsumed(state1)(state2);
                            return v1(state2$prime, more, lift1, $$throw, function(state3, a) {
                                return more(function(v4) {
                                    return done($2b6d012b5a71a466$var$appendConsumed(state2$prime)(state3), f(a));
                                });
                            });
                        });
                    });
                });
            };
        };
    },
    Functor0: function() {
        return $2b6d012b5a71a466$export$858eabc7228a4f5b;
    }
};
var $2b6d012b5a71a466$var$lift2 = /* #__PURE__ */ $a5g3C.lift2($2b6d012b5a71a466$export$8808000bb50bc47);
var $2b6d012b5a71a466$export$a80a9dff0c4321f9 = {
    pure: function(a) {
        return function(state1, v, v1, v2, done) {
            return done(state1, a);
        };
    },
    Apply0: function() {
        return $2b6d012b5a71a466$export$8808000bb50bc47;
    }
};
var $2b6d012b5a71a466$var$pure = /* #__PURE__ */ $gUTA8.pure($2b6d012b5a71a466$export$a80a9dff0c4321f9);
var $2b6d012b5a71a466$export$32bd52aa0d2a958d = function(dictSemigroup) {
    return {
        append: $2b6d012b5a71a466$var$lift2($iwqgS.append(dictSemigroup))
    };
};
var $2b6d012b5a71a466$export$93591ff715526817 = function(dictMonoid) {
    var semigroupParserT1 = $2b6d012b5a71a466$export$32bd52aa0d2a958d(dictMonoid.Semigroup0());
    return {
        mempty: $2b6d012b5a71a466$var$pure($aknDF.mempty(dictMonoid)),
        Semigroup0: function() {
            return semigroupParserT1;
        }
    };
};
var $2b6d012b5a71a466$export$d3d664fa4d5a96c6 = {
    bind: function(v) {
        return function(next) {
            return function(state1, more, lift1, $$throw, done) {
                return more(function(v1) {
                    return v(state1, more, lift1, $$throw, function(state2, a) {
                        return more(function(v2) {
                            var v3 = next(a);
                            return v3($2b6d012b5a71a466$var$appendConsumed(state1)(state2), more, lift1, $$throw, done);
                        });
                    });
                });
            };
        };
    },
    Apply0: function() {
        return $2b6d012b5a71a466$export$8808000bb50bc47;
    }
};
var $2b6d012b5a71a466$var$bindFlipped = /* #__PURE__ */ $9Grh5.bindFlipped($2b6d012b5a71a466$export$d3d664fa4d5a96c6);
var $2b6d012b5a71a466$var$bind = /* #__PURE__ */ $9Grh5.bind($2b6d012b5a71a466$export$d3d664fa4d5a96c6);
var $2b6d012b5a71a466$export$50fcd154ffbb53ba = {
    Applicative0: function() {
        return $2b6d012b5a71a466$export$a80a9dff0c4321f9;
    },
    Bind1: function() {
        return $2b6d012b5a71a466$export$d3d664fa4d5a96c6;
    }
};
var $2b6d012b5a71a466$export$cb0672d40d811a96 = function(dictMonadAsk) {
    return {
        ask: $2b6d012b5a71a466$var$lift(dictMonadAsk.Monad0())($9ZRMq.ask(dictMonadAsk)),
        Monad0: function() {
            return $2b6d012b5a71a466$export$50fcd154ffbb53ba;
        }
    };
};
var $2b6d012b5a71a466$export$ecce73bba72cc5 = function(dictMonadReader) {
    var local = $9ZRMq.local(dictMonadReader);
    var monadAskParserT1 = $2b6d012b5a71a466$export$cb0672d40d811a96(dictMonadReader.MonadAsk0());
    return {
        local: function(f) {
            return function(v) {
                return function(state1, more, lift1, $$throw, done) {
                    return v(state1, more, function() {
                        var $298 = local(f);
                        return function($299) {
                            return lift1($298($299));
                        };
                    }(), $$throw, done);
                };
            };
        },
        MonadAsk0: function() {
            return monadAskParserT1;
        }
    };
};
var $2b6d012b5a71a466$export$76baed2e83aead93 = function(dictMonadState) {
    var lift1 = $2b6d012b5a71a466$var$lift(dictMonadState.Monad0());
    var state = $kQAxW.state(dictMonadState);
    return {
        state: function(k) {
            return lift1(state(k));
        },
        Monad0: function() {
            return $2b6d012b5a71a466$export$50fcd154ffbb53ba;
        }
    };
};
var $2b6d012b5a71a466$export$728b06f25edead82 = {
    throwError: function(err) {
        return function(state1, v, v1, $$throw, v2) {
            return $$throw(state1, err);
        };
    },
    Monad0: function() {
        return $2b6d012b5a71a466$export$50fcd154ffbb53ba;
    }
};
var $2b6d012b5a71a466$var$throwError = /* #__PURE__ */ $84kZf.throwError($2b6d012b5a71a466$export$728b06f25edead82);
var $2b6d012b5a71a466$export$d048d07e0ea3e0f1 = function(message) {
    return function(pos) {
        return $2b6d012b5a71a466$var$throwError(new $2b6d012b5a71a466$export$f9c837a54db411d(message, pos));
    };
};
var $2b6d012b5a71a466$export$2b62a06a9fee979c = function(message) {
    return $2b6d012b5a71a466$var$bindFlipped($2b6d012b5a71a466$export$d048d07e0ea3e0f1(message))($2b6d012b5a71a466$export$5880b8b5730aff45);
};
var $2b6d012b5a71a466$export$bd6bd7bb5418f998 = function(dictMonad) {
    return function(f) {
        if (f instanceof $aKY4H.Left) return $2b6d012b5a71a466$export$2b62a06a9fee979c(f.value0);
        if (f instanceof $aKY4H.Right) return $2b6d012b5a71a466$var$pure(f.value0);
        throw new Error("Failed pattern match at Parsing (line 529, column 16 - line 531, column 20): " + [
            f.constructor.name
        ]);
    };
};
var $2b6d012b5a71a466$export$d5cae9b05ce784eb = function(dictMonad) {
    var lift1 = $2b6d012b5a71a466$var$lift(dictMonad);
    return function(f) {
        return $2b6d012b5a71a466$var$bind(lift1($i2F6a.runExceptT(f)))(function(v) {
            if (v instanceof $aKY4H.Left) return $2b6d012b5a71a466$export$2b62a06a9fee979c(v.value0);
            if (v instanceof $aKY4H.Right) return $2b6d012b5a71a466$var$pure(v.value0);
            throw new Error("Failed pattern match at Parsing (line 543, column 41 - line 545, column 20): " + [
                v.constructor.name
            ]);
        });
    };
};
var $2b6d012b5a71a466$export$1cf01ae67112be7b = function(dictMonad) {
    return function(message) {
        return function(f) {
            if (f instanceof $ykHdR.Nothing) return $2b6d012b5a71a466$export$2b62a06a9fee979c(message($r2HHk.unit));
            if (f instanceof $ykHdR.Just) return $2b6d012b5a71a466$var$pure(f.value0);
            throw new Error("Failed pattern match at Parsing (line 515, column 23 - line 517, column 19): " + [
                f.constructor.name
            ]);
        };
    };
};
var $2b6d012b5a71a466$export$304c3a29e5bb9689 = {
    empty: /* #__PURE__ */ $2b6d012b5a71a466$export$2b62a06a9fee979c("No alternative"),
    Alt0: function() {
        return $2b6d012b5a71a466$export$6d6c2eed9b26bef3;
    }
};
var $2b6d012b5a71a466$export$5220689f708908c3 = {
    Applicative0: function() {
        return $2b6d012b5a71a466$export$a80a9dff0c4321f9;
    },
    Plus1: function() {
        return $2b6d012b5a71a466$export$304c3a29e5bb9689;
    }
};
var $2b6d012b5a71a466$export$e929610c0683bf9a = {
    Monad0: function() {
        return $2b6d012b5a71a466$export$50fcd154ffbb53ba;
    },
    Alternative1: function() {
        return $2b6d012b5a71a466$export$5220689f708908c3;
    }
};
var $2b6d012b5a71a466$export$ce3dafa370e28e44 = {
    catchError: function(v) {
        return function(next) {
            return function(state1, more, lift1, $$throw, done) {
                return more(function(v1) {
                    return v(state1, more, lift1, function(state2, err) {
                        var v2 = next(err);
                        return v2(state2, more, lift1, $$throw, done);
                    }, done);
                });
            };
        };
    },
    MonadThrow0: function() {
        return $2b6d012b5a71a466$export$728b06f25edead82;
    }
};
var $2b6d012b5a71a466$var$catchError = /* #__PURE__ */ $84kZf.catchError($2b6d012b5a71a466$export$ce3dafa370e28e44);
var $2b6d012b5a71a466$export$9b1a70c9ede163e = function(context) {
    return function(p) {
        return $2b6d012b5a71a466$var$catchError(p)(function(err) {
            return $2b6d012b5a71a466$var$throwError(context(err));
        });
    };
};
var $2b6d012b5a71a466$export$c97488a047bfb404 = {
    tailRecM: function(next) {
        return function(initArg) {
            return function(state1, more, lift1, $$throw, done) {
                var $lazy_loop = $2b6d012b5a71a466$var$$runtime_lazy("loop", "Parsing", function() {
                    return function(state2, arg, gas) {
                        var v = next(arg);
                        return v(state2, more, lift1, $$throw, function(state3, step) {
                            var state3$prime = $2b6d012b5a71a466$var$appendConsumed(state2)(state3);
                            if (step instanceof $lowBm.Loop) {
                                var $292 = gas === 0;
                                if ($292) return more(function(v1) {
                                    return $lazy_loop(288)(state3$prime, step.value0, 30);
                                });
                                return $lazy_loop(290)(state3$prime, step.value0, gas - 1 | 0);
                            }
                            if (step instanceof $lowBm.Done) return done(state3$prime, step.value0);
                            throw new Error("Failed pattern match at Parsing (line 284, column 19 - line 292, column 46): " + [
                                step.constructor.name
                            ]);
                        });
                    };
                });
                var loop = $lazy_loop(279);
                return loop(state1, initArg, 30);
            };
        };
    },
    Monad0: function() {
        return $2b6d012b5a71a466$export$50fcd154ffbb53ba;
    }
};

});

parcelRegister("1woEV", function(module, exports) {

$parcel$export(module.exports, "withLazyErrorMessage", () => $11bbe85c947c529d$export$db22ac524b337b7);
$parcel$export(module.exports, "withErrorMessage", () => $11bbe85c947c529d$export$49261000d13ed9a7);
$parcel$export(module.exports, "tryRethrow", () => $11bbe85c947c529d$export$6f621483de7c32dc);
$parcel$export(module.exports, "try", () => $11bbe85c947c529d$export$410a452afcd48948);
$parcel$export(module.exports, "skipMany1", () => $11bbe85c947c529d$export$764f12fa29fd189c);
$parcel$export(module.exports, "skipMany", () => $11bbe85c947c529d$export$1871c6d98c36e478);
$parcel$export(module.exports, "sepBy1", () => $11bbe85c947c529d$export$617220f394cba247);
$parcel$export(module.exports, "sepBy", () => $11bbe85c947c529d$export$a0228d318ff1a462);
$parcel$export(module.exports, "option", () => $11bbe85c947c529d$export$a75d1723e6bda2ec);
$parcel$export(module.exports, "optionMaybe", () => $11bbe85c947c529d$export$b9803a97967f594);
$parcel$export(module.exports, "notFollowedBy", () => $11bbe85c947c529d$export$5cdbf197bae344fe);
$parcel$export(module.exports, "choice", () => $11bbe85c947c529d$export$7a5825874deea16a);
$parcel$export(module.exports, "between", () => $11bbe85c947c529d$export$cf95c51b03f10bae);
$parcel$export(module.exports, "asErrorMessage", () => $11bbe85c947c529d$export$7fff6b5ce3920a5c);
// Generated by purs version 0.15.16

var $a7Dxq = parcelRequire("a7Dxq");

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $9Grh5 = parcelRequire("9Grh5");

var $dTFzl = parcelRequire("dTFzl");

var $84kZf = parcelRequire("84kZf");

var $lowBm = parcelRequire("lowBm");

var $axmEP = parcelRequire("axmEP");

var $6RkEA = parcelRequire("6RkEA");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");

var $5gmr2 = parcelRequire("5gmr2");

var $3xeiS = parcelRequire("3xeiS");

var $fZM3T = parcelRequire("fZM3T");

var $amUgg = parcelRequire("amUgg");

var $ykHdR = parcelRequire("ykHdR");

var $3Orkn = parcelRequire("3Orkn");

var $9MxTl = parcelRequire("9MxTl");

var $hsyEi = parcelRequire("hsyEi");

var $hNKjN = parcelRequire("hNKjN");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");

var $3J9zV = parcelRequire("3J9zV");
var $11bbe85c947c529d$var$alt = /* #__PURE__ */ $a7Dxq.alt($3J9zV.altParserT);
var $11bbe85c947c529d$var$defer = /* #__PURE__ */ $dTFzl.defer($3J9zV.lazyParserT);
var $11bbe85c947c529d$var$voidLeft = /* #__PURE__ */ $l0wDR.voidLeft($3J9zV.functorParserT);
var $11bbe85c947c529d$var$pure = /* #__PURE__ */ $gUTA8.pure($3J9zV.applicativeParserT);
var $11bbe85c947c529d$var$applySecond = /* #__PURE__ */ $a5g3C.applySecond($3J9zV.applyParserT);
var $11bbe85c947c529d$var$tailRecM = /* #__PURE__ */ $lowBm.tailRecM($3J9zV.monadRecParserT);
var $11bbe85c947c529d$var$bind = /* #__PURE__ */ $9Grh5.bind($3J9zV.bindParserT);
var $11bbe85c947c529d$var$mapFlipped = /* #__PURE__ */ $l0wDR.mapFlipped($3J9zV.functorParserT);
var $11bbe85c947c529d$var$map = /* #__PURE__ */ $l0wDR.map($3J9zV.functorParserT);
var $11bbe85c947c529d$var$manyRec = /* #__PURE__ */ $5gmr2.manyRec($3J9zV.monadRecParserT)($3J9zV.alternativeParserT);
var $11bbe85c947c529d$var$$$void = /* #__PURE__ */ $l0wDR.void($3J9zV.functorParserT);
var $11bbe85c947c529d$var$catchError = /* #__PURE__ */ $84kZf.catchError($3J9zV.monadErrorParseErrorParse);
var $11bbe85c947c529d$var$throwError = /* #__PURE__ */ $84kZf.throwError($3J9zV.monadThrowParseErrorParse);
var $11bbe85c947c529d$var$show = /* #__PURE__ */ $3Orkn.show($3Orkn.showInt);
var $11bbe85c947c529d$var$apply = /* #__PURE__ */ $a5g3C.apply($3J9zV.applyParserT);
var $11bbe85c947c529d$var$applyFirst = /* #__PURE__ */ $a5g3C.applyFirst($3J9zV.applyParserT);
var $11bbe85c947c529d$var$empty = /* #__PURE__ */ $axmEP.empty($3J9zV.plusParserT);
var $11bbe85c947c529d$var$foldl = /* #__PURE__ */ $6RkEA.foldl($amUgg.foldableList);
var $11bbe85c947c529d$export$db22ac524b337b7 = function(p) {
    return function(msg) {
        return $11bbe85c947c529d$var$alt(p)($11bbe85c947c529d$var$defer(function(v) {
            return $3J9zV.fail("Expected " + msg($r2HHk.unit));
        }));
    };
};
var $11bbe85c947c529d$export$49261000d13ed9a7 = function(p) {
    return function(msg) {
        return $11bbe85c947c529d$var$alt(p)($3J9zV.fail("Expected " + msg));
    };
};
var $11bbe85c947c529d$export$6f621483de7c32dc = function(v) {
    return function(v1, more, lift, $$throw, done) {
        return v(v1, more, lift, function(v2, v3) {
            return $$throw(new $3J9zV.ParseState(v2.value0, v2.value1, v1.value2), new $3J9zV.ParseError(v3.value0, v1.value1));
        }, done);
    };
};
var $11bbe85c947c529d$export$410a452afcd48948 = function(v) {
    return function(v1, more, lift, $$throw, done) {
        return v(v1, more, lift, function(v2, err) {
            return $$throw(new $3J9zV.ParseState(v2.value0, v2.value1, v1.value2), err);
        }, done);
    };
};
var $11bbe85c947c529d$export$764f12fa29fd189c = function(p) {
    var go = function(v) {
        return $11bbe85c947c529d$var$alt($11bbe85c947c529d$var$voidLeft(p)(new $lowBm.Loop($r2HHk.unit)))($11bbe85c947c529d$var$pure(new $lowBm.Done($r2HHk.unit)));
    };
    return $11bbe85c947c529d$var$applySecond(p)($11bbe85c947c529d$var$tailRecM(go)($r2HHk.unit));
};
var $11bbe85c947c529d$export$1871c6d98c36e478 = function(p) {
    return $11bbe85c947c529d$var$alt($11bbe85c947c529d$export$764f12fa29fd189c(p))($11bbe85c947c529d$var$pure($r2HHk.unit));
};
var $11bbe85c947c529d$export$d2ed8cc1d2e8029b = function(p) {
    return function(sep) {
        var go = function(acc) {
            var done = $11bbe85c947c529d$var$defer(function(v) {
                return $11bbe85c947c529d$var$pure(new $lowBm.Done($5gmr2.reverse(acc)));
            });
            var nextOne = $11bbe85c947c529d$var$bind(sep)(function() {
                return $11bbe85c947c529d$var$alt($11bbe85c947c529d$var$mapFlipped(p)(function(a) {
                    return new $lowBm.Loop(new $amUgg.Cons(a, acc));
                }))(done);
            });
            return $11bbe85c947c529d$var$alt(nextOne)(done);
        };
        return $11bbe85c947c529d$var$bind(p)(function(a) {
            return $11bbe85c947c529d$var$alt($11bbe85c947c529d$var$map($fZM3T.cons$prime(a))($11bbe85c947c529d$var$tailRecM(go)($amUgg.Nil.value)))($11bbe85c947c529d$var$pure($fZM3T.singleton(a)));
        });
    };
};
var $11bbe85c947c529d$export$3f00b9d4810f7a39 = function(p) {
    return function(sep) {
        return $11bbe85c947c529d$var$alt($11bbe85c947c529d$var$map($fZM3T.toList)($11bbe85c947c529d$export$d2ed8cc1d2e8029b(p)(sep)))($11bbe85c947c529d$var$pure($amUgg.Nil.value));
    };
};
var $11bbe85c947c529d$export$617220f394cba247 = function(p) {
    return function(sep) {
        return $11bbe85c947c529d$var$bind(p)(function(a) {
            return $11bbe85c947c529d$var$bind($11bbe85c947c529d$var$manyRec($11bbe85c947c529d$var$applySecond(sep)(p)))(function(as) {
                return $11bbe85c947c529d$var$pure($fZM3T.cons$prime(a)(as));
            });
        });
    };
};
var $11bbe85c947c529d$export$a0228d318ff1a462 = function(p) {
    return function(sep) {
        return $11bbe85c947c529d$var$alt($11bbe85c947c529d$var$map($fZM3T.toList)($11bbe85c947c529d$export$617220f394cba247(p)(sep)))($11bbe85c947c529d$var$pure($amUgg.Nil.value));
    };
};
var $11bbe85c947c529d$export$516e28dec6a4b6d4 = function(p) {
    return $11bbe85c947c529d$var$alt($11bbe85c947c529d$var$$$void(p))($11bbe85c947c529d$var$pure($r2HHk.unit));
};
var $11bbe85c947c529d$export$a75d1723e6bda2ec = function(a) {
    return function(p) {
        return $11bbe85c947c529d$var$alt(p)($11bbe85c947c529d$var$pure(a));
    };
};
var $11bbe85c947c529d$export$b9803a97967f594 = function(p) {
    return $11bbe85c947c529d$export$a75d1723e6bda2ec($ykHdR.Nothing.value)($11bbe85c947c529d$var$map($ykHdR.Just.create)(p));
};
var $11bbe85c947c529d$export$5cdbf197bae344fe = function(p) {
    return $11bbe85c947c529d$export$410a452afcd48948($11bbe85c947c529d$var$alt($11bbe85c947c529d$var$applySecond($11bbe85c947c529d$export$410a452afcd48948(p))($3J9zV.fail("Negated parser succeeded")))($11bbe85c947c529d$var$pure($r2HHk.unit)));
};
var $11bbe85c947c529d$export$633afda11b622955 = function(p) {
    return function(end) {
        var go = function(xs) {
            return $11bbe85c947c529d$var$alt($11bbe85c947c529d$var$bind(end)(function(t) {
                return $11bbe85c947c529d$var$pure(new $lowBm.Done(new $9MxTl.Tuple($5gmr2.reverse(xs), t)));
            }))($11bbe85c947c529d$var$bind(p)(function(x) {
                return $11bbe85c947c529d$var$pure(new $lowBm.Loop(new $amUgg.Cons(x, xs)));
            }));
        };
        return $11bbe85c947c529d$var$tailRecM(go)($amUgg.Nil.value);
    };
};
var $11bbe85c947c529d$export$cf7e1b47032e4a7c = function(p) {
    return function(end) {
        var go = function(acc) {
            return $11bbe85c947c529d$var$alt($11bbe85c947c529d$var$mapFlipped(end)(function(v) {
                return new $lowBm.Done($5gmr2.reverse(acc));
            }))($11bbe85c947c529d$var$mapFlipped(p)(function(x) {
                return new $lowBm.Loop(new $amUgg.Cons(x, acc));
            }));
        };
        return $11bbe85c947c529d$var$tailRecM(go)($amUgg.Nil.value);
    };
};
var $11bbe85c947c529d$export$3f2c92a97f73c35a = function(from) {
    return function(to) {
        return function(p) {
            var go = function(v) {
                var $72 = v.value0 >= to;
                if ($72) return $11bbe85c947c529d$var$pure(new $lowBm.Done(new $9MxTl.Tuple(v.value0, $5gmr2.reverse(v.value1))));
                return $11bbe85c947c529d$var$catchError($11bbe85c947c529d$var$bind(p(v.value0))(function(x) {
                    return $11bbe85c947c529d$var$pure(new $lowBm.Loop(new $9MxTl.Tuple(v.value0 + 1 | 0, new $amUgg.Cons(x, v.value1))));
                }))(function(e) {
                    var $73 = v.value0 >= from;
                    if ($73) return $11bbe85c947c529d$var$pure(new $lowBm.Done(new $9MxTl.Tuple(v.value0, $5gmr2.reverse(v.value1))));
                    return $11bbe85c947c529d$var$throwError(new $3J9zV.ParseError($3J9zV.parseErrorMessage(e) + (" (at least " + ($11bbe85c947c529d$var$show(from) + (", but only parsed " + ($11bbe85c947c529d$var$show(v.value0) + ")")))), $3J9zV.parseErrorPosition(e)));
                });
            };
            var $76 = from > to || from < 0;
            if ($76) return $11bbe85c947c529d$var$pure(new $9MxTl.Tuple(0, $amUgg.Nil.value));
            return $11bbe85c947c529d$var$tailRecM(go)(new $9MxTl.Tuple(0, $amUgg.Nil.value));
        };
    };
};
var $11bbe85c947c529d$export$d0905e8758ea346d = function(p) {
    return function(end) {
        return $11bbe85c947c529d$var$bind(p)(function(x) {
            return $11bbe85c947c529d$var$bind($11bbe85c947c529d$export$633afda11b622955(p)(end))(function(v) {
                return $11bbe85c947c529d$var$pure(new $9MxTl.Tuple($fZM3T.cons$prime(x)(v.value0), v.value1));
            });
        });
    };
};
var $11bbe85c947c529d$export$eddf5dbe069fa672 = function(p) {
    return function(end) {
        return $11bbe85c947c529d$var$apply($11bbe85c947c529d$var$map($fZM3T.cons$prime)(p))($11bbe85c947c529d$export$cf7e1b47032e4a7c(p)(end));
    };
};
var $11bbe85c947c529d$export$a6482580fab70c30 = function(p) {
    return $11bbe85c947c529d$var$apply($11bbe85c947c529d$var$map($fZM3T.cons$prime)(p))($11bbe85c947c529d$var$manyRec(p));
};
var $11bbe85c947c529d$export$14badfee79ea396f = $11bbe85c947c529d$var$manyRec;
var $11bbe85c947c529d$export$89c36ea49ad05bf3 = function(v) {
    return function(state1, more, lift, $$throw, done) {
        return v(state1, more, lift, function(v1, err) {
            return $$throw(state1, err);
        }, function(v1, res) {
            return done(state1, res);
        });
    };
};
var $11bbe85c947c529d$export$30acb68292ba53d0 = function(p) {
    return function(sep) {
        return $11bbe85c947c529d$export$a6482580fab70c30($11bbe85c947c529d$var$applyFirst(p)(sep));
    };
};
var $11bbe85c947c529d$export$62391786201b0e3b = function(p) {
    return function(sep) {
        return $11bbe85c947c529d$var$manyRec($11bbe85c947c529d$var$applyFirst(p)(sep));
    };
};
var $11bbe85c947c529d$export$7a5825874deea16a = function(dictFoldable) {
    var go = function(p1) {
        return function(v) {
            if (v instanceof $ykHdR.Nothing) return new $ykHdR.Just(p1);
            if (v instanceof $ykHdR.Just) return new $ykHdR.Just($11bbe85c947c529d$var$alt(p1)(v.value0));
            throw new Error("Failed pattern match at Parsing.Combinators (line 362, column 11 - line 364, column 32): " + [
                v.constructor.name
            ]);
        };
    };
    var $95 = $ykHdR.fromMaybe($11bbe85c947c529d$var$empty);
    var $96 = $6RkEA.foldr(dictFoldable)(go)($ykHdR.Nothing.value);
    return function($97) {
        return $95($96($97));
    };
};
var $11bbe85c947c529d$export$38a115df1905c022 = function(p) {
    return function(f) {
        var apply1 = function(y) {
            return function(v) {
                return v.value1(v.value0)(y);
            };
        };
        var go = function(v) {
            return $11bbe85c947c529d$var$alt($11bbe85c947c529d$var$bind(f)(function(op) {
                return $11bbe85c947c529d$var$bind(p)(function(a) {
                    return $11bbe85c947c529d$var$pure(new $lowBm.Loop({
                        last: a,
                        init: new $amUgg.Cons(new $9MxTl.Tuple(v.last, op), v.init)
                    }));
                });
            }))($11bbe85c947c529d$var$defer(function(v1) {
                return $11bbe85c947c529d$var$pure(new $lowBm.Done($11bbe85c947c529d$var$foldl(apply1)(v.last)(v.init)));
            }));
        };
        return $11bbe85c947c529d$var$bind(p)(function(a) {
            return $11bbe85c947c529d$var$tailRecM(go)({
                last: a,
                init: $amUgg.Nil.value
            });
        });
    };
};
var $11bbe85c947c529d$export$d2a0d5a23b042780 = function(p) {
    return function(f) {
        return function(a) {
            return $11bbe85c947c529d$var$alt($11bbe85c947c529d$export$38a115df1905c022(p)(f))($11bbe85c947c529d$var$pure(a));
        };
    };
};
var $11bbe85c947c529d$export$3acf224bcd43567a = function(p) {
    return function(f) {
        var go = function(a) {
            return $11bbe85c947c529d$var$alt($11bbe85c947c529d$var$bind(f)(function(op) {
                return $11bbe85c947c529d$var$bind(p)(function(a$prime) {
                    return $11bbe85c947c529d$var$pure(new $lowBm.Loop(op(a)(a$prime)));
                });
            }))($11bbe85c947c529d$var$pure(new $lowBm.Done(a)));
        };
        return $11bbe85c947c529d$var$bind(p)(function(a) {
            return $11bbe85c947c529d$var$tailRecM(go)(a);
        });
    };
};
var $11bbe85c947c529d$export$6f5833edc27e1eaa = function(p) {
    return function(f) {
        return function(a) {
            return $11bbe85c947c529d$var$alt($11bbe85c947c529d$export$3acf224bcd43567a(p)(f))($11bbe85c947c529d$var$pure(a));
        };
    };
};
var $11bbe85c947c529d$export$cf95c51b03f10bae = function(open) {
    return function(close) {
        return function(p) {
            return $11bbe85c947c529d$var$applyFirst($11bbe85c947c529d$var$applySecond(open)(p))(close);
        };
    };
};
var $11bbe85c947c529d$export$7fff6b5ce3920a5c = /* #__PURE__ */ $l4M7e.flip($11bbe85c947c529d$export$49261000d13ed9a7);
var $11bbe85c947c529d$export$35d233f3b2dbf62a = function(p) {
    return $11bbe85c947c529d$var$bind($3J9zV.position)(function(v) {
        return $11bbe85c947c529d$var$bind(p)(function(x) {
            return $11bbe85c947c529d$var$bind($3J9zV.position)(function(v1) {
                var $92 = v1.index > v.index;
                if ($92) return $11bbe85c947c529d$var$pure(x);
                return $3J9zV.fail("Expected progress");
            });
        });
    });
};

});
parcelRegister("3xeiS", function(module, exports) {
// Generated by purs version 0.15.16

var $a7Dxq = parcelRequire("a7Dxq");

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $9Grh5 = parcelRequire("9Grh5");

var $7T8P4 = parcelRequire("7T8P4");

var $dTFzl = parcelRequire("dTFzl");

var $lowBm = parcelRequire("lowBm");

var $6UHO6 = parcelRequire("6UHO6");

var $4MBcA = parcelRequire("4MBcA");

var $6RkEA = parcelRequire("6RkEA");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");

var $lnl7Y = parcelRequire("lnl7Y");

var $9VGs1 = parcelRequire("9VGs1");
var $dc43y = parcelRequire("dc43y");

var $7YrkG = parcelRequire("7YrkG");

var $76RAV = parcelRequire("76RAV");

var $ykHdR = parcelRequire("ykHdR");

var $6PW1p = parcelRequire("6PW1p");

var $2FBb2 = parcelRequire("2FBb2");

var $d0PPW = parcelRequire("d0PPW");

var $6SDUu = parcelRequire("6SDUu");

var $iwqgS = parcelRequire("iwqgS");

var $3Orkn = parcelRequire("3Orkn");

var $1wR1l = parcelRequire("1wR1l");

var $9MxTl = parcelRequire("9MxTl");

var $hsyEi = parcelRequire("hsyEi");
var $292f8c84f8002d8c$var$apply = /* #__PURE__ */ $a5g3C.apply($9VGs1.applyLazy);
var $292f8c84f8002d8c$var$map = /* #__PURE__ */ $l0wDR.map($9VGs1.functorLazy);
var $292f8c84f8002d8c$var$unwrap = /* #__PURE__ */ $6PW1p.unwrap();
var $292f8c84f8002d8c$var$sequence = /* #__PURE__ */ $1wR1l.sequence($76RAV.traversableList);
var $292f8c84f8002d8c$var$foldr = /* #__PURE__ */ $6RkEA.foldr($76RAV.foldableList);
var $292f8c84f8002d8c$var$map1 = /* #__PURE__ */ $l0wDR.map($ykHdR.functorMaybe);
var $292f8c84f8002d8c$var$tailRecM2 = /* #__PURE__ */ $lowBm.tailRecM2($lowBm.monadRecMaybe);
var $292f8c84f8002d8c$var$defer = /* #__PURE__ */ $dTFzl.defer($76RAV.lazyList);
var $292f8c84f8002d8c$var$foldl = /* #__PURE__ */ $6RkEA.foldl($76RAV.foldableList);
var $292f8c84f8002d8c$var$fix = /* #__PURE__ */ $dTFzl.fix($76RAV.lazyList);
var $292f8c84f8002d8c$var$unfoldr = /* #__PURE__ */ $hsyEi.unfoldr($76RAV.unfoldableList);
var $292f8c84f8002d8c$var$map2 = /* #__PURE__ */ $l0wDR.map($76RAV.functorList);
var $292f8c84f8002d8c$var$bind = /* #__PURE__ */ $9Grh5.bind($ykHdR.bindMaybe);
var $292f8c84f8002d8c$var$pure = /* #__PURE__ */ $gUTA8.pure($ykHdR.applicativeMaybe);
var $292f8c84f8002d8c$var$any = /* #__PURE__ */ $6RkEA.any($76RAV.foldableList)($lnl7Y.heytingAlgebraBoolean);
var $292f8c84f8002d8c$var$append1 = /* #__PURE__ */ $iwqgS.append($76RAV.semigroupList);
var $292f8c84f8002d8c$var$bind1 = /* #__PURE__ */ $9Grh5.bind($76RAV.bindList);
var $292f8c84f8002d8c$var$identity = /* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn);
var $292f8c84f8002d8c$export$47606a6ae3eaed8e = function(x) {
    return x;
};
var $292f8c84f8002d8c$export$b634740ce272acb5 = function(f) {
    return function(xs) {
        return function(ys) {
            var go = function(v) {
                return function(v1) {
                    if (v instanceof $76RAV.Nil) return $76RAV.Nil.value;
                    if (v1 instanceof $76RAV.Nil) return $76RAV.Nil.value;
                    if (v instanceof $76RAV.Cons && v1 instanceof $76RAV.Cons) return new $76RAV.Cons(f(v.value0)(v1.value0), $292f8c84f8002d8c$export$b634740ce272acb5(f)(v.value1)(v1.value1));
                    throw new Error("Failed pattern match at Data.List.Lazy (line 705, column 3 - line 705, column 35): " + [
                        v.constructor.name,
                        v1.constructor.name
                    ]);
                };
            };
            return $292f8c84f8002d8c$var$apply($292f8c84f8002d8c$var$map(go)($292f8c84f8002d8c$var$unwrap(xs)))($292f8c84f8002d8c$var$unwrap(ys));
        };
    };
};
var $292f8c84f8002d8c$export$e00c1e5c5a2b1ad7 = function(dictApplicative) {
    var sequence1 = $292f8c84f8002d8c$var$sequence(dictApplicative);
    return function(f) {
        return function(xs) {
            return function(ys) {
                return sequence1($292f8c84f8002d8c$export$b634740ce272acb5(f)(xs)(ys));
            };
        };
    };
};
var $292f8c84f8002d8c$export$8901015135f2fb22 = /* #__PURE__ */ function() {
    return $292f8c84f8002d8c$export$b634740ce272acb5($9MxTl.Tuple.create);
}();
var $292f8c84f8002d8c$export$b6d8713d53419d4c = function(n) {
    return function(x) {
        return function(xs) {
            var go = function(v) {
                return function(v1) {
                    if (v1 instanceof $76RAV.Nil) return $76RAV.Nil.value;
                    if (v === 0 && v1 instanceof $76RAV.Cons) return new $76RAV.Cons(x, v1.value1);
                    if (v1 instanceof $76RAV.Cons) return new $76RAV.Cons(v1.value0, $292f8c84f8002d8c$export$b6d8713d53419d4c(v - 1 | 0)(x)(v1.value1));
                    throw new Error("Failed pattern match at Data.List.Lazy (line 361, column 3 - line 361, column 17): " + [
                        v.constructor.name,
                        v1.constructor.name
                    ]);
                };
            };
            return $292f8c84f8002d8c$var$map(go(n))($292f8c84f8002d8c$var$unwrap(xs));
        };
    };
};
var $292f8c84f8002d8c$export$23c8d3f8757cab88 = /* #__PURE__ */ function() {
    return $292f8c84f8002d8c$var$foldr(function(v) {
        return function(v1) {
            return new $9MxTl.Tuple($76RAV.cons(v.value0)(v1.value0), $76RAV.cons(v.value1)(v1.value1));
        };
    })(new $9MxTl.Tuple($76RAV.nil, $76RAV.nil));
}();
var $292f8c84f8002d8c$export$b446f6baa3bb1430 = function(xs) {
    var v = $76RAV.step(xs);
    if (v instanceof $76RAV.Nil) return $ykHdR.Nothing.value;
    if (v instanceof $76RAV.Cons) return new $ykHdR.Just({
        head: v.value0,
        tail: v.value1
    });
    throw new Error("Failed pattern match at Data.List.Lazy (line 288, column 13 - line 290, column 44): " + [
        v.constructor.name
    ]);
};
var $292f8c84f8002d8c$export$823be24f8766da23 = function(dictUnfoldable) {
    return $hsyEi.unfoldr(dictUnfoldable)(function(xs) {
        return $292f8c84f8002d8c$var$map1(function(rec) {
            return new $9MxTl.Tuple(rec.head, rec.tail);
        })($292f8c84f8002d8c$export$b446f6baa3bb1430(xs));
    });
};
var $292f8c84f8002d8c$export$9384c7afe4015e42 = function(p) {
    var go = function(v) {
        if (v instanceof $76RAV.Cons && p(v.value0)) return new $76RAV.Cons(v.value0, $292f8c84f8002d8c$export$9384c7afe4015e42(p)(v.value1));
        return $76RAV.Nil.value;
    };
    var $331 = $292f8c84f8002d8c$var$map(go);
    return function($332) {
        return $76RAV.List($331($292f8c84f8002d8c$var$unwrap($332)));
    };
};
var $292f8c84f8002d8c$export$b7df5d561049483a = function(n) {
    var go = function(v) {
        return function(v1) {
            if (v1 instanceof $76RAV.Nil) return $76RAV.Nil.value;
            if (v1 instanceof $76RAV.Cons) return new $76RAV.Cons(v1.value0, $292f8c84f8002d8c$export$b7df5d561049483a(v - 1 | 0)(v1.value1));
            throw new Error("Failed pattern match at Data.List.Lazy (line 505, column 3 - line 505, column 32): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    };
    var $202 = n <= 0;
    if ($202) return $l4M7e.const($76RAV.nil);
    var $333 = $292f8c84f8002d8c$var$map(go(n));
    return function($334) {
        return $76RAV.List($333($292f8c84f8002d8c$var$unwrap($334)));
    };
};
var $292f8c84f8002d8c$export$c01875f616615628 = function(xs) {
    return $292f8c84f8002d8c$var$map1(function(v) {
        return v.tail;
    })($292f8c84f8002d8c$export$b446f6baa3bb1430(xs));
};
var $292f8c84f8002d8c$export$71c2a1babd78d286 = function(dictEq) {
    var eq = $4MBcA.eq(dictEq);
    return function(v) {
        return function(s) {
            var go = function(prefix) {
                return function(input) {
                    var v1 = $76RAV.step(prefix);
                    if (v1 instanceof $76RAV.Nil) return new $ykHdR.Just(new $lowBm.Done(input));
                    if (v1 instanceof $76RAV.Cons) {
                        var v2 = $76RAV.step(input);
                        if (v2 instanceof $76RAV.Cons && eq(v1.value0)(v2.value0)) return new $ykHdR.Just(new $lowBm.Loop({
                            a: v1.value1,
                            b: v2.value1
                        }));
                        return $ykHdR.Nothing.value;
                    }
                    throw new Error("Failed pattern match at Data.List.Lazy (line 487, column 21 - line 491, column 19): " + [
                        v1.constructor.name
                    ]);
                };
            };
            return $292f8c84f8002d8c$var$tailRecM2(go)(v)(s);
        };
    };
};
var $292f8c84f8002d8c$export$afc1bfabebaf28a2 = function(p) {
    return function(xs) {
        var v = $292f8c84f8002d8c$export$b446f6baa3bb1430(xs);
        if (v instanceof $ykHdR.Just && p(v.value0.head)) {
            var v1 = $292f8c84f8002d8c$export$afc1bfabebaf28a2(p)(v.value0.tail);
            return {
                init: $76RAV.cons(v.value0.head)(v1.init),
                rest: v1.rest
            };
        }
        return {
            init: $76RAV.nil,
            rest: xs
        };
    };
};
var $292f8c84f8002d8c$export$c40cf5aab899f397 = function(xs) {
    return function(x) {
        return $292f8c84f8002d8c$var$foldr($76RAV.cons)($76RAV.cons(x)($76RAV.nil))(xs);
    };
};
var $292f8c84f8002d8c$export$439306a4dcaafbb9 = function(a) {
    return $76RAV.cons(a)($76RAV.nil);
};
var $292f8c84f8002d8c$export$b5c655b9d1f9203e = function(dictShow) {
    var show = $3Orkn.show($76RAV.showList(dictShow));
    return {
        show: function(v) {
            return "(Pattern " + (show(v) + ")");
        }
    };
};
var $292f8c84f8002d8c$export$951e420fdeef37cd = function(f) {
    return function(acc) {
        return function(xs) {
            var go = function(v) {
                if (v instanceof $76RAV.Nil) return $76RAV.Nil.value;
                if (v instanceof $76RAV.Cons) {
                    var acc$prime = f(acc)(v.value0);
                    return new $76RAV.Cons(acc$prime, $292f8c84f8002d8c$export$951e420fdeef37cd(f)(acc$prime)(v.value1));
                }
                throw new Error("Failed pattern match at Data.List.Lazy (line 776, column 5 - line 776, column 27): " + [
                    v.constructor.name
                ]);
            };
            return $292f8c84f8002d8c$var$map(go)($292f8c84f8002d8c$var$unwrap(xs));
        };
    };
};
var $292f8c84f8002d8c$export$66c1ae025e96b4bc = function(xs) {
    return $292f8c84f8002d8c$var$defer(function(v) {
        return $292f8c84f8002d8c$var$foldl($l4M7e.flip($76RAV.cons))($76RAV.nil)(xs);
    });
};
var $292f8c84f8002d8c$export$f1fa93b59bdd728d = function(dictMonad) {
    var pure1 = $gUTA8.pure(dictMonad.Applicative0());
    var bind2 = $9Grh5.bind(dictMonad.Bind1());
    return function(n) {
        return function(m) {
            if (n < 1) return pure1($76RAV.nil);
            if ($6UHO6.otherwise) return bind2(m)(function(a) {
                return bind2($292f8c84f8002d8c$export$f1fa93b59bdd728d(dictMonad)(n - 1 | 0)(m))(function(as) {
                    return pure1($76RAV.cons(a)(as));
                });
            });
            throw new Error("Failed pattern match at Data.List.Lazy (line 164, column 1 - line 164, column 62): " + [
                n.constructor.name,
                m.constructor.name
            ]);
        };
    };
};
var $292f8c84f8002d8c$export$76d90c956114f2c2 = function(x) {
    return $292f8c84f8002d8c$var$fix(function(xs) {
        return $76RAV.cons(x)(xs);
    });
};
var $292f8c84f8002d8c$export$606959e7ccb797f0 = function(i) {
    return function(xs) {
        return $292f8c84f8002d8c$export$b7df5d561049483a(i)($292f8c84f8002d8c$export$76d90c956114f2c2(xs));
    };
};
var $292f8c84f8002d8c$export$d02631cccf789723 = function(start) {
    return function(end) {
        if (start > end) {
            var g = function(x) {
                if (x >= end) return new $ykHdR.Just(new $9MxTl.Tuple(x, x - 1 | 0));
                if ($6UHO6.otherwise) return $ykHdR.Nothing.value;
                throw new Error("Failed pattern match at Data.List.Lazy (line 151, column 13 - line 152, column 38): " + [
                    x.constructor.name
                ]);
            };
            return $292f8c84f8002d8c$var$unfoldr(g)(start);
        }
        if ($6UHO6.otherwise) {
            var f = function(x) {
                if (x <= end) return new $ykHdR.Just(new $9MxTl.Tuple(x, x + 1 | 0));
                if ($6UHO6.otherwise) return $ykHdR.Nothing.value;
                throw new Error("Failed pattern match at Data.List.Lazy (line 156, column 5 - line 157, column 30): " + [
                    x.constructor.name
                ]);
            };
            return $292f8c84f8002d8c$var$unfoldr(f)(start);
        }
        throw new Error("Failed pattern match at Data.List.Lazy (line 148, column 1 - line 148, column 32): " + [
            start.constructor.name,
            end.constructor.name
        ]);
    };
};
var $292f8c84f8002d8c$export$b29f828819edca8d = function(f) {
    var go = function(x) {
        return function(v) {
            var $230 = f(x);
            if ($230) return {
                yes: $76RAV.cons(x)(v.yes),
                no: v.no
            };
            return {
                yes: v.yes,
                no: $76RAV.cons(x)(v.no)
            };
        };
    };
    return $292f8c84f8002d8c$var$foldr(go)({
        yes: $76RAV.nil,
        no: $76RAV.nil
    });
};
var $292f8c84f8002d8c$export$7b1b591b262c240 = function($335) {
    return $ykHdR.isNothing($292f8c84f8002d8c$export$b446f6baa3bb1430($335));
};
var $292f8c84f8002d8c$export$18f77a3bafa759b9 = function(p) {
    var goStep = function(v) {
        return function(v1) {
            if (v1 instanceof $76RAV.Nil) return $76RAV.Nil.value;
            if (v1 instanceof $76RAV.Cons) {
                var v2 = $7YrkG.insertAndLookupBy(p)(v1.value0)(v);
                if (v2.found) return $76RAV.step(go(v2.result)(v1.value1));
                return new $76RAV.Cons(v1.value0, go(v2.result)(v1.value1));
            }
            throw new Error("Failed pattern match at Data.List.Lazy (line 613, column 5 - line 613, column 23): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    };
    var go = function(s) {
        return function(v) {
            return $292f8c84f8002d8c$var$map(goStep(s))(v);
        };
    };
    return go($7YrkG.emptySet);
};
var $292f8c84f8002d8c$export$94f4066a75b10404 = function(dictOrd) {
    return $292f8c84f8002d8c$export$18f77a3bafa759b9($d0PPW.compare(dictOrd));
};
var $292f8c84f8002d8c$export$86c9b635481112b7 = {
    Coercible0: function() {
        return undefined;
    }
};
var $292f8c84f8002d8c$export$e70771d2e7e590a = function(f) {
    var go = function($copy_v) {
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v) {
            if (v instanceof $76RAV.Nil) {
                $tco_done = true;
                return $76RAV.Nil.value;
            }
            if (v instanceof $76RAV.Cons) {
                var v1 = f(v.value0);
                if (v1 instanceof $ykHdR.Nothing) {
                    $copy_v = $76RAV.step(v.value1);
                    return;
                }
                if (v1 instanceof $ykHdR.Just) {
                    $tco_done = true;
                    return new $76RAV.Cons(v1.value0, $292f8c84f8002d8c$export$e70771d2e7e590a(f)(v.value1));
                }
                throw new Error("Failed pattern match at Data.List.Lazy (line 448, column 5 - line 450, column 39): " + [
                    v1.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Data.List.Lazy (line 446, column 3 - line 446, column 15): " + [
                v.constructor.name
            ]);
        }
        while(!$tco_done)$tco_result = $tco_loop($copy_v);
        return $tco_result;
    };
    var $336 = $292f8c84f8002d8c$var$map(go);
    return function($337) {
        return $76RAV.List($336($292f8c84f8002d8c$var$unwrap($337)));
    };
};
var $292f8c84f8002d8c$export$ad14ef4001db2bcd = function(dictAlternative) {
    var apply1 = $a5g3C.apply(dictAlternative.Applicative0().Apply0());
    var map3 = $l0wDR.map(dictAlternative.Plus1().Alt0().Functor0());
    return function(dictLazy) {
        var defer1 = $dTFzl.defer(dictLazy);
        return function(v) {
            return apply1(map3($76RAV.cons)(v))(defer1(function(v1) {
                return $292f8c84f8002d8c$export$14badfee79ea396f(dictAlternative)(dictLazy)(v);
            }));
        };
    };
};
var $292f8c84f8002d8c$export$14badfee79ea396f = function(dictAlternative) {
    var alt = $a7Dxq.alt(dictAlternative.Plus1().Alt0());
    var pure1 = $gUTA8.pure(dictAlternative.Applicative0());
    return function(dictLazy) {
        return function(v) {
            return alt($292f8c84f8002d8c$export$ad14ef4001db2bcd(dictAlternative)(dictLazy)(v))(pure1($76RAV.nil));
        };
    };
};
var $292f8c84f8002d8c$export$f24224f1c91d8156 = /* #__PURE__ */ $292f8c84f8002d8c$var$foldl(function(l) {
    return function(v) {
        return l + 1 | 0;
    };
})(0);
var $292f8c84f8002d8c$export$4c7897fafd92b108 = /* #__PURE__ */ function() {
    var go = function($copy_v) {
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v) {
            if (v instanceof $76RAV.Cons) {
                if ($292f8c84f8002d8c$export$7b1b591b262c240(v.value1)) {
                    $tco_done = true;
                    return new $ykHdR.Just(v.value0);
                }
                if ($6UHO6.otherwise) {
                    $copy_v = $76RAV.step(v.value1);
                    return;
                }
            }
            $tco_done = true;
            return $ykHdR.Nothing.value;
        }
        while(!$tco_done)$tco_result = $tco_loop($copy_v);
        return $tco_result;
    };
    return function($338) {
        return go($76RAV.step($338));
    };
}();
var $292f8c84f8002d8c$export$c1a059043cc9c119 = function(f) {
    return function(x) {
        return $292f8c84f8002d8c$var$fix(function(xs) {
            return $76RAV.cons(x)($292f8c84f8002d8c$var$map2(f)(xs));
        });
    };
};
var $292f8c84f8002d8c$export$9f200c4466975173 = function(v) {
    return function(v1) {
        return function(v2) {
            if (v === 0) return $76RAV.cons(v1)(v2);
            var go = function(v3) {
                if (v3 instanceof $76RAV.Nil) return new $76RAV.Cons(v1, $76RAV.nil);
                if (v3 instanceof $76RAV.Cons) return new $76RAV.Cons(v3.value0, $292f8c84f8002d8c$export$9f200c4466975173(v - 1 | 0)(v1)(v3.value1));
                throw new Error("Failed pattern match at Data.List.Lazy (line 340, column 3 - line 340, column 22): " + [
                    v3.constructor.name
                ]);
            };
            return $292f8c84f8002d8c$var$map(go)($292f8c84f8002d8c$var$unwrap(v2));
        };
    };
};
var $292f8c84f8002d8c$export$2cd8252107eb640b = /* #__PURE__ */ function() {
    var go = function(v) {
        if (v instanceof $76RAV.Cons) {
            if ($292f8c84f8002d8c$export$7b1b591b262c240(v.value1)) return new $ykHdR.Just($76RAV.nil);
            if ($6UHO6.otherwise) return $292f8c84f8002d8c$var$map1($76RAV.cons(v.value0))(go($76RAV.step(v.value1)));
        }
        return $ykHdR.Nothing.value;
    };
    return function($339) {
        return go($76RAV.step($339));
    };
}();
var $292f8c84f8002d8c$export$b610b8812bbcded9 = function(xs) {
    var go = function($copy_v) {
        return function($copy_v1) {
            var $tco_var_v = $copy_v;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v, v1) {
                if (v instanceof $76RAV.Nil) {
                    $tco_done = true;
                    return $ykHdR.Nothing.value;
                }
                if (v instanceof $76RAV.Cons && v1 === 0) {
                    $tco_done = true;
                    return new $ykHdR.Just(v.value0);
                }
                if (v instanceof $76RAV.Cons) {
                    $tco_var_v = $76RAV.step(v.value1);
                    $copy_v1 = v1 - 1 | 0;
                    return;
                }
                throw new Error("Failed pattern match at Data.List.Lazy (line 302, column 3 - line 302, column 21): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
            return $tco_result;
        };
    };
    return go($76RAV.step(xs));
};
var $292f8c84f8002d8c$export$5fd5031fecdacec3 = function(xs) {
    return $292f8c84f8002d8c$var$map1(function(v) {
        return v.head;
    })($292f8c84f8002d8c$export$b446f6baa3bb1430(xs));
};
var $292f8c84f8002d8c$export$9cb09a71b7d66923 = function(xs) {
    var v = $292f8c84f8002d8c$export$b446f6baa3bb1430(xs);
    if (v instanceof $ykHdR.Nothing) return xs;
    if (v instanceof $ykHdR.Just) {
        var v1 = $292f8c84f8002d8c$export$b446f6baa3bb1430(v.value0.head);
        if (v1 instanceof $ykHdR.Nothing) return $292f8c84f8002d8c$export$9cb09a71b7d66923(v.value0.tail);
        if (v1 instanceof $ykHdR.Just) return $76RAV.cons($76RAV.cons(v1.value0.head)($292f8c84f8002d8c$export$e70771d2e7e590a($292f8c84f8002d8c$export$5fd5031fecdacec3)(v.value0.tail)))($292f8c84f8002d8c$export$9cb09a71b7d66923($76RAV.cons(v1.value0.tail)($292f8c84f8002d8c$export$e70771d2e7e590a($292f8c84f8002d8c$export$c01875f616615628)(v.value0.tail))));
        throw new Error("Failed pattern match at Data.List.Lazy (line 746, column 7 - line 750, column 72): " + [
            v1.constructor.name
        ]);
    }
    throw new Error("Failed pattern match at Data.List.Lazy (line 742, column 3 - line 750, column 72): " + [
        v.constructor.name
    ]);
};
var $292f8c84f8002d8c$export$3f063810d7bf01bd = function(eq) {
    var go = function(v) {
        if (v instanceof $76RAV.Nil) return $76RAV.Nil.value;
        if (v instanceof $76RAV.Cons) {
            var v1 = $292f8c84f8002d8c$export$afc1bfabebaf28a2(eq(v.value0))(v.value1);
            return new $76RAV.Cons($dc43y.defer(function(v2) {
                return new $2FBb2.NonEmpty(v.value0, v1.init);
            }), $292f8c84f8002d8c$export$3f063810d7bf01bd(eq)(v1.rest));
        }
        throw new Error("Failed pattern match at Data.List.Lazy (line 576, column 3 - line 576, column 15): " + [
            v.constructor.name
        ]);
    };
    var $340 = $292f8c84f8002d8c$var$map(go);
    return function($341) {
        return $76RAV.List($340($292f8c84f8002d8c$var$unwrap($341)));
    };
};
var $292f8c84f8002d8c$export$e5e25fbcc1f7affe = function(dictEq) {
    return $292f8c84f8002d8c$export$3f063810d7bf01bd($4MBcA.eq(dictEq));
};
var $292f8c84f8002d8c$var$fromStep = /* #__PURE__ */ function() {
    var $342 = $gUTA8.pure($9VGs1.applicativeLazy);
    return function($343) {
        return $76RAV.List($342($343));
    };
}();
var $292f8c84f8002d8c$export$b8bc901090d2b1d4 = function(cmp) {
    return function(x) {
        return function(xs) {
            var go = function(v) {
                if (v instanceof $76RAV.Nil) return new $76RAV.Cons(x, $76RAV.nil);
                if (v instanceof $76RAV.Cons) {
                    var v1 = cmp(x)(v.value0);
                    if (v1 instanceof $6SDUu.GT) return new $76RAV.Cons(v.value0, $292f8c84f8002d8c$export$b8bc901090d2b1d4(cmp)(x)(v.value1));
                    return new $76RAV.Cons(x, $292f8c84f8002d8c$var$fromStep(v));
                }
                throw new Error("Failed pattern match at Data.List.Lazy (line 238, column 3 - line 238, column 22): " + [
                    v.constructor.name
                ]);
            };
            return $292f8c84f8002d8c$var$map(go)($292f8c84f8002d8c$var$unwrap(xs));
        };
    };
};
var $292f8c84f8002d8c$export$21a5ca8aa77d35ff = function(dictOrd) {
    return $292f8c84f8002d8c$export$b8bc901090d2b1d4($d0PPW.compare(dictOrd));
};
var $292f8c84f8002d8c$export$b7d5d9bb9ff52072 = function(dictFoldable) {
    return $6RkEA.foldr(dictFoldable)($76RAV.cons)($76RAV.nil);
};
var $292f8c84f8002d8c$export$a6d4c5c719005a90 = function(dictLazy) {
    var defer1 = $dTFzl.defer(dictLazy);
    return function(op) {
        return function(z) {
            var go = function(xs) {
                var v = $76RAV.step(xs);
                if (v instanceof $76RAV.Cons) return defer1(function(v1) {
                    return op(v.value0)(go(v.value1));
                });
                if (v instanceof $76RAV.Nil) return z;
                throw new Error("Failed pattern match at Data.List.Lazy (line 768, column 13 - line 770, column 15): " + [
                    v.constructor.name
                ]);
            };
            return go;
        };
    };
};
var $292f8c84f8002d8c$export$7a067f9280ad8af0 = function(dictMonad) {
    var pure1 = $gUTA8.pure(dictMonad.Applicative0());
    var bind2 = $9Grh5.bind(dictMonad.Bind1());
    return function(f) {
        return function(b) {
            return function(xs) {
                var v = $292f8c84f8002d8c$export$b446f6baa3bb1430(xs);
                if (v instanceof $ykHdR.Nothing) return pure1(b);
                if (v instanceof $ykHdR.Just) return bind2(f(b)(v.value0.head))(function(b$prime) {
                    return $292f8c84f8002d8c$export$7a067f9280ad8af0(dictMonad)(f)(b$prime)(v.value0.tail);
                });
                throw new Error("Failed pattern match at Data.List.Lazy (line 759, column 5 - line 762, column 54): " + [
                    v.constructor.name
                ]);
            };
        };
    };
};
var $292f8c84f8002d8c$export$de3a4d4a0d731119 = function(fn) {
    var go = function(n) {
        return function(list) {
            return $292f8c84f8002d8c$var$bind($292f8c84f8002d8c$export$b446f6baa3bb1430(list))(function(o) {
                var $291 = fn(o.head);
                if ($291) return $292f8c84f8002d8c$var$pure(n);
                return go(n + 1 | 0)(o.tail);
            });
        };
    };
    return go(0);
};
var $292f8c84f8002d8c$export$8855a8be7bd3e9f8 = function(fn) {
    return function(xs) {
        return $292f8c84f8002d8c$var$map1(function(v) {
            return ($292f8c84f8002d8c$export$f24224f1c91d8156(xs) - 1 | 0) - v | 0;
        })($292f8c84f8002d8c$export$de3a4d4a0d731119(fn)($292f8c84f8002d8c$export$66c1ae025e96b4bc(xs)));
    };
};
var $292f8c84f8002d8c$export$20098ecb074a31e6 = function(dictMonad) {
    var pure1 = $gUTA8.pure(dictMonad.Applicative0());
    var bind2 = $9Grh5.bind(dictMonad.Bind1());
    return function(p) {
        return function(list) {
            var v = $292f8c84f8002d8c$export$b446f6baa3bb1430(list);
            if (v instanceof $ykHdR.Nothing) return pure1($76RAV.nil);
            if (v instanceof $ykHdR.Just) return bind2(p(v.value0.head))(function(b) {
                return bind2($292f8c84f8002d8c$export$20098ecb074a31e6(dictMonad)(p)(v.value0.tail))(function(xs$prime) {
                    return pure1(function() {
                        if (b) return $76RAV.cons(v.value0.head)(xs$prime);
                        return xs$prime;
                    }());
                });
            });
            throw new Error("Failed pattern match at Data.List.Lazy (line 431, column 5 - line 436, column 48): " + [
                v.constructor.name
            ]);
        };
    };
};
var $292f8c84f8002d8c$export$3dea766d36a8935f = function(p) {
    var go = function($copy_v) {
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v) {
            if (v instanceof $76RAV.Nil) {
                $tco_done = true;
                return $76RAV.Nil.value;
            }
            if (v instanceof $76RAV.Cons) {
                if (p(v.value0)) {
                    $tco_done = true;
                    return new $76RAV.Cons(v.value0, $292f8c84f8002d8c$export$3dea766d36a8935f(p)(v.value1));
                }
                if ($6UHO6.otherwise) {
                    $copy_v = $76RAV.step(v.value1);
                    return;
                }
            }
            throw new Error("Failed pattern match at Data.List.Lazy (line 416, column 3 - line 416, column 15): " + [
                v.constructor.name
            ]);
        }
        while(!$tco_done)$tco_result = $tco_loop($copy_v);
        return $tco_result;
    };
    var $344 = $292f8c84f8002d8c$var$map(go);
    return function($345) {
        return $76RAV.List($344($292f8c84f8002d8c$var$unwrap($345)));
    };
};
var $292f8c84f8002d8c$export$f161f39e9c06ab2d = function(eq) {
    return function(xs) {
        return function(ys) {
            return $292f8c84f8002d8c$export$3dea766d36a8935f(function(x) {
                return $292f8c84f8002d8c$var$any(eq(x))(ys);
            })(xs);
        };
    };
};
var $292f8c84f8002d8c$export$1f4807a235930d45 = function(dictEq) {
    return $292f8c84f8002d8c$export$f161f39e9c06ab2d($4MBcA.eq(dictEq));
};
var $292f8c84f8002d8c$export$45273896c792ff3b = function(eq) {
    var go = function(v) {
        if (v instanceof $76RAV.Nil) return $76RAV.Nil.value;
        if (v instanceof $76RAV.Cons) return new $76RAV.Cons(v.value0, $292f8c84f8002d8c$export$45273896c792ff3b(eq)($292f8c84f8002d8c$export$3dea766d36a8935f(function(y) {
            return !eq(v.value0)(y);
        })(v.value1)));
        throw new Error("Failed pattern match at Data.List.Lazy (line 633, column 3 - line 633, column 15): " + [
            v.constructor.name
        ]);
    };
    var $346 = $292f8c84f8002d8c$var$map(go);
    return function($347) {
        return $76RAV.List($346($292f8c84f8002d8c$var$unwrap($347)));
    };
};
var $292f8c84f8002d8c$export$edce5881c815871 = function(dictEq) {
    return $292f8c84f8002d8c$export$45273896c792ff3b($4MBcA.eq(dictEq));
};
var $292f8c84f8002d8c$export$3c57592525e2b27e = function(dictEq) {
    var eq = $4MBcA.eq($76RAV.eqList(dictEq));
    return {
        eq: function(x) {
            return function(y) {
                return eq(x)(y);
            };
        }
    };
};
var $292f8c84f8002d8c$export$21c206d752eba296 = function(dictOrd) {
    var compare = $d0PPW.compare($76RAV.ordList(dictOrd));
    var eqPattern1 = $292f8c84f8002d8c$export$3c57592525e2b27e(dictOrd.Eq0());
    return {
        compare: function(x) {
            return function(y) {
                return compare(x)(y);
            };
        },
        Eq0: function() {
            return eqPattern1;
        }
    };
};
var $292f8c84f8002d8c$export$c19d79386f4ed99a = function(dictEq) {
    var eq = $4MBcA.eq(dictEq);
    return function(x) {
        return $292f8c84f8002d8c$export$8855a8be7bd3e9f8(function(v) {
            return eq(v)(x);
        });
    };
};
var $292f8c84f8002d8c$export$f444781b0adb7e4d = function(dictEq) {
    var eq = $4MBcA.eq(dictEq);
    return function(x) {
        return $292f8c84f8002d8c$export$de3a4d4a0d731119(function(v) {
            return eq(v)(x);
        });
    };
};
var $292f8c84f8002d8c$export$533af5c8cd6afa16 = function(p) {
    var go = function($copy_v) {
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v) {
            if (v instanceof $76RAV.Cons && p(v.value0)) {
                $copy_v = $76RAV.step(v.value1);
                return;
            }
            $tco_done = true;
            return $292f8c84f8002d8c$var$fromStep(v);
        }
        while(!$tco_done)$tco_result = $tco_loop($copy_v);
        return $tco_result;
    };
    return function($348) {
        return go($76RAV.step($348));
    };
};
var $292f8c84f8002d8c$export$663103110d94aac9 = function(n) {
    var go = function($copy_v) {
        return function($copy_v1) {
            var $tco_var_v = $copy_v;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v, v1) {
                if (v === 0) {
                    $tco_done = true;
                    return v1;
                }
                if (v1 instanceof $76RAV.Nil) {
                    $tco_done = true;
                    return $76RAV.Nil.value;
                }
                if (v1 instanceof $76RAV.Cons) {
                    $tco_var_v = v - 1 | 0;
                    $copy_v1 = $76RAV.step(v1.value1);
                    return;
                }
                throw new Error("Failed pattern match at Data.List.Lazy (line 524, column 3 - line 524, column 15): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
            return $tco_result;
        };
    };
    var $349 = $292f8c84f8002d8c$var$map(go(n));
    return function($350) {
        return $76RAV.List($349($292f8c84f8002d8c$var$unwrap($350)));
    };
};
var $292f8c84f8002d8c$export$58adb3bec8346d0f = function(start) {
    return function(end) {
        return function(xs) {
            return $292f8c84f8002d8c$export$b7df5d561049483a(end - start | 0)($292f8c84f8002d8c$export$663103110d94aac9(start)(xs));
        };
    };
};
var $292f8c84f8002d8c$export$9ea2b6c3fae093d8 = function(eq) {
    return function(x) {
        return function(xs) {
            var go = function(v) {
                if (v instanceof $76RAV.Nil) return $76RAV.Nil.value;
                if (v instanceof $76RAV.Cons) {
                    if (eq(x)(v.value0)) return $76RAV.step(v.value1);
                    if ($6UHO6.otherwise) return new $76RAV.Cons(v.value0, $292f8c84f8002d8c$export$9ea2b6c3fae093d8(eq)(x)(v.value1));
                }
                throw new Error("Failed pattern match at Data.List.Lazy (line 662, column 3 - line 662, column 15): " + [
                    v.constructor.name
                ]);
            };
            return $292f8c84f8002d8c$var$map(go)($292f8c84f8002d8c$var$unwrap(xs));
        };
    };
};
var $292f8c84f8002d8c$export$ef1d06dc4d91d507 = function(eq) {
    return function(xs) {
        return function(ys) {
            return $292f8c84f8002d8c$var$append1(xs)($292f8c84f8002d8c$var$foldl($l4M7e.flip($292f8c84f8002d8c$export$9ea2b6c3fae093d8(eq)))($292f8c84f8002d8c$export$45273896c792ff3b(eq)(ys))(xs));
        };
    };
};
var $292f8c84f8002d8c$export$971dd5b0dfd021b6 = function(dictEq) {
    return $292f8c84f8002d8c$export$ef1d06dc4d91d507($4MBcA.eq(dictEq));
};
var $292f8c84f8002d8c$export$90f9093465da3136 = function(n) {
    return function(xs) {
        var go = function(v) {
            return function(v1) {
                if (v1 instanceof $76RAV.Nil) return $76RAV.Nil.value;
                if (v === 0 && v1 instanceof $76RAV.Cons) return $76RAV.step(v1.value1);
                if (v1 instanceof $76RAV.Cons) return new $76RAV.Cons(v1.value0, $292f8c84f8002d8c$export$90f9093465da3136(v - 1 | 0)(v1.value1));
                throw new Error("Failed pattern match at Data.List.Lazy (line 350, column 3 - line 350, column 17): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
        return $292f8c84f8002d8c$var$map(go(n))($292f8c84f8002d8c$var$unwrap(xs));
    };
};
var $292f8c84f8002d8c$export$1822828d790e23ee = function(dictEq) {
    return $292f8c84f8002d8c$export$9ea2b6c3fae093d8($4MBcA.eq(dictEq));
};
var $292f8c84f8002d8c$export$acaf96a27438246b = function(dictEq) {
    return $292f8c84f8002d8c$var$foldl($l4M7e.flip($292f8c84f8002d8c$export$1822828d790e23ee(dictEq)));
};
var $292f8c84f8002d8c$export$c04a9f24a4230e1f = function(xs) {
    return $292f8c84f8002d8c$var$fix(function(ys) {
        return $292f8c84f8002d8c$var$append1(xs)(ys);
    });
};
var $292f8c84f8002d8c$export$c28c8388be0ab31a = /* #__PURE__ */ $l4M7e.flip($292f8c84f8002d8c$var$bind1);
var $292f8c84f8002d8c$export$ee1b3e54f0441b22 = function(v) {
    return $292f8c84f8002d8c$var$bind1(v)($292f8c84f8002d8c$var$identity);
};
var $292f8c84f8002d8c$export$986c2bbe7a34be0b = /* #__PURE__ */ $292f8c84f8002d8c$export$e70771d2e7e590a($292f8c84f8002d8c$var$identity);
var $292f8c84f8002d8c$export$2dd9d44f93be5e22 = function(n) {
    return function(f) {
        return function(xs) {
            var go = function(v) {
                return function(v1) {
                    if (v1 instanceof $76RAV.Nil) return $76RAV.Nil.value;
                    if (v === 0 && v1 instanceof $76RAV.Cons) {
                        var v2 = f(v1.value0);
                        if (v2 instanceof $ykHdR.Nothing) return $76RAV.step(v1.value1);
                        if (v2 instanceof $ykHdR.Just) return new $76RAV.Cons(v2.value0, v1.value1);
                        throw new Error("Failed pattern match at Data.List.Lazy (line 382, column 22 - line 384, column 26): " + [
                            v2.constructor.name
                        ]);
                    }
                    if (v1 instanceof $76RAV.Cons) return new $76RAV.Cons(v1.value0, $292f8c84f8002d8c$export$2dd9d44f93be5e22(v - 1 | 0)(f)(v1.value1));
                    throw new Error("Failed pattern match at Data.List.Lazy (line 381, column 3 - line 381, column 17): " + [
                        v.constructor.name,
                        v1.constructor.name
                    ]);
                };
            };
            return $292f8c84f8002d8c$var$map(go(n))($292f8c84f8002d8c$var$unwrap(xs));
        };
    };
};
var $292f8c84f8002d8c$export$cba09f9e3d3e58eb = function(n) {
    return function(f) {
        return $292f8c84f8002d8c$export$2dd9d44f93be5e22(n)(function($351) {
            return $ykHdR.Just.create(f($351));
        });
    };
};

});
parcelRegister("76RAV", function(module, exports) {

$parcel$export(module.exports, "List", () => $52d2aab060724108$export$54c2e3dc7acea9f5);
$parcel$export(module.exports, "Nil", () => $52d2aab060724108$export$c1bed610ade55e1c);
$parcel$export(module.exports, "Cons", () => $52d2aab060724108$export$74c44e616647f5c0);
$parcel$export(module.exports, "nil", () => $52d2aab060724108$export$f2c4f74e8fe88e34);
$parcel$export(module.exports, "step", () => $52d2aab060724108$export$35d34bc0ed591a92);
$parcel$export(module.exports, "semigroupList", () => $52d2aab060724108$export$11cb7909a85856b);
$parcel$export(module.exports, "lazyList", () => $52d2aab060724108$export$b4de83846969a6e1);
$parcel$export(module.exports, "functorList", () => $52d2aab060724108$export$40b9e4330ffd17e3);
$parcel$export(module.exports, "eqList", () => $52d2aab060724108$export$1ae88a7f3c5f59ef);
$parcel$export(module.exports, "ordList", () => $52d2aab060724108$export$86359cd4476084f8);
$parcel$export(module.exports, "cons", () => $52d2aab060724108$export$8327ebbef2a0ba76);
$parcel$export(module.exports, "foldableList", () => $52d2aab060724108$export$92659ee1fc91a075);
$parcel$export(module.exports, "showList", () => $52d2aab060724108$export$36831384a74c4427);
$parcel$export(module.exports, "traversableList", () => $52d2aab060724108$export$99c2ce29c0ead637);
$parcel$export(module.exports, "unfoldableList", () => $52d2aab060724108$export$1d41caf0a0a6a680);
$parcel$export(module.exports, "bindList", () => $52d2aab060724108$export$497dcf96eb2383ec);
// Generated by purs version 0.15.16

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $9Grh5 = parcelRequire("9Grh5");

var $7T8P4 = parcelRequire("7T8P4");

var $dTFzl = parcelRequire("dTFzl");

var $ibtPS = parcelRequire("ibtPS");

var $4MBcA = parcelRequire("4MBcA");

var $6RkEA = parcelRequire("6RkEA");

var $70sTh = parcelRequire("70sTh");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");

var $4oUwX = parcelRequire("4oUwX");
parcelRequire("9VGs1");
var $dc43y = parcelRequire("dc43y");
var $9VGs1 = parcelRequire("9VGs1");

var $ykHdR = parcelRequire("ykHdR");

var $aknDF = parcelRequire("aknDF");

var $6PW1p = parcelRequire("6PW1p");

var $2FBb2 = parcelRequire("2FBb2");

var $d0PPW = parcelRequire("d0PPW");

var $6SDUu = parcelRequire("6SDUu");

var $iwqgS = parcelRequire("iwqgS");

var $gyPYh = parcelRequire("gyPYh");

var $3Orkn = parcelRequire("3Orkn");

var $1wR1l = parcelRequire("1wR1l");

var $3OKRG = parcelRequire("3OKRG");

var $9MxTl = parcelRequire("9MxTl");

var $hNKjN = parcelRequire("hNKjN");
var $52d2aab060724108$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $52d2aab060724108$var$unwrap = /* #__PURE__ */ $6PW1p.unwrap();
var $52d2aab060724108$var$map = /* #__PURE__ */ $l0wDR.map($9VGs1.functorLazy);
var $52d2aab060724108$var$eq1 = /* #__PURE__ */ $4MBcA.eq1($9VGs1.eq1Lazy);
var $52d2aab060724108$var$compare1 = /* #__PURE__ */ $d0PPW.compare1($9VGs1.ord1Lazy);
var $52d2aab060724108$var$add = /* #__PURE__ */ $gyPYh.add($gyPYh.semiringInt);
var $52d2aab060724108$var$identity = /* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn);
var $52d2aab060724108$export$54c2e3dc7acea9f5 = function(x) {
    return x;
};
var $52d2aab060724108$export$c1bed610ade55e1c = /* #__PURE__ */ function() {
    function Nil() {}
    Nil.value = new Nil();
    return Nil;
}();
var $52d2aab060724108$export$74c44e616647f5c0 = /* #__PURE__ */ function() {
    function Cons(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Cons.create = function(value0) {
        return function(value1) {
            return new Cons(value0, value1);
        };
    };
    return Cons;
}();
var $52d2aab060724108$export$ab241a3582569781 = function(x) {
    return x;
};
var $52d2aab060724108$export$f2c4f74e8fe88e34 = /* #__PURE__ */ $dc43y.defer(function(v) {
    return $52d2aab060724108$export$c1bed610ade55e1c.value;
});
var $52d2aab060724108$export$e1330f0deced5836 = {
    Coercible0: function() {
        return undefined;
    }
};
var $52d2aab060724108$export$d7c6954d7d62822f = {
    Coercible0: function() {
        return undefined;
    }
};
var $52d2aab060724108$export$35d34bc0ed591a92 = function($319) {
    return $dc43y.force($52d2aab060724108$var$unwrap($319));
};
var $52d2aab060724108$export$11cb7909a85856b = {
    append: function(xs) {
        return function(ys) {
            var go = function(v) {
                if (v instanceof $52d2aab060724108$export$c1bed610ade55e1c) return $52d2aab060724108$export$35d34bc0ed591a92(ys);
                if (v instanceof $52d2aab060724108$export$74c44e616647f5c0) return new $52d2aab060724108$export$74c44e616647f5c0(v.value0, $iwqgS.append($52d2aab060724108$export$11cb7909a85856b)(v.value1)(ys));
                throw new Error("Failed pattern match at Data.List.Lazy.Types (line 103, column 5 - line 103, column 21): " + [
                    v.constructor.name
                ]);
            };
            return $52d2aab060724108$var$map(go)($52d2aab060724108$var$unwrap(xs));
        };
    }
};
var $52d2aab060724108$var$append1 = /* #__PURE__ */ $iwqgS.append($52d2aab060724108$export$11cb7909a85856b);
var $52d2aab060724108$export$14584e231e9c63ca = {
    mempty: $52d2aab060724108$export$f2c4f74e8fe88e34,
    Semigroup0: function() {
        return $52d2aab060724108$export$11cb7909a85856b;
    }
};
var $52d2aab060724108$export$b4de83846969a6e1 = {
    defer: function(f) {
        return $dc43y.defer(function($320) {
            return $52d2aab060724108$export$35d34bc0ed591a92(f($320));
        });
    }
};
var $52d2aab060724108$var$defer = /* #__PURE__ */ $dTFzl.defer($52d2aab060724108$export$b4de83846969a6e1);
var $52d2aab060724108$export$40b9e4330ffd17e3 = {
    map: function(f) {
        return function(xs) {
            var go = function(v) {
                if (v instanceof $52d2aab060724108$export$c1bed610ade55e1c) return $52d2aab060724108$export$c1bed610ade55e1c.value;
                if (v instanceof $52d2aab060724108$export$74c44e616647f5c0) return new $52d2aab060724108$export$74c44e616647f5c0(f(v.value0), $l0wDR.map($52d2aab060724108$export$40b9e4330ffd17e3)(f)(v.value1));
                throw new Error("Failed pattern match at Data.List.Lazy.Types (line 112, column 5 - line 112, column 17): " + [
                    v.constructor.name
                ]);
            };
            return $52d2aab060724108$var$map(go)($52d2aab060724108$var$unwrap(xs));
        };
    }
};
var $52d2aab060724108$var$map1 = /* #__PURE__ */ $l0wDR.map(/* #__PURE__ */ $2FBb2.functorNonEmpty($52d2aab060724108$export$40b9e4330ffd17e3));
var $52d2aab060724108$export$3c979cc7d75b024c = {
    map: function(f) {
        return function(v) {
            return $52d2aab060724108$var$map($52d2aab060724108$var$map1(f))(v);
        };
    }
};
var $52d2aab060724108$export$b7e705972f3b8317 = {
    eq1: function(dictEq) {
        var eq = $4MBcA.eq(dictEq);
        return function(xs) {
            return function(ys) {
                var go = function($copy_v) {
                    return function($copy_v1) {
                        var $tco_var_v = $copy_v;
                        var $tco_done = false;
                        var $tco_result;
                        function $tco_loop(v, v1) {
                            if (v instanceof $52d2aab060724108$export$c1bed610ade55e1c && v1 instanceof $52d2aab060724108$export$c1bed610ade55e1c) {
                                $tco_done = true;
                                return true;
                            }
                            if (v instanceof $52d2aab060724108$export$74c44e616647f5c0 && v1 instanceof $52d2aab060724108$export$74c44e616647f5c0 && eq(v.value0)(v1.value0)) {
                                $tco_var_v = $52d2aab060724108$export$35d34bc0ed591a92(v.value1);
                                $copy_v1 = $52d2aab060724108$export$35d34bc0ed591a92(v1.value1);
                                return;
                            }
                            $tco_done = true;
                            return false;
                        }
                        while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
                        return $tco_result;
                    };
                };
                return go($52d2aab060724108$export$35d34bc0ed591a92(xs))($52d2aab060724108$export$35d34bc0ed591a92(ys));
            };
        };
    }
};
var $52d2aab060724108$var$eqNonEmpty = /* #__PURE__ */ $2FBb2.eqNonEmpty($52d2aab060724108$export$b7e705972f3b8317);
var $52d2aab060724108$var$eq11 = /* #__PURE__ */ $4MBcA.eq1($52d2aab060724108$export$b7e705972f3b8317);
var $52d2aab060724108$export$80901a10e94c964a = {
    eq1: function(dictEq) {
        var eq12 = $52d2aab060724108$var$eq1($52d2aab060724108$var$eqNonEmpty(dictEq));
        return function(v) {
            return function(v1) {
                return eq12(v)(v1);
            };
        };
    }
};
var $52d2aab060724108$export$1ae88a7f3c5f59ef = function(dictEq) {
    return {
        eq: $52d2aab060724108$var$eq11(dictEq)
    };
};
var $52d2aab060724108$export$25985b0447eac39b = function(dictEq) {
    return $9VGs1.eqLazy($52d2aab060724108$var$eqNonEmpty(dictEq));
};
var $52d2aab060724108$export$a37dd417b96243af = {
    compare1: function(dictOrd) {
        var compare = $d0PPW.compare(dictOrd);
        return function(xs) {
            return function(ys) {
                var go = function($copy_v) {
                    return function($copy_v1) {
                        var $tco_var_v = $copy_v;
                        var $tco_done = false;
                        var $tco_result;
                        function $tco_loop(v, v1) {
                            if (v instanceof $52d2aab060724108$export$c1bed610ade55e1c && v1 instanceof $52d2aab060724108$export$c1bed610ade55e1c) {
                                $tco_done = true;
                                return $6SDUu.EQ.value;
                            }
                            if (v instanceof $52d2aab060724108$export$c1bed610ade55e1c) {
                                $tco_done = true;
                                return $6SDUu.LT.value;
                            }
                            if (v1 instanceof $52d2aab060724108$export$c1bed610ade55e1c) {
                                $tco_done = true;
                                return $6SDUu.GT.value;
                            }
                            if (v instanceof $52d2aab060724108$export$74c44e616647f5c0 && v1 instanceof $52d2aab060724108$export$74c44e616647f5c0) {
                                var v2 = compare(v.value0)(v1.value0);
                                if (v2 instanceof $6SDUu.EQ) {
                                    $tco_var_v = $52d2aab060724108$export$35d34bc0ed591a92(v.value1);
                                    $copy_v1 = $52d2aab060724108$export$35d34bc0ed591a92(v1.value1);
                                    return;
                                }
                                $tco_done = true;
                                return v2;
                            }
                            throw new Error("Failed pattern match at Data.List.Lazy.Types (line 89, column 5 - line 89, column 20): " + [
                                v.constructor.name,
                                v1.constructor.name
                            ]);
                        }
                        while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
                        return $tco_result;
                    };
                };
                return go($52d2aab060724108$export$35d34bc0ed591a92(xs))($52d2aab060724108$export$35d34bc0ed591a92(ys));
            };
        };
    },
    Eq10: function() {
        return $52d2aab060724108$export$b7e705972f3b8317;
    }
};
var $52d2aab060724108$var$ordNonEmpty = /* #__PURE__ */ $2FBb2.ordNonEmpty($52d2aab060724108$export$a37dd417b96243af);
var $52d2aab060724108$var$compare11 = /* #__PURE__ */ $d0PPW.compare1($52d2aab060724108$export$a37dd417b96243af);
var $52d2aab060724108$export$bf20701e75931fe8 = {
    compare1: function(dictOrd) {
        var compare12 = $52d2aab060724108$var$compare1($52d2aab060724108$var$ordNonEmpty(dictOrd));
        return function(v) {
            return function(v1) {
                return compare12(v)(v1);
            };
        };
    },
    Eq10: function() {
        return $52d2aab060724108$export$80901a10e94c964a;
    }
};
var $52d2aab060724108$export$86359cd4476084f8 = function(dictOrd) {
    var eqList1 = $52d2aab060724108$export$1ae88a7f3c5f59ef(dictOrd.Eq0());
    return {
        compare: $52d2aab060724108$var$compare11(dictOrd),
        Eq0: function() {
            return eqList1;
        }
    };
};
var $52d2aab060724108$export$783a13ebf5a1203d = function(dictOrd) {
    return $9VGs1.ordLazy($52d2aab060724108$var$ordNonEmpty(dictOrd));
};
var $52d2aab060724108$export$8327ebbef2a0ba76 = function(x) {
    return function(xs) {
        return $dc43y.defer(function(v) {
            return new $52d2aab060724108$export$74c44e616647f5c0(x, xs);
        });
    };
};
var $52d2aab060724108$export$92659ee1fc91a075 = {
    foldr: function(op) {
        return function(z) {
            return function(xs) {
                var rev = $6RkEA.foldl($52d2aab060724108$export$92659ee1fc91a075)($l4M7e.flip($52d2aab060724108$export$8327ebbef2a0ba76))($52d2aab060724108$export$f2c4f74e8fe88e34);
                return $6RkEA.foldl($52d2aab060724108$export$92659ee1fc91a075)($l4M7e.flip(op))(z)(rev(xs));
            };
        };
    },
    foldl: function(op) {
        var go = function($copy_b) {
            return function($copy_xs) {
                var $tco_var_b = $copy_b;
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(b, xs) {
                    var v = $52d2aab060724108$export$35d34bc0ed591a92(xs);
                    if (v instanceof $52d2aab060724108$export$c1bed610ade55e1c) {
                        $tco_done = true;
                        return b;
                    }
                    if (v instanceof $52d2aab060724108$export$74c44e616647f5c0) {
                        $tco_var_b = op(b)(v.value0);
                        $copy_xs = v.value1;
                        return;
                    }
                    throw new Error("Failed pattern match at Data.List.Lazy.Types (line 127, column 7 - line 129, column 40): " + [
                        v.constructor.name
                    ]);
                }
                while(!$tco_done)$tco_result = $tco_loop($tco_var_b, $copy_xs);
                return $tco_result;
            };
        };
        return go;
    },
    foldMap: function(dictMonoid) {
        var append2 = $iwqgS.append(dictMonoid.Semigroup0());
        var mempty = $aknDF.mempty(dictMonoid);
        return function(f) {
            return $6RkEA.foldl($52d2aab060724108$export$92659ee1fc91a075)(function(b) {
                return function(a) {
                    return append2(b)(f(a));
                };
            })(mempty);
        };
    }
};
var $52d2aab060724108$var$foldr = /* #__PURE__ */ $6RkEA.foldr($52d2aab060724108$export$92659ee1fc91a075);
var $52d2aab060724108$var$foldableNonEmpty = /* #__PURE__ */ $2FBb2.foldableNonEmpty($52d2aab060724108$export$92659ee1fc91a075);
var $52d2aab060724108$var$foldr1 = /* #__PURE__ */ $6RkEA.foldr($52d2aab060724108$var$foldableNonEmpty);
var $52d2aab060724108$var$foldl = /* #__PURE__ */ $6RkEA.foldl($52d2aab060724108$var$foldableNonEmpty);
var $52d2aab060724108$var$foldMap = /* #__PURE__ */ $6RkEA.foldMap($52d2aab060724108$var$foldableNonEmpty);
var $52d2aab060724108$var$foldl1 = /* #__PURE__ */ $6RkEA.foldl($52d2aab060724108$export$92659ee1fc91a075);
var $52d2aab060724108$export$a2b02e086d468c06 = {
    extend: function(f) {
        return function(l) {
            var go = function(a) {
                return function(v) {
                    var acc$prime = $52d2aab060724108$export$8327ebbef2a0ba76(a)(v.acc);
                    return {
                        val: $52d2aab060724108$export$8327ebbef2a0ba76(f(acc$prime))(v.val),
                        acc: acc$prime
                    };
                };
            };
            var v = $52d2aab060724108$export$35d34bc0ed591a92(l);
            if (v instanceof $52d2aab060724108$export$c1bed610ade55e1c) return $52d2aab060724108$export$f2c4f74e8fe88e34;
            if (v instanceof $52d2aab060724108$export$74c44e616647f5c0) return $52d2aab060724108$export$8327ebbef2a0ba76(f(l))($52d2aab060724108$var$foldr(go)({
                val: $52d2aab060724108$export$f2c4f74e8fe88e34,
                acc: $52d2aab060724108$export$f2c4f74e8fe88e34
            })(v.value1).val);
            throw new Error("Failed pattern match at Data.List.Lazy.Types (line 197, column 5 - line 200, column 55): " + [
                v.constructor.name
            ]);
        };
    },
    Functor0: function() {
        return $52d2aab060724108$export$40b9e4330ffd17e3;
    }
};
var $52d2aab060724108$export$44a6d15320cfc4c5 = {
    extend: function(f) {
        return function(v) {
            var go = function(a) {
                return function(v1) {
                    return {
                        val: $52d2aab060724108$export$8327ebbef2a0ba76(f($dc43y.defer(function(v2) {
                            return new $2FBb2.NonEmpty(a, v1.acc);
                        })))(v1.val),
                        acc: $52d2aab060724108$export$8327ebbef2a0ba76(a)(v1.acc)
                    };
                };
            };
            var v1 = $dc43y.force(v);
            return $dc43y.defer(function(v2) {
                return new $2FBb2.NonEmpty(f(v), $52d2aab060724108$var$foldr(go)({
                    val: $52d2aab060724108$export$f2c4f74e8fe88e34,
                    acc: $52d2aab060724108$export$f2c4f74e8fe88e34
                })(v1.value1).val);
            });
        };
    },
    Functor0: function() {
        return $52d2aab060724108$export$3c979cc7d75b024c;
    }
};
var $52d2aab060724108$export$604c31769a93bbe0 = {
    foldr: function(f) {
        return function(b) {
            return function(v) {
                return $52d2aab060724108$var$foldr1(f)(b)($dc43y.force(v));
            };
        };
    },
    foldl: function(f) {
        return function(b) {
            return function(v) {
                return $52d2aab060724108$var$foldl(f)(b)($dc43y.force(v));
            };
        };
    },
    foldMap: function(dictMonoid) {
        var foldMap1 = $52d2aab060724108$var$foldMap(dictMonoid);
        return function(f) {
            return function(v) {
                return foldMap1(f)($dc43y.force(v));
            };
        };
    }
};
var $52d2aab060724108$export$36831384a74c4427 = function(dictShow) {
    var show = $3Orkn.show(dictShow);
    return {
        show: function(xs) {
            return "(fromFoldable [" + (function() {
                var v = $52d2aab060724108$export$35d34bc0ed591a92(xs);
                if (v instanceof $52d2aab060724108$export$c1bed610ade55e1c) return "";
                if (v instanceof $52d2aab060724108$export$74c44e616647f5c0) return show(v.value0) + $52d2aab060724108$var$foldl1(function(shown) {
                    return function(x$prime) {
                        return shown + ("," + show(x$prime));
                    };
                })("")(v.value1);
                throw new Error("Failed pattern match at Data.List.Lazy.Types (line 66, column 13 - line 69, column 78): " + [
                    v.constructor.name
                ]);
            }() + "])");
        }
    };
};
var $52d2aab060724108$export$3a5290e21dfc0ad7 = function(dictShow) {
    var show = $3Orkn.show($9VGs1.showLazy($2FBb2.showNonEmpty(dictShow)($52d2aab060724108$export$36831384a74c4427(dictShow))));
    return {
        show: function(v) {
            return "(NonEmptyList " + (show(v) + ")");
        }
    };
};
var $52d2aab060724108$export$17f3d25eed773ff1 = function(dictShow) {
    var show = $3Orkn.show(dictShow);
    var show1 = $3Orkn.show($52d2aab060724108$export$36831384a74c4427(dictShow));
    return {
        show: function(v) {
            if (v instanceof $52d2aab060724108$export$c1bed610ade55e1c) return "Nil";
            if (v instanceof $52d2aab060724108$export$74c44e616647f5c0) return "(" + (show(v.value0) + (" : " + (show1(v.value1) + ")")));
            throw new Error("Failed pattern match at Data.List.Lazy.Types (line 36, column 1 - line 38, column 62): " + [
                v.constructor.name
            ]);
        }
    };
};
var $52d2aab060724108$export$465bfc9894c20a50 = {
    foldrWithIndex: function(f) {
        return function(b) {
            return function(xs) {
                var v = function() {
                    var rev = $52d2aab060724108$var$foldl1(function(v1) {
                        return function(a) {
                            return new $9MxTl.Tuple(v1.value0 + 1 | 0, $52d2aab060724108$export$8327ebbef2a0ba76(a)(v1.value1));
                        };
                    });
                    return rev(new $9MxTl.Tuple(0, $52d2aab060724108$export$f2c4f74e8fe88e34))(xs);
                }();
                return $9MxTl.snd($52d2aab060724108$var$foldl1(function(v1) {
                    return function(a) {
                        return new $9MxTl.Tuple(v1.value0 - 1 | 0, f(v1.value0 - 1 | 0)(a)(v1.value1));
                    };
                })(new $9MxTl.Tuple(v.value0, b))(v.value1));
            };
        };
    },
    foldlWithIndex: function(f) {
        return function(acc) {
            var $321 = $52d2aab060724108$var$foldl1(function(v) {
                return function(a) {
                    return new $9MxTl.Tuple(v.value0 + 1 | 0, f(v.value0)(v.value1)(a));
                };
            })(new $9MxTl.Tuple(0, acc));
            return function($322) {
                return $9MxTl.snd($321($322));
            };
        };
    },
    foldMapWithIndex: function(dictMonoid) {
        var append2 = $iwqgS.append(dictMonoid.Semigroup0());
        var mempty = $aknDF.mempty(dictMonoid);
        return function(f) {
            return $70sTh.foldlWithIndex($52d2aab060724108$export$465bfc9894c20a50)(function(i) {
                return function(acc) {
                    var $323 = append2(acc);
                    var $324 = f(i);
                    return function($325) {
                        return $323($324($325));
                    };
                };
            })(mempty);
        };
    },
    Foldable0: function() {
        return $52d2aab060724108$export$92659ee1fc91a075;
    }
};
var $52d2aab060724108$var$foldableWithIndexNonEmpty = /* #__PURE__ */ $2FBb2.foldableWithIndexNonEmpty($52d2aab060724108$export$465bfc9894c20a50);
var $52d2aab060724108$var$foldMapWithIndex = /* #__PURE__ */ $70sTh.foldMapWithIndex($52d2aab060724108$var$foldableWithIndexNonEmpty);
var $52d2aab060724108$var$foldlWithIndex = /* #__PURE__ */ $70sTh.foldlWithIndex($52d2aab060724108$var$foldableWithIndexNonEmpty);
var $52d2aab060724108$var$foldrWithIndex = /* #__PURE__ */ $70sTh.foldrWithIndex($52d2aab060724108$var$foldableWithIndexNonEmpty);
var $52d2aab060724108$var$foldrWithIndex1 = /* #__PURE__ */ $70sTh.foldrWithIndex($52d2aab060724108$export$465bfc9894c20a50);
var $52d2aab060724108$export$181d5b43cf38a79a = {
    foldMapWithIndex: function(dictMonoid) {
        var foldMapWithIndex1 = $52d2aab060724108$var$foldMapWithIndex(dictMonoid);
        return function(f) {
            return function(v) {
                return foldMapWithIndex1(function() {
                    var $326 = $ykHdR.maybe(0)($52d2aab060724108$var$add(1));
                    return function($327) {
                        return f($326($327));
                    };
                }())($dc43y.force(v));
            };
        };
    },
    foldlWithIndex: function(f) {
        return function(b) {
            return function(v) {
                return $52d2aab060724108$var$foldlWithIndex(function() {
                    var $328 = $ykHdR.maybe(0)($52d2aab060724108$var$add(1));
                    return function($329) {
                        return f($328($329));
                    };
                }())(b)($dc43y.force(v));
            };
        };
    },
    foldrWithIndex: function(f) {
        return function(b) {
            return function(v) {
                return $52d2aab060724108$var$foldrWithIndex(function() {
                    var $330 = $ykHdR.maybe(0)($52d2aab060724108$var$add(1));
                    return function($331) {
                        return f($330($331));
                    };
                }())(b)($dc43y.force(v));
            };
        };
    },
    Foldable0: function() {
        return $52d2aab060724108$export$604c31769a93bbe0;
    }
};
var $52d2aab060724108$export$3951fb12c9649f2b = {
    mapWithIndex: function(f) {
        return $52d2aab060724108$var$foldrWithIndex1(function(i) {
            return function(x) {
                return function(acc) {
                    return $52d2aab060724108$export$8327ebbef2a0ba76(f(i)(x))(acc);
                };
            };
        })($52d2aab060724108$export$f2c4f74e8fe88e34);
    },
    Functor0: function() {
        return $52d2aab060724108$export$40b9e4330ffd17e3;
    }
};
var $52d2aab060724108$var$mapWithIndex = /* #__PURE__ */ $4oUwX.mapWithIndex(/* #__PURE__ */ $2FBb2.functorWithIndex($52d2aab060724108$export$3951fb12c9649f2b));
var $52d2aab060724108$export$116ff457f4ca2f6a = {
    mapWithIndex: function(f) {
        return function(v) {
            return $dc43y.defer(function(v1) {
                return $52d2aab060724108$var$mapWithIndex(function() {
                    var $332 = $ykHdR.maybe(0)($52d2aab060724108$var$add(1));
                    return function($333) {
                        return f($332($333));
                    };
                }())($dc43y.force(v));
            });
        };
    },
    Functor0: function() {
        return $52d2aab060724108$export$3c979cc7d75b024c;
    }
};
var $52d2aab060724108$export$effcdbd76139450 = function(v) {
    return $52d2aab060724108$var$defer(function(v1) {
        var v2 = $dc43y.force(v);
        return $52d2aab060724108$export$8327ebbef2a0ba76(v2.value0)(v2.value1);
    });
};
var $52d2aab060724108$export$a8cfc3dfdfca72cf = {
    append: function(v) {
        return function(as$prime) {
            var v1 = $dc43y.force(v);
            return $dc43y.defer(function(v2) {
                return new $2FBb2.NonEmpty(v1.value0, $52d2aab060724108$var$append1(v1.value1)($52d2aab060724108$export$effcdbd76139450(as$prime)));
            });
        };
    }
};
var $52d2aab060724108$export$99c2ce29c0ead637 = {
    traverse: function(dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        var apply1 = $a5g3C.apply(Apply0);
        var map2 = $l0wDR.map(Apply0.Functor0());
        var pure = $gUTA8.pure(dictApplicative);
        return function(f) {
            return $52d2aab060724108$var$foldr(function(a) {
                return function(b) {
                    return apply1(map2($52d2aab060724108$export$8327ebbef2a0ba76)(f(a)))(b);
                };
            })(pure($52d2aab060724108$export$f2c4f74e8fe88e34));
        };
    },
    sequence: function(dictApplicative) {
        return $1wR1l.traverse($52d2aab060724108$export$99c2ce29c0ead637)(dictApplicative)($52d2aab060724108$var$identity);
    },
    Functor0: function() {
        return $52d2aab060724108$export$40b9e4330ffd17e3;
    },
    Foldable1: function() {
        return $52d2aab060724108$export$92659ee1fc91a075;
    }
};
var $52d2aab060724108$var$traversableNonEmpty = /* #__PURE__ */ $2FBb2.traversableNonEmpty($52d2aab060724108$export$99c2ce29c0ead637);
var $52d2aab060724108$var$traverse = /* #__PURE__ */ $1wR1l.traverse($52d2aab060724108$var$traversableNonEmpty);
var $52d2aab060724108$var$sequence = /* #__PURE__ */ $1wR1l.sequence($52d2aab060724108$var$traversableNonEmpty);
var $52d2aab060724108$export$d0a0d45336d2d3e3 = {
    traverse: function(dictApplicative) {
        var map2 = $l0wDR.map(dictApplicative.Apply0().Functor0());
        var traverse1 = $52d2aab060724108$var$traverse(dictApplicative);
        return function(f) {
            return function(v) {
                return map2(function(xxs) {
                    return $dc43y.defer(function(v1) {
                        return xxs;
                    });
                })(traverse1(f)($dc43y.force(v)));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map2 = $l0wDR.map(dictApplicative.Apply0().Functor0());
        var sequence1 = $52d2aab060724108$var$sequence(dictApplicative);
        return function(v) {
            return map2(function(xxs) {
                return $dc43y.defer(function(v1) {
                    return xxs;
                });
            })(sequence1($dc43y.force(v)));
        };
    },
    Functor0: function() {
        return $52d2aab060724108$export$3c979cc7d75b024c;
    },
    Foldable1: function() {
        return $52d2aab060724108$export$604c31769a93bbe0;
    }
};
var $52d2aab060724108$export$aed77e3b7bbfc02d = {
    traverseWithIndex: function(dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        var apply1 = $a5g3C.apply(Apply0);
        var map2 = $l0wDR.map(Apply0.Functor0());
        var pure = $gUTA8.pure(dictApplicative);
        return function(f) {
            return $52d2aab060724108$var$foldrWithIndex1(function(i) {
                return function(a) {
                    return function(b) {
                        return apply1(map2($52d2aab060724108$export$8327ebbef2a0ba76)(f(i)(a)))(b);
                    };
                };
            })(pure($52d2aab060724108$export$f2c4f74e8fe88e34));
        };
    },
    FunctorWithIndex0: function() {
        return $52d2aab060724108$export$3951fb12c9649f2b;
    },
    FoldableWithIndex1: function() {
        return $52d2aab060724108$export$465bfc9894c20a50;
    },
    Traversable2: function() {
        return $52d2aab060724108$export$99c2ce29c0ead637;
    }
};
var $52d2aab060724108$var$traverseWithIndex = /* #__PURE__ */ $3OKRG.traverseWithIndex(/* #__PURE__ */ $2FBb2.traversableWithIndexNonEmpty($52d2aab060724108$export$aed77e3b7bbfc02d));
var $52d2aab060724108$export$29974dc3d1d7196b = {
    traverseWithIndex: function(dictApplicative) {
        var map2 = $l0wDR.map(dictApplicative.Apply0().Functor0());
        var traverseWithIndex1 = $52d2aab060724108$var$traverseWithIndex(dictApplicative);
        return function(f) {
            return function(v) {
                return map2(function(xxs) {
                    return $dc43y.defer(function(v1) {
                        return xxs;
                    });
                })(traverseWithIndex1(function() {
                    var $334 = $ykHdR.maybe(0)($52d2aab060724108$var$add(1));
                    return function($335) {
                        return f($334($335));
                    };
                }())($dc43y.force(v)));
            };
        };
    },
    FunctorWithIndex0: function() {
        return $52d2aab060724108$export$116ff457f4ca2f6a;
    },
    FoldableWithIndex1: function() {
        return $52d2aab060724108$export$181d5b43cf38a79a;
    },
    Traversable2: function() {
        return $52d2aab060724108$export$d0a0d45336d2d3e3;
    }
};
var $52d2aab060724108$export$c7fe2ca4bf0cb8df = {
    unfoldr1: /* #__PURE__ */ function() {
        var go = function(f) {
            return function(b) {
                return $52d2aab060724108$var$defer(function(v) {
                    var v1 = f(b);
                    if (v1.value1 instanceof $ykHdR.Just) return $52d2aab060724108$export$8327ebbef2a0ba76(v1.value0)(go(f)(v1.value1.value0));
                    if (v1.value1 instanceof $ykHdR.Nothing) return $52d2aab060724108$export$8327ebbef2a0ba76(v1.value0)($52d2aab060724108$export$f2c4f74e8fe88e34);
                    throw new Error("Failed pattern match at Data.List.Lazy.Types (line 151, column 28 - line 153, column 33): " + [
                        v1.constructor.name
                    ]);
                });
            };
        };
        return go;
    }()
};
var $52d2aab060724108$export$1d41caf0a0a6a680 = {
    unfoldr: /* #__PURE__ */ function() {
        var go = function(f) {
            return function(b) {
                return $52d2aab060724108$var$defer(function(v) {
                    var v1 = f(b);
                    if (v1 instanceof $ykHdR.Nothing) return $52d2aab060724108$export$f2c4f74e8fe88e34;
                    if (v1 instanceof $ykHdR.Just) return $52d2aab060724108$export$8327ebbef2a0ba76(v1.value0.value0)(go(f)(v1.value0.value1));
                    throw new Error("Failed pattern match at Data.List.Lazy.Types (line 157, column 28 - line 159, column 39): " + [
                        v1.constructor.name
                    ]);
                });
            };
        };
        return go;
    }(),
    Unfoldable10: function() {
        return $52d2aab060724108$export$c7fe2ca4bf0cb8df;
    }
};
var $52d2aab060724108$var$unfoldr1 = /* #__PURE__ */ $hNKjN.unfoldr1(/* #__PURE__ */ $2FBb2.unfoldable1NonEmpty($52d2aab060724108$export$1d41caf0a0a6a680));
var $52d2aab060724108$export$6907256bb4275b5b = {
    unfoldr1: function(f) {
        return function(b) {
            return $dc43y.defer(function(v) {
                return $52d2aab060724108$var$unfoldr1(f)(b);
            });
        };
    }
};
var $52d2aab060724108$export$7bc4d4de9c57db1f = {
    extract: function(v) {
        return $2FBb2.head($dc43y.force(v));
    },
    Extend0: function() {
        return $52d2aab060724108$export$44a6d15320cfc4c5;
    }
};
var $52d2aab060724108$export$7c78e86b21f51881 = {
    Applicative0: function() {
        return $52d2aab060724108$export$25cda6d3e08b28fe;
    },
    Bind1: function() {
        return $52d2aab060724108$export$497dcf96eb2383ec;
    }
};
var $52d2aab060724108$export$497dcf96eb2383ec = {
    bind: function(xs) {
        return function(f) {
            var go = function(v) {
                if (v instanceof $52d2aab060724108$export$c1bed610ade55e1c) return $52d2aab060724108$export$c1bed610ade55e1c.value;
                if (v instanceof $52d2aab060724108$export$74c44e616647f5c0) return $52d2aab060724108$export$35d34bc0ed591a92($52d2aab060724108$var$append1(f(v.value0))($9Grh5.bind($52d2aab060724108$export$497dcf96eb2383ec)(v.value1)(f)));
                throw new Error("Failed pattern match at Data.List.Lazy.Types (line 180, column 5 - line 180, column 17): " + [
                    v.constructor.name
                ]);
            };
            return $52d2aab060724108$var$map(go)($52d2aab060724108$var$unwrap(xs));
        };
    },
    Apply0: function() {
        return $52d2aab060724108$var$$lazy_applyList(0);
    }
};
var $52d2aab060724108$export$25cda6d3e08b28fe = {
    pure: function(a) {
        return $52d2aab060724108$export$8327ebbef2a0ba76(a)($52d2aab060724108$export$f2c4f74e8fe88e34);
    },
    Apply0: function() {
        return $52d2aab060724108$var$$lazy_applyList(0);
    }
};
var $52d2aab060724108$var$$lazy_applyList = /* #__PURE__ */ $52d2aab060724108$var$$runtime_lazy("applyList", "Data.List.Lazy.Types", function() {
    return {
        apply: $ibtPS.ap($52d2aab060724108$export$7c78e86b21f51881),
        Functor0: function() {
            return $52d2aab060724108$export$40b9e4330ffd17e3;
        }
    };
});
var $52d2aab060724108$export$7e49f2fa1ca16fbc = /* #__PURE__ */ $52d2aab060724108$var$$lazy_applyList(171);
var $52d2aab060724108$var$apply = /* #__PURE__ */ $a5g3C.apply($52d2aab060724108$export$7e49f2fa1ca16fbc);
var $52d2aab060724108$var$bind = /* #__PURE__ */ $9Grh5.bind($52d2aab060724108$export$497dcf96eb2383ec);
var $52d2aab060724108$export$18f1a42667f2921e = {
    apply: function(v) {
        return function(v1) {
            var v2 = $dc43y.force(v1);
            var v3 = $dc43y.force(v);
            return $dc43y.defer(function(v4) {
                return new $2FBb2.NonEmpty(v3.value0(v2.value0), $52d2aab060724108$var$append1($52d2aab060724108$var$apply(v3.value1)($52d2aab060724108$export$8327ebbef2a0ba76(v2.value0)($52d2aab060724108$export$f2c4f74e8fe88e34)))($52d2aab060724108$var$apply($52d2aab060724108$export$8327ebbef2a0ba76(v3.value0)(v3.value1))(v2.value1)));
            });
        };
    },
    Functor0: function() {
        return $52d2aab060724108$export$3c979cc7d75b024c;
    }
};
var $52d2aab060724108$export$12e3398ee6f4a417 = {
    bind: function(v) {
        return function(f) {
            var v1 = $dc43y.force(v);
            var v2 = $dc43y.force($52d2aab060724108$var$unwrap(f(v1.value0)));
            return $dc43y.defer(function(v3) {
                return new $2FBb2.NonEmpty(v2.value0, $52d2aab060724108$var$append1(v2.value1)($52d2aab060724108$var$bind(v1.value1)(function($336) {
                    return $52d2aab060724108$export$effcdbd76139450(f($336));
                })));
            });
        };
    },
    Apply0: function() {
        return $52d2aab060724108$export$18f1a42667f2921e;
    }
};
var $52d2aab060724108$export$852a754cd45a1ed = {
    alt: /* #__PURE__ */ $iwqgS.append($52d2aab060724108$export$a8cfc3dfdfca72cf),
    Functor0: function() {
        return $52d2aab060724108$export$3c979cc7d75b024c;
    }
};
var $52d2aab060724108$export$97980ce7ea95015b = {
    alt: $52d2aab060724108$var$append1,
    Functor0: function() {
        return $52d2aab060724108$export$40b9e4330ffd17e3;
    }
};
var $52d2aab060724108$export$55d622505c452dcb = {
    empty: $52d2aab060724108$export$f2c4f74e8fe88e34,
    Alt0: function() {
        return $52d2aab060724108$export$97980ce7ea95015b;
    }
};
var $52d2aab060724108$var$singleton = /* #__PURE__ */ $2FBb2.singleton($52d2aab060724108$export$55d622505c452dcb);
var $52d2aab060724108$export$503ce72759d93980 = {
    Applicative0: function() {
        return $52d2aab060724108$export$25cda6d3e08b28fe;
    },
    Plus1: function() {
        return $52d2aab060724108$export$55d622505c452dcb;
    }
};
var $52d2aab060724108$export$9ea554ee3c75e458 = {
    Monad0: function() {
        return $52d2aab060724108$export$7c78e86b21f51881;
    },
    Alternative1: function() {
        return $52d2aab060724108$export$503ce72759d93980;
    }
};
var $52d2aab060724108$export$e5d0ed5dac805e10 = {
    pure: function(a) {
        return $dc43y.defer(function(v) {
            return $52d2aab060724108$var$singleton(a);
        });
    },
    Apply0: function() {
        return $52d2aab060724108$export$18f1a42667f2921e;
    }
};
var $52d2aab060724108$export$f444cc7484072e62 = {
    Applicative0: function() {
        return $52d2aab060724108$export$e5d0ed5dac805e10;
    },
    Bind1: function() {
        return $52d2aab060724108$export$12e3398ee6f4a417;
    }
};

});



parcelRegister("hmOcH", function(module, exports) {

$parcel$export(module.exports, "satisfyCodePoint", () => $ca4b6f31ec4b9857$export$566aa36e2fcdcfb9);
$parcel$export(module.exports, "satisfy", () => $ca4b6f31ec4b9857$export$ec0bab193bdafe1);
$parcel$export(module.exports, "eof", () => $ca4b6f31ec4b9857$export$d83becf4b42ec59);
$parcel$export(module.exports, "consumeWith", () => $ca4b6f31ec4b9857$export$9b3710c6484cace);
$parcel$export(module.exports, "regex", () => $ca4b6f31ec4b9857$export$17b0f4d84dbfeedf);
$parcel$export(module.exports, "string", () => $ca4b6f31ec4b9857$export$22b082955e083ec3);
$parcel$export(module.exports, "char", () => $ca4b6f31ec4b9857$export$eba6f6f03b0a92e7);
$parcel$export(module.exports, "anyCodePoint", () => $ca4b6f31ec4b9857$export$3eeefabf9b38b449);
$parcel$export(module.exports, "anyChar", () => $ca4b6f31ec4b9857$export$3df35137cff8cab7);
// Generated by purs version 0.15.16

var $a7Dxq = parcelRequire("a7Dxq");

var $gUTA8 = parcelRequire("gUTA8");

var $9Grh5 = parcelRequire("9Grh5");

var $lowBm = parcelRequire("lowBm");

var $4VF0K = parcelRequire("4VF0K");

var $jxBf5 = parcelRequire("jxBf5");

var $6UHO6 = parcelRequire("6UHO6");

var $aKY4H = parcelRequire("aKY4H");

var $loxi1 = parcelRequire("loxi1");

var $4MBcA = parcelRequire("4MBcA");

var $fb7aO = parcelRequire("fb7aO");

var $l4M7e = parcelRequire("l4M7e");
parcelRequire("ikChJ");
var $chZgc = parcelRequire("chZgc");

var $l0wDR = parcelRequire("l0wDR");

var $c8kPS = parcelRequire("c8kPS");

var $ykHdR = parcelRequire("ykHdR");

var $d0PPW = parcelRequire("d0PPW");

var $3Orkn = parcelRequire("3Orkn");

var $5oIYL = parcelRequire("5oIYL");
parcelRequire("2gT7Y");
var $MTXA4 = parcelRequire("MTXA4");
var $2gT7Y = parcelRequire("2gT7Y");
parcelRequire("2Zpo4");
var $7OyoZ = parcelRequire("7OyoZ");
var $2Zpo4 = parcelRequire("2Zpo4");

var $jVyOx = parcelRequire("jVyOx");

var $9MxTl = parcelRequire("9MxTl");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");

var $3J9zV = parcelRequire("3J9zV");

var $1woEV = parcelRequire("1woEV");
var $ca4b6f31ec4b9857$var$fromEnum = /* #__PURE__ */ $loxi1.fromEnum($5oIYL.boundedEnumCodePoint);
var $ca4b6f31ec4b9857$var$mod = /* #__PURE__ */ $fb7aO.mod($fb7aO.euclideanRingInt);
var $ca4b6f31ec4b9857$var$fromJust = /* #__PURE__ */ $ykHdR.fromJust();
var $ca4b6f31ec4b9857$var$toEnum = /* #__PURE__ */ $loxi1.toEnum($loxi1.boundedEnumChar);
var $ca4b6f31ec4b9857$var$eq1 = /* #__PURE__ */ $4MBcA.eq($5oIYL.eqCodePoint);
var $ca4b6f31ec4b9857$var$div = /* #__PURE__ */ $fb7aO.div($fb7aO.euclideanRingInt);
var $ca4b6f31ec4b9857$var$max = /* #__PURE__ */ $d0PPW.max($d0PPW.ordInt);
var $ca4b6f31ec4b9857$var$min = /* #__PURE__ */ $d0PPW.min($d0PPW.ordInt);
var $ca4b6f31ec4b9857$var$show = /* #__PURE__ */ $3Orkn.show($3Orkn.showInt);
var $ca4b6f31ec4b9857$var$bind = /* #__PURE__ */ $9Grh5.bind($3J9zV.bindParserT);
var $ca4b6f31ec4b9857$var$pure = /* #__PURE__ */ $gUTA8.pure($3J9zV.applicativeParserT);
var $ca4b6f31ec4b9857$var$mapFlipped = /* #__PURE__ */ $l0wDR.mapFlipped($aKY4H.functorEither);
var $ca4b6f31ec4b9857$var$map = /* #__PURE__ */ $l0wDR.map($ykHdR.functorMaybe);
var $ca4b6f31ec4b9857$var$show1 = /* #__PURE__ */ $3Orkn.show($3Orkn.showString);
var $ca4b6f31ec4b9857$var$show2 = /* #__PURE__ */ $3Orkn.show($3Orkn.showChar);
var $ca4b6f31ec4b9857$var$alt = /* #__PURE__ */ $a7Dxq.alt($3J9zV.altParserT);
var $ca4b6f31ec4b9857$var$tailRecM = /* #__PURE__ */ $lowBm.tailRecM($3J9zV.monadRecParserT);
var $ca4b6f31ec4b9857$var$updatePosSingle = function(v) {
    return function(cp) {
        return function(after) {
            var v1 = $ca4b6f31ec4b9857$var$fromEnum(cp);
            if (v1 === 10) return {
                index: v.index + 1 | 0,
                line: v.line + 1 | 0,
                column: 1
            };
            if (v1 === 13) {
                var v2 = $5oIYL.codePointAt(0)(after);
                if (v2 instanceof $ykHdR.Just && $ca4b6f31ec4b9857$var$fromEnum(v2.value0) === 10) return {
                    index: v.index + 1 | 0,
                    line: v.line,
                    column: v.column
                };
                return {
                    index: v.index + 1 | 0,
                    line: v.line + 1 | 0,
                    column: 1
                };
            }
            if (v1 === 9) return {
                index: v.index + 1 | 0,
                line: v.line,
                column: (v.column + 8 | 0) - $ca4b6f31ec4b9857$var$mod(v.column - 1 | 0)(8) | 0
            };
            return {
                index: v.index + 1 | 0,
                line: v.line,
                column: v.column + 1 | 0
            };
        };
    };
};
var $ca4b6f31ec4b9857$var$updatePosString = function($copy_pos) {
    return function($copy_before) {
        return function($copy_after) {
            var $tco_var_pos = $copy_pos;
            var $tco_var_before = $copy_before;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(pos, before, after) {
                var v = $5oIYL.uncons(before);
                if (v instanceof $ykHdR.Nothing) {
                    $tco_done = true;
                    return pos;
                }
                if (v instanceof $ykHdR.Just) {
                    var newPos = function() {
                        if ($2Zpo4.null(v.value0.tail)) return $ca4b6f31ec4b9857$var$updatePosSingle(pos)(v.value0.head)(after);
                        if ($6UHO6.otherwise) return $ca4b6f31ec4b9857$var$updatePosSingle(pos)(v.value0.head)(v.value0.tail);
                        throw new Error("Failed pattern match at Parsing.String (line 165, column 7 - line 167, column 52): ");
                    }();
                    $tco_var_pos = newPos;
                    $tco_var_before = v.value0.tail;
                    $copy_after = after;
                    return;
                }
                throw new Error("Failed pattern match at Parsing.String (line 161, column 36 - line 168, column 38): " + [
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_pos, $tco_var_before, $copy_after);
            return $tco_result;
        };
    };
};
var $ca4b6f31ec4b9857$export$566aa36e2fcdcfb9 = function(f) {
    return $chZgc.mkFn5(function(v) {
        return function(v1) {
            return function(v2) {
                return function($$throw) {
                    return function(done) {
                        var v3 = $5oIYL.uncons(v.value0);
                        if (v3 instanceof $ykHdR.Nothing) return $$throw(v, new $3J9zV.ParseError("Unexpected EOF", v.value1));
                        if (v3 instanceof $ykHdR.Just) {
                            var $76 = f(v3.value0.head);
                            if ($76) return done(new $3J9zV.ParseState(v3.value0.tail, $ca4b6f31ec4b9857$var$updatePosSingle(v.value1)(v3.value0.head)(v3.value0.tail), true), v3.value0.head);
                            return $$throw(v, new $3J9zV.ParseError("Predicate unsatisfied", v.value1));
                        }
                        throw new Error("Failed pattern match at Parsing.String (line 136, column 7 - line 143, column 73): " + [
                            v3.constructor.name
                        ]);
                    };
                };
            };
        };
    });
};
var $ca4b6f31ec4b9857$export$ec0bab193bdafe1 = function(f) {
    return $chZgc.mkFn5(function(v) {
        return function(v1) {
            return function(v2) {
                return function($$throw) {
                    return function(done) {
                        var v3 = $5oIYL.uncons(v.value0);
                        if (v3 instanceof $ykHdR.Nothing) return $$throw(v, new $3J9zV.ParseError("Unexpected EOF", v.value1));
                        if (v3 instanceof $ykHdR.Just) {
                            var cp = $ca4b6f31ec4b9857$var$fromEnum(v3.value0.head);
                            var $85 = cp < 0 || cp > 65535;
                            if ($85) return $$throw(v, new $3J9zV.ParseError("Expected Char", v.value1));
                            var ch = $ca4b6f31ec4b9857$var$fromJust($ca4b6f31ec4b9857$var$toEnum(cp));
                            var $86 = f(ch);
                            if ($86) return done(new $3J9zV.ParseState(v3.value0.tail, $ca4b6f31ec4b9857$var$updatePosSingle(v.value1)(v3.value0.head)(v3.value0.tail), true), ch);
                            return $$throw(v, new $3J9zV.ParseError("Predicate unsatisfied", v.value1));
                        }
                        throw new Error("Failed pattern match at Parsing.String (line 114, column 7 - line 129, column 75): " + [
                            v3.constructor.name
                        ]);
                    };
                };
            };
        };
    });
};
var $ca4b6f31ec4b9857$export$37fb72b4878ecd33 = function(input) {
    return function(contextSize) {
        return function(v) {
            var v1 = function() {
                var go = function($copy_posBegin) {
                    return function($copy_lineBegin) {
                        return function($copy_posEnd) {
                            return function($copy_lineEnd) {
                                var $tco_var_posBegin = $copy_posBegin;
                                var $tco_var_lineBegin = $copy_lineBegin;
                                var $tco_var_posEnd = $copy_posEnd;
                                var $tco_done = false;
                                var $tco_result;
                                function $tco_loop(posBegin, lineBegin, posEnd, lineEnd) {
                                    var v2 = $5oIYL.uncons(lineEnd);
                                    if (v2 instanceof $ykHdR.Just && $ca4b6f31ec4b9857$var$eq1(v2.value0.head)($5oIYL.codePointFromChar("\x0a"))) {
                                        var $97 = posEnd === v.value1.index;
                                        if ($97) {
                                            $tco_done = true;
                                            return {
                                                posBegin: posBegin,
                                                posEnd: posEnd + 1 | 0,
                                                lineBegin: lineBegin
                                            };
                                        }
                                        var $98 = posEnd > v.value1.index;
                                        if ($98) {
                                            $tco_done = true;
                                            return {
                                                posBegin: posBegin,
                                                posEnd: posEnd,
                                                lineBegin: lineBegin
                                            };
                                        }
                                        $tco_var_posBegin = posEnd + 1 | 0;
                                        $tco_var_lineBegin = v2.value0.tail;
                                        $tco_var_posEnd = posEnd + 1 | 0;
                                        $copy_lineEnd = v2.value0.tail;
                                        return;
                                    }
                                    if (v2 instanceof $ykHdR.Just && $ca4b6f31ec4b9857$var$eq1(v2.value0.head)($5oIYL.codePointFromChar("\x0d"))) {
                                        var $102 = posEnd === v.value1.index;
                                        if ($102) {
                                            $tco_done = true;
                                            return {
                                                posBegin: posBegin,
                                                posEnd: posEnd + 1 | 0,
                                                lineBegin: lineBegin
                                            };
                                        }
                                        var $103 = posEnd > v.value1.index;
                                        if ($103) {
                                            $tco_done = true;
                                            return {
                                                posBegin: posBegin,
                                                posEnd: posEnd,
                                                lineBegin: lineBegin
                                            };
                                        }
                                        $tco_var_posBegin = posEnd + 1 | 0;
                                        $tco_var_lineBegin = v2.value0.tail;
                                        $tco_var_posEnd = posEnd + 1 | 0;
                                        $copy_lineEnd = v2.value0.tail;
                                        return;
                                    }
                                    if (v2 instanceof $ykHdR.Just) {
                                        $tco_var_posBegin = posBegin;
                                        $tco_var_lineBegin = lineBegin;
                                        $tco_var_posEnd = posEnd + 1 | 0;
                                        $copy_lineEnd = v2.value0.tail;
                                        return;
                                    }
                                    $tco_done = true;
                                    return {
                                        posBegin: posBegin,
                                        posEnd: posEnd,
                                        lineBegin: lineBegin
                                    };
                                }
                                while(!$tco_done)$tco_result = $tco_loop($tco_var_posBegin, $tco_var_lineBegin, $tco_var_posEnd, $copy_lineEnd);
                                return $tco_result;
                            };
                        };
                    };
                };
                return go(0)(input)(0)(input);
            }();
            var lineSelect = $5oIYL.take(v1.posEnd - v1.posBegin | 0)(v1.lineBegin);
            var lineLength = $5oIYL.length(lineSelect);
            var lineIndex = v.value1.index - v1.posBegin | 0;
            var bestPosBefore = lineIndex - $ca4b6f31ec4b9857$var$div(contextSize)(2) | 0;
            var bestPosAfter = (lineIndex + $ca4b6f31ec4b9857$var$div(contextSize)(2) | 0) + function() {
                var $110 = $c8kPS.odd(contextSize);
                if ($110) return 1;
                return 0;
            }() | 0;
            var v2 = function() {
                var $111 = bestPosBefore >= 0;
                if ($111) {
                    var $112 = bestPosAfter <= lineLength;
                    if ($112) return new $9MxTl.Tuple(bestPosBefore, bestPosAfter);
                    return new $9MxTl.Tuple($ca4b6f31ec4b9857$var$max(0)(lineLength - contextSize | 0), lineLength);
                }
                return new $9MxTl.Tuple(0, $ca4b6f31ec4b9857$var$min(lineLength)(contextSize));
            }();
            var inputContext = $5oIYL.take(v2.value1 - v2.value0 | 0)($5oIYL.drop(v2.value0)(lineSelect));
            return [
                v.value0 + (" at position index:" + ($ca4b6f31ec4b9857$var$show(v.value1.index) + (" (line:" + ($ca4b6f31ec4b9857$var$show(v.value1.line) + (", column:" + ($ca4b6f31ec4b9857$var$show(v.value1.column) + ")")))))),
                $7OyoZ.joinWith("")($4VF0K.replicate(lineIndex - v2.value0 | 0)(" ")) + "\u25bc",
                inputContext
            ];
        };
    };
};
var $ca4b6f31ec4b9857$export$4659b591c19bdf3d = function(p) {
    return $ca4b6f31ec4b9857$var$bind($3J9zV.getParserT)(function(v) {
        return $ca4b6f31ec4b9857$var$bind(p)(function(x) {
            return $ca4b6f31ec4b9857$var$bind($3J9zV.getParserT)(function(v1) {
                return $ca4b6f31ec4b9857$var$pure(new $9MxTl.Tuple($MTXA4.take($MTXA4.length(v.value0) - $MTXA4.length(v1.value0) | 0)(v.value0), x));
            });
        });
    });
};
var $ca4b6f31ec4b9857$export$d83becf4b42ec59 = /* #__PURE__ */ $chZgc.mkFn5(function(v) {
    return function(v1) {
        return function(v2) {
            return function($$throw) {
                return function(done) {
                    var $133 = $2Zpo4.null(v.value0);
                    if ($133) return done(new $3J9zV.ParseState(v.value0, v.value1, true), $r2HHk.unit);
                    return $$throw(v, new $3J9zV.ParseError("Expected EOF", v.value1));
                };
            };
        };
    };
});
var $ca4b6f31ec4b9857$export$9b3710c6484cace = function(f) {
    return $chZgc.mkFn5(function(v) {
        return function(v1) {
            return function(v2) {
                return function($$throw) {
                    return function(done) {
                        var v3 = f(v.value0);
                        if (v3 instanceof $aKY4H.Left) return $$throw(v, new $3J9zV.ParseError(v3.value0, v.value1));
                        if (v3 instanceof $aKY4H.Right) return done(new $3J9zV.ParseState(v3.value0.remainder, $ca4b6f31ec4b9857$var$updatePosString(v.value1)(v3.value0.consumed)(v3.value0.remainder), !$2Zpo4.null(v3.value0.consumed)), v3.value0.value);
                        throw new Error("Failed pattern match at Parsing.String (line 286, column 7 - line 290, column 121): " + [
                            v3.constructor.name
                        ]);
                    };
                };
            };
        };
    });
};
var $ca4b6f31ec4b9857$export$17b0f4d84dbfeedf = function(pattern) {
    return function(flags) {
        return $ca4b6f31ec4b9857$var$mapFlipped($jVyOx.regex("^(" + (pattern + ")"))(flags))(function(regexobj) {
            return $ca4b6f31ec4b9857$export$9b3710c6484cace(function(input) {
                var v = $ca4b6f31ec4b9857$var$map($jxBf5.head)($jVyOx.match(regexobj)(input));
                if (v instanceof $ykHdR.Just && v.value0 instanceof $ykHdR.Just) {
                    var remainder = $MTXA4.drop($MTXA4.length(v.value0.value0))(input);
                    return new $aKY4H.Right({
                        value: v.value0.value0,
                        consumed: v.value0.value0,
                        remainder: remainder
                    });
                }
                return new $aKY4H.Left("No Regex pattern match");
            });
        });
    };
};
var $ca4b6f31ec4b9857$export$c58417706a208278 = /* #__PURE__ */ $ca4b6f31ec4b9857$export$9b3710c6484cace(function(consumed) {
    return new $aKY4H.Right({
        value: consumed,
        consumed: consumed,
        remainder: ""
    });
});
var $ca4b6f31ec4b9857$export$22b082955e083ec3 = function(str) {
    return $ca4b6f31ec4b9857$export$9b3710c6484cace(function(input) {
        var v = $2gT7Y.stripPrefix(str)(input);
        if (v instanceof $ykHdR.Just) return new $aKY4H.Right({
            value: str,
            consumed: str,
            remainder: v.value0
        });
        return new $aKY4H.Left("Expected " + $ca4b6f31ec4b9857$var$show1(str));
    });
};
var $ca4b6f31ec4b9857$export$7634b617e2c58e32 = function(n) {
    return $ca4b6f31ec4b9857$export$9b3710c6484cace(function(input) {
        var v = $5oIYL.splitAt(n)(input);
        var $153 = $5oIYL.length(v.before) === n;
        if ($153) return new $aKY4H.Right({
            value: v.before,
            consumed: v.before,
            remainder: v.after
        });
        return new $aKY4H.Left("Could not take " + ($ca4b6f31ec4b9857$var$show(n) + " characters"));
    });
};
var $ca4b6f31ec4b9857$export$eba6f6f03b0a92e7 = function(c) {
    return $1woEV.withErrorMessage($ca4b6f31ec4b9857$export$ec0bab193bdafe1(function(v) {
        return v === c;
    }))($ca4b6f31ec4b9857$var$show2(c));
};
var $ca4b6f31ec4b9857$export$3eeefabf9b38b449 = /* #__PURE__ */ $ca4b6f31ec4b9857$export$566aa36e2fcdcfb9(/* #__PURE__ */ $l4M7e.const(true));
var $ca4b6f31ec4b9857$export$cf85aa27ccfa294 = function(dictMonad) {
    return function(p) {
        var go = function(unit) {
            return $ca4b6f31ec4b9857$var$alt($ca4b6f31ec4b9857$var$bind($3J9zV.getParserT)(function(v) {
                return $ca4b6f31ec4b9857$var$bind($1woEV.try(p))(function(t) {
                    return $ca4b6f31ec4b9857$var$pure(new $lowBm.Done(new $9MxTl.Tuple(v.value0, t)));
                });
            }))($ca4b6f31ec4b9857$var$bind($ca4b6f31ec4b9857$export$3eeefabf9b38b449)(function() {
                return $ca4b6f31ec4b9857$var$pure(new $lowBm.Loop(unit));
            }));
        };
        return $ca4b6f31ec4b9857$var$bind($3J9zV.getParserT)(function(v) {
            return $ca4b6f31ec4b9857$var$bind($ca4b6f31ec4b9857$var$tailRecM(go)($r2HHk.unit))(function(v1) {
                return $ca4b6f31ec4b9857$var$pure(new $9MxTl.Tuple($MTXA4.take($MTXA4.length(v.value0) - $MTXA4.length(v1.value0) | 0)(v.value0), v1.value1));
            });
        });
    };
};
var $ca4b6f31ec4b9857$export$3df35137cff8cab7 = /* #__PURE__ */ $ca4b6f31ec4b9857$export$ec0bab193bdafe1(/* #__PURE__ */ $l4M7e.const(true));

});
parcelRegister("jVyOx", function(module, exports) {

$parcel$export(module.exports, "regex", () => $03be6cc86948e3c6$export$17b0f4d84dbfeedf);
$parcel$export(module.exports, "match", () => $03be6cc86948e3c6$export$4659b591c19bdf3d);
// Generated by purs version 0.15.16

var $knAUn = parcelRequire("knAUn");

var $aKY4H = parcelRequire("aKY4H");

var $ykHdR = parcelRequire("ykHdR");

var $2gT7Y = parcelRequire("2gT7Y");

var $lz4BY = parcelRequire("lz4BY");
var $03be6cc86948e3c6$export$a9b8f38109c4ed61 = {
    show: $knAUn.showRegexImpl
};
var $03be6cc86948e3c6$export$d76128d007d19019 = /* #__PURE__ */ function() {
    return $knAUn._search($ykHdR.Just.create)($ykHdR.Nothing.value);
}();
var $03be6cc86948e3c6$export$1b5e458140968481 = /* #__PURE__ */ function() {
    return $knAUn._replaceBy($ykHdR.Just.create)($ykHdR.Nothing.value);
}();
var $03be6cc86948e3c6$export$b6228dc14c5adf51 = function(v) {
    return function() {
        if (v.global) return "g";
        return "";
    }() + (function() {
        if (v.ignoreCase) return "i";
        return "";
    }() + (function() {
        if (v.multiline) return "m";
        return "";
    }() + (function() {
        if (v.dotAll) return "s";
        return "";
    }() + (function() {
        if (v.sticky) return "y";
        return "";
    }() + function() {
        if (v.unicode) return "u";
        return "";
    }()))));
};
var $03be6cc86948e3c6$export$17b0f4d84dbfeedf = function(s) {
    return function(f) {
        return $knAUn.regexImpl($aKY4H.Left.create)($aKY4H.Right.create)(s)($03be6cc86948e3c6$export$b6228dc14c5adf51(f));
    };
};
var $03be6cc86948e3c6$export$909765d3c3e4d815 = function(s) {
    return {
        global: $2gT7Y.contains("g")(s),
        ignoreCase: $2gT7Y.contains("i")(s),
        multiline: $2gT7Y.contains("m")(s),
        dotAll: $2gT7Y.contains("s")(s),
        sticky: $2gT7Y.contains("y")(s),
        unicode: $2gT7Y.contains("u")(s)
    };
};
var $03be6cc86948e3c6$export$4659b591c19bdf3d = /* #__PURE__ */ function() {
    return $knAUn._match($ykHdR.Just.create)($ykHdR.Nothing.value);
}();
var $03be6cc86948e3c6$export$ceac1d294cf61000 = function($10) {
    return $lz4BY.RegexFlags($knAUn.flagsImpl($10));
};

});
parcelRegister("knAUn", function(module, exports) {

$parcel$export(module.exports, "showRegexImpl", () => $ed6295dbdc25761e$export$22dedfc55ca7a214);
$parcel$export(module.exports, "regexImpl", () => $ed6295dbdc25761e$export$f69e81cb42c99394);
$parcel$export(module.exports, "flagsImpl", () => $ed6295dbdc25761e$export$a0f57c1eeb878eb7);
$parcel$export(module.exports, "_match", () => $ed6295dbdc25761e$export$46506e5af176113c);
$parcel$export(module.exports, "_replaceBy", () => $ed6295dbdc25761e$export$bad08cfccf5cc7c3);
$parcel$export(module.exports, "_search", () => $ed6295dbdc25761e$export$abe1cf074395fe09);
const $ed6295dbdc25761e$export$22dedfc55ca7a214 = function(r) {
    return "" + r;
};
const $ed6295dbdc25761e$export$f69e81cb42c99394 = function(left) {
    return function(right) {
        return function(s1) {
            return function(s2) {
                try {
                    return right(new RegExp(s1, s2));
                } catch (e) {
                    return left(e.message);
                }
            };
        };
    };
};
const $ed6295dbdc25761e$export$b4d5da5f34fb77ad = function(r) {
    return r.source;
};
const $ed6295dbdc25761e$export$a0f57c1eeb878eb7 = function(r) {
    return {
        multiline: r.multiline,
        ignoreCase: r.ignoreCase,
        global: r.global,
        dotAll: r.dotAll,
        sticky: !!r.sticky,
        unicode: !!r.unicode
    };
};
const $ed6295dbdc25761e$export$e0969da9b8fb378d = function(r) {
    return function(s) {
        var lastIndex = r.lastIndex;
        var result = r.test(s);
        r.lastIndex = lastIndex;
        return result;
    };
};
const $ed6295dbdc25761e$export$46506e5af176113c = function(just) {
    return function(nothing) {
        return function(r) {
            return function(s) {
                var m = s.match(r);
                if (m == null || m.length === 0) return nothing;
                else {
                    for(var i = 0; i < m.length; i++)m[i] = m[i] == null ? nothing : just(m[i]);
                    return just(m);
                }
            };
        };
    };
};
const $ed6295dbdc25761e$export$77ad94ebf1c2b9ed = function(r) {
    return function(s1) {
        return function(s2) {
            return s2.replace(r, s1);
        };
    };
};
const $ed6295dbdc25761e$export$bad08cfccf5cc7c3 = function(just) {
    return function(nothing) {
        return function(r) {
            return function(f) {
                return function(s) {
                    return s.replace(r, function(match) {
                        var groups = [];
                        var group, i = 1;
                        while(typeof (group = arguments[i++]) !== "number")groups.push(group == null ? nothing : just(group));
                        return f(match)(groups);
                    });
                };
            };
        };
    };
};
const $ed6295dbdc25761e$export$abe1cf074395fe09 = function(just) {
    return function(nothing) {
        return function(r) {
            return function(s) {
                var result = s.search(r);
                return result === -1 ? nothing : just(result);
            };
        };
    };
};
const $ed6295dbdc25761e$export$65980d18b75784e2 = function(r) {
    return function(s) {
        return s.split(r);
    };
};

});

parcelRegister("lz4BY", function(module, exports) {

$parcel$export(module.exports, "RegexFlags", () => $fb3071975af0bbe0$export$8760a645d51315cb);
$parcel$export(module.exports, "monoidRegexFlags", () => $fb3071975af0bbe0$export$85aac2cdb4833912);
// Generated by purs version 0.15.16

var $kK1nx = parcelRequire("kK1nx");

var $4MBcA = parcelRequire("4MBcA");

var $l0wDR = parcelRequire("l0wDR");

var $iwqgS = parcelRequire("iwqgS");
parcelRequire("2Zpo4");
var $7OyoZ = parcelRequire("7OyoZ");
var $fb3071975af0bbe0$var$append = /* #__PURE__ */ $iwqgS.append($iwqgS.semigroupArray);
var $fb3071975af0bbe0$var$voidLeft = /* #__PURE__ */ $l0wDR.voidLeft($l0wDR.functorArray);
var $fb3071975af0bbe0$var$guard = /* #__PURE__ */ $kK1nx.guard($kK1nx.alternativeArray);
var $fb3071975af0bbe0$var$eq = /* #__PURE__ */ $4MBcA.eq(/* #__PURE__ */ $4MBcA.eqArray($4MBcA.eqString));
var $fb3071975af0bbe0$export$8760a645d51315cb = function(x) {
    return x;
};
var $fb3071975af0bbe0$export$1aaf7eccd7f610ad = {
    global: false,
    ignoreCase: false,
    multiline: false,
    dotAll: false,
    sticky: false,
    unicode: true
};
var $fb3071975af0bbe0$export$4bd4b47501432316 = {
    global: false,
    ignoreCase: false,
    multiline: false,
    dotAll: false,
    sticky: true,
    unicode: false
};
var $fb3071975af0bbe0$export$ea09a2a1f3b28164 = {
    show: function(v) {
        var usedFlags = $fb3071975af0bbe0$var$append([])($fb3071975af0bbe0$var$append($fb3071975af0bbe0$var$voidLeft($fb3071975af0bbe0$var$guard(v.global))("global"))($fb3071975af0bbe0$var$append($fb3071975af0bbe0$var$voidLeft($fb3071975af0bbe0$var$guard(v.ignoreCase))("ignoreCase"))($fb3071975af0bbe0$var$append($fb3071975af0bbe0$var$voidLeft($fb3071975af0bbe0$var$guard(v.multiline))("multiline"))($fb3071975af0bbe0$var$append($fb3071975af0bbe0$var$voidLeft($fb3071975af0bbe0$var$guard(v.dotAll))("dotAll"))($fb3071975af0bbe0$var$append($fb3071975af0bbe0$var$voidLeft($fb3071975af0bbe0$var$guard(v.sticky))("sticky"))($fb3071975af0bbe0$var$voidLeft($fb3071975af0bbe0$var$guard(v.unicode))("unicode")))))));
        var $43 = $fb3071975af0bbe0$var$eq(usedFlags)([]);
        if ($43) return "noFlags";
        return "(" + ($7OyoZ.joinWith(" <> ")(usedFlags) + ")");
    }
};
var $fb3071975af0bbe0$export$69936738517d6e4e = {
    append: function(v) {
        return function(v1) {
            return {
                global: v.global || v1.global,
                ignoreCase: v.ignoreCase || v1.ignoreCase,
                multiline: v.multiline || v1.multiline,
                dotAll: v.dotAll || v1.dotAll,
                sticky: v.sticky || v1.sticky,
                unicode: v.unicode || v1.unicode
            };
        };
    }
};
var $fb3071975af0bbe0$export$77e76a4721f88dfa = {
    global: false,
    ignoreCase: false,
    multiline: false,
    dotAll: false,
    sticky: false,
    unicode: false
};
var $fb3071975af0bbe0$export$726fd70d90b3a5b4 = {
    Coercible0: function() {
        return undefined;
    }
};
var $fb3071975af0bbe0$export$e086dccf8e77e85 = {
    global: false,
    ignoreCase: false,
    multiline: true,
    dotAll: false,
    sticky: false,
    unicode: false
};
var $fb3071975af0bbe0$export$85aac2cdb4833912 = {
    mempty: $fb3071975af0bbe0$export$77e76a4721f88dfa,
    Semigroup0: function() {
        return $fb3071975af0bbe0$export$69936738517d6e4e;
    }
};
var $fb3071975af0bbe0$export$2afc0c80c8dff0e7 = {
    global: false,
    ignoreCase: true,
    multiline: false,
    dotAll: false,
    sticky: false,
    unicode: false
};
var $fb3071975af0bbe0$export$90b4d2ff6acb88af = {
    global: true,
    ignoreCase: false,
    multiline: false,
    dotAll: false,
    sticky: false,
    unicode: false
};
var $fb3071975af0bbe0$export$36f4f1589a5fb413 = /* #__PURE__ */ $4MBcA.eqRec()(/* #__PURE__ */ $4MBcA.eqRowCons(/* #__PURE__ */ $4MBcA.eqRowCons(/* #__PURE__ */ $4MBcA.eqRowCons(/* #__PURE__ */ $4MBcA.eqRowCons(/* #__PURE__ */ $4MBcA.eqRowCons(/* #__PURE__ */ $4MBcA.eqRowCons($4MBcA.eqRowNil)()({
    reflectSymbol: function() {
        return "unicode";
    }
})($4MBcA.eqBoolean))()({
    reflectSymbol: function() {
        return "sticky";
    }
})($4MBcA.eqBoolean))()({
    reflectSymbol: function() {
        return "multiline";
    }
})($4MBcA.eqBoolean))()({
    reflectSymbol: function() {
        return "ignoreCase";
    }
})($4MBcA.eqBoolean))()({
    reflectSymbol: function() {
        return "global";
    }
})($4MBcA.eqBoolean))()({
    reflectSymbol: function() {
        return "dotAll";
    }
})($4MBcA.eqBoolean));
var $fb3071975af0bbe0$export$6866eb06e0b66746 = {
    global: false,
    ignoreCase: false,
    multiline: false,
    dotAll: true,
    sticky: false,
    unicode: false
};

});




parcelRegister("lO7j1", function(module, exports) {

$parcel$export(module.exports, "cata", () => $fe03ef3e9bd54d52$export$7ed679b61418205e);
// Generated by purs version 0.15.16

var $gUTA8 = parcelRequire("gUTA8");

var $9Grh5 = parcelRequire("9Grh5");

var $7T8P4 = parcelRequire("7T8P4");

var $frF73 = parcelRequire("frF73");

var $epcZi = parcelRequire("epcZi");

var $j5Y99 = parcelRequire("j5Y99");

var $hfMWE = parcelRequire("hfMWE");

var $7yzxp = parcelRequire("7yzxp");

var $6RkEA = parcelRequire("6RkEA");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");

var $lnl7Y = parcelRequire("lnl7Y");

var $amUgg = parcelRequire("amUgg");

var $1zczT = parcelRequire("1zczT");

var $6PW1p = parcelRequire("6PW1p");

var $8JwLM = parcelRequire("8JwLM");

var $1wR1l = parcelRequire("1wR1l");

var $9MxTl = parcelRequire("9MxTl");

var $aaxt2 = parcelRequire("aaxt2");

var $eo6zx = parcelRequire("eo6zx");

var $gwTNH = parcelRequire("gwTNH");

var $h6B4A = parcelRequire("h6B4A");
var $fe03ef3e9bd54d52$var$fanout = /* #__PURE__ */ $8JwLM.fanout($7yzxp.semigroupoidFn)($8JwLM.strongFn);
var $fe03ef3e9bd54d52$var$identity = /* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn);
var $fe03ef3e9bd54d52$var$alaF = /* #__PURE__ */ $6PW1p.alaF()()()();
var $fe03ef3e9bd54d52$var$monoidDisj = /* #__PURE__ */ $1zczT.monoidDisj($lnl7Y.heytingAlgebraBoolean);
var $fe03ef3e9bd54d52$var$pure = /* #__PURE__ */ $gUTA8.pure($amUgg.applicativeList);
var $fe03ef3e9bd54d52$var$bindFlipped = /* #__PURE__ */ $9Grh5.bindFlipped($amUgg.bindList);
var $fe03ef3e9bd54d52$export$66c73011cb4beac2 = function(dictRecursive) {
    var mapR = $h6B4A.mapR(dictRecursive);
    return function(dictCorecursive) {
        var mapR1 = mapR(dictCorecursive);
        var map = $l0wDR.map(dictCorecursive.Functor0());
        return function(f) {
            var go = function(t) {
                return f(t)(mapR1(map(go))(t));
            };
            return go;
        };
    };
};
var $fe03ef3e9bd54d52$export$35ae8c6eae3ffa85 = function(dictRecursive) {
    var mapR = $h6B4A.mapR(dictRecursive);
    var map = $l0wDR.map(dictRecursive.Functor0());
    return function(dictCorecursive) {
        var mapR1 = mapR(dictCorecursive);
        return function(f) {
            var go = function(t) {
                return mapR1(function() {
                    var $283 = map($fe03ef3e9bd54d52$var$fanout($fe03ef3e9bd54d52$var$identity)(go));
                    return function($284) {
                        return f($283($284));
                    };
                }())(t);
            };
            return go;
        };
    };
};
var $fe03ef3e9bd54d52$export$10a8ec4ab045d5 = function(dictRecursive) {
    var traverseR = $h6B4A.traverseR(dictRecursive);
    return function(dictCorecursive) {
        var traverseR1 = traverseR(dictCorecursive);
        return function(dictMonad) {
            var Bind1 = dictMonad.Bind1();
            var bindFlipped1 = $9Grh5.bindFlipped(Bind1);
            var traverseR2 = traverseR1(Bind1.Apply0().Functor0());
            var Applicative0 = dictMonad.Applicative0();
            return function(dictTraversable) {
                var traverse = $1wR1l.traverse(dictTraversable)(Applicative0);
                return function(f) {
                    var go = function(t) {
                        return bindFlipped1(f)(traverseR2(traverse(go))(t));
                    };
                    return go;
                };
            };
        };
    };
};
var $fe03ef3e9bd54d52$export$97407f38c9c800ab = function(dictRecursive) {
    var mapR = $h6B4A.mapR(dictRecursive);
    return function(dictCorecursive) {
        var mapR1 = mapR(dictCorecursive);
        var map = $l0wDR.map(dictCorecursive.Functor0());
        return function(f) {
            var go = function(t) {
                return f(mapR1(map(go))(t));
            };
            return go;
        };
    };
};
var $fe03ef3e9bd54d52$export$f8af97f6fec19f6a = function(dictRecursive) {
    var traverseR = $h6B4A.traverseR(dictRecursive);
    return function(dictCorecursive) {
        var traverseR1 = traverseR(dictCorecursive);
        return function(dictMonad) {
            var Bind1 = dictMonad.Bind1();
            var traverseR2 = traverseR1(Bind1.Apply0().Functor0());
            var composeKleisliFlipped = $9Grh5.composeKleisliFlipped(Bind1);
            var Applicative0 = dictMonad.Applicative0();
            return function(dictTraversable) {
                var traverse = $1wR1l.traverse(dictTraversable)(Applicative0);
                return function(f) {
                    var go = function(t) {
                        return traverseR2(composeKleisliFlipped(f)(traverse(go)))(t);
                    };
                    return go;
                };
            };
        };
    };
};
var $fe03ef3e9bd54d52$export$4878665b7c46dee = function(dictRecursive) {
    var mapR = $h6B4A.mapR(dictRecursive);
    var map = $l0wDR.map(dictRecursive.Functor0());
    return function(dictCorecursive) {
        var mapR1 = mapR(dictCorecursive);
        return function(f) {
            var go = function(t) {
                return mapR1(function() {
                    var $285 = map(go);
                    return function($286) {
                        return f($285($286));
                    };
                }())(t);
            };
            return go;
        };
    };
};
var $fe03ef3e9bd54d52$export$eebd59f01a530486 = function(dictRecursive) {
    var mapR = $h6B4A.mapR(dictRecursive);
    var transCata1 = $fe03ef3e9bd54d52$export$4878665b7c46dee(dictRecursive);
    return function(dictCorecursive) {
        var map = $l0wDR.map(dictCorecursive.Functor0());
        var transCata2 = transCata1(dictCorecursive);
        return function(dictCorecursive1) {
            var mapR1 = mapR(dictCorecursive1);
            return function(f) {
                return function(g) {
                    var go = function(t) {
                        return mapR1(function() {
                            var $287 = map(function() {
                                var $289 = transCata2(f);
                                return function($290) {
                                    return go($289($290));
                                };
                            }());
                            return function($288) {
                                return g($287($288));
                            };
                        }())(t);
                    };
                    return go;
                };
            };
        };
    };
};
var $fe03ef3e9bd54d52$export$c1b968664f72549c = function(dictRecursive) {
    var traverseR = $h6B4A.traverseR(dictRecursive);
    return function(dictCorecursive) {
        var traverseR1 = traverseR(dictCorecursive);
        return function(dictMonad) {
            var Bind1 = dictMonad.Bind1();
            var bind = $9Grh5.bind(Bind1);
            var traverseR2 = traverseR1(Bind1.Apply0().Functor0());
            var Applicative0 = dictMonad.Applicative0();
            return function(dictTraversable) {
                var traverse = $1wR1l.traverse(dictTraversable)(Applicative0);
                return function(f) {
                    var go = function(a) {
                        return function(t) {
                            return bind(f(a)(t))(function(v) {
                                return traverseR2(traverse(go(v.value0)))(v.value1);
                            });
                        };
                    };
                    return go;
                };
            };
        };
    };
};
var $fe03ef3e9bd54d52$export$332c05e52ff9433d = function(dictRecursive) {
    var mapR = $h6B4A.mapR(dictRecursive);
    return function(dictCorecursive) {
        var mapR1 = mapR(dictCorecursive);
        var map = $l0wDR.map(dictCorecursive.Functor0());
        return function(f) {
            var go = function(a) {
                return function(t) {
                    var v = f(a)(t);
                    return mapR1(map(go(v.value0)))(v.value1);
                };
            };
            return go;
        };
    };
};
var $fe03ef3e9bd54d52$export$678729c06cde3b3a = function(dictRecursive) {
    var project = $eo6zx.project(dictRecursive);
    return function(dictMonad) {
        var Bind1 = dictMonad.Bind1();
        var bindFlipped1 = $9Grh5.bindFlipped(Bind1);
        var Applicative0 = dictMonad.Applicative0();
        var map = $l0wDR.map(Bind1.Apply0().Functor0());
        return function(dictTraversable) {
            var traverse = $1wR1l.traverse(dictTraversable)(Applicative0);
            return function(f) {
                var go = function(t) {
                    return bindFlipped1(f)(traverse(function() {
                        var $291 = map($9MxTl.Tuple.create(t));
                        return function($292) {
                            return $291(go($292));
                        };
                    }())(project(t)));
                };
                return go;
            };
        };
    };
};
var $fe03ef3e9bd54d52$export$bc31b96302c4c50a = function(dictRecursive) {
    var map = $l0wDR.map(dictRecursive.Functor0());
    var project = $eo6zx.project(dictRecursive);
    return function(f) {
        var go = function(t) {
            return f(map(g)(project(t)));
        };
        var g = function(t) {
            return new $9MxTl.Tuple(t, go(t));
        };
        return go;
    };
};
var $fe03ef3e9bd54d52$export$25745bf602cb0cde = function(dictRecursive) {
    var map = $l0wDR.map(dictRecursive.Functor0());
    var project = $eo6zx.project(dictRecursive);
    return function(f) {
        return function(g) {
            var go = function(x) {
                return new $9MxTl.Tuple($fe03ef3e9bd54d52$export$25745bf602cb0cde(dictRecursive)(g)(f)(x), $fe03ef3e9bd54d52$export$25745bf602cb0cde(dictRecursive)(f)(g)(x));
            };
            var $293 = map(go);
            return function($294) {
                return g($293(project($294)));
            };
        };
    };
};
var $fe03ef3e9bd54d52$export$e132ced8f644a612 = function(dictRecursive) {
    var project = $eo6zx.project(dictRecursive);
    return function(dictFoldable) {
        var foldMap = $6RkEA.foldMap(dictFoldable)($fe03ef3e9bd54d52$var$monoidDisj);
        return function(t) {
            return $fe03ef3e9bd54d52$var$alaF($1zczT.Disj)(foldMap)($l4M7e.const(true))(project(t));
        };
    };
};
var $fe03ef3e9bd54d52$export$fba9fc8f7df2f853 = function(dictRecursive) {
    var project = $eo6zx.project(dictRecursive);
    return function(dictMonad) {
        var Bind1 = dictMonad.Bind1();
        var map = $l0wDR.map(Bind1.Apply0().Functor0());
        var Applicative0 = dictMonad.Applicative0();
        var composeKleisliFlipped = $9Grh5.composeKleisliFlipped(Bind1);
        return function(dictComonad) {
            var duplicate = $hfMWE.duplicate(dictComonad.Extend0());
            var extract = $frF73.extract(dictComonad);
            return function(dictTraversable) {
                var traverse = $1wR1l.traverse(dictTraversable)(Applicative0);
                return function(dictTraversable1) {
                    var traverse1 = $1wR1l.traverse(dictTraversable1)(Applicative0);
                    return function(k) {
                        return function(g) {
                            var loop = function(t) {
                                return map(k)(traverse(composeKleisliFlipped(function() {
                                    var $295 = map(duplicate);
                                    var $296 = traverse1(g);
                                    return function($297) {
                                        return $295($296($297));
                                    };
                                }())(loop))(project(t)));
                            };
                            return composeKleisliFlipped(function($298) {
                                return g(extract($298));
                            })(loop);
                        };
                    };
                };
            };
        };
    };
};
var $fe03ef3e9bd54d52$export$7957462b99c7bb06 = function(dictRecursive) {
    var map = $l0wDR.map(dictRecursive.Functor0());
    var project = $eo6zx.project(dictRecursive);
    return function(dictComonad) {
        var Extend0 = dictComonad.Extend0();
        var duplicate = $hfMWE.duplicate(Extend0);
        var map1 = $l0wDR.map(Extend0.Functor0());
        var extract = $frF73.extract(dictComonad);
        return function(k) {
            return function(g) {
                var go = function(t) {
                    return k(map(function() {
                        var $299 = map1(g);
                        return function($300) {
                            return duplicate($299(go($300)));
                        };
                    }())(project(t)));
                };
                return function($301) {
                    return g(extract(go($301)));
                };
            };
        };
    };
};
var $fe03ef3e9bd54d52$export$b6649f7a3dc082fa = function(dictRecursive) {
    var gcata1 = $fe03ef3e9bd54d52$export$7957462b99c7bb06(dictRecursive);
    var distGHisto = $gwTNH.distGHisto(dictRecursive.Functor0());
    return function(dictFunctor) {
        var gcata2 = gcata1($epcZi.comonadCofree(dictFunctor));
        var distGHisto1 = distGHisto(dictFunctor);
        return function(g) {
            return gcata2(distGHisto1(g));
        };
    };
};
var $fe03ef3e9bd54d52$export$83062f557e1959af = function(dictRecursive) {
    var gcata1 = $fe03ef3e9bd54d52$export$7957462b99c7bb06(dictRecursive);
    var distZygoT = $gwTNH.distZygoT(dictRecursive.Functor0());
    return function(dictComonad) {
        var gcata2 = gcata1($j5Y99.comonadEnvT(dictComonad));
        var distZygoT1 = distZygoT(dictComonad);
        return function(f) {
            return function(w) {
                return gcata2(distZygoT1(f)(w));
            };
        };
    };
};
var $fe03ef3e9bd54d52$export$6a2cc90eaa666087 = function(dictRecursive) {
    var gzygo1 = $fe03ef3e9bd54d52$export$83062f557e1959af(dictRecursive);
    return function(dictCorecursive) {
        var embed = $aaxt2.embed(dictCorecursive);
        return function(dictComonad) {
            return gzygo1(dictComonad)(embed);
        };
    };
};
var $fe03ef3e9bd54d52$export$3f08479faf48e9fb = function(dictRecursive) {
    var Functor0 = dictRecursive.Functor0();
    return $fe03ef3e9bd54d52$export$7957462b99c7bb06(dictRecursive)($epcZi.comonadCofree(Functor0))($gwTNH.distHisto(Functor0));
};
var $fe03ef3e9bd54d52$export$abb298f0218a93e6 = function(dictRecursive) {
    var $302 = $fe03ef3e9bd54d52$export$7957462b99c7bb06(dictRecursive)($9MxTl.comonadTuple);
    var $303 = $gwTNH.distZygo(dictRecursive.Functor0());
    return function($304) {
        return $302($303($304));
    };
};
var $fe03ef3e9bd54d52$export$ceaec0eac696d23a = function(dictRecursive) {
    var map = $l0wDR.map(dictRecursive.Functor0());
    var project = $eo6zx.project(dictRecursive);
    return function(f) {
        var go = function(t) {
            return f(new $9MxTl.Tuple(t, map(go)(project(t))));
        };
        return go;
    };
};
var $fe03ef3e9bd54d52$export$9179f4819538ecfa = function(dictRecursive) {
    var map = $l0wDR.map(dictRecursive.Functor0());
    var project = $eo6zx.project(dictRecursive);
    return function(dictComonad) {
        var Extend0 = dictComonad.Extend0();
        var map1 = $l0wDR.map(Extend0.Functor0());
        var duplicate = $hfMWE.duplicate(Extend0);
        return function(k) {
            return function(g) {
                var go = function(t) {
                    return k(map(function() {
                        var $305 = map1(g);
                        return function($306) {
                            return $305(duplicate(go($306)));
                        };
                    }())(project(t)));
                };
                return function($307) {
                    return g(go($307));
                };
            };
        };
    };
};
var $fe03ef3e9bd54d52$export$5d50f83ccb2ad1ed = function(dictRecursive) {
    var Functor0 = dictRecursive.Functor0();
    return $fe03ef3e9bd54d52$export$9179f4819538ecfa(dictRecursive)($epcZi.comonadCofree(Functor0))($gwTNH.distHisto(Functor0));
};
var $fe03ef3e9bd54d52$export$c5648ffecac74e6e = function(dictRecursive) {
    var $308 = $fe03ef3e9bd54d52$export$9179f4819538ecfa(dictRecursive)($9MxTl.comonadTuple);
    var $309 = $gwTNH.distZygo(dictRecursive.Functor0());
    return function($310) {
        return $308($309($310));
    };
};
var $fe03ef3e9bd54d52$export$c1a837ad417ac59f = function(dictRecursive) {
    var elgotCata1 = $fe03ef3e9bd54d52$export$9179f4819538ecfa(dictRecursive);
    var distZygoT = $gwTNH.distZygoT(dictRecursive.Functor0());
    return function(dictComonad) {
        var elgotCata2 = elgotCata1($j5Y99.comonadEnvT(dictComonad));
        var distZygoT1 = distZygoT(dictComonad);
        return function(f) {
            return function(w) {
                return elgotCata2(distZygoT1(f)(w));
            };
        };
    };
};
var $fe03ef3e9bd54d52$export$bacb5cc5a11aef16 = function(dictRecursive) {
    var project = $eo6zx.project(dictRecursive);
    return function(dictFoldable) {
        var $311 = $6RkEA.foldMap(dictFoldable)($amUgg.monoidList)($fe03ef3e9bd54d52$var$pure);
        return function($312) {
            return $311(project($312));
        };
    };
};
var $fe03ef3e9bd54d52$export$1f09e347b82c0d05 = function(dictRecursive) {
    var children1 = $fe03ef3e9bd54d52$export$bacb5cc5a11aef16(dictRecursive);
    return function(dictFoldable) {
        var children2 = children1(dictFoldable);
        return function(t) {
            return $fe03ef3e9bd54d52$var$bindFlipped($fe03ef3e9bd54d52$export$1f09e347b82c0d05(dictRecursive)(dictFoldable))(children2(t));
        };
    };
};
var $fe03ef3e9bd54d52$export$e26e17aa6351d322 = function(dictRecursive) {
    var project = $eo6zx.project(dictRecursive);
    return function(dictMonad) {
        var bindFlipped1 = $9Grh5.bindFlipped(dictMonad.Bind1());
        var Applicative0 = dictMonad.Applicative0();
        return function(dictTraversable) {
            var traverse = $1wR1l.traverse(dictTraversable)(Applicative0);
            return function(f) {
                var go = function(t) {
                    return bindFlipped1(f)(traverse(go)(project(t)));
                };
                return go;
            };
        };
    };
};
var $fe03ef3e9bd54d52$export$7ed679b61418205e = function(dictRecursive) {
    var map = $l0wDR.map(dictRecursive.Functor0());
    var project = $eo6zx.project(dictRecursive);
    return function(f) {
        var go = function(t) {
            return f(map(go)(project(t)));
        };
        return go;
    };
};
var $fe03ef3e9bd54d52$export$348d9949340a0454 = function(dictRecursive) {
    var cata1 = $fe03ef3e9bd54d52$export$7ed679b61418205e(dictRecursive);
    var project = $eo6zx.project(dictRecursive);
    return function(dictCorecursive) {
        var map = $l0wDR.map(dictCorecursive.Functor0());
        var embed = $aaxt2.embed(dictCorecursive);
        return function(dictComonad) {
            var Extend0 = dictComonad.Extend0();
            var map1 = $l0wDR.map(Extend0.Functor0());
            var duplicate = $hfMWE.duplicate(Extend0);
            var extract = $frF73.extract(dictComonad);
            return function(f) {
                return function(g) {
                    return function(h) {
                        var go = function(t) {
                            return map1(h)(f(map(function() {
                                var $313 = cata1(function($315) {
                                    return embed(g($315));
                                });
                                return function($314) {
                                    return duplicate(go($313($314)));
                                };
                            }())(project(t))));
                        };
                        return function($316) {
                            return extract(go($316));
                        };
                    };
                };
            };
        };
    };
};
var $fe03ef3e9bd54d52$export$24ffb218bb5af683 = function(dictRecursive) {
    var cata1 = $fe03ef3e9bd54d52$export$7ed679b61418205e(dictRecursive);
    return function(dictCorecursive) {
        return cata1($l0wDR.map(dictCorecursive.Functor0())($aaxt2.embed(dictCorecursive)));
    };
};
var $fe03ef3e9bd54d52$export$27510bfe580292d2 = function(dictRecursive) {
    var cata1 = $fe03ef3e9bd54d52$export$7ed679b61418205e(dictRecursive);
    var project = $eo6zx.project(dictRecursive);
    return function(dictCorecursive) {
        var map = $l0wDR.map(dictCorecursive.Functor0());
        var embed = $aaxt2.embed(dictCorecursive);
        return function(f) {
            return function(g) {
                var go = function(t) {
                    return g(map(function() {
                        var $317 = cata1(function($319) {
                            return embed(f($319));
                        });
                        return function($318) {
                            return go($317($318));
                        };
                    }())(project(t)));
                };
                return go;
            };
        };
    };
};
var $fe03ef3e9bd54d52$export$7553e710805c2ce5 = function(dictRecursive) {
    var project = $eo6zx.project(dictRecursive);
    return function(dictMonad) {
        var Bind1 = dictMonad.Bind1();
        var bindFlipped1 = $9Grh5.bindFlipped(Bind1);
        var map = $l0wDR.map(Bind1.Apply0().Functor0());
        var Applicative0 = dictMonad.Applicative0();
        return function(dictTraversable) {
            var traverse = $1wR1l.traverse(dictTraversable)(Applicative0);
            return function(f) {
                return function(z) {
                    var go = function(t) {
                        var ft = project(t);
                        return bindFlipped1(function() {
                            var $320 = $l4M7e.flip(map)(traverse(go)(ft));
                            return function($321) {
                                return $320($epcZi.mkCofree($321));
                            };
                        }())(f(z)(ft));
                    };
                    return go;
                };
            };
        };
    };
};
var $fe03ef3e9bd54d52$export$1d7027206a0e7711 = function(dictRecursive) {
    var project = $eo6zx.project(dictRecursive);
    var map = $l0wDR.map(dictRecursive.Functor0());
    return function(f) {
        return function(z) {
            var go = function(t) {
                var ft = project(t);
                return $epcZi.mkCofree(f(z)(ft))(map(go)(ft));
            };
            return go;
        };
    };
};

});
parcelRegister("epcZi", function(module, exports) {

$parcel$export(module.exports, "tail", () => $a7cd7990ff17745a$export$c01875f616615628);
$parcel$export(module.exports, "mkCofree", () => $a7cd7990ff17745a$export$5d6e20892d59dd4f);
$parcel$export(module.exports, "head", () => $a7cd7990ff17745a$export$5fd5031fecdacec3);
$parcel$export(module.exports, "comonadCofree", () => $a7cd7990ff17745a$export$3d90a06a91631e50);
$parcel$export(module.exports, "buildCofree", () => $a7cd7990ff17745a$export$b3bcb4782421e76f);
// Generated by purs version 0.15.16

var $a7Dxq = parcelRequire("a7Dxq");

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $7T8P4 = parcelRequire("7T8P4");

var $frF73 = parcelRequire("frF73");

var $ibtPS = parcelRequire("ibtPS");

var $hV7d0 = parcelRequire("hV7d0");

var $lowBm = parcelRequire("lowBm");

var $6m1DK = parcelRequire("6m1DK");

var $kQAxW = parcelRequire("kQAxW");

var $k4cbH = parcelRequire("k4cbH");

var $axmEP = parcelRequire("axmEP");

var $4MBcA = parcelRequire("4MBcA");

var $6RkEA = parcelRequire("6RkEA");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");

var $6VVZC = parcelRequire("6VVZC");
parcelRequire("9VGs1");
var $dc43y = parcelRequire("dc43y");
var $9VGs1 = parcelRequire("9VGs1");

var $aknDF = parcelRequire("aknDF");

var $d0PPW = parcelRequire("d0PPW");

var $6SDUu = parcelRequire("6SDUu");

var $iwqgS = parcelRequire("iwqgS");

var $1wR1l = parcelRequire("1wR1l");

var $9MxTl = parcelRequire("9MxTl");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");
var $a7cd7990ff17745a$var$map = /* #__PURE__ */ $l0wDR.map($9VGs1.functorLazy);
var $a7cd7990ff17745a$var$map1 = /* #__PURE__ */ $l0wDR.map($9MxTl.functorTuple);
var $a7cd7990ff17745a$var$identity = /* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn);
var $a7cd7990ff17745a$var$state = /* #__PURE__ */ $kQAxW.state(/* #__PURE__ */ $k4cbH.monadStateStateT($6VVZC.monadIdentity));
var $a7cd7990ff17745a$var$monadRecStateT = /* #__PURE__ */ $k4cbH.monadRecStateT($lowBm.monadRecIdentity);
var $a7cd7990ff17745a$var$Cofree = function(x) {
    return x;
};
var $a7cd7990ff17745a$export$c01875f616615628 = function(v) {
    return $9MxTl.snd($dc43y.force(v));
};
var $a7cd7990ff17745a$export$5d6e20892d59dd4f = function(a) {
    return function(t) {
        return $dc43y.defer(function(v) {
            return new $9MxTl.Tuple(a, t);
        });
    };
};
var $a7cd7990ff17745a$export$997c52585a9ceb85 = {
    defer: function(k) {
        return $dc43y.defer(function(v) {
            var v1 = k($r2HHk.unit);
            return $dc43y.force(v1);
        });
    }
};
var $a7cd7990ff17745a$export$b74b29e7f282f5ad = function(dictFunctor) {
    var map2 = $l0wDR.map(dictFunctor);
    return function(nat) {
        return function(v) {
            return $a7cd7990ff17745a$var$map($a7cd7990ff17745a$var$map1(function() {
                var $185 = map2($a7cd7990ff17745a$export$b74b29e7f282f5ad(dictFunctor)(nat));
                return function($186) {
                    return nat($185($186));
                };
            }()))(v);
        };
    };
};
var $a7cd7990ff17745a$export$5fd5031fecdacec3 = function(v) {
    return $9MxTl.fst($dc43y.force(v));
};
var $a7cd7990ff17745a$export$f880ce3874d12f41 = function(dictFunctor) {
    var map2 = $l0wDR.map(dictFunctor);
    return {
        map: function(f) {
            var loop = function(v) {
                return $a7cd7990ff17745a$var$map(function(v1) {
                    return new $9MxTl.Tuple(f(v1.value0), map2(loop)(v1.value1));
                })(v);
            };
            return loop;
        }
    };
};
var $a7cd7990ff17745a$export$d8dbe3dc0fc45337 = function(dictFunctor) {
    var map2 = $l0wDR.map(dictFunctor);
    var functorCofree1 = $a7cd7990ff17745a$export$f880ce3874d12f41(dictFunctor);
    return {
        mapWithIndex: function(f) {
            var loop = function(n) {
                return function(v) {
                    return $a7cd7990ff17745a$var$map(function(v1) {
                        return new $9MxTl.Tuple(f(n)(v1.value0), map2(loop(n + 1 | 0))(v1.value1));
                    })(v);
                };
            };
            return loop(0);
        },
        Functor0: function() {
            return functorCofree1;
        }
    };
};
var $a7cd7990ff17745a$export$27b554deba9d6cfd = function(dictFoldable) {
    var foldr = $6RkEA.foldr(dictFoldable);
    var foldl = $6RkEA.foldl(dictFoldable);
    var foldMap = $6RkEA.foldMap(dictFoldable);
    return {
        foldr: function(f) {
            var go = function(fa) {
                return function(b) {
                    return f($a7cd7990ff17745a$export$5fd5031fecdacec3(fa))(foldr(go)(b)($a7cd7990ff17745a$export$c01875f616615628(fa)));
                };
            };
            return $l4M7e.flip(go);
        },
        foldl: function(f) {
            var go = function(b) {
                return function(fa) {
                    return foldl(go)(f(b)($a7cd7990ff17745a$export$5fd5031fecdacec3(fa)))($a7cd7990ff17745a$export$c01875f616615628(fa));
                };
            };
            return go;
        },
        foldMap: function(dictMonoid) {
            var append = $iwqgS.append(dictMonoid.Semigroup0());
            var foldMap1 = foldMap(dictMonoid);
            return function(f) {
                var go = function(fa) {
                    return append(f($a7cd7990ff17745a$export$5fd5031fecdacec3(fa)))(foldMap1(go)($a7cd7990ff17745a$export$c01875f616615628(fa)));
                };
                return go;
            };
        }
    };
};
var $a7cd7990ff17745a$export$a4997176d66ab7ef = function(dictFoldable) {
    var foldr = $6RkEA.foldr(dictFoldable);
    var foldl = $6RkEA.foldl(dictFoldable);
    var foldMap = $6RkEA.foldMap(dictFoldable);
    var foldableCofree1 = $a7cd7990ff17745a$export$27b554deba9d6cfd(dictFoldable);
    return {
        foldrWithIndex: function(f) {
            var go = function(ix) {
                return function(b) {
                    return function(fa) {
                        return f(ix)($a7cd7990ff17745a$export$5fd5031fecdacec3(fa))(foldr($l4M7e.flip(go(ix + 1 | 0)))(b)($a7cd7990ff17745a$export$c01875f616615628(fa)));
                    };
                };
            };
            return go(0);
        },
        foldlWithIndex: function(f) {
            var go = function(ix) {
                return function(b) {
                    return function(fa) {
                        return foldl(go(ix + 1 | 0))(f(ix)(b)($a7cd7990ff17745a$export$5fd5031fecdacec3(fa)))($a7cd7990ff17745a$export$c01875f616615628(fa));
                    };
                };
            };
            return go(0);
        },
        foldMapWithIndex: function(dictMonoid) {
            var append = $iwqgS.append(dictMonoid.Semigroup0());
            var foldMap1 = foldMap(dictMonoid);
            return function(f) {
                var go = function(ix) {
                    return function(fa) {
                        return append(f(ix)($a7cd7990ff17745a$export$5fd5031fecdacec3(fa)))(foldMap1(go(ix + 1 | 0))($a7cd7990ff17745a$export$c01875f616615628(fa)));
                    };
                };
                return go(0);
            };
        },
        Foldable0: function() {
            return foldableCofree1;
        }
    };
};
var $a7cd7990ff17745a$export$afea7a71a27f2ae9 = function(dictTraversable) {
    var traverse = $1wR1l.traverse(dictTraversable);
    var functorCofree1 = $a7cd7990ff17745a$export$f880ce3874d12f41(dictTraversable.Functor0());
    var foldableCofree1 = $a7cd7990ff17745a$export$27b554deba9d6cfd(dictTraversable.Foldable1());
    return {
        sequence: function(dictApplicative) {
            return $1wR1l.traverse($a7cd7990ff17745a$export$afea7a71a27f2ae9(dictTraversable))(dictApplicative)($a7cd7990ff17745a$var$identity);
        },
        traverse: function(dictApplicative) {
            var Apply0 = dictApplicative.Apply0();
            var apply = $a5g3C.apply(Apply0);
            var map2 = $l0wDR.map(Apply0.Functor0());
            var traverse1 = traverse(dictApplicative);
            return function(f) {
                var loop = function(ta) {
                    return apply(map2($a7cd7990ff17745a$export$5d6e20892d59dd4f)(f($a7cd7990ff17745a$export$5fd5031fecdacec3(ta))))(traverse1(loop)($a7cd7990ff17745a$export$c01875f616615628(ta)));
                };
                return loop;
            };
        },
        Functor0: function() {
            return functorCofree1;
        },
        Foldable1: function() {
            return foldableCofree1;
        }
    };
};
var $a7cd7990ff17745a$export$5328eb44a9219841 = function(dictTraversable) {
    var traverse = $1wR1l.traverse(dictTraversable);
    var functorWithIndexCofree1 = $a7cd7990ff17745a$export$d8dbe3dc0fc45337(dictTraversable.Functor0());
    var foldableWithIndexCofree1 = $a7cd7990ff17745a$export$a4997176d66ab7ef(dictTraversable.Foldable1());
    var traversableCofree1 = $a7cd7990ff17745a$export$afea7a71a27f2ae9(dictTraversable);
    return {
        traverseWithIndex: function(dictApplicative) {
            var Apply0 = dictApplicative.Apply0();
            var apply = $a5g3C.apply(Apply0);
            var map2 = $l0wDR.map(Apply0.Functor0());
            var traverse1 = traverse(dictApplicative);
            return function(f) {
                var loop = function(ix) {
                    return function(ta) {
                        return apply(map2($a7cd7990ff17745a$export$5d6e20892d59dd4f)(f(ix)($a7cd7990ff17745a$export$5fd5031fecdacec3(ta))))(traverse1(loop(ix + 1 | 0))($a7cd7990ff17745a$export$c01875f616615628(ta)));
                    };
                };
                return loop(0);
            };
        },
        FunctorWithIndex0: function() {
            return functorWithIndexCofree1;
        },
        FoldableWithIndex1: function() {
            return foldableWithIndexCofree1;
        },
        Traversable2: function() {
            return traversableCofree1;
        }
    };
};
var $a7cd7990ff17745a$export$680d116616e6c381 = function(dictFunctor) {
    var map2 = $l0wDR.map(dictFunctor);
    var functorCofree1 = $a7cd7990ff17745a$export$f880ce3874d12f41(dictFunctor);
    return {
        extend: function(f) {
            var loop = function(v) {
                return $a7cd7990ff17745a$var$map(function(v1) {
                    return new $9MxTl.Tuple(f(v), map2(loop)(v1.value1));
                })(v);
            };
            return loop;
        },
        Functor0: function() {
            return functorCofree1;
        }
    };
};
var $a7cd7990ff17745a$export$3186123601b26111 = function(dictEq1) {
    var eq1 = $4MBcA.eq1(dictEq1);
    return function(dictEq) {
        var eq = $4MBcA.eq(dictEq);
        return {
            eq: function(x) {
                return function(y) {
                    return eq($a7cd7990ff17745a$export$5fd5031fecdacec3(x))($a7cd7990ff17745a$export$5fd5031fecdacec3(y)) && eq1($a7cd7990ff17745a$export$3186123601b26111(dictEq1)(dictEq))($a7cd7990ff17745a$export$c01875f616615628(x))($a7cd7990ff17745a$export$c01875f616615628(y));
                };
            }
        };
    };
};
var $a7cd7990ff17745a$export$d55c5d3ff285f8ac = function(dictOrd1) {
    var compare1 = $d0PPW.compare1(dictOrd1);
    var eqCofree1 = $a7cd7990ff17745a$export$3186123601b26111(dictOrd1.Eq10());
    return function(dictOrd) {
        var compare = $d0PPW.compare(dictOrd);
        var eqCofree2 = eqCofree1(dictOrd.Eq0());
        return {
            compare: function(x) {
                return function(y) {
                    var v = compare($a7cd7990ff17745a$export$5fd5031fecdacec3(x))($a7cd7990ff17745a$export$5fd5031fecdacec3(y));
                    if (v instanceof $6SDUu.EQ) return compare1($a7cd7990ff17745a$export$d55c5d3ff285f8ac(dictOrd1)(dictOrd))($a7cd7990ff17745a$export$c01875f616615628(x))($a7cd7990ff17745a$export$c01875f616615628(y));
                    return v;
                };
            },
            Eq0: function() {
                return eqCofree2;
            }
        };
    };
};
var $a7cd7990ff17745a$export$23960db76f4202fc = function(dictEq1) {
    var eqCofree1 = $a7cd7990ff17745a$export$3186123601b26111(dictEq1);
    return {
        eq1: function(dictEq) {
            return $4MBcA.eq(eqCofree1(dictEq));
        }
    };
};
var $a7cd7990ff17745a$export$11e95260dbde4518 = function(dictOrd1) {
    var ordCofree1 = $a7cd7990ff17745a$export$d55c5d3ff285f8ac(dictOrd1);
    var eq1Cofree1 = $a7cd7990ff17745a$export$23960db76f4202fc(dictOrd1.Eq10());
    return {
        compare1: function(dictOrd) {
            return $d0PPW.compare(ordCofree1(dictOrd));
        },
        Eq10: function() {
            return eq1Cofree1;
        }
    };
};
var $a7cd7990ff17745a$export$18736d0fdc79bf66 = function($187) {
    return $a7cd7990ff17745a$var$Cofree($dc43y.defer($187));
};
var $a7cd7990ff17745a$export$4cd8cee3369393b2 = function(dictApply) {
    var apply = $a5g3C.apply(dictApply);
    var map2 = $l0wDR.map(dictApply.Functor0());
    return function(dictSemigroup) {
        var append = $iwqgS.append(dictSemigroup);
        return {
            append: function(x) {
                return function(y) {
                    return $a7cd7990ff17745a$export$18736d0fdc79bf66(function(v) {
                        return new $9MxTl.Tuple(append($a7cd7990ff17745a$export$5fd5031fecdacec3(x))($a7cd7990ff17745a$export$5fd5031fecdacec3(y)), apply(map2($iwqgS.append($a7cd7990ff17745a$export$4cd8cee3369393b2(dictApply)(dictSemigroup)))($a7cd7990ff17745a$export$c01875f616615628(x)))($a7cd7990ff17745a$export$c01875f616615628(y)));
                    });
                };
            }
        };
    };
};
var $a7cd7990ff17745a$export$207d9540d6c38a4a = function(dictApplicative) {
    var pure = $gUTA8.pure(dictApplicative);
    var semigroupCofree1 = $a7cd7990ff17745a$export$4cd8cee3369393b2(dictApplicative.Apply0());
    return function(dictMonoid) {
        var mempty = $aknDF.mempty(dictMonoid);
        var semigroupCofree2 = semigroupCofree1(dictMonoid.Semigroup0());
        return {
            mempty: $a7cd7990ff17745a$export$18736d0fdc79bf66(function(v) {
                return new $9MxTl.Tuple(mempty, pure($aknDF.mempty($a7cd7990ff17745a$export$207d9540d6c38a4a(dictApplicative)(dictMonoid))));
            }),
            Semigroup0: function() {
                return semigroupCofree2;
            }
        };
    };
};
var $a7cd7990ff17745a$export$3d90a06a91631e50 = function(dictFunctor) {
    var extendCofree1 = $a7cd7990ff17745a$export$680d116616e6c381(dictFunctor);
    return {
        extract: $a7cd7990ff17745a$export$5fd5031fecdacec3,
        Extend0: function() {
            return extendCofree1;
        }
    };
};
var $a7cd7990ff17745a$export$6c6e679936662ba2 = function(dictFunctor) {
    var map2 = $l0wDR.map(dictFunctor);
    var runFreeM = $hV7d0.runFreeM(dictFunctor)($a7cd7990ff17745a$var$monadRecStateT);
    return function(dictFunctor1) {
        var extract = $frF73.extract($a7cd7990ff17745a$export$3d90a06a91631e50(dictFunctor1));
        return function(pair) {
            return function(m) {
                return function(w) {
                    var step = function(ff) {
                        return $a7cd7990ff17745a$var$state(function(cof) {
                            return pair(map2($9MxTl.Tuple.create)(ff))($a7cd7990ff17745a$export$c01875f616615628(cof));
                        });
                    };
                    var v = $6m1DK.runState(runFreeM(step)(m))(w);
                    return v.value0(extract(v.value1));
                };
            };
        };
    };
};
var $a7cd7990ff17745a$export$282b56ce68655d1d = function(dictFunctor) {
    var map2 = $l0wDR.map(dictFunctor);
    var runFreeM = $hV7d0.runFreeM(dictFunctor);
    return function(dictFunctor1) {
        var extract = $frF73.extract($a7cd7990ff17745a$export$3d90a06a91631e50(dictFunctor1));
        return function(dictMonadRec) {
            var map3 = $l0wDR.map(dictMonadRec.Monad0().Bind1().Apply0().Functor0());
            var runFreeM1 = runFreeM($k4cbH.monadRecStateT(dictMonadRec));
            return function(pair) {
                return function(m) {
                    return function(w) {
                        var step = function(ff) {
                            return function(cof) {
                                return pair(map2($9MxTl.Tuple.create)(ff))($a7cd7990ff17745a$export$c01875f616615628(cof));
                            };
                        };
                        var $$eval = function(v) {
                            return v.value0(extract(v.value1));
                        };
                        return map3($$eval)($k4cbH.runStateT(runFreeM1(step)(m))(w));
                    };
                };
            };
        };
    };
};
var $a7cd7990ff17745a$export$b3bcb4782421e76f = function(dictFunctor) {
    var map2 = $l0wDR.map(dictFunctor);
    return function(k) {
        return function(s) {
            return $dc43y.defer(function(v) {
                return $a7cd7990ff17745a$var$map1(map2($a7cd7990ff17745a$export$b3bcb4782421e76f(dictFunctor)(k)))(k(s));
            });
        };
    };
};
var $a7cd7990ff17745a$export$822f8cf624bdf75a = function(dictAlternative) {
    return {
        Applicative0: function() {
            return $a7cd7990ff17745a$export$e7f4fbe6660ee944(dictAlternative);
        },
        Bind1: function() {
            return $a7cd7990ff17745a$export$bae78b53de66415b(dictAlternative);
        }
    };
};
var $a7cd7990ff17745a$export$bae78b53de66415b = function(dictAlternative) {
    var Alt0 = dictAlternative.Plus1().Alt0();
    var alt = $a7Dxq.alt(Alt0);
    var map2 = $l0wDR.map(Alt0.Functor0());
    return {
        bind: function(fa) {
            return function(f) {
                var loop = function(fa$prime) {
                    var fh = f($a7cd7990ff17745a$export$5fd5031fecdacec3(fa$prime));
                    return $a7cd7990ff17745a$export$5d6e20892d59dd4f($a7cd7990ff17745a$export$5fd5031fecdacec3(fh))(alt($a7cd7990ff17745a$export$c01875f616615628(fh))(map2(loop)($a7cd7990ff17745a$export$c01875f616615628(fa$prime))));
                };
                return loop(fa);
            };
        },
        Apply0: function() {
            return $a7cd7990ff17745a$export$29fadb90ec70ad5(dictAlternative);
        }
    };
};
var $a7cd7990ff17745a$export$29fadb90ec70ad5 = function(dictAlternative) {
    var functorCofree1 = $a7cd7990ff17745a$export$f880ce3874d12f41(dictAlternative.Plus1().Alt0().Functor0());
    return {
        apply: $ibtPS.ap($a7cd7990ff17745a$export$822f8cf624bdf75a(dictAlternative)),
        Functor0: function() {
            return functorCofree1;
        }
    };
};
var $a7cd7990ff17745a$export$e7f4fbe6660ee944 = function(dictAlternative) {
    var empty = $axmEP.empty(dictAlternative.Plus1());
    return {
        pure: function(a) {
            return $a7cd7990ff17745a$export$5d6e20892d59dd4f(a)(empty);
        },
        Apply0: function() {
            return $a7cd7990ff17745a$export$29fadb90ec70ad5(dictAlternative);
        }
    };
};

});
parcelRegister("6m1DK", function(module, exports) {

$parcel$export(module.exports, "runState", () => $4a0611d0fc3e3eac$export$4b65631072155b20);
$parcel$export(module.exports, "evalState", () => $4a0611d0fc3e3eac$export$3f3c20f32c573065);
// Generated by purs version 0.15.16

var $kQAxW = parcelRequire("kQAxW");

var $k4cbH = parcelRequire("k4cbH");

var $6VVZC = parcelRequire("6VVZC");

var $6PW1p = parcelRequire("6PW1p");
var $4a0611d0fc3e3eac$var$unwrap = /* #__PURE__ */ $6PW1p.unwrap();
var $4a0611d0fc3e3eac$export$29d22fcef0a54f1b = $k4cbH.withStateT;
var $4a0611d0fc3e3eac$export$4b65631072155b20 = function(v) {
    return function($18) {
        return $4a0611d0fc3e3eac$var$unwrap(v($18));
    };
};
var $4a0611d0fc3e3eac$export$a337c713bdba072 = function(f) {
    return $k4cbH.mapStateT(function($19) {
        return $6VVZC.Identity(f($4a0611d0fc3e3eac$var$unwrap($19)));
    });
};
var $4a0611d0fc3e3eac$export$6feb49085bba08e4 = function(v) {
    return function(s) {
        var v1 = v(s);
        return v1.value1;
    };
};
var $4a0611d0fc3e3eac$export$3f3c20f32c573065 = function(v) {
    return function(s) {
        var v1 = v(s);
        return v1.value0;
    };
};

});


parcelRegister("j5Y99", function(module, exports) {

$parcel$export(module.exports, "runEnvT", () => $de6d23ce72bd9963$export$7822f62148dbdb7b);
$parcel$export(module.exports, "functorEnvT", () => $de6d23ce72bd9963$export$2e69b643bad40a49);
$parcel$export(module.exports, "comonadTransEnvT", () => $de6d23ce72bd9963$export$260cd79e24f6044c);
$parcel$export(module.exports, "comonadEnvT", () => $de6d23ce72bd9963$export$2f1fbbfc0241eefc);
// Generated by purs version 0.15.16

var $frF73 = parcelRequire("frF73");

var $hfMWE = parcelRequire("hfMWE");

var $6RkEA = parcelRequire("6RkEA");

var $70sTh = parcelRequire("70sTh");

var $l0wDR = parcelRequire("l0wDR");

var $4oUwX = parcelRequire("4oUwX");

var $1wR1l = parcelRequire("1wR1l");

var $3OKRG = parcelRequire("3OKRG");

var $9MxTl = parcelRequire("9MxTl");
var $de6d23ce72bd9963$var$map = /* #__PURE__ */ $l0wDR.map($l0wDR.functorFn);
var $de6d23ce72bd9963$export$20bb9dd6299ac2d1 = function(x) {
    return x;
};
var $de6d23ce72bd9963$export$78fb6fdf6391de3f = function(f) {
    return function(v) {
        return new $9MxTl.Tuple(f(v.value0), v.value1);
    };
};
var $de6d23ce72bd9963$export$7822f62148dbdb7b = function(v) {
    return v;
};
var $de6d23ce72bd9963$export$8d8100cbc8f4aeb3 = {
    Coercible0: function() {
        return undefined;
    }
};
var $de6d23ce72bd9963$export$8fdc1986807940ca = function(f) {
    return function(v) {
        return new $9MxTl.Tuple(v.value0, f(v.value1));
    };
};
var $de6d23ce72bd9963$export$2e69b643bad40a49 = function(dictFunctor) {
    var map1 = $l0wDR.map(dictFunctor);
    return {
        map: function(f) {
            return function(v) {
                return new $9MxTl.Tuple(v.value0, map1(f)(v.value1));
            };
        }
    };
};
var $de6d23ce72bd9963$export$7c49c2d2785a7b53 = function(dictFunctorWithIndex) {
    var mapWithIndex = $4oUwX.mapWithIndex(dictFunctorWithIndex);
    var functorEnvT1 = $de6d23ce72bd9963$export$2e69b643bad40a49(dictFunctorWithIndex.Functor0());
    return {
        mapWithIndex: function(f) {
            return function(v) {
                return new $9MxTl.Tuple(v.value0, mapWithIndex(f)(v.value1));
            };
        },
        Functor0: function() {
            return functorEnvT1;
        }
    };
};
var $de6d23ce72bd9963$export$247238ed362e712e = function(dictFoldable) {
    var foldl = $6RkEA.foldl(dictFoldable);
    var foldr = $6RkEA.foldr(dictFoldable);
    var foldMap = $6RkEA.foldMap(dictFoldable);
    return {
        foldl: function(fn) {
            return function(a) {
                return function(v) {
                    return foldl(fn)(a)(v.value1);
                };
            };
        },
        foldr: function(fn) {
            return function(a) {
                return function(v) {
                    return foldr(fn)(a)(v.value1);
                };
            };
        },
        foldMap: function(dictMonoid) {
            var foldMap1 = foldMap(dictMonoid);
            return function(fn) {
                return function(v) {
                    return foldMap1(fn)(v.value1);
                };
            };
        }
    };
};
var $de6d23ce72bd9963$export$7f951632576d3a9c = function(dictFoldableWithIndex) {
    var foldlWithIndex = $70sTh.foldlWithIndex(dictFoldableWithIndex);
    var foldrWithIndex = $70sTh.foldrWithIndex(dictFoldableWithIndex);
    var foldMapWithIndex = $70sTh.foldMapWithIndex(dictFoldableWithIndex);
    var foldableEnvT1 = $de6d23ce72bd9963$export$247238ed362e712e(dictFoldableWithIndex.Foldable0());
    return {
        foldlWithIndex: function(f) {
            return function(a) {
                return function(v) {
                    return foldlWithIndex(f)(a)(v.value1);
                };
            };
        },
        foldrWithIndex: function(f) {
            return function(a) {
                return function(v) {
                    return foldrWithIndex(f)(a)(v.value1);
                };
            };
        },
        foldMapWithIndex: function(dictMonoid) {
            var foldMapWithIndex1 = foldMapWithIndex(dictMonoid);
            return function(f) {
                return function(v) {
                    return foldMapWithIndex1(f)(v.value1);
                };
            };
        },
        Foldable0: function() {
            return foldableEnvT1;
        }
    };
};
var $de6d23ce72bd9963$export$c72865941a3d759 = function(dictTraversable) {
    var sequence = $1wR1l.sequence(dictTraversable);
    var traverse = $1wR1l.traverse(dictTraversable);
    var functorEnvT1 = $de6d23ce72bd9963$export$2e69b643bad40a49(dictTraversable.Functor0());
    var foldableEnvT1 = $de6d23ce72bd9963$export$247238ed362e712e(dictTraversable.Foldable1());
    return {
        sequence: function(dictApplicative) {
            var map1 = $l0wDR.map(dictApplicative.Apply0().Functor0());
            var sequence1 = sequence(dictApplicative);
            return function(v) {
                return map1($de6d23ce72bd9963$var$map($de6d23ce72bd9963$export$20bb9dd6299ac2d1)($9MxTl.Tuple.create(v.value0)))(sequence1(v.value1));
            };
        },
        traverse: function(dictApplicative) {
            var map1 = $l0wDR.map(dictApplicative.Apply0().Functor0());
            var traverse1 = traverse(dictApplicative);
            return function(f) {
                return function(v) {
                    return map1($de6d23ce72bd9963$var$map($de6d23ce72bd9963$export$20bb9dd6299ac2d1)($9MxTl.Tuple.create(v.value0)))(traverse1(f)(v.value1));
                };
            };
        },
        Functor0: function() {
            return functorEnvT1;
        },
        Foldable1: function() {
            return foldableEnvT1;
        }
    };
};
var $de6d23ce72bd9963$export$3c0098c5f17855fc = function(dictTraversableWithIndex) {
    var traverseWithIndex = $3OKRG.traverseWithIndex(dictTraversableWithIndex);
    var functorWithIndexEnvT1 = $de6d23ce72bd9963$export$7c49c2d2785a7b53(dictTraversableWithIndex.FunctorWithIndex0());
    var foldableWithIndexEnvT1 = $de6d23ce72bd9963$export$7f951632576d3a9c(dictTraversableWithIndex.FoldableWithIndex1());
    var traversableEnvT1 = $de6d23ce72bd9963$export$c72865941a3d759(dictTraversableWithIndex.Traversable2());
    return {
        traverseWithIndex: function(dictApplicative) {
            var map1 = $l0wDR.map(dictApplicative.Apply0().Functor0());
            var traverseWithIndex1 = traverseWithIndex(dictApplicative);
            return function(f) {
                return function(v) {
                    return map1($de6d23ce72bd9963$var$map($de6d23ce72bd9963$export$20bb9dd6299ac2d1)($9MxTl.Tuple.create(v.value0)))(traverseWithIndex1(f)(v.value1));
                };
            };
        },
        FunctorWithIndex0: function() {
            return functorWithIndexEnvT1;
        },
        FoldableWithIndex1: function() {
            return foldableWithIndexEnvT1;
        },
        Traversable2: function() {
            return traversableEnvT1;
        }
    };
};
var $de6d23ce72bd9963$export$fdb6ce98815caa94 = function(dictExtend) {
    var Functor0 = dictExtend.Functor0();
    var map1 = $l0wDR.map(Functor0);
    var extend = $hfMWE.extend(dictExtend);
    var functorEnvT1 = $de6d23ce72bd9963$export$2e69b643bad40a49(Functor0);
    return {
        extend: function(f) {
            return function(v) {
                return new $9MxTl.Tuple(v.value0, map1(f)(extend(function() {
                    var $145 = $9MxTl.Tuple.create(v.value0);
                    return function($146) {
                        return $de6d23ce72bd9963$export$20bb9dd6299ac2d1($145($146));
                    };
                }())(v.value1)));
            };
        },
        Functor0: function() {
            return functorEnvT1;
        }
    };
};
var $de6d23ce72bd9963$export$260cd79e24f6044c = {
    lower: function(dictComonad) {
        return function(v) {
            return v.value1;
        };
    }
};
var $de6d23ce72bd9963$export$2f1fbbfc0241eefc = function(dictComonad) {
    var extract = $frF73.extract(dictComonad);
    var extendEnvT1 = $de6d23ce72bd9963$export$fdb6ce98815caa94(dictComonad.Extend0());
    return {
        extract: function(v) {
            return extract(v.value1);
        },
        Extend0: function() {
            return extendEnvT1;
        }
    };
};

});

parcelRegister("aaxt2", function(module, exports) {

$parcel$export(module.exports, "embed", () => $7674cc77d45770f9$export$2be46bb7e96db87f);
// Generated by purs version 0.15.16

var $gUTA8 = parcelRequire("gUTA8");

var $9Grh5 = parcelRequire("9Grh5");

var $epcZi = parcelRequire("epcZi");

var $j5Y99 = parcelRequire("j5Y99");

var $hV7d0 = parcelRequire("hV7d0");

var $aKY4H = parcelRequire("aKY4H");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");

var $eStIU = parcelRequire("eStIU");

var $16FCk = parcelRequire("16FCk");

var $e9rM5 = parcelRequire("e9rM5");
var $7674cc77d45770f9$var$pure = /* #__PURE__ */ $gUTA8.pure($hV7d0.freeApplicative);
var $7674cc77d45770f9$var$join = /* #__PURE__ */ $9Grh5.join($hV7d0.freeBind);
var $7674cc77d45770f9$export$2be46bb7e96db87f = function(dict) {
    return dict.embed;
};
var $7674cc77d45770f9$export$eeb77993e5cf9dc8 = function(dictFunctor) {
    return {
        embed: $l4M7e.flip($16FCk.unfold)($l0wDR.map(dictFunctor)($16FCk.observe(dictFunctor))),
        Functor0: function() {
            return dictFunctor;
        }
    };
};
var $7674cc77d45770f9$export$294336e788132aa1 = function(dictFunctor) {
    return {
        embed: $eStIU.roll,
        Functor0: function() {
            return dictFunctor;
        }
    };
};
var $7674cc77d45770f9$export$dbfc582279754464 = function(dictFunctor) {
    var functorEnvT = $e9rM5.functorEnvT(dictFunctor);
    return {
        embed: function(v) {
            return $aKY4H.either($7674cc77d45770f9$var$pure)(function($22) {
                return $7674cc77d45770f9$var$join($hV7d0.liftF($22));
            })(v);
        },
        Functor0: function() {
            return functorEnvT;
        }
    };
};
var $7674cc77d45770f9$export$d6df447eb5421718 = function(dictFunctor) {
    var functorEnvT = $j5Y99.functorEnvT(dictFunctor);
    return {
        embed: function(et) {
            var lower = function(v) {
                return v.value1;
            };
            var ask = function(v) {
                return v.value0;
            };
            return $epcZi.mkCofree(ask(et))(lower(et));
        },
        Functor0: function() {
            return functorEnvT;
        }
    };
};

});
parcelRegister("eStIU", function(module, exports) {

$parcel$export(module.exports, "unroll", () => $ad4d2a43e2994107$export$ed24ab65af38c83e);
$parcel$export(module.exports, "roll", () => $ad4d2a43e2994107$export$39cc7ad085a13ff8);
// Generated by purs version 0.15.16

var $a7Dxq = parcelRequire("a7Dxq");

var $axmEP = parcelRequire("axmEP");

var $4MBcA = parcelRequire("4MBcA");

var $l0wDR = parcelRequire("l0wDR");

var $d0PPW = parcelRequire("d0PPW");

var $3Orkn = parcelRequire("3Orkn");

var $58rFN = parcelRequire("58rFN");
var $ad4d2a43e2994107$export$be675d0e549a4f69 = function(x) {
    return x;
};
var $ad4d2a43e2994107$export$ed24ab65af38c83e = function(v) {
    return v;
};
var $ad4d2a43e2994107$export$21071bb829d28f46 = function(dictShow) {
    var show = $3Orkn.show(dictShow);
    return function(dictFunctor) {
        var mapFlipped = $l0wDR.mapFlipped(dictFunctor);
        return {
            show: function(v) {
                return show(mapFlipped(v)(function() {
                    var $36 = $3Orkn.show($ad4d2a43e2994107$export$21071bb829d28f46(dictShow)(dictFunctor));
                    return function($37) {
                        return $58rFN.hush($36($37));
                    };
                }()));
            }
        };
    };
};
var $ad4d2a43e2994107$export$453ff0413cf16cbd = function(dictAlt) {
    var alt = $a7Dxq.alt(dictAlt);
    return {
        append: function(v) {
            return function(v1) {
                return alt(v)(v1);
            };
        }
    };
};
var $ad4d2a43e2994107$export$39cc7ad085a13ff8 = $ad4d2a43e2994107$export$be675d0e549a4f69;
var $ad4d2a43e2994107$export$2e45390d04217597 = function(dictFunctor) {
    var map = $l0wDR.map(dictFunctor);
    return function(\u03B7) {
        var $38 = map($ad4d2a43e2994107$export$2e45390d04217597(dictFunctor)(\u03B7));
        return function($39) {
            return $ad4d2a43e2994107$export$39cc7ad085a13ff8($38(\u03B7($ad4d2a43e2994107$export$ed24ab65af38c83e($39))));
        };
    };
};
var $ad4d2a43e2994107$export$c2aed7dcf2fd79b7 = {
    Coercible0: function() {
        return undefined;
    }
};
var $ad4d2a43e2994107$export$e59411599e8db694 = function(dictPlus) {
    var semigroupMu1 = $ad4d2a43e2994107$export$453ff0413cf16cbd(dictPlus.Alt0());
    return {
        mempty: $axmEP.empty(dictPlus),
        Semigroup0: function() {
            return semigroupMu1;
        }
    };
};
var $ad4d2a43e2994107$export$d88b9cb82fe4c356 = function(dictEq1) {
    var eq1 = $4MBcA.eq1(dictEq1);
    return {
        eq: function(v) {
            return function(v1) {
                return eq1($ad4d2a43e2994107$export$d88b9cb82fe4c356(dictEq1))(v)(v1);
            };
        }
    };
};
var $ad4d2a43e2994107$export$feca25d27e97e291 = function(dictEq1) {
    var eqMu1 = $ad4d2a43e2994107$export$d88b9cb82fe4c356(dictEq1);
    return function(dictOrd1) {
        var compare1 = $d0PPW.compare1(dictOrd1);
        return {
            compare: function(v) {
                return function(v1) {
                    return compare1($ad4d2a43e2994107$export$feca25d27e97e291(dictEq1)(dictOrd1))(v)(v1);
                };
            },
            Eq0: function() {
                return eqMu1;
            }
        };
    };
};

});
parcelRegister("58rFN", function(module, exports) {

$parcel$export(module.exports, "hush", () => $3bd32a656a2c5f99$export$3a6c138b8d0f3874);
// Generated by purs version 0.15.16

var $d0PPW = parcelRequire("d0PPW");
var $3bd32a656a2c5f99$var$compare = /* #__PURE__ */ $d0PPW.compare($d0PPW.ordString);
var $3bd32a656a2c5f99$var$TacitString = function(x) {
    return x;
};
var $3bd32a656a2c5f99$export$fc4337b1f701f91e = {
    show: function(v) {
        return v;
    }
};
var $3bd32a656a2c5f99$export$3a6c138b8d0f3874 = $3bd32a656a2c5f99$var$TacitString;
var $3bd32a656a2c5f99$export$4c2a24f680eaa53f = {
    eq: function(x) {
        return function(y) {
            return x === y;
        };
    }
};
var $3bd32a656a2c5f99$export$fddccc1662a33272 = {
    compare: function(x) {
        return function(y) {
            return $3bd32a656a2c5f99$var$compare(x)(y);
        };
    },
    Eq0: function() {
        return $3bd32a656a2c5f99$export$4c2a24f680eaa53f;
    }
};

});


parcelRegister("16FCk", function(module, exports) {

$parcel$export(module.exports, "unfold", () => $0ce6a249b1b5ce25$export$c48e357c1a89b78d);
$parcel$export(module.exports, "observe", () => $0ce6a249b1b5ce25$export$d1203567a167490e);
// Generated by purs version 0.15.16

var $i0kD8 = parcelRequire("i0kD8");

var $fQr0C = parcelRequire("fQr0C");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");
var $0ce6a249b1b5ce25$export$9616291006d2ed55 = function(x) {
    return x;
};
var $0ce6a249b1b5ce25$export$1ed70b0ce2a68fe = function(x) {
    return x;
};
var $0ce6a249b1b5ce25$export$c48e357c1a89b78d = function(pos) {
    return function(peek) {
        return $fQr0C.mkExists($i0kD8.store(peek)(pos));
    };
};
var $0ce6a249b1b5ce25$var$observeF = function(dictFunctor) {
    var map = $l0wDR.map(dictFunctor);
    return function(v) {
        var v1 = $i0kD8.runStore(v);
        return map($l4M7e.flip($0ce6a249b1b5ce25$export$c48e357c1a89b78d)(v1.value0))(v1.value0(v1.value1));
    };
};
var $0ce6a249b1b5ce25$export$d1203567a167490e = function(dictFunctor) {
    var observeF1 = $0ce6a249b1b5ce25$var$observeF(dictFunctor);
    return function(v) {
        return $fQr0C.runExists(observeF1)(v);
    };
};
var $0ce6a249b1b5ce25$export$c730e8346d8004c1 = {
    Coercible0: function() {
        return undefined;
    }
};

});
parcelRegister("i0kD8", function(module, exports) {

$parcel$export(module.exports, "store", () => $0361f06ebde30b55$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "runStore", () => $0361f06ebde30b55$export$97c81f9db0ee9f9b);
// Generated by purs version 0.15.16

var $5ax6m = parcelRequire("5ax6m");

var $humdu = parcelRequire("humdu");

var $l0wDR = parcelRequire("l0wDR");

var $6PW1p = parcelRequire("6PW1p");

var $9MxTl = parcelRequire("9MxTl");
var $0361f06ebde30b55$var$map = /* #__PURE__ */ $l0wDR.map($9MxTl.functorTuple);
var $0361f06ebde30b55$var$unwrap = /* #__PURE__ */ $6PW1p.unwrap();
var $0361f06ebde30b55$export$6f57813fe9f31bf9 = function(f) {
    return function(x) {
        return new $9MxTl.Tuple(f, x);
    };
};
var $0361f06ebde30b55$export$97c81f9db0ee9f9b = function(v) {
    return $9MxTl.swap($0361f06ebde30b55$var$map($0361f06ebde30b55$var$unwrap)($9MxTl.swap(v)));
};

});
parcelRegister("5ax6m", function(module, exports) {
// Generated by purs version 0.15.16

var $frF73 = parcelRequire("frF73");

var $j5Y99 = parcelRequire("j5Y99");

var $humdu = parcelRequire("humdu");

var $26Zin = parcelRequire("26Zin");

var $hYXJ6 = parcelRequire("hYXJ6");

var $hfMWE = parcelRequire("hfMWE");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");
var $3c37903866a3f98a$var$lower = /* #__PURE__ */ $hYXJ6.lower($j5Y99.comonadTransEnvT);
var $3c37903866a3f98a$export$5bc51b3f4583b4e2 = function(dict) {
    return dict.pos;
};
var $3c37903866a3f98a$export$4d3fb11e950abb9e = function(dict) {
    return dict.peek;
};
var $3c37903866a3f98a$export$274662666e2810e9 = function(dictComonadStore) {
    var peek1 = $3c37903866a3f98a$export$4d3fb11e950abb9e(dictComonadStore);
    var pos1 = $3c37903866a3f98a$export$5bc51b3f4583b4e2(dictComonadStore);
    return function(f) {
        return function(x) {
            return peek1(f(pos1(x)))(x);
        };
    };
};
var $3c37903866a3f98a$export$ff9351ab58e5131d = function(dictComonadStore) {
    var peeks1 = $3c37903866a3f98a$export$274662666e2810e9(dictComonadStore);
    var duplicate = $hfMWE.duplicate(dictComonadStore.Comonad0().Extend0());
    return function(f) {
        var $50 = peeks1(f);
        return function($51) {
            return $50(duplicate($51));
        };
    };
};
var $3c37903866a3f98a$export$990806b8ad8af834 = function(dictComonadStore) {
    var peek1 = $3c37903866a3f98a$export$4d3fb11e950abb9e(dictComonadStore);
    var duplicate = $hfMWE.duplicate(dictComonadStore.Comonad0().Extend0());
    return function(s) {
        var $52 = peek1(s);
        return function($53) {
            return $52(duplicate($53));
        };
    };
};
var $3c37903866a3f98a$export$6c39d87d46da7797 = function(dictComonadStore) {
    var peek1 = $3c37903866a3f98a$export$4d3fb11e950abb9e(dictComonadStore);
    var pos1 = $3c37903866a3f98a$export$5bc51b3f4583b4e2(dictComonadStore);
    return function(dictFunctor) {
        var map = $l0wDR.map(dictFunctor);
        return function(f) {
            return function(x) {
                return map($l4M7e.flip(peek1)(x))(f(pos1(x)));
            };
        };
    };
};
var $3c37903866a3f98a$export$63d84c079eef1a5f = function(dictComonadStore) {
    var pos1 = $3c37903866a3f98a$export$5bc51b3f4583b4e2(dictComonadStore);
    var Comonad0 = dictComonadStore.Comonad0();
    var peek1 = $3c37903866a3f98a$export$4d3fb11e950abb9e(dictComonadStore);
    var comonadTracedT = $26Zin.comonadTracedT(Comonad0);
    return function(dictMonoid) {
        var lower1 = $hYXJ6.lower($26Zin.comonadTransTracedT(dictMonoid))(Comonad0);
        var comonadTracedT1 = comonadTracedT(dictMonoid);
        return {
            pos: function($54) {
                return pos1(lower1($54));
            },
            peek: function(s) {
                var $55 = peek1(s);
                return function($56) {
                    return $55(lower1($56));
                };
            },
            Comonad0: function() {
                return comonadTracedT1;
            }
        };
    };
};
var $3c37903866a3f98a$export$b965fd43ac1cc049 = function(dictComonad) {
    var extract = $frF73.extract(dictComonad);
    var comonadStoreT = $humdu.comonadStoreT(dictComonad);
    return {
        pos: function(v) {
            return v.value1;
        },
        peek: function(s) {
            return function(v) {
                return extract(v.value0)(s);
            };
        },
        Comonad0: function() {
            return comonadStoreT;
        }
    };
};
var $3c37903866a3f98a$export$d5dc1b480b63b39d = function(dictComonadStore) {
    var Comonad0 = dictComonadStore.Comonad0();
    var lower1 = $3c37903866a3f98a$var$lower(Comonad0);
    var peek1 = $3c37903866a3f98a$export$4d3fb11e950abb9e(dictComonadStore);
    var comonadEnvT = $j5Y99.comonadEnvT(Comonad0);
    return {
        pos: function() {
            var $57 = $3c37903866a3f98a$export$5bc51b3f4583b4e2(dictComonadStore);
            return function($58) {
                return $57(lower1($58));
            };
        }(),
        peek: function(s) {
            var $59 = peek1(s);
            return function($60) {
                return $59(lower1($60));
            };
        },
        Comonad0: function() {
            return comonadEnvT;
        }
    };
};

});
parcelRegister("humdu", function(module, exports) {

$parcel$export(module.exports, "comonadStoreT", () => $cbb678c328461566$export$8342d7f40bd721cc);
// Generated by purs version 0.15.16

var $frF73 = parcelRequire("frF73");

var $hfMWE = parcelRequire("hfMWE");

var $l0wDR = parcelRequire("l0wDR");

var $9MxTl = parcelRequire("9MxTl");
var $cbb678c328461566$export$c6139d235ea5747f = function(x) {
    return x;
};
var $cbb678c328461566$export$7062c2003728a476 = function(v) {
    return v;
};
var $cbb678c328461566$export$752da87b44e3afad = {
    Coercible0: function() {
        return undefined;
    }
};
var $cbb678c328461566$export$7b3ce695953964c7 = function(dictFunctor) {
    var map = $l0wDR.map(dictFunctor);
    return {
        map: function(f) {
            return function(v) {
                return new $9MxTl.Tuple(map(function(h) {
                    return function($36) {
                        return f(h($36));
                    };
                })(v.value0), v.value1);
            };
        }
    };
};
var $cbb678c328461566$export$5167a26b17a236fe = function(dictExtend) {
    var extend = $hfMWE.extend(dictExtend);
    var functorStoreT1 = $cbb678c328461566$export$7b3ce695953964c7(dictExtend.Functor0());
    return {
        extend: function(f) {
            return function(v) {
                return new $9MxTl.Tuple(extend(function(w$prime) {
                    return function(s$prime) {
                        return f(new $9MxTl.Tuple(w$prime, s$prime));
                    };
                })(v.value0), v.value1);
            };
        },
        Functor0: function() {
            return functorStoreT1;
        }
    };
};
var $cbb678c328461566$export$d38e4f497e7b9304 = {
    lower: function(dictComonad) {
        var map = $l0wDR.map(dictComonad.Extend0().Functor0());
        return function(v) {
            return map(function(v1) {
                return v1(v.value1);
            })(v.value0);
        };
    }
};
var $cbb678c328461566$export$8342d7f40bd721cc = function(dictComonad) {
    var extract = $frF73.extract(dictComonad);
    var extendStoreT1 = $cbb678c328461566$export$5167a26b17a236fe(dictComonad.Extend0());
    return {
        extract: function(v) {
            return extract(v.value0)(v.value1);
        },
        Extend0: function() {
            return extendStoreT1;
        }
    };
};

});

parcelRegister("26Zin", function(module, exports) {

$parcel$export(module.exports, "comonadTransTracedT", () => $189bb046306a79ab$export$9dca622578931e8d);
$parcel$export(module.exports, "comonadTracedT", () => $189bb046306a79ab$export$10faa991513f1bd7);
// Generated by purs version 0.15.16

var $frF73 = parcelRequire("frF73");

var $hfMWE = parcelRequire("hfMWE");

var $l0wDR = parcelRequire("l0wDR");

var $aknDF = parcelRequire("aknDF");

var $iwqgS = parcelRequire("iwqgS");
var $189bb046306a79ab$export$b1f62b2554dc438a = function(x) {
    return x;
};
var $189bb046306a79ab$export$873056795cbbf4fb = function(v) {
    return v;
};
var $189bb046306a79ab$export$500451682ebcfb15 = {
    Coercible0: function() {
        return undefined;
    }
};
var $189bb046306a79ab$export$734682673532d962 = function(dictFunctor) {
    var map = $l0wDR.map(dictFunctor);
    return {
        map: function(f) {
            return function(v) {
                return map(function(g) {
                    return function(t) {
                        return f(g(t));
                    };
                })(v);
            };
        }
    };
};
var $189bb046306a79ab$export$b74c9e93c48446f4 = function(dictExtend) {
    var extend = $hfMWE.extend(dictExtend);
    var Functor0 = dictExtend.Functor0();
    var map = $l0wDR.map(Functor0);
    var functorTracedT1 = $189bb046306a79ab$export$734682673532d962(Functor0);
    return function(dictSemigroup) {
        var append = $iwqgS.append(dictSemigroup);
        return {
            extend: function(f) {
                return function(v) {
                    return extend(function(w$prime) {
                        return function(t) {
                            return f(map(function(h) {
                                return function(t$prime) {
                                    return h(append(t)(t$prime));
                                };
                            })(w$prime));
                        };
                    })(v);
                };
            },
            Functor0: function() {
                return functorTracedT1;
            }
        };
    };
};
var $189bb046306a79ab$export$9dca622578931e8d = function(dictMonoid) {
    var mempty = $aknDF.mempty(dictMonoid);
    return {
        lower: function(dictComonad) {
            var map = $l0wDR.map(dictComonad.Extend0().Functor0());
            return function(v) {
                return map(function(f) {
                    return f(mempty);
                })(v);
            };
        }
    };
};
var $189bb046306a79ab$export$10faa991513f1bd7 = function(dictComonad) {
    var extract = $frF73.extract(dictComonad);
    var extendTracedT1 = $189bb046306a79ab$export$b74c9e93c48446f4(dictComonad.Extend0());
    return function(dictMonoid) {
        var mempty = $aknDF.mempty(dictMonoid);
        var extendTracedT2 = extendTracedT1(dictMonoid.Semigroup0());
        return {
            extract: function(v) {
                return extract(v)(mempty);
            },
            Extend0: function() {
                return extendTracedT2;
            }
        };
    };
};

});

parcelRegister("hYXJ6", function(module, exports) {

$parcel$export(module.exports, "lower", () => $d1765eb5cc953f6a$export$abae053c7acf36bb);
// Generated by purs version 0.15.16

var $cPaFP = parcelRequire("cPaFP");
var $d1765eb5cc953f6a$export$abae053c7acf36bb = function(dict) {
    return dict.lower;
};
var $d1765eb5cc953f6a$export$2dba7d1d9edcf903 = {
    lower: function(dictComonad) {
        return $cPaFP.runIdentityT;
    }
};

});
parcelRegister("cPaFP", function(module, exports) {

$parcel$export(module.exports, "runIdentityT", () => $95628704cdc289b7$export$f559614bc68eadeb);
// Generated by purs version 0.15.16

var $frF73 = parcelRequire("frF73");

var $hfMWE = parcelRequire("hfMWE");

var $4MBcA = parcelRequire("4MBcA");

var $d0PPW = parcelRequire("d0PPW");
var $95628704cdc289b7$export$312b4bd1908c74b8 = function(x) {
    return x;
};
var $95628704cdc289b7$export$d10bd1a8e6b5a0fc = function(dictMonadST) {
    return dictMonadST;
};
var $95628704cdc289b7$export$cc197473107e49d8 = function(dictTraversable) {
    return dictTraversable;
};
var $95628704cdc289b7$export$f559614bc68eadeb = function(v) {
    return v;
};
var $95628704cdc289b7$export$4b66f180ab3ebc3e = function(dictPlus) {
    return dictPlus;
};
var $95628704cdc289b7$export$c92b0492bf7a0c95 = {
    Coercible0: function() {
        return undefined;
    }
};
var $95628704cdc289b7$export$9b8192a3dd66254d = function(dictMonadWriter) {
    return dictMonadWriter;
};
var $95628704cdc289b7$export$377151221bfc0368 = {
    lift: function(dictMonad) {
        return $95628704cdc289b7$export$312b4bd1908c74b8;
    }
};
var $95628704cdc289b7$export$935d30293f1a30ab = function(dictMonadThrow) {
    return dictMonadThrow;
};
var $95628704cdc289b7$export$d03c9d58a48667e7 = function(dictMonadTell) {
    return dictMonadTell;
};
var $95628704cdc289b7$export$f1507096648b94e8 = function(dictMonadState) {
    return dictMonadState;
};
var $95628704cdc289b7$export$d57c804b8d8af0bc = function(dictMonadRec) {
    return dictMonadRec;
};
var $95628704cdc289b7$export$d30aead10083b10a = function(dictMonadReader) {
    return dictMonadReader;
};
var $95628704cdc289b7$export$699b998d9a84f4d3 = function(dictMonadPlus) {
    return dictMonadPlus;
};
var $95628704cdc289b7$export$d524096adbdb86bd = function(dictMonad) {
    return dictMonad;
};
var $95628704cdc289b7$export$cc3587cb5809554b = function(dictMonadError) {
    return dictMonadError;
};
var $95628704cdc289b7$export$6325ecc9b14976fe = function(dictMonadEffect) {
    return dictMonadEffect;
};
var $95628704cdc289b7$export$b8c79a421f3b9f83 = function(dictMonadCont) {
    return dictMonadCont;
};
var $95628704cdc289b7$export$730b2ccc17b296a8 = function(dictMonadAsk) {
    return dictMonadAsk;
};
var $95628704cdc289b7$export$d63c73ca9b2c4a6d = function(f) {
    return function(v) {
        return f(v);
    };
};
var $95628704cdc289b7$export$6cf1fa41571c25b3 = function(dictFunctor) {
    return dictFunctor;
};
var $95628704cdc289b7$export$2406de5612ef89a = function(dictFoldable) {
    return dictFoldable;
};
var $95628704cdc289b7$export$981c5696dd63a69 = function(dictExtend) {
    var extend = $hfMWE.extend(dictExtend);
    var functorIdentityT1 = $95628704cdc289b7$export$6cf1fa41571c25b3(dictExtend.Functor0());
    return {
        extend: function(f) {
            return function(v) {
                return extend(function($77) {
                    return f($95628704cdc289b7$export$312b4bd1908c74b8($77));
                })(v);
            };
        },
        Functor0: function() {
            return functorIdentityT1;
        }
    };
};
var $95628704cdc289b7$export$71596e5fc1eb8bdb = function(dictEq1) {
    var eq1 = $4MBcA.eq1(dictEq1);
    return function(dictEq) {
        var eq11 = eq1(dictEq);
        return {
            eq: function(x) {
                return function(y) {
                    return eq11(x)(y);
                };
            }
        };
    };
};
var $95628704cdc289b7$export$dfed092773760e1a = function(dictOrd1) {
    var compare1 = $d0PPW.compare1(dictOrd1);
    var eqIdentityT1 = $95628704cdc289b7$export$71596e5fc1eb8bdb(dictOrd1.Eq10());
    return function(dictOrd) {
        var compare11 = compare1(dictOrd);
        var eqIdentityT2 = eqIdentityT1(dictOrd.Eq0());
        return {
            compare: function(x) {
                return function(y) {
                    return compare11(x)(y);
                };
            },
            Eq0: function() {
                return eqIdentityT2;
            }
        };
    };
};
var $95628704cdc289b7$export$fcbc0eec96251e72 = function(dictEq1) {
    var eqIdentityT1 = $95628704cdc289b7$export$71596e5fc1eb8bdb(dictEq1);
    return {
        eq1: function(dictEq) {
            return $4MBcA.eq(eqIdentityT1(dictEq));
        }
    };
};
var $95628704cdc289b7$export$d8491e08836f9401 = function(dictOrd1) {
    var ordIdentityT1 = $95628704cdc289b7$export$dfed092773760e1a(dictOrd1);
    var eq1IdentityT1 = $95628704cdc289b7$export$fcbc0eec96251e72(dictOrd1.Eq10());
    return {
        compare1: function(dictOrd) {
            return $d0PPW.compare(ordIdentityT1(dictOrd));
        },
        Eq10: function() {
            return eq1IdentityT1;
        }
    };
};
var $95628704cdc289b7$export$193b33bd645fa615 = function(dictComonad) {
    var extendIdentityI1 = $95628704cdc289b7$export$981c5696dd63a69(dictComonad.Extend0());
    return {
        extract: function() {
            var $78 = $frF73.extract(dictComonad);
            return function($79) {
                return $78($95628704cdc289b7$export$f559614bc68eadeb($79));
            };
        }(),
        Extend0: function() {
            return extendIdentityI1;
        }
    };
};
var $95628704cdc289b7$export$6a5d8c95bed4c6ee = function(dictBind) {
    return dictBind;
};
var $95628704cdc289b7$export$f618241787f7f03b = function(dictApply) {
    return dictApply;
};
var $95628704cdc289b7$export$59727565d52819db = function(dictApplicative) {
    return dictApplicative;
};
var $95628704cdc289b7$export$a055f51beb16bbca = function(dictAlternative) {
    return dictAlternative;
};
var $95628704cdc289b7$export$bdc991011c3f73d3 = function(dictAlt) {
    return dictAlt;
};

});





parcelRegister("e9rM5", function(module, exports) {

$parcel$export(module.exports, "CoEnvT", () => $a4d773650e2db79e$export$eaa1387f8004eb1a);
$parcel$export(module.exports, "functorEnvT", () => $a4d773650e2db79e$export$2e69b643bad40a49);
// Generated by purs version 0.15.16

var $2Mmje = parcelRequire("2Mmje");

var $aKY4H = parcelRequire("aKY4H");

var $l0wDR = parcelRequire("l0wDR");
var $a4d773650e2db79e$var$lmap = /* #__PURE__ */ $2Mmje.lmap($2Mmje.bifunctorEither);
var $a4d773650e2db79e$var$map = /* #__PURE__ */ $l0wDR.map($aKY4H.functorEither);
var $a4d773650e2db79e$export$eaa1387f8004eb1a = function(x) {
    return x;
};
var $a4d773650e2db79e$export$78fb6fdf6391de3f = function(f) {
    return function(v) {
        return $a4d773650e2db79e$var$lmap(f)(v);
    };
};
var $a4d773650e2db79e$export$7822f62148dbdb7b = function(v) {
    return v;
};
var $a4d773650e2db79e$export$8d8100cbc8f4aeb3 = {
    Coercible0: function() {
        return undefined;
    }
};
var $a4d773650e2db79e$export$8fdc1986807940ca = function(f) {
    return function(v) {
        return $a4d773650e2db79e$var$map(f)(v);
    };
};
var $a4d773650e2db79e$export$2e69b643bad40a49 = function(dictFunctor) {
    var map1 = $l0wDR.map(dictFunctor);
    return {
        map: function(f) {
            return function(v) {
                return $a4d773650e2db79e$var$map(map1(f))(v);
            };
        }
    };
};

});


parcelRegister("eo6zx", function(module, exports) {

$parcel$export(module.exports, "project", () => $a79867b2072009fe$export$ab03b6763ed7026f);
// Generated by purs version 0.15.16

var $epcZi = parcelRequire("epcZi");

var $j5Y99 = parcelRequire("j5Y99");

var $hV7d0 = parcelRequire("hV7d0");

var $aKY4H = parcelRequire("aKY4H");

var $eStIU = parcelRequire("eStIU");

var $16FCk = parcelRequire("16FCk");

var $9MxTl = parcelRequire("9MxTl");

var $e9rM5 = parcelRequire("e9rM5");
var $a79867b2072009fe$export$80f4d18f20633d93 = function(dictFunctor) {
    return {
        project: $16FCk.observe(dictFunctor),
        Functor0: function() {
            return dictFunctor;
        }
    };
};
var $a79867b2072009fe$export$8a36964b19a055a = function(dictFunctor) {
    return {
        project: $eStIU.unroll,
        Functor0: function() {
            return dictFunctor;
        }
    };
};
var $a79867b2072009fe$export$4bb5417dca3e5fd1 = function(dictFunctor) {
    var functorEnvT = $e9rM5.functorEnvT(dictFunctor);
    return {
        project: function() {
            var $10 = $aKY4H.either($aKY4H.Right.create)($aKY4H.Left.create);
            var $11 = $hV7d0.resume(dictFunctor);
            return function($12) {
                return $e9rM5.CoEnvT($10($11($12)));
            };
        }(),
        Functor0: function() {
            return functorEnvT;
        }
    };
};
var $a79867b2072009fe$export$791814fcc90ca7bb = function(dictFunctor) {
    var functorEnvT = $j5Y99.functorEnvT(dictFunctor);
    return {
        project: function(cf) {
            return new $9MxTl.Tuple($epcZi.head(cf), $epcZi.tail(cf));
        },
        Functor0: function() {
            return functorEnvT;
        }
    };
};
var $a79867b2072009fe$export$ab03b6763ed7026f = function(dict) {
    return dict.project;
};

});

parcelRegister("gwTNH", function(module, exports) {

$parcel$export(module.exports, "distZygoT", () => $c08aeb5990a09481$export$3ad423c73a4598e7);
$parcel$export(module.exports, "distZygo", () => $c08aeb5990a09481$export$b25d9a9c5406421d);
$parcel$export(module.exports, "distGHisto", () => $c08aeb5990a09481$export$3e2919fd5cfaf867);
$parcel$export(module.exports, "distHisto", () => $c08aeb5990a09481$export$59f09792149f5fdd);
$parcel$export(module.exports, "distFutu", () => $c08aeb5990a09481$export$331719a1a2bf9be2);
$parcel$export(module.exports, "distAna", () => $c08aeb5990a09481$export$8351e4cb01ba3ef5);
// Generated by purs version 0.15.16

var $gUTA8 = parcelRequire("gUTA8");

var $9Grh5 = parcelRequire("9Grh5");

var $7T8P4 = parcelRequire("7T8P4");

var $frF73 = parcelRequire("frF73");

var $epcZi = parcelRequire("epcZi");

var $j5Y99 = parcelRequire("j5Y99");

var $hYXJ6 = parcelRequire("hYXJ6");

var $i2F6a = parcelRequire("i2F6a");

var $hV7d0 = parcelRequire("hV7d0");

var $5ecNO = parcelRequire("5ecNO");

var $aKY4H = parcelRequire("aKY4H");

var $l0wDR = parcelRequire("l0wDR");

var $6PW1p = parcelRequire("6PW1p");

var $1wR1l = parcelRequire("1wR1l");

var $9MxTl = parcelRequire("9MxTl");

var $aaxt2 = parcelRequire("aaxt2");

var $eo6zx = parcelRequire("eo6zx");
var $c08aeb5990a09481$var$lower = /* #__PURE__ */ $hYXJ6.lower($j5Y99.comonadTransEnvT);
var $c08aeb5990a09481$var$identity = /* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn);
var $c08aeb5990a09481$var$join = /* #__PURE__ */ $9Grh5.join($hV7d0.freeBind);
var $c08aeb5990a09481$var$pure = /* #__PURE__ */ $gUTA8.pure($hV7d0.freeApplicative);
var $c08aeb5990a09481$var$wrap = /* #__PURE__ */ $6PW1p.wrap();
var $c08aeb5990a09481$var$unwrap = /* #__PURE__ */ $6PW1p.unwrap();
var $c08aeb5990a09481$export$3ad423c73a4598e7 = function(dictFunctor) {
    var map = $l0wDR.map(dictFunctor);
    return function(dictComonad) {
        var lower1 = $c08aeb5990a09481$var$lower(dictComonad);
        return function(g) {
            return function(k) {
                return function(fe) {
                    return new $9MxTl.Tuple(g(map(function($68) {
                        return $9MxTl.fst($j5Y99.runEnvT($68));
                    })(fe)), k(map(lower1)(fe)));
                };
            };
        };
    };
};
var $c08aeb5990a09481$export$b25d9a9c5406421d = function(dictFunctor) {
    var map = $l0wDR.map(dictFunctor);
    return function(g) {
        return function(m) {
            return new $9MxTl.Tuple(g(map($9MxTl.fst)(m)), map($9MxTl.snd)(m));
        };
    };
};
var $c08aeb5990a09481$export$defcc2a2d5839471 = function(dictCorecursive) {
    var distZygoT1 = $c08aeb5990a09481$export$3ad423c73a4598e7(dictCorecursive.Functor0());
    var embed = $aaxt2.embed(dictCorecursive);
    return function(dictComonad) {
        return distZygoT1(dictComonad)(embed);
    };
};
var $c08aeb5990a09481$export$e2dbc2129423f912 = function(dictCorecursive) {
    return $c08aeb5990a09481$export$b25d9a9c5406421d(dictCorecursive.Functor0())($aaxt2.embed(dictCorecursive));
};
var $c08aeb5990a09481$export$3e2919fd5cfaf867 = function(dictFunctor) {
    var map = $l0wDR.map(dictFunctor);
    return function(dictFunctor1) {
        var buildCofree = $epcZi.buildCofree(dictFunctor1);
        var extract = $frF73.extract($epcZi.comonadCofree(dictFunctor1));
        return function(k) {
            return buildCofree(function(s) {
                return new $9MxTl.Tuple(map(extract)(s), k(map($epcZi.tail)(s)));
            });
        };
    };
};
var $c08aeb5990a09481$export$59f09792149f5fdd = function(dictFunctor) {
    return $c08aeb5990a09481$export$3e2919fd5cfaf867(dictFunctor)(dictFunctor)($c08aeb5990a09481$var$identity);
};
var $c08aeb5990a09481$export$e13c7e2e9a754d3d = function(dictFunctor) {
    var map = $l0wDR.map(dictFunctor);
    return function(dictFunctor1) {
        var resume = $hV7d0.resume(dictFunctor1);
        var map1 = $l0wDR.map(dictFunctor1);
        return function(k) {
            return function(f) {
                var v = resume(f);
                if (v instanceof $aKY4H.Left) return map(function($69) {
                    return $c08aeb5990a09481$var$join($hV7d0.liftF($69));
                })(k(map1($c08aeb5990a09481$export$e13c7e2e9a754d3d(dictFunctor)(dictFunctor1)(k))(v.value0)));
                if (v instanceof $aKY4H.Right) return map($c08aeb5990a09481$var$pure)(v.value0);
                throw new Error("Failed pattern match at Matryoshka.DistributiveLaw (line 113, column 17 - line 115, column 24): " + [
                    v.constructor.name
                ]);
            };
        };
    };
};
var $c08aeb5990a09481$export$4291c494f266f306 = function(dictFunctor) {
    var map = $l0wDR.map(dictFunctor);
    return function(f) {
        return $aKY4H.either(function() {
            var $70 = map($aKY4H.Left.create);
            return function($71) {
                return $70(f($71));
            };
        }())(map($aKY4H.Right.create));
    };
};
var $c08aeb5990a09481$export$f7b4c276d8bd227 = function(dictFunctor) {
    var map = $l0wDR.map(dictFunctor);
    var distGApo1 = $c08aeb5990a09481$export$4291c494f266f306(dictFunctor);
    return function(dictFunctor1) {
        var map1 = $l0wDR.map(dictFunctor1);
        return function(g) {
            return function(k) {
                var $72 = map($i2F6a.ExceptT);
                var $73 = map1(distGApo1(g));
                return function($74) {
                    return $72(k($73($i2F6a.runExceptT($74))));
                };
            };
        };
    };
};
var $c08aeb5990a09481$export$331719a1a2bf9be2 = function(dictFunctor) {
    return $c08aeb5990a09481$export$e13c7e2e9a754d3d(dictFunctor)(dictFunctor)($c08aeb5990a09481$var$identity);
};
var $c08aeb5990a09481$export$72c6a63406418bfa = function(dictTraversable) {
    var Functor0 = dictTraversable.Functor0();
    return function(dictDistributive) {
        return $5ecNO.distribute(dictDistributive)(Functor0);
    };
};
var $c08aeb5990a09481$export$6b7a71410a4d5454 = function(dictFunctor) {
    var $75 = $l0wDR.map(dictFunctor)($c08aeb5990a09481$var$unwrap);
    return function($76) {
        return $c08aeb5990a09481$var$wrap($75($76));
    };
};
var $c08aeb5990a09481$export$446a568c568952b3 = function(dictTraversable) {
    var sequence = $1wR1l.sequence(dictTraversable);
    return function(dictApplicative) {
        return sequence(dictApplicative);
    };
};
var $c08aeb5990a09481$export$31ae77933c45c85f = function(dictRecursive) {
    return $c08aeb5990a09481$export$4291c494f266f306(dictRecursive.Functor0())($eo6zx.project(dictRecursive));
};
var $c08aeb5990a09481$export$8351e4cb01ba3ef5 = function(dictFunctor) {
    var $77 = $l0wDR.map(dictFunctor)($c08aeb5990a09481$var$wrap);
    return function($78) {
        return $77($c08aeb5990a09481$var$unwrap($78));
    };
};

});

parcelRegister("h6B4A", function(module, exports) {

$parcel$export(module.exports, "traverseR", () => $c73fc1233538f017$export$6bc82e5668fe4d3e);
$parcel$export(module.exports, "mapR", () => $c73fc1233538f017$export$f555059471b9a0a7);
// Generated by purs version 0.15.16

var $l0wDR = parcelRequire("l0wDR");

var $aaxt2 = parcelRequire("aaxt2");

var $eo6zx = parcelRequire("eo6zx");
var $c73fc1233538f017$export$6bc82e5668fe4d3e = function(dictRecursive) {
    var project = $eo6zx.project(dictRecursive);
    return function(dictCorecursive) {
        var embed = $aaxt2.embed(dictCorecursive);
        return function(dictFunctor) {
            var map = $l0wDR.map(dictFunctor);
            return function(f) {
                var $11 = map(embed);
                return function($12) {
                    return $11(f(project($12)));
                };
            };
        };
    };
};
var $c73fc1233538f017$export$f555059471b9a0a7 = function(dictRecursive) {
    var project = $eo6zx.project(dictRecursive);
    return function(dictCorecursive) {
        var embed = $aaxt2.embed(dictCorecursive);
        return function(f) {
            return function($13) {
                return embed(f(project($13)));
            };
        };
    };
};

});


parcelRegister("6rKEG", function(module, exports) {

$parcel$export(module.exports, "anaM", () => $4b1974702efa26d7$export$1fe039aff1cafe30);
// Generated by purs version 0.15.16

var $gUTA8 = parcelRequire("gUTA8");

var $9Grh5 = parcelRequire("9Grh5");

var $7T8P4 = parcelRequire("7T8P4");

var $hV7d0 = parcelRequire("hV7d0");

var $aKY4H = parcelRequire("aKY4H");

var $l0wDR = parcelRequire("l0wDR");

var $6VVZC = parcelRequire("6VVZC");

var $1wR1l = parcelRequire("1wR1l");

var $aaxt2 = parcelRequire("aaxt2");

var $eo6zx = parcelRequire("eo6zx");

var $gwTNH = parcelRequire("gwTNH");

var $h6B4A = parcelRequire("h6B4A");
var $4b1974702efa26d7$var$identity = /* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn);
var $4b1974702efa26d7$export$294d00da6c8cafac = function(dictRecursive) {
    var mapR = $h6B4A.mapR(dictRecursive);
    return function(dictCorecursive) {
        var mapR1 = mapR(dictCorecursive);
        var map = $l0wDR.map(dictCorecursive.Functor0());
        return function(f) {
            var go = function(t) {
                return $aKY4H.either($4b1974702efa26d7$var$identity)(mapR1(map(go)))(f(t));
            };
            return go;
        };
    };
};
var $4b1974702efa26d7$export$951e81ccedb95a76 = function(dictRecursive) {
    var mapR = $h6B4A.mapR(dictRecursive);
    return function(dictCorecursive) {
        var mapR1 = mapR(dictCorecursive);
        var map = $l0wDR.map(dictCorecursive.Functor0());
        return function(f) {
            var go = function(t) {
                return mapR1(function() {
                    var $198 = map($aKY4H.either($4b1974702efa26d7$var$identity)(go));
                    return function($199) {
                        return $198(f($199));
                    };
                }())(t);
            };
            return go;
        };
    };
};
var $4b1974702efa26d7$export$879775626ee4d582 = function(dictRecursive) {
    var traverseR = $h6B4A.traverseR(dictRecursive);
    return function(dictCorecursive) {
        var traverseR1 = traverseR(dictCorecursive);
        return function(dictMonad) {
            var Bind1 = dictMonad.Bind1();
            var bindFlipped = $9Grh5.bindFlipped(Bind1);
            var traverseR2 = traverseR1(Bind1.Apply0().Functor0());
            var Applicative0 = dictMonad.Applicative0();
            return function(dictTraversable) {
                var traverse = $1wR1l.traverse(dictTraversable)(Applicative0);
                return function(f) {
                    var go = function(t) {
                        return bindFlipped(traverseR2(traverse(go)))(f(t));
                    };
                    return go;
                };
            };
        };
    };
};
var $4b1974702efa26d7$export$543c1d25fd8f4f84 = function(dictRecursive) {
    var mapR = $h6B4A.mapR(dictRecursive);
    return function(dictCorecursive) {
        var mapR1 = mapR(dictCorecursive);
        var map = $l0wDR.map(dictCorecursive.Functor0());
        return function(f) {
            var go = function(t) {
                return mapR1(map(go))(f(t));
            };
            return go;
        };
    };
};
var $4b1974702efa26d7$export$2017909a722469d4 = function(dictRecursive) {
    var traverseR = $h6B4A.traverseR(dictRecursive);
    return function(dictCorecursive) {
        var traverseR1 = traverseR(dictCorecursive);
        return function(dictMonad) {
            var Bind1 = dictMonad.Bind1();
            var traverseR2 = traverseR1(Bind1.Apply0().Functor0());
            var composeKleisliFlipped = $9Grh5.composeKleisliFlipped(Bind1);
            var Applicative0 = dictMonad.Applicative0();
            return function(dictTraversable) {
                var traverse = $1wR1l.traverse(dictTraversable)(Applicative0);
                return function(f) {
                    var go = function(t) {
                        return traverseR2(composeKleisliFlipped(traverse(go))(f))(t);
                    };
                    return go;
                };
            };
        };
    };
};
var $4b1974702efa26d7$export$fcba7023ffe024f = function(dictRecursive) {
    var mapR = $h6B4A.mapR(dictRecursive);
    return function(dictCorecursive) {
        var mapR1 = mapR(dictCorecursive);
        var map = $l0wDR.map(dictCorecursive.Functor0());
        return function(f) {
            var go = function(t) {
                return mapR1(function() {
                    var $200 = map(go);
                    return function($201) {
                        return $200(f($201));
                    };
                }())(t);
            };
            return go;
        };
    };
};
var $4b1974702efa26d7$export$4e5b0b7cb5e1ffa1 = function(dictRecursive) {
    var mapR = $h6B4A.mapR(dictRecursive);
    return function(dictRecursive1) {
        var transAna1 = $4b1974702efa26d7$export$fcba7023ffe024f(dictRecursive1);
        return function(dictCorecursive) {
            var mapR1 = mapR(dictCorecursive);
            var map = $l0wDR.map(dictCorecursive.Functor0());
            var transAna2 = transAna1(dictCorecursive);
            return function(f) {
                return function(g) {
                    var go = function(t) {
                        return mapR1(function() {
                            var $202 = map(function() {
                                var $204 = transAna2(f);
                                return function($205) {
                                    return $204(go($205));
                                };
                            }());
                            return function($203) {
                                return $202(g($203));
                            };
                        }())(t);
                    };
                    return go;
                };
            };
        };
    };
};
var $4b1974702efa26d7$export$52daec307fc0053f = function(dictCorecursive) {
    var embed = $aaxt2.embed(dictCorecursive);
    return function(dictMonad) {
        var Bind1 = dictMonad.Bind1();
        var map = $l0wDR.map(Bind1.Apply0().Functor0());
        var Applicative0 = dictMonad.Applicative0();
        var composeKleisliFlipped = $9Grh5.composeKleisliFlipped(Bind1);
        return function(dictMonad1) {
            var join = $9Grh5.join(dictMonad1.Bind1());
            var pure = $gUTA8.pure(dictMonad1.Applicative0());
            return function(dictTraversable) {
                var traverse = $1wR1l.traverse(dictTraversable)(Applicative0);
                return function(dictTraversable1) {
                    var traverse1 = $1wR1l.traverse(dictTraversable1)(Applicative0);
                    return function(k) {
                        return function(f) {
                            var go = function(a) {
                                return map(embed)(traverse(composeKleisliFlipped(go)(function() {
                                    var $206 = traverse1(f);
                                    return function($207) {
                                        return $206(join($207));
                                    };
                                }()))(k(a)));
                            };
                            return composeKleisliFlipped(go)(function() {
                                var $208 = map(pure);
                                return function($209) {
                                    return $208(f($209));
                                };
                            }());
                        };
                    };
                };
            };
        };
    };
};
var $4b1974702efa26d7$export$17889cbb1b90a398 = function(dictCorecursive) {
    var embed = $aaxt2.embed(dictCorecursive);
    var map = $l0wDR.map(dictCorecursive.Functor0());
    return function(dictMonad) {
        var Bind1 = dictMonad.Bind1();
        var map1 = $l0wDR.map(Bind1.Apply0().Functor0());
        var join = $9Grh5.join(Bind1);
        var pure = $gUTA8.pure(dictMonad.Applicative0());
        return function(k) {
            return function(f) {
                var go = function(a) {
                    return embed(map(function() {
                        var $210 = map1(f);
                        return function($211) {
                            return go($210(join($211)));
                        };
                    }())(k(a)));
                };
                return function($212) {
                    return go(pure(f($212)));
                };
            };
        };
    };
};
var $4b1974702efa26d7$export$b4af27762c2524c6 = function(dictCorecursive) {
    var embed = $aaxt2.embed(dictCorecursive);
    var resume = $hV7d0.resume(dictCorecursive.Functor0());
    return function(dictMonad) {
        var Bind1 = dictMonad.Bind1();
        var map = $l0wDR.map(Bind1.Apply0().Functor0());
        var Applicative0 = dictMonad.Applicative0();
        var bindFlipped = $9Grh5.bindFlipped(Bind1);
        return function(dictTraversable) {
            var traverse = $1wR1l.traverse(dictTraversable)(Applicative0);
            return function(f) {
                var loop = function(x) {
                    return $aKY4H.either(function() {
                        var $213 = map(embed);
                        var $214 = traverse(loop);
                        return function($215) {
                            return $213($214($215));
                        };
                    }())(go)(resume(x));
                };
                var go = function(a) {
                    return bindFlipped(function() {
                        var $216 = map(embed);
                        var $217 = traverse(loop);
                        return function($218) {
                            return $216($217($218));
                        };
                    }())(f(a));
                };
                return go;
            };
        };
    };
};
var $4b1974702efa26d7$export$f5ea4018c4959bca = function(dictCorecursive) {
    return $4b1974702efa26d7$export$17889cbb1b90a398(dictCorecursive)($hV7d0.freeMonad)($gwTNH.distFutu(dictCorecursive.Functor0()));
};
var $4b1974702efa26d7$export$161b4775969601ce = function(dictCorecursive) {
    var embed = $aaxt2.embed(dictCorecursive);
    var map = $l0wDR.map(dictCorecursive.Functor0());
    return function(f) {
        var go = function(a) {
            return $aKY4H.either($4b1974702efa26d7$var$identity)(function() {
                var $219 = map(go);
                return function($220) {
                    return embed($219($220));
                };
            }())(f(a));
        };
        return go;
    };
};
var $4b1974702efa26d7$export$edec7adbafd045e1 = function(dictCorecursive) {
    var embed = $aaxt2.embed(dictCorecursive);
    var map = $l0wDR.map(dictCorecursive.Functor0());
    return function(dictMonad) {
        var bindFlipped = $9Grh5.bindFlipped(dictMonad.Bind1());
        return function(k) {
            return function(f) {
                var go = function(a) {
                    return embed(map(function($221) {
                        return go(function(v) {
                            return bindFlipped(f)(v);
                        }($221));
                    })(k(a)));
                };
                return function($222) {
                    return go(f($222));
                };
            };
        };
    };
};
var $4b1974702efa26d7$export$4a1568673314a663 = function(dictCorecursive) {
    return $4b1974702efa26d7$export$edec7adbafd045e1(dictCorecursive)($hV7d0.freeMonad)($gwTNH.distFutu(dictCorecursive.Functor0()));
};
var $4b1974702efa26d7$export$64711a1df28021c9 = function(dictCorecursive) {
    var embed = $aaxt2.embed(dictCorecursive);
    return function(dictMonad) {
        var Bind1 = dictMonad.Bind1();
        var map = $l0wDR.map(Bind1.Apply0().Functor0());
        var bindFlipped = $9Grh5.bindFlipped(Bind1);
        var Applicative0 = dictMonad.Applicative0();
        var pure = $gUTA8.pure(Applicative0);
        return function(dictTraversable) {
            var traverse = $1wR1l.traverse(dictTraversable)(Applicative0);
            return function(f) {
                var go = function(a) {
                    return map(embed)(bindFlipped(traverse($aKY4H.either(pure)(go)))(f(a)));
                };
                return go;
            };
        };
    };
};
var $4b1974702efa26d7$export$49bb14c7754fadc7 = function(dictCorecursive) {
    var embed = $aaxt2.embed(dictCorecursive);
    var map = $l0wDR.map(dictCorecursive.Functor0());
    return function(f) {
        var go = function(a) {
            return embed(map($aKY4H.either($4b1974702efa26d7$var$identity)(go))(f(a)));
        };
        return go;
    };
};
var $4b1974702efa26d7$export$1fe039aff1cafe30 = function(dictCorecursive) {
    var embed = $aaxt2.embed(dictCorecursive);
    return function(dictMonad) {
        var Bind1 = dictMonad.Bind1();
        var bind = $9Grh5.bind(Bind1);
        var map = $l0wDR.map(Bind1.Apply0().Functor0());
        var Applicative0 = dictMonad.Applicative0();
        return function(dictTraversable) {
            var traverse = $1wR1l.traverse(dictTraversable)(Applicative0);
            return function(f) {
                var go = function(a) {
                    return bind(f(a))(function() {
                        var $223 = map(embed);
                        var $224 = traverse(go);
                        return function($225) {
                            return $223($224($225));
                        };
                    }());
                };
                return go;
            };
        };
    };
};
var $4b1974702efa26d7$export$5cd5b8dd55a7f6ae = function(dictCorecursive) {
    var embed = $aaxt2.embed(dictCorecursive);
    var map = $l0wDR.map(dictCorecursive.Functor0());
    return function(f) {
        var go = function(a) {
            return embed(map(go)(f(a)));
        };
        return go;
    };
};
var $4b1974702efa26d7$export$7780f7ce03067a92 = function(dictRecursive) {
    var project = $eo6zx.project(dictRecursive);
    return function(dictCorecursive) {
        return $4b1974702efa26d7$export$5cd5b8dd55a7f6ae(dictCorecursive)($l0wDR.map(dictCorecursive.Functor0())(project));
    };
};
var $4b1974702efa26d7$export$eb64909c1c87227a = function(dictCorecursive) {
    var ana1 = $4b1974702efa26d7$export$5cd5b8dd55a7f6ae(dictCorecursive);
    var embed = $aaxt2.embed(dictCorecursive);
    var map = $l0wDR.map(dictCorecursive.Functor0());
    return function(f) {
        return function(g) {
            var anaf = ana1(f);
            var go = function(a) {
                return embed(map($aKY4H.either(anaf)(go))(g(a)));
            };
            return go;
        };
    };
};
var $4b1974702efa26d7$export$9eb41824a8cea1cc = function(dictRecursive) {
    var project = $eo6zx.project(dictRecursive);
    return function(dictCorecursive) {
        var embed = $aaxt2.embed(dictCorecursive);
        var map = $l0wDR.map(dictCorecursive.Functor0());
        var ana1 = $4b1974702efa26d7$export$5cd5b8dd55a7f6ae(dictCorecursive);
        return function(dictMonad) {
            var Bind1 = dictMonad.Bind1();
            var join = $9Grh5.join(Bind1);
            var map1 = $l0wDR.map(Bind1.Apply0().Functor0());
            var pure = $gUTA8.pure(dictMonad.Applicative0());
            return function(f) {
                return function(g) {
                    return function(h) {
                        var go = function(na) {
                            return embed(map(function() {
                                var $226 = ana1(function($228) {
                                    return g(project($228));
                                });
                                return function($227) {
                                    return $226(go(join($227)));
                                };
                            }())(f(map1(h)(na))));
                        };
                        return function($229) {
                            return go(pure($229));
                        };
                    };
                };
            };
        };
    };
};
var $4b1974702efa26d7$export$b7ccc71c02c138db = function(dictRecursive) {
    var gpostpro1 = $4b1974702efa26d7$export$9eb41824a8cea1cc(dictRecursive);
    return function(dictCorecursive) {
        var gpostpro2 = gpostpro1(dictCorecursive)($6VVZC.monadIdentity);
        var Functor0 = dictCorecursive.Functor0();
        var distAna = $gwTNH.distAna(Functor0);
        var map = $l0wDR.map(Functor0);
        return function(f) {
            return function(g) {
                return gpostpro2(distAna)(f)(function() {
                    var $230 = map($6VVZC.Identity);
                    return function($231) {
                        return $230(g($231));
                    };
                }());
            };
        };
    };
};

});

parcelRegister("27rSX", function(module, exports) {

$parcel$export(module.exports, "token", () => $18b1ddaa538e7cc7$export$9e1725a4cfeada27);
// Generated by purs version 0.15.16

var $a7Dxq = parcelRequire("a7Dxq");

var $kK1nx = parcelRequire("kK1nx");

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $9Grh5 = parcelRequire("9Grh5");

var $7T8P4 = parcelRequire("7T8P4");

var $dTFzl = parcelRequire("dTFzl");

var $4VF0K = parcelRequire("4VF0K");

var $6UHO6 = parcelRequire("6UHO6");

var $6VC7y = parcelRequire("6VC7y");

var $eWReo = parcelRequire("eWReo");

var $aKY4H = parcelRequire("aKY4H");

var $4MBcA = parcelRequire("4MBcA");

var $6RkEA = parcelRequire("6RkEA");

var $l0wDR = parcelRequire("l0wDR");
parcelRequire("c8kPS");
var $6pI6x = parcelRequire("6pI6x");

var $5gmr2 = parcelRequire("5gmr2");

var $amUgg = parcelRequire("amUgg");

var $ykHdR = parcelRequire("ykHdR");
parcelRequire("rzgQX");
var $deaB6 = parcelRequire("deaB6");

var $d0PPW = parcelRequire("d0PPW");

var $6SDUu = parcelRequire("6SDUu");

var $hTcAb = parcelRequire("hTcAb");

var $iwqgS = parcelRequire("iwqgS");

var $3Orkn = parcelRequire("3Orkn");

var $5oIYL = parcelRequire("5oIYL");
parcelRequire("2gT7Y");
var $MTXA4 = parcelRequire("MTXA4");
var $2gT7Y = parcelRequire("2gT7Y");

var $2Zpo4 = parcelRequire("2Zpo4");
var $7OyoZ = parcelRequire("7OyoZ");

var $TrGmk = parcelRequire("TrGmk");

var $9MxTl = parcelRequire("9MxTl");

var $hsyEi = parcelRequire("hsyEi");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");

var $3J9zV = parcelRequire("3J9zV");

var $1woEV = parcelRequire("1woEV");

var $hmOcH = parcelRequire("hmOcH");

var $4kSuu = parcelRequire("4kSuu");
var $18b1ddaa538e7cc7$var$bind = /* #__PURE__ */ $9Grh5.bind($3J9zV.bindParserT);
var $18b1ddaa538e7cc7$var$discard = /* #__PURE__ */ $9Grh5.discard($9Grh5.discardUnit)($3J9zV.bindParserT);
var $18b1ddaa538e7cc7$var$pure = /* #__PURE__ */ $gUTA8.pure($3J9zV.applicativeParserT);
var $18b1ddaa538e7cc7$var$guard = /* #__PURE__ */ $kK1nx.guard($3J9zV.alternativeParserT);
var $18b1ddaa538e7cc7$var$sort = /* #__PURE__ */ $4VF0K.sort($d0PPW.ordString);
var $18b1ddaa538e7cc7$var$map = /* #__PURE__ */ $l0wDR.map($l0wDR.functorArray);
var $18b1ddaa538e7cc7$var$applySecond = /* #__PURE__ */ $a5g3C.applySecond($3J9zV.applyParserT);
var $18b1ddaa538e7cc7$var$compare = /* #__PURE__ */ $d0PPW.compare($d0PPW.ordString);
var $18b1ddaa538e7cc7$var$append = /* #__PURE__ */ $iwqgS.append($iwqgS.semigroupArray);
var $18b1ddaa538e7cc7$var$fix = /* #__PURE__ */ $dTFzl.fix($3J9zV.lazyParserT);
var $18b1ddaa538e7cc7$var$alt = /* #__PURE__ */ $a7Dxq.alt($3J9zV.altParserT);
var $18b1ddaa538e7cc7$var$$$void = /* #__PURE__ */ $l0wDR.void($3J9zV.functorParserT);
var $18b1ddaa538e7cc7$var$voidLeft = /* #__PURE__ */ $l0wDR.voidLeft($3J9zV.functorParserT);
var $18b1ddaa538e7cc7$var$identity = /* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn);
var $18b1ddaa538e7cc7$var$many = /* #__PURE__ */ $4VF0K.many($3J9zV.alternativeParserT)($3J9zV.lazyParserT);
var $18b1ddaa538e7cc7$var$map1 = /* #__PURE__ */ $l0wDR.map($ykHdR.functorMaybe);
var $18b1ddaa538e7cc7$var$some = /* #__PURE__ */ $4VF0K.some($3J9zV.alternativeParserT)($3J9zV.lazyParserT);
var $18b1ddaa538e7cc7$var$foldl = /* #__PURE__ */ $6RkEA.foldl($6RkEA.foldableArray);
var $18b1ddaa538e7cc7$var$applyFirst = /* #__PURE__ */ $a5g3C.applyFirst($3J9zV.applyParserT);
var $18b1ddaa538e7cc7$var$show = /* #__PURE__ */ $3Orkn.show($3Orkn.showString);
var $18b1ddaa538e7cc7$var$bind1 = /* #__PURE__ */ $9Grh5.bind($ykHdR.bindMaybe);
var $18b1ddaa538e7cc7$var$pure1 = /* #__PURE__ */ $gUTA8.pure($ykHdR.applicativeMaybe);
var $18b1ddaa538e7cc7$var$foldr = /* #__PURE__ */ $6RkEA.foldr($6RkEA.foldableArray);
var $18b1ddaa538e7cc7$var$map2 = /* #__PURE__ */ $l0wDR.map($3J9zV.functorParserT);
var $18b1ddaa538e7cc7$var$choice = /* #__PURE__ */ $1woEV.choice($6RkEA.foldableArray);
var $18b1ddaa538e7cc7$var$many1 = /* #__PURE__ */ $5gmr2.many($3J9zV.alternativeParserT)($3J9zV.lazyParserT);
var $18b1ddaa538e7cc7$var$toUnfoldable = /* #__PURE__ */ $5gmr2.toUnfoldable($hsyEi.unfoldableArray);
var $18b1ddaa538e7cc7$var$foldr1 = /* #__PURE__ */ $6RkEA.foldr($amUgg.foldableList);
var $18b1ddaa538e7cc7$export$499906e44ae7845b = function(x) {
    return x;
};
var $18b1ddaa538e7cc7$export$b90040b5f8a4c121 = function(v) {
    return v;
};
var $18b1ddaa538e7cc7$export$9e1725a4cfeada27 = function(tokpos) {
    return $18b1ddaa538e7cc7$var$bind($3J9zV.getParserT)(function(v) {
        var v1 = $5gmr2.uncons(v.value0);
        if (v1 instanceof $ykHdR.Nothing) return $3J9zV.fail("Unexpected EOF");
        if (v1 instanceof $ykHdR.Just) return $18b1ddaa538e7cc7$var$discard($3J9zV.stateParserT(function(v2) {
            return new $9MxTl.Tuple($r2HHk.unit, new $3J9zV.ParseState(v1.value0.tail, tokpos(v1.value0.head), true));
        }))(function() {
            return $18b1ddaa538e7cc7$var$pure(v1.value0.head);
        });
        throw new Error("Failed pattern match at Parsing.Token (line 55, column 3 - line 59, column 16): " + [
            v1.constructor.name
        ]);
    });
};
var $18b1ddaa538e7cc7$export$a55877ca9db47377 = function(tokpos) {
    return function(f) {
        return $1woEV.tryRethrow($18b1ddaa538e7cc7$var$bind($18b1ddaa538e7cc7$export$9e1725a4cfeada27(tokpos))(function(a) {
            return $18b1ddaa538e7cc7$var$discard($18b1ddaa538e7cc7$var$guard(f(a)))(function() {
                return $18b1ddaa538e7cc7$var$pure(a);
            });
        }));
    };
};
var $18b1ddaa538e7cc7$var$theReservedNames = function(v) {
    if (v.caseSensitive) return $18b1ddaa538e7cc7$var$sort(v.reservedNames);
    if ($6UHO6.otherwise) return $18b1ddaa538e7cc7$var$sort($18b1ddaa538e7cc7$var$map($7OyoZ.toLower)(v.reservedNames));
    throw new Error("Failed pattern match at Parsing.Token (line 828, column 1 - line 828, column 70): " + [
        v.constructor.name
    ]);
};
var $18b1ddaa538e7cc7$var$simpleSpace = /* #__PURE__ */ $1woEV.skipMany1(/* #__PURE__ */ $hmOcH.satisfyCodePoint($eWReo.isSpace));
var $18b1ddaa538e7cc7$var$oneLineComment = function(v) {
    return $18b1ddaa538e7cc7$var$applySecond($1woEV.try($hmOcH.string(v.commentLine)))($1woEV.skipMany($hmOcH.satisfy(function(v1) {
        return v1 !== "\x0a";
    })));
};
var $18b1ddaa538e7cc7$export$4659b591c19bdf3d = function(dictEq) {
    var eq = $4MBcA.eq(dictEq);
    return function(tokpos) {
        return function(tok) {
            return $18b1ddaa538e7cc7$export$a55877ca9db47377(tokpos)(function(v) {
                return eq(v)(tok);
            });
        };
    };
};
var $18b1ddaa538e7cc7$var$isReserved = function($copy_names) {
    return function($copy_name) {
        var $tco_var_names = $copy_names;
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(names, name) {
            var v = $4VF0K.uncons(names);
            if (v instanceof $ykHdR.Nothing) {
                $tco_done = true;
                return false;
            }
            if (v instanceof $ykHdR.Just) {
                var v1 = $18b1ddaa538e7cc7$var$compare(v.value0.head)(name);
                if (v1 instanceof $6SDUu.LT) {
                    $tco_var_names = v.value0.tail;
                    $copy_name = name;
                    return;
                }
                if (v1 instanceof $6SDUu.EQ) {
                    $tco_done = true;
                    return true;
                }
                if (v1 instanceof $6SDUu.GT) {
                    $tco_done = true;
                    return false;
                }
                throw new Error("Failed pattern match at Parsing.Token (line 823, column 35 - line 826, column 18): " + [
                    v1.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Parsing.Token (line 821, column 3 - line 826, column 18): " + [
                v.constructor.name
            ]);
        }
        while(!$tco_done)$tco_result = $tco_loop($tco_var_names, $copy_name);
        return $tco_result;
    };
};
var $18b1ddaa538e7cc7$var$isReservedName = function(v) {
    return function(name) {
        var caseName = function() {
            if (v.caseSensitive) return name;
            if ($6UHO6.otherwise) return $7OyoZ.toLower(name);
            throw new Error("Failed pattern match at Parsing.Token (line 815, column 3 - line 817, column 31): ");
        }();
        return $18b1ddaa538e7cc7$var$isReserved($18b1ddaa538e7cc7$var$theReservedNames(v))(caseName);
    };
};
var $18b1ddaa538e7cc7$var$inCommentSingle = function(v) {
    var startEnd = $18b1ddaa538e7cc7$var$append($MTXA4.toCharArray(v.commentEnd))($MTXA4.toCharArray(v.commentStart));
    return $18b1ddaa538e7cc7$var$fix(function(p) {
        return $18b1ddaa538e7cc7$var$alt($18b1ddaa538e7cc7$var$$$void($1woEV.try($hmOcH.string(v.commentEnd))))($18b1ddaa538e7cc7$var$alt($18b1ddaa538e7cc7$var$applySecond($1woEV.skipMany1($4kSuu.noneOf(startEnd)))(p))($1woEV.withErrorMessage($18b1ddaa538e7cc7$var$applySecond($4kSuu.oneOf(startEnd))(p))("end of comment")));
    });
};
var $18b1ddaa538e7cc7$var$multiLineComment = function(v) {
    return $18b1ddaa538e7cc7$var$applySecond($1woEV.try($hmOcH.string(v.commentStart)))($18b1ddaa538e7cc7$var$inComment(v));
};
var $18b1ddaa538e7cc7$var$inCommentMulti = function(v) {
    var startEnd = $18b1ddaa538e7cc7$var$append($MTXA4.toCharArray(v.commentEnd))($MTXA4.toCharArray(v.commentStart));
    return $18b1ddaa538e7cc7$var$fix(function(p) {
        return $18b1ddaa538e7cc7$var$alt($18b1ddaa538e7cc7$var$$$void($1woEV.try($hmOcH.string(v.commentEnd))))($18b1ddaa538e7cc7$var$alt($18b1ddaa538e7cc7$var$applySecond($18b1ddaa538e7cc7$var$multiLineComment(v))(p))($18b1ddaa538e7cc7$var$alt($18b1ddaa538e7cc7$var$applySecond($1woEV.skipMany1($4kSuu.noneOf(startEnd)))(p))($1woEV.withErrorMessage($18b1ddaa538e7cc7$var$applySecond($4kSuu.oneOf(startEnd))(p))("end of comment"))));
    });
};
var $18b1ddaa538e7cc7$var$inComment = function(v) {
    if (v.nestedComments) return $18b1ddaa538e7cc7$var$inCommentMulti(v);
    return $18b1ddaa538e7cc7$var$inCommentSingle(v);
};
var $18b1ddaa538e7cc7$var$whiteSpace$prime = function(v) {
    if ($2Zpo4.null(v.commentLine) && $2Zpo4.null(v.commentStart)) return $1woEV.skipMany($1woEV.withErrorMessage($18b1ddaa538e7cc7$var$simpleSpace)(""));
    if ($2Zpo4.null(v.commentLine)) return $1woEV.skipMany($18b1ddaa538e7cc7$var$alt($18b1ddaa538e7cc7$var$simpleSpace)($1woEV.withErrorMessage($18b1ddaa538e7cc7$var$multiLineComment(v))("")));
    if ($2Zpo4.null(v.commentStart)) return $1woEV.skipMany($18b1ddaa538e7cc7$var$alt($18b1ddaa538e7cc7$var$simpleSpace)($1woEV.withErrorMessage($18b1ddaa538e7cc7$var$oneLineComment(v))("")));
    if ($6UHO6.otherwise) return $1woEV.skipMany($18b1ddaa538e7cc7$var$alt($18b1ddaa538e7cc7$var$simpleSpace)($18b1ddaa538e7cc7$var$alt($18b1ddaa538e7cc7$var$oneLineComment(v))($1woEV.withErrorMessage($18b1ddaa538e7cc7$var$multiLineComment(v))(""))));
    throw new Error("Failed pattern match at Parsing.Token (line 837, column 1 - line 837, column 74): " + [
        v.constructor.name
    ]);
};
var $18b1ddaa538e7cc7$export$91a4aa374f937230 = function(v) {
    var stringLetter = $hmOcH.satisfy(function(c) {
        return c !== "\"" && c !== "\\" && c > "\x1a";
    });
    var sign = function(dictRing) {
        return $18b1ddaa538e7cc7$var$alt($18b1ddaa538e7cc7$var$voidLeft($hmOcH.char("-"))($hTcAb.negate(dictRing)))($18b1ddaa538e7cc7$var$alt($18b1ddaa538e7cc7$var$voidLeft($hmOcH.char("+"))($18b1ddaa538e7cc7$var$identity))($18b1ddaa538e7cc7$var$pure($18b1ddaa538e7cc7$var$identity)));
    };
    var sign1 = sign($hTcAb.ringInt);
    var oper = function() {
        var go = $18b1ddaa538e7cc7$var$bind(v.opStart)(function(c) {
            return $18b1ddaa538e7cc7$var$bind($18b1ddaa538e7cc7$var$many(v.opLetter))(function(cs) {
                return $18b1ddaa538e7cc7$var$pure($MTXA4.singleton(c) + $MTXA4.fromCharArray(cs));
            });
        });
        return $1woEV.withErrorMessage(go)("operator");
    }();
    var number = function(base) {
        return function(baseDigit) {
            var folder = function(v1) {
                return function(v2) {
                    if (v1 instanceof $ykHdR.Nothing) return $ykHdR.Nothing.value;
                    if (v1 instanceof $ykHdR.Just) return $18b1ddaa538e7cc7$var$map1(function(v3) {
                        return (base * v1.value0 | 0) + v3 | 0;
                    })($eWReo.hexDigitToInt($5oIYL.codePointFromChar(v2)));
                    throw new Error("Failed pattern match at Parsing.Token (line 707, column 5 - line 707, column 45): " + [
                        v1.constructor.name,
                        v2.constructor.name
                    ]);
                };
            };
            return $18b1ddaa538e7cc7$var$bind($18b1ddaa538e7cc7$var$some(baseDigit))(function(digits) {
                return $ykHdR.maybe($3J9zV.fail("not digits"))($18b1ddaa538e7cc7$var$pure)($18b1ddaa538e7cc7$var$foldl(folder)(new $ykHdR.Just(0))(digits));
            });
        };
    };
    var octal = $18b1ddaa538e7cc7$var$applySecond($4kSuu.oneOf([
        "o",
        "O"
    ]))(number(8)($4kSuu.octDigit));
    var lexeme = function(p) {
        return $18b1ddaa538e7cc7$var$applyFirst(p)($18b1ddaa538e7cc7$var$whiteSpace$prime(v));
    };
    var reservedOp = function(name) {
        var go = $18b1ddaa538e7cc7$var$bind($hmOcH.string(name))(function() {
            return $1woEV.withErrorMessage($1woEV.notFollowedBy(v.opLetter))("end of " + name);
        });
        return lexeme($1woEV.try(go));
    };
    var symbol = function(name) {
        return $18b1ddaa538e7cc7$var$voidLeft(lexeme($hmOcH.string(name)))(name);
    };
    var parens = function(p) {
        return $1woEV.between(symbol("("))(symbol(")"))(p);
    };
    var semi = symbol(";");
    var semiSep = function(p) {
        return $1woEV.sepBy(p)(semi);
    };
    var semiSep1 = function(p) {
        return $1woEV.sepBy1(p)(semi);
    };
    var isReservedOp = function(name) {
        return $18b1ddaa538e7cc7$var$isReserved($18b1ddaa538e7cc7$var$sort(v.reservedOpNames))(name);
    };
    var operator = function() {
        var go = $18b1ddaa538e7cc7$var$bind(oper)(function(name) {
            var $115 = isReservedOp(name);
            if ($115) return $3J9zV.fail("reserved operator " + name);
            return $18b1ddaa538e7cc7$var$pure(name);
        });
        return lexeme($1woEV.try(go));
    }();
    var ident = function() {
        var go = $18b1ddaa538e7cc7$var$bind(v.identStart)(function(c) {
            return $18b1ddaa538e7cc7$var$bind($18b1ddaa538e7cc7$var$many(v.identLetter))(function(cs) {
                return $18b1ddaa538e7cc7$var$pure($MTXA4.singleton(c) + $MTXA4.fromCharArray(cs));
            });
        });
        return $1woEV.withErrorMessage(go)("identifier");
    }();
    var identifier = function() {
        var go = $18b1ddaa538e7cc7$var$bind(ident)(function(name) {
            var $116 = $18b1ddaa538e7cc7$var$isReservedName(v)(name);
            if ($116) return $3J9zV.fail("reserved word " + $18b1ddaa538e7cc7$var$show(name));
            return $18b1ddaa538e7cc7$var$pure(name);
        });
        return lexeme($1woEV.try(go));
    }();
    var hexadecimal = $18b1ddaa538e7cc7$var$applySecond($4kSuu.oneOf([
        "x",
        "X"
    ]))(number(16)($4kSuu.hexDigit));
    var fraction = function() {
        var op = function(v1) {
            return function(v2) {
                if (v2 instanceof $ykHdR.Nothing) return $ykHdR.Nothing.value;
                if (v2 instanceof $ykHdR.Just) return $18b1ddaa538e7cc7$var$bind1($eWReo.hexDigitToInt($5oIYL.codePointFromChar(v1)))(function(int$prime) {
                    return $18b1ddaa538e7cc7$var$pure1((v2.value0 + $6pI6x.toNumber(int$prime)) / 10.0);
                });
                throw new Error("Failed pattern match at Parsing.Token (line 654, column 5 - line 654, column 47): " + [
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
        return $1woEV.asErrorMessage("fraction")($18b1ddaa538e7cc7$var$bind($hmOcH.char("."))(function() {
            return $18b1ddaa538e7cc7$var$bind($1woEV.withErrorMessage($18b1ddaa538e7cc7$var$some($4kSuu.digit))("fraction"))(function(digits) {
                return $ykHdR.maybe($3J9zV.fail("not digit"))($18b1ddaa538e7cc7$var$pure)($18b1ddaa538e7cc7$var$foldr(op)(new $ykHdR.Just(0.0))(digits));
            });
        }));
    }();
    var escapeGap = $1woEV.withErrorMessage($18b1ddaa538e7cc7$var$applySecond($18b1ddaa538e7cc7$var$some($4kSuu.space))($hmOcH.char("\\")))("end of string gap");
    var escapeEmpty = $hmOcH.char("&");
    var escMap = $4VF0K.zip([
        "a",
        "b",
        "f",
        "n",
        "r",
        "t",
        "v",
        "\\",
        "\"",
        "'"
    ])([
        "\x07",
        "\x08",
        "\x0c",
        "\x0a",
        "\x0d",
        "\x09",
        "\x0b",
        "\\",
        "\"",
        "'"
    ]);
    var dot = symbol(".");
    var decimal = number(10)($4kSuu.digit);
    var exponent$prime = function() {
        var power = function(e) {
            if (e < 0) return 1.0 / power(-e | 0);
            if ($6UHO6.otherwise) return $deaB6.pow(10.0)($6pI6x.toNumber(e));
            throw new Error("Failed pattern match at Parsing.Token (line 667, column 5 - line 667, column 27): " + [
                e.constructor.name
            ]);
        };
        return $1woEV.asErrorMessage("exponent")($18b1ddaa538e7cc7$var$bind($4kSuu.oneOf([
            "e",
            "E"
        ]))(function() {
            return $18b1ddaa538e7cc7$var$bind(sign1)(function(f) {
                return $18b1ddaa538e7cc7$var$bind($1woEV.withErrorMessage(decimal)("exponent"))(function(e) {
                    return $18b1ddaa538e7cc7$var$pure(power(f(e)));
                });
            });
        }));
    }();
    var fractExponent = function(n) {
        var justExponent = $18b1ddaa538e7cc7$var$bind(exponent$prime)(function(expo) {
            return $18b1ddaa538e7cc7$var$pure($6pI6x.toNumber(n) * expo);
        });
        var fractExponent$prime = $18b1ddaa538e7cc7$var$bind(fraction)(function(fract) {
            return $18b1ddaa538e7cc7$var$bind($1woEV.option(1.0)(exponent$prime))(function(expo) {
                return $18b1ddaa538e7cc7$var$pure(($6pI6x.toNumber(n) + fract) * expo);
            });
        });
        return $18b1ddaa538e7cc7$var$alt(fractExponent$prime)(justExponent);
    };
    var fractFloat = function(n) {
        return $18b1ddaa538e7cc7$var$map2($aKY4H.Right.create)(fractExponent(n));
    };
    var decimalFloat = $18b1ddaa538e7cc7$var$bind(decimal)(function(n) {
        return $1woEV.option(new $aKY4H.Left(n))(fractFloat(n));
    });
    var zeroNumFloat = $18b1ddaa538e7cc7$var$alt($18b1ddaa538e7cc7$var$map2($aKY4H.Left.create)($18b1ddaa538e7cc7$var$alt(hexadecimal)(octal)))($18b1ddaa538e7cc7$var$alt(decimalFloat)($18b1ddaa538e7cc7$var$alt(fractFloat(0))($18b1ddaa538e7cc7$var$pure(new $aKY4H.Left(0)))));
    var natFloat = $18b1ddaa538e7cc7$var$alt($18b1ddaa538e7cc7$var$applySecond($hmOcH.char("0"))(zeroNumFloat))(decimalFloat);
    var naturalOrFloat = $1woEV.withErrorMessage(lexeme(natFloat))("number");
    var floating = $18b1ddaa538e7cc7$var$bind($18b1ddaa538e7cc7$var$map2($ykHdR.fromMaybe($18b1ddaa538e7cc7$var$identity))($1woEV.optionMaybe(sign($hTcAb.ringNumber))))(function(f) {
        return $18b1ddaa538e7cc7$var$bind($18b1ddaa538e7cc7$var$bind(decimal)(fractExponent))(function(x) {
            return $18b1ddaa538e7cc7$var$pure(f(x));
        });
    });
    var $$float = $1woEV.withErrorMessage(lexeme(floating))("float");
    var zeroNumber = $1woEV.withErrorMessage($18b1ddaa538e7cc7$var$applySecond($hmOcH.char("0"))($18b1ddaa538e7cc7$var$alt(hexadecimal)($18b1ddaa538e7cc7$var$alt(octal)($18b1ddaa538e7cc7$var$alt(decimal)($18b1ddaa538e7cc7$var$pure(0))))))("");
    var nat = $18b1ddaa538e7cc7$var$alt(zeroNumber)(decimal);
    var $$int = $18b1ddaa538e7cc7$var$bind(lexeme(sign1))(function(f) {
        return $18b1ddaa538e7cc7$var$bind(nat)(function(n) {
            return $18b1ddaa538e7cc7$var$pure(f(n));
        });
    });
    var integer = $1woEV.withErrorMessage(lexeme($$int))("integer");
    var natural = $1woEV.withErrorMessage(lexeme(nat))("natural");
    var comma = symbol(",");
    var commaSep = function(p) {
        return $1woEV.sepBy(p)(comma);
    };
    var commaSep1 = function(p) {
        return $1woEV.sepBy1(p)(comma);
    };
    var colon = symbol(":");
    var charNum = $18b1ddaa538e7cc7$var$bind($18b1ddaa538e7cc7$var$alt(decimal)($18b1ddaa538e7cc7$var$alt($18b1ddaa538e7cc7$var$applySecond($hmOcH.char("o"))(number(8)($4kSuu.octDigit)))($18b1ddaa538e7cc7$var$applySecond($hmOcH.char("x"))(number(16)($4kSuu.hexDigit)))))(function(code) {
        var $121 = code > 1114111;
        if ($121) return $3J9zV.fail("invalid escape sequence");
        var v1 = $6VC7y.fromCharCode(code);
        if (v1 instanceof $ykHdR.Just) return $18b1ddaa538e7cc7$var$pure(v1.value0);
        if (v1 instanceof $ykHdR.Nothing) return $3J9zV.fail("invalid character code (should not happen)");
        throw new Error("Failed pattern match at Parsing.Token (line 498, column 10 - line 500, column 67): " + [
            v1.constructor.name
        ]);
    });
    var charLetter = $hmOcH.satisfy(function(c) {
        return c !== "'" && c !== "\\" && c > "\x1a";
    });
    var charEsc = function() {
        var parseEsc = function(v1) {
            return $18b1ddaa538e7cc7$var$voidLeft($hmOcH.char(v1.value0))(v1.value1);
        };
        return $18b1ddaa538e7cc7$var$choice($18b1ddaa538e7cc7$var$map(parseEsc)(escMap));
    }();
    var charControl = $18b1ddaa538e7cc7$var$bind($hmOcH.char("^"))(function() {
        return $18b1ddaa538e7cc7$var$bind($4kSuu.upper)(function(code) {
            var v1 = $6VC7y.fromCharCode(($6VC7y.toCharCode(code) - $6VC7y.toCharCode("A") | 0) + 1 | 0);
            if (v1 instanceof $ykHdR.Just) return $18b1ddaa538e7cc7$var$pure(v1.value0);
            if (v1 instanceof $ykHdR.Nothing) return $3J9zV.fail("invalid character code (should not happen)");
            throw new Error("Failed pattern match at Parsing.Token (line 488, column 5 - line 490, column 67): " + [
                v1.constructor.name
            ]);
        });
    });
    var caseString = function(name) {
        if (v.caseSensitive) return $18b1ddaa538e7cc7$var$voidLeft($hmOcH.string(name))(name);
        if ($6UHO6.otherwise) {
            var msg = $18b1ddaa538e7cc7$var$show(name);
            var caseChar = function(c) {
                var v1 = function(v2) {
                    if ($6UHO6.otherwise) return $hmOcH.char(c);
                    throw new Error("Failed pattern match at Parsing.Token (line 355, column 1 - line 355, column 80): " + [
                        c.constructor.name
                    ]);
                };
                var $132 = $eWReo.isAlpha($5oIYL.codePointFromChar(c));
                if ($132) {
                    var $133 = $2gT7Y.toChar($TrGmk.toLowerSimple($MTXA4.singleton(c)));
                    if ($133 instanceof $ykHdR.Just) {
                        var $134 = $2gT7Y.toChar($TrGmk.toUpperSimple($MTXA4.singleton(c)));
                        if ($134 instanceof $ykHdR.Just) return $18b1ddaa538e7cc7$var$alt($hmOcH.char($133.value0))($hmOcH.char($134.value0));
                        return v1(true);
                    }
                    return v1(true);
                }
                return v1(true);
            };
            var walk = function(name$prime) {
                var v1 = $2gT7Y.uncons(name$prime);
                if (v1 instanceof $ykHdR.Nothing) return $18b1ddaa538e7cc7$var$pure($r2HHk.unit);
                if (v1 instanceof $ykHdR.Just) return $18b1ddaa538e7cc7$var$applySecond($1woEV.withErrorMessage(caseChar(v1.value0.head))(msg))(walk(v1.value0.tail));
                throw new Error("Failed pattern match at Parsing.Token (line 760, column 22 - line 762, column 72): " + [
                    v1.constructor.name
                ]);
            };
            return $18b1ddaa538e7cc7$var$voidLeft(walk(name))(name);
        }
        throw new Error("Failed pattern match at Parsing.Token (line 754, column 3 - line 754, column 50): " + [
            name.constructor.name
        ]);
    };
    var reserved = function(name) {
        var go = $18b1ddaa538e7cc7$var$applySecond(caseString(name))($1woEV.withErrorMessage($1woEV.notFollowedBy(v.identLetter))("end of " + name));
        return lexeme($1woEV.try(go));
    };
    var brackets = function(p) {
        return $1woEV.between(symbol("["))(symbol("]"))(p);
    };
    var braces = function(p) {
        return $1woEV.between(symbol("{"))(symbol("}"))(p);
    };
    var ascii3codes = [
        "NUL",
        "SOH",
        "STX",
        "ETX",
        "EOT",
        "ENQ",
        "ACK",
        "BEL",
        "DLE",
        "DC1",
        "DC2",
        "DC3",
        "DC4",
        "NAK",
        "SYN",
        "ETB",
        "CAN",
        "SUB",
        "ESC",
        "DEL"
    ];
    var ascii3 = [
        "\x00",
        "\x01",
        "\x02",
        "\x03",
        "\x04",
        "\x05",
        "\x06",
        "\x07",
        "\x10",
        "\x11",
        "\x12",
        "\x13",
        "\x14",
        "\x15",
        "\x16",
        "\x17",
        "\x18",
        "\x1a",
        "\x1b",
        "\x7f"
    ];
    var ascii2codes = [
        "BS",
        "HT",
        "LF",
        "VT",
        "FF",
        "CR",
        "SO",
        "SI",
        "EM",
        "FS",
        "GS",
        "RS",
        "US",
        "SP"
    ];
    var ascii2 = [
        "\x08",
        "\x09",
        "\x0a",
        "\x0b",
        "\x0c",
        "\x0d",
        "\x0e",
        "\x0f",
        "\x19",
        "\x1c",
        "\x1d",
        "\x1e",
        "\x1f",
        " "
    ];
    var asciiMap = $4VF0K.zip($18b1ddaa538e7cc7$var$append(ascii3codes)(ascii2codes))($18b1ddaa538e7cc7$var$append(ascii3)(ascii2));
    var charAscii = function() {
        var parseAscii = function(v1) {
            return $1woEV.try($18b1ddaa538e7cc7$var$voidLeft($hmOcH.string(v1.value0))(v1.value1));
        };
        return $18b1ddaa538e7cc7$var$choice($18b1ddaa538e7cc7$var$map(parseAscii)(asciiMap));
    }();
    var escapeCode = $18b1ddaa538e7cc7$var$alt(charEsc)($18b1ddaa538e7cc7$var$alt(charNum)($18b1ddaa538e7cc7$var$alt(charAscii)($1woEV.withErrorMessage(charControl)("escape code"))));
    var charEscape = $18b1ddaa538e7cc7$var$applySecond($hmOcH.char("\\"))(escapeCode);
    var characterChar = $18b1ddaa538e7cc7$var$alt(charLetter)($1woEV.withErrorMessage(charEscape)("literal character"));
    var charLiteral = function() {
        var go = $1woEV.between($hmOcH.char("'"))($1woEV.withErrorMessage($hmOcH.char("'"))("end of character"))(characterChar);
        return $1woEV.withErrorMessage(lexeme(go))("character");
    }();
    var stringEscape = $18b1ddaa538e7cc7$var$bind($hmOcH.char("\\"))(function() {
        return $18b1ddaa538e7cc7$var$alt($18b1ddaa538e7cc7$var$voidLeft(escapeGap)($ykHdR.Nothing.value))($18b1ddaa538e7cc7$var$alt($18b1ddaa538e7cc7$var$voidLeft(escapeEmpty)($ykHdR.Nothing.value))($18b1ddaa538e7cc7$var$map2($ykHdR.Just.create)(escapeCode)));
    });
    var stringChar = $18b1ddaa538e7cc7$var$alt($18b1ddaa538e7cc7$var$map2($ykHdR.Just.create)(stringLetter))($1woEV.withErrorMessage(stringEscape)("string character"));
    var stringLiteral = function() {
        var folder = function(v1) {
            return function(v2) {
                if (v1 instanceof $ykHdR.Nothing) return v2;
                if (v1 instanceof $ykHdR.Just) return new $amUgg.Cons(v1.value0, v2);
                throw new Error("Failed pattern match at Parsing.Token (line 455, column 5 - line 455, column 51): " + [
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
        var go = $18b1ddaa538e7cc7$var$bind($1woEV.between($hmOcH.char("\""))($1woEV.withErrorMessage($hmOcH.char("\""))("end of string"))($18b1ddaa538e7cc7$var$many1(stringChar)))(function(maybeChars) {
            return $18b1ddaa538e7cc7$var$pure($MTXA4.fromCharArray($18b1ddaa538e7cc7$var$toUnfoldable($18b1ddaa538e7cc7$var$foldr1(folder)($amUgg.Nil.value)(maybeChars))));
        });
        return lexeme($1woEV.withErrorMessage(go)("literal string"));
    }();
    var angles = function(p) {
        return $1woEV.between(symbol("<"))(symbol(">"))(p);
    };
    return {
        identifier: identifier,
        reserved: reserved,
        operator: operator,
        reservedOp: reservedOp,
        charLiteral: charLiteral,
        stringLiteral: stringLiteral,
        natural: natural,
        integer: integer,
        "float": $$float,
        naturalOrFloat: naturalOrFloat,
        decimal: decimal,
        hexadecimal: hexadecimal,
        octal: octal,
        symbol: symbol,
        lexeme: lexeme,
        whiteSpace: $18b1ddaa538e7cc7$var$whiteSpace$prime(v),
        parens: parens,
        braces: braces,
        angles: angles,
        brackets: brackets,
        semi: semi,
        comma: comma,
        colon: colon,
        dot: dot,
        semiSep: semiSep,
        semiSep1: semiSep1,
        commaSep: commaSep,
        commaSep1: commaSep1
    };
};
var $18b1ddaa538e7cc7$export$d83becf4b42ec59 = /* #__PURE__ */ $18b1ddaa538e7cc7$var$bind($3J9zV.getParserT)(function(v) {
    var $148 = $5gmr2.null(v.value0);
    if ($148) return $3J9zV.consume;
    return $3J9zV.fail("Expected EOF");
});

});
parcelRegister("TrGmk", function(module, exports) {

$parcel$export(module.exports, "toLowerSimple", () => $0a6a9c4797b902db$export$3407ec4ae1791d82);
$parcel$export(module.exports, "toUpperSimple", () => $0a6a9c4797b902db$export$758e327c875e235b);
// Generated by purs version 0.15.16

var $9Grh5 = parcelRequire("9Grh5");

var $eWReo = parcelRequire("eWReo");

var $l0wDR = parcelRequire("l0wDR");

var $5oIYL = parcelRequire("5oIYL");
var $0a6a9c4797b902db$var$bindFlipped = /* #__PURE__ */ $9Grh5.bindFlipped($9Grh5.bindArray);
var $0a6a9c4797b902db$var$map = /* #__PURE__ */ $l0wDR.map($l0wDR.functorArray);
var $0a6a9c4797b902db$var$convertFull = function(f) {
    var $4 = $0a6a9c4797b902db$var$bindFlipped(f);
    return function($5) {
        return $5oIYL.fromCodePointArray($4($5oIYL.toCodePointArray($5)));
    };
};
var $0a6a9c4797b902db$export$b1ceac3893cbda6b = /* #__PURE__ */ $0a6a9c4797b902db$var$convertFull($eWReo.toLower);
var $0a6a9c4797b902db$export$43df7fc17cca38a4 = /* #__PURE__ */ $0a6a9c4797b902db$var$convertFull($eWReo.toUpper);
var $0a6a9c4797b902db$var$convert = function(f) {
    var $6 = $0a6a9c4797b902db$var$map(f);
    return function($7) {
        return $5oIYL.fromCodePointArray($6($5oIYL.toCodePointArray($7)));
    };
};
var $0a6a9c4797b902db$export$3407ec4ae1791d82 = /* #__PURE__ */ $0a6a9c4797b902db$var$convert($eWReo.toLowerSimple);
var $0a6a9c4797b902db$export$758e327c875e235b = /* #__PURE__ */ $0a6a9c4797b902db$var$convert($eWReo.toUpperSimple);
var $0a6a9c4797b902db$export$aa379662b51020a0 = /* #__PURE__ */ $0a6a9c4797b902db$var$convert($eWReo.caseFoldSimple);
var $0a6a9c4797b902db$export$ed703a87961582a2 = /* #__PURE__ */ $0a6a9c4797b902db$var$convertFull($eWReo.caseFold);
var $0a6a9c4797b902db$export$17b09a31ccc9ed13 = function(s1) {
    return function(s2) {
        return $0a6a9c4797b902db$export$ed703a87961582a2(s1) === $0a6a9c4797b902db$export$ed703a87961582a2(s2);
    };
};

});

parcelRegister("4kSuu", function(module, exports) {

$parcel$export(module.exports, "whiteSpace", () => $32834c6d75ca0cb1$export$9ef81298ca34ad41);
$parcel$export(module.exports, "skipSpaces", () => $32834c6d75ca0cb1$export$c85b81cf4e701929);
$parcel$export(module.exports, "space", () => $32834c6d75ca0cb1$export$a941ed4b947d12f8);
$parcel$export(module.exports, "upper", () => $32834c6d75ca0cb1$export$74b75dbc6083f1f5);
$parcel$export(module.exports, "oneOf", () => $32834c6d75ca0cb1$export$a9a18ae5ba42aeab);
$parcel$export(module.exports, "octDigit", () => $32834c6d75ca0cb1$export$6558cf8480d84f77);
$parcel$export(module.exports, "noneOf", () => $32834c6d75ca0cb1$export$2a75fb877f753830);
$parcel$export(module.exports, "hexDigit", () => $32834c6d75ca0cb1$export$6cf91e62dabd9493);
$parcel$export(module.exports, "digit", () => $32834c6d75ca0cb1$export$8a40e5669d3698bc);
// Generated by purs version 0.15.16

var $a7Dxq = parcelRequire("a7Dxq");

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $9Grh5 = parcelRequire("9Grh5");

var $7T8P4 = parcelRequire("7T8P4");

var $4VF0K = parcelRequire("4VF0K");

var $eWReo = parcelRequire("eWReo");

var $aKY4H = parcelRequire("aKY4H");

var $4MBcA = parcelRequire("4MBcA");

var $6RkEA = parcelRequire("6RkEA");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");

var $c8kPS = parcelRequire("c8kPS");

var $ykHdR = parcelRequire("ykHdR");

var $aknDF = parcelRequire("aknDF");

var $rzgQX = parcelRequire("rzgQX");
var $deaB6 = parcelRequire("deaB6");

var $3Orkn = parcelRequire("3Orkn");

var $5oIYL = parcelRequire("5oIYL");
parcelRequire("2gT7Y");
var $MTXA4 = parcelRequire("MTXA4");

var $lz4BY = parcelRequire("lz4BY");

var $3J9zV = parcelRequire("3J9zV");

var $1woEV = parcelRequire("1woEV");

var $hmOcH = parcelRequire("hmOcH");

var $c0aRt = parcelRequire("c0aRt");
var $32834c6d75ca0cb1$var$elem = /* #__PURE__ */ $4VF0K.elem($5oIYL.eqCodePoint);
var $32834c6d75ca0cb1$var$show = /* #__PURE__ */ $3Orkn.show(/* #__PURE__ */ $3Orkn.showArray($3Orkn.showString));
var $32834c6d75ca0cb1$var$map = /* #__PURE__ */ $l0wDR.map($l0wDR.functorArray);
var $32834c6d75ca0cb1$var$elem1 = /* #__PURE__ */ $4VF0K.elem($4MBcA.eqChar);
var $32834c6d75ca0cb1$var$show1 = /* #__PURE__ */ $3Orkn.show(/* #__PURE__ */ $3Orkn.showArray($3Orkn.showChar));
var $32834c6d75ca0cb1$var$identity = /* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn);
var $32834c6d75ca0cb1$var$mempty = /* #__PURE__ */ $aknDF.mempty($lz4BY.monoidRegexFlags);
var $32834c6d75ca0cb1$var$alt = /* #__PURE__ */ $a7Dxq.alt($3J9zV.altParserT);
var $32834c6d75ca0cb1$var$applySecond = /* #__PURE__ */ $a5g3C.applySecond($3J9zV.applyParserT);
var $32834c6d75ca0cb1$var$pure = /* #__PURE__ */ $gUTA8.pure($3J9zV.applicativeParserT);
var $32834c6d75ca0cb1$var$bind = /* #__PURE__ */ $9Grh5.bind($3J9zV.bindParserT);
var $32834c6d75ca0cb1$var$notElem = /* #__PURE__ */ $4VF0K.notElem($5oIYL.eqCodePoint);
var $32834c6d75ca0cb1$var$notElem1 = /* #__PURE__ */ $4VF0K.notElem($4MBcA.eqChar);
var $32834c6d75ca0cb1$export$fa0d629c75fdc0f1 = function(predicate) {
    return $hmOcH.consumeWith(function(s) {
        var value = $5oIYL.takeWhile(predicate)(s);
        var len = $MTXA4.length(value);
        var $27 = len > 0;
        if ($27) return new $aKY4H.Right({
            consumed: value,
            remainder: $MTXA4.drop($MTXA4.length(value))(s),
            value: value
        });
        return new $aKY4H.Left("Expected character satisfying predicate");
    });
};
var $32834c6d75ca0cb1$export$9384c7afe4015e42 = function(predicate) {
    return $hmOcH.consumeWith(function(s) {
        var value = $5oIYL.takeWhile(predicate)(s);
        return new $aKY4H.Right({
            consumed: value,
            remainder: $MTXA4.drop($MTXA4.length(value))(s),
            value: value
        });
    });
};
var $32834c6d75ca0cb1$export$9ef81298ca34ad41 = /* #__PURE__ */ $32834c6d75ca0cb1$export$9384c7afe4015e42($eWReo.isSpace);
var $32834c6d75ca0cb1$export$c85b81cf4e701929 = /* #__PURE__ */ $l0wDR.void($3J9zV.functorParserT)($32834c6d75ca0cb1$export$9ef81298ca34ad41);
var $32834c6d75ca0cb1$var$satisfyCP = function(p) {
    return $hmOcH.satisfy(function($32) {
        return p($5oIYL.codePointFromChar($32));
    });
};
var $32834c6d75ca0cb1$export$a941ed4b947d12f8 = /* #__PURE__ */ $1woEV.withErrorMessage(/* #__PURE__ */ $32834c6d75ca0cb1$var$satisfyCP($eWReo.isSpace))("space");
var $32834c6d75ca0cb1$export$74b75dbc6083f1f5 = /* #__PURE__ */ $1woEV.withErrorMessage(/* #__PURE__ */ $32834c6d75ca0cb1$var$satisfyCP($eWReo.isUpper))("uppercase letter");
var $32834c6d75ca0cb1$export$719a4d2b42fce467 = function(ss) {
    return $1woEV.withLazyErrorMessage($hmOcH.satisfyCodePoint($l4M7e.flip($32834c6d75ca0cb1$var$elem)(ss)))(function(v) {
        return "one of " + $32834c6d75ca0cb1$var$show($32834c6d75ca0cb1$var$map($5oIYL.singleton)(ss));
    });
};
var $32834c6d75ca0cb1$export$a9a18ae5ba42aeab = function(ss) {
    return $1woEV.withLazyErrorMessage($hmOcH.satisfy($l4M7e.flip($32834c6d75ca0cb1$var$elem1)(ss)))(function(v) {
        return "one of " + $32834c6d75ca0cb1$var$show1(ss);
    });
};
var $32834c6d75ca0cb1$export$6558cf8480d84f77 = /* #__PURE__ */ $1woEV.withErrorMessage(/* #__PURE__ */ $32834c6d75ca0cb1$var$satisfyCP($eWReo.isOctDigit))("oct digit");
var $32834c6d75ca0cb1$var$numberRegex = /* #__PURE__ */ $aKY4H.either($c0aRt.unsafeCrashWith)($32834c6d75ca0cb1$var$identity)(/* #__PURE__ */ $hmOcH.regex("[+-]?[0-9]*(\\.[0-9]*)?([eE][+-]?[0-9]*(\\.[0-9]*)?)?")($32834c6d75ca0cb1$var$mempty));
var $32834c6d75ca0cb1$export$98e628dec113755e = /* #__PURE__ */ function() {
    return $32834c6d75ca0cb1$var$alt($1woEV.choice($6RkEA.foldableArray)([
        $32834c6d75ca0cb1$var$applySecond($hmOcH.string("Infinity"))($32834c6d75ca0cb1$var$pure($deaB6.infinity)),
        $32834c6d75ca0cb1$var$applySecond($hmOcH.string("+Infinity"))($32834c6d75ca0cb1$var$pure($deaB6.infinity)),
        $32834c6d75ca0cb1$var$applySecond($hmOcH.string("-Infinity"))($32834c6d75ca0cb1$var$pure(-$deaB6.infinity)),
        $32834c6d75ca0cb1$var$applySecond($hmOcH.string("NaN"))($32834c6d75ca0cb1$var$pure($deaB6.nan)),
        $1woEV.tryRethrow($32834c6d75ca0cb1$var$bind($32834c6d75ca0cb1$var$numberRegex)(function(section) {
            var v = $rzgQX.fromString(section);
            if (v instanceof $ykHdR.Nothing) return $3J9zV.fail("Expected Number");
            if (v instanceof $ykHdR.Just) return $32834c6d75ca0cb1$var$pure(v.value0);
            throw new Error("Failed pattern match at Parsing.String.Basic (line 118, column 9 - line 120, column 27): " + [
                v.constructor.name
            ]);
        }))
    ]))($3J9zV.fail("Expected Number"));
}();
var $32834c6d75ca0cb1$export$64af8ff3ab95bbe6 = function(ss) {
    return $1woEV.withLazyErrorMessage($hmOcH.satisfyCodePoint($l4M7e.flip($32834c6d75ca0cb1$var$notElem)(ss)))(function(v) {
        return "none of " + $32834c6d75ca0cb1$var$show($32834c6d75ca0cb1$var$map($5oIYL.singleton)(ss));
    });
};
var $32834c6d75ca0cb1$export$2a75fb877f753830 = function(ss) {
    return $1woEV.withLazyErrorMessage($hmOcH.satisfy($l4M7e.flip($32834c6d75ca0cb1$var$notElem1)(ss)))(function(v) {
        return "none of " + $32834c6d75ca0cb1$var$show1(ss);
    });
};
var $32834c6d75ca0cb1$export$abae053c7acf36bb = /* #__PURE__ */ $1woEV.withErrorMessage(/* #__PURE__ */ $32834c6d75ca0cb1$var$satisfyCP($eWReo.isLower))("lowercase letter");
var $32834c6d75ca0cb1$export$30780d0b6b610af8 = /* #__PURE__ */ $1woEV.withErrorMessage(/* #__PURE__ */ $32834c6d75ca0cb1$var$satisfyCP($eWReo.isAlpha))("letter");
var $32834c6d75ca0cb1$var$intDecimalRegex = /* #__PURE__ */ $aKY4H.either($c0aRt.unsafeCrashWith)($32834c6d75ca0cb1$var$identity)(/* #__PURE__ */ $hmOcH.regex("[+-]?[0-9]+")($32834c6d75ca0cb1$var$mempty));
var $32834c6d75ca0cb1$export$198d5c93fe95ea67 = /* #__PURE__ */ $1woEV.tryRethrow(/* #__PURE__ */ $32834c6d75ca0cb1$var$bind(/* #__PURE__ */ $32834c6d75ca0cb1$var$alt($32834c6d75ca0cb1$var$intDecimalRegex)(/* #__PURE__ */ $3J9zV.fail("Expected Int")))(function(section) {
    var v = $c8kPS.fromString(section);
    if (v instanceof $ykHdR.Nothing) return $3J9zV.fail("Expected Int");
    if (v instanceof $ykHdR.Just) return $32834c6d75ca0cb1$var$pure(v.value0);
    throw new Error("Failed pattern match at Parsing.String.Basic (line 140, column 3 - line 142, column 21): " + [
        v.constructor.name
    ]);
}));
var $32834c6d75ca0cb1$export$6cf91e62dabd9493 = /* #__PURE__ */ $1woEV.withErrorMessage(/* #__PURE__ */ $32834c6d75ca0cb1$var$satisfyCP($eWReo.isHexDigit))("hex digit");
var $32834c6d75ca0cb1$export$8a40e5669d3698bc = /* #__PURE__ */ $1woEV.withErrorMessage(/* #__PURE__ */ $32834c6d75ca0cb1$var$satisfyCP($eWReo.isDecDigit))("digit");
var $32834c6d75ca0cb1$export$2f9d0d831d496619 = /* #__PURE__ */ $1woEV.withErrorMessage(/* #__PURE__ */ $32834c6d75ca0cb1$var$satisfyCP($eWReo.isAlphaNum))("letter or digit");

});


parcelRegister("7yevh", function(module, exports) {

$parcel$export(module.exports, "Tokenize", () => $57f6f579ea86fa54$export$ddc49d956008d2b3);
$parcel$export(module.exports, "tokens", () => $57f6f579ea86fa54$export$6ad93df59e712c43);
$parcel$export(module.exports, "tokenizer", () => $57f6f579ea86fa54$export$5f8c09e3ae6f64e1);
// Generated by purs version 0.15.16

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $9Grh5 = parcelRequire("9Grh5");

var $kUmUH = parcelRequire("kUmUH");

var $kQAxW = parcelRequire("kQAxW");

var $3Dhkl = parcelRequire("3Dhkl");

var $6Y3sG = parcelRequire("6Y3sG");

var $aKY4H = parcelRequire("aKY4H");

var $4MBcA = parcelRequire("4MBcA");

var $6RkEA = parcelRequire("6RkEA");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");

var $6VVZC = parcelRequire("6VVZC");

var $amUgg = parcelRequire("amUgg");

var $ykHdR = parcelRequire("ykHdR");

var $6PW1p = parcelRequire("6PW1p");

var $3Orkn = parcelRequire("3Orkn");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");

var $kugLX = parcelRequire("kugLX");

var $hhMAk = parcelRequire("hhMAk");

var $jIMHU = parcelRequire("jIMHU");

var $cLQJF = parcelRequire("cLQJF");

var $bllhK = parcelRequire("bllhK");

var $5tIT8 = parcelRequire("5tIT8");

var $3J9zV = parcelRequire("3J9zV");

var $hmOcH = parcelRequire("hmOcH");

var $4kSuu = parcelRequire("4kSuu");
var $57f6f579ea86fa54$var$apply = /* #__PURE__ */ $a5g3C.apply($3J9zV.applyParserT);
var $57f6f579ea86fa54$var$map = /* #__PURE__ */ $l0wDR.map($3J9zV.functorParserT);
var $57f6f579ea86fa54$var$applyFirst = /* #__PURE__ */ $a5g3C.applyFirst($3J9zV.applyParserT);
var $57f6f579ea86fa54$var$applySecond = /* #__PURE__ */ $a5g3C.applySecond($3J9zV.applyParserT);
var $57f6f579ea86fa54$var$discard = /* #__PURE__ */ $9Grh5.discard($9Grh5.discardUnit)($bllhK.bindHalogenM);
var $57f6f579ea86fa54$var$modify_ = /* #__PURE__ */ $kQAxW.modify_($bllhK.monadStateHalogenM);
var $57f6f579ea86fa54$var$over = /* #__PURE__ */ $6PW1p.over()();
var $57f6f579ea86fa54$var$pure = /* #__PURE__ */ $gUTA8.pure($bllhK.applicativeHalogenM);
var $57f6f579ea86fa54$var$put = /* #__PURE__ */ $kQAxW.put($bllhK.monadStateHalogenM);
var $57f6f579ea86fa54$var$renderMany = /* #__PURE__ */ $5tIT8.renderMany($amUgg.functorList)($amUgg.foldableList);
var $57f6f579ea86fa54$var$map1 = /* #__PURE__ */ $l0wDR.map($amUgg.functorList);
var $57f6f579ea86fa54$var$show = /* #__PURE__ */ $3Orkn.show($3J9zV.showParseError);
var $57f6f579ea86fa54$var$foldr = /* #__PURE__ */ $6RkEA.foldr($amUgg.foldableList);
var $57f6f579ea86fa54$var$unwrap = /* #__PURE__ */ $6PW1p.unwrap();
var $57f6f579ea86fa54$var$eq = /* #__PURE__ */ $4MBcA.eq($5tIT8.eqLexeme);
var $57f6f579ea86fa54$export$50792b0e93539fde = function(x) {
    return x;
};
var $57f6f579ea86fa54$export$ddc49d956008d2b3 = /* #__PURE__ */ function() {
    function Tokenize(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    Tokenize.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new Tokenize(value0, value1, value2);
            };
        };
    };
    return Tokenize;
}();
var $57f6f579ea86fa54$var$TokenizerState = function(x) {
    return x;
};
var $57f6f579ea86fa54$var$token = function(dictMonad) {
    return function(lexeme) {
        return $57f6f579ea86fa54$var$apply($57f6f579ea86fa54$var$apply($57f6f579ea86fa54$var$map(function(v) {
            return function(v1) {
                return function(v2) {
                    return {
                        start: v,
                        lexeme: v1,
                        end: v2
                    };
                };
            };
        })($3J9zV.position))(lexeme))($3J9zV.position);
    };
};
var $57f6f579ea86fa54$export$6ad93df59e712c43 = function(dictMonad) {
    var sepByLazy = $6Y3sG.sepByLazy(dictMonad);
    var token1 = $57f6f579ea86fa54$var$token(dictMonad);
    return function(lexeme) {
        return sepByLazy(token1(lexeme))($4kSuu.whiteSpace);
    };
};
var $57f6f579ea86fa54$var$tokens1 = /* #__PURE__ */ $57f6f579ea86fa54$export$6ad93df59e712c43($6VVZC.monadIdentity);
var $57f6f579ea86fa54$var$ntTokenizerState = {
    Coercible0: function() {
        return undefined;
    }
};
var $57f6f579ea86fa54$var$tokQuery = function(v) {
    var v1 = $3J9zV.runParser(v.value0)($57f6f579ea86fa54$var$applyFirst($57f6f579ea86fa54$var$applyFirst($57f6f579ea86fa54$var$applySecond($4kSuu.skipSpaces)($57f6f579ea86fa54$var$tokens1($5tIT8.parser)))($4kSuu.skipSpaces))($hmOcH.eof));
    if (v1 instanceof $aKY4H.Left) return $57f6f579ea86fa54$var$discard($57f6f579ea86fa54$var$modify_($57f6f579ea86fa54$var$over($57f6f579ea86fa54$var$TokenizerState)(function(v2) {
        return {
            lastTokenize: v2.lastTokenize,
            parseError: new $ykHdR.Just(v1.value0)
        };
    })))(function() {
        return $57f6f579ea86fa54$var$pure(new $ykHdR.Just(v.value2(v1.value0)));
    });
    if (v1 instanceof $aKY4H.Right) return $57f6f579ea86fa54$var$discard($57f6f579ea86fa54$var$put({
        parseError: $ykHdR.Nothing.value,
        lastTokenize: v1.value0
    }))(function() {
        return $57f6f579ea86fa54$var$pure(new $ykHdR.Just(v.value1(v1.value0)));
    });
    throw new Error("Failed pattern match at Token (line 106, column 3 - line 112, column 30): " + [
        v1.constructor.name
    ]);
};
var $57f6f579ea86fa54$export$5f8c09e3ae6f64e1 = /* #__PURE__ */ function() {
    var render = function(v) {
        var renderToks = $57f6f579ea86fa54$var$renderMany($57f6f579ea86fa54$var$map1(function(v1) {
            return v1.lexeme;
        })(v.lastTokenize));
        return $jIMHU.div([
            $cLQJF.class_("tokenizer")
        ])(function() {
            if (v.parseError instanceof $ykHdR.Nothing) return [
                renderToks
            ];
            if (v.parseError instanceof $ykHdR.Just) return [
                $3Dhkl.overlay([
                    "tokenizer_error"
                ])([
                    $hhMAk.text($57f6f579ea86fa54$var$show(v.parseError.value0))
                ]),
                renderToks
            ];
            throw new Error("Failed pattern match at Token (line 129, column 5 - line 134, column 10): " + [
                v.parseError.constructor.name
            ]);
        }());
    };
    return $kugLX.mkComponent({
        initialState: $l4M7e.const({
            parseError: $ykHdR.Nothing.value,
            lastTokenize: $amUgg.Nil.value
        }),
        render: render,
        "eval": $kugLX.mkEval({
            initialize: $ykHdR.Nothing.value,
            receive: $l4M7e.const($ykHdR.Nothing.value),
            handleAction: $l4M7e.const($57f6f579ea86fa54$var$pure($r2HHk.unit)),
            handleQuery: $57f6f579ea86fa54$var$tokQuery,
            finalize: $ykHdR.Nothing.value
        })
    });
}();
var $57f6f579ea86fa54$export$eec6f192398c516b = {
    Coercible0: function() {
        return undefined;
    }
};
var $57f6f579ea86fa54$var$renderTokens = function(toks) {
    var alg = function(v) {
        return function(v1) {
            return function(v2) {
                if (v instanceof $5tIT8.Identifier) return function() {
                    if (v2) return " " + v.value0;
                    return v.value0;
                }() + v1(true);
                return $5tIT8.print(v) + v1(false);
            };
        };
    };
    return $57f6f579ea86fa54$var$foldr(alg)($l4M7e.const(""))($57f6f579ea86fa54$var$map1(function($85) {
        return function(v) {
            return v.lexeme;
        }($57f6f579ea86fa54$var$unwrap($85));
    })(toks))(false);
};
var $57f6f579ea86fa54$export$ec2d3faf92471b56 = function(toks) {
    var eqOnLexeme = function(v) {
        return function(v1) {
            if (v instanceof $amUgg.Nil && v1 instanceof $amUgg.Nil) return true;
            if (v instanceof $amUgg.Cons && v1 instanceof $amUgg.Cons) return $57f6f579ea86fa54$var$eq(v.value0.lexeme)(v1.value0.lexeme) && eqOnLexeme(v.value1)(v1.value1);
            return false;
        };
    };
    return $aKY4H.either($l4M7e.const(false))(eqOnLexeme(toks))($3J9zV.runParser($57f6f579ea86fa54$var$renderTokens(toks))($57f6f579ea86fa54$var$tokens1($5tIT8.parser)));
};
var $57f6f579ea86fa54$export$edcf7789d7795735 = function(dictMonadGen) {
    var Apply0 = dictMonadGen.Monad0().Bind1().Apply0();
    var apply1 = $a5g3C.apply(Apply0);
    var map2 = $l0wDR.map(Apply0.Functor0());
    var chooseInt = $kUmUH.chooseInt(dictMonadGen);
    return function(lexeme) {
        var gp = apply1(apply1(map2(function(v) {
            return function(v1) {
                return function(v2) {
                    return {
                        column: v,
                        line: v2,
                        index: v1
                    };
                };
            };
        })(chooseInt(0)(125)))(chooseInt(1)(50000)))(chooseInt(1)(2500));
        return apply1(apply1(map2(function(v) {
            return function(v1) {
                return function(v2) {
                    return {
                        start: v,
                        end: v2,
                        lexeme: v1
                    };
                };
            };
        })(gp))(lexeme))(gp);
    };
};

});
parcelRegister("6Y3sG", function(module, exports) {

$parcel$export(module.exports, "sepByLazy", () => $512b0814b076ee9d$export$28aa36e8f89b9988);
// Generated by purs version 0.15.16

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $9Grh5 = parcelRequire("9Grh5");

var $5gmr2 = parcelRequire("5gmr2");

var $amUgg = parcelRequire("amUgg");

var $3J9zV = parcelRequire("3J9zV");

var $1woEV = parcelRequire("1woEV");
var $512b0814b076ee9d$var$bind = /* #__PURE__ */ $9Grh5.bind($3J9zV.bindParserT);
var $512b0814b076ee9d$var$many = /* #__PURE__ */ $5gmr2.many($3J9zV.alternativeParserT)($3J9zV.lazyParserT);
var $512b0814b076ee9d$var$applySecond = /* #__PURE__ */ $a5g3C.applySecond($3J9zV.applyParserT);
var $512b0814b076ee9d$var$pure = /* #__PURE__ */ $gUTA8.pure($3J9zV.applicativeParserT);
var $512b0814b076ee9d$export$28aa36e8f89b9988 = function(dictMonad) {
    return function(elemp) {
        return function(sepp) {
            return $512b0814b076ee9d$var$bind(elemp)(function(h) {
                return $512b0814b076ee9d$var$bind($512b0814b076ee9d$var$many($1woEV.try($512b0814b076ee9d$var$applySecond(sepp)(elemp))))(function(t) {
                    return $512b0814b076ee9d$var$pure(new $amUgg.Cons(h, t));
                });
            });
        };
    };
};

});



parcelRegister("hK1Ac", function(module, exports) {

$parcel$export(module.exports, "hmap", () => $cea7f5ded680bc2e$export$92e76f30ee0bf2e4);
// Generated by purs version 0.15.16
var $cea7f5ded680bc2e$export$9a3a235afba7298b = function(x) {
    return x;
};
var $cea7f5ded680bc2e$export$92e76f30ee0bf2e4 = function(dict) {
    return dict.hmap;
};
var $cea7f5ded680bc2e$export$7ed679b61418205e = function(dictHFunctor) {
    var hmap1 = $cea7f5ded680bc2e$export$92e76f30ee0bf2e4(dictHFunctor);
    return function(nat) {
        return function(v) {
            return nat(hmap1($cea7f5ded680bc2e$export$7ed679b61418205e(dictHFunctor)(nat))(v));
        };
    };
};

});


parcelRegister("bjiNg", function(module, exports) {

$parcel$export(module.exports, "component", () => $83c00c10ef0626d4$export$d8556a2a8f973135);
// Generated by purs version 0.15.16

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $9Grh5 = parcelRequire("9Grh5");

var $dTFzl = parcelRequire("dTFzl");

var $84kZf = parcelRequire("84kZf");

var $8D18I = parcelRequire("8D18I");

var $kUmUH = parcelRequire("kUmUH");

var $kQAxW = parcelRequire("kQAxW");

var $4VF0K = parcelRequire("4VF0K");

var $jxBf5 = parcelRequire("jxBf5");

var $cwMDv = parcelRequire("cwMDv");

var $aKY4H = parcelRequire("aKY4H");

var $4MBcA = parcelRequire("4MBcA");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");

var $cw1rg = parcelRequire("cw1rg");
parcelRequire("c8kPS");
var $6pI6x = parcelRequire("6pI6x");
var $c8kPS = parcelRequire("c8kPS");

var $amUgg = parcelRequire("amUgg");

var $ykHdR = parcelRequire("ykHdR");
parcelRequire("rzgQX");
var $deaB6 = parcelRequire("deaB6");

var $d0PPW = parcelRequire("d0PPW");

var $3Orkn = parcelRequire("3Orkn");

var $7eHfd = parcelRequire("7eHfd");

var $79GDW = parcelRequire("79GDW");

var $hsyEi = parcelRequire("hsyEi");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");

var $jHZNn = parcelRequire("jHZNn");

var $kugLX = parcelRequire("kugLX");

var $hhMAk = parcelRequire("hhMAk");

var $jIMHU = parcelRequire("jIMHU");

var $1qNv1 = parcelRequire("1qNv1");

var $cLQJF = parcelRequire("cLQJF");

var $bllhK = parcelRequire("bllhK");
var $83c00c10ef0626d4$var$showRecord = /* #__PURE__ */ $3Orkn.showRecord()();
var $83c00c10ef0626d4$var$environmentIsSymbol = {
    reflectSymbol: function() {
        return "environment";
    }
};
var $83c00c10ef0626d4$var$showRecordFieldsCons = /* #__PURE__ */ $3Orkn.showRecordFieldsCons($83c00c10ef0626d4$var$environmentIsSymbol)(/* #__PURE__ */ $3Orkn.showRecordFieldsConsNil({
    reflectSymbol: function() {
        return "target";
    }
})($jHZNn.showExpr));
var $83c00c10ef0626d4$var$nameIsSymbol = {
    reflectSymbol: function() {
        return "name";
    }
};
var $83c00c10ef0626d4$var$showRecordFieldsCons1 = /* #__PURE__ */ $3Orkn.showRecordFieldsCons($83c00c10ef0626d4$var$nameIsSymbol);
var $83c00c10ef0626d4$var$valueIsSymbol = {
    reflectSymbol: function() {
        return "value";
    }
};
var $83c00c10ef0626d4$var$showRecordFieldsConsNil = /* #__PURE__ */ $3Orkn.showRecordFieldsConsNil($83c00c10ef0626d4$var$valueIsSymbol);
var $83c00c10ef0626d4$var$MkClosureIsSymbol = {
    reflectSymbol: function() {
        return "MkClosure";
    }
};
var $83c00c10ef0626d4$var$genericShowConstructor = /* #__PURE__ */ $7eHfd.genericShowConstructor($7eHfd.genericShowArgsNoArguments);
var $83c00c10ef0626d4$var$eqRec = /* #__PURE__ */ $4MBcA.eqRec();
var $83c00c10ef0626d4$var$eqRowCons = /* #__PURE__ */ $4MBcA.eqRowCons($4MBcA.eqRowNil)();
var $83c00c10ef0626d4$var$eqRowCons1 = /* #__PURE__ */ $83c00c10ef0626d4$var$eqRowCons($83c00c10ef0626d4$var$valueIsSymbol);
var $83c00c10ef0626d4$var$eq = /* #__PURE__ */ $4MBcA.eq($jHZNn.eqExpr);
var $83c00c10ef0626d4$var$max = /* #__PURE__ */ $d0PPW.max($d0PPW.ordInt);
var $83c00c10ef0626d4$var$map = /* #__PURE__ */ $l0wDR.map($l0wDR.functorArray);
var $83c00c10ef0626d4$var$show = /* #__PURE__ */ $3Orkn.show($3Orkn.showString);
var $83c00c10ef0626d4$var$discard = /* #__PURE__ */ $9Grh5.discard($9Grh5.discardUnit)($bllhK.bindHalogenM);
var $83c00c10ef0626d4$var$put = /* #__PURE__ */ $kQAxW.put($bllhK.monadStateHalogenM);
var $83c00c10ef0626d4$var$pure = /* #__PURE__ */ $gUTA8.pure($bllhK.applicativeHalogenM);
var $83c00c10ef0626d4$var$modify_ = /* #__PURE__ */ $kQAxW.modify_($bllhK.monadStateHalogenM);
var $83c00c10ef0626d4$export$d050db8f6426404e = function(x) {
    return x;
};
var $83c00c10ef0626d4$export$b71522256f53395 = function(x) {
    return x;
};
var $83c00c10ef0626d4$var$VariableNotFound = /* #__PURE__ */ function() {
    function VariableNotFound(value0) {
        this.value0 = value0;
    }
    VariableNotFound.create = function(value0) {
        return new VariableNotFound(value0);
    };
    return VariableNotFound;
}();
var $83c00c10ef0626d4$var$StepBack = /* #__PURE__ */ function() {
    function StepBack() {}
    StepBack.value = new StepBack();
    return StepBack;
}();
var $83c00c10ef0626d4$var$StepForward = /* #__PURE__ */ function() {
    function StepForward() {}
    StepForward.value = new StepForward();
    return StepForward;
}();
var $83c00c10ef0626d4$export$7fe28cb29e71bf10 = /* #__PURE__ */ function() {
    function Done() {}
    Done.value = new Done();
    return Done;
}();
var $83c00c10ef0626d4$export$367616366844a674 = /* #__PURE__ */ function() {
    function KontArg(value0) {
        this.value0 = value0;
    }
    KontArg.create = function(value0) {
        return new KontArg(value0);
    };
    return KontArg;
}();
var $83c00c10ef0626d4$export$5958d2a478bf80a9 = /* #__PURE__ */ function() {
    function KontApp(value0) {
        this.value0 = value0;
    }
    KontApp.create = function(value0) {
        return new KontApp(value0);
    };
    return KontApp;
}();
var $83c00c10ef0626d4$var$Uninitialized = /* #__PURE__ */ function() {
    function Uninitialized() {}
    Uninitialized.value = new Uninitialized();
    return Uninitialized;
}();
var $83c00c10ef0626d4$var$Working = /* #__PURE__ */ function() {
    function Working(value0) {
        this.value0 = value0;
    }
    Working.create = function(value0) {
        return new Working(value0);
    };
    return Working;
}();
var $83c00c10ef0626d4$var$Final = /* #__PURE__ */ function() {
    function Final(value0) {
        this.value0 = value0;
    }
    Final.create = function(value0) {
        return new Final(value0);
    };
    return Final;
}();
var $83c00c10ef0626d4$var$Review = /* #__PURE__ */ function() {
    function Review(value0) {
        this.value0 = value0;
    }
    Review.create = function(value0) {
        return new Review(value0);
    };
    return Review;
}();
var $83c00c10ef0626d4$export$6b34c2670558f345 = {
    to: function(x) {
        return x;
    },
    from: function(x) {
        return x;
    }
};
var $83c00c10ef0626d4$var$genericShow = /* #__PURE__ */ $7eHfd.genericShow($83c00c10ef0626d4$export$6b34c2670558f345);
var $83c00c10ef0626d4$export$838144556d04d2fe = {
    show: function(c) {
        return $83c00c10ef0626d4$var$genericShow($7eHfd.genericShowConstructor($7eHfd.genericShowArgsArgument($83c00c10ef0626d4$var$showRecord($83c00c10ef0626d4$var$showRecordFieldsCons($3Orkn.showArray($83c00c10ef0626d4$var$showRecord($83c00c10ef0626d4$var$showRecordFieldsCons1($83c00c10ef0626d4$var$showRecordFieldsConsNil($83c00c10ef0626d4$export$838144556d04d2fe))($3Orkn.showString)))))))($83c00c10ef0626d4$var$MkClosureIsSymbol))(c);
    }
};
var $83c00c10ef0626d4$var$genericAction_ = {
    to: function(x) {
        if (x instanceof $cw1rg.Inl) return $83c00c10ef0626d4$var$StepBack.value;
        if (x instanceof $cw1rg.Inr) return $83c00c10ef0626d4$var$StepForward.value;
        throw new Error("Failed pattern match at CEK (line 371, column 1 - line 371, column 33): " + [
            x.constructor.name
        ]);
    },
    from: function(x) {
        if (x instanceof $83c00c10ef0626d4$var$StepBack) return new $cw1rg.Inl($cw1rg.NoArguments.value);
        if (x instanceof $83c00c10ef0626d4$var$StepForward) return new $cw1rg.Inr($cw1rg.NoArguments.value);
        throw new Error("Failed pattern match at CEK (line 371, column 1 - line 371, column 33): " + [
            x.constructor.name
        ]);
    }
};
var $83c00c10ef0626d4$var$showAction = {
    show: /* #__PURE__ */ $7eHfd.genericShow($83c00c10ef0626d4$var$genericAction_)(/* #__PURE__ */ $7eHfd.genericShowSum(/* #__PURE__ */ $83c00c10ef0626d4$var$genericShowConstructor({
        reflectSymbol: function() {
            return "StepBack";
        }
    }))(/* #__PURE__ */ $83c00c10ef0626d4$var$genericShowConstructor({
        reflectSymbol: function() {
            return "StepForward";
        }
    })))
};
var $83c00c10ef0626d4$export$bfa8358851c1e687 = {
    eq: function(x) {
        return function(y) {
            return $4MBcA.eq($4MBcA.eqArray($83c00c10ef0626d4$var$eqRec($4MBcA.eqRowCons($83c00c10ef0626d4$var$eqRowCons1($83c00c10ef0626d4$export$bfa8358851c1e687))()($83c00c10ef0626d4$var$nameIsSymbol)($4MBcA.eqString))))(x.environment)(y.environment) && $83c00c10ef0626d4$var$eq(x.target)(y.target);
        };
    }
};
var $83c00c10ef0626d4$var$eqArray = /* #__PURE__ */ $4MBcA.eqArray(/* #__PURE__ */ $83c00c10ef0626d4$var$eqRec(/* #__PURE__ */ $4MBcA.eqRowCons(/* #__PURE__ */ $83c00c10ef0626d4$var$eqRowCons1($83c00c10ef0626d4$export$bfa8358851c1e687))()($83c00c10ef0626d4$var$nameIsSymbol)($4MBcA.eqString)));
var $83c00c10ef0626d4$var$eq2 = /* #__PURE__ */ $4MBcA.eq($83c00c10ef0626d4$var$eqArray);
var $83c00c10ef0626d4$export$6de2a0f9145ac4cd = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $83c00c10ef0626d4$export$7fe28cb29e71bf10 && y instanceof $83c00c10ef0626d4$export$7fe28cb29e71bf10) return true;
            if (x instanceof $83c00c10ef0626d4$export$367616366844a674 && y instanceof $83c00c10ef0626d4$export$367616366844a674) return $83c00c10ef0626d4$var$eq(x.value0.argument)(y.value0.argument) && $83c00c10ef0626d4$var$eq2(x.value0.environment)(y.value0.environment) && $4MBcA.eq($83c00c10ef0626d4$export$6de2a0f9145ac4cd)(x.value0.next)(y.value0.next);
            if (x instanceof $83c00c10ef0626d4$export$5958d2a478bf80a9 && y instanceof $83c00c10ef0626d4$export$5958d2a478bf80a9) return x.value0.abstraction.binder === y.value0.abstraction.binder && $83c00c10ef0626d4$var$eq(x.value0.abstraction.body)(y.value0.abstraction.body) && $83c00c10ef0626d4$var$eq2(x.value0.environment)(y.value0.environment) && $4MBcA.eq($83c00c10ef0626d4$export$6de2a0f9145ac4cd)(x.value0.next)(y.value0.next);
            return false;
        };
    }
};
var $83c00c10ef0626d4$var$eqMachineError = {
    eq: function(x) {
        return function(y) {
            return $83c00c10ef0626d4$var$eq2(x.value0.environment)(y.value0.environment) && x.value0.name === y.value0.name;
        };
    }
};
var $83c00c10ef0626d4$var$eq3 = /* #__PURE__ */ $4MBcA.eq(/* #__PURE__ */ $aKY4H.eqEither($83c00c10ef0626d4$var$eqMachineError)(/* #__PURE__ */ $aKY4H.eqEither($jHZNn.eqExpr)(/* #__PURE__ */ $83c00c10ef0626d4$var$eqRec(/* #__PURE__ */ $4MBcA.eqRowCons(/* #__PURE__ */ $4MBcA.eqRowCons(/* #__PURE__ */ $83c00c10ef0626d4$var$eqRowCons({
    reflectSymbol: function() {
        return "kontinuation";
    }
})($83c00c10ef0626d4$export$6de2a0f9145ac4cd))()($83c00c10ef0626d4$var$environmentIsSymbol)($83c00c10ef0626d4$var$eqArray))()({
    reflectSymbol: function() {
        return "control";
    }
})($jHZNn.eqExpr)))));
var $83c00c10ef0626d4$var$eqAction = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $83c00c10ef0626d4$var$StepBack && y instanceof $83c00c10ef0626d4$var$StepBack) return true;
            if (x instanceof $83c00c10ef0626d4$var$StepForward && y instanceof $83c00c10ef0626d4$var$StepForward) return true;
            return false;
        };
    }
};
var $83c00c10ef0626d4$var$pred = function(s) {
    return $83c00c10ef0626d4$var$max(0)(s - 1 | 0);
};
var $83c00c10ef0626d4$var$lzInit = function(lz) {
    if (lz.previousReverse instanceof $amUgg.Nil) return lz;
    if (lz.previousReverse instanceof $amUgg.Cons) return {
        previousReverse: lz.previousReverse.value1,
        current: lz.previousReverse.value0,
        future: new $amUgg.Cons(lz.current, lz.future)
    };
    throw new Error("Failed pattern match at CEK (line 349, column 13 - line 352, column 68): " + [
        lz.previousReverse.constructor.name
    ]);
};
var $83c00c10ef0626d4$var$initialMachineState = function(control) {
    return {
        control: control,
        environment: [],
        kontinuation: $83c00c10ef0626d4$export$7fe28cb29e71bf10.value
    };
};
var $83c00c10ef0626d4$var$genKont = function(dictMonadRec) {
    var genAlphaString = $79GDW.genAlphaString(dictMonadRec);
    return function(dictMonadGen) {
        var resize = $kUmUH.resize(dictMonadGen);
        var Monad0 = dictMonadGen.Monad0();
        var pure1 = $gUTA8.pure(Monad0.Applicative0());
        var Apply0 = Monad0.Bind1().Apply0();
        var apply = $a5g3C.apply(Apply0);
        var map1 = $l0wDR.map(Apply0.Functor0());
        var genAlphaString1 = genAlphaString(dictMonadGen);
        var oneOf = $8D18I.oneOf(dictMonadGen)($cwMDv.foldable1NonEmptyArray);
        var sized = $kUmUH.sized(dictMonadGen);
        return function(expr) {
            return function(env) {
                return function(k) {
                    var smaller = resize(function() {
                        var $302 = $83c00c10ef0626d4$var$max(0);
                        return function($303) {
                            return $302(function(v) {
                                return v - 1 | 0;
                            }($303));
                        };
                    }())(k);
                    var small = pure1($83c00c10ef0626d4$export$7fe28cb29e71bf10.value);
                    var arg = apply(apply(map1(function(v) {
                        return function(v1) {
                            return function(v2) {
                                return {
                                    argument: v,
                                    environment: v1,
                                    next: v2
                                };
                            };
                        };
                    })(expr))(env))(smaller);
                    var app = apply(apply(map1(function(v) {
                        return function(v1) {
                            return function(v2) {
                                return {
                                    abstraction: v,
                                    environment: v1,
                                    next: v2
                                };
                            };
                        };
                    })(apply(map1(function(v) {
                        return function(v1) {
                            return {
                                binder: v,
                                body: v1
                            };
                        };
                    })(genAlphaString1))(expr)))(env))(smaller);
                    var large = oneOf($jxBf5.cons$prime(small)([
                        map1($83c00c10ef0626d4$export$367616366844a674.create)(arg),
                        map1($83c00c10ef0626d4$export$5958d2a478bf80a9.create)(app)
                    ]));
                    return sized(function(size) {
                        var $237 = size <= 1;
                        if ($237) return small;
                        return large;
                    });
                };
            };
        };
    };
};
var $83c00c10ef0626d4$var$genE = function(dictApplicative) {
    var Apply0 = dictApplicative.Apply0();
    var apply = $a5g3C.apply(Apply0);
    var map1 = $l0wDR.map(Apply0.Functor0());
    return function(dictMonadGen) {
        return function(dictMonadRec) {
            var genAlphaString = $79GDW.genAlphaString(dictMonadRec)(dictMonadGen);
            var unfoldable = $8D18I.unfoldable(dictMonadRec)(dictMonadGen)($hsyEi.unfoldableArray);
            return function(genClos) {
                var genEntry = apply(map1(function(v) {
                    return function(v1) {
                        return {
                            name: v,
                            value: v1
                        };
                    };
                })(genAlphaString))(genClos);
                return unfoldable(genEntry);
            };
        };
    };
};
var $83c00c10ef0626d4$var$genC = function(dictApplicative) {
    var Apply0 = dictApplicative.Apply0();
    var apply = $a5g3C.apply(Apply0);
    var map1 = $l0wDR.map(Apply0.Functor0());
    return function(dictMonadRec) {
        return function(dictMonadGen) {
            return function(genExpr) {
                return function(genEnv) {
                    return apply(map1(function(v) {
                        return function(v1) {
                            return {
                                target: v,
                                environment: v1
                            };
                        };
                    })(genExpr))(genEnv);
                };
            };
        };
    };
};
var $83c00c10ef0626d4$export$20a75346d120c232 = function(dictApplicative) {
    var genC1 = $83c00c10ef0626d4$var$genC(dictApplicative);
    var genE1 = $83c00c10ef0626d4$var$genE(dictApplicative);
    return function(dictMonadRec) {
        var genC2 = genC1(dictMonadRec);
        var generator = $jHZNn.generator(dictMonadRec);
        return function(dictMonadGen) {
            var genC3 = genC2(dictMonadGen);
            var resize = $kUmUH.resize(dictMonadGen);
            var generator1 = generator(dictMonadGen);
            var genE2 = genE1(dictMonadGen)(dictMonadRec);
            return function(dictLazy) {
                var half = function(n) {
                    return $6pI6x.quot(n)(2);
                };
                return $dTFzl.fix(dictLazy)(function(gc) {
                    return genC3(resize(half)(generator1))(genE2(resize(half)(gc)));
                });
            };
        };
    };
};
var $83c00c10ef0626d4$export$144c3f0460c4e970 = function(dictApplicative) {
    var genE1 = $83c00c10ef0626d4$var$genE(dictApplicative);
    var genC1 = $83c00c10ef0626d4$var$genC(dictApplicative);
    return function(dictMonadRec) {
        var genC2 = genC1(dictMonadRec);
        var generator = $jHZNn.generator(dictMonadRec);
        return function(dictMonadGen) {
            var genE2 = genE1(dictMonadGen)(dictMonadRec);
            var genC3 = genC2(dictMonadGen);
            var generator1 = generator(dictMonadGen);
            var resize = $kUmUH.resize(dictMonadGen);
            return function(dictLazy) {
                return $dTFzl.fix(dictLazy)(function(ge) {
                    return genE2(genC3(generator1)(resize(function($304) {
                        return $c8kPS.trunc($deaB6.sqrt($6pI6x.toNumber($83c00c10ef0626d4$var$pred($304))));
                    })(ge)));
                });
            };
        };
    };
};
var $83c00c10ef0626d4$export$eb06a0c8d5ce8c7d = function(dictMonadRec) {
    var genKont1 = $83c00c10ef0626d4$var$genKont(dictMonadRec);
    var generator = $jHZNn.generator(dictMonadRec);
    return function(dictMonadGen) {
        var genKont2 = genKont1(dictMonadGen);
        var generator1 = generator(dictMonadGen);
        var genEnvironment1 = $83c00c10ef0626d4$export$144c3f0460c4e970(dictMonadGen.Monad0().Applicative0())(dictMonadRec)(dictMonadGen);
        return function(dictLazy) {
            return function(dictLazy1) {
                var genEnvironment2 = genEnvironment1(dictLazy1);
                return function(dictLazy2) {
                    return $dTFzl.fix(dictLazy2)(genKont2(generator1)(genEnvironment2));
                };
            };
        };
    };
};
var $83c00c10ef0626d4$var$displayEnvironment = function(env) {
    var displayClosure = function(v) {
        return [
            $jHZNn.render(v.target),
            $83c00c10ef0626d4$var$displayEnvironment(v.environment)
        ];
    };
    var displayEntry = function(ent) {
        return $jIMHU.tr([
            $cLQJF.class_("environment-entry")
        ])([
            $jIMHU.td_([
                $hhMAk.text(ent.name)
            ]),
            $jIMHU.td([
                $cLQJF.class_("environment-closure")
            ])(displayClosure(ent.value))
        ]);
    };
    var $243 = $4VF0K.null(env);
    if ($243) return $jIMHU.div([
        $cLQJF.class_("environment-empty")
    ])([
        $hhMAk.text("<empty>")
    ]);
    return $jIMHU.table([
        $cLQJF.class_("environment-nonEmpty")
    ])([
        $jIMHU.thead_([
            $jIMHU.tr_([
                $jIMHU.th_([
                    $hhMAk.text("Name")
                ]),
                $jIMHU.th_([
                    $hhMAk.text("Value")
                ])
            ])
        ]),
        $jIMHU.tbody_($83c00c10ef0626d4$var$map(displayEntry)(env))
    ]);
};
var $83c00c10ef0626d4$var$displayKontinuation = function(kont) {
    var andThen = $hhMAk.text(", and then...");
    var kontArray = function(v) {
        if (v instanceof $83c00c10ef0626d4$export$7fe28cb29e71bf10) return [
            $jIMHU.li_([
                $hhMAk.text("evaluation is complete.")
            ])
        ];
        if (v instanceof $83c00c10ef0626d4$export$367616366844a674) return $4VF0K.cons($jIMHU.li_([
            $hhMAk.text("evaluate the argument"),
            $jHZNn.render(v.value0.argument),
            $hhMAk.text("in the environment"),
            $83c00c10ef0626d4$var$displayEnvironment(v.value0.environment),
            $hhMAk.text("and apply the current result to it"),
            andThen
        ]))(kontArray(v.value0.next));
        if (v instanceof $83c00c10ef0626d4$export$5958d2a478bf80a9) return $4VF0K.cons($jIMHU.li_([
            $hhMAk.text("evaluate the function body"),
            $jHZNn.render(v.value0.abstraction.body),
            $hhMAk.text("in the envionrment"),
            $83c00c10ef0626d4$var$displayEnvironment(v.value0.environment),
            $hhMAk.text("extended by binding the current result to " + $83c00c10ef0626d4$var$show(v.value0.abstraction.binder)),
            andThen
        ]))(kontArray(v.value0.next));
        throw new Error("Failed pattern match at CEK (line 269, column 3 - line 269, column 62): " + [
            v.constructor.name
        ]);
    };
    return $jIMHU.ol([
        $cLQJF.class_("kontinuation")
    ])(kontArray(kont));
};
var $83c00c10ef0626d4$var$displayMachineState = function(st) {
    return $jIMHU.table([
        $cLQJF.class_("machine-state")
    ])([
        $jIMHU.thead_([
            $jIMHU.tr_([
                $jIMHU.th_([
                    $hhMAk.text("Control")
                ]),
                $jIMHU.th_([
                    $hhMAk.text("Environment")
                ]),
                $jIMHU.th_([
                    $hhMAk.text("Kontinuation")
                ])
            ])
        ]),
        $jIMHU.tbody_([
            $jIMHU.tr_([
                $jIMHU.td_([
                    $jHZNn.render(st.control)
                ]),
                $jIMHU.td_([
                    $83c00c10ef0626d4$var$displayEnvironment(st.environment)
                ]),
                $jIMHU.td_([
                    $83c00c10ef0626d4$var$displayKontinuation(st.kontinuation)
                ])
            ])
        ])
    ]);
};
var $83c00c10ef0626d4$var$cekStep = function(dictMonadThrow) {
    var throwError = $84kZf.throwError(dictMonadThrow);
    var pure1 = $gUTA8.pure(dictMonadThrow.Monad0().Applicative0());
    return function(v) {
        return function(v1) {
            return function(v2) {
                if (v instanceof $jHZNn.Variable) {
                    var onEntry = function(ent) {
                        var $250 = v.value0 === ent.name;
                        if ($250) return new $ykHdR.Just(ent.value);
                        return $ykHdR.Nothing.value;
                    };
                    var onClosure = function(v3) {
                        return {
                            control: v3.target,
                            environment: v3.environment,
                            kontinuation: v2
                        };
                    };
                    return $ykHdR.maybe(throwError(new $83c00c10ef0626d4$var$VariableNotFound({
                        name: v.value0,
                        environment: v1
                    })))(function($305) {
                        return pure1($aKY4H.Right.create(onClosure($305)));
                    })($4VF0K.findMap(onEntry)(v1));
                }
                if (v instanceof $jHZNn.Application) return pure1(new $aKY4H.Right({
                    control: v["value0"]["function"],
                    environment: v1,
                    kontinuation: new $83c00c10ef0626d4$export$367616366844a674({
                        argument: v.value0.argument,
                        environment: v1,
                        next: v2
                    })
                }));
                if (v2 instanceof $83c00c10ef0626d4$export$7fe28cb29e71bf10) return pure1(new $aKY4H.Left(v));
                if (v instanceof $jHZNn.Abstraction && v2 instanceof $83c00c10ef0626d4$export$367616366844a674) return pure1(new $aKY4H.Right({
                    control: v2.value0.argument,
                    environment: v2.value0.environment,
                    kontinuation: new $83c00c10ef0626d4$export$5958d2a478bf80a9({
                        abstraction: {
                            binder: v.value0.binder,
                            body: v.value0.body
                        },
                        environment: v1,
                        next: v2.value0.next
                    })
                }));
                if (v2 instanceof $83c00c10ef0626d4$export$5958d2a478bf80a9) return pure1(new $aKY4H.Right({
                    control: v2.value0.abstraction.body,
                    environment: $4VF0K.cons({
                        name: v2.value0.abstraction.binder,
                        value: {
                            target: v,
                            environment: v1
                        }
                    })(v2.value0.environment),
                    kontinuation: v2.value0.next
                }));
                throw new Error("Failed pattern match at CEK (line 196, column 1 - line 202, column 31): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    };
};
var $83c00c10ef0626d4$var$cekStep1 = /* #__PURE__ */ $83c00c10ef0626d4$var$cekStep($84kZf.monadThrowEither);
var $83c00c10ef0626d4$export$a22bafc708fe09fb = function(x) {
    return function(v) {
        return function(et) {
            return function(k) {
                var ost = {
                    control: v.target,
                    environment: v.environment,
                    kontinuation: k
                };
                var e = $4VF0K.cons({
                    name: x,
                    value: v
                })(et);
                return $83c00c10ef0626d4$var$eq3(new $aKY4H.Right(new $aKY4H.Right(ost)))($83c00c10ef0626d4$var$cekStep1(new $jHZNn.Variable(x))(e)(k));
            };
        };
    };
};
var $83c00c10ef0626d4$export$d8556a2a8f973135 = /* #__PURE__ */ function() {
    var stepForward = function(st) {
        if (st instanceof $83c00c10ef0626d4$var$Uninitialized) return st;
        if (st instanceof $83c00c10ef0626d4$var$Working) {
            if (st.value0.future instanceof $amUgg.Nil) {
                var v = $83c00c10ef0626d4$var$cekStep1(st.value0.current.control)(st.value0.current.environment)(st.value0.current.kontinuation);
                if (v instanceof $aKY4H.Left) return new $83c00c10ef0626d4$var$Final({
                    initReverse: st.value0.previousReverse,
                    last: st.value0.current,
                    result: new $aKY4H.Left(v.value0)
                });
                if (v instanceof $aKY4H.Right) {
                    if (v.value0 instanceof $aKY4H.Left) return new $83c00c10ef0626d4$var$Final({
                        initReverse: st.value0.previousReverse,
                        last: st.value0.current,
                        result: new $aKY4H.Right(v.value0.value0)
                    });
                    if (v.value0 instanceof $aKY4H.Right) return new $83c00c10ef0626d4$var$Working({
                        previousReverse: new $amUgg.Cons(st.value0.current, st.value0.previousReverse),
                        current: v.value0.value0,
                        future: $amUgg.Nil.value
                    });
                    throw new Error("Failed pattern match at CEK (line 467, column 27 - line 476, column 20): " + [
                        v.value0.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at CEK (line 464, column 11 - line 476, column 20): " + [
                    v.constructor.name
                ]);
            }
            if (st.value0.future instanceof $amUgg.Cons) return new $83c00c10ef0626d4$var$Working({
                previousReverse: new $amUgg.Cons(st.value0.current, st.value0.previousReverse),
                current: st.value0.future.value0,
                future: st.value0.future.value1
            });
            throw new Error("Failed pattern match at CEK (line 461, column 19 - line 482, column 12): " + [
                st.value0.future.constructor.name
            ]);
        }
        if (st instanceof $83c00c10ef0626d4$var$Final) return st;
        if (st instanceof $83c00c10ef0626d4$var$Review) {
            if (st.value0.process.future instanceof $amUgg.Nil) return new $83c00c10ef0626d4$var$Final({
                initReverse: st.value0.process.previousReverse,
                last: st.value0.process.current,
                result: st.value0.result
            });
            if (st.value0.process.future instanceof $amUgg.Cons) return new $83c00c10ef0626d4$var$Review({
                result: st.value0.result,
                process: {
                    previousReverse: new $amUgg.Cons(st.value0.process.current, st.value0.process.previousReverse),
                    current: st.value0.process.future.value0,
                    future: st.value0.process.future.value1
                }
            });
            throw new Error("Failed pattern match at CEK (line 484, column 38 - line 499, column 16): " + [
                st.value0.process.future.constructor.name
            ]);
        }
        throw new Error("Failed pattern match at CEK (line 459, column 20 - line 499, column 16): " + [
            st.constructor.name
        ]);
    };
    var stepBack = function(st) {
        if (st instanceof $83c00c10ef0626d4$var$Uninitialized) return st;
        if (st instanceof $83c00c10ef0626d4$var$Working) return new $83c00c10ef0626d4$var$Working($83c00c10ef0626d4$var$lzInit(st.value0));
        if (st instanceof $83c00c10ef0626d4$var$Final) return new $83c00c10ef0626d4$var$Review({
            process: {
                previousReverse: st.value0.initReverse,
                current: st.value0.last,
                future: $amUgg.Nil.value
            },
            result: st.value0.result
        });
        if (st instanceof $83c00c10ef0626d4$var$Review) return new $83c00c10ef0626d4$var$Review({
            result: st.value0.result,
            process: $83c00c10ef0626d4$var$lzInit(st.value0.process)
        });
        throw new Error("Failed pattern match at CEK (line 445, column 17 - line 457, column 61): " + [
            st.constructor.name
        ]);
    };
    var render = function() {
        var controls = $jIMHU.div([
            $cLQJF.class_("cek-component-controls")
        ])([
            $jIMHU.button([
                $cLQJF.disabled(true)
            ])([
                $hhMAk.text("|<")
            ]),
            $jIMHU.button([
                $cLQJF.disabled(true)
            ])([
                $hhMAk.text("<<")
            ]),
            $jIMHU.button([
                $1qNv1.onClick($l4M7e.const($83c00c10ef0626d4$var$StepBack.value))
            ])([
                $hhMAk.text("<")
            ]),
            $jIMHU.button([
                $1qNv1.onClick($l4M7e.const($83c00c10ef0626d4$var$StepForward.value))
            ])([
                $hhMAk.text(">")
            ]),
            $jIMHU.button([
                $cLQJF.disabled(true)
            ])([
                $hhMAk.text(">>")
            ]),
            $jIMHU.button([
                $cLQJF.disabled(true)
            ])([
                $hhMAk.text(">>>")
            ]),
            $jIMHU.button([
                $cLQJF.disabled(true)
            ])([
                $hhMAk.text(">|")
            ])
        ]);
        return function(v) {
            if (v instanceof $83c00c10ef0626d4$var$Uninitialized) return $jIMHU.div([
                $cLQJF.class_("cek-component-uninitialized")
            ])([
                $hhMAk.text("No valid expression, yet.")
            ]);
            if (v instanceof $83c00c10ef0626d4$var$Working) return $jIMHU.div([
                $cLQJF.class_("cek-component-working")
            ])([
                controls,
                $83c00c10ef0626d4$var$displayMachineState(v.value0.current)
            ]);
            if (v instanceof $83c00c10ef0626d4$var$Final) {
                var displayResult = function(v1) {
                    if (v1 instanceof $aKY4H.Left) return $jIMHU.div([
                        $cLQJF.class_("cek-machine-error-variable-not-found")
                    ])([
                        $hhMAk.text("The variable "),
                        $hhMAk.text($83c00c10ef0626d4$var$show(v1.value0.value0.name)),
                        $hhMAk.text(" was not found in the environemnt:"),
                        $83c00c10ef0626d4$var$displayEnvironment(v1.value0.value0.environment)
                    ]);
                    if (v1 instanceof $aKY4H.Right) return $jHZNn.render(v1.value0);
                    throw new Error("Failed pattern match at CEK (line 404, column 23 - line 414, column 41): " + [
                        v1.constructor.name
                    ]);
                };
                return $jIMHU.div([
                    $cLQJF.class_("cek-component-final")
                ])([
                    controls,
                    displayResult(v.value0.result)
                ]);
            }
            if (v instanceof $83c00c10ef0626d4$var$Review) return $jIMHU.div([
                $cLQJF.class_("cek-component-review")
            ])([
                controls,
                $83c00c10ef0626d4$var$displayMachineState(v.value0.process.current)
            ]);
            throw new Error("Failed pattern match at CEK (line 390, column 12 - line 418, column 63): " + [
                v.constructor.name
            ]);
        };
    }();
    var handleQuery = function(v) {
        return $83c00c10ef0626d4$var$discard($83c00c10ef0626d4$var$put(new $83c00c10ef0626d4$var$Working({
            previousReverse: $amUgg.Nil.value,
            current: $83c00c10ef0626d4$var$initialMachineState(v),
            future: $amUgg.Nil.value
        })))(function() {
            return $83c00c10ef0626d4$var$pure($ykHdR.Nothing.value);
        });
    };
    var handleAction = function(act) {
        return $83c00c10ef0626d4$var$discard(function() {
            if (act instanceof $83c00c10ef0626d4$var$StepBack) return $83c00c10ef0626d4$var$modify_(stepBack);
            if (act instanceof $83c00c10ef0626d4$var$StepForward) return $83c00c10ef0626d4$var$modify_(stepForward);
            throw new Error("Failed pattern match at CEK (line 502, column 5 - line 504, column 41): " + [
                act.constructor.name
            ]);
        }())(function() {
            return $83c00c10ef0626d4$var$pure($r2HHk.unit);
        });
    };
    return $kugLX.mkComponent({
        initialState: $l4M7e.const($83c00c10ef0626d4$var$Uninitialized.value),
        render: render,
        "eval": $kugLX.mkEval({
            initialize: $ykHdR.Nothing.value,
            receive: $l4M7e.const($ykHdR.Nothing.value),
            handleAction: handleAction,
            handleQuery: handleQuery,
            finalize: $ykHdR.Nothing.value
        })
    });
}();

});
parcelRegister("1qNv1", function(module, exports) {

$parcel$export(module.exports, "onClick", () => $10ae9db6658426ac$export$1d5a917feb871989);
$parcel$export(module.exports, "onValueInput", () => $10ae9db6658426ac$export$4b31b9659da30fc9);
// Generated by purs version 0.15.16

var $9Grh5 = parcelRequire("9Grh5");

var $lssqB = parcelRequire("lssqB");

var $i2F6a = parcelRequire("i2F6a");

var $aKY4H = parcelRequire("aKY4H");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");

var $6VVZC = parcelRequire("6VVZC");

var $ykHdR = parcelRequire("ykHdR");

var $hsyEi = parcelRequire("hsyEi");
parcelRequire("k5Trf");
var $guZlc = parcelRequire("guZlc");

var $hiwiV = parcelRequire("hiwiV");

var $at47P = parcelRequire("at47P");

var $hhMAk = parcelRequire("hhMAk");

var $cVGsR = parcelRequire("cVGsR");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $74dhc = parcelRequire("74dhc");

var $3rLSJ = parcelRequire("3rLSJ");

var $72K4s = parcelRequire("72K4s");

var $drTzw = parcelRequire("drTzw");

var $d59zr = parcelRequire("d59zr");

var $iRNNV = parcelRequire("iRNNV");

var $czWbO = parcelRequire("czWbO");

var $d3Djj = parcelRequire("d3Djj");

var $akV2s = parcelRequire("akV2s");

var $8E7ak = parcelRequire("8E7ak");
var $10ae9db6658426ac$var$map = /* #__PURE__ */ $l0wDR.map($ykHdR.functorMaybe);
var $10ae9db6658426ac$var$composeKleisli = /* #__PURE__ */ $9Grh5.composeKleisli($ykHdR.bindMaybe);
var $10ae9db6658426ac$var$composeKleisliFlipped = /* #__PURE__ */ $9Grh5.composeKleisliFlipped(/* #__PURE__ */ $i2F6a.bindExceptT($6VVZC.monadIdentity));
var $10ae9db6658426ac$var$readProp = /* #__PURE__ */ $at47P.readProp($6VVZC.monadIdentity);
var $10ae9db6658426ac$var$readString = /* #__PURE__ */ $hiwiV.readString($6VVZC.monadIdentity);
var $10ae9db6658426ac$var$wheelHandler = $eOrGk.unsafeCoerce;
var $10ae9db6658426ac$var$touchHandler = $eOrGk.unsafeCoerce;
var $10ae9db6658426ac$var$mouseHandler = $eOrGk.unsafeCoerce;
var $10ae9db6658426ac$var$keyHandler = $eOrGk.unsafeCoerce;
var $10ae9db6658426ac$export$6b8360dd6fa5f18d = function(et) {
    return function(f) {
        return $hhMAk.handler(et)(function(ev) {
            return $10ae9db6658426ac$var$map($cVGsR.Action.create)(f(ev));
        });
    };
};
var $10ae9db6658426ac$export$c3c52e219617878 = function(et) {
    return function(f) {
        return $hhMAk.handler(et)(function(ev) {
            return new $ykHdR.Just(new $cVGsR.Action(f(ev)));
        });
    };
};
var $10ae9db6658426ac$export$d36091e57812e07 = /* #__PURE__ */ $10ae9db6658426ac$export$c3c52e219617878("abort");
var $10ae9db6658426ac$export$81738f2b2c64902d = /* #__PURE__ */ function() {
    var $13 = $10ae9db6658426ac$export$c3c52e219617878($akV2s.auxclick);
    return function($14) {
        return $13($10ae9db6658426ac$var$mouseHandler($14));
    };
}();
var $10ae9db6658426ac$export$bd913411069e59d3 = /* #__PURE__ */ $10ae9db6658426ac$export$c3c52e219617878($d59zr.change);
var $10ae9db6658426ac$export$1d5a917feb871989 = /* #__PURE__ */ function() {
    var $15 = $10ae9db6658426ac$export$c3c52e219617878($akV2s.click);
    return function($16) {
        return $15($10ae9db6658426ac$var$mouseHandler($16));
    };
}();
var $10ae9db6658426ac$export$12204e800775a4e0 = /* #__PURE__ */ function() {
    var $17 = $10ae9db6658426ac$export$c3c52e219617878($akV2s.dblclick);
    return function($18) {
        return $17($10ae9db6658426ac$var$mouseHandler($18));
    };
}();
var $10ae9db6658426ac$export$2288787135a8f66e = /* #__PURE__ */ $10ae9db6658426ac$export$c3c52e219617878($d59zr.error);
var $10ae9db6658426ac$export$83b89249c82cb32b = function(dictUnfoldable) {
    var none = $hsyEi.none(dictUnfoldable);
    var items = $72K4s.items(dictUnfoldable);
    return function(f) {
        return $10ae9db6658426ac$export$c3c52e219617878($d59zr.change)(function() {
            var $19 = $ykHdR.maybe(none)(items);
            var $20 = $10ae9db6658426ac$var$composeKleisli($3rLSJ.target)($10ae9db6658426ac$var$composeKleisli($iRNNV.fromEventTarget)(function($22) {
                return $guZlc.unsafePerformEffect($iRNNV.files($22));
            }));
            return function($21) {
                return f($19($20($21)));
            };
        }());
    };
};
var $10ae9db6658426ac$export$7fbc06d7c1beb512 = /* #__PURE__ */ $10ae9db6658426ac$export$c3c52e219617878($d59zr.input);
var $10ae9db6658426ac$export$ea9576bc99d1b7dd = /* #__PURE__ */ $10ae9db6658426ac$export$c3c52e219617878($d59zr.invalid);
var $10ae9db6658426ac$export$de8e1b1372cdb41b = /* #__PURE__ */ function() {
    var $23 = $10ae9db6658426ac$export$c3c52e219617878($d3Djj.keydown);
    return function($24) {
        return $23($10ae9db6658426ac$var$keyHandler($24));
    };
}();
var $10ae9db6658426ac$export$f144bbb6e186b14b = /* #__PURE__ */ function() {
    var $25 = $10ae9db6658426ac$export$c3c52e219617878($d3Djj.keyup);
    return function($26) {
        return $25($10ae9db6658426ac$var$keyHandler($26));
    };
}();
var $10ae9db6658426ac$export$4e4d8b287d028b6b = /* #__PURE__ */ $10ae9db6658426ac$export$c3c52e219617878($d59zr.load);
var $10ae9db6658426ac$export$6b09a96aed3f5178 = /* #__PURE__ */ function() {
    var $27 = $10ae9db6658426ac$export$c3c52e219617878($akV2s.mousedown);
    return function($28) {
        return $27($10ae9db6658426ac$var$mouseHandler($28));
    };
}();
var $10ae9db6658426ac$export$7c562fbb06b8dec3 = /* #__PURE__ */ function() {
    var $29 = $10ae9db6658426ac$export$c3c52e219617878($akV2s.mouseenter);
    return function($30) {
        return $29($10ae9db6658426ac$var$mouseHandler($30));
    };
}();
var $10ae9db6658426ac$export$f06e70624327ed63 = /* #__PURE__ */ function() {
    var $31 = $10ae9db6658426ac$export$c3c52e219617878($akV2s.mouseleave);
    return function($32) {
        return $31($10ae9db6658426ac$var$mouseHandler($32));
    };
}();
var $10ae9db6658426ac$export$4e8e585ca96adf5d = /* #__PURE__ */ function() {
    var $33 = $10ae9db6658426ac$export$c3c52e219617878($akV2s.mousemove);
    return function($34) {
        return $33($10ae9db6658426ac$var$mouseHandler($34));
    };
}();
var $10ae9db6658426ac$export$65a11040da641544 = /* #__PURE__ */ function() {
    var $35 = $10ae9db6658426ac$export$c3c52e219617878($akV2s.mouseout);
    return function($36) {
        return $35($10ae9db6658426ac$var$mouseHandler($36));
    };
}();
var $10ae9db6658426ac$export$afc474fdab5e8a8e = /* #__PURE__ */ function() {
    var $37 = $10ae9db6658426ac$export$c3c52e219617878($akV2s.mouseover);
    return function($38) {
        return $37($10ae9db6658426ac$var$mouseHandler($38));
    };
}();
var $10ae9db6658426ac$export$3df825bff4f0a835 = /* #__PURE__ */ function() {
    var $39 = $10ae9db6658426ac$export$c3c52e219617878($akV2s.mouseup);
    return function($40) {
        return $39($10ae9db6658426ac$var$mouseHandler($40));
    };
}();
var $10ae9db6658426ac$export$79fcb145cc53473e = /* #__PURE__ */ $10ae9db6658426ac$export$c3c52e219617878("reset");
var $10ae9db6658426ac$export$45b39e67d4ce4921 = /* #__PURE__ */ $10ae9db6658426ac$export$c3c52e219617878("resize");
var $10ae9db6658426ac$export$d4d89fd61e5416ee = /* #__PURE__ */ $10ae9db6658426ac$export$c3c52e219617878("scroll");
var $10ae9db6658426ac$export$2cc8197d6ae5570 = /* #__PURE__ */ $10ae9db6658426ac$export$c3c52e219617878($d59zr.select);
var $10ae9db6658426ac$export$307d29742c654737 = /* #__PURE__ */ $10ae9db6658426ac$export$c3c52e219617878("submit");
var $10ae9db6658426ac$export$931f312019b226f2 = /* #__PURE__ */ function() {
    var $41 = $10ae9db6658426ac$export$c3c52e219617878("touchcancel");
    return function($42) {
        return $41($10ae9db6658426ac$var$touchHandler($42));
    };
}();
var $10ae9db6658426ac$export$79b4bc20f2630414 = /* #__PURE__ */ function() {
    var $43 = $10ae9db6658426ac$export$c3c52e219617878("touchend");
    return function($44) {
        return $43($10ae9db6658426ac$var$touchHandler($44));
    };
}();
var $10ae9db6658426ac$export$e1ee796ca0d1f5fd = /* #__PURE__ */ function() {
    var $45 = $10ae9db6658426ac$export$c3c52e219617878("touchenter");
    return function($46) {
        return $45($10ae9db6658426ac$var$touchHandler($46));
    };
}();
var $10ae9db6658426ac$export$a8fb1c034c732052 = /* #__PURE__ */ function() {
    var $47 = $10ae9db6658426ac$export$c3c52e219617878("touchleave");
    return function($48) {
        return $47($10ae9db6658426ac$var$touchHandler($48));
    };
}();
var $10ae9db6658426ac$export$42c53271760d4595 = /* #__PURE__ */ function() {
    var $49 = $10ae9db6658426ac$export$c3c52e219617878("touchmove");
    return function($50) {
        return $49($10ae9db6658426ac$var$touchHandler($50));
    };
}();
var $10ae9db6658426ac$export$37cbf11924865552 = /* #__PURE__ */ function() {
    var $51 = $10ae9db6658426ac$export$c3c52e219617878("touchstart");
    return function($52) {
        return $51($10ae9db6658426ac$var$touchHandler($52));
    };
}();
var $10ae9db6658426ac$export$e967ac7bdb3c237c = /* #__PURE__ */ $10ae9db6658426ac$export$c3c52e219617878("transitionend");
var $10ae9db6658426ac$export$65ea24ac132a9be9 = /* #__PURE__ */ function() {
    var $53 = $10ae9db6658426ac$export$c3c52e219617878($8E7ak.wheel);
    return function($54) {
        return $53($10ae9db6658426ac$var$wheelHandler($54));
    };
}();
var $10ae9db6658426ac$var$focusHandler = $eOrGk.unsafeCoerce;
var $10ae9db6658426ac$export$5e446bc31724fca4 = /* #__PURE__ */ function() {
    var $55 = $10ae9db6658426ac$export$c3c52e219617878($d59zr.blur);
    return function($56) {
        return $55($10ae9db6658426ac$var$focusHandler($56));
    };
}();
var $10ae9db6658426ac$export$ecf9bf35ad97eb74 = /* #__PURE__ */ function() {
    var $57 = $10ae9db6658426ac$export$c3c52e219617878($czWbO.focus);
    return function($58) {
        return $57($10ae9db6658426ac$var$focusHandler($58));
    };
}();
var $10ae9db6658426ac$export$e9c0af77f352888d = /* #__PURE__ */ function() {
    var $59 = $10ae9db6658426ac$export$c3c52e219617878($czWbO.focusin);
    return function($60) {
        return $59($10ae9db6658426ac$var$focusHandler($60));
    };
}();
var $10ae9db6658426ac$export$299df4cb415b3de7 = /* #__PURE__ */ function() {
    var $61 = $10ae9db6658426ac$export$c3c52e219617878($czWbO.focusout);
    return function($62) {
        return $61($10ae9db6658426ac$var$focusHandler($62));
    };
}();
var $10ae9db6658426ac$var$dragHandler = $eOrGk.unsafeCoerce;
var $10ae9db6658426ac$export$11a07b18d6f8f6d2 = /* #__PURE__ */ function() {
    var $63 = $10ae9db6658426ac$export$c3c52e219617878($drTzw.drag);
    return function($64) {
        return $63($10ae9db6658426ac$var$dragHandler($64));
    };
}();
var $10ae9db6658426ac$export$8566066e92caa8a = /* #__PURE__ */ function() {
    var $65 = $10ae9db6658426ac$export$c3c52e219617878($drTzw.dragend);
    return function($66) {
        return $65($10ae9db6658426ac$var$dragHandler($66));
    };
}();
var $10ae9db6658426ac$export$e2ce2d097d95a991 = /* #__PURE__ */ function() {
    var $67 = $10ae9db6658426ac$export$c3c52e219617878($drTzw.dragenter);
    return function($68) {
        return $67($10ae9db6658426ac$var$dragHandler($68));
    };
}();
var $10ae9db6658426ac$export$5d99689eba023667 = /* #__PURE__ */ function() {
    var $69 = $10ae9db6658426ac$export$c3c52e219617878($drTzw.dragexit);
    return function($70) {
        return $69($10ae9db6658426ac$var$dragHandler($70));
    };
}();
var $10ae9db6658426ac$export$5280b1a9a538737a = /* #__PURE__ */ function() {
    var $71 = $10ae9db6658426ac$export$c3c52e219617878($drTzw.dragleave);
    return function($72) {
        return $71($10ae9db6658426ac$var$dragHandler($72));
    };
}();
var $10ae9db6658426ac$export$caca362e3b7795bf = /* #__PURE__ */ function() {
    var $73 = $10ae9db6658426ac$export$c3c52e219617878($drTzw.dragover);
    return function($74) {
        return $73($10ae9db6658426ac$var$dragHandler($74));
    };
}();
var $10ae9db6658426ac$export$b00174fdb6a6ab8f = /* #__PURE__ */ function() {
    var $75 = $10ae9db6658426ac$export$c3c52e219617878($drTzw.dragstart);
    return function($76) {
        return $75($10ae9db6658426ac$var$dragHandler($76));
    };
}();
var $10ae9db6658426ac$export$c052d596304c05ec = /* #__PURE__ */ function() {
    var $77 = $10ae9db6658426ac$export$c3c52e219617878($drTzw.drop);
    return function($78) {
        return $77($10ae9db6658426ac$var$dragHandler($78));
    };
}();
var $10ae9db6658426ac$var$clipboardHandler = $eOrGk.unsafeCoerce;
var $10ae9db6658426ac$export$f7fe233856e3c643 = /* #__PURE__ */ function() {
    var $79 = $10ae9db6658426ac$export$c3c52e219617878($74dhc.copy);
    return function($80) {
        return $79($10ae9db6658426ac$var$clipboardHandler($80));
    };
}();
var $10ae9db6658426ac$export$330ca67a316b532c = /* #__PURE__ */ function() {
    var $81 = $10ae9db6658426ac$export$c3c52e219617878($74dhc.cut);
    return function($82) {
        return $81($10ae9db6658426ac$var$clipboardHandler($82));
    };
}();
var $10ae9db6658426ac$export$48aae1120b60938a = /* #__PURE__ */ function() {
    var $83 = $10ae9db6658426ac$export$c3c52e219617878($74dhc.paste);
    return function($84) {
        return $83($10ae9db6658426ac$var$clipboardHandler($84));
    };
}();
var $10ae9db6658426ac$var$addForeignPropHandler = function(key) {
    return function(prop) {
        return function(reader) {
            return function(f) {
                var go = function(a) {
                    return $10ae9db6658426ac$var$composeKleisliFlipped(reader)($10ae9db6658426ac$var$readProp(prop))($hiwiV.unsafeToForeign(a));
                };
                return $10ae9db6658426ac$export$6b8360dd6fa5f18d(key)($10ae9db6658426ac$var$composeKleisli($3rLSJ.currentTarget)(function(e) {
                    return $aKY4H.either($l4M7e.const($ykHdR.Nothing.value))(function($85) {
                        return $ykHdR.Just.create(f($85));
                    })($lssqB.runExcept(go(e)));
                }));
            };
        };
    };
};
var $10ae9db6658426ac$export$1706e2dd89331370 = /* #__PURE__ */ $10ae9db6658426ac$var$addForeignPropHandler($d59zr.change)("checked")(/* #__PURE__ */ $hiwiV.readBoolean($6VVZC.monadIdentity));
var $10ae9db6658426ac$export$4a70483021db3500 = /* #__PURE__ */ $10ae9db6658426ac$var$addForeignPropHandler($d59zr.change)("selectedIndex")(/* #__PURE__ */ $hiwiV.readInt($6VVZC.monadIdentity));
var $10ae9db6658426ac$export$faef864395e27f71 = /* #__PURE__ */ $10ae9db6658426ac$var$addForeignPropHandler($d59zr.change)("value")($10ae9db6658426ac$var$readString);
var $10ae9db6658426ac$export$4b31b9659da30fc9 = /* #__PURE__ */ $10ae9db6658426ac$var$addForeignPropHandler($d59zr.input)("value")($10ae9db6658426ac$var$readString);

});
parcelRegister("lssqB", function(module, exports) {

$parcel$export(module.exports, "runExcept", () => $f9f243b94d1fc188$export$a25b8a8a37f2d1cd);
// Generated by purs version 0.15.16

var $84kZf = parcelRequire("84kZf");

var $i2F6a = parcelRequire("i2F6a");

var $6VVZC = parcelRequire("6VVZC");

var $6PW1p = parcelRequire("6PW1p");
var $f9f243b94d1fc188$var$unwrap = /* #__PURE__ */ $6PW1p.unwrap();
var $f9f243b94d1fc188$export$64f3cd24d850d401 = /* #__PURE__ */ $i2F6a.withExceptT($6VVZC.functorIdentity);
var $f9f243b94d1fc188$export$a25b8a8a37f2d1cd = function($3) {
    return $f9f243b94d1fc188$var$unwrap($i2F6a.runExceptT($3));
};
var $f9f243b94d1fc188$export$8e638b2c22277c65 = function(f) {
    return $i2F6a.mapExceptT(function($4) {
        return $6VVZC.Identity(f($f9f243b94d1fc188$var$unwrap($4)));
    });
};

});

parcelRegister("at47P", function(module, exports) {

$parcel$export(module.exports, "readProp", () => $79efcffe70231542$export$d133c026d013828b);
// Generated by purs version 0.15.16

var $3U260 = parcelRequire("3U260");

var $gUTA8 = parcelRequire("gUTA8");

var $9Grh5 = parcelRequire("9Grh5");

var $i2F6a = parcelRequire("i2F6a");

var $l4M7e = parcelRequire("l4M7e");

var $hiwiV = parcelRequire("hiwiV");
var $gILGT = parcelRequire("gILGT");
var $79efcffe70231542$var$unsafeReadProp = function(dictMonad) {
    var fail = $hiwiV.fail(dictMonad);
    var pure = $gUTA8.pure($i2F6a.applicativeExceptT(dictMonad));
    return function(k) {
        return function(value) {
            return $3U260.unsafeReadPropImpl(fail(new $hiwiV.TypeMismatch("object", $gILGT.typeOf(value))), pure, k, value);
        };
    };
};
var $79efcffe70231542$export$d133c026d013828b = function(dictMonad) {
    return $79efcffe70231542$var$unsafeReadProp(dictMonad);
};
var $79efcffe70231542$export$49ec5109fafd7888 = function(dictMonad) {
    return $79efcffe70231542$var$unsafeReadProp(dictMonad);
};
var $79efcffe70231542$export$bc3518d3f65cefd1 = function(dict) {
    return dict.ix;
};
var $79efcffe70231542$export$b610b8812bbcded9 = function(dict) {
    return dict.index;
};
var $79efcffe70231542$export$8e083630a1c429e2 = function(dictMonad) {
    var bindFlipped = $9Grh5.bindFlipped($i2F6a.bindExceptT(dictMonad));
    return {
        ix: function(dictIndex) {
            var index1 = $79efcffe70231542$export$b610b8812bbcded9(dictIndex);
            return function(f) {
                return function(i) {
                    return bindFlipped($l4M7e.flip(index1)(i))(f);
                };
            };
        }
    };
};
var $79efcffe70231542$export$5603d6456559ad27 = function(dictMonad) {
    return {
        ix: function(dictIndex) {
            return $79efcffe70231542$export$b610b8812bbcded9(dictIndex);
        }
    };
};
var $79efcffe70231542$var$hasPropertyImpl = function(v) {
    return function(v1) {
        if ($gILGT.isNull(v1)) return false;
        if ($gILGT.isUndefined(v1)) return false;
        if ($gILGT.typeOf(v1) === "object" || $gILGT.typeOf(v1) === "function") return $3U260.unsafeHasProperty(v, v1);
        return false;
    };
};
var $79efcffe70231542$export$bf9617eaf5d2451 = function(dict) {
    return dict.hasProperty;
};
var $79efcffe70231542$var$hasOwnPropertyImpl = function(v) {
    return function(v1) {
        if ($gILGT.isNull(v1)) return false;
        if ($gILGT.isUndefined(v1)) return false;
        if ($gILGT.typeOf(v1) === "object" || $gILGT.typeOf(v1) === "function") return $3U260.unsafeHasOwnProperty(v, v1);
        return false;
    };
};
var $79efcffe70231542$export$27e041b47b0d7594 = function(dictMonad) {
    return {
        index: $l4M7e.flip($79efcffe70231542$export$49ec5109fafd7888(dictMonad)),
        hasProperty: $79efcffe70231542$var$hasPropertyImpl,
        hasOwnProperty: $79efcffe70231542$var$hasOwnPropertyImpl,
        errorAt: $hiwiV.ErrorAtIndex.create
    };
};
var $79efcffe70231542$export$d60c33947aba4299 = function(dictMonad) {
    return {
        index: $l4M7e.flip($79efcffe70231542$export$d133c026d013828b(dictMonad)),
        hasProperty: $79efcffe70231542$var$hasPropertyImpl,
        hasOwnProperty: $79efcffe70231542$var$hasOwnPropertyImpl,
        errorAt: $hiwiV.ErrorAtProperty.create
    };
};
var $79efcffe70231542$export$5a15a386532a5ea4 = function(dict) {
    return dict.hasOwnProperty;
};
var $79efcffe70231542$export$6917a1a7c5a9c9cc = function(dict) {
    return dict.errorAt;
};

});
parcelRegister("3U260", function(module, exports) {

$parcel$export(module.exports, "unsafeReadPropImpl", () => $2d783a45bb716946$export$209a9e76e7f1bdd5);
$parcel$export(module.exports, "unsafeHasOwnProperty", () => $2d783a45bb716946$export$2c522840c892e8a);
$parcel$export(module.exports, "unsafeHasProperty", () => $2d783a45bb716946$export$c3f84ec7467d28a0);
function $2d783a45bb716946$export$209a9e76e7f1bdd5(f, s, key, value) {
    return value == null ? f : s(value[key]);
}
function $2d783a45bb716946$export$2c522840c892e8a(prop, value) {
    return Object.prototype.hasOwnProperty.call(value, prop);
}
function $2d783a45bb716946$export$c3f84ec7467d28a0(prop, value) {
    return prop in value;
}

});


parcelRegister("74dhc", function(module, exports) {

$parcel$export(module.exports, "paste", () => $5253348ec4f02e0c$export$9b6706c8686cfc8e);
$parcel$export(module.exports, "cut", () => $5253348ec4f02e0c$export$af2a99f971a346e6);
$parcel$export(module.exports, "copy", () => $5253348ec4f02e0c$export$784d13d8ee351f07);
// Generated by purs version 0.15.16
var $5253348ec4f02e0c$export$9b6706c8686cfc8e = "paste";
var $5253348ec4f02e0c$export$af2a99f971a346e6 = "cut";
var $5253348ec4f02e0c$export$784d13d8ee351f07 = "copy";
var $5253348ec4f02e0c$export$82e583f9eee21106 = "clipboardchange";

});

parcelRegister("3rLSJ", function(module, exports) {

$parcel$export(module.exports, "target", () => $2829090ac282514c$export$44271b4f0c6a3563);
$parcel$export(module.exports, "currentTarget", () => $2829090ac282514c$export$28b27b1605aa05ad);
// Generated by purs version 0.15.16

var $8Obsc = parcelRequire("8Obsc");

var $loxi1 = parcelRequire("loxi1");

var $4MBcA = parcelRequire("4MBcA");

var $ykHdR = parcelRequire("ykHdR");

var $T79xE = parcelRequire("T79xE");

var $d0PPW = parcelRequire("d0PPW");

var $6BpYS = parcelRequire("6BpYS");
parcelRequire("9Iupi");
var $2829090ac282514c$var$fromJust = /* #__PURE__ */ $ykHdR.fromJust();
var $2829090ac282514c$var$toEnum = /* #__PURE__ */ $loxi1.toEnum($6BpYS.boundedEnumEventPhase);
var $2829090ac282514c$export$3d7865934588d77e = function(x) {
    return x;
};
var $2829090ac282514c$export$44271b4f0c6a3563 = function($3) {
    return $T79xE.toMaybe($8Obsc._target($3));
};
var $2829090ac282514c$export$5c9c459b1e542b91 = $d0PPW.ordString;
var $2829090ac282514c$export$bbde49cc37df068e = {
    Coercible0: function() {
        return undefined;
    }
};
var $2829090ac282514c$export$adaf9bfc2029072d = function() {
    return function($4) {
        return $2829090ac282514c$var$fromJust($2829090ac282514c$var$toEnum($8Obsc.eventPhaseIndex($4)));
    };
};
var $2829090ac282514c$export$521449dd33bc9b79 = $4MBcA.eqString;
var $2829090ac282514c$export$28b27b1605aa05ad = function($5) {
    return $T79xE.toMaybe($8Obsc._currentTarget($5));
};

});
parcelRegister("8Obsc", function(module, exports) {

$parcel$export(module.exports, "_currentTarget", () => $669be0b5ad323ff1$export$c2cb7a6607e209d9);
$parcel$export(module.exports, "eventPhaseIndex", () => $669be0b5ad323ff1$export$751396ee394cb35f);
$parcel$export(module.exports, "_target", () => $669be0b5ad323ff1$export$e2c9f5456eee864);
function $669be0b5ad323ff1$export$a0e54c3daa7db493(e) {
    return e.bubbles;
}
function $669be0b5ad323ff1$export$95ff25b64c2b7c9d(e) {
    return e.cancelable;
}
function $669be0b5ad323ff1$export$c2cb7a6607e209d9(e) {
    return e.currentTarget;
}
function $669be0b5ad323ff1$export$6add31d873bb7f97(e) {
    return function() {
        return e.defaultPrevented;
    };
}
function $669be0b5ad323ff1$export$751396ee394cb35f(e) {
    return e.eventPhase;
}
function $669be0b5ad323ff1$export$e2c9f5456eee864(e) {
    return e.target;
}
function $669be0b5ad323ff1$export$c0dbb1ea68a069d3(e) {
    return e.timeStamp;
}
function $669be0b5ad323ff1$export$d4a6a4db5b31e621(e) {
    return e.type;
}
function $669be0b5ad323ff1$export$fa3b29edae795ef4(e) {
    return function() {
        return e.preventDefault();
    };
}
function $669be0b5ad323ff1$export$d5cb5f1c8a62fdf1(e) {
    return function() {
        return e.stopImmediatePropagation();
    };
}
function $669be0b5ad323ff1$export$51134cce184326b9(e) {
    return function() {
        return e.stopPropagation();
    };
}

});

parcelRegister("6BpYS", function(module, exports) {

$parcel$export(module.exports, "boundedEnumEventPhase", () => $4cea5a089b994203$export$9171e0cf0644640e);
// Generated by purs version 0.15.16

var $loxi1 = parcelRequire("loxi1");

var $ykHdR = parcelRequire("ykHdR");

var $6SDUu = parcelRequire("6SDUu");
var $4cea5a089b994203$export$57ca7e07b341709d = /* #__PURE__ */ function() {
    function None() {}
    None.value = new None();
    return None;
}();
var $4cea5a089b994203$export$7c1f271456e9da5c = /* #__PURE__ */ function() {
    function Capturing() {}
    Capturing.value = new Capturing();
    return Capturing;
}();
var $4cea5a089b994203$export$c9dfa296ffa718f3 = /* #__PURE__ */ function() {
    function AtTarget() {}
    AtTarget.value = new AtTarget();
    return AtTarget;
}();
var $4cea5a089b994203$export$afda6610fd3be704 = /* #__PURE__ */ function() {
    function Bubbling() {}
    Bubbling.value = new Bubbling();
    return Bubbling;
}();
var $4cea5a089b994203$export$87e393cb260cfe35 = function(v) {
    if (v === 0) return new $ykHdR.Just($4cea5a089b994203$export$57ca7e07b341709d.value);
    if (v === 1) return new $ykHdR.Just($4cea5a089b994203$export$7c1f271456e9da5c.value);
    if (v === 2) return new $ykHdR.Just($4cea5a089b994203$export$c9dfa296ffa718f3.value);
    if (v === 3) return new $ykHdR.Just($4cea5a089b994203$export$afda6610fd3be704.value);
    return $ykHdR.Nothing.value;
};
var $4cea5a089b994203$export$bf52d9629dd54342 = function(v) {
    if (v instanceof $4cea5a089b994203$export$57ca7e07b341709d) return 0;
    if (v instanceof $4cea5a089b994203$export$7c1f271456e9da5c) return 1;
    if (v instanceof $4cea5a089b994203$export$c9dfa296ffa718f3) return 2;
    if (v instanceof $4cea5a089b994203$export$afda6610fd3be704) return 3;
    throw new Error("Failed pattern match at Web.Event.EventPhase (line 40, column 3 - line 44, column 18): " + [
        v.constructor.name
    ]);
};
var $4cea5a089b994203$export$e7849b249d968c7d = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $4cea5a089b994203$export$57ca7e07b341709d && y instanceof $4cea5a089b994203$export$57ca7e07b341709d) return true;
            if (x instanceof $4cea5a089b994203$export$7c1f271456e9da5c && y instanceof $4cea5a089b994203$export$7c1f271456e9da5c) return true;
            if (x instanceof $4cea5a089b994203$export$c9dfa296ffa718f3 && y instanceof $4cea5a089b994203$export$c9dfa296ffa718f3) return true;
            if (x instanceof $4cea5a089b994203$export$afda6610fd3be704 && y instanceof $4cea5a089b994203$export$afda6610fd3be704) return true;
            return false;
        };
    }
};
var $4cea5a089b994203$export$2dff6326408f563 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $4cea5a089b994203$export$57ca7e07b341709d && y instanceof $4cea5a089b994203$export$57ca7e07b341709d) return $6SDUu.EQ.value;
            if (x instanceof $4cea5a089b994203$export$57ca7e07b341709d) return $6SDUu.LT.value;
            if (y instanceof $4cea5a089b994203$export$57ca7e07b341709d) return $6SDUu.GT.value;
            if (x instanceof $4cea5a089b994203$export$7c1f271456e9da5c && y instanceof $4cea5a089b994203$export$7c1f271456e9da5c) return $6SDUu.EQ.value;
            if (x instanceof $4cea5a089b994203$export$7c1f271456e9da5c) return $6SDUu.LT.value;
            if (y instanceof $4cea5a089b994203$export$7c1f271456e9da5c) return $6SDUu.GT.value;
            if (x instanceof $4cea5a089b994203$export$c9dfa296ffa718f3 && y instanceof $4cea5a089b994203$export$c9dfa296ffa718f3) return $6SDUu.EQ.value;
            if (x instanceof $4cea5a089b994203$export$c9dfa296ffa718f3) return $6SDUu.LT.value;
            if (y instanceof $4cea5a089b994203$export$c9dfa296ffa718f3) return $6SDUu.GT.value;
            if (x instanceof $4cea5a089b994203$export$afda6610fd3be704 && y instanceof $4cea5a089b994203$export$afda6610fd3be704) return $6SDUu.EQ.value;
            throw new Error("Failed pattern match at Web.Event.EventPhase (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $4cea5a089b994203$export$e7849b249d968c7d;
    }
};
var $4cea5a089b994203$export$1961ce3762a1f623 = {
    succ: /* #__PURE__ */ $loxi1.defaultSucc($4cea5a089b994203$export$87e393cb260cfe35)($4cea5a089b994203$export$bf52d9629dd54342),
    pred: /* #__PURE__ */ $loxi1.defaultPred($4cea5a089b994203$export$87e393cb260cfe35)($4cea5a089b994203$export$bf52d9629dd54342),
    Ord0: function() {
        return $4cea5a089b994203$export$2dff6326408f563;
    }
};
var $4cea5a089b994203$export$2c5501f89051a84e = /* #__PURE__ */ function() {
    return {
        bottom: $4cea5a089b994203$export$57ca7e07b341709d.value,
        top: $4cea5a089b994203$export$afda6610fd3be704.value,
        Ord0: function() {
            return $4cea5a089b994203$export$2dff6326408f563;
        }
    };
}();
var $4cea5a089b994203$export$9171e0cf0644640e = {
    cardinality: 4,
    toEnum: $4cea5a089b994203$export$87e393cb260cfe35,
    fromEnum: $4cea5a089b994203$export$bf52d9629dd54342,
    Bounded0: function() {
        return $4cea5a089b994203$export$2c5501f89051a84e;
    },
    Enum1: function() {
        return $4cea5a089b994203$export$1961ce3762a1f623;
    }
};

});


parcelRegister("72K4s", function(module, exports) {

$parcel$export(module.exports, "items", () => $520c7508336e9c23$export$17a1664ed1fb5d6f);
// Generated by purs version 0.15.16

var $bhWcP = parcelRequire("bhWcP");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");

var $ykHdR = parcelRequire("ykHdR");

var $T79xE = parcelRequire("T79xE");

var $9MxTl = parcelRequire("9MxTl");

var $hsyEi = parcelRequire("hsyEi");
var $520c7508336e9c23$var$map = /* #__PURE__ */ $l0wDR.map($ykHdR.functorMaybe);
var $520c7508336e9c23$export$7061c75fc5af8b7e = function(i) {
    var $5 = $bhWcP._item(i);
    return function($6) {
        return $T79xE.toMaybe($5($6));
    };
};
var $520c7508336e9c23$export$17a1664ed1fb5d6f = function(dictUnfoldable) {
    var unfoldr = $hsyEi.unfoldr(dictUnfoldable);
    return function(fl) {
        return unfoldr(function(i) {
            return $520c7508336e9c23$var$map($l4M7e.flip($9MxTl.Tuple.create)(i + 1 | 0))($520c7508336e9c23$export$7061c75fc5af8b7e(i)(fl));
        })(0);
    };
};

});
parcelRegister("bhWcP", function(module, exports) {

$parcel$export(module.exports, "_item", () => $837e6eb387618e21$export$613ce04884e90507);
function $837e6eb387618e21$export$f24224f1c91d8156(fileList) {
    return fileList.length;
}
function $837e6eb387618e21$export$613ce04884e90507(index) {
    return function(fileList) {
        return fileList.item(index);
    };
}

});


parcelRegister("drTzw", function(module, exports) {

$parcel$export(module.exports, "drop", () => $9ca8e76be04efe86$export$663103110d94aac9);
$parcel$export(module.exports, "dragstart", () => $9ca8e76be04efe86$export$dc0badfde684823c);
$parcel$export(module.exports, "dragover", () => $9ca8e76be04efe86$export$ced0a5bb82ba6aee);
$parcel$export(module.exports, "dragleave", () => $9ca8e76be04efe86$export$f58195b0ad38aa36);
$parcel$export(module.exports, "dragexit", () => $9ca8e76be04efe86$export$ddffa9b7b4c3e300);
$parcel$export(module.exports, "dragenter", () => $9ca8e76be04efe86$export$bf1ba5dda238dc20);
$parcel$export(module.exports, "dragend", () => $9ca8e76be04efe86$export$26ae3c90d367ea9a);
$parcel$export(module.exports, "drag", () => $9ca8e76be04efe86$export$d7d5d435647ed5a0);
// Generated by purs version 0.15.16
var $9ca8e76be04efe86$export$663103110d94aac9 = "drop";
var $9ca8e76be04efe86$export$dc0badfde684823c = "dragstart";
var $9ca8e76be04efe86$export$ced0a5bb82ba6aee = "dragover";
var $9ca8e76be04efe86$export$f58195b0ad38aa36 = "dragleave";
var $9ca8e76be04efe86$export$ddffa9b7b4c3e300 = "dragexit";
var $9ca8e76be04efe86$export$bf1ba5dda238dc20 = "dragenter";
var $9ca8e76be04efe86$export$26ae3c90d367ea9a = "dragend";
var $9ca8e76be04efe86$export$d7d5d435647ed5a0 = "drag";

});

parcelRegister("d59zr", function(module, exports) {

$parcel$export(module.exports, "select", () => $98632a8bc67f7e8c$export$2e6c959c16ff56b8);
$parcel$export(module.exports, "load", () => $98632a8bc67f7e8c$export$11e63f7b0f3d9900);
$parcel$export(module.exports, "invalid", () => $98632a8bc67f7e8c$export$9f85add0327f687e);
$parcel$export(module.exports, "input", () => $98632a8bc67f7e8c$export$b7e3ae3d7c15e42e);
$parcel$export(module.exports, "error", () => $98632a8bc67f7e8c$export$a3bc9b8ed74fc);
$parcel$export(module.exports, "domcontentloaded", () => $98632a8bc67f7e8c$export$ead50553077ff635);
$parcel$export(module.exports, "change", () => $98632a8bc67f7e8c$export$d8a7b8f475ec0161);
$parcel$export(module.exports, "blur", () => $98632a8bc67f7e8c$export$2cc7ff91bcacba5e);
// Generated by purs version 0.15.16
var $98632a8bc67f7e8c$export$117f7ddab482d006 = "unload";
var $98632a8bc67f7e8c$export$e03c1c3201ee8bb7 = "toggle";
var $98632a8bc67f7e8c$export$853c27de4ce0f746 = "submit";
var $98632a8bc67f7e8c$export$ddcffe0146c8f882 = "storage";
var $98632a8bc67f7e8c$export$2e6c959c16ff56b8 = "select";
var $98632a8bc67f7e8c$export$aad8462122ac592b = "reset";
var $98632a8bc67f7e8c$export$1427eba79b2ae340 = "readystatechange";
var $98632a8bc67f7e8c$export$504d7abb21fa8c9 = "progress";
var $98632a8bc67f7e8c$export$9b6706c8686cfc8e = "paste";
var $98632a8bc67f7e8c$export$6dd222fd9e8d7968 = "online";
var $98632a8bc67f7e8c$export$3b16d2a27b22a87a = "offline";
var $98632a8bc67f7e8c$export$a8ecead220dd38a6 = "message";
var $98632a8bc67f7e8c$export$dca0cefb631ec861 = "loadstart";
var $98632a8bc67f7e8c$export$ddc39cda6f909ee1 = "loadend";
var $98632a8bc67f7e8c$export$11e63f7b0f3d9900 = "load";
var $98632a8bc67f7e8c$export$8d5b9ac6cde54772 = "languagechange";
var $98632a8bc67f7e8c$export$9f85add0327f687e = "invalid";
var $98632a8bc67f7e8c$export$b7e3ae3d7c15e42e = "input";
var $98632a8bc67f7e8c$export$d7ddd398f22d79ef = "focus";
var $98632a8bc67f7e8c$export$a3bc9b8ed74fc = "error";
var $98632a8bc67f7e8c$export$ead50553077ff635 = "DOMContentLoaded";
var $98632a8bc67f7e8c$export$af2a99f971a346e6 = "cut";
var $98632a8bc67f7e8c$export$784d13d8ee351f07 = "copy";
var $98632a8bc67f7e8c$export$8360e631d277ea4d = "close";
var $98632a8bc67f7e8c$export$64ef1bee2b9504c1 = "click";
var $98632a8bc67f7e8c$export$d8a7b8f475ec0161 = "change";
var $98632a8bc67f7e8c$export$70b61ad426ddbe54 = "cancel";
var $98632a8bc67f7e8c$export$2cc7ff91bcacba5e = "blur";
var $98632a8bc67f7e8c$export$26ecb34e09d46df7 = "beforescriptexecute";
var $98632a8bc67f7e8c$export$ad2ab82a6fc787c7 = "beforeprint";
var $98632a8bc67f7e8c$export$7af6a91a06bd66bd = "afterscriptexecute";
var $98632a8bc67f7e8c$export$56890049c3283011 = "afterprint";
var $98632a8bc67f7e8c$export$5def58af4fd46132 = "abort";

});

parcelRegister("iRNNV", function(module, exports) {

$parcel$export(module.exports, "fromEventTarget", () => $dbc3cf4ed216a106$export$a0a0bf09b44710c9);
$parcel$export(module.exports, "files", () => $dbc3cf4ed216a106$export$3a444357c5f65f65);
// Generated by purs version 0.15.16

var $2Zecj = parcelRequire("2Zecj");

var $l0wDR = parcelRequire("l0wDR");

var $T79xE = parcelRequire("T79xE");

var $9hRVP = parcelRequire("9hRVP");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $gxdyz = parcelRequire("gxdyz");

var $6EJMX = parcelRequire("6EJMX");
var $dbc3cf4ed216a106$var$map = /* #__PURE__ */ $l0wDR.map($9hRVP.functorEffect);
var $dbc3cf4ed216a106$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $dbc3cf4ed216a106$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $dbc3cf4ed216a106$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $dbc3cf4ed216a106$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $dbc3cf4ed216a106$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $dbc3cf4ed216a106$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $dbc3cf4ed216a106$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $dbc3cf4ed216a106$export$daa292563bc4c5ef = $2Zecj.stepUpBy;
var $dbc3cf4ed216a106$export$218b3ebffb5cc7e4 = /* #__PURE__ */ $dbc3cf4ed216a106$export$daa292563bc4c5ef(1);
var $dbc3cf4ed216a106$export$6dd86ef1ac84105c = $2Zecj.stepDownBy;
var $dbc3cf4ed216a106$export$d45ac0df5909f3e5 = /* #__PURE__ */ $dbc3cf4ed216a106$export$6dd86ef1ac84105c(1);
var $dbc3cf4ed216a106$export$873e7fe8f20f100c = function(rpl) {
    return function(s) {
        return function(e) {
            return function(mode) {
                return function(area) {
                    return function() {
                        return $2Zecj._setRangeText(rpl, s, e, $gxdyz.print(mode), area);
                    };
                };
            };
        };
    };
};
var $dbc3cf4ed216a106$export$8837f4fc672e936d = /* #__PURE__ */ function() {
    var $2 = $dbc3cf4ed216a106$var$map($T79xE.toMaybe);
    return function($3) {
        return $2($2Zecj._list($3));
    };
}();
var $dbc3cf4ed216a106$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLInputElement");
var $dbc3cf4ed216a106$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLInputElement");
var $dbc3cf4ed216a106$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLInputElement");
var $dbc3cf4ed216a106$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLInputElement");
var $dbc3cf4ed216a106$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLInputElement");
var $dbc3cf4ed216a106$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLInputElement");
var $dbc3cf4ed216a106$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLInputElement");
var $dbc3cf4ed216a106$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $4 = $dbc3cf4ed216a106$var$map($T79xE.toMaybe);
    return function($5) {
        return $4($2Zecj._form($5));
    };
}();
var $dbc3cf4ed216a106$export$3a444357c5f65f65 = /* #__PURE__ */ function() {
    var $6 = $dbc3cf4ed216a106$var$map($T79xE.toMaybe);
    return function($7) {
        return $6($2Zecj._files($7));
    };
}();

});
parcelRegister("2Zecj", function(module, exports) {

$parcel$export(module.exports, "_form", () => $22cc4a9f2b8eb096$export$242c63e9758836c2);
$parcel$export(module.exports, "_files", () => $22cc4a9f2b8eb096$export$92d18e9db2d4e896);
$parcel$export(module.exports, "_list", () => $22cc4a9f2b8eb096$export$8932efb87fe83757);
$parcel$export(module.exports, "stepUpBy", () => $22cc4a9f2b8eb096$export$801b713d5ecf6e3f);
$parcel$export(module.exports, "stepDownBy", () => $22cc4a9f2b8eb096$export$228be912dbc8075f);
$parcel$export(module.exports, "_setRangeText", () => $22cc4a9f2b8eb096$export$309b5632e9b49193);
function $22cc4a9f2b8eb096$export$73f57eecff448cc8(input) {
    return function() {
        return input.accept;
    };
}
function $22cc4a9f2b8eb096$export$b20dfae471de8dc1(accept) {
    return function(input) {
        return function() {
            input.accept = accept;
        };
    };
}
function $22cc4a9f2b8eb096$export$228be17d80722ab(input) {
    return function() {
        return input.alt;
    };
}
function $22cc4a9f2b8eb096$export$14a0e7c2e6152665(alt) {
    return function(input) {
        return function() {
            input.alt = alt;
        };
    };
}
function $22cc4a9f2b8eb096$export$485ded5f26ebe08d(input) {
    return function() {
        return input.autocomplete;
    };
}
function $22cc4a9f2b8eb096$export$5fb7c729919301a5(autocomplete) {
    return function(input) {
        return function() {
            input.autocomplete = autocomplete;
        };
    };
}
function $22cc4a9f2b8eb096$export$4c47992fc278c9a0(input) {
    return function() {
        return input.autofocus;
    };
}
function $22cc4a9f2b8eb096$export$db2bbdcbda3d335e(autofocus) {
    return function(input) {
        return function() {
            input.autofocus = autofocus;
        };
    };
}
function $22cc4a9f2b8eb096$export$8f49a7e9e3141ccc(input) {
    return function() {
        return input.defaultChecked;
    };
}
function $22cc4a9f2b8eb096$export$63092561e9c9bec4(defaultChecked) {
    return function(input) {
        return function() {
            input.defaultChecked = defaultChecked;
        };
    };
}
function $22cc4a9f2b8eb096$export$b96bb35bc88d6fa(input) {
    return function() {
        return input.checked;
    };
}
function $22cc4a9f2b8eb096$export$d2270ed72c00a9b2(checked) {
    return function(input) {
        return function() {
            input.checked = checked;
        };
    };
}
function $22cc4a9f2b8eb096$export$9ebb36ddc946da55(input) {
    return function() {
        return input.dirName;
    };
}
function $22cc4a9f2b8eb096$export$e2460e55089b163d(dirName) {
    return function(input) {
        return function() {
            input.dirName = dirName;
        };
    };
}
function $22cc4a9f2b8eb096$export$683472f6198a076e(input) {
    return function() {
        return input.disabled;
    };
}
function $22cc4a9f2b8eb096$export$4532d31cef66d703(disabled) {
    return function(input) {
        return function() {
            input.disabled = disabled;
        };
    };
}
function $22cc4a9f2b8eb096$export$242c63e9758836c2(input) {
    return function() {
        return input.form;
    };
}
function $22cc4a9f2b8eb096$export$92d18e9db2d4e896(input) {
    return function() {
        return input.files;
    };
}
function $22cc4a9f2b8eb096$export$7e4d70bab1b5c4a0(input) {
    return function() {
        return input.formAction;
    };
}
function $22cc4a9f2b8eb096$export$577bb1d64e4c83b9(formAction) {
    return function(input) {
        return function() {
            input.formAction = formAction;
        };
    };
}
function $22cc4a9f2b8eb096$export$21f1c8008acfa9c0(input) {
    return function() {
        return input.formEnctype;
    };
}
function $22cc4a9f2b8eb096$export$346989dcff4ba18b(formEnctype) {
    return function(input) {
        return function() {
            input.formEnctype = formEnctype;
        };
    };
}
function $22cc4a9f2b8eb096$export$3f1ffee261a00124(input) {
    return function() {
        return input.formMethod;
    };
}
function $22cc4a9f2b8eb096$export$c38a1a871bb0e145(formMethod) {
    return function(input) {
        return function() {
            input.formMethod = formMethod;
        };
    };
}
function $22cc4a9f2b8eb096$export$87c857905fcc4a84(input) {
    return function() {
        return input.formNoValidate;
    };
}
function $22cc4a9f2b8eb096$export$ad9ff32d0af51586(formNoValidate) {
    return function(input) {
        return function() {
            input.formNoValidate = formNoValidate;
        };
    };
}
function $22cc4a9f2b8eb096$export$497949a0ae76184f(input) {
    return function() {
        return input.formTarget;
    };
}
function $22cc4a9f2b8eb096$export$4c7e983548149eb5(formTarget) {
    return function(input) {
        return function() {
            input.formTarget = formTarget;
        };
    };
}
function $22cc4a9f2b8eb096$export$ac607276a8fe9f0a(input) {
    return function() {
        return input.height;
    };
}
function $22cc4a9f2b8eb096$export$3f31360357be44e4(height) {
    return function(input) {
        return function() {
            input.height = height;
        };
    };
}
function $22cc4a9f2b8eb096$export$5a1fde3dfe3b3c2a(input) {
    return function() {
        return input.indeterminate;
    };
}
function $22cc4a9f2b8eb096$export$52735f1bbb810b6(indeterminate) {
    return function(input) {
        return function() {
            input.indeterminate = indeterminate;
        };
    };
}
function $22cc4a9f2b8eb096$export$8932efb87fe83757(input) {
    return function() {
        return input.list;
    };
}
function $22cc4a9f2b8eb096$export$8960430cfd85939f(input) {
    return function() {
        return input.max;
    };
}
function $22cc4a9f2b8eb096$export$b03015b7eb8a4a0d(max) {
    return function(input) {
        return function() {
            input.max = max;
        };
    };
}
function $22cc4a9f2b8eb096$export$c9f461152c658a8b(input) {
    return function() {
        return input.maxLength;
    };
}
function $22cc4a9f2b8eb096$export$45077a575ddd961f(maxLength) {
    return function(input) {
        return function() {
            input.maxLength = maxLength;
        };
    };
}
function $22cc4a9f2b8eb096$export$96ec731ed4dcb222(input) {
    return function() {
        return input.min;
    };
}
function $22cc4a9f2b8eb096$export$46d199234e678744(min) {
    return function(input) {
        return function() {
            input.min = min;
        };
    };
}
function $22cc4a9f2b8eb096$export$8fe860a115a1e636(input) {
    return function() {
        return input.minLength;
    };
}
function $22cc4a9f2b8eb096$export$2b867239766ba1e3(minLength) {
    return function(input) {
        return function() {
            input.minLength = minLength;
        };
    };
}
function $22cc4a9f2b8eb096$export$939ddaa3205df08e(input) {
    return function() {
        return input.multiple;
    };
}
function $22cc4a9f2b8eb096$export$be7c7381b31f2269(multiple) {
    return function(input) {
        return function() {
            input.multiple = multiple;
        };
    };
}
function $22cc4a9f2b8eb096$export$a8ff84c12d48cfa6(input) {
    return function() {
        return input.name;
    };
}
function $22cc4a9f2b8eb096$export$6cf3d710d3a367e5(name) {
    return function(input) {
        return function() {
            input.name = name;
        };
    };
}
function $22cc4a9f2b8eb096$export$24f82734ea047e6f(input) {
    return function() {
        return input.pattern;
    };
}
function $22cc4a9f2b8eb096$export$faed90dbedc3b6d5(pattern) {
    return function(input) {
        return function() {
            input.pattern = pattern;
        };
    };
}
function $22cc4a9f2b8eb096$export$c7187bbd1a7a9244(input) {
    return function() {
        return input.placeholder;
    };
}
function $22cc4a9f2b8eb096$export$645bf5697adfa088(placeholder) {
    return function(input) {
        return function() {
            input.placeholder = placeholder;
        };
    };
}
function $22cc4a9f2b8eb096$export$b2cbc93d4da94977(input) {
    return function() {
        return input.readOnly;
    };
}
function $22cc4a9f2b8eb096$export$62311ce54ddfc862(readOnly) {
    return function(input) {
        return function() {
            input.readOnly = readOnly;
        };
    };
}
function $22cc4a9f2b8eb096$export$a7a0278c004aac3f(input) {
    return function() {
        return input.required;
    };
}
function $22cc4a9f2b8eb096$export$47f9362469f346c4(required) {
    return function(input) {
        return function() {
            input.required = required;
        };
    };
}
function $22cc4a9f2b8eb096$export$346677f925de839c(input) {
    return function() {
        return input.size;
    };
}
function $22cc4a9f2b8eb096$export$1c70a6cc12bc0366(size) {
    return function(input) {
        return function() {
            input.size = size;
        };
    };
}
function $22cc4a9f2b8eb096$export$2e40c9e35e9506f4(input) {
    return function() {
        return input.src;
    };
}
function $22cc4a9f2b8eb096$export$5771e3a4c80da7df(src) {
    return function(input) {
        return function() {
            input.src = src;
        };
    };
}
function $22cc4a9f2b8eb096$export$35d34bc0ed591a92(input) {
    return function() {
        return input.step;
    };
}
function $22cc4a9f2b8eb096$export$5305615f76bbd5b5(step) {
    return function(input) {
        return function() {
            input.step = step;
        };
    };
}
function $22cc4a9f2b8eb096$export$d4a6a4db5b31e621(input) {
    return function() {
        return input.type;
    };
}
function $22cc4a9f2b8eb096$export$1bf7f05044e9c5cb(type) {
    return function(input) {
        return function() {
            input.type = type;
        };
    };
}
function $22cc4a9f2b8eb096$export$1a01ae0705bafd37(input) {
    return function() {
        return input.defaultValue;
    };
}
function $22cc4a9f2b8eb096$export$d8becbd7468e206f(defaultValue) {
    return function(input) {
        return function() {
            input.defaultValue = defaultValue;
        };
    };
}
function $22cc4a9f2b8eb096$export$2ab9a8f9f1186f14(input) {
    return function() {
        return input.value;
    };
}
function $22cc4a9f2b8eb096$export$80746c6bc6142fc8(value) {
    return function(input) {
        return function() {
            input.value = value;
        };
    };
}
function $22cc4a9f2b8eb096$export$f0d0381422fe3a76(input) {
    return function() {
        return input.valueAsDate;
    };
}
function $22cc4a9f2b8eb096$export$8dfa787857729211(valueAsDate) {
    return function(input) {
        return function() {
            input.valueAsDate = valueAsDate;
        };
    };
}
function $22cc4a9f2b8eb096$export$3e66e4a199ac841d(input) {
    return function() {
        return input.valueAsNumber;
    };
}
function $22cc4a9f2b8eb096$export$4f64bca7327fe0dc(valueAsNumber) {
    return function(input) {
        return function() {
            input.valueAsNumber = valueAsNumber;
        };
    };
}
function $22cc4a9f2b8eb096$export$7e3df82ee760448c(input) {
    return function() {
        return input.width;
    };
}
function $22cc4a9f2b8eb096$export$67f48e0594af05d(width) {
    return function(input) {
        return function() {
            input.width = width;
        };
    };
}
function $22cc4a9f2b8eb096$export$801b713d5ecf6e3f(n) {
    return function(input) {
        return function() {
            input.stepUp(n);
        };
    };
}
function $22cc4a9f2b8eb096$export$228be912dbc8075f(n) {
    return function(input) {
        return function() {
            input.stepDown(n);
        };
    };
}
function $22cc4a9f2b8eb096$export$5e55a9e709e8e020(input) {
    return function() {
        return input.willValidate;
    };
}
function $22cc4a9f2b8eb096$export$1bdd3f9a89b22594(input) {
    return function() {
        return input.validity;
    };
}
function $22cc4a9f2b8eb096$export$6ee4201e37a931e2(input) {
    return function() {
        return input.validationMessage;
    };
}
function $22cc4a9f2b8eb096$export$50d70f8cedc54453(input) {
    return function() {
        return input.checkValidity();
    };
}
function $22cc4a9f2b8eb096$export$b962d864c477cc49(input) {
    return function() {
        return input.reportValidity();
    };
}
function $22cc4a9f2b8eb096$export$6f569cb704992105(value) {
    return function(input) {
        return function() {
            input.setCustomValidity(value);
        };
    };
}
function $22cc4a9f2b8eb096$export$a238cb463698c900(input) {
    return function() {
        return input.labels;
    };
}
function $22cc4a9f2b8eb096$export$2e6c959c16ff56b8(input) {
    return function() {
        input.select();
    };
}
function $22cc4a9f2b8eb096$export$5e2f617ae845fb63(input) {
    return function() {
        return input.selectionStart;
    };
}
function $22cc4a9f2b8eb096$export$47b9c21811f199bd(selectionStart) {
    return function(input) {
        return function() {
            input.selectionStart = selectionStart;
        };
    };
}
function $22cc4a9f2b8eb096$export$1028be563f1155b2(input) {
    return function() {
        return input.selectionEnd;
    };
}
function $22cc4a9f2b8eb096$export$15d012c6be3c352(selectionEnd) {
    return function(input) {
        return function() {
            input.selectionEnd = selectionEnd;
        };
    };
}
function $22cc4a9f2b8eb096$export$b4e8aad052258154(input) {
    return function() {
        return input.selectionDirection;
    };
}
function $22cc4a9f2b8eb096$export$6ac306cb2c51a4e6(selectionDirection) {
    return function(input) {
        return function() {
            input.selectionDirection = selectionDirection;
        };
    };
}
function $22cc4a9f2b8eb096$export$2add2a46d1c1d557(replacement) {
    return function(input) {
        return function() {
            input.setRangeText(replacement);
        };
    };
}
function $22cc4a9f2b8eb096$export$309b5632e9b49193(replacement, start, end, selectionMode, textarea) {
    textarea.setRangeText(replacement, start, end, selectionMode);
}
function $22cc4a9f2b8eb096$export$3b045ac5f470d884(start) {
    return function(end) {
        return function(direction) {
            return function(input) {
                return function() {
                    input.setSelectionRange(start, end, direction, input);
                };
            };
        };
    };
}

});

parcelRegister("gxdyz", function(module, exports) {

$parcel$export(module.exports, "print", () => $c09a3e7cfbb6a57f$export$c2d084dc44961371);
// Generated by purs version 0.15.16

var $ykHdR = parcelRequire("ykHdR");

var $6SDUu = parcelRequire("6SDUu");
var $c09a3e7cfbb6a57f$export$8163af2a41fbee7 = /* #__PURE__ */ function() {
    function Preserve() {}
    Preserve.value = new Preserve();
    return Preserve;
}();
var $c09a3e7cfbb6a57f$export$ef9b1a59e592288f = /* #__PURE__ */ function() {
    function Select() {}
    Select.value = new Select();
    return Select;
}();
var $c09a3e7cfbb6a57f$export$568b89e600fc77eb = /* #__PURE__ */ function() {
    function Start() {}
    Start.value = new Start();
    return Start;
}();
var $c09a3e7cfbb6a57f$export$290d774e6bd35c9a = /* #__PURE__ */ function() {
    function End() {}
    End.value = new End();
    return End;
}();
var $c09a3e7cfbb6a57f$export$7e20bbef4bce8df9 = {
    show: function(v) {
        if (v instanceof $c09a3e7cfbb6a57f$export$8163af2a41fbee7) return "Preserve";
        if (v instanceof $c09a3e7cfbb6a57f$export$ef9b1a59e592288f) return "Select";
        if (v instanceof $c09a3e7cfbb6a57f$export$568b89e600fc77eb) return "Start";
        if (v instanceof $c09a3e7cfbb6a57f$export$290d774e6bd35c9a) return "End";
        throw new Error("Failed pattern match at Web.HTML.SelectionMode (line 17, column 10 - line 21, column 17): " + [
            v.constructor.name
        ]);
    }
};
var $c09a3e7cfbb6a57f$export$c2d084dc44961371 = function(v) {
    if (v instanceof $c09a3e7cfbb6a57f$export$8163af2a41fbee7) return "preserve";
    if (v instanceof $c09a3e7cfbb6a57f$export$ef9b1a59e592288f) return "select";
    if (v instanceof $c09a3e7cfbb6a57f$export$568b89e600fc77eb) return "start";
    if (v instanceof $c09a3e7cfbb6a57f$export$290d774e6bd35c9a) return "end";
    throw new Error("Failed pattern match at Web.HTML.SelectionMode (line 32, column 9 - line 36, column 15): " + [
        v.constructor.name
    ]);
};
var $c09a3e7cfbb6a57f$export$98e6a39c04603d36 = function(v) {
    if (v === "preserve") return new $ykHdR.Just($c09a3e7cfbb6a57f$export$8163af2a41fbee7.value);
    if (v === "select") return new $ykHdR.Just($c09a3e7cfbb6a57f$export$ef9b1a59e592288f.value);
    if (v === "start") return new $ykHdR.Just($c09a3e7cfbb6a57f$export$568b89e600fc77eb.value);
    if (v === "end") return new $ykHdR.Just($c09a3e7cfbb6a57f$export$290d774e6bd35c9a.value);
    return $ykHdR.Nothing.value;
};
var $c09a3e7cfbb6a57f$export$b299fa6c3cca1ee7 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $c09a3e7cfbb6a57f$export$8163af2a41fbee7 && y instanceof $c09a3e7cfbb6a57f$export$8163af2a41fbee7) return true;
            if (x instanceof $c09a3e7cfbb6a57f$export$ef9b1a59e592288f && y instanceof $c09a3e7cfbb6a57f$export$ef9b1a59e592288f) return true;
            if (x instanceof $c09a3e7cfbb6a57f$export$568b89e600fc77eb && y instanceof $c09a3e7cfbb6a57f$export$568b89e600fc77eb) return true;
            if (x instanceof $c09a3e7cfbb6a57f$export$290d774e6bd35c9a && y instanceof $c09a3e7cfbb6a57f$export$290d774e6bd35c9a) return true;
            return false;
        };
    }
};
var $c09a3e7cfbb6a57f$export$81b0e65721ff4cca = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $c09a3e7cfbb6a57f$export$8163af2a41fbee7 && y instanceof $c09a3e7cfbb6a57f$export$8163af2a41fbee7) return $6SDUu.EQ.value;
            if (x instanceof $c09a3e7cfbb6a57f$export$8163af2a41fbee7) return $6SDUu.LT.value;
            if (y instanceof $c09a3e7cfbb6a57f$export$8163af2a41fbee7) return $6SDUu.GT.value;
            if (x instanceof $c09a3e7cfbb6a57f$export$ef9b1a59e592288f && y instanceof $c09a3e7cfbb6a57f$export$ef9b1a59e592288f) return $6SDUu.EQ.value;
            if (x instanceof $c09a3e7cfbb6a57f$export$ef9b1a59e592288f) return $6SDUu.LT.value;
            if (y instanceof $c09a3e7cfbb6a57f$export$ef9b1a59e592288f) return $6SDUu.GT.value;
            if (x instanceof $c09a3e7cfbb6a57f$export$568b89e600fc77eb && y instanceof $c09a3e7cfbb6a57f$export$568b89e600fc77eb) return $6SDUu.EQ.value;
            if (x instanceof $c09a3e7cfbb6a57f$export$568b89e600fc77eb) return $6SDUu.LT.value;
            if (y instanceof $c09a3e7cfbb6a57f$export$568b89e600fc77eb) return $6SDUu.GT.value;
            if (x instanceof $c09a3e7cfbb6a57f$export$290d774e6bd35c9a && y instanceof $c09a3e7cfbb6a57f$export$290d774e6bd35c9a) return $6SDUu.EQ.value;
            throw new Error("Failed pattern match at Web.HTML.SelectionMode (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $c09a3e7cfbb6a57f$export$b299fa6c3cca1ee7;
    }
};

});


parcelRegister("czWbO", function(module, exports) {

$parcel$export(module.exports, "focusout", () => $9285e421afbabad0$export$d0dc5134b51e78ad);
$parcel$export(module.exports, "focusin", () => $9285e421afbabad0$export$e7fa4ea7f1bfcb53);
$parcel$export(module.exports, "focus", () => $9285e421afbabad0$export$d7ddd398f22d79ef);
// Generated by purs version 0.15.16
var $9285e421afbabad0$export$d0dc5134b51e78ad = "focusout";
var $9285e421afbabad0$export$e7fa4ea7f1bfcb53 = "focusin";
var $9285e421afbabad0$export$d7ddd398f22d79ef = "focus";
var $9285e421afbabad0$export$2cc7ff91bcacba5e = "blur";

});

parcelRegister("d3Djj", function(module, exports) {

$parcel$export(module.exports, "keyup", () => $981a0c6551e76cf0$export$d26052c770f81a55);
$parcel$export(module.exports, "keydown", () => $981a0c6551e76cf0$export$e65a0c4970da3025);
// Generated by purs version 0.15.16
var $981a0c6551e76cf0$export$d26052c770f81a55 = "keyup";
var $981a0c6551e76cf0$export$e65a0c4970da3025 = "keydown";

});

parcelRegister("akV2s", function(module, exports) {

$parcel$export(module.exports, "mouseup", () => $7868044d3d97cfc5$export$c367b5bd9b361db9);
$parcel$export(module.exports, "mouseover", () => $7868044d3d97cfc5$export$41b161f130dc7f9);
$parcel$export(module.exports, "mouseout", () => $7868044d3d97cfc5$export$c3a736a37c400eb8);
$parcel$export(module.exports, "mousemove", () => $7868044d3d97cfc5$export$6d0a9e0f4f73830a);
$parcel$export(module.exports, "mouseleave", () => $7868044d3d97cfc5$export$996a190879e3098b);
$parcel$export(module.exports, "mouseenter", () => $7868044d3d97cfc5$export$474cd8abd87e2f89);
$parcel$export(module.exports, "mousedown", () => $7868044d3d97cfc5$export$8b0cb8993e7a9391);
$parcel$export(module.exports, "dblclick", () => $7868044d3d97cfc5$export$efb8dd8d61939266);
$parcel$export(module.exports, "click", () => $7868044d3d97cfc5$export$64ef1bee2b9504c1);
$parcel$export(module.exports, "auxclick", () => $7868044d3d97cfc5$export$2991dd47f111a03b);
// Generated by purs version 0.15.16
var $7868044d3d97cfc5$export$c367b5bd9b361db9 = "mouseup";
var $7868044d3d97cfc5$export$41b161f130dc7f9 = "mouseover";
var $7868044d3d97cfc5$export$c3a736a37c400eb8 = "mouseout";
var $7868044d3d97cfc5$export$6d0a9e0f4f73830a = "mousemove";
var $7868044d3d97cfc5$export$996a190879e3098b = "mouseleave";
var $7868044d3d97cfc5$export$474cd8abd87e2f89 = "mouseenter";
var $7868044d3d97cfc5$export$8b0cb8993e7a9391 = "mousedown";
var $7868044d3d97cfc5$export$efb8dd8d61939266 = "dblclick";
var $7868044d3d97cfc5$export$64ef1bee2b9504c1 = "click";
var $7868044d3d97cfc5$export$2991dd47f111a03b = "auxclick";

});

parcelRegister("8E7ak", function(module, exports) {

$parcel$export(module.exports, "wheel", () => $64b79e1476c3e095$export$d3028820ea014224);
// Generated by purs version 0.15.16
var $64b79e1476c3e095$export$d3028820ea014224 = "wheel";

});



parcelRegister("khWlH", function(module, exports) {

$parcel$export(module.exports, "log", () => $ec52a8164fabd1b2$export$bef1f36f5486a6a3);
// Generated by purs version 0.15.16

var $gUTA8 = parcelRequire("gUTA8");

var $9Grh5 = parcelRequire("9Grh5");

var $kQlZ1 = parcelRequire("kQlZ1");
parcelRequire("ajVG6");
var $cGCmj = parcelRequire("cGCmj");
var $ajVG6 = parcelRequire("ajVG6");
var $ec52a8164fabd1b2$var$discard = /* #__PURE__ */ $9Grh5.discard($9Grh5.discardUnit);
var $ec52a8164fabd1b2$export$28709abf85ddce1d = function(dictMonadEffect) {
    var liftEffect = $kQlZ1.liftEffect(dictMonadEffect);
    return function(dictShow) {
        var $55 = $ajVG6.warnShow(dictShow);
        return function($56) {
            return liftEffect($55($56));
        };
    };
};
var $ec52a8164fabd1b2$export$c106dd0671a0fc2d = function(dictMonadEffect) {
    var $57 = $kQlZ1.liftEffect(dictMonadEffect);
    return function($58) {
        return $57($cGCmj.warn($58));
    };
};
var $ec52a8164fabd1b2$export$1694f226a9241aae = function(dictMonadEffect) {
    var $59 = $kQlZ1.liftEffect(dictMonadEffect);
    return function($60) {
        return $59($cGCmj.timeLog($60));
    };
};
var $ec52a8164fabd1b2$export$8f2977fb54cb3601 = function(dictMonadEffect) {
    var $61 = $kQlZ1.liftEffect(dictMonadEffect);
    return function($62) {
        return $61($cGCmj.timeEnd($62));
    };
};
var $ec52a8164fabd1b2$export$2da9be4cfdb689b1 = function(dictMonadEffect) {
    var $63 = $kQlZ1.liftEffect(dictMonadEffect);
    return function($64) {
        return $63($cGCmj.time($64));
    };
};
var $ec52a8164fabd1b2$export$9f43f5977f8d5609 = function(dictMonadEffect) {
    var liftEffect = $kQlZ1.liftEffect(dictMonadEffect);
    return function(dictShow) {
        var $65 = $ajVG6.logShow(dictShow);
        return function($66) {
            return liftEffect($65($66));
        };
    };
};
var $ec52a8164fabd1b2$export$bef1f36f5486a6a3 = function(dictMonadEffect) {
    var $67 = $kQlZ1.liftEffect(dictMonadEffect);
    return function($68) {
        return $67($cGCmj.log($68));
    };
};
var $ec52a8164fabd1b2$export$fc9467e2ad369291 = function(dictMonadEffect) {
    var liftEffect = $kQlZ1.liftEffect(dictMonadEffect);
    return function(dictShow) {
        var $69 = $ajVG6.infoShow(dictShow);
        return function($70) {
            return liftEffect($69($70));
        };
    };
};
var $ec52a8164fabd1b2$export$a80b3bd66acc52ff = function(dictMonadEffect) {
    var $71 = $kQlZ1.liftEffect(dictMonadEffect);
    return function($72) {
        return $71($cGCmj.info($72));
    };
};
var $ec52a8164fabd1b2$export$a57f3dfe595273e6 = function(dictMonadEffect) {
    return $kQlZ1.liftEffect(dictMonadEffect)($cGCmj.groupEnd);
};
var $ec52a8164fabd1b2$export$488ef8fb3416a29f = function(dictMonadEffect) {
    var $73 = $kQlZ1.liftEffect(dictMonadEffect);
    return function($74) {
        return $73($cGCmj.groupCollapsed($74));
    };
};
var $ec52a8164fabd1b2$export$e5e25fbcc1f7affe = function(dictMonadEffect) {
    var $75 = $kQlZ1.liftEffect(dictMonadEffect);
    return function($76) {
        return $75($cGCmj.group($76));
    };
};
var $ec52a8164fabd1b2$export$a188e271553f9211 = function(dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var Bind1 = Monad0.Bind1();
    var discard1 = $ec52a8164fabd1b2$var$discard(Bind1);
    var group1 = $ec52a8164fabd1b2$export$e5e25fbcc1f7affe(dictMonadEffect);
    var bind = $9Grh5.bind(Bind1);
    var groupEnd1 = $ec52a8164fabd1b2$export$a57f3dfe595273e6(dictMonadEffect);
    var pure = $gUTA8.pure(Monad0.Applicative0());
    return function(name) {
        return function(inner) {
            return discard1(group1(name))(function() {
                return bind(inner)(function(result) {
                    return discard1(groupEnd1)(function() {
                        return pure(result);
                    });
                });
            });
        };
    };
};
var $ec52a8164fabd1b2$export$cbd229996ecd7704 = function(dictMonadEffect) {
    var liftEffect = $kQlZ1.liftEffect(dictMonadEffect);
    return function(dictShow) {
        var $77 = $ajVG6.errorShow(dictShow);
        return function($78) {
            return liftEffect($77($78));
        };
    };
};
var $ec52a8164fabd1b2$export$a3bc9b8ed74fc = function(dictMonadEffect) {
    var $79 = $kQlZ1.liftEffect(dictMonadEffect);
    return function($80) {
        return $79($cGCmj.error($80));
    };
};
var $ec52a8164fabd1b2$export$18fab8ed91d044eb = function(dictMonadEffect) {
    var liftEffect = $kQlZ1.liftEffect(dictMonadEffect);
    return function(dictShow) {
        var $81 = $ajVG6.debugShow(dictShow);
        return function($82) {
            return liftEffect($81($82));
        };
    };
};
var $ec52a8164fabd1b2$export$1c9f709888824e05 = function(dictMonadEffect) {
    var $83 = $kQlZ1.liftEffect(dictMonadEffect);
    return function($84) {
        return $83($cGCmj.debug($84));
    };
};
var $ec52a8164fabd1b2$export$42ffd38884aecdac = function(dictMonadEffect) {
    return $kQlZ1.liftEffect(dictMonadEffect)($cGCmj.clear);
};

});
parcelRegister("ajVG6", function(module, exports) {

$parcel$export(module.exports, "warnShow", () => $78386b654cef599e$export$28709abf85ddce1d);
$parcel$export(module.exports, "logShow", () => $78386b654cef599e$export$9f43f5977f8d5609);
$parcel$export(module.exports, "infoShow", () => $78386b654cef599e$export$fc9467e2ad369291);
$parcel$export(module.exports, "errorShow", () => $78386b654cef599e$export$cbd229996ecd7704);
$parcel$export(module.exports, "debugShow", () => $78386b654cef599e$export$18fab8ed91d044eb);
$parcel$export(module.exports, "log", () => (parcelRequire("cGCmj")).log);
$parcel$export(module.exports, "warn", () => (parcelRequire("cGCmj")).warn);
$parcel$export(module.exports, "error", () => (parcelRequire("cGCmj")).error);
$parcel$export(module.exports, "info", () => (parcelRequire("cGCmj")).info);
$parcel$export(module.exports, "debug", () => (parcelRequire("cGCmj")).debug);
$parcel$export(module.exports, "time", () => (parcelRequire("cGCmj")).time);
$parcel$export(module.exports, "timeLog", () => (parcelRequire("cGCmj")).timeLog);
$parcel$export(module.exports, "timeEnd", () => (parcelRequire("cGCmj")).timeEnd);
$parcel$export(module.exports, "clear", () => (parcelRequire("cGCmj")).clear);
$parcel$export(module.exports, "group", () => (parcelRequire("cGCmj")).group);
$parcel$export(module.exports, "groupCollapsed", () => (parcelRequire("cGCmj")).groupCollapsed);
$parcel$export(module.exports, "groupEnd", () => (parcelRequire("cGCmj")).groupEnd);
// Generated by purs version 0.15.16

var $cGCmj = parcelRequire("cGCmj");

var $3Orkn = parcelRequire("3Orkn");
var $78386b654cef599e$export$28709abf85ddce1d = function(dictShow) {
    var show = $3Orkn.show(dictShow);
    return function(a) {
        return $cGCmj.warn(show(a));
    };
};
var $78386b654cef599e$export$9f43f5977f8d5609 = function(dictShow) {
    var show = $3Orkn.show(dictShow);
    return function(a) {
        return $cGCmj.log(show(a));
    };
};
var $78386b654cef599e$export$fc9467e2ad369291 = function(dictShow) {
    var show = $3Orkn.show(dictShow);
    return function(a) {
        return $cGCmj.info(show(a));
    };
};
var $78386b654cef599e$export$a188e271553f9211 = function(name) {
    return function(inner) {
        return function __do() {
            $cGCmj.group(name)();
            var result = inner();
            $cGCmj.groupEnd();
            return result;
        };
    };
};
var $78386b654cef599e$export$cbd229996ecd7704 = function(dictShow) {
    var show = $3Orkn.show(dictShow);
    return function(a) {
        return $cGCmj.error(show(a));
    };
};
var $78386b654cef599e$export$18fab8ed91d044eb = function(dictShow) {
    var show = $3Orkn.show(dictShow);
    return function(a) {
        return $cGCmj.debug(show(a));
    };
};

});
parcelRegister("cGCmj", function(module, exports) {

$parcel$export(module.exports, "log", () => $93c729927fdf3160$export$bef1f36f5486a6a3);
$parcel$export(module.exports, "warn", () => $93c729927fdf3160$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "error", () => $93c729927fdf3160$export$a3bc9b8ed74fc);
$parcel$export(module.exports, "info", () => $93c729927fdf3160$export$a80b3bd66acc52ff);
$parcel$export(module.exports, "debug", () => $93c729927fdf3160$export$1c9f709888824e05);
$parcel$export(module.exports, "time", () => $93c729927fdf3160$export$2da9be4cfdb689b1);
$parcel$export(module.exports, "timeLog", () => $93c729927fdf3160$export$1694f226a9241aae);
$parcel$export(module.exports, "timeEnd", () => $93c729927fdf3160$export$8f2977fb54cb3601);
$parcel$export(module.exports, "clear", () => $93c729927fdf3160$export$42ffd38884aecdac);
$parcel$export(module.exports, "group", () => $93c729927fdf3160$export$e5e25fbcc1f7affe);
$parcel$export(module.exports, "groupCollapsed", () => $93c729927fdf3160$export$488ef8fb3416a29f);
$parcel$export(module.exports, "groupEnd", () => $93c729927fdf3160$export$a57f3dfe595273e6);
const $93c729927fdf3160$export$bef1f36f5486a6a3 = function(s) {
    return function() {
        console.log(s);
    };
};
const $93c729927fdf3160$export$c106dd0671a0fc2d = function(s) {
    return function() {
        console.warn(s);
    };
};
const $93c729927fdf3160$export$a3bc9b8ed74fc = function(s) {
    return function() {
        console.error(s);
    };
};
const $93c729927fdf3160$export$a80b3bd66acc52ff = function(s) {
    return function() {
        console.info(s);
    };
};
const $93c729927fdf3160$export$1c9f709888824e05 = function(s) {
    return function() {
        console.debug(s);
    };
};
const $93c729927fdf3160$export$2da9be4cfdb689b1 = function(s) {
    return function() {
        console.time(s);
    };
};
const $93c729927fdf3160$export$1694f226a9241aae = function(s) {
    return function() {
        console.timeLog(s);
    };
};
const $93c729927fdf3160$export$8f2977fb54cb3601 = function(s) {
    return function() {
        console.timeEnd(s);
    };
};
const $93c729927fdf3160$export$42ffd38884aecdac = function() {
    console.clear();
};
const $93c729927fdf3160$export$e5e25fbcc1f7affe = function(s) {
    return function() {
        console.group(s);
    };
};
const $93c729927fdf3160$export$488ef8fb3416a29f = function(s) {
    return function() {
        console.groupCollapsed(s);
    };
};
const $93c729927fdf3160$export$a57f3dfe595273e6 = function() {
    console.groupEnd();
};

});



parcelRegister("dstJY", function(module, exports) {

$parcel$export(module.exports, "stepper", () => $9cc4f5c1ad3ea077$export$8bd74650e74ef8ff);
// Generated by purs version 0.15.16

var $32mKU = parcelRequire("32mKU");

var $e6cRy = parcelRequire("e6cRy");

var $gUTA8 = parcelRequire("gUTA8");

var $9Grh5 = parcelRequire("9Grh5");

var $kQAxW = parcelRequire("kQAxW");

var $2Mmje = parcelRequire("2Mmje");

var $4MBcA = parcelRequire("4MBcA");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");

var $cw1rg = parcelRequire("cw1rg");

var $ykHdR = parcelRequire("ykHdR");

var $aknDF = parcelRequire("aknDF");

var $d0PPW = parcelRequire("d0PPW");

var $iwqgS = parcelRequire("iwqgS");

var $3Orkn = parcelRequire("3Orkn");

var $7eHfd = parcelRequire("7eHfd");

var $9MxTl = parcelRequire("9MxTl");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");

var $7DusG = parcelRequire("7DusG");

var $kugLX = parcelRequire("kugLX");

var $d8Pe6 = parcelRequire("d8Pe6");

var $hhMAk = parcelRequire("hhMAk");

var $jIMHU = parcelRequire("jIMHU");

var $1qNv1 = parcelRequire("1qNv1");

var $cLQJF = parcelRequire("cLQJF");

var $bllhK = parcelRequire("bllhK");

var $h3hu6 = parcelRequire("h3hu6");
var $9cc4f5c1ad3ea077$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $9cc4f5c1ad3ea077$var$genericShowSum = /* #__PURE__ */ $7eHfd.genericShowSum(/* #__PURE__ */ $7eHfd.genericShowConstructor($7eHfd.genericShowArgsNoArguments)({
    reflectSymbol: function() {
        return "Beta";
    }
}));
var $9cc4f5c1ad3ea077$var$FunctionIsSymbol = {
    reflectSymbol: function() {
        return "Function";
    }
};
var $9cc4f5c1ad3ea077$var$instantiate1 = /* #__PURE__ */ $32mKU.instantiate1($e6cRy.monadBExpr);
var $9cc4f5c1ad3ea077$var$map = /* #__PURE__ */ $l0wDR.map($ykHdR.functorMaybe);
var $9cc4f5c1ad3ea077$var$bimap = /* #__PURE__ */ $2Mmje.bimap($2Mmje.bifunctorTuple);
var $9cc4f5c1ad3ea077$var$append = /* #__PURE__ */ $iwqgS.append($iwqgS.semigroupArray);
var $9cc4f5c1ad3ea077$var$nextStepperIsSymbol = {
    reflectSymbol: function() {
        return "nextStepper";
    }
};
var $9cc4f5c1ad3ea077$var$slot_ = /* #__PURE__ */ $d8Pe6.slot_()($9cc4f5c1ad3ea077$var$nextStepperIsSymbol)($d0PPW.ordUnit);
var $9cc4f5c1ad3ea077$var$mempty = /* #__PURE__ */ $aknDF.mempty($aknDF.monoidArray);
var $9cc4f5c1ad3ea077$var$discard = /* #__PURE__ */ $9Grh5.discard($9Grh5.discardUnit)($bllhK.bindHalogenM);
var $9cc4f5c1ad3ea077$var$put = /* #__PURE__ */ $kQAxW.put($bllhK.monadStateHalogenM);
var $9cc4f5c1ad3ea077$var$pure = /* #__PURE__ */ $gUTA8.pure($bllhK.applicativeHalogenM);
var $9cc4f5c1ad3ea077$var$bind = /* #__PURE__ */ $9Grh5.bind($bllhK.bindHalogenM);
var $9cc4f5c1ad3ea077$var$get = /* #__PURE__ */ $kQAxW.get($bllhK.monadStateHalogenM);
var $9cc4f5c1ad3ea077$var$$$void = /* #__PURE__ */ $l0wDR.void($bllhK.functorHalogenM);
var $9cc4f5c1ad3ea077$var$query = /* #__PURE__ */ $bllhK.query()($9cc4f5c1ad3ea077$var$nextStepperIsSymbol)($d0PPW.ordUnit);
var $9cc4f5c1ad3ea077$export$87f4bb7fc4bf2d59 = function(x) {
    return x;
};
var $9cc4f5c1ad3ea077$export$4637d999aac180ea = /* #__PURE__ */ function() {
    function Beta() {}
    Beta.value = new Beta();
    return Beta;
}();
var $9cc4f5c1ad3ea077$export$f3890eeaf6851387 = /* #__PURE__ */ function() {
    function $$Function(value0) {
        this.value0 = value0;
    }
    $$Function.create = function(value0) {
        return new $$Function(value0);
    };
    return $$Function;
}();
var $9cc4f5c1ad3ea077$export$c5b9d36ae97d4d5d = {
    to: function(x) {
        if (x instanceof $cw1rg.Inl) return $9cc4f5c1ad3ea077$export$4637d999aac180ea.value;
        if (x instanceof $cw1rg.Inr) return new $9cc4f5c1ad3ea077$export$f3890eeaf6851387(x.value0);
        throw new Error("Failed pattern match at Eval (line 33, column 1 - line 33, column 36): " + [
            x.constructor.name
        ]);
    },
    from: function(x) {
        if (x instanceof $9cc4f5c1ad3ea077$export$4637d999aac180ea) return new $cw1rg.Inl($cw1rg.NoArguments.value);
        if (x instanceof $9cc4f5c1ad3ea077$export$f3890eeaf6851387) return new $cw1rg.Inr(x.value0);
        throw new Error("Failed pattern match at Eval (line 33, column 1 - line 33, column 36): " + [
            x.constructor.name
        ]);
    }
};
var $9cc4f5c1ad3ea077$var$genericShow = /* #__PURE__ */ $7eHfd.genericShow($9cc4f5c1ad3ea077$export$c5b9d36ae97d4d5d);
var $9cc4f5c1ad3ea077$export$a7ed8bf31182f671 = {
    show: function(s) {
        return $9cc4f5c1ad3ea077$var$genericShow($9cc4f5c1ad3ea077$var$genericShowSum($7eHfd.genericShowConstructor($7eHfd.genericShowArgsArgument($9cc4f5c1ad3ea077$export$a7ed8bf31182f671))($9cc4f5c1ad3ea077$var$FunctionIsSymbol)))(s);
    }
};
var $9cc4f5c1ad3ea077$export$6ab77615e3cebe88 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $9cc4f5c1ad3ea077$export$4637d999aac180ea && y instanceof $9cc4f5c1ad3ea077$export$4637d999aac180ea) return true;
            if (x instanceof $9cc4f5c1ad3ea077$export$f3890eeaf6851387 && y instanceof $9cc4f5c1ad3ea077$export$f3890eeaf6851387) return $4MBcA.eq($9cc4f5c1ad3ea077$export$6ab77615e3cebe88)(x.value0)(y.value0);
            return false;
        };
    }
};
var $9cc4f5c1ad3ea077$var$eqTuple = /* #__PURE__ */ $9MxTl.eqTuple($9cc4f5c1ad3ea077$export$6ab77615e3cebe88);
var $9cc4f5c1ad3ea077$export$d82a1fa31a53ed1e = function(v) {
    if (v instanceof $e6cRy.Application) {
        if (v["value0"]["function"] instanceof $e6cRy.Abstraction) return new $ykHdR.Just(new $9MxTl.Tuple($9cc4f5c1ad3ea077$export$4637d999aac180ea.value, $9cc4f5c1ad3ea077$var$instantiate1(v.value0.argument)(v["value0"]["function"].value0.body)));
        return $9cc4f5c1ad3ea077$var$map($9cc4f5c1ad3ea077$var$bimap($9cc4f5c1ad3ea077$export$f3890eeaf6851387.create)(function($101) {
            return $e6cRy.Application.create(function(v1) {
                return {
                    argument: v.value0.argument,
                    "function": v1
                };
            }($101));
        }))($9cc4f5c1ad3ea077$export$d82a1fa31a53ed1e(v["value0"]["function"]));
    }
    if (v instanceof $e6cRy.Abstraction) return $ykHdR.Nothing.value;
    if (v instanceof $e6cRy.FreeVariable) return $ykHdR.Nothing.value;
    throw new Error("Failed pattern match at Eval (line 41, column 1 - line 44, column 45): " + [
        v.constructor.name
    ]);
};
var $9cc4f5c1ad3ea077$export$5c72d8c2586c4a3b = /* #__PURE__ */ $3Orkn.show($9cc4f5c1ad3ea077$export$a7ed8bf31182f671);
var $9cc4f5c1ad3ea077$export$83d0b60754095f14 = function(dictEq) {
    var eq = $4MBcA.eq($ykHdR.eqMaybe($9cc4f5c1ad3ea077$var$eqTuple($e6cRy.eqBExpr(dictEq))));
    return function(x) {
        return eq($ykHdR.Nothing.value)($9cc4f5c1ad3ea077$export$d82a1fa31a53ed1e(new $e6cRy.FreeVariable(x)));
    };
};
var $9cc4f5c1ad3ea077$export$b341a2e60881d7cc = function(dictEq) {
    var eq = $4MBcA.eq($ykHdR.eqMaybe($9cc4f5c1ad3ea077$var$eqTuple($e6cRy.eqBExpr(dictEq))));
    return function(x) {
        return function(argument) {
            return eq($ykHdR.Nothing.value)($9cc4f5c1ad3ea077$export$d82a1fa31a53ed1e(new $e6cRy.Application({
                "function": new $e6cRy.FreeVariable(x),
                argument: argument
            })));
        };
    };
};
var $9cc4f5c1ad3ea077$export$1011911aaa147ed0 = function(dictEq) {
    var eq = $4MBcA.eq($ykHdR.eqMaybe($9cc4f5c1ad3ea077$var$eqTuple($e6cRy.eqBExpr(dictEq))));
    return function(fun) {
        return function(arg) {
            return function(argument) {
                var funapp = new $e6cRy.Application({
                    "function": fun,
                    argument: arg
                });
                var expected = $9cc4f5c1ad3ea077$var$map($9cc4f5c1ad3ea077$var$bimap($9cc4f5c1ad3ea077$export$f3890eeaf6851387.create)(function($102) {
                    return $e6cRy.Application.create(function(v) {
                        return {
                            "function": v,
                            argument: argument
                        };
                    }($102));
                }))($9cc4f5c1ad3ea077$export$d82a1fa31a53ed1e(funapp));
                return eq(expected)($9cc4f5c1ad3ea077$export$d82a1fa31a53ed1e(new $e6cRy.Application({
                    "function": funapp,
                    argument: argument
                })));
            };
        };
    };
};
var $9cc4f5c1ad3ea077$export$6c3fdc99d4813ea4 = function(dictEq) {
    var eq = $4MBcA.eq($ykHdR.eqMaybe($9cc4f5c1ad3ea077$var$eqTuple($e6cRy.eqBExpr(dictEq))));
    return function(variableName) {
        return function(body) {
            return function(argument) {
                return eq(new $ykHdR.Just(new $9MxTl.Tuple($9cc4f5c1ad3ea077$export$4637d999aac180ea.value, $9cc4f5c1ad3ea077$var$instantiate1(argument)(body))))($9cc4f5c1ad3ea077$export$d82a1fa31a53ed1e(new $e6cRy.Application({
                    "function": new $e6cRy.Abstraction({
                        variableName: variableName,
                        body: body
                    }),
                    argument: argument
                })));
            };
        };
    };
};
var $9cc4f5c1ad3ea077$export$db48d2d14e304a61 = function(dictEq) {
    var eq = $4MBcA.eq($ykHdR.eqMaybe($9cc4f5c1ad3ea077$var$eqTuple($e6cRy.eqBExpr(dictEq))));
    return function(variableName) {
        return function(body) {
            return eq($ykHdR.Nothing.value)($9cc4f5c1ad3ea077$export$d82a1fa31a53ed1e(new $e6cRy.Abstraction({
                variableName: variableName,
                body: body
            })));
        };
    };
};
var $9cc4f5c1ad3ea077$export$9d215119613387a8 = /* #__PURE__ */ function() {
    return $h3hu6.Proxy.value;
}();
var $9cc4f5c1ad3ea077$var$$lazy_stepper = /* #__PURE__ */ $9cc4f5c1ad3ea077$var$$runtime_lazy("stepper", "Eval", function() {
    var render = function(v) {
        if (v instanceof $ykHdR.Nothing) return $hhMAk.text("No expression to evaluate, yet.");
        if (v instanceof $ykHdR.Just && v.value0 instanceof $ykHdR.Nothing) return $hhMAk.text("Expression in normal form (or stuck).");
        if (v instanceof $ykHdR.Just && v.value0 instanceof $ykHdR.Just) return $jIMHU.div([
            $cLQJF.class_("stepper")
        ])($9cc4f5c1ad3ea077$var$append([
            $jIMHU.span([
                $cLQJF.class_("stepper-prose")
            ])([
                $hhMAk.text("Next: "),
                $jIMHU.a([
                    $1qNv1.onClick($l4M7e.const($r2HHk.unit))
                ])([
                    $hhMAk.text($9cc4f5c1ad3ea077$export$5c72d8c2586c4a3b(v.value0.value0.value0.value0))
                ])
            ])
        ])(function() {
            if (v.value0.value0.value1) return [
                $jIMHU.div([
                    $cLQJF.class_("stepper-expr")
                ])([
                    $e6cRy.displayBExpr($7DusG.absurd)(v.value0.value0.value0.value1),
                    $9cc4f5c1ad3ea077$var$slot_($9cc4f5c1ad3ea077$export$9d215119613387a8)($r2HHk.unit)($9cc4f5c1ad3ea077$var$$lazy_stepper(91))($r2HHk.unit)
                ])
            ];
            return $9cc4f5c1ad3ea077$var$mempty;
        }()));
        throw new Error("Failed pattern match at Eval (line 77, column 3 - line 77, column 58): " + [
            v.constructor.name
        ]);
    };
    var handleQuery = function(v) {
        return $9cc4f5c1ad3ea077$var$discard($9cc4f5c1ad3ea077$var$put($ykHdR.Just.create(function() {
            var v1 = $9cc4f5c1ad3ea077$export$d82a1fa31a53ed1e(v);
            if (v1 instanceof $ykHdR.Nothing) return $ykHdR.Nothing.value;
            if (v1 instanceof $ykHdR.Just) return new $ykHdR.Just(new $9MxTl.Tuple(v1.value0, false));
            throw new Error("Failed pattern match at Eval (line 110, column 20 - line 112, column 43): " + [
                v1.constructor.name
            ]);
        }())))(function() {
            return $9cc4f5c1ad3ea077$var$pure($ykHdR.Nothing.value);
        });
    };
    var handleAction = function(unitIn) {
        return $9cc4f5c1ad3ea077$var$bind($9cc4f5c1ad3ea077$var$get)(function(state) {
            if (state instanceof $ykHdR.Just && state.value0 instanceof $ykHdR.Just && !state.value0.value0.value1) return $9cc4f5c1ad3ea077$var$discard($9cc4f5c1ad3ea077$var$put(new $ykHdR.Just(new $ykHdR.Just(new $9MxTl.Tuple(state.value0.value0.value0, true)))))(function() {
                return $9cc4f5c1ad3ea077$var$discard($9cc4f5c1ad3ea077$var$$$void($9cc4f5c1ad3ea077$var$query($9cc4f5c1ad3ea077$export$9d215119613387a8)($r2HHk.unit)($9MxTl.snd(state.value0.value0.value0))))(function() {
                    return $9cc4f5c1ad3ea077$var$pure(unitIn);
                });
            });
            return $9cc4f5c1ad3ea077$var$pure(unitIn);
        });
    };
    return $kugLX.mkComponent({
        initialState: $l4M7e.const($ykHdR.Nothing.value),
        render: render,
        "eval": $kugLX.mkEval({
            initialize: $ykHdR.Nothing.value,
            receive: $l4M7e.const($ykHdR.Nothing.value),
            handleAction: handleAction,
            handleQuery: handleQuery,
            finalize: $ykHdR.Nothing.value
        })
    });
});
var $9cc4f5c1ad3ea077$export$8bd74650e74ef8ff = /* #__PURE__ */ $9cc4f5c1ad3ea077$var$$lazy_stepper(64);

});
parcelRegister("d8Pe6", function(module, exports) {

$parcel$export(module.exports, "slot_", () => $9913c23e14d7f752$export$76bf64fc47d1f9ce);
$parcel$export(module.exports, "slot", () => $9913c23e14d7f752$export$103b78750979eead);
// Generated by purs version 0.15.16

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");

var $ykHdR = parcelRequire("ykHdR");

var $kugLX = parcelRequire("kugLX");

var $hhMAk = parcelRequire("hhMAk");

var $jIMHU = parcelRequire("jIMHU");

var $cLQJF = parcelRequire("cLQJF");

var $kKOpj = parcelRequire("kKOpj");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");
var $9913c23e14d7f752$var$componentSlot = /* #__PURE__ */ $kugLX.componentSlot();
var $9913c23e14d7f752$var$map = /* #__PURE__ */ $l0wDR.map($l0wDR.functorFn);
var $9913c23e14d7f752$export$76bf64fc47d1f9ce = function() {
    return function(dictIsSymbol) {
        var componentSlot1 = $9913c23e14d7f752$var$componentSlot(dictIsSymbol);
        return function(dictOrd) {
            var componentSlot2 = componentSlot1(dictOrd);
            return function(label) {
                return function(p) {
                    return function(component) {
                        return function(input) {
                            return $hhMAk.widget(new $kugLX.ComponentSlot(componentSlot2(label)(p)(component)(input)($l4M7e.const($ykHdR.Nothing.value))));
                        };
                    };
                };
            };
        };
    };
};
var $9913c23e14d7f752$export$103b78750979eead = function() {
    return function(dictIsSymbol) {
        var componentSlot1 = $9913c23e14d7f752$var$componentSlot(dictIsSymbol);
        return function(dictOrd) {
            var componentSlot2 = componentSlot1(dictOrd);
            return function(label) {
                return function(p) {
                    return function(component) {
                        return function(input) {
                            return function(outputQuery) {
                                return $hhMAk.widget(new $kugLX.ComponentSlot(componentSlot2(label)(p)(component)(input)(function($11) {
                                    return $ykHdR.Just.create(outputQuery($11));
                                })));
                            };
                        };
                    };
                };
            };
        };
    };
};
var $9913c23e14d7f752$export$9756366f7cb6f62b = function(eqFn) {
    return function(f) {
        return $9913c23e14d7f752$var$map(function($12) {
            return $hhMAk.widget($kugLX.ThunkSlot.create($12));
        })($kKOpj.thunked(eqFn)(f));
    };
};
var $9913c23e14d7f752$export$1590e93dfc8f2cb5 = function(f) {
    return function(a) {
        return function(b) {
            return function(c) {
                return $hhMAk.widget(new $kugLX.ThunkSlot($kKOpj.thunk3(f, a, b, c)));
            };
        };
    };
};
var $9913c23e14d7f752$export$5a7f8ed0ed0de90f = function(f) {
    return function(a) {
        return function(b) {
            return $hhMAk.widget(new $kugLX.ThunkSlot($kKOpj.thunk2(f, a, b)));
        };
    };
};
var $9913c23e14d7f752$export$488013bae63b21da = function(f) {
    return function(a) {
        return $hhMAk.widget(new $kugLX.ThunkSlot($kKOpj.thunk1(f, a)));
    };
};
var $9913c23e14d7f752$export$1fb0fe1b9ee1b1bf = $eOrGk.unsafeCoerce;

});


parcelRegister("j8EJb", function(module, exports) {

$parcel$export(module.exports, "runHalogenAff", () => $deee5b6018c98796$export$1b79e4d7fc8e4817);
$parcel$export(module.exports, "awaitBody", () => $deee5b6018c98796$export$f79c83a36c9670be);
// Generated by purs version 0.15.16

var $gUTA8 = parcelRequire("gUTA8");

var $9Grh5 = parcelRequire("9Grh5");

var $84kZf = parcelRequire("84kZf");

var $aKY4H = parcelRequire("aKY4H");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");

var $ykHdR = parcelRequire("ykHdR");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");

var $9hRVP = parcelRequire("9hRVP");

var $kqxtr = parcelRequire("kqxtr");
var $fkeSt = parcelRequire("fkeSt");

var $kQlZ1 = parcelRequire("kQlZ1");
parcelRequire("6ITWO");
var $eROd4 = parcelRequire("eROd4");

var $ai79w = parcelRequire("ai79w");
parcelRequire("cehdW");
var $d7ECG = parcelRequire("d7ECG");
parcelRequire("gUeXR");
var $3gl8k = parcelRequire("3gl8k");

var $d59zr = parcelRequire("d59zr");

var $lbDmF = parcelRequire("lbDmF");

var $dcJBI = parcelRequire("dcJBI");

var $7NSrV = parcelRequire("7NSrV");
parcelRequire("9cmD3");
var $eC1jx = parcelRequire("eC1jx");
var $9cmD3 = parcelRequire("9cmD3");
var $deee5b6018c98796$var$bind = /* #__PURE__ */ $9Grh5.bind($kqxtr.bindAff);
var $deee5b6018c98796$var$liftEffect = /* #__PURE__ */ $kQlZ1.liftEffect($kqxtr.monadEffectAff);
var $deee5b6018c98796$var$bindFlipped = /* #__PURE__ */ $9Grh5.bindFlipped($9hRVP.bindEffect);
var $deee5b6018c98796$var$composeKleisliFlipped = /* #__PURE__ */ $9Grh5.composeKleisliFlipped($9hRVP.bindEffect);
var $deee5b6018c98796$var$pure = /* #__PURE__ */ $gUTA8.pure($kqxtr.applicativeAff);
var $deee5b6018c98796$var$bindFlipped1 = /* #__PURE__ */ $9Grh5.bindFlipped($ykHdR.bindMaybe);
var $deee5b6018c98796$var$pure1 = /* #__PURE__ */ $gUTA8.pure($9hRVP.applicativeEffect);
var $deee5b6018c98796$var$map = /* #__PURE__ */ $l0wDR.map($9hRVP.functorEffect);
var $deee5b6018c98796$var$discard = /* #__PURE__ */ $9Grh5.discard($9Grh5.discardUnit);
var $deee5b6018c98796$var$throwError = /* #__PURE__ */ $84kZf.throwError($kqxtr.monadThrowAff);
var $deee5b6018c98796$export$895e5c0dd54cd456 = function(query) {
    return $deee5b6018c98796$var$bind($deee5b6018c98796$var$liftEffect($deee5b6018c98796$var$bindFlipped($deee5b6018c98796$var$composeKleisliFlipped(function() {
        var $16 = $ai79w.querySelector(query);
        return function($17) {
            return $16($lbDmF.toParentNode($17));
        };
    }())($eC1jx.document))($3gl8k.window)))(function(mel) {
        return $deee5b6018c98796$var$pure($deee5b6018c98796$var$bindFlipped1($7NSrV.fromElement)(mel));
    });
};
var $deee5b6018c98796$export$1b79e4d7fc8e4817 = /* #__PURE__ */ $kqxtr.runAff_(/* #__PURE__ */ $aKY4H.either($eROd4.throwException)(/* #__PURE__ */ $l4M7e.const(/* #__PURE__ */ $deee5b6018c98796$var$pure1($r2HHk.unit))));
var $deee5b6018c98796$export$11dc33decdfc25c9 = /* #__PURE__ */ $fkeSt.makeAff(function(callback) {
    return function __do() {
        var rs = $deee5b6018c98796$var$bindFlipped($lbDmF.readyState)($deee5b6018c98796$var$bindFlipped($eC1jx.document)($3gl8k.window))();
        if (rs instanceof $dcJBI.Loading) {
            var et = $deee5b6018c98796$var$map($9cmD3.toEventTarget)($3gl8k.window)();
            var listener = $d7ECG.eventListener(function(v) {
                return callback(new $aKY4H.Right($r2HHk.unit));
            })();
            $d7ECG.addEventListener($d59zr.domcontentloaded)(listener)(false)(et)();
            return $kqxtr.effectCanceler($d7ECG.removeEventListener($d59zr.domcontentloaded)(listener)(false)(et));
        }
        callback(new $aKY4H.Right($r2HHk.unit))();
        return $kqxtr.nonCanceler;
    };
});
var $deee5b6018c98796$export$f79c83a36c9670be = /* #__PURE__ */ $deee5b6018c98796$var$discard($kqxtr.bindAff)($deee5b6018c98796$export$11dc33decdfc25c9)(function() {
    return $deee5b6018c98796$var$bind($deee5b6018c98796$export$895e5c0dd54cd456("body"))(function(body) {
        return $ykHdR.maybe($deee5b6018c98796$var$throwError($eROd4.error("Could not find body")))($deee5b6018c98796$var$pure)(body);
    });
});

});
parcelRegister("gUeXR", function(module, exports) {

$parcel$export(module.exports, "window", () => (parcelRequire("3gl8k")).window);
// Generated by purs version 0.15.16

var $3gl8k = parcelRequire("3gl8k");
parcelRequire("iBWyn");
parcelRequire("flfyb");
parcelRequire("gRUJ3");
parcelRequire("dpTtj");
parcelRequire("3vagv");
parcelRequire("2H4JY");
parcelRequire("dzTbP");
parcelRequire("h0Ea4");
parcelRequire("llGw0");
parcelRequire("8fwoE");
parcelRequire("5VzHT");
parcelRequire("jPdgp");
parcelRequire("8lavi");
parcelRequire("lbDmF");
parcelRequire("7NSrV");
parcelRequire("92qno");
parcelRequire("fOAku");
parcelRequire("dFAxl");
parcelRequire("5sdFN");
parcelRequire("kXX5Y");
parcelRequire("e8wS4");
parcelRequire("gg536");
parcelRequire("3zf9Y");
parcelRequire("iRNNV");
parcelRequire("4BKEa");
parcelRequire("64ADu");
parcelRequire("g18mW");
parcelRequire("4VEFa");
parcelRequire("8MEQ3");
parcelRequire("7iTX8");
parcelRequire("8FqE0");
parcelRequire("44vFb");
parcelRequire("bf5Ru");
parcelRequire("6jsIv");
parcelRequire("dVSmW");
parcelRequire("hjIra");
parcelRequire("hdMAX");
parcelRequire("28IXz");
parcelRequire("ah5tt");
parcelRequire("hqnl7");
parcelRequire("lqi2X");
parcelRequire("bodBV");
parcelRequire("iMlWw");
parcelRequire("7ZhYu");
parcelRequire("1tT4V");
parcelRequire("ebFeN");
parcelRequire("jWyDm");
parcelRequire("1zExv");
parcelRequire("gI6GO");
parcelRequire("6EsyS");
parcelRequire("hmAwo");
parcelRequire("3z8Mp");
parcelRequire("cq1tX");
parcelRequire("0lbA2");
parcelRequire("71Ync");
parcelRequire("8wc3z");
parcelRequire("7aDwq");
parcelRequire("lSIzx");
parcelRequire("6YO7x");
parcelRequire("kHGUQ");
parcelRequire("9IxHk");
parcelRequire("tcg3L");
parcelRequire("j5ALL");
parcelRequire("aetWv");
parcelRequire("gUzwk");
parcelRequire("8kUKU");
parcelRequire("kTB0t");
parcelRequire("9cmD3");

});
parcelRegister("3gl8k", function(module, exports) {

$parcel$export(module.exports, "window", () => $2603425f82e959df$export$8291e5b88f90ce4);
const $2603425f82e959df$export$8291e5b88f90ce4 = function() {
    return window;
};

});

parcelRegister("flfyb", function(module, exports) {
// Generated by purs version 0.15.16

var $6Vsis = parcelRequire("6Vsis");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $b2b4e127c7797d01$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $b2b4e127c7797d01$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $b2b4e127c7797d01$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $b2b4e127c7797d01$export$9da26c0441db8b03 = $eOrGk.unsafeCoerce;
var $b2b4e127c7797d01$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $b2b4e127c7797d01$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $b2b4e127c7797d01$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $b2b4e127c7797d01$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $b2b4e127c7797d01$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLAnchorElement");
var $b2b4e127c7797d01$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLAnchorElement");
var $b2b4e127c7797d01$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLAnchorElement");
var $b2b4e127c7797d01$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLAnchorElement");
var $b2b4e127c7797d01$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLAnchorElement");
var $b2b4e127c7797d01$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLAnchorElement");
var $b2b4e127c7797d01$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLAnchorElement");

});
parcelRegister("6Vsis", function(module, exports) {
function $50ae04148e431f75$export$44271b4f0c6a3563(a) {
    return function() {
        return a.target;
    };
}
function $50ae04148e431f75$export$1f61c53461aff4a5(target) {
    return function(a) {
        return function() {
            a.target = target;
        };
    };
}
function $50ae04148e431f75$export$24422be91ad4011f(a) {
    return function() {
        return a.download;
    };
}
function $50ae04148e431f75$export$4c9843daef742201(download) {
    return function(a) {
        return function() {
            a.download = download;
        };
    };
}
function $50ae04148e431f75$export$bad408f43b005bc8(a) {
    return function() {
        return a.rel;
    };
}
function $50ae04148e431f75$export$9e86d1af7d63c52c(rel) {
    return function(a) {
        return function() {
            a.rel = rel;
        };
    };
}
function $50ae04148e431f75$export$edb1c8e715f3944e(a) {
    return function() {
        return a.rev;
    };
}
function $50ae04148e431f75$export$671b41179a9f15fb(rev) {
    return function(a) {
        return function() {
            a.rev = rev;
        };
    };
}
function $50ae04148e431f75$export$5884a0b424dd5ef2(a) {
    return function() {
        return a.relList;
    };
}
function $50ae04148e431f75$export$4bf4138386d6b8cc(a) {
    return function() {
        return a.hreflang;
    };
}
function $50ae04148e431f75$export$17b5334c80252e15(hreflang) {
    return function(a) {
        return function() {
            a.hreflang = hreflang;
        };
    };
}
function $50ae04148e431f75$export$d4a6a4db5b31e621(a) {
    return function() {
        return a.type;
    };
}
function $50ae04148e431f75$export$1bf7f05044e9c5cb(type) {
    return function(a) {
        return function() {
            a.type = type;
        };
    };
}
function $50ae04148e431f75$export$6f093cfa640b7166(a) {
    return function() {
        return a.text;
    };
}
function $50ae04148e431f75$export$cbe0d99836e1498f(text) {
    return function(a) {
        return function() {
            a.text = text;
        };
    };
}

});


parcelRegister("gRUJ3", function(module, exports) {
// Generated by purs version 0.15.16

var $8xLII = parcelRequire("8xLII");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $c47d991e98d75165$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $c47d991e98d75165$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $c47d991e98d75165$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $c47d991e98d75165$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $c47d991e98d75165$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $c47d991e98d75165$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $c47d991e98d75165$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $c47d991e98d75165$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLAreaElement");
var $c47d991e98d75165$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLAreaElement");
var $c47d991e98d75165$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLAreaElement");
var $c47d991e98d75165$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLAreaElement");
var $c47d991e98d75165$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLAreaElement");
var $c47d991e98d75165$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLAreaElement");
var $c47d991e98d75165$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLAreaElement");

});
parcelRegister("8xLII", function(module, exports) {
function $63866c0466b6a770$export$228be17d80722ab(area) {
    return function() {
        return area.alt;
    };
}
function $63866c0466b6a770$export$14a0e7c2e6152665(alt) {
    return function(area) {
        return function() {
            area.alt = alt;
        };
    };
}
function $63866c0466b6a770$export$5bf93b4680474bd(area) {
    return function() {
        return area.coords;
    };
}
function $63866c0466b6a770$export$d03eafa2070fb6d7(coords) {
    return function(area) {
        return function() {
            area.coords = coords;
        };
    };
}
function $63866c0466b6a770$export$98bada23690e67eb(area) {
    return function() {
        return area.shape;
    };
}
function $63866c0466b6a770$export$89565ec41213f41c(shape) {
    return function(area) {
        return function() {
            area.shape = shape;
        };
    };
}
function $63866c0466b6a770$export$44271b4f0c6a3563(area) {
    return function() {
        return area.target;
    };
}
function $63866c0466b6a770$export$1f61c53461aff4a5(target) {
    return function(area) {
        return function() {
            area.target = target;
        };
    };
}
function $63866c0466b6a770$export$24422be91ad4011f(area) {
    return function() {
        return area.download;
    };
}
function $63866c0466b6a770$export$4c9843daef742201(download) {
    return function(area) {
        return function() {
            area.download = download;
        };
    };
}
function $63866c0466b6a770$export$bad408f43b005bc8(area) {
    return function() {
        return area.rel;
    };
}
function $63866c0466b6a770$export$9e86d1af7d63c52c(rel) {
    return function(area) {
        return function() {
            area.rel = rel;
        };
    };
}
function $63866c0466b6a770$export$5884a0b424dd5ef2(area) {
    return function() {
        return area.relList;
    };
}
function $63866c0466b6a770$export$4bf4138386d6b8cc(area) {
    return function() {
        return area.hreflang;
    };
}
function $63866c0466b6a770$export$17b5334c80252e15(hreflang) {
    return function(area) {
        return function() {
            area.hreflang = hreflang;
        };
    };
}
function $63866c0466b6a770$export$d4a6a4db5b31e621(area) {
    return function() {
        return area.type;
    };
}
function $63866c0466b6a770$export$1bf7f05044e9c5cb(type) {
    return function(area) {
        return function() {
            area.type = type;
        };
    };
}

});


parcelRegister("dpTtj", function(module, exports) {
// Generated by purs version 0.15.16

var $gda1W = parcelRequire("gda1W");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $9c48a3b1514e7e20$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $9c48a3b1514e7e20$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $9c48a3b1514e7e20$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $9c48a3b1514e7e20$export$fd26055f9731f4b9 = $eOrGk.unsafeCoerce;
var $9c48a3b1514e7e20$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $9c48a3b1514e7e20$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $9c48a3b1514e7e20$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $9c48a3b1514e7e20$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $9c48a3b1514e7e20$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLAudioElement");
var $9c48a3b1514e7e20$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLAudioElement");
var $9c48a3b1514e7e20$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLAudioElement");
var $9c48a3b1514e7e20$export$cdb626e247ef0ce5 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLAudioElement");
var $9c48a3b1514e7e20$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLAudioElement");
var $9c48a3b1514e7e20$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLAudioElement");
var $9c48a3b1514e7e20$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLAudioElement");
var $9c48a3b1514e7e20$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLAudioElement");
var $9c48a3b1514e7e20$export$20f9c2173df486a8 = $gda1W.createWithURL;

});
parcelRegister("gda1W", function(module, exports) {

$parcel$export(module.exports, "createWithURL", () => $bcd5a412110bec59$export$2faa2f53d87c7f7e);
function $bcd5a412110bec59$export$185802fd694ee1f5() {
    return new Audio();
}
function $bcd5a412110bec59$export$2faa2f53d87c7f7e(url) {
    return function() {
        return new Audio(url);
    };
}

});


parcelRegister("3vagv", function(module, exports) {
// Generated by purs version 0.15.16
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $28cc3aca3b37f8c1$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $28cc3aca3b37f8c1$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $28cc3aca3b37f8c1$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $28cc3aca3b37f8c1$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $28cc3aca3b37f8c1$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $28cc3aca3b37f8c1$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $28cc3aca3b37f8c1$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $28cc3aca3b37f8c1$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLBRElement");
var $28cc3aca3b37f8c1$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLBRElement");
var $28cc3aca3b37f8c1$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLBRElement");
var $28cc3aca3b37f8c1$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLBRElement");
var $28cc3aca3b37f8c1$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLBRElement");
var $28cc3aca3b37f8c1$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLBRElement");
var $28cc3aca3b37f8c1$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLBRElement");

});

parcelRegister("2H4JY", function(module, exports) {
// Generated by purs version 0.15.16

var $dqMIr = parcelRequire("dqMIr");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $1f63464ba4e88016$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $1f63464ba4e88016$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $1f63464ba4e88016$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $1f63464ba4e88016$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $1f63464ba4e88016$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $1f63464ba4e88016$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $1f63464ba4e88016$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $1f63464ba4e88016$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLBaseElement");
var $1f63464ba4e88016$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLBaseElement");
var $1f63464ba4e88016$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLBaseElement");
var $1f63464ba4e88016$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLBaseElement");
var $1f63464ba4e88016$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLBaseElement");
var $1f63464ba4e88016$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLBaseElement");
var $1f63464ba4e88016$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLBaseElement");

});
parcelRegister("dqMIr", function(module, exports) {
function $9c737e057094c556$export$8f51af5840e0602a(base) {
    return function() {
        return base.href;
    };
}
function $9c737e057094c556$export$428f6e77b5a5a669(href) {
    return function(base) {
        return function() {
            base.href = href;
        };
    };
}
function $9c737e057094c556$export$44271b4f0c6a3563(base) {
    return function() {
        return base.target;
    };
}
function $9c737e057094c556$export$1f61c53461aff4a5(target) {
    return function(base) {
        return function() {
            base.target = target;
        };
    };
}

});


parcelRegister("dzTbP", function(module, exports) {
// Generated by purs version 0.15.16
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $9e295ac610849d32$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $9e295ac610849d32$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $9e295ac610849d32$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $9e295ac610849d32$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $9e295ac610849d32$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $9e295ac610849d32$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $9e295ac610849d32$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $9e295ac610849d32$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLBodyElement");
var $9e295ac610849d32$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLBodyElement");
var $9e295ac610849d32$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLBodyElement");
var $9e295ac610849d32$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLBodyElement");
var $9e295ac610849d32$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLBodyElement");
var $9e295ac610849d32$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLBodyElement");
var $9e295ac610849d32$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLBodyElement");

});

parcelRegister("h0Ea4", function(module, exports) {
// Generated by purs version 0.15.16

var $2NR1c = parcelRequire("2NR1c");

var $l0wDR = parcelRequire("l0wDR");

var $T79xE = parcelRequire("T79xE");

var $9hRVP = parcelRequire("9hRVP");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $c6219700cb28efb6$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $c6219700cb28efb6$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $c6219700cb28efb6$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $c6219700cb28efb6$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $c6219700cb28efb6$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $c6219700cb28efb6$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $c6219700cb28efb6$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $c6219700cb28efb6$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLButtonElement");
var $c6219700cb28efb6$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLButtonElement");
var $c6219700cb28efb6$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLButtonElement");
var $c6219700cb28efb6$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLButtonElement");
var $c6219700cb28efb6$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLButtonElement");
var $c6219700cb28efb6$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLButtonElement");
var $c6219700cb28efb6$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLButtonElement");
var $c6219700cb28efb6$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $l0wDR.map($9hRVP.functorEffect)($T79xE.toMaybe);
    return function($3) {
        return $2($2NR1c._form($3));
    };
}();

});
parcelRegister("2NR1c", function(module, exports) {

$parcel$export(module.exports, "_form", () => $20a948bbaa0c268a$export$242c63e9758836c2);
function $20a948bbaa0c268a$export$4c47992fc278c9a0(button) {
    return function() {
        return button.autofocus;
    };
}
function $20a948bbaa0c268a$export$db2bbdcbda3d335e(autofocus) {
    return function(button) {
        return function() {
            button.autofocus = autofocus;
        };
    };
}
function $20a948bbaa0c268a$export$683472f6198a076e(button) {
    return function() {
        return button.disabled;
    };
}
function $20a948bbaa0c268a$export$4532d31cef66d703(disabled) {
    return function(button) {
        return function() {
            button.disabled = disabled;
        };
    };
}
function $20a948bbaa0c268a$export$242c63e9758836c2(button) {
    return function() {
        return button.form;
    };
}
function $20a948bbaa0c268a$export$7e4d70bab1b5c4a0(button) {
    return function() {
        return button.formAction;
    };
}
function $20a948bbaa0c268a$export$577bb1d64e4c83b9(formAction) {
    return function(button) {
        return function() {
            button.formAction = formAction;
        };
    };
}
function $20a948bbaa0c268a$export$21f1c8008acfa9c0(button) {
    return function() {
        return button.formEnctype;
    };
}
function $20a948bbaa0c268a$export$346989dcff4ba18b(formEnctype) {
    return function(button) {
        return function() {
            button.formEnctype = formEnctype;
        };
    };
}
function $20a948bbaa0c268a$export$3f1ffee261a00124(button) {
    return function() {
        return button.formMethod;
    };
}
function $20a948bbaa0c268a$export$c38a1a871bb0e145(formMethod) {
    return function(button) {
        return function() {
            button.formMethod = formMethod;
        };
    };
}
function $20a948bbaa0c268a$export$87c857905fcc4a84(button) {
    return function() {
        return button.formNoValidate;
    };
}
function $20a948bbaa0c268a$export$ad9ff32d0af51586(formNoValidate) {
    return function(button) {
        return function() {
            button.formNoValidate = formNoValidate;
        };
    };
}
function $20a948bbaa0c268a$export$497949a0ae76184f(button) {
    return function() {
        return button.formTarget;
    };
}
function $20a948bbaa0c268a$export$4c7e983548149eb5(formTarget) {
    return function(button) {
        return function() {
            button.formTarget = formTarget;
        };
    };
}
function $20a948bbaa0c268a$export$a8ff84c12d48cfa6(button) {
    return function() {
        return button.name;
    };
}
function $20a948bbaa0c268a$export$6cf3d710d3a367e5(name) {
    return function(button) {
        return function() {
            button.name = name;
        };
    };
}
function $20a948bbaa0c268a$export$d4a6a4db5b31e621(button) {
    return function() {
        return button.type;
    };
}
function $20a948bbaa0c268a$export$1bf7f05044e9c5cb(type) {
    return function(button) {
        return function() {
            button.type = type;
        };
    };
}
function $20a948bbaa0c268a$export$2ab9a8f9f1186f14(button) {
    return function() {
        return button.value;
    };
}
function $20a948bbaa0c268a$export$80746c6bc6142fc8(value) {
    return function(button) {
        return function() {
            button.value = value;
        };
    };
}
function $20a948bbaa0c268a$export$5e55a9e709e8e020(button) {
    return function() {
        return button.willValidate;
    };
}
function $20a948bbaa0c268a$export$1bdd3f9a89b22594(button) {
    return function() {
        return button.validity;
    };
}
function $20a948bbaa0c268a$export$6ee4201e37a931e2(button) {
    return function() {
        return button.validationMessage;
    };
}
function $20a948bbaa0c268a$export$50d70f8cedc54453(button) {
    return function() {
        return button.checkValidity();
    };
}
function $20a948bbaa0c268a$export$b962d864c477cc49(button) {
    return function() {
        return button.reportValidity();
    };
}
function $20a948bbaa0c268a$export$6f569cb704992105(value) {
    return function(button) {
        return function() {
            button.setCustomValidity(value);
        };
    };
}
function $20a948bbaa0c268a$export$a238cb463698c900(button) {
    return function() {
        return button.labels;
    };
}

});


parcelRegister("llGw0", function(module, exports) {
// Generated by purs version 0.15.16

var $aL7W5 = parcelRequire("aL7W5");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $f8ac89c5dd24c0f2$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $f8ac89c5dd24c0f2$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $f8ac89c5dd24c0f2$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $f8ac89c5dd24c0f2$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $f8ac89c5dd24c0f2$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $f8ac89c5dd24c0f2$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $f8ac89c5dd24c0f2$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $f8ac89c5dd24c0f2$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLCanvasElement");
var $f8ac89c5dd24c0f2$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLCanvasElement");
var $f8ac89c5dd24c0f2$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLCanvasElement");
var $f8ac89c5dd24c0f2$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLCanvasElement");
var $f8ac89c5dd24c0f2$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLCanvasElement");
var $f8ac89c5dd24c0f2$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLCanvasElement");
var $f8ac89c5dd24c0f2$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLCanvasElement");

});
parcelRegister("aL7W5", function(module, exports) {
function $7d547317abc5459f$export$7e3df82ee760448c(canvas) {
    return function() {
        return canvas.width;
    };
}
function $7d547317abc5459f$export$67f48e0594af05d(width) {
    return function(canvas) {
        return function() {
            canvas.width = width;
        };
    };
}
function $7d547317abc5459f$export$ac607276a8fe9f0a(canvas) {
    return function() {
        return canvas.height;
    };
}
function $7d547317abc5459f$export$3f31360357be44e4(height) {
    return function(canvas) {
        return function() {
            canvas.height = height;
        };
    };
}

});


parcelRegister("8fwoE", function(module, exports) {
// Generated by purs version 0.15.16
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $6018dac1d12eb9e0$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $6018dac1d12eb9e0$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $6018dac1d12eb9e0$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $6018dac1d12eb9e0$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $6018dac1d12eb9e0$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $6018dac1d12eb9e0$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $6018dac1d12eb9e0$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $6018dac1d12eb9e0$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLDListElement");
var $6018dac1d12eb9e0$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLDListElement");
var $6018dac1d12eb9e0$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLDListElement");
var $6018dac1d12eb9e0$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLDListElement");
var $6018dac1d12eb9e0$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLDListElement");
var $6018dac1d12eb9e0$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLDListElement");
var $6018dac1d12eb9e0$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLDListElement");

});

parcelRegister("5VzHT", function(module, exports) {
// Generated by purs version 0.15.16

var $3B4eT = parcelRequire("3B4eT");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $450df947978ac297$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $450df947978ac297$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $450df947978ac297$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $450df947978ac297$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $450df947978ac297$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $450df947978ac297$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $450df947978ac297$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $450df947978ac297$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLDataElement");
var $450df947978ac297$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLDataElement");
var $450df947978ac297$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLDataElement");
var $450df947978ac297$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLDataElement");
var $450df947978ac297$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLDataElement");
var $450df947978ac297$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLDataElement");
var $450df947978ac297$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLDataElement");

});
parcelRegister("3B4eT", function(module, exports) {
function $29e81da2666ff0a3$export$2ab9a8f9f1186f14(data) {
    return function() {
        return data.value;
    };
}
function $29e81da2666ff0a3$export$80746c6bc6142fc8(value) {
    return function(data) {
        return function() {
            data.value = value;
        };
    };
}

});


parcelRegister("jPdgp", function(module, exports) {
// Generated by purs version 0.15.16

var $c67uX = parcelRequire("c67uX");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $e6ed11a356105002$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $e6ed11a356105002$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $e6ed11a356105002$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $e6ed11a356105002$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $e6ed11a356105002$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $e6ed11a356105002$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $e6ed11a356105002$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $e6ed11a356105002$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLDataListElement");
var $e6ed11a356105002$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLDataListElement");
var $e6ed11a356105002$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLDataListElement");
var $e6ed11a356105002$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLDataListElement");
var $e6ed11a356105002$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLDataListElement");
var $e6ed11a356105002$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLDataListElement");
var $e6ed11a356105002$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLDataListElement");

});
parcelRegister("c67uX", function(module, exports) {
function $8cebdc995025043e$export$41c562ebe57d11e2(dle) {
    return function() {
        return dle.options;
    };
}

});


parcelRegister("8lavi", function(module, exports) {
// Generated by purs version 0.15.16
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $61286eb7c73211a7$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $61286eb7c73211a7$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $61286eb7c73211a7$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $61286eb7c73211a7$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $61286eb7c73211a7$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $61286eb7c73211a7$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $61286eb7c73211a7$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $61286eb7c73211a7$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLDivElement");
var $61286eb7c73211a7$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLDivElement");
var $61286eb7c73211a7$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLDivElement");
var $61286eb7c73211a7$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLDivElement");
var $61286eb7c73211a7$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLDivElement");
var $61286eb7c73211a7$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLDivElement");
var $61286eb7c73211a7$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLDivElement");

});

parcelRegister("lbDmF", function(module, exports) {

$parcel$export(module.exports, "toParentNode", () => $f6c9290a5db8f197$export$c8b651b897da2de);
$parcel$export(module.exports, "toDocument", () => $f6c9290a5db8f197$export$ce0e204f587740c3);
$parcel$export(module.exports, "readyState", () => $f6c9290a5db8f197$export$1ae2b664eea77b7e);
// Generated by purs version 0.15.16

var $1d4Vl = parcelRequire("1d4Vl");

var $l0wDR = parcelRequire("l0wDR");

var $ykHdR = parcelRequire("ykHdR");

var $T79xE = parcelRequire("T79xE");

var $9hRVP = parcelRequire("9hRVP");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $dcJBI = parcelRequire("dcJBI");

var $kkHll = parcelRequire("kkHll");

var $6EJMX = parcelRequire("6EJMX");
var $f6c9290a5db8f197$var$map = /* #__PURE__ */ $l0wDR.map($9hRVP.functorEffect);
var $f6c9290a5db8f197$export$3d0d3483832deb8e = function(doc) {
    return $f6c9290a5db8f197$var$map(function() {
        var $2 = $ykHdR.fromMaybe($kkHll.Visible.value);
        return function($3) {
            return $2($kkHll.parse($3));
        };
    }())(function() {
        return $1d4Vl._visibilityState(doc);
    });
};
var $f6c9290a5db8f197$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $f6c9290a5db8f197$export$d8d5f203c133934 = $eOrGk.unsafeCoerce;
var $f6c9290a5db8f197$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $f6c9290a5db8f197$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $f6c9290a5db8f197$export$ce0e204f587740c3 = $eOrGk.unsafeCoerce;
var $f6c9290a5db8f197$export$fb184b623420d9be = function(doc) {
    return function() {
        return $1d4Vl._title(doc);
    };
};
var $f6c9290a5db8f197$export$420a7f2fd9cad6f6 = function(newTitle) {
    return function(doc) {
        return function() {
            return $1d4Vl._setTitle(newTitle, doc);
        };
    };
};
var $f6c9290a5db8f197$export$a0c6a011d8b20057 = function(doc) {
    return function() {
        return $1d4Vl._referrer(doc);
    };
};
var $f6c9290a5db8f197$export$1ae2b664eea77b7e = function(doc) {
    return $f6c9290a5db8f197$var$map(function() {
        var $4 = $ykHdR.fromMaybe($dcJBI.Loading.value);
        return function($5) {
            return $4($dcJBI.parse($5));
        };
    }())(function() {
        return $1d4Vl._readyState(doc);
    });
};
var $f6c9290a5db8f197$export$5fd5031fecdacec3 = function(doc) {
    return $f6c9290a5db8f197$var$map($T79xE.toMaybe)(function() {
        return $1d4Vl._head(doc);
    });
};
var $f6c9290a5db8f197$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLDocument");
var $f6c9290a5db8f197$export$45b532d2a1c7642b = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLDocument");
var $f6c9290a5db8f197$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLDocument");
var $f6c9290a5db8f197$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLDocument");
var $f6c9290a5db8f197$export$cb6b1c55e7404aef = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLDocument");
var $f6c9290a5db8f197$export$170c446b87804fad = function(doc) {
    return $f6c9290a5db8f197$var$map($T79xE.toMaybe)(function() {
        return $1d4Vl._documentElement(doc);
    });
};
var $f6c9290a5db8f197$export$7aca2fdfd0625e3a = function(doc) {
    return $f6c9290a5db8f197$var$map($T79xE.toMaybe)(function() {
        return $1d4Vl._currentScript(doc);
    });
};
var $f6c9290a5db8f197$export$32180ef41b15b513 = function(doc) {
    return $f6c9290a5db8f197$var$map($T79xE.toMaybe)(function() {
        return $1d4Vl._body(doc);
    });
};
var $f6c9290a5db8f197$export$da980962bd2147a4 = function(doc) {
    return $f6c9290a5db8f197$var$map($T79xE.toMaybe)(function() {
        return $1d4Vl._activeElement(doc);
    });
};

});
parcelRegister("1d4Vl", function(module, exports) {

$parcel$export(module.exports, "_documentElement", () => $0e1ad3264aa8b3c4$export$445a11d197c0312);
$parcel$export(module.exports, "_head", () => $0e1ad3264aa8b3c4$export$327008c45899d79e);
$parcel$export(module.exports, "_body", () => $0e1ad3264aa8b3c4$export$773bb8dac55dfce8);
$parcel$export(module.exports, "_readyState", () => $0e1ad3264aa8b3c4$export$4bf8a366db6a678b);
$parcel$export(module.exports, "_visibilityState", () => $0e1ad3264aa8b3c4$export$5a15a2f945550a96);
$parcel$export(module.exports, "_activeElement", () => $0e1ad3264aa8b3c4$export$6282f43d08fc4121);
$parcel$export(module.exports, "_currentScript", () => $0e1ad3264aa8b3c4$export$f0905ed0c7a5fd27);
$parcel$export(module.exports, "_referrer", () => $0e1ad3264aa8b3c4$export$6392ea9cea2135f3);
$parcel$export(module.exports, "_title", () => $0e1ad3264aa8b3c4$export$a80dcad378414f77);
$parcel$export(module.exports, "_setTitle", () => $0e1ad3264aa8b3c4$export$485b6f1fe8b035f3);
function $0e1ad3264aa8b3c4$export$445a11d197c0312(doc) {
    return doc.documentElement;
}
function $0e1ad3264aa8b3c4$export$327008c45899d79e(doc) {
    return doc.head;
}
function $0e1ad3264aa8b3c4$export$773bb8dac55dfce8(doc) {
    return doc.body;
}
function $0e1ad3264aa8b3c4$export$4bf8a366db6a678b(doc) {
    return doc.readyState;
}
function $0e1ad3264aa8b3c4$export$5a15a2f945550a96(doc) {
    return doc.readyState;
}
function $0e1ad3264aa8b3c4$export$6282f43d08fc4121(doc) {
    return doc.activeElement;
}
function $0e1ad3264aa8b3c4$export$f0905ed0c7a5fd27(doc) {
    return doc.currentScript;
}
function $0e1ad3264aa8b3c4$export$6392ea9cea2135f3(doc) {
    return doc.referrer;
}
function $0e1ad3264aa8b3c4$export$a80dcad378414f77(doc) {
    return doc.title;
}
function $0e1ad3264aa8b3c4$export$485b6f1fe8b035f3(title, doc) {
    doc.title = title;
}

});

parcelRegister("dcJBI", function(module, exports) {

$parcel$export(module.exports, "Loading", () => $99cfc603fe5cc0f7$export$669f6ea7d267feaf);
$parcel$export(module.exports, "parse", () => $99cfc603fe5cc0f7$export$98e6a39c04603d36);
// Generated by purs version 0.15.16

var $ykHdR = parcelRequire("ykHdR");

var $6SDUu = parcelRequire("6SDUu");
var $99cfc603fe5cc0f7$export$669f6ea7d267feaf = /* #__PURE__ */ function() {
    function Loading() {}
    Loading.value = new Loading();
    return Loading;
}();
var $99cfc603fe5cc0f7$export$43d8ad7b9c99dd97 = /* #__PURE__ */ function() {
    function Interactive() {}
    Interactive.value = new Interactive();
    return Interactive;
}();
var $99cfc603fe5cc0f7$export$37474717eef9e2a4 = /* #__PURE__ */ function() {
    function Complete() {}
    Complete.value = new Complete();
    return Complete;
}();
var $99cfc603fe5cc0f7$export$33dd24f3d942b82e = {
    show: function(v) {
        if (v instanceof $99cfc603fe5cc0f7$export$669f6ea7d267feaf) return "Loading";
        if (v instanceof $99cfc603fe5cc0f7$export$43d8ad7b9c99dd97) return "Interactive";
        if (v instanceof $99cfc603fe5cc0f7$export$37474717eef9e2a4) return "Complete";
        throw new Error("Failed pattern match at Web.HTML.HTMLDocument.ReadyState (line 16, column 10 - line 19, column 27): " + [
            v.constructor.name
        ]);
    }
};
var $99cfc603fe5cc0f7$export$c2d084dc44961371 = function(v) {
    if (v instanceof $99cfc603fe5cc0f7$export$669f6ea7d267feaf) return "loading";
    if (v instanceof $99cfc603fe5cc0f7$export$43d8ad7b9c99dd97) return "interactive";
    if (v instanceof $99cfc603fe5cc0f7$export$37474717eef9e2a4) return "complete";
    throw new Error("Failed pattern match at Web.HTML.HTMLDocument.ReadyState (line 22, column 9 - line 25, column 25): " + [
        v.constructor.name
    ]);
};
var $99cfc603fe5cc0f7$export$98e6a39c04603d36 = function(v) {
    if (v === "loading") return new $ykHdR.Just($99cfc603fe5cc0f7$export$669f6ea7d267feaf.value);
    if (v === "interactive") return new $ykHdR.Just($99cfc603fe5cc0f7$export$43d8ad7b9c99dd97.value);
    if (v === "complete") return new $ykHdR.Just($99cfc603fe5cc0f7$export$37474717eef9e2a4.value);
    return $ykHdR.Nothing.value;
};
var $99cfc603fe5cc0f7$export$c71e02dcc13f94a6 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $99cfc603fe5cc0f7$export$669f6ea7d267feaf && y instanceof $99cfc603fe5cc0f7$export$669f6ea7d267feaf) return true;
            if (x instanceof $99cfc603fe5cc0f7$export$43d8ad7b9c99dd97 && y instanceof $99cfc603fe5cc0f7$export$43d8ad7b9c99dd97) return true;
            if (x instanceof $99cfc603fe5cc0f7$export$37474717eef9e2a4 && y instanceof $99cfc603fe5cc0f7$export$37474717eef9e2a4) return true;
            return false;
        };
    }
};
var $99cfc603fe5cc0f7$export$6557947d538c3b81 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $99cfc603fe5cc0f7$export$669f6ea7d267feaf && y instanceof $99cfc603fe5cc0f7$export$669f6ea7d267feaf) return $6SDUu.EQ.value;
            if (x instanceof $99cfc603fe5cc0f7$export$669f6ea7d267feaf) return $6SDUu.LT.value;
            if (y instanceof $99cfc603fe5cc0f7$export$669f6ea7d267feaf) return $6SDUu.GT.value;
            if (x instanceof $99cfc603fe5cc0f7$export$43d8ad7b9c99dd97 && y instanceof $99cfc603fe5cc0f7$export$43d8ad7b9c99dd97) return $6SDUu.EQ.value;
            if (x instanceof $99cfc603fe5cc0f7$export$43d8ad7b9c99dd97) return $6SDUu.LT.value;
            if (y instanceof $99cfc603fe5cc0f7$export$43d8ad7b9c99dd97) return $6SDUu.GT.value;
            if (x instanceof $99cfc603fe5cc0f7$export$37474717eef9e2a4 && y instanceof $99cfc603fe5cc0f7$export$37474717eef9e2a4) return $6SDUu.EQ.value;
            throw new Error("Failed pattern match at Web.HTML.HTMLDocument.ReadyState (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $99cfc603fe5cc0f7$export$c71e02dcc13f94a6;
    }
};

});

parcelRegister("kkHll", function(module, exports) {

$parcel$export(module.exports, "Visible", () => $ecd74bf9585b1551$export$3824c08153b44726);
$parcel$export(module.exports, "parse", () => $ecd74bf9585b1551$export$98e6a39c04603d36);
// Generated by purs version 0.15.16

var $ykHdR = parcelRequire("ykHdR");

var $6SDUu = parcelRequire("6SDUu");
var $ecd74bf9585b1551$export$3824c08153b44726 = /* #__PURE__ */ function() {
    function Visible() {}
    Visible.value = new Visible();
    return Visible;
}();
var $ecd74bf9585b1551$export$8dc98ba7eadeaa56 = /* #__PURE__ */ function() {
    function Hidden() {}
    Hidden.value = new Hidden();
    return Hidden;
}();
var $ecd74bf9585b1551$export$d2d17f8156d66f42 = {
    show: function(v) {
        if (v instanceof $ecd74bf9585b1551$export$3824c08153b44726) return "Visible";
        if (v instanceof $ecd74bf9585b1551$export$8dc98ba7eadeaa56) return "Hidden";
        throw new Error("Failed pattern match at Web.HTML.HTMLDocument.VisibilityState (line 15, column 10 - line 17, column 23): " + [
            v.constructor.name
        ]);
    }
};
var $ecd74bf9585b1551$export$c2d084dc44961371 = function(v) {
    if (v instanceof $ecd74bf9585b1551$export$3824c08153b44726) return "visible";
    if (v instanceof $ecd74bf9585b1551$export$8dc98ba7eadeaa56) return "hidden";
    throw new Error("Failed pattern match at Web.HTML.HTMLDocument.VisibilityState (line 20, column 9 - line 22, column 21): " + [
        v.constructor.name
    ]);
};
var $ecd74bf9585b1551$export$98e6a39c04603d36 = function(v) {
    if (v === "visible") return new $ykHdR.Just($ecd74bf9585b1551$export$3824c08153b44726.value);
    if (v === "hidden") return new $ykHdR.Just($ecd74bf9585b1551$export$8dc98ba7eadeaa56.value);
    return $ykHdR.Nothing.value;
};
var $ecd74bf9585b1551$export$e4139843c5cdd239 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $ecd74bf9585b1551$export$3824c08153b44726 && y instanceof $ecd74bf9585b1551$export$3824c08153b44726) return true;
            if (x instanceof $ecd74bf9585b1551$export$8dc98ba7eadeaa56 && y instanceof $ecd74bf9585b1551$export$8dc98ba7eadeaa56) return true;
            return false;
        };
    }
};
var $ecd74bf9585b1551$export$712b05ab3ead9d93 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $ecd74bf9585b1551$export$3824c08153b44726 && y instanceof $ecd74bf9585b1551$export$3824c08153b44726) return $6SDUu.EQ.value;
            if (x instanceof $ecd74bf9585b1551$export$3824c08153b44726) return $6SDUu.LT.value;
            if (y instanceof $ecd74bf9585b1551$export$3824c08153b44726) return $6SDUu.GT.value;
            if (x instanceof $ecd74bf9585b1551$export$8dc98ba7eadeaa56 && y instanceof $ecd74bf9585b1551$export$8dc98ba7eadeaa56) return $6SDUu.EQ.value;
            throw new Error("Failed pattern match at Web.HTML.HTMLDocument.VisibilityState (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $ecd74bf9585b1551$export$e4139843c5cdd239;
    }
};

});


parcelRegister("7NSrV", function(module, exports) {

$parcel$export(module.exports, "toNode", () => $5ae75883a0b7923c$export$83a0de4644f1fbc4);
$parcel$export(module.exports, "fromElement", () => $5ae75883a0b7923c$export$c56654a6d0e3bd48);
// Generated by purs version 0.15.16

var $hAYkF = parcelRequire("hAYkF");

var $l0wDR = parcelRequire("l0wDR");

var $ykHdR = parcelRequire("ykHdR");

var $T79xE = parcelRequire("T79xE");

var $9hRVP = parcelRequire("9hRVP");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");
var $5ae75883a0b7923c$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $5ae75883a0b7923c$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $5ae75883a0b7923c$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $5ae75883a0b7923c$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $5ae75883a0b7923c$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $5ae75883a0b7923c$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $5ae75883a0b7923c$export$759f2a42fd33dfde = /* #__PURE__ */ function() {
    var $2 = $l0wDR.map($9hRVP.functorEffect)($T79xE.toMaybe);
    return function($3) {
        return $2($hAYkF._offsetParent($3));
    };
}();
var $5ae75883a0b7923c$export$7039ba397093f069 = function(x) {
    return $hAYkF._read($ykHdR.Nothing.value, $ykHdR.Just.create, x);
};
var $5ae75883a0b7923c$export$66db07be43ecb0c3 = function(x) {
    return $hAYkF._read($ykHdR.Nothing.value, $ykHdR.Just.create, x);
};
var $5ae75883a0b7923c$export$a7f097b65af8aa04 = function(x) {
    return $hAYkF._read($ykHdR.Nothing.value, $ykHdR.Just.create, x);
};
var $5ae75883a0b7923c$export$a0a0bf09b44710c9 = function(x) {
    return $hAYkF._read($ykHdR.Nothing.value, $ykHdR.Just.create, x);
};
var $5ae75883a0b7923c$export$c56654a6d0e3bd48 = function(x) {
    return $hAYkF._read($ykHdR.Nothing.value, $ykHdR.Just.create, x);
};
var $5ae75883a0b7923c$export$31942037104a4a20 = function(x) {
    return $hAYkF._read($ykHdR.Nothing.value, $ykHdR.Just.create, x);
};

});
parcelRegister("hAYkF", function(module, exports) {

$parcel$export(module.exports, "_read", () => $ccf49930316caf57$export$b2a016fb14adc1e4);
$parcel$export(module.exports, "_offsetParent", () => $ccf49930316caf57$export$351f7ed5e1f4cbfb);
function $ccf49930316caf57$export$b2a016fb14adc1e4(nothing, just, value) {
    var tag = Object.prototype.toString.call(value);
    if (tag.indexOf("[object HTML") === 0 && tag.indexOf("Element]") === tag.length - 8) return just(value);
    else return nothing;
}
function $ccf49930316caf57$export$fb184b623420d9be(elt) {
    return function() {
        return elt.title;
    };
}
function $ccf49930316caf57$export$420a7f2fd9cad6f6(title) {
    return function(elt) {
        return function() {
            elt.title = title;
        };
    };
}
function $ccf49930316caf57$export$9a771d6906431624(elt) {
    return function() {
        return elt.lang;
    };
}
function $ccf49930316caf57$export$a3665b844fbc095d(lang) {
    return function(elt) {
        return function() {
            elt.lang = lang;
        };
    };
}
function $ccf49930316caf57$export$147ec2801e896265(elt) {
    return function() {
        return elt.dir;
    };
}
function $ccf49930316caf57$export$5d00cbe77a0f4da4(dir) {
    return function(elt) {
        return function() {
            elt.dir = dir;
        };
    };
}
function $ccf49930316caf57$export$73920f18ca706874(elt) {
    return function() {
        return elt.hidden;
    };
}
function $ccf49930316caf57$export$306a681a1fc87013(hidden) {
    return function(elt) {
        return function() {
            elt.hidden = hidden;
        };
    };
}
function $ccf49930316caf57$export$9a625f9de50bf0b7(elt) {
    return function() {
        return elt.tabIndex;
    };
}
function $ccf49930316caf57$export$de72581b19a869cc(tabIndex) {
    return function(elt) {
        return function() {
            elt.tabIndex = tabIndex;
        };
    };
}
function $ccf49930316caf57$export$c746a5152d4ba26c(elt) {
    return function() {
        return elt.draggable;
    };
}
function $ccf49930316caf57$export$b681bd05c45bbdd7(draggable) {
    return function(elt) {
        return function() {
            elt.draggable = draggable;
        };
    };
}
function $ccf49930316caf57$export$d9d317b4285c34e7(elt) {
    return function() {
        return elt.contentEditable;
    };
}
function $ccf49930316caf57$export$91a56ab73e46c5d4(contentEditable) {
    return function(elt) {
        return function() {
            elt.contentEditable = contentEditable;
        };
    };
}
function $ccf49930316caf57$export$3453cc819780f652(elt) {
    return function() {
        return elt.isContentEditable;
    };
}
function $ccf49930316caf57$export$afbe3196582d9f14(elt) {
    return function() {
        return elt.spellcheck;
    };
}
function $ccf49930316caf57$export$f5c89d87509db2c2(spellcheck) {
    return function(elt) {
        return function() {
            elt.spellcheck = spellcheck;
        };
    };
}
function $ccf49930316caf57$export$64ef1bee2b9504c1(elt) {
    return function() {
        return elt.click();
    };
}
function $ccf49930316caf57$export$d7ddd398f22d79ef(elt) {
    return function() {
        return elt.focus();
    };
}
function $ccf49930316caf57$export$2cc7ff91bcacba5e(elt) {
    return function() {
        return elt.blur();
    };
}
function $ccf49930316caf57$export$351f7ed5e1f4cbfb(el) {
    return function() {
        return el.offsetParent;
    };
}
function $ccf49930316caf57$export$9051df5ff5b6ece8(el) {
    return function() {
        return el.offsetTop;
    };
}
function $ccf49930316caf57$export$4ad6bc00a859a01c(el) {
    return function() {
        return el.offsetLeft;
    };
}
function $ccf49930316caf57$export$abda199d6e675d54(el) {
    return function() {
        return el.offsetWidth;
    };
}
function $ccf49930316caf57$export$720e3813341eb9b(el) {
    return function() {
        return el.offsetHeight;
    };
}

});


parcelRegister("92qno", function(module, exports) {
// Generated by purs version 0.15.16

var $2z8mv = parcelRequire("2z8mv");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $6948c2c57b43dc19$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $6948c2c57b43dc19$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $6948c2c57b43dc19$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $6948c2c57b43dc19$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $6948c2c57b43dc19$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $6948c2c57b43dc19$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $6948c2c57b43dc19$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $6948c2c57b43dc19$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLEmbedElement");
var $6948c2c57b43dc19$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLEmbedElement");
var $6948c2c57b43dc19$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLEmbedElement");
var $6948c2c57b43dc19$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLEmbedElement");
var $6948c2c57b43dc19$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLEmbedElement");
var $6948c2c57b43dc19$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLEmbedElement");
var $6948c2c57b43dc19$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLEmbedElement");

});
parcelRegister("2z8mv", function(module, exports) {
function $1de55632ffb04144$export$2e40c9e35e9506f4(embed) {
    return function() {
        return embed.src;
    };
}
function $1de55632ffb04144$export$5771e3a4c80da7df(src) {
    return function(embed) {
        return function() {
            embed.src = src;
        };
    };
}
function $1de55632ffb04144$export$d4a6a4db5b31e621(embed) {
    return function() {
        return embed.type;
    };
}
function $1de55632ffb04144$export$1bf7f05044e9c5cb(type) {
    return function(embed) {
        return function() {
            embed.type = type;
        };
    };
}
function $1de55632ffb04144$export$7e3df82ee760448c(embed) {
    return function() {
        return embed.width;
    };
}
function $1de55632ffb04144$export$67f48e0594af05d(width) {
    return function(embed) {
        return function() {
            embed.width = width;
        };
    };
}
function $1de55632ffb04144$export$ac607276a8fe9f0a(embed) {
    return function() {
        return embed.height;
    };
}
function $1de55632ffb04144$export$3f31360357be44e4(height) {
    return function(embed) {
        return function() {
            embed.height = height;
        };
    };
}

});


parcelRegister("fOAku", function(module, exports) {
// Generated by purs version 0.15.16

var $l6pC7 = parcelRequire("l6pC7");

var $l0wDR = parcelRequire("l0wDR");

var $T79xE = parcelRequire("T79xE");

var $9hRVP = parcelRequire("9hRVP");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $b837b4d3f419e563$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $b837b4d3f419e563$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $b837b4d3f419e563$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $b837b4d3f419e563$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $b837b4d3f419e563$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $b837b4d3f419e563$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $b837b4d3f419e563$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $b837b4d3f419e563$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLFieldSetElement");
var $b837b4d3f419e563$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLFieldSetElement");
var $b837b4d3f419e563$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLFieldSetElement");
var $b837b4d3f419e563$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLFieldSetElement");
var $b837b4d3f419e563$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLFieldSetElement");
var $b837b4d3f419e563$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLFieldSetElement");
var $b837b4d3f419e563$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLFieldSetElement");
var $b837b4d3f419e563$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $l0wDR.map($9hRVP.functorEffect)($T79xE.toMaybe);
    return function($3) {
        return $2($l6pC7._form($3));
    };
}();

});
parcelRegister("l6pC7", function(module, exports) {

$parcel$export(module.exports, "_form", () => $f5ce06e2d4c9fafa$export$242c63e9758836c2);
function $f5ce06e2d4c9fafa$export$683472f6198a076e(fieldset) {
    return function() {
        return fieldset.disabled;
    };
}
function $f5ce06e2d4c9fafa$export$4532d31cef66d703(disabled) {
    return function(fieldset) {
        return function() {
            fieldset.disabled = disabled;
        };
    };
}
function $f5ce06e2d4c9fafa$export$242c63e9758836c2(fieldset) {
    return function() {
        return fieldset.form;
    };
}
function $f5ce06e2d4c9fafa$export$a8ff84c12d48cfa6(fieldset) {
    return function() {
        return fieldset.name;
    };
}
function $f5ce06e2d4c9fafa$export$6cf3d710d3a367e5(name) {
    return function(fieldset) {
        return function() {
            fieldset.name = name;
        };
    };
}
function $f5ce06e2d4c9fafa$export$d4a6a4db5b31e621(fieldset) {
    return function() {
        return fieldset.type;
    };
}
function $f5ce06e2d4c9fafa$export$1bf7f05044e9c5cb(type) {
    return function(fieldset) {
        return function() {
            fieldset.type = type;
        };
    };
}
function $f5ce06e2d4c9fafa$export$5e55a9e709e8e020(fieldset) {
    return function() {
        return fieldset.willValidate;
    };
}
function $f5ce06e2d4c9fafa$export$1bdd3f9a89b22594(fieldset) {
    return function() {
        return fieldset.validity;
    };
}
function $f5ce06e2d4c9fafa$export$6ee4201e37a931e2(fieldset) {
    return function() {
        return fieldset.validationMessage;
    };
}
function $f5ce06e2d4c9fafa$export$50d70f8cedc54453(fieldset) {
    return function() {
        return fieldset.checkValidity();
    };
}
function $f5ce06e2d4c9fafa$export$b962d864c477cc49(fieldset) {
    return function() {
        return fieldset.reportValidity();
    };
}
function $f5ce06e2d4c9fafa$export$6f569cb704992105(value) {
    return function(fieldset) {
        return function() {
            fieldset.setCustomValidity(value);
        };
    };
}

});


parcelRegister("dFAxl", function(module, exports) {
// Generated by purs version 0.15.16

var $k5ChQ = parcelRequire("k5ChQ");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $9f3b722473e4bf22$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $9f3b722473e4bf22$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $9f3b722473e4bf22$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $9f3b722473e4bf22$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $9f3b722473e4bf22$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $9f3b722473e4bf22$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $9f3b722473e4bf22$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $9f3b722473e4bf22$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLFormElement");
var $9f3b722473e4bf22$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLFormElement");
var $9f3b722473e4bf22$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLFormElement");
var $9f3b722473e4bf22$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLFormElement");
var $9f3b722473e4bf22$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLFormElement");
var $9f3b722473e4bf22$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLFormElement");
var $9f3b722473e4bf22$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLFormElement");

});
parcelRegister("k5ChQ", function(module, exports) {
function $ea01f93abd44760a$export$7e2eca70ed294fb(form) {
    return function() {
        return form.acceptCharset;
    };
}
function $ea01f93abd44760a$export$9ec8703ca0dc2663(acceptCharset) {
    return function(form) {
        return function() {
            form.acceptCharset = acceptCharset;
        };
    };
}
function $ea01f93abd44760a$export$31eb53bd5b582a97(form) {
    return function() {
        return form.action;
    };
}
function $ea01f93abd44760a$export$a0c65badd8d09883(action) {
    return function(form) {
        return function() {
            form.action = action;
        };
    };
}
function $ea01f93abd44760a$export$485ded5f26ebe08d(form) {
    return function() {
        return form.autocomplete;
    };
}
function $ea01f93abd44760a$export$5fb7c729919301a5(autocomplete) {
    return function(form) {
        return function() {
            form.autocomplete = autocomplete;
        };
    };
}
function $ea01f93abd44760a$export$9fc5d082ec250407(form) {
    return function() {
        return form.enctype;
    };
}
function $ea01f93abd44760a$export$71f7bac871e6ce1b(enctype) {
    return function(form) {
        return function() {
            form.enctype = enctype;
        };
    };
}
function $ea01f93abd44760a$export$d8738670c721d955(form) {
    return function() {
        return form.encoding;
    };
}
function $ea01f93abd44760a$export$11699ce243a224fd(encoding) {
    return function(form) {
        return function() {
            form.encoding = encoding;
        };
    };
}
function $ea01f93abd44760a$export$26f73335cc2e7868(form) {
    return function() {
        return form.method;
    };
}
function $ea01f93abd44760a$export$8c6ecab5174b959(method) {
    return function(form) {
        return function() {
            form.method = method;
        };
    };
}
function $ea01f93abd44760a$export$a8ff84c12d48cfa6(form) {
    return function() {
        return form.name;
    };
}
function $ea01f93abd44760a$export$6cf3d710d3a367e5(name) {
    return function(form) {
        return function() {
            form.name = name;
        };
    };
}
function $ea01f93abd44760a$export$f50297589147f25e(form) {
    return function() {
        return form.noValidate;
    };
}
function $ea01f93abd44760a$export$2271539dcccd0a8a(noValidate) {
    return function(form) {
        return function() {
            form.noValidate = noValidate;
        };
    };
}
function $ea01f93abd44760a$export$44271b4f0c6a3563(form) {
    return function() {
        return form.target;
    };
}
function $ea01f93abd44760a$export$1f61c53461aff4a5(target) {
    return function(form) {
        return function() {
            form.target = target;
        };
    };
}
function $ea01f93abd44760a$export$f24224f1c91d8156(form) {
    return function() {
        return form.length;
    };
}
function $ea01f93abd44760a$export$853c27de4ce0f746(form) {
    return function() {
        form.submit();
    };
}
function $ea01f93abd44760a$export$aad8462122ac592b(form) {
    return function() {
        form.reset();
    };
}
function $ea01f93abd44760a$export$50d70f8cedc54453(form) {
    return function() {
        return form.checkValidity();
    };
}
function $ea01f93abd44760a$export$b962d864c477cc49(form) {
    return function() {
        return form.reportValidity();
    };
}

});


parcelRegister("5sdFN", function(module, exports) {
// Generated by purs version 0.15.16
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $3f8a2c745615078e$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $3f8a2c745615078e$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $3f8a2c745615078e$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $3f8a2c745615078e$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $3f8a2c745615078e$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $3f8a2c745615078e$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $3f8a2c745615078e$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $3f8a2c745615078e$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLHRElement");
var $3f8a2c745615078e$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLHRElement");
var $3f8a2c745615078e$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLHRElement");
var $3f8a2c745615078e$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLHRElement");
var $3f8a2c745615078e$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLHRElement");
var $3f8a2c745615078e$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLHRElement");
var $3f8a2c745615078e$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLHRElement");

});

parcelRegister("kXX5Y", function(module, exports) {
// Generated by purs version 0.15.16
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $f437286c23d51fb9$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $f437286c23d51fb9$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $f437286c23d51fb9$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $f437286c23d51fb9$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $f437286c23d51fb9$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $f437286c23d51fb9$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $f437286c23d51fb9$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $f437286c23d51fb9$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLHeadElement");
var $f437286c23d51fb9$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLHeadElement");
var $f437286c23d51fb9$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLHeadElement");
var $f437286c23d51fb9$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLHeadElement");
var $f437286c23d51fb9$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLHeadElement");
var $f437286c23d51fb9$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLHeadElement");
var $f437286c23d51fb9$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLHeadElement");

});

parcelRegister("e8wS4", function(module, exports) {
// Generated by purs version 0.15.16
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $a4ab4f8ed836a554$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $a4ab4f8ed836a554$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $a4ab4f8ed836a554$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $a4ab4f8ed836a554$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $a4ab4f8ed836a554$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $a4ab4f8ed836a554$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $a4ab4f8ed836a554$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $a4ab4f8ed836a554$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLHeadingElement");
var $a4ab4f8ed836a554$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLHeadingElement");
var $a4ab4f8ed836a554$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLHeadingElement");
var $a4ab4f8ed836a554$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLHeadingElement");
var $a4ab4f8ed836a554$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLHeadingElement");
var $a4ab4f8ed836a554$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLHeadingElement");
var $a4ab4f8ed836a554$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLHeadingElement");

});

parcelRegister("gg536", function(module, exports) {
// Generated by purs version 0.15.16

var $cUx7b = parcelRequire("cUx7b");

var $l0wDR = parcelRequire("l0wDR");

var $T79xE = parcelRequire("T79xE");

var $9hRVP = parcelRequire("9hRVP");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $bd620e99ccde661e$var$map = /* #__PURE__ */ $l0wDR.map($9hRVP.functorEffect);
var $bd620e99ccde661e$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $bd620e99ccde661e$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $bd620e99ccde661e$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $bd620e99ccde661e$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $bd620e99ccde661e$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $bd620e99ccde661e$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $bd620e99ccde661e$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $bd620e99ccde661e$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLIFrameElement");
var $bd620e99ccde661e$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLIFrameElement");
var $bd620e99ccde661e$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLIFrameElement");
var $bd620e99ccde661e$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLIFrameElement");
var $bd620e99ccde661e$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLIFrameElement");
var $bd620e99ccde661e$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLIFrameElement");
var $bd620e99ccde661e$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLIFrameElement");
var $bd620e99ccde661e$export$6677e9b58554b15d = /* #__PURE__ */ function() {
    var $2 = $bd620e99ccde661e$var$map($T79xE.toMaybe);
    return function($3) {
        return $2($cUx7b._contentWindow($3));
    };
}();
var $bd620e99ccde661e$export$a186087d330c547b = /* #__PURE__ */ function() {
    var $4 = $bd620e99ccde661e$var$map($T79xE.toMaybe);
    return function($5) {
        return $4($cUx7b._contentDocument($5));
    };
}();

});
parcelRegister("cUx7b", function(module, exports) {

$parcel$export(module.exports, "_contentDocument", () => $966466ed4b666020$export$a51825c89fe24f94);
$parcel$export(module.exports, "_contentWindow", () => $966466ed4b666020$export$688aae7b7ac35f92);
function $966466ed4b666020$export$2e40c9e35e9506f4(iframe) {
    return function() {
        return iframe.src;
    };
}
function $966466ed4b666020$export$5771e3a4c80da7df(src) {
    return function(iframe) {
        return function() {
            iframe.src = src;
        };
    };
}
function $966466ed4b666020$export$7be70892c9d4d10e(iframe) {
    return function() {
        return iframe.srcdoc;
    };
}
function $966466ed4b666020$export$8a11fa357d4cbbc0(srcdoc) {
    return function(iframe) {
        return function() {
            iframe.srcdoc = srcdoc;
        };
    };
}
function $966466ed4b666020$export$a8ff84c12d48cfa6(iframe) {
    return function() {
        return iframe.name;
    };
}
function $966466ed4b666020$export$6cf3d710d3a367e5(name) {
    return function(iframe) {
        return function() {
            iframe.name = name;
        };
    };
}
function $966466ed4b666020$export$7e3df82ee760448c(iframe) {
    return function() {
        return iframe.width;
    };
}
function $966466ed4b666020$export$67f48e0594af05d(width) {
    return function(iframe) {
        return function() {
            iframe.width = width;
        };
    };
}
function $966466ed4b666020$export$ac607276a8fe9f0a(iframe) {
    return function() {
        return iframe.height;
    };
}
function $966466ed4b666020$export$3f31360357be44e4(height) {
    return function(iframe) {
        return function() {
            iframe.height = height;
        };
    };
}
function $966466ed4b666020$export$a51825c89fe24f94(iframe) {
    return function() {
        return iframe.contentDocument;
    };
}
function $966466ed4b666020$export$688aae7b7ac35f92(iframe) {
    return function() {
        return iframe.contentWindow;
    };
}

});


parcelRegister("3zf9Y", function(module, exports) {
// Generated by purs version 0.15.16

var $6Qn6U = parcelRequire("6Qn6U");

var $9Grh5 = parcelRequire("9Grh5");

var $l0wDR = parcelRequire("l0wDR");

var $ykHdR = parcelRequire("ykHdR");

var $T79xE = parcelRequire("T79xE");

var $9hRVP = parcelRequire("9hRVP");
parcelRequire("3bQIh");
var $3voTt = parcelRequire("3voTt");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $lWiqy = parcelRequire("lWiqy");

var $gnFY8 = parcelRequire("gnFY8");

var $edk1H = parcelRequire("edk1H");

var $6EJMX = parcelRequire("6EJMX");
var $29906668619f3a83$var$map = /* #__PURE__ */ $l0wDR.map($9hRVP.functorEffect);
var $29906668619f3a83$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $29906668619f3a83$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $29906668619f3a83$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $29906668619f3a83$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $29906668619f3a83$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $29906668619f3a83$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $29906668619f3a83$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $29906668619f3a83$export$3ac708362c1f96eb = function(laziness) {
    return $3voTt.runEffectFn2($6Qn6U._setLoading)($edk1H.print(laziness));
};
var $29906668619f3a83$export$fe0b2eeb59b63d00 = function(hint) {
    return $3voTt.runEffectFn2($6Qn6U._setDecoding)($gnFY8.print(hint));
};
var $29906668619f3a83$export$e7fd69f64f92856 = function(mode) {
    return $3voTt.runEffectFn2($6Qn6U._setCrossOrigin)($lWiqy.print(mode));
};
var $29906668619f3a83$export$46c1c92549715335 = /* #__PURE__ */ function() {
    var $3 = $29906668619f3a83$var$map(function() {
        var $6 = $ykHdR.fromMaybe($edk1H.Eager.value);
        return function($7) {
            return $6($edk1H.parse($7));
        };
    }());
    var $4 = $3voTt.runEffectFn1($6Qn6U._loading);
    return function($5) {
        return $3($4($5));
    };
}();
var $29906668619f3a83$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLImageElement");
var $29906668619f3a83$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLImageElement");
var $29906668619f3a83$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLImageElement");
var $29906668619f3a83$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLImageElement");
var $29906668619f3a83$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLImageElement");
var $29906668619f3a83$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLImageElement");
var $29906668619f3a83$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLImageElement");
var $29906668619f3a83$export$7b9cc1601c0b9c78 = /* #__PURE__ */ function() {
    var $8 = $29906668619f3a83$var$map(function() {
        var $11 = $ykHdR.fromMaybe($gnFY8.Auto.value);
        return function($12) {
            return $11($gnFY8.parse($12));
        };
    }());
    var $9 = $3voTt.runEffectFn1($6Qn6U._decoding);
    return function($10) {
        return $8($9($10));
    };
}();
var $29906668619f3a83$export$c47cb7c63271266e = /* #__PURE__ */ function() {
    var $13 = $29906668619f3a83$var$map($9Grh5.composeKleisliFlipped($ykHdR.bindMaybe)($lWiqy.parse)($T79xE.toMaybe));
    var $14 = $3voTt.runEffectFn1($6Qn6U._crossOrigin);
    return function($15) {
        return $13($14($15));
    };
}();
var $29906668619f3a83$export$20f9c2173df486a8 = $6Qn6U.createWithDimensions;

});
parcelRegister("6Qn6U", function(module, exports) {

$parcel$export(module.exports, "createWithDimensions", () => $4fb986a93dbcc125$export$11b6d15e47fb61cf);
$parcel$export(module.exports, "_crossOrigin", () => $4fb986a93dbcc125$export$2a95876eedf9defd);
$parcel$export(module.exports, "_setCrossOrigin", () => $4fb986a93dbcc125$export$15671bab5b2a825c);
$parcel$export(module.exports, "_decoding", () => $4fb986a93dbcc125$export$8774eb0dcbbe3146);
$parcel$export(module.exports, "_setDecoding", () => $4fb986a93dbcc125$export$533597f26ad51793);
$parcel$export(module.exports, "_loading", () => $4fb986a93dbcc125$export$c1978f45d5c8c1fd);
$parcel$export(module.exports, "_setLoading", () => $4fb986a93dbcc125$export$820843123ac3b9d);
function $4fb986a93dbcc125$export$185802fd694ee1f5() {
    return new Image();
}
function $4fb986a93dbcc125$export$11b6d15e47fb61cf(width) {
    return function(height) {
        return function() {
            return new Image(width, height);
        };
    };
}
function $4fb986a93dbcc125$export$228be17d80722ab(image) {
    return function() {
        return image.alt;
    };
}
function $4fb986a93dbcc125$export$14a0e7c2e6152665(alt) {
    return function(image) {
        return function() {
            image.alt = alt;
        };
    };
}
function $4fb986a93dbcc125$export$2e40c9e35e9506f4(image) {
    return function() {
        return image.src;
    };
}
function $4fb986a93dbcc125$export$5771e3a4c80da7df(src) {
    return function(image) {
        return function() {
            image.src = src;
        };
    };
}
function $4fb986a93dbcc125$export$c2507fd1cd56d483(image) {
    return function() {
        return image.srcset;
    };
}
function $4fb986a93dbcc125$export$c95fa5d268267aa4(srcset) {
    return function(image) {
        return function() {
            image.srcset = srcset;
        };
    };
}
function $4fb986a93dbcc125$export$c647cb0ee6e282fe(image) {
    return function() {
        return image.sizes;
    };
}
function $4fb986a93dbcc125$export$2652819f9fe6d59b(sizes) {
    return function(image) {
        return function() {
            image.sizes = sizes;
        };
    };
}
function $4fb986a93dbcc125$export$22e7408040d24cb8(image) {
    return function() {
        return image.currentSrc;
    };
}
function $4fb986a93dbcc125$export$2a95876eedf9defd(image) {
    return image.crossOrigin;
}
function $4fb986a93dbcc125$export$15671bab5b2a825c(crossOrigin, image) {
    image.crossOrigin = crossOrigin;
}
function $4fb986a93dbcc125$export$86f8f9f08863e403(image) {
    return function() {
        return image.useMap;
    };
}
function $4fb986a93dbcc125$export$ab416bdbb887640e(useMap) {
    return function(image) {
        return function() {
            image.useMap = useMap;
        };
    };
}
function $4fb986a93dbcc125$export$5c90113a285f2241(image) {
    return function() {
        return image.isMap;
    };
}
function $4fb986a93dbcc125$export$e634cf4c55ef6324(isMap) {
    return function(image) {
        return function() {
            image.isMap = isMap;
        };
    };
}
function $4fb986a93dbcc125$export$7e3df82ee760448c(image) {
    return function() {
        return image.width;
    };
}
function $4fb986a93dbcc125$export$67f48e0594af05d(width) {
    return function(image) {
        return function() {
            image.width = width;
        };
    };
}
function $4fb986a93dbcc125$export$ac607276a8fe9f0a(image) {
    return function() {
        return image.height;
    };
}
function $4fb986a93dbcc125$export$3f31360357be44e4(height) {
    return function(image) {
        return function() {
            image.height = height;
        };
    };
}
function $4fb986a93dbcc125$export$c32e50dfb9f4ec89(image) {
    return function() {
        return image.naturalWidth;
    };
}
function $4fb986a93dbcc125$export$6a4b566b54dc81c0(image) {
    return function() {
        return image.naturalHeight;
    };
}
function $4fb986a93dbcc125$export$8b29ef2611187a5f(image) {
    return function() {
        return image.referrerPolicy;
    };
}
function $4fb986a93dbcc125$export$c73d54db5b3c6ed4(referrerPolicy) {
    return function(image) {
        return function() {
            image.referrerPolicy = referrerPolicy;
        };
    };
}
function $4fb986a93dbcc125$export$8774eb0dcbbe3146(image) {
    return image.decoding;
}
function $4fb986a93dbcc125$export$533597f26ad51793(decoding, image) {
    image.decoding = decoding;
}
function $4fb986a93dbcc125$export$c1978f45d5c8c1fd(image) {
    return image.loading;
}
function $4fb986a93dbcc125$export$820843123ac3b9d(loading, image) {
    image.loading = loading;
}
function $4fb986a93dbcc125$export$b1bc8081da8c9e77(image) {
    return function() {
        return image.complete;
    };
}

});

parcelRegister("3bQIh", function(module, exports) {

$parcel$export(module.exports, "runEffectFn1", () => (parcelRequire("3voTt")).runEffectFn1);
$parcel$export(module.exports, "runEffectFn2", () => (parcelRequire("3voTt")).runEffectFn2);
// Generated by purs version 0.15.16

var $3voTt = parcelRequire("3voTt");

var $aknDF = parcelRequire("aknDF");

var $iwqgS = parcelRequire("iwqgS");

var $9hRVP = parcelRequire("9hRVP");
var $252b49eb63e60f04$export$6b33adf3a8e3f704 = function(dictSemigroup) {
    var append = $iwqgS.append($9hRVP.semigroupEffect(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $3voTt.mkEffectFn9(function(a) {
                    return function(b) {
                        return function(c) {
                            return function(d) {
                                return function(e) {
                                    return function(f) {
                                        return function(g) {
                                            return function(h) {
                                                return function(i) {
                                                    return append($3voTt.runEffectFn9(f1)(a)(b)(c)(d)(e)(f)(g)(h)(i))($3voTt.runEffectFn9(f2)(a)(b)(c)(d)(e)(f)(g)(h)(i));
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                });
            };
        }
    };
};
var $252b49eb63e60f04$export$1b434506fc11421 = function(dictSemigroup) {
    var append = $iwqgS.append($9hRVP.semigroupEffect(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $3voTt.mkEffectFn8(function(a) {
                    return function(b) {
                        return function(c) {
                            return function(d) {
                                return function(e) {
                                    return function(f) {
                                        return function(g) {
                                            return function(h) {
                                                return append($3voTt.runEffectFn8(f1)(a)(b)(c)(d)(e)(f)(g)(h))($3voTt.runEffectFn8(f2)(a)(b)(c)(d)(e)(f)(g)(h));
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                });
            };
        }
    };
};
var $252b49eb63e60f04$export$f9d62e28920765a6 = function(dictSemigroup) {
    var append = $iwqgS.append($9hRVP.semigroupEffect(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $3voTt.mkEffectFn7(function(a) {
                    return function(b) {
                        return function(c) {
                            return function(d) {
                                return function(e) {
                                    return function(f) {
                                        return function(g) {
                                            return append($3voTt.runEffectFn7(f1)(a)(b)(c)(d)(e)(f)(g))($3voTt.runEffectFn7(f2)(a)(b)(c)(d)(e)(f)(g));
                                        };
                                    };
                                };
                            };
                        };
                    };
                });
            };
        }
    };
};
var $252b49eb63e60f04$export$1cdb6e5a843aefe2 = function(dictSemigroup) {
    var append = $iwqgS.append($9hRVP.semigroupEffect(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $3voTt.mkEffectFn6(function(a) {
                    return function(b) {
                        return function(c) {
                            return function(d) {
                                return function(e) {
                                    return function(f) {
                                        return append($3voTt.runEffectFn6(f1)(a)(b)(c)(d)(e)(f))($3voTt.runEffectFn6(f2)(a)(b)(c)(d)(e)(f));
                                    };
                                };
                            };
                        };
                    };
                });
            };
        }
    };
};
var $252b49eb63e60f04$export$99aa837ed31887aa = function(dictSemigroup) {
    var append = $iwqgS.append($9hRVP.semigroupEffect(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $3voTt.mkEffectFn5(function(a) {
                    return function(b) {
                        return function(c) {
                            return function(d) {
                                return function(e) {
                                    return append($3voTt.runEffectFn5(f1)(a)(b)(c)(d)(e))($3voTt.runEffectFn5(f2)(a)(b)(c)(d)(e));
                                };
                            };
                        };
                    };
                });
            };
        }
    };
};
var $252b49eb63e60f04$export$8cb019b91258e3b9 = function(dictSemigroup) {
    var append = $iwqgS.append($9hRVP.semigroupEffect(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $3voTt.mkEffectFn4(function(a) {
                    return function(b) {
                        return function(c) {
                            return function(d) {
                                return append($3voTt.runEffectFn4(f1)(a)(b)(c)(d))($3voTt.runEffectFn4(f2)(a)(b)(c)(d));
                            };
                        };
                    };
                });
            };
        }
    };
};
var $252b49eb63e60f04$export$fb0bdf58ff0a6426 = function(dictSemigroup) {
    var append = $iwqgS.append($9hRVP.semigroupEffect(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $3voTt.mkEffectFn3(function(a) {
                    return function(b) {
                        return function(c) {
                            return append($3voTt.runEffectFn3(f1)(a)(b)(c))($3voTt.runEffectFn3(f2)(a)(b)(c));
                        };
                    };
                });
            };
        }
    };
};
var $252b49eb63e60f04$export$9bf195cde6bca966 = function(dictSemigroup) {
    var append = $iwqgS.append($9hRVP.semigroupEffect(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $3voTt.mkEffectFn2(function(a) {
                    return function(b) {
                        return append($3voTt.runEffectFn2(f1)(a)(b))($3voTt.runEffectFn2(f2)(a)(b));
                    };
                });
            };
        }
    };
};
var $252b49eb63e60f04$export$39f0bfa3de9c8ca1 = function(dictSemigroup) {
    var append = $iwqgS.append($9hRVP.semigroupEffect(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $3voTt.mkEffectFn10(function(a) {
                    return function(b) {
                        return function(c) {
                            return function(d) {
                                return function(e) {
                                    return function(f) {
                                        return function(g) {
                                            return function(h) {
                                                return function(i) {
                                                    return function(j) {
                                                        return append($3voTt.runEffectFn10(f1)(a)(b)(c)(d)(e)(f)(g)(h)(i)(j))($3voTt.runEffectFn10(f2)(a)(b)(c)(d)(e)(f)(g)(h)(i)(j));
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                });
            };
        }
    };
};
var $252b49eb63e60f04$export$d15c5b9160f5bf5 = function(dictSemigroup) {
    var append = $iwqgS.append($9hRVP.semigroupEffect(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $3voTt.mkEffectFn1(function(a) {
                    return append($3voTt.runEffectFn1(f1)(a))($3voTt.runEffectFn1(f2)(a));
                });
            };
        }
    };
};
var $252b49eb63e60f04$export$951567719e338e25 = function(dictMonoid) {
    var mempty = $aknDF.mempty($9hRVP.monoidEffect(dictMonoid));
    var semigroupEffectFn91 = $252b49eb63e60f04$export$6b33adf3a8e3f704(dictMonoid.Semigroup0());
    return {
        mempty: $3voTt.mkEffectFn9(function(v) {
            return function(v1) {
                return function(v2) {
                    return function(v3) {
                        return function(v4) {
                            return function(v5) {
                                return function(v6) {
                                    return function(v7) {
                                        return function(v8) {
                                            return mempty;
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        }),
        Semigroup0: function() {
            return semigroupEffectFn91;
        }
    };
};
var $252b49eb63e60f04$export$60b4106c40599be6 = function(dictMonoid) {
    var mempty = $aknDF.mempty($9hRVP.monoidEffect(dictMonoid));
    var semigroupEffectFn81 = $252b49eb63e60f04$export$1b434506fc11421(dictMonoid.Semigroup0());
    return {
        mempty: $3voTt.mkEffectFn8(function(v) {
            return function(v1) {
                return function(v2) {
                    return function(v3) {
                        return function(v4) {
                            return function(v5) {
                                return function(v6) {
                                    return function(v7) {
                                        return mempty;
                                    };
                                };
                            };
                        };
                    };
                };
            };
        }),
        Semigroup0: function() {
            return semigroupEffectFn81;
        }
    };
};
var $252b49eb63e60f04$export$63d6254dd5b47db1 = function(dictMonoid) {
    var mempty = $aknDF.mempty($9hRVP.monoidEffect(dictMonoid));
    var semigroupEffectFn71 = $252b49eb63e60f04$export$f9d62e28920765a6(dictMonoid.Semigroup0());
    return {
        mempty: $3voTt.mkEffectFn7(function(v) {
            return function(v1) {
                return function(v2) {
                    return function(v3) {
                        return function(v4) {
                            return function(v5) {
                                return function(v6) {
                                    return mempty;
                                };
                            };
                        };
                    };
                };
            };
        }),
        Semigroup0: function() {
            return semigroupEffectFn71;
        }
    };
};
var $252b49eb63e60f04$export$80d58e93d1dd53e4 = function(dictMonoid) {
    var mempty = $aknDF.mempty($9hRVP.monoidEffect(dictMonoid));
    var semigroupEffectFn61 = $252b49eb63e60f04$export$1cdb6e5a843aefe2(dictMonoid.Semigroup0());
    return {
        mempty: $3voTt.mkEffectFn6(function(v) {
            return function(v1) {
                return function(v2) {
                    return function(v3) {
                        return function(v4) {
                            return function(v5) {
                                return mempty;
                            };
                        };
                    };
                };
            };
        }),
        Semigroup0: function() {
            return semigroupEffectFn61;
        }
    };
};
var $252b49eb63e60f04$export$c346a9c2957c12e8 = function(dictMonoid) {
    var mempty = $aknDF.mempty($9hRVP.monoidEffect(dictMonoid));
    var semigroupEffectFn51 = $252b49eb63e60f04$export$99aa837ed31887aa(dictMonoid.Semigroup0());
    return {
        mempty: $3voTt.mkEffectFn5(function(v) {
            return function(v1) {
                return function(v2) {
                    return function(v3) {
                        return function(v4) {
                            return mempty;
                        };
                    };
                };
            };
        }),
        Semigroup0: function() {
            return semigroupEffectFn51;
        }
    };
};
var $252b49eb63e60f04$export$fd6b07fef28d22de = function(dictMonoid) {
    var mempty = $aknDF.mempty($9hRVP.monoidEffect(dictMonoid));
    var semigroupEffectFn41 = $252b49eb63e60f04$export$8cb019b91258e3b9(dictMonoid.Semigroup0());
    return {
        mempty: $3voTt.mkEffectFn4(function(v) {
            return function(v1) {
                return function(v2) {
                    return function(v3) {
                        return mempty;
                    };
                };
            };
        }),
        Semigroup0: function() {
            return semigroupEffectFn41;
        }
    };
};
var $252b49eb63e60f04$export$f091af598ee150a6 = function(dictMonoid) {
    var mempty = $aknDF.mempty($9hRVP.monoidEffect(dictMonoid));
    var semigroupEffectFn31 = $252b49eb63e60f04$export$fb0bdf58ff0a6426(dictMonoid.Semigroup0());
    return {
        mempty: $3voTt.mkEffectFn3(function(v) {
            return function(v1) {
                return function(v2) {
                    return mempty;
                };
            };
        }),
        Semigroup0: function() {
            return semigroupEffectFn31;
        }
    };
};
var $252b49eb63e60f04$export$6294c3a3ece87949 = function(dictMonoid) {
    var mempty = $aknDF.mempty($9hRVP.monoidEffect(dictMonoid));
    var semigroupEffectFn21 = $252b49eb63e60f04$export$9bf195cde6bca966(dictMonoid.Semigroup0());
    return {
        mempty: $3voTt.mkEffectFn2(function(v) {
            return function(v1) {
                return mempty;
            };
        }),
        Semigroup0: function() {
            return semigroupEffectFn21;
        }
    };
};
var $252b49eb63e60f04$export$c62e1ced10b8c8b0 = function(dictMonoid) {
    var mempty = $aknDF.mempty($9hRVP.monoidEffect(dictMonoid));
    var semigroupEffectFn101 = $252b49eb63e60f04$export$39f0bfa3de9c8ca1(dictMonoid.Semigroup0());
    return {
        mempty: $3voTt.mkEffectFn10(function(v) {
            return function(v1) {
                return function(v2) {
                    return function(v3) {
                        return function(v4) {
                            return function(v5) {
                                return function(v6) {
                                    return function(v7) {
                                        return function(v8) {
                                            return function(v9) {
                                                return mempty;
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        }),
        Semigroup0: function() {
            return semigroupEffectFn101;
        }
    };
};
var $252b49eb63e60f04$export$333b269eda63e7a7 = function(dictMonoid) {
    var mempty = $aknDF.mempty($9hRVP.monoidEffect(dictMonoid));
    var semigroupEffectFn11 = $252b49eb63e60f04$export$d15c5b9160f5bf5(dictMonoid.Semigroup0());
    return {
        mempty: $3voTt.mkEffectFn1(function(v) {
            return mempty;
        }),
        Semigroup0: function() {
            return semigroupEffectFn11;
        }
    };
};

});
parcelRegister("3voTt", function(module, exports) {

$parcel$export(module.exports, "mkEffectFn1", () => $28d793bcad7b6401$export$33e695b1da6bf8ce);
$parcel$export(module.exports, "mkEffectFn2", () => $28d793bcad7b6401$export$d349e7010d9e4f18);
$parcel$export(module.exports, "mkEffectFn3", () => $28d793bcad7b6401$export$1329fa30c595aae1);
$parcel$export(module.exports, "mkEffectFn4", () => $28d793bcad7b6401$export$745d51d1abc5cd82);
$parcel$export(module.exports, "mkEffectFn5", () => $28d793bcad7b6401$export$b3413456c3617180);
$parcel$export(module.exports, "mkEffectFn6", () => $28d793bcad7b6401$export$becea21a68009b07);
$parcel$export(module.exports, "mkEffectFn7", () => $28d793bcad7b6401$export$83674e2607660e0f);
$parcel$export(module.exports, "mkEffectFn8", () => $28d793bcad7b6401$export$c7f26c65f1b8e3);
$parcel$export(module.exports, "mkEffectFn9", () => $28d793bcad7b6401$export$5d4846e0dbe026fa);
$parcel$export(module.exports, "mkEffectFn10", () => $28d793bcad7b6401$export$ac08820aca1c1ebc);
$parcel$export(module.exports, "runEffectFn1", () => $28d793bcad7b6401$export$84baa7a1ea5377fd);
$parcel$export(module.exports, "runEffectFn2", () => $28d793bcad7b6401$export$6a301f847372dca1);
$parcel$export(module.exports, "runEffectFn3", () => $28d793bcad7b6401$export$40df0ea470e346f0);
$parcel$export(module.exports, "runEffectFn4", () => $28d793bcad7b6401$export$ec3c5c8caae58867);
$parcel$export(module.exports, "runEffectFn5", () => $28d793bcad7b6401$export$5b882d1088aa8dc9);
$parcel$export(module.exports, "runEffectFn6", () => $28d793bcad7b6401$export$53e477d88d18e854);
$parcel$export(module.exports, "runEffectFn7", () => $28d793bcad7b6401$export$2d0fb35e82261b8d);
$parcel$export(module.exports, "runEffectFn8", () => $28d793bcad7b6401$export$801a85b4a2b405ac);
$parcel$export(module.exports, "runEffectFn9", () => $28d793bcad7b6401$export$326863f2889caa23);
$parcel$export(module.exports, "runEffectFn10", () => $28d793bcad7b6401$export$8fc2053a354b81aa);
const $28d793bcad7b6401$export$33e695b1da6bf8ce = function mkEffectFn1(fn) {
    return function(x) {
        return fn(x)();
    };
};
const $28d793bcad7b6401$export$d349e7010d9e4f18 = function mkEffectFn2(fn) {
    return function(a, b) {
        return fn(a)(b)();
    };
};
const $28d793bcad7b6401$export$1329fa30c595aae1 = function mkEffectFn3(fn) {
    return function(a, b, c) {
        return fn(a)(b)(c)();
    };
};
const $28d793bcad7b6401$export$745d51d1abc5cd82 = function mkEffectFn4(fn) {
    return function(a, b, c, d) {
        return fn(a)(b)(c)(d)();
    };
};
const $28d793bcad7b6401$export$b3413456c3617180 = function mkEffectFn5(fn) {
    return function(a, b, c, d, e) {
        return fn(a)(b)(c)(d)(e)();
    };
};
const $28d793bcad7b6401$export$becea21a68009b07 = function mkEffectFn6(fn) {
    return function(a, b, c, d, e, f) {
        return fn(a)(b)(c)(d)(e)(f)();
    };
};
const $28d793bcad7b6401$export$83674e2607660e0f = function mkEffectFn7(fn) {
    return function(a, b, c, d, e, f, g) {
        return fn(a)(b)(c)(d)(e)(f)(g)();
    };
};
const $28d793bcad7b6401$export$c7f26c65f1b8e3 = function mkEffectFn8(fn) {
    return function(a, b, c, d, e, f, g, h) {
        return fn(a)(b)(c)(d)(e)(f)(g)(h)();
    };
};
const $28d793bcad7b6401$export$5d4846e0dbe026fa = function mkEffectFn9(fn) {
    return function(a, b, c, d, e, f, g, h, i) {
        return fn(a)(b)(c)(d)(e)(f)(g)(h)(i)();
    };
};
const $28d793bcad7b6401$export$ac08820aca1c1ebc = function mkEffectFn10(fn) {
    return function(a, b, c, d, e, f, g, h, i, j) {
        return fn(a)(b)(c)(d)(e)(f)(g)(h)(i)(j)();
    };
};
const $28d793bcad7b6401$export$84baa7a1ea5377fd = function runEffectFn1(fn) {
    return function(a) {
        return function() {
            return fn(a);
        };
    };
};
const $28d793bcad7b6401$export$6a301f847372dca1 = function runEffectFn2(fn) {
    return function(a) {
        return function(b) {
            return function() {
                return fn(a, b);
            };
        };
    };
};
const $28d793bcad7b6401$export$40df0ea470e346f0 = function runEffectFn3(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function() {
                    return fn(a, b, c);
                };
            };
        };
    };
};
const $28d793bcad7b6401$export$ec3c5c8caae58867 = function runEffectFn4(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function() {
                        return fn(a, b, c, d);
                    };
                };
            };
        };
    };
};
const $28d793bcad7b6401$export$5b882d1088aa8dc9 = function runEffectFn5(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function() {
                            return fn(a, b, c, d, e);
                        };
                    };
                };
            };
        };
    };
};
const $28d793bcad7b6401$export$53e477d88d18e854 = function runEffectFn6(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function() {
                                return fn(a, b, c, d, e, f);
                            };
                        };
                    };
                };
            };
        };
    };
};
const $28d793bcad7b6401$export$2d0fb35e82261b8d = function runEffectFn7(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function() {
                                    return fn(a, b, c, d, e, f, g);
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
const $28d793bcad7b6401$export$801a85b4a2b405ac = function runEffectFn8(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function(h) {
                                    return function() {
                                        return fn(a, b, c, d, e, f, g, h);
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
const $28d793bcad7b6401$export$326863f2889caa23 = function runEffectFn9(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function(h) {
                                    return function(i) {
                                        return function() {
                                            return fn(a, b, c, d, e, f, g, h, i);
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
const $28d793bcad7b6401$export$8fc2053a354b81aa = function runEffectFn10(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function(h) {
                                    return function(i) {
                                        return function(j) {
                                            return function() {
                                                return fn(a, b, c, d, e, f, g, h, i, j);
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};

});


parcelRegister("lWiqy", function(module, exports) {

$parcel$export(module.exports, "print", () => $ff8d4f0527bf7f56$export$c2d084dc44961371);
$parcel$export(module.exports, "parse", () => $ff8d4f0527bf7f56$export$98e6a39c04603d36);
// Generated by purs version 0.15.16

var $ykHdR = parcelRequire("ykHdR");

var $6SDUu = parcelRequire("6SDUu");
var $ff8d4f0527bf7f56$export$e1bb774e9664e700 = /* #__PURE__ */ function() {
    function Anonymous() {}
    Anonymous.value = new Anonymous();
    return Anonymous;
}();
var $ff8d4f0527bf7f56$export$bf6fef082af5a2d3 = /* #__PURE__ */ function() {
    function UseCredentials() {}
    UseCredentials.value = new UseCredentials();
    return UseCredentials;
}();
var $ff8d4f0527bf7f56$export$e83dceb76bcd9724 = {
    show: function(v) {
        if (v instanceof $ff8d4f0527bf7f56$export$e1bb774e9664e700) return "Anonymous";
        if (v instanceof $ff8d4f0527bf7f56$export$bf6fef082af5a2d3) return "UseCredentials";
        throw new Error("Failed pattern match at Web.HTML.HTMLImageElement.CORSMode (line 18, column 10 - line 20, column 39): " + [
            v.constructor.name
        ]);
    }
};
var $ff8d4f0527bf7f56$export$c2d084dc44961371 = function(v) {
    if (v instanceof $ff8d4f0527bf7f56$export$e1bb774e9664e700) return "anonymous";
    if (v instanceof $ff8d4f0527bf7f56$export$bf6fef082af5a2d3) return "use-credentials";
    throw new Error("Failed pattern match at Web.HTML.HTMLImageElement.CORSMode (line 30, column 9 - line 32, column 38): " + [
        v.constructor.name
    ]);
};
var $ff8d4f0527bf7f56$export$98e6a39c04603d36 = function(v) {
    if (v === "") return new $ykHdR.Just($ff8d4f0527bf7f56$export$e1bb774e9664e700.value);
    if (v === "anonymous") return new $ykHdR.Just($ff8d4f0527bf7f56$export$e1bb774e9664e700.value);
    if (v === "use-credentials") return new $ykHdR.Just($ff8d4f0527bf7f56$export$bf6fef082af5a2d3.value);
    return $ykHdR.Nothing.value;
};
var $ff8d4f0527bf7f56$export$8a8a93ce7ed989f9 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $ff8d4f0527bf7f56$export$e1bb774e9664e700 && y instanceof $ff8d4f0527bf7f56$export$e1bb774e9664e700) return true;
            if (x instanceof $ff8d4f0527bf7f56$export$bf6fef082af5a2d3 && y instanceof $ff8d4f0527bf7f56$export$bf6fef082af5a2d3) return true;
            return false;
        };
    }
};
var $ff8d4f0527bf7f56$export$4877633354812171 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $ff8d4f0527bf7f56$export$e1bb774e9664e700 && y instanceof $ff8d4f0527bf7f56$export$e1bb774e9664e700) return $6SDUu.EQ.value;
            if (x instanceof $ff8d4f0527bf7f56$export$e1bb774e9664e700) return $6SDUu.LT.value;
            if (y instanceof $ff8d4f0527bf7f56$export$e1bb774e9664e700) return $6SDUu.GT.value;
            if (x instanceof $ff8d4f0527bf7f56$export$bf6fef082af5a2d3 && y instanceof $ff8d4f0527bf7f56$export$bf6fef082af5a2d3) return $6SDUu.EQ.value;
            throw new Error("Failed pattern match at Web.HTML.HTMLImageElement.CORSMode (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $ff8d4f0527bf7f56$export$8a8a93ce7ed989f9;
    }
};

});

parcelRegister("gnFY8", function(module, exports) {

$parcel$export(module.exports, "Auto", () => $becf597acb9365c5$export$6cc2e70440926d44);
$parcel$export(module.exports, "print", () => $becf597acb9365c5$export$c2d084dc44961371);
$parcel$export(module.exports, "parse", () => $becf597acb9365c5$export$98e6a39c04603d36);
// Generated by purs version 0.15.16

var $ykHdR = parcelRequire("ykHdR");

var $6SDUu = parcelRequire("6SDUu");
var $becf597acb9365c5$export$2ae15352e0a80063 = /* #__PURE__ */ function() {
    function Sync() {}
    Sync.value = new Sync();
    return Sync;
}();
var $becf597acb9365c5$export$4d3c597da532240f = /* #__PURE__ */ function() {
    function Async() {}
    Async.value = new Async();
    return Async;
}();
var $becf597acb9365c5$export$6cc2e70440926d44 = /* #__PURE__ */ function() {
    function Auto() {}
    Auto.value = new Auto();
    return Auto;
}();
var $becf597acb9365c5$export$e83dceb76bcd9724 = {
    show: function(v) {
        if (v instanceof $becf597acb9365c5$export$2ae15352e0a80063) return "Sync";
        if (v instanceof $becf597acb9365c5$export$4d3c597da532240f) return "Async";
        if (v instanceof $becf597acb9365c5$export$6cc2e70440926d44) return "Auto";
        throw new Error("Failed pattern match at Web.HTML.HTMLImageElement.DecodingHint (line 19, column 10 - line 22, column 19): " + [
            v.constructor.name
        ]);
    }
};
var $becf597acb9365c5$export$c2d084dc44961371 = function(v) {
    if (v instanceof $becf597acb9365c5$export$2ae15352e0a80063) return "sync";
    if (v instanceof $becf597acb9365c5$export$4d3c597da532240f) return "async";
    if (v instanceof $becf597acb9365c5$export$6cc2e70440926d44) return "auto";
    throw new Error("Failed pattern match at Web.HTML.HTMLImageElement.DecodingHint (line 33, column 9 - line 36, column 17): " + [
        v.constructor.name
    ]);
};
var $becf597acb9365c5$export$98e6a39c04603d36 = function(v) {
    if (v === "") return new $ykHdR.Just($becf597acb9365c5$export$6cc2e70440926d44.value);
    if (v === "sync") return new $ykHdR.Just($becf597acb9365c5$export$2ae15352e0a80063.value);
    if (v === "async") return new $ykHdR.Just($becf597acb9365c5$export$4d3c597da532240f.value);
    if (v === "auto") return new $ykHdR.Just($becf597acb9365c5$export$6cc2e70440926d44.value);
    return $ykHdR.Nothing.value;
};
var $becf597acb9365c5$export$e32bcfaf2cb99de5 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $becf597acb9365c5$export$2ae15352e0a80063 && y instanceof $becf597acb9365c5$export$2ae15352e0a80063) return true;
            if (x instanceof $becf597acb9365c5$export$4d3c597da532240f && y instanceof $becf597acb9365c5$export$4d3c597da532240f) return true;
            if (x instanceof $becf597acb9365c5$export$6cc2e70440926d44 && y instanceof $becf597acb9365c5$export$6cc2e70440926d44) return true;
            return false;
        };
    }
};
var $becf597acb9365c5$export$d32ec4886a1d7587 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $becf597acb9365c5$export$2ae15352e0a80063 && y instanceof $becf597acb9365c5$export$2ae15352e0a80063) return $6SDUu.EQ.value;
            if (x instanceof $becf597acb9365c5$export$2ae15352e0a80063) return $6SDUu.LT.value;
            if (y instanceof $becf597acb9365c5$export$2ae15352e0a80063) return $6SDUu.GT.value;
            if (x instanceof $becf597acb9365c5$export$4d3c597da532240f && y instanceof $becf597acb9365c5$export$4d3c597da532240f) return $6SDUu.EQ.value;
            if (x instanceof $becf597acb9365c5$export$4d3c597da532240f) return $6SDUu.LT.value;
            if (y instanceof $becf597acb9365c5$export$4d3c597da532240f) return $6SDUu.GT.value;
            if (x instanceof $becf597acb9365c5$export$6cc2e70440926d44 && y instanceof $becf597acb9365c5$export$6cc2e70440926d44) return $6SDUu.EQ.value;
            throw new Error("Failed pattern match at Web.HTML.HTMLImageElement.DecodingHint (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $becf597acb9365c5$export$e32bcfaf2cb99de5;
    }
};

});

parcelRegister("edk1H", function(module, exports) {

$parcel$export(module.exports, "Eager", () => $a591d06baacc8fdb$export$a4acc175556f6dbc);
$parcel$export(module.exports, "print", () => $a591d06baacc8fdb$export$c2d084dc44961371);
$parcel$export(module.exports, "parse", () => $a591d06baacc8fdb$export$98e6a39c04603d36);
// Generated by purs version 0.15.16

var $ykHdR = parcelRequire("ykHdR");

var $6SDUu = parcelRequire("6SDUu");
var $a591d06baacc8fdb$export$a4acc175556f6dbc = /* #__PURE__ */ function() {
    function Eager() {}
    Eager.value = new Eager();
    return Eager;
}();
var $a591d06baacc8fdb$export$b624eff549462981 = /* #__PURE__ */ function() {
    function Lazy() {}
    Lazy.value = new Lazy();
    return Lazy;
}();
var $a591d06baacc8fdb$export$e83dceb76bcd9724 = {
    show: function(v) {
        if (v instanceof $a591d06baacc8fdb$export$a4acc175556f6dbc) return "Eager";
        if (v instanceof $a591d06baacc8fdb$export$b624eff549462981) return "Lazy";
        throw new Error("Failed pattern match at Web.HTML.HTMLImageElement.Laziness (line 18, column 10 - line 20, column 19): " + [
            v.constructor.name
        ]);
    }
};
var $a591d06baacc8fdb$export$c2d084dc44961371 = function(v) {
    if (v instanceof $a591d06baacc8fdb$export$a4acc175556f6dbc) return "eager";
    if (v instanceof $a591d06baacc8fdb$export$b624eff549462981) return "lazy";
    throw new Error("Failed pattern match at Web.HTML.HTMLImageElement.Laziness (line 30, column 9 - line 32, column 17): " + [
        v.constructor.name
    ]);
};
var $a591d06baacc8fdb$export$98e6a39c04603d36 = function(v) {
    if (v === "") return new $ykHdR.Just($a591d06baacc8fdb$export$a4acc175556f6dbc.value);
    if (v === "eager") return new $ykHdR.Just($a591d06baacc8fdb$export$a4acc175556f6dbc.value);
    if (v === "lazy") return new $ykHdR.Just($a591d06baacc8fdb$export$b624eff549462981.value);
    return $ykHdR.Nothing.value;
};
var $a591d06baacc8fdb$export$e32bcfaf2cb99de5 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $a591d06baacc8fdb$export$a4acc175556f6dbc && y instanceof $a591d06baacc8fdb$export$a4acc175556f6dbc) return true;
            if (x instanceof $a591d06baacc8fdb$export$b624eff549462981 && y instanceof $a591d06baacc8fdb$export$b624eff549462981) return true;
            return false;
        };
    }
};
var $a591d06baacc8fdb$export$d32ec4886a1d7587 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $a591d06baacc8fdb$export$a4acc175556f6dbc && y instanceof $a591d06baacc8fdb$export$a4acc175556f6dbc) return $6SDUu.EQ.value;
            if (x instanceof $a591d06baacc8fdb$export$a4acc175556f6dbc) return $6SDUu.LT.value;
            if (y instanceof $a591d06baacc8fdb$export$a4acc175556f6dbc) return $6SDUu.GT.value;
            if (x instanceof $a591d06baacc8fdb$export$b624eff549462981 && y instanceof $a591d06baacc8fdb$export$b624eff549462981) return $6SDUu.EQ.value;
            throw new Error("Failed pattern match at Web.HTML.HTMLImageElement.Laziness (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $a591d06baacc8fdb$export$e32bcfaf2cb99de5;
    }
};

});


parcelRegister("4BKEa", function(module, exports) {
// Generated by purs version 0.15.16

var $527LP = parcelRequire("527LP");

var $l0wDR = parcelRequire("l0wDR");

var $T79xE = parcelRequire("T79xE");

var $9hRVP = parcelRequire("9hRVP");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $35aecd379c08dc0f$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $35aecd379c08dc0f$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $35aecd379c08dc0f$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $35aecd379c08dc0f$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $35aecd379c08dc0f$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $35aecd379c08dc0f$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $35aecd379c08dc0f$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $35aecd379c08dc0f$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLKeygenElement");
var $35aecd379c08dc0f$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLKeygenElement");
var $35aecd379c08dc0f$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLKeygenElement");
var $35aecd379c08dc0f$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLKeygenElement");
var $35aecd379c08dc0f$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLKeygenElement");
var $35aecd379c08dc0f$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLKeygenElement");
var $35aecd379c08dc0f$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLKeygenElement");
var $35aecd379c08dc0f$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $l0wDR.map($9hRVP.functorEffect)($T79xE.toMaybe);
    return function($3) {
        return $2($527LP._form($3));
    };
}();

});
parcelRegister("527LP", function(module, exports) {

$parcel$export(module.exports, "_form", () => $3aa32ab13deeb208$export$242c63e9758836c2);
function $3aa32ab13deeb208$export$4c47992fc278c9a0(keygen) {
    return function() {
        return keygen.autofocus;
    };
}
function $3aa32ab13deeb208$export$db2bbdcbda3d335e(autofocus) {
    return function(keygen) {
        return function() {
            keygen.autofocus = autofocus;
        };
    };
}
function $3aa32ab13deeb208$export$1cb6aab4c63c6c51(keygen) {
    return function() {
        return keygen.challenge;
    };
}
function $3aa32ab13deeb208$export$e4ab94f6a56193a3(challenge) {
    return function(keygen) {
        return function() {
            keygen.challenge = challenge;
        };
    };
}
function $3aa32ab13deeb208$export$683472f6198a076e(keygen) {
    return function() {
        return keygen.disabled;
    };
}
function $3aa32ab13deeb208$export$4532d31cef66d703(disabled) {
    return function(keygen) {
        return function() {
            keygen.disabled = disabled;
        };
    };
}
function $3aa32ab13deeb208$export$242c63e9758836c2(keygen) {
    return function() {
        return keygen.form;
    };
}
function $3aa32ab13deeb208$export$63e1099bcd6b827d(keygen) {
    return function() {
        return keygen.keytype;
    };
}
function $3aa32ab13deeb208$export$d04d7126b9e1b9(keytype) {
    return function(keygen) {
        return function() {
            keygen.keytype = keytype;
        };
    };
}
function $3aa32ab13deeb208$export$a8ff84c12d48cfa6(keygen) {
    return function() {
        return keygen.name;
    };
}
function $3aa32ab13deeb208$export$6cf3d710d3a367e5(name) {
    return function(keygen) {
        return function() {
            keygen.name = name;
        };
    };
}
function $3aa32ab13deeb208$export$d4a6a4db5b31e621(keygen) {
    return function() {
        return keygen.type;
    };
}
function $3aa32ab13deeb208$export$5e55a9e709e8e020(keygen) {
    return function() {
        return keygen.willValidate;
    };
}
function $3aa32ab13deeb208$export$1bdd3f9a89b22594(keygen) {
    return function() {
        return keygen.validity;
    };
}
function $3aa32ab13deeb208$export$6ee4201e37a931e2(keygen) {
    return function() {
        return keygen.validationMessage;
    };
}
function $3aa32ab13deeb208$export$50d70f8cedc54453(keygen) {
    return function() {
        return keygen.checkValidity();
    };
}
function $3aa32ab13deeb208$export$b962d864c477cc49(keygen) {
    return function() {
        return keygen.reportValidity();
    };
}
function $3aa32ab13deeb208$export$6f569cb704992105(value) {
    return function(keygen) {
        return function() {
            keygen.setCustomValidity(value);
        };
    };
}
function $3aa32ab13deeb208$export$a238cb463698c900(keygen) {
    return function() {
        return keygen.labels;
    };
}

});


parcelRegister("64ADu", function(module, exports) {
// Generated by purs version 0.15.16

var $kNEEP = parcelRequire("kNEEP");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $46bf88ea94d3504e$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $46bf88ea94d3504e$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $46bf88ea94d3504e$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $46bf88ea94d3504e$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $46bf88ea94d3504e$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $46bf88ea94d3504e$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $46bf88ea94d3504e$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $46bf88ea94d3504e$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLLIElement");
var $46bf88ea94d3504e$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLLIElement");
var $46bf88ea94d3504e$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLLIElement");
var $46bf88ea94d3504e$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLLIElement");
var $46bf88ea94d3504e$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLLIElement");
var $46bf88ea94d3504e$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLLIElement");
var $46bf88ea94d3504e$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLLIElement");

});
parcelRegister("kNEEP", function(module, exports) {
function $f247ebfc04032388$export$2ab9a8f9f1186f14(li) {
    return function() {
        return li.value;
    };
}
function $f247ebfc04032388$export$80746c6bc6142fc8(value) {
    return function(li) {
        return function() {
            li.value = value;
        };
    };
}

});


parcelRegister("g18mW", function(module, exports) {
// Generated by purs version 0.15.16

var $bCZjj = parcelRequire("bCZjj");

var $l0wDR = parcelRequire("l0wDR");

var $T79xE = parcelRequire("T79xE");

var $9hRVP = parcelRequire("9hRVP");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $ba933b3d44ed7c03$var$map = /* #__PURE__ */ $l0wDR.map($9hRVP.functorEffect);
var $ba933b3d44ed7c03$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $ba933b3d44ed7c03$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $ba933b3d44ed7c03$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $ba933b3d44ed7c03$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $ba933b3d44ed7c03$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $ba933b3d44ed7c03$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $ba933b3d44ed7c03$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $ba933b3d44ed7c03$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLLabelElement");
var $ba933b3d44ed7c03$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLLabelElement");
var $ba933b3d44ed7c03$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLLabelElement");
var $ba933b3d44ed7c03$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLLabelElement");
var $ba933b3d44ed7c03$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLLabelElement");
var $ba933b3d44ed7c03$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLLabelElement");
var $ba933b3d44ed7c03$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLLabelElement");
var $ba933b3d44ed7c03$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $ba933b3d44ed7c03$var$map($T79xE.toMaybe);
    return function($3) {
        return $2($bCZjj._form($3));
    };
}();
var $ba933b3d44ed7c03$export$b5cde1de278b4330 = /* #__PURE__ */ function() {
    var $4 = $ba933b3d44ed7c03$var$map($T79xE.toMaybe);
    return function($5) {
        return $4($bCZjj._control($5));
    };
}();

});
parcelRegister("bCZjj", function(module, exports) {

$parcel$export(module.exports, "_form", () => $8772cd4a9c558251$export$242c63e9758836c2);
$parcel$export(module.exports, "_control", () => $8772cd4a9c558251$export$317fb27ad464e186);
function $8772cd4a9c558251$export$242c63e9758836c2(label) {
    return function() {
        return label.form;
    };
}
function $8772cd4a9c558251$export$35d9e1c947946090(label) {
    return function() {
        return label.htmlFor;
    };
}
function $8772cd4a9c558251$export$a6c638cfae205843(htmlFor) {
    return function(label) {
        return function() {
            label.htmlFor = htmlFor;
        };
    };
}
function $8772cd4a9c558251$export$317fb27ad464e186(label) {
    return function() {
        return label.control;
    };
}

});


parcelRegister("4VEFa", function(module, exports) {
// Generated by purs version 0.15.16

var $6Sfsu = parcelRequire("6Sfsu");

var $l0wDR = parcelRequire("l0wDR");

var $T79xE = parcelRequire("T79xE");

var $9hRVP = parcelRequire("9hRVP");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $396c0721c94d9624$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $396c0721c94d9624$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $396c0721c94d9624$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $396c0721c94d9624$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $396c0721c94d9624$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $396c0721c94d9624$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $396c0721c94d9624$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $396c0721c94d9624$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLLegendElement");
var $396c0721c94d9624$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLLegendElement");
var $396c0721c94d9624$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLLegendElement");
var $396c0721c94d9624$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLLegendElement");
var $396c0721c94d9624$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLLegendElement");
var $396c0721c94d9624$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLLegendElement");
var $396c0721c94d9624$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLLegendElement");
var $396c0721c94d9624$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $l0wDR.map($9hRVP.functorEffect)($T79xE.toMaybe);
    return function($3) {
        return $2($6Sfsu._form($3));
    };
}();

});
parcelRegister("6Sfsu", function(module, exports) {

$parcel$export(module.exports, "_form", () => $5013c6f6daaea1f9$export$242c63e9758836c2);
function $5013c6f6daaea1f9$export$242c63e9758836c2(le) {
    return function() {
        return le.form;
    };
}

});


parcelRegister("8MEQ3", function(module, exports) {
// Generated by purs version 0.15.16

var $016RQ = parcelRequire("016RQ");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $66527c1ba968c066$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $66527c1ba968c066$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $66527c1ba968c066$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $66527c1ba968c066$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $66527c1ba968c066$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $66527c1ba968c066$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $66527c1ba968c066$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $66527c1ba968c066$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLLinkElement");
var $66527c1ba968c066$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLLinkElement");
var $66527c1ba968c066$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLLinkElement");
var $66527c1ba968c066$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLLinkElement");
var $66527c1ba968c066$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLLinkElement");
var $66527c1ba968c066$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLLinkElement");
var $66527c1ba968c066$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLLinkElement");

});
parcelRegister("016RQ", function(module, exports) {
function $00356bd5e80c6412$export$683472f6198a076e(link) {
    return function() {
        return link.disabled;
    };
}
function $00356bd5e80c6412$export$4532d31cef66d703(disabled) {
    return function(link) {
        return function() {
            link.disabled = disabled;
        };
    };
}
function $00356bd5e80c6412$export$8f51af5840e0602a(link) {
    return function() {
        return link.href;
    };
}
function $00356bd5e80c6412$export$428f6e77b5a5a669(href) {
    return function(link) {
        return function() {
            link.href = href;
        };
    };
}
function $00356bd5e80c6412$export$c47cb7c63271266e(link) {
    return function() {
        return link.crossOrigin;
    };
}
function $00356bd5e80c6412$export$e7fd69f64f92856(crossOrigin) {
    return function(link) {
        return function() {
            link.crossOrigin = crossOrigin;
        };
    };
}
function $00356bd5e80c6412$export$bad408f43b005bc8(link) {
    return function() {
        return link.rel;
    };
}
function $00356bd5e80c6412$export$9e86d1af7d63c52c(rel) {
    return function(link) {
        return function() {
            link.rel = rel;
        };
    };
}
function $00356bd5e80c6412$export$edb1c8e715f3944e(link) {
    return function() {
        return link.rev;
    };
}
function $00356bd5e80c6412$export$671b41179a9f15fb(rev) {
    return function(link) {
        return function() {
            link.rev = rev;
        };
    };
}
function $00356bd5e80c6412$export$5884a0b424dd5ef2(link) {
    return function() {
        return link.relList;
    };
}
function $00356bd5e80c6412$export$987d49ffe1b0900f(link) {
    return function() {
        return link.media;
    };
}
function $00356bd5e80c6412$export$5c1855deea651e41(media) {
    return function(link) {
        return function() {
            link.media = media;
        };
    };
}
function $00356bd5e80c6412$export$4bf4138386d6b8cc(link) {
    return function() {
        return link.hreflang;
    };
}
function $00356bd5e80c6412$export$17b5334c80252e15(hreflang) {
    return function(link) {
        return function() {
            link.hreflang = hreflang;
        };
    };
}
function $00356bd5e80c6412$export$d4a6a4db5b31e621(link) {
    return function() {
        return link.type;
    };
}
function $00356bd5e80c6412$export$1bf7f05044e9c5cb(type) {
    return function(link) {
        return function() {
            link.type = type;
        };
    };
}

});


parcelRegister("7iTX8", function(module, exports) {
// Generated by purs version 0.15.16

var $82Vec = parcelRequire("82Vec");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $55159de58cd7500d$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $55159de58cd7500d$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $55159de58cd7500d$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $55159de58cd7500d$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $55159de58cd7500d$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $55159de58cd7500d$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $55159de58cd7500d$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $55159de58cd7500d$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLMapElement");
var $55159de58cd7500d$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLMapElement");
var $55159de58cd7500d$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLMapElement");
var $55159de58cd7500d$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLMapElement");
var $55159de58cd7500d$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLMapElement");
var $55159de58cd7500d$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLMapElement");
var $55159de58cd7500d$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLMapElement");

});
parcelRegister("82Vec", function(module, exports) {
function $5dbae6eb2b9d7a07$export$a8ff84c12d48cfa6(map) {
    return function() {
        return map.name;
    };
}
function $5dbae6eb2b9d7a07$export$6cf3d710d3a367e5(name) {
    return function(map) {
        return function() {
            map.name = name;
        };
    };
}
function $5dbae6eb2b9d7a07$export$4bdc600e2ccf60d6(map) {
    return function() {
        return map.areas;
    };
}
function $5dbae6eb2b9d7a07$export$6c746a5570b8b35c(map) {
    return function() {
        return map.images;
    };
}

});


parcelRegister("8FqE0", function(module, exports) {
// Generated by purs version 0.15.16

var $8Vhcf = parcelRequire("8Vhcf");

var $loxi1 = parcelRequire("loxi1");

var $l0wDR = parcelRequire("l0wDR");

var $ykHdR = parcelRequire("ykHdR");

var $9hRVP = parcelRequire("9hRVP");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $SGhZI = parcelRequire("SGhZI");

var $h90wX = parcelRequire("h90wX");

var $jgHe4 = parcelRequire("jgHe4");

var $6EJMX = parcelRequire("6EJMX");
var $01a0e25b259ac8ae$var$map = /* #__PURE__ */ $l0wDR.map($9hRVP.functorEffect);
var $01a0e25b259ac8ae$var$toEnum = /* #__PURE__ */ $loxi1.toEnum($jgHe4.boundedEnumReadyState);
var $01a0e25b259ac8ae$var$toEnum1 = /* #__PURE__ */ $loxi1.toEnum($h90wX.boundedEnumNetworkState);
var $01a0e25b259ac8ae$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $01a0e25b259ac8ae$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $01a0e25b259ac8ae$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $01a0e25b259ac8ae$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $01a0e25b259ac8ae$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $01a0e25b259ac8ae$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $01a0e25b259ac8ae$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $01a0e25b259ac8ae$export$1ae2b664eea77b7e = function(el) {
    return $01a0e25b259ac8ae$var$map(function() {
        var $4 = $ykHdR.fromMaybe($jgHe4.HaveNothing.value);
        return function($5) {
            return $4($01a0e25b259ac8ae$var$toEnum($5));
        };
    }())(function() {
        return $8Vhcf._readyState(el);
    });
};
var $01a0e25b259ac8ae$export$8ee3aa19592dce0d = function(el) {
    return $01a0e25b259ac8ae$var$map(function() {
        var $6 = $ykHdR.fromMaybe($h90wX.Empty.value);
        return function($7) {
            return $6($01a0e25b259ac8ae$var$toEnum1($7));
        };
    }())(function() {
        return $8Vhcf._networkState(el);
    });
};
var $01a0e25b259ac8ae$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLMediaElement");
var $01a0e25b259ac8ae$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLMediaElement");
var $01a0e25b259ac8ae$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLMediaElement");
var $01a0e25b259ac8ae$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLMediaElement");
var $01a0e25b259ac8ae$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLMediaElement");
var $01a0e25b259ac8ae$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLMediaElement");
var $01a0e25b259ac8ae$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLMediaElement");
var $01a0e25b259ac8ae$export$2b5874dc653b656c = function(ty) {
    return function(el) {
        return $01a0e25b259ac8ae$var$map(function() {
            var $8 = $ykHdR.fromMaybe($SGhZI.Unspecified.value);
            return function($9) {
                return $8($SGhZI.parse($9));
            };
        }())(function() {
            return $8Vhcf._canPlayType(ty, el);
        });
    };
};

});
parcelRegister("8Vhcf", function(module, exports) {

$parcel$export(module.exports, "_networkState", () => $67f0fc7db8c638cb$export$145bdcc6d8d4a53d);
$parcel$export(module.exports, "_canPlayType", () => $67f0fc7db8c638cb$export$1a796126c2303a8);
$parcel$export(module.exports, "_readyState", () => $67f0fc7db8c638cb$export$4bf8a366db6a678b);
function $67f0fc7db8c638cb$export$2e40c9e35e9506f4(media) {
    return function() {
        return media.src;
    };
}
function $67f0fc7db8c638cb$export$5771e3a4c80da7df(src) {
    return function(media) {
        return function() {
            media.src = src;
        };
    };
}
function $67f0fc7db8c638cb$export$22e7408040d24cb8(media) {
    return function() {
        return media.currentSrc;
    };
}
function $67f0fc7db8c638cb$export$c47cb7c63271266e(media) {
    return function() {
        return media.crossOrigin;
    };
}
function $67f0fc7db8c638cb$export$e7fd69f64f92856(crossOrigin) {
    return function(media) {
        return function() {
            media.crossOrigin = crossOrigin;
        };
    };
}
function $67f0fc7db8c638cb$export$145bdcc6d8d4a53d(media) {
    return media.networkState;
}
function $67f0fc7db8c638cb$export$513ccb98c53b8039(media) {
    return function() {
        return media.preload;
    };
}
function $67f0fc7db8c638cb$export$f6b3982121e869a(preload) {
    return function(media) {
        return function() {
            media.preload = preload;
        };
    };
}
function $67f0fc7db8c638cb$export$11e63f7b0f3d9900(media) {
    return function() {
        return media.load();
    };
}
function $67f0fc7db8c638cb$export$1a796126c2303a8(type, media) {
    return media.canPlayType(type);
}
function $67f0fc7db8c638cb$export$4bf8a366db6a678b(media) {
    return media.readyState;
}
function $67f0fc7db8c638cb$export$c8243f3943339030(media) {
    return function() {
        return media.seeking;
    };
}
function $67f0fc7db8c638cb$export$283f641d6ed1ac80(media) {
    return function() {
        return media.currentTime;
    };
}
function $67f0fc7db8c638cb$export$428d94eac67f5311(currentTime) {
    return function(media) {
        return function() {
            media.currentTime = currentTime;
        };
    };
}
function $67f0fc7db8c638cb$export$1f34108aa9eb96ab(media) {
    return function() {
        return media.duration;
    };
}
function $67f0fc7db8c638cb$export$3ee8fbdbeceaef0e(media) {
    return function() {
        return media.getStartDate();
    };
}
function $67f0fc7db8c638cb$export$cd215b91700bbebc(media) {
    return function() {
        return media.paused;
    };
}
function $67f0fc7db8c638cb$export$388da195c50bfd17(media) {
    return function() {
        return media.defaultPlaybackRate;
    };
}
function $67f0fc7db8c638cb$export$6fa34934a59a9a1(defaultPlaybackRate) {
    return function(media) {
        return function() {
            media.defaultPlaybackRate = defaultPlaybackRate;
        };
    };
}
function $67f0fc7db8c638cb$export$6d7f3930b8041bc4(media) {
    return function() {
        return media.playbackRate;
    };
}
function $67f0fc7db8c638cb$export$3f48445a0d32edb0(playbackRate) {
    return function(media) {
        return function() {
            media.playbackRate = playbackRate;
        };
    };
}
function $67f0fc7db8c638cb$export$999b7b72c79021f2(media) {
    return function() {
        return media.ended;
    };
}
function $67f0fc7db8c638cb$export$b243096046abd58(media) {
    return function() {
        return media.autoplay;
    };
}
function $67f0fc7db8c638cb$export$7a98ea7b6e6b2d36(autoplay) {
    return function(media) {
        return function() {
            media.autoplay = autoplay;
        };
    };
}
function $67f0fc7db8c638cb$export$f9ef67375ddc185(media) {
    return function() {
        return media.loop;
    };
}
function $67f0fc7db8c638cb$export$cf50c2db8dc11f8e(loop) {
    return function(media) {
        return function() {
            media.loop = loop;
        };
    };
}
function $67f0fc7db8c638cb$export$899fbdb5fa08b653(media) {
    return function() {
        media.play();
    };
}
function $67f0fc7db8c638cb$export$229c72e5fdee233b(media) {
    return function() {
        media.pause();
    };
}
function $67f0fc7db8c638cb$export$2855e964765eac9(media) {
    return function() {
        return media.mediaGroup;
    };
}
function $67f0fc7db8c638cb$export$2c8be4634a501ac1(mediaGroup) {
    return function(media) {
        return function() {
            media.mediaGroup = mediaGroup;
        };
    };
}
function $67f0fc7db8c638cb$export$cc1adf6fb659c762(media) {
    return function() {
        return media.controls;
    };
}
function $67f0fc7db8c638cb$export$891f55ce9f9e8605(controls) {
    return function(media) {
        return function() {
            media.controls = controls;
        };
    };
}
function $67f0fc7db8c638cb$export$7714b48ed08b13f2(media) {
    return function() {
        return media.volume;
    };
}
function $67f0fc7db8c638cb$export$246e658b67178cb0(volume) {
    return function(media) {
        return function() {
            media.volume = volume;
        };
    };
}
function $67f0fc7db8c638cb$export$987a4e3838aef8c6(media) {
    return function() {
        return media.muted;
    };
}
function $67f0fc7db8c638cb$export$a1680ba91cc9be33(muted) {
    return function(media) {
        return function() {
            media.muted = muted;
        };
    };
}
function $67f0fc7db8c638cb$export$4c9bd91015e50a76(media) {
    return function() {
        return media.defaultMuted;
    };
}
function $67f0fc7db8c638cb$export$a203b6be5128443d(defaultMuted) {
    return function(media) {
        return function() {
            media.defaultMuted = defaultMuted;
        };
    };
}

});

parcelRegister("SGhZI", function(module, exports) {

$parcel$export(module.exports, "Unspecified", () => $0a45d905703115c9$export$fadaed88e803a5ce);
$parcel$export(module.exports, "parse", () => $0a45d905703115c9$export$98e6a39c04603d36);
// Generated by purs version 0.15.16

var $ykHdR = parcelRequire("ykHdR");

var $6SDUu = parcelRequire("6SDUu");
var $0a45d905703115c9$export$fadaed88e803a5ce = /* #__PURE__ */ function() {
    function Unspecified() {}
    Unspecified.value = new Unspecified();
    return Unspecified;
}();
var $0a45d905703115c9$export$ad3bd6e4e1ec5d06 = /* #__PURE__ */ function() {
    function Maybe() {}
    Maybe.value = new Maybe();
    return Maybe;
}();
var $0a45d905703115c9$export$1fa2c133480c0d67 = /* #__PURE__ */ function() {
    function Probably() {}
    Probably.value = new Probably();
    return Probably;
}();
var $0a45d905703115c9$export$639d66421832ff11 = {
    show: function(v) {
        if (v instanceof $0a45d905703115c9$export$fadaed88e803a5ce) return "Unspecified";
        if (v instanceof $0a45d905703115c9$export$ad3bd6e4e1ec5d06) return "Maybe";
        if (v instanceof $0a45d905703115c9$export$1fa2c133480c0d67) return "Probably";
        throw new Error("Failed pattern match at Web.HTML.HTMLMediaElement.CanPlayType (line 16, column 10 - line 19, column 27): " + [
            v.constructor.name
        ]);
    }
};
var $0a45d905703115c9$export$c2d084dc44961371 = function(v) {
    if (v instanceof $0a45d905703115c9$export$fadaed88e803a5ce) return "";
    if (v instanceof $0a45d905703115c9$export$ad3bd6e4e1ec5d06) return "maybe";
    if (v instanceof $0a45d905703115c9$export$1fa2c133480c0d67) return "probably";
    throw new Error("Failed pattern match at Web.HTML.HTMLMediaElement.CanPlayType (line 29, column 9 - line 32, column 25): " + [
        v.constructor.name
    ]);
};
var $0a45d905703115c9$export$98e6a39c04603d36 = function(v) {
    if (v === "") return new $ykHdR.Just($0a45d905703115c9$export$fadaed88e803a5ce.value);
    if (v === "maybe") return new $ykHdR.Just($0a45d905703115c9$export$ad3bd6e4e1ec5d06.value);
    if (v === "probably") return new $ykHdR.Just($0a45d905703115c9$export$1fa2c133480c0d67.value);
    return $ykHdR.Nothing.value;
};
var $0a45d905703115c9$export$34fdecd70907479d = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $0a45d905703115c9$export$fadaed88e803a5ce && y instanceof $0a45d905703115c9$export$fadaed88e803a5ce) return true;
            if (x instanceof $0a45d905703115c9$export$ad3bd6e4e1ec5d06 && y instanceof $0a45d905703115c9$export$ad3bd6e4e1ec5d06) return true;
            if (x instanceof $0a45d905703115c9$export$1fa2c133480c0d67 && y instanceof $0a45d905703115c9$export$1fa2c133480c0d67) return true;
            return false;
        };
    }
};
var $0a45d905703115c9$export$dbc9bfdb74d43b21 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $0a45d905703115c9$export$fadaed88e803a5ce && y instanceof $0a45d905703115c9$export$fadaed88e803a5ce) return $6SDUu.EQ.value;
            if (x instanceof $0a45d905703115c9$export$fadaed88e803a5ce) return $6SDUu.LT.value;
            if (y instanceof $0a45d905703115c9$export$fadaed88e803a5ce) return $6SDUu.GT.value;
            if (x instanceof $0a45d905703115c9$export$ad3bd6e4e1ec5d06 && y instanceof $0a45d905703115c9$export$ad3bd6e4e1ec5d06) return $6SDUu.EQ.value;
            if (x instanceof $0a45d905703115c9$export$ad3bd6e4e1ec5d06) return $6SDUu.LT.value;
            if (y instanceof $0a45d905703115c9$export$ad3bd6e4e1ec5d06) return $6SDUu.GT.value;
            if (x instanceof $0a45d905703115c9$export$1fa2c133480c0d67 && y instanceof $0a45d905703115c9$export$1fa2c133480c0d67) return $6SDUu.EQ.value;
            throw new Error("Failed pattern match at Web.HTML.HTMLMediaElement.CanPlayType (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $0a45d905703115c9$export$34fdecd70907479d;
    }
};

});

parcelRegister("h90wX", function(module, exports) {

$parcel$export(module.exports, "Empty", () => $c7b3b04bec1e8e92$export$1f74963c34e8bfec);
$parcel$export(module.exports, "boundedEnumNetworkState", () => $c7b3b04bec1e8e92$export$19d342d9da2ba7a3);
// Generated by purs version 0.15.16

var $loxi1 = parcelRequire("loxi1");

var $ykHdR = parcelRequire("ykHdR");

var $6SDUu = parcelRequire("6SDUu");
var $c7b3b04bec1e8e92$export$1f74963c34e8bfec = /* #__PURE__ */ function() {
    function Empty() {}
    Empty.value = new Empty();
    return Empty;
}();
var $c7b3b04bec1e8e92$export$5407f8fd4e62a93 = /* #__PURE__ */ function() {
    function Idle() {}
    Idle.value = new Idle();
    return Idle;
}();
var $c7b3b04bec1e8e92$export$669f6ea7d267feaf = /* #__PURE__ */ function() {
    function Loading() {}
    Loading.value = new Loading();
    return Loading;
}();
var $c7b3b04bec1e8e92$export$9f99d34709abd9bc = /* #__PURE__ */ function() {
    function NoSource() {}
    NoSource.value = new NoSource();
    return NoSource;
}();
var $c7b3b04bec1e8e92$var$toEnumNetworkState = function(v) {
    if (v === 0) return new $ykHdR.Just($c7b3b04bec1e8e92$export$1f74963c34e8bfec.value);
    if (v === 1) return new $ykHdR.Just($c7b3b04bec1e8e92$export$5407f8fd4e62a93.value);
    if (v === 2) return new $ykHdR.Just($c7b3b04bec1e8e92$export$669f6ea7d267feaf.value);
    if (v === 3) return new $ykHdR.Just($c7b3b04bec1e8e92$export$9f99d34709abd9bc.value);
    return $ykHdR.Nothing.value;
};
var $c7b3b04bec1e8e92$export$6dde42aa2c503bde = {
    show: function(v) {
        if (v instanceof $c7b3b04bec1e8e92$export$1f74963c34e8bfec) return "Empty";
        if (v instanceof $c7b3b04bec1e8e92$export$5407f8fd4e62a93) return "Idle";
        if (v instanceof $c7b3b04bec1e8e92$export$669f6ea7d267feaf) return "Loading";
        if (v instanceof $c7b3b04bec1e8e92$export$9f99d34709abd9bc) return "NoSource";
        throw new Error("Failed pattern match at Web.HTML.HTMLMediaElement.NetworkState (line 30, column 1 - line 34, column 29): " + [
            v.constructor.name
        ]);
    }
};
var $c7b3b04bec1e8e92$var$fromEnumNetworkState = function(v) {
    if (v instanceof $c7b3b04bec1e8e92$export$1f74963c34e8bfec) return 0;
    if (v instanceof $c7b3b04bec1e8e92$export$5407f8fd4e62a93) return 1;
    if (v instanceof $c7b3b04bec1e8e92$export$669f6ea7d267feaf) return 2;
    if (v instanceof $c7b3b04bec1e8e92$export$9f99d34709abd9bc) return 3;
    throw new Error("Failed pattern match at Web.HTML.HTMLMediaElement.NetworkState (line 47, column 3 - line 51, column 18): " + [
        v.constructor.name
    ]);
};
var $c7b3b04bec1e8e92$export$a2cfa34e78ccc2f5 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $c7b3b04bec1e8e92$export$1f74963c34e8bfec && y instanceof $c7b3b04bec1e8e92$export$1f74963c34e8bfec) return true;
            if (x instanceof $c7b3b04bec1e8e92$export$5407f8fd4e62a93 && y instanceof $c7b3b04bec1e8e92$export$5407f8fd4e62a93) return true;
            if (x instanceof $c7b3b04bec1e8e92$export$669f6ea7d267feaf && y instanceof $c7b3b04bec1e8e92$export$669f6ea7d267feaf) return true;
            if (x instanceof $c7b3b04bec1e8e92$export$9f99d34709abd9bc && y instanceof $c7b3b04bec1e8e92$export$9f99d34709abd9bc) return true;
            return false;
        };
    }
};
var $c7b3b04bec1e8e92$export$dd5f9f1c18c12839 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $c7b3b04bec1e8e92$export$1f74963c34e8bfec && y instanceof $c7b3b04bec1e8e92$export$1f74963c34e8bfec) return $6SDUu.EQ.value;
            if (x instanceof $c7b3b04bec1e8e92$export$1f74963c34e8bfec) return $6SDUu.LT.value;
            if (y instanceof $c7b3b04bec1e8e92$export$1f74963c34e8bfec) return $6SDUu.GT.value;
            if (x instanceof $c7b3b04bec1e8e92$export$5407f8fd4e62a93 && y instanceof $c7b3b04bec1e8e92$export$5407f8fd4e62a93) return $6SDUu.EQ.value;
            if (x instanceof $c7b3b04bec1e8e92$export$5407f8fd4e62a93) return $6SDUu.LT.value;
            if (y instanceof $c7b3b04bec1e8e92$export$5407f8fd4e62a93) return $6SDUu.GT.value;
            if (x instanceof $c7b3b04bec1e8e92$export$669f6ea7d267feaf && y instanceof $c7b3b04bec1e8e92$export$669f6ea7d267feaf) return $6SDUu.EQ.value;
            if (x instanceof $c7b3b04bec1e8e92$export$669f6ea7d267feaf) return $6SDUu.LT.value;
            if (y instanceof $c7b3b04bec1e8e92$export$669f6ea7d267feaf) return $6SDUu.GT.value;
            if (x instanceof $c7b3b04bec1e8e92$export$9f99d34709abd9bc && y instanceof $c7b3b04bec1e8e92$export$9f99d34709abd9bc) return $6SDUu.EQ.value;
            throw new Error("Failed pattern match at Web.HTML.HTMLMediaElement.NetworkState (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $c7b3b04bec1e8e92$export$a2cfa34e78ccc2f5;
    }
};
var $c7b3b04bec1e8e92$export$e6f607f3cddfb3c1 = {
    succ: /* #__PURE__ */ $loxi1.defaultSucc($c7b3b04bec1e8e92$var$toEnumNetworkState)($c7b3b04bec1e8e92$var$fromEnumNetworkState),
    pred: /* #__PURE__ */ $loxi1.defaultPred($c7b3b04bec1e8e92$var$toEnumNetworkState)($c7b3b04bec1e8e92$var$fromEnumNetworkState),
    Ord0: function() {
        return $c7b3b04bec1e8e92$export$dd5f9f1c18c12839;
    }
};
var $c7b3b04bec1e8e92$export$63a4f766ab578d95 = /* #__PURE__ */ function() {
    return {
        bottom: $c7b3b04bec1e8e92$export$1f74963c34e8bfec.value,
        top: $c7b3b04bec1e8e92$export$9f99d34709abd9bc.value,
        Ord0: function() {
            return $c7b3b04bec1e8e92$export$dd5f9f1c18c12839;
        }
    };
}();
var $c7b3b04bec1e8e92$export$19d342d9da2ba7a3 = {
    cardinality: 4,
    toEnum: $c7b3b04bec1e8e92$var$toEnumNetworkState,
    fromEnum: $c7b3b04bec1e8e92$var$fromEnumNetworkState,
    Bounded0: function() {
        return $c7b3b04bec1e8e92$export$63a4f766ab578d95;
    },
    Enum1: function() {
        return $c7b3b04bec1e8e92$export$e6f607f3cddfb3c1;
    }
};

});

parcelRegister("jgHe4", function(module, exports) {

$parcel$export(module.exports, "HaveNothing", () => $e0710ab4ffdb9869$export$aeb73cf127af2fad);
$parcel$export(module.exports, "boundedEnumReadyState", () => $e0710ab4ffdb9869$export$94a641e970e969f9);
// Generated by purs version 0.15.16

var $loxi1 = parcelRequire("loxi1");

var $ykHdR = parcelRequire("ykHdR");

var $6SDUu = parcelRequire("6SDUu");
var $e0710ab4ffdb9869$export$aeb73cf127af2fad = /* #__PURE__ */ function() {
    function HaveNothing() {}
    HaveNothing.value = new HaveNothing();
    return HaveNothing;
}();
var $e0710ab4ffdb9869$export$e96d91cd125cf5ba = /* #__PURE__ */ function() {
    function HaveMetadata() {}
    HaveMetadata.value = new HaveMetadata();
    return HaveMetadata;
}();
var $e0710ab4ffdb9869$export$c416983dd5609b6e = /* #__PURE__ */ function() {
    function HaveCurrentData() {}
    HaveCurrentData.value = new HaveCurrentData();
    return HaveCurrentData;
}();
var $e0710ab4ffdb9869$export$3c862393aec03c72 = /* #__PURE__ */ function() {
    function HaveFutureData() {}
    HaveFutureData.value = new HaveFutureData();
    return HaveFutureData;
}();
var $e0710ab4ffdb9869$export$c0fee25792a80051 = /* #__PURE__ */ function() {
    function HaveEnoughData() {}
    HaveEnoughData.value = new HaveEnoughData();
    return HaveEnoughData;
}();
var $e0710ab4ffdb9869$var$toEnumReadyState = function(v) {
    if (v === 0) return new $ykHdR.Just($e0710ab4ffdb9869$export$aeb73cf127af2fad.value);
    if (v === 1) return new $ykHdR.Just($e0710ab4ffdb9869$export$e96d91cd125cf5ba.value);
    if (v === 2) return new $ykHdR.Just($e0710ab4ffdb9869$export$c416983dd5609b6e.value);
    if (v === 3) return new $ykHdR.Just($e0710ab4ffdb9869$export$3c862393aec03c72.value);
    if (v === 4) return new $ykHdR.Just($e0710ab4ffdb9869$export$c0fee25792a80051.value);
    return $ykHdR.Nothing.value;
};
var $e0710ab4ffdb9869$export$33dd24f3d942b82e = {
    show: function(v) {
        if (v instanceof $e0710ab4ffdb9869$export$aeb73cf127af2fad) return "HaveNothing";
        if (v instanceof $e0710ab4ffdb9869$export$e96d91cd125cf5ba) return "HaveMetadata";
        if (v instanceof $e0710ab4ffdb9869$export$c416983dd5609b6e) return "HaveCurrentData";
        if (v instanceof $e0710ab4ffdb9869$export$3c862393aec03c72) return "HaveFutureData";
        if (v instanceof $e0710ab4ffdb9869$export$c0fee25792a80051) return "HaveEnoughData";
        throw new Error("Failed pattern match at Web.HTML.HTMLMediaElement.ReadyState (line 31, column 1 - line 36, column 41): " + [
            v.constructor.name
        ]);
    }
};
var $e0710ab4ffdb9869$var$fromEnumReadyState = function(v) {
    if (v instanceof $e0710ab4ffdb9869$export$aeb73cf127af2fad) return 0;
    if (v instanceof $e0710ab4ffdb9869$export$e96d91cd125cf5ba) return 1;
    if (v instanceof $e0710ab4ffdb9869$export$c416983dd5609b6e) return 2;
    if (v instanceof $e0710ab4ffdb9869$export$3c862393aec03c72) return 3;
    if (v instanceof $e0710ab4ffdb9869$export$c0fee25792a80051) return 4;
    throw new Error("Failed pattern match at Web.HTML.HTMLMediaElement.ReadyState (line 50, column 3 - line 55, column 24): " + [
        v.constructor.name
    ]);
};
var $e0710ab4ffdb9869$export$c71e02dcc13f94a6 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $e0710ab4ffdb9869$export$aeb73cf127af2fad && y instanceof $e0710ab4ffdb9869$export$aeb73cf127af2fad) return true;
            if (x instanceof $e0710ab4ffdb9869$export$e96d91cd125cf5ba && y instanceof $e0710ab4ffdb9869$export$e96d91cd125cf5ba) return true;
            if (x instanceof $e0710ab4ffdb9869$export$c416983dd5609b6e && y instanceof $e0710ab4ffdb9869$export$c416983dd5609b6e) return true;
            if (x instanceof $e0710ab4ffdb9869$export$3c862393aec03c72 && y instanceof $e0710ab4ffdb9869$export$3c862393aec03c72) return true;
            if (x instanceof $e0710ab4ffdb9869$export$c0fee25792a80051 && y instanceof $e0710ab4ffdb9869$export$c0fee25792a80051) return true;
            return false;
        };
    }
};
var $e0710ab4ffdb9869$export$6557947d538c3b81 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $e0710ab4ffdb9869$export$aeb73cf127af2fad && y instanceof $e0710ab4ffdb9869$export$aeb73cf127af2fad) return $6SDUu.EQ.value;
            if (x instanceof $e0710ab4ffdb9869$export$aeb73cf127af2fad) return $6SDUu.LT.value;
            if (y instanceof $e0710ab4ffdb9869$export$aeb73cf127af2fad) return $6SDUu.GT.value;
            if (x instanceof $e0710ab4ffdb9869$export$e96d91cd125cf5ba && y instanceof $e0710ab4ffdb9869$export$e96d91cd125cf5ba) return $6SDUu.EQ.value;
            if (x instanceof $e0710ab4ffdb9869$export$e96d91cd125cf5ba) return $6SDUu.LT.value;
            if (y instanceof $e0710ab4ffdb9869$export$e96d91cd125cf5ba) return $6SDUu.GT.value;
            if (x instanceof $e0710ab4ffdb9869$export$c416983dd5609b6e && y instanceof $e0710ab4ffdb9869$export$c416983dd5609b6e) return $6SDUu.EQ.value;
            if (x instanceof $e0710ab4ffdb9869$export$c416983dd5609b6e) return $6SDUu.LT.value;
            if (y instanceof $e0710ab4ffdb9869$export$c416983dd5609b6e) return $6SDUu.GT.value;
            if (x instanceof $e0710ab4ffdb9869$export$3c862393aec03c72 && y instanceof $e0710ab4ffdb9869$export$3c862393aec03c72) return $6SDUu.EQ.value;
            if (x instanceof $e0710ab4ffdb9869$export$3c862393aec03c72) return $6SDUu.LT.value;
            if (y instanceof $e0710ab4ffdb9869$export$3c862393aec03c72) return $6SDUu.GT.value;
            if (x instanceof $e0710ab4ffdb9869$export$c0fee25792a80051 && y instanceof $e0710ab4ffdb9869$export$c0fee25792a80051) return $6SDUu.EQ.value;
            throw new Error("Failed pattern match at Web.HTML.HTMLMediaElement.ReadyState (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $e0710ab4ffdb9869$export$c71e02dcc13f94a6;
    }
};
var $e0710ab4ffdb9869$export$f705a14e9e99c6f0 = {
    succ: /* #__PURE__ */ $loxi1.defaultSucc($e0710ab4ffdb9869$var$toEnumReadyState)($e0710ab4ffdb9869$var$fromEnumReadyState),
    pred: /* #__PURE__ */ $loxi1.defaultPred($e0710ab4ffdb9869$var$toEnumReadyState)($e0710ab4ffdb9869$var$fromEnumReadyState),
    Ord0: function() {
        return $e0710ab4ffdb9869$export$6557947d538c3b81;
    }
};
var $e0710ab4ffdb9869$export$7b40514a91e8387e = /* #__PURE__ */ function() {
    return {
        bottom: $e0710ab4ffdb9869$export$aeb73cf127af2fad.value,
        top: $e0710ab4ffdb9869$export$c0fee25792a80051.value,
        Ord0: function() {
            return $e0710ab4ffdb9869$export$6557947d538c3b81;
        }
    };
}();
var $e0710ab4ffdb9869$export$94a641e970e969f9 = {
    cardinality: 5,
    toEnum: $e0710ab4ffdb9869$var$toEnumReadyState,
    fromEnum: $e0710ab4ffdb9869$var$fromEnumReadyState,
    Bounded0: function() {
        return $e0710ab4ffdb9869$export$7b40514a91e8387e;
    },
    Enum1: function() {
        return $e0710ab4ffdb9869$export$f705a14e9e99c6f0;
    }
};

});


parcelRegister("44vFb", function(module, exports) {
// Generated by purs version 0.15.16

var $iyxpb = parcelRequire("iyxpb");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $2f7018ceaced9755$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $2f7018ceaced9755$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $2f7018ceaced9755$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $2f7018ceaced9755$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $2f7018ceaced9755$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $2f7018ceaced9755$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $2f7018ceaced9755$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $2f7018ceaced9755$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLMetaElement");
var $2f7018ceaced9755$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLMetaElement");
var $2f7018ceaced9755$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLMetaElement");
var $2f7018ceaced9755$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLMetaElement");
var $2f7018ceaced9755$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLMetaElement");
var $2f7018ceaced9755$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLMetaElement");
var $2f7018ceaced9755$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLMetaElement");

});
parcelRegister("iyxpb", function(module, exports) {
function $d825508ebfe0ea30$export$a8ff84c12d48cfa6(meta) {
    return function() {
        return meta.name;
    };
}
function $d825508ebfe0ea30$export$6cf3d710d3a367e5(name) {
    return function(meta) {
        return function() {
            meta.name = name;
        };
    };
}
function $d825508ebfe0ea30$export$725a8790b31857c5(meta) {
    return function() {
        return meta.httpEquiv;
    };
}
function $d825508ebfe0ea30$export$253f18aa71ab8120(httpEquiv) {
    return function(meta) {
        return function() {
            meta.httpEquiv = httpEquiv;
        };
    };
}
function $d825508ebfe0ea30$export$a7db06668cad9adb(meta) {
    return function() {
        return meta.content;
    };
}
function $d825508ebfe0ea30$export$431313f2afd011e2(content) {
    return function(meta) {
        return function() {
            meta.content = content;
        };
    };
}

});


parcelRegister("bf5Ru", function(module, exports) {
// Generated by purs version 0.15.16

var $5wqix = parcelRequire("5wqix");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $82f5a476dc04f459$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $82f5a476dc04f459$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $82f5a476dc04f459$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $82f5a476dc04f459$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $82f5a476dc04f459$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $82f5a476dc04f459$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $82f5a476dc04f459$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $82f5a476dc04f459$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLMeterElement");
var $82f5a476dc04f459$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLMeterElement");
var $82f5a476dc04f459$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLMeterElement");
var $82f5a476dc04f459$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLMeterElement");
var $82f5a476dc04f459$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLMeterElement");
var $82f5a476dc04f459$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLMeterElement");
var $82f5a476dc04f459$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLMeterElement");

});
parcelRegister("5wqix", function(module, exports) {
function $4054571ff23c1117$export$2ab9a8f9f1186f14(meter) {
    return function() {
        return meter.value;
    };
}
function $4054571ff23c1117$export$80746c6bc6142fc8(value) {
    return function(meter) {
        return function() {
            meter.value = value;
        };
    };
}
function $4054571ff23c1117$export$96ec731ed4dcb222(meter) {
    return function() {
        return meter.min;
    };
}
function $4054571ff23c1117$export$46d199234e678744(min) {
    return function(meter) {
        return function() {
            meter.min = min;
        };
    };
}
function $4054571ff23c1117$export$8960430cfd85939f(meter) {
    return function() {
        return meter.max;
    };
}
function $4054571ff23c1117$export$b03015b7eb8a4a0d(max) {
    return function(meter) {
        return function() {
            meter.max = max;
        };
    };
}
function $4054571ff23c1117$export$e81601c80b4e876e(meter) {
    return function() {
        return meter.low;
    };
}
function $4054571ff23c1117$export$8b78ab0b9863288b(low) {
    return function(meter) {
        return function() {
            meter.low = low;
        };
    };
}
function $4054571ff23c1117$export$7cb505ef3217a5c4(meter) {
    return function() {
        return meter.high;
    };
}
function $4054571ff23c1117$export$f4a8cfe80ee4d275(high) {
    return function(meter) {
        return function() {
            meter.high = high;
        };
    };
}
function $4054571ff23c1117$export$49f2954c623150dd(meter) {
    return function() {
        return meter.optimum;
    };
}
function $4054571ff23c1117$export$47b0039e9987ccc5(optimum) {
    return function(meter) {
        return function() {
            meter.optimum = optimum;
        };
    };
}
function $4054571ff23c1117$export$a238cb463698c900(meter) {
    return function() {
        return meter.labels;
    };
}

});


parcelRegister("6jsIv", function(module, exports) {
// Generated by purs version 0.15.16

var $9jtyF = parcelRequire("9jtyF");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $498acb025c9c8d86$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $498acb025c9c8d86$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $498acb025c9c8d86$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $498acb025c9c8d86$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $498acb025c9c8d86$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $498acb025c9c8d86$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $498acb025c9c8d86$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $498acb025c9c8d86$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLModElement");
var $498acb025c9c8d86$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLModElement");
var $498acb025c9c8d86$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLModElement");
var $498acb025c9c8d86$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLModElement");
var $498acb025c9c8d86$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLModElement");
var $498acb025c9c8d86$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLModElement");
var $498acb025c9c8d86$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLModElement");

});
parcelRegister("9jtyF", function(module, exports) {
function $01bff2db061b962c$export$3035df57df42c31a(mod) {
    return function() {
        return mod.cite;
    };
}
function $01bff2db061b962c$export$86262a2b9f03fae3(cite) {
    return function(mod) {
        return function() {
            mod.cite = cite;
        };
    };
}
function $01bff2db061b962c$export$3a17bddce263fba0(mod) {
    return function() {
        return mod.dateTime;
    };
}
function $01bff2db061b962c$export$3a84b9eda98e95dc(dateTime) {
    return function(mod) {
        return function() {
            mod.dateTime = dateTime;
        };
    };
}

});


parcelRegister("dVSmW", function(module, exports) {
// Generated by purs version 0.15.16

var $iq8JD = parcelRequire("iq8JD");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $a24ac5c57b03a069$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $a24ac5c57b03a069$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $a24ac5c57b03a069$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $a24ac5c57b03a069$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $a24ac5c57b03a069$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $a24ac5c57b03a069$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $a24ac5c57b03a069$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $a24ac5c57b03a069$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLOListElement");
var $a24ac5c57b03a069$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLOListElement");
var $a24ac5c57b03a069$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLOListElement");
var $a24ac5c57b03a069$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLOListElement");
var $a24ac5c57b03a069$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLOListElement");
var $a24ac5c57b03a069$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLOListElement");
var $a24ac5c57b03a069$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLOListElement");

});
parcelRegister("iq8JD", function(module, exports) {
function $d6916e47721f2e71$export$e2239770db970295(ol) {
    return function() {
        return ol.reversed;
    };
}
function $d6916e47721f2e71$export$9c908e987b6cb694(reversed) {
    return function(ol) {
        return function() {
            ol.reversed = reversed;
        };
    };
}
function $d6916e47721f2e71$export$b3571188c770cc5a(ol) {
    return function() {
        return ol.start;
    };
}
function $d6916e47721f2e71$export$b61b8b027b966010(start) {
    return function(ol) {
        return function() {
            ol.start = start;
        };
    };
}
function $d6916e47721f2e71$export$d4a6a4db5b31e621(ol) {
    return function() {
        return ol.type;
    };
}
function $d6916e47721f2e71$export$1bf7f05044e9c5cb(type) {
    return function(ol) {
        return function() {
            ol.type = type;
        };
    };
}

});


parcelRegister("hjIra", function(module, exports) {
// Generated by purs version 0.15.16

var $cpLnq = parcelRequire("cpLnq");

var $l0wDR = parcelRequire("l0wDR");

var $T79xE = parcelRequire("T79xE");

var $9hRVP = parcelRequire("9hRVP");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $c9b6ae535f32e637$var$map = /* #__PURE__ */ $l0wDR.map($9hRVP.functorEffect);
var $c9b6ae535f32e637$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $c9b6ae535f32e637$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $c9b6ae535f32e637$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $c9b6ae535f32e637$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $c9b6ae535f32e637$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $c9b6ae535f32e637$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $c9b6ae535f32e637$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $c9b6ae535f32e637$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLObjectElement");
var $c9b6ae535f32e637$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLObjectElement");
var $c9b6ae535f32e637$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLObjectElement");
var $c9b6ae535f32e637$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLObjectElement");
var $c9b6ae535f32e637$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLObjectElement");
var $c9b6ae535f32e637$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLObjectElement");
var $c9b6ae535f32e637$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLObjectElement");
var $c9b6ae535f32e637$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $c9b6ae535f32e637$var$map($T79xE.toMaybe);
    return function($3) {
        return $2($cpLnq._form($3));
    };
}();
var $c9b6ae535f32e637$export$a186087d330c547b = /* #__PURE__ */ function() {
    var $4 = $c9b6ae535f32e637$var$map($T79xE.toMaybe);
    return function($5) {
        return $4($cpLnq._contentDocument($5));
    };
}();

});
parcelRegister("cpLnq", function(module, exports) {

$parcel$export(module.exports, "_form", () => $909c91e6774cc50c$export$242c63e9758836c2);
$parcel$export(module.exports, "_contentDocument", () => $909c91e6774cc50c$export$a51825c89fe24f94);
function $909c91e6774cc50c$export$70ac1efc5b13b551(object) {
    return function() {
        return object.data;
    };
}
function $909c91e6774cc50c$export$3a6802af14bf5fa6(data) {
    return function(object) {
        return function() {
            object.data = data;
        };
    };
}
function $909c91e6774cc50c$export$d4a6a4db5b31e621(object) {
    return function() {
        return object.type;
    };
}
function $909c91e6774cc50c$export$1bf7f05044e9c5cb(type) {
    return function(object) {
        return function() {
            object.type = type;
        };
    };
}
function $909c91e6774cc50c$export$dc0b74bdecf765a4(object) {
    return function() {
        return object.typeMustMatch;
    };
}
function $909c91e6774cc50c$export$a8ff84c12d48cfa6(object) {
    return function() {
        return object.name;
    };
}
function $909c91e6774cc50c$export$6cf3d710d3a367e5(name) {
    return function(object) {
        return function() {
            object.name = name;
        };
    };
}
function $909c91e6774cc50c$export$86f8f9f08863e403(object) {
    return function() {
        return object.useMap;
    };
}
function $909c91e6774cc50c$export$ab416bdbb887640e(useMap) {
    return function(object) {
        return function() {
            object.useMap = useMap;
        };
    };
}
function $909c91e6774cc50c$export$242c63e9758836c2(object) {
    return function() {
        return object.form;
    };
}
function $909c91e6774cc50c$export$7e3df82ee760448c(object) {
    return function() {
        return object.width;
    };
}
function $909c91e6774cc50c$export$67f48e0594af05d(width) {
    return function(object) {
        return function() {
            object.width = width;
        };
    };
}
function $909c91e6774cc50c$export$ac607276a8fe9f0a(object) {
    return function() {
        return object.height;
    };
}
function $909c91e6774cc50c$export$3f31360357be44e4(height) {
    return function(object) {
        return function() {
            object.height = height;
        };
    };
}
function $909c91e6774cc50c$export$a51825c89fe24f94(object) {
    return function() {
        return object.contentDocument;
    };
}
function $909c91e6774cc50c$export$5e55a9e709e8e020(object) {
    return function() {
        return object.willValidate;
    };
}
function $909c91e6774cc50c$export$1bdd3f9a89b22594(object) {
    return function() {
        return object.validity;
    };
}
function $909c91e6774cc50c$export$6ee4201e37a931e2(object) {
    return function() {
        return object.validationMessage;
    };
}
function $909c91e6774cc50c$export$50d70f8cedc54453(object) {
    return function() {
        return object.checkValidity();
    };
}
function $909c91e6774cc50c$export$b962d864c477cc49(object) {
    return function() {
        return object.reportValidity();
    };
}
function $909c91e6774cc50c$export$6f569cb704992105(value) {
    return function(object) {
        return function() {
            object.setCustomValidity(value);
        };
    };
}

});


parcelRegister("hdMAX", function(module, exports) {
// Generated by purs version 0.15.16

var $fK178 = parcelRequire("fK178");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $c89958870ff6a525$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $c89958870ff6a525$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $c89958870ff6a525$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $c89958870ff6a525$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $c89958870ff6a525$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $c89958870ff6a525$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $c89958870ff6a525$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $c89958870ff6a525$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLOptGroupElement");
var $c89958870ff6a525$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLOptGroupElement");
var $c89958870ff6a525$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLOptGroupElement");
var $c89958870ff6a525$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLOptGroupElement");
var $c89958870ff6a525$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLOptGroupElement");
var $c89958870ff6a525$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLOptGroupElement");
var $c89958870ff6a525$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLOptGroupElement");

});
parcelRegister("fK178", function(module, exports) {
function $b75c0419f3dc5c84$export$683472f6198a076e(optgroup) {
    return function() {
        return optgroup.disabled;
    };
}
function $b75c0419f3dc5c84$export$4532d31cef66d703(disabled) {
    return function(optgroup) {
        return function() {
            optgroup.disabled = disabled;
        };
    };
}
function $b75c0419f3dc5c84$export$1237798dc640739a(optgroup) {
    return function() {
        return optgroup.label;
    };
}
function $b75c0419f3dc5c84$export$4f65e594f6031297(label) {
    return function(optgroup) {
        return function() {
            optgroup.label = label;
        };
    };
}

});


parcelRegister("28IXz", function(module, exports) {
// Generated by purs version 0.15.16

var $jHDTW = parcelRequire("jHDTW");

var $l0wDR = parcelRequire("l0wDR");

var $T79xE = parcelRequire("T79xE");

var $9hRVP = parcelRequire("9hRVP");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $18ef343036740bd3$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $18ef343036740bd3$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $18ef343036740bd3$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $18ef343036740bd3$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $18ef343036740bd3$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $18ef343036740bd3$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $18ef343036740bd3$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $18ef343036740bd3$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLOptionElement");
var $18ef343036740bd3$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLOptionElement");
var $18ef343036740bd3$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLOptionElement");
var $18ef343036740bd3$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLOptionElement");
var $18ef343036740bd3$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLOptionElement");
var $18ef343036740bd3$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLOptionElement");
var $18ef343036740bd3$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLOptionElement");
var $18ef343036740bd3$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $l0wDR.map($9hRVP.functorEffect)($T79xE.toMaybe);
    return function($3) {
        return $2($jHDTW._form($3));
    };
}();

});
parcelRegister("jHDTW", function(module, exports) {

$parcel$export(module.exports, "_form", () => $e580fc0cf2be85d0$export$242c63e9758836c2);
function $e580fc0cf2be85d0$export$683472f6198a076e(option) {
    return function() {
        return option.disabled;
    };
}
function $e580fc0cf2be85d0$export$4532d31cef66d703(disabled) {
    return function(option) {
        return function() {
            option.disabled = disabled;
        };
    };
}
function $e580fc0cf2be85d0$export$242c63e9758836c2(option) {
    return function() {
        return option.form;
    };
}
function $e580fc0cf2be85d0$export$1237798dc640739a(option) {
    return function() {
        return option.label;
    };
}
function $e580fc0cf2be85d0$export$4f65e594f6031297(label) {
    return function(option) {
        return function() {
            option.label = label;
        };
    };
}
function $e580fc0cf2be85d0$export$63db087985f790e3(option) {
    return function() {
        return option.defaultSelected;
    };
}
function $e580fc0cf2be85d0$export$83d19b461d3b2ee7(defaultSelected) {
    return function(option) {
        return function() {
            option.defaultSelected = defaultSelected;
        };
    };
}
function $e580fc0cf2be85d0$export$d90250155de6d7e7(option) {
    return function() {
        return option.selected;
    };
}
function $e580fc0cf2be85d0$export$5a4818cec1656a71(selected) {
    return function(option) {
        return function() {
            option.selected = selected;
        };
    };
}
function $e580fc0cf2be85d0$export$2ab9a8f9f1186f14(option) {
    return function() {
        return option.value;
    };
}
function $e580fc0cf2be85d0$export$80746c6bc6142fc8(value) {
    return function(option) {
        return function() {
            option.value = value;
        };
    };
}
function $e580fc0cf2be85d0$export$6f093cfa640b7166(option) {
    return function() {
        return option.text;
    };
}
function $e580fc0cf2be85d0$export$cbe0d99836e1498f(text) {
    return function(option) {
        return function() {
            option.text = text;
        };
    };
}
function $e580fc0cf2be85d0$export$b610b8812bbcded9(option) {
    return function() {
        return option.index;
    };
}

});


parcelRegister("ah5tt", function(module, exports) {
// Generated by purs version 0.15.16

var $do011 = parcelRequire("do011");

var $l0wDR = parcelRequire("l0wDR");

var $T79xE = parcelRequire("T79xE");

var $9hRVP = parcelRequire("9hRVP");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $77afbd0210834ce4$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $77afbd0210834ce4$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $77afbd0210834ce4$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $77afbd0210834ce4$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $77afbd0210834ce4$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $77afbd0210834ce4$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $77afbd0210834ce4$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $77afbd0210834ce4$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLOutputElement");
var $77afbd0210834ce4$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLOutputElement");
var $77afbd0210834ce4$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLOutputElement");
var $77afbd0210834ce4$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLOutputElement");
var $77afbd0210834ce4$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLOutputElement");
var $77afbd0210834ce4$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLOutputElement");
var $77afbd0210834ce4$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLOutputElement");
var $77afbd0210834ce4$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $l0wDR.map($9hRVP.functorEffect)($T79xE.toMaybe);
    return function($3) {
        return $2($do011._form($3));
    };
}();

});
parcelRegister("do011", function(module, exports) {

$parcel$export(module.exports, "_form", () => $9bed875784302b3c$export$242c63e9758836c2);
function $9bed875784302b3c$export$242c63e9758836c2(output) {
    return function() {
        return output.form;
    };
}
function $9bed875784302b3c$export$a8ff84c12d48cfa6(output) {
    return function() {
        return output.name;
    };
}
function $9bed875784302b3c$export$6cf3d710d3a367e5(name) {
    return function(output) {
        return function() {
            output.name = name;
        };
    };
}
function $9bed875784302b3c$export$d4a6a4db5b31e621(output) {
    return function() {
        return output.type;
    };
}
function $9bed875784302b3c$export$1a01ae0705bafd37(output) {
    return function() {
        return output.defaultValue;
    };
}
function $9bed875784302b3c$export$d8becbd7468e206f(defaultValue) {
    return function(output) {
        return function() {
            output.defaultValue = defaultValue;
        };
    };
}
function $9bed875784302b3c$export$2ab9a8f9f1186f14(output) {
    return function() {
        return output.value;
    };
}
function $9bed875784302b3c$export$80746c6bc6142fc8(value) {
    return function(output) {
        return function() {
            output.value = value;
        };
    };
}
function $9bed875784302b3c$export$5e55a9e709e8e020(output) {
    return function() {
        return output.willValidate;
    };
}
function $9bed875784302b3c$export$1bdd3f9a89b22594(output) {
    return function() {
        return output.validity;
    };
}
function $9bed875784302b3c$export$6ee4201e37a931e2(output) {
    return function() {
        return output.validationMessage;
    };
}
function $9bed875784302b3c$export$50d70f8cedc54453(output) {
    return function() {
        return output.checkValidity();
    };
}
function $9bed875784302b3c$export$b962d864c477cc49(output) {
    return function() {
        return output.reportValidity();
    };
}
function $9bed875784302b3c$export$6f569cb704992105(value) {
    return function(output) {
        return function() {
            output.setCustomValidity(value);
        };
    };
}
function $9bed875784302b3c$export$a238cb463698c900(output) {
    return function() {
        return output.labels;
    };
}

});


parcelRegister("hqnl7", function(module, exports) {
// Generated by purs version 0.15.16
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $caf6f82488ae8096$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $caf6f82488ae8096$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $caf6f82488ae8096$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $caf6f82488ae8096$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $caf6f82488ae8096$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $caf6f82488ae8096$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $caf6f82488ae8096$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $caf6f82488ae8096$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLParagraphElement");
var $caf6f82488ae8096$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLParagraphElement");
var $caf6f82488ae8096$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLParagraphElement");
var $caf6f82488ae8096$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLParagraphElement");
var $caf6f82488ae8096$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLParagraphElement");
var $caf6f82488ae8096$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLParagraphElement");
var $caf6f82488ae8096$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLParagraphElement");

});

parcelRegister("lqi2X", function(module, exports) {
// Generated by purs version 0.15.16

var $2qVZI = parcelRequire("2qVZI");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $f98a066659a15f53$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $f98a066659a15f53$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $f98a066659a15f53$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $f98a066659a15f53$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $f98a066659a15f53$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $f98a066659a15f53$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $f98a066659a15f53$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $f98a066659a15f53$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLParamElement");
var $f98a066659a15f53$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLParamElement");
var $f98a066659a15f53$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLParamElement");
var $f98a066659a15f53$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLParamElement");
var $f98a066659a15f53$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLParamElement");
var $f98a066659a15f53$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLParamElement");
var $f98a066659a15f53$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLParamElement");

});
parcelRegister("2qVZI", function(module, exports) {
function $1c5afef61dd21eb4$export$a8ff84c12d48cfa6(param) {
    return function() {
        return param.name;
    };
}
function $1c5afef61dd21eb4$export$6cf3d710d3a367e5(name) {
    return function(param) {
        return function() {
            param.name = name;
        };
    };
}
function $1c5afef61dd21eb4$export$2ab9a8f9f1186f14(param) {
    return function() {
        return param.value;
    };
}
function $1c5afef61dd21eb4$export$80746c6bc6142fc8(value) {
    return function(param) {
        return function() {
            param.value = value;
        };
    };
}

});


parcelRegister("bodBV", function(module, exports) {
// Generated by purs version 0.15.16
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $84ac7e6146bd7613$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $84ac7e6146bd7613$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $84ac7e6146bd7613$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $84ac7e6146bd7613$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $84ac7e6146bd7613$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $84ac7e6146bd7613$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $84ac7e6146bd7613$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $84ac7e6146bd7613$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLPreElement");
var $84ac7e6146bd7613$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLPreElement");
var $84ac7e6146bd7613$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLPreElement");
var $84ac7e6146bd7613$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLPreElement");
var $84ac7e6146bd7613$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLPreElement");
var $84ac7e6146bd7613$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLPreElement");
var $84ac7e6146bd7613$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLPreElement");

});

parcelRegister("iMlWw", function(module, exports) {
// Generated by purs version 0.15.16

var $h1Qhn = parcelRequire("h1Qhn");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $dabdbb18392010de$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $dabdbb18392010de$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $dabdbb18392010de$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $dabdbb18392010de$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $dabdbb18392010de$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $dabdbb18392010de$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $dabdbb18392010de$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $dabdbb18392010de$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLProgressElement");
var $dabdbb18392010de$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLProgressElement");
var $dabdbb18392010de$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLProgressElement");
var $dabdbb18392010de$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLProgressElement");
var $dabdbb18392010de$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLProgressElement");
var $dabdbb18392010de$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLProgressElement");
var $dabdbb18392010de$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLProgressElement");

});
parcelRegister("h1Qhn", function(module, exports) {
function $c65b15421363cde9$export$2ab9a8f9f1186f14(progress) {
    return function() {
        return progress.value;
    };
}
function $c65b15421363cde9$export$80746c6bc6142fc8(value) {
    return function(progress) {
        return function() {
            progress.value = value;
        };
    };
}
function $c65b15421363cde9$export$8960430cfd85939f(progress) {
    return function() {
        return progress.max;
    };
}
function $c65b15421363cde9$export$b03015b7eb8a4a0d(max) {
    return function(progress) {
        return function() {
            progress.max = max;
        };
    };
}
function $c65b15421363cde9$export$5880b8b5730aff45(progress) {
    return function() {
        return progress.position;
    };
}
function $c65b15421363cde9$export$a238cb463698c900(progress) {
    return function() {
        return progress.labels;
    };
}

});


parcelRegister("7ZhYu", function(module, exports) {
// Generated by purs version 0.15.16

var $2BXjc = parcelRequire("2BXjc");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $5d0c2c5071b861d1$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $5d0c2c5071b861d1$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $5d0c2c5071b861d1$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $5d0c2c5071b861d1$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $5d0c2c5071b861d1$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $5d0c2c5071b861d1$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $5d0c2c5071b861d1$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $5d0c2c5071b861d1$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLQuoteElement");
var $5d0c2c5071b861d1$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLQuoteElement");
var $5d0c2c5071b861d1$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLQuoteElement");
var $5d0c2c5071b861d1$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLQuoteElement");
var $5d0c2c5071b861d1$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLQuoteElement");
var $5d0c2c5071b861d1$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLQuoteElement");
var $5d0c2c5071b861d1$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLQuoteElement");

});
parcelRegister("2BXjc", function(module, exports) {
function $1e6d0af303f227ec$export$3035df57df42c31a(quote) {
    return function() {
        return quote.cite;
    };
}
function $1e6d0af303f227ec$export$86262a2b9f03fae3(cite) {
    return function(quote) {
        return function() {
            quote.cite = cite;
        };
    };
}

});


parcelRegister("1tT4V", function(module, exports) {
// Generated by purs version 0.15.16

var $6wl49 = parcelRequire("6wl49");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $1143394fd0c1cb41$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $1143394fd0c1cb41$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $1143394fd0c1cb41$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $1143394fd0c1cb41$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $1143394fd0c1cb41$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $1143394fd0c1cb41$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $1143394fd0c1cb41$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $1143394fd0c1cb41$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLScriptElement");
var $1143394fd0c1cb41$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLScriptElement");
var $1143394fd0c1cb41$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLScriptElement");
var $1143394fd0c1cb41$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLScriptElement");
var $1143394fd0c1cb41$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLScriptElement");
var $1143394fd0c1cb41$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLScriptElement");
var $1143394fd0c1cb41$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLScriptElement");

});
parcelRegister("6wl49", function(module, exports) {
function $4bf6127f0f22b047$export$2e40c9e35e9506f4(script) {
    return function() {
        return script.src;
    };
}
function $4bf6127f0f22b047$export$5771e3a4c80da7df(src) {
    return function(script) {
        return function() {
            script.src = src;
        };
    };
}
function $4bf6127f0f22b047$export$d4a6a4db5b31e621(script) {
    return function() {
        return script.type;
    };
}
function $4bf6127f0f22b047$export$1bf7f05044e9c5cb(type) {
    return function(script) {
        return function() {
            script.type = type;
        };
    };
}
function $4bf6127f0f22b047$export$e4c823724462c3fd(script) {
    return function() {
        return script.charset;
    };
}
function $4bf6127f0f22b047$export$61ed102e375c8bae(charset) {
    return function(script) {
        return function() {
            script.charset = charset;
        };
    };
}
function $4bf6127f0f22b047$export$12af436354f1a4f7(script) {
    return function() {
        return script.async;
    };
}
function $4bf6127f0f22b047$export$8ed1e1e4b75b53c6(async) {
    return function(script) {
        return function() {
            script.async = async;
        };
    };
}
function $4bf6127f0f22b047$export$260e5c0943f31606(script) {
    return function() {
        return script.defer;
    };
}
function $4bf6127f0f22b047$export$d440c7f1383ddd12(defer) {
    return function(script) {
        return function() {
            script.defer = defer;
        };
    };
}
function $4bf6127f0f22b047$export$c47cb7c63271266e(script) {
    return function() {
        return script.crossOrigin;
    };
}
function $4bf6127f0f22b047$export$e7fd69f64f92856(crossOrigin) {
    return function(script) {
        return function() {
            script.crossOrigin = crossOrigin;
        };
    };
}
function $4bf6127f0f22b047$export$6f093cfa640b7166(script) {
    return function() {
        return script.text;
    };
}
function $4bf6127f0f22b047$export$cbe0d99836e1498f(text) {
    return function(script) {
        return function() {
            script.text = text;
        };
    };
}

});


parcelRegister("ebFeN", function(module, exports) {
// Generated by purs version 0.15.16

var $6NYeU = parcelRequire("6NYeU");

var $l0wDR = parcelRequire("l0wDR");

var $T79xE = parcelRequire("T79xE");

var $9hRVP = parcelRequire("9hRVP");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $a54214b82be35498$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $a54214b82be35498$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $a54214b82be35498$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $a54214b82be35498$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $a54214b82be35498$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $a54214b82be35498$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $a54214b82be35498$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $a54214b82be35498$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLSelectElement");
var $a54214b82be35498$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLSelectElement");
var $a54214b82be35498$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLSelectElement");
var $a54214b82be35498$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLSelectElement");
var $a54214b82be35498$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLSelectElement");
var $a54214b82be35498$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLSelectElement");
var $a54214b82be35498$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLSelectElement");
var $a54214b82be35498$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $l0wDR.map($9hRVP.functorEffect)($T79xE.toMaybe);
    return function($3) {
        return $2($6NYeU._form($3));
    };
}();

});
parcelRegister("6NYeU", function(module, exports) {

$parcel$export(module.exports, "_form", () => $4f460bff72193069$export$242c63e9758836c2);
function $4f460bff72193069$export$4c47992fc278c9a0(select) {
    return function() {
        return select.autofocus;
    };
}
function $4f460bff72193069$export$db2bbdcbda3d335e(autofocus) {
    return function(select) {
        return function() {
            select.autofocus = autofocus;
        };
    };
}
function $4f460bff72193069$export$683472f6198a076e(select) {
    return function() {
        return select.disabled;
    };
}
function $4f460bff72193069$export$4532d31cef66d703(disabled) {
    return function(select) {
        return function() {
            select.disabled = disabled;
        };
    };
}
function $4f460bff72193069$export$939ddaa3205df08e(select) {
    return function() {
        return select.multiple;
    };
}
function $4f460bff72193069$export$be7c7381b31f2269(multiple) {
    return function(select) {
        return function() {
            select.multiple = multiple;
        };
    };
}
function $4f460bff72193069$export$242c63e9758836c2(select) {
    return function() {
        return select.form;
    };
}
function $4f460bff72193069$export$a8ff84c12d48cfa6(select) {
    return function() {
        return select.name;
    };
}
function $4f460bff72193069$export$6cf3d710d3a367e5(name) {
    return function(select) {
        return function() {
            select.name = name;
        };
    };
}
function $4f460bff72193069$export$a7a0278c004aac3f(select) {
    return function() {
        return select.required;
    };
}
function $4f460bff72193069$export$47f9362469f346c4(required) {
    return function(select) {
        return function() {
            select.required = required;
        };
    };
}
function $4f460bff72193069$export$346677f925de839c(select) {
    return function() {
        return select.size;
    };
}
function $4f460bff72193069$export$1c70a6cc12bc0366(size) {
    return function(select) {
        return function() {
            select.size = size;
        };
    };
}
function $4f460bff72193069$export$d4a6a4db5b31e621(select) {
    return function() {
        return select.type;
    };
}
function $4f460bff72193069$export$f24224f1c91d8156(select) {
    return function() {
        return select.length;
    };
}
function $4f460bff72193069$export$e37a2cb6f0a9cac9(length) {
    return function(select) {
        return function() {
            select.length = length;
        };
    };
}
function $4f460bff72193069$export$b0ea99e7ae5aed6c(select) {
    return function() {
        return select.selectedOptions;
    };
}
function $4f460bff72193069$export$9ea87e299ff6a368(select) {
    return function() {
        return select.selectedIndex;
    };
}
function $4f460bff72193069$export$940820044e1b4923(selectedIndex) {
    return function(select) {
        return function() {
            select.selectedIndex = selectedIndex;
        };
    };
}
function $4f460bff72193069$export$2ab9a8f9f1186f14(select) {
    return function() {
        return select.value;
    };
}
function $4f460bff72193069$export$80746c6bc6142fc8(value) {
    return function(select) {
        return function() {
            select.value = value;
        };
    };
}
function $4f460bff72193069$export$5e55a9e709e8e020(select) {
    return function() {
        return select.willValidate;
    };
}
function $4f460bff72193069$export$1bdd3f9a89b22594(select) {
    return function() {
        return select.validity;
    };
}
function $4f460bff72193069$export$6ee4201e37a931e2(select) {
    return function() {
        return select.validationMessage;
    };
}
function $4f460bff72193069$export$50d70f8cedc54453(select) {
    return function() {
        return select.checkValidity();
    };
}
function $4f460bff72193069$export$b962d864c477cc49(select) {
    return function() {
        return select.reportValidity();
    };
}
function $4f460bff72193069$export$6f569cb704992105(value) {
    return function(select) {
        return function() {
            select.setCustomValidity(value);
        };
    };
}
function $4f460bff72193069$export$a238cb463698c900(select) {
    return function() {
        return select.labels;
    };
}

});


parcelRegister("jWyDm", function(module, exports) {
// Generated by purs version 0.15.16

var $4cMiy = parcelRequire("4cMiy");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $e84e4cab6b69fa3a$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $e84e4cab6b69fa3a$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $e84e4cab6b69fa3a$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $e84e4cab6b69fa3a$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $e84e4cab6b69fa3a$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $e84e4cab6b69fa3a$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $e84e4cab6b69fa3a$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $e84e4cab6b69fa3a$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLSourceElement");
var $e84e4cab6b69fa3a$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLSourceElement");
var $e84e4cab6b69fa3a$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLSourceElement");
var $e84e4cab6b69fa3a$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLSourceElement");
var $e84e4cab6b69fa3a$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLSourceElement");
var $e84e4cab6b69fa3a$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLSourceElement");
var $e84e4cab6b69fa3a$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLSourceElement");

});
parcelRegister("4cMiy", function(module, exports) {
function $30fdbf6c46de325a$export$2e40c9e35e9506f4(source) {
    return function() {
        return source.src;
    };
}
function $30fdbf6c46de325a$export$5771e3a4c80da7df(src) {
    return function(source) {
        return function() {
            source.src = src;
        };
    };
}
function $30fdbf6c46de325a$export$d4a6a4db5b31e621(source) {
    return function() {
        return source.type;
    };
}
function $30fdbf6c46de325a$export$1bf7f05044e9c5cb(type) {
    return function(source) {
        return function() {
            source.type = type;
        };
    };
}
function $30fdbf6c46de325a$export$987d49ffe1b0900f(source) {
    return function() {
        return source.media;
    };
}
function $30fdbf6c46de325a$export$5c1855deea651e41(media) {
    return function(source) {
        return function() {
            source.media = media;
        };
    };
}

});


parcelRegister("1zExv", function(module, exports) {
// Generated by purs version 0.15.16
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $1258819ad56163ca$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $1258819ad56163ca$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $1258819ad56163ca$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $1258819ad56163ca$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $1258819ad56163ca$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $1258819ad56163ca$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $1258819ad56163ca$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $1258819ad56163ca$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLSpanElement");
var $1258819ad56163ca$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLSpanElement");
var $1258819ad56163ca$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLSpanElement");
var $1258819ad56163ca$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLSpanElement");
var $1258819ad56163ca$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLSpanElement");
var $1258819ad56163ca$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLSpanElement");
var $1258819ad56163ca$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLSpanElement");

});

parcelRegister("gI6GO", function(module, exports) {
// Generated by purs version 0.15.16

var $4URoD = parcelRequire("4URoD");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $c2a5f1d09180ba9d$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $c2a5f1d09180ba9d$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $c2a5f1d09180ba9d$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $c2a5f1d09180ba9d$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $c2a5f1d09180ba9d$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $c2a5f1d09180ba9d$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $c2a5f1d09180ba9d$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $c2a5f1d09180ba9d$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLStyleElement");
var $c2a5f1d09180ba9d$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLStyleElement");
var $c2a5f1d09180ba9d$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLStyleElement");
var $c2a5f1d09180ba9d$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLStyleElement");
var $c2a5f1d09180ba9d$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLStyleElement");
var $c2a5f1d09180ba9d$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLStyleElement");
var $c2a5f1d09180ba9d$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLStyleElement");

});
parcelRegister("4URoD", function(module, exports) {
function $3945cfcc1dd51d92$export$987d49ffe1b0900f(style) {
    return function() {
        return style.media;
    };
}
function $3945cfcc1dd51d92$export$5c1855deea651e41(media) {
    return function(style) {
        return function() {
            style.media = media;
        };
    };
}
function $3945cfcc1dd51d92$export$d4a6a4db5b31e621(style) {
    return function() {
        return style.type;
    };
}
function $3945cfcc1dd51d92$export$1bf7f05044e9c5cb(type) {
    return function(style) {
        return function() {
            style.type = type;
        };
    };
}

});


parcelRegister("6EsyS", function(module, exports) {
// Generated by purs version 0.15.16
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $4d7ca2355751c293$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $4d7ca2355751c293$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $4d7ca2355751c293$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $4d7ca2355751c293$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $4d7ca2355751c293$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $4d7ca2355751c293$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $4d7ca2355751c293$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $4d7ca2355751c293$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableCaptionElement");
var $4d7ca2355751c293$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableCaptionElement");
var $4d7ca2355751c293$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableCaptionElement");
var $4d7ca2355751c293$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableCaptionElement");
var $4d7ca2355751c293$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableCaptionElement");
var $4d7ca2355751c293$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableCaptionElement");
var $4d7ca2355751c293$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableCaptionElement");

});

parcelRegister("hmAwo", function(module, exports) {
// Generated by purs version 0.15.16

var $iZPqE = parcelRequire("iZPqE");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $ca40d224410598c5$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $ca40d224410598c5$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $ca40d224410598c5$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $ca40d224410598c5$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $ca40d224410598c5$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $ca40d224410598c5$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $ca40d224410598c5$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $ca40d224410598c5$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableCellElement");
var $ca40d224410598c5$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableCellElement");
var $ca40d224410598c5$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableCellElement");
var $ca40d224410598c5$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableCellElement");
var $ca40d224410598c5$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableCellElement");
var $ca40d224410598c5$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableCellElement");
var $ca40d224410598c5$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableCellElement");

});
parcelRegister("iZPqE", function(module, exports) {
function $dd45d132df79042b$export$47be69ffacd0da98(cell) {
    return function() {
        return cell.colSpan;
    };
}
function $dd45d132df79042b$export$41feea65f12f6ad6(colSpan) {
    return function(cell) {
        return function() {
            cell.colSpan = colSpan;
        };
    };
}
function $dd45d132df79042b$export$a5ce0649174d616e(cell) {
    return function() {
        return cell.rowSpan;
    };
}
function $dd45d132df79042b$export$1f37716400d14942(rowSpan) {
    return function(cell) {
        return function() {
            cell.rowSpan = rowSpan;
        };
    };
}
function $dd45d132df79042b$export$b507ffb2fd978043(cell) {
    return function() {
        return cell.cellIndex;
    };
}

});


parcelRegister("3z8Mp", function(module, exports) {
// Generated by purs version 0.15.16

var $4wnrH = parcelRequire("4wnrH");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $298b737852233db7$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $298b737852233db7$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $298b737852233db7$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $298b737852233db7$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $298b737852233db7$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $298b737852233db7$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $298b737852233db7$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $298b737852233db7$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableColElement");
var $298b737852233db7$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableColElement");
var $298b737852233db7$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableColElement");
var $298b737852233db7$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableColElement");
var $298b737852233db7$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableColElement");
var $298b737852233db7$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableColElement");
var $298b737852233db7$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableColElement");

});
parcelRegister("4wnrH", function(module, exports) {
function $34ac56698048b1d0$export$afc1bfabebaf28a2(col) {
    return function() {
        return col.span;
    };
}
function $34ac56698048b1d0$export$8ab2f2e6ee8ed0a8(span) {
    return function(col) {
        return function() {
            col.span = span;
        };
    };
}

});


parcelRegister("cq1tX", function(module, exports) {
// Generated by purs version 0.15.16
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $90a91012d61f1bcd$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $90a91012d61f1bcd$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $90a91012d61f1bcd$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $90a91012d61f1bcd$export$619123619593c03d = $eOrGk.unsafeCoerce;
var $90a91012d61f1bcd$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $90a91012d61f1bcd$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $90a91012d61f1bcd$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $90a91012d61f1bcd$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $90a91012d61f1bcd$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableDataCellElement");
var $90a91012d61f1bcd$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableDataCellElement");
var $90a91012d61f1bcd$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableDataCellElement");
var $90a91012d61f1bcd$export$7b01868159b235fe = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableDataCellElement");
var $90a91012d61f1bcd$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableDataCellElement");
var $90a91012d61f1bcd$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableDataCellElement");
var $90a91012d61f1bcd$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableDataCellElement");
var $90a91012d61f1bcd$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableDataCellElement");

});

parcelRegister("0lbA2", function(module, exports) {
// Generated by purs version 0.15.16

var $6fRcm = parcelRequire("6fRcm");

var $l0wDR = parcelRequire("l0wDR");

var $T79xE = parcelRequire("T79xE");

var $9hRVP = parcelRequire("9hRVP");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $00106f41ab48b85e$var$map = /* #__PURE__ */ $l0wDR.map($9hRVP.functorEffect);
var $00106f41ab48b85e$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $00106f41ab48b85e$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $00106f41ab48b85e$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $00106f41ab48b85e$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $00106f41ab48b85e$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $00106f41ab48b85e$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $00106f41ab48b85e$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $00106f41ab48b85e$export$8ffb9307dee41683 = /* #__PURE__ */ function() {
    var $3 = $00106f41ab48b85e$var$map($T79xE.toMaybe);
    return function($4) {
        return $3($6fRcm._tHead($4));
    };
}();
var $00106f41ab48b85e$export$4ce044d081650b4 = /* #__PURE__ */ function() {
    var $5 = $00106f41ab48b85e$var$map($T79xE.toMaybe);
    return function($6) {
        return $5($6fRcm._tFoot($6));
    };
}();
var $00106f41ab48b85e$export$73c0abfa2c0e52e4 = function($7) {
    return $6fRcm._setTHead($T79xE.toNullable($7));
};
var $00106f41ab48b85e$export$1350b3df0623f8d7 = function($8) {
    return $6fRcm._setTFoot($T79xE.toNullable($8));
};
var $00106f41ab48b85e$export$c972b85f531b9f41 = function($9) {
    return $6fRcm._setCaption($T79xE.toNullable($9));
};
var $00106f41ab48b85e$export$6f91cb21ef21b608 = $6fRcm.insertRowAt;
var $00106f41ab48b85e$export$5a4e94bbc04b5f2 = /* #__PURE__ */ function() {
    return $00106f41ab48b85e$export$6f91cb21ef21b608(-1);
}();
var $00106f41ab48b85e$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableElement");
var $00106f41ab48b85e$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableElement");
var $00106f41ab48b85e$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableElement");
var $00106f41ab48b85e$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableElement");
var $00106f41ab48b85e$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableElement");
var $00106f41ab48b85e$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableElement");
var $00106f41ab48b85e$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableElement");
var $00106f41ab48b85e$export$8e3c2dfdc4f0453d = /* #__PURE__ */ function() {
    var $10 = $00106f41ab48b85e$var$map($T79xE.toMaybe);
    return function($11) {
        return $10($6fRcm._caption($11));
    };
}();

});
parcelRegister("6fRcm", function(module, exports) {

$parcel$export(module.exports, "_caption", () => $48dd68dffe0e6e15$export$b815d8b2ae8b8a8f);
$parcel$export(module.exports, "_setCaption", () => $48dd68dffe0e6e15$export$c1cd099bccef98fe);
$parcel$export(module.exports, "_tHead", () => $48dd68dffe0e6e15$export$75d2083daf0d4c8);
$parcel$export(module.exports, "_setTHead", () => $48dd68dffe0e6e15$export$accedb93377ebcb2);
$parcel$export(module.exports, "_tFoot", () => $48dd68dffe0e6e15$export$6c9b4fbde50fbc0f);
$parcel$export(module.exports, "_setTFoot", () => $48dd68dffe0e6e15$export$10a8938b95fbdb4);
$parcel$export(module.exports, "insertRowAt", () => $48dd68dffe0e6e15$export$281b3c86eeab738f);
function $48dd68dffe0e6e15$export$b815d8b2ae8b8a8f(table) {
    return function() {
        return table.caption;
    };
}
function $48dd68dffe0e6e15$export$c1cd099bccef98fe(caption) {
    return function(table) {
        return function() {
            table.caption = caption;
        };
    };
}
function $48dd68dffe0e6e15$export$690474d079e8aee0(table) {
    return function() {
        return table.createCaption();
    };
}
function $48dd68dffe0e6e15$export$2f169497140e8e8c(table) {
    return function() {
        table.deleteCaption();
    };
}
function $48dd68dffe0e6e15$export$75d2083daf0d4c8(table) {
    return function() {
        return table.tHead;
    };
}
function $48dd68dffe0e6e15$export$accedb93377ebcb2(tHead) {
    return function(table) {
        return function() {
            table.tHead = tHead;
        };
    };
}
function $48dd68dffe0e6e15$export$8e9dedfded1540ee(table) {
    return function() {
        return table.createTHead();
    };
}
function $48dd68dffe0e6e15$export$c28532ed8fc4a976(table) {
    return function() {
        table.deleteTHead();
    };
}
function $48dd68dffe0e6e15$export$6c9b4fbde50fbc0f(table) {
    return function() {
        return table.tFoot;
    };
}
function $48dd68dffe0e6e15$export$10a8938b95fbdb4(tFoot) {
    return function(table) {
        return function() {
            table.tFoot = tFoot;
        };
    };
}
function $48dd68dffe0e6e15$export$ab9f248e0049bb9d(table) {
    return function() {
        return table.createTFoot();
    };
}
function $48dd68dffe0e6e15$export$3c3cb2a6af70fe52(table) {
    return function() {
        table.deleteTFoot();
    };
}
function $48dd68dffe0e6e15$export$c63586cd99d53eee(table) {
    return function() {
        return table.tBodies;
    };
}
function $48dd68dffe0e6e15$export$76a5bd1e5d516e91(table) {
    return function() {
        return table.createTBody();
    };
}
function $48dd68dffe0e6e15$export$2dd197b55cf13440(table) {
    return function() {
        return table.rows;
    };
}
function $48dd68dffe0e6e15$export$281b3c86eeab738f(index) {
    return function(table) {
        return function() {
            return table.insertRow(index);
        };
    };
}
function $48dd68dffe0e6e15$export$2ef39e5ffdaff9ed(index) {
    return function(table) {
        return function() {
            table.deleteRow(index);
        };
    };
}
function $48dd68dffe0e6e15$export$1edee58a52776cd9(table) {
    return function() {
        return table.border;
    };
}
function $48dd68dffe0e6e15$export$df6de19f3e6baa52(border) {
    return function(table) {
        return function() {
            table.border = border;
        };
    };
}

});


parcelRegister("71Ync", function(module, exports) {
// Generated by purs version 0.15.16

var $hWi4u = parcelRequire("hWi4u");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $51e7753cdccb5d79$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $51e7753cdccb5d79$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $51e7753cdccb5d79$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $51e7753cdccb5d79$export$619123619593c03d = $eOrGk.unsafeCoerce;
var $51e7753cdccb5d79$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $51e7753cdccb5d79$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $51e7753cdccb5d79$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $51e7753cdccb5d79$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $51e7753cdccb5d79$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableHeaderCellElement");
var $51e7753cdccb5d79$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableHeaderCellElement");
var $51e7753cdccb5d79$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableHeaderCellElement");
var $51e7753cdccb5d79$export$7b01868159b235fe = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableHeaderCellElement");
var $51e7753cdccb5d79$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableHeaderCellElement");
var $51e7753cdccb5d79$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableHeaderCellElement");
var $51e7753cdccb5d79$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableHeaderCellElement");
var $51e7753cdccb5d79$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableHeaderCellElement");

});
parcelRegister("hWi4u", function(module, exports) {
function $d0f5df104e75ba24$export$5cff813ca8e50db9(cell) {
    return function() {
        return cell.scope;
    };
}
function $d0f5df104e75ba24$export$d9e5239df8f952de(scope) {
    return function(cell) {
        return function() {
            cell.scope = scope;
        };
    };
}
function $d0f5df104e75ba24$export$2bcb785951133fe5(cell) {
    return function() {
        return cell.abbr;
    };
}
function $d0f5df104e75ba24$export$4b75111ed99261c8(abbr) {
    return function(cell) {
        return function() {
            cell.abbr = abbr;
        };
    };
}

});


parcelRegister("8wc3z", function(module, exports) {
// Generated by purs version 0.15.16

var $jhmmJ = parcelRequire("jhmmJ");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $633aaa19d7d1d3a1$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $633aaa19d7d1d3a1$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $633aaa19d7d1d3a1$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $633aaa19d7d1d3a1$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $633aaa19d7d1d3a1$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $633aaa19d7d1d3a1$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $633aaa19d7d1d3a1$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $633aaa19d7d1d3a1$export$27b66c5ce67ee025 = $jhmmJ.insertCellAt;
var $633aaa19d7d1d3a1$export$51965e0a3b80eb5c = /* #__PURE__ */ function() {
    return $633aaa19d7d1d3a1$export$27b66c5ce67ee025(-1);
}();
var $633aaa19d7d1d3a1$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableRowElement");
var $633aaa19d7d1d3a1$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableRowElement");
var $633aaa19d7d1d3a1$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableRowElement");
var $633aaa19d7d1d3a1$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableRowElement");
var $633aaa19d7d1d3a1$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableRowElement");
var $633aaa19d7d1d3a1$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableRowElement");
var $633aaa19d7d1d3a1$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableRowElement");

});
parcelRegister("jhmmJ", function(module, exports) {

$parcel$export(module.exports, "insertCellAt", () => $e090f42f468fa271$export$96a7dd0d30a5e7fe);
function $e090f42f468fa271$export$f6e5b2c929a2f19d(row) {
    return function() {
        return row.rowIndex;
    };
}
function $e090f42f468fa271$export$11d8b50a98496a38(row) {
    return function() {
        return row.sectionRowIndex;
    };
}
function $e090f42f468fa271$export$57ba6370ea0e47f8(row) {
    return function() {
        return row.cells;
    };
}
function $e090f42f468fa271$export$96a7dd0d30a5e7fe(index) {
    return function(row) {
        return function() {
            return row.insertCell(index);
        };
    };
}
function $e090f42f468fa271$export$6e37d353cc5629c9(index) {
    return function(row) {
        return function() {
            row.deleteCell(index);
        };
    };
}

});


parcelRegister("7aDwq", function(module, exports) {
// Generated by purs version 0.15.16

var $iR4ac = parcelRequire("iR4ac");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $53881fd03908fa53$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $53881fd03908fa53$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $53881fd03908fa53$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $53881fd03908fa53$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $53881fd03908fa53$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $53881fd03908fa53$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $53881fd03908fa53$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $53881fd03908fa53$export$6f91cb21ef21b608 = $iR4ac.insertRowAt;
var $53881fd03908fa53$export$5a4e94bbc04b5f2 = /* #__PURE__ */ function() {
    return $53881fd03908fa53$export$6f91cb21ef21b608(-1);
}();
var $53881fd03908fa53$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableSectionElement");
var $53881fd03908fa53$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableSectionElement");
var $53881fd03908fa53$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableSectionElement");
var $53881fd03908fa53$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableSectionElement");
var $53881fd03908fa53$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableSectionElement");
var $53881fd03908fa53$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableSectionElement");
var $53881fd03908fa53$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTableSectionElement");

});
parcelRegister("iR4ac", function(module, exports) {

$parcel$export(module.exports, "insertRowAt", () => $dba0680894fb8dd0$export$281b3c86eeab738f);
function $dba0680894fb8dd0$export$2dd197b55cf13440(section) {
    return function() {
        return section.rows;
    };
}
function $dba0680894fb8dd0$export$281b3c86eeab738f(index) {
    return function(section) {
        return function() {
            return section.insertRow(index);
        };
    };
}
function $dba0680894fb8dd0$export$2ef39e5ffdaff9ed(index) {
    return function(section) {
        return function() {
            section.deleteRow(index);
        };
    };
}

});


parcelRegister("lSIzx", function(module, exports) {
// Generated by purs version 0.15.16

var $2kVRP = parcelRequire("2kVRP");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $fee13735939d9bee$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $fee13735939d9bee$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $fee13735939d9bee$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $fee13735939d9bee$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $fee13735939d9bee$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $fee13735939d9bee$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $fee13735939d9bee$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $fee13735939d9bee$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTemplateElement");
var $fee13735939d9bee$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTemplateElement");
var $fee13735939d9bee$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTemplateElement");
var $fee13735939d9bee$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTemplateElement");
var $fee13735939d9bee$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTemplateElement");
var $fee13735939d9bee$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTemplateElement");
var $fee13735939d9bee$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTemplateElement");

});
parcelRegister("2kVRP", function(module, exports) {
function $1b3a563b18f6151d$export$a7db06668cad9adb(template) {
    return function() {
        return template.content;
    };
}

});


parcelRegister("6YO7x", function(module, exports) {
// Generated by purs version 0.15.16

var $3uZuT = parcelRequire("3uZuT");

var $l0wDR = parcelRequire("l0wDR");

var $T79xE = parcelRequire("T79xE");

var $9hRVP = parcelRequire("9hRVP");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $gxdyz = parcelRequire("gxdyz");

var $6EJMX = parcelRequire("6EJMX");
var $514f398dc6a7828b$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $514f398dc6a7828b$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $514f398dc6a7828b$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $514f398dc6a7828b$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $514f398dc6a7828b$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $514f398dc6a7828b$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $514f398dc6a7828b$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $514f398dc6a7828b$export$873e7fe8f20f100c = function(rpl) {
    return function(s) {
        return function(e) {
            return function(mode) {
                return function(area) {
                    return function() {
                        return $3uZuT._setRangeText(rpl, s, e, $gxdyz.print(mode), area);
                    };
                };
            };
        };
    };
};
var $514f398dc6a7828b$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTextAreaElement");
var $514f398dc6a7828b$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTextAreaElement");
var $514f398dc6a7828b$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTextAreaElement");
var $514f398dc6a7828b$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTextAreaElement");
var $514f398dc6a7828b$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTextAreaElement");
var $514f398dc6a7828b$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTextAreaElement");
var $514f398dc6a7828b$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTextAreaElement");
var $514f398dc6a7828b$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $l0wDR.map($9hRVP.functorEffect)($T79xE.toMaybe);
    return function($3) {
        return $2($3uZuT._form($3));
    };
}();

});
parcelRegister("3uZuT", function(module, exports) {

$parcel$export(module.exports, "_form", () => $28c3e08a1c48c9af$export$242c63e9758836c2);
$parcel$export(module.exports, "_setRangeText", () => $28c3e08a1c48c9af$export$309b5632e9b49193);
function $28c3e08a1c48c9af$export$485ded5f26ebe08d(textarea) {
    return function() {
        return textarea.autocomplete;
    };
}
function $28c3e08a1c48c9af$export$5fb7c729919301a5(autocomplete) {
    return function(textarea) {
        return function() {
            textarea.autocomplete = autocomplete;
        };
    };
}
function $28c3e08a1c48c9af$export$4c47992fc278c9a0(textarea) {
    return function() {
        return textarea.autofocus;
    };
}
function $28c3e08a1c48c9af$export$db2bbdcbda3d335e(autofocus) {
    return function(textarea) {
        return function() {
            textarea.autofocus = autofocus;
        };
    };
}
function $28c3e08a1c48c9af$export$1eebcb1e706ab348(textarea) {
    return function() {
        return textarea.cols;
    };
}
function $28c3e08a1c48c9af$export$3df203352cd8517(cols) {
    return function(textarea) {
        return function() {
            textarea.cols = cols;
        };
    };
}
function $28c3e08a1c48c9af$export$9ebb36ddc946da55(textarea) {
    return function() {
        return textarea.dirName;
    };
}
function $28c3e08a1c48c9af$export$e2460e55089b163d(dirName) {
    return function(textarea) {
        return function() {
            textarea.dirName = dirName;
        };
    };
}
function $28c3e08a1c48c9af$export$683472f6198a076e(textarea) {
    return function() {
        return textarea.disabled;
    };
}
function $28c3e08a1c48c9af$export$4532d31cef66d703(disabled) {
    return function(textarea) {
        return function() {
            textarea.disabled = disabled;
        };
    };
}
function $28c3e08a1c48c9af$export$242c63e9758836c2(textarea) {
    return function() {
        return textarea.form;
    };
}
function $28c3e08a1c48c9af$export$c9f461152c658a8b(textarea) {
    return function() {
        return textarea.maxLength;
    };
}
function $28c3e08a1c48c9af$export$45077a575ddd961f(maxLength) {
    return function(textarea) {
        return function() {
            textarea.maxLength = maxLength;
        };
    };
}
function $28c3e08a1c48c9af$export$8fe860a115a1e636(textarea) {
    return function() {
        return textarea.minLength;
    };
}
function $28c3e08a1c48c9af$export$2b867239766ba1e3(minLength) {
    return function(textarea) {
        return function() {
            textarea.minLength = minLength;
        };
    };
}
function $28c3e08a1c48c9af$export$a8ff84c12d48cfa6(textarea) {
    return function() {
        return textarea.name;
    };
}
function $28c3e08a1c48c9af$export$6cf3d710d3a367e5(name) {
    return function(textarea) {
        return function() {
            textarea.name = name;
        };
    };
}
function $28c3e08a1c48c9af$export$c7187bbd1a7a9244(textarea) {
    return function() {
        return textarea.placeholder;
    };
}
function $28c3e08a1c48c9af$export$645bf5697adfa088(placeholder) {
    return function(textarea) {
        return function() {
            textarea.placeholder = placeholder;
        };
    };
}
function $28c3e08a1c48c9af$export$b2cbc93d4da94977(textarea) {
    return function() {
        return textarea.readOnly;
    };
}
function $28c3e08a1c48c9af$export$62311ce54ddfc862(readOnly) {
    return function(textarea) {
        return function() {
            textarea.readOnly = readOnly;
        };
    };
}
function $28c3e08a1c48c9af$export$a7a0278c004aac3f(textarea) {
    return function() {
        return textarea.required;
    };
}
function $28c3e08a1c48c9af$export$47f9362469f346c4(required) {
    return function(textarea) {
        return function() {
            textarea.required = required;
        };
    };
}
function $28c3e08a1c48c9af$export$2dd197b55cf13440(textarea) {
    return function() {
        return textarea.rows;
    };
}
function $28c3e08a1c48c9af$export$f2d998961118057a(rows) {
    return function(textarea) {
        return function() {
            textarea.rows = rows;
        };
    };
}
function $28c3e08a1c48c9af$export$4997ffc0176396a6(textarea) {
    return function() {
        return textarea.wrap;
    };
}
function $28c3e08a1c48c9af$export$696447b714acda6d(wrap) {
    return function(textarea) {
        return function() {
            textarea.wrap = wrap;
        };
    };
}
function $28c3e08a1c48c9af$export$d4a6a4db5b31e621(textarea) {
    return function() {
        return textarea.type;
    };
}
function $28c3e08a1c48c9af$export$1a01ae0705bafd37(textarea) {
    return function() {
        return textarea.defaultValue;
    };
}
function $28c3e08a1c48c9af$export$d8becbd7468e206f(defaultValue) {
    return function(textarea) {
        return function() {
            textarea.defaultValue = defaultValue;
        };
    };
}
function $28c3e08a1c48c9af$export$2ab9a8f9f1186f14(textarea) {
    return function() {
        return textarea.value;
    };
}
function $28c3e08a1c48c9af$export$80746c6bc6142fc8(value) {
    return function(textarea) {
        return function() {
            textarea.value = value;
        };
    };
}
function $28c3e08a1c48c9af$export$6f846043e306f02c(textarea) {
    return function() {
        return textarea.textLength;
    };
}
function $28c3e08a1c48c9af$export$5e55a9e709e8e020(textarea) {
    return function() {
        return textarea.willValidate;
    };
}
function $28c3e08a1c48c9af$export$1bdd3f9a89b22594(textarea) {
    return function() {
        return textarea.validity;
    };
}
function $28c3e08a1c48c9af$export$6ee4201e37a931e2(textarea) {
    return function() {
        return textarea.validationMessage;
    };
}
function $28c3e08a1c48c9af$export$50d70f8cedc54453(textarea) {
    return function() {
        return textarea.checkValidity();
    };
}
function $28c3e08a1c48c9af$export$b962d864c477cc49(textarea) {
    return function() {
        return textarea.reportValidity();
    };
}
function $28c3e08a1c48c9af$export$6f569cb704992105(value) {
    return function(textarea) {
        return function() {
            textarea.setCustomValidity(value);
        };
    };
}
function $28c3e08a1c48c9af$export$a238cb463698c900(textarea) {
    return function() {
        return textarea.labels;
    };
}
function $28c3e08a1c48c9af$export$2e6c959c16ff56b8(textarea) {
    return function() {
        textarea.select();
    };
}
function $28c3e08a1c48c9af$export$5e2f617ae845fb63(textarea) {
    return function() {
        return textarea.selectionStart;
    };
}
function $28c3e08a1c48c9af$export$47b9c21811f199bd(selectionStart) {
    return function(textarea) {
        return function() {
            textarea.selectionStart = selectionStart;
        };
    };
}
function $28c3e08a1c48c9af$export$1028be563f1155b2(textarea) {
    return function() {
        return textarea.selectionEnd;
    };
}
function $28c3e08a1c48c9af$export$15d012c6be3c352(selectionEnd) {
    return function(textarea) {
        return function() {
            textarea.selectionEnd = selectionEnd;
        };
    };
}
function $28c3e08a1c48c9af$export$b4e8aad052258154(textarea) {
    return function() {
        return textarea.selectionDirection;
    };
}
function $28c3e08a1c48c9af$export$6ac306cb2c51a4e6(selectionDirection) {
    return function(textarea) {
        return function() {
            textarea.selectionDirection = selectionDirection;
        };
    };
}
function $28c3e08a1c48c9af$export$2add2a46d1c1d557(replacement) {
    return function(textarea) {
        return function() {
            textarea.setRangeText(replacement);
        };
    };
}
function $28c3e08a1c48c9af$export$309b5632e9b49193(replacement, start, end, selectionMode, textarea) {
    textarea.setRangeText(replacement, start, end, selectionMode);
}
function $28c3e08a1c48c9af$export$3b045ac5f470d884(start) {
    return function(end) {
        return function(direction) {
            return function(textarea) {
                return function() {
                    textarea.setSelectionRange(start, end, direction);
                };
            };
        };
    };
}

});


parcelRegister("kHGUQ", function(module, exports) {
// Generated by purs version 0.15.16

var $90erZ = parcelRequire("90erZ");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $f1291cf94838d52b$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $f1291cf94838d52b$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $f1291cf94838d52b$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $f1291cf94838d52b$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $f1291cf94838d52b$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $f1291cf94838d52b$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $f1291cf94838d52b$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $f1291cf94838d52b$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTimeElement");
var $f1291cf94838d52b$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTimeElement");
var $f1291cf94838d52b$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTimeElement");
var $f1291cf94838d52b$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTimeElement");
var $f1291cf94838d52b$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTimeElement");
var $f1291cf94838d52b$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTimeElement");
var $f1291cf94838d52b$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTimeElement");

});
parcelRegister("90erZ", function(module, exports) {
function $68df52b2f5f30ba7$export$3a17bddce263fba0(time) {
    return function() {
        return time.dateTime;
    };
}
function $68df52b2f5f30ba7$export$3a84b9eda98e95dc(dateTime) {
    return function(time) {
        return function() {
            time.dateTime = dateTime;
        };
    };
}

});


parcelRegister("9IxHk", function(module, exports) {
// Generated by purs version 0.15.16

var $eo7E4 = parcelRequire("eo7E4");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $71325cd3e1c1cf85$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $71325cd3e1c1cf85$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $71325cd3e1c1cf85$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $71325cd3e1c1cf85$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $71325cd3e1c1cf85$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $71325cd3e1c1cf85$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $71325cd3e1c1cf85$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $71325cd3e1c1cf85$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTitleElement");
var $71325cd3e1c1cf85$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTitleElement");
var $71325cd3e1c1cf85$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTitleElement");
var $71325cd3e1c1cf85$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTitleElement");
var $71325cd3e1c1cf85$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTitleElement");
var $71325cd3e1c1cf85$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTitleElement");
var $71325cd3e1c1cf85$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTitleElement");

});
parcelRegister("eo7E4", function(module, exports) {
function $a7993cc78206c04b$export$6f093cfa640b7166(title) {
    return function() {
        return title.text;
    };
}
function $a7993cc78206c04b$export$cbe0d99836e1498f(text) {
    return function(title) {
        return function() {
            title.text = text;
        };
    };
}

});


parcelRegister("tcg3L", function(module, exports) {
// Generated by purs version 0.15.16

var $42jg5 = parcelRequire("42jg5");

var $loxi1 = parcelRequire("loxi1");

var $l0wDR = parcelRequire("l0wDR");

var $ykHdR = parcelRequire("ykHdR");

var $9hRVP = parcelRequire("9hRVP");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $5MUEu = parcelRequire("5MUEu");

var $6EJMX = parcelRequire("6EJMX");
var $057c37bcb2e4f7d0$var$map = /* #__PURE__ */ $l0wDR.map($9hRVP.functorEffect);
var $057c37bcb2e4f7d0$var$toEnum = /* #__PURE__ */ $loxi1.toEnum($5MUEu.boundedEnumReadyState);
var $057c37bcb2e4f7d0$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $057c37bcb2e4f7d0$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $057c37bcb2e4f7d0$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $057c37bcb2e4f7d0$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $057c37bcb2e4f7d0$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $057c37bcb2e4f7d0$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $057c37bcb2e4f7d0$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $057c37bcb2e4f7d0$export$1ae2b664eea77b7e = function(el) {
    return $057c37bcb2e4f7d0$var$map(function() {
        var $3 = $ykHdR.fromMaybe($5MUEu.None.value);
        return function($4) {
            return $3($057c37bcb2e4f7d0$var$toEnum($4));
        };
    }())(function() {
        return $42jg5._readyState(el);
    });
};
var $057c37bcb2e4f7d0$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTrackElement");
var $057c37bcb2e4f7d0$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTrackElement");
var $057c37bcb2e4f7d0$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTrackElement");
var $057c37bcb2e4f7d0$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTrackElement");
var $057c37bcb2e4f7d0$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTrackElement");
var $057c37bcb2e4f7d0$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTrackElement");
var $057c37bcb2e4f7d0$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLTrackElement");

});
parcelRegister("42jg5", function(module, exports) {

$parcel$export(module.exports, "_readyState", () => $2f0649a862aa117b$export$4bf8a366db6a678b);
function $2f0649a862aa117b$export$78062f36b16ed2f8(track) {
    return function() {
        return track.kind;
    };
}
function $2f0649a862aa117b$export$8f76af250dd43cf6(kind) {
    return function(track) {
        return function() {
            track.kind = kind;
        };
    };
}
function $2f0649a862aa117b$export$2e40c9e35e9506f4(track) {
    return function() {
        return track.src;
    };
}
function $2f0649a862aa117b$export$5771e3a4c80da7df(src) {
    return function(track) {
        return function() {
            track.src = src;
        };
    };
}
function $2f0649a862aa117b$export$4be5a609db5ad788(track) {
    return function() {
        return track.srclang;
    };
}
function $2f0649a862aa117b$export$5406412834bff708(srclang) {
    return function(track) {
        return function() {
            track.srclang = srclang;
        };
    };
}
function $2f0649a862aa117b$export$1237798dc640739a(track) {
    return function() {
        return track.label;
    };
}
function $2f0649a862aa117b$export$4f65e594f6031297(label) {
    return function(track) {
        return function() {
            track.label = label;
        };
    };
}
// ----------------------------------------------------------------------------
const $2f0649a862aa117b$export$2e2bcd8739ae039 = function(track) {
    return function() {
        return track["default"];
    };
};
function $2f0649a862aa117b$export$d590af038dd015bd(def) {
    return function(track) {
        return function() {
            track["default"] = def;
        };
    };
}
function $2f0649a862aa117b$export$4bf8a366db6a678b(track) {
    return track.readyState;
}

});

parcelRegister("5MUEu", function(module, exports) {

$parcel$export(module.exports, "None", () => $436d616104359630$export$57ca7e07b341709d);
$parcel$export(module.exports, "boundedEnumReadyState", () => $436d616104359630$export$94a641e970e969f9);
// Generated by purs version 0.15.16

var $loxi1 = parcelRequire("loxi1");

var $ykHdR = parcelRequire("ykHdR");

var $6SDUu = parcelRequire("6SDUu");
var $436d616104359630$export$57ca7e07b341709d = /* #__PURE__ */ function() {
    function None() {}
    None.value = new None();
    return None;
}();
var $436d616104359630$export$669f6ea7d267feaf = /* #__PURE__ */ function() {
    function Loading() {}
    Loading.value = new Loading();
    return Loading;
}();
var $436d616104359630$export$b6517d5bdd20170e = /* #__PURE__ */ function() {
    function Loaded() {}
    Loaded.value = new Loaded();
    return Loaded;
}();
var $436d616104359630$export$edf27be85e5f6da0 = /* #__PURE__ */ function() {
    function $$Error() {}
    $$Error.value = new $$Error();
    return $$Error;
}();
var $436d616104359630$export$dc807b9f83d61e2e = function(v) {
    if (v === 0) return new $ykHdR.Just($436d616104359630$export$57ca7e07b341709d.value);
    if (v === 1) return new $ykHdR.Just($436d616104359630$export$669f6ea7d267feaf.value);
    if (v === 2) return new $ykHdR.Just($436d616104359630$export$b6517d5bdd20170e.value);
    if (v === 3) return new $ykHdR.Just($436d616104359630$export$edf27be85e5f6da0.value);
    return $ykHdR.Nothing.value;
};
var $436d616104359630$export$33dd24f3d942b82e = {
    show: function(v) {
        if (v instanceof $436d616104359630$export$57ca7e07b341709d) return "None";
        if (v instanceof $436d616104359630$export$669f6ea7d267feaf) return "Loading";
        if (v instanceof $436d616104359630$export$b6517d5bdd20170e) return "Loaded";
        if (v instanceof $436d616104359630$export$edf27be85e5f6da0) return "Error";
        throw new Error("Failed pattern match at Web.HTML.HTMLTrackElement.ReadyState (line 30, column 1 - line 34, column 23): " + [
            v.constructor.name
        ]);
    }
};
var $436d616104359630$export$9974ae2c28acb3c9 = function(v) {
    if (v instanceof $436d616104359630$export$57ca7e07b341709d) return 0;
    if (v instanceof $436d616104359630$export$669f6ea7d267feaf) return 1;
    if (v instanceof $436d616104359630$export$b6517d5bdd20170e) return 2;
    if (v instanceof $436d616104359630$export$edf27be85e5f6da0) return 3;
    throw new Error("Failed pattern match at Web.HTML.HTMLTrackElement.ReadyState (line 47, column 3 - line 51, column 15): " + [
        v.constructor.name
    ]);
};
var $436d616104359630$export$c71e02dcc13f94a6 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $436d616104359630$export$57ca7e07b341709d && y instanceof $436d616104359630$export$57ca7e07b341709d) return true;
            if (x instanceof $436d616104359630$export$669f6ea7d267feaf && y instanceof $436d616104359630$export$669f6ea7d267feaf) return true;
            if (x instanceof $436d616104359630$export$b6517d5bdd20170e && y instanceof $436d616104359630$export$b6517d5bdd20170e) return true;
            if (x instanceof $436d616104359630$export$edf27be85e5f6da0 && y instanceof $436d616104359630$export$edf27be85e5f6da0) return true;
            return false;
        };
    }
};
var $436d616104359630$export$6557947d538c3b81 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $436d616104359630$export$57ca7e07b341709d && y instanceof $436d616104359630$export$57ca7e07b341709d) return $6SDUu.EQ.value;
            if (x instanceof $436d616104359630$export$57ca7e07b341709d) return $6SDUu.LT.value;
            if (y instanceof $436d616104359630$export$57ca7e07b341709d) return $6SDUu.GT.value;
            if (x instanceof $436d616104359630$export$669f6ea7d267feaf && y instanceof $436d616104359630$export$669f6ea7d267feaf) return $6SDUu.EQ.value;
            if (x instanceof $436d616104359630$export$669f6ea7d267feaf) return $6SDUu.LT.value;
            if (y instanceof $436d616104359630$export$669f6ea7d267feaf) return $6SDUu.GT.value;
            if (x instanceof $436d616104359630$export$b6517d5bdd20170e && y instanceof $436d616104359630$export$b6517d5bdd20170e) return $6SDUu.EQ.value;
            if (x instanceof $436d616104359630$export$b6517d5bdd20170e) return $6SDUu.LT.value;
            if (y instanceof $436d616104359630$export$b6517d5bdd20170e) return $6SDUu.GT.value;
            if (x instanceof $436d616104359630$export$edf27be85e5f6da0 && y instanceof $436d616104359630$export$edf27be85e5f6da0) return $6SDUu.EQ.value;
            throw new Error("Failed pattern match at Web.HTML.HTMLTrackElement.ReadyState (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $436d616104359630$export$c71e02dcc13f94a6;
    }
};
var $436d616104359630$export$f705a14e9e99c6f0 = {
    succ: /* #__PURE__ */ $loxi1.defaultSucc($436d616104359630$export$dc807b9f83d61e2e)($436d616104359630$export$9974ae2c28acb3c9),
    pred: /* #__PURE__ */ $loxi1.defaultPred($436d616104359630$export$dc807b9f83d61e2e)($436d616104359630$export$9974ae2c28acb3c9),
    Ord0: function() {
        return $436d616104359630$export$6557947d538c3b81;
    }
};
var $436d616104359630$export$7b40514a91e8387e = /* #__PURE__ */ function() {
    return {
        bottom: $436d616104359630$export$57ca7e07b341709d.value,
        top: $436d616104359630$export$edf27be85e5f6da0.value,
        Ord0: function() {
            return $436d616104359630$export$6557947d538c3b81;
        }
    };
}();
var $436d616104359630$export$94a641e970e969f9 = {
    cardinality: 4,
    toEnum: $436d616104359630$export$dc807b9f83d61e2e,
    fromEnum: $436d616104359630$export$9974ae2c28acb3c9,
    Bounded0: function() {
        return $436d616104359630$export$7b40514a91e8387e;
    },
    Enum1: function() {
        return $436d616104359630$export$f705a14e9e99c6f0;
    }
};

});


parcelRegister("j5ALL", function(module, exports) {
// Generated by purs version 0.15.16
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $de5b01932d221096$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $de5b01932d221096$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $de5b01932d221096$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $de5b01932d221096$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $de5b01932d221096$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $de5b01932d221096$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $de5b01932d221096$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $de5b01932d221096$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLUListElement");
var $de5b01932d221096$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLUListElement");
var $de5b01932d221096$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLUListElement");
var $de5b01932d221096$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLUListElement");
var $de5b01932d221096$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLUListElement");
var $de5b01932d221096$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLUListElement");
var $de5b01932d221096$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLUListElement");

});

parcelRegister("aetWv", function(module, exports) {
// Generated by purs version 0.15.16

var $8oEll = parcelRequire("8oEll");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $7732702ec87f6f21$export$c8b651b897da2de = $eOrGk.unsafeCoerce;
var $7732702ec87f6f21$export$f8671ec463598929 = $eOrGk.unsafeCoerce;
var $7732702ec87f6f21$export$83a0de4644f1fbc4 = $eOrGk.unsafeCoerce;
var $7732702ec87f6f21$export$fd26055f9731f4b9 = $eOrGk.unsafeCoerce;
var $7732702ec87f6f21$export$3667cdd4f3a5105e = $eOrGk.unsafeCoerce;
var $7732702ec87f6f21$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $7732702ec87f6f21$export$8d51e3db1a844094 = $eOrGk.unsafeCoerce;
var $7732702ec87f6f21$export$8ff7c34974173077 = $eOrGk.unsafeCoerce;
var $7732702ec87f6f21$export$7039ba397093f069 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLVideoElement");
var $7732702ec87f6f21$export$66db07be43ecb0c3 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLVideoElement");
var $7732702ec87f6f21$export$a7f097b65af8aa04 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLVideoElement");
var $7732702ec87f6f21$export$cdb626e247ef0ce5 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLVideoElement");
var $7732702ec87f6f21$export$f9471d229cb6cb3f = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLVideoElement");
var $7732702ec87f6f21$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLVideoElement");
var $7732702ec87f6f21$export$c56654a6d0e3bd48 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLVideoElement");
var $7732702ec87f6f21$export$31942037104a4a20 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("HTMLVideoElement");

});
parcelRegister("8oEll", function(module, exports) {
// ----------------------------------------------------------------------------
function $61cfdbf50fc824d4$export$7e3df82ee760448c(video) {
    return function() {
        return video.width;
    };
}
function $61cfdbf50fc824d4$export$67f48e0594af05d(width) {
    return function(video) {
        return function() {
            video.width = width;
        };
    };
}
function $61cfdbf50fc824d4$export$ac607276a8fe9f0a(video) {
    return function() {
        return video.height;
    };
}
function $61cfdbf50fc824d4$export$3f31360357be44e4(height) {
    return function(video) {
        return function() {
            video.height = height;
        };
    };
}
function $61cfdbf50fc824d4$export$dbb4894ced044525(video) {
    return function() {
        return video.videoWidth;
    };
}
function $61cfdbf50fc824d4$export$848581bdb4a7943d(video) {
    return function() {
        return video.videoHeight;
    };
}
function $61cfdbf50fc824d4$export$b840e55573b2d2e7(video) {
    return function() {
        return video.poster;
    };
}
function $61cfdbf50fc824d4$export$2c8117e8f5cb8138(poster) {
    return function(video) {
        return function() {
            video.poster = poster;
        };
    };
}

});


parcelRegister("gUzwk", function(module, exports) {
// Generated by purs version 0.15.16

var $a7Vc1 = parcelRequire("a7Vc1");

var $d0PPW = parcelRequire("d0PPW");
var $c4fd6deeadc2e277$var$compare = /* #__PURE__ */ $d0PPW.compare($d0PPW.ordString);
var $c4fd6deeadc2e277$var$compare1 = /* #__PURE__ */ $d0PPW.compare($d0PPW.ordInt);
var $c4fd6deeadc2e277$export$61abde59b50deb8e = function(x) {
    return x;
};
var $c4fd6deeadc2e277$export$dd5ad0b65cf665da = function(x) {
    return x;
};
var $c4fd6deeadc2e277$export$1f333647865369bf = function(x) {
    return x;
};
var $c4fd6deeadc2e277$export$e587774857b65d31 = {
    Coercible0: function() {
        return undefined;
    }
};
var $c4fd6deeadc2e277$export$2cdd79be0aa3bb07 = {
    Coercible0: function() {
        return undefined;
    }
};
var $c4fd6deeadc2e277$export$3c3105bc6097b846 = {
    Coercible0: function() {
        return undefined;
    }
};
var $c4fd6deeadc2e277$export$214a01057915d716 = {
    eq: function(x) {
        return function(y) {
            return x === y;
        };
    }
};
var $c4fd6deeadc2e277$export$dbc0939544a3624 = {
    compare: function(x) {
        return function(y) {
            return $c4fd6deeadc2e277$var$compare(x)(y);
        };
    },
    Eq0: function() {
        return $c4fd6deeadc2e277$export$214a01057915d716;
    }
};
var $c4fd6deeadc2e277$export$28be1498e824b653 = {
    eq: function(x) {
        return function(y) {
            return x === y;
        };
    }
};
var $c4fd6deeadc2e277$export$7c3d39f0cf320c7b = {
    compare: function(x) {
        return function(y) {
            return $c4fd6deeadc2e277$var$compare(x)(y);
        };
    },
    Eq0: function() {
        return $c4fd6deeadc2e277$export$28be1498e824b653;
    }
};
var $c4fd6deeadc2e277$export$3e1b8005eb6f3d68 = {
    eq: function(x) {
        return function(y) {
            return x === y;
        };
    }
};
var $c4fd6deeadc2e277$export$4ef0c953a661f864 = {
    compare: function(x) {
        return function(y) {
            return $c4fd6deeadc2e277$var$compare1(x)(y);
        };
    },
    Eq0: function() {
        return $c4fd6deeadc2e277$export$3e1b8005eb6f3d68;
    }
};

});
parcelRegister("a7Vc1", function(module, exports) {
function $75f6ec27f640501f$export$7c341cb16fc91138(history) {
    return function() {
        return history.back();
    };
}
function $75f6ec27f640501f$export$174bb771924e7eb1(history) {
    return function() {
        return history.forward();
    };
}
function $75f6ec27f640501f$export$93bb224d05b3906d(delta) {
    return function(history) {
        return function() {
            return history.go(delta);
        };
    };
}
function $75f6ec27f640501f$export$ba0fd82af7b4fe6e(a) {
    return function(docTitle) {
        return function(url) {
            return function(history) {
                return function() {
                    return history.pushState(a, docTitle, url);
                };
            };
        };
    };
}
function $75f6ec27f640501f$export$e68dd4d2e7e08394(a) {
    return function(docTitle) {
        return function(url) {
            return function(history) {
                return function() {
                    return history.replaceState(a, docTitle, url);
                };
            };
        };
    };
}
function $75f6ec27f640501f$export$ca000e230c0caa3e(history) {
    return function() {
        return history.state;
    };
}

});


parcelRegister("8kUKU", function(module, exports) {
// Generated by purs version 0.15.16

var $ln02a = parcelRequire("ln02a");

});
parcelRegister("ln02a", function(module, exports) {
function $f8ebc5adafdca7e8$export$d6af199866bfb566(location) {
    return function() {
        return location.hash;
    };
}
function $f8ebc5adafdca7e8$export$42c3f3255a992e7(hash) {
    return function(location) {
        return function() {
            location.hash = hash;
        };
    };
}
function $f8ebc5adafdca7e8$export$5e032988b71f6158(location) {
    return function() {
        return location.host;
    };
}
function $f8ebc5adafdca7e8$export$db0724f89fd14c87(host) {
    return function(location) {
        return function() {
            location.host = host;
        };
    };
}
function $f8ebc5adafdca7e8$export$640106f6dc7d2706(location) {
    return function() {
        return location.hostname;
    };
}
function $f8ebc5adafdca7e8$export$d120c0a46ba2e633(hostname) {
    return function(location) {
        return function() {
            location.hostname = hostname;
        };
    };
}
function $f8ebc5adafdca7e8$export$8f51af5840e0602a(location) {
    return function() {
        return location.href;
    };
}
function $f8ebc5adafdca7e8$export$428f6e77b5a5a669(href) {
    return function(location) {
        return function() {
            location.href = href;
        };
    };
}
function $f8ebc5adafdca7e8$export$f710a83a91838a36(location) {
    return function() {
        return location.origin;
    };
}
function $f8ebc5adafdca7e8$export$717aaa4b4fe61ebd(origin) {
    return function(location) {
        return function() {
            location.origin = origin;
        };
    };
}
function $f8ebc5adafdca7e8$export$7333db99aa99d383(location) {
    return function() {
        return location.pathname;
    };
}
function $f8ebc5adafdca7e8$export$8c7da94d5c72705a(pathname) {
    return function(location) {
        return function() {
            location.pathname = pathname;
        };
    };
}
function $f8ebc5adafdca7e8$export$2433da7bd3cc7af7(location) {
    return function() {
        return location.port;
    };
}
function $f8ebc5adafdca7e8$export$b0effcd3879eb064(port) {
    return function(location) {
        return function() {
            location.port = port;
        };
    };
}
function $f8ebc5adafdca7e8$export$a51d6b395ff4c65a(location) {
    return function() {
        return location.protocol;
    };
}
function $f8ebc5adafdca7e8$export$caabdac475e4f216(protocol) {
    return function(location) {
        return function() {
            location.protocol = protocol;
        };
    };
}
function $f8ebc5adafdca7e8$export$d76128d007d19019(location) {
    return function() {
        return location.search;
    };
}
function $f8ebc5adafdca7e8$export$f96d8961b67fb6df(search) {
    return function(location) {
        return function() {
            location.search = search;
        };
    };
}
function $f8ebc5adafdca7e8$export$e6e34fd1f2686227(url) {
    return function(location) {
        return function() {
            location.assign(url);
        };
    };
}
function $f8ebc5adafdca7e8$export$77ad94ebf1c2b9ed(url) {
    return function(location) {
        return function() {
            location.replace(url);
        };
    };
}
function $f8ebc5adafdca7e8$export$32da5b5043dcd88c(location) {
    return function() {
        location.reload();
    };
}

});


parcelRegister("kTB0t", function(module, exports) {
// Generated by purs version 0.15.16

var $egxc5 = parcelRequire("egxc5");

});
parcelRegister("egxc5", function(module, exports) {
function $a62c4ef37c9a21b6$export$789c912f57fe164c(navigator) {
    return function() {
        return navigator.language;
    };
}
function $a62c4ef37c9a21b6$export$d0d68bb9ed2c643d(navigator) {
    return function() {
        return navigator.languages;
    };
}
function $a62c4ef37c9a21b6$export$c65ce66152f1cb9d(navigator) {
    return function() {
        return navigator.onLine;
    };
}
function $a62c4ef37c9a21b6$export$722a64dea1b767dc(navigator) {
    return function() {
        return navigator.platform;
    };
}
function $a62c4ef37c9a21b6$export$3dcce53a3755dc8c(navigator) {
    return function() {
        return navigator.userAgent;
    };
}

});


parcelRegister("9cmD3", function(module, exports) {

$parcel$export(module.exports, "toEventTarget", () => $6b26c9b0fa2d7b7a$export$55c9526d22b9f8e6);
$parcel$export(module.exports, "document", () => (parcelRequire("eC1jx")).document);
// Generated by purs version 0.15.16

var $eC1jx = parcelRequire("eC1jx");

var $l0wDR = parcelRequire("l0wDR");

var $T79xE = parcelRequire("T79xE");

var $d0PPW = parcelRequire("d0PPW");

var $9hRVP = parcelRequire("9hRVP");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");

var $6EJMX = parcelRequire("6EJMX");
var $6b26c9b0fa2d7b7a$var$map = /* #__PURE__ */ $l0wDR.map($9hRVP.functorEffect);
var $6b26c9b0fa2d7b7a$var$compare = /* #__PURE__ */ $d0PPW.compare($d0PPW.ordInt);
var $6b26c9b0fa2d7b7a$var$RequestIdleCallbackId = function(x) {
    return x;
};
var $6b26c9b0fa2d7b7a$var$RequestAnimationFrameId = function(x) {
    return x;
};
var $6b26c9b0fa2d7b7a$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $6b26c9b0fa2d7b7a$export$20682ad686515a40 = function(msg) {
    return function(defaultText) {
        return function(window) {
            return $6b26c9b0fa2d7b7a$var$map($T79xE.toMaybe)($eC1jx._prompt(msg)(defaultText)(window));
        };
    };
};
var $6b26c9b0fa2d7b7a$export$195ba6d62321b933 = function(msg) {
    return function(window) {
        return $6b26c9b0fa2d7b7a$var$map($T79xE.toMaybe)($eC1jx._prompt(msg)("")(window));
    };
};
var $6b26c9b0fa2d7b7a$export$1828d3c48a8aa004 = function(window) {
    return $6b26c9b0fa2d7b7a$var$map($T79xE.toMaybe)($eC1jx._opener(window));
};
var $6b26c9b0fa2d7b7a$export$3ce6949f20cea765 = function(url$prime) {
    return function(name) {
        return function(features) {
            return function(window) {
                return $6b26c9b0fa2d7b7a$var$map($T79xE.toMaybe)($eC1jx._open(url$prime)(name)(features)(window));
            };
        };
    };
};
var $6b26c9b0fa2d7b7a$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("Window");
var $6b26c9b0fa2d7b7a$export$5e61711963baf8b7 = {
    eq: function(x) {
        return function(y) {
            return x === y;
        };
    }
};
var $6b26c9b0fa2d7b7a$export$2a5c622a4a2ca36d = {
    compare: function(x) {
        return function(y) {
            return $6b26c9b0fa2d7b7a$var$compare(x)(y);
        };
    },
    Eq0: function() {
        return $6b26c9b0fa2d7b7a$export$5e61711963baf8b7;
    }
};
var $6b26c9b0fa2d7b7a$export$c27c49a6c01c4337 = {
    eq: function(x) {
        return function(y) {
            return x === y;
        };
    }
};
var $6b26c9b0fa2d7b7a$export$5ec63fa26beb11f3 = {
    compare: function(x) {
        return function(y) {
            return $6b26c9b0fa2d7b7a$var$compare(x)(y);
        };
    },
    Eq0: function() {
        return $6b26c9b0fa2d7b7a$export$c27c49a6c01c4337;
    }
};

});
parcelRegister("eC1jx", function(module, exports) {

$parcel$export(module.exports, "document", () => $aa35a24624ec08d2$export$5a7bfc01df82fcd1);
$parcel$export(module.exports, "_open", () => $aa35a24624ec08d2$export$f4b9acba9659afe8);
$parcel$export(module.exports, "_prompt", () => $aa35a24624ec08d2$export$ce783d49a08713a7);
$parcel$export(module.exports, "_opener", () => $aa35a24624ec08d2$export$b161e74f44e020b9);
function $aa35a24624ec08d2$export$5a7bfc01df82fcd1(window) {
    return function() {
        return window.document;
    };
}
function $aa35a24624ec08d2$export$ec7c8efa7f5790ae(window) {
    return function() {
        return window.navigator;
    };
}
function $aa35a24624ec08d2$export$17b07c660794dc13(window) {
    return function() {
        return window.location;
    };
}
function $aa35a24624ec08d2$export$55abd4691b317664(window) {
    return function() {
        return window.history;
    };
}
function $aa35a24624ec08d2$export$d23fbaf1a2e7133c(window) {
    return function() {
        return window.innerWidth;
    };
}
function $aa35a24624ec08d2$export$d3ad305c42af1069(window) {
    return function() {
        return window.innerHeight;
    };
}
function $aa35a24624ec08d2$export$5ea928c9faf85bd3(str) {
    return function(window) {
        return function() {
            window.alert(str);
        };
    };
}
function $aa35a24624ec08d2$export$715f9d76bb8c1fea(str) {
    return function(window) {
        return function() {
            return window.confirm(str);
        };
    };
}
function $aa35a24624ec08d2$export$7290db243fe4f181(xDelta) {
    return function(yDelta) {
        return function(window) {
            return function() {
                window.moveBy(xDelta, yDelta);
            };
        };
    };
}
function $aa35a24624ec08d2$export$75f1ccd6dc32e80a(width) {
    return function(height) {
        return function(window) {
            return function() {
                window.moveTo(width, height);
            };
        };
    };
}
function $aa35a24624ec08d2$export$f4b9acba9659afe8(url) {
    return function(name) {
        return function(features) {
            return function(window) {
                return function() {
                    return window.open(url, name, features);
                };
            };
        };
    };
}
function $aa35a24624ec08d2$export$8360e631d277ea4d(window) {
    return function() {
        return window.close();
    };
}
function $aa35a24624ec08d2$export$fc5b8aac72846d1e(window) {
    return function() {
        return window.outerHeight;
    };
}
function $aa35a24624ec08d2$export$e823f88e4111159a(window) {
    return function() {
        return window.outerWidth;
    };
}
function $aa35a24624ec08d2$export$c2d084dc44961371(window) {
    return function() {
        window.print();
    };
}
function $aa35a24624ec08d2$export$ce783d49a08713a7(str) {
    return function(defaultText) {
        return function(window) {
            return function() {
                return window.prompt(str, defaultText);
            };
        };
    };
}
function $aa35a24624ec08d2$export$5f72b7db69802ea0(xDelta) {
    return function(yDelta) {
        return function(window) {
            return function() {
                window.resizeBy(xDelta, yDelta);
            };
        };
    };
}
function $aa35a24624ec08d2$export$663d9c149a16f84d(width) {
    return function(height) {
        return function(window) {
            return function() {
                window.resizeTo(width, height);
            };
        };
    };
}
function $aa35a24624ec08d2$export$daeacaab2dbcebdc(window) {
    return function() {
        return window.screenX;
    };
}
function $aa35a24624ec08d2$export$51b695a8750464db(window) {
    return function() {
        return window.screenY;
    };
}
function $aa35a24624ec08d2$export$209876d7b1ac8f3(xCoord) {
    return function(yCoord) {
        return function(window) {
            return function() {
                window.scroll(xCoord, yCoord);
            };
        };
    };
}
function $aa35a24624ec08d2$export$19a39865fecdb343(xCoord) {
    return function(yCoord) {
        return function(window) {
            return function() {
                window.scrollBy(xCoord, yCoord);
            };
        };
    };
}
function $aa35a24624ec08d2$export$5320ec237fcf13b2(window) {
    return function() {
        return window.scrollX;
    };
}
function $aa35a24624ec08d2$export$2dd824eca41ca48d(window) {
    return function() {
        return window.scrollY;
    };
}
function $aa35a24624ec08d2$export$c2ed3351cac403d1(window) {
    return function() {
        return window.localStorage;
    };
}
function $aa35a24624ec08d2$export$f119d83aa936d634(window) {
    return function() {
        return window.sessionStorage;
    };
}
function $aa35a24624ec08d2$export$6cb2c4c0a22909c0(fn) {
    return function(window) {
        return function() {
            return window.requestAnimationFrame(fn);
        };
    };
}
function $aa35a24624ec08d2$export$e00521de187a817a(id) {
    return function(window) {
        return function() {
            return window.cancelAnimationFrame(id);
        };
    };
}
function $aa35a24624ec08d2$export$9288a5d956b3efbe(opts) {
    return function(fn) {
        return function(window) {
            return function() {
                return window.requestIdleCallback(fn, opts);
            };
        };
    };
}
function $aa35a24624ec08d2$export$bf0a62c3939e5933(id) {
    return function(window) {
        return function() {
            return window.cancelIdleCallback(id);
        };
    };
}
function $aa35a24624ec08d2$export$91124bb58bc04465(window) {
    return function() {
        return window.parent;
    };
}
function $aa35a24624ec08d2$export$b161e74f44e020b9(window) {
    return function() {
        return window.opener;
    };
}

});




parcelRegister("b3Gyo", function(module, exports) {

$parcel$export(module.exports, "runUI", () => $80d0fbcfdca571e1$export$32d31a833a940d1c);
// Generated by purs version 0.15.16

var $gUTA8 = parcelRequire("gUTA8");

var $9Grh5 = parcelRequire("9Grh5");

var $7T8P4 = parcelRequire("7T8P4");

var $6RkEA = parcelRequire("6RkEA");

var $l0wDR = parcelRequire("l0wDR");

var $lnl7Y = parcelRequire("lnl7Y");

var $ykHdR = parcelRequire("ykHdR");

var $6PW1p = parcelRequire("6PW1p");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");

var $9hRVP = parcelRequire("9hRVP");

var $kqxtr = parcelRequire("kqxtr");

var $kQlZ1 = parcelRequire("kQlZ1");

var $cnyA5 = parcelRequire("cnyA5");
var $jFEU8 = parcelRequire("jFEU8");

var $kZ0gj = parcelRequire("kZ0gj");

var $kzfBX = parcelRequire("kzfBX");

var $kugLX = parcelRequire("kugLX");

var $akkXi = parcelRequire("akkXi");

var $lrGyk = parcelRequire("lrGyk");

var $69gPG = parcelRequire("69gPG");

var $kKOpj = parcelRequire("kKOpj");

var $bBd0x = parcelRequire("bBd0x");
parcelRequire("5Pc7Y");
var $dpyXb = parcelRequire("dpyXb");
var $5Pc7Y = parcelRequire("5Pc7Y");
parcelRequire("gUeXR");
var $3gl8k = parcelRequire("3gl8k");

var $lbDmF = parcelRequire("lbDmF");

var $7NSrV = parcelRequire("7NSrV");
parcelRequire("9cmD3");
var $eC1jx = parcelRequire("eC1jx");
var $80d0fbcfdca571e1$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $80d0fbcfdca571e1$var$$$void = /* #__PURE__ */ $l0wDR.void($9hRVP.functorEffect);
var $80d0fbcfdca571e1$var$pure = /* #__PURE__ */ $gUTA8.pure($9hRVP.applicativeEffect);
var $80d0fbcfdca571e1$var$traverse_ = /* #__PURE__ */ $6RkEA.traverse_($9hRVP.applicativeEffect)($6RkEA.foldableMaybe);
var $80d0fbcfdca571e1$var$unwrap = /* #__PURE__ */ $6PW1p.unwrap();
var $80d0fbcfdca571e1$var$when = /* #__PURE__ */ $gUTA8.when($9hRVP.applicativeEffect);
var $80d0fbcfdca571e1$var$not = /* #__PURE__ */ $lnl7Y.not(/* #__PURE__ */ $lnl7Y.heytingAlgebraFunction(/* #__PURE__ */ $lnl7Y.heytingAlgebraFunction($lnl7Y.heytingAlgebraBoolean)));
var $80d0fbcfdca571e1$var$identity = /* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn);
var $80d0fbcfdca571e1$var$bind1 = /* #__PURE__ */ $9Grh5.bind($kqxtr.bindAff);
var $80d0fbcfdca571e1$var$liftEffect = /* #__PURE__ */ $kQlZ1.liftEffect($kqxtr.monadEffectAff);
var $80d0fbcfdca571e1$var$map = /* #__PURE__ */ $l0wDR.map($9hRVP.functorEffect);
var $80d0fbcfdca571e1$var$bindFlipped = /* #__PURE__ */ $9Grh5.bindFlipped($9hRVP.bindEffect);
var $80d0fbcfdca571e1$var$RenderState = function(x) {
    return x;
};
var $80d0fbcfdca571e1$var$substInParent = function(v) {
    return function(v1) {
        return function(v2) {
            if (v1 instanceof $ykHdR.Just && v2 instanceof $ykHdR.Just) return $80d0fbcfdca571e1$var$$$void($dpyXb.insertBefore(v)(v1.value0)(v2.value0));
            if (v1 instanceof $ykHdR.Nothing && v2 instanceof $ykHdR.Just) return $80d0fbcfdca571e1$var$$$void($dpyXb.appendChild(v)(v2.value0));
            return $80d0fbcfdca571e1$var$pure($r2HHk.unit);
        };
    };
};
var $80d0fbcfdca571e1$var$removeChild = function(v) {
    return function __do() {
        var npn = $5Pc7Y.parentNode(v.node)();
        return $80d0fbcfdca571e1$var$traverse_(function(pn) {
            return $dpyXb.removeChild(v.node)(pn);
        })(npn)();
    };
};
var $80d0fbcfdca571e1$var$mkSpec = function(handler) {
    return function(renderChildRef) {
        return function(document) {
            var getNode = $kzfBX.unRenderStateX(function(v) {
                return v.node;
            });
            var done = function(st) {
                if (st instanceof $ykHdR.Just) return $69gPG.halt(st.value0);
                return $r2HHk.unit;
            };
            var buildWidget = function(spec) {
                var buildThunk = $kKOpj.buildThunk($80d0fbcfdca571e1$var$unwrap)(spec);
                var $lazy_patch = $80d0fbcfdca571e1$var$$runtime_lazy("patch", "Halogen.VDom.Driver", function() {
                    return function(st, slot) {
                        if (st instanceof $ykHdR.Just) {
                            if (slot instanceof $kugLX.ComponentSlot) {
                                $69gPG.halt(st.value0);
                                return $lazy_renderComponentSlot(100)(slot.value0);
                            }
                            if (slot instanceof $kugLX.ThunkSlot) {
                                var step$prime = $69gPG.step(st.value0, slot.value0);
                                return $69gPG.mkStep(new $69gPG.Step($69gPG.extract(step$prime), new $ykHdR.Just(step$prime), $lazy_patch(103), done));
                            }
                            throw new Error("Failed pattern match at Halogen.VDom.Driver (line 97, column 22 - line 103, column 79): " + [
                                slot.constructor.name
                            ]);
                        }
                        return $lazy_render(104)(slot);
                    };
                });
                var $lazy_render = $80d0fbcfdca571e1$var$$runtime_lazy("render", "Halogen.VDom.Driver", function() {
                    return function(slot) {
                        if (slot instanceof $kugLX.ComponentSlot) return $lazy_renderComponentSlot(86)(slot.value0);
                        if (slot instanceof $kugLX.ThunkSlot) {
                            var step = buildThunk(slot.value0);
                            return $69gPG.mkStep(new $69gPG.Step($69gPG.extract(step), new $ykHdR.Just(step), $lazy_patch(89), done));
                        }
                        throw new Error("Failed pattern match at Halogen.VDom.Driver (line 84, column 7 - line 89, column 75): " + [
                            slot.constructor.name
                        ]);
                    };
                });
                var $lazy_renderComponentSlot = $80d0fbcfdca571e1$var$$runtime_lazy("renderComponentSlot", "Halogen.VDom.Driver", function() {
                    return function(cs) {
                        var renderChild = $jFEU8.read(renderChildRef)();
                        var rsx = renderChild(cs)();
                        var node = getNode(rsx);
                        return $69gPG.mkStep(new $69gPG.Step(node, $ykHdR.Nothing.value, $lazy_patch(117), done));
                    };
                });
                var patch = $lazy_patch(91);
                var render = $lazy_render(82);
                var renderComponentSlot = $lazy_renderComponentSlot(109);
                return render;
            };
            var buildAttributes = $lrGyk.buildProp(handler);
            return {
                buildWidget: buildWidget,
                buildAttributes: buildAttributes,
                document: document
            };
        };
    };
};
var $80d0fbcfdca571e1$var$renderSpec = function(document) {
    return function(container) {
        var render = function(handler) {
            return function(child) {
                return function(v) {
                    return function(v1) {
                        if (v1 instanceof $ykHdR.Nothing) return function __do() {
                            var renderChildRef = $cnyA5.new(child)();
                            var spec = $80d0fbcfdca571e1$var$mkSpec(handler)(renderChildRef)(document);
                            var machine = $akkXi.buildVDom(spec)(v);
                            var node = $69gPG.extract(machine);
                            $80d0fbcfdca571e1$var$$$void($dpyXb.appendChild(node)($7NSrV.toNode(container)))();
                            return {
                                machine: machine,
                                node: node,
                                renderChildRef: renderChildRef
                            };
                        };
                        if (v1 instanceof $ykHdR.Just) return function __do() {
                            $jFEU8.write(child)(v1.value0.renderChildRef)();
                            var parent = $5Pc7Y.parentNode(v1.value0.node)();
                            var nextSib = $5Pc7Y.nextSibling(v1.value0.node)();
                            var machine$prime = $69gPG.step(v1.value0.machine, v);
                            var newNode = $69gPG.extract(machine$prime);
                            $80d0fbcfdca571e1$var$when($80d0fbcfdca571e1$var$not($bBd0x.unsafeRefEq)(v1.value0.node)(newNode))($80d0fbcfdca571e1$var$substInParent(newNode)(nextSib)(parent))();
                            return {
                                machine: machine$prime,
                                node: newNode,
                                renderChildRef: v1.value0.renderChildRef
                            };
                        };
                        throw new Error("Failed pattern match at Halogen.VDom.Driver (line 157, column 5 - line 173, column 80): " + [
                            v1.constructor.name
                        ]);
                    };
                };
            };
        };
        return {
            render: render,
            renderChild: $80d0fbcfdca571e1$var$identity,
            removeChild: $80d0fbcfdca571e1$var$removeChild,
            dispose: $80d0fbcfdca571e1$var$removeChild
        };
    };
};
var $80d0fbcfdca571e1$export$32d31a833a940d1c = function(component) {
    return function(i) {
        return function(element) {
            return $80d0fbcfdca571e1$var$bind1($80d0fbcfdca571e1$var$liftEffect($80d0fbcfdca571e1$var$map($lbDmF.toDocument)($80d0fbcfdca571e1$var$bindFlipped($eC1jx.document)($3gl8k.window))))(function(document) {
                return $kZ0gj.runUI($80d0fbcfdca571e1$var$renderSpec(document)(element))(component)(i);
            });
        };
    };
};

});
parcelRegister("kZ0gj", function(module, exports) {

$parcel$export(module.exports, "runUI", () => $f469b52d7c3c8200$export$32d31a833a940d1c);
// Generated by purs version 0.15.16

var $gUTA8 = parcelRequire("gUTA8");

var $9Grh5 = parcelRequire("9Grh5");

var $5dx6Q = parcelRequire("5dx6Q");

var $lowBm = parcelRequire("lowBm");

var $4A3Wv = parcelRequire("4A3Wv");

var $6RkEA = parcelRequire("6RkEA");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");

var $5gmr2 = parcelRequire("5gmr2");

var $amUgg = parcelRequire("amUgg");

var $k6SBa = parcelRequire("k6SBa");

var $ykHdR = parcelRequire("ykHdR");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");

var $9hRVP = parcelRequire("9hRVP");

var $kqxtr = parcelRequire("kqxtr");

var $kQlZ1 = parcelRequire("kQlZ1");
parcelRequire("ajVG6");
var $cGCmj = parcelRequire("cGCmj");
parcelRequire("6ITWO");
var $eROd4 = parcelRequire("eROd4");
var $6ITWO = parcelRequire("6ITWO");

var $cnyA5 = parcelRequire("cnyA5");
var $jFEU8 = parcelRequire("jFEU8");
parcelRequire("bwyyL");

var $9gMhV = parcelRequire("9gMhV");

var $kzfBX = parcelRequire("kzfBX");

var $kugLX = parcelRequire("kugLX");

var $1j54f = parcelRequire("1j54f");

var $5OEb5 = parcelRequire("5OEb5");

var $cVGsR = parcelRequire("cVGsR");

var $bhj9Z = parcelRequire("bhj9Z");
var $f469b52d7c3c8200$var$bind = /* #__PURE__ */ $9Grh5.bind($9hRVP.bindEffect);
var $f469b52d7c3c8200$var$discard = /* #__PURE__ */ $9Grh5.discard($9Grh5.discardUnit);
var $f469b52d7c3c8200$var$for_ = /* #__PURE__ */ $6RkEA.for_($9hRVP.applicativeEffect)($6RkEA.foldableMaybe);
var $f469b52d7c3c8200$var$traverse_ = /* #__PURE__ */ $6RkEA.traverse_($kqxtr.applicativeAff)($amUgg.foldableList);
var $f469b52d7c3c8200$var$fork = /* #__PURE__ */ $5dx6Q.fork($5dx6Q.monadForkAff);
var $f469b52d7c3c8200$var$bindFlipped = /* #__PURE__ */ $9Grh5.bindFlipped($9hRVP.bindEffect);
var $f469b52d7c3c8200$var$traverse_1 = /* #__PURE__ */ $6RkEA.traverse_($9hRVP.applicativeEffect);
var $f469b52d7c3c8200$var$traverse_2 = /* #__PURE__ */ $f469b52d7c3c8200$var$traverse_1($6RkEA.foldableMaybe);
var $f469b52d7c3c8200$var$traverse_3 = /* #__PURE__ */ $f469b52d7c3c8200$var$traverse_1($k6SBa.foldableMap);
var $f469b52d7c3c8200$var$discard2 = /* #__PURE__ */ $f469b52d7c3c8200$var$discard($kqxtr.bindAff);
var $f469b52d7c3c8200$var$parSequence_ = /* #__PURE__ */ $4A3Wv.parSequence_($kqxtr.parallelAff)($kqxtr.applicativeParAff)($amUgg.foldableList);
var $f469b52d7c3c8200$var$liftEffect = /* #__PURE__ */ $kQlZ1.liftEffect($kqxtr.monadEffectAff);
var $f469b52d7c3c8200$var$pure = /* #__PURE__ */ $gUTA8.pure($9hRVP.applicativeEffect);
var $f469b52d7c3c8200$var$map = /* #__PURE__ */ $l0wDR.map($9hRVP.functorEffect);
var $f469b52d7c3c8200$var$pure1 = /* #__PURE__ */ $gUTA8.pure($kqxtr.applicativeAff);
var $f469b52d7c3c8200$var$when = /* #__PURE__ */ $gUTA8.when($9hRVP.applicativeEffect);
var $f469b52d7c3c8200$var$renderStateX = /* #__PURE__ */ $kzfBX.renderStateX($9hRVP.functorEffect);
var $f469b52d7c3c8200$var$$$void = /* #__PURE__ */ $l0wDR.void($kqxtr.functorAff);
var $f469b52d7c3c8200$var$foreachSlot = /* #__PURE__ */ $1j54f.foreachSlot($9hRVP.applicativeEffect);
var $f469b52d7c3c8200$var$renderStateX_ = /* #__PURE__ */ $kzfBX.renderStateX_($9hRVP.applicativeEffect);
var $f469b52d7c3c8200$var$tailRecM = /* #__PURE__ */ $lowBm.tailRecM($lowBm.monadRecEffect);
var $f469b52d7c3c8200$var$voidLeft = /* #__PURE__ */ $l0wDR.voidLeft($9hRVP.functorEffect);
var $f469b52d7c3c8200$var$bind1 = /* #__PURE__ */ $9Grh5.bind($kqxtr.bindAff);
var $f469b52d7c3c8200$var$liftEffect1 = /* #__PURE__ */ $kQlZ1.liftEffect($kQlZ1.monadEffectEffect);
var $f469b52d7c3c8200$var$newLifecycleHandlers = /* #__PURE__ */ function() {
    return $cnyA5.new({
        initializers: $amUgg.Nil.value,
        finalizers: $amUgg.Nil.value
    });
}();
var $f469b52d7c3c8200$var$handlePending = function(ref) {
    return function __do() {
        var queue = $jFEU8.read(ref)();
        $jFEU8.write($ykHdR.Nothing.value)(ref)();
        return $f469b52d7c3c8200$var$for_(queue)(function() {
            var $59 = $f469b52d7c3c8200$var$traverse_($f469b52d7c3c8200$var$fork);
            return function($60) {
                return $9gMhV.handleAff($59($5gmr2.reverse($60)));
            };
        }())();
    };
};
var $f469b52d7c3c8200$var$cleanupSubscriptionsAndForks = function(v) {
    return function __do() {
        $f469b52d7c3c8200$var$bindFlipped($f469b52d7c3c8200$var$traverse_2($f469b52d7c3c8200$var$traverse_3($bhj9Z.unsubscribe)))($jFEU8.read(v.subscriptions))();
        $jFEU8.write($ykHdR.Nothing.value)(v.subscriptions)();
        $f469b52d7c3c8200$var$bindFlipped($f469b52d7c3c8200$var$traverse_3(function() {
            var $61 = $kqxtr.killFiber($eROd4.error("finalized"));
            return function($62) {
                return $9gMhV.handleAff($61($62));
            };
        }()))($jFEU8.read(v.forks))();
        return $jFEU8.write($k6SBa.empty)(v.forks)();
    };
};
var $f469b52d7c3c8200$export$32d31a833a940d1c = function(renderSpec) {
    return function(component) {
        return function(i) {
            var squashChildInitializers = function(lchs) {
                return function(preInits) {
                    return $kzfBX.unDriverStateX(function(st) {
                        var parentInitializer = $9gMhV.evalM(render)(st.selfRef)(st["component"]["eval"](new $5OEb5.Initialize($r2HHk.unit)));
                        return $cnyA5.modify_(function(handlers) {
                            return {
                                initializers: new $amUgg.Cons($f469b52d7c3c8200$var$discard2($f469b52d7c3c8200$var$parSequence_($5gmr2.reverse(handlers.initializers)))(function() {
                                    return $f469b52d7c3c8200$var$discard2(parentInitializer)(function() {
                                        return $f469b52d7c3c8200$var$liftEffect(function __do() {
                                            $f469b52d7c3c8200$var$handlePending(st.pendingQueries)();
                                            return $f469b52d7c3c8200$var$handlePending(st.pendingOuts)();
                                        });
                                    });
                                }), preInits),
                                finalizers: handlers.finalizers
                            };
                        })(lchs);
                    });
                };
            };
            var runComponent = function(lchs) {
                return function(handler) {
                    return function(j) {
                        return $kugLX.unComponent(function(c) {
                            return function __do() {
                                var lchs$prime = $f469b52d7c3c8200$var$newLifecycleHandlers();
                                var $$var = $kzfBX.initDriverState(c)(j)(handler)(lchs$prime)();
                                var pre = $jFEU8.read(lchs)();
                                $jFEU8.write({
                                    initializers: $amUgg.Nil.value,
                                    finalizers: pre.finalizers
                                })(lchs)();
                                $f469b52d7c3c8200$var$bindFlipped($kzfBX.unDriverStateX(function() {
                                    var $63 = render(lchs);
                                    return function($64) {
                                        return $63(function(v) {
                                            return v.selfRef;
                                        }($64));
                                    };
                                }()))($jFEU8.read($$var))();
                                $f469b52d7c3c8200$var$bindFlipped(squashChildInitializers(lchs)(pre.initializers))($jFEU8.read($$var))();
                                return $$var;
                            };
                        });
                    };
                };
            };
            var renderChild = function(lchs) {
                return function(handler) {
                    return function(childrenInRef) {
                        return function(childrenOutRef) {
                            return $kugLX.unComponentSlot(function(slot) {
                                return function __do() {
                                    var childrenIn = $f469b52d7c3c8200$var$map(slot.pop)($jFEU8.read(childrenInRef))();
                                    var $$var = function() {
                                        if (childrenIn instanceof $ykHdR.Just) {
                                            $jFEU8.write(childrenIn.value0.value1)(childrenInRef)();
                                            var dsx = $jFEU8.read(childrenIn.value0.value0)();
                                            $kzfBX.unDriverStateX(function(st) {
                                                return function __do() {
                                                    $l4M7e.flip($jFEU8.write)(st.handlerRef)(function() {
                                                        var $65 = $ykHdR.maybe($f469b52d7c3c8200$var$pure1($r2HHk.unit))(handler);
                                                        return function($66) {
                                                            return $65(slot.output($66));
                                                        };
                                                    }())();
                                                    return $9gMhV.handleAff($9gMhV.evalM(render)(st.selfRef)(st["component"]["eval"](new $5OEb5.Receive(slot.input, $r2HHk.unit))))();
                                                };
                                            })(dsx)();
                                            return childrenIn.value0.value0;
                                        }
                                        if (childrenIn instanceof $ykHdR.Nothing) return runComponent(lchs)(function() {
                                            var $67 = $ykHdR.maybe($f469b52d7c3c8200$var$pure1($r2HHk.unit))(handler);
                                            return function($68) {
                                                return $67(slot.output($68));
                                            };
                                        }())(slot.input)(slot.component)();
                                        throw new Error("Failed pattern match at Halogen.Aff.Driver (line 213, column 14 - line 222, column 98): " + [
                                            childrenIn.constructor.name
                                        ]);
                                    }();
                                    var isDuplicate = $f469b52d7c3c8200$var$map(function($69) {
                                        return $ykHdR.isJust(slot.get($69));
                                    })($jFEU8.read(childrenOutRef))();
                                    $f469b52d7c3c8200$var$when(isDuplicate)($cGCmj.warn("Halogen: Duplicate slot address was detected during rendering, unexpected results may occur"))();
                                    $cnyA5.modify_(slot.set($$var))(childrenOutRef)();
                                    return $f469b52d7c3c8200$var$bind($jFEU8.read($$var))($f469b52d7c3c8200$var$renderStateX(function(v) {
                                        if (v instanceof $ykHdR.Nothing) return $6ITWO.throw("Halogen internal error: child was not initialized in renderChild");
                                        if (v instanceof $ykHdR.Just) return $f469b52d7c3c8200$var$pure(renderSpec.renderChild(v.value0));
                                        throw new Error("Failed pattern match at Halogen.Aff.Driver (line 227, column 37 - line 229, column 50): " + [
                                            v.constructor.name
                                        ]);
                                    }))();
                                };
                            });
                        };
                    };
                };
            };
            var render = function(lchs) {
                return function($$var) {
                    return function __do() {
                        var v = $jFEU8.read($$var)();
                        var shouldProcessHandlers = $f469b52d7c3c8200$var$map($ykHdR.isNothing)($jFEU8.read(v.pendingHandlers))();
                        $f469b52d7c3c8200$var$when(shouldProcessHandlers)($jFEU8.write(new $ykHdR.Just($amUgg.Nil.value))(v.pendingHandlers))();
                        $jFEU8.write($1j54f.empty)(v.childrenOut)();
                        $jFEU8.write(v.children)(v.childrenIn)();
                        var handler = function() {
                            var $70 = $9gMhV.queueOrRun(v.pendingHandlers);
                            var $71 = $9gMhV.evalF(render)(v.selfRef);
                            return function($72) {
                                return $70($f469b52d7c3c8200$var$$$void($71($72)));
                            };
                        }();
                        var childHandler = function() {
                            var $73 = $9gMhV.queueOrRun(v.pendingQueries);
                            return function($74) {
                                return $73(handler($cVGsR.Action.create($74)));
                            };
                        }();
                        var rendering = renderSpec.render(function($75) {
                            return $9gMhV.handleAff(handler($75));
                        })(renderChild(lchs)(childHandler)(v.childrenIn)(v.childrenOut))(v.component.render(v.state))(v.rendering)();
                        var children = $jFEU8.read(v.childrenOut)();
                        var childrenIn = $jFEU8.read(v.childrenIn)();
                        $f469b52d7c3c8200$var$foreachSlot(childrenIn)(function(v1) {
                            return function __do() {
                                var childDS = $jFEU8.read(v1)();
                                $f469b52d7c3c8200$var$renderStateX_(renderSpec.removeChild)(childDS)();
                                return finalize(lchs)(childDS)();
                            };
                        })();
                        $l4M7e.flip($cnyA5.modify_)(v.selfRef)($kzfBX.mapDriverState(function(ds$prime) {
                            return {
                                component: ds$prime.component,
                                state: ds$prime.state,
                                refs: ds$prime.refs,
                                childrenIn: ds$prime.childrenIn,
                                childrenOut: ds$prime.childrenOut,
                                selfRef: ds$prime.selfRef,
                                handlerRef: ds$prime.handlerRef,
                                pendingQueries: ds$prime.pendingQueries,
                                pendingOuts: ds$prime.pendingOuts,
                                pendingHandlers: ds$prime.pendingHandlers,
                                fresh: ds$prime.fresh,
                                subscriptions: ds$prime.subscriptions,
                                forks: ds$prime.forks,
                                lifecycleHandlers: ds$prime.lifecycleHandlers,
                                rendering: new $ykHdR.Just(rendering),
                                children: children
                            };
                        }))();
                        return $f469b52d7c3c8200$var$when(shouldProcessHandlers)($l4M7e.flip($f469b52d7c3c8200$var$tailRecM)($r2HHk.unit)(function(v1) {
                            return function __do() {
                                var handlers = $jFEU8.read(v.pendingHandlers)();
                                $jFEU8.write(new $ykHdR.Just($amUgg.Nil.value))(v.pendingHandlers)();
                                $f469b52d7c3c8200$var$traverse_2(function() {
                                    var $76 = $f469b52d7c3c8200$var$traverse_($f469b52d7c3c8200$var$fork);
                                    return function($77) {
                                        return $9gMhV.handleAff($76($5gmr2.reverse($77)));
                                    };
                                }())(handlers)();
                                var mmore = $jFEU8.read(v.pendingHandlers)();
                                var $52 = $ykHdR.maybe(false)($5gmr2.null)(mmore);
                                if ($52) return $f469b52d7c3c8200$var$voidLeft($jFEU8.write($ykHdR.Nothing.value)(v.pendingHandlers))(new $lowBm.Done($r2HHk.unit))();
                                return new $lowBm.Loop($r2HHk.unit);
                            };
                        }))();
                    };
                };
            };
            var finalize = function(lchs) {
                return $kzfBX.unDriverStateX(function(st) {
                    return function __do() {
                        $f469b52d7c3c8200$var$cleanupSubscriptionsAndForks(st)();
                        var f = $9gMhV.evalM(render)(st.selfRef)(st["component"]["eval"](new $5OEb5.Finalize($r2HHk.unit)));
                        $cnyA5.modify_(function(handlers) {
                            return {
                                initializers: handlers.initializers,
                                finalizers: new $amUgg.Cons(f, handlers.finalizers)
                            };
                        })(lchs)();
                        return $f469b52d7c3c8200$var$foreachSlot(st.children)(function(v) {
                            return function __do() {
                                var dsx = $jFEU8.read(v)();
                                return finalize(lchs)(dsx)();
                            };
                        })();
                    };
                });
            };
            var evalDriver = function(disposed) {
                return function(ref) {
                    return function(q) {
                        return $f469b52d7c3c8200$var$bind1($f469b52d7c3c8200$var$liftEffect($jFEU8.read(disposed)))(function(v) {
                            if (v) return $f469b52d7c3c8200$var$pure1($ykHdR.Nothing.value);
                            return $9gMhV.evalQ(render)(ref)(q);
                        });
                    };
                };
            };
            var dispose = function(disposed) {
                return function(lchs) {
                    return function(dsx) {
                        return $9gMhV.handleLifecycle(lchs)(function __do() {
                            var v = $jFEU8.read(disposed)();
                            if (v) return $r2HHk.unit;
                            $jFEU8.write(true)(disposed)();
                            finalize(lchs)(dsx)();
                            return $kzfBX.unDriverStateX(function(v1) {
                                return function __do() {
                                    var v2 = $f469b52d7c3c8200$var$liftEffect1($jFEU8.read(v1.selfRef))();
                                    return $f469b52d7c3c8200$var$for_(v2.rendering)(renderSpec.dispose)();
                                };
                            })(dsx)();
                        });
                    };
                };
            };
            return $f469b52d7c3c8200$var$bind1($f469b52d7c3c8200$var$liftEffect($f469b52d7c3c8200$var$newLifecycleHandlers))(function(lchs) {
                return $f469b52d7c3c8200$var$bind1($f469b52d7c3c8200$var$liftEffect($cnyA5.new(false)))(function(disposed) {
                    return $9gMhV.handleLifecycle(lchs)(function __do() {
                        var sio = $bhj9Z.create();
                        var dsx = $f469b52d7c3c8200$var$bindFlipped($jFEU8.read)(runComponent(lchs)(function() {
                            var $78 = $bhj9Z.notify(sio.listener);
                            return function($79) {
                                return $f469b52d7c3c8200$var$liftEffect($78($79));
                            };
                        }())(i)(component))();
                        return $kzfBX.unDriverStateX(function(st) {
                            return $f469b52d7c3c8200$var$pure({
                                query: evalDriver(disposed)(st.selfRef),
                                messages: sio.emitter,
                                dispose: dispose(disposed)(lchs)(dsx)
                            });
                        })(dsx)();
                    });
                });
            });
        };
    };
};

});
parcelRegister("5dx6Q", function(module, exports) {

$parcel$export(module.exports, "monadForkAff", () => $3cc7d978c1d7ea03$export$353ec5b900391c5);
$parcel$export(module.exports, "fork", () => $3cc7d978c1d7ea03$export$7a5058c6b79333e0);
// Generated by purs version 0.15.16

var $bnrVm = parcelRequire("bnrVm");

var $4PFx6 = parcelRequire("4PFx6");

var $kqxtr = parcelRequire("kqxtr");
var $fkeSt = parcelRequire("fkeSt");
var $3cc7d978c1d7ea03$var$lift = /* #__PURE__ */ $4PFx6.lift($bnrVm.monadTransReaderT);
var $3cc7d978c1d7ea03$export$d2a72f000c4be67b = /* #__PURE__ */ function() {
    function Completed(value0) {
        this.value0 = value0;
    }
    Completed.create = function(value0) {
        return new Completed(value0);
    };
    return Completed;
}();
var $3cc7d978c1d7ea03$export$91ae1e982b7b05d4 = /* #__PURE__ */ function() {
    function Failed(value0) {
        this.value0 = value0;
    }
    Failed.create = function(value0) {
        return new Failed(value0);
    };
    return Failed;
}();
var $3cc7d978c1d7ea03$export$bc0dd2ad24d78194 = /* #__PURE__ */ function() {
    function Killed(value0) {
        this.value0 = value0;
    }
    Killed.create = function(value0) {
        return new Killed(value0);
    };
    return Killed;
}();
var $3cc7d978c1d7ea03$export$bb8edd1f55ec0e96 = function(dict) {
    return dict.uninterruptible;
};
var $3cc7d978c1d7ea03$export$a1428c8f7ba796e8 = function(dict) {
    return dict.suspend;
};
var $3cc7d978c1d7ea03$export$b3e22bcfd64c1022 = function(dict) {
    return dict.never;
};
var $3cc7d978c1d7ea03$export$353ec5b900391c5 = {
    suspend: $kqxtr.suspendAff,
    fork: $kqxtr.forkAff,
    join: $kqxtr.joinFiber,
    Monad0: function() {
        return $kqxtr.monadAff;
    },
    Functor1: function() {
        return $kqxtr.functorFiber;
    }
};
var $3cc7d978c1d7ea03$export$283d19abc99a5706 = {
    kill: $kqxtr.killFiber,
    MonadFork0: function() {
        return $3cc7d978c1d7ea03$export$353ec5b900391c5;
    },
    MonadThrow1: function() {
        return $kqxtr.monadThrowAff;
    }
};
var $3cc7d978c1d7ea03$export$f2e13c7c49fc01aa = {
    bracket: function(acquire) {
        return function(release) {
            return function(run) {
                return $fkeSt.generalBracket(acquire)({
                    completed: function($44) {
                        return release($3cc7d978c1d7ea03$export$d2a72f000c4be67b.create($44));
                    },
                    failed: function($45) {
                        return release($3cc7d978c1d7ea03$export$91ae1e982b7b05d4.create($45));
                    },
                    killed: function($46) {
                        return release($3cc7d978c1d7ea03$export$bc0dd2ad24d78194.create($46));
                    }
                })(run);
            };
        };
    },
    uninterruptible: $kqxtr.invincible,
    never: $kqxtr.never,
    MonadKill0: function() {
        return $3cc7d978c1d7ea03$export$283d19abc99a5706;
    },
    MonadError1: function() {
        return $kqxtr.monadErrorAff;
    }
};
var $3cc7d978c1d7ea03$export$dfdb508572caf3d7 = function(dict) {
    return dict.kill;
};
var $3cc7d978c1d7ea03$export$f7e2c8231c57a8bd = function(dict) {
    return dict.join;
};
var $3cc7d978c1d7ea03$export$7a5058c6b79333e0 = function(dict) {
    return dict.fork;
};
var $3cc7d978c1d7ea03$export$21277a949ab1c87a = function(dictMonadFork) {
    var suspend1 = $3cc7d978c1d7ea03$export$a1428c8f7ba796e8(dictMonadFork);
    var fork1 = $3cc7d978c1d7ea03$export$7a5058c6b79333e0(dictMonadFork);
    var Monad0 = dictMonadFork.Monad0();
    var monadReaderT = $bnrVm.monadReaderT(Monad0);
    var Functor1 = dictMonadFork.Functor1();
    return {
        suspend: function(v) {
            return function($47) {
                return suspend1(v($47));
            };
        },
        fork: function(v) {
            return function($48) {
                return fork1(v($48));
            };
        },
        join: function() {
            var $49 = $3cc7d978c1d7ea03$var$lift(Monad0);
            var $50 = $3cc7d978c1d7ea03$export$f7e2c8231c57a8bd(dictMonadFork);
            return function($51) {
                return $49($50($51));
            };
        }(),
        Monad0: function() {
            return monadReaderT;
        },
        Functor1: function() {
            return Functor1;
        }
    };
};
var $3cc7d978c1d7ea03$export$b03c2ddf720364a4 = function(dictMonadKill) {
    var MonadThrow1 = dictMonadKill.MonadThrow1();
    var lift1 = $3cc7d978c1d7ea03$var$lift(MonadThrow1.Monad0());
    var kill1 = $3cc7d978c1d7ea03$export$dfdb508572caf3d7(dictMonadKill);
    var monadForkReaderT1 = $3cc7d978c1d7ea03$export$21277a949ab1c87a(dictMonadKill.MonadFork0());
    var monadThrowReaderT = $bnrVm.monadThrowReaderT(MonadThrow1);
    return {
        kill: function(e) {
            var $52 = kill1(e);
            return function($53) {
                return lift1($52($53));
            };
        },
        MonadFork0: function() {
            return monadForkReaderT1;
        },
        MonadThrow1: function() {
            return monadThrowReaderT;
        }
    };
};
var $3cc7d978c1d7ea03$export$df5598cc12b9c8c = function(dict) {
    return dict.bracket;
};
var $3cc7d978c1d7ea03$export$746d58fd4800e2fa = function(dictMonadBracket) {
    var bracket1 = $3cc7d978c1d7ea03$export$df5598cc12b9c8c(dictMonadBracket);
    var uninterruptible1 = $3cc7d978c1d7ea03$export$bb8edd1f55ec0e96(dictMonadBracket);
    var MonadError1 = dictMonadBracket.MonadError1();
    var monadKillReaderT1 = $3cc7d978c1d7ea03$export$b03c2ddf720364a4(dictMonadBracket.MonadKill0());
    var monadErrorReaderT = $bnrVm.monadErrorReaderT(MonadError1);
    return {
        bracket: function(v) {
            return function(release) {
                return function(run) {
                    return function(r) {
                        return bracket1(v(r))(function(c) {
                            return function(a) {
                                return $bnrVm.runReaderT(release(c)(a))(r);
                            };
                        })(function(a) {
                            return $bnrVm.runReaderT(run(a))(r);
                        });
                    };
                };
            };
        },
        uninterruptible: function(k) {
            return function(r) {
                return uninterruptible1($bnrVm.runReaderT(k)(r));
            };
        },
        never: $3cc7d978c1d7ea03$var$lift(MonadError1.MonadThrow0().Monad0())($3cc7d978c1d7ea03$export$b3e22bcfd64c1022(dictMonadBracket)),
        MonadKill0: function() {
            return monadKillReaderT1;
        },
        MonadError1: function() {
            return monadErrorReaderT;
        }
    };
};

});

parcelRegister("bwyyL", function(module, exports) {
// Generated by purs version 0.15.16
parcelRequire("9VGs1");
var $dc43y = parcelRequire("dc43y");

var $kugLX = parcelRequire("kugLX");
parcelRequire("1j54f");
parcelRequire("d8Pe6");
parcelRequire("hhMAk");
var $iBWyn = parcelRequire("iBWyn");
var $gorft = parcelRequire("gorft");

var $3x1EB = parcelRequire("3x1EB");
var $5OEb5 = parcelRequire("5OEb5");
var $cVGsR = parcelRequire("cVGsR");
var $kQAxW = parcelRequire("kQAxW");
var $bllhK = parcelRequire("bllhK");
var $4PFx6 = parcelRequire("4PFx6");
var $fHfnu = parcelRequire("fHfnu");
var $kQlZ1 = parcelRequire("kQlZ1");

});
parcelRegister("3x1EB", function(module, exports) {
// Generated by purs version 0.15.16

var $9Grh5 = parcelRequire("9Grh5");

var $7T8P4 = parcelRequire("7T8P4");

var $kQAxW = parcelRequire("kQAxW");

var $4PFx6 = parcelRequire("4PFx6");

var $l0wDR = parcelRequire("l0wDR");

var $ykHdR = parcelRequire("ykHdR");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");

var $fHfnu = parcelRequire("fHfnu");

var $kQlZ1 = parcelRequire("kQlZ1");

var $bllhK = parcelRequire("bllhK");

var $5OEb5 = parcelRequire("5OEb5");

var $cVGsR = parcelRequire("cVGsR");

var $7NSrV = parcelRequire("7NSrV");
var $2925bc950f7308d7$var$$$void = /* #__PURE__ */ $l0wDR.void($bllhK.functorHalogenM);
var $2925bc950f7308d7$var$queryAll = /* #__PURE__ */ $bllhK.queryAll();
var $2925bc950f7308d7$var$query = /* #__PURE__ */ $bllhK.query();
var $2925bc950f7308d7$var$identity = /* #__PURE__ */ $7T8P4.identity($7T8P4.categoryFn);
var $2925bc950f7308d7$var$bindFlipped = /* #__PURE__ */ $9Grh5.bindFlipped($ykHdR.bindMaybe);
var $2925bc950f7308d7$export$786cec95229c2a31 = function() {
    return function(dictIsSymbol) {
        var queryAll1 = $2925bc950f7308d7$var$queryAll(dictIsSymbol);
        return function(dictOrd) {
            var queryAll2 = queryAll1(dictOrd);
            return function(label) {
                return function(req) {
                    return $2925bc950f7308d7$var$$$void(queryAll2(label)(req($r2HHk.unit)));
                };
            };
        };
    };
};
var $2925bc950f7308d7$export$de3113ed932c61ab = function() {
    return function(dictIsSymbol) {
        var query1 = $2925bc950f7308d7$var$query(dictIsSymbol);
        return function(dictOrd) {
            var query2 = query1(dictOrd);
            return function(slot) {
                return function(label) {
                    return function(req) {
                        return $2925bc950f7308d7$var$$$void(query2(slot)(label)(req($r2HHk.unit)));
                    };
                };
            };
        };
    };
};
var $2925bc950f7308d7$export$57331aaf6e3ff74d = function() {
    return function(dictIsSymbol) {
        var queryAll1 = $2925bc950f7308d7$var$queryAll(dictIsSymbol);
        return function(dictOrd) {
            var queryAll2 = queryAll1(dictOrd);
            return function(label) {
                return function(req) {
                    return queryAll2(label)(req($2925bc950f7308d7$var$identity));
                };
            };
        };
    };
};
var $2925bc950f7308d7$export$b5fe3f66a567bec0 = function() {
    return function(dictIsSymbol) {
        var query1 = $2925bc950f7308d7$var$query(dictIsSymbol);
        return function(dictOrd) {
            var query2 = query1(dictOrd);
            return function(slot) {
                return function(label) {
                    return function(req) {
                        return query2(slot)(label)(req($2925bc950f7308d7$var$identity));
                    };
                };
            };
        };
    };
};
var $2925bc950f7308d7$export$a39c6a18d03be90d = function(act) {
    return act($r2HHk.unit);
};
var $2925bc950f7308d7$export$377703b067ff01a = function(req) {
    return req($2925bc950f7308d7$var$identity);
};
var $2925bc950f7308d7$export$bd6cf4e30aa8da47 = /* #__PURE__ */ function() {
    var $24 = $l0wDR.map($bllhK.functorHalogenM)(function(v) {
        return $2925bc950f7308d7$var$bindFlipped($7NSrV.fromElement)(v);
    });
    return function($25) {
        return $24($bllhK.getRef($25));
    };
}();

});


parcelRegister("9gMhV", function(module, exports) {

$parcel$export(module.exports, "queueOrRun", () => $6bfb10b11a80fc8b$export$2d912d1764c6009b);
$parcel$export(module.exports, "handleLifecycle", () => $6bfb10b11a80fc8b$export$b7a8cef929df0d3c);
$parcel$export(module.exports, "handleAff", () => $6bfb10b11a80fc8b$export$c4c41c035efd1fb3);
$parcel$export(module.exports, "evalQ", () => $6bfb10b11a80fc8b$export$f960635a4c7f8a61);
$parcel$export(module.exports, "evalM", () => $6bfb10b11a80fc8b$export$b505393bc8c03d39);
$parcel$export(module.exports, "evalF", () => $6bfb10b11a80fc8b$export$6533955444d826a5);
// Generated by purs version 0.15.16

var $gUTA8 = parcelRequire("gUTA8");

var $iVIp8 = parcelRequire("iVIp8");

var $9Grh5 = parcelRequire("9Grh5");

var $ibtPS = parcelRequire("ibtPS");

var $5dx6Q = parcelRequire("5dx6Q");

var $hV7d0 = parcelRequire("hV7d0");

var $4A3Wv = parcelRequire("4A3Wv");

var $bvHbv = parcelRequire("bvHbv");

var $6UHO6 = parcelRequire("6UHO6");

var $cYgrH = parcelRequire("cYgrH");

var $aKY4H = parcelRequire("aKY4H");

var $6RkEA = parcelRequire("6RkEA");

var $l4M7e = parcelRequire("l4M7e");

var $l0wDR = parcelRequire("l0wDR");

var $amUgg = parcelRequire("amUgg");

var $k6SBa = parcelRequire("k6SBa");

var $ykHdR = parcelRequire("ykHdR");

var $d0PPW = parcelRequire("d0PPW");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");

var $9hRVP = parcelRequire("9hRVP");

var $kqxtr = parcelRequire("kqxtr");

var $kQlZ1 = parcelRequire("kQlZ1");
parcelRequire("6ITWO");
var $eROd4 = parcelRequire("eROd4");

var $cnyA5 = parcelRequire("cnyA5");
var $jFEU8 = parcelRequire("jFEU8");

var $kzfBX = parcelRequire("kzfBX");

var $1nuum = parcelRequire("1nuum");

var $bllhK = parcelRequire("bllhK");

var $5OEb5 = parcelRequire("5OEb5");

var $cVGsR = parcelRequire("cVGsR");

var $bhj9Z = parcelRequire("bhj9Z");

var $bBd0x = parcelRequire("bBd0x");
var $6bfb10b11a80fc8b$var$traverse_ = /* #__PURE__ */ $6RkEA.traverse_($9hRVP.applicativeEffect)($6RkEA.foldableMaybe);
var $6bfb10b11a80fc8b$var$bindFlipped = /* #__PURE__ */ $9Grh5.bindFlipped($ykHdR.bindMaybe);
var $6bfb10b11a80fc8b$var$lookup = /* #__PURE__ */ $k6SBa.lookup($bllhK.ordSubscriptionId);
var $6bfb10b11a80fc8b$var$bind1 = /* #__PURE__ */ $9Grh5.bind($kqxtr.bindAff);
var $6bfb10b11a80fc8b$var$liftEffect = /* #__PURE__ */ $kQlZ1.liftEffect($kqxtr.monadEffectAff);
var $6bfb10b11a80fc8b$var$discard = /* #__PURE__ */ $9Grh5.discard($9Grh5.discardUnit);
var $6bfb10b11a80fc8b$var$discard1 = /* #__PURE__ */ $6bfb10b11a80fc8b$var$discard($kqxtr.bindAff);
var $6bfb10b11a80fc8b$var$traverse_1 = /* #__PURE__ */ $6RkEA.traverse_($kqxtr.applicativeAff);
var $6bfb10b11a80fc8b$var$traverse_2 = /* #__PURE__ */ $6bfb10b11a80fc8b$var$traverse_1($amUgg.foldableList);
var $6bfb10b11a80fc8b$var$fork = /* #__PURE__ */ $5dx6Q.fork($5dx6Q.monadForkAff);
var $6bfb10b11a80fc8b$var$parSequence_ = /* #__PURE__ */ $4A3Wv.parSequence_($kqxtr.parallelAff)($kqxtr.applicativeParAff)($amUgg.foldableList);
var $6bfb10b11a80fc8b$var$pure = /* #__PURE__ */ $gUTA8.pure($kqxtr.applicativeAff);
var $6bfb10b11a80fc8b$var$map = /* #__PURE__ */ $l0wDR.map($cYgrH.functorCoyoneda);
var $6bfb10b11a80fc8b$var$parallel = /* #__PURE__ */ $bvHbv.parallel($kqxtr.parallelAff);
var $6bfb10b11a80fc8b$var$map1 = /* #__PURE__ */ $l0wDR.map($kqxtr.functorAff);
var $6bfb10b11a80fc8b$var$sequential = /* #__PURE__ */ $bvHbv.sequential($kqxtr.parallelAff);
var $6bfb10b11a80fc8b$var$map2 = /* #__PURE__ */ $l0wDR.map($ykHdR.functorMaybe);
var $6bfb10b11a80fc8b$var$insert = /* #__PURE__ */ $k6SBa.insert($bllhK.ordSubscriptionId);
var $6bfb10b11a80fc8b$var$retractFreeAp = /* #__PURE__ */ $iVIp8.retractFreeAp($kqxtr.applicativeParAff);
var $6bfb10b11a80fc8b$var$$$delete = /* #__PURE__ */ $k6SBa.delete($bllhK.ordForkId);
var $6bfb10b11a80fc8b$var$unlessM = /* #__PURE__ */ $ibtPS.unlessM($9hRVP.monadEffect);
var $6bfb10b11a80fc8b$var$insert1 = /* #__PURE__ */ $k6SBa.insert($bllhK.ordForkId);
var $6bfb10b11a80fc8b$var$traverse_3 = /* #__PURE__ */ $6bfb10b11a80fc8b$var$traverse_1($6RkEA.foldableMaybe);
var $6bfb10b11a80fc8b$var$lookup1 = /* #__PURE__ */ $k6SBa.lookup($bllhK.ordForkId);
var $6bfb10b11a80fc8b$var$lookup2 = /* #__PURE__ */ $k6SBa.lookup($d0PPW.ordString);
var $6bfb10b11a80fc8b$var$foldFree = /* #__PURE__ */ $hV7d0.foldFree($kqxtr.monadRecAff);
var $6bfb10b11a80fc8b$var$alter = /* #__PURE__ */ $k6SBa.alter($d0PPW.ordString);
var $6bfb10b11a80fc8b$var$unsubscribe = function(sid) {
    return function(ref) {
        return function __do() {
            var v = $jFEU8.read(ref)();
            var subs = $jFEU8.read(v.subscriptions)();
            return $6bfb10b11a80fc8b$var$traverse_($bhj9Z.unsubscribe)($6bfb10b11a80fc8b$var$bindFlipped($6bfb10b11a80fc8b$var$lookup(sid))(subs))();
        };
    };
};
var $6bfb10b11a80fc8b$export$2d912d1764c6009b = function(ref) {
    return function(au) {
        return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($jFEU8.read(ref)))(function(v) {
            if (v instanceof $ykHdR.Nothing) return au;
            if (v instanceof $ykHdR.Just) return $6bfb10b11a80fc8b$var$liftEffect($jFEU8.write(new $ykHdR.Just(new $amUgg.Cons(au, v.value0)))(ref));
            throw new Error("Failed pattern match at Halogen.Aff.Driver.Eval (line 188, column 33 - line 190, column 57): " + [
                v.constructor.name
            ]);
        });
    };
};
var $6bfb10b11a80fc8b$export$b7a8cef929df0d3c = function(lchs) {
    return function(f) {
        return $6bfb10b11a80fc8b$var$discard1($6bfb10b11a80fc8b$var$liftEffect($jFEU8.write({
            initializers: $amUgg.Nil.value,
            finalizers: $amUgg.Nil.value
        })(lchs)))(function() {
            return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect(f))(function(result) {
                return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($jFEU8.read(lchs)))(function(v) {
                    return $6bfb10b11a80fc8b$var$discard1($6bfb10b11a80fc8b$var$traverse_2($6bfb10b11a80fc8b$var$fork)(v.finalizers))(function() {
                        return $6bfb10b11a80fc8b$var$discard1($6bfb10b11a80fc8b$var$parSequence_(v.initializers))(function() {
                            return $6bfb10b11a80fc8b$var$pure(result);
                        });
                    });
                });
            });
        });
    };
};
var $6bfb10b11a80fc8b$export$c4c41c035efd1fb3 = /* #__PURE__ */ $kqxtr.runAff_(/* #__PURE__ */ $aKY4H.either($eROd4.throwException)(/* #__PURE__ */ $l4M7e.const(/* #__PURE__ */ $gUTA8.pure($9hRVP.applicativeEffect)($r2HHk.unit))));
var $6bfb10b11a80fc8b$var$fresh = function(f) {
    return function(ref) {
        return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($jFEU8.read(ref)))(function(v) {
            return $6bfb10b11a80fc8b$var$liftEffect($cnyA5.modify$prime(function(i) {
                return {
                    state: i + 1 | 0,
                    value: f(i)
                };
            })(v.fresh));
        });
    };
};
var $6bfb10b11a80fc8b$export$f960635a4c7f8a61 = function(render) {
    return function(ref) {
        return function(q) {
            return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($jFEU8.read(ref)))(function(v) {
                return $6bfb10b11a80fc8b$export$b505393bc8c03d39(render)(ref)(v["component"]["eval"](new $5OEb5.Query($6bfb10b11a80fc8b$var$map($ykHdR.Just.create)($cYgrH.liftCoyoneda(q)), $l4M7e.const($ykHdR.Nothing.value))));
            });
        };
    };
};
var $6bfb10b11a80fc8b$export$b505393bc8c03d39 = function(render) {
    return function(initRef) {
        return function(v) {
            var evalChildQuery = function(ref) {
                return function(cqb) {
                    return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($jFEU8.read(ref)))(function(v1) {
                        return $1nuum.unChildQueryBox(function(v2) {
                            var evalChild = function(v3) {
                                return $6bfb10b11a80fc8b$var$parallel($6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($jFEU8.read(v3)))(function(dsx) {
                                    return $kzfBX.unDriverStateX(function(ds) {
                                        return $6bfb10b11a80fc8b$export$f960635a4c7f8a61(render)(ds.selfRef)(v2.value1);
                                    })(dsx);
                                }));
                            };
                            return $6bfb10b11a80fc8b$var$map1(v2.value2)($6bfb10b11a80fc8b$var$sequential(v2.value0($kqxtr.applicativeParAff)(evalChild)(v1.children)));
                        })(cqb);
                    });
                };
            };
            var go = function(ref) {
                return function(v1) {
                    if (v1 instanceof $bllhK.State) return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($jFEU8.read(ref)))(function(v2) {
                        var v3 = v1.value0(v2.state);
                        if ($bBd0x.unsafeRefEq(v2.state)(v3.value1)) return $6bfb10b11a80fc8b$var$pure(v3.value0);
                        if ($6UHO6.otherwise) return $6bfb10b11a80fc8b$var$discard1($6bfb10b11a80fc8b$var$liftEffect($jFEU8.write({
                            component: v2.component,
                            refs: v2.refs,
                            children: v2.children,
                            childrenIn: v2.childrenIn,
                            childrenOut: v2.childrenOut,
                            selfRef: v2.selfRef,
                            handlerRef: v2.handlerRef,
                            pendingQueries: v2.pendingQueries,
                            pendingOuts: v2.pendingOuts,
                            pendingHandlers: v2.pendingHandlers,
                            rendering: v2.rendering,
                            fresh: v2.fresh,
                            subscriptions: v2.subscriptions,
                            forks: v2.forks,
                            lifecycleHandlers: v2.lifecycleHandlers,
                            state: v3.value1
                        })(ref)))(function() {
                            return $6bfb10b11a80fc8b$var$discard1($6bfb10b11a80fc8b$export$b7a8cef929df0d3c(v2.lifecycleHandlers)(render(v2.lifecycleHandlers)(ref)))(function() {
                                return $6bfb10b11a80fc8b$var$pure(v3.value0);
                            });
                        });
                        throw new Error("Failed pattern match at Halogen.Aff.Driver.Eval (line 86, column 7 - line 92, column 21): " + [
                            v3.constructor.name
                        ]);
                    });
                    if (v1 instanceof $bllhK.Subscribe) return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$fresh($bllhK.SubscriptionId)(ref))(function(sid) {
                        return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($bhj9Z.subscribe(v1.value0(sid))(function(act) {
                            return $6bfb10b11a80fc8b$export$c4c41c035efd1fb3($6bfb10b11a80fc8b$export$6533955444d826a5(render)(ref)(new $cVGsR.Action(act)));
                        })))(function(finalize) {
                            return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($jFEU8.read(ref)))(function(v2) {
                                return $6bfb10b11a80fc8b$var$discard1($6bfb10b11a80fc8b$var$liftEffect($cnyA5.modify_($6bfb10b11a80fc8b$var$map2($6bfb10b11a80fc8b$var$insert(sid)(finalize)))(v2.subscriptions)))(function() {
                                    return $6bfb10b11a80fc8b$var$pure(v1.value1(sid));
                                });
                            });
                        });
                    });
                    if (v1 instanceof $bllhK.Unsubscribe) return $6bfb10b11a80fc8b$var$discard1($6bfb10b11a80fc8b$var$liftEffect($6bfb10b11a80fc8b$var$unsubscribe(v1.value0)(ref)))(function() {
                        return $6bfb10b11a80fc8b$var$pure(v1.value1);
                    });
                    if (v1 instanceof $bllhK.Lift) return v1.value0;
                    if (v1 instanceof $bllhK.ChildQuery) return evalChildQuery(ref)(v1.value0);
                    if (v1 instanceof $bllhK.Raise) return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($jFEU8.read(ref)))(function(v2) {
                        return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($jFEU8.read(v2.handlerRef)))(function(handler) {
                            return $6bfb10b11a80fc8b$var$discard1($6bfb10b11a80fc8b$export$2d912d1764c6009b(v2.pendingOuts)(handler(v1.value0)))(function() {
                                return $6bfb10b11a80fc8b$var$pure(v1.value1);
                            });
                        });
                    });
                    if (v1 instanceof $bllhK.Par) return $6bfb10b11a80fc8b$var$sequential($6bfb10b11a80fc8b$var$retractFreeAp($iVIp8.hoistFreeAp(function() {
                        var $119 = $6bfb10b11a80fc8b$export$b505393bc8c03d39(render)(ref);
                        return function($120) {
                            return $6bfb10b11a80fc8b$var$parallel($119($120));
                        };
                    }())(v1.value0)));
                    if (v1 instanceof $bllhK.Fork) return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$fresh($bllhK.ForkId)(ref))(function(fid) {
                        return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($jFEU8.read(ref)))(function(v2) {
                            return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($cnyA5.new(false)))(function(doneRef) {
                                return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$fork($kqxtr.finally($6bfb10b11a80fc8b$var$liftEffect(function __do() {
                                    $cnyA5.modify_($6bfb10b11a80fc8b$var$$$delete(fid))(v2.forks)();
                                    return $jFEU8.write(true)(doneRef)();
                                }))($6bfb10b11a80fc8b$export$b505393bc8c03d39(render)(ref)(v1.value0))))(function(fiber) {
                                    return $6bfb10b11a80fc8b$var$discard1($6bfb10b11a80fc8b$var$liftEffect($6bfb10b11a80fc8b$var$unlessM($jFEU8.read(doneRef))($cnyA5.modify_($6bfb10b11a80fc8b$var$insert1(fid)(fiber))(v2.forks))))(function() {
                                        return $6bfb10b11a80fc8b$var$pure(v1.value1(fid));
                                    });
                                });
                            });
                        });
                    });
                    if (v1 instanceof $bllhK.Join) return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($jFEU8.read(ref)))(function(v2) {
                        return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($jFEU8.read(v2.forks)))(function(forkMap) {
                            return $6bfb10b11a80fc8b$var$discard1($6bfb10b11a80fc8b$var$traverse_3($kqxtr.joinFiber)($6bfb10b11a80fc8b$var$lookup1(v1.value0)(forkMap)))(function() {
                                return $6bfb10b11a80fc8b$var$pure(v1.value1);
                            });
                        });
                    });
                    if (v1 instanceof $bllhK.Kill) return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($jFEU8.read(ref)))(function(v2) {
                        return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($jFEU8.read(v2.forks)))(function(forkMap) {
                            return $6bfb10b11a80fc8b$var$discard1($6bfb10b11a80fc8b$var$traverse_3($kqxtr.killFiber($eROd4.error("Cancelled")))($6bfb10b11a80fc8b$var$lookup1(v1.value0)(forkMap)))(function() {
                                return $6bfb10b11a80fc8b$var$pure(v1.value1);
                            });
                        });
                    });
                    if (v1 instanceof $bllhK.GetRef) return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($jFEU8.read(ref)))(function(v2) {
                        return $6bfb10b11a80fc8b$var$pure(v1.value1($6bfb10b11a80fc8b$var$lookup2(v1.value0)(v2.refs)));
                    });
                    throw new Error("Failed pattern match at Halogen.Aff.Driver.Eval (line 83, column 12 - line 139, column 33): " + [
                        v1.constructor.name
                    ]);
                };
            };
            return $6bfb10b11a80fc8b$var$foldFree(go(initRef))(v);
        };
    };
};
var $6bfb10b11a80fc8b$export$6533955444d826a5 = function(render) {
    return function(ref) {
        return function(v) {
            if (v instanceof $cVGsR.RefUpdate) return $6bfb10b11a80fc8b$var$liftEffect($l4M7e.flip($cnyA5.modify_)(ref)($kzfBX.mapDriverState(function(st) {
                return {
                    component: st.component,
                    state: st.state,
                    children: st.children,
                    childrenIn: st.childrenIn,
                    childrenOut: st.childrenOut,
                    selfRef: st.selfRef,
                    handlerRef: st.handlerRef,
                    pendingQueries: st.pendingQueries,
                    pendingOuts: st.pendingOuts,
                    pendingHandlers: st.pendingHandlers,
                    rendering: st.rendering,
                    fresh: st.fresh,
                    subscriptions: st.subscriptions,
                    forks: st.forks,
                    lifecycleHandlers: st.lifecycleHandlers,
                    refs: $6bfb10b11a80fc8b$var$alter($l4M7e.const(v.value1))(v.value0)(st.refs)
                };
            })));
            if (v instanceof $cVGsR.Action) return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($jFEU8.read(ref)))(function(v1) {
                return $6bfb10b11a80fc8b$export$b505393bc8c03d39(render)(ref)(v1["component"]["eval"](new $5OEb5.Action(v.value0, $r2HHk.unit)));
            });
            throw new Error("Failed pattern match at Halogen.Aff.Driver.Eval (line 52, column 20 - line 58, column 62): " + [
                v.constructor.name
            ]);
        };
    };
};

});
parcelRegister("kzfBX", function(module, exports) {

$parcel$export(module.exports, "unRenderStateX", () => $ef932f98609e5673$export$b29cd3b133bc0fa4);
$parcel$export(module.exports, "unDriverStateX", () => $ef932f98609e5673$export$b325883598264040);
$parcel$export(module.exports, "renderStateX_", () => $ef932f98609e5673$export$dcc8908fea536646);
$parcel$export(module.exports, "renderStateX", () => $ef932f98609e5673$export$8a58ffe66c3bbb4d);
$parcel$export(module.exports, "mapDriverState", () => $ef932f98609e5673$export$43ced40f2a8d1657);
$parcel$export(module.exports, "initDriverState", () => $ef932f98609e5673$export$2999486de8d3a294);
// Generated by purs version 0.15.16

var $6RkEA = parcelRequire("6RkEA");

var $amUgg = parcelRequire("amUgg");

var $k6SBa = parcelRequire("k6SBa");

var $ykHdR = parcelRequire("ykHdR");

var $cnyA5 = parcelRequire("cnyA5");
var $jFEU8 = parcelRequire("jFEU8");

var $1j54f = parcelRequire("1j54f");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");
var $ef932f98609e5673$export$57f9bfb98da0e5b8 = function(x) {
    return x;
};
var $ef932f98609e5673$export$74fd2e01b52646ce = function(x) {
    return x;
};
var $ef932f98609e5673$export$b29cd3b133bc0fa4 = $eOrGk.unsafeCoerce;
var $ef932f98609e5673$export$b325883598264040 = $eOrGk.unsafeCoerce;
var $ef932f98609e5673$export$dcc8908fea536646 = function(dictApplicative) {
    var traverse_ = $6RkEA.traverse_(dictApplicative)($6RkEA.foldableMaybe);
    return function(f) {
        return $ef932f98609e5673$export$b325883598264040(function(st) {
            return traverse_(f)(st.rendering);
        });
    };
};
var $ef932f98609e5673$var$mkRenderStateX = $eOrGk.unsafeCoerce;
var $ef932f98609e5673$export$8a58ffe66c3bbb4d = function(dictFunctor) {
    return function(f) {
        return $ef932f98609e5673$export$b325883598264040(function(st) {
            return $ef932f98609e5673$var$mkRenderStateX(f(st.rendering));
        });
    };
};
var $ef932f98609e5673$export$52c65da2de355775 = $eOrGk.unsafeCoerce;
var $ef932f98609e5673$export$43ced40f2a8d1657 = function(f) {
    return function(v) {
        return f(v);
    };
};
var $ef932f98609e5673$export$2999486de8d3a294 = function(component) {
    return function(input) {
        return function(handler) {
            return function(lchs) {
                return function __do() {
                    var selfRef = $cnyA5.new({})();
                    var childrenIn = $cnyA5.new($1j54f.empty)();
                    var childrenOut = $cnyA5.new($1j54f.empty)();
                    var handlerRef = $cnyA5.new(handler)();
                    var pendingQueries = $cnyA5.new(new $ykHdR.Just($amUgg.Nil.value))();
                    var pendingOuts = $cnyA5.new(new $ykHdR.Just($amUgg.Nil.value))();
                    var pendingHandlers = $cnyA5.new($ykHdR.Nothing.value)();
                    var fresh = $cnyA5.new(1)();
                    var subscriptions = $cnyA5.new(new $ykHdR.Just($k6SBa.empty))();
                    var forks = $cnyA5.new($k6SBa.empty)();
                    var ds = {
                        component: component,
                        state: component.initialState(input),
                        refs: $k6SBa.empty,
                        children: $1j54f.empty,
                        childrenIn: childrenIn,
                        childrenOut: childrenOut,
                        selfRef: selfRef,
                        handlerRef: handlerRef,
                        pendingQueries: pendingQueries,
                        pendingOuts: pendingOuts,
                        pendingHandlers: pendingHandlers,
                        rendering: $ykHdR.Nothing.value,
                        fresh: fresh,
                        subscriptions: subscriptions,
                        forks: forks,
                        lifecycleHandlers: lchs
                    };
                    $jFEU8.write(ds)(selfRef)();
                    return $ef932f98609e5673$export$52c65da2de355775(selfRef);
                };
            };
        };
    };
};

});



parcelRegister("5Pc7Y", function(module, exports) {

$parcel$export(module.exports, "parentNode", () => $43db1f7c9150eb00$export$b54be7ce267a037b);
$parcel$export(module.exports, "nextSibling", () => $43db1f7c9150eb00$export$335219007e689d29);
$parcel$export(module.exports, "insertBefore", () => (parcelRequire("dpyXb")).insertBefore);
$parcel$export(module.exports, "appendChild", () => (parcelRequire("dpyXb")).appendChild);
$parcel$export(module.exports, "removeChild", () => (parcelRequire("dpyXb")).removeChild);
// Generated by purs version 0.15.16

var $dpyXb = parcelRequire("dpyXb");

var $loxi1 = parcelRequire("loxi1");

var $l0wDR = parcelRequire("l0wDR");

var $ykHdR = parcelRequire("ykHdR");

var $T79xE = parcelRequire("T79xE");

var $9hRVP = parcelRequire("9hRVP");
parcelRequire("gukrE");
var $eOrGk = parcelRequire("eOrGk");
parcelRequire("bmTaV");

var $eDtWz = parcelRequire("eDtWz");

var $6EJMX = parcelRequire("6EJMX");
var $43db1f7c9150eb00$var$map = /* #__PURE__ */ $l0wDR.map($9hRVP.functorEffect);
var $43db1f7c9150eb00$var$fromJust = /* #__PURE__ */ $ykHdR.fromJust();
var $43db1f7c9150eb00$var$toEnum = /* #__PURE__ */ $loxi1.toEnum($eDtWz.boundedEnumNodeType);
var $43db1f7c9150eb00$export$55c9526d22b9f8e6 = $eOrGk.unsafeCoerce;
var $43db1f7c9150eb00$export$6c33a601ef71fce7 = /* #__PURE__ */ function() {
    var $4 = $43db1f7c9150eb00$var$map($T79xE.toMaybe);
    return function($5) {
        return $4($dpyXb._previousSibling($5));
    };
}();
var $43db1f7c9150eb00$export$b54be7ce267a037b = /* #__PURE__ */ function() {
    var $6 = $43db1f7c9150eb00$var$map($T79xE.toMaybe);
    return function($7) {
        return $6($dpyXb._parentNode($7));
    };
}();
var $43db1f7c9150eb00$export$222ab8a52715b4f4 = /* #__PURE__ */ function() {
    var $8 = $43db1f7c9150eb00$var$map($T79xE.toMaybe);
    return function($9) {
        return $8($dpyXb._parentElement($9));
    };
}();
var $43db1f7c9150eb00$export$512a1115db01100d = /* #__PURE__ */ function() {
    var $10 = $43db1f7c9150eb00$var$map($T79xE.toMaybe);
    return function($11) {
        return $10($dpyXb._ownerDocument($11));
    };
}();
var $43db1f7c9150eb00$export$63bfedaececbd5f5 = /* #__PURE__ */ function() {
    var $12 = $43db1f7c9150eb00$var$map($T79xE.toMaybe);
    return function($13) {
        return $12($dpyXb._nodeValue($13));
    };
}();
var $43db1f7c9150eb00$export$4debbe1037afe35e = function() {
    return function($14) {
        return $43db1f7c9150eb00$var$fromJust($43db1f7c9150eb00$var$toEnum($dpyXb.nodeTypeIndex($14)));
    };
};
var $43db1f7c9150eb00$export$335219007e689d29 = /* #__PURE__ */ function() {
    var $15 = $43db1f7c9150eb00$var$map($T79xE.toMaybe);
    return function($16) {
        return $15($dpyXb._nextSibling($16));
    };
}();
var $43db1f7c9150eb00$export$20ad2ac0440a470d = function(p) {
    var $17 = $43db1f7c9150eb00$var$map($T79xE.toMaybe);
    var $18 = $dpyXb._lookupPrefix(p);
    return function($19) {
        return $17($18($19));
    };
};
var $43db1f7c9150eb00$export$eca9f13e904be86a = function(ns) {
    var $20 = $43db1f7c9150eb00$var$map($T79xE.toMaybe);
    var $21 = $dpyXb._lookupNamespaceURI(ns);
    return function($22) {
        return $20($21($22));
    };
};
var $43db1f7c9150eb00$export$86c2694e50e8251b = /* #__PURE__ */ function() {
    var $23 = $43db1f7c9150eb00$var$map($T79xE.toMaybe);
    return function($24) {
        return $23($dpyXb._lastChild($24));
    };
}();
var $43db1f7c9150eb00$export$a0a0bf09b44710c9 = /* #__PURE__ */ $6EJMX.unsafeReadProtoTagged("Node");
var $43db1f7c9150eb00$export$b212a48622cd6ee3 = /* #__PURE__ */ function() {
    var $25 = $43db1f7c9150eb00$var$map($T79xE.toMaybe);
    return function($26) {
        return $25($dpyXb._firstChild($26));
    };
}();

});
parcelRegister("dpyXb", function(module, exports) {

$parcel$export(module.exports, "nodeTypeIndex", () => $9c38b931c8b22574$export$c441300b2d51b958);
$parcel$export(module.exports, "_ownerDocument", () => $9c38b931c8b22574$export$23cc1b2a9bb6c61a);
$parcel$export(module.exports, "_parentNode", () => $9c38b931c8b22574$export$72030ded560177b6);
$parcel$export(module.exports, "_parentElement", () => $9c38b931c8b22574$export$e8e77848f4a9ad40);
$parcel$export(module.exports, "_firstChild", () => $9c38b931c8b22574$export$274e0d97326033db);
$parcel$export(module.exports, "_lastChild", () => $9c38b931c8b22574$export$951f870fb0fe03c3);
$parcel$export(module.exports, "_previousSibling", () => $9c38b931c8b22574$export$e2e6c080f0f2a76d);
$parcel$export(module.exports, "_nextSibling", () => $9c38b931c8b22574$export$2eda4366e9b7c29f);
$parcel$export(module.exports, "_nodeValue", () => $9c38b931c8b22574$export$d6cd495109f5e655);
$parcel$export(module.exports, "_lookupPrefix", () => $9c38b931c8b22574$export$b9a4e863f082a036);
$parcel$export(module.exports, "_lookupNamespaceURI", () => $9c38b931c8b22574$export$a79c57bed1c08193);
$parcel$export(module.exports, "insertBefore", () => $9c38b931c8b22574$export$86b68c7dbeb53c22);
$parcel$export(module.exports, "appendChild", () => $9c38b931c8b22574$export$1b8e57c9ea42f1d2);
$parcel$export(module.exports, "removeChild", () => $9c38b931c8b22574$export$7ae609f7af59e4f7);
var $9c38b931c8b22574$var$getEffProp = function(name) {
    return function(node) {
        return function() {
            return node[name];
        };
    };
};
function $9c38b931c8b22574$export$c441300b2d51b958(node) {
    return node.nodeType;
}
function $9c38b931c8b22574$export$860bddf988a8498c(node) {
    return node.nodeName;
}
const $9c38b931c8b22574$export$74061d4f476da680 = $9c38b931c8b22574$var$getEffProp("baseURI");
const $9c38b931c8b22574$export$23cc1b2a9bb6c61a = $9c38b931c8b22574$var$getEffProp("ownerDocument");
const $9c38b931c8b22574$export$72030ded560177b6 = $9c38b931c8b22574$var$getEffProp("parentNode");
const $9c38b931c8b22574$export$e8e77848f4a9ad40 = $9c38b931c8b22574$var$getEffProp("parentElement");
function $9c38b931c8b22574$export$13782f450ac5e09a(node) {
    return function() {
        return node.hasChildNodes();
    };
}
const $9c38b931c8b22574$export$c9fa23d9ff60a2d1 = $9c38b931c8b22574$var$getEffProp("childNodes");
const $9c38b931c8b22574$export$274e0d97326033db = $9c38b931c8b22574$var$getEffProp("firstChild");
const $9c38b931c8b22574$export$951f870fb0fe03c3 = $9c38b931c8b22574$var$getEffProp("lastChild");
const $9c38b931c8b22574$export$e2e6c080f0f2a76d = $9c38b931c8b22574$var$getEffProp("previousSibling");
const $9c38b931c8b22574$export$2eda4366e9b7c29f = $9c38b931c8b22574$var$getEffProp("nextSibling");
const $9c38b931c8b22574$export$d6cd495109f5e655 = $9c38b931c8b22574$var$getEffProp("nodeValue");
function $9c38b931c8b22574$export$df6212ebae08b450(value) {
    return function(node) {
        return function() {
            node.nodeValue = value;
        };
    };
}
const $9c38b931c8b22574$export$e0e0794250e9118f = $9c38b931c8b22574$var$getEffProp("textContent");
function $9c38b931c8b22574$export$94b0296cab6203e(value) {
    return function(node) {
        return function() {
            node.textContent = value;
        };
    };
}
function $9c38b931c8b22574$export$a3295358bff77e(node) {
    return function() {
        node.normalize();
    };
}
function $9c38b931c8b22574$export$9cd59f9826255e47(node) {
    return function() {
        return node.cloneNode(false);
    };
}
function $9c38b931c8b22574$export$b7d58db314e0ac27(node) {
    return function() {
        return node.cloneNode(true);
    };
}
function $9c38b931c8b22574$export$55e9b4d3368d84dd(node1) {
    return function(node2) {
        return function() {
            return node1.isEqualNode(node2);
        };
    };
}
function $9c38b931c8b22574$export$aff35b31398d5fba(node1) {
    return function(node2) {
        return function() {
            return node1.compareDocumentPosition(node2);
        };
    };
}
function $9c38b931c8b22574$export$2344b14b097df817(node1) {
    return function(node2) {
        return function() {
            return node1.contains(node2);
        };
    };
}
function $9c38b931c8b22574$export$b9a4e863f082a036(prefix) {
    return function(node) {
        return function() {
            return node.lookupPrefix(prefix);
        };
    };
}
function $9c38b931c8b22574$export$a79c57bed1c08193(ns) {
    return function(node) {
        return function() {
            return node.lookupNamespaceURI(ns);
        };
    };
}
function $9c38b931c8b22574$export$61f41c073d810e4f(ns) {
    return function(node) {
        return function() {
            return node.isDefaultNamespace(ns);
        };
    };
}
function $9c38b931c8b22574$export$86b68c7dbeb53c22(node1) {
    return function(node2) {
        return function(parent) {
            return function() {
                parent.insertBefore(node1, node2);
            };
        };
    };
}
function $9c38b931c8b22574$export$1b8e57c9ea42f1d2(node) {
    return function(parent) {
        return function() {
            parent.appendChild(node);
        };
    };
}
function $9c38b931c8b22574$export$46f78da0e790aab7(newChild) {
    return function(oldChild) {
        return function(parent) {
            return function() {
                parent.replaceChild(newChild, oldChild);
            };
        };
    };
}
function $9c38b931c8b22574$export$7ae609f7af59e4f7(node) {
    return function(parent) {
        return function() {
            parent.removeChild(node);
        };
    };
}

});

parcelRegister("eDtWz", function(module, exports) {

$parcel$export(module.exports, "boundedEnumNodeType", () => $aa7bef674fe53e14$export$db18e9bcd7fea75b);
// Generated by purs version 0.15.16

var $loxi1 = parcelRequire("loxi1");

var $ykHdR = parcelRequire("ykHdR");

var $d0PPW = parcelRequire("d0PPW");
var $aa7bef674fe53e14$var$compare = /* #__PURE__ */ $d0PPW.compare($d0PPW.ordInt);
var $aa7bef674fe53e14$export$dc064fe9e59310fd = /* #__PURE__ */ function() {
    function ElementNode() {}
    ElementNode.value = new ElementNode();
    return ElementNode;
}();
var $aa7bef674fe53e14$export$dc88047a888cd46b = /* #__PURE__ */ function() {
    function AttributeNode() {}
    AttributeNode.value = new AttributeNode();
    return AttributeNode;
}();
var $aa7bef674fe53e14$export$f0a25ea3087686aa = /* #__PURE__ */ function() {
    function TextNode() {}
    TextNode.value = new TextNode();
    return TextNode;
}();
var $aa7bef674fe53e14$export$28835d60136fdd55 = /* #__PURE__ */ function() {
    function CDATASectionNode() {}
    CDATASectionNode.value = new CDATASectionNode();
    return CDATASectionNode;
}();
var $aa7bef674fe53e14$export$a4de1a63043e7a6d = /* #__PURE__ */ function() {
    function EntityReferenceNode() {}
    EntityReferenceNode.value = new EntityReferenceNode();
    return EntityReferenceNode;
}();
var $aa7bef674fe53e14$export$34dac3329b92804f = /* #__PURE__ */ function() {
    function EntityNode() {}
    EntityNode.value = new EntityNode();
    return EntityNode;
}();
var $aa7bef674fe53e14$export$2458c2a2a9d8a0a8 = /* #__PURE__ */ function() {
    function ProcessingInstructionNode() {}
    ProcessingInstructionNode.value = new ProcessingInstructionNode();
    return ProcessingInstructionNode;
}();
var $aa7bef674fe53e14$export$dd3132c03c97153e = /* #__PURE__ */ function() {
    function CommentNode() {}
    CommentNode.value = new CommentNode();
    return CommentNode;
}();
var $aa7bef674fe53e14$export$9da34d55490083d8 = /* #__PURE__ */ function() {
    function DocumentNode() {}
    DocumentNode.value = new DocumentNode();
    return DocumentNode;
}();
var $aa7bef674fe53e14$export$c4edab6ab3262a44 = /* #__PURE__ */ function() {
    function DocumentTypeNode() {}
    DocumentTypeNode.value = new DocumentTypeNode();
    return DocumentTypeNode;
}();
var $aa7bef674fe53e14$export$ed75c007fb9b19c0 = /* #__PURE__ */ function() {
    function DocumentFragmentNode() {}
    DocumentFragmentNode.value = new DocumentFragmentNode();
    return DocumentFragmentNode;
}();
var $aa7bef674fe53e14$export$71dc25271abd047 = /* #__PURE__ */ function() {
    function NotationNode() {}
    NotationNode.value = new NotationNode();
    return NotationNode;
}();
var $aa7bef674fe53e14$var$toEnumNodeType = function(v) {
    if (v === 1) return new $ykHdR.Just($aa7bef674fe53e14$export$dc064fe9e59310fd.value);
    if (v === 2) return new $ykHdR.Just($aa7bef674fe53e14$export$dc88047a888cd46b.value);
    if (v === 3) return new $ykHdR.Just($aa7bef674fe53e14$export$f0a25ea3087686aa.value);
    if (v === 4) return new $ykHdR.Just($aa7bef674fe53e14$export$28835d60136fdd55.value);
    if (v === 5) return new $ykHdR.Just($aa7bef674fe53e14$export$a4de1a63043e7a6d.value);
    if (v === 6) return new $ykHdR.Just($aa7bef674fe53e14$export$34dac3329b92804f.value);
    if (v === 7) return new $ykHdR.Just($aa7bef674fe53e14$export$2458c2a2a9d8a0a8.value);
    if (v === 8) return new $ykHdR.Just($aa7bef674fe53e14$export$dd3132c03c97153e.value);
    if (v === 9) return new $ykHdR.Just($aa7bef674fe53e14$export$9da34d55490083d8.value);
    if (v === 10) return new $ykHdR.Just($aa7bef674fe53e14$export$c4edab6ab3262a44.value);
    if (v === 11) return new $ykHdR.Just($aa7bef674fe53e14$export$ed75c007fb9b19c0.value);
    if (v === 12) return new $ykHdR.Just($aa7bef674fe53e14$export$71dc25271abd047.value);
    return $ykHdR.Nothing.value;
};
var $aa7bef674fe53e14$export$eb0d4895a3e15732 = {
    show: function(v) {
        if (v instanceof $aa7bef674fe53e14$export$dc064fe9e59310fd) return "ElementNode";
        if (v instanceof $aa7bef674fe53e14$export$dc88047a888cd46b) return "AttributeNode";
        if (v instanceof $aa7bef674fe53e14$export$f0a25ea3087686aa) return "TextNode";
        if (v instanceof $aa7bef674fe53e14$export$28835d60136fdd55) return "CDATASectionNode";
        if (v instanceof $aa7bef674fe53e14$export$a4de1a63043e7a6d) return "EntityReferenceNode";
        if (v instanceof $aa7bef674fe53e14$export$34dac3329b92804f) return "EntityNode";
        if (v instanceof $aa7bef674fe53e14$export$2458c2a2a9d8a0a8) return "ProcessingInstructionNode";
        if (v instanceof $aa7bef674fe53e14$export$dd3132c03c97153e) return "CommentNode";
        if (v instanceof $aa7bef674fe53e14$export$9da34d55490083d8) return "DocumentNode";
        if (v instanceof $aa7bef674fe53e14$export$c4edab6ab3262a44) return "DocumentTypeNode";
        if (v instanceof $aa7bef674fe53e14$export$ed75c007fb9b19c0) return "DocumentFragmentNode";
        if (v instanceof $aa7bef674fe53e14$export$71dc25271abd047) return "NotationNode";
        throw new Error("Failed pattern match at Web.DOM.NodeType (line 39, column 1 - line 51, column 37): " + [
            v.constructor.name
        ]);
    }
};
var $aa7bef674fe53e14$var$fromEnumNodeType = function(v) {
    if (v instanceof $aa7bef674fe53e14$export$dc064fe9e59310fd) return 1;
    if (v instanceof $aa7bef674fe53e14$export$dc88047a888cd46b) return 2;
    if (v instanceof $aa7bef674fe53e14$export$f0a25ea3087686aa) return 3;
    if (v instanceof $aa7bef674fe53e14$export$28835d60136fdd55) return 4;
    if (v instanceof $aa7bef674fe53e14$export$a4de1a63043e7a6d) return 5;
    if (v instanceof $aa7bef674fe53e14$export$34dac3329b92804f) return 6;
    if (v instanceof $aa7bef674fe53e14$export$2458c2a2a9d8a0a8) return 7;
    if (v instanceof $aa7bef674fe53e14$export$dd3132c03c97153e) return 8;
    if (v instanceof $aa7bef674fe53e14$export$9da34d55490083d8) return 9;
    if (v instanceof $aa7bef674fe53e14$export$c4edab6ab3262a44) return 10;
    if (v instanceof $aa7bef674fe53e14$export$ed75c007fb9b19c0) return 11;
    if (v instanceof $aa7bef674fe53e14$export$71dc25271abd047) return 12;
    throw new Error("Failed pattern match at Web.DOM.NodeType (line 68, column 1 - line 68, column 36): " + [
        v.constructor.name
    ]);
};
var $aa7bef674fe53e14$export$88377e09539feb78 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $aa7bef674fe53e14$export$dc064fe9e59310fd && y instanceof $aa7bef674fe53e14$export$dc064fe9e59310fd) return true;
            if (x instanceof $aa7bef674fe53e14$export$dc88047a888cd46b && y instanceof $aa7bef674fe53e14$export$dc88047a888cd46b) return true;
            if (x instanceof $aa7bef674fe53e14$export$f0a25ea3087686aa && y instanceof $aa7bef674fe53e14$export$f0a25ea3087686aa) return true;
            if (x instanceof $aa7bef674fe53e14$export$28835d60136fdd55 && y instanceof $aa7bef674fe53e14$export$28835d60136fdd55) return true;
            if (x instanceof $aa7bef674fe53e14$export$a4de1a63043e7a6d && y instanceof $aa7bef674fe53e14$export$a4de1a63043e7a6d) return true;
            if (x instanceof $aa7bef674fe53e14$export$34dac3329b92804f && y instanceof $aa7bef674fe53e14$export$34dac3329b92804f) return true;
            if (x instanceof $aa7bef674fe53e14$export$2458c2a2a9d8a0a8 && y instanceof $aa7bef674fe53e14$export$2458c2a2a9d8a0a8) return true;
            if (x instanceof $aa7bef674fe53e14$export$dd3132c03c97153e && y instanceof $aa7bef674fe53e14$export$dd3132c03c97153e) return true;
            if (x instanceof $aa7bef674fe53e14$export$9da34d55490083d8 && y instanceof $aa7bef674fe53e14$export$9da34d55490083d8) return true;
            if (x instanceof $aa7bef674fe53e14$export$c4edab6ab3262a44 && y instanceof $aa7bef674fe53e14$export$c4edab6ab3262a44) return true;
            if (x instanceof $aa7bef674fe53e14$export$ed75c007fb9b19c0 && y instanceof $aa7bef674fe53e14$export$ed75c007fb9b19c0) return true;
            if (x instanceof $aa7bef674fe53e14$export$71dc25271abd047 && y instanceof $aa7bef674fe53e14$export$71dc25271abd047) return true;
            return false;
        };
    }
};
var $aa7bef674fe53e14$export$98741689c6e0b987 = {
    compare: function(x) {
        return function(y) {
            return $aa7bef674fe53e14$var$compare($aa7bef674fe53e14$var$fromEnumNodeType(x))($aa7bef674fe53e14$var$fromEnumNodeType(y));
        };
    },
    Eq0: function() {
        return $aa7bef674fe53e14$export$88377e09539feb78;
    }
};
var $aa7bef674fe53e14$export$61b56a5f9f6230cb = {
    succ: /* #__PURE__ */ $loxi1.defaultSucc($aa7bef674fe53e14$var$toEnumNodeType)($aa7bef674fe53e14$var$fromEnumNodeType),
    pred: /* #__PURE__ */ $loxi1.defaultPred($aa7bef674fe53e14$var$toEnumNodeType)($aa7bef674fe53e14$var$fromEnumNodeType),
    Ord0: function() {
        return $aa7bef674fe53e14$export$98741689c6e0b987;
    }
};
var $aa7bef674fe53e14$export$5879f3f4738185fd = /* #__PURE__ */ function() {
    return {
        bottom: $aa7bef674fe53e14$export$dc064fe9e59310fd.value,
        top: $aa7bef674fe53e14$export$71dc25271abd047.value,
        Ord0: function() {
            return $aa7bef674fe53e14$export$98741689c6e0b987;
        }
    };
}();
var $aa7bef674fe53e14$export$db18e9bcd7fea75b = {
    cardinality: 12,
    toEnum: $aa7bef674fe53e14$var$toEnumNodeType,
    fromEnum: $aa7bef674fe53e14$var$fromEnumNodeType,
    Bounded0: function() {
        return $aa7bef674fe53e14$export$5879f3f4738185fd;
    },
    Enum1: function() {
        return $aa7bef674fe53e14$export$61b56a5f9f6230cb;
    }
};

});



parcelRegister("gaeJx", function(module, exports) {

$parcel$export(module.exports, "monadRecGen", () => $bc49024203989caa$export$b03367abac3ff7e8);
$parcel$export(module.exports, "randomSampleOne", () => $bc49024203989caa$export$277a6090301c27ce);
$parcel$export(module.exports, "monadGenGen", () => $bc49024203989caa$export$f103a64475a4fd0b);
// Generated by purs version 0.15.16

var $f6nCb = parcelRequire("f6nCb");

var $gUTA8 = parcelRequire("gUTA8");

var $a5g3C = parcelRequire("a5g3C");

var $9Grh5 = parcelRequire("9Grh5");

var $lowBm = parcelRequire("lowBm");

var $6m1DK = parcelRequire("6m1DK");

var $kQAxW = parcelRequire("kQAxW");

var $k4cbH = parcelRequire("k4cbH");

var $4VF0K = parcelRequire("4VF0K");
var $lGiKR = parcelRequire("lGiKR");

var $jxBf5 = parcelRequire("jxBf5");

var $cwMDv = parcelRequire("cwMDv");

var $6UHO6 = parcelRequire("6UHO6");

var $95fRU = parcelRequire("95fRU");

var $loxi1 = parcelRequire("loxi1");

var $l0wDR = parcelRequire("l0wDR");

var $6VVZC = parcelRequire("6VVZC");

var $c8kPS = parcelRequire("c8kPS");
var $6pI6x = parcelRequire("6pI6x");

var $5gmr2 = parcelRequire("5gmr2");

var $amUgg = parcelRequire("amUgg");

var $ykHdR = parcelRequire("ykHdR");

var $jCCb5 = parcelRequire("jCCb5");

var $6PW1p = parcelRequire("6PW1p");
parcelRequire("rzgQX");
var $deaB6 = parcelRequire("deaB6");

var $d0PPW = parcelRequire("d0PPW");

var $IFMV2 = parcelRequire("IFMV2");

var $gyPYh = parcelRequire("gyPYh");

var $9MxTl = parcelRequire("9MxTl");

var $hsyEi = parcelRequire("hsyEi");
parcelRequire("csvvy");
var $r2HHk = parcelRequire("r2HHk");

var $cOZDQ = parcelRequire("cOZDQ");
var $bc49024203989caa$var$monadStateStateT = /* #__PURE__ */ $k4cbH.monadStateStateT($6VVZC.monadIdentity);
var $bc49024203989caa$var$state = /* #__PURE__ */ $kQAxW.state($bc49024203989caa$var$monadStateStateT);
var $bc49024203989caa$var$map = /* #__PURE__ */ $l0wDR.map($9MxTl.functorTuple);
var $bc49024203989caa$var$bindStateT = /* #__PURE__ */ $k4cbH.bindStateT($6VVZC.monadIdentity);
var $bc49024203989caa$var$discard = /* #__PURE__ */ $9Grh5.discard($9Grh5.discardUnit)($bc49024203989caa$var$bindStateT);
var $bc49024203989caa$var$functorStateT = /* #__PURE__ */ $k4cbH.functorStateT($6VVZC.functorIdentity);
var $bc49024203989caa$var$$$void = /* #__PURE__ */ $l0wDR.void($bc49024203989caa$var$functorStateT);
var $bc49024203989caa$var$modify = /* #__PURE__ */ $kQAxW.modify($bc49024203989caa$var$monadStateStateT);
var $bc49024203989caa$var$toUnfoldable = /* #__PURE__ */ $5gmr2.toUnfoldable($hsyEi.unfoldableArray);
var $bc49024203989caa$var$mul = /* #__PURE__ */ $gyPYh.mul($gyPYh.semiringNumber);
var $bc49024203989caa$var$min = /* #__PURE__ */ $d0PPW.min($d0PPW.ordNumber);
var $bc49024203989caa$var$max = /* #__PURE__ */ $d0PPW.max($d0PPW.ordNumber);
var $bc49024203989caa$var$add = /* #__PURE__ */ $gyPYh.add($gyPYh.semiringNumber);
var $bc49024203989caa$var$unwrap = /* #__PURE__ */ $6PW1p.unwrap();
var $bc49024203989caa$var$foldMap1 = /* #__PURE__ */ $IFMV2.foldMap1($cwMDv.foldable1NonEmptyArray)(/* #__PURE__ */ $jCCb5.semigroupAdditive($gyPYh.semiringNumber));
var $bc49024203989caa$var$unsafeIndex = /* #__PURE__ */ $jxBf5.unsafeIndex();
var $bc49024203989caa$var$fromJust = /* #__PURE__ */ $ykHdR.fromJust();
var $bc49024203989caa$var$top = /* #__PURE__ */ $95fRU.top($95fRU.boundedInt);
var $bc49024203989caa$var$map1 = /* #__PURE__ */ $l0wDR.map($l0wDR.functorArray);
var $bc49024203989caa$var$comparing = /* #__PURE__ */ $d0PPW.comparing($d0PPW.ordInt);
var $bc49024203989caa$var$Gen = function(x) {
    return x;
};
var $bc49024203989caa$export$501e8ddb7256577d = function(v) {
    return v;
};
var $bc49024203989caa$export$57b56d217c942094 = function($103) {
    return $6m1DK.runState($bc49024203989caa$export$501e8ddb7256577d($103));
};
var $bc49024203989caa$export$b9607df69539b8a5 = function(f) {
    return $bc49024203989caa$var$state(function(s) {
        return $bc49024203989caa$export$57b56d217c942094(f(s))(s);
    });
};
var $bc49024203989caa$export$c1c8be52b85daeca = function(f) {
    return $bc49024203989caa$export$b9607df69539b8a5(function(s) {
        return f(s.size);
    });
};
var $bc49024203989caa$export$8fdf71db98f19724 = function(n) {
    return function(g) {
        return $bc49024203989caa$var$state(function(s) {
            return $bc49024203989caa$export$57b56d217c942094(g)({
                size: s.size,
                newSeed: n
            });
        });
    };
};
var $bc49024203989caa$export$4380c87abf28fdf = function(sz) {
    return function(g) {
        return $bc49024203989caa$var$state(function(v) {
            return $bc49024203989caa$var$map(function(v1) {
                return {
                    newSeed: v1.newSeed,
                    size: v.size
                };
            })($bc49024203989caa$export$57b56d217c942094(g)({
                newSeed: v.newSeed,
                size: sz
            }));
        });
    };
};
var $bc49024203989caa$var$replicateMRec = function(dictMonadRec) {
    var Monad0 = dictMonadRec.Monad0();
    var pure2 = $gUTA8.pure(Monad0.Applicative0());
    var mapFlipped = $l0wDR.mapFlipped(Monad0.Bind1().Apply0().Functor0());
    var tailRecM1 = $lowBm.tailRecM(dictMonadRec);
    return function(v) {
        return function(v1) {
            if (v <= 0) return pure2($amUgg.Nil.value);
            var go = function(v2) {
                if (v2.value1 === 0) return pure2(new $lowBm.Done(v2.value0));
                return mapFlipped(v1)(function(x) {
                    return new $lowBm.Loop(new $9MxTl.Tuple(new $amUgg.Cons(x, v2.value0), v2.value1 - 1 | 0));
                });
            };
            return tailRecM1(go)(new $9MxTl.Tuple($amUgg.Nil.value, v));
        };
    };
};
var $bc49024203989caa$export$a1767e9fa438fa19 = function(f) {
    return $bc49024203989caa$var$state(function(s) {
        return new $9MxTl.Tuple(function(a) {
            return $9MxTl.fst($bc49024203989caa$export$57b56d217c942094(f(a))(s));
        }, {
            size: s.size,
            newSeed: $cOZDQ.lcgNext(s.newSeed)
        });
    });
};
var $bc49024203989caa$export$1c0695923c609880 = function(n) {
    return function(gen) {
        return $bc49024203989caa$var$discard($bc49024203989caa$var$$$void($bc49024203989caa$var$modify(function(s) {
            var $91 = {};
            for(var $92 in s)if (({}).hasOwnProperty.call(s, $92)) $91[$92] = s[$92];
            $91.newSeed = $cOZDQ.lcgPerturb($f6nCb.float32ToInt32(n))(s.newSeed);
            return $91;
        })))(function() {
            return $bc49024203989caa$export$501e8ddb7256577d(gen);
        });
    };
};
var $bc49024203989caa$export$b03367abac3ff7e8 = /* #__PURE__ */ $k4cbH.monadRecStateT($lowBm.monadRecIdentity);
var $bc49024203989caa$var$tailRecM = /* #__PURE__ */ $lowBm.tailRecM($bc49024203989caa$export$b03367abac3ff7e8);
var $bc49024203989caa$export$52ad81a118d95d95 = /* #__PURE__ */ $k4cbH.monadStateT($6VVZC.monadIdentity);
var $bc49024203989caa$export$2e12bfb3e89e4ebb = /* #__PURE__ */ $bc49024203989caa$var$replicateMRec($bc49024203989caa$export$b03367abac3ff7e8);
var $bc49024203989caa$var$lcgStep = /* #__PURE__ */ function() {
    var f = function(s) {
        return new $9MxTl.Tuple($cOZDQ.unSeed(s.newSeed), function() {
            var $94 = {};
            for(var $95 in s)if (({}).hasOwnProperty.call(s, $95)) $94[$95] = s[$95];
            $94.newSeed = $cOZDQ.lcgNext(s.newSeed);
            return $94;
        }());
    };
    return $bc49024203989caa$var$state(f);
}();
var $bc49024203989caa$export$c1f7d6d1f306d098 = $k4cbH.lazyStateT;
var $bc49024203989caa$export$5d116872cdd6398d = $bc49024203989caa$var$functorStateT;
var $bc49024203989caa$var$map2 = /* #__PURE__ */ $l0wDR.map($bc49024203989caa$export$5d116872cdd6398d);
var $bc49024203989caa$export$379455b567eff87d = /* #__PURE__ */ $bc49024203989caa$var$map2(function(n) {
    return $6pI6x.toNumber(n) / $6pI6x.toNumber($cOZDQ.lcgM);
})($bc49024203989caa$var$lcgStep);
var $bc49024203989caa$export$b81db5163bc14d3a = function(k) {
    return function(g) {
        return $bc49024203989caa$var$map2($bc49024203989caa$var$toUnfoldable)($bc49024203989caa$export$2e12bfb3e89e4ebb(k)(g));
    };
};
var $bc49024203989caa$export$15844f9800ba116b = function($104) {
    return $6m1DK.evalState($bc49024203989caa$export$501e8ddb7256577d($104));
};
var $bc49024203989caa$export$277a6090301c27ce = function(gen) {
    return function __do() {
        var seed = $cOZDQ.randomSeed();
        return $bc49024203989caa$export$15844f9800ba116b(gen)({
            newSeed: seed,
            size: 10
        });
    };
};
var $bc49024203989caa$export$4812e460280c6ef2 = function(seed) {
    return function(sz) {
        return function(g) {
            return $bc49024203989caa$export$15844f9800ba116b($bc49024203989caa$export$b81db5163bc14d3a(sz)(g))({
                newSeed: seed,
                size: sz
            });
        };
    };
};
var $bc49024203989caa$export$e2ce9cb992b4de1d = function(n) {
    return function(g) {
        return function __do() {
            var seed = $cOZDQ.randomSeed();
            return $bc49024203989caa$export$4812e460280c6ef2(seed)(n)(g);
        };
    };
};
var $bc49024203989caa$export$cd4f956adf59bc3d = /* #__PURE__ */ $bc49024203989caa$export$e2ce9cb992b4de1d(10);
var $bc49024203989caa$export$7877a478dd30fd3d = function(a) {
    return function(b) {
        var unscale = function(v) {
            return v * 2.0;
        };
        var scale = function(v) {
            return v * 0.5;
        };
        var min$prime = scale($bc49024203989caa$var$min(a)(b));
        var max$prime = scale($bc49024203989caa$var$max(a)(b));
        return $bc49024203989caa$var$map2(function() {
            var $105 = $bc49024203989caa$var$add(min$prime);
            var $106 = $bc49024203989caa$var$mul(max$prime - min$prime);
            return function($107) {
                return unscale($105($106($107)));
            };
        }())($bc49024203989caa$export$379455b567eff87d);
    };
};
var $bc49024203989caa$export$6d788b9a2716f3a2 = $bc49024203989caa$var$bindStateT;
var $bc49024203989caa$var$bind1 = /* #__PURE__ */ $9Grh5.bind($bc49024203989caa$export$6d788b9a2716f3a2);
var $bc49024203989caa$export$7ca27958f28e2974 = function(xxs) {
    var total = $bc49024203989caa$var$unwrap($bc49024203989caa$var$foldMap1(function($108) {
        return $jCCb5.Additive($9MxTl.fst($108));
    })(xxs));
    var $$default = $9MxTl.snd($jxBf5.head(xxs));
    var pick = function($copy_i) {
        return function($copy_n) {
            var $tco_var_i = $copy_i;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(i, n) {
                var v = $jxBf5.index(xxs)(i);
                if (v instanceof $ykHdR.Nothing) {
                    $tco_done = true;
                    return $$default;
                }
                if (v instanceof $ykHdR.Just) {
                    if (n <= v.value0.value0) {
                        $tco_done = true;
                        return v.value0.value1;
                    }
                    if ($6UHO6.otherwise) {
                        $tco_var_i = i + 1 | 0;
                        $copy_n = n - v.value0.value0;
                        return;
                    }
                }
                throw new Error("Failed pattern match at Test.QuickCheck.Gen (line 168, column 16 - line 172, column 44): " + [
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_i, $copy_n);
            return $tco_result;
        };
    };
    return $bc49024203989caa$var$bind1($bc49024203989caa$export$7877a478dd30fd3d(0)(total))(function(n) {
        return pick(0)(n);
    });
};
var $bc49024203989caa$export$f24ec99cecd50fca = /* #__PURE__ */ $k4cbH.applyStateT($6VVZC.monadIdentity);
var $bc49024203989caa$var$apply = /* #__PURE__ */ $a5g3C.apply($bc49024203989caa$export$f24ec99cecd50fca);
var $bc49024203989caa$var$chooseInt$prime = function(a) {
    return function(b) {
        var numB = $6pI6x.toNumber(b);
        var numA = $6pI6x.toNumber(a);
        var clamp = function(x) {
            return numA + $deaB6.remainder(x)(numB - numA + 1);
        };
        var choose31BitPosNumber = $bc49024203989caa$var$map2($6pI6x.toNumber)($bc49024203989caa$var$lcgStep);
        var choose32BitPosNumber = $bc49024203989caa$var$apply($bc49024203989caa$var$map2($bc49024203989caa$var$add)(choose31BitPosNumber))($bc49024203989caa$var$map2($bc49024203989caa$var$mul(2.0))(choose31BitPosNumber));
        return $bc49024203989caa$var$map2(function($109) {
            return $c8kPS.floor(clamp($109));
        })(choose32BitPosNumber);
    };
};
var $bc49024203989caa$export$24b3f9c3c8227daa = function(a) {
    return function(b) {
        var $101 = a <= b;
        if ($101) return $bc49024203989caa$var$chooseInt$prime(a)(b);
        return $bc49024203989caa$var$chooseInt$prime(b)(a);
    };
};
var $bc49024203989caa$export$e57ff0f701c44363 = function(g) {
    return $bc49024203989caa$export$c1c8be52b85daeca(function(n) {
        return $bc49024203989caa$var$bind1($bc49024203989caa$export$24b3f9c3c8227daa(0)(n))(function(k) {
            return $bc49024203989caa$export$b81db5163bc14d3a(k)(g);
        });
    });
};
var $bc49024203989caa$export$f103a64475a4fd0b = {
    chooseInt: $bc49024203989caa$export$24b3f9c3c8227daa,
    chooseFloat: $bc49024203989caa$export$7877a478dd30fd3d,
    chooseBool: /* #__PURE__ */ $bc49024203989caa$var$map2(function(v) {
        return v < 0.5;
    })($bc49024203989caa$export$379455b567eff87d),
    resize: function(f) {
        return function(g) {
            return $bc49024203989caa$export$c1c8be52b85daeca(function(s) {
                return $bc49024203989caa$export$4380c87abf28fdf(f(s))(g);
            });
        };
    },
    sized: $bc49024203989caa$export$c1c8be52b85daeca,
    Monad0: function() {
        return $bc49024203989caa$export$52ad81a118d95d95;
    }
};
var $bc49024203989caa$export$a9a18ae5ba42aeab = function(xs) {
    return $bc49024203989caa$var$bind1($bc49024203989caa$export$24b3f9c3c8227daa(0)($jxBf5.length(xs) - 1 | 0))(function(n) {
        return $bc49024203989caa$var$unsafeIndex(xs)(n);
    });
};
var $bc49024203989caa$export$69ada092a2da39c = /* #__PURE__ */ $k4cbH.applicativeStateT($6VVZC.monadIdentity);
var $bc49024203989caa$var$pure1 = /* #__PURE__ */ $gUTA8.pure($bc49024203989caa$export$69ada092a2da39c);
var $bc49024203989caa$export$d809131b0d748327 = function(g) {
    return $bc49024203989caa$export$c1c8be52b85daeca(function(n) {
        return $bc49024203989caa$var$bind1($bc49024203989caa$export$24b3f9c3c8227daa(0)(n))(function(k) {
            return $bc49024203989caa$var$bind1(g)(function(x) {
                return $bc49024203989caa$var$bind1($bc49024203989caa$export$b81db5163bc14d3a(k - 1 | 0)(g))(function(xs) {
                    return $bc49024203989caa$var$pure1($bc49024203989caa$var$fromJust($jxBf5.fromArray($4VF0K.cons(x)(xs))));
                });
            });
        });
    });
};
var $bc49024203989caa$export$7a5d735b2ab6389d = function(xs) {
    return $bc49024203989caa$var$bind1($bc49024203989caa$export$24b3f9c3c8227daa(0)($jxBf5.length(xs) - 1 | 0))(function(n) {
        return $bc49024203989caa$var$pure1($bc49024203989caa$var$unsafeIndex(xs)(n));
    });
};
var $bc49024203989caa$export$78a99c8d44d72635 = function(dictBoundedEnum) {
    var fromEnum = $loxi1.fromEnum(dictBoundedEnum);
    var Bounded0 = dictBoundedEnum.Bounded0();
    var toEnum = $loxi1.toEnum(dictBoundedEnum);
    return $bc49024203989caa$var$bind1($bc49024203989caa$export$24b3f9c3c8227daa(fromEnum($95fRU.bottom(Bounded0)))(fromEnum($95fRU.top(Bounded0))))(function(i) {
        return $bc49024203989caa$var$pure1($bc49024203989caa$var$fromJust(toEnum(i)));
    });
};
var $bc49024203989caa$export$448332262467e042 = function(xs) {
    return $bc49024203989caa$var$bind1($bc49024203989caa$export$b81db5163bc14d3a($lGiKR.length(xs))($bc49024203989caa$export$24b3f9c3c8227daa(0)($bc49024203989caa$var$top)))(function(ns) {
        return $bc49024203989caa$var$pure1($bc49024203989caa$var$map1($9MxTl.snd)($4VF0K.sortBy($bc49024203989caa$var$comparing($9MxTl.fst))($4VF0K.zip(ns)(xs))));
    });
};
var $bc49024203989caa$export$a7e2a49ace6c34c5 = function(gen) {
    return function(pred) {
        var go = function(v) {
            return $bc49024203989caa$var$bind1(gen)(function(a) {
                return $bc49024203989caa$var$pure1(function() {
                    var $102 = pred(a);
                    if ($102) return new $lowBm.Done(a);
                    return new $lowBm.Loop($r2HHk.unit);
                }());
            });
        };
        return $bc49024203989caa$var$tailRecM(go)($r2HHk.unit);
    };
};
var $bc49024203989caa$export$9a3b72d4f4d3c6b8 = /* #__PURE__ */ $k4cbH.altStateT($6VVZC.monadIdentity)($6VVZC.altIdentity);

});
parcelRegister("f6nCb", function(module, exports) {

$parcel$export(module.exports, "float32ToInt32", () => $afe9bbfe2ce5003b$export$2d1ed1a7368a8bb7);
/* global ArrayBuffer, Float32Array, Int32Array */ // module Test.QuickCheck.Gen
function $afe9bbfe2ce5003b$export$2d1ed1a7368a8bb7(n) {
    var arr = new ArrayBuffer(4);
    var fv = new Float32Array(arr);
    var iv = new Int32Array(arr);
    fv[0] = n;
    return iv[0];
}

});

parcelRegister("cOZDQ", function(module, exports) {

$parcel$export(module.exports, "unSeed", () => $9559f84fe253e941$export$7042ae9d28c01125);
$parcel$export(module.exports, "lcgM", () => $9559f84fe253e941$export$d98c3c51a54fd85);
$parcel$export(module.exports, "randomSeed", () => $9559f84fe253e941$export$7c185c3757807f6c);
$parcel$export(module.exports, "lcgPerturb", () => $9559f84fe253e941$export$4adeeb01377a1217);
$parcel$export(module.exports, "lcgNext", () => $9559f84fe253e941$export$9b78b1302b1d14b9);
// Generated by purs version 0.15.16

var $fb7aO = parcelRequire("fb7aO");

var $l0wDR = parcelRequire("l0wDR");

var $c8kPS = parcelRequire("c8kPS");
var $6pI6x = parcelRequire("6pI6x");

var $ykHdR = parcelRequire("ykHdR");
parcelRequire("rzgQX");
var $deaB6 = parcelRequire("deaB6");

var $d0PPW = parcelRequire("d0PPW");

var $3Orkn = parcelRequire("3Orkn");

var $9hRVP = parcelRequire("9hRVP");

var $agGw8 = parcelRequire("agGw8");
var $9559f84fe253e941$var$show = /* #__PURE__ */ $3Orkn.show($3Orkn.showInt);
var $9559f84fe253e941$var$mod = /* #__PURE__ */ $fb7aO.mod($fb7aO.euclideanRingInt);
var $9559f84fe253e941$var$fromJust = /* #__PURE__ */ $ykHdR.fromJust();
var $9559f84fe253e941$var$compare = /* #__PURE__ */ $d0PPW.compare($d0PPW.ordInt);
var $9559f84fe253e941$var$Seed = function(x) {
    return x;
};
var $9559f84fe253e941$export$7042ae9d28c01125 = function(v) {
    return v;
};
var $9559f84fe253e941$export$e65cb34e627289de = {
    show: function(v) {
        return "Seed " + $9559f84fe253e941$var$show(v);
    }
};
var $9559f84fe253e941$var$seedMin = 1;
var $9559f84fe253e941$export$d98c3c51a54fd85 = 2147483647;
var $9559f84fe253e941$var$seedMax = /* #__PURE__ */ function() {
    return $9559f84fe253e941$export$d98c3c51a54fd85 - 1 | 0;
}();
var $9559f84fe253e941$export$2735a0808990c853 = function(x) {
    var ensureBetween = function(min) {
        return function(max) {
            return function(n) {
                var rangeSize = max - min | 0;
                var n$prime = $9559f84fe253e941$var$mod(n)(rangeSize);
                var $25 = n$prime < min;
                if ($25) return n$prime + max | 0;
                return n$prime;
            };
        };
    };
    return ensureBetween($9559f84fe253e941$var$seedMin)($9559f84fe253e941$var$seedMax)(x);
};
var $9559f84fe253e941$export$7c185c3757807f6c = /* #__PURE__ */ $l0wDR.map($9hRVP.functorEffect)($9559f84fe253e941$export$2735a0808990c853)(/* #__PURE__ */ $agGw8.randomInt($9559f84fe253e941$var$seedMin)($9559f84fe253e941$var$seedMax));
var $9559f84fe253e941$export$61f3493dfd88d63c = 0;
var $9559f84fe253e941$export$f17df8294784fc83 = 48271;
var $9559f84fe253e941$export$4adeeb01377a1217 = function(d) {
    return function(v) {
        return $9559f84fe253e941$var$fromJust($c8kPS.fromNumber($deaB6.remainder($6pI6x.toNumber($9559f84fe253e941$export$f17df8294784fc83) * $6pI6x.toNumber(v) + $6pI6x.toNumber(d))($6pI6x.toNumber($9559f84fe253e941$export$d98c3c51a54fd85))));
    };
};
var $9559f84fe253e941$export$9b78b1302b1d14b9 = /* #__PURE__ */ $9559f84fe253e941$export$4adeeb01377a1217($9559f84fe253e941$export$61f3493dfd88d63c);
var $9559f84fe253e941$export$1bcc581bf56ac2e3 = {
    eq: function(x) {
        return function(y) {
            return x === y;
        };
    }
};
var $9559f84fe253e941$export$bcaddbba31d9e24 = {
    compare: function(x) {
        return function(y) {
            return $9559f84fe253e941$var$compare(x)(y);
        };
    },
    Eq0: function() {
        return $9559f84fe253e941$export$1bcc581bf56ac2e3;
    }
};

});
parcelRegister("agGw8", function(module, exports) {

$parcel$export(module.exports, "randomInt", () => $779c6109fa03e926$export$3c5f89dae98e900b);
// Generated by purs version 0.15.16

var $1Bw3W = parcelRequire("1Bw3W");

var $l0wDR = parcelRequire("l0wDR");

var $c8kPS = parcelRequire("c8kPS");
var $6pI6x = parcelRequire("6pI6x");

var $9hRVP = parcelRequire("9hRVP");
var $779c6109fa03e926$export$5c61011b8a176cb5 = function(min) {
    return function(max) {
        return function __do() {
            var n = $1Bw3W.random();
            return n * (max - min) + min;
        };
    };
};
var $779c6109fa03e926$export$3c5f89dae98e900b = function(low) {
    return function(high) {
        return function __do() {
            var n = $1Bw3W.random();
            var asNumber = ($6pI6x.toNumber(high) - $6pI6x.toNumber(low) + 1) * n + $6pI6x.toNumber(low);
            return $c8kPS.floor(asNumber);
        };
    };
};
var $779c6109fa03e926$export$b3b584c8d6ffe165 = /* #__PURE__ */ $l0wDR.map($9hRVP.functorEffect)(function(v) {
    return v < 0.5;
})($1Bw3W.random);

});
parcelRegister("1Bw3W", function(module, exports) {

$parcel$export(module.exports, "random", () => $12b21e1b0d841cdb$export$4385e60b38654f68);
const $12b21e1b0d841cdb$export$4385e60b38654f68 = Math.random;

});






(parcelRequire("1229Z")).main();


//# sourceMappingURL=dev.983039ea.js.map
